/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		0:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "" + chunkId + ".bundle.js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://cdn1.espn.net/sCoreNode/8527132b9447-release-09-11-2019.0/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {'use strict';
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(42);
	
	var _reactRouter = __webpack_require__(180);
	
	var _history = __webpack_require__(243);
	
	var _reactRedux = __webpack_require__(247);
	
	var _routes = __webpack_require__(277);
	
	var _selectn = __webpack_require__(438);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	var _momentTimezone = __webpack_require__(450);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _lib = __webpack_require__(392);
	
	var _configureStore = __webpack_require__(1113);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	var _config = __webpack_require__(423);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _shell = __webpack_require__(422);
	
	var _shell2 = _interopRequireDefault(_shell);
	
	var _actions = __webpack_require__(415);
	
	var _docReady = __webpack_require__(1129);
	
	var _isReactPath = __webpack_require__(829);
	
	var _isReactPath2 = _interopRequireDefault(_isReactPath);
	
	var _getRequestParams = __webpack_require__(1130);
	
	var _getRequestParams2 = _interopRequireDefault(_getRequestParams);
	
	var _translateURI = __webpack_require__(832);
	
	var _momentLocales = __webpack_require__(1131);
	
	var _momentLocales2 = _interopRequireDefault(_momentLocales);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global espn espn_ui jQuery */
	// ES6 promise polyfill for IEs
	__webpack_require__(1132).polyfill();
	/**
	 * Shim startsWith when not available
	 * From : https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
	 *
	 * @param {String}    searchString  string which needs to be searched for
	 * @param {Number}    position      position from which searchString should be searched
	 * @returns {Boolean}               true if string starts with given string
	 */
	if (!String.prototype.startsWith) {
	  String.prototype.startsWith = function (searchString, position) {
	    position = position || 0;
	    return this.substr(position, searchString.length) === searchString;
	  };
	}
	
	var history = (0, _reactRouter.useRouterHistory)((0, _history.useBeforeUnload)(_history.createHistory))();
	var store = (0, _configureStore2.default)(window.__INITIAL_STATE__, history);
	var dispatch = store.dispatch;
	
	var edition = (0, _selectn2.default)('page.edition', store.getState()) || {};
	var routes = !edition.isEspnCricinfo ? _routes.routesDefault : _routes.routesCricinfo;
	var initialLoad = true;
	
	// Set window._reactInMem=true on init
	window._reactInMem = true;
	
	function updateApp(location, pathnameChange, prevTemplate) {
	  if (typeof location !== 'undefined') {
	
	    //Translation - without this client side routing won't work
	    var translatedPath = (0, _translateURI.translatePath)(edition, location.pathname, true);
	    var translatedQuery = (0, _translateURI.translateQueryKey)(edition, location.query, true);
	    location.pathname = translatedPath;
	    location.query = translatedQuery;
	    (0, _reactRouter.match)({ routes: routes, location: location }, function (err, redirectLocation) {
	      var renderProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	
	      var currState = store.getState();
	      var appProps = (0, _selectn2.default)('page.appProps', currState) || {};
	      edition = (0, _selectn2.default)('page.edition', currState) || {};
	      var language = edition.language || 'en';
	      _momentTimezone2.default.locale(language, (0, _momentLocales2.default)(language));
	      /* modify params to correct sport/league and pageType */
	      var routeParams = (0, _getRequestParams2.default)(edition, renderProps, location) || {};
	      renderProps.params = routeParams;
	      var pageType = routeParams.pageType,
	          sport = routeParams.sport,
	          platform = routeParams.platform,
	          team = routeParams.team,
	          league = routeParams.league;
	
	      var template = (0, _lib.mapPageToTemplate)({ pageType: pageType, sport: sport, platform: platform });
	
	      try {
	        _shell2.default.transition.preRender(edition, sport, template, team, league);
	      } catch (e) {
	        console.log(e);
	      }
	
	      // end transition immediately, if template is unchanged or has platform param (webview)
	      if (prevTemplate === template || platform) {
	        _shell2.default.transition.end();
	      }
	      // call fetchComponentData only if initialState is undefined,
	      // or when app is not server rendered
	      if (typeof window.__INITIAL_STATE__ === 'undefined') {
	        var prefetchActions = initialLoad ? [] : [_actions.validatePageConfig];
	        if (espn.siteType) {
	          appProps.siteType = espn.siteType;
	        }
	        (0, _lib.fetchComponentData)(dispatch, renderProps, renderProps.location || location, prefetchActions, edition, appProps).then(function () {
	          renderApp(false, pathnameChange);
	          _shell2.default.transition.end();
	        });
	      } else {
	        delete window.__INITIAL_STATE__;
	        renderApp(false, pathnameChange);
	      }
	    });
	  }
	}
	
	(0, _docReady.docReady)(function connectShell() {
	
	  // Intercept the `history.change` event from the shell
	  jQuery(document).on('history.change', function (e, state) {
	    // exit if transition is between non react pages
	    if (!(0, _selectn2.default)('Helpers.page.react', espn_ui) && !state.react) {
	      return;
	    }
	    _shell2.default.transition.start();
	    // if prev page is jQuery, current is React,
	    if (!(0, _selectn2.default)('Helpers.page.react', espn_ui) && state.react) {
	      // Follows the same logic from original `history.change`
	      if (state.meta && state.meta.type === 'gamepackage' && state.url) {
	        window.location = state.url;
	        return;
	      }
	      try {
	        espn_ui.Helpers.page.load(state, null, { eventType: 'history' });
	      } catch (e) {
	        console.error(e);
	      }
	      // notify history.change
	      dispatch(function () {
	        return { type: 'HISTORY_CHANGE' };
	      });
	      // Unmount the whole app, to circumvent mismatched id errors
	      (0, _reactDom.unmountComponentAtNode)(document.getElementById(_config2.default.uid));
	      // Re-render the app
	      renderApp(true);
	      // Set page.react to true
	      try {
	        espn_ui.Helpers.page.react = true;
	      } catch (e) {
	        console.error(e);
	      }
	    }
	    // End page transition (show/hide)
	    window.setTimeout(_shell2.default.transition.end, 250);
	  });
	
	  // Subscribe to `analytics.loaded` and pull page analytics data
	  //For data lite we are using image tracking (analytics.liteTrack) for analytics so need to have separate condition to load ads config
	  jQuery.subscribe('analytics.loaded', function (data) {
	    // Pull ads and analytics from the page shell and store it in the app state
	    dispatch((0, _actions.setPageConfig)({ ads: espn.ads && espn.ads.config, analytics: data }));
	  });
	
	  // In webviews, we have to set the cmsEnbldSpnsrdCntntPrvdrs flag here because
	  // the above event for analytics being loaded won't fire, yet we still need this
	  // for sponsored content to be displayed
	  var state = store.getState();
	  if ((0, _selectn2.default)('page.params.platform', state)) {
	    dispatch((0, _actions.setPageConfig)({ ads: espn.ads && espn.ads.config }));
	  }
	  if ((0, _selectn2.default)('page.appProps.siteType', state) === 'data-lite') {
	    dispatch((0, _actions.setPageConfig)({ ads: espn.ads && espn.ads.config }));
	  }
	
	  // Listen to `espn.defer.ready`, and trigger app load on init
	  var startedInteractivity = false;
	  var startInteractivity = function startInteractivity() {
	    if (startedInteractivity) {
	      return;
	    }
	    startedInteractivity = true;
	    // Before navigation handler
	    // if `history.change` takes user to a page
	    // that matches react-router routes, but isn't handled by react,
	    // prevent location change in react-router.
	    history.listenBefore(function (location) {
	      //console.info('location', location)
	      return (0, _isReactPath2.default)(window.location.hostname, location.pathname, edition) || false;
	    });
	
	    // Add history listener
	    history.listen(function (location) {
	      espn_ui.Helpers.page = espn_ui.Helpers.page || {};
	      // transition.start(), hides the app container.
	      // We prevent it from hiding it when location change is
	      // triggered for query filters, ex: scoreboards
	      // TODO: improve url change check
	      var pathnameChange = location.pathname !== espn_ui.Helpers.page.pathname;
	      if (!initialLoad && pathnameChange) {
	        window.scrollTo(0, 0);
	        _shell2.default.transition.start();
	      }
	      // If initialLoad or if page id is react
	      if (initialLoad || (0, _selectn2.default)('Helpers.page.react', espn_ui)) {
	        updateApp(location, pathnameChange, espn_ui.Helpers.page.template);
	      }
	    });
	
	    // Set window._reactInMem=false before unload
	    history.listenBeforeUnload(function () {
	      console.log('listenBeforeUnload');
	      window._reactInMem = false;
	    });
	
	    // TEMP: Click handler for playing videos on mobile devices,
	    // TODO: Remove after CSS and clickable areas for play icons are fixed
	    jQuery('body').on('click', '.highlight.module_bloom_behavior:not(.video-play-button-external,.app_partial)', function (event) {
	      if (espn_ui.device.isMobile) {
	        espn_ui.Helpers.video.playFromElement(jQuery('.video-play-button', this), false, event);
	      }
	    });
	
	    if (espn.siteType === 'data-lite' && typeof espn.ads.loadGPT === 'function') {
	      espn.ads.loadGPT();
	    }
	  };
	
	  if (espn.siteType === 'data-lite' && espn_ui.docAndDeferReady === true) {
	    startInteractivity();
	  } else {
	    jQuery.subscribe('espn.defer.ready', startInteractivity);
	  }
	});
	/*
	This method is exposed at window level so that mobile app can trigger reduxion from static landing page
	It accepts absolute gamepackage url as a param which will init reduxion with gameid in game url
	*/
	window.load = function (gameUrl) {
	  var linkObj = document.createElement('a');
	  linkObj.href = gameUrl;
	  var url = linkObj.pathname;
	  var query = linkObj.search;
	  if (typeof query != 'undefined') {
	    url += query;
	  }
	  history.push(url);
	};
	window.reset = function () {
	  var platform = 'ios';
	  if (/\/android\//.test(location.href)) {
	    platform = 'android';
	  }
	  var query = window.location.search;
	  var resetUrl = '/cricket/static/game/' + platform + '/webview/';
	  if (typeof query !== 'undefined') {
	    resetUrl += query;
	  }
	  history.push(resetUrl);
	};
	function renderApp(historyChange, pathnameChange) {
	  (0, _reactDom.render)(_react2.default.createElement(
	    _reactRedux.Provider,
	    { store: store },
	    _react2.default.createElement(_reactRouter.Router, { uid: _config2.default.uid, children: routes, history: history })
	  ), document.getElementById(_config2.default.uid), function () {
	    dispatch((0, _actions.onRenderComplete)({ initialLoad: initialLoad, historyChange: historyChange, pathnameChange: pathnameChange }));
	    initialLoad = false;
	  });
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*global window, global*/
	var util = __webpack_require__(3)
	var assert = __webpack_require__(7)
	var now = __webpack_require__(11)
	
	var slice = Array.prototype.slice
	var console
	var times = {}
	
	if (typeof global !== "undefined" && global.console) {
	    console = global.console
	} else if (typeof window !== "undefined" && window.console) {
	    console = window.console
	} else {
	    console = {}
	}
	
	var functions = [
	    [log, "log"],
	    [info, "info"],
	    [warn, "warn"],
	    [error, "error"],
	    [time, "time"],
	    [timeEnd, "timeEnd"],
	    [trace, "trace"],
	    [dir, "dir"],
	    [consoleAssert, "assert"]
	]
	
	for (var i = 0; i < functions.length; i++) {
	    var tuple = functions[i]
	    var f = tuple[0]
	    var name = tuple[1]
	
	    if (!console[name]) {
	        console[name] = f
	    }
	}
	
	module.exports = console
	
	function log() {}
	
	function info() {
	    console.log.apply(console, arguments)
	}
	
	function warn() {
	    console.log.apply(console, arguments)
	}
	
	function error() {
	    console.warn.apply(console, arguments)
	}
	
	function time(label) {
	    times[label] = now()
	}
	
	function timeEnd(label) {
	    var time = times[label]
	    if (!time) {
	        throw new Error("No such label: " + label)
	    }
	
	    var duration = now() - time
	    console.log(label + ": " + duration + "ms")
	}
	
	function trace() {
	    var err = new Error()
	    err.name = "Trace"
	    err.message = util.format.apply(null, arguments)
	    console.error(err.stack)
	}
	
	function dir(object) {
	    console.log(util.inspect(object) + "\n")
	}
	
	function consoleAssert(expression) {
	    if (!expression) {
	        var arr = slice.call(arguments, 1)
	        assert.ok(false, util.format.apply(null, arr))
	    }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process, console) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"NODE_ENV":"production","SITE_API_FRONTCHANNEL_HOST":"site.web.api.espn.com","SCORETC_FRONTCHANNEL_HOST":"www.espn.com/core"}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(5);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(6);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 5 */
/***/ (function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
	// original notice:
	
	/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	function compare(a, b) {
	  if (a === b) {
	    return 0;
	  }
	
	  var x = a.length;
	  var y = b.length;
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i];
	      y = b[i];
	      break;
	    }
	  }
	
	  if (x < y) {
	    return -1;
	  }
	  if (y < x) {
	    return 1;
	  }
	  return 0;
	}
	function isBuffer(b) {
	  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
	    return global.Buffer.isBuffer(b);
	  }
	  return !!(b != null && b._isBuffer);
	}
	
	// based on node assert, original notice:
	
	// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
	//
	// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
	//
	// Originally from narwhal.js (http://narwhaljs.org)
	// Copyright (c) 2009 Thomas Robinson <280north.com>
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the 'Software'), to
	// deal in the Software without restriction, including without limitation the
	// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
	// sell copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var util = __webpack_require__(8);
	var hasOwn = Object.prototype.hasOwnProperty;
	var pSlice = Array.prototype.slice;
	var functionsHaveNames = (function () {
	  return function foo() {}.name === 'foo';
	}());
	function pToString (obj) {
	  return Object.prototype.toString.call(obj);
	}
	function isView(arrbuf) {
	  if (isBuffer(arrbuf)) {
	    return false;
	  }
	  if (typeof global.ArrayBuffer !== 'function') {
	    return false;
	  }
	  if (typeof ArrayBuffer.isView === 'function') {
	    return ArrayBuffer.isView(arrbuf);
	  }
	  if (!arrbuf) {
	    return false;
	  }
	  if (arrbuf instanceof DataView) {
	    return true;
	  }
	  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
	    return true;
	  }
	  return false;
	}
	// 1. The assert module provides functions that throw
	// AssertionError's when particular conditions are not met. The
	// assert module must conform to the following interface.
	
	var assert = module.exports = ok;
	
	// 2. The AssertionError is defined in assert.
	// new assert.AssertionError({ message: message,
	//                             actual: actual,
	//                             expected: expected })
	
	var regex = /\s*function\s+([^\(\s]*)\s*/;
	// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
	function getName(func) {
	  if (!util.isFunction(func)) {
	    return;
	  }
	  if (functionsHaveNames) {
	    return func.name;
	  }
	  var str = func.toString();
	  var match = str.match(regex);
	  return match && match[1];
	}
	assert.AssertionError = function AssertionError(options) {
	  this.name = 'AssertionError';
	  this.actual = options.actual;
	  this.expected = options.expected;
	  this.operator = options.operator;
	  if (options.message) {
	    this.message = options.message;
	    this.generatedMessage = false;
	  } else {
	    this.message = getMessage(this);
	    this.generatedMessage = true;
	  }
	  var stackStartFunction = options.stackStartFunction || fail;
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, stackStartFunction);
	  } else {
	    // non v8 browsers so we can have a stacktrace
	    var err = new Error();
	    if (err.stack) {
	      var out = err.stack;
	
	      // try to strip useless frames
	      var fn_name = getName(stackStartFunction);
	      var idx = out.indexOf('\n' + fn_name);
	      if (idx >= 0) {
	        // once we have located the function frame
	        // we need to strip out everything before it (and its line)
	        var next_line = out.indexOf('\n', idx + 1);
	        out = out.substring(next_line + 1);
	      }
	
	      this.stack = out;
	    }
	  }
	};
	
	// assert.AssertionError instanceof Error
	util.inherits(assert.AssertionError, Error);
	
	function truncate(s, n) {
	  if (typeof s === 'string') {
	    return s.length < n ? s : s.slice(0, n);
	  } else {
	    return s;
	  }
	}
	function inspect(something) {
	  if (functionsHaveNames || !util.isFunction(something)) {
	    return util.inspect(something);
	  }
	  var rawname = getName(something);
	  var name = rawname ? ': ' + rawname : '';
	  return '[Function' +  name + ']';
	}
	function getMessage(self) {
	  return truncate(inspect(self.actual), 128) + ' ' +
	         self.operator + ' ' +
	         truncate(inspect(self.expected), 128);
	}
	
	// At present only the three keys mentioned above are used and
	// understood by the spec. Implementations or sub modules can pass
	// other keys to the AssertionError's constructor - they will be
	// ignored.
	
	// 3. All of the following functions must throw an AssertionError
	// when a corresponding condition is not met, with a message that
	// may be undefined if not provided.  All assertion methods provide
	// both the actual and expected values to the assertion error for
	// display purposes.
	
	function fail(actual, expected, message, operator, stackStartFunction) {
	  throw new assert.AssertionError({
	    message: message,
	    actual: actual,
	    expected: expected,
	    operator: operator,
	    stackStartFunction: stackStartFunction
	  });
	}
	
	// EXTENSION! allows for well behaved errors defined elsewhere.
	assert.fail = fail;
	
	// 4. Pure assertion tests whether a value is truthy, as determined
	// by !!guard.
	// assert.ok(guard, message_opt);
	// This statement is equivalent to assert.equal(true, !!guard,
	// message_opt);. To test strictly for the value true, use
	// assert.strictEqual(true, guard, message_opt);.
	
	function ok(value, message) {
	  if (!value) fail(value, true, message, '==', assert.ok);
	}
	assert.ok = ok;
	
	// 5. The equality assertion tests shallow, coercive equality with
	// ==.
	// assert.equal(actual, expected, message_opt);
	
	assert.equal = function equal(actual, expected, message) {
	  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
	};
	
	// 6. The non-equality assertion tests for whether two objects are not equal
	// with != assert.notEqual(actual, expected, message_opt);
	
	assert.notEqual = function notEqual(actual, expected, message) {
	  if (actual == expected) {
	    fail(actual, expected, message, '!=', assert.notEqual);
	  }
	};
	
	// 7. The equivalence assertion tests a deep equality relation.
	// assert.deepEqual(actual, expected, message_opt);
	
	assert.deepEqual = function deepEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
	  }
	};
	
	assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
	  }
	};
	
	function _deepEqual(actual, expected, strict, memos) {
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	  } else if (isBuffer(actual) && isBuffer(expected)) {
	    return compare(actual, expected) === 0;
	
	  // 7.2. If the expected value is a Date object, the actual value is
	  // equivalent if it is also a Date object that refers to the same time.
	  } else if (util.isDate(actual) && util.isDate(expected)) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3 If the expected value is a RegExp object, the actual value is
	  // equivalent if it is also a RegExp object with the same source and
	  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
	  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
	    return actual.source === expected.source &&
	           actual.global === expected.global &&
	           actual.multiline === expected.multiline &&
	           actual.lastIndex === expected.lastIndex &&
	           actual.ignoreCase === expected.ignoreCase;
	
	  // 7.4. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if ((actual === null || typeof actual !== 'object') &&
	             (expected === null || typeof expected !== 'object')) {
	    return strict ? actual === expected : actual == expected;
	
	  // If both values are instances of typed arrays, wrap their underlying
	  // ArrayBuffers in a Buffer each to increase performance
	  // This optimization requires the arrays to have the same type as checked by
	  // Object.prototype.toString (aka pToString). Never perform binary
	  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
	  // bit patterns are not identical.
	  } else if (isView(actual) && isView(expected) &&
	             pToString(actual) === pToString(expected) &&
	             !(actual instanceof Float32Array ||
	               actual instanceof Float64Array)) {
	    return compare(new Uint8Array(actual.buffer),
	                   new Uint8Array(expected.buffer)) === 0;
	
	  // 7.5 For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else if (isBuffer(actual) !== isBuffer(expected)) {
	    return false;
	  } else {
	    memos = memos || {actual: [], expected: []};
	
	    var actualIndex = memos.actual.indexOf(actual);
	    if (actualIndex !== -1) {
	      if (actualIndex === memos.expected.indexOf(expected)) {
	        return true;
	      }
	    }
	
	    memos.actual.push(actual);
	    memos.expected.push(expected);
	
	    return objEquiv(actual, expected, strict, memos);
	  }
	}
	
	function isArguments(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	}
	
	function objEquiv(a, b, strict, actualVisitedObjects) {
	  if (a === null || a === undefined || b === null || b === undefined)
	    return false;
	  // if one is a primitive, the other must be same
	  if (util.isPrimitive(a) || util.isPrimitive(b))
	    return a === b;
	  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
	    return false;
	  var aIsArgs = isArguments(a);
	  var bIsArgs = isArguments(b);
	  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
	    return false;
	  if (aIsArgs) {
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return _deepEqual(a, b, strict);
	  }
	  var ka = objectKeys(a);
	  var kb = objectKeys(b);
	  var key, i;
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length !== kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] !== kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
	      return false;
	  }
	  return true;
	}
	
	// 8. The non-equivalence assertion tests for any deep inequality.
	// assert.notDeepEqual(actual, expected, message_opt);
	
	assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
	  }
	};
	
	assert.notDeepStrictEqual = notDeepStrictEqual;
	function notDeepStrictEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
	  }
	}
	
	
	// 9. The strict equality assertion tests strict equality, as determined by ===.
	// assert.strictEqual(actual, expected, message_opt);
	
	assert.strictEqual = function strictEqual(actual, expected, message) {
	  if (actual !== expected) {
	    fail(actual, expected, message, '===', assert.strictEqual);
	  }
	};
	
	// 10. The strict non-equality assertion tests for strict inequality, as
	// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);
	
	assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
	  if (actual === expected) {
	    fail(actual, expected, message, '!==', assert.notStrictEqual);
	  }
	};
	
	function expectedException(actual, expected) {
	  if (!actual || !expected) {
	    return false;
	  }
	
	  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
	    return expected.test(actual);
	  }
	
	  try {
	    if (actual instanceof expected) {
	      return true;
	    }
	  } catch (e) {
	    // Ignore.  The instanceof check doesn't work for arrow functions.
	  }
	
	  if (Error.isPrototypeOf(expected)) {
	    return false;
	  }
	
	  return expected.call({}, actual) === true;
	}
	
	function _tryBlock(block) {
	  var error;
	  try {
	    block();
	  } catch (e) {
	    error = e;
	  }
	  return error;
	}
	
	function _throws(shouldThrow, block, expected, message) {
	  var actual;
	
	  if (typeof block !== 'function') {
	    throw new TypeError('"block" argument must be a function');
	  }
	
	  if (typeof expected === 'string') {
	    message = expected;
	    expected = null;
	  }
	
	  actual = _tryBlock(block);
	
	  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
	            (message ? ' ' + message : '.');
	
	  if (shouldThrow && !actual) {
	    fail(actual, expected, 'Missing expected exception' + message);
	  }
	
	  var userProvidedMessage = typeof message === 'string';
	  var isUnwantedException = !shouldThrow && util.isError(actual);
	  var isUnexpectedException = !shouldThrow && actual && !expected;
	
	  if ((isUnwantedException &&
	      userProvidedMessage &&
	      expectedException(actual, expected)) ||
	      isUnexpectedException) {
	    fail(actual, expected, 'Got unwanted exception' + message);
	  }
	
	  if ((shouldThrow && actual && expected &&
	      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
	    throw actual;
	  }
	}
	
	// 11. Expected to throw an error:
	// assert.throws(block, Error_opt, message_opt);
	
	assert.throws = function(block, /*optional*/error, /*optional*/message) {
	  _throws(true, block, error, message);
	};
	
	// EXTENSION! This is annoying to write outside this module.
	assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
	  _throws(false, block, error, message);
	};
	
	assert.ifError = function(err) { if (err) throw err; };
	
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    if (hasOwn.call(obj, key)) keys.push(key);
	  }
	  return keys;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process, console) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"NODE_ENV":"production","SITE_API_FRONTCHANNEL_HOST":"site.web.api.espn.com","SCORETC_FRONTCHANNEL_HOST":"www.espn.com/core"}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(9);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(10);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	module.exports = now
	
	function now() {
	    return new Date().getTime()
	}


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(13);


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var ReactBaseClasses = __webpack_require__(15);
	var ReactChildren = __webpack_require__(24);
	var ReactDOMFactories = __webpack_require__(32);
	var ReactElement = __webpack_require__(26);
	var ReactPropTypes = __webpack_require__(33);
	var ReactVersion = __webpack_require__(38);
	
	var createReactClass = __webpack_require__(39);
	var onlyChild = __webpack_require__(41);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(16),
	    _assign = __webpack_require__(14);
	
	var ReactNoopUpdateQueue = __webpack_require__(17);
	
	var canDefineProperty = __webpack_require__(20);
	var emptyObject = __webpack_require__(21);
	var invariant = __webpack_require__(22);
	var lowPriorityWarning = __webpack_require__(23);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(18);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(19);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(25);
	var ReactElement = __webpack_require__(26);
	
	var emptyFunction = __webpack_require__(19);
	var traverseAllChildren = __webpack_require__(29);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(16);
	
	var invariant = __webpack_require__(22);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var ReactCurrentOwner = __webpack_require__(27);
	
	var warning = __webpack_require__(18);
	var canDefineProperty = __webpack_require__(20);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(28);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(16);
	
	var ReactCurrentOwner = __webpack_require__(27);
	var REACT_ELEMENT_TYPE = __webpack_require__(28);
	
	var getIteratorFn = __webpack_require__(30);
	var invariant = __webpack_require__(22);
	var KeyEscapeUtils = __webpack_require__(31);
	var warning = __webpack_require__(18);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 31 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(26);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(26),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(34);
	
	module.exports = factory(isValidElement);

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(35);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var assign = __webpack_require__(14);
	
	var ReactPropTypesSecret = __webpack_require__(36);
	var checkPropTypes = __webpack_require__(37);
	
	var printWarning = function() {};
	
	if (false) {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? printWarning('Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 36 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var printWarning = function() {};
	
	if (false) {
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          )
	
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ }),
/* 38 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(15),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(26),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(17);
	var factory = __webpack_require__(40);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var emptyObject = __webpack_require__(21);
	var _invariant = __webpack_require__(22);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(16);
	
	var ReactElement = __webpack_require__(26);
	
	var invariant = __webpack_require__(22);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(43);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactDefaultInjection = __webpack_require__(48);
	var ReactMount = __webpack_require__(171);
	var ReactReconciler = __webpack_require__(69);
	var ReactUpdates = __webpack_require__(66);
	var ReactVersion = __webpack_require__(176);
	
	var findDOMNode = __webpack_require__(177);
	var getHostComponentFromComposite = __webpack_require__(178);
	var renderSubtreeIntoContainer = __webpack_require__(179);
	var warning = __webpack_require__(18);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(45);
	
	var DOMProperty = __webpack_require__(46);
	var ReactDOMComponentFlags = __webpack_require__(47);
	
	var invariant = __webpack_require__(22);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(45);
	
	var invariant = __webpack_require__(22);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(49);
	var BeforeInputEventPlugin = __webpack_require__(50);
	var ChangeEventPlugin = __webpack_require__(65);
	var DefaultEventPluginOrder = __webpack_require__(78);
	var EnterLeaveEventPlugin = __webpack_require__(79);
	var HTMLDOMPropertyConfig = __webpack_require__(84);
	var ReactComponentBrowserEnvironment = __webpack_require__(85);
	var ReactDOMComponent = __webpack_require__(98);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactDOMEmptyComponent = __webpack_require__(142);
	var ReactDOMTreeTraversal = __webpack_require__(143);
	var ReactDOMTextComponent = __webpack_require__(144);
	var ReactDefaultBatchingStrategy = __webpack_require__(145);
	var ReactEventListener = __webpack_require__(146);
	var ReactInjection = __webpack_require__(149);
	var ReactReconcileTransaction = __webpack_require__(150);
	var SVGDOMPropertyConfig = __webpack_require__(158);
	var SelectEventPlugin = __webpack_require__(159);
	var SimpleEventPlugin = __webpack_require__(160);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(51);
	var ExecutionEnvironment = __webpack_require__(58);
	var FallbackCompositionState = __webpack_require__(59);
	var SyntheticCompositionEvent = __webpack_require__(62);
	var SyntheticInputEvent = __webpack_require__(64);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(52);
	var EventPluginUtils = __webpack_require__(54);
	
	var accumulateInto = __webpack_require__(56);
	var forEachAccumulated = __webpack_require__(57);
	var warning = __webpack_require__(18);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(45);
	
	var EventPluginRegistry = __webpack_require__(53);
	var EventPluginUtils = __webpack_require__(54);
	var ReactErrorUtils = __webpack_require__(55);
	
	var accumulateInto = __webpack_require__(56);
	var forEachAccumulated = __webpack_require__(57);
	var invariant = __webpack_require__(22);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(45);
	
	var invariant = __webpack_require__(22);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(45);
	
	var ReactErrorUtils = __webpack_require__(55);
	
	var invariant = __webpack_require__(22);
	var warning = __webpack_require__(18);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function () {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(45);
	
	var invariant = __webpack_require__(22);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ }),
/* 57 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ }),
/* 58 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var PooledClass = __webpack_require__(60);
	
	var getTextContentAccessor = __webpack_require__(61);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(45);
	
	var invariant = __webpack_require__(22);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(58);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(63);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var PooledClass = __webpack_require__(60);
	
	var emptyFunction = __webpack_require__(19);
	var warning = __webpack_require__(18);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(63);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(52);
	var EventPropagators = __webpack_require__(51);
	var ExecutionEnvironment = __webpack_require__(58);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactUpdates = __webpack_require__(66);
	var SyntheticEvent = __webpack_require__(63);
	
	var inputValueTracking = __webpack_require__(74);
	var getEventTarget = __webpack_require__(75);
	var isEventSupported = __webpack_require__(76);
	var isTextInputElement = __webpack_require__(77);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(45),
	    _assign = __webpack_require__(14);
	
	var CallbackQueue = __webpack_require__(67);
	var PooledClass = __webpack_require__(60);
	var ReactFeatureFlags = __webpack_require__(68);
	var ReactReconciler = __webpack_require__(69);
	var Transaction = __webpack_require__(73);
	
	var invariant = __webpack_require__(22);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(45);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(60);
	
	var invariant = __webpack_require__(22);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 68 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(70);
	var ReactInstrumentation = __webpack_require__(72);
	
	var warning = __webpack_require__(18);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(71);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(45);
	
	var invariant = __webpack_require__(22);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(45);
	
	var invariant = __webpack_require__(22);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(44);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ }),
/* 75 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(58);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ }),
/* 77 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ }),
/* 78 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(51);
	var ReactDOMComponentTree = __webpack_require__(44);
	var SyntheticMouseEvent = __webpack_require__(80);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(81);
	var ViewportMetrics = __webpack_require__(82);
	
	var getEventModifierState = __webpack_require__(83);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(63);
	
	var getEventTarget = __webpack_require__(75);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ }),
/* 82 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ }),
/* 83 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(46);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(86);
	var ReactDOMIDOperations = __webpack_require__(97);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(87);
	var Danger = __webpack_require__(93);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactInstrumentation = __webpack_require__(72);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(90);
	var setInnerHTML = __webpack_require__(89);
	var setTextContent = __webpack_require__(91);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(88);
	var setInnerHTML = __webpack_require__(89);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(90);
	var setTextContent = __webpack_require__(91);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ }),
/* 88 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(58);
	var DOMNamespaces = __webpack_require__(88);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(90);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ }),
/* 90 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(58);
	var escapeTextContentForBrowser = __webpack_require__(92);
	var setInnerHTML = __webpack_require__(89);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ }),
/* 92 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(45);
	
	var DOMLazyTree = __webpack_require__(87);
	var ExecutionEnvironment = __webpack_require__(58);
	
	var createNodesFromMarkup = __webpack_require__(94);
	var emptyFunction = __webpack_require__(19);
	var invariant = __webpack_require__(22);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(58);
	
	var createArrayFromMixed = __webpack_require__(95);
	var getMarkupWrap = __webpack_require__(96);
	var invariant = __webpack_require__(22);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(22);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(58);
	
	var invariant = __webpack_require__(22);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(86);
	var ReactDOMComponentTree = __webpack_require__(44);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(45),
	    _assign = __webpack_require__(14);
	
	var AutoFocusUtils = __webpack_require__(99);
	var CSSPropertyOperations = __webpack_require__(101);
	var DOMLazyTree = __webpack_require__(87);
	var DOMNamespaces = __webpack_require__(88);
	var DOMProperty = __webpack_require__(46);
	var DOMPropertyOperations = __webpack_require__(109);
	var EventPluginHub = __webpack_require__(52);
	var EventPluginRegistry = __webpack_require__(53);
	var ReactBrowserEventEmitter = __webpack_require__(111);
	var ReactDOMComponentFlags = __webpack_require__(47);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactDOMInput = __webpack_require__(114);
	var ReactDOMOption = __webpack_require__(117);
	var ReactDOMSelect = __webpack_require__(118);
	var ReactDOMTextarea = __webpack_require__(119);
	var ReactInstrumentation = __webpack_require__(72);
	var ReactMultiChild = __webpack_require__(120);
	var ReactServerRenderingTransaction = __webpack_require__(138);
	
	var emptyFunction = __webpack_require__(19);
	var escapeTextContentForBrowser = __webpack_require__(92);
	var invariant = __webpack_require__(22);
	var isEventSupported = __webpack_require__(76);
	var shallowEqual = __webpack_require__(127);
	var inputValueTracking = __webpack_require__(74);
	var validateDOMNesting = __webpack_require__(141);
	var warning = __webpack_require__(18);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(44);
	
	var focusNode = __webpack_require__(100);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ }),
/* 100 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(102);
	var ExecutionEnvironment = __webpack_require__(58);
	var ReactInstrumentation = __webpack_require__(72);
	
	var camelizeStyleName = __webpack_require__(103);
	var dangerousStyleValue = __webpack_require__(105);
	var hyphenateStyleName = __webpack_require__(106);
	var memoizeStringOnly = __webpack_require__(108);
	var warning = __webpack_require__(18);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ }),
/* 102 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(104);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ }),
/* 104 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(102);
	var warning = __webpack_require__(18);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(107);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ }),
/* 107 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(46);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactInstrumentation = __webpack_require__(72);
	
	var quoteAttributeValueForBrowser = __webpack_require__(110);
	var warning = __webpack_require__(18);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(92);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var EventPluginRegistry = __webpack_require__(53);
	var ReactEventEmitterMixin = __webpack_require__(112);
	var ViewportMetrics = __webpack_require__(82);
	
	var getVendorPrefixedEventName = __webpack_require__(113);
	var isEventSupported = __webpack_require__(76);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(52);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(58);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(45),
	    _assign = __webpack_require__(14);
	
	var DOMPropertyOperations = __webpack_require__(109);
	var LinkedValueUtils = __webpack_require__(115);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactUpdates = __webpack_require__(66);
	
	var invariant = __webpack_require__(22);
	var warning = __webpack_require__(18);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(45);
	
	var ReactPropTypesSecret = __webpack_require__(116);
	var propTypesFactory = __webpack_require__(34);
	
	var React = __webpack_require__(13);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(22);
	var warning = __webpack_require__(18);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ }),
/* 116 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var React = __webpack_require__(13);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactDOMSelect = __webpack_require__(118);
	
	var warning = __webpack_require__(18);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var LinkedValueUtils = __webpack_require__(115);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactUpdates = __webpack_require__(66);
	
	var warning = __webpack_require__(18);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(45),
	    _assign = __webpack_require__(14);
	
	var LinkedValueUtils = __webpack_require__(115);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactUpdates = __webpack_require__(66);
	
	var invariant = __webpack_require__(22);
	var warning = __webpack_require__(18);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(45);
	
	var ReactComponentEnvironment = __webpack_require__(121);
	var ReactInstanceMap = __webpack_require__(122);
	var ReactInstrumentation = __webpack_require__(72);
	
	var ReactCurrentOwner = __webpack_require__(27);
	var ReactReconciler = __webpack_require__(69);
	var ReactChildReconciler = __webpack_require__(123);
	
	var emptyFunction = __webpack_require__(19);
	var flattenChildren = __webpack_require__(137);
	var invariant = __webpack_require__(22);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(45);
	
	var invariant = __webpack_require__(22);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ }),
/* 122 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(69);
	
	var instantiateReactComponent = __webpack_require__(124);
	var KeyEscapeUtils = __webpack_require__(132);
	var shouldUpdateReactComponent = __webpack_require__(128);
	var traverseAllChildren = __webpack_require__(133);
	var warning = __webpack_require__(18);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","SITE_API_FRONTCHANNEL_HOST":"site.web.api.espn.com","SCORETC_FRONTCHANNEL_HOST":"www.espn.com/core"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(136);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(45),
	    _assign = __webpack_require__(14);
	
	var ReactCompositeComponent = __webpack_require__(125);
	var ReactEmptyComponent = __webpack_require__(129);
	var ReactHostComponent = __webpack_require__(130);
	
	var getNextDebugID = __webpack_require__(131);
	var invariant = __webpack_require__(22);
	var warning = __webpack_require__(18);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(45),
	    _assign = __webpack_require__(14);
	
	var React = __webpack_require__(13);
	var ReactComponentEnvironment = __webpack_require__(121);
	var ReactCurrentOwner = __webpack_require__(27);
	var ReactErrorUtils = __webpack_require__(55);
	var ReactInstanceMap = __webpack_require__(122);
	var ReactInstrumentation = __webpack_require__(72);
	var ReactNodeTypes = __webpack_require__(126);
	var ReactReconciler = __webpack_require__(69);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(21);
	var invariant = __webpack_require__(22);
	var shallowEqual = __webpack_require__(127);
	var shouldUpdateReactComponent = __webpack_require__(128);
	var warning = __webpack_require__(18);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(45);
	
	var React = __webpack_require__(13);
	
	var invariant = __webpack_require__(22);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ }),
/* 127 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 128 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ }),
/* 129 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(45);
	
	var invariant = __webpack_require__(22);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ }),
/* 131 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ }),
/* 132 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(45);
	
	var ReactCurrentOwner = __webpack_require__(27);
	var REACT_ELEMENT_TYPE = __webpack_require__(134);
	
	var getIteratorFn = __webpack_require__(135);
	var invariant = __webpack_require__(22);
	var KeyEscapeUtils = __webpack_require__(132);
	var warning = __webpack_require__(18);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 134 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 135 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(16);
	
	var ReactCurrentOwner = __webpack_require__(27);
	
	var invariant = __webpack_require__(22);
	var warning = __webpack_require__(18);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(132);
	var traverseAllChildren = __webpack_require__(133);
	var warning = __webpack_require__(18);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","SITE_API_FRONTCHANNEL_HOST":"site.web.api.espn.com","SCORETC_FRONTCHANNEL_HOST":"www.espn.com/core"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(136);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var PooledClass = __webpack_require__(60);
	var Transaction = __webpack_require__(73);
	var ReactInstrumentation = __webpack_require__(72);
	var ReactServerUpdateQueue = __webpack_require__(139);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(140);
	
	var warning = __webpack_require__(18);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(45);
	
	var ReactCurrentOwner = __webpack_require__(27);
	var ReactInstanceMap = __webpack_require__(122);
	var ReactInstrumentation = __webpack_require__(72);
	var ReactUpdates = __webpack_require__(66);
	
	var invariant = __webpack_require__(22);
	var warning = __webpack_require__(18);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var emptyFunction = __webpack_require__(19);
	var warning = __webpack_require__(18);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var DOMLazyTree = __webpack_require__(87);
	var ReactDOMComponentTree = __webpack_require__(44);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(45);
	
	var invariant = __webpack_require__(22);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(45),
	    _assign = __webpack_require__(14);
	
	var DOMChildrenOperations = __webpack_require__(86);
	var DOMLazyTree = __webpack_require__(87);
	var ReactDOMComponentTree = __webpack_require__(44);
	
	var escapeTextContentForBrowser = __webpack_require__(92);
	var invariant = __webpack_require__(22);
	var validateDOMNesting = __webpack_require__(141);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var ReactUpdates = __webpack_require__(66);
	var Transaction = __webpack_require__(73);
	
	var emptyFunction = __webpack_require__(19);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var EventListener = __webpack_require__(147);
	var ExecutionEnvironment = __webpack_require__(58);
	var PooledClass = __webpack_require__(60);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactUpdates = __webpack_require__(66);
	
	var getEventTarget = __webpack_require__(75);
	var getUnboundedScrollPosition = __webpack_require__(148);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(19);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ }),
/* 148 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(46);
	var EventPluginHub = __webpack_require__(52);
	var EventPluginUtils = __webpack_require__(54);
	var ReactComponentEnvironment = __webpack_require__(121);
	var ReactEmptyComponent = __webpack_require__(129);
	var ReactBrowserEventEmitter = __webpack_require__(111);
	var ReactHostComponent = __webpack_require__(130);
	var ReactUpdates = __webpack_require__(66);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var CallbackQueue = __webpack_require__(67);
	var PooledClass = __webpack_require__(60);
	var ReactBrowserEventEmitter = __webpack_require__(111);
	var ReactInputSelection = __webpack_require__(151);
	var ReactInstrumentation = __webpack_require__(72);
	var Transaction = __webpack_require__(73);
	var ReactUpdateQueue = __webpack_require__(140);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(152);
	
	var containsNode = __webpack_require__(154);
	var focusNode = __webpack_require__(100);
	var getActiveElement = __webpack_require__(157);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(58);
	
	var getNodeForCharacterOffset = __webpack_require__(153);
	var getTextContentAccessor = __webpack_require__(61);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ }),
/* 153 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(155);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(156);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ }),
/* 156 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ }),
/* 157 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ }),
/* 158 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(51);
	var ExecutionEnvironment = __webpack_require__(58);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactInputSelection = __webpack_require__(151);
	var SyntheticEvent = __webpack_require__(63);
	
	var getActiveElement = __webpack_require__(157);
	var isTextInputElement = __webpack_require__(77);
	var shallowEqual = __webpack_require__(127);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(45);
	
	var EventListener = __webpack_require__(147);
	var EventPropagators = __webpack_require__(51);
	var ReactDOMComponentTree = __webpack_require__(44);
	var SyntheticAnimationEvent = __webpack_require__(161);
	var SyntheticClipboardEvent = __webpack_require__(162);
	var SyntheticEvent = __webpack_require__(63);
	var SyntheticFocusEvent = __webpack_require__(163);
	var SyntheticKeyboardEvent = __webpack_require__(164);
	var SyntheticMouseEvent = __webpack_require__(80);
	var SyntheticDragEvent = __webpack_require__(167);
	var SyntheticTouchEvent = __webpack_require__(168);
	var SyntheticTransitionEvent = __webpack_require__(169);
	var SyntheticUIEvent = __webpack_require__(81);
	var SyntheticWheelEvent = __webpack_require__(170);
	
	var emptyFunction = __webpack_require__(19);
	var getEventCharCode = __webpack_require__(165);
	var invariant = __webpack_require__(22);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(63);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(63);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(81);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(81);
	
	var getEventCharCode = __webpack_require__(165);
	var getEventKey = __webpack_require__(166);
	var getEventModifierState = __webpack_require__(83);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 165 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(165);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(80);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(81);
	
	var getEventModifierState = __webpack_require__(83);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(63);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(80);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(45);
	
	var DOMLazyTree = __webpack_require__(87);
	var DOMProperty = __webpack_require__(46);
	var React = __webpack_require__(13);
	var ReactBrowserEventEmitter = __webpack_require__(111);
	var ReactCurrentOwner = __webpack_require__(27);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactDOMContainerInfo = __webpack_require__(172);
	var ReactDOMFeatureFlags = __webpack_require__(173);
	var ReactFeatureFlags = __webpack_require__(68);
	var ReactInstanceMap = __webpack_require__(122);
	var ReactInstrumentation = __webpack_require__(72);
	var ReactMarkupChecksum = __webpack_require__(174);
	var ReactReconciler = __webpack_require__(69);
	var ReactUpdateQueue = __webpack_require__(140);
	var ReactUpdates = __webpack_require__(66);
	
	var emptyObject = __webpack_require__(21);
	var instantiateReactComponent = __webpack_require__(124);
	var invariant = __webpack_require__(22);
	var setInnerHTML = __webpack_require__(89);
	var shouldUpdateReactComponent = __webpack_require__(128);
	var warning = __webpack_require__(18);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(141);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ }),
/* 173 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(175);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ }),
/* 175 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ }),
/* 176 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(45);
	
	var ReactCurrentOwner = __webpack_require__(27);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactInstanceMap = __webpack_require__(122);
	
	var getHostComponentFromComposite = __webpack_require__(178);
	var invariant = __webpack_require__(22);
	var warning = __webpack_require__(18);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(126);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(171);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.PropTypes = exports.RoutingContext = exports.RouterContext = exports.createRoutes = exports.useRoutes = exports.RouteContext = exports.Lifecycle = exports.History = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(181);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes2 = __webpack_require__(182);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(187);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(189);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(220);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(221);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(222);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(224);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(226);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(225);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(227);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _History2 = __webpack_require__(228);
	
	var _History3 = _interopRequireDefault(_History2);
	
	var _Lifecycle2 = __webpack_require__(229);
	
	var _Lifecycle3 = _interopRequireDefault(_Lifecycle2);
	
	var _RouteContext2 = __webpack_require__(230);
	
	var _RouteContext3 = _interopRequireDefault(_RouteContext2);
	
	var _useRoutes2 = __webpack_require__(231);
	
	var _useRoutes3 = _interopRequireDefault(_useRoutes2);
	
	var _RouterContext2 = __webpack_require__(217);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _RoutingContext2 = __webpack_require__(232);
	
	var _RoutingContext3 = _interopRequireDefault(_RoutingContext2);
	
	var _PropTypes3 = _interopRequireDefault(_PropTypes2);
	
	var _match2 = __webpack_require__(233);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(237);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(238);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(239);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(242);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(234);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* mixins */
	
	exports.History = _History3.default;
	exports.Lifecycle = _Lifecycle3.default;
	exports.RouteContext = _RouteContext3.default;
	
	/* utils */
	
	exports.useRoutes = _useRoutes3.default;
	exports.RouterContext = _RouterContext3.default;
	exports.RoutingContext = _RoutingContext3.default;
	exports.PropTypes = _PropTypes3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.router = exports.routes = exports.route = exports.components = exports.component = exports.location = exports.history = exports.falsy = exports.locationShape = exports.routerShape = undefined;
	
	var _react = __webpack_require__(12);
	
	var _deprecateObjectProperties = __webpack_require__(183);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _InternalPropTypes = __webpack_require__(186);
	
	var InternalPropTypes = _interopRequireWildcard(_InternalPropTypes);
	
	var _routerWarning = __webpack_require__(184);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	var routerShape = exports.routerShape = shape({
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired,
	  setRouteLeaveHook: func.isRequired,
	  isActive: func.isRequired
	});
	
	var locationShape = exports.locationShape = shape({
	  pathname: string.isRequired,
	  search: string.isRequired,
	  state: object,
	  action: string.isRequired,
	  key: string
	});
	
	// Deprecated stuff below:
	
	var falsy = exports.falsy = InternalPropTypes.falsy;
	var history = exports.history = InternalPropTypes.history;
	var location = exports.location = locationShape;
	var component = exports.component = InternalPropTypes.component;
	var components = exports.components = InternalPropTypes.components;
	var route = exports.route = InternalPropTypes.route;
	var routes = exports.routes = InternalPropTypes.routes;
	var router = exports.router = routerShape;
	
	if (false) {
	  (function () {
	    var deprecatePropType = function deprecatePropType(propType, message) {
	      return function () {
	        process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	        return propType.apply(undefined, arguments);
	      };
	    };
	
	    var deprecateInternalPropType = function deprecateInternalPropType(propType) {
	      return deprecatePropType(propType, 'This prop type is not intended for external use, and was previously exported by mistake. These internal prop types are deprecated for external use, and will be removed in a later version.');
	    };
	
	    var deprecateRenamedPropType = function deprecateRenamedPropType(propType, name) {
	      return deprecatePropType(propType, 'The `' + name + '` prop type is now exported as `' + name + 'Shape` to avoid name conflicts. This export is deprecated and will be removed in a later version.');
	    };
	
	    exports.falsy = falsy = deprecateInternalPropType(falsy);
	    exports.history = history = deprecateInternalPropType(history);
	    exports.component = component = deprecateInternalPropType(component);
	    exports.components = components = deprecateInternalPropType(components);
	    exports.route = route = deprecateInternalPropType(route);
	    exports.routes = routes = deprecateInternalPropType(routes);
	
	    exports.location = location = deprecateRenamedPropType(location, 'location');
	    exports.router = router = deprecateRenamedPropType(router, 'router');
	  })();
	}
	
	var defaultExport = {
	  falsy: falsy,
	  history: history,
	  location: location,
	  component: component,
	  components: components,
	  route: route,
	  // For some reason, routes was never here.
	  router: router
	};
	
	if (false) {
	  defaultExport = (0, _deprecateObjectProperties2.default)(defaultExport, 'The default export from `react-router/lib/PropTypes` is deprecated. Please use the named exports instead.');
	}
	
	exports.default = defaultExport;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.canUseMembrane = undefined;
	
	var _routerWarning = __webpack_require__(184);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseMembrane = exports.canUseMembrane = false;
	
	// No-op by default.
	var deprecateObjectProperties = function deprecateObjectProperties(object) {
	  return object;
	};
	
	if (false) {
	  try {
	    if (Object.defineProperty({}, 'x', {
	      get: function get() {
	        return true;
	      }
	    }).x) {
	      exports.canUseMembrane = canUseMembrane = true;
	    }
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	  if (canUseMembrane) {
	    deprecateObjectProperties = function deprecateObjectProperties(object, message) {
	      // Wrap the deprecated object in a membrane to warn on property access.
	      var membrane = {};
	
	      var _loop = function _loop(prop) {
	        if (!Object.prototype.hasOwnProperty.call(object, prop)) {
	          return 'continue';
	        }
	
	        if (typeof object[prop] === 'function') {
	          // Can't use fat arrow here because of use of arguments below.
	          membrane[prop] = function () {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop].apply(object, arguments);
	          };
	          return 'continue';
	        }
	
	        // These properties are non-enumerable to prevent React dev tools from
	        // seeing them and causing spurious warnings when accessing them. In
	        // principle this could be done with a proxy, but support for the
	        // ownKeys trap on proxies is not universal, even among browsers that
	        // otherwise support proxies.
	        Object.defineProperty(membrane, prop, {
	          get: function get() {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop];
	          }
	        });
	      };
	
	      for (var prop in object) {
	        var _ret = _loop(prop);
	
	        if (_ret === 'continue') continue;
	      }
	
	      return membrane;
	    };
	  }
	}
	
	exports.default = deprecateObjectProperties;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(185);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _react = __webpack_require__(12);
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var arrayOf = _react.PropTypes.arrayOf;
	var oneOfType = _react.PropTypes.oneOfType;
	var element = _react.PropTypes.element;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = shape({
	  listen: func.isRequired,
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired
	});
	
	var component = exports.component = oneOfType([func, string]);
	var components = exports.components = oneOfType([component, object]);
	var route = exports.route = oneOfType([object, element]);
	var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(188);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern);
	
	  var regexpSource = _compilePattern2.regexpSource;
	  var paramNames = _compilePattern2.paramNames;
	  var tokens = _compilePattern2.tokens;
	
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames;
	  var paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern);
	
	  var tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0;
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenCount += 1;
	    } else if (token === ')') {
	      parenCount -= 1;
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURIComponent(paramValue);
	    } else {
	      pathname += token;
	    }
	  }
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createHashHistory = __webpack_require__(190);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _useQueries = __webpack_require__(206);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _invariant = __webpack_require__(188);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createTransitionManager = __webpack_require__(209);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _InternalPropTypes = __webpack_require__(186);
	
	var _RouterContext = __webpack_require__(217);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(181);
	
	var _RouterUtils = __webpack_require__(219);
	
	var _routerWarning = __webpack_require__(184);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isDeprecatedHistory(history) {
	  return !history || !history.__v2_compatible__;
	}
	
	/* istanbul ignore next: sanity check */
	function isUnsupportedHistory(history) {
	  // v3 histories expose getCurrentLocation, but aren't currently supported.
	  return history && history.getCurrentLocation;
	}
	
	var _React$PropTypes = _react2.default.PropTypes;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	
	var Router = _react2.default.createClass({
	  displayName: 'Router',
	
	
	  propTypes: {
	    history: object,
	    children: _InternalPropTypes.routes,
	    routes: _InternalPropTypes.routes, // alias for children
	    render: func,
	    createElement: func,
	    onError: func,
	    onUpdate: func,
	
	    // Deprecated:
	    parseQueryString: func,
	    stringifyQuery: func,
	
	    // PRIVATE: For client-side rehydration of server match.
	    matchContext: object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    var _props = this.props;
	    var parseQueryString = _props.parseQueryString;
	    var stringifyQuery = _props.stringifyQuery;
	
	     false ? (0, _routerWarning2.default)(!(parseQueryString || stringifyQuery), '`parseQueryString` and `stringifyQuery` are deprecated. Please create a custom history. http://tiny.cc/router-customquerystring') : void 0;
	
	    var _createRouterObjects = this.createRouterObjects();
	
	    var history = _createRouterObjects.history;
	    var transitionManager = _createRouterObjects.transitionManager;
	    var router = _createRouterObjects.router;
	
	
	    this._unlisten = transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	
	    this.history = history;
	    this.router = router;
	  },
	  createRouterObjects: function createRouterObjects() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext;
	    }
	
	    var history = this.props.history;
	    var _props2 = this.props;
	    var routes = _props2.routes;
	    var children = _props2.children;
	
	
	    !!isUnsupportedHistory(history) ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v3.x. ' + 'This version of React Router is not compatible with v3 history ' + 'objects. Please use history v2.x instead.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isDeprecatedHistory(history)) {
	      history = this.wrapDeprecatedHistory(history);
	    }
	
	    var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	    var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	    var routingHistory = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	    return { history: routingHistory, transitionManager: transitionManager, router: router };
	  },
	  wrapDeprecatedHistory: function wrapDeprecatedHistory(history) {
	    var _props3 = this.props;
	    var parseQueryString = _props3.parseQueryString;
	    var stringifyQuery = _props3.stringifyQuery;
	
	
	    var createHistory = void 0;
	    if (history) {
	       false ? (0, _routerWarning2.default)(false, 'It appears you have provided a deprecated history object to `<Router/>`, please use a history provided by ' + 'React Router with `import { browserHistory } from \'react-router\'` or `import { hashHistory } from \'react-router\'`. ' + 'If you are using a custom history please create it with `useRouterHistory`, see http://tiny.cc/router-usinghistory for details.') : void 0;
	      createHistory = function createHistory() {
	        return history;
	      };
	    } else {
	       false ? (0, _routerWarning2.default)(false, '`Router` no longer defaults the history prop to hash history. Please use the `hashHistory` singleton instead. http://tiny.cc/router-defaulthistory') : void 0;
	      createHistory = _createHashHistory2.default;
	    }
	
	    return (0, _useQueries2.default)(createHistory)({ parseQueryString: parseQueryString, stringifyQuery: stringifyQuery });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state;
	    var location = _state.location;
	    var routes = _state.routes;
	    var params = _state.params;
	    var components = _state.components;
	    var _props4 = this.props;
	    var createElement = _props4.createElement;
	    var render = _props4.render;
	
	    var props = _objectWithoutProperties(_props4, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(Router.propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      history: this.history,
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(191);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(188);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(192);
	
	var _PathUtils = __webpack_require__(193);
	
	var _ExecutionEnvironment = __webpack_require__(194);
	
	var _DOMUtils = __webpack_require__(195);
	
	var _DOMStateStorage = __webpack_require__(196);
	
	var _createDOMHistory = __webpack_require__(197);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	function isAbsolutePath(path) {
	  return typeof path === 'string' && path.charAt(0) === '/';
	}
	
	function ensureSlash() {
	  var path = _DOMUtils.getHashPath();
	
	  if (isAbsolutePath(path)) return true;
	
	  _DOMUtils.replaceHashPath('/' + path);
	
	  return false;
	}
	
	function addQueryStringValueToPath(path, key, value) {
	  return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
	}
	
	function stripQueryStringValueFromPath(path, key) {
	  return path.replace(new RegExp('[?&]?' + key + '=[a-zA-Z0-9]+'), '');
	}
	
	function getQueryStringValueFromPath(path, key) {
	  var match = path.match(new RegExp('\\?.*?\\b' + key + '=(.+?)\\b'));
	  return match && match[1];
	}
	
	var DefaultQueryKey = '_k';
	
	function createHashHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Hash history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var queryKey = options.queryKey;
	
	  if (queryKey === undefined || !!queryKey) queryKey = typeof queryKey === 'string' ? queryKey : DefaultQueryKey;
	
	  function getCurrentLocation() {
	    var path = _DOMUtils.getHashPath();
	
	    var key = undefined,
	        state = undefined;
	    if (queryKey) {
	      key = getQueryStringValueFromPath(path, queryKey);
	      path = stripQueryStringValueFromPath(path, queryKey);
	
	      if (key) {
	        state = _DOMStateStorage.readState(key);
	      } else {
	        state = null;
	        key = history.createKey();
	        _DOMUtils.replaceHashPath(addQueryStringValueToPath(path, queryKey, key));
	      }
	    } else {
	      key = state = null;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startHashChangeListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function hashChangeListener() {
	      if (!ensureSlash()) return; // Always make sure hashes are preceeded with a /.
	
	      transitionTo(getCurrentLocation());
	    }
	
	    ensureSlash();
	    _DOMUtils.addEventListener(window, 'hashchange', hashChangeListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'hashchange', hashChangeListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    var path = (basename || '') + pathname + search;
	
	    if (queryKey) {
	      path = addQueryStringValueToPath(path, queryKey, key);
	      _DOMStateStorage.saveState(key, state);
	    } else {
	      // Drop key and state.
	      location.key = location.state = null;
	    }
	
	    var currentHash = _DOMUtils.getHashPath();
	
	    if (action === _Actions.PUSH) {
	      if (currentHash !== path) {
	        window.location.hash = path;
	      } else {
	         false ? _warning2['default'](false, 'You cannot PUSH the same path using hash history') : undefined;
	      }
	    } else if (currentHash !== path) {
	      // REPLACE
	      _DOMUtils.replaceHashPath(path);
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopHashChangeListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function push(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.push(location);
	  }
	
	  function replace(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replace(location);
	  }
	
	  var goIsSupportedWithoutReload = _DOMUtils.supportsGoWithoutReloadUsingHash();
	
	  function go(n) {
	     false ? _warning2['default'](goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : undefined;
	
	    history.go(n);
	  }
	
	  function createHref(path) {
	    return '#' + history.createHref(path);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopHashChangeListener();
	  }
	
	  // deprecated
	  function pushState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.pushState(state, path);
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replaceState(state, path);
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    push: push,
	    replace: replace,
	    go: go,
	    createHref: createHref,
	
	    registerTransitionHook: registerTransitionHook, // deprecated - warning is in createHistory
	    unregisterTransitionHook: unregisterTransitionHook, // deprecated - warning is in createHistory
	    pushState: pushState, // deprecated - warning is in createHistory
	    replaceState: replaceState // deprecated - warning is in createHistory
	  });
	}
	
	exports['default'] = createHashHistory;
	module.exports = exports['default'];

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 192 */
/***/ (function(module, exports) {

	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	'use strict';
	
	exports.__esModule = true;
	var PUSH = 'PUSH';
	
	exports.PUSH = PUSH;
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = 'REPLACE';
	
	exports.REPLACE = REPLACE;
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = 'POP';
	
	exports.POP = POP;
	exports['default'] = {
	  PUSH: PUSH,
	  REPLACE: REPLACE,
	  POP: POP
	};

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.extractPath = extractPath;
	exports.parsePath = parsePath;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(191);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function extractPath(string) {
	  var match = string.match(/^https?:\/\/[^\/]*/);
	
	  if (match == null) return string;
	
	  return string.substring(match[0].length);
	}
	
	function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? _warning2['default'](path === pathname, 'A path must be pathname + search + hash only, not a fully qualified URL like "%s"', path) : undefined;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	}

/***/ }),
/* 194 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	exports.canUseDOM = canUseDOM;

/***/ }),
/* 195 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.getHashPath = getHashPath;
	exports.replaceHashPath = replaceHashPath;
	exports.getWindowPath = getWindowPath;
	exports.go = go;
	exports.getUserConfirmation = getUserConfirmation;
	exports.supportsHistory = supportsHistory;
	exports.supportsGoWithoutReloadUsingHash = supportsGoWithoutReloadUsingHash;
	
	function addEventListener(node, event, listener) {
	  if (node.addEventListener) {
	    node.addEventListener(event, listener, false);
	  } else {
	    node.attachEvent('on' + event, listener);
	  }
	}
	
	function removeEventListener(node, event, listener) {
	  if (node.removeEventListener) {
	    node.removeEventListener(event, listener, false);
	  } else {
	    node.detachEvent('on' + event, listener);
	  }
	}
	
	function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  return window.location.href.split('#')[1] || '';
	}
	
	function replaceHashPath(path) {
	  window.location.replace(window.location.pathname + window.location.search + '#' + path);
	}
	
	function getWindowPath() {
	  return window.location.pathname + window.location.search + window.location.hash;
	}
	
	function go(n) {
	  if (n) window.history.go(n);
	}
	
	function getUserConfirmation(message, callback) {
	  callback(window.confirm(message));
	}
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	 */
	
	function supportsHistory() {
	  var ua = navigator.userAgent;
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
	    return false;
	  }
	  return window.history && 'pushState' in window.history;
	}
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	
	function supportsGoWithoutReloadUsingHash() {
	  var ua = navigator.userAgent;
	  return ua.indexOf('Firefox') === -1;
	}

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	/*eslint-disable no-empty */
	'use strict';
	
	exports.__esModule = true;
	exports.saveState = saveState;
	exports.readState = readState;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(191);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var KeyPrefix = '@@History/';
	var QuotaExceededErrors = ['QuotaExceededError', 'QUOTA_EXCEEDED_ERR'];
	
	var SecurityError = 'SecurityError';
	
	function createKey(key) {
	  return KeyPrefix + key;
	}
	
	function saveState(key, state) {
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available due to security settings') : undefined;
	
	      return;
	    }
	
	    if (QuotaExceededErrors.indexOf(error.name) >= 0 && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : undefined;
	
	      return;
	    }
	
	    throw error;
	  }
	}
	
	function readState(key) {
	  var json = undefined;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to read state; sessionStorage is not available due to security settings') : undefined;
	
	      return null;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return null;
	}

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(188);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(194);
	
	var _DOMUtils = __webpack_require__(195);
	
	var _createHistory = __webpack_require__(198);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createDOMHistory(options) {
	  var history = _createHistory2['default'](_extends({
	    getUserConfirmation: _DOMUtils.getUserConfirmation
	  }, options, {
	    go: _DOMUtils.go
	  }));
	
	  function listen(listener) {
	    !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'DOM history needs a DOM') : _invariant2['default'](false) : undefined;
	
	    return history.listen(listener);
	  }
	
	  return _extends({}, history, {
	    listen: listen
	  });
	}
	
	exports['default'] = createDOMHistory;
	module.exports = exports['default'];

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(191);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _deepEqual = __webpack_require__(199);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _PathUtils = __webpack_require__(193);
	
	var _AsyncUtils = __webpack_require__(202);
	
	var _Actions = __webpack_require__(192);
	
	var _createLocation2 = __webpack_require__(203);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _runTransitionHook = __webpack_require__(204);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(205);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function createRandomKey(length) {
	  return Math.random().toString(36).substr(2, length);
	}
	
	function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search &&
	  //a.action === b.action && // Different action !== location change.
	  a.key === b.key && _deepEqual2['default'](a.state, b.state);
	}
	
	var DefaultKeyLength = 6;
	
	function createHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var getCurrentLocation = options.getCurrentLocation;
	  var finishTransition = options.finishTransition;
	  var saveState = options.saveState;
	  var go = options.go;
	  var getUserConfirmation = options.getUserConfirmation;
	  var keyLength = options.keyLength;
	
	  if (typeof keyLength !== 'number') keyLength = DefaultKeyLength;
	
	  var transitionHooks = [];
	
	  function listenBefore(hook) {
	    transitionHooks.push(hook);
	
	    return function () {
	      transitionHooks = transitionHooks.filter(function (item) {
	        return item !== hook;
	      });
	    };
	  }
	
	  var allKeys = [];
	  var changeListeners = [];
	  var location = undefined;
	
	  function getCurrent() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) {
	      return allKeys.indexOf(pendingLocation.key);
	    } else if (location) {
	      return allKeys.indexOf(location.key);
	    } else {
	      return -1;
	    }
	  }
	
	  function updateLocation(newLocation) {
	    var current = getCurrent();
	
	    location = newLocation;
	
	    if (location.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, current + 1), [location.key]);
	    } else if (location.action === _Actions.REPLACE) {
	      allKeys[current] = location.key;
	    }
	
	    changeListeners.forEach(function (listener) {
	      listener(location);
	    });
	  }
	
	  function listen(listener) {
	    changeListeners.push(listener);
	
	    if (location) {
	      listener(location);
	    } else {
	      var _location = getCurrentLocation();
	      allKeys = [_location.key];
	      updateLocation(_location);
	    }
	
	    return function () {
	      changeListeners = changeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }
	
	  function confirmTransitionTo(location, callback) {
	    _AsyncUtils.loopAsync(transitionHooks.length, function (index, next, done) {
	      _runTransitionHook2['default'](transitionHooks[index], location, function (result) {
	        if (result != null) {
	          done(result);
	        } else {
	          next();
	        }
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  }
	
	  var pendingLocation = undefined;
	
	  function transitionTo(nextLocation) {
	    if (location && locationsAreEqual(location, nextLocation)) return; // Nothing to do.
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted.
	
	      if (ok) {
	        // treat PUSH to current path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = createPath(location);
	          var nextPath = createPath(nextLocation);
	
	          if (nextPath === prevPath && _deepEqual2['default'](location.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (finishTransition(nextLocation) !== false) updateLocation(nextLocation);
	      } else if (location && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(location.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL.
	      }
	    });
	  }
	
	  function push(location) {
	    transitionTo(createLocation(location, _Actions.PUSH, createKey()));
	  }
	
	  function replace(location) {
	    transitionTo(createLocation(location, _Actions.REPLACE, createKey()));
	  }
	
	  function goBack() {
	    go(-1);
	  }
	
	  function goForward() {
	    go(1);
	  }
	
	  function createKey() {
	    return createRandomKey(keyLength);
	  }
	
	  function createPath(location) {
	    if (location == null || typeof location === 'string') return location;
	
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	
	    var result = pathname;
	
	    if (search) result += search;
	
	    if (hash) result += hash;
	
	    return result;
	  }
	
	  function createHref(location) {
	    return createPath(location);
	  }
	
	  function createLocation(location, action) {
	    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
	
	    if (typeof action === 'object') {
	       false ? _warning2['default'](false, 'The state (2nd) argument to history.createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      location = _extends({}, location, { state: action });
	
	      action = key;
	      key = arguments[3] || createKey();
	    }
	
	    return _createLocation3['default'](location, action, key);
	  }
	
	  // deprecated
	  function setState(state) {
	    if (location) {
	      updateLocationState(location, state);
	      updateLocation(location);
	    } else {
	      updateLocationState(getCurrentLocation(), state);
	    }
	  }
	
	  function updateLocationState(location, state) {
	    location.state = _extends({}, location.state, state);
	    saveState(location.key, location.state);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (transitionHooks.indexOf(hook) === -1) transitionHooks.push(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    transitionHooks = transitionHooks.filter(function (item) {
	      return item !== hook;
	    });
	  }
	
	  // deprecated
	  function pushState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    push(_extends({ state: state }, path));
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    replace(_extends({ state: state }, path));
	  }
	
	  return {
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: createPath,
	    createHref: createHref,
	    createLocation: createLocation,
	
	    setState: _deprecate2['default'](setState, 'setState is deprecated; use location.key to save state instead'),
	    registerTransitionHook: _deprecate2['default'](registerTransitionHook, 'registerTransitionHook is deprecated; use listenBefore instead'),
	    unregisterTransitionHook: _deprecate2['default'](unregisterTransitionHook, 'unregisterTransitionHook is deprecated; use the callback returned from listenBefore instead'),
	    pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	    replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	  };
	}
	
	exports['default'] = createHistory;
	module.exports = exports['default'];

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(200);
	var isArguments = __webpack_require__(201);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),
/* 200 */
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),
/* 201 */
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),
/* 202 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var _slice = Array.prototype.slice;
	exports.loopAsync = loopAsync;
	
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = undefined;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(_slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(191);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Actions = __webpack_require__(192);
	
	var _PathUtils = __webpack_require__(193);
	
	function createLocation() {
	  var location = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
	  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	  var _fourthArg = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	
	  if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	  if (typeof action === 'object') {
	     false ? _warning2['default'](false, 'The state (2nd) argument to createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	    location = _extends({}, location, { state: action });
	
	    action = key || _Actions.POP;
	    key = _fourthArg;
	  }
	
	  var pathname = location.pathname || '/';
	  var search = location.search || '';
	  var hash = location.hash || '';
	  var state = location.state || null;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	}
	
	exports['default'] = createLocation;
	module.exports = exports['default'];

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(191);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? _warning2['default'](result === undefined, 'You should not "return" in a transition hook with a callback argument; call the callback instead') : undefined;
	  }
	}
	
	exports['default'] = runTransitionHook;
	module.exports = exports['default'];

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(191);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function deprecate(fn, message) {
	  return function () {
	     false ? _warning2['default'](false, '[history] ' + message) : undefined;
	    return fn.apply(this, arguments);
	  };
	}
	
	exports['default'] = deprecate;
	module.exports = exports['default'];

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(191);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _queryString = __webpack_require__(207);
	
	var _runTransitionHook = __webpack_require__(204);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(193);
	
	var _deprecate = __webpack_require__(205);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var SEARCH_BASE_KEY = '$searchBase';
	
	function defaultStringifyQuery(query) {
	  return _queryString.stringify(query).replace(/%20/g, '+');
	}
	
	var defaultParseQueryString = _queryString.parse;
	
	function isNestedObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p) && typeof object[p] === 'object' && !Array.isArray(object[p]) && object[p] !== null) return true;
	  }return false;
	}
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var stringifyQuery = options.stringifyQuery;
	    var parseQueryString = options.parseQueryString;
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    function addQuery(location) {
	      if (location.query == null) {
	        var search = location.search;
	
	        location.query = parseQueryString(search.substring(1));
	        location[SEARCH_BASE_KEY] = { search: search, searchBase: '' };
	      }
	
	      // TODO: Instead of all the book-keeping here, this should just strip the
	      // stringified query from the search.
	
	      return location;
	    }
	
	    function appendQuery(location, query) {
	      var _extends2;
	
	      var searchBaseSpec = location[SEARCH_BASE_KEY];
	      var queryString = query ? stringifyQuery(query) : '';
	      if (!searchBaseSpec && !queryString) {
	        return location;
	      }
	
	       false ? _warning2['default'](stringifyQuery !== defaultStringifyQuery || !isNestedObject(query), 'useQueries does not stringify nested query objects by default; ' + 'use a custom stringifyQuery function') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var searchBase = undefined;
	      if (searchBaseSpec && location.search === searchBaseSpec.search) {
	        searchBase = searchBaseSpec.searchBase;
	      } else {
	        searchBase = location.search || '';
	      }
	
	      var search = searchBase;
	      if (queryString) {
	        search += (search ? '&' : '?') + queryString;
	      }
	
	      return _extends({}, location, (_extends2 = {
	        search: search
	      }, _extends2[SEARCH_BASE_KEY] = { search: search, searchBase: searchBase }, _extends2));
	    }
	
	    // Override all read methods with query-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addQuery(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addQuery(location));
	      });
	    }
	
	    // Override all write methods with query-aware versions.
	    function push(location) {
	      history.push(appendQuery(location, location.query));
	    }
	
	    function replace(location) {
	      history.replace(appendQuery(location, location.query));
	    }
	
	    function createPath(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createPath is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createPath(appendQuery(location, query || location.query));
	    }
	
	    function createHref(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createHref is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createHref(appendQuery(location, query || location.query));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var fullLocation = history.createLocation.apply(history, [appendQuery(location, location.query)].concat(args));
	      if (location.query) {
	        fullLocation.query = location.query;
	      }
	      return addQuery(fullLocation);
	    }
	
	    // deprecated
	    function pushState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path, { query: query }));
	    }
	
	    // deprecated
	    function replaceState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path, { query: query }));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useQueries;
	module.exports = exports['default'];

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(208);
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		if (typeof str !== 'string') {
			return {};
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return {};
		}
	
		return str.split('&').reduce(function (ret, param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (!ret.hasOwnProperty(key)) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
	
			return ret;
		}, {});
	};
	
	exports.stringify = function (obj) {
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return key;
			}
	
			if (Array.isArray(val)) {
				return val.slice().sort().map(function (val2) {
					return strictUriEncode(key) + '=' + strictUriEncode(val2);
				}).join('&');
			}
	
			return strictUriEncode(key) + '=' + strictUriEncode(val);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ }),
/* 208 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(184);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(210);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(211);
	
	var _isActive2 = __webpack_require__(213);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(214);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(216);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	  function isActive(location) {
	    var indexOnlyOrDeprecatedQuery = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	    var deprecatedIndexOnly = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	    var indexOnly = void 0;
	    if (indexOnlyOrDeprecatedQuery && indexOnlyOrDeprecatedQuery !== true || deprecatedIndexOnly !== null) {
	       false ? (0, _routerWarning2.default)(false, '`isActive(pathname, query, indexOnly) is deprecated; use `isActive(location, indexOnly)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      location = { pathname: location, query: indexOnlyOrDeprecatedQuery };
	      indexOnly = deprecatedIndexOnly || false;
	    } else {
	      location = history.createLocation(location);
	      indexOnly = indexOnlyOrDeprecatedQuery;
	    }
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState);
	
	    var leaveRoutes = _computeChangedRoutes.leaveRoutes;
	    var changeRoutes = _computeChangedRoutes.changeRoutes;
	    var enterRoutes = _computeChangedRoutes.enterRoutes;
	
	
	    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.reduce(function (hooks, route) {
	      hooks.push.apply(hooks, RouteHooks[getRouteID(route)]);
	      return hooks;
	    }, []);
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route, false);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    // TODO: Warn if they register for a route that isn't currently
	    // active. They're probably doing something wrong, like re-creating
	    // route objects on every location change.
	    var routeID = getRouteID(route);
	    var hooks = RouteHooks[routeID];
	
	    if (!hooks) {
	      var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	
	      RouteHooks[routeID] = [hook];
	
	      if (thereWereNoRouteHooks) {
	        // setup transition & beforeunload hooks
	        unlistenBefore = history.listenBefore(transitionHook);
	
	        if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	      }
	    } else {
	      if (hooks.indexOf(hook) === -1) {
	         false ? (0, _routerWarning2.default)(false, 'adding multiple leave hooks for the same route is deprecated; manage multiple confirmations in your own code instead') : void 0;
	
	        hooks.push(hook);
	      }
	    }
	
	    return function () {
	      var hooks = RouteHooks[routeID];
	
	      if (hooks) {
	        var newHooks = hooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (newHooks.length === 0) {
	          removeListenBeforeHooksForRoute(route);
	        } else {
	          RouteHooks[routeID] = newHooks;
	        }
	      }
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    // TODO: Only use a single history listener. Otherwise we'll
	    // end up with multiple concurrent calls to match.
	    return history.listen(function (location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    });
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	
	//export default useRoutes
	
	module.exports = exports['default'];

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(187);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    (function () {
	      var parentIsLeaving = false;
	      leaveRoutes = prevRoutes.filter(function (route) {
	        if (parentIsLeaving) {
	          return true;
	        } else {
	          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	          if (isLeaving) parentIsLeaving = true;
	          return isLeaving;
	        }
	      });
	
	      // onLeave hooks start at the leaf route.
	      leaveRoutes.reverse();
	
	      enterRoutes = [];
	      changeRoutes = [];
	
	      nextRoutes.forEach(function (route) {
	        var isNew = prevRoutes.indexOf(route) === -1;
	        var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	      });
	    })();
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runEnterHooks = runEnterHooks;
	exports.runChangeHooks = runChangeHooks;
	exports.runLeaveHooks = runLeaveHooks;
	
	var _AsyncUtils = __webpack_require__(212);
	
	var _routerWarning = __webpack_require__(184);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createTransitionHook(hook, route, asyncArity) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    hook.apply(route, args);
	
	    if (hook.length < asyncArity) {
	      var callback = args[args.length - 1];
	      // Assume hook executes synchronously and
	      // automatically call the callback.
	      callback();
	    }
	  };
	}
	
	function getEnterHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3));
	
	    return hooks;
	  }, []);
	}
	
	function getChangeHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4));
	    return hooks;
	  }, []);
	}
	
	function runTransitionHooks(length, iter, callback) {
	  if (!length) {
	    callback();
	    return;
	  }
	
	  var redirectInfo = void 0;
	  function replace(location, deprecatedPathname, deprecatedQuery) {
	    if (deprecatedPathname) {
	       false ? (0, _routerWarning2.default)(false, '`replaceState(state, pathname, query) is deprecated; use `replace(location)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      redirectInfo = {
	        pathname: deprecatedPathname,
	        query: deprecatedQuery,
	        state: location
	      };
	
	      return;
	    }
	
	    redirectInfo = location;
	  }
	
	  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	    iter(index, replace, function (error) {
	      if (error || redirectInfo) {
	        done(error, redirectInfo); // No need to continue.
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	
	/**
	 * Runs all onEnter hooks in the given array of routes in order
	 * with onEnter(nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runEnterHooks(routes, nextState, callback) {
	  var hooks = getEnterHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onChange hooks in the given array of routes in order
	 * with onChange(prevState, nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runChangeHooks(routes, state, nextState, callback) {
	  var hooks = getChangeHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](state, nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onLeave hooks in the given array of routes in order.
	 */
	function runLeaveHooks(routes, prevState) {
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	  }
	}

/***/ }),
/* 212 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(187);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname;
	  var query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(212);
	
	var _makeStateWithLocation = __webpack_require__(215);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (!getComponent) {
	    callback();
	    return;
	  }
	
	  var location = nextState.location;
	
	  var nextStateWithLocation = (0, _makeStateWithLocation2.default)(nextState, location);
	
	  getComponent.call(route, nextStateWithLocation, callback);
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = makeStateWithLocation;
	
	var _deprecateObjectProperties = __webpack_require__(183);
	
	var _routerWarning = __webpack_require__(184);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeStateWithLocation(state, location) {
	  if (false) {
	    var stateWithLocation = _extends({}, state);
	
	    // I don't use deprecateObjectProperties here because I want to keep the
	    // same code path between development and production, in that we just
	    // assign extra properties to the copy of the state object in both cases.
	
	    var _loop = function _loop(prop) {
	      if (!Object.prototype.hasOwnProperty.call(location, prop)) {
	        return 'continue';
	      }
	
	      Object.defineProperty(stateWithLocation, prop, {
	        get: function get() {
	          process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, 'Accessing location properties directly from the first argument to `getComponent`, `getComponents`, `getChildRoutes`, and `getIndexRoute` is deprecated. That argument is now the router state (`nextState` or `partialNextState`) rather than the location. To access the location, use `nextState.location` or `partialNextState.location`.') : void 0;
	          return location[prop];
	        }
	      });
	    };
	
	    for (var prop in location) {
	      var _ret = _loop(prop);
	
	      if (_ret === 'continue') continue;
	    }
	
	    return stateWithLocation;
	  }
	
	  return _extends({}, state, location);
	}
	module.exports = exports['default'];

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(212);
	
	var _makeStateWithLocation = __webpack_require__(215);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	var _PatternUtils = __webpack_require__(187);
	
	var _routerWarning = __webpack_require__(184);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(181);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	  route.getChildRoutes(partialNextStateWithLocation, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	    route.getIndexRoute(partialNextStateWithLocation, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	  } else if (route.childRoutes) {
	    (function () {
	      var pathless = route.childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    })();
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var _ret2 = function () {
	        var match = {
	          routes: [route],
	          params: createParams(paramNames, paramValues)
	        };
	
	        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	          if (error) {
	            callback(error);
	          } else {
	            if (Array.isArray(indexRoute)) {
	              var _match$routes;
	
	               false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	                return !route.path;
	              }), 'Index routes should not have paths') : void 0;
	              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	            } else if (indexRoute) {
	               false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	              match.routes.push(indexRoute);
	            }
	
	            callback(null, match);
	          }
	        });
	
	        return {
	          v: void 0
	        };
	      }();
	
	      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];
	  var paramValues = arguments.length <= 5 || arguments[5] === undefined ? [] : arguments[5];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(188);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _deprecateObjectProperties = __webpack_require__(183);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _getRouteParams = __webpack_require__(218);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _RouteUtils = __webpack_require__(181);
	
	var _routerWarning = __webpack_require__(184);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var array = _React$PropTypes.array;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	
	var RouterContext = _react2.default.createClass({
	  displayName: 'RouterContext',
	
	
	  propTypes: {
	    history: object,
	    router: object.isRequired,
	    location: object.isRequired,
	    routes: array.isRequired,
	    params: object.isRequired,
	    components: array.isRequired,
	    createElement: func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    history: object,
	    location: object.isRequired,
	    router: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    var _props = this.props;
	    var router = _props.router;
	    var history = _props.history;
	    var location = _props.location;
	
	    if (!router) {
	       false ? (0, _routerWarning2.default)(false, '`<RouterContext>` expects a `router` rather than a `history`') : void 0;
	
	      router = _extends({}, history, {
	        setRouteLeaveHook: history.listenBeforeLeavingRoute
	      });
	      delete router.listenBeforeLeavingRoute;
	    }
	
	    if (false) {
	      location = (0, _deprecateObjectProperties2.default)(location, '`context.location` is deprecated, please use a route component\'s `props.location` instead. http://tiny.cc/router-accessinglocation');
	    }
	
	    return { history: history, location: location, router: router };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props2 = this.props;
	    var history = _props2.history;
	    var location = _props2.location;
	    var routes = _props2.routes;
	    var params = _props2.params;
	    var components = _props2.components;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          history: history,
	          location: location,
	          params: params,
	          route: route,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(187);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.createRoutingHistory = createRoutingHistory;
	
	var _deprecateObjectProperties = __webpack_require__(183);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createRouterObject(history, transitionManager) {
	  return _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	}
	
	// deprecated
	function createRoutingHistory(history, transitionManager) {
	  history = _extends({}, history, transitionManager);
	
	  if (false) {
	    history = (0, _deprecateObjectProperties2.default)(history, '`props.history` and `context.history` are deprecated. Please use `context.router`. http://tiny.cc/router-contextchanges');
	  }
	
	  return history;
	}

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(184);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(188);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(182);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var bool = _React$PropTypes.bool;
	var object = _React$PropTypes.object;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	var oneOfType = _React$PropTypes.oneOfType;
	
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function createLocationDescriptor(to, _ref) {
	  var query = _ref.query;
	  var hash = _ref.hash;
	  var state = _ref.state;
	
	  if (query || hash || state) {
	    return { pathname: to, query: query, hash: hash, state: state };
	  }
	
	  return to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 *
	 * Links may pass along location state and/or query string parameters
	 * in the state/query props, respectively.
	 *
	 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
	 */
	var Link = _react2.default.createClass({
	  displayName: 'Link',
	
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: oneOfType([string, object]),
	    query: object,
	    hash: string,
	    state: object,
	    activeStyle: object,
	    activeClassName: string,
	    onlyActiveOnIndex: bool.isRequired,
	    onClick: func,
	    target: string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    !this.context.router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    var _props = this.props;
	    var to = _props.to;
	    var query = _props.query;
	    var hash = _props.hash;
	    var state = _props.state;
	
	    var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	
	    this.context.router.push(location);
	  },
	  render: function render() {
	    var _props2 = this.props;
	    var to = _props2.to;
	    var query = _props2.query;
	    var hash = _props2.hash;
	    var state = _props2.state;
	    var activeClassName = _props2.activeClassName;
	    var activeStyle = _props2.activeStyle;
	    var onlyActiveOnIndex = _props2.onlyActiveOnIndex;
	
	    var props = _objectWithoutProperties(_props2, ['to', 'query', 'hash', 'state', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	     false ? (0, _routerWarning2.default)(!(query || hash || state), 'the `query`, `hash`, and `state` props on `<Link>` are deprecated, use `<Link to={{ pathname, query, hash, state }}/>. http://tiny.cc/router-isActivedeprecated') : void 0;
	
	    // Ignore if rendered outside the context of router, simplifies unit testing.
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (to == null) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	      props.href = router.createHref(location);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(location, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(220);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = _react2.default.createClass({
	  displayName: 'IndexLink',
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(188);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(223);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _PropTypes = __webpack_require__(182);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = _react2.default.createClass({
	    displayName: 'WithRouter',
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      var props = _extends({}, this.props, { router: router });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ }),
/* 223 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(184);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(188);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(225);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	
	var IndexRedirect = _react2.default.createClass({
	  displayName: 'IndexRedirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(188);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(181);
	
	var _PatternUtils = __webpack_require__(187);
	
	var _InternalPropTypes = __webpack_require__(186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	
	var Redirect = _react2.default.createClass({
	  displayName: 'Redirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location;
	        var params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: string,
	    from: string, // Alias for path
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(184);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(188);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(181);
	
	var _InternalPropTypes = __webpack_require__(186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react2.default.PropTypes.func;
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	
	var IndexRoute = _react2.default.createClass({
	  displayName: 'IndexRoute',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(188);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(181);
	
	var _InternalPropTypes = __webpack_require__(186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	
	var Route = _react2.default.createClass({
	  displayName: 'Route',
	
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(184);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _InternalPropTypes = __webpack_require__(186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A mixin that adds the "history" instance variable to components.
	 */
	var History = {
	
	  contextTypes: {
	    history: _InternalPropTypes.history
	  },
	
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `History` mixin is deprecated, please access `context.router` with your own `contextTypes`. http://tiny.cc/router-historymixin') : void 0;
	    this.history = this.context.history;
	  }
	};
	
	exports.default = History;
	module.exports = exports['default'];

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(184);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(188);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The Lifecycle mixin adds the routerWillLeave lifecycle method to a
	 * component that may be used to cancel a transition or prompt the user
	 * for confirmation.
	 *
	 * On standard transitions, routerWillLeave receives a single argument: the
	 * location we're transitioning to. To cancel the transition, return false.
	 * To prompt the user for confirmation, return a prompt message (string).
	 *
	 * During the beforeunload event (assuming you're using the useBeforeUnload
	 * history enhancer), routerWillLeave does not receive a location object
	 * because it isn't possible for us to know the location we're transitioning
	 * to. In this case routerWillLeave must return a prompt message to prevent
	 * the user from closing the window/tab.
	 */
	
	var Lifecycle = {
	
	  contextTypes: {
	    history: object.isRequired,
	    // Nested children receive the route as context, either
	    // set by the route component using the RouteContext mixin
	    // or by some other ancestor.
	    route: object
	  },
	
	  propTypes: {
	    // Route components receive the route object as a prop.
	    route: object
	  },
	
	  componentDidMount: function componentDidMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `Lifecycle` mixin is deprecated, please use `context.router.setRouteLeaveHook(route, hook)`. http://tiny.cc/router-lifecyclemixin') : void 0;
	    !this.routerWillLeave ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin requires you to define a routerWillLeave method') : (0, _invariant2.default)(false) : void 0;
	
	    var route = this.props.route || this.context.route;
	
	    !route ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin must be used on either a) a <Route component> or ' + 'b) a descendant of a <Route component> that uses the RouteContext mixin') : (0, _invariant2.default)(false) : void 0;
	
	    this._unlistenBeforeLeavingRoute = this.context.history.listenBeforeLeavingRoute(route, this.routerWillLeave);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlistenBeforeLeavingRoute) this._unlistenBeforeLeavingRoute();
	  }
	};
	
	exports.default = Lifecycle;
	module.exports = exports['default'];

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(184);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The RouteContext mixin provides a convenient way for route
	 * components to set the route in context. This is needed for
	 * routes that render elements that want to use the Lifecycle
	 * mixin to prevent transitions.
	 */
	
	var RouteContext = {
	
	  propTypes: {
	    route: object.isRequired
	  },
	
	  childContextTypes: {
	    route: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      route: this.props.route
	    };
	  },
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'The `RouteContext` mixin is deprecated. You can provide `this.props.route` on context with your own `contextTypes`. http://tiny.cc/router-routecontextmixin') : void 0;
	  }
	};
	
	exports.default = RouteContext;
	module.exports = exports['default'];

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _useQueries = __webpack_require__(206);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _createTransitionManager = __webpack_require__(209);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _routerWarning = __webpack_require__(184);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know about routing.
	 *
	 * Enhances history objects with the following methods:
	 *
	 * - listen((error, nextState) => {})
	 * - listenBeforeLeavingRoute(route, (nextLocation) => {})
	 * - match(location, (error, redirectLocation, nextState) => {})
	 * - isActive(pathname, query, indexOnly=false)
	 */
	function useRoutes(createHistory) {
	   false ? (0, _routerWarning2.default)(false, '`useRoutes` is deprecated. Please use `createTransitionManager` instead.') : void 0;
	
	  return function () {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var routes = _ref.routes;
	
	    var options = _objectWithoutProperties(_ref, ['routes']);
	
	    var history = (0, _useQueries2.default)(createHistory)(options);
	    var transitionManager = (0, _createTransitionManager2.default)(history, routes);
	    return _extends({}, history, transitionManager);
	  };
	}
	
	exports.default = useRoutes;
	module.exports = exports['default'];

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(217);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(184);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RoutingContext = _react2.default.createClass({
	  displayName: 'RoutingContext',
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, '`RoutingContext` has been renamed to `RouterContext`. Please use `import { RouterContext } from \'react-router\'`. http://tiny.cc/router-routercontext') : void 0;
	  },
	  render: function render() {
	    return _react2.default.createElement(_RouterContext2.default, this.props);
	  }
	});
	
	exports.default = RoutingContext;
	module.exports = exports['default'];

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(192);
	
	var _invariant = __webpack_require__(188);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(234);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(209);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(181);
	
	var _RouterUtils = __webpack_require__(219);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history;
	  var routes = _ref.routes;
	  var location = _ref.location;
	
	  var options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  var unlisten = void 0;
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    // Pick up the location from the history via synchronous history.listen
	    // call if needed.
	    unlisten = history.listen(function (historyLocation) {
	      location = historyLocation;
	    });
	  }
	
	  var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	  history = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    callback(error, redirectLocation && router.createLocation(redirectLocation, _Actions.REPLACE), nextState && _extends({}, nextState, {
	      history: history,
	      router: router,
	      matchContext: { history: history, transitionManager: transitionManager, router: router }
	    }));
	
	    // Defer removing the listener to here to prevent DOM histories from having
	    // to unwind DOM event listeners unnecessarily, in case callback renders a
	    // <Router> and attaches another history listener.
	    if (unlisten) {
	      unlisten();
	    }
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(206);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(235);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(236);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useRoutes` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  history.__v2_compatible__ = true;
	  return history;
	}
	module.exports = exports['default'];

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(191);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ExecutionEnvironment = __webpack_require__(194);
	
	var _PathUtils = __webpack_require__(193);
	
	var _runTransitionHook = __webpack_require__(204);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(205);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var basename = options.basename;
	
	    var checkedBaseHref = false;
	
	    function checkBaseHref() {
	      if (checkedBaseHref) {
	        return;
	      }
	
	      // Automatically use the value of <base href> in HTML
	      // documents as basename if it's not explicitly given.
	      if (basename == null && _ExecutionEnvironment.canUseDOM) {
	        var base = document.getElementsByTagName('base')[0];
	        var baseHref = base && base.getAttribute('href');
	
	        if (baseHref != null) {
	          basename = baseHref;
	
	           false ? _warning2['default'](false, 'Automatically setting basename using <base href> is deprecated and will ' + 'be removed in the next major release. The semantics of <base href> are ' + 'subtly different from basename. Please pass the basename explicitly in ' + 'the options to createHistory') : undefined;
	        }
	      }
	
	      checkedBaseHref = true;
	    }
	
	    function addBasename(location) {
	      checkBaseHref();
	
	      if (basename && location.basename == null) {
	        if (location.pathname.indexOf(basename) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    }
	
	    function prependBasename(location) {
	      checkBaseHref();
	
	      if (!basename) return location;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var pname = location.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, location, {
	        pathname: pathname
	      });
	    }
	
	    // Override all read methods with basename-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addBasename(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addBasename(location));
	      });
	    }
	
	    // Override all write methods with basename-aware versions.
	    function push(location) {
	      history.push(prependBasename(location));
	    }
	
	    function replace(location) {
	      history.replace(prependBasename(location));
	    }
	
	    function createPath(location) {
	      return history.createPath(prependBasename(location));
	    }
	
	    function createHref(location) {
	      return history.createHref(prependBasename(location));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    }
	
	    // deprecated
	    function pushState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path));
	    }
	
	    // deprecated
	    function replaceState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useBasename;
	module.exports = exports['default'];

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(191);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(188);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PathUtils = __webpack_require__(193);
	
	var _Actions = __webpack_require__(192);
	
	var _createHistory = __webpack_require__(198);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	}
	
	function createMemoryHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var history = _createHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: saveState,
	    go: go
	  }));
	
	  var _options = options;
	  var entries = _options.entries;
	  var current = _options.current;
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    var key = history.createKey();
	
	    if (typeof entry === 'string') return { pathname: entry, key: key };
	
	    if (typeof entry === 'object' && entry) return _extends({}, entry, { key: key });
	
	     true ?  false ? _invariant2['default'](false, 'Unable to create history entry from %s', entry) : _invariant2['default'](false) : undefined;
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? _invariant2['default'](false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : _invariant2['default'](false) : undefined;
	  }
	
	  var storage = createStateStorage(entries);
	
	  function saveState(key, state) {
	    storage[key] = state;
	  }
	
	  function readState(key) {
	    return storage[key];
	  }
	
	  function getCurrentLocation() {
	    var entry = entries[current];
	    var basename = entry.basename;
	    var pathname = entry.pathname;
	    var search = entry.search;
	
	    var path = (basename || '') + pathname + (search || '');
	
	    var key = undefined,
	        state = undefined;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    } else {
	      key = history.createKey();
	      state = null;
	      entry.key = key;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  }
	
	  function go(n) {
	    if (n) {
	      if (!canGo(n)) {
	         false ? _warning2['default'](false, 'Cannot go(%s) there is not enough history', n) : undefined;
	        return;
	      }
	
	      current += n;
	
	      var currentLocation = getCurrentLocation();
	
	      // change action to POP
	      history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	    }
	  }
	
	  function finishTransition(location) {
	    switch (location.action) {
	      case _Actions.PUSH:
	        current += 1;
	
	        // if we are not on the top of stack
	        // remove rest and push new
	        if (current < entries.length) entries.splice(current);
	
	        entries.push(location);
	        saveState(location.key, location.state);
	        break;
	      case _Actions.REPLACE:
	        entries[current] = location;
	        saveState(location.key, location.state);
	        break;
	    }
	  }
	
	  return history;
	}
	
	exports['default'] = createMemoryHistory;
	module.exports = exports['default'];

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(206);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(235);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    history.__v2_compatible__ = true;
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(217);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(184);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length <= 0 || arguments[0] === undefined ? _react.createElement : arguments[0];
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(240);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(241);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(188);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(192);
	
	var _PathUtils = __webpack_require__(193);
	
	var _ExecutionEnvironment = __webpack_require__(194);
	
	var _DOMUtils = __webpack_require__(195);
	
	var _DOMStateStorage = __webpack_require__(196);
	
	var _createDOMHistory = __webpack_require__(197);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve URLs.
	 */
	function createBrowserHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Browser history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var forceRefresh = options.forceRefresh;
	
	  var isSupported = _DOMUtils.supportsHistory();
	  var useRefresh = !isSupported || forceRefresh;
	
	  function getCurrentLocation(historyState) {
	    try {
	      historyState = historyState || window.history.state || {};
	    } catch (e) {
	      historyState = {};
	    }
	
	    var path = _DOMUtils.getWindowPath();
	    var _historyState = historyState;
	    var key = _historyState.key;
	
	    var state = undefined;
	    if (key) {
	      state = _DOMStateStorage.readState(key);
	    } else {
	      state = null;
	      key = history.createKey();
	
	      if (isSupported) window.history.replaceState(_extends({}, historyState, { key: key }), null);
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startPopStateListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function popStateListener(event) {
	      if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.
	
	      transitionTo(getCurrentLocation(event.state));
	    }
	
	    _DOMUtils.addEventListener(window, 'popstate', popStateListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'popstate', popStateListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    _DOMStateStorage.saveState(key, state);
	
	    var path = (basename || '') + pathname + search + hash;
	    var historyState = {
	      key: key
	    };
	
	    if (action === _Actions.PUSH) {
	      if (useRefresh) {
	        window.location.href = path;
	        return false; // Prevent location update.
	      } else {
	          window.history.pushState(historyState, null, path);
	        }
	    } else {
	      // REPLACE
	      if (useRefresh) {
	        window.location.replace(path);
	        return false; // Prevent location update.
	      } else {
	          window.history.replaceState(historyState, null, path);
	        }
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopPopStateListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopPopStateListener();
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    registerTransitionHook: registerTransitionHook,
	    unregisterTransitionHook: unregisterTransitionHook
	  });
	}
	
	exports['default'] = createBrowserHistory;
	module.exports = exports['default'];

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	};
	
	var _useRouterHistory = __webpack_require__(237);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	module.exports = exports['default'];

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(190);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(241);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _deprecate = __webpack_require__(205);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var _createLocation2 = __webpack_require__(203);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _createBrowserHistory = __webpack_require__(240);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	exports.createHistory = _createBrowserHistory2['default'];
	
	var _createHashHistory2 = __webpack_require__(190);
	
	var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);
	
	exports.createHashHistory = _createHashHistory3['default'];
	
	var _createMemoryHistory2 = __webpack_require__(236);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	exports.createMemoryHistory = _createMemoryHistory3['default'];
	
	var _useBasename2 = __webpack_require__(235);
	
	var _useBasename3 = _interopRequireDefault(_useBasename2);
	
	exports.useBasename = _useBasename3['default'];
	
	var _useBeforeUnload2 = __webpack_require__(244);
	
	var _useBeforeUnload3 = _interopRequireDefault(_useBeforeUnload2);
	
	exports.useBeforeUnload = _useBeforeUnload3['default'];
	
	var _useQueries2 = __webpack_require__(206);
	
	var _useQueries3 = _interopRequireDefault(_useQueries2);
	
	exports.useQueries = _useQueries3['default'];
	
	var _Actions2 = __webpack_require__(192);
	
	var _Actions3 = _interopRequireDefault(_Actions2);
	
	exports.Actions = _Actions3['default'];
	
	// deprecated
	
	var _enableBeforeUnload2 = __webpack_require__(245);
	
	var _enableBeforeUnload3 = _interopRequireDefault(_enableBeforeUnload2);
	
	exports.enableBeforeUnload = _enableBeforeUnload3['default'];
	
	var _enableQueries2 = __webpack_require__(246);
	
	var _enableQueries3 = _interopRequireDefault(_enableQueries2);
	
	exports.enableQueries = _enableQueries3['default'];
	var createLocation = _deprecate2['default'](_createLocation3['default'], 'Using createLocation without a history instance is deprecated; please use history.createLocation instead');
	exports.createLocation = createLocation;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(191);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ExecutionEnvironment = __webpack_require__(194);
	
	var _DOMUtils = __webpack_require__(195);
	
	var _deprecate = __webpack_require__(205);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function startBeforeUnloadListener(getBeforeUnloadPromptMessage) {
	  function listener(event) {
	    var message = getBeforeUnloadPromptMessage();
	
	    if (typeof message === 'string') {
	      (event || window.event).returnValue = message;
	      return message;
	    }
	  }
	
	  _DOMUtils.addEventListener(window, 'beforeunload', listener);
	
	  return function () {
	    _DOMUtils.removeEventListener(window, 'beforeunload', listener);
	  };
	}
	
	/**
	 * Returns a new createHistory function that can be used to create
	 * history objects that know how to use the beforeunload event in web
	 * browsers to cancel navigation.
	 */
	function useBeforeUnload(createHistory) {
	  return function (options) {
	    var history = createHistory(options);
	
	    var stopBeforeUnloadListener = undefined;
	    var beforeUnloadHooks = [];
	
	    function getBeforeUnloadPromptMessage() {
	      var message = undefined;
	
	      for (var i = 0, len = beforeUnloadHooks.length; message == null && i < len; ++i) {
	        message = beforeUnloadHooks[i].call();
	      }return message;
	    }
	
	    function listenBeforeUnload(hook) {
	      beforeUnloadHooks.push(hook);
	
	      if (beforeUnloadHooks.length === 1) {
	        if (_ExecutionEnvironment.canUseDOM) {
	          stopBeforeUnloadListener = startBeforeUnloadListener(getBeforeUnloadPromptMessage);
	        } else {
	           false ? _warning2['default'](false, 'listenBeforeUnload only works in DOM environments') : undefined;
	        }
	      }
	
	      return function () {
	        beforeUnloadHooks = beforeUnloadHooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (beforeUnloadHooks.length === 0 && stopBeforeUnloadListener) {
	          stopBeforeUnloadListener();
	          stopBeforeUnloadListener = null;
	        }
	      };
	    }
	
	    // deprecated
	    function registerBeforeUnloadHook(hook) {
	      if (_ExecutionEnvironment.canUseDOM && beforeUnloadHooks.indexOf(hook) === -1) {
	        beforeUnloadHooks.push(hook);
	
	        if (beforeUnloadHooks.length === 1) stopBeforeUnloadListener = startBeforeUnloadListener(getBeforeUnloadPromptMessage);
	      }
	    }
	
	    // deprecated
	    function unregisterBeforeUnloadHook(hook) {
	      if (beforeUnloadHooks.length > 0) {
	        beforeUnloadHooks = beforeUnloadHooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (beforeUnloadHooks.length === 0) stopBeforeUnloadListener();
	      }
	    }
	
	    return _extends({}, history, {
	      listenBeforeUnload: listenBeforeUnload,
	
	      registerBeforeUnloadHook: _deprecate2['default'](registerBeforeUnloadHook, 'registerBeforeUnloadHook is deprecated; use listenBeforeUnload instead'),
	      unregisterBeforeUnloadHook: _deprecate2['default'](unregisterBeforeUnloadHook, 'unregisterBeforeUnloadHook is deprecated; use the callback returned from listenBeforeUnload instead')
	    });
	  };
	}
	
	exports['default'] = useBeforeUnload;
	module.exports = exports['default'];

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _deprecate = __webpack_require__(205);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var _useBeforeUnload = __webpack_require__(244);
	
	var _useBeforeUnload2 = _interopRequireDefault(_useBeforeUnload);
	
	exports['default'] = _deprecate2['default'](_useBeforeUnload2['default'], 'enableBeforeUnload is deprecated, use useBeforeUnload instead');
	module.exports = exports['default'];

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _deprecate = __webpack_require__(205);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var _useQueries = __webpack_require__(206);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	exports['default'] = _deprecate2['default'](_useQueries2['default'], 'enableQueries is deprecated, use useQueries instead');
	module.exports = exports['default'];

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(248);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connect = __webpack_require__(253);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports.Provider = _Provider2["default"];
	exports.connect = _connect2["default"];

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = undefined;
	
	var _react = __webpack_require__(12);
	
	var _propTypes = __webpack_require__(249);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _storeShape = __webpack_require__(251);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__(252);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    return _react.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports["default"] = Provider;
	
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2["default"].isRequired,
	  children: _propTypes2["default"].element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2["default"].isRequired
	};

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(250)();
	}


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(36);
	
	function emptyFunction() {}
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(249);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports["default"] = _propTypes2["default"].shape({
	  subscribe: _propTypes2["default"].func.isRequired,
	  dispatch: _propTypes2["default"].func.isRequired,
	  getState: _propTypes2["default"].func.isRequired
	});

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = connect;
	
	var _react = __webpack_require__(12);
	
	var _storeShape = __webpack_require__(251);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _shallowEqual = __webpack_require__(254);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__(255);
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _warning = __webpack_require__(252);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isPlainObject = __webpack_require__(258);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _hoistNonReactStatics = __webpack_require__(276);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(188);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	var errorObject = { value: null };
	function tryCatch(fn, ctx) {
	  try {
	    return fn.apply(ctx);
	  } catch (e) {
	    errorObject.value = e;
	    return errorObject;
	  }
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var mapState = mapStateToProps || defaultMapStateToProps;
	
	  var mapDispatch = void 0;
	  if (typeof mapDispatchToProps === 'function') {
	    mapDispatch = mapDispatchToProps;
	  } else if (!mapDispatchToProps) {
	    mapDispatch = defaultMapDispatchToProps;
	  } else {
	    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
	  }
	
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var _options$pure = options.pure,
	      pure = _options$pure === undefined ? true : _options$pure,
	      _options$withRef = options.withRef,
	      withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;
	
	  // Helps track hot reloading.
	  var version = nextVersion++;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	
	    function checkStateShape(props, methodName) {
	      if (!(0, _isPlainObject2["default"])(props)) {
	        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
	      }
	    }
	
	    function computeMergedProps(stateProps, dispatchProps, parentProps) {
	      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	      if (false) {
	        checkStateShape(mergedProps, 'mergeProps');
	      }
	      return mergedProps;
	    }
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
	        if (!this.finalMapStateToProps) {
	          return this.configureFinalMapState(store, props);
	        }
	
	        var state = store.getState();
	        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);
	
	        if (false) {
	          checkStateShape(stateProps, 'mapStateToProps');
	        }
	        return stateProps;
	      };
	
	      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
	        var mappedState = mapState(store.getState(), props);
	        var isFactory = typeof mappedState === 'function';
	
	        this.finalMapStateToProps = isFactory ? mappedState : mapState;
	        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeStateProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedState, 'mapStateToProps');
	        }
	        return mappedState;
	      };
	
	      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
	        if (!this.finalMapDispatchToProps) {
	          return this.configureFinalMapDispatch(store, props);
	        }
	
	        var dispatch = store.dispatch;
	
	        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);
	
	        if (false) {
	          checkStateShape(dispatchProps, 'mapDispatchToProps');
	        }
	        return dispatchProps;
	      };
	
	      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
	        var mappedDispatch = mapDispatch(store.dispatch, props);
	        var isFactory = typeof mappedDispatch === 'function';
	
	        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
	        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeDispatchProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedDispatch, 'mapDispatchToProps');
	        }
	        return mappedDispatch;
	      };
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = this.computeStateProps(this.store, this.props);
	        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
	        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
	          return false;
	        }
	
	        this.mergedProps = nextMergedProps;
	        return true;
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	        this.renderedElement = null;
	        this.finalMapDispatchToProps = null;
	        this.finalMapStateToProps = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var storeState = this.store.getState();
	        var prevStoreState = this.state.storeState;
	        if (pure && prevStoreState === storeState) {
	          return;
	        }
	
	        if (pure && !this.doStatePropsDependOnOwnProps) {
	          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
	          if (!haveStatePropsChanged) {
	            return;
	          }
	          if (haveStatePropsChanged === errorObject) {
	            this.statePropsPrecalculationError = errorObject.value;
	          }
	          this.haveStatePropsBeenPrecalculated = true;
	        }
	
	        this.hasStoreStateChanged = true;
	        this.setState({ storeState: storeState });
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged,
	            hasStoreStateChanged = this.hasStoreStateChanged,
	            haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated,
	            statePropsPrecalculationError = this.statePropsPrecalculationError,
	            renderedElement = this.renderedElement;
	
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	
	        if (statePropsPrecalculationError) {
	          throw statePropsPrecalculationError;
	        }
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (haveStatePropsBeenPrecalculated) {
	          haveStatePropsChanged = true;
	        } else if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = connectDisplayName;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: _storeShape2["default"]
	    };
	    Connect.propTypes = {
	      store: _storeShape2["default"]
	    };
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
	  };
	}

/***/ }),
/* 254 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = wrapActionCreators;
	
	var _redux = __webpack_require__(256);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(257);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(271);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(273);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(274);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(275);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(272);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(258);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(268);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(259),
	    getPrototype = __webpack_require__(265),
	    isObjectLike = __webpack_require__(267);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(260),
	    getRawTag = __webpack_require__(263),
	    objectToString = __webpack_require__(264);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(261);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(262);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 262 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(260);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 264 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(266);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 266 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 267 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(270);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(269)(module)))

/***/ }),
/* 269 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 270 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(257);
	
	var _isPlainObject = __webpack_require__(258);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(272);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 273 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(275);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ }),
/* 275 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ }),
/* 276 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routesCricinfo = exports.routesDefault = undefined;
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(180);
	
	var _App = __webpack_require__(278);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Home = __webpack_require__(867);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// polyfill webpack require.ensure
	if (false) require.ensure = function (d, c) {
	  return c(require);
	};
	
	//import shell from '../lib/utils/shell'
	//import mapPageToTemplate from '../../reduxion-core/lib/mapPageToTemplate'
	
	/**
	 * Logic to determine and split app into webpack chunks
	 * based on routes
	 * @param  {Object}   params parsed routing params
	 * @param  {Function} cb     react router callback
	 * @return {void}
	 */
	var getSportComponent = function getSportComponent() {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var cb = arguments[1];
	  var pageType = params.pageType;
	
	
	  switch (pageType) {
	    case 'game':
	    case 'match':
	    case 'scorecard':
	    case 'preview':
	    case 'recap':
	    case 'report':
	    case 'commentary':
	    case 'statistics':
	    case 'coverage':
	    case 'matchstats':
	    case 'playerstats':
	    case 'conversation':
	    case 'lineups':
	    case 'video':
	    case 'hawkeye':
	      __webpack_require__.e/* nsure */(1, function (require) {
	        cb(null, __webpack_require__(868).default);
	      });
	      break;
	    // Case added for testing
	    case 'info':
	      // Enables webpack code splitting/chunks
	      __webpack_require__.e/* nsure */(2, function (require) {
	        cb(null, __webpack_require__(1074).default);
	      });
	      break;
	    case 'table':
	    case 'standings':
	      __webpack_require__.e/* nsure */(3, function (require) {
	        cb(null, __webpack_require__(1076).default);
	      });
	      break;
	    case 'scoreboard':
	    case 'scores':
	      __webpack_require__.e/* nsure */(4, function (require) {
	        cb(null, __webpack_require__(1079).default);
	      });
	      break;
	    case 'schedule':
	    case 'fixtures':
	    case 'results':
	      __webpack_require__.e/* nsure */(5, function (require) {
	        cb(null, __webpack_require__(1104).default);
	      });
	      break;
	    case 'team':
	      __webpack_require__.e/* nsure */(6, function (require) {
	        cb(null, __webpack_require__(1106).default);
	      });
	      break;
	    case 'static':
	      __webpack_require__.e/* nsure */(7, function (require) {
	        cb(null, __webpack_require__(1112).default);
	      });
	      break;
	    default:
	      cb(null, _Home2.default);
	  }
	};
	
	/**
	 * Get name of sports from location object
	 * @param  {Object} location location
	 * @return {String}          name of sports
	 */
	function getSportName(location) {
	  var fullPath = location.pathname || '';
	  // Sport name is at 2nd position of splitted array
	  var sportName = fullPath.split('/')[1] || '';
	  return sportName;
	}
	
	/**
	 * Parse urls for all sport pages
	 * @param  {Object}   nextState updated state
	 * @param  {Function} cb       router cb function
	 * @return {void}
	 */
	var parseSportPage = function parseSportPage() {
	  var nextState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var cb = arguments[1];
	
	  var location = nextState.location;
	  var pageIdx = 1;
	  // List of sports which are supported by sCoreNode
	  var validSports = ['rugby', 'rugby-league'];
	  // Get sport name from location
	  var sportName = getSportName(location);
	  // If cricket is available or sport is supported, pick pagetype from index 2
	  if (isCricketAvailble(location) || validSports.indexOf(sportName) > -1) {
	    pageIdx = 2;
	  }
	  var params = {
	    pageType: location.pathname.split('/')[pageIdx]
	    //console.info('params', params)
	  };getSportComponent(params, cb);
	};
	
	var parseCricketPage = function parseCricketPage() {
	  var nextState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var cb = arguments[1];
	
	  var location = nextState.location;
	  var pageIdx = isCricketAvailble(location) ? 2 : 1;
	  var params = {
	    pageType: location.pathname.split('/')[pageIdx]
	  };
	  getSportComponent(params, cb);
	};
	
	/**
	 * Parse urls for cricket game package
	 * @param  {Object}   nextState updated state
	 * @param  {Function} cb       router cb function
	 * @return {void}
	 */
	var parseCricketGame = function parseCricketGame() {
	  var nextState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var cb = arguments[1];
	
	  var location = nextState.location;
	  var pageIdx = isCricketAvailble(location) ? 4 : 3;
	  //console.info('isCricketAvailble, pageIdx', isCricketAvailble, pageIdx)
	  var params = {
	    pageType: location.pathname.split('/')[pageIdx]
	    //console.info('parseCricketGame:params', params)
	  };getSportComponent(params, cb);
	};
	
	var parseStaticLandingPage = function parseStaticLandingPage(nextState, cb) {
	  //const location = nextState.location
	  var params = {
	    pageType: 'static'
	  };
	  getSportComponent(params, cb);
	};
	
	/**
	 * Check whether the sport name is 'cricket' or not a sport
	 * @param  {Object}   location location object from router
	 * @return {Boolean}  true if cricket is availble else false
	 */
	var isCricketAvailble = function isCricketAvailble(location) {
	  var sportName = getSportName(location);
	  // Is cricket part of the URL?
	  return sportName === 'cricket' ? true : false;
	};
	
	/**
	 * onEnter callback that updates page shell
	 * @param  {Object}   nextState    next router state
	 * @param  {Function}   transition router transition
	 * @param  {Function} callback     callback to continue render
	 * @return {void}
	 */
	function onEnter(nextState, transition, callback) {
	  /*if(process.browser === true) {
	    try{
	      const { pageType, sport = 'cricket' } = nextState.params
	      const template = mapPageToTemplate({ pageType, sport })
	       shell.transition.preRender(sport, template)
	    }catch(e) {
	      console.log(e)
	    }
	  }*/
	
	  callback();
	}
	
	var routesDefault = _react2.default.createElement(
	  _reactRouter.Route,
	  { onEnter: onEnter, component: _App2.default, path: '/' },
	  _react2.default.createElement(_reactRouter.Redirect, { from: 'cricket/game', to: 'cricket/series/901359/game/951331/slug' }),
	  _react2.default.createElement(_reactRouter.Route, { path: '(:sport/)series/:league/:pageType/:gameId(/day/:day)(/:slug)(/:platform)(/:webview)', getComponent: parseCricketGame }),
	  _react2.default.createElement(_reactRouter.Route, { path: ':sport/static/:pageType/:platform/:webview', getComponent: parseStaticLandingPage }),
	  _react2.default.createElement(
	    _reactRouter.Route,
	    { path: ':sport/:pageType', getComponent: parseSportPage },
	    _react2.default.createElement(_reactRouter.Route, { name: 'standingsParams', path: '_(/sort/:sortKey)(/dir/:sortDir)(/league/:league)(/season/:season)(/seasontype/:seasontype)' }),
	    _react2.default.createElement(_reactRouter.Route, { name: 'standingsParamsCric', path: '(sort/:sortKey/)(dir/:sortDir/)(series/:league)(/season/:season)(/:slug)' }),
	    _react2.default.createElement(_reactRouter.Route, { name: 'scoreboardParams', path: '(_)(/team/:team)(/league/:league)(/date/:date)(/season/:season)' }),
	    _react2.default.createElement(_reactRouter.Route, { name: 'teamScoreboardParams', path: '(team/:team)(/:slug)' }),
	    _react2.default.createElement(_reactRouter.Route, { name: 'matchParams', path: '?gameId=:gameId&league=:leagueId' }),
	    _react2.default.createElement(_reactRouter.Route, { name: 'clubhouseParams', path: '_/id/:team(/:slug)' }),
	    _react2.default.createElement(_reactRouter.Route, { name: 'matchwebview', path: ':platform/:webview' })
	  ),
	  _react2.default.createElement(_reactRouter.IndexRoute, { component: _Home2.default })
	);
	
	var routesCricinfo = _react2.default.createElement(
	  _reactRouter.Route,
	  { onEnter: onEnter, component: _App2.default, path: '/' },
	  _react2.default.createElement(_reactRouter.Redirect, { from: 'cricket/game', to: 'cricket/series/901359/game/951331/slug' }),
	  _react2.default.createElement(_reactRouter.Route, { name: 'standingsParamsCricinfo', path: '(cricket/):pageType/(sort/:sortKey/)(dir/:sortDir/)(series/:league)(/season/:season)(/:slug)', getComponent: parseSportPage }),
	  _react2.default.createElement(_reactRouter.Route, { path: '(:sport/)series/:league/:pageType/:gameId(/day/:day)(/:slug)(/:platform)(/:webview)', getComponent: parseCricketGame }),
	  _react2.default.createElement(_reactRouter.Route, { path: ':sport/static/:pageType/:platform/:webview', getComponent: parseStaticLandingPage }),
	  _react2.default.createElement(
	    _reactRouter.Route,
	    { path: '(cricket/):pageType', getComponent: parseCricketPage },
	    _react2.default.createElement(_reactRouter.Route, { name: 'scoreboardParams', path: '(/team/:team)(/series/:league)(/date/:date)(/season/:season)' }),
	    _react2.default.createElement(_reactRouter.Route, { name: 'teamScoreboardParams', path: '(team/:team)(/:slug)' })
	  ),
	  _react2.default.createElement(_reactRouter.IndexRoute, { component: _Home2.default })
	);
	
	/**
	 * Route configuration
	 */
	exports.routesDefault = routesDefault;
	exports.routesCricinfo = routesCricinfo;
	exports.default = {
	  routesDefault: routesDefault,
	  routesCricinfo: routesCricinfo
	};

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(279);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(306);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(307);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(311);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(356);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(364);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _class, _class2, _temp; /* global jQuery */
	
	//import { push }             from 'react-router-redux'
	//import qs                   from 'query-string'
	
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(247);
	
	var _api = __webpack_require__(369);
	
	var _actions = __webpack_require__(415);
	
	var _ads = __webpack_require__(429);
	
	var _ads2 = _interopRequireDefault(_ads);
	
	var _meta = __webpack_require__(862);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _webviews = __webpack_require__(863);
	
	var _webviews2 = _interopRequireDefault(_webviews);
	
	var _shell = __webpack_require__(422);
	
	var _shell2 = _interopRequireDefault(_shell);
	
	var _debounce = __webpack_require__(866);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _dateformat = __webpack_require__(449);
	
	var _dateformat2 = _interopRequireDefault(_dateformat);
	
	var _utils = __webpack_require__(857);
	
	var _mapPageToTemplate = __webpack_require__(765);
	
	var _mapPageToTemplate2 = _interopRequireDefault(_mapPageToTemplate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var App = (_dec = (0, _reactRedux.connect)(function (state) {
	  return (0, _extends3.default)({}, state.page);
	}, function (dispatch) {
	  return { dispatch: dispatch, routerPush: (0, _utils.bindRouterPush)(dispatch) };
	}), _dec(_class = (_temp = _class2 = function (_React$Component) {
	  (0, _inherits3.default)(App, _React$Component);
	
	  function App() {
	    (0, _classCallCheck3.default)(this, App);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (App.__proto__ || (0, _getPrototypeOf2.default)(App)).call(this));
	
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.state = {
	      width: 0
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(App, [{
	    key: 'initResizeEvent',
	    value: function initResizeEvent() {
	      try {
	        jQuery(window).resize((0, _debounce2.default)(this.handleResize, 500));
	        this.handleResize();
	      } catch (e) {
	        /* Intentionally ignored error */
	      }
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize() {
	      var currentWidth = jQuery(window).outerWidth();
	      if (this.state.width !== currentWidth) {
	        this.setState({ width: currentWidth });
	        this.props.dispatch((0, _utils.setDeviceType)(currentWidth));
	      }
	    }
	  }, {
	    key: 'postRenderHooks',
	    value: function postRenderHooks() {
	      var _props = this.props,
	          _props$params = _props.params,
	          params = _props$params === undefined ? {} : _props$params,
	          ads = _props.ads,
	          analytics = _props.analytics,
	          tier3Nav = _props.tier3Nav,
	          tier2Nav = _props.tier2Nav;
	      var pageType = params.pageType,
	          sport = params.sport;
	
	      var template = (0, _mapPageToTemplate2.default)({ pageType: pageType, sport: sport });
	
	      _shell2.default.transition.postRender(sport, template, ads, analytics, tier3Nav, tier2Nav);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props2 = this.props,
	          edition = _props2.edition,
	          location = _props2.location,
	          params = _props2.params;
	
	      this.props.dispatch((0, _api.getGeoLocation)(params, location.query || {}, true)); /* Call action to get geo details to filter videos */
	      this.initResizeEvent();
	      if (edition.timeZoneDomain !== _dateformat2.default.getLocalTimezone()) {
	        this.props.dispatch((0, _actions.updateTimeZone)(edition, params, location.query || {}));
	      }
	      this.postRenderHooks();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.postRenderHooks();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          edition = _props3.edition,
	          location = _props3.location,
	          routerPush = _props3.routerPush,
	          appProps = _props3.appProps,
	          isFastcastAllowed = _props3.isFastcastAllowed;
	
	      var pageURL = 'http://' + edition.domain + (location.pathname + location.search);
	      return _react2.default.cloneElement(this.props.children, { params: this.props.params, ads: _ads2.default, updateMeta: _meta2.default.update, webviews: _webviews2.default, pageURL: pageURL, routerPush: routerPush, appProps: appProps, isFastcastAllowed: isFastcastAllowed });
	    }
	  }]);
	  return App;
	}(_react2.default.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  children: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = App;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(280), __esModule: true };

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(281);
	module.exports = __webpack_require__(288).Object.getPrototypeOf;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(282);
	var $getPrototypeOf = __webpack_require__(284);
	
	__webpack_require__(292)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(283);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 283 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(285);
	var toObject = __webpack_require__(282);
	var IE_PROTO = __webpack_require__(286)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 285 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(287)('keys');
	var uid = __webpack_require__(291);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(288);
	var global = __webpack_require__(289);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(290) ? 'pure' : 'global',
	  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 288 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.7' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 289 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 290 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 291 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(293);
	var core = __webpack_require__(288);
	var fails = __webpack_require__(302);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(289);
	var core = __webpack_require__(288);
	var ctx = __webpack_require__(294);
	var hide = __webpack_require__(296);
	var has = __webpack_require__(285);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(295);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 295 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(297);
	var createDesc = __webpack_require__(305);
	module.exports = __webpack_require__(301) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(298);
	var IE8_DOM_DEFINE = __webpack_require__(300);
	var toPrimitive = __webpack_require__(304);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(301) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(299);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 299 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(301) && !__webpack_require__(302)(function () {
	  return Object.defineProperty(__webpack_require__(303)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(302)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 302 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(299);
	var document = __webpack_require__(289).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(299);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 305 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 306 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(308);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(309), __esModule: true };

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(310);
	var $Object = __webpack_require__(288).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(293);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(301), 'Object', { defineProperty: __webpack_require__(297).f });


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(312);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(313);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(341);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(314), __esModule: true };

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(315);
	__webpack_require__(336);
	module.exports = __webpack_require__(340).f('iterator');


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(316)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(318)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(317);
	var defined = __webpack_require__(283);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 317 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(290);
	var $export = __webpack_require__(293);
	var redefine = __webpack_require__(319);
	var hide = __webpack_require__(296);
	var Iterators = __webpack_require__(320);
	var $iterCreate = __webpack_require__(321);
	var setToStringTag = __webpack_require__(334);
	var getPrototypeOf = __webpack_require__(284);
	var ITERATOR = __webpack_require__(335)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(296);


/***/ }),
/* 320 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(322);
	var descriptor = __webpack_require__(305);
	var setToStringTag = __webpack_require__(334);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(296)(IteratorPrototype, __webpack_require__(335)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(298);
	var dPs = __webpack_require__(323);
	var enumBugKeys = __webpack_require__(332);
	var IE_PROTO = __webpack_require__(286)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(303)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(333).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(297);
	var anObject = __webpack_require__(298);
	var getKeys = __webpack_require__(324);
	
	module.exports = __webpack_require__(301) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(325);
	var enumBugKeys = __webpack_require__(332);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(285);
	var toIObject = __webpack_require__(326);
	var arrayIndexOf = __webpack_require__(329)(false);
	var IE_PROTO = __webpack_require__(286)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(327);
	var defined = __webpack_require__(283);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(328);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 328 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(326);
	var toLength = __webpack_require__(330);
	var toAbsoluteIndex = __webpack_require__(331);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(317);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(317);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 332 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(289).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(297).f;
	var has = __webpack_require__(285);
	var TAG = __webpack_require__(335)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(287)('wks');
	var uid = __webpack_require__(291);
	var Symbol = __webpack_require__(289).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(337);
	var global = __webpack_require__(289);
	var hide = __webpack_require__(296);
	var Iterators = __webpack_require__(320);
	var TO_STRING_TAG = __webpack_require__(335)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(338);
	var step = __webpack_require__(339);
	var Iterators = __webpack_require__(320);
	var toIObject = __webpack_require__(326);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(318)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 338 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 339 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(335);


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(342), __esModule: true };

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(343);
	__webpack_require__(353);
	__webpack_require__(354);
	__webpack_require__(355);
	module.exports = __webpack_require__(288).Symbol;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(289);
	var has = __webpack_require__(285);
	var DESCRIPTORS = __webpack_require__(301);
	var $export = __webpack_require__(293);
	var redefine = __webpack_require__(319);
	var META = __webpack_require__(344).KEY;
	var $fails = __webpack_require__(302);
	var shared = __webpack_require__(287);
	var setToStringTag = __webpack_require__(334);
	var uid = __webpack_require__(291);
	var wks = __webpack_require__(335);
	var wksExt = __webpack_require__(340);
	var wksDefine = __webpack_require__(345);
	var enumKeys = __webpack_require__(346);
	var isArray = __webpack_require__(349);
	var anObject = __webpack_require__(298);
	var isObject = __webpack_require__(299);
	var toIObject = __webpack_require__(326);
	var toPrimitive = __webpack_require__(304);
	var createDesc = __webpack_require__(305);
	var _create = __webpack_require__(322);
	var gOPNExt = __webpack_require__(350);
	var $GOPD = __webpack_require__(352);
	var $DP = __webpack_require__(297);
	var $keys = __webpack_require__(324);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(351).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(348).f = $propertyIsEnumerable;
	  __webpack_require__(347).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(290)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(296)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(291)('meta');
	var isObject = __webpack_require__(299);
	var has = __webpack_require__(285);
	var setDesc = __webpack_require__(297).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(302)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(289);
	var core = __webpack_require__(288);
	var LIBRARY = __webpack_require__(290);
	var wksExt = __webpack_require__(340);
	var defineProperty = __webpack_require__(297).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(324);
	var gOPS = __webpack_require__(347);
	var pIE = __webpack_require__(348);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 347 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 348 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(328);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(326);
	var gOPN = __webpack_require__(351).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(325);
	var hiddenKeys = __webpack_require__(332).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(348);
	var createDesc = __webpack_require__(305);
	var toIObject = __webpack_require__(326);
	var toPrimitive = __webpack_require__(304);
	var has = __webpack_require__(285);
	var IE8_DOM_DEFINE = __webpack_require__(300);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(301) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 353 */
/***/ (function(module, exports) {



/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(345)('asyncIterator');


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(345)('observable');


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(357);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(361);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(312);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(358), __esModule: true };

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(359);
	module.exports = __webpack_require__(288).Object.setPrototypeOf;


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(293);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(360).set });


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(299);
	var anObject = __webpack_require__(298);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(294)(Function.call, __webpack_require__(352).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(362), __esModule: true };

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(363);
	var $Object = __webpack_require__(288).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(293);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(322) });


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(365);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(366), __esModule: true };

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(367);
	module.exports = __webpack_require__(288).Object.assign;


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(293);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(368) });


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(324);
	var gOPS = __webpack_require__(347);
	var pIE = __webpack_require__(348);
	var toObject = __webpack_require__(282);
	var IObject = __webpack_require__(327);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(302)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, console) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.api = exports.getClubhouse = exports.getStandingsPage = exports.getSchedule = undefined;
	
	var _promise = __webpack_require__(370);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _assign = __webpack_require__(365);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.getHost = getHost;
	exports.getQueryString = getQueryString;
	exports.createAction = createAction;
	exports.getLeagues = getLeagues;
	exports.getScoreboard = getScoreboard;
	exports.updateFavorites = updateFavorites;
	exports.getTopEventScores = getTopEventScores;
	exports.getEditorial = getEditorial;
	exports.getGameSummary = getGameSummary;
	exports.getGamePackage = getGamePackage;
	exports.getGeoLocation = getGeoLocation;
	exports.getVideosMore = getVideosMore;
	exports.apiReqStart = apiReqStart;
	exports.apiReqComplete = apiReqComplete;
	exports.getFlexApiUrl = getFlexApiUrl;
	exports.getNowApiUrl = getNowApiUrl;
	exports.getMoreMidColFeed = getMoreMidColFeed;
	exports.getLeagueSearch = getLeagueSearch;
	
	var _queryString = __webpack_require__(207);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _lib = __webpack_require__(392);
	
	var _actionTypes = __webpack_require__(417);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _transform = __webpack_require__(806);
	
	var transform = _interopRequireWildcard(_transform);
	
	var _cricket = __webpack_require__(856);
	
	var cricket = _interopRequireWildcard(_cricket);
	
	var _config = __webpack_require__(423);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _selectn = __webpack_require__(438);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	var _standings = __webpack_require__(859);
	
	var _standings2 = _interopRequireDefault(_standings);
	
	var _schedule = __webpack_require__(860);
	
	var _schedule2 = _interopRequireDefault(_schedule);
	
	var _clubhouse = __webpack_require__(861);
	
	var _clubhouse2 = _interopRequireDefault(_clubhouse);
	
	var _common = __webpack_require__(430);
	
	var _momentTimezone = __webpack_require__(450);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Gets the API host based on the environment
	 * @param  {String} service   type of service (site, v1, score)
	 * @param  {String} platform  type of platform (android, ios)
	 * @param  {Object} appProps  tyoe of app, which api being used
	 * @return {String}           API host
	 */
	/* global espn */
	function getHost() {
	  var service = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'site';
	  var platform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var appProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  service = service.toLowerCase();
	  if (service == 'site' && appProps.qaApi) {
	    service = 'site_qa';
	  }
	  if (service == 'score' && appProps.qaApi) {
	    service = 'sCoreQahost';
	  }
	  platform = platform || process.browser ? 'client' : 'server';
	  var hostMap = {
	    site: {
	      client: 'client',
	      server: 'server'
	    },
	    site_qa: {
	      client: 'client_qa',
	      server: 'server_qa'
	    },
	    v1: {
	      client: 'client_v1',
	      server: 'server_v1'
	    },
	    score: {
	      client: 'sCoreTcClient',
	      server: 'sCoreTcServer'
	    },
	    now: {
	      client: 'now_client',
	      server: 'now_server'
	    },
	    sCoreQahost: {
	      client: 'sCoreQahost'
	    }
	  };
	
	  var hostConfig = hostMap[service];
	  var key = hostConfig[platform];
	  var apiHost = _config2.default.apiHost;
	  var finalHost = apiHost[key];
	
	  if (platform === 'client') {
	    finalHost = typeof window !== 'undefined' && (0, _selectn2.default)('espn.reduxion.apiHost[' + key + ']', window) || finalHost;
	  }
	
	  //return 'http://' +'10.42.45.211:9003'
	  return 'https://' + finalHost;
	}
	
	/**
	 * get query string from Object
	 * @param  {Object}  queryObject        query object
	 * @param  {Object}  edition            edition config
	 * @param  {Object}  params             router params
	 * @param  {Boolean} skipEditionParams  flag to skip edition params
	 * @param  {Boolean} skipSectionParams  flag to section params if API does not require section=cricinfo
	 * @return {String}                     full query string starting with `?`
	 */
	function getQueryString() {
	  var queryObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var edition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var skipEditionParams = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	  var skipSectionParams = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	  var userGeo = edition.userGeo,
	      language = edition.language,
	      country = edition.country,
	      domain = edition.domain;
	
	  var isSonyESPN = domain === "www.espn.in";
	  country = isSonyESPN ? (0, _common.getCountrySupportedRegion)(userGeo) : country;
	
	  if (!skipEditionParams) {
	    queryObject.region = country;
	    queryObject.lang = language;
	  }
	
	  // All Espncricinfo API's calls have additionl param 'section=cricinfo'.
	  if (edition.isEspnCricinfo && !skipSectionParams) {
	    queryObject.section = 'cricinfo';
	  }
	  var queryString = _queryString2.default.stringify(queryObject);
	
	  return queryString ? '?' + queryString : '';
	}
	
	/**
	 * Creates and returns an API action
	 * @param  {Function} fn    Action
	 * @param  {Object} params  Args to call the function with
	 * @return {Function}       API action
	 */
	function createAction(fn, params) {
	  return function (routingParams) {
	    for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      rest[_key - 1] = arguments[_key];
	    }
	
	    return fn.call.apply(fn, [null, (0, _assign2.default)({}, params, routingParams)].concat(rest));
	  };
	}
	
	/**
	 * action to get leagues
	 * @param  {Object} edition   edition config
	 * @param  {Object} params    router params
	 * @param  {Object} location  Router location
	 * @return {Object}           action
	 */
	function getLeagues(_ref) {
	  var _ref$edition = _ref.edition,
	      edition = _ref$edition === undefined ? {} : _ref$edition,
	      _ref$params = _ref.params,
	      params = _ref$params === undefined ? {} : _ref$params,
	      _ref$location = _ref.location,
	      location = _ref$location === undefined ? {} : _ref$location,
	      appProps = _ref.appProps;
	
	  var queryObject = {};
	  if (params.sport == 'cricket' && params.pageType == 'scores') {
	    return {
	      type: null
	    };
	  }
	  var actionObject = {
	    type: _actionTypes2.default.GET_LEAGUES,
	    sport: params.sport,
	    pageType: params.pageType,
	    edition: edition
	    // Return if team scoreboard, does not require leagues (only cricket)
	  };if (typeof params.team !== 'undefined' && params.sport === 'cricket') {
	    return actionObject;
	  }
	
	  if (params.sport === 'cricket') {
	    queryObject.ceId = 15031083;
	  } else {
	    queryObject.sport = params.sport;
	  }
	
	  var url = (params.origin || getHost('site', '', appProps)) + '/apis/site/v2/leagues/dropdown' + getQueryString(queryObject, edition, params);
	
	  actionObject.url = url;
	  actionObject.edition = edition;
	  actionObject.params = params;
	  actionObject.location = location;
	  actionObject.promise = _lib.memoizr.get(url, { cachePolicy: 'max-age=30' });
	  actionObject.transform = transform.onGetLeagues;
	
	  return actionObject;
	}
	
	/**
	 * action to get scoreboard
	 * @param  {Object} edition     edition config
	 * @param  {Object} params      router params
	 * @param  {Object} location    Router location
	 * @param  {Boolean} isPolling  isPolling
	 * @return {Object}             action
	 */
	function getScoreboard(_ref2) {
	  var _ref2$edition = _ref2.edition,
	      edition = _ref2$edition === undefined ? {} : _ref2$edition,
	      _ref2$params = _ref2.params,
	      params = _ref2$params === undefined ? {} : _ref2$params,
	      _ref2$location = _ref2.location,
	      location = _ref2$location === undefined ? {} : _ref2$location,
	      isPolling = _ref2.isPolling,
	      appProps = _ref2.appProps;
	
	  var query = location.query || _queryString2.default.parse(location.search);
	  var topEventsId = edition.topEventsId,
	      language = edition.language;
	
	  var league = params.league;
	  var date = query.date || params.date;
	
	  var queryObject = {
	    dates: date,
	    contentorigin: language === 'es' || language === 'pt' ? 'deportes' : 'espn'
	  };
	
	  var curDate = _momentTimezone2.default.utc().format('YYYYMMDD');
	
	  if (!params.sport) {
	    return {
	      type: null
	    };
	  }
	
	  // Add default dates to api querystring only for team SB, for aggregate SB date need not be passed
	  if (typeof params.team !== 'undefined') {
	    queryObject.team = params.team;
	    if (typeof date === 'undefined') {
	      queryObject.dates = (0, _momentTimezone2.default)().format('YYYYMM');
	      if (params.sport === 'rugby') {
	        queryObject.dates = (0, _momentTimezone2.default)().format('YYYY');
	      }
	      if (typeof params.season !== 'undefined') {
	        queryObject.dates = params.season;
	      }
	    }
	    if (typeof limit === 'undefined') {
	      queryObject.limit = 50;
	    }
	    if (params.sport === 'rugby') {
	      //params.origin = 'https://site.web.api.espnqa.com'
	      league = undefined; /* if we have a team no need to filter by league */
	    }
	  }
	  if (!params.league && !params.team && params.sport == 'cricket') {
	    if (typeof queryObject.dates === 'undefined' || queryObject.dates === curDate) {
	      queryObject.ceID = topEventsId;
	    }
	  }
	
	  if (params.sport == 'cricket' && (params.league || params.team)) {
	    queryObject.section = 'cricinfo';
	  }
	  var host = getHost('site', '', appProps);
	  var url = (params.origin || host) + '/apis/site/v2/sports/' + params.sport + '/scorepanel' + getQueryString(queryObject, edition, params);
	
	  if (league) {
	    queryObject.limit = 300;
	    queryObject.sort = 'events:asc';
	    if (params.season) {
	      queryObject.season = params.season;
	    }
	    url = (params.origin || host) + '/apis/site/v2/sports/' + params.sport + '/' + league + '/scoreboard' + getQueryString(queryObject, edition, params);
	  }
	
	  return {
	    url: url,
	    edition: edition,
	    location: location,
	    params: params,
	    appProps: appProps,
	    isPolling: isPolling,
	    type: _actionTypes2.default.GET_SCOREBOARD,
	    sport: params.sport,
	    promise: _lib.memoizr.get(url),
	    transform: transform.onGetScoreboard
	  };
	}
	function updateFavorites() {
	  var sport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'cricket';
	
	  return function (dispatch) {
	    try {
	      espn.user.getFavorites().then(function () {
	        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        var favTeams = [];
	        if (typeof res !== 'undefined') {
	          (res.myTeams || []).map(function () {
	            var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            if (typeof key.sportName == 'string' && key.sportName.toLowerCase() === sport) {
	              favTeams.push(key.id);
	            }
	          });
	        }
	        dispatch({
	          type: _actionTypes2.default.UPDATE_FAVORITES,
	          data: favTeams
	        });
	      });
	    } catch (e) {
	      console.log(e);
	    }
	  };
	}
	function getTopEventScores(_ref3) {
	  var _ref3$edition = _ref3.edition,
	      edition = _ref3$edition === undefined ? {} : _ref3$edition,
	      _ref3$params = _ref3.params,
	      params = _ref3$params === undefined ? {} : _ref3$params,
	      _ref3$location = _ref3.location,
	      location = _ref3$location === undefined ? {} : _ref3$location,
	      isPolling = _ref3.isPolling,
	      appProps = _ref3.appProps;
	
	  var query = location.query || _queryString2.default.parse(location.search);
	  var topEventsId = edition.topEventsId;
	
	  var date = query.date || params.date;
	  var curDate = _momentTimezone2.default.utc().format('YYYYMMDD');
	  var showTopEvents = false;
	  if (params.sport === 'cricket' && !params.league && !params.team) {
	    if (typeof date === 'undefined' || date === curDate) {
	      showTopEvents = true;
	    }
	  }
	
	  if (!showTopEvents) {
	    return {
	      type: null
	    };
	  }
	
	  var queryObject = {
	    contentorigin: 'espn',
	    _ceID: topEventsId
	  };
	
	  var host = getHost('site', '', appProps);
	  var url = (params.origin || host) + '/apis/v2/scoreboard/header' + getQueryString(queryObject, edition, params);
	
	  return {
	    url: url,
	    edition: edition,
	    location: location,
	    params: params,
	    appProps: appProps,
	    isPolling: isPolling,
	    type: _actionTypes2.default.GET_TOPEVENTS,
	    sport: params.sport,
	    promise: _lib.memoizr.get(url),
	    transform: transform.onGetTopEventScores
	  };
	}
	
	/**
	 * action to get editorial content for scoreboard
	 * @param  {Object} edition   edition config
	 * @param  {Object} params    router params
	 * @param  {Object} location  Router location
	 * @return {Object}           action
	 */
	function getEditorial(_ref4) {
	  var _ref4$edition = _ref4.edition,
	      edition = _ref4$edition === undefined ? {} : _ref4$edition,
	      _ref4$params = _ref4.params,
	      params = _ref4$params === undefined ? {} : _ref4$params,
	      _ref4$location = _ref4.location,
	      location = _ref4$location === undefined ? {} : _ref4$location,
	      appProps = _ref4.appProps;
	  var country = edition.country,
	      language = edition.language;
	
	  var queryObject = {
	    headlinestack: typeof params.headlinestack === 'boolean' ? params.headlinestack : true,
	    insider: params.insider || false,
	    pubkey: params.pubkey || 'espnuk-en-' + params.sport + '-index',
	    region: country,
	    lang: language,
	    limit: 0,
	    contentorigin: language === 'es' || language === 'pt' ? 'deportes' : 'espn'
	  };
	
	  if (language === 'es' || language === 'pt') {
	    queryObject.pubkey = 'espn-' + language + '-' + country + '-' + params.sport + '-index';
	  }
	
	  if (params.sport === 'cricket') {
	    //pubkey has uk in case of edition country as gb.
	    //Also managing pubkeys for espn editions for the countries au, ph
	    var cricketPubkey = edition.site === 'espncricinfo' ? 'espncricinfo-en-' + (edition.country === 'gb' ? 'uk' : edition.country) + '-' + params.sport + '-index' : edition.country === 'gb' ? 'espncricinfo-en-uk-' + params.sport + '-index' : edition.country === 'au' || edition.country === 'ph' ? 'espncricinfo-en-in-' + params.sport + '-index' : 'espncricinfo-en-' + edition.country + '-' + params.sport + '-index';
	
	    queryObject.pubkey = cricketPubkey;
	
	    if (country === 'gb') {
	      queryObject.region = 'uk';
	    }
	  }
	
	  var host = getHost('site', '', appProps);
	  var url = (params.origin || host) + '/apis/v2/flex' + getQueryString(queryObject, edition, params, true);
	
	  return {
	    url: url,
	    edition: edition,
	    params: params,
	    location: location,
	    type: _actionTypes2.default.GET_EDITORIAL,
	    promise: _lib.memoizr.get(url, { cachePolicy: 'max-age=300' }),
	    transform: transform.onGetEditorial
	  };
	}
	
	/**
	 * Action to get Game package summary
	 * @param  {Object}   edition   edition config
	 * @param  {Object}   params    Router params
	 * @param  {Object}   location  Router location
	 * @param  {Boolean}  isPolling isPolling
	 * @return {Function}           Handled by thunk middleware
	 */
	function getGameSummary(_ref5) {
	  var _ref5$edition = _ref5.edition,
	      edition = _ref5$edition === undefined ? {} : _ref5$edition,
	      _ref5$params = _ref5.params,
	      params = _ref5$params === undefined ? {} : _ref5$params,
	      _ref5$location = _ref5.location,
	      location = _ref5$location === undefined ? {} : _ref5$location,
	      isPolling = _ref5.isPolling,
	      _ref5$appProps = _ref5.appProps,
	      appProps = _ref5$appProps === undefined ? {} : _ref5$appProps;
	
	
	  var queryObject = {
	    event: params.gameId || 0,
	    contentorigin: 'espn'
	  };
	  var league = params.league || 0;
	
	  if (appProps.isAppLite === true) {
	    queryObject.device = 'featurephone';
	  }
	
	  if (edition.language === 'es' || edition.language == 'pt') {
	    queryObject.contentorigin = 'deportes';
	  }
	
	  var path = '/apis/site/v2/sports/' + params.sport + '/' + league + '/summary' + getQueryString(queryObject, edition, params);
	  var clientApiUrl = '';
	
	  // get client url only once
	  if (!process.browser) {
	    clientApiUrl = '' + getHost('site', 'client', appProps) + path;
	  }
	  var host = getHost('site', '', appProps);
	  var url = '' + (params.origin || host) + path;
	
	  return {
	    url: url,
	    clientApiUrl: clientApiUrl,
	    edition: edition,
	    location: location,
	    params: params,
	    isPolling: isPolling,
	    appProps: appProps,
	    type: _actionTypes2.default.GET_GAMEPACKAGE,
	    promise: _lib.memoizr.get(url),
	    transform: transform.onGetGamePackage
	  };
	}
	
	/**
	 * Action to get Game package
	 * @param  {Object} edition     edition config
	 * @param  {Object} params      Router params
	 * @param  {Object} location    Router location
	 * @param  {Boolean} isPolling  isPolling
	 * @return {Object|Function}    redux action
	 */
	function getGamePackage(_ref6) {
	  var _ref6$edition = _ref6.edition,
	      edition = _ref6$edition === undefined ? {} : _ref6$edition,
	      _ref6$params = _ref6.params,
	      params = _ref6$params === undefined ? {} : _ref6$params,
	      _ref6$location = _ref6.location,
	      location = _ref6$location === undefined ? {} : _ref6$location,
	      isPolling = _ref6.isPolling,
	      _ref6$appProps = _ref6.appProps,
	      appProps = _ref6$appProps === undefined ? {} : _ref6$appProps;
	
	  if (params.sport === 'cricket') {
	    if (params.pageType === 'commentary') {
	      return function (dispatch) {
	        return dispatch(cricket.getCommentaryTab({ edition: edition, params: params, location: location, isPolling: isPolling, appProps: appProps }));
	      };
	    } else if (params.pageType === 'preview' || params.pageType === 'report') {
	      return function (dispatch) {
	        return dispatch(cricket.getArticleTab({ edition: edition, params: params, location: location, isPolling: isPolling, appProps: appProps }));
	      };
	    } else {
	      return getGameSummary({ edition: edition, params: params, location: location, isPolling: isPolling, appProps: appProps });
	    }
	  } else {
	
	    if (params.pageType === 'preview' || params.pageType === 'report') {
	      return function (dispatch) {
	        return dispatch(cricket.getArticleTab({ edition: edition, params: params, location: location, appProps: appProps }));
	      };
	    }
	
	    return getGameSummary({ edition: edition, params: params, location: location, isPolling: isPolling, appProps: appProps });
	  }
	}
	
	function getGeoLocation(params) {
	  return {
	    params: params,
	    type: _actionTypes2.default.GET_GEO_LOCATION,
	    promise: new _promise2.default(function (resolve) {
	      var getLocation = (0, _selectn2.default)('espn.geo.getLocation', window || {});
	      if (!getLocation) {
	        resolve();
	      } else {
	        getLocation.done(resolve);
	      }
	    }),
	    transform: transform.onGetGeoLocation
	  };
	}
	
	function getVideosMore(_ref7) {
	  var _ref7$edition = _ref7.edition,
	      edition = _ref7$edition === undefined ? {} : _ref7$edition,
	      _ref7$params = _ref7.params,
	      params = _ref7$params === undefined ? {} : _ref7$params,
	      location = _ref7.location,
	      _ref7$isForceLazyload = _ref7.isForceLazyload,
	      isForceLazyload = _ref7$isForceLazyload === undefined ? false : _ref7$isForceLazyload;
	
	  return function (dispatch, getState) {
	    var allVideos = (0, _selectn2.default)('gamePackage.allVideos', getState());
	
	    var _ref8 = allVideos || {},
	        currentVideosCount = _ref8.currentVideosCount,
	        resultsOffset = _ref8.resultsOffset;
	
	    // videos per page
	
	
	    var limit = 10;
	    var offset = resultsOffset ? currentVideosCount + resultsOffset : 20;
	
	    if (isForceLazyload === true) {
	      limit = 30;
	    }
	
	    var queryObject = {
	      limit: limit,
	      offset: offset
	    };
	    var host = getHost('v1');
	    var url = (params.origin || host) + '/v1/video/' + params.sport + '/' + params.sport + '/events/' + params.gameId + '/clips' + getQueryString(queryObject, edition, params);
	    var videoPromise = _lib.memoizr.get(url);
	
	    videoPromise.then(function (res) {
	      dispatch({
	        url: url,
	        edition: edition,
	        params: params,
	        location: location,
	        type: _actionTypes2.default.GET_VIDEOS_MORE,
	        data: transform.onGetVideos({ res: res })
	      });
	    });
	  };
	}
	
	/**
	 * action when api call is started
	 * used in thunk middleware to dispatch api request action
	 * @param  {boolean}  isPolling   Boolean to pass through to determine if this is polling
	 * @return {Object}   store       Action
	**/
	function apiReqStart(isPolling) {
	  return {
	    type: _actionTypes2.default.API_REQUEST_START,
	    isPolling: isPolling
	  };
	}
	
	/**
	 * action when api call is completed
	 * used in thunk middleware to dispatch api complete action
	 * @return {Object} store action
	 */
	function apiReqComplete() {
	  return {
	    type: _actionTypes2.default.API_REQUEST_COMPLETE
	  };
	}
	
	/**
	 * [getFlexApiUrl , will return final API url]
	 * @param  {Object} edition         [edition details]
	 * @param  {Object} params          [page params]
	 * @param  {Object} location        [location details]
	 * @param  {Object} additionalQuery [additiona queries for the page to load]
	 * @param  {Object} appProps        [additional props]
	 * @return {[string]}               [final url with required params]
	 */
	function getFlexApiUrl() {
	  var edition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var location = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var additionalQuery = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var appProps = arguments[4];
	
	  var queryObject = {
	    region: params.country || edition.country,
	    headlinestack: typeof params.headlinestack === 'boolean' ? params.headlinestack : true,
	    insider: params.insider || false,
	    lang: params.lang || edition.language,
	    pubkey: 'espn-en-' + params.sport + '-index',
	    contentorigin: edition.language === 'es' || edition.language === 'pt' ? 'deportes' : 'espn'
	  };
	  var host = getHost('site', '', appProps);
	  var url = (params.origin || host) + '/apis/v2/flex' + getQueryString((0, _assign2.default)(queryObject, additionalQuery), edition, params);
	
	  return url;
	}
	
	/**
	 * [getNowApiUrl , will return final API url]
	 * @param  {Object} edition         [edition details]
	 * @param  {Object} params          [page params]
	 * @param  {Object} location        [location details]
	 * @param  {Object} additionalQuery [additional queries for the page to load]
	 * @return {[string]}               [final url with required params]
	 */
	function getNowApiUrl() {
	  var edition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var location = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var additionalQuery = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var queryObject = {
	    region: params.country || edition.country,
	    lang: params.lang || edition.language,
	    limit: 25
	  };
	  var host = getHost('now');
	  var queryString = getQueryString((0, _assign2.default)(queryObject, additionalQuery), edition, params);
	  queryString = decodeURIComponent(queryString);
	
	  var url = (params.origin || host) + '/allsports/apis/v1/now/' + queryString;
	
	  return url;
	}
	
	/**
	 * [getMoreMidColFeed - will get more items for lazyload]
	 * @param  {Object} edition  [edition details]
	 * @param  {Object} params   [page params]
	 * @param  {Object} location [location details]
	 * @return {[type]}          [redux action]
	 */
	function getMoreMidColFeed() {
	  var edition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var location = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  return function (dispatch, getState) {
	    var midColumn = (0, _selectn2.default)('clubhouse.middleColumn', getState()); //state before the new API request fired, currently for 'Clubhouse', ToDO, how it can be dynamic
	
	    var _ref9 = midColumn || {},
	        resultsOffset = _ref9.resultsOffset;
	
	    var currentArticleCount = (0, _selectn2.default)('newsfeed.length', midColumn);
	
	    var setOffset = 25; //to fetch new items set the offset
	    var offset = resultsOffset + setOffset; //increment by setOffset with previous offset for every api call
	
	    // Attributes for now API specific to sports clubhouse
	    var clubhouseAttr = {
	      'rugby': {
	        '_pinnedID': 14056160,
	        'content': 'alert,shortstop,video,story,blog,module,external,recap,preview,topstorypackage,podcast'
	      },
	      'cricket': {
	        '_pinnedID': 15083330,
	        'content': 'alert,shortstop,video,story,blog,module,external,recap,preview,topstorypackage,podcast,grantland,fivethirtyeight'
	      },
	      'soccer': {
	        '_pinnedID': 11875394,
	        'content': 'alert,shortstop,video,story,blog,module,external,recap,preview,topstorypackage,podcast,instagram,grantland,fivethirtyeight'
	      }
	
	      // Common attributes for now API for Clubhouse
	    };if (params.pageType === 'team') {
	      var additionalQuery = {
	        teams: params.team,
	        leagues: params.sport,
	        offset: offset,
	        enable: 'peers,story,logos,headshots',
	        defaultsort: 'false',
	        logosize: 'large',
	        headshotsize: 'full',
	        sort: 'false',
	        filtertypes: 'OnePlay',
	        content: clubhouseAttr[params.sport].content,
	        _pinnedID: clubhouseAttr[params.sport]._pinnedID
	      };
	    }
	
	    var url = getNowApiUrl(edition, params, location, additionalQuery); //now api call for clubhouse page, it accepts offset to get content for clubhouse
	    var newsfeedPromise = _lib.memoizr.get(url);
	
	    newsfeedPromise.then(function (res) {
	      dispatch({
	        url: url,
	        edition: edition,
	        params: params,
	        location: location,
	        type: _actionTypes2.default.GET_MORE_MID_COL_FEED,
	        data: transform.getMoreMidColFeed(res, edition, params, currentArticleCount)
	      });
	    });
	  };
	}
	
	/**
	 * [getLeagueSearch - Method to fetch typeahead search results]
	 * @param  {Object} edition         [edition for site details]
	 * @param  {Object} params          [params for lang, region]
	 * @param  {Object} additionalQuery [additional queries, includes search keyword]
	 * @param  {Object} appProps        type of app, which api being used
	 * @return {promise}                [returns promise for search]
	 */
	function getLeagueSearch() {
	  var edition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var additionalQuery = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var appProps = arguments[3];
	  var limit = additionalQuery.limit,
	      query = additionalQuery.query;
	
	  var queryObject = {
	    section: edition.site,
	    region: params.region || edition.region,
	    lang: params.lang || edition.language,
	    limit: limit || 8,
	    query: query,
	    mode: 'prefix',
	    type: 'league'
	  };
	
	  if (espn && espn.i18n && espn.i18n.isSingleSport === false) {
	    queryObject.type = 'league,sport';
	  }
	
	  if (query != '') {
	    if (params.sport !== '') {
	      queryObject.sport = params.sport;
	    }
	
	    var keyW = queryObject.query ? queryObject.query.replace(/\s+/g, '+') : '';
	    queryObject.query = keyW;
	    //params set to false/true in getQueryString method: skipEditionParams = false, skipSectionParams = true
	    var queryString = getQueryString(queryObject, edition, params, false, true);
	    queryString = decodeURIComponent(queryString);
	
	    var host = getHost('site', '', appProps);
	    var url = (params.origin || host) + '/apis/common/v3/search' + queryString;
	
	    var leagueSearchPromise = _lib.memoizr.get(url);
	
	    return leagueSearchPromise;
	  }
	}
	
	exports.getSchedule = _schedule2.default;
	exports.getStandingsPage = _standings2.default;
	exports.getClubhouse = _clubhouse2.default;
	var api = exports.api = {
	  getLeagues: getLeagues,
	  getStandingsPage: _standings2.default,
	  getScoreboard: getScoreboard,
	  getTopEventScores: getTopEventScores,
	  updateFavorites: updateFavorites,
	  getGamePackage: getGamePackage,
	  getGameSummary: getGameSummary,
	  getSchedule: _schedule2.default,
	  getClubhouse: _clubhouse2.default,
	  getLeagueSearch: getLeagueSearch,
	  getEditorial: getEditorial
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(371), __esModule: true };

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(353);
	__webpack_require__(315);
	__webpack_require__(336);
	__webpack_require__(372);
	__webpack_require__(390);
	__webpack_require__(391);
	module.exports = __webpack_require__(288).Promise;


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(290);
	var global = __webpack_require__(289);
	var ctx = __webpack_require__(294);
	var classof = __webpack_require__(373);
	var $export = __webpack_require__(293);
	var isObject = __webpack_require__(299);
	var aFunction = __webpack_require__(295);
	var anInstance = __webpack_require__(374);
	var forOf = __webpack_require__(375);
	var speciesConstructor = __webpack_require__(379);
	var task = __webpack_require__(380).set;
	var microtask = __webpack_require__(382)();
	var newPromiseCapabilityModule = __webpack_require__(383);
	var perform = __webpack_require__(384);
	var userAgent = __webpack_require__(385);
	var promiseResolve = __webpack_require__(386);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(335)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(387)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(334)($Promise, PROMISE);
	__webpack_require__(388)(PROMISE);
	Wrapper = __webpack_require__(288)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(389)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(328);
	var TAG = __webpack_require__(335)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 374 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(294);
	var call = __webpack_require__(376);
	var isArrayIter = __webpack_require__(377);
	var anObject = __webpack_require__(298);
	var toLength = __webpack_require__(330);
	var getIterFn = __webpack_require__(378);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(298);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(320);
	var ITERATOR = __webpack_require__(335)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(373);
	var ITERATOR = __webpack_require__(335)('iterator');
	var Iterators = __webpack_require__(320);
	module.exports = __webpack_require__(288).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(298);
	var aFunction = __webpack_require__(295);
	var SPECIES = __webpack_require__(335)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(294);
	var invoke = __webpack_require__(381);
	var html = __webpack_require__(333);
	var cel = __webpack_require__(303);
	var global = __webpack_require__(289);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(328)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 381 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(289);
	var macrotask = __webpack_require__(380).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(328)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(295);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 384 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(289);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(298);
	var isObject = __webpack_require__(299);
	var newPromiseCapability = __webpack_require__(383);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(296);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(289);
	var core = __webpack_require__(288);
	var dP = __webpack_require__(297);
	var DESCRIPTORS = __webpack_require__(301);
	var SPECIES = __webpack_require__(335)('species');
	
	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(335)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(293);
	var core = __webpack_require__(288);
	var global = __webpack_require__(289);
	var speciesConstructor = __webpack_require__(379);
	var promiseResolve = __webpack_require__(386);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(293);
	var newPromiseCapability = __webpack_require__(383);
	var perform = __webpack_require__(384);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.memoizr = exports.mapPageToTemplate = exports.fetchComponentData = undefined;
	
	var _fetchComponentData = __webpack_require__(393);
	
	var _fetchComponentData2 = _interopRequireDefault(_fetchComponentData);
	
	var _mapPageToTemplate = __webpack_require__(765);
	
	var _mapPageToTemplate2 = _interopRequireDefault(_mapPageToTemplate);
	
	var _memoizr = __webpack_require__(766);
	
	var _memoizr2 = _interopRequireDefault(_memoizr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.fetchComponentData = _fetchComponentData2.default;
	exports.mapPageToTemplate = _mapPageToTemplate2.default;
	exports.memoizr = _memoizr2.default;
	exports.default = {
	  fetchComponentData: _fetchComponentData2.default,
	  mapPageToTemplate: _mapPageToTemplate2.default,
	  memoizr: _memoizr2.default
	};

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(370);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _set = __webpack_require__(394);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _toConsumableArray2 = __webpack_require__(410);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.default = fetchComponentData;
	
	var _actions = __webpack_require__(415);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchComponentData(dispatch) {
	  var renderProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var location = arguments[2];
	  var actions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	  var edition = arguments[4];
	  var appProps = arguments[5];
	  var _renderProps$componen = renderProps.components,
	      components = _renderProps$componen === undefined ? [] : _renderProps$componen,
	      _renderProps$params = renderProps.params,
	      params = _renderProps$params === undefined ? {} : _renderProps$params;
	
	
	  var loadActions = components.reduce(function (prev, current) {
	    return (current && current.loadActions || []).concat((current && current.WrappedComponent ? current.WrappedComponent.loadActions : []) || []).concat(prev);
	  }, actions.concat(_actions.setPageConfig));
	
	  loadActions = [].concat((0, _toConsumableArray3.default)(new _set2.default(loadActions)));
	
	  var promises = loadActions.map(function (action) {
	    return dispatch(action({ edition: edition, params: params, location: location, appProps: appProps }));
	  });
	
	  return _promise2.default.all(promises);
	}

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(395), __esModule: true };

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(353);
	__webpack_require__(315);
	__webpack_require__(336);
	__webpack_require__(396);
	__webpack_require__(403);
	__webpack_require__(406);
	__webpack_require__(408);
	module.exports = __webpack_require__(288).Set;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(397);
	var validate = __webpack_require__(398);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(399)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(297).f;
	var create = __webpack_require__(322);
	var redefineAll = __webpack_require__(387);
	var ctx = __webpack_require__(294);
	var anInstance = __webpack_require__(374);
	var forOf = __webpack_require__(375);
	var $iterDefine = __webpack_require__(318);
	var step = __webpack_require__(339);
	var setSpecies = __webpack_require__(388);
	var DESCRIPTORS = __webpack_require__(301);
	var fastKey = __webpack_require__(344).fastKey;
	var validate = __webpack_require__(398);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(299);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(289);
	var $export = __webpack_require__(293);
	var meta = __webpack_require__(344);
	var fails = __webpack_require__(302);
	var hide = __webpack_require__(296);
	var redefineAll = __webpack_require__(387);
	var forOf = __webpack_require__(375);
	var anInstance = __webpack_require__(374);
	var isObject = __webpack_require__(299);
	var setToStringTag = __webpack_require__(334);
	var dP = __webpack_require__(297).f;
	var each = __webpack_require__(400)(0);
	var DESCRIPTORS = __webpack_require__(301);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    C = wrapper(function (target, iterable) {
	      anInstance(target, C, NAME, '_c');
	      target._c = new Base();
	      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
	    });
	    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
	      var IS_ADDER = KEY == 'add' || KEY == 'set';
	      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
	        anInstance(this, C, KEY);
	        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
	        var result = this._c[KEY](a === 0 ? 0 : a, b);
	        return IS_ADDER ? this : result;
	      });
	    });
	    IS_WEAK || dP(C.prototype, 'size', {
	      get: function () {
	        return this._c.size;
	      }
	    });
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F, O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(294);
	var IObject = __webpack_require__(327);
	var toObject = __webpack_require__(282);
	var toLength = __webpack_require__(330);
	var asc = __webpack_require__(401);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(402);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(299);
	var isArray = __webpack_require__(349);
	var SPECIES = __webpack_require__(335)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(293);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(404)('Set') });


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(373);
	var from = __webpack_require__(405);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(375);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(407)('Set');


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(293);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(409)('Set');


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(293);
	var aFunction = __webpack_require__(295);
	var ctx = __webpack_require__(294);
	var forOf = __webpack_require__(375);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(411);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(412), __esModule: true };

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(315);
	__webpack_require__(413);
	module.exports = __webpack_require__(288).Array.from;


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(294);
	var $export = __webpack_require__(293);
	var toObject = __webpack_require__(282);
	var call = __webpack_require__(376);
	var isArrayIter = __webpack_require__(377);
	var toLength = __webpack_require__(330);
	var createProperty = __webpack_require__(414);
	var getIterFn = __webpack_require__(378);
	
	$export($export.S + $export.F * !__webpack_require__(389)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(297);
	var createDesc = __webpack_require__(305);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(364);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(416);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	exports.getPageConfig = getPageConfig;
	exports.validatePageConfig = validatePageConfig;
	exports.setPageConfig = setPageConfig;
	exports.onRenderComplete = onRenderComplete;
	exports.updateTimeZone = updateTimeZone;
	exports.setAppProps = setAppProps;
	exports.updateGameStrip = updateGameStrip;
	
	var _lib = __webpack_require__(392);
	
	var _actionTypes = __webpack_require__(417);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _analytics = __webpack_require__(418);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _api = __webpack_require__(369);
	
	var _momentTimezone = __webpack_require__(450);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _selectn = __webpack_require__(438);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * get page config on client
	 * Config for: ads, analytics etc.
	 * @param  {Object} edition     edition config
	 * @param  {Object} params      Router params
	 * @return {Object}             action
	 */
	/* global espn espn_ui jQuery */
	function getPageConfig(_ref) {
	  var _ref$edition = _ref.edition,
	      edition = _ref$edition === undefined ? {} : _ref$edition,
	      _ref$params = _ref.params,
	      params = _ref$params === undefined ? {} : _ref$params,
	      appProps = _ref.appProps;
	
	  var queryObject = {
	    pageShell: true,
	    xhr: 1
	  };
	  var host = edition.host;
	  var editionKey = edition.editionKey;
	  var localEditionKey = edition.localEditionKey;
	  var lang = edition.language;
	  var region = edition.country;
	  var sport = params.sport;
	  var pageType = params.pageType;
	  var template = (0, _lib.mapPageToTemplate)({ pageType: pageType, sport: sport });
	  var sCoreTcClient = (0, _api.getHost)('score', '', appProps);
	
	  if (template === 'standings' || template === 'scoreboard') {
	    if (params.league) {
	      queryObject.league = params.league;
	    }
	    if (params.team) {
	      queryObject.team = params.team;
	    }
	    if (params.season) {
	      queryObject.season = params.season;
	    }
	  }
	
	  if (editionKey && localEditionKey) {
	    queryObject['edition'] = editionKey;
	    queryObject['edition-view'] = localEditionKey;
	  } else {
	    queryObject['edition-host'] = host;
	    queryObject.lang = lang;
	    queryObject.region = region;
	  }
	
	  var queryString = (0, _api.getQueryString)(queryObject, params, edition);
	
	  var url = sCoreTcClient + '/' + params.sport + '/' + (template === 'gamepackage' ? 'game' : template) + queryString;
	
	  if (template === 'clubhouse') {
	    url = sCoreTcClient + '/' + params.sport + '/team/_/id/' + params.team + queryString;
	  }
	  return {
	    sport: sport,
	    pageType: pageType,
	    type: _actionTypes2.default.PAGE_CONFIG,
	    promise: _lib.memoizr.get(url)
	  };
	}
	
	/**
	 * Validate and get page config if required
	 * @param  {Object} edition     edition config
	 * @param  {Object} params      Router params
	 * @return {undefined}
	 */
	function validatePageConfig(_ref2) {
	  var _ref2$edition = _ref2.edition,
	      edition = _ref2$edition === undefined ? {} : _ref2$edition,
	      _ref2$params = _ref2.params,
	      params = _ref2$params === undefined ? {} : _ref2$params,
	      appProps = _ref2.appProps;
	
	  return function (dispatch, getState) {
	    var state = getState();
	    var page = state.page || {};
	    var sport = page.sport,
	        pageType = page.pageType;
	
	    // Make page config if not a webview and page/sport has changed
	
	    if (!params.platform && (sport !== params.sport || pageType !== params.pageType)) {
	      dispatch(getPageConfig({ edition: edition, params: params, appProps: appProps }));
	    }
	  };
	}
	
	/**
	 * Set page config - ads, analytics
	 * that come along with the page shell
	 * @param  {Object} edition     edition config
	 * @param  {Object} params      Router params
	 * @param  {Object} location    location params
	 * @param  {Object} config      config
	 * @return {Object}             page config action type
	 */
	function setPageConfig(_ref3) {
	  var config = (0, _objectWithoutProperties3.default)(_ref3, []);
	
	  return (0, _extends3.default)({}, config, {
	    type: _actionTypes2.default.PAGE_CONFIG
	  });
	}
	
	/**
	 * onRenderComplete callback
	 * @param  {Boolean} initialLoad initial page load
	 * @param  {Boolean} historyChange history change
	 * @param  {Boolean} pathnameChange pathname change
	 * @return {undefined}
	 */
	function onRenderComplete(_ref4) {
	  var initialLoad = _ref4.initialLoad,
	      historyChange = _ref4.historyChange,
	      pathnameChange = _ref4.pathnameChange;
	
	  return function (dispatch, getState) {
	    var state = getState();
	    var isWebview = (0, _selectn2.default)('page.params.platform', state) ? true : false;
	    if (!historyChange && !isWebview) {
	      if ((0, _selectn2.default)('page.appProps.siteType', state) === 'data-lite') {
	        _analytics2.default.liteTrack(state);
	      } else {
	        _analytics2.default.init(state, initialLoad, pathnameChange);
	      }
	    }
	    try {
	      var tier3Nav = (0, _selectn2.default)('page.tier3Nav', state) || initialLoad && (0, _selectn2.default)('nav.tier3', espn);
	      var tier2Nav = (0, _selectn2.default)('page.tier2Nav', state) || initialLoad && (0, _selectn2.default)('nav.tier2', espn);
	      if (typeof espn_ui.Helpers.nav == 'undefined') {
	        espn_ui.Helpers.nav = {};
	      }
	      if (tier3Nav) {
	        espn_ui.Helpers.nav.tier3Nav = tier3Nav;
	      } else {
	        espn_ui.Helpers.nav.tier3Nav = null;
	      }
	
	      if (tier2Nav) {
	        espn_ui.Helpers.nav.tier2Nav = tier2Nav;
	      } else {
	        espn_ui.Helpers.nav.tier2Nav = null;
	      }
	
	      var t2LoadType = jQuery('#global-nav-secondary').attr('data-loadtype');
	      if (!initialLoad || initialLoad && t2LoadType !== 'server') {
	        jQuery(document).trigger('nav.sportChange');
	      }
	    } catch (e) {
	      console.log(e);
	    }
	
	    // console.info('onRenderComplete')
	  };
	}
	
	/**
	 * updateTimeZone
	 * @param  {Object} edition     edition config
	 * @param  {Object} params      Router params
	 * @param  {Object} query       query params
	 * @return {Object} action object
	 */
	function updateTimeZone() {
	  var edition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  var timeZone = _momentTimezone2.default.tz.guess() || '';
	  var timeZoneAbbr = timeZone ? _momentTimezone2.default.tz(timeZone).format('z') : '';
	  return {
	    zone: timeZone,
	    zoneAbbr: timeZoneAbbr,
	    type: _actionTypes2.default.UPDATE_TIMEZONE,
	    edition: edition,
	    params: params,
	    query: query
	  };
	}
	
	/**
	 * update the appProps
	 * @param {Object} options.appProps app props
	 * @return {Object} action object
	 */
	function setAppProps(_ref5) {
	  var appProps = _ref5.appProps;
	
	  return {
	    appProps: appProps,
	    type: _actionTypes2.default.APP_PROPS
	  };
	}
	/**
	 * update gamestrip
	 * @param {String} sport sport cricket
	 * @return {Object} action object
	 */
	function updateGameStrip() {
	  var sport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	  return {
	    sport: sport,
	    type: _actionTypes2.default.UPDATE_GAMESTRIP_TIME
	  };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 416 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ }),
/* 417 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  PAGE_CONFIG: 'PAGE_CONFIG',
	  GET_LEAGUES: 'GET_LEAGUES',
	  GET_SCOREBOARD: 'GET_SCOREBOARD',
	  GET_TOPEVENTS: 'GET_TOPEVENTS',
	  UPDATE_FAVORITES: 'UPDATE_FAVORITES',
	  GET_SCOREBOARD_REQUEST: 'GET_SCOREBOARD_REQUEST',
	  GET_SCOREBOARD_FAILURE: 'GET_SCOREBOARD_FAILURE',
	  GET_STANDINGS: 'GET_STANDINGS',
	  GET_FIXTURES: 'GET_FIXTURES',
	  GET_HEADLINES: 'GET_HEADLINES',
	  GET_EDITORIAL: 'GET_EDITORIAL',
	  GET_GAMEPACKAGE: 'GET_GAMEPACKAGE',
	  GET_PLAY_BY_PLAY: 'GET_PLAY_BY_PLAY',
	  GET_VIDEOS_MORE: 'GET_VIDEOS_MORE',
	  GET_GEO_LOCATION: 'GET_GEO_LOCATION',
	  GET_RENDERED_ARTICLE: 'GET_RENDERED_ARTICLE',
	  SET_DEVICE_TYPE: 'SET_DEVICE_TYPE',
	  HISTORY_CHANGE: 'HISTORY_CHANGE',
	  UPDATE_TIMEZONE: 'UPDATE_TIMEZONE',
	  API_REQUEST_START: 'API_REQUEST_START',
	  API_REQUEST_COMPLETE: 'API_REQUEST_COMPLETE',
	  GET_CLUBHOUSE: 'GET_CLUBHOUSE',
	  GET_MORE_MID_COL_FEED: 'GET_MORE_MID_COL_FEED',
	  APP_PROPS: 'APP_PROPS',
	  COMM_FB_STATUS: 'COMM_FB_STATUS',
	  ALLOW_DENY_FASTCAST: 'ALLOW_DENY_FASTCAST',
	  UPDATE_GAMESTRIP_TIME: 'UPDATE_GAMESTRIP_TIME',
	  RESET_GAMEPACKAGE: 'RESET_GAMEPACKAGE',
	  RESET_SCOREBOARD: 'RESET_SCOREBOARD'
	};

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.analytics = undefined;
	
	var _keys = __webpack_require__(419);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _shell = __webpack_require__(422);
	
	var _shell2 = _interopRequireDefault(_shell);
	
	var _common = __webpack_require__(430);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var analytics = exports.analytics = {
	  init: function init(state, initialLoad, pathnameChange) {
	    var page = state.page;
	
	    var mergedAnalytics = analytics.merge(state, page.analytics, page.template);
	
	    if (initialLoad) {
	      _shell2.default.track.init(mergedAnalytics);
	    } else if (pathnameChange) {
	      _shell2.default.track.page({ analytics: mergedAnalytics });
	    }
	    history.state.ads = page.ads;
	    history.state.analytics = page.analytics;
	    // TODO: update app state again? should we trigger another action?
	  },
	  merge: function merge() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var template = arguments[2];
	
	    var reducerName = (0, _common.mapTemplateToReducer)(template);
	    var reducer = state[reducerName] || {};
	    var processedAnalytics = reducer.analytics || {};
	
	    (0, _keys2.default)(processedAnalytics).map(function (type) {
	      var source = processedAnalytics[type] || {};
	      (0, _keys2.default)(source).map(function (prop) {
	        if (processedAnalytics[type] && data[type]) {
	          data[type][prop] = processedAnalytics[type][prop];
	        }
	      });
	    });
	
	    return data;
	  },
	  liteTrack: function liteTrack(state) {
	    var _state$page = state.page,
	        page = _state$page === undefined ? {} : _state$page;
	
	    var template = page.template || '';
	    var site = page.edition && page.edition.site || '';
	    var reducerName = (0, _common.mapTemplateToReducer)(template);
	    var reducer = state[reducerName];
	    var trackingImg = reducer && reducer.trackingImg || '';
	    if (process.browser && trackingImg && site === 'espncricinfo') {
	      var img = document.createElement('img');
	      img.src = trackingImg;
	      img.id = 'omniture';
	      img.style.display = 'none';
	      img.onload = function () {
	        img.parentNode && img.parentNode.removeChild(img);
	      };
	      document.body.appendChild(img);
	    }
	  }
	};
	
	exports.default = analytics;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(420), __esModule: true };

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(421);
	module.exports = __webpack_require__(288).Object.keys;


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(282);
	var $keys = __webpack_require__(324);
	
	__webpack_require__(292)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shell = undefined;
	
	var _keys = __webpack_require__(419);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _config = __webpack_require__(423);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _ads = __webpack_require__(429);
	
	var _ads2 = _interopRequireDefault(_ads);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global jQuery espn_ui espn */
	var shell = exports.shell = {
	  setContainer: function setContainer() {
	    espn_ui.Helpers.page.container = jQuery('#main-container');
	  },
	
	  transition: {
	    start: function start() {
	      jQuery('#' + _config2.default.uid).attr('style', 'opacity:0');
	    },
	    end: function end() {
	      jQuery('#' + _config2.default.uid).attr('style', 'opacity:1');
	    },
	    preRender: function preRender(edition, sport, template, team, league) {
	      try {
	
	        shell.unloadAds();
	
	        // arguments to be passed to page.preRender
	        // [  url, pagetype, prefetch, autoCSS, customStyleSheet ]
	        var args = ['', template, false, null];
	
	        switch (template) {
	          case 'gamepackage':
	            if (sport === 'rugby-league') {
	              args.push('game-package-rugby');
	            } else {
	              args.push('game-package-' + sport);
	            }
	            break;
	          case 'scoreboard':
	            if (sport === 'rugby') {
	              args.push('scoreboards-' + sport);
	            } else if (sport === 'rugby-league') {
	              args.push('scoreboards-rugby');
	            } else if (sport == 'cricket') {
	              args.push('score-center');
	            }
	            break;
	        }
	        jQuery(document).trigger('page.preRender', args);
	
	        espn_ui.Helpers.page.react = true;
	
	        espn_ui.Helpers.page.pathname = location.pathname;
	
	        espn_ui.Helpers.page.template = template;
	
	        shell.updateClassNames(template, sport);
	
	        shell.updateAds(template, edition);
	
	        //disable header scoreboard for cricinfo/scores
	        shell.showHideScoreboard(template, edition.site, team, league);
	      } catch (e) {
	        console.log(e);
	      }
	    },
	    postRender: function postRender(sport, template) {
	      var ads = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	      var analytics = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	      var tier3Nav = arguments[4];
	      var tier2Nav = arguments[5];
	
	      try {
	        var stateProps = {
	          url: location.href,
	          react: true,
	          type: template
	        };
	
	        if ((0, _keys2.default)(ads).length) {
	          stateProps.ads = ads;
	        }
	
	        if ((0, _keys2.default)(analytics).length) {
	          stateProps.analytics = analytics;
	        }
	
	        switch (template) {
	          case 'gamepackage':
	            if (sport === 'rugby' || sport === 'rugby-league') {
	              stateProps.customStyleSheet = 'game-package-rugby';
	            } else if (sport === 'cricket') {
	              stateProps.customStyleSheet = 'game-package-cricket';
	            }
	            break;
	          case 'scoreboard':
	            if (sport === 'rugby' || sport === 'rugby-league') {
	              stateProps.customStyleSheet = 'scoreboards-rugby';
	            } else if (sport == 'cricket') {
	              stateProps.customStyleSheet = 'score-center';
	            }
	            break;
	          case 'standings':
	            break;
	        }
	
	        shell.setContainer();
	
	        espn_ui.Helpers.page.contentPreBehavior = espn_ui.Helpers.page.container.html();
	
	        var newState = espn_ui.Helpers.history.getStateData();
	        newState.content.html = espn_ui.Helpers.page.container.html();
	        newState.meta.type = template;
	        newState.sport = [sport];
	
	        tier3Nav = tier3Nav || espn.nav && espn.nav.tier3;
	        tier2Nav = tier2Nav || espn.nav && espn.nav.tier2;
	
	        if (tier3Nav) {
	          newState.tier3Nav = tier3Nav;
	        }
	
	        if (tier2Nav) {
	          newState.tier2Nav = tier2Nav;
	        }
	
	        (0, _keys2.default)(stateProps).map(function (key) {
	          newState[key] = stateProps[key];
	        });
	
	        // replace history state
	        history.replaceState(newState, template, window.location);
	      } catch (e) {
	        console.log(e);
	      }
	    }
	  },
	  updateClassNames: function updateClassNames(template, sport) {
	    var bodyClassNames = {
	      add: [template],
	      remove: []
	    };
	    var paneMainClassNames = {
	      add: [],
	      remove: []
	    };
	
	    switch (template) {
	      case 'gamepackage':
	        bodyClassNames.remove.push('standings', 'scoreboard');
	        paneMainClassNames.add.push('pre');
	        paneMainClassNames.add.push('details-header');
	        if (/cricket/.test(sport) === false) {
	          paneMainClassNames.add.push('details-header');
	        }
	        break;
	
	      case 'standings':
	        bodyClassNames.remove.push('gamepackage', 'scoreboard');
	        paneMainClassNames.remove.push('pre', 'details-header', 'details-footer');
	        break;
	
	      case 'scoreboard':
	        bodyClassNames.remove.push('gamepackage', 'standings');
	        paneMainClassNames.remove.push('pre', 'details-header', 'details-footer');
	        break;
	    }
	
	    jQuery('body').attr('data-pagetype', template.replace(/\-webview\-.*$/, '')).addClass(bodyClassNames.add.join(' ')).removeClass(bodyClassNames.remove.join(' '));
	
	    jQuery('#pane-main').addClass(paneMainClassNames.add.join(' ')).removeClass(paneMainClassNames.remove.join(' '));
	  },
	  unloadAds: function unloadAds() {
	    try {
	      if (location.pathname !== espn_ui.Helpers.page.pathname) {
	        _ads2.default.unloadAds();
	      }
	    } catch (e) {
	      console.log(e);
	    }
	  },
	  updateAds: function updateAds(template, edition) {
	    // Placeholder method to update ads,
	    // currently only overlay and wallpaper are hidden
	    // on gamepackage for espn.in.
	    // TODO: add logic as required for other editions
	    var variableAdTypes = ['overlay', 'wallpaper'];
	    var selectors = variableAdTypes.map(function (type) {
	      return '.ad-slot-' + type;
	    });
	    var selectorString = selectors.join(', ');
	
	    if (template === 'gamepackage' && edition && !edition.isEspnCricinfo) {
	      jQuery(selectorString).remove();
	    } else {
	
	      // TODO: check ads initing on page transitions
	      if (!jQuery('.ad-slot-overlay').length && template.indexOf('webview') == -1) {
	        jQuery('body').prepend(_ads2.default.getSlot('overlay'));
	      }
	
	      if (!jQuery('.ad-slot-wallpaper').length) {
	        jQuery('body').prepend(_ads2.default.getSlot('wallpaper'));
	      }
	
	      /*
	       * Scoreheader presby ad will appear for espncricinfo india edition
	      */
	      if (edition.isAsiaRegion) {
	        if (!jQuery('.ad-slot-presby').length) {
	          jQuery('.scoreboard-content .scoreboard-menu').after(_ads2.default.getSlot('presbyHeader'));
	        }
	      }
	    }
	  },
	  showHideScoreboard: function showHideScoreboard(template, site, team, league) {
	    var $el = jQuery('#global-scoreboard');
	    if (window.espn_ui) {
	      var isDesktop = window.espn_ui.deviceType === 'desktop' || false;
	      var isNotDevice = !window.espn_ui.device.isMobile && !window.espn_ui.device.isTablet;
	      if (site === 'espncricinfo' && isDesktop && isNotDevice) {
	        if (template === 'scoreboard' && !team && !league) {
	          $el.hide();
	        } else {
	          $el.show();
	          if (window.espnSB) {
	            window.espnSB.trigger('resetSB');
	          }
	        }
	      }
	    }
	  },
	
	  track: {
	    init: function init(data) {
	      try {
	        if (typeof espn.track !== 'undefined' && typeof espn.track.init == 'function') {
	          espn.track.init(data);
	        }
	      } catch (e) {
	        console.log(e);
	      }
	    },
	    page: function page(props) {
	      jQuery(document).trigger('page.track', [props]);
	    }
	  }
	};
	
	exports.default = shell;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {'use strict';
	
	var _assign = __webpack_require__(365);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var envConfig = __webpack_require__(424);
	var path = __webpack_require__(427);
	var apiTimeout = envConfig.api.timeout;
	var env = ({"NODE_ENV":"production","SITE_API_FRONTCHANNEL_HOST":"site.web.api.espn.com","SCORETC_FRONTCHANNEL_HOST":"www.espn.com/core"});
	var REGION_NAME = env.REGION_NAME || null;
	var EUREKA = env.EUREKA || null;
	var SERVICE_NAME = env.SERVICE_NAME || 'scorenode';
	var cpus = __webpack_require__(428).cpus();
	var cpuCnt = cpus && cpus.length;
	
	module.exports = function () {
	
	  var config = (0, _assign2.default)({
	    dirs: {
	      root: path.resolve(__dirname + '/../'),
	      app: '/app',
	      views: '/../app/views',
	      partials: '/../app/views/partials'
	    },
	    name: SERVICE_NAME,
	    cpuCnt: cpuCnt,
	    cpuPct:  false ? 10 : 65,
	    useCluster: true,
	    httpCollapsing: true,
	    adminPort: 1378,
	    enablePurging: true,
	    LRUcache: {
	      maxMemSize: 67108864,
	      minPurgeInterval: 5000
	    },
	    http: {
	      attempts: 2,
	      timeout: {
	        server: apiTimeout,
	        client: 10000,
	        dns: 2000
	      }
	    },
	    serviceLink: {
	      instance: {
	        app: SERVICE_NAME,
	        vipAddress: SERVICE_NAME
	      },
	      ec2Region: REGION_NAME,
	      eureka: EUREKA
	    }
	  }, envConfig);
	
	  return config;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var fitt = __webpack_require__(425);
	var cnum = fitt.cnum;
	
	module.exports = function () {
	
	  var env = ({"NODE_ENV":"production","SITE_API_FRONTCHANNEL_HOST":"site.web.api.espn.com","SCORETC_FRONTCHANNEL_HOST":"www.espn.com/core"});
	  var UID = env.UID;
	  var PORT = env.PORT;
	  var HOST = env.HOST;
	  var MEMCACHED_SERVERS = (env.MEMCACHED_SERVERS || '127.0.0.1:11211').split(',');
	  var MEMCACHED_POOLSIZE = env.MEMCACHED_POOLSIZE;
	  var MEMCACHED_TIMEOUT = env.MEMCACHED_TIMEOUT;
	  var MEMCACHED_RETRIES = env.MEMCACHED_RETRIES;
	  var MEMCACHED_FAILURES = env.MEMCACHED_FAILURES;
	  var MEMCACHED_NAMESPACE = env.MEMCACHED_NAMESPACE;
	
	  // CDN path for serving App bundles
	  var CDN_PATH = env.CDN_PATH;
	
	  var GZIPPED_REQUESTS = env.GZIPPED_REQUESTS;
	
	  // Site API host names. We use different host names
	  // for backchannel calls inside the datacenters vs
	  // from the public internet
	  var SITE_API_FRONTCHANNEL_HOST = env.SITE_API_FRONTCHANNEL_HOST;
	  var SITE_API_BACKCHANNEL_HOST = env.SITE_API_BACKCHANNEL_HOST;
	  var V1_API_FRONTCHANNEL_HOST = env.V1_API_FRONTCHANNEL_HOST;
	  var V1_API_BACKCHANNEL_HOST = env.V1_API_BACKCHANNEL_HOST;
	  var NOW_API_FRONTCHANNEL_HOST = env.NOW_FRONTCHANNEL_HOST;
	  var NOW_API_BACKCHANNEL_HOST = env.NOW_BACKCHANNEL_HOST;
	
	  var API_TIMEOUT = env.API_TIMEOUT;
	
	  var SCORETC_FRONTCHANNEL_HOST = env.SCORETC_FRONTCHANNEL_HOST;
	  var SCORETC_BACKCHANNEL_HOST = env.SCORETC_BACKCHANNEL_HOST;
	
	  // MEMCACHED DEFAULTS
	  var MEMCACHED_LIVE_DATA_TTL = env.MEMCACHED_LIVE_DATA_TTL;
	  var MEMCACHED_DEFAULT_DATA_TTL = env.MEMCACHED_DEFAULT_DATA_TTL;
	
	  // In Memory Caching configurations
	  var IN_MEM_CACHE_SHELL_TTL = env.IN_MEM_CACHE_SHELL_TTL;
	  var IN_MEM_CACHE_SHELL_STALE_TTL = env.IN_MEM_CACHE_SHELL_STALE_TTL;
	  var IN_MEM_CACHE_I18N_TTL = env.IN_MEM_CACHE_I18N_TTL;
	  var IN_MEM_CACHE_I18N_STALE_TTL = env.IN_MEM_CACHE_I18N_STALE_TTL;
	  var SERVER_REQUEST_TIMEOUT = env.SERVER_REQUEST_TIMEOUT;
	
	  var PRIMER_ACTIVE = env.PRIMER_ACTIVE;
	  var PRIMER_SUMMARIES = env.PRIMER_SUMMARIES;
	
	  return {
	    uid: UID || 'reduxion',
	    port: cnum(PORT) || 1377,
	    host: HOST || '0.0.0.0',
	    // overall request timeout
	    serverRequestTimeout: cnum(SERVER_REQUEST_TIMEOUT, 7000, 7000, 10000),
	    api: {
	      // Specifies the number of milliseconds before the request times out; 5000ms client-side, 1000ms by default
	      timeout: cnum(API_TIMEOUT, 3000, 3000, 5000),
	      useGzip: GZIPPED_REQUESTS === 'true'
	    },
	    cacheDuration: {
	      // Duration for which every API is cached by default,
	      // can be overridden at each API level
	      liveData: cnum(MEMCACHED_LIVE_DATA_TTL) || 5,
	      defaultData: cnum(MEMCACHED_DEFAULT_DATA_TTL) || 60,
	
	      // Duration for which pageShell is cached
	      shell: cnum(IN_MEM_CACHE_SHELL_TTL) || 300,
	      shellStale: cnum(IN_MEM_CACHE_SHELL_STALE_TTL) || 1800,
	
	      // Duration for which translationMap is cached
	      translation: cnum(IN_MEM_CACHE_I18N_TTL) || 3600,
	      translationStale: cnum(IN_MEM_CACHE_I18N_STALE_TTL) || 1800
	    },
	    // ideally, this would get merged into the api
	    // key, but Object.assign doesnt' do deep copies.
	    // TODO: discuss adding underscore/lo-dash/etc.
	    apiHost: {
	      sCoreTcClient: SCORETC_FRONTCHANNEL_HOST || 'www.espn.com/core',
	      sCoreTcServer: SCORETC_BACKCHANNEL_HOST || 'www.espn.com/core',
	      sCoreQahost: 'www.espnqa.com/core',
	      client: SITE_API_FRONTCHANNEL_HOST || 'site.web.api.espn.com',
	      server: SITE_API_BACKCHANNEL_HOST || 'site.web.api.espn.com',
	      client_qa: 'site.web.api.espnqa.com',
	      server_qa: 'site.web.api.espnqa.com',
	      client_v1: V1_API_FRONTCHANNEL_HOST || 'api-app.espn.com',
	      server_v1: V1_API_BACKCHANNEL_HOST || 'api-app.espn.com',
	      now_client: NOW_API_FRONTCHANNEL_HOST || 'now.core.api.espn.com',
	      now_server: NOW_API_BACKCHANNEL_HOST || 'now.core.api.espn.com'
	    },
	    cache: {
	      servers: MEMCACHED_SERVERS,
	      poolSize: cnum(MEMCACHED_POOLSIZE) || 50,
	      timeout: cnum(MEMCACHED_TIMEOUT) || 1000,
	      retries: cnum(MEMCACHED_RETRIES) || 1,
	      failures: cnum(MEMCACHED_FAILURES) || 1,
	      namespace: MEMCACHED_NAMESPACE || ''
	    },
	    cdnPath: CDN_PATH || '',
	    cachePrimer: {
	      active: PRIMER_ACTIVE === undefined ? true : PRIMER_ACTIVE === 'true',
	      primeSummaries: PRIMER_SUMMARIES === undefined ? true : PRIMER_SUMMARIES === 'true'
	    }
	
	  };
	}();

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	if (true) {
	    module.exports = __webpack_require__(426);
	}

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Core JavaScript functionality.  Provides wrappers / shorthand for many common JavaScript programming needs,
	 * and many of the functions in the api provide additional optimization, or debugging improvements.
	 * This module is intended to be the base / required module for pretty much every piece of modularized JS code
	 * going forward.
	 *
	 * @name {Object} fitt
	 * @namespace
	 * @public
	*/
	
	var fitt;
	
	fitt = fitt || function () {
	
	
		/*
	                             * Modules should start with variable/constant declaration / initialization
	                             * for items that have no dependancies.  All functions, including module
	                             * definitions should always have only 1 single var statement, with each
	                             * variable initiliazation/declaration seperated by commma.  In other
	                             * words, 1 function should only have 1 single var statement and optionally
	                             * 1 single const statement (if we are allowing new school syntax).
	                             *
	                             * let statements are allowed in blocks, as per their use-case, but there
	                             * should NOT be const or var statements interspersed throughout blocks
	                             * of a function
	                            */
	
		/*
	                                * Shorthand constants, which we will expose out of the module as well.
	                                * (See documentation below).  A great number of property / method names
	                                * in JavaScript and the DOM are rather long in terms of number of characters
	                                * and so we have variables/constants defined to allow us to make the code
	                                * size much smaller.  Client-side, this can reduce overall code size by
	                                * as much as 20% depending on how other code is written.
	                               */
	
		/*
	                                   * Constants are always ALL CAPS, word seperation done with '_'
	                                  */
	
		var PROTO = "prototype",
		UPROTO = "__proto__",
		CONSTRUCT = "constructor",
		TO_STR = "toString",
		VALUE = "value",
		VALUE_OF = VALUE + "Of",
		TYPE_STR = "string",
		TYPE_NUM = "number",
		TYPE_BOOL = "boolean",
		TYPE_FUNC = "function",
		TYPE_OBJ = "object",
		TYPE_SYM = "symbol",
		TYPE_UNDEF = "undefined",
		TYPE_UNKNOWN = "unknown", /* legacy IE 9 and below */
		CAN_CONF = "configurable",
		CAN_WRITE = "writable",
		CAN_ENUM = "enumerable",
		DEF_GET = "__defineGetter__",
		DEF_SET = "__defineSetter__",
		NULL = null,
		UNDEF = void 0,
		TRUE = true,
		FALSE = false,
		NEG_ONE = -1,
		RETURN = "return",
		WIN = "window",
		GLOBAL = "global",
	
		/* Shorthand dereferenced module variables */
	
		/*
	                                                * Shorthand deferenced static members (properties / methods)
	                                                * should use the same name as the dereferenced shorthand variable
	                                                * name seperated by an '_'
	                                               */
	
		/*
	                                                   * Next in modules should be any variables that are declared
	                                                   * or initialized via dependencies
	                                                  */
		obj = Object,
		obj_assign = obj.assign,
		obj_create = obj.create,
		obj_cprop = obj.defineProperty,
		obj_gprop = obj.getOwnPropertyDescriptor,
		obj_props = obj.getOwnPropertyNames,
		obj_syms = obj.getOwnPropertySymbols,
		obj_keys = obj.keys,
		obj_getProto = obj.getPrototypeOf,
		obj_setProto = obj.setPrototypeOf,
		obj_noExtend = obj.preventExtensions,
		obj_canExtend = obj.isExtensible,
		obj_seal = obj.seal,
		obj_freeze = obj.freeze,
		obj_sealed = obj.isSealed,
		obj_frozen = obj.isFrozen,
	
		/*
	                             * Shorthand deferenced members from a prototype object
	                             * use a prefix of '$' to reference the function / class from
	                             * which the prototype object lives, and short hand deferenced
	                             * variables for members of that prototype follow the same pattern
	                             * of '_' to seperate the owning object, and then a member.
	                             *
	                             * For example:
	                             *      var obj             = Object;
	                             *
	                             *      var obj_assign      = obj.assign;  //where obj is the owning reference _assign means the property 'assign'
	                             *                                         //on the obj variable.
	                            */
		$obj = obj[PROTO],
		$obj_owns = $obj.hasOwnProperty,
		$obj_toString = $obj.toString,
		$obj_kindOf = $obj.isPrototypeOf,
	
		ary = Array,
		$ary = ary[PROTO],
		$ary_slice = $ary.slice,
		$ary_join = $ary.join,
		$ary_strTag = toStringTag.call([]),
		$ary_forEach = $ary.forEach,
		func = Function,
		$func = func[PROTO],
		str = String,
		$str = str[PROTO],
		$str_trim = $str.trim,
		strArrayAccess = FALSE,
	
		regx = RegExp,
		$regx = regx[PROTO],
		$regx_strTag = toStringTag(/\s/),
		$regx_test = $regx.test,
	
		dte = Date,
		$dte = dte[PROTO],
		$dte_strTag = toStringTag(new dte()),
	
		num = Number,
		$num = num[PROTO],
	
		err = Error,
		$err = err[PROTO],
	
		jsn = typeof JSON === TYPE_OBJ && JSON,
		jsnParse = jsn && jsn.parse,
		jsnStringify = jsn && jsn.stringify,
	
		/* Shorthand Constants (with dependencies on shorthand dereferenced items */
	
		/*
	                                                                               * Next in modules should be any constants that are declared
	                                                                               * or initialized via dependencies
	                                                                              */
	
		NUM_MAX = num && num.MAX_VALUE || 9007199254740992,
		NUM_MIN = NEG_ONE * NUM_MAX,
		NAN = num.NaN,
	
		/*
	                 * The last variables in modules should be state related things
	                 *
	                */
	
		ECMAScript5 = typeof obj_create === TYPE_FUNC && typeof obj_props === TYPE_FUNC,
		PropDescErrProto = err(),
		PropDescErr_ERRS,
	
	
		/**
	                    * Holds a map of global variable names to functions
	                    * you can use to get at a given global variable safely
	                    * without having to write your own typeof / window. checks
	                    *
	                    * @name fitt-globalVarNameCache
	                    * @private
	                    * @static
	                    * @type {Object}
	                   */
		globalVarNameCache = {},
	
		exp = {};
	
		/*
	            * After variable declarion, is function declarations, which should ALL be named functions
	            *
	            * Adding to the prototype property of functions to set them up for being used as constructors
	            * or adding static properties to said functions right after the definition is acceptable practice
	           */
	
		/**
	               * Basic empty function
	               *
	               * @name fitt.noop
	               * @memberof fitt
	               * @function
	               * @public
	               * @return void
	               *
	              */
	
		function noop() {}
	
		/**
	                        * Basic function returning the value true
	                        *
	                        * @name fitt.passThru
	                        * @memberof fitt
	                        * @function
	                        * @public
	                     * @param {any} [o=undefined] param to be returned
	                        * @return {any} param passed in
	                       */
	
		function passThru(o) {return o;}
	
		/**
	                                   * Basic function returning the value true
	                                   *
	                                   * @name fitt.rtrue
	                                   * @memberof fitt
	                                   * @function
	                                   * @public
	                                   * @return {Boolean} true
	                                  */
	
		function rtrue() {return TRUE;}
	
		/**
	                                  * Basic function returning the value false
	                                  *
	                                  * @name fitt.rfalse
	                                  * @function
	                                  * @public
	                                  * @return {Boolean} false
	                                 */
	
		function rfalse() {return FALSE;}
	
		/**
	                                    * Basic function returing the value null
	                                    *
	                                    * @name fitt.rnull
	                                    * @function
	                                    * @public
	                                    * @return {Null} null
	                                   */
	
		function rnull() {return NULL;}
	
		/**
	                                  * Basic function returning the value 0
	                                  *
	                                  * @name fitt.rzero
	                                  * @function
	                                  * @public
	                                  * @return {Number} 0
	                                 */
	
		function rzero() {return 0;}
	
		/**
	                               * Basic function for returning the value 1 or -1
	                               *
	                               * @name fitt.rone
	                               * @function
	                               * @public
	                               * @param {Boolean} [n=false] If true return -1, instead of 1
	                               * @return {Number}
	                              */
	
		function rone(n) {return n ? -1 : 1;}
	
	
		/**
	                                        * Checks to see if a given object is actually an Array
	                                        * Array objects from different realms/frames/windows will
	                                        * return true.  However objects which inherit from Array or
	                                        * objects that are iterable lists like collections or other dom
	                                        * objects are not considered arrays (although are considered array like)
	                                        *
	                                        * @name fitt.isAry
	                                        * @function
	                                        * @public
	                                        * @param {Object} o The object to inspect
	                                        * @param {Boolean} [loose=false] Array objects will return true from this function, by default.
	                                        *                               Passing true allows inherited / sub-classed objects (like MobX Observable Arrays) to be accepted
	                                        * @return {Boolean} true is the object is a pure JavaScript Array object.
	                                       */
	
		function isAry(o, loose) {
	
			return !loose ? o && (o[CONSTRUCT] == ary || toStringTag(o) == $ary_strTag) :
			o && typeof o == TYPE_OBJ && typeof o.slice == TYPE_FUNC && typeof o.push == TYPE_FUNC && typeof o.join == TYPE_FUNC && 'length' in o;
		}
	
		/**
	    * Checks to see if a given object is actually a RegExp object.
	    * Objects from different realms/frames/windows will return true
	    *
	    * @name fitt.isRegX
	    * @function
	    * @public
	    * @param {Object} o The object to inpsect
	    * @return {Boolean} true if the object is a pure JavaScript RegExp object
	   */
	
		function isRegX(o)
		{
			return o && (o[CONSTRUCT] == regx || toStringTag(o) == $regx_strTag);
		}
	
		/**
	    * Checks to see if a given object is either an array or behaves like
	    * an array, meaning it has numerical index properties and a length property.
	    * Note that empty collections / objects cannot be completely tested for said
	    * functionality since they may be read-only or some sort of exotic object,
	    * hence why this function returns a numeric value as opposed to a boolean.
	    *
	    * @name fitt.isAryLike
	    * @function
	    * @public
	    * @param {Object} o The object to inspect
	    * @param {Boolean} [ots=false]  Pass true if you are 100% postive the 1st argument is an object, which provides a slight
	    *								 performance gain since this function will not then test to ensure the 1st arg is an object on it's
	    *								 own
	    *
	    * @return {Number} returns 0 if not array like, 1 if is array like, -1 if the object appears to have a 0 length and therefore we're not sure
	    *
	   */
	
		function isAryLike(o, ots)
		{
			var ret = 0,
			cnt = 0;
	
			if (isAry(o, TRUE)) {
				ret = 1;
			} else if (ots || typeof o == TYPE_OBJ && "length" in o) {
				/* if it has length of at least 1 and the 0 index shows up as
	                                                             * a prop then we can trust it can be indexed over, otherwise
	                                                             * we cannot truly trust when there are no items since we don't
	                                                             * know if adding a new indexed property will also add the length
	                                                             * etc.
	                                                            */
	
				cnt = o.length;
				if (cnt && "0" in o) {
					ret = 1;
				} else {
					ret = NEG_ONE;
				}
			}
			return ret;
		}
	
		/**
	    * Test if a given reference is a function
	    *
	    * @name fitt.isFunc
	    * @function
	    * @public
	    * @param {*} o A reference to anything
	    * @return {Boolean} whether or not the given argument is a function
	    *
	   */
	
		function isFunc(o)
		{
			return o && typeof o == TYPE_FUNC;
		}
	
		/**
	    * Test if a given reference is a type of object
	    *
	    * @name fitt.isObj
	    * @function
	    * @public
	    * @param {*} o A reference to anything
	    * @return {Boolean}
	   */
	
		function isObj(o)
		{
			return o && typeof o == TYPE_OBJ ? TRUE : FALSE;
		}
	
		/**
	    * Test if a given reference is an object or function type, as opposed to some primitive value
	    * Good for cases where you want to know that the reference is a complex type since functions
	    * are also technically objects.
	    *
	    * @name fitt.isObjLike
	    * @function
	    * @public
	    * @param {*} A reference to anything
	    * @return {Boolean}
	   */
	
		function isObjLike(o)
		{
			var ots = o && typeof o;
	
			switch (ots) {
	
				case TYPE_OBJ:
				case TYPE_FUNC:
					return TRUE;}
	
			return FALSE;
		}
	
		/**
	    * Is the given value a number type and also NOT NaN. In other
	    * words is it a usable number.
	    *
	    * @name fitt.isNum
	    * @function
	    * @public
	    * @param {*} n
	    * @return {Boolean}
	   */
	
		function isNum(n)
		{
			return typeof n == TYPE_NUM && !isNaN(n);
		}
	
		/**
	    * Determine if a value is a Date
	    *
	    * @name fitt.isDate
	    * @param {Object} val The value to test
	    * @returns {Boolean} True if value is a Date, otherwise false
	      */
	
		function isDate(val) {
			return toStringTag(val) === $dte_strTag;
		}
	
		/**
	    * Returns a string describing the given object type/prototype (e.g. "[object Array]", "[object HTMLElement]" etc.)
	    * Note that passing a primitive value to this function is effectively the same as converting
	    * the given value to a string.
	    *
	    * @name fitt.toStringTag
	    * @function
	    * @public
	    * @param {Object} n
	    * @return {String}
	   */
	
		function toStringTag(o)
		{
			return $obj_toString.call(o);
		}
	
	
		/**
	    * A error describing issues when a property is configured on an object
	    * improperly
	    *
	    * @name fitt.PropDescErr
	    * @class
	    * @public
	    * @param {String} [msg]
	    * @param {Number} code
	    * @property {Number} number
	    * @property {String} message
	   */
	
		function PropDescErr(code, msg)
		{
			var me = this;
	
			/*
	                  * Allow construction to occur with out a new operator
	                 */
			if (!me || !(me instanceof PropDescErr)) {
				return new PropDescErr(code, msg);
			}
	
			code = cnum(code, 0, 0, NULL, TRUE);
			if (!(code in PropDescErr_ERRS)) {
				code = 0;
			}
	
			me.message = PropDescErr_ERRS[code] + cstr(msg);
			me.number = code;
	
			return me;
		}
	
		/**
	    * An object containing the list of available error codes and their description strings.
	    *
	    * @name fitt.PropDescErr.ERRS
	    * @type {Object}
	    * @constant
	    * @public
	    * @property {String} 0		Invalid target and/or descriptor object
	    * @property {String} 100 	Property configuration failed
	    * @property {String} 200	Invalid call to DataPropDesc constructor
	    * @property {String} 201	DataPropDesc objects cannot have a "get" property
	    * @property {String} 202	DataPropDesc objects cannot have a "set" property,
	    * @property {String} 300	Invalid call to DynPropDesc constructor,
	    * @property {String} 301	DynPropDesc objects cannot have a "writable" property
	    * @property {String} 302	DynPropDesc objects cannot have a "value" property
	   */
	
		PropDescErr_ERRS =
		{
			0: "Invalid target and/or descriptor object",
			100: "Property configuration failed",
			200: "Invalid call to DataPropDesc constructor",
			201: 'DataPropDesc objects cannot have a "get" property',
			202: 'DataPropDesc objects cannot have a "set" property',
			300: 'Invalid call to DynPropDesc constructor',
			301: 'DynPropDesc objects cannot have a "writable" property',
			302: 'DynPropDesc objects cannot have a "value" property' };
	
	
		/* Make the prototype object of the constructor non-writable */
		cprop(PropDescErr, PROTO, PropDescErrProto, FALSE, FALSE, FALSE);
	
		/* Make the prototype constructor property non-configurable and non-writable */
		cprop(PropDescErr[PROTO], CONSTRUCT, PropDescErr, FALSE, FALSE, FALSE);
	
		/* Make the static PropDescErr.ERRS map non-writable and non-configurable */
		cprop(PropDescErr, "ERRS", PropDescErr_ERRS, FALSE, TRUE, FALSE);
	
		/**
	                                                                    * Base class implementation for setting up a descriptor object
	                                                                    * for defining properties
	                                                                    *
	                                                                    * @name fitt.PropDesc
	                                                                    * @public
	                                                                    * @class
	                                                                    * @param {Boolean} [cc=true] Whether or not a property is configurable
	                                                                    * @param {Boolean} [ce=true] Whether or not a property is enumerable
	                                                                    * @property {Boolean} configurable
	                                                                    * @property {Boolean} enumerable
	                                                                    *
	                                                                   */
	
		function PropDesc(cc, ce)
		{
			var me = this;
	
			if (!me || !(me instanceof PropDesc)) {
				return new PropDesc(cc, ce);
			}
	
			/*
	     * if the this pointer already has a configurable or enumerable
	     * property, and no corresponding argument is passed in, then
	     * use the value from that property
	    */
	
			me[CAN_CONF] = cc == NULL ? CAN_CONF in me ? !!me[CAN_CONF] : TRUE : !!cc;
			me[CAN_ENUM] = ce == NULL ? CAN_ENUM in me ? !!me[CAN_ENUM] : TRUE : !!ce;
	
			return me;
		}
	
		cprop(PropDesc, PROTO, PropDesc[PROTO], FALSE, FALSE, FALSE);
		cprop(PropDesc[PROTO], CONSTRUCT, PropDesc, FALSE, FALSE, FALSE);
	
	
		/**
	                                                                    * Class implementation for creating a data descriptor for an object property
	                                                                    *
	                                                                    * @name fitt.DataPropDesc
	                                                                    * @class
	                                                                    * @public
	                                                                    * @param {Boolean} [cw=true] Whether or not a property is writable
	                                                                    * @param {*} [v=null] The value for a given property
	                                                                    * @param {Boolean} [cc=true] Whether or not the property is configurable
	                                                                    * @param {Boolean} [ce=true] Whether or not the property is enumerable
	                                                                    * @extends fitt.PropDesc
	                                                                    * @property {Boolean} configurable
	                                                                    * @property {Boolean} writable
	                                                                    * @property {Boolean} enumerable
	                                                                    * @property {*} value
	                                                                    * @throws {fitt.PropDescErr} if the constructed object has a "get" or "set" property defined (meaning you should be using fitt.DynPropDesc),
	                                                                    *							 or if this function is not called as a constructor (e.g. DataPropDesc(true,0,false,false) will throw
	                                                                    *							 but new DataPropDesc(true,0,false,false) will not).
	                                                                   */
	
		function DataPropDesc(cw, v, cc, ce)
		{
			var me = this;
	
			if (!me || !(me instanceof DataPropDesc)) {
				throw new PropDescErr(200);
			}
	
			if ("get" in me) {
				delete me.get;
	
				if ("get" in me) {
					throw PropDescErr(201);
				}
			}
	
			if ("set" in me) {
				delete me.set;
	
				if ("set" in me) {
					throw PropDescErr(202);
				}
			}
	
			PropDesc.call(me, cc, ce);
	
			me[CAN_WRITE] = cw == NULL ? CAN_WRITE in me ? !!me[CAN_WRITE] : TRUE : !!cw;
			me[VALUE] = v == NULL ? VALUE in me ? me[VALUE] : NULL : v;
	
			return me;
		}
	
		cprop(DataPropDesc, PROTO, new PropDesc(), FALSE, FALSE, FALSE);
		cprop(DataPropDesc[PROTO], CONSTRUCT, DataPropDesc, FALSE, FALSE, FALSE);
	
		/**
	                                                                            * Class implementation for creating a data descriptor for an object property
	                                                                            *
	                                                                            * @name fitt.DynPropDesc
	                                                                            * @class
	                                                                            * @public
	                                                                            * @param {Function} g Getter function for a given property
	                                                                            * @param {Function} [s=null] Setter function for a given propery, pass null or constructing the class with only a single argument results in creating
	                                                                            *							  a read only property
	                                                                            * @param {Boolean} [cc=true] Whether or not the property is configurable
	                                                                            * @param {Boolean} [ce=true] Whether or not the property is enumerable
	                                                                            * @extends fitt.PropDesc
	                                                                            * @property {Function} get
	                                                                            * @property {Function} set
	                                                                            * @property {Boolean} configurable
	                                                                            * @property {Boolean} enumerable
	                                                                            * @throws {fitt.PropDescErr} if the constructed object has a "writable" or "value" property defined (meaning you should be using fitt.DataPropDesc),
	                                                                            *							 or if this function is not called as a constructor (e.g. DynPropDesc(function() { return 0 },null,false,false) will throw
	                                                                            *							 but new DynPropDesc(function() { return 0 },null,false,false) will not).
	                                                                           */
	
		function DynPropDesc(g, s, cc, ce)
		{
			var me = this;
	
			if (!me || !(me instanceof DynPropDesc)) {
				throw PropDescErr(300);
			}
	
			if (CAN_WRITE in me) {
				delete me[CAN_WRITE];
	
				if (CAN_WRITE in me) {
					throw new PropDescErr(301);
				}
			}
	
			if (VALUE in me) {
				delete me[VALUE];
	
				if (VALUE in me) {
					throw new PropDescErr(302);
				}
			}
	
			PropDesc.call(me, cc, ce);
	
			me.get = g == NULL ? noop : g;
			me.set = s == NULL ? noop : s;
	
			return me;
		}
	
		cprop(DynPropDesc, PROTO, new PropDesc(), FALSE, FALSE, FALSE);
		cprop(DynPropDesc[PROTO], CONSTRUCT, DynPropDesc, FALSE, FALSE, FALSE);
	
	
		/**
	                                                                          * Construct and object descriptor for defining how a call to mix will behave. Rather than passing {@link fitt.mix} multiple arguments
	                                                                          * for said options you can alternatively pass just this object.
	                                                                          *
	                                                                          * @name fitt.MixOptions
	                                                                          * @class
	                                                                          * @public
	                                                                          * @param {Boolean} [owned=false] Force only copying 'owned' properties from the given supplier.
	                                                                          * @param {Boolean} [sourceArrayAsSingle=false] If you pass an array to mix, use it as single source, copying each index into your receiver object when this is set to true.
	                                                                          *                                              Otherwise it behaves similar to Object.assign, if you pass an array as the source it will treat each item in the array as it's own source.
	                                                                          * @param {Boolean} [skipFuncs=false] If true, don't mix in properties that are functions.
	                                                                          * @param {Boolean} [noRecurse=false] If true, do not recurse down into objects, simply treat them as primitive values.
	                                                                          * @param {Boolean|Number} [noOverwrite=false] If true, and if the receiver already has a property of the given name, do not set it's value to that of what's in the supplier.
	                                                                          * 											   If set to 2, then same logic applies but if the given property in the receiver is an object, allow recursive mixin from the supplier
	                                                                          *											   to occur (in other words allows further annotation of an exising object).
	                                                                         	 * @param {Boolean} [defProps=false] If true, add the property to the receiver object using Object.defineProperty rather than just doing an implicit define of the property via
	                                                                          *                                  a set.  This will be slightly slower, but will allow you to add own properties to objects that have a frozen proto object.
	                                                                         	 * @param {Object|Boolean} [altKeys=null]  If argument is true, then we will iterate over the properties in the receiver object, and copy values from the source object.
	                                                                          *												    If argument is an object, then only properties from this object will be used it copy values (think of it like a filter object).
	                                                                          *													In either case, if there is recursion (which is the default), the same list of properties are copied throughout each level of recursion
	                                                                          * @property {Boolean} owned See 'owned' parameter above
	                                                                          * @property {Boolean|Number} noOvr See 'noOverwrite' parameter above
	                                                                          * @property {Boolean} defProp See 'defProps' parameter above
	                                                                          * @property {Boolean} snglSrc See 'sourceArrayAsSingle' parameter above
	                                                                          * @property {Boolean} skipFuncs See 'skipFuncs' parameter above
	                                                                          * @property {Boolean} noRecurse See 'noRecurse' parameter above
	                                                                          *
	                                                                            */
	
	
	
	
		function MixOptions(owned, sourceArrayAsSingle, skipFuncs, noRecurse, noOvr, defProps, altKeys)
		{
			var me = this;
	
			me.owned = !!owned;
			me.noOvr = noOvr;
			me.defProp = !!defProps;
			me.snglSrc = !!sourceArrayAsSingle;
			me.skipFuncs = !!skipFuncs;
			me.noRecurse = !!noRecurse;
		}
	
		/**
	    * Safely convert any value to a string, and error caught/failure results
	    * to convert results in an empty string being returned.
	    *
	    * Arrays are converted to a string via the join method with NO DELIMITER
	    * (making life easier for using arrays as templates / buffers for output).
	    * Passing a 2nd argument as a truthy value will forcibly treat that input
	    * argument as an array object and call Array.prototype.join using that object
	    * as the 'this' pointer
	    *
	    * Note that false is converted to '', but true is converted to 'true', and 0 is converted to '0'.
	    *
	    * The main use case is to ensure that you always are dealing with a string primitive
	    * and non numeric falsy values such as false, undefined, and null are converted to the
	    * falsy string equivalent ('');
	    *
	    * @name fitt.cstr
	    * @function
	    * @public
	    * @param {*} s, any value / ref to a value to be converted into a primitive string
	    * @param {Boolean} [al=false] If true, automatically treat the 1st argument as an array and join it together into a string
	    * @return {String} empty string is returned on failure.
	    *
	   */
	
		function cstr(s, al)
		{
			var typ = typeof s;
	
			if (al && s) {
				return $ary_join.call(s, "") || "";
			}
	
			if (typ == TYPE_STR) return s;
			if (typ == TYPE_NUM) {
				/*
	                         	NaN check without calling function if number is not < 0 and not > 0
	                         	and does not eq 0 it must be NaN so default
	                        */
				if (s === 0) return "0";
				if (isNaN(s)) return "0";
	
				return s + "";
			}
	
			if (typ == TYPE_OBJ && s && typeof s.join == TYPE_FUNC) {
				return s.join("");
			}
	
			if (!s) return "";
	
			try {
				s = str(s);
			} catch (e) {
				s = "";
			}
			return s;
		}
	
		/**
	    * Get an ordinal value of a number
	    * (e.g. 1 -> 1st, 2 -> 2nd etc.)
	    *
	    * Note that if the 1st parameter passed in does not convert into a positive
	    * integer, an empty string is returned.
	    *
	    * @name fitt.ord
	    * @function
	    * @public
	    * @param {String|Number|Object} val Represents a numeric value to be converted into an ordinal string
	    * @param {Boolean} [isnum=false] Pass true to speed thing up a tiny bit avoiding the forced numeric conversion
	    *                                of the incoming value
	    * @return {String}
	      */
	
		function ord(val, isnum) {
			var n = isnum ? val : cnum(val, 0, 0),
			s = '',
			ret = '',
			j,k;
	
			if (n > 0) {
				n = Math.round(n);
				j = n % 10;
				k = n % 100;
				if (j === 1 && k !== 11) {
					s = 'st';
				} else if (j === 2 && k !== 12) {
					s = 'nd';
				} else if (j === 3 && k !== 13) {
					s = 'rd';
				} else {
					s = 'th';
				}
				ret = n + s;
			}
			return ret;
		}
	
		/**
	    * Convert a given string (or 1stly convert a given parameter into a string), and then
	    * to it's lower case form.  Wrapper for String.prototype.toLowerCase();
	    *
	    * @name fitt.strlc
	    * @function
	    * @public
	    * @param {*} s Any value / reference to a value
	    * @param {Boolean} [ist=false] Set to true if you are sure that the 1st argument is already a string, and conversion is skipped.
	    * @return {String}
	   */
	
		function strlc(s, ist)
		{
			s = ist ? s : cstr(s);
			return s.toLowerCase();
		}
	
		/**
	    * Convert a given string (or 1stly convert a given parameter into a string), and then
	    * to it's upper case form.  Wrapper for String.prototype.toUpperCase();
	    *
	    * @name fitt.struc
	    * @function
	    * @public
	    * @param {*} s Any value / reference to a value
	    * @param {Boolean} [ist=false] Set to true if you are sure that the 1st argument is already a string, and conversion is skipped.
	    * @return {String}
	   */
	
		function struc(s, ist)
		{
			s = ist ? s : cstr(s);
			return s.toUpperCase();
		}
	
	
		/**
	    * Do a regular expression / string replacement on the given input which generally is a string
	    * but this function allows you to pass in any object which will then be converted to a string.
	    * Wrapper for String.prototype.replace
	    *
	    * @name fitt.strReplace
	    * @function
	    * @public
	    * @param {*} s Any value which will be converted into a string if not already.
	    * @param {RegExp} ex The regular expression to use for replacing content.  Can also be a string or number but note that you must be careful
	    * 					  as such values are then automatically converted into a RegExp object which can lead to unexpected results.
	    * @param {String} r  The string to replace within the current string
	    * @param {Boolean} [ist=false] Pass true if you are sure the 1st argument is of string type, and this method will skip doing the auto conversion to string type (performance boost).
	    * @param {Boolean} [rist=false] Pass true if you are sure the 3rd argument is of string type, and this method will skip doing the auto conversion to string type (performance boost).
	    * @return {String}
	    *
	   */
	
		function strReplace(s, ex, r, ist, rist)
		{
			s = ist ? s : cstr(s);
			r = rist ? r : cstr(r);
			return s.replace(ex, r);
		}
	
		/**
	    * Do a regular expression match on a string (wrapper for String.prototype.match),
	    * but this function allows you to pass in any object which is then converted to a string.
	    *
	    * @name fitt.strMatch
	    * @function
	    * @public
	    * @param {*} str Any value which will automatically be converted to a string if needed (auto conversion can be disabled by the 4th optional argument).
	    * @param {RegExp} The regular expression object to use for match execution.
	    * @param {Number} [idx=null] If specified the return value of this function will return the the item returned from a successful match at the given index.
	    * @param {Boolean} [its=false] Force treating the 1st argument as a string and do not attempt auto conversion (slight performance boost).
	    * @return {Array|null|String} If no idx argument is specified returns the Array like match object or null on failure.  If an idx argument is specified
	    *							   returns the item at the given index in the Array like match object or null if nothing found.
	    *
	   */
	
		function strMatch(str, regEx, idx, its)
		{
			var m;
	
			str = its ? str : cstr(str);
			m = str && str.match(regEx);
	
			return idx == NULL ? m || NULL : m && m[idx] || NULL;
		}
	
		/**
	    * Wrapper for RegExp.prototype.test, returning a boolean true if the
	    * given regular expression matches something in the given string
	    *
	    * @name fitt.regxTest
	    * @public
	    * @param {RegExp} r A regular expression
	    * @param {String} s A string
	    * @param {Boolean} [rts=false] If true, first argument is guaranteed to be a RegExp instance (small run time speed improvement)
	    * @param {Boolean} [sts=false] If true, 2nd argument is guaranteed to be a string (small run time speed improvement)
	    * @return {Boolean}
	   */
	
		function regxTest(r, s, rts, sts)
		{
			s = sts ? s : cstr(s);
			r = rts ? r : r && isRegX(r) ? r : NULL;
			return s && r ? $regx_test.call(r, s) : FALSE;
		}
	
	
		/**
	    * Wrapper for String.prototype.search, returning a boolean true if the
	    * given regular expression matches something in the given string
	    *
	    * @name fitt.regxSearch
	    * @public
	    * @param {RegExp} r A regular expression
	    * @param {String} s A string
	    * @param {Boolean} [rts=false] If true, first argument is guaranteed to be a RegExp instance (small run time speed improvement)
	    * @param {Boolean} [sts=false] If true, 2nd argument is guaranteed to be a string (small run time speed improvement)
	    * @return {Number} returns -1 if nothing found
	   */
	
		function regxSearch(r, s, rts, sts)
		{
			s = sts ? s : cstr(s);
			r = rts ? r : r && isRegX(r) ? r : NULL;
			return s && r ? s.search(r) : -1;
		}
	
		/**
	    * Safely convert a value into a primitive number type, as well as allowing you to specify a range of values
	    * the given number value should fall within.  If the value results in a NaN value or does not fall in the specified
	    * ranges, you may also specify a default value to be returned.
	    *
	    * @name fitt.cnum
	    * @function
	    * @public
	    * @param {*} val Any value to be converted to a number.  Objects will automatically call their valueOf or [Symbol.toPrimitive] functions
	    * @param {*} [defVal=null] If specified, this value will be returned when the 1st argument cannot be converted to a valid number or if it does not fall within the given min max ranges.
	    * @param {Number} [minVal=Number.MIN_VALUE] If specified the mininum value the number should be.  The default minimum value is equivalent to the Number.MIN_VALUE constant which
	    * 											 is approx (-9007199254740992).
	    * @param {Number} [maxVal=Number.MAX_VALUE] If specified the maximum value the number should be.  The default maximum value is equivalent to the Number.MAX_VALUE constant which
	    * 											 is approx (9007199254740992).
	    * @param {Boolean} [ts=false] Do not wrap the attempted numeric value conversion in a try/catch block (small performance boost on some platforms).
	    * @return {Number|*}
	   */
	
		function cnum(val, defVal, minVal, maxVal, ts)
		{
			var v = val;
	
			if (typeof val != TYPE_NUM) {
				if (ts) {
					v = num(val);
	
					if (isNaN(v)) {
						v = parseFloat(val);
					}
				} else {
					try {
						v = num(val);
	
						if (isNaN(v)) {
							v = parseFloat(val);
						}
					} catch (e) {
						v = NAN;
					}
				}
			}
	
			/* Yes we use == here on purpose, as == NULL works for
	     * both null and undefined values
	    */
			if (maxVal == NULL) maxVal = NUM_MAX;
			if (minVal == NULL) minVal = NUM_MIN;
	
			return (isNaN(v) || v < minVal || v > maxVal) && defVal != NULL ? defVal : v;
		}
	
		/**
	    * Convert a value into a boolean, parsing certain common strings to be treated as true/false
	    * The value is converted to a string if it is an object.
	    * Values of "0", "false", "undefined", "null", "no" are all converted to false (normally these would evaluate to true since they are strings with some chars).
	    *
	    * @name fitt.cbool
	    * @function
	    * @public
	    * @param {*} Any value to convert
	    * @return {Boolean}
	    *
	   */
	
		function cbool(v)
		{
			var tmp = v,typ = typeof tmp;
	
			if (tmp && typ == TYPE_OBJ) {
				tmp = strlc(tmp);
				typ = TYPE_STR;
			}
	
			if (typ == TYPE_STR && tmp === "0" || tmp === "false" || tmp === "no" || tmp === TYPE_UNDEF || tmp === "null") return FALSE;
	
			return !!tmp;
		}
	
		/**
	    * Create an object, optionally with a specified prototype and set of properties.
	    * Essentially a wrapper for Object.create, with 1 difference that the default prototype
	    * of this call is null rather than Object.prototype unless you specify some other object.
	    *
	    * @name fitt.cobj
	    * @function
	    * @public
	    * @param {Object|Function} [p=null] The prototype of the object to created if desired.
	    * @param {Object} [d=null] A nested descriptor object, with each key representing the name of a property and each value being an object descriptor
	    *							for how the property should be configured.
	    * @return {Object}
	    *
	   */
	
		/*
	       * functions which are dynamically generated should still first be defined
	       * inline using a named function declartion, and then re-assigned
	      */
	
		/**@ignore */
		function cobj(p, d) {}
	
		cobj = function () {
	
			var fc, f, b;
	
			if (ECMAScript5) {
				fc = func("c", cstr([RETURN, "(", TYPE_FUNC, " cobj(p, d) { p = p || null; ", RETURN, " (arguments.length > 1) ? c(p, d) : c(p); });"]));
				f = fc(obj_create);
			} else {
				b =
				[
				TYPE_FUNC, " cobj(p, d) {\n",
				"	var f = ", TYPE_FUNC, "(){}, o;\n",
				"	p = p || null;\n",
				"	f.", PROTO, " = p;\n",
				"	o = new f();\n",
				"	if (d) {\n",
				"		cp(o,d);\n",
				"	}\n",
				"	", RETURN, " o;\n",
				"};\n",
				"return cobj;"];
	
				fc = func("cp", cstr(b));
				f = fc(cprops);
			}
	
			return f;
	
		}();
	
		/**
	       * Attempt to convert array-like objects such as regular expression matches, arguments objects, node lists, and so
	       * on into a formal JavaScript array object.
	       * Defaults to returning an empty array object if a null/undefined input object is passed in or
	       * if the given object cannot be converted into an array.
	       * Strings are split into an array by each character in the string.
	       *
	       * @name fitt.cary
	       * @function
	       * @public
	       * @param {*} [o=null] The array like object to use to convert into a formal array.  Pass no arguments, or null to create
	       * @param {Number} [n=null] The size of the array to be created, if not used the array's size is determined by the number of items in the given input object
	       * @return {Array}
	      */
	
		function cary(o, n)
		{
			var ret = [],otyp,did_ap,len = 0,idx;
	
			if (o) {
				try {
					otyp = typeof o;
	
					/* ignore functions, window objects, or node objects */
					if (otyp == TYPE_FUNC || o.top == top || o.nodeType || o.tagName) {
						if (n > 0) {
							ret = new ary(n);
						}
						return ret;
					}
	
					/* if it's a string, split it to a char array */
					if (otyp == TYPE_STR) {
						ret = o.split("");
						if (n > 0 && ret.length >= n) {
							ret = ret.slice(n);
						}
						return ret;
					}
	
					/* if it's a non-object return empty array */
					if (otyp != TYPE_OBJ) return ret;
	
					len = cnum(o.length, NEG_ONE, NULL, NULL, TRUE);
				} catch (e) {
					/* if a failure checking the args just beat it */
					if (n > 0) {
						ret = new ary(n);
					}
					return ret;
				}
	
				if (len > 0) {
					/* if it's really an Array, just make a new array from the orignal
	                    note we use the constructor prop, rather than doing an instanceof
	                    b/c we don't want to call Array.prototype.concat on sub-classes of Array
	                    since that can produce very odd results.
	                 */
	
					if (isAry(o)) {
						ret = ret.concat(o);
						did_ap = ret.length === len; /* but make sure to check you get the length you expect */
					}
	
					if (!did_ap) {
						try {
							ret = $ary_slice.call(o);
							did_ap = ret.length === len;
						} catch (e) {
							did_ap = FALSE;
							ret = [];
						}
					}
	
					if (!did_ap) {
						/*
	                   * array apply or concat couldn't be called (say it's old IE and you have a Dom Node List)
	                   * so just brute force loop
	                  */
						ret = new ary(len);
						for (idx = 0; idx < len; idx++) {
							ret[idx] = o[idx];
						}
					}
				} else if (o && "0" in o) {
					for (idx in o)
					{
						idx = cnum(idx, -1, 0, NULL, NULL, TRUE);
						if (idx >= 0) {
							ret[idx] = o[idx];
						}
					}
				}
	
				if (n > 0 && ret.length >= n) {
					ret = ret.slice(n);
				}
			}
			return ret;
		}
	
		/**
	    * Ensures that a given function is still valid by checking the global object/realm from
	    * which the function reference was created.  If that global / realm no longer exists
	    * than the function is no longer valid / truly callable in a safe way.  Especially
	    * useful in cases where you have a function handle from an IFrame or shared worker,
	    * where that context/global/realm can be dynamically removed.
	    *
	    * @name fitt.canCall
	    * @function
	    * @public
	    * @param {Function} f A function reference
	    * @return {Boolean}
	    *
	   */
	
		function canCall(f)
		{
			var isOK = FALSE,
			o;
	
			try {
				if (f && typeof f == TYPE_FUNC) {
					if (f instanceof func) {
						isOK = TRUE;
					} else {
						o = f.toString();
						if (o) {
							o = f[CONSTRUCT]("return window || global;");
							isOK = !!(o && (o.top || o.global));
						}
					}
				}
			} catch (e) {
				isOK = FALSE;
			}
	
			o = f = NULL;
			return isOK;
		}
	
		/**
	   * Similar to native JavaScript call/apply functions except that it first
	   * checks to make sure that the function reference is still valid and
	   * that it wraps the call to said function in a try / catch block
	   *
	   * If an error is caught by default it is swallowed, allowing your
	   * program to continue.  To retrieve information about said error
	   * pass in a info object as the 3rd argument.
	   *
	   * @name fitt.callSafe
	   * @function
	   * @param {Function} f A reference to a function to be called
	   * @param {Object} [thisPointer] An object to be used as the this pointer for the function call. Must be a native JS object
	   * @param {Object} [info] Pass in an empty object to be used an output parameter for discovering information about the function call. This object will contain at least 2 properties "time" which is the number
	   *                        of milliseconds that the function took and "err" which is the error object that was caught if any
	   * @param {...Mixed} func_args Any additional arguments will be passed directly to said function. Note that passing in only one extra argument that is an array, that array will be treated as the argument list
	   *
	   * @return return value of the function called
	   *
	   */
	
		function callSafe(f, thisPointer, info /* additional args */)
		{
			var ret,err,args = arguments,arg_cnt = args.length,idx = 3,new_arg_list = [],start = 0,end = 0;
	
			if (canCall(f)) {
				if (arg_cnt > idx) new_arg_list = cary(args, idx);
	
				thisPointer = thisPointer || NULL;
	
				if (info) {
					start = new dte();
					try {
						ret = f.apply(thisPointer, new_arg_list);
					} catch (e) {
						err = e;
					}
					end = new dte();
				} else {
					/* if no info object is provided then there is no reason to construct
	            * date objects
	           */
					try {
						ret = f.apply(thisPointer, new_arg_list);
					} catch (e) {
						err = e;
					}
				}
			} else {
				err = new Error("bad ref");
				err[TYPE_NUM] = -2147418113;
			}
	
			if (info) {
				try {
					info.time = end - start;
					info.err = err || NULL;
				} catch (e) {}
			}
	
			return ret;
		}
	
	
		/**
	    * Define/redefine a property on a given object, handling edge cases for IE 8,
	    * and returning a boolean indicating whether or not the property was defined
	    * on the object properly.
	    *
	    * Automatically checks the object's current properties to ensure configuration
	    * can occur and creates the descriptor object for you.
	    *
	    * Effectively this is an alias for Object.defineProperty with fallback logic
	    * in case ECMAScript 5 is not supported.
	    *
	    * @name fitt.cprop
	    * @function
	    * @public
	    * @param {Object|Function} o The object on which to configure/re-configure a property
	    * @param {String} pn The property name
	    * @param {*} [v=null] The value of the property to be used if the given property is to be setup as a static property (as in no getter / setter)
	    * @param {Boolean} [cr=true] Whether or not the given property should be re-configurable or deletable
	    * @param {Boolean} [ce=true] Whether or not the given should be enumerable (shows up in for/in loops, or Object.keys).
	    * @param {Boolean} [cw=null] Whether or not the given property is writable, assuming it is a static property (use null if the property has getters/setters)
	    * @param {Function} [cg=null] A function used as a getter to retrieve the property value, use null for static/data properties
	    * @param {Function} [cs=null] A function used as a setter to set the value of the property on the object.
	    * @param {Boolean} [nfbk=false] If true, and property configuration fails, do not attempt a simple set of an own property. By default, this function
	    * 								 will do that for fallback cases of non-ECMAScript 5 compliance (like say IE7), which will both set and create a property
	    * @return {Boolean} true if the property was configured with your settings
	   */
	
		function cprop(o, pn, v, cr, ce, cw, cg, cs, nfbk)
		{
			var didIt = FALSE,
			sentGetter = FALSE,
			sentSetter = FALSE,
			objType = o && typeof o || "",
			getFunc,setFunc,desc,newDesc,tempFunc;
	
			if (cg && canCall(cg)) {
				sentGetter = TRUE;
				getFunc = cg;
			} else {
				tempFunc = func("v", cstr([RETURN, " (", TYPE_FUNC, "() { ", RETURN, " v; }); "]));
				getFunc = tempFunc(v);
				tempFunc = NULL;
			}
	
			if (cs && canCall(cs)) {
				sentSetter = TRUE;
				setFunc = cs;
			} else {
				setFunc = noop;
			}
	
			if (sentSetter && !sentGetter) getFunc = noop;
	
			if (obj_cprop && (objType == TYPE_OBJ || objType == TYPE_FUNC)) {
				/*
	                                                                    * IE 8 doesn't like you to use writable in some cases
	                                                                    * so just automatically use getter/setter mode
	                                                                    * above we have automatically created a getter / setter
	                                                                    * for the given value if needed
	                                                                    *
	                                                                    * IE 8 has no Object.create method
	                                                                   */
	
				if (sentGetter || sentSetter || !ECMAScript5) {
					newDesc = new DynPropDesc(getFunc, setFunc, cr, ce);
				} else {
					newDesc = new DataPropDesc(cw, v, cr, ce);
				}
	
				/*
	      * IE 8 doesn't like configurable or enumerable to be set
	      * IE 8 doesn't have Object.create method
	     */
	
				if (!ECMAScript5) {
					newDesc[CAN_CONF] =
					newDesc[CAN_ENUM] = TRUE;
				}
			}
	
			if (obj_gprop) {
				desc = obj_gprop(o, pn);
			}
	
			if (obj_cprop) {
				if (!desc) {
					obj_cprop(o, pn, newDesc);
					didIt = TRUE;
				} else if (!desc[CAN_CONF] && desc[CAN_WRITE]) {
					/* even if something is not configurable, if it's writeable, you're still
	                                                    * allowed to lock / change writeable down to false
	                                                   */
	
					newDesc[CAN_CONF] = desc[CAN_CONF];
					newDesc[CAN_ENUM] = desc[CAN_ENUM];
	
					if (newDesc.get) delete newDesc.get;
					if (newDesc.set) delete newDesc.set;
	
					if (!(CAN_WRITE in newDesc)) {
						newDesc[CAN_WRITE] = setFunc == noop ? FALSE : !!cw;
					}
	
					if (!(VALUE in newDesc)) {
						newDesc[VALUE] = v;
					}
	
					obj_cprop(o, pn, newDesc);
	
					didIt = TRUE;
	
				} else {
					try {
						obj_cprop(o, pn, newDesc);
						didIt = TRUE;
					} catch (e) {
						didIt = FALSE;
					}
				}
			}
	
			if (didIt) {
				try {
					didIt = o[pn] === v;
				} catch (e) {
					didIt = FALSE;
				}
			}
	
			try {
				if (didIt === FALSE && o[DEF_GET]) {
					o[DEF_GET](pn, getFunc);
					o[DEF_SET](pn, setFunc);
					didIt = o[pn] === v;
				}
			} catch (e) {
				didIt = FALSE;
			}
	
			if (!nfbk && !didIt) {
				try {
					o[pn] = v;
					didIt = o[pn] === v;
				} catch (e) {
					didIt = FALSE;
				}
			}
	
			return didIt;
		}
	
		/**
	    * Private method called by {@link fitt.inherits} that tags each function
	    * so that we can tell what methods were part of a 'class' at the time of inheritance
	    *
	    * @name fitt-inherits_forEachClassMethod
	    * @function
	    * @private
	    * @param {*} func The property value on a function prototype
	    * @param {String} name The name of the property on that prototype
	    *
	   */
	
		function inherits_forEachClassMethod(func, name)
		{
			if (typeof func === TYPE_FUNC && !owns(func, '_methodName')) {
				func._methodName = name;
			}
		}
	
	
		/**
	    * Private getter function used to retrieve the 'super' version of a calling function / method on
	    * an object.  Note that this does indeed rely on Function.prototype.caller, b/c it's ES5
	    * but until we can use ES6 classes in browsers directly, this is the only way.
	    * (It does however make that call safely)
	    *
	    * @name fitt-inherits_getSuper
	    * @function
	    * @private
	    * @return {Function}
	    * @throws {Error} if the target is not an object or if the given caller cannot be found.
	   */
	
		function inherits_getSuper(funcToFind)
		{
			var me = this,
			name = funcToFind && funcToFind._methodName,
			foundCaller = false,
			proto = me,
			impl;
	
			if (!isObjLike(me)) {throw new err('invalid target object');}
	
			if (name) {
				while ((proto = obj_getProto(proto)) && !impl) {
					if (!proto[name]) {
						break; // no implementation here
					} else if (proto[name] === funcToFind) {
						foundCaller = true; // found the function we are calling from
					} else if (foundCaller) {
						impl = proto[name]; // we've already passed our calling function in the chain, so we must be at correct implementation
					}
				}
			}
	
			if (!impl) {throw new err('super implementation not found');}
	
			return function () {
				return impl.apply(me, arguments);
			};
		}
	
		/**
	    * Inherit the prototype methods from one constructor into another.
	    *
	    * @name fitt.inherits
	    * @function
	    * @param  {Function} C Child constructor
	    * @param  {Function} P Parent constructor
	    *
	    */
		function inherits(C, P) {
	
			var CProto = C[PROTO] = mix(cobj(P[PROTO]), C[PROTO]);
	
			C.parent = P[PROTO];
	
			/** @override */
			CProto[CONSTRUCT] = C;
	
			forEach(CProto, inherits_forEachClassMethod);
	
			// Define a special `super` property that locates the super implementation of the caller
	
			cprop(CProto, 'super', inherits_getSuper, FALSE, FALSE, FALSE, NULL, NULL, TRUE);
	
		};
	
		/**
	     * Performs equality by iterating through keys on an object and returning false
	     * when any key has values which are not strictly equal between the arguments.
	     * Returns true when the values of all keys are strictly equal.
	     *
	     * @name fitt.shallowEq
	     * @function
	     * @public
	     * @param {Object} A The first object
	     * @param {Object} B The second object
	     * @return {Boolean} true when the values of all keys are strictly equal
	     */
	
		function shallowEq(A, B) {
			var i, keysA, keysB, typeA, typeB, keysALen, valA, valB, key;
	
			if (A === B) {
				return TRUE;
			}
	
			typeA = typeof A;
			typeB = typeof B;
	
			if (typeA !== typeB || A === NULL || B === NULL) {
				return FALSE;
			}
	
			if (
			typeA === TYPE_NUM && typeB === TYPE_NUM &&
			A !== A && B !== B)
			{
				return TRUE;
			}
	
			keysA = keys(A);
			keysB = keys(B);
	
			keysALen = keysA.length;
	
			if (keysALen !== keysB.length) {
				return FALSE;
			}
	
			for (i = 0; i < keysALen; i++) {
				key = keysA[i];
				valA = A[key];
				valB = B[key];
	
				if (
				!owns(B, key) ||
				!(valA === valB ||
	
				typeof valA === TYPE_NUM && typeof valB === TYPE_NUM &&
				valA !== valA && valB !== valB))
	
	
				{
					return FALSE;
				}
			}
	
			return TRUE;
		};
	
		/**
	     * Define multiple properties on an object at once.  Effectively an alias for Object.defineProperties,
	     * but will fallback in situations where ECMAScript 5 features are not available.
	     *
	     * See {@link fitt.cprop}
	     *
	     * @name fitt.cprops
	     * @function
	     * @public
	     * @param {Object|Function} o An object on which to define properties
	     * @param {Object} d A descriptor object with string keys one for each property to be configured,
	     * 					 where the string key is used as the property name and the value is also an object
	     *					 which is a descriptor for how the property should be configured.
	     * @param {Boolean} [noerr=false] Pass true to continue configuring properties if one given property fails to configure rather than throwing an error
	     *
	     * @throws {PropDescErr} if one of the given property names in the descriptor cannot be configured, or if no properties are found in the descriptor object
	    */
	
		function cprops(o, d, noerr)
		{
			var propNames,propName,propDesc,idx = 0,cnt;
	
			if (!isObjLike(o) || !isObj(d) || empty(d)) {
				throw PropDescErr();
			}
	
			propNames = keys(d);
			cnt = propNames && propNames.length || 0;
	
			for (; idx < cnt; idx++) {
				propName = propNames[idx];
				propDesc = o[propName];
	
				if (!cprop(o, propName, NULL, propDesc[CAN_CONF], propDesc[CAN_ENUM], propDesc[CAN_WRITE], propDesc.get, propDesc.set)) {
	
					if (noerr) continue;
	
					throw PropDescErr(100);
				}
			}
		}
	
		/**
	   * Iterate over an Array or an Object invoking a function for each item.
	   *
	   * If `obj` is an Array callback will be called passing
	   * the value, index, and complete array for each item.
	   *
	   * If 'obj' is an Object callback will be called passing
	   * the value, key, and complete object for each property.
	   *
	   * @name fitt.forEach
	   * @function
	   * @static
	   * @public
	   * @param {Object|Array} obj The object to iterate
	   * @param {Function} fn The callback to invoke for each item
	   */
	
		function forEach(obj, fn)
		{
			var isLikeAry = FALSE,
			idx = 0,
			len = 0,
			objKeys,prop;
	
			// Don't bother if no value provided
			if (!isObjLike(obj)) {
				fn = obj = NULL;
				return;
			}
	
			isLikeAry = isAryLike(obj);
	
			// Force an array if not already something iterable
			if (!isObj(obj) && !isLikeAry) {
				isLikeAry = TRUE;
				obj = [obj];
			}
	
			if (isLikeAry) {
				if ($ary_forEach) {
					$ary_forEach.call(obj, fn);
				} else {
					// Iterate over array values
					for (len = obj.length; idx < len; idx++) {
						fn(obj[idx], idx, obj);
					}
				}
			} else {
				objKeys = keys(obj);
				len = objKeys && objKeys.length || 0;
				/* we can't use a while loop dense assignment loop
	                                          * construct b/c it is possible to get a key that's an empty
	                                          * string
	                                         */
				for (idx = 0; idx < len; idx++) {
					prop = objKeys[idx];
					fn(obj[prop], prop, obj);
				}
			}
	
			obj = fn = NULL;
		}
	
		/**
	    * A helper function for running the logic for mixing properties of objects.
	    * Completely private, called when {@link fitt.mix} is called while iterating over objects
	    *
	    * @name fitt-mix_loopLogic
	    * @function
	    * @private
	    * @param {Object} r The object to mix properties into (receiver object).
	    * @param {Object} s The object which supplies the values (and property names) for the r parameter.
	    * @param {Object} u Alternate filter object, which if specified is used to determine the property names that will be added to the r parameter.
	    *					 Not used directly in this function, but passed back to the iteration function
	    * @param {String} p The property name being added to the r parameter (receiver object).
	    * @param {Boolean} [wantsMerge=false] If the receiver object already has a property of the given name and it's an object, do not overwrite the object
	    *									   value said receiver object, but instead, copy/mixin properties into that object.  Requires recursion be on as well
	    *									   (noRecurse=false which is the default).
	    * @param {Boolean} [skipFuncs=false] Do not add properties to the object which are functions
	    * @param {Boolean|Number} [noOverwrite=false] If true, and if the receiver already has a property of the given name, do not set it's value to that of what's in the supplier.
	    * 											   If set to 2, then same logic applies but if the given property in the receiver is an object, allow recursive mixin from the supplier
	    *											   to occur (in other words allows further annotation of an exising object).
	    * @param {Boolean} [noRecurse=false] If true, do not recurse down into objects, simply treat them as primitive values.
	    * @param {Function} recFunc The iteration function to call after the copy/add of a given property into the receiver is complete.
	    * @param {Boolean} [defprop=false] If true, add the property to the receiver object using Object.defineProperty rather than just doing an implicit define of the property via
	    *                                  a set.  This will be slightly slower, but will allow you to add own properties to objects that have a frozen proto object.
	    * @return {Object} The r parameter is returned after mix completion.
	   */
	
	
		function mix_loopLogic(r, s, u, p, wantsMerge, skipFuncs, noOverwrite, noRecurse, recFunc, defprop, usingAltKeys, keepArrays)
		{
			"use strict";
			var has_prop, shas_prop, item, typ, objTyp, cont, rpropType, subItem, newItem, o;
	
	
			item = s[p];
			typ = typeof item;
			objTyp = typ === TYPE_OBJ;
	
			if (skipFuncs && typ === TYPE_FUNC) return;
	
			has_prop = p in r;
			shas_prop = p in s;
			rpropType = has_prop ? typeof r[p] : TYPE_UNDEF;
	
			/*
	                                                    * noOverwrite 2 means that we don't overwrite the property in the receiving
	                                                    * object itself but we will merge properties from the supplier into
	                                                    * the receiver, so we set the continue flag to true if the receiver
	                                                    * property is an object and user wants merging + recursion
	                                                    * other wise if no_ovr is truthy and receiver has the prop, skip
	                                                   */
	
			if (wantsMerge) {
				cont = !has_prop || rpropType === TYPE_OBJ || rpropType === TYPE_FUNC;
			} else {
				cont = has_prop ? !noOverwrite : TRUE;
			}
	
			if (!cont) return;
			if (!shas_prop && usingAltKeys) return;
	
	
			if (!objTyp) {
				if (defprop) {
					cprop(r, p, item, TRUE, TRUE, TRUE);
				} else {
					r[p] = item;
				}
			} else {
				if (item) {
					if (has_prop) {
						if (noOverwrite) {
							if (wantsMerge) {
								o = r[p];
								if (o && typeof o === TYPE_OBJ) {
									recFunc(o, item, item, skipFuncs, noOverwrite, noRecurse, defprop, usingAltKeys, keepArrays);
								}
								return;
							}
						}
					}
					if (!noRecurse) {
						newItem = keepArrays && isAryLike(item) ? [] : {};
						if (defprop) {
							subItem = recFunc(newItem, item, s, skipFuncs, noOverwrite, noRecurse, defprop, usingAltKeys, keepArrays);
							cprop(r, p, subItem, TRUE, TRUE, TRUE);
						} else {
							r[p] = recFunc(newItem, item, s, skipFuncs, noOverwrite, noRecurse, defprop, usingAltKeys, keepArrays);
						}
					} else {
						if (defprop) {
							cprop(r, p, item, TRUE, TRUE, TRUE);
						} else {
							r[p] = item;
						}
					}
				} else {
					if (defprop) {
						cprop(r, p, item, TRUE, TRUE, TRUE);
					} else {
						r[p] = item;
					}
				}
			}
		}
	
		/*
	    * inner functions, that are called soley as the result of some outer function
	    * (regardless of them being defined inside said outer function, or outside),
	    * should be named using the initial outer function name as a prefix, followed by '_'
	    * and then the function name for that given function.
	    *
	    * So for example, the fitt.mix function is actually function mix
	    *
	    * mix has 3 helper functions, 2 of which do iteration in 2 different ways
	    * depending on the input arguments, and 1 of which is logical operation for
	    * each iteration run.
	    *
	    * So we name each of the helper functions with mix_doSomething, to help identify
	    * the code flow / ownership
	   */
	
		/**
	       * A helper function for iterating over a given object.  In this case {@link fitt.mix} has been
	       * called where the caller wants to only copy 'owned' properties, and so this function optimizes
	       * how the loop is done to improve performance.
	       *
	       * Completely private, called when {@link fitt.mix} is called with a owned parameter of true.
	       *
	       * @name fitt-mix_iterateOwned
	       * @function
	       * @private
	       * @param {Object} r The object to mix properties into (receiver object).
	       * @param {Object} s The object which supplies the values (and property names) for the r parameter.
	       * @param {Object} u Alternate filter object, which if specified is used to determine the property names that will be added to the r parameter.
	       *					 Not used directly in this function, but passed back to the iteration function
	       * @param {Boolean} [wantsMerge=false] If the receiver object already has a property of the given name and it's an object, do not overwrite the object
	       *									   value said receiver object, but instead, copy/mixin properties into that object.  Requires recursion be on as well
	       *									   (noRecurse=false which is the default).
	       * @param {Boolean} [skipFuncs=false] Do not add properties to the object which are functions
	       * @param {Boolean|Number} [noOverwrite=false] If true, and if the receiver already has a property of the given name, do not set it's value to that of what's in the supplier.
	       * 											   If set to 2, then same logic applies but if the given property in the receiver is an object, allow recursive mixin from the supplier
	       *											   to occur (in other words allows further annotation of an exising object).
	       * @param {Boolean} [noRecurse=false] If true, do not recurse down into objects, simply treat them as primitive values.
	       * @param {Boolean} [useDefProp=false] If true, add the property to the receiver object using Object.defineProperty rather than just doing an implicit define of the property via
	       *                                  a set.  This will be slightly slower, but will allow you to add own properties to objects that have a frozen proto object.
	       * @return {Object} The r parameter is returned after mix completion.
	       *
	      */
	
		function mix_iterateOwned(r, s, u, skipFuncs, noOverwrite, noRecurse, useDefProp, usingAltKeys, keepArrays)
		{
			"use strict";
			var wantsMerge = noOverwrite === 2 && !noRecurse,
			idx = 0,
			ps = usingAltKeys ? keys(u) : keys(s),
			keyCnt = ps && ps.length || 0,
			p;
	
			/* you could in theory have a empty string as a key
	      * or some other falsy value so don't use a while + assignment construct
	     */
			for (; idx < keyCnt; idx++) {
				p = ps[idx];
				mix_loopLogic(r, s, u, p, wantsMerge, skipFuncs, noOverwrite, noRecurse, mix_iterateOwned, useDefProp, usingAltKeys, keepArrays);
			}
	
			return r;
		}
	
		/**
	    * A helper function for iterating over a given object.  In this case {@link fitt.mix} has been
	    * called where the caller wants both 'owned' and 'non-owned' (as in those inherited from the prototype chain).
	    * properties, and so this function optimizes how the loop is done to improve performance.
	    *
	    * Completely private, called when {@link fitt.mix} is called with a owned parameter of false.
	    *
	    * @name fitt-mix_iterateNonOwned
	    * @function
	    * @private
	    * @inner
	    * @param {Object} r The object to mix properties into (receiver object).
	    * @param {Object} s The object which supplies the values (and property names) for the r parameter.
	    * @param {Object} u Alternate filter object, which if specified is used to determine the property names that will be added to the r parameter.
	    *					 Not used directly in this function, but passed back to the iteration function
	    * @param {Boolean} [wantsMerge=false] If the receiver object already has a property of the given name and it's an object, do not overwrite the object
	    *									   value said receiver object, but instead, copy/mixin properties into that object.  Requires recursion be on as well
	    *									   (noRecurse=false which is the default).
	    * @param {Boolean} [skipFuncs=false] Do not add properties to the object which are functions
	    * @param {Boolean|Number} [noOverwrite=false] If true, and if the receiver already has a property of the given name, do not set it's value to that of what's in the supplier.
	    * 											   If set to 2, then same logic applies but if the given property in the receiver is an object, allow recursive mixin from the supplier
	    *											   to occur (in other words allows further annotation of an exising object).
	    * @param {Boolean} [noRecurse=false] If true, do not recurse down into objects, simply treat them as primitive values.
	    * @param {Boolean} [useDefProp=false] If true, add the property to the receiver object using Object.defineProperty rather than just doing an implicit define of the property via
	    *                                  a set.  This will be slightly slower, but will allow you to add own properties to objects that have a frozen proto object.
	    * @return {Object} The r parameter is returned after mix completion.
	    *
	   */
	
		function mix_iterateNonOwned(r, s, u, skipFuncs, noOverwrite, noRecurse, useDefProp, usingAltKeys, keepArrays)
		{
			"use strict";
			var wantsMerge = noOverwrite === 2 && !noRecurse,
			p;
	
			u = usingAltKeys ? u : s;
	
			/*
	                             * Loop optimization, yes we can safely not call hasOwnProperty
	                             * (which some jslint/hint engines argue should be required when that's
	                             * not really valid/true in many cases).
	                            */
	
			/*jsl:ignore*/
			for (p in u)
			/*jsl:end*/
			{
				mix_loopLogic(r, s, u, p, wantsMerge, skipFuncs, noOverwrite, noRecurse, mix_iterateNonOwned, useDefProp, usingAltKeys, keepArrays);
			}
	
			return r;
		}
	
		/**
	    * A helper function for mix when dealing with an array of multiple sources rather than a single source
	    *
	    * @param {Object} r The object to mix properties into (receiver object).
	    * @param {Object} s The object which supplies the values (and property names) for the r parameter.
	    * @param {Object} u Alternate filter object, which if specified is used to determine the property names that will be added to the r parameter.
	    *					 Not used directly in this function, but passed back to the iteration function
	    * @param {Boolean} [owned=false] If is a boolean, force only copying 'owned' properties from the given supplier.
	    * @param {Boolean} [skipFuncs=false] Do not add properties to the object which are functions
	    * @param {Boolean|Number} [noOverwrite=false] If true, and if the receiver already has a property of the given name, do not set it's value to that of what's in the supplier.
	    * 											   If set to 2, then same logic applies but if the given property in the receiver is an object, allow recursive mixin from the supplier
	    *											   to occur (in other words allows further annotation of an exising object).
	    * @param {Boolean} [noRecurse=false] If true, do not recurse down into objects, simply treat them as primitive values.
	    * @param {Boolean} [useDefProp=false] If true, add the property to the receiver object using Object.defineProperty rather than just doing an implicit define of the property via
	    *                                  a set.  This will be slightly slower, but will allow you to add own properties to objects that have a frozen proto object.
	    * @return {Object} The r parameter is returned after mix completion.
	   */
	
		function mix_iterateSourceArray(r, s, u, owned, skipFuncs, noOverwrite, noRecurse, useDefProp, usingAltKeys, keepArrays)
		{
			var idx = 0,
			aryCnt = s.length,
			funcToCall = owned ? mix_iterateOwned : mix_iterateNonOwned,
			sitem;
	
			for (; idx < aryCnt; idx++)
			{
				sitem = s[idx];
				funcToCall(r, sitem, usingAltKeys ? u : sitem, skipFuncs, noOverwrite, noRecurse, useDefProp, usingAltKeys, keepArrays);
			}
			return r;
		}
	
		/**
	    * A cloning function. . . set properties in a given object according to their values in another object. Similar to Object.assign,
	    * or JSON.parse(JSON.stringify([object])), except that you pass in custom options for how the mixin occurs.
	    * By default if no r parameter is passed, a generic base object is created automatically.
	    *
	    * Note that if you pass in an EMPTY object, with the right arguments, you must accept the return value as the result
	    * and the r parameter is basically ignored, it's always a good idea just to accept the return result anyway, if
	    * the JSON optimization is not used the behavior is still the same
	    *
	    * Note that this function DOES NOT create properties with the same property descriptor as the source, but rather
	    * creates simple data properties.
	    *
	    * Also note that this function DOES NOT protect against circular references in most cases.  The only exception
	    * to this is if you are copying only owned properties and do not want functions, in which case JSON is used
	    * as an optimization, and most native JSON implementations will throw an error when circular references are detected.
	    *
	    * the various flags/options you can pass in will greatly determine speed.  for example if you are recursing through
	    * an object (on by default), and know you don't care about arrays staying as arrays, don't have/want functions, and
	    * don't care if properties are owned you can speed things up. . .
	    *
	    * Note also that some advanced options can only be set if you use the descriptor format for the 3rd argument,
	    * rather than passing in multiple arguments.
	    *
	    * If you want to pass in multiple sources to be mixed/merged into a given target, simply pass the source/supplier argument
	    * an array of things to be mixed. This is the default behvaior.
	    * @example
	   <pre>
	      var foo = [{x:1,y:2}, {z:3} ],
	          bar = {};
	       bar = fitt.mix(bar, foo); //result is {x:1,y:1,z:3}
	   </pre>
	        * But you can also have the array itself treated as a single source if need be. .
	       *@example
	   <pre>
	      var var foo = [10, 20, 30],
	          bar = {};
	       bar = fitt.mix(bar, foo, {snglSrc:true,skipFuncs:true}); //result is {'0':10,'1':20,'2':30,'length':3}
	   </pre>
	    *
	    * @name fitt.mix
	    * @function
	    * @public
	    * @param {Object} [r=new Object] The object to receive properties and values from another object (receiver object)
	    * @param {Object|Function|Array} s The object from which (supplier/source object) to copy values (and by default the properties).
	    * 							        Note that pasing a function is allowed but it is just treated as if it
	    *							        were an normal object.  If an Array is passed, by default is is assumed that you want each item
	    *                                  in the array to be a source item, mixing all of those items into a single object.  To treat the array
	    *                                  as a single source, see {@link fitt.MixOptions}, and use a descriptor object for options.
	    *
	    * @param {Boolean|Object} [ownedOrOpts=false] If is a boolean, force only copying 'owned' properties from the given supplier. Otherwise you can pass in an
	    *                                             object to define further parameters / options for this function.  See {@link fitt.MixOptions}. Note that
	    *                                             passing an object will ignore further parameters defined below.
	    *
	    *
	    * @param {Boolean} [ownedOrOpts.skipFuncs=false] Same as 4th argument skipFuncs parameter (see below)
	    * @param {Boolean} [ownedOrOpts.owned=false] Use only owned properties, same as pasing 3rd parameter as a boolean true
	    * @param {Boolean|Number} [ownedOrOpts.noOvr=false] When false allow properties to be overwritten, when true (truthy, 1 also accepted), do not allow properties to be overwritten.
	    *                                                   If set to 2, then same logic applies but if the given property in the receiver is an object, allow recursive mixin from the supplier
	    *											         to occur (in other words allows further annotation of an exising object).
	    * @param {Object} [ownedOrOpts.recKeys=null] Only copy these properties from a source into the receiver, see 7th argument below (keysFromReceiver)
	    * @param {Boolean} [ownedOrOpts.defProp=false] Use Object.defineProperty to set properties on the receiver rather than a simple dot / bracket set notation. Useful for some cases where
	    *                                              an object is a proxy or has a getter/setter defined
	    * @param {Boolean} [ownedOrOpts.snglSrc=false] The 2nd argument MUST be an instance of Array, and instead of using it has multiple source objects to be merged, when true, treats
	    *                                              the array as a single source (meaning if your array has 3 items, your receiver object will get properties "0", "1", and "2").
	    * @param {Boolean} [ownedOrOpts.keepArrays=true] Set to false to boost performance, but with the caveat of array-like objects being converted into normal objects as opposed to staying arrays.
	    * @param {Boolean} [skipFuncs=false] Do not add properties to the object which are functions
	    * @param {Boolean|Number} [noOverwrite=false] If true, and if the receiver already has a property of the given name, do not set it's value to that of what's in the supplier.
	    * 											   If set to 2, then same logic applies but if the given property in the receiver is an object, allow recursive mixin from the supplier
	    *											   to occur (in other words allows further annotation of an exising object).
	    * @param {Boolean} [noRecurse=false] If true, do not recurse down into objects, simply treat them as primitive values.
	    * @param {Object|Boolean} [keysFromReceiver=null]  If argument is true, then we will iterate over the properties in the receiver object, and copy values from the source object.
	    *												    If argument is an object, then only properties from this object will be used it copy values (think of it like a filter object).
	    *													In either case, if there is recursion (which is the default), the same list of properties are copied throughout each level of recursion
	    * @param {Boolean} [useDefProp=false] If true, add the property to the receiver object using Object.defineProperty rather than just doing an implicit define of the property via
	    *                                  a set.  This will be slightly slower, but will allow you to add own properties to objects that have a frozen proto object.
	    * @return {Object} The receiver object.
	   */
	
	
	
	
		function mix(r, s, ownedOrOpts, skipFuncs, noOverwrite, noRecurse, keysFromReceiver, useDefProp)
		{
			var args = arguments,
			argCnt = args.length,
			emptyR = FALSE,
			srcIsAry = FALSE,
			haveOptsObj = FALSE,
			singleSourceAry = FALSE,
			useOwnedProps = FALSE,
			usingAltKeys = FALSE,
			keepArrays = TRUE,
			utyp = "",
			useKeysObj = NULL,
			strJSON = "";
	
			if (!isObjLike(r)) {
				emptyR = TRUE;
				r = {};
			}
	
			if (!isObjLike(s)) return r;
	
			srcIsAry = isAryLike(s, TRUE);
			srcIsAry = srcIsAry === 1;
	
			if (argCnt <= 3) haveOptsObj = isObjLike(ownedOrOpts);
	
			if (!haveOptsObj) {
				useOwnedProps = !!ownedOrOpts;
	
				/*
	                                   * if the receiver was not an object (above) then we already know
	                                   * it's empty and so we control what needs to be returned and therefore
	                                   * can pick JSON optimization for example.
	                                   *
	                                   * if the receiver was a valid object, then we don't yet really
	                                   * know if the object is empty so we do that here. . .we have
	                                   * to wait to do it here since we just now computed whether
	                                   * the user/caller wanted us to only deal with owned props or not.
	                                  */
	
				if (!emptyR) {
					emptyR = empty(r, useOwnedProps ? 1 : 0, TRUE);
				}
			} else {
				useOwnedProps = !!ownedOrOpts.owned;
	
				if (!emptyR) {
					if (!("empty" in ownedOrOpts)) {
						emptyR = empty(r, useOwnedProps ? 1 : 0, TRUE);
					}
				}
	
				singleSourceAry = !!(srcIsAry && ownedOrOpts.snglSrc);
				keysFromReceiver = !!ownedOrOpts.recKeys;
				noRecurse = !!ownedOrOpts.noRecurse;
				useDefProp = !!ownedOrOpts.defProp;
				skipFuncs = !!ownedOrOpts.skipFuncs;
				keepArrays = "keepArrays" in ownedOrOpts ? !!ownedOrOpts.keepArrays : keepArrays;
				noOverwrite = ownedOrOpts.noOvr;
	
			}
	
			if (keysFromReceiver) {
				utyp = typeof keysFromReceiver;
				if (utyp == TYPE_OBJ || utyp == TYPE_FUNC) {
					useKeysObj = keysFromReceiver;
					usingAltKeys = TRUE;
				} else {
					useKeysObj = r;
					usingAltKeys = TRUE;
				}
			} else {
				useKeysObj = s;
			}
	
			/*
	     * Optimization logic:
	     *
	     * Our mix has a lot of different varied options, and various combinations allow
	     * us to skip doing our own iteration over an object in favor of the JS engine doing something
	     *
	     * these boil down into 2 main categories
	     *
	     * 1.) JSON mode -- you passed in an empty object to mix into (no override is false / implied b/c the tgt is empty),
	     *                  don't want functions, only want owned props, do want recursion, no filtered keys, and you are
	     *                  not passing in multiple sources.
	     *
	     * 2.) Native Object.assign -- no filter keys, only owned props, and NO recursion, and allow receiver props to be overriden by
	     *                             props in source(s)
	     *
	    */
			if (useOwnedProps && keepArrays && !keysFromReceiver && emptyR && (!srcIsAry || srcIsAry && !singleSourceAry) && skipFuncs && !noRecurse) {
				strJSON = jsnStringify(s);
				r = jsnParse(strJSON);
			} else if (useOwnedProps && !keysFromReceiver && noRecurse && !noOverwrite && obj_assign) {
				if (srcIsAry && !singleSourceAry) {
					r = obj_assign.apply(NULL, [r].concat(s));
				} else {
					r = obj_assign(r, s);
				}
			} else {
				if (srcIsAry && !singleSourceAry) {
					r = mix_iterateSourceArray(r, s, useKeysObj, useOwnedProps, skipFuncs, noOverwrite, noRecurse, useDefProp, usingAltKeys, keepArrays);
				} else {
					if (useOwnedProps) {
						r = mix_iterateOwned(r, s, useKeysObj, skipFuncs, noOverwrite, noRecurse, useDefProp, usingAltKeys, keepArrays);
					} else {
						r = mix_iterateNonOwned(r, s, useKeysObj, skipFuncs, noOverwrite, noRecurse, useDefProp, usingAltKeys, keepArrays);
					}
				}
			}
	
			return r;
		}
	
		/**
	    * Create a namespace or check for the existence of a namespace like string
	    * within an object.  Uses global by default in browsers only, otherwise when
	    * run server-side will use the "fitt" object exported by this module as the root
	    * unless the forceServerSideGlobal argument is true. This is done to avoid cyclical reference / closure
	    * memory leak issues with JavaScript modules particularly in NodeJS.
	    *
	    * @name fitt.ns
	    * @function
	    * @public
	    * @param {String} strNS A string representing a namespace within an object (defaulting to global).  Format of string MUST use dot notation (e.g. "name.foo.bar").
	    *
	    * @param {Object} [aug=null] A descriptor object with each key being the name of a property on the end of the namespace to be added or changed, with whatever given value desired.
	    *							  If not specified a default object is used to create the namespace end point.
	    *
	    * @param {Object|Function} [root=null] Create / find the namespace using this given argument as the root. Default is to use the global namespace
	    *
	    * @param {Boolean} [ovr=false] Forcibly overwrite an existing namespace object.
	    *
	    * @param {Boolean} [forceServerSideGlobal=false] Attach to or check the namespace string against the global object when running server-side
	    *
	    * @return {Object|Function|Boolean} depending on mode
	    *
	   */
	
		function ns(strNS, aug, root, ovr, forceServerSideGlobal) {
			"use strict";
	
			var obj = isObjLike(root) ? root : isBrowser() || forceServerSideGlobal ? getGlobal() : {},
			idx = 0,
			per = ".",
			ret = NULL,
			noOvr = !ovr,
			ar,item,objVal,dontSet,canMix;
	
			if (strNS) {
				strNS = cstr(strNS);
				aug = isObjLike(aug) ? aug : NULL;
				if (idxOf(strNS, per) !== NEG_ONE) {
					ar = strNS.split(per);
					/*jsl:ignore*/
					while (item = ar[idx++])
					/*jsl:end*/
					{
						item = trim(item, TRUE);
						objVal = obj[item];
						canMix = isObjLike(objVal);
						dontSet = !!(noOvr && canMix);
	
						if (idx == ar.length) {
							if (canMix && aug) {
								ret = obj[item] = mix(objVal, aug, FALSE, FALSE, 2);
							} else {
								if (dontSet) {
									ret = objVal;
								} else {
									ret = obj[item] = objVal || aug || {};
								}
							}
						} else {
							if (dontSet) {
								ret = objVal;
							} else {
								ret = obj[item] = objVal || {};
							}
						}
						obj = ret;
					}
				} else {
					objVal = obj[strNS];
					canMix = isObjLike(objVal);
	
					if (canMix && aug) {
						ret = obj[strNS] = mix(objVal, aug, FALSE, FALSE, 2);
					} else {
						if (!objVal && !aug) {
							ret = obj[strNS] = {};
						} else if (!aug) {
							ret = objVal;
						} else {
							ret = aug;
						}
					}
				}
			}
			return ret;
		}
	
		/**
	    * Check to see if a given object/function has an "own" property
	    *
	    * @name fitt.owns
	    * @function
	    * @public
	    * @param {Object|Function} o The object to inspect
	    * @param {String} p The name of the property
	    * @param {Boolean} [ots=false] Passing true skips validating that the input object is truly an object or function (small performance gain).
	    * @param {Boolean} [pts=false] Passing true skips forcing the conversion of a property name into a string (small performance gain).
	    * @return {Boolean}
	   */
	
		function owns(o, p, ots, pts)
		{
			p = pts ? p : cstr(p);
			o = ots || isObjLike(o) ? o : FALSE;
	
			return p && o && $obj_owns.call(o, p);
		}
	
		/**
	    * Check to see if a object is an instance of the given prototype. For example fitt.kindOf({}, Object.prototype).  Wrapper for Object.prototype.isPrototypeOf
	    *
	    * @name fitt.kindOf
	    * @function
	    * @public
	    * @param {Object|Function} o The object instance to inspect
	    * @param {Object} The prototype object instance to check
	    * @param {Boolean} [ots=false] Passing true skips validating that the 1st argument is a true object / function (small perfomance gain).
	    * @param {Boolean} [pts=false] Passing true skips validating that the 2nd argument is a true object / function (small peformance gain).
	    * @return {Boolean}
	   */
	
		function kindOf(o, p, ots, pts)
		{
			return (ots || isObjLike(o)) && (pts || isObjLike(p)) && $obj_kindOf.call(p, o);
		}
	
		/**
	    * Wrapper around JavaScript ASCII [en/de]codeURI/[en/de]codeURIComponent/[es|unes]cape global functions,
	    * ensures conversion into a string and allows you to wrap (or not) the call in a try/catch block if you are unsure of
	    * the incoming type (as in it's not a true javascript object that can safely convert to
	    * a string).
	    *
	    * @name fitt.encdec
	    * @function
	    * @public
	    * @param {*} str The string to ASCII encode/decode.
	    * @param {Object} [options=null] A descriptor object to pass various optional arguments for varied features
	    * @param {String} [options.method='comp'] Which encode function to use. Valid values are:
	    * <dl>
	    *  <dt>'comp' (Default)</dt>
	    *  <dd>Use the 'encodeURIComponent/decodeURIComponent' global function</dd>
	    *  <dt>'uri'</dt>
	    *  <dd>Use the 'encodeURI/decodeURI' global function</dd>
	    *  <dt>'esc'</dt>
	    *  <dd>Use the 'escape/unescape' global function</dd>
	    *</dl>
	    * @param {Boolean} [options.safe=true] Whether the call to the underlying encode function is wrapped in a try /catch. If wrapped and an error occurs an empty string is retuned
	    * @param {Boolean} [options.cstr=true] Whether the argument passed is forcibly converted to a string first using {@link fitt.cstr}
	    * @param {Boolean} [options.enc=true] Whether to encode or decode the string (encode is the default)
	    * @return {String}
	    */
	
		function encodeDecode(str, options)
		{
			var ret = '',
			hasOptsObj = isObj(options),
			whichFunc = cstr(hasOptsObj && options.method),
			doEncoding = TRUE,
			useCstr = TRUE,
			useTry = TRUE,
			func,strVal;
	
			if (hasOptsObj) {
				useCstr = 'cstr' in options ? !!options.cstr : TRUE;
				useTry = 'safe' in options ? !!options.safe : TRUE;
				doEncoding = 'enc' in options ? !!options.enc : TRUE;
			}
	
			try {
				switch (whichFunc) {
					case 'uri':
						if (doEncoding) {
							func = encodeURI;
						} else {
							func = decodeURI;
						}
						break;
					case 'esc':
						if (doEncoding) {
							func = escape;
						} else {
							func = unescape;
						}
						break;
					default:
						if (doEncoding) {
							func = encodeURIComponent;
						} else {
							func = decodeURIComponent;
						}
						break;}
	
			} catch (e) {}
	
			if (func) {
				if (useCstr) {
					strVal = cstr(str);
				} else {
					strVal = str;
				}
				if (strVal) {
					if (useTry) {
						try {
							ret = func(strVal);
						} catch (e) {
							ret = '';
						}
					} else {
						ret = func(strVal);
					}
				}
			}
	
			return ret;
		}
	
		/**
	    * Wrapper around JavaScript escape global function, ensures conversion into a string
	    * and allows you to wrap (or not) the call in a try/catch block if you are unsure of
	    * the incoming type (as in it's not a true javascript object that can safely convert to
	    * a string).
	    *
	    * @name fitt.es
	    * @function
	    * @public
	    * @param {*} str The string to ASCII escape.  Note that this PURPOSEFULLY uses the escape function rather than encodeURI or encodeURIComponent
	    *                 because it's faster and also encodes some characters that are not always encoded (but may need to be).
	    * @return {String}
	    */
	
		function es(str) {
			return encodeDecode(str, { method: 'esc' });
		}
	
		/**
	    * Opposite of {@link fit.es}.  Decodes an ASCII encoded string using the global unescape function.
	    *
	    * @name fitt.ues
	       * @function
	       * @public
	       * @param {*} str The string to ASCII unescape.  Note that this PURPOSEFULLY uses the unescape function rather than decodeeURI or decodeURIComponent
	       *                 because it's faster.
	       * @return {String}
	      */
	
		function ues(str) {
			return encodeDecode(str, { method: 'esc', enc: false });
		}
	
		/**
	    * Wrapper around encodeURIComponent for saftey, shorthand for <code>fitt.encdec(str);</code>
	    *
	    * @name fitt.encURIComp
	    * @function
	    * @public
	    * @param {*} str
	    * @return {String}
	   */
	
		function encURIComp(str) {
			return encodeDecode(str);
		}
	
		/**
	    * Wrapper around decodeURIComponent for saftey, shorthand for <code>fitt.encdec(str,{enc:false})</code>
	    *
	       * @name fitt.decURIComp
	       * @function
	       * @public
	       * @param {*} str
	       * @return {String}
	      */
	
		function decURIComp(str) {
			return encodeDecode(str, { enc: false });
		}
	
		/**
	    * Wrapper around encodeURI for saftey, shorthand for <code>fitt.encdec(str,{method:'uri'})</code>
	    *
	       * @name fitt.encURI
	       * @function
	       * @public
	       * @param {*} str
	       * @return {String}
	      */
	
		function encURI(str) {
			return encodeDecode(str, { method: 'uri' });
		}
	
		/**
	   * Wrapper around decodeURI for saftey, shorthand for <code>fitt.encdec(str,{method:'uri',enc:false})</code>
	   *
	    * @name fitt.decURI
	    * @function
	    * @public
	    * @param {*} str
	    * @return {String}
	   */
	
		function decURI(str) {
			return encodeDecode(str, { method: 'uri', enc: false });
		}
	
		/**
	    * Static wrapper around common String / Array prototype methods indexOf and lastIndexOf
	    * Function will automatically convert the given 1st argument into a string unless
	    * that object has a property / method "indexOf" or "lastIndexOf" (like arrays in modern
	    * JS do).
	    *
	    * @name fitt.idxOf
	    * @function
	    * @public
	    * @param {String|Array} haystack The string or array to search through.  If an object is passed in which does not have an indexOf or lastIndexOf method, it
	    *                                will first be converted into a string.
	    * @param {String} needle The substring to search for
	    * @param {Boolean} [useLast=false] Search from the begining or ending of the string (defaults to begining)
	    * @param {Number} [fromIndex=0|haystack.length] The starting index in the string or array to search through, defaults to 0 if searching from the start of the string / array
	    *                                               or the length of the string / array if searching from the back.
	    * @return {Number} returns -1 if item not found.
	    *
	   */
	
		function idxOf(haystack, needle, useLast, fromIndex)
		{
			var meth = useLast ? "lastIndexOf" : "indexOf",
			hasFromIndex = arguments.length > 3,
			ret = NEG_ONE,
			hayType = typeof haystack;
	
			if (useLast) {
				if (!hasFromIndex) {
					fromIndex = haystack.length || 0;
				}
			} else {
				if (!hasFromIndex) {
					fromIndex = 0;
				}
			}
	
			switch (hayType) {
	
				case TYPE_UNDEF:return ret;
				case TYPE_FUNC:
				case TYPE_NUM:
				case TYPE_BOOL:
					return str(haystack)[meth](needle, fromIndex);
				case TYPE_STR:
					return !haystack ? ret : haystack[meth](needle, fromIndex);
				case TYPE_OBJ:
					if (!haystack) return ret;
	
					if (meth in haystack) return haystack[meth](needle, fromIndex);
	
					return str(haystack)[meth](needle, fromIndex);}
	
	
			return ret;
		}
	
		/**
	    * Static wrapper around String.prototype.substring
	    *
	    * @name fitt.subStr
	    * @function
	    * @public
	    * @param {String} haystack Base string to use for extracting. If haystack param is null or undefined an empty string is returned.
	    *                          If argument is not a string it will be converted into a string.
	    * @param {Number} start
	    * @param {Number} end
	    * @return {String}
	   */
	
		function subStr(haystack, start, end)
		{
			var haytyp = typeof haystack,
			hasEndArg = arguments.length > 2,
			SUBSTR = "substring";
	
			if (haystack == NULL) return '';
			if (haytyp !== TYPE_STR) {
				haystack = str(haystack);
			}
	
			if (!haystack) return '';
	
			return hasEndArg ? haystack[SUBSTR](start, end) : haystack[SUBSTR](start);
		}
	
		/**
	    * Static wrapper around String.prototype.charAt, which will also use newer functionality
	    * where string parts can be accessed via [] (slight performance improvement), if the environment
	    * supports it.
	    *
	    * @name fitt.charAt
	    * @function
	    * @public
	    * @param {String} str The given string
	    * @param {Number} idx The index in the string to look
	    * @return {String} representing a single character in the string void/undefined if the index is out of bounds
	    *
	   */
	
		function charAt(str, idx) {};
	
		charAt = function () {
	
			var str = "hello",
			fsrc;
	
			try {
				strArrayAccess = str[1] === 'e' && str[2] === 'l';
			} catch (e) {
				strArrayAccess = FALSE;
			}
	
			if (strArrayAccess) {
				fsrc = function charAt(str, idx) {return str[idx];};
			} else {
				fsrc = function charAt(str, idx) {return str.charAt(idx);};
			}
	
			return fsrc;
		}();
	
	
		/**
	       * Polyfill support for Object.keys in cases of no ECMAScript 5 support,
	       * otherwise simply a pointer to the default Object.keys native function
	       *
	       * @name fitt.keys
	       * @function
	       * @public
	       * @param {Object|Function} o The object instance to inspect
	       * @return {String[]} An array of property names (strings), that are owned and enumerable.
	       *
	      */
	
		function keys(o) {}
	
		keys = function () {
			var f, fc, fsrc;
	
			if (obj_keys) return obj_keys;
			fsrc =
			[
			"return (function(o) {\n",
			"\n",
			"   var a = [], n;\n",
			"   if (isObjLike(o)) {\n",
			"       for (n in o)\n",
			"       {\n",
			"           if (owns(o, n, TRUE, TRUE)) {\n",
			"               a.push(n);\n",
			"           }\n",
			"       }\n",
			"   }\n",
			"   return a;\n",
			"});\n"];
	
			fsrc = cstr(fsrc);
			fc = func("owns", "isObjLike", "TRUE", fsrc);
			f = fc(owns, isObjLike, TRUE);
			return f;
		}();
	
		/**
	       * Check to see if a given reference is empty.  Passing a primitive value that evaluate to false, will
	       * cause this function to return true (they are considered empty). The default is tObjects / functions are considered
	       * empty if they have no enumerable properties (INCLUDING ANYTHING INHERITED FROM THE PROTOTYPE CHAIN). You
	       * can require that properties also be be owned and enumerable, or simply owned properties (both enumerable and non-enumerable)
	       * by switching modes (note that this feature only works with full ECMAScript 5 support environments).
	       *
	       * @name fitt.empty
	       * @function
	       * @public
	       * @param {*} o  The thing to inspect
	       * @param {Number} [mode=0] What types properties on the given object / function (assuming the 1st argument is indeed an object/ function),
	       * 							should be considered.
	       *							<dl>
	       *								<dt>0 (default)</dt>
	       *								<dd>Consider any enumerable properties, whether they are owned properties or inherited via the prototoype chain,
	       *									as making the object non-empty.</dd>
	       *								<dt>1</dt>
	       *								<dd>Require all properties be owned and enumerable.  An object with no owned and enumerable properties is considered empty.</dd>
	       *								<dt>2</dt>
	       *								<dd>Require all properties be owned, but allow both enumerable and non-enumerable properties to be considered.</dd>
	       *							</dl>
	       * @return {Boolean}
	       *
	      */
	
		/*
	          * we define the function up front here empty since we're
	          * going to do a generated implementation below.  This way
	          * most IDE's still pick it up in their tools, and we don't
	          * have to define a variable for it.
	         */
	
		/** @ignore */
		function empty() {}
	
		/*
	                      * Since there is a possibility (very low) of not having ECMAScript 5
	                      * support, we build this (and a few other) functions dynamically,
	                      * rather than always checking for those features each run.
	                      * As a general rule, we return a closure function from our function
	                      * constructor b/c functions created purely with strings via a function
	                      * constructor have their body/source re-evaluated each time they run
	                      * and thereby drag down performance.
	                     */
	
		/** @ignore */
		empty = function () {
	
			var f, fc, fsrc;
	
			if (typeof obj_keys == TYPE_FUNC && typeof obj_props == TYPE_FUNC) {
				/*
	                                                                       * to save space with compression, we create a named "empty"
	                                                                       * function inside an IIEF, which also prevents the named
	                                                                       * function from being a variable in our outer scope,
	                                                                       * and then we convert that to a string and use a function
	                                                                       * constructor to redefine the source, so that said function
	                                                                       * only holds references to the dependancies that it needs
	                                                                      */
	
				fsrc =
				[
				"return (function(o,m,ots) {\n",
				"   var emp = TRUE, p;\n",
				"   if (!o) return TRUE;\n",
				"   if (!ots && !isObjLike(o)) return FALSE;\n",
				"   if (m === 1) return !(obj_keys(o).length);\n",
				"   if (m === 2) return !(obj_props(o).length);\n",
				"   for (p in o) {\n",
				"       emp = FALSE;\n",
				"       break;\n",
				"   }\n",
				"   return emp;\n",
				"});\n"];
	
				fsrc = cstr(fsrc);
				fc = func("obj_keys", "obj_props", "isObjLike", "TRUE", "FALSE", fsrc);
				f = fc(obj_keys, obj_props, isObjLike, TRUE, FALSE);
			} else {
				fsrc =
				[
				"return (function(o,m,ots) {\n",
				"   var emp = TRUE, p;\n",
				"   if (!o) return FALSE;\n",
				"   if (!ots && !isObjLike(o)) return FALSE;\n",
				"   if (m === 2) throw new Error('call to fitt.empty with mode 2 failed, environment does not support ECMAScript5');\n",
				"   for (p in o) {\n",
				"   if (m === 1 && !owns(o,p)) continue;\n",
				"       emp = FALSE;\n",
				"       break;\n",
				"   }\n",
				"   return emp;\n",
				"});\n"];
	
				fsrc = cstr(fsrc);
				fc = func("owns", "isObjLike", "TRUE", "FALSE", fsrc);
				f = fc(owns, isObjLike, TRUE, FALSE);
			}
	
			return f;
		}();
	
	
		/** @ignore */
		function trim() {}
	
		/**
	                     * Shorthand / wrapper for String.prototype.trim which is only available in ECMAScript 6.
	                     *
	                     * @name fitt.trim
	                     * @public
	                     * @function
	                     * @param {String|*} s A string to trim the whitespace from the left and right sides. You may also pass in an object or non-string type, and it will be converted.
	                     * @param {Boolean} [its=false] Pass true to dictate that the 1st argument is indeed a string (small performance gain).
	                     * @return {String}
	                    */
	
		/** @ignore */
		trim = function () {
	
			var f, fc;
	
			if (typeof $str_trim == TYPE_FUNC) {
				fc = func("$str_trim", "cstr",
				cstr([
				TYPE_FUNC, " trim(s,its) { ",
				"	s = (its) ? s : cstr(s); ",
				"	", RETURN, " $str_trim.call(s); ",
				"}; ",
				RETURN, " trim;"]));
	
	
				f = fc($str_trim, cstr);
			} else {
				fc = func("cstr",
				cstr([
				TYPE_FUNC, " trim(s,its) { ",
				"	s = (its) ? s : cstr(s); ",
				"	", RETURN, " s.replace(/^\s\s*/, '').replace(/\s\s*$/, ''); ",
				"}; ",
				RETURN, " trim;"]));
	
	
				f = fc(cstr);
			}
	
			return f;
		}();
	
		/** @ignore */
		function now() {};
	
		/**
	                     *  Shorthand / wrapper around getting the currently known time (client-side), which either calls
	                     *  (new Date()).getTime(), or Date.now() (in modern browsers which is also faster).
	                     *
	                     * @name fitt.now
	                     * @function
	                     * @return {Number} The current time in milliseconds from the epoch (Jan 1, 1970).
	                    */
	
		now = function () {
	
			var hasErr = FALSE,val,dteNow,ret,fc;
	
			try {
				dteNow = dte.now;
				val = dteNow();
				if (!isNum(val)) {
					hasErr = TRUE;
				}
			} catch (e) {
				hasErr = TRUE;
			}
	
			if (!hasErr) {
				ret = dteNow;
			} else {
				fc = func("d", cstr([RETURN, " (", TYPE_FUNC, "() { ", RETURN, " (new d()).getTime(); });"]));
				ret = fc(dte);
			}
	
			return ret;
		}();
	
		/** @ignore */
		function getGlobal() {}
	
		/**
	                          * Get a reference to the top level / global object for the given realm / window,
	                          * or a variable that's defined in global scope.
	                          *
	                          * Note that globally defined variables using "const" or "let" operators, do
	                          * not actually attach themselves to the global object as opposed named function
	                          * declarations and "var" statements.  So for example, in a script you have something
	                          * globally defined via let / const (which really can only happen in a browser):<br />
	                          <pre>
	                             let foo = 100;
	                         	    alert(window.foo); //undefined
	                          </pre>
	                          *<br />
	                          *
	                          * This function will allow you to still get at said global:<br />
	                          <pre>
	                             let foo = 100;
	                         	    alert(fitt.getGlobal("foo")); //100
	                          </pre>
	                          *
	                          *
	                          * @name fitt.getGlobal
	                          * @function
	                          * @param {String} [varName=""]  If passed, will attempt to find the given variable name in the global object, otherwise this function just returns the global object.
	                          * @param {*} [defaultValue=void|undefined] If specified, will be returned when the global object cannot be found (shoudl be never), or mainly used for trying to find
	                          *                                          out if a global variable exists.
	                          * @public
	                          * @return {Object|*} if using a varName argument, returns the value of said argument (which could be any type), if indentifier does not exist, returns your default value
	                          *                    specifed, or undefined (we allow you to pass your own default to let you be able to tell the difference between an identifier that does not exist, versus
	                          *                    existing, but set as an undefined value.  If you pass no varName argument, simply returns a hook to the global object (window in browsers, global in NodeJS).
	                         */
	
	
	
		/** @ignore */
		getGlobal = function () {
	
			var gg, fc; //stores the chosen function to get the global object
			/*
	   * the 3rd case below should never really happen
	   * we use a function constructor that returns its own
	   * inline function so that it will still get optimized
	   * by modern JS engines (rather than functions from constructors
	   * which are re-parsed every time they run), and we use
	   * the function constructor so that we don't have to hold
	   * ref to the main window/global ourselves for ever
	  */
			function ggv(nm, def)
			{
				var findFailed = FALSE,fc,gfv,ret;
	
				nm = cstr(nm);
	
				if (nm) {
					if (nm in globalVarNameCache) {
						gfv = globalVarNameCache[nm];
					} else {
						try {
							fc = func(cstr([RETURN, " (", TYPE_FUNC, "() { ", RETURN, " ", nm, "; });"]));
							gfv = fc();
						} catch (e) {
							gfv = NULL;
						}
					}
					if (gfv) {
						try {
							ret = gfv();
						} catch (e) {
							findFailed = TRUE;
						}
					} else {
						findFailed = TRUE;
					}
	
					return findFailed ? arguments.length > 1 ? def : UNDEF : ret;
				}
				return gg();
			}
	
			/*
	     * dynamcically build a function via string that returns
	     * another function to get the global object.
	     * We return a function out of the constructed function
	     * so that the string code doesn't get re-parsed every time it runs
	     * (an optimization, b/c functions constructed via string always get their body re-parsed).
	    */
			if (typeof window == TYPE_OBJ) {
				fc = func(cstr([RETURN, "(", TYPE_FUNC, "() { ", RETURN, " ", WIN, "; });"]));
			} else if (typeof global == TYPE_OBJ) {
				fc = func(cstr([RETURN, "(", TYPE_FUNC, "() { ", RETURN, " ", GLOBAL, "; });"]));
			} else {
				fc = func(cstr([RETURN, "(", TYPE_FUNC, "() { throw new TypeError('no ", GLOBAL, " hook found'); });"]));
			}
			gg = fc();
	
			return ggv;
		}();
	
		/**
	       * A reliable way to detect that we are running in a browser. Currently
	       * grabs onto the global object and attempts to create a temporary DOM element
	       * and validate that HTML parsing works.  Since an environment would have to
	       * fake the DOM and HTML parsing in order to trick the function it's a pretty
	       * safe bet.
	       *
	       * @name fitt.isBrowser
	       * @function
	       * @return {Boolean}
	      */
	
		function isBrowser() {}
	
		isBrowser = function () {
	
			var win = getGlobal(),
			ret = FALSE,
			doc,tempEl,firstChild;
	
			try {
				doc = win.document;
				tempEl = doc.createElement('div');
				tempEl.innerHTML = '<div id="browserCheck"></div>';
				firstChild = tempEl.firstChild;
				ret = !!(firstChild && firstChild.id === 'browserCheck');
			} catch (e) {
				ret = FALSE;
			}
	
			return ret ? rtrue : rfalse;
	
		}();
	
	
		/**
	       * Shorthand constant for the string "prototype"
	       *
	       * @name fitt.PROTO
	       * @constant
	       * @public
	       * @type {String}
	      */
	
		exp.PROTO = PROTO;
	
	
		/**
	                     * Shorthand constant for the string "__proto__"
	                     *
	                     * @name fitt.UPROTO
	                     * @constant
	                     * @public
	                     * @type {String}
	                     *
	                    */
	
		exp.UPROTO = UPROTO;
	
		/**
	                       * Shorthand constant for the string "constructor"
	                       *
	                       * @name fitt.CONSTRUCT
	                       * @constant
	                       * @public
	                       * @type {String}
	                      */
	
		exp.CONSTRUCT = CONSTRUCT;
	
		/**
	                             * Shorthand constant for "toString"
	                             *
	                             * @name fitt.TO_STR
	                             * @constant
	                             * @public
	                             * @type {String}
	                            */
	
		exp.TO_STR = TO_STR;
	
		/**
	                       * Shorthand constant for "value"
	                       *
	                       * @name fitt.VALUE
	                       * @constant
	                       * @public
	                       * @type {String}
	                      */
	
		exp.VALUE = VALUE;
	
		/**
	                     * Shorthand constant for "valueOf"
	                     *
	                     * @name fitt.VALUE_OF
	                     * @constant
	                     * @public
	                     * @type {String}
	                    */
	
		exp.VALUE_OF = VALUE_OF;
	
		/**
	                           * Shorthand constant for "string" (as in the result of typeof on a string value)
	                           *
	                           * @name fitt.TYPE_STR
	                           * @constant
	                           * @public
	                           * @type {String}
	                          */
	
		exp.TYPE_STR = TYPE_STR;
	
		/**
	                           * Shorthand constant for "number" (as in the result of typeof on a number value)
	                           *
	                           * @name fitt.TYPE_NUM
	                           * @constant
	                           * @public
	                           * @type {String}
	                          */
	
		exp.TYPE_NUM = TYPE_NUM;
	
		/**
	                           * Shorthand constant for "boolean" (as in the result of typeof on a boolean value)
	                           *
	                           * @name fitt.TYPE_BOOL
	                           * @constant
	                           * @public
	                           * @type {String}
	                          */
	
		exp.TYPE_BOOL = TYPE_BOOL;
	
		/**
	                             * Shorthand constant for "function" (as in the result of a typeof on a function reference)
	                             *
	                             * @name fitt.TYPE_FUNC
	                             * @constant
	                             * @public
	                             * @type {String}
	                            */
	
		exp.TYPE_FUNC = TYPE_FUNC;
	
		/**
	                             * Shorthand constant for "object" (as in the result of a typeof on an object (or null) reference)
	                             *
	                             * @name fitt.TYPE_OBJ
	                             * @constant
	                             * @public
	                             * @type {String}
	                            */
	
		exp.TYPE_OBJ = TYPE_OBJ;
	
		/**
	                           * Shorthand constant for "symbol" (as in the result of a typeof on a symbol value)
	                           *
	                           * @name fitt.TYPE_SYM
	                           * @constant
	                           * @public
	                           * @type {String}
	                          */
	
		exp.TYPE_SYM = TYPE_SYM;
	
		/**
	                           * Shorthand constant for "undefined"
	                           *
	                           * @name fitt.TYPE_UNDEF
	                           * @constant
	                           * @public
	                           * @type {String}
	                          */
	
		exp.TYPE_UNDEF = TYPE_UNDEF;
	
		/**
	                               * Shorthand constant for "unknown"
	                               * Note that the typeof operator in JavaScript on IE 9 browsers and below
	                               * can return this value in cases where a reference is being deleted / removed
	                               * from memory or if the reference in JavaScript points to some other native but not
	                               * JavaScript based object (like VBScript).
	                               *
	                               * @name fitt.TYPE_UNKNOWN
	                               * @constant
	                               * @public
	                               * @type {String}
	                              */
	
	
		exp.TYPE_UNKNOWN = TYPE_UNKNOWN;
	
		/**
	                                   * Shorthand constant for "configurable" (commonly used in property descriptors of objects)
	                                   *
	                                   * @name fitt.CAN_CONF
	                                   * @constant
	                                   * @public
	                                   * @type {String}
	                                  */
	
		exp.CAN_CONF = CAN_CONF;
	
		/**
	                           * Shorthand constant for "writable" (commonly used in property descriptors of objects)
	                           *
	                           * @name fitt.CAN_WRITE
	                           * @constant
	                           * @public
	                           * @type {String}
	                          */
	
		exp.CAN_WRITE = CAN_WRITE;
	
		/**
	                             * Shorthand constant for "enumerable"  (commonly used in property descriptors of objects)
	                             *
	                             * @name fitt.CAN_ENUM
	                             * @constant
	                             * @public
	                             * @type {String}
	                            */
	
		exp.CAN_ENUM = CAN_ENUM;
	
		/**
	                           * Shorthand constant for "__defineGetter__" (legacy getter definition pre-ECMAScript 5 which
	                           * is still used in some fallback cases).
	                           *
	                           * @name fitt.DEF_GET
	                           * @constant
	                           * @public
	                           * @type {String}
	                          */
	
		exp.DEF_GET = DEF_GET;
	
		/**
	                         * Shorthand constant for "__defineSetter__" (legacy setter definition definition pre-ECMAScript 5 which
	                         * is still used in some fallback cases).
	                         *
	                         * @name fitt.DEF_SET
	                         * @constant
	                         * @public
	                         * @type {String}
	                        */
	
		exp.DEF_SET = DEF_SET;
	
		/**
	                         * Shorthand constant for null value
	                         *
	                         * @name fitt.NULL
	                         * @constant
	                         * @public
	                         * @type {Null}
	                        */
	
		exp.NULL = NULL;
	
		/**
	                   * Shorthand constant for undefined (void 0) value
	                   *
	                   * @name fitt.UNDEF
	                   * @constant
	                   * @public
	                   * @type {void}
	                  */
	
		exp.UNDEF = UNDEF;
	
		/**
	                     * Shorthand constant for true value (boolean)
	                     *
	                     * @name fitt.TRUE
	                     * @constant
	                     * @public
	                     * @type {Boolean}
	                    */
	
		exp.TRUE = TRUE;
	
		/**
	                   * Shorthand constant for false value (boolean)
	                   *
	                   * @name fitt.FALSE
	                   * @constant
	                   * @public
	                   * @type {Boolean}
	                  */
		exp.FALSE = FALSE;
	
		/**
	                     * Shorthand constant for -1 (number)
	                     *
	                     * @name fitt.NEG_ONE
	                     * @constant
	                     * @public
	                     * @type {Number}
	                    */
	
		exp.NEG_ONE = NEG_ONE;
	
		/**
	                         * Shorthand for core JavaScript Object constructor
	                         *
	                         * @name fitt.obj
	                         * @constant
	                         * @public
	                         * @type {Function}
	                        */
	
		exp.obj = obj;
	
		/**
	                 * Shorthand for core JavaScript Object.prototype object
	                 *
	                 * @name fitt.$obj
	                 * @constant
	                 * @public
	                 * @type {Object}
	                */
	
		exp.$obj = $obj;
	
		/**
	                   * Shorthand for core JavaScript Array constructor
	                   *
	                   * @name fitt.ary
	                   * @constant
	                   * @public
	                   * @type {Function}
	                  */
		exp.ary = ary;
	
		/**
	                 * Shorthand for core JavaScript Array.prototype object
	                 *
	                 * @name fitt.$ary
	                 * @constant
	                 * @public
	                 * @type {Function}
	                */
	
		exp.$ary = $ary;
	
		/**
	                   * Shorthand for core JavaScript Function constructor
	                   *
	                   * @name fitt.func
	                   * @constant
	                   * @public
	                   * @type {Function}
	                  */
	
		exp.func = func;
	
		/**
	                   * Shorthand for core JavaScript Function prototype object
	                   *
	                   * @name fitt.$func
	                   * @constant
	                   * @public
	                   * @type {Object}
	                  */
	
		exp.$func = $func;
	
		/**
	                     * Shorthand for core JavaScript String constructor
	                     *
	                     * @name fitt.str
	                     * @constant
	                     * @public
	                     * @type {Function}
	                    */
	
		exp.str = str;
	
		/**
	                 * Shorthand for core JavaScript String.prototype object
	                 *
	                 * @name fitt.$str
	                 * @constant
	                 * @public
	                 * @type {Object}
	                */
	
		exp.$str = $str;
	
		/**
	                   * Whether or not the environment supports accessing characters of a string type via
	                   * square bracket notation (e.g. str[2] rather than str.charAt(2))
	                   *
	                   * @name fitt.strArrayAccess
	                   * @constant
	                   * @public
	                   * @type {Boolean}
	                  */
	
		exp.strArrayAccess = strArrayAccess;
	
		/**
	                                       * Shorthand for core JavaScript Number constructor
	                                       *
	                                       * @name fitt.num
	                                       * @constant
	                                       * @public
	                                       * @type {Function}
	                                      */
	
		exp.num = num;
	
		/**
	                 * Shorthand for core JavaScript Number prototype object
	                 *
	                 * @name fitt.$num
	                 * @constant
	                 * @public
	                 * @type {Object}
	                */
	
		exp.$num = $num;
	
		/**
	                   * Shorthand for core JavaScript Error constructor
	                   *
	                   * @name fitt.err
	                   * @constant
	                   * @public
	                   * @type {Function}
	                  */
	
		exp.err = err;
	
		/**
	                 * Shorthand for core JavaScript Error prototype object.
	                 *
	                 * @name fitt.$err
	                 * @constant
	                 * @public
	                 * @type {Object}
	                */
	
		exp.$err = $err;
	
		/**
	                   * Shorthand for core JavaScript RegExp constructor
	                   * @name fitt.regex
	                   * @constant
	                   * @public
	                   * @type {RegExp}
	                  */
	
		exp.regx = regx;
	
	
		/**
	                   * Shorthand for core JavaScript RegExp prototype object
	                   *
	                   * @name fitt.$regx
	                   * @constant
	                   * @public
	                   * @type {Object}
	                  */
	
		exp.$regx = $regx,
	
	
		/**
	                     * Shorthand for core JavaScript Date object
	                     * @constant
	                     * @public
	                     * @type {Date}
	                    */
	
		exp.dte = dte;
	
		/**
	                 * Shorthand for core JavaScript Date prototype object
	                 * @constant
	                 * @public
	                 * @type {Object}
	                */
	
		exp.$dte = $dte;
	
		/**
	                   * Shorthand for core JavaScript Number.MAX_VALUE / largest safe
	                   * integer value
	                   * @name fitt.NUM_MAX
	                   * @constant
	                   * @public
	                   * @type {Object}
	                  */
	
		exp.NUM_MAX = NUM_MAX;
	
		/**
	                        * Shorthand for core JavaScript Number.MIN_VALUE / smallest safe
	                        * integer value (as in a negative version of NUM_MAX)
	                        * @name fitt.NUM_MIN
	                        * @constant
	                        * @public
	                        * @type {Object}
	                        */
	
		exp.NUM_MIN = NUM_MIN;
	
		/*
	                         * The remaining exported items need no further documenation
	                         * as they were documented above
	                        */
	
		exp.noop = noop;
		exp.passThru = passThru;
		exp.rtrue = rtrue;
		exp.rfalse = rfalse;
		exp.rnull = rnull;
		exp.rzero = rzero;
		exp.rone = rone;
		exp.isAry = isAry;
		exp.isAryLike = isAryLike;
		exp.isFunc = isFunc;
		exp.isObj = isObj;
		exp.isObjLike = isObjLike;
		exp.isDate = isDate;
		exp.isNum = isNum;
		exp.cnum = cnum;
		exp.cbool = cbool;
		exp.toStringTag = toStringTag;
		exp.cstr = cstr;
		exp.ord = ord;
		exp.strlc = strlc;
		exp.struc = struc;
		exp.strReplace = strReplace;
		exp.strMatch = strMatch;
		exp.trim = trim;
		exp.owns = owns;
		exp.empty = empty;
		exp.cobj = cobj;
		exp.cary = cary;
		exp.cprop = cprop;
		exp.cprops = cprops;
		exp.kindOf = kindOf;
		exp.gprop = obj_gprop;
		exp.gprops = obj_props;
		exp.forEach = forEach;
		exp.ns = ns;
		exp.mix = mix;
		exp.now = now;
		exp.gproto = obj_getProto;
		exp.sproto = obj_setProto;
		exp.noext = obj_noExtend;
		exp.canext = obj_canExtend;
		exp.frozen = obj_frozen;
		exp.sealed = obj_sealed;
		exp.seal = obj_seal;
		exp.freeze = obj_freeze;
		exp.props = obj_props;
		exp.keys = keys;
		exp.syms = obj_syms;
		exp.getGlobal = getGlobal;
		exp.isBrowser = isBrowser;
		exp.es = es;
		exp.ues = ues;
		exp.encdec = encodeDecode;
		exp.encURIComp = encURIComp;
		exp.decURIComp = decURIComp;
		exp.encURI = encURI;
		exp.decURI = decURI;
		exp.idxOf = idxOf;
		exp.subStr = subStr;
		exp.charAt = charAt;
		exp.regxTest = regxTest;
		exp.regxSearch = regxSearch;
		exp.canCall = canCall;
		exp.callSafe = callSafe;
		exp.inherits = inherits;
		exp.shallowEq = shallowEq;
	
		exp.PropDescErr = PropDescErr;
		exp.PropDesc = PropDesc;
		exp.DataPropDesc = DataPropDesc;
		exp.DynPropDesc = DynPropDesc;
		exp.MixOptions = MixOptions;
	
		return exp;
	}();
	
	
	(function () {
	
		var ret = fitt.mix({}, fitt, { noRecurse: true }),
		glob,globFitt;
	
		if (fitt.isBrowser()) {
			glob = fitt.getGlobal();
			globFitt = glob.fitt;
	
			if (!globFitt) {
				glob.fitt = ret;
			}
		}
	
		if (true) {
			module.exports = ret;
		}
	})();
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = parts.length - 1; i >= 0; i--) {
	    var last = parts[i];
	    if (last === '.') {
	      parts.splice(i, 1);
	    } else if (last === '..') {
	      parts.splice(i, 1);
	      up++;
	    } else if (up) {
	      parts.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (allowAboveRoot) {
	    for (; up--; up) {
	      parts.unshift('..');
	    }
	  }
	
	  return parts;
	}
	
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var splitPath = function(filename) {
	  return splitPathRe.exec(filename).slice(1);
	};
	
	// path.resolve([from ...], to)
	// posix version
	exports.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;
	
	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();
	
	    // Skip empty and invalid entries
	    if (typeof path !== 'string') {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }
	
	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path.charAt(0) === '/';
	  }
	
	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)
	
	  // Normalize the path
	  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
	    return !!p;
	  }), !resolvedAbsolute).join('/');
	
	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};
	
	// path.normalize(path)
	// posix version
	exports.normalize = function(path) {
	  var isAbsolute = exports.isAbsolute(path),
	      trailingSlash = substr(path, -1) === '/';
	
	  // Normalize the path
	  path = normalizeArray(filter(path.split('/'), function(p) {
	    return !!p;
	  }), !isAbsolute).join('/');
	
	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }
	
	  return (isAbsolute ? '/' : '') + path;
	};
	
	// posix version
	exports.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};
	
	// posix version
	exports.join = function() {
	  var paths = Array.prototype.slice.call(arguments, 0);
	  return exports.normalize(filter(paths, function(p, index) {
	    if (typeof p !== 'string') {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    return p;
	  }).join('/'));
	};
	
	
	// path.relative(from, to)
	// posix version
	exports.relative = function(from, to) {
	  from = exports.resolve(from).substr(1);
	  to = exports.resolve(to).substr(1);
	
	  function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	      if (arr[start] !== '') break;
	    }
	
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	      if (arr[end] !== '') break;
	    }
	
	    if (start > end) return [];
	    return arr.slice(start, end - start + 1);
	  }
	
	  var fromParts = trim(from.split('/'));
	  var toParts = trim(to.split('/'));
	
	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }
	
	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }
	
	  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
	  return outputParts.join('/');
	};
	
	exports.sep = '/';
	exports.delimiter = ':';
	
	exports.dirname = function(path) {
	  var result = splitPath(path),
	      root = result[0],
	      dir = result[1];
	
	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }
	
	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }
	
	  return root + dir;
	};
	
	
	exports.basename = function(path, ext) {
	  var f = splitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};
	
	
	exports.extname = function(path) {
	  return splitPath(path)[3];
	};
	
	function filter (xs, f) {
	    if (xs.filter) return xs.filter(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        if (f(xs[i], i, xs)) res.push(xs[i]);
	    }
	    return res;
	}
	
	// String.prototype.substr - negative index don't work in IE8
	var substr = 'ab'.substr(-1) === 'b'
	    ? function (str, start, len) { return str.substr(start, len) }
	    : function (str, start, len) {
	        if (start < 0) start = str.length + start;
	        return str.substr(start, len);
	    }
	;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 428 */
/***/ (function(module, exports) {

	exports.endianness = function () { return 'LE' };
	
	exports.hostname = function () {
	    if (typeof location !== 'undefined') {
	        return location.hostname
	    }
	    else return '';
	};
	
	exports.loadavg = function () { return [] };
	
	exports.uptime = function () { return 0 };
	
	exports.freemem = function () {
	    return Number.MAX_VALUE;
	};
	
	exports.totalmem = function () {
	    return Number.MAX_VALUE;
	};
	
	exports.cpus = function () { return [] };
	
	exports.type = function () { return 'Browser' };
	
	exports.release = function () {
	    if (typeof navigator !== 'undefined') {
	        return navigator.appVersion;
	    }
	    return '';
	};
	
	exports.networkInterfaces
	= exports.getNetworkInterfaces
	= function () { return {} };
	
	exports.arch = function () { return 'javascript' };
	
	exports.platform = function () { return 'browser' };
	
	exports.tmpdir = exports.tmpDir = function () {
	    return '/tmp';
	};
	
	exports.EOL = '\n';


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ads = undefined;
	
	var _extends2 = __webpack_require__(364);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _common = __webpack_require__(430);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global jQuery admgr espn */
	var ads = exports.ads = {
	
	  /**
	   * [gamebreak Function to init the gamebreak video ad in gamepackage page]
	   * @param  {[type]} props [includes all the data like gameId(integer), gamestatus(pre,post), sport(cricket)]
	   * @return {[type]}        [description]
	   */
	  gamebreak: function gamebreak(props) {
	
	    var _ = window._;
	    var espn_ui = window.espn_ui;
	    var espn_util = window.espn_util;
	
	    espn.gamepackage = espn.gamepackage || {};
	
	    /*
	    creates markup for ooyala player if we want to run the ad
	    after div#videoPlayer is removed from dom
	    */
	    if (props.hasOwnProperty('addplayerhtml') === true) {
	      if (props.addplayerhtml) {
	        addVideoPlayerDiv(props.addplayerhtml);
	        return false;
	      }
	    }
	
	    //when show ad is false stop execution
	    if (props.showad === false) {
	      return false;
	    }
	
	    var config = props;
	    var _gameId = props.gameId;
	    var _gamestatus = props.gamestatus;
	    var _sport = props.sport;
	    var _gamebreakstatus = props.gamebreakstatus;
	
	    if (_gamestatus !== 'in') {
	      return false;
	    }
	
	    var cms = 'espn';
	    if (espn.i18n.lang === 'es') {
	      cms = 'deportes';
	    } else if (_sport === 'soccer') {
	      cms = 'intl';
	    }
	
	    var siteSectionTarget = 'espn:gamepackage:' + _sport;
	    var videoIdTarget = 'espn:gamepackage:' + _sport;
	
	    var playHook = void 0;
	    var adStartHook = void 0;
	    var completeHook = void 0;
	    var countdownHook = void 0;
	    var timeoutHook = void 0;
	    var fallbackTimeoutHook = void 0;
	    var _isIncompatibleBrowser = isIncompatibleBrowser();
	
	    jQuery(document).on('page.render', onPageRender);
	
	    function addVideoPlayerDiv(html) {
	      var videoPlaceholderDiv = jQuery('#gamepackage-gamebreak').length;
	      if (html && videoPlaceholderDiv === 0) {
	        jQuery('#videogamebreak').html('').append(html);
	      }
	    }
	
	    var durationMessage = _.translate('Advertisement: Game coverage will resume in');
	    var defaultMessage = _.translate('Advertisement: Game coverage will resume after ad is complete.');
	    var MIN_TIME_BETWEEN_ADS = 5; // in mins
	
	    /**
	     * [onBeforeLoad Clear listeners if already created ]
	     * @return {[type]} []
	     */
	    function onBeforeLoad() {
	      if (playHook) {
	        jQuery.unsubscribe(playHook);
	      }
	      if (adStartHook) {
	        jQuery.unsubscribe(adStartHook);
	      }
	      if (completeHook) {
	        jQuery.unsubscribe(completeHook);
	      }
	      jQuery(document).off('page.beforeload', onBeforeLoad);
	      clearInterval(countdownHook);
	      clearTimeout(timeoutHook);
	      clearTimeout(fallbackTimeoutHook);
	    }
	
	    /**
	     * [onAdStart Callback when the ad is started, to start countdown]
	     * @param  {[type]} duration [time in seconds]
	     * @return {[type]}          []
	     */
	    function onAdStart(duration) {
	      clearTimeout(fallbackTimeoutHook);
	
	      if (!isNaN(duration)) {
	        countdown(parseInt(duration, 10));
	      } else {
	        jQuery('.video-ad-break-wrap .countdown').html(defaultMessage);
	      }
	    }
	
	    /**
	     * [countdown counts the number of seconds left when ad is playing]
	     * @param  {[type]} duration [time in seconds]
	     * @return {[type]}          []
	     */
	    function countdown(duration) {
	      var start = duration,
	          secondString = start === 1 ? _.translate('second') : _.translate('seconds');
	
	      clearInterval(countdownHook);
	      jQuery('.video-ad-break-wrap .countdown').html(durationMessage + ' ' + start + ' ' + secondString);
	
	      countdownHook = setInterval(function () {
	        start--;
	        secondString = start === 1 ? _.translate('second') : _.translate('seconds');
	        jQuery('.video-ad-break-wrap .countdown').html(durationMessage + ' ' + start + ' ' + secondString);
	        if (start <= 0) {
	          clearInterval(countdownHook);
	        }
	      }, 1000);
	    }
	    /**
	     * [remove Function to remove the container where video player ad will be loaded]
	     * @return {[type]} []
	     */
	    function remove() {
	      jQuery('#gamepackage-gamebreak').remove();
	      clearInterval(countdownHook);
	    }
	
	    function isIncompatibleBrowser() {
	      var USER_AGENT = typeof window !== 'undefined' && window.navigator && window.navigator.userAgent || '',
	          IS_EDGE = /Edge/i.test(USER_AGENT),
	          IS_CHROME = !IS_EDGE && /Chrome/i.test(USER_AGENT),
	          IS_ANDROID = /Android/i.test(USER_AGENT),
	          IS_SAFARI = /Safari/i.test(USER_AGENT) && /Mac OS X 10_/i.test(USER_AGENT) && !IS_CHROME && !IS_ANDROID && !IS_EDGE,
	          versionString = 'Version/',
	          versionStringStart = USER_AGENT.indexOf(versionString),
	          versionStringEnd = versionStringStart + versionString.length,
	          versionStringNumber = USER_AGENT.substring(versionStringEnd, versionStringEnd + 4).replace(/\s/g, '');
	
	      return IS_SAFARI && parseFloat(versionStringNumber) >= 11;
	    }
	
	    /**
	     * [initAd Function to init the ad based on cookie]
	     * @return {[type]} []
	     */
	    var initAd = function initAd() {
	      var mq = espn_ui.media_query_in_use;
	      var type = 'Pre-Roll';
	      var _show = false;
	      var timeout = 7000; // default timeout is 7s
	
	      if (mq && mq !== 'mobile') {
	        _show = true;
	        timeout = 0; // dont delay for pre-roll, show immediately
	        if (_show === true) {
	          // if we've shown an ad in the last 5 mins... don't show another one here...
	          if ((jQuery.cookie('gamebreak') !== '1' || jQuery.cookie('gamebreak') === 'show') && jQuery.cookie('gamebreak') !== 'hide') {
	            timeoutHook = setTimeout(function () {
	              // only show the ad if we aren't backed up with other plays ready to bet shown
	              show(type);
	            }, timeout);
	          }
	        }
	      }
	    };
	    /**
	     * [show Function to show the ad based on type]
	     * @param  {[type]} type [Type of ad used; value can be "Pre-Roll", "Mid-Roll" and "Post-Roll"]
	     * @return {[type]}      [returns the ad in the targeted container]
	     */
	    var show = function show(type) {
	
	      var targetReplaceIdTag = 'gbVideoPlayer';
	      var adSet = cms;
	
	      /**
	       * [insertAd Function to insert the Ad unit based on location]
	       * @return {[type]} [creates OBJECT tag for video ad in the targetReplaceId]
	       */
	      var insertAd = function insertAd() {
	        var adParams = {
	          adUnit: type, //(String) Determines the playback position of the adSet.  Value can be "Pre-Roll", "Mid-Roll" and "Post-Roll".
	          adSet: adSet, //(String) Indicates the adSetCode to be used. Values can be "espn", "deportes", "intl" or "intl-domestic".
	          midSequence: 0,
	          siteSection: siteSectionTarget, //(String) The Freewheel Site Section.
	          videoId: videoIdTarget, //(String) Colon delimitted list of the first two parts of the siteSection.
	          targetReplaceId: targetReplaceIdTag //(String) ID of div where the ooyala player will be loaded dynamically
	
	
	          //Don't load the ooyala player outside of the component if main div#gbVideoPlayer is not found
	        };if (jQuery('#' + targetReplaceIdTag).length === 0) {
	          return false;
	        }
	
	        if (jQuery.cookie('gamebreak') === '1' || jQuery.cookie('gamebreak') === 'hide') {
	          return false;
	        }
	
	        jQuery('#gamepackage-gamebreak').show();
	
	        //console.log('=======AD HAS STARTED PLAYING======')
	
	        espn.video.insertAd(adParams, cms);
	
	        var expires = new Date();
	        expires.setTime(expires.getTime() + MIN_TIME_BETWEEN_ADS * 60 * 1000);
	        jQuery.cookie('gamebreak', '1', { expires: expires });
	
	        // at this point we've inserted the video player..
	        // if we don't hear anything from it (ie ad hasn't started)
	        // within 15 seconds, remove it.
	        fallbackTimeoutHook = setTimeout(remove, 15000);
	      };
	      //check for location, then load the ad based on location
	      if (cms === 'intl') {
	        var intlDomesticCountries = ['us', 'in'];
	        espn.geo.getLocation().done(function (loc) {
	          var country_code = espn_util.find(loc || {}, ['country', 'isoCodeAlpha2']) || '';
	          adSet = intlDomesticCountries.indexOf(country_code) !== -1 ? 'intl-domestic' : cms;
	          insertAd();
	        });
	      } else {
	        insertAd();
	      }
	    };
	    /**
	     * [init Init the ad based on gamestatus and if flash is available]
	     * @return {[type]} []
	     */
	    function init() {
	      if (_gamestatus === 'in' && _isIncompatibleBrowser === false) {
	        playHook = jQuery.subscribe('gamepackage:play', initAd);
	        // jQuery.subscribe('espn.video.error', remove);
	        // jQuery.subscribe('espn.video.unavailable', remove);
	        adStartHook = jQuery.subscribe('espn.video.ad.start', onAdStart);
	        completeHook = jQuery.subscribe('espn.video.complete', remove);
	        jQuery(document).on('page.beforeload', onBeforeLoad);
	
	        initAd();
	      }
	    }
	    /**
	     * [onPageRender Function to call init, if game page on document load complete]
	     * @return {[type]} [description]
	     */
	    function onPageRender() {
	      if (config && (config.type === 'game' || config.type === 'match') && typeof _gameId !== 'undefined') {
	        if (typeof _gamebreakstatus !== 'undefined') {
	          init();
	        }
	      }
	    }
	
	    onPageRender();
	  },
	
	  inviewAdRevert: function inviewAdRevert() {
	    var _independent = [];
	    var adClass = '.ad-slot.loaded';
	    var $el = void 0;
	    _independent = jQuery('body').find(adClass);
	    if (_independent.length > 0) {
	      for (var i = 0, l = _independent.length; i < l; i++) {
	        $el = _independent.eq(i);
	        if ($el.length === 1) {
	          $el.removeClass('ad-slot loaded').addClass('ad-slot-independent');
	        }
	      }
	    }
	  },
	
	  loadInViewAds: function loadInViewAds() {
	    var _inview = [];
	
	    function pageRender() /*e, url, html, data*/{
	      var adClass = '.ad-slot-independent';
	      _inview = jQuery('body').find(adClass);
	      if (_inview.length > 0) {
	        registerInviewAds({
	          refresh: true
	        });
	        adScrollevent('on');
	      } else {
	        adScrollevent('off');
	      }
	    }
	
	    function adScrollevent(type) {
	      try {
	        var $window = jQuery(window);
	
	        if (type === 'on') {
	          $window.on('windowscroll.debounce.ads', initInviewAds);
	        } else {
	          $window.off('windowscroll.debounce.ads', initInviewAds);
	        }
	      } catch (err) {
	        console.log(err);
	      }
	    }
	
	    function registerInviewAds(obj) {
	      var found = false;
	      var $el = void 0;
	      for (var i = 0, l = _inview.length; i < l; i++) {
	        $el = jQuery(_inview[i]);
	        if ($el.length === 1 && !$el.hasClass('loaded') && isAdInViewport(getAdReqCatalystElement($el[0]))) {
	          $el.addClass('ad-slot loaded').removeClass('ad-slot-independent');
	
	          if (obj && obj.refresh === true) {
	            admgr.registerSlot($el[0], espn.ads.config);
	          }
	
	          _inview.splice(i, 1);
	          found = true;
	          break;
	        }
	      }
	      return found;
	    }
	
	    function initInviewAds(force) {
	      var found = false;
	      var $el = void 0;
	      for (var i = 0, l = _inview.length; i < l; i++) {
	        $el = jQuery(_inview[i]);
	        if ($el.length === 1 && !$el.hasClass('loaded') && (isAdInViewport(getAdReqCatalystElement($el[0])) || force === true)) {
	          $el.addClass('ad-slot loaded').removeClass('ad-slot-independent');
	          admgr.initSlot($el[0], espn.ads.config);
	          _inview.splice(i, 1);
	          found = true;
	
	          // we found the ad, no need to keep listening to scrolls
	          if (_inview.length === 0) {
	            adScrollevent('off');
	          }
	          break;
	        }
	      }
	      return found;
	    }
	
	    function getAdReqCatalystElement(element) {
	      return element.className.indexOf('native') > -1 ? element.previousElementSibling : element;
	    }
	
	    function isAdInViewport(el) {
	      var rect = el.getBoundingClientRect();
	      if (rect.top === 0 && rect.bottom === 0) {
	        return false;
	      }
	      return rect.top >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight) || rect.bottom >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
	    }
	
	    pageRender();
	  },
	
	  updateKeyValue: function updateKeyValue() {
	    var edition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var pageState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	    var kvevent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
	    var kvbattingteam = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
	
	    if (edition.hasOwnProperty('isEspnCricinfo') === true) {
	      if (edition.isEspnCricinfo && meta) {
	        var platform = params.platform,
	            pageType = params.pageType,
	            league = params.league,
	            gameId = params.gameId;
	
	        var leagueName = meta && meta.leagueName || '';
	        if (pageState === 'scoreboard') {
	          leagueName = meta.title ? meta.title.substring(0, meta.title.lastIndexOf('-')) : '';
	        }
	        if (leagueName.length === 0) {
	          leagueName = params.slug || '';
	        }
	        var kvObj = {};
	        if (leagueName && typeof leagueName === 'string') {
	          leagueName = leagueName.replace(/\W+/g, '');
	          leagueName = leagueName.toLowerCase();
	        }
	        if (pageType === 'scores') {
	          kvObj.kvpt = pageState;
	          kvObj.pgtyp = pageState;
	        } else if (pageType === 'standings') {
	          kvObj.kvpt = 'pointstable';
	        } else if (pageType === 'table') {
	          kvObj.kvpt = 'table';
	        } else {
	          kvObj.kvpt = 'livescorecard';
	          if (pageState === 'final') {
	            kvObj.kvpt = 'archivedscorecard';
	          }
	          kvObj.kvsite = leagueName;
	          kvObj.pgtyp = 'game';
	        }
	
	        if (typeof platform !== 'undefined') {
	          kvObj.kvos = platform;
	        }
	        if (pageType === 'scores' && pageState === 'scoreboard') {
	          kvObj.kvsite = leagueName;
	          kvObj.kvbrand = leagueName;
	        }
	        if (pageType !== 'scores') {
	          kvObj.kvsite = leagueName;
	          kvObj.kvbrand = '';
	          kvObj.kvseriesid = league || '';
	          kvObj.kvmatchid = gameId || '';
	        }
	        kvObj.kvevent = kvevent;
	        kvObj.kvbattingteam = kvbattingteam;
	        ads.updateAdsKvps(kvObj, pageType);
	      }
	    }
	  },
	  /**
	  * Add key value pair for ads
	  * @param {Object} kvObj key values details
	  * @param {String} pageType page type info
	  * @set key value pairs and pass to espn.ads.config.kvps
	  * @return {undefined} undefined
	  */
	  updateAdsKvps: function updateAdsKvps() {
	    var kvObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var pageType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	    try {
	      var kvps = espn.ads.config.kvps || [];
	      var adLevel = '';
	
	      if (pageType.length > 0) {
	        if (pageType === 'scores') {
	          adLevel = 'espn.cricinfo.com/matches/liveindex';
	        } else if (pageType === 'standings') {
	          adLevel = 'espn.cricinfo.com/standings/series/' + kvObj.kvsite;
	        } else if (pageType === 'table') {
	          adLevel = 'espn.cricinfo.com/table/series/' + kvObj.kvsite;
	        } else {
	          adLevel = 'espn.cricinfo.com/game/' + pageType;
	        }
	      }
	
	      espn.ads.config.level = adLevel;
	
	      var _loop = function _loop(key) {
	        if (kvObj.hasOwnProperty(key)) {
	
	          var objIndex = kvps.findIndex(function (obj) {
	            return obj.name == key;
	          });
	
	          if (objIndex === -1) {
	            kvps.push({
	              'name': key,
	              'value': kvObj[key]
	            });
	          } else if (objIndex > 1) {
	
	            for (var k in kvps) {
	              if (kvps.hasOwnProperty(k)) {
	                if (kvps[k].name === key) {
	                  kvps[k].value = kvObj[key];
	                }
	              }
	            }
	          }
	        }
	      };
	
	      for (var key in kvObj) {
	        _loop(key);
	      }
	    } catch (err) {
	      console.log(err);
	    }
	  },
	
	  init: function init(adblock) {
	    var edition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    if (adblock === true) {
	      return false;
	    }
	
	    // Begin CMS-enabled sponsored content providers setup
	    var _ = window._ || {};
	    var espn = window.espn || {};
	    var espnI18N = espn.i18n || {};
	    var sponsoredContentProviders = edition && edition.sponsoredContentProviders || [];
	    var numSponsoredContentProviders = sponsoredContentProviders.length;
	    var cmsEnabledSponsoredContentProviders = [];
	    var espnStorage = espn && espn.storage || {};
	    var config = espn.ads.config;
	    // if cookie contains 'ESPN_PLUS' that means the fan has E+ and should not get ads
	    var espnPlusEntitle = espnStorage && espnStorage.getItem('ESPN_PLUS') === 1 ? true : false;
	    if (espnPlusEntitle === true) {
	      jQuery('.ad-slot').removeClass(); // remove white space
	      return false;
	    }
	    for (var i = 0; i < numSponsoredContentProviders; i++) {
	      var sponsoredContentProvider = sponsoredContentProviders[i];
	      // We only care about the CMS flag because we rely on Reduxion edition configs
	      // instead of sCore edition configs
	      if (_.get(espnI18N, [sponsoredContentProvider, 'cmsEnabled'])) {
	        cmsEnabledSponsoredContentProviders.push(sponsoredContentProvider);
	      }
	    }
	    if (cmsEnabledSponsoredContentProviders.length) {
	      espn.ads = espn.ads || {};
	      espn.ads.config = espn.ads.config || {};
	      espn.ads.config.cmsEnbldSpnsrdCntntPrvdrs = cmsEnabledSponsoredContentProviders.join(',');
	    }
	    // End CMS-enabled sponsored content providers setup
	    var refreshRate = config.refreshRate || 0;
	    if (refreshRate > 0 && edition.isEspnCricinfo && !edition.isAsiaRegion) {
	      refreshRate = config.refreshRateOther || 0;
	    }
	    try {
	      admgr.init((0, _extends3.default)({}, config, { refreshRate: refreshRate, refreshWhenVideoPlays: true }));
	    } catch (e) {
	      console.error(e);
	    }
	  },
	  get: function get(type) {
	    try {
	      var arr = admgr.getGPTArray() || [];
	      for (var i = 0, len = arr.length; i < len; i++) {
	        if (arr[i].type === type) {
	          return arr[i];
	        }
	      }
	    } catch (e) {
	      console.log(e);
	    }
	    return null;
	  },
	  refresh: function refresh(slot) {
	    try {
	      var ad = this.getAd(slot);
	      if (ad !== null) {
	        admgr.refresh([ad]);
	      }
	    } catch (e) {
	      console.log(e);
	    }
	  },
	  refreshAdOnEvent: function refreshAdOnEvent(adSlot) {
	    try {
	      if (adSlot !== null) {
	        admgr.initSlot(adSlot, espn.ads.config);
	      }
	    } catch (e) {
	      console.log(e);
	    }
	  },
	  refreshAll: function refreshAll() {
	    admgr.refreshAll();
	  },
	  getSlot: function getSlot(type) {
	
	    var attrs = [];
	
	    attrs.push('data-slot-type="' + type + '"', 'data-slot-kvps="pos=' + type + '"');
	    if (type === 'presbyHeader') {
	      attrs.push('class="scoreboard-dropdown-wrapper presby-ad react-ad ad-slot ad-slot-presby"', 'data-exclude-bp="s"');
	    } else {
	      attrs.push('class="react-ad ad-slot ad-slot-' + type + '"');
	    }
	
	    if (type === 'wallpaper') {
	      attrs.push('data-collapse-before-load="true"');
	    }
	
	    if (type === 'overlay') {
	      attrs.push('data-out-of-page="true"');
	    }
	
	    return '<div ' + attrs.join(' ') + ' />';
	  },
	  unloadAds: function unloadAds() {
	    jQuery('.ad-slot').removeAttr('data-disabled').empty();
	    admgr.resetDisabledTypes();
	  }
	};
	
	exports.default = ads;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, console) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getSiteType = exports.urlWithParams = exports.showCopyrightVideo = exports.isGeoRestricted = undefined;
	
	var _promise = __webpack_require__(370);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _values = __webpack_require__(431);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _keys = __webpack_require__(419);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getIterator2 = __webpack_require__(435);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _typeof2 = __webpack_require__(312);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.throttle = throttle;
	exports.isPropertyTruthy = isPropertyTruthy;
	exports.isObjectEmpty = isObjectEmpty;
	exports.scrollLock = scrollLock;
	exports.getPlayerRoles = getPlayerRoles;
	exports.getBatsmanComm = getBatsmanComm;
	exports.deviceType = deviceType;
	exports.relativeDate = relativeDate;
	exports.getScorePageType = getScorePageType;
	exports.hasRouteChanged = hasRouteChanged;
	exports.hasStandingChanged = hasStandingChanged;
	exports.poll = poll;
	exports.mapTemplateToReducer = mapTemplateToReducer;
	exports.getBallClass = getBallClass;
	exports.isCurrentLeague = isCurrentLeague;
	exports.getYearDropDown = getYearDropDown;
	exports.compose = compose;
	exports.getConnectionSpeed = getConnectionSpeed;
	exports.isDataLiteEligible = isDataLiteEligible;
	exports.isCricAppWebView = isCricAppWebView;
	exports.getDevice = getDevice;
	exports.getAppType = getAppType;
	exports.getHostInfo = getHostInfo;
	exports.isLibraryLoaded = isLibraryLoaded;
	exports.getCountrySupportedRegion = getCountrySupportedRegion;
	exports.isEspnCricinfo = isEspnCricinfo;
	exports.isBet365KioskEdition = isBet365KioskEdition;
	exports.getMpuIndex = getMpuIndex;
	exports.getTrackingImg = getTrackingImg;
	exports.isEspnCricinfoIn = isEspnCricinfoIn;
	exports.showBottomAdModule = showBottomAdModule;
	exports.getBet365Odds = getBet365Odds;
	exports.getToWinOdds = getToWinOdds;
	exports.getToWinTheToss = getToWinTheToss;
	exports.getManOfTheMatchOdds = getManOfTheMatchOdds;
	exports.getBet365Nbo = getBet365Nbo;
	exports.getPlayerDismissalMethodOdds = getPlayerDismissalMethodOdds;
	exports.getDrawNoBetOdds = getDrawNoBetOdds;
	exports.getBet365 = getBet365;
	exports.getUpdatedAffiliateCode = getUpdatedAffiliateCode;
	exports.getCricketCanonical = getCricketCanonical;
	exports.redirectToCanonical = redirectToCanonical;
	exports.hasValidPageParams = hasValidPageParams;
	exports.isPageHidden = isPageHidden;
	exports.loadScript = loadScript;
	exports.generateEventsTeam = generateEventsTeam;
	exports.generateScoreEvent = generateScoreEvent;
	exports.generateWicketEvent = generateWicketEvent;
	exports.generateGameStatusEvent = generateGameStatusEvent;
	exports.generateEvents = generateEvents;
	
	var _selectn = __webpack_require__(438);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	var _countryToRegion = __webpack_require__(446);
	
	var _kveventsBreaks = __webpack_require__(447);
	
	var _editions = __webpack_require__(448);
	
	var _dateformat = __webpack_require__(449);
	
	var _dateformat2 = _interopRequireDefault(_dateformat);
	
	var _map2 = __webpack_require__(702);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _compact2 = __webpack_require__(758);
	
	var _compact3 = _interopRequireDefault(_compact2);
	
	var _url = __webpack_require__(759);
	
	var _url2 = _interopRequireDefault(_url);
	
	var _queryString = __webpack_require__(207);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * create and returns a thortted function
	 * @param  {Function} callback - function to be throttled
	 * @param  {Number}   limit    - milliseconds
	 * @return {[type]}            thortted function
	 */
	function throttle(callback, limit) {
	  var wait = false;
	  return function () {
	    if (!wait) {
	      callback.call();
	      wait = true;
	      setTimeout(function () {
	        wait = false;
	      }, limit);
	    }
	  };
	}
	
	/**
	 * Check if a object's property holds truthy value.(string true or boolean true)
	 *
	 * @param  {Object}  input input object on which property needs to be checked
	 * @param  {String}  key   property name
	 * @return {Boolean}       true of input[key] is truthy else false
	 */
	/* global jQuery Modernizr espn_ui */
	function isPropertyTruthy() {
	  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  if (input) {
	    if (input.hasOwnProperty(key) === false) {
	      return false;
	    }
	    //  Get the actual value
	    var value = input[key];
	    // Check if typeof is a boolean and equals to true
	    if (typeof value === 'boolean' && value === true) {
	      return true;
	    }
	    // Check if typeof is a string and equals to 'true'
	    if (typeof value === 'string' && value === 'true') {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Check if an object is empty i.e. if it has a property
	 * @param  {Object}  input input object
	 * @return {Boolean}       true if object is empty else false
	 */
	function isObjectEmpty() {
	  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  for (var k in input) {
	    if (input.hasOwnProperty(k)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	function scrollLock(flag) {
	  var scrollLockClass = 'scroll-locked';
	
	  if (flag === true) {
	    jQuery('body').addClass(scrollLockClass);
	  } else {
	    jQuery('body').removeClass(scrollLockClass);
	  }
	}
	
	/**
	 * Get player roles (e.g. captain, wicket keeper).
	 * If valid return as is. Else return empty string.
	 * @param  {String} name  player name
	 * @param  {String} roles captain & wicket keeper roles
	 * @param  {String} comma if multiple players passed
	 * @return {Object}  name & roles & comma based on multiple players
	 */
	function getPlayerRoles() {
	  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var roles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var comma = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	  var sanitizedRoles = '';
	  // default return string
	  var playerRoleDisplayable = '';
	  // Store name & roles & comma if available
	  var playerRole = [];
	
	  if (name !== '') {
	    playerRole.push(name);
	  }
	  // Allow only captain and wicket keeper roles.
	  if (roles.indexOf('(c)') > -1 || roles.indexOf('&dagger;') > -1) {
	    sanitizedRoles = roles;
	    // Role should have a comma after player name, else it is not readable
	    playerRole.push(' ' + sanitizedRoles);
	  }
	  // Append comma only if passed as argument
	  if (comma !== '') {
	    playerRole.push(comma);
	  }
	  // Join only if fields are pushed to playerRole
	  if (playerRole.length !== 0) {
	    playerRoleDisplayable = playerRole.join('');
	  }
	  //console.info('playerRoleDisplayable', playerRoleDisplayable)
	  return { __html: playerRoleDisplayable };
	}
	
	/**
	 * Get commentary for a batsman.
	 * Displays how a batsman got out or is not out
	 *
	 * @param  {Object} batsman       batsman details
	 * @param  {Number} i             batting order number
	 * @param  {Number} id            innings order number
	 * @param  {Boolean} hideOutComm  true if out commentary should be hidden
	 * @return {Object}         commentary markup
	 */
	function getBatsmanComm() {
	  var batsman = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var i = arguments[1];
	  var id = arguments[2];
	  var hideOutComm = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  // Use this flag to determine if batsman how out comms needs to be shown
	  var displayMore = true;
	  var shortComm = void 0;
	
	  // Display Not out for a not out batsman
	  if (batsman.isNotOut === true || batsman.shortText.indexOf('absent hurt') > -1) {
	    displayMore = false;
	    shortComm = batsman.isNotOut === true ? 'Not Out' : batsman.shortText;
	  }
	  // If commentary is not available or should not be shown, show only short text
	  if (batsman.commentary == '' || hideOutComm) {
	    displayMore = false;
	    shortComm = batsman.shortText;
	  }
	  //console.info('displayMore', displayMore)
	
	  var markup = '';
	  // Display shortComm if no commentary is available
	  if (displayMore === false) {
	    markup = shortComm;
	  }
	  // Else show markup of expand collapse hyperlink
	  else {
	      markup = '<a class="icon-font-before collapsed" role="button" data-toggle="collapse" href="#commentary-00' + (i + 1) + '-' + id + '" aria-expanded="true" aria-controls="commentary-00' + (i + 1) + '">' + batsman.shortText + '</a>';
	    }
	  return { __html: markup };
	}
	
	function deviceType() {
	  try {
	    if (process.browser) {
	      var media_query_in_use = espn_ui.media_query_in_use || '';
	      var _deviceType = { isTouch: false };
	
	      switch (media_query_in_use) {
	        case 'mobile':
	          _deviceType.isMobile = true;
	          break;
	        case 'tablet':
	          _deviceType.isTablet = true;
	          break;
	        case 'desktop':
	          _deviceType.isDesktop = true;
	          break;
	        case 'desktop-lg':
	          _deviceType.isDesktopXX = true;
	          break;
	      }
	
	      _deviceType.isTouch = Modernizr && Modernizr.touch;
	
	      return _deviceType;
	    } else {
	      // return empty Object in server rendering to avoid error
	      return {};
	    }
	  } catch (err) {
	    console.log(err);
	  }
	}
	
	function relativeDate(date) {
	  // logic copied from sCore tea/core-tea/src/main/tea/format/util/relativeDate.tea
	  var displayTime = date;
	
	  if (date instanceof Date) {
	    var timeToShow = (new Date() - date.getTime()) / 60000;
	    var wordToShow = 'm';
	
	    if (timeToShow <= 0) {
	      timeToShow = 1;
	    }
	    if (timeToShow >= 60) {
	      timeToShow = Math.round(timeToShow / 60.0);
	      if (timeToShow < 24) {
	        wordToShow = 'h';
	      } else {
	        timeToShow = Math.round(timeToShow / 24.0);
	        wordToShow = 'd';
	      }
	    }
	    displayTime = Math.round(timeToShow) + wordToShow;
	  }
	
	  return displayTime;
	}
	
	var isGeoRestricted = exports.isGeoRestricted = function isGeoRestricted() {
	  var geoRestrictions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var userCountry = arguments[1];
	
	  var type = geoRestrictions.type || '';
	  var countries = geoRestrictions.countries || [];
	  if (!(userCountry && type && countries.length)) {
	    return type === 'whitelist';
	  }
	  if (countries.indexOf(userCountry) !== -1) {
	    return type === 'blacklist';
	  } else {
	    return type === 'whitelist';
	  }
	};
	
	/**
	 * To show or restrict video with certain copyright text in site, domain or app
	 * @param  {Object} copyRightText Text for copyright
	 * @param  {Object} config        options for geo, webview, edition etc
	 * @return {Boolean}              to show or not
	 */
	var showCopyrightVideo = exports.showCopyrightVideo = function showCopyrightVideo() {
	  var copyRightText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var isWebView = config.isWebView,
	      site = config.site,
	      userGeo = config.userGeo,
	      domain = config.domain;
	
	  var toShow = true;
	  var isEspnInApp = false;
	  var isEspnInWeb = false;
	
	  copyRightText = copyRightText ? copyRightText.bundle ? copyRightText.bundle.toLowerCase() : '' : {};
	
	  if (isWebView && site === 'espn' && userGeo === 'in') {
	    isEspnInApp = true;
	  } else if (site === 'espn' && domain === 'www.espn.in') {
	    isEspnInWeb = true;
	  }
	
	  //video with copyright text 'sony_rights_content' only to show in ESPN India website and ESPN India app
	  if (copyRightText === 'sony_rights_content') {
	    if (isEspnInApp || isEspnInWeb) {
	      toShow = true;
	    } else {
	      toShow = false;
	    }
	  }
	
	  return toShow;
	};
	
	function getScorePageType() {
	  var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var scoreboardType = arguments[1];
	
	  var query = location.query;
	  var defaultDate = new Date();
	  var scorePageType = 'scoreboard';
	  if (scoreboardType === 'default') {
	    scorePageType = 'liveindex';
	  }
	  if (query.date && scoreboardType === 'default') {
	    if (_dateformat2.default.dateToObject(query.date || '').setHours(0, 0, 0, 0) > defaultDate.setHours(0, 0, 0, 0)) {
	      scorePageType = 'fixtures';
	    } else if (_dateformat2.default.dateToObject(query.date || '').setHours(0, 0, 0, 0) < defaultDate.setHours(0, 0, 0, 0)) {
	      scorePageType = 'results';
	    }
	  }
	  return scorePageType;
	}
	
	function hasRouteChanged() {
	  var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var newLocation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var currentPath = location.pathname + location.search;
	  var changedPath = newLocation.pathname + newLocation.search;
	  if (changedPath === currentPath) {
	    return false;
	  } else {
	    return true;
	  }
	}
	
	function hasStandingChanged() {
	  var leagueId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var currleagueId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var season = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	  var currentSeason = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	
	  if (leagueId === currleagueId && season === currentSeason) {
	    return false;
	  } else {
	    return true;
	  }
	}
	
	/**
	 * Enables polling data in a container
	 * @param  {Array}  actions actions
	 * @return {void}
	 */
	function poll() {
	  var _this = this;
	
	  var actions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var _props = this.props,
	      dispatch = _props.dispatch,
	      _props$polling = _props.polling,
	      polling = _props$polling === undefined ? {} : _props$polling,
	      appProps = _props.appProps;
	  var enabled = polling.enabled,
	      duration = polling.duration;
	
	  if (this.timer === null && enabled === true) {
	    this.timer = window.setInterval(function () {
	      // Run a route change check with window.location
	      // This prevents polling in the background after,
	      // if user has moved outside of a React page
	      var _props2 = _this.props,
	          edition = _props2.edition,
	          location = _props2.location,
	          params = _props2.params,
	          _props2$polling = _props2.polling,
	          polling = _props2$polling === undefined ? {} : _props2$polling;
	
	      if (!hasRouteChanged(location, window.location) && polling.enabled) {
	        actions.map(function (action) {
	          dispatch(action({ edition: edition, params: params, location: location, isPolling: true, appProps: appProps }));
	        });
	      } else {
	        //console.info(`cleared timer: ${params.pageType}`)
	        window.clearInterval(_this.timer);
	        _this.timer = null;
	      }
	    }.bind(this), duration);
	  }
	}
	
	var urlWithParams = exports.urlWithParams = function urlWithParams() {
	  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	  return url + (url.indexOf('?') === -1 ? '?' : '&') + Array.prototype.slice.call(arguments).slice(1).join('&');
	};
	/**
	 * This method will return appropriate reducer mapping
	 * @param {string} template template name
	 * @return {string} reducer name
	 */
	function mapTemplateToReducer(template) {
	  var map = {
	    'gamepackage': 'gamePackage',
	    'gamepackage-webview-ios': 'gamePackage',
	    'gamepackage-webview-android': 'gamePackage'
	  };
	  return map[template] || template;
	}
	
	/**
	 * Get class name for a ball by ball commentary event
	 * @param  {String} event as received from the commentary
	 * @return {String}       class name which will be used by components
	 */
	function getBallClass() {
	  var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	  // array to hold all class names
	  var allClasses = ['over-circle'];
	  // default value of class name for a ball
	  var eventClassName = 'low-score';
	
	  if (event === 'W') {
	    eventClassName = 'wicket';
	  } else if (event >= 4) {
	    eventClassName = 'high-score';
	  }
	  // Append required class name to array and create final string
	  allClasses.push(eventClassName);
	  var classString = allClasses.join(' ');
	
	  return classString;
	}
	
	function isCurrentLeague(startDate, endDate, currDate) {
	  var isCurrent = false;
	  if (currDate > startDate && currDate < endDate) {
	    isCurrent = true;
	  } else {
	    isCurrent = false;
	  }
	  return isCurrent;
	}
	
	function getYearDropDown() {
	  var currYear = new Date().getFullYear();
	  var startYear = currYear - 6;
	  var yearFliter = [];
	
	  for (var i = currYear; i > startYear; i--) {
	    yearFliter.push({
	      name: i,
	      text: i
	    });
	  }
	  return yearFliter;
	}
	
	/*!
	 *
	 * Copyright (c) 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative
	 * Reporters & Editors
	
	 * Permission is hereby granted, free of charge, to any person
	 * obtaining a copy of this software and associated documentation
	 * files (the "Software"), to deal in the Software without
	 * restriction, including without limitation the rights to use,
	 * copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the
	 * Software is furnished to do so, subject to the following
	 * conditions:
	
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	
	 * Returns a function that is the composition of a list of functions, each
	 * consuming the return value of the function that follows.
	 * @return {Function} composed function
	 */
	function compose() {
	  var args = arguments;
	  var start = args.length - 1;
	  return function () {
	    var i = start;
	    var result = args[start].apply(this, arguments);
	    while (i--) {
	      result = args[i].call(this, result);
	    }return result;
	  };
	}
	
	/**
	 * get connection speed
	 * @param  {Object} req request object
	 * @param {Object} routeParams object
	 * @param {String} template (gamepackage)
	 * @return {String} connectionspeed (data-lite|full)
	 */
	function getConnectionSpeed() {
	  var req = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var routeParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var template = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	  var query = req.query || {};
	  var connectionSpeeds = ['data-lite', 'full'];
	  var connectionSpeed = 'full';
	
	  // by default force cric app to use data-lite
	  if (isCricAppWebView(req, routeParams, template)) {
	    connectionSpeed = 'data-lite';
	  }
	
	  // for debugging and testing, let people force data-lite or full via query param
	  var tmpConnectionSpeed = query.connectionspeed;
	  if (connectionSpeeds.indexOf(tmpConnectionSpeed) !== -1) {
	    connectionSpeed = tmpConnectionSpeed;
	  } else if (isDataLiteEligible(req, routeParams)) {
	    // if user isn't forcing a connectionSpeed, and if the site can use data-lite, use connectionSpeed from headers in avai'able
	    tmpConnectionSpeed = req.headers && req.headers['x-connectionspeed'] || connectionSpeed;
	    if (connectionSpeeds.indexOf(tmpConnectionSpeed) !== -1) {
	      connectionSpeed = tmpConnectionSpeed;
	    }
	  }
	  return connectionSpeed;
	}
	
	var dataLiteCountries = ['in', 'pk', 'lk', 'bd'];
	var dataLiteSites = ['espncricinfo'];
	
	/*
	 * only users with specific site / country values will be eligble to view data-lite version of site
	 * should follow the same logic in sCore, as defined (https://goo.gl/Fksd1m)
	*/
	function isDataLiteEligible() {
	  var req = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var routeParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _req$edition = req.edition,
	      site = _req$edition.site,
	      country = _req$edition.userGeo;
	
	  var isWebView = routeParams.webview;
	
	  if (!country) {
	    console.warn('user country not detected, falling back to edition country');
	    country = req.edition.country;
	  }
	  return dataLiteCountries.indexOf(country) !== -1 && dataLiteSites.indexOf(site) !== -1 && !isWebView;
	}
	
	function isCricAppWebView() {
	  var req = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var routeParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var template = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	
	  var query = req.query || {};
	  var appsrc = query.appsrc,
	      appName = query.appName;
	
	  var editionHost = query['edition-host'];
	  var platform = routeParams.platform;
	
	  var environment = (0, _editions.getEnvironment)(req);
	  var cricAppDataLiteEnvironments = ['qa', 'dev', 'local'];
	  var device = getDevice(req);
	  var isAppLite = getAppType(device, req.edition);
	  if (typeof template !== 'undefined') {
	    if (!isAppLite && cricAppDataLiteEnvironments.indexOf(environment) !== -1 && template.indexOf('gamepackage') === 0) {
	      if (appsrc === 'cricinfo') {
	        // future iOS builds of CricInfo after 5.01
	        return true;
	      } else if (appsrc === 'sc' && editionHost === 'espncricinfo.com') {
	        // current iOS build for CricInfo app
	        return true;
	      } else if ((platform === 'android' || platform === 'ios') && editionHost === 'espncricinfo.com') {
	        // Android CricInfo article XHR and game pages
	        return true;
	      } else if (platform === 'android' && appName === 'cricinfo') {
	        // Android static shell for article pages
	        return true;
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * get site type alias for getConnectionSpeed
	 * @param  {Object} req request object
	 * @return {String} siteType (data-lite|full)
	 */
	var getSiteType = exports.getSiteType = getConnectionSpeed;
	
	/**
	 * get device type
	 * @param  {Object} req request object
	 * @return {String}     device type
	 */
	function getDevice(req) {
	  var query = req.query || {};
	  var device = query.device || req.headers && req.headers['x-device'] || 'desktop';
	
	  // porting existing Tea logic
	  // TODO: detection based on cookie for non varnish (local) requests
	  if (device == 'pc' || device == 'tv') {
	    device = 'desktop';
	  } else if (device == 'mobile-smartphone' || device == 'handset') {
	    device = 'mobile';
	  } else if (device == 'mobile-generic') {
	    device = 'featurephone';
	  } else if (device == 'pc-generic') {
	    device = 'featurephone';
	  }
	
	  if (device != 'tablet' && device != 'mobile' && device != 'featurephone') {
	    device = 'desktop';
	  }
	  return device;
	}
	
	function getAppType() {
	  var device = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var edition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var host = edition.host || '';
	  var liteAppHosts = ['espncricinfo.com', 'espncricinfosb.com'];
	
	  if (device === 'featurephone' && liteAppHosts.indexOf(host) >= 0) {
	    return true;
	  } else {
	    return false;
	  }
	}
	/**
	   * Get hostInfo from editions
	   * Returns hostInfo based on host in editions
	   * @param {String} host host
	   * @return {String} hostInfo
	  */
	function getHostInfo(host) {
	  var hostInfo = 'ESPN';
	  if (host && typeof host === 'string') {
	    switch (host.toLowerCase()) {
	      case 'espncricinfo.com':
	        hostInfo = 'ESPNCricinfo';
	        break;
	      case 'espncricinfosb.com':
	        hostInfo = 'ESPNCricinfo';
	        break;
	      default:
	        hostInfo = 'ESPN';
	    }
	  }
	  return hostInfo;
	}
	
	/**
	 * Helper function that triggers a callback when the given library is loaded
	 * @param  {String}   namespace Namespace of the library
	 * @param  {Object}   cntx      Context on which library would be mounted
	 * @param  {Number}   interval  Interval b/w recursive call
	 * @param  {Function} callback  Callback function (use Arrow function or function(){}.bind(this) if Fn definition uses 'this' operator)
	 * @return {undefined}
	 */
	function isLibraryLoaded(_ref) {
	  var namespace = _ref.namespace,
	      _ref$cntx = _ref.cntx,
	      cntx = _ref$cntx === undefined ? window : _ref$cntx,
	      interval = _ref.interval,
	      callback = _ref.callback;
	
	  var timer = void 0;
	
	  if (typeof namespace !== 'string' || typeof callback !== 'function' || cntx && (typeof cntx === 'undefined' ? 'undefined' : (0, _typeof3.default)(cntx)) !== 'object') {
	    return;
	  }
	
	  // set default time interval
	  if (isNaN(interval)) {
	    interval = parseInt(interval, 10);
	
	    if (isNaN(interval)) {
	      interval = 300;
	    }
	  }
	
	  var checkNamespace = function checkNamespace() {
	    window.clearTimeout(timer);
	    try {
	      if (typeof cntx[namespace] !== 'undefined') {
	        callback();
	      } else {
	        timer = window.setTimeout(checkNamespace, interval);
	      }
	    } catch (err) {
	      console.error(err);
	    }
	  };
	
	  // init
	  checkNamespace();
	}
	
	function getCountrySupportedRegion(country) {
	  var region = '';
	  if (typeof country === 'string') {
	    region = _countryToRegion.COUNTRY_REGION[country] || region;
	  }
	  //console.info('region', region)
	  return region;
	}
	
	/**
	   * Get isEspnCricinfo from host
	   * Returns isEspnCricinfo based on host
	   * @param {String} host host
	   * @param {String} editionKey editionKey
	   * @return {String} isEspnCricinfo
	  */
	function isEspnCricinfo(host, editionKey) {
	  var isEspnCricinfo = false;
	  var key = host + ' ' + editionKey;
	  if (key && typeof key === 'string' && key.indexOf('espncricinfo') > -1) {
	    isEspnCricinfo = true;
	  }
	  return isEspnCricinfo;
	}
	
	/**
	   * List supported bet365 kiosk ad editions
	   * @param  {Object} edition  edition object
	   * @return {Boolean}  true if bet365 kiosk should appear for passed edition
	  */
	function isBet365KioskEdition() {
	  var edition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var supportedEditions = {
	    'espnww-en': true,
	    'espnuk-en': true,
	    'espnau-en': true
	  };
	  return supportedEditions[edition.editionKey] ? true : false;
	}
	
	/**
	 * Get 2nd MPU index value on RHS gamepackage module
	 * @param  {Integer} highlightsVideoCount  heighlight counts
	 * @param  {Object} standings object
	 * @param  {Object} matchcards object
	 * @param  {Object} news object
	 * @return {Integer}  Index value
	 */
	function getMpuIndex() {
	  var highlightsVideoCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	  var standings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var matchcards = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var news = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var newsCount = news.items ? news.items.length : 0;
	  var matchcardsCount = matchcards.length;
	  var standingsCount = standings.teams ? standings.teams.length : 0;
	
	  if (highlightsVideoCount > 0) {
	    return 4;
	  } else if (newsCount > 0) {
	    return 5;
	  } else if (matchcardsCount > 0) {
	    return 6;
	  } else if (standingsCount > 0) {
	    return 7;
	  }
	}
	
	function getTrackingImg() {
	  var edition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var pageType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var leagueName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	  var slug = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	  var gameId = arguments[4];
	  var location = arguments[5];
	  var siteType = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';
	  var gameState = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
	  var query = arguments[8];
	  var teams = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : {};
	  var scoreboardType = arguments[10];
	
	  var isDataLite = siteType === 'data-lite' ? true : false;
	  var checkQaRegExp = /(qa\.|local\.|localhost\.|sb\.|preview\.|dev2\.|useqa=true|enable=qaAPI)/i;
	  var locationHref = typeof window !== 'undefined' ? window.location && window.location.href : '';
	  var account = checkQaRegExp.test(locationHref) ? 'wdgespncomdev' : 'wdgespcricinfo,wdgespge';
	  var site = 'cricinfo';
	  var host = 'https://sw88.espn.com';
	  var version = '/1/JS-1.6.1/s';
	  var server = edition.host || 'www.espn.com';
	  var time = Date.now();
	  var noCookies = 'Cookies Not Supported';
	  var omniParamString = '';
	  var sport = 'cricket';
	  var namespace = 'espn';
	  var charset = 'ISO-8859-1';
	  var currencyCode = 'USD';
	  var cookieDomainCode = '2';
	  var strParams = '';
	  var nSite = site;
	  var featurephoneTxt = 'Feature+Phone';
	  var pageTypeTxt = '';
	  var section = '';
	  var pagename = '';
	  var events = 'event3';
	  var ex_cid = query['ex_cid'] || '';
	  var leagueSlug = slug || leagueName;
	  leagueSlug = leagueSlug && leagueSlug.replace(' ', '-').toLowerCase();
	  var _teams$home = teams.home,
	      home = _teams$home === undefined ? {} : _teams$home,
	      _teams$away = teams.away,
	      away = _teams$away === undefined ? {} : _teams$away;
	
	  var homeTeam = home.name || '';
	  var awayTeam = away.name || '';
	  var gameInfo = homeTeam.length > 0 || awayTeam.length > 0 ? homeTeam + ' vs ' + awayTeam : leagueSlug;
	  gameInfo = gameInfo && gameInfo.toLowerCase();
	  pageType = pageType === 'scores' ? 'scoreboard' : pageType;
	
	  switch (pageType) {
	    case 'table':
	    case 'standings':
	      pageTypeTxt = 'standings';
	      pagename = site + ':' + leagueSlug + ':' + pageTypeTxt;
	      section = site + ':' + leagueSlug;
	      break;
	    case 'scoreboard':
	      pageTypeTxt = pageType;
	      gameInfo = gameInfo === '' ? 'no+league' : gameInfo;
	      switch (scoreboardType) {
	        case 'default':
	          pagename = site + ':' + pageType + ':' + 'index';
	          section = site + ':' + pageType;
	          break;
	        case 'team':
	          pagename = site + ':' + slug + ':' + pageType;
	          section = site + ':' + slug;
	          break;
	        case 'series':
	          pagename = site + ':' + leagueSlug + ':' + pageType;
	          section = site + ':' + leagueSlug;
	          break;
	      }
	      break;
	    case 'game':
	      pageTypeTxt = 'game';
	      switch (gameState) {
	        case 'in':
	          pageType = 'live';
	          break;
	        default:
	          pageType = 'summary';
	      }
	      pagename = site + ':' + gameInfo + ':' + pageTypeTxt + ':' + pageType;
	      section = site + ':' + leagueSlug;
	      break;
	  }
	
	  if (isDataLite) {
	    nSite = site + ':lite';
	    featurephoneTxt = '';
	    events = 'event3,event20';
	  }
	
	  if (edition.isEspnCricinfo && location.indexOf('/cricket/') > -1) {
	    location = location.replace('/cricket/', '/');
	  }
	
	  var omniData = {
	    'c1': nSite,
	    'ch': section,
	    'c2': 'D=SWID',
	    'c5': pagename,
	    'c6': noCookies,
	    'c16': edition.countryName,
	    'v12': edition.countryName,
	    'v14': gameId + '+' + gameInfo,
	    'c14': gameId + '+' + gameInfo,
	    'c24': noCookies,
	    'c37': featurephoneTxt,
	    'v37': featurephoneTxt,
	    'pageName': pagename,
	    'v13': pagename,
	    'h1': pagename,
	    'c30': 'N',
	    'v19': sport,
	    'g': location,
	    'c17': edition.language,
	    'v9': edition.language,
	    'c4': 'match',
	    'c25': sport,
	    'v69': gameState,
	    'v11': pagename,
	    'c26': leagueSlug,
	    'v21': leagueSlug,
	    'events': events,
	    'v0': ex_cid
	  };
	
	  for (var key in omniData) {
	    if (omniData.hasOwnProperty(key)) {
	      if (encodeURIComponent(omniData[key])) {
	        omniParamString += '&' + key + '=' + encodeURIComponent(omniData[key]);
	      }
	    }
	  }
	
	  var trackLinkParam = {
	    'AQB': 1,
	    'ndh': 1,
	    'server': server,
	    'ns': namespace,
	    'ce': charset,
	    'cc': currencyCode,
	    'cdp': cookieDomainCode + omniParamString,
	    'AQE': 1
	  };
	
	  for (var k in trackLinkParam) {
	    if (trackLinkParam.hasOwnProperty(k)) {
	      strParams += k + '=' + trackLinkParam[k] + '&';
	    }
	  }
	
	  var trackingUrl = host + '/b/ss/' + account + version + time + '?' + strParams;
	
	  return trackingUrl;
	}
	/** Get isEspnCricinfoIn from editions
	   * Returns isEspnCricinfoIn based on host in editions
	   * @param  {Object} edition edition object
	   * @return {Boolean} isEspnCricinfoIn
	  */
	function isEspnCricinfoIn() {
	  var edition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var isEspnCricinfoIn = false;
	  if (edition.isEspnCricinfo && edition.country === 'in') {
	    isEspnCricinfoIn = true;
	  }
	  return isEspnCricinfoIn;
	}
	
	/**
	 * show buttom ads for different tabs of gamepackage page
	 * @param  {String} pageType different pagetypes
	 * @return {Boolean}          return true/false if report/video/coverage/standings page
	 */
	function showBottomAdModule() {
	  var pageType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	  var showBottomAds = false;
	  var pageList = ['report', 'video', 'coverage', 'standings', 'table'];
	  if (pageList.indexOf(pageType) > -1) {
	    showBottomAds = true;
	  }
	  return showBottomAds;
	}
	
	function getBet365Odds() {
	  var oddsNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var oddsArray = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	  var device = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var pageType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	
	  var items = {};
	  if (pageType === 'gamepackagemodule') {
	    var teamOdds = oddsArray || [];
	
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = (0, _getIterator3.default)(teamOdds), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var oddNode = _step.value;
	
	        var oddType = (0, _selectn2.default)('type', oddNode) || '';
	        var oddDetails = {};
	
	        switch (oddType.toLowerCase()) {
	          case 'towin':
	            oddDetails = getToWinOdds(oddNode, device);
	            break;
	          case 'manofthematch':
	            oddDetails = getManOfTheMatchOdds(oddNode);
	            break;
	          case 'towinthetoss':
	            oddDetails = getToWinTheToss(oddNode);
	            break;
	          case 'playerdismissalmethod':
	            oddDetails = getPlayerDismissalMethodOdds(oddNode);
	            break;
	          case 'drawnobet':
	            oddDetails = getDrawNoBetOdds(oddNode);
	            break;
	        }
	
	        items[oddType] = oddDetails;
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  } else {
	    var _teamOdds = oddsNode || {};
	    var links = (0, _selectn2.default)('links', _teamOdds) || [];
	    var oddTypes = ['homeTeamOdds', 'awayTeamOdds', 'drawOdds'];
	    var linkMap = {};
	
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	      for (var _iterator2 = (0, _getIterator3.default)(links), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	        var link = _step2.value;
	
	        linkMap[link.text] = link;
	      }
	    } catch (err) {
	      _didIteratorError2 = true;
	      _iteratorError2 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion2 && _iterator2.return) {
	          _iterator2.return();
	        }
	      } finally {
	        if (_didIteratorError2) {
	          throw _iteratorError2;
	        }
	      }
	    }
	
	    var _iteratorNormalCompletion3 = true;
	    var _didIteratorError3 = false;
	    var _iteratorError3 = undefined;
	
	    try {
	      for (var _iterator3 = (0, _getIterator3.default)(oddTypes), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	        var _oddType = _step3.value;
	
	        var odd = _teamOdds[_oddType];
	
	        if (typeof odd !== 'undefined') {
	          if (_oddType === 'drawOdds') {
	
	            items.Draws = {
	              'summary': (0, _selectn2.default)('summary', odd),
	              'href': (0, _selectn2.default)(_oddType + '.href', linkMap)
	            };
	          } else {
	            var team = (0, _selectn2.default)('team.abbreviation', odd) || (0, _selectn2.default)('team.displayName', odd) || '';
	            if (device && device.desktop == true) {
	              team = (0, _selectn2.default)('team.displayName', odd) || '';
	            }
	
	            if (team === '') {
	              continue;
	            }
	
	            items[team] = {
	              'summary': (0, _selectn2.default)('odds.summary', odd),
	              'href': (0, _selectn2.default)(_oddType + '.href', linkMap)
	            };
	          }
	        }
	      }
	    } catch (err) {
	      _didIteratorError3 = true;
	      _iteratorError3 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion3 && _iterator3.return) {
	          _iterator3.return();
	        }
	      } finally {
	        if (_didIteratorError3) {
	          throw _iteratorError3;
	        }
	      }
	    }
	  }
	
	  return {
	    items: items
	  };
	}
	
	function getToWinOdds() {
	  var oddNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var device = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var items = {};
	  var links = (0, _selectn2.default)('links', oddNode) || [];
	  var oddTypes = ['homeTeamOdds', 'awayTeamOdds', 'drawOdds'];
	
	  var linkMap = {};
	
	  var _iteratorNormalCompletion4 = true;
	  var _didIteratorError4 = false;
	  var _iteratorError4 = undefined;
	
	  try {
	    for (var _iterator4 = (0, _getIterator3.default)(links), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	      var link = _step4.value;
	
	      linkMap[link.text] = link;
	    }
	  } catch (err) {
	    _didIteratorError4 = true;
	    _iteratorError4 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion4 && _iterator4.return) {
	        _iterator4.return();
	      }
	    } finally {
	      if (_didIteratorError4) {
	        throw _iteratorError4;
	      }
	    }
	  }
	
	  var _iteratorNormalCompletion5 = true;
	  var _didIteratorError5 = false;
	  var _iteratorError5 = undefined;
	
	  try {
	    for (var _iterator5 = (0, _getIterator3.default)(oddTypes), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	      var oddType = _step5.value;
	
	      var odd = oddNode[oddType];
	
	      if (typeof odd !== 'undefined') {
	        if (oddType === 'drawOdds') {
	
	          items.Draws = {
	            'summary': (0, _selectn2.default)('summary', odd),
	            'href': (0, _selectn2.default)(oddType + '.href', linkMap)
	          };
	        } else {
	          var team = (0, _selectn2.default)('team.abbreviation', odd) || (0, _selectn2.default)('team.displayName', odd) || '';
	          if (device && device.desktop == true) {
	            team = (0, _selectn2.default)('team.displayName', odd) || '';
	          }
	
	          if (team === '') {
	            continue;
	          }
	
	          items[oddType] = {
	            'displayName': team,
	            'teamAbbrev': (0, _selectn2.default)('team.abbreviation', odd),
	            'summary': (0, _selectn2.default)('odds.summary', odd),
	            'href': (0, _selectn2.default)(oddType + '.href', linkMap)
	          };
	        }
	      }
	    }
	  } catch (err) {
	    _didIteratorError5 = true;
	    _iteratorError5 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion5 && _iterator5.return) {
	        _iterator5.return();
	      }
	    } finally {
	      if (_didIteratorError5) {
	        throw _iteratorError5;
	      }
	    }
	  }
	
	  return items;
	}
	
	function getToWinTheToss() {
	  var oddNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var items = {};
	  var odds = (0, _selectn2.default)('winTheTossoOdds', oddNode) || [];
	
	  var _iteratorNormalCompletion6 = true;
	  var _didIteratorError6 = false;
	  var _iteratorError6 = undefined;
	
	  try {
	    for (var _iterator6 = (0, _getIterator3.default)(odds), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	      var odd = _step6.value;
	
	      var link = (0, _selectn2.default)('links.[0].rel', odd) || [];
	      var oddType = link.includes('home') ? 'home' : link.includes('away') ? 'away' : '';
	
	      items[oddType] = {
	        'displayName': (0, _selectn2.default)('team.displayName', odd),
	        'teamAbbrev': (0, _selectn2.default)('team.abbreviation', odd),
	        'summary': (0, _selectn2.default)('odds.summary', odd),
	        'href': (0, _selectn2.default)('links.[0].href', odd)
	      };
	    }
	  } catch (err) {
	    _didIteratorError6 = true;
	    _iteratorError6 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion6 && _iterator6.return) {
	        _iterator6.return();
	      }
	    } finally {
	      if (_didIteratorError6) {
	        throw _iteratorError6;
	      }
	    }
	  }
	
	  return items;
	}
	
	function getManOfTheMatchOdds() {
	  var oddNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var items = [];
	  var players = (0, _selectn2.default)('playerOfTheMatchOdds', oddNode) || [];
	
	  var _iteratorNormalCompletion7 = true;
	  var _didIteratorError7 = false;
	  var _iteratorError7 = undefined;
	
	  try {
	    for (var _iterator7 = (0, _getIterator3.default)(players), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	      var player = _step7.value;
	
	      items.push({
	        name: (0, _selectn2.default)('athlete.displayName', player),
	        summary: (0, _selectn2.default)('odds.summary', player),
	        href: (0, _selectn2.default)('links.[0].href', player)
	      });
	    }
	  } catch (err) {
	    _didIteratorError7 = true;
	    _iteratorError7 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion7 && _iterator7.return) {
	        _iterator7.return();
	      }
	    } finally {
	      if (_didIteratorError7) {
	        throw _iteratorError7;
	      }
	    }
	  }
	
	  return items;
	}
	
	function getBet365Nbo() {
	  var situationNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  var oddsNode = situationNode.odds || [];
	  var items = {};
	
	  var _iteratorNormalCompletion8 = true;
	  var _didIteratorError8 = false;
	  var _iteratorError8 = undefined;
	
	  try {
	    for (var _iterator8 = (0, _getIterator3.default)(oddsNode), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
	      var odd = _step8.value;
	
	      var athlete = (0, _selectn2.default)('nextBatsmanOut.athlete.name', odd) || '';
	
	      if (athlete == '') {
	        continue;
	      }
	
	      items[athlete] = {
	        'summary': (0, _selectn2.default)('nextBatsmanOut.odds.summary', odd),
	        'href': (0, _selectn2.default)('links[0].href', odd)
	      };
	    }
	  } catch (err) {
	    _didIteratorError8 = true;
	    _iteratorError8 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion8 && _iterator8.return) {
	        _iterator8.return();
	      }
	    } finally {
	      if (_didIteratorError8) {
	        throw _iteratorError8;
	      }
	    }
	  }
	
	  return {
	    text: (0, _selectn2.default)('[0].links[0].text', oddsNode),
	    items: items
	  };
	}
	
	function getPlayerDismissalMethodOdds() {
	  var oddNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var items = {};
	  var methods = (0, _selectn2.default)('playerDismissalMethodOdds', oddNode) || [];
	
	  var _iteratorNormalCompletion9 = true;
	  var _didIteratorError9 = false;
	  var _iteratorError9 = undefined;
	
	  try {
	    for (var _iterator9 = (0, _getIterator3.default)(methods), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
	      var method = _step9.value;
	
	      var methodName = (0, _selectn2.default)('dismissalMethod', method) || {};
	      var methodType = methodName.displayName.startsWith('Caught') ? 'Caught' : 'Not Caught';
	
	      items[methodType] = {
	        'summary': (0, _selectn2.default)('odds.summary', method),
	        'href': (0, _selectn2.default)('links.[0].href', method)
	      };
	    }
	  } catch (err) {
	    _didIteratorError9 = true;
	    _iteratorError9 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion9 && _iterator9.return) {
	        _iterator9.return();
	      }
	    } finally {
	      if (_didIteratorError9) {
	        throw _iteratorError9;
	      }
	    }
	  }
	
	  return items;
	}
	
	function getDrawNoBetOdds() {
	  var oddNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var items = {};
	  var teams = (0, _selectn2.default)('drawNoBetOdds', oddNode) || [];
	
	  var _iteratorNormalCompletion10 = true;
	  var _didIteratorError10 = false;
	  var _iteratorError10 = undefined;
	
	  try {
	    for (var _iterator10 = (0, _getIterator3.default)(teams), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
	      var team = _step10.value;
	
	      var teamName = (0, _selectn2.default)('team.displayName', team) || {};
	
	      items[teamName] = {
	        'summary': (0, _selectn2.default)('odds.summary', team),
	        'href': (0, _selectn2.default)('links.[0].href', team)
	      };
	    }
	  } catch (err) {
	    _didIteratorError10 = true;
	    _iteratorError10 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion10 && _iterator10.return) {
	        _iterator10.return();
	      }
	    } finally {
	      if (_didIteratorError10) {
	        throw _iteratorError10;
	      }
	    }
	  }
	
	  return items;
	}
	
	function getBet365() {
	  var oddsNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var oddsArray = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	  var site = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	  var situationNode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var gameState = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
	  var device = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
	  var userGeo = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';
	
	  var odds = getBet365Odds(oddsNode, oddsArray, device);
	  var moduleOdds = getBet365Odds(oddsNode, oddsArray, device, 'gamepackagemodule');
	  var situationNodeOdd = {};
	  if (situationNode) {
	    situationNodeOdd = getBet365Nbo(situationNode);
	  }
	  // dont show bet365 if user country is unknown from varnish
	  var showInGeo = userGeo && userGeo == 'UNKNOWN' && false;
	  return {
	    // 'showInEdition' flag decided by edition and match state
	    showInEdition: true,
	    // 'showInGeo' decided by geo location
	    showInGeo: showInGeo,
	    defaultMsg: 'In-play betting with bet365.',
	    defaultLink: 'https://www.bet365.com/home/default.asp?cid=3&affiliate=365_307576&deeplink=1',
	    odds: odds,
	    moduleOdds: moduleOdds,
	    situationNodeOdd: situationNodeOdd,
	    gameState: gameState,
	    site: site
	  };
	}
	
	function getUpdatedAffiliateCode() {
	  var link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var affiliateCodeOverwrite = arguments[1];
	
	  var queryParam = link.indexOf('affiliatecode=') > -1 ? 'affiliatecode=' : 'affiliate=';
	  var regex = new RegExp('(' + queryParam + ').*?(&|\")');
	  return link.replace(regex, '$1' + affiliateCodeOverwrite + '$2');
	}
	
	/**
	 *
	 * @param {String} url canonical url
	 * @return {String}    canonical url without '/cricket' for editions
	 */
	function getCricketCanonical(url) {
	  var canonical = '';
	  if (url.indexOf('/cricket/') > -1) {
	    canonical = url.replace('/cricket', '');
	  }
	  return canonical || url;
	}
	/**
	 * [redirectToCanonical Redirect to the canonical page, if slug is different]
	 * @param  {String} canonical  [correct canonical link]
	 * @param  {Object} reqOptions [request url options]
	 * @return {Object}            [return allow redirect flag, redirect URL]
	 */
	function redirectToCanonical(canonical, reqOptions) {
	  var url = reqOptions.url,
	      slug = reqOptions.slug,
	      host = reqOptions.host,
	      platform = reqOptions.platform,
	      device = reqOptions.device,
	      sport = reqOptions.sport;
	
	  var _slug_ = false;
	  var noRedirect = platform || device === 'featurephone' ? true : false;
	  var defaultRedirOptions = { allow: false, href: undefined, path: undefined, _slug_: _slug_ };
	  var reqUrl = url;
	
	  if (!noRedirect) {
	
	    //fix for _slug_ in rugby team pages
	    if (RegExp('_slug_=').test(reqUrl) && sport === 'rugby') {
	      var qsObj = _queryString2.default.parse(reqUrl);
	      qsObj._slug_ = slug;
	      reqUrl = (0, _keys2.default)(qsObj).map(function (key) {
	        return key + '=' + qsObj[key];
	      }).join('&');
	      _slug_ = true;
	    }
	
	    var reqUrlObj = _url2.default.parse(reqUrl) || {};
	    var reqCanonicalObj = _url2.default.parse(canonical) || {};
	    var query = reqUrlObj && reqUrlObj.query || '';
	    var redirectFullPath = ['http://', host, canonical].join('');
	    //set default redirect URL till pathname
	    var redirectHref = redirectFullPath;
	    var redirectPath = canonical;
	    //keep query params
	    if (query) {
	      redirectHref = [redirectFullPath, '?', query].join('');
	      redirectPath = [redirectPath, '?', query].join('');
	    }
	
	    //check if slug is different
	    var sendTempRedirect = reqUrlObj.pathname !== reqCanonicalObj.pathname ? true : false;
	
	    if (sport === 'rugby') {
	      sendTempRedirect = false;
	    }
	
	    //do not redirect espn.in / kwese / espn.co.uk cricket pages. It will use canonical of espncricinfo.com
	    //therefore, no need for correcting the slug
	    if (sport === 'cricket' && host.indexOf('espncricinfo') === -1) {
	      sendTempRedirect = false;
	    }
	
	    if (sendTempRedirect) {
	      return { allow: sendTempRedirect, href: redirectHref, path: redirectPath, _slug_: _slug_ };
	    } else {
	      return defaultRedirOptions;
	    }
	  }
	
	  return defaultRedirOptions;
	}
	
	/**
	 * Function checks the param type for preventing XSS
	 * @param {Object} renderProps Params gameId, leagueId etc.
	 * @return {Boolean} true or false
	 */
	function hasValidPageParams(renderProps) {
	  var params = renderProps.params,
	      location = renderProps.location;
	
	  var query = location && location.query || {};
	
	  var isValid = true;
	  var paramsArr = [];
	  var paramsArrLen = void 0;
	  var validParamsArr = [];
	
	  //params to be considered numeric
	  var numParams = {
	    gameId: params && params.gameId,
	    league: params && params.league,
	    team: params && params.team,
	    season: params && params.season,
	    date: query && query.date
	  };
	
	  paramsArr = (0, _map3.default)(numParams, function (val, key) {
	    var item = {};
	    item[key] = val;
	    return val !== undefined ? item : null;
	  });
	  paramsArr = (0, _compact3.default)(paramsArr);
	  paramsArrLen = paramsArr && paramsArr.length;
	  if (paramsArrLen > 0) {
	    //console.log('paramsArr => ', paramsArr)
	
	    for (var i = 0; i < paramsArrLen; i++) {
	      var item = paramsArr[i];
	      //console.log('item => ', item)
	      (0, _values2.default)(item).forEach(function (i) {
	        //console.log('this test is ', (/^[0-9]*$/g).test(i))
	        validParamsArr.push(/^[0-9]*$/g.test(i));
	      });
	      //console.log('validParamsArr => ', validParamsArr)
	    }
	  }
	
	  if (validParamsArr.indexOf(false) > -1) {
	    isValid = false;
	  }
	
	  return isValid;
	}
	/**
	 * Function to check if a page / tab is hidden or active tab
	 * @return {Boolean} returns true or false
	 */
	function isPageHidden() {
	  return document.hidden || document.msHidden || document.webkitHidden || document.mozHidden || document.visibilityState === 'hidden' || document.webkitVisibilityState === 'hidden';
	}
	
	function loadScript(src, id) {
	  return new _promise2.default(function (resolve, reject) {
	    var script = document.createElement('script');
	    script.src = src;
	    script.id = id;
	    script.type = 'text/javascript';
	    script.async = true;
	    script.onload = resolve;
	    script.onerror = reject;
	    script.integrity = '';
	    var fs = document.getElementsByTagName('script')[0];
	    fs.parentNode.insertBefore(script, fs);
	  });
	}
	
	function generateEventsTeam(updatedProps) {
	  var kvbattingteam = '',
	      allInningsLength = 0,
	      selectedTeam = '',
	      allInnings = updatedProps && updatedProps.allInnings;
	
	  var sport = (0, _selectn2.default)('params.sport', updatedProps) || '';
	  if (sport === 'cricket') {
	    allInningsLength = allInnings && allInnings.length;
	    if (allInningsLength !== 0) {
	      selectedTeam = (0, _selectn2.default)('allInnings[' + (allInningsLength - 1) + '].teamDisplayName', updatedProps) || '';
	      kvbattingteam = selectedTeam ? selectedTeam.replace(/\s/g, '').toLowerCase() : '';
	    }
	  }
	
	  return kvbattingteam;
	}
	
	function generateScoreEvent(currentScore, updatedScore) {
	  var event = '';
	
	  [100, 200, 250, 300, 325, 350, 400].forEach(function (item) {
	    if (currentScore < item && updatedScore >= item) {
	      event = 'team' + item;
	    }
	  });
	
	  return event;
	}
	
	function generateWicketEvent(updatedWickets) {
	  var event = '';
	
	  if ([3, 5, 8].indexOf(updatedWickets) !== -1) {
	    event = 'wickets' + updatedWickets;
	  } else {
	    event = 'wicket';
	  }
	
	  return event;
	}
	
	function generateGameStatusEvent(currentGameStatusText, updatedGameStatusText) {
	  if (currentGameStatusText && currentGameStatusText === updatedGameStatusText) {
	    return '';
	  } else {
	    return updatedGameStatusText && _kveventsBreaks.BREAKS[updatedGameStatusText];
	  }
	}
	
	function generateEvents(currentProps, updatedProps) {
	  var kvevent = '',
	      selectedInnings = 0,
	      selectedInningsKey = '',
	      currentBrief = {},
	      updatedBrief = {},
	      currentRuns = 0,
	      updatedRuns = 0,
	      currentWickets = 0,
	      updatedWickets = 0,
	      currentFours = 0,
	      updatedFours = 0,
	      currentSixes = 0,
	      updatedSixes = 0,
	      currentLiteBatsmen = [],
	      updatedLiteBatsmen = [],
	      updatedBatsmanPlayerId = '',
	      selectedBatsman = {},
	      currentBatsmanRuns = 0,
	      updatedBatsmanRuns = 0,
	      currentGameStatusText = '',
	      updatedGameStatusText = '',
	      currentPropsAllInningsLength = 0,
	      updatedPropsAllInningsLength = 0,
	      recentOverScore = 0,
	      scoreDiff = 0;
	
	  var sport = (0, _selectn2.default)('params.sport', updatedProps) || '',
	      lastOver = (0, _selectn2.default)('innings.recentOvers[0]', updatedProps) || [];
	
	  updatedPropsAllInningsLength = updatedProps.allInnings && updatedProps.allInnings.length;
	  selectedInnings = updatedPropsAllInningsLength - 1;
	  selectedInningsKey = 'allInnings[' + selectedInnings + '].stats.brief';
	  updatedBrief = (0, _selectn2.default)(selectedInningsKey, updatedProps) || {};
	  updatedLiteBatsmen = (0, _selectn2.default)('innings.liteBatsmen', updatedProps) || [];
	  updatedGameStatusText = updatedProps.gameStatusText || '';
	
	  updatedWickets = updatedBrief.wickets || 0;
	  updatedRuns = updatedBrief.runs || 0;
	  updatedFours = updatedBrief.fours || 0;
	  updatedSixes = updatedBrief.sixes || 0;
	
	  if (sport === 'cricket') {
	    if (!(0, _keys2.default)(currentProps).length === true) {
	      recentOverScore = lastOver.reduce(function (accumulator, a) {
	        if (typeof a === 'number') {
	          accumulator += a;
	        }
	        return accumulator;
	      }, 0);
	      scoreDiff = updatedRuns - recentOverScore;
	
	      lastOver.forEach(function (ball) {
	        if (ball === 4) {
	          kvevent = 'four';
	        } else if (ball === 6) {
	          kvevent = 'six';
	        } else if (/^w$/i.test(ball)) {
	          kvevent = generateWicketEvent(updatedWickets);
	        }
	      });
	
	      kvevent = generateScoreEvent(scoreDiff, updatedRuns) || kvevent;
	
	      kvevent = generateGameStatusEvent('', updatedGameStatusText) || kvevent;
	    } else {
	      currentGameStatusText = currentProps.gameStatusText || '';
	      currentPropsAllInningsLength = currentProps.allInnings && currentProps.allInnings.length;
	
	      // If allinnings in updated props are empty then return kvevents to avoid breakdown
	      if (updatedPropsAllInningsLength === 0) {
	        return kvevent;
	      }
	
	      /**
	      * If allinnings length in updated props is equal to allinnings length in current props
	      * get the currentBrief & currentLiteBatsmen from current props
	      */
	      if (currentPropsAllInningsLength === updatedPropsAllInningsLength) {
	        currentBrief = (0, _selectn2.default)(selectedInningsKey, currentProps) || {};
	        currentLiteBatsmen = (0, _selectn2.default)('innings.liteBatsmen', currentProps) || [];
	      }
	
	      /**
	      * If allinnings length in updated props is not equal to allinnings length in current props
	      * then set the currentBrief & currentLiteBatsmen to defaults as its not available in current props
	      */
	      if (currentPropsAllInningsLength !== updatedPropsAllInningsLength) {
	        currentBrief = {};
	        currentLiteBatsmen = [];
	      }
	
	      currentRuns = currentBrief.runs || 0;
	      currentWickets = currentBrief.wickets || 0;
	      currentFours = currentBrief.fours || 0;
	      currentSixes = currentBrief.sixes || 0;
	
	      // If team current fours is less than updated fours then fire kvevent=four event
	      if (currentFours < updatedFours) {
	        kvevent = 'four';
	      }
	
	      // If team current sixes is less than updated sixes then fire kvevent=six event
	      if (currentSixes < updatedSixes) {
	        kvevent = 'six';
	      }
	
	      /**
	      * Looping through all the batsmen from current and updated props and checking
	      * if their score is 50 or 100 and firing respective event
	      */
	      if (currentWickets === updatedWickets) {
	        updatedLiteBatsmen.forEach(function () {
	          var updateBatsman = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	          updatedBatsmanPlayerId = updateBatsman.playerid;
	          currentLiteBatsmen.forEach(function () {
	            var currentBatsman = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            if (updatedBatsmanPlayerId === currentBatsman.playerid) {
	              selectedBatsman = currentBatsman;
	            }
	          });
	          currentBatsmanRuns = (0, _selectn2.default)('stats[0].value', selectedBatsman) || 0;
	          updatedBatsmanRuns = (0, _selectn2.default)('stats[0].value', updateBatsman) || 0;
	          if (currentBatsmanRuns < 50 && updatedBatsmanRuns >= 50) {
	            kvevent = 'bat50';
	          } else if (currentBatsmanRuns < 100 && updatedBatsmanRuns >= 100) {
	            kvevent = 'bat100';
	          }
	        });
	      }
	
	      kvevent = generateScoreEvent(currentRuns, updatedRuns) || kvevent;
	
	      /**
	      * If wickets from previous props is less than
	      * wickets in updated props then check for count and
	      * send respective event else fire kvevent=wicket
	      */
	      if (currentWickets < updatedWickets) {
	        kvevent = generateWicketEvent(updatedWickets);
	      }
	
	      /**
	      * If game status text from current props is not equal to game status
	      * text in updated props then do check and fire respective events
	      */
	      kvevent = generateGameStatusEvent(currentGameStatusText, updatedGameStatusText) || kvevent;
	    }
	
	    // If toss status from current props is true then fire the kvevent=toss event
	    if (updatedProps.tossStatus === true) {
	      kvevent = 'toss';
	    }
	  }
	
	  return kvevent;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(432), __esModule: true };

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(433);
	module.exports = __webpack_require__(288).Object.values;


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(293);
	var $values = __webpack_require__(434)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	var getKeys = __webpack_require__(324);
	var toIObject = __webpack_require__(326);
	var isEnum = __webpack_require__(348).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) if (isEnum.call(O, key = keys[i++])) {
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(436), __esModule: true };

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(336);
	__webpack_require__(315);
	module.exports = __webpack_require__(437);


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(298);
	var get = __webpack_require__(378);
	module.exports = __webpack_require__(288).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var curry2 = __webpack_require__(439)
	var debug = __webpack_require__(441)('selectn')
	var dotted = __webpack_require__(444)
	var splits = __webpack_require__(445)
	var string = Object.prototype.toString
	
	module.exports = curry2(selectn)
	
	/**
	 * Curried property accessor function that resolves deeply-nested object properties via dot/bracket-notation
	 * string path while mitigating `TypeErrors` via friendly and composable API.
	 *
	 * @param {String|Array} path
	 * Dot/bracket-notation string path or array.
	 *
	 * @param {Object} object
	 * Object to access.
	 *
	 * @return {Function|*|undefined}
	 * (1) returns `selectn/1` when partially applied.
	 * (2) returns value at path if path exists.
	 * (3) returns undefined if path does not exist.
	 */
	function selectn (path, object) {
	  debug('arguments:', {
	    path: path,
	    object: object
	  })
	
	  var idx = -1
	  var seg = string.call(path) === '[object Array]' ? path : splits(dotted(path))
	  var end = seg.length
	  var ref = end ? object : void 0
	
	  while (++idx < end) {
	    if (Object(ref) !== ref) return void 0
	    ref = ref[seg[idx]]
	  }
	
	  debug('ref:', ref)
	  return typeof ref === 'function' ? ref() : ref
	}


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	/*!
	 * imports.
	 */
	
	var bind = Function.prototype.bind || __webpack_require__(440)
	
	/*!
	 * exports.
	 */
	
	module.exports = curry2
	
	/**
	 * Curry a binary function.
	 *
	 * @param {Function} fn
	 * Binary function to curry.
	 *
	 * @param {Object} [self]
	 * Function `this` context.
	 *
	 * @return {Function|*}
	 * If partially applied, return unary function, otherwise, return result of full application.
	 */
	
	function curry2 (fn, self) {
	  var out = function () {
	    if (arguments.length === 0) return out
	
	    return arguments.length > 1
	      ? fn.apply(self, arguments)
	      : bind.call(fn, self, arguments[0])
	  }
	
	  out.uncurry = function uncurry () {
	    return fn
	  }
	
	  return out
	}


/***/ }),
/* 440 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = function(boundThis) {
	  var f = this
	    , ret
	
	  if (arguments.length < 2)
	    ret = function() {
	      if (this instanceof ret) {
	        var ret_ = f.apply(this, arguments)
	        return Object(ret_) === ret_
	          ? ret_
	          : this
	      }
	      else
	        return f.apply(boundThis, arguments)
	    }
	  else {
	    var boundArgs = new Array(arguments.length - 1)
	    for (var i = 1; i < arguments.length; i++)
	      boundArgs[i - 1] = arguments[i]
	
	    ret = function() {
	      var boundLen = boundArgs.length
	        , args = new Array(boundLen + arguments.length)
	        , i
	      for (i = 0; i < boundLen; i++)
	        args[i] = boundArgs[i]
	      for (i = 0; i < arguments.length; i++)
	        args[boundLen + i] = arguments[i]
	
	      if (this instanceof ret) {
	        var ret_ = f.apply(this, args)
	        return Object(ret_) === ret_
	          ? ret_
	          : this
	      }
	      else
	        return f.apply(boundThis, args)
	    }
	  }
	
	  ret.prototype = f.prototype
	  return ret
	}


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console, process) {/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(442);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
	    return true;
	  }
	
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
	    // double check webkit in userAgent just in case we are in a worker
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs(args) {
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return;
	
	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit')
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = ({"NODE_ENV":"production","SITE_API_FRONTCHANNEL_HOST":"site.web.api.espn.com","SCORETC_FRONTCHANNEL_HOST":"www.espn.com/core"}).DEBUG;
	  }
	
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(4)))

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(443);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor(namespace) {
	  var hash = 0, i;
	
	  for (i in namespace) {
	    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }
	
	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function createDebug(namespace) {
	
	  function debug() {
	    // disabled?
	    if (!debug.enabled) return;
	
	    var self = debug;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);
	
	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	
	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	
	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }
	
	  return debug;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  exports.names = [];
	  exports.skips = [];
	
	  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 443 */
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return;
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name;
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ }),
/* 444 */
/***/ (function(module, exports) {

	'use strict';
	
	/*!
	 * exports.
	 */
	
	module.exports = brackets2dots;
	
	/*!
	 * regexp patterns.
	 */
	
	var REPLACE_BRACKETS = /\[([^\[\]]+)\]/g;
	var LFT_RT_TRIM_DOTS = /^[.]*|[.]*$/g;
	
	/**
	 * Convert string with bracket notation to dot property notation.
	 *
	 * ### Examples:
	 *
	 *      brackets2dots('group[0].section.a.seat[3]')
	 *      //=> 'group.0.section.a.seat.3'
	 *
	 *      brackets2dots('[0].section.a.seat[3]')
	 *      //=> '0.section.a.seat.3'
	 *
	 *      brackets2dots('people[*].age')
	 *      //=> 'people.*.age'
	 *
	 * @param  {String} string
	 * original string
	 *
	 * @return {String}
	 * dot/bracket-notation string
	 */
	
	function brackets2dots(string) {
	  return ({}).toString.call(string) == '[object String]'
	       ? string.replace(REPLACE_BRACKETS, '.$1').replace(LFT_RT_TRIM_DOTS, '')
	       : ''
	}


/***/ }),
/* 445 */
/***/ (function(module, exports) {

	'use strict'
	
	var toString = Object.prototype.toString
	
	/**
	 * Transform dot-delimited strings to array of strings.
	 *
	 * @param  {String} string
	 * Dot-delimited string.
	 *
	 * @return {Array}
	 * Array of strings.
	 */
	
	function dotsplit (string) {
	  var idx = -1
	  var str = compact(normalize(string).split('.'))
	  var end = str.length
	  var out = []
	
	  while (++idx < end) {
	    out.push(todots(str[idx]))
	  }
	
	  return out
	}
	
	/**
	 * Replace escapes with a placeholder.
	 *
	 * @param  {String} string
	 * Dot-delimited string.
	 *
	 * @return {String}
	 * Dot-delimited string with placeholders in place of escapes.
	 */
	
	function normalize (string) {
	  return (toString.call(string) === '[object String]' ? string : '').replace(/\\\./g, '\uffff')
	}
	
	/**
	 * Drop empty values from array.
	 *
	 * @param  {Array} array
	 * Array of strings.
	 *
	 * @return {Array}
	 * Array of strings (empty values dropped).
	 */
	
	function compact (arr) {
	  var idx = -1
	  var end = arr.length
	  var out = []
	
	  while (++idx < end) {
	    if (arr[idx]) out.push(arr[idx])
	  }
	
	  return out
	}
	
	/**
	 * Change placeholder to dots.
	 *
	 * @param  {String} string
	 * Dot-delimited string with placeholders.
	 *
	 * @return {String}
	 * Dot-delimited string without placeholders.
	 */
	
	function todots (string) {
	  return string.replace(/\uffff/g, '.')
	}
	
	/*!
	 * exports.
	 */
	
	module.exports = dotsplit


/***/ }),
/* 446 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Lookup region for a country.
	 */
	var COUNTRY_REGION = exports.COUNTRY_REGION = {
	  'au': 'au',
	  'cc': 'au',
	  'cx': 'au',
	  'fj': 'au',
	  'nc': 'au',
	  'nf': 'au',
	  'pg': 'au',
	  'sb': 'au',
	  'vu': 'au',
	  'bd': 'bd',
	  'fk': 'uk',
	  'gb': 'uk',
	  'gg': 'uk',
	  'gi': 'uk',
	  'gs': 'uk',
	  'im': 'uk',
	  'io': 'uk',
	  'je': 'uk',
	  'sh': 'uk',
	  'uk': 'uk',
	  'bt': 'in',
	  'in': 'in',
	  'np': 'in',
	  'lk': 'lk',
	  'mv': 'lk',
	  'as': 'nz',
	  'ck': 'nz',
	  'nu': 'nz',
	  'nz': 'nz',
	  'pf': 'nz',
	  'pn': 'nz',
	  'tk': 'nz',
	  'to': 'nz',
	  'tv': 'nz',
	  'wf': 'nz',
	  'ws': 'nz',
	  'af': 'pk',
	  'pk': 'pk',
	  'pr': 'us',
	  'um': 'us',
	  'us': 'us',
	  'ww': 'ww',
	  'bw': 'za',
	  'ls': 'za',
	  'mg': 'za',
	  'mw': 'za',
	  'mz': 'za',
	  'na': 'za',
	  'sz': 'za',
	  'za': 'za',
	  'zm': 'za',
	  'zw': 'za'
	};

/***/ }),
/* 447 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var BREAKS = exports.BREAKS = {
	  inningsbreak: 'inningsbreak',
	  drinks: 'drinksbreak',
	  tea: 'teabreak',
	  lunch: 'lunchbreak',
	  dinner: 'dinnerbreak'
	};

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getheaderSBTopicId = getheaderSBTopicId;
	exports.getEditionKey = getEditionKey;
	exports.getEnvironment = getEnvironment;
	exports.getEditionSettings = getEditionSettings;
	
	var _selectn = __webpack_require__(438);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	var _dateformat = __webpack_require__(449);
	
	var _dateformat2 = _interopRequireDefault(_dateformat);
	
	var _common = __webpack_require__(430);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: pull config for other editions
	var configMap = {
	  'espnin-en': 'india',
	  'espn-en': 'unitedstates',
	  'espnuk-en': 'unitedkingdom',
	  'espnau-en': 'australia',
	  'espnza-en': 'southafrica',
	  'espnph-en': 'philippines',
	  'espnww-en': 'en-global',
	  'espncricinfo-en-za': 'africa',
	  'espncricinfo-en-in': 'india',
	  'espncricinfo-en-au': 'australia',
	  'espncricinfo-en-bd': 'bangladesh',
	  'espncricinfo-en-nz': 'newzealand',
	  'espncricinfo-en-pk': 'pakistan',
	  'espncricinfo-en-lk': 'srilanka',
	  'espncricinfo-en-uk': 'unitedkingdom',
	  'espncricinfo-en-us': 'unitedstates',
	  'espncricinfo-en-ww': 'global',
	  'espn-es-ar': 'spanish/argentina',
	  'espn-es-cl': 'spanish/chile',
	  'espn-es-co': 'spanish/colombia',
	  'espn-es-do': 'spanish/dominicanrepublic',
	  'espn-es-ec': 'spanish/ecuador',
	  'espn-es-gt': 'spanish/guatemala',
	  'espn-es-mx': 'spanish/mexico',
	  'espn-es-pa': 'spanish/panama',
	  'espn-es-pe': 'spanish/peru',
	  'espn-es-es': 'spanish/spanish',
	  'espn-es-us': 'spanish/unitedstates',
	  'espn-es-uy': 'spanish/uruguay',
	  'espn-es-ve': 'spanish/venezuela',
	  'espn-pt-br': 'portuguese/brazil'
	};
	
	function getheaderSBTopicId(isEspnCricinfo, country, language) {
	  var headerKey = country + '-' + language;
	  if (isEspnCricinfo) {
	    headerKey = 'espncricinfo-' + headerKey;
	  }
	  return headerKey;
	}
	
	function getEditionKey(request) {
	  var host = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var lang = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en';
	  var region = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'us';
	  var isEspnCricinfo = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	
	  var hostKey = void 0;
	  var environment = void 0;
	
	  request.query = request.query || {};
	  request.headers = request.headers || {};
	
	  if (host) {
	    environment = getEnvironment(request);
	
	    if (environment == 'local' || environment == 'ondemand' || environment == 'localdev') {
	      var editionSlugMatches = host.match(/^(.*).cloud.go.com(:0-9999+)?/) || [];
	      if (editionSlugMatches[1]) {
	        // host = ##(
	        //   'deportes' => 'espndeportes.espn.go.com'
	        // )[editionSlugMatches[1]];
	      } else if (host == 'coreserver') {
	        host = 'espndeportes.espn.go.com';
	      } else if (host.indexOf('.sandbox.aws.espn.com') > -1) {
	        host = host.replace('.sandbox.aws.espn.com', '');
	      } else if (host.indexOf('.sonyespn.com') > -1) {
	        host = 'sonyespn.com';
	      } else if (host.indexOf('global.espn.com') > -1) {
	        host = 'global.espn.com';
	      } else if (host.indexOf('tv5.espn.com') > -1) {
	        host = 'tv5.espn.com';
	      } else if (host.indexOf('espn') > -1) {
	        if (host.indexOf('africa') == -1) {
	          host = host.replace(/:8080|:1377/, '');
	          var espnIndex = host.indexOf('espn');
	          host = host.substring(espnIndex);
	        }
	      } else {
	        host = 'espn.com';
	      }
	    }
	
	    if (isEspnCricinfo) {
	      if (typeof region === 'undefined') {
	        var country = request.query['country'] || request.headers['x-country'] || '';
	        region = (0, _common.getCountrySupportedRegion)(country);
	      }
	
	      if (typeof region !== 'undefined' && region.length > 0 && region === 'gb') {
	        region = 'uk';
	      }
	
	      lang = typeof lang !== 'undefined' && lang || 'en';
	
	      hostKey = 'espncricinfo' + '-' + lang + (region.length > 0 ? '-' + region : '');
	    } else {
	      var hostToSite = {
	        // English
	        'espn.go.com': 'espn-en',
	        'www.espn.com': 'espn-en',
	        'espn.co.uk': 'espnuk-en',
	        'espnsb.co.uk': 'espnuk-en',
	        'espnqa.co.uk': 'espnuk-en',
	        'espn.com.au': 'espnau-en',
	        'espnfc.com': 'espnfc-en',
	        'espnfc.us': 'espnfc-en-us',
	        'espnfc.co.uk': 'espnfc-en-uk',
	        'espnfc.com.ng': 'espnfc-en-ng',
	        'espnfc.com.au': 'espnfc-en-au',
	        'espnfcasia.com': 'espnfc-en-sg',
	        'espn.in': 'espnin-en',
	        'espnsb.in': 'espnin-en',
	        'sonyespn.com': 'espnin-en',
	        'xgames.espn.go.com': 'xgames',
	        'africa.espn.com': 'espnza-en',
	        'africa.espnsb.com': 'espnza-en',
	        'tv5.espn.com': 'espnph-en',
	        'global.espn.com': 'espnww-en',
	
	        // Spanish
	        'espndeportes.espn.go.com': 'espn-es-us',
	        'espndeportes.espn.com': 'espn-es-us',
	        'espndeportes.com': 'espn-es-us',
	        'espn.com.ar': 'espn-es-ar',
	        'espn.com.co': 'espn-es-co',
	        'espn.com.mx': 'espn-es-mx',
	        'espn.com.ve': 'espn-es-ve',
	        'espn.cl': 'espn-es-cl',
	        // Portuguese
	        'espn.uol.com.br': 'espn-pt-br',
	        'espn.com.br': 'espn-pt-br'
	      };
	
	      hostKey = hostToSite[host];
	    }
	  } else if (lang && region) {
	    hostKey = 'espn';
	
	    if (lang === 'es') {
	      hostKey = hostKey + '-' + lang + '-' + region;
	      // the english team came up with a different key schema
	    } else if (lang === 'en') {
	      if (region === 'gb') {
	        region = 'uk';
	      }
	      if (region !== 'us') {
	        hostKey = hostKey + region;
	      }
	      hostKey = hostKey + '-' + lang;
	    }
	  }
	
	  if (!hostKey) {
	    //if unknown host like local or iaas, then use espn-en
	    hostKey = isEspnCricinfo ? 'espncricinfo-en-ww' : 'espn-en';
	  }
	
	  return hostKey;
	}
	
	function getEnvironment(request) {
	
	  var environment = '';
	
	  // determine environment from host
	  var host = (0, _selectn2.default)('headers.host', request) || '';
	
	  if (host.startsWith('espn') || host.startsWith('n7') || host.startsWith('proxy') || host.startsWith('sports') || host.startsWith('scores')) {
	    environment = 'prod';
	  } else if (host.startsWith('prod-preview')) {
	    environment = 'prod-preview';
	  } else if (host.startsWith('prod-mast')) {
	    environment = 'prod-mast';
	  } else if (host.startsWith('dev') || host.startsWith('test') || host.startsWith('vwtsas') || host.startsWith('vwdsapp')) {
	    environment = 'dev';
	  } else if (host.startsWith('beta.qa.') || host.startsWith('beta.qa2.') || host.startsWith('qa') || host.startsWith('qn7espn')) {
	    environment = 'qa';
	  } else if (host.indexOf('espnqa') !== -1) {
	    environment = 'qa';
	  } else {
	    environment = 'local';
	  }
	
	  environment = environment.toLowerCase().trim();
	
	  // normalize qa2 -> qa
	  if (environment == 'qa2') {
	    environment = 'qa';
	  } else if (environment == 'maven' || environment == 'localdev' || environment == 'dev') {
	    environment = 'local';
	  } else if (environment == 'prod_preview') {
	    environment = 'prod-preview';
	  } else if (environment == 'prod_mast') {
	    environment = 'prod-mast';
	  }
	
	  return environment;
	}
	
	function getEditionSettings() {
	  var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	
	  request.query = request.query || {};
	  request.headers = request.headers || {};
	  var editionConfig = {};
	  var asiaRegions = ['in', 'pk', 'lk', 'bd'];
	  var isAsiaRegion = false;
	
	  var host = request.query['host'] || request.headers['Host'] || request.hostname;
	  var editionHostParam = request.query['edition-host'];
	  var localEditionKey = request.query['edition'] || request.headers['x-edition'] || '';
	  var edition_view = request.query['edition-view'] || request.headers['x-edition-view'] || '';
	  var lang = request.query['lang'] || 'en';
	  var region = request.query['region'] || 'us';
	
	  if (editionHostParam) {
	    host = editionHostParam;
	  }
	
	  var hostReplaces = /localhost|local\.|www\.|-qa|qa\.|preview\./;
	
	  if (typeof host === 'string') {
	    // replace espnqa.com with espn.com
	    host = host.replace('espnqa.com', 'espn.com');
	
	    host = host.replace(hostReplaces, '');
	  }
	
	  /* NOTE: webpack will load everyone of these config files so uk will get anz, in, us config to download needs consideration as we add more
	   * https://github.com/webpack/webpack/issues/118
	  */
	
	  var isEspnCricinfo = (0, _common.isEspnCricinfo)(host, localEditionKey);
	
	  if (isEspnCricinfo) {
	    edition_view = edition_view ? edition_view : 'espncricinfo-en-ww';
	    var edition_country = '';
	    var editionViewArr = edition_view.split('-');
	    if (editionViewArr.length > 0) {
	      edition_country = editionViewArr[2];
	    }
	    host = 'espncricinfo.com';
	    region = (0, _common.getCountrySupportedRegion)(edition_country);
	  }
	
	  var userGeo = request.query['locale'] || request.query['country'] || request.headers['x-country'] || 'us';
	  userGeo = userGeo.toLowerCase();
	
	  if (userGeo === 'uk') {
	    userGeo = 'gb';
	  }
	
	  var editionKey = getEditionKey(request, host, lang, region, isEspnCricinfo);
	
	  if (isEspnCricinfo) {
	    editionConfig = __webpack_require__(579)("./" + (configMap[editionKey] || configMap['espncricinfo-en-ww'])).default;
	  } else if (edition_view) {
	    editionConfig = __webpack_require__(678)("./" + (configMap[edition_view] || configMap['espn-en'])).default;
	  } else if (lang === 'en' || lang === 'es' || lang === 'pt') {
	    editionConfig = __webpack_require__(678)("./" + (configMap[editionKey] || configMap['espn-en'])).default;
	  }
	
	  var editionSettings = editionConfig.editionSettings || {};
	  var site = editionSettings.site;
	  var timeZoneBucket = (0, _selectn2.default)('dateTime.timeZoneBucket', editionConfig) || 'America/New_York';
	  var language = editionSettings.language;
	  var country = editionSettings.country;
	  var countryName = editionSettings.countryName;
	  var domain = editionSettings.domain;
	  var siteId = editionSettings.editionSiteId;
	  var https = editionSettings.https;
	  var reactOverride = editionConfig.reactOverride || {};
	  var sponsoredContentProviders = editionConfig.sponsoredContentProviders || [];
	  var taboolaSettings = editionConfig.taboola || {};
	  var outbrainSettings = editionConfig.outbrain || {};
	  var isMultiSports = isEspnCricinfo ? false : true;
	  var defaultSport = isEspnCricinfo ? 'cricket' : '';
	  var uriRewrites = (0, _selectn2.default)('uriRewrites', editionConfig);
	
	  var gameSettings = editionConfig.gameSettings || {};
	  var topEventsId = gameSettings.topEventsId;
	
	  var geoCountry = userGeo ? userGeo : country;
	
	  if (isEspnCricinfo && asiaRegions.indexOf(geoCountry.toLowerCase()) > -1) {
	    isAsiaRegion = true;
	  }
	
	  host = host || domain.replace(hostReplaces, '');
	  var headerSBTopicId = getheaderSBTopicId(isEspnCricinfo, country, language);
	
	  var edition = {
	    country: country,
	    userGeo: userGeo,
	    isAsiaRegion: isAsiaRegion,
	    countryName: countryName,
	    language: language,
	    domain: domain,
	    site: site,
	    // config: editionConfig,
	    siteId: siteId,
	    timeZoneBucket: _dateformat2.default.getTimezone(timeZoneBucket),
	    timeZoneDomain: timeZoneBucket,
	    editionKey: editionKey,
	    localEditionKey: localEditionKey,
	    xEdition: localEditionKey,
	    xEditionView: edition_view,
	    host: host,
	    // rewrites : rewrites,
	    https: https,
	    uriRewrites: uriRewrites,
	    // configs : configs
	    reactOverride: reactOverride,
	    taboola: taboolaSettings,
	    outbrain: outbrainSettings,
	    sponsoredContentProviders: sponsoredContentProviders,
	    isEspnCricinfo: isEspnCricinfo,
	    isMultiSports: isMultiSports,
	    defaultSport: defaultSport,
	    topEventsId: topEventsId,
	    headerSBTopicId: headerSBTopicId
	  };
	
	  return edition;
	}

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _momentTimezone = __webpack_require__(450);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _selectn = __webpack_require__(438);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	var _typeOf = __webpack_require__(578);
	
	var _typeOf2 = _interopRequireDefault(_typeOf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// date time formatting related settings
	function dateTime() {
	  var locale = (0, _momentTimezone2.default)()._locale;
	  return {
	    'dateFormats': {
	      'time1': 'h:mm A',
	      'date1': 'D MMM, YYYY',
	      'date2': 'D/M/YYYY',
	      'date3': 'DD/MM/YYYY',
	      'date4': 'DDMMYYYY',
	      'date5': 'Do MMMM YYYY',
	      'date6': 'dddd, Do MMMM YYYY',
	      'date7': 'ddd, D MMM YYYY',
	      'date8': 'D/M',
	      'date9': 'ddd',
	      'date10': 'dddd, MMMM Do',
	      'date11': 'MMMM YYYY',
	      'date12': 'YYYYMMDD',
	      'date13': 'LL',
	      'date14': 'dddd, MMMM D',
	      'date15': 'D',
	      'date16': 'ddd, MMM D',
	      'date17': 'll',
	      'date18': 'Do MMM, hh.mmA z',
	      'date19': 'YYYYMM',
	      'timezone1': 'z',
	      'timezone2': '(z)',
	      'dateTime1': 'h:mm A, MMMM D, YYYY'
	    },
	    'dayNamesLong': locale._weekdays,
	    'dayNamesMedium': locale._weekdaysShort,
	    'dayNamesShort': locale._weekdaysMin,
	    'monthNamesLong': locale._months,
	    'monthNamesShort': locale._monthsShort
	  };
	}
	
	var DEFAULT_TIMEZONE = 'America/New_York';
	var monthWiseSearchRegex = new RegExp('^\\d{4}(0[1-9]|1[0-2])$');
	var dateFormatYYYYMMDD = 'YYYYMMDD';
	
	exports.default = {
	
	  getTimezone: function getTimezone(domainTimezone) {
	    var timezone = DEFAULT_TIMEZONE;
	    if (process.browser) {
	      timezone = _momentTimezone2.default.tz.guess() || timezone;
	    } else {
	      timezone = domainTimezone || _momentTimezone2.default.tz.guess() || timezone;
	    }
	    return timezone;
	  },
	
	  getLocalTimezone: function getLocalTimezone() {
	    return _momentTimezone2.default.tz.guess() || DEFAULT_TIMEZONE;
	  },
	
	  dateToKey: function dateToKey(oDate) {
	    var timezone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	    return this.dateFormat(oDate, 'date12', timezone);
	  },
	
	  paramToDate: function paramToDate(sParam) {
	
	    if (typeof sParam === 'undefined' || sParam === null || !sParam) {
	      return null;
	    }
	    var iYear = sParam.substr(0, 4);
	    var iMonth = sParam.substr(4, 2);
	    var iDay = sParam.substr(6, 2);
	
	    return this.dateToObject(iYear + '-' + iMonth + '-' + iDay);
	  },
	
	  dateDayNamesMedium: function dateDayNamesMedium() {
	    return dateTime().dayNamesMedium;
	  },
	  dateDayNamesXShort: function dateDayNamesXShort() {
	    var days = dateTime().dayNamesShort || [];
	    days = days.map(function (day) {
	      return day[0];
	    });
	    return days;
	  },
	  dateDayNamesShort: function dateDayNamesShort() {
	    return dateTime().dayNamesShort;
	  },
	  monthNamesShort: function monthNamesShort() {
	    return dateTime().monthNamesShort;
	  },
	  monthNamesLong: function monthNamesLong() {
	    return dateTime().monthNamesLong;
	  },
	  dateFormat: function dateFormat() {
	    var ISODate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	    var _dateFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	    var timezone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	
	    var formatsMap = dateTime().dateFormats;
	    var dateType = (0, _typeOf2.default)(ISODate);
	    var dateString = ISODate;
	
	    if (ISODate && (dateType === 'string' || dateType === 'number')) {
	
	      if (!_dateFormat || (0, _typeOf2.default)(_dateFormat) !== 'string') {
	        _dateFormat = 'MMMM Do, YYYY';
	      } else {
	        if (formatsMap[_dateFormat]) {
	          _dateFormat = formatsMap[_dateFormat];
	        }
	      }
	
	      if (timezone && (0, _typeOf2.default)(timezone) !== 'string') {
	        timezone = '';
	      }
	
	      // Convert to moment object
	      var dateObj = (0, _momentTimezone2.default)(ISODate);
	
	      // Format the date only if valid
	      if (dateObj.isValid() === true) {
	        if (timezone && _momentTimezone2.default.tz.zone(timezone)) {
	          dateString = dateObj.tz(timezone).format(_dateFormat);
	        } else {
	          dateString = dateObj.format(_dateFormat);
	        }
	      }
	    }
	
	    return dateString;
	  },
	
	  /**
	   * Converts the date in d to a date-object using moment-timezone
	   * @param  {String/object} d date in string/Object
	   * @return {Object}          date-object
	   */
	  dateToObject: function dateToObject(d) {
	    return (0, _momentTimezone2.default)(d).toDate();
	  },
	
	  /**
	   * Compare two dates (could be of any type supported by the convert
	   * function above) and returns:
	   *  -1 : if a < b
	   *   0 : if a = b
	   *   1 : if a > b
	   * NaN : if a or b is an illegal date
	   * NOTE: The code inside isFinite does an assignment (=).
	   *
	   * @param  {String/object} a date in string/Object
	   * @param  {String/object} b date in string/Object
	   * @return {Number}        as described above
	   **/
	  dateCompare: function dateCompare(a, b) {
	    return isFinite(a = this.dateToObject(a).valueOf()) && isFinite(b = this.dateToObject(b).valueOf()) ? (a > b) - (a < b) : NaN;
	  },
	
	  /**
	   * Checks if date in d is between dates in start and end.
	   * Returns a boolean or NaN:
	   *    true  : if d is between start and end (inclusive)
	   *    false : if d is before start or after end
	   *    NaN   : if one or more of the dates is illegal.
	   * NOTE: The code inside isFinite does an assignment (=).
	   *
	   * @param {String/object} d date in string/Object
	   * @param {String/Object} start startdate
	   * @param {String/Object} end startdate
	   * @return {Boolean/NaN}  As described above
	   **/
	  dateInRange: function dateInRange(d, start, end) {
	    return isFinite(d = this.dateToObject(d).valueOf()) && isFinite(start = this.dateToObject(start).valueOf()) && isFinite(end = this.dateToObject(end).valueOf()) ? start <= d && d <= end : NaN;
	  },
	
	  /**
	   * Convert date/time as per the passed options of timezone and formatting
	   * @param  {String} d date  String in ISO 8601 format
	   * @param  {Object} options date formatting options
	   * @return {String}         formatted time as per the options
	   */
	  convertDateTime: function convertDateTime(d, options) {
	    // default return type
	    var displayTime = '';
	    /**
	     * default formatting options
	     * UTC as time zone - 'America/New_York'
	     * 24HR time format - HH:mm z
	     */
	    var timeZone = this.getLocalTimezone();
	    var timeFormat = 'HH:mm z';
	    // Override default options if options input has valid properties
	    if (typeof (0, _selectn2.default)('timeZone', options) !== 'undefined') {
	      timeZone = options.timeZone;
	    }
	
	    if (typeof (0, _selectn2.default)('timeFormat', options) !== 'undefined') {
	      timeFormat = options.timeFormat;
	    }
	    // Convert to moment object
	    var startTime = (0, _momentTimezone2.default)(d);
	    // Format the date only if valid
	    if (startTime.isValid() === true) {
	      displayTime = startTime.tz(timeZone).format(timeFormat);
	    }
	    return displayTime;
	  },
	  addMonths: function addMonths(date, months) {
	    return (0, _momentTimezone2.default)(date).add(months, 'months').toDate();
	  },
	  subtractMonths: function subtractMonths(date, months) {
	    return (0, _momentTimezone2.default)(date).subtract(months, 'months').toDate();
	  },
	  dateDiff: function dateDiff(fromDate, toDate, diffType) {
	    return (0, _momentTimezone2.default)(toDate).diff((0, _momentTimezone2.default)(fromDate), diffType);
	  },
	  /**
	   * Method to find if the game is happening today/on the selected day from date slider
	   * @param {String} competitionDate   Competition Date from API Response
	   * @param {String} queryDate   Date for which scoreboard is being displayed
	   * @return {boolean} true if the same day, otherwise false
	  */
	  isTheGameToday: function isTheGameToday(competitionDate, queryDate) {
	
	    var competitionDateMoment = (0, _momentTimezone2.default)(competitionDate).format(dateFormatYYYYMMDD),
	        currentDateMoment = void 0;
	
	    if (typeof queryDate === 'undefined' || monthWiseSearchRegex.test(queryDate)) {
	      currentDateMoment = (0, _momentTimezone2.default)().format(dateFormatYYYYMMDD);
	    } else {
	      currentDateMoment = (0, _momentTimezone2.default)(queryDate).format(dateFormatYYYYMMDD);
	    }
	
	    return currentDateMoment ? competitionDateMoment - currentDateMoment === 0 : false;
	  }
	};
	
	/* Date comparison taken from
	 * https://stackoverflow.com/questions/492994/compare-two-dates-with-javascript
	 */
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	var moment = module.exports = __webpack_require__(451);
	moment.tz.load(__webpack_require__(577));


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(console) {//! moment-timezone.js
	//! version : 0.5.21
	//! Copyright (c) JS Foundation and other contributors
	//! license : MIT
	//! github.com/moment/moment-timezone
	
	(function (root, factory) {
		"use strict";
	
		/*global define*/
		if (typeof module === 'object' && module.exports) {
			module.exports = factory(__webpack_require__(452)); // Node
		} else if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(452)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
		} else {
			factory(root.moment);                        // Browser
		}
	}(this, function (moment) {
		"use strict";
	
		// Do not load moment-timezone a second time.
		// if (moment.tz !== undefined) {
		// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
		// 	return moment;
		// }
	
		var VERSION = "0.5.21",
			zones = {},
			links = {},
			names = {},
			guesses = {},
			cachedGuess;
	
		if (!moment || typeof moment.version !== 'string') {
			logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
		}
	
		var momentVersion = moment.version.split('.'),
			major = +momentVersion[0],
			minor = +momentVersion[1];
	
		// Moment.js version check
		if (major < 2 || (major === 2 && minor < 6)) {
			logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
		}
	
		/************************************
			Unpacking
		************************************/
	
		function charCodeToInt(charCode) {
			if (charCode > 96) {
				return charCode - 87;
			} else if (charCode > 64) {
				return charCode - 29;
			}
			return charCode - 48;
		}
	
		function unpackBase60(string) {
			var i = 0,
				parts = string.split('.'),
				whole = parts[0],
				fractional = parts[1] || '',
				multiplier = 1,
				num,
				out = 0,
				sign = 1;
	
			// handle negative numbers
			if (string.charCodeAt(0) === 45) {
				i = 1;
				sign = -1;
			}
	
			// handle digits before the decimal
			for (i; i < whole.length; i++) {
				num = charCodeToInt(whole.charCodeAt(i));
				out = 60 * out + num;
			}
	
			// handle digits after the decimal
			for (i = 0; i < fractional.length; i++) {
				multiplier = multiplier / 60;
				num = charCodeToInt(fractional.charCodeAt(i));
				out += num * multiplier;
			}
	
			return out * sign;
		}
	
		function arrayToInt (array) {
			for (var i = 0; i < array.length; i++) {
				array[i] = unpackBase60(array[i]);
			}
		}
	
		function intToUntil (array, length) {
			for (var i = 0; i < length; i++) {
				array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
			}
	
			array[length - 1] = Infinity;
		}
	
		function mapIndices (source, indices) {
			var out = [], i;
	
			for (i = 0; i < indices.length; i++) {
				out[i] = source[indices[i]];
			}
	
			return out;
		}
	
		function unpack (string) {
			var data = string.split('|'),
				offsets = data[2].split(' '),
				indices = data[3].split(''),
				untils  = data[4].split(' ');
	
			arrayToInt(offsets);
			arrayToInt(indices);
			arrayToInt(untils);
	
			intToUntil(untils, indices.length);
	
			return {
				name       : data[0],
				abbrs      : mapIndices(data[1].split(' '), indices),
				offsets    : mapIndices(offsets, indices),
				untils     : untils,
				population : data[5] | 0
			};
		}
	
		/************************************
			Zone object
		************************************/
	
		function Zone (packedString) {
			if (packedString) {
				this._set(unpack(packedString));
			}
		}
	
		Zone.prototype = {
			_set : function (unpacked) {
				this.name       = unpacked.name;
				this.abbrs      = unpacked.abbrs;
				this.untils     = unpacked.untils;
				this.offsets    = unpacked.offsets;
				this.population = unpacked.population;
			},
	
			_index : function (timestamp) {
				var target = +timestamp,
					untils = this.untils,
					i;
	
				for (i = 0; i < untils.length; i++) {
					if (target < untils[i]) {
						return i;
					}
				}
			},
	
			parse : function (timestamp) {
				var target  = +timestamp,
					offsets = this.offsets,
					untils  = this.untils,
					max     = untils.length - 1,
					offset, offsetNext, offsetPrev, i;
	
				for (i = 0; i < max; i++) {
					offset     = offsets[i];
					offsetNext = offsets[i + 1];
					offsetPrev = offsets[i ? i - 1 : i];
	
					if (offset < offsetNext && tz.moveAmbiguousForward) {
						offset = offsetNext;
					} else if (offset > offsetPrev && tz.moveInvalidForward) {
						offset = offsetPrev;
					}
	
					if (target < untils[i] - (offset * 60000)) {
						return offsets[i];
					}
				}
	
				return offsets[max];
			},
	
			abbr : function (mom) {
				return this.abbrs[this._index(mom)];
			},
	
			offset : function (mom) {
				logError("zone.offset has been deprecated in favor of zone.utcOffset");
				return this.offsets[this._index(mom)];
			},
	
			utcOffset : function (mom) {
				return this.offsets[this._index(mom)];
			}
		};
	
		/************************************
			Current Timezone
		************************************/
	
		function OffsetAt(at) {
			var timeString = at.toTimeString();
			var abbr = timeString.match(/\([a-z ]+\)/i);
			if (abbr && abbr[0]) {
				// 17:56:31 GMT-0600 (CST)
				// 17:56:31 GMT-0600 (Central Standard Time)
				abbr = abbr[0].match(/[A-Z]/g);
				abbr = abbr ? abbr.join('') : undefined;
			} else {
				// 17:56:31 CST
				// 17:56:31 GMT+0800 (台北標準時間)
				abbr = timeString.match(/[A-Z]{3,5}/g);
				abbr = abbr ? abbr[0] : undefined;
			}
	
			if (abbr === 'GMT') {
				abbr = undefined;
			}
	
			this.at = +at;
			this.abbr = abbr;
			this.offset = at.getTimezoneOffset();
		}
	
		function ZoneScore(zone) {
			this.zone = zone;
			this.offsetScore = 0;
			this.abbrScore = 0;
		}
	
		ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
			this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
			if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
				this.abbrScore++;
			}
		};
	
		function findChange(low, high) {
			var mid, diff;
	
			while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
				mid = new OffsetAt(new Date(low.at + diff));
				if (mid.offset === low.offset) {
					low = mid;
				} else {
					high = mid;
				}
			}
	
			return low;
		}
	
		function userOffsets() {
			var startYear = new Date().getFullYear() - 2,
				last = new OffsetAt(new Date(startYear, 0, 1)),
				offsets = [last],
				change, next, i;
	
			for (i = 1; i < 48; i++) {
				next = new OffsetAt(new Date(startYear, i, 1));
				if (next.offset !== last.offset) {
					change = findChange(last, next);
					offsets.push(change);
					offsets.push(new OffsetAt(new Date(change.at + 6e4)));
				}
				last = next;
			}
	
			for (i = 0; i < 4; i++) {
				offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
				offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
			}
	
			return offsets;
		}
	
		function sortZoneScores (a, b) {
			if (a.offsetScore !== b.offsetScore) {
				return a.offsetScore - b.offsetScore;
			}
			if (a.abbrScore !== b.abbrScore) {
				return a.abbrScore - b.abbrScore;
			}
			return b.zone.population - a.zone.population;
		}
	
		function addToGuesses (name, offsets) {
			var i, offset;
			arrayToInt(offsets);
			for (i = 0; i < offsets.length; i++) {
				offset = offsets[i];
				guesses[offset] = guesses[offset] || {};
				guesses[offset][name] = true;
			}
		}
	
		function guessesForUserOffsets (offsets) {
			var offsetsLength = offsets.length,
				filteredGuesses = {},
				out = [],
				i, j, guessesOffset;
	
			for (i = 0; i < offsetsLength; i++) {
				guessesOffset = guesses[offsets[i].offset] || {};
				for (j in guessesOffset) {
					if (guessesOffset.hasOwnProperty(j)) {
						filteredGuesses[j] = true;
					}
				}
			}
	
			for (i in filteredGuesses) {
				if (filteredGuesses.hasOwnProperty(i)) {
					out.push(names[i]);
				}
			}
	
			return out;
		}
	
		function rebuildGuess () {
	
			// use Intl API when available and returning valid time zone
			try {
				var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
				if (intlName && intlName.length > 3) {
					var name = names[normalizeName(intlName)];
					if (name) {
						return name;
					}
					logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
				}
			} catch (e) {
				// Intl unavailable, fall back to manual guessing.
			}
	
			var offsets = userOffsets(),
				offsetsLength = offsets.length,
				guesses = guessesForUserOffsets(offsets),
				zoneScores = [],
				zoneScore, i, j;
	
			for (i = 0; i < guesses.length; i++) {
				zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
				for (j = 0; j < offsetsLength; j++) {
					zoneScore.scoreOffsetAt(offsets[j]);
				}
				zoneScores.push(zoneScore);
			}
	
			zoneScores.sort(sortZoneScores);
	
			return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
		}
	
		function guess (ignoreCache) {
			if (!cachedGuess || ignoreCache) {
				cachedGuess = rebuildGuess();
			}
			return cachedGuess;
		}
	
		/************************************
			Global Methods
		************************************/
	
		function normalizeName (name) {
			return (name || '').toLowerCase().replace(/\//g, '_');
		}
	
		function addZone (packed) {
			var i, name, split, normalized;
	
			if (typeof packed === "string") {
				packed = [packed];
			}
	
			for (i = 0; i < packed.length; i++) {
				split = packed[i].split('|');
				name = split[0];
				normalized = normalizeName(name);
				zones[normalized] = packed[i];
				names[normalized] = name;
				addToGuesses(normalized, split[2].split(' '));
			}
		}
	
		function getZone (name, caller) {
			
			name = normalizeName(name);
	
			var zone = zones[name];
			var link;
	
			if (zone instanceof Zone) {
				return zone;
			}
	
			if (typeof zone === 'string') {
				zone = new Zone(zone);
				zones[name] = zone;
				return zone;
			}
	
			// Pass getZone to prevent recursion more than 1 level deep
			if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
				zone = zones[name] = new Zone();
				zone._set(link);
				zone.name = names[name];
				return zone;
			}
	
			return null;
		}
	
		function getNames () {
			var i, out = [];
	
			for (i in names) {
				if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
					out.push(names[i]);
				}
			}
	
			return out.sort();
		}
	
		function addLink (aliases) {
			var i, alias, normal0, normal1;
	
			if (typeof aliases === "string") {
				aliases = [aliases];
			}
	
			for (i = 0; i < aliases.length; i++) {
				alias = aliases[i].split('|');
	
				normal0 = normalizeName(alias[0]);
				normal1 = normalizeName(alias[1]);
	
				links[normal0] = normal1;
				names[normal0] = alias[0];
	
				links[normal1] = normal0;
				names[normal1] = alias[1];
			}
		}
	
		function loadData (data) {
			addZone(data.zones);
			addLink(data.links);
			tz.dataVersion = data.version;
		}
	
		function zoneExists (name) {
			if (!zoneExists.didShowError) {
				zoneExists.didShowError = true;
					logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
			}
			return !!getZone(name);
		}
	
		function needsOffset (m) {
			var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
			return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
		}
	
		function logError (message) {
			if (typeof console !== 'undefined' && typeof console.error === 'function') {
				console.error(message);
			}
		}
	
		/************************************
			moment.tz namespace
		************************************/
	
		function tz (input) {
			var args = Array.prototype.slice.call(arguments, 0, -1),
				name = arguments[arguments.length - 1],
				zone = getZone(name),
				out  = moment.utc.apply(null, args);
	
			if (zone && !moment.isMoment(input) && needsOffset(out)) {
				out.add(zone.parse(out), 'minutes');
			}
	
			out.tz(name);
	
			return out;
		}
	
		tz.version      = VERSION;
		tz.dataVersion  = '';
		tz._zones       = zones;
		tz._links       = links;
		tz._names       = names;
		tz.add          = addZone;
		tz.link         = addLink;
		tz.load         = loadData;
		tz.zone         = getZone;
		tz.zoneExists   = zoneExists; // deprecated in 0.1.0
		tz.guess        = guess;
		tz.names        = getNames;
		tz.Zone         = Zone;
		tz.unpack       = unpack;
		tz.unpackBase60 = unpackBase60;
		tz.needsOffset  = needsOffset;
		tz.moveInvalidForward   = true;
		tz.moveAmbiguousForward = false;
	
		/************************************
			Interface with Moment.js
		************************************/
	
		var fn = moment.fn;
	
		moment.tz = tz;
	
		moment.defaultZone = null;
	
		moment.updateOffset = function (mom, keepTime) {
			var zone = moment.defaultZone,
				offset;
	
			if (mom._z === undefined) {
				if (zone && needsOffset(mom) && !mom._isUTC) {
					mom._d = moment.utc(mom._a)._d;
					mom.utc().add(zone.parse(mom), 'minutes');
				}
				mom._z = zone;
			}
			if (mom._z) {
				offset = mom._z.utcOffset(mom);
				if (Math.abs(offset) < 16) {
					offset = offset / 60;
				}
				if (mom.utcOffset !== undefined) {
					mom.utcOffset(-offset, keepTime);
				} else {
					mom.zone(offset, keepTime);
				}
			}
		};
	
		fn.tz = function (name, keepTime) {
			if (name) {
				if (typeof name !== 'string') {
					throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
				}
				this._z = getZone(name);
				if (this._z) {
					moment.updateOffset(this, keepTime);
				} else {
					logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
				}
				return this;
			}
			if (this._z) { return this._z.name; }
		};
	
		function abbrWrap (old) {
			return function () {
				if (this._z) { return this._z.abbr(this); }
				return old.call(this);
			};
		}
	
		function resetZoneWrap (old) {
			return function () {
				this._z = null;
				return old.apply(this, arguments);
			};
		}
	
		fn.zoneName = abbrWrap(fn.zoneName);
		fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
		fn.utc      = resetZoneWrap(fn.utc);
	
		moment.tz.setDefault = function(name) {
			if (major < 2 || (major === 2 && minor < 9)) {
				logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
			}
			moment.defaultZone = name ? getZone(name) : null;
			return moment;
		};
	
		// Cloning a moment should include the _z property.
		var momentProperties = moment.momentProperties;
		if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
			// moment 2.8.1+
			momentProperties.push('_z');
			momentProperties.push('_a');
		} else if (momentProperties) {
			// moment 2.7.0
			momentProperties._z = null;
		}
	
		// INJECT DATA
	
		return moment;
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(console, module) {//! moment.js
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return (Object.getOwnPropertyNames(obj).length === 0);
	        } else {
	            var k;
	            for (k in obj) {
	                if (obj.hasOwnProperty(k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null,
	            rfc2822         : false,
	            weekdayMismatch : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid = isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            }
	            else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid (flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        ss : '%d seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function set$1 (mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	            }
	            else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        if (!m) {
	            return isArray(this._months) ? this._months :
	                this._months['standalone'];
	        }
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        if (!m) {
	            return isArray(this._monthsShort) ? this._monthsShort :
	                this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date = new Date(y, m, d, h, M, s, ms);
	
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	            date.setFullYear(y);
	        }
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date = new Date(Date.UTC.apply(null, arguments));
	
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	            date.setUTCFullYear(y);
	        }
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        if (!m) {
	            return isArray(this._weekdays) ? this._weekdays :
	                this._weekdays['standalone'];
	        }
	        return isArray(this._weekdays) ? this._weekdays[m.day()] :
	            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('k',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour they want. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var localeFamilies = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                var aliasedRequire = require;
	                __webpack_require__(453)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {}
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	            else {
	                if ((typeof console !==  'undefined') && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var locale, parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, tmpLocale, parentConfig = baseConfig;
	            // MERGE
	            tmpLocale = loadLocale(name);
	            if (tmpLocale != null) {
	                parentConfig = tmpLocale._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            var curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from begining of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to begining of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10)
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    var obsOffsets = {
	        UT: 0,
	        GMT: 0,
	        EDT: -4 * 60,
	        EST: -5 * 60,
	        CDT: -5 * 60,
	        CST: -6 * 60,
	        MDT: -6 * 60,
	        MST: -7 * 60,
	        PDT: -7 * 60,
	        PST: -8 * 60
	    };
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10);
	            var m = hm % 100, h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i));
	        if (match) {
	            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        // Final attempt, use Input Fallback
	        hooks.createFromInputFallback(config);
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	        'discouraged and will be removed in an upcoming major release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	    function isDurationValid(m) {
	        for (var key in m) {
	            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	                return false;
	            }
	        }
	
	        var unitHasDecimal = false;
	        for (var i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher);
	
	        if (matches === null) {
	            return null;
	        }
	
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ?
	          0 :
	          parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            }
	            else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (isNumber(input)) {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])                         * sign,
	                h  : toInt(match[HOUR])                         * sign,
	                m  : toInt(match[MINUTE])                       * sign,
	                s  : toInt(match[SECOND])                       * sign,
	                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {milliseconds: 0, months: 0};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add      = createAdder(1, 'add');
	    var subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function calendar$1 (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units || 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input,units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input,units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year': output = monthDiff(this, that) / 12; break;
	            case 'month': output = monthDiff(this, that); break;
	            case 'quarter': output = monthDiff(this, that) / 3; break;
	            case 'second': output = (this - that) / 1e3; break; // 1000
	            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default: output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true;
	        var m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect () {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment';
	        var zone = '';
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        var prefix = '[' + func + '("]';
	        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        var suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    function startOf (units) {
	        units = normalizeUnits(units);
	        // the following switch intentionally omits break keywords
	        // to utilize falling through the cases.
	        switch (units) {
	            case 'year':
	                this.month(0);
	                /* falls through */
	            case 'quarter':
	            case 'month':
	                this.date(1);
	                /* falls through */
	            case 'week':
	            case 'isoWeek':
	            case 'day':
	            case 'date':
	                this.hours(0);
	                /* falls through */
	            case 'hour':
	                this.minutes(0);
	                /* falls through */
	            case 'minute':
	                this.seconds(0);
	                /* falls through */
	            case 'second':
	                this.milliseconds(0);
	        }
	
	        // weeks are a special case
	        if (units === 'week') {
	            this.weekday(0);
	        }
	        if (units === 'isoWeek') {
	            this.isoWeekday(1);
	        }
	
	        // quarters are also special
	        if (units === 'quarter') {
	            this.month(Math.floor(this.month() / 3) * 3);
	        }
	
	        return this;
	    }
	
	    function endOf (units) {
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond') {
	            return this;
	        }
	
	        // 'date' is an alias for 'day', so it should be considered as such.
	        if (units === 'date') {
	            units = 'day';
	        }
	
	        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	    }
	
	    function valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2 () {
	        return isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict ?
	          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	          locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add               = add;
	    proto.calendar          = calendar$1;
	    proto.clone             = clone;
	    proto.diff              = diff;
	    proto.endOf             = endOf;
	    proto.format            = format;
	    proto.from              = from;
	    proto.fromNow           = fromNow;
	    proto.to                = to;
	    proto.toNow             = toNow;
	    proto.get               = stringGet;
	    proto.invalidAt         = invalidAt;
	    proto.isAfter           = isAfter;
	    proto.isBefore          = isBefore;
	    proto.isBetween         = isBetween;
	    proto.isSame            = isSame;
	    proto.isSameOrAfter     = isSameOrAfter;
	    proto.isSameOrBefore    = isSameOrBefore;
	    proto.isValid           = isValid$2;
	    proto.lang              = lang;
	    proto.locale            = locale;
	    proto.localeData        = localeData;
	    proto.max               = prototypeMax;
	    proto.min               = prototypeMin;
	    proto.parsingFlags      = parsingFlags;
	    proto.set               = stringSet;
	    proto.startOf           = startOf;
	    proto.subtract          = subtract;
	    proto.toArray           = toArray;
	    proto.toObject          = toObject;
	    proto.toDate            = toDate;
	    proto.toISOString       = toISOString;
	    proto.inspect           = inspect;
	    proto.toJSON            = toJSON;
	    proto.toString          = toString;
	    proto.unix              = unix;
	    proto.valueOf           = valueOf;
	    proto.creationData      = creationData;
	    proto.year       = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear    = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month       = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week           = proto.weeks        = getSetWeek;
	    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	    proto.weeksInYear    = getWeeksInYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.date       = getSetDayOfMonth;
	    proto.day        = proto.days             = getSetDayOfWeek;
	    proto.weekday    = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear  = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset            = getSetOffset;
	    proto.utc                  = setOffsetToUTC;
	    proto.local                = setOffsetToLocal;
	    proto.parseZone            = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST                = isDaylightSavingTime;
	    proto.isLocal              = isLocal;
	    proto.isUtcOffset          = isUtcOffset;
	    proto.isUtc                = isUtc;
	    proto.isUTC                = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    function createUnix (input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone () {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar        = calendar;
	    proto$1.longDateFormat  = longDateFormat;
	    proto$1.invalidDate     = invalidDate;
	    proto$1.ordinal         = ordinal;
	    proto$1.preparse        = preParsePostFormat;
	    proto$1.postformat      = preParsePostFormat;
	    proto$1.relativeTime    = relativeTime;
	    proto$1.pastFuture      = pastFuture;
	    proto$1.set             = set;
	
	    proto$1.months            =        localeMonths;
	    proto$1.monthsShort       =        localeMonthsShort;
	    proto$1.monthsParse       =        localeMonthsParse;
	    proto$1.monthsRegex       = monthsRegex;
	    proto$1.monthsShortRegex  = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays       =        localeWeekdays;
	    proto$1.weekdaysMin    =        localeWeekdaysMin;
	    proto$1.weekdaysShort  =        localeWeekdaysShort;
	    proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	    proto$1.weekdaysRegex       =        weekdaysRegex;
	    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1 (format, index, field, setter) {
	        var locale = getLocale();
	        var utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	    var mathAbs = Math.abs;
	
	    function abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1 (duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1 (input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1 (input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'year') {
	            days   = this._days   + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            return units === 'month' ? months : months / 12;
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1 () {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asYears        = makeAs('y');
	
	    function clone$1 () {
	        return createDuration(this);
	    }
	
	    function get$2 (units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        ss: 44,         // a few seconds to seconds
	        s : 45,         // seconds to minute
	        m : 45,         // minutes to hour
	        h : 22,         // hours to day
	        d : 26,         // days to month
	        M : 11          // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	        var duration = createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds <= thresholds.ss && ['s', seconds]  ||
	                seconds < thresholds.s   && ['ss', seconds] ||
	                minutes <= 1             && ['m']           ||
	                minutes < thresholds.m   && ['mm', minutes] ||
	                hours   <= 1             && ['h']           ||
	                hours   < thresholds.h   && ['hh', hours]   ||
	                days    <= 1             && ['d']           ||
	                days    < thresholds.d   && ['dd', days]    ||
	                months  <= 1             && ['M']           ||
	                months  < thresholds.M   && ['MM', months]  ||
	                years   <= 1             && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var locale = this.localeData();
	        var output = relativeTime$1(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return ((x > 0) - (x < 0)) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000;
	        var days         = abs$1(this._days);
	        var months       = abs$1(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        var totalSign = total < 0 ? '-' : '';
	        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return totalSign + 'P' +
	            (Y ? ymSign + Y + 'Y' : '') +
	            (M ? ymSign + M + 'M' : '') +
	            (D ? daysSign + D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? hmsSign + h + 'H' : '') +
	            (m ? hmsSign + m + 'M' : '') +
	            (s ? hmsSign + s + 'S' : '');
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid        = isValid$1;
	    proto$2.abs            = abs;
	    proto$2.add            = add$1;
	    proto$2.subtract       = subtract$1;
	    proto$2.as             = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds      = asSeconds;
	    proto$2.asMinutes      = asMinutes;
	    proto$2.asHours        = asHours;
	    proto$2.asDays         = asDays;
	    proto$2.asWeeks        = asWeeks;
	    proto$2.asMonths       = asMonths;
	    proto$2.asYears        = asYears;
	    proto$2.valueOf        = valueOf$1;
	    proto$2._bubble        = bubble;
	    proto$2.clone          = clone$1;
	    proto$2.get            = get$2;
	    proto$2.milliseconds   = milliseconds;
	    proto$2.seconds        = seconds;
	    proto$2.minutes        = minutes;
	    proto$2.hours          = hours;
	    proto$2.days           = days;
	    proto$2.weeks          = weeks;
	    proto$2.months         = months;
	    proto$2.years          = years;
	    proto$2.humanize       = humanize;
	    proto$2.toISOString    = toISOString$1;
	    proto$2.toString       = toISOString$1;
	    proto$2.toJSON         = toISOString$1;
	    proto$2.locale         = locale;
	    proto$2.localeData     = localeData;
	
	    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	    proto$2.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    hooks.version = '2.22.2';
	
	    setHookCallback(createLocal);
	
	    hooks.fn                    = proto;
	    hooks.min                   = min;
	    hooks.max                   = max;
	    hooks.now                   = now;
	    hooks.utc                   = createUTC;
	    hooks.unix                  = createUnix;
	    hooks.months                = listMonths;
	    hooks.isDate                = isDate;
	    hooks.locale                = getSetGlobalLocale;
	    hooks.invalid               = createInvalid;
	    hooks.duration              = createDuration;
	    hooks.isMoment              = isMoment;
	    hooks.weekdays              = listWeekdays;
	    hooks.parseZone             = createInZone;
	    hooks.localeData            = getLocale;
	    hooks.isDuration            = isDuration;
	    hooks.monthsShort           = listMonthsShort;
	    hooks.weekdaysMin           = listWeekdaysMin;
	    hooks.defineLocale          = defineLocale;
	    hooks.updateLocale          = updateLocale;
	    hooks.locales               = listLocales;
	    hooks.weekdaysShort         = listWeekdaysShort;
	    hooks.normalizeUnits        = normalizeUnits;
	    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat        = getCalendarFormat;
	    hooks.prototype             = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD',                             // <input type="date" />
	        TIME: 'HH:mm',                                  // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	        WEEK: 'YYYY-[W]WW',                             // <input type="week" />
	        MONTH: 'YYYY-MM'                                // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(269)(module)))

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 454,
		"./af.js": 454,
		"./ar": 455,
		"./ar-dz": 456,
		"./ar-dz.js": 456,
		"./ar-kw": 457,
		"./ar-kw.js": 457,
		"./ar-ly": 458,
		"./ar-ly.js": 458,
		"./ar-ma": 459,
		"./ar-ma.js": 459,
		"./ar-sa": 460,
		"./ar-sa.js": 460,
		"./ar-tn": 461,
		"./ar-tn.js": 461,
		"./ar.js": 455,
		"./az": 462,
		"./az.js": 462,
		"./be": 463,
		"./be.js": 463,
		"./bg": 464,
		"./bg.js": 464,
		"./bm": 465,
		"./bm.js": 465,
		"./bn": 466,
		"./bn.js": 466,
		"./bo": 467,
		"./bo.js": 467,
		"./br": 468,
		"./br.js": 468,
		"./bs": 469,
		"./bs.js": 469,
		"./ca": 470,
		"./ca.js": 470,
		"./cs": 471,
		"./cs.js": 471,
		"./cv": 472,
		"./cv.js": 472,
		"./cy": 473,
		"./cy.js": 473,
		"./da": 474,
		"./da.js": 474,
		"./de": 475,
		"./de-at": 476,
		"./de-at.js": 476,
		"./de-ch": 477,
		"./de-ch.js": 477,
		"./de.js": 475,
		"./dv": 478,
		"./dv.js": 478,
		"./el": 479,
		"./el.js": 479,
		"./en-au": 480,
		"./en-au.js": 480,
		"./en-ca": 481,
		"./en-ca.js": 481,
		"./en-gb": 482,
		"./en-gb.js": 482,
		"./en-ie": 483,
		"./en-ie.js": 483,
		"./en-il": 484,
		"./en-il.js": 484,
		"./en-nz": 485,
		"./en-nz.js": 485,
		"./eo": 486,
		"./eo.js": 486,
		"./es": 487,
		"./es-do": 488,
		"./es-do.js": 488,
		"./es-us": 489,
		"./es-us.js": 489,
		"./es.js": 487,
		"./et": 490,
		"./et.js": 490,
		"./eu": 491,
		"./eu.js": 491,
		"./fa": 492,
		"./fa.js": 492,
		"./fi": 493,
		"./fi.js": 493,
		"./fo": 494,
		"./fo.js": 494,
		"./fr": 495,
		"./fr-ca": 496,
		"./fr-ca.js": 496,
		"./fr-ch": 497,
		"./fr-ch.js": 497,
		"./fr.js": 495,
		"./fy": 498,
		"./fy.js": 498,
		"./gd": 499,
		"./gd.js": 499,
		"./gl": 500,
		"./gl.js": 500,
		"./gom-latn": 501,
		"./gom-latn.js": 501,
		"./gu": 502,
		"./gu.js": 502,
		"./he": 503,
		"./he.js": 503,
		"./hi": 504,
		"./hi.js": 504,
		"./hr": 505,
		"./hr.js": 505,
		"./hu": 506,
		"./hu.js": 506,
		"./hy-am": 507,
		"./hy-am.js": 507,
		"./id": 508,
		"./id.js": 508,
		"./is": 509,
		"./is.js": 509,
		"./it": 510,
		"./it.js": 510,
		"./ja": 511,
		"./ja.js": 511,
		"./jv": 512,
		"./jv.js": 512,
		"./ka": 513,
		"./ka.js": 513,
		"./kk": 514,
		"./kk.js": 514,
		"./km": 515,
		"./km.js": 515,
		"./kn": 516,
		"./kn.js": 516,
		"./ko": 517,
		"./ko.js": 517,
		"./ky": 518,
		"./ky.js": 518,
		"./lb": 519,
		"./lb.js": 519,
		"./lo": 520,
		"./lo.js": 520,
		"./lt": 521,
		"./lt.js": 521,
		"./lv": 522,
		"./lv.js": 522,
		"./me": 523,
		"./me.js": 523,
		"./mi": 524,
		"./mi.js": 524,
		"./mk": 525,
		"./mk.js": 525,
		"./ml": 526,
		"./ml.js": 526,
		"./mn": 527,
		"./mn.js": 527,
		"./mr": 528,
		"./mr.js": 528,
		"./ms": 529,
		"./ms-my": 530,
		"./ms-my.js": 530,
		"./ms.js": 529,
		"./mt": 531,
		"./mt.js": 531,
		"./my": 532,
		"./my.js": 532,
		"./nb": 533,
		"./nb.js": 533,
		"./ne": 534,
		"./ne.js": 534,
		"./nl": 535,
		"./nl-be": 536,
		"./nl-be.js": 536,
		"./nl.js": 535,
		"./nn": 537,
		"./nn.js": 537,
		"./pa-in": 538,
		"./pa-in.js": 538,
		"./pl": 539,
		"./pl.js": 539,
		"./pt": 540,
		"./pt-br": 541,
		"./pt-br.js": 541,
		"./pt.js": 540,
		"./ro": 542,
		"./ro.js": 542,
		"./ru": 543,
		"./ru.js": 543,
		"./sd": 544,
		"./sd.js": 544,
		"./se": 545,
		"./se.js": 545,
		"./si": 546,
		"./si.js": 546,
		"./sk": 547,
		"./sk.js": 547,
		"./sl": 548,
		"./sl.js": 548,
		"./sq": 549,
		"./sq.js": 549,
		"./sr": 550,
		"./sr-cyrl": 551,
		"./sr-cyrl.js": 551,
		"./sr.js": 550,
		"./ss": 552,
		"./ss.js": 552,
		"./sv": 553,
		"./sv.js": 553,
		"./sw": 554,
		"./sw.js": 554,
		"./ta": 555,
		"./ta.js": 555,
		"./te": 556,
		"./te.js": 556,
		"./tet": 557,
		"./tet.js": 557,
		"./tg": 558,
		"./tg.js": 558,
		"./th": 559,
		"./th.js": 559,
		"./tl-ph": 560,
		"./tl-ph.js": 560,
		"./tlh": 561,
		"./tlh.js": 561,
		"./tr": 562,
		"./tr.js": 562,
		"./tzl": 563,
		"./tzl.js": 563,
		"./tzm": 564,
		"./tzm-latn": 565,
		"./tzm-latn.js": 565,
		"./tzm.js": 564,
		"./ug-cn": 566,
		"./ug-cn.js": 566,
		"./uk": 567,
		"./uk.js": 567,
		"./ur": 568,
		"./ur.js": 568,
		"./uz": 569,
		"./uz-latn": 570,
		"./uz-latn.js": 570,
		"./uz.js": 569,
		"./vi": 571,
		"./vi.js": 571,
		"./x-pseudo": 572,
		"./x-pseudo.js": 572,
		"./yo": 573,
		"./yo.js": 573,
		"./zh-cn": 574,
		"./zh-cn.js": 574,
		"./zh-hk": 575,
		"./zh-hk.js": 575,
		"./zh-tw": 576,
		"./zh-tw.js": 576
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 453;


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var af = moment.defineLocale('af', {
	        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM : function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Vandag om] LT',
	            nextDay : '[Môre om] LT',
	            nextWeek : 'dddd [om] LT',
	            lastDay : '[Gister om] LT',
	            lastWeek : '[Laas] dddd [om] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'oor %s',
	            past : '%s gelede',
	            s : '\'n paar sekondes',
	            ss : '%d sekondes',
	            m : '\'n minuut',
	            mm : '%d minute',
	            h : '\'n uur',
	            hh : '%d ure',
	            d : '\'n dag',
	            dd : '%d dae',
	            M : '\'n maand',
	            MM : '%d maande',
	            y : '\'n jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week : {
	            dow : 1, // Maandag is die eerste dag van die week.
	            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });
	
	    return af;
	
	})));


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var ar = moment.defineLocale('ar', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar;
	
	})));


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 4  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return arDz;
	
	})));


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return arKw;
	
	})));


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '1',
	        '2': '2',
	        '3': '3',
	        '4': '4',
	        '5': '5',
	        '6': '6',
	        '7': '7',
	        '8': '8',
	        '9': '9',
	        '0': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return arLy;
	
	})));


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return arMa;
	
	})));


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return arSa;
	
	})));


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss : '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return arTn;
	
	})));


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };
	
	    var az = moment.defineLocale('az', {
	        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[sabah saat] LT',
	            nextWeek : '[gələn həftə] dddd [saat] LT',
	            lastDay : '[dünən] LT',
	            lastWeek : '[keçən həftə] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s əvvəl',
	            s : 'birneçə saniyə',
	            ss : '%d saniyə',
	            m : 'bir dəqiqə',
	            mm : '%d dəqiqə',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir il',
	            yy : '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM : function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return az;
	
	})));


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months : {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	        },
	        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays : {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
	        },
	        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'праз %s',
	            past : '%s таму',
	            s : 'некалькі секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithPlural,
	            hh : relativeTimeWithPlural,
	            d : 'дзень',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM : function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return be;
	
	})));


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bg = moment.defineLocale('bg', {
	        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Днес в] LT',
	            nextDay : '[Утре в] LT',
	            nextWeek : 'dddd [в] LT',
	            lastDay : '[Вчера в] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[В изминалата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'след %s',
	            past : 'преди %s',
	            s : 'няколко секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дни',
	            M : 'месец',
	            MM : '%d месеца',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bg;
	
	})));


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bm = moment.defineLocale('bm', {
	        months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
	        monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'MMMM [tile] D [san] YYYY',
	            LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bi lɛrɛ] LT',
	            nextDay : '[Sini lɛrɛ] LT',
	            nextWeek : 'dddd [don lɛrɛ] LT',
	            lastDay : '[Kunu lɛrɛ] LT',
	            lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s kɔnɔ',
	            past : 'a bɛ %s bɔ',
	            s : 'sanga dama dama',
	            ss : 'sekondi %d',
	            m : 'miniti kelen',
	            mm : 'miniti %d',
	            h : 'lɛrɛ kelen',
	            hh : 'lɛrɛ %d',
	            d : 'tile kelen',
	            dd : 'tile %d',
	            M : 'kalo kelen',
	            MM : 'kalo %d',
	            y : 'san kelen',
	            yy : 'san %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return bm;
	
	})));


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    },
	    numberMap = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };
	
	    var bn = moment.defineLocale('bn', {
	        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm সময়',
	            LTS : 'A h:mm:ss সময়',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm সময়',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar : {
	            sameDay : '[আজ] LT',
	            nextDay : '[আগামীকাল] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[গতকাল] LT',
	            lastWeek : '[গত] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s পরে',
	            past : '%s আগে',
	            s : 'কয়েক সেকেন্ড',
	            ss : '%d সেকেন্ড',
	            m : 'এক মিনিট',
	            mm : '%d মিনিট',
	            h : 'এক ঘন্টা',
	            hh : '%d ঘন্টা',
	            d : 'এক দিন',
	            dd : '%d দিন',
	            M : 'এক মাস',
	            MM : '%d মাস',
	            y : 'এক বছর',
	            yy : '%d বছর'
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'রাত' && hour >= 4) ||
	                    (meridiem === 'দুপুর' && hour < 5) ||
	                    meridiem === 'বিকাল') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bn;
	
	})));


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    },
	    numberMap = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };
	
	    var bo = moment.defineLocale('bo', {
	        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[དི་རིང] LT',
	            nextDay : '[སང་ཉིན] LT',
	            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay : '[ཁ་སང] LT',
	            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ལ་',
	            past : '%s སྔན་ལ',
	            s : 'ལམ་སང',
	            ss : '%d སྐར་ཆ།',
	            m : 'སྐར་མ་གཅིག',
	            mm : '%d སྐར་མ',
	            h : 'ཆུ་ཚོད་གཅིག',
	            hh : '%d ཆུ་ཚོད',
	            d : 'ཉིན་གཅིག',
	            dd : '%d ཉིན་',
	            M : 'ཟླ་བ་གཅིག',
	            MM : '%d ཟླ་བ',
	            y : 'ལོ་གཅིག',
	            yy : '%d ལོ'
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                    meridiem === 'དགོང་དག') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bo;
	
	})));


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var br = moment.defineLocale('br', {
	        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h[e]mm A',
	            LTS : 'h[e]mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [a viz] MMMM YYYY',
	            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar : {
	            sameDay : '[Hiziv da] LT',
	            nextDay : '[Warc\'hoazh da] LT',
	            nextWeek : 'dddd [da] LT',
	            lastDay : '[Dec\'h da] LT',
	            lastWeek : 'dddd [paset da] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'a-benn %s',
	            past : '%s \'zo',
	            s : 'un nebeud segondennoù',
	            ss : '%d eilenn',
	            m : 'ur vunutenn',
	            mm : relativeTimeWithMutation,
	            h : 'un eur',
	            hh : '%d eur',
	            d : 'un devezh',
	            dd : relativeTimeWithMutation,
	            M : 'ur miz',
	            MM : relativeTimeWithMutation,
	            y : 'ur bloaz',
	            yy : specialMutationForYears
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal : function (number) {
	            var output = (number === 1) ? 'añ' : 'vet';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return br;
	
	})));


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bs;
	
	})));


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ca = moment.defineLocale('ca', {
	        months : {
	            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	            isFormat: /D[oD]?(\s)+MMMM/
	        },
	        monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [de] YYYY',
	            ll : 'D MMM YYYY',
	            LLL : 'D MMMM [de] YYYY [a les] H:mm',
	            lll : 'D MMM YYYY, H:mm',
	            LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll : 'ddd D MMM YYYY, H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextDay : function () {
	                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastDay : function () {
	                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'd\'aquí %s',
	            past : 'fa %s',
	            s : 'uns segons',
	            ss : '%d segons',
	            m : 'un minut',
	            mm : '%d minuts',
	            h : 'una hora',
	            hh : '%d hores',
	            d : 'un dia',
	            dd : '%d dies',
	            M : 'un mes',
	            MM : '%d mesos',
	            y : 'un any',
	            yy : '%d anys'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal : function (number, period) {
	            var output = (number === 1) ? 'r' :
	                (number === 2) ? 'n' :
	                (number === 3) ? 'r' :
	                (number === 4) ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ca;
	
	})));


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	                break;
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParse : (function (months, monthsShort) {
	            var i, _monthsParse = [];
	            for (i = 0; i < 12; i++) {
	                // use custom parser to solve problem with July (červenec)
	                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	            }
	            return _monthsParse;
	        }(months, monthsShort)),
	        shortMonthsParse : (function (monthsShort) {
	            var i, _shortMonthsParse = [];
	            for (i = 0; i < 12; i++) {
	                _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	            }
	            return _shortMonthsParse;
	        }(monthsShort)),
	        longMonthsParse : (function (months) {
	            var i, _longMonthsParse = [];
	            for (i = 0; i < 12; i++) {
	                _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	            }
	            return _longMonthsParse;
	        }(months)),
	        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm',
	            l : 'D. M. YYYY'
	        },
	        calendar : {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'před %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cs;
	
	})));


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cv = moment.defineLocale('cv', {
	        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar : {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past : '%s каялла',
	            s : 'пӗр-ик ҫеккунт',
	            ss : '%d ҫеккунт',
	            m : 'пӗр минут',
	            mm : '%d минут',
	            h : 'пӗр сехет',
	            hh : '%d сехет',
	            d : 'пӗр кун',
	            dd : '%d кун',
	            M : 'пӗр уйӑх',
	            MM : '%d уйӑх',
	            y : 'пӗр ҫул',
	            yy : '%d ҫул'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal : '%d-мӗш',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return cv;
	
	})));


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cy;
	
	})));


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var da = moment.defineLocale('da', {
	        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay : '[i dag kl.] LT',
	            nextDay : '[i morgen kl.] LT',
	            nextWeek : 'på dddd [kl.] LT',
	            lastDay : '[i går kl.] LT',
	            lastWeek : '[i] dddd[s kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'få sekunder',
	            ss : '%d sekunder',
	            m : 'et minut',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dage',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'et år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return da;
	
	})));


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de;
	
	})));


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deAt;
	
	})));


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deCh;
	
	})));


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'ޖެނުއަރީ',
	        'ފެބްރުއަރީ',
	        'މާރިޗު',
	        'އޭޕްރީލު',
	        'މޭ',
	        'ޖޫން',
	        'ޖުލައި',
	        'އޯގަސްޓު',
	        'ސެޕްޓެމްބަރު',
	        'އޮކްޓޯބަރު',
	        'ނޮވެމްބަރު',
	        'ޑިސެމްބަރު'
	    ], weekdays = [
	        'އާދިއްތަ',
	        'ހޯމަ',
	        'އަންގާރަ',
	        'ބުދަ',
	        'ބުރާސްފަތި',
	        'ހުކުރު',
	        'ހޮނިހިރު'
	    ];
	
	    var dv = moment.defineLocale('dv', {
	        months : months,
	        monthsShort : months,
	        weekdays : weekdays,
	        weekdaysShort : weekdays,
	        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat : {
	
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/M/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM : function (input) {
	            return 'މފ' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar : {
	            sameDay : '[މިއަދު] LT',
	            nextDay : '[މާދަމާ] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[އިއްޔެ] LT',
	            lastWeek : '[ފާއިތުވި] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ތެރޭގައި %s',
	            past : 'ކުރިން %s',
	            s : 'ސިކުންތުކޮޅެއް',
	            ss : 'd% ސިކުންތު',
	            m : 'މިނިޓެއް',
	            mm : 'މިނިޓު %d',
	            h : 'ގަޑިއިރެއް',
	            hh : 'ގަޑިއިރު %d',
	            d : 'ދުވަހެއް',
	            dd : 'ދުވަސް %d',
	            M : 'މަހެއް',
	            MM : 'މަސް %d',
	            y : 'އަހަރެއް',
	            yy : 'އަހަރު %d'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 7,  // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return dv;
	
	})));


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM : function (input) {
	            return ((input + '').toLowerCase()[0] === 'μ');
	        },
	        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl : {
	            sameDay : '[Σήμερα {}] LT',
	            nextDay : '[Αύριο {}] LT',
	            nextWeek : 'dddd [{}] LT',
	            lastDay : '[Χθες {}] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        calendar : function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	        },
	        relativeTime : {
	            future : 'σε %s',
	            past : '%s πριν',
	            s : 'λίγα δευτερόλεπτα',
	            ss : '%d δευτερόλεπτα',
	            m : 'ένα λεπτό',
	            mm : '%d λεπτά',
	            h : 'μία ώρα',
	            hh : '%d ώρες',
	            d : 'μία μέρα',
	            dd : '%d μέρες',
	            M : 'ένας μήνας',
	            MM : '%d μήνες',
	            y : 'ένας χρόνος',
	            yy : '%d χρόνια'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4st is the first week of the year.
	        }
	    });
	
	    return el;
	
	})));


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enAu = moment.defineLocale('en-au', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enAu;
	
	})));


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enCa = moment.defineLocale('en-ca', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'YYYY-MM-DD',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY h:mm A',
	            LLLL : 'dddd, MMMM D, YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enCa;
	
	})));


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enGb = moment.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enGb;
	
	})));


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIe = moment.defineLocale('en-ie', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enIe;
	
	})));


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIl = moment.defineLocale('en-il', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enIl;
	
	})));


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enNz = moment.defineLocale('en-nz', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enNz;
	
	})));


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eo = moment.defineLocale('eo', {
	        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D[-a de] MMMM, YYYY',
	            LLL : 'D[-a de] MMMM, YYYY HH:mm',
	            LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar : {
	            sameDay : '[Hodiaŭ je] LT',
	            nextDay : '[Morgaŭ je] LT',
	            nextWeek : 'dddd [je] LT',
	            lastDay : '[Hieraŭ je] LT',
	            lastWeek : '[pasinta] dddd [je] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'post %s',
	            past : 'antaŭ %s',
	            s : 'sekundoj',
	            ss : '%d sekundoj',
	            m : 'minuto',
	            mm : '%d minutoj',
	            h : 'horo',
	            hh : '%d horoj',
	            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	            dd : '%d tagoj',
	            M : 'monato',
	            MM : '%d monatoj',
	            y : 'jaro',
	            yy : '%d jaroj'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal : '%da',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eo;
	
	})));


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es;
	
	})));


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return esDo;
	
	})));


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var esUs = moment.defineLocale('es-us', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'MM/DD/YYYY',
	            LL : 'MMMM [de] D [de] YYYY',
	            LLL : 'MMMM [de] D [de] YYYY h:mm A',
	            LLLL : 'dddd, MMMM [de] D [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return esUs;
	
	})));


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'ss': [number + 'sekundi', number + 'sekundit'],
	            'm' : ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd' : ['ühe päeva', 'üks päev'],
	            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat : {
	            LT   : 'H:mm',
	            LTS : 'H:mm:ss',
	            L    : 'DD.MM.YYYY',
	            LL   : 'D. MMMM YYYY',
	            LLL  : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[Täna,] LT',
	            nextDay  : '[Homme,] LT',
	            nextWeek : '[Järgmine] dddd LT',
	            lastDay  : '[Eile,] LT',
	            lastWeek : '[Eelmine] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s pärast',
	            past   : '%s tagasi',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : '%d päeva',
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return et;
	
	})));


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eu = moment.defineLocale('eu', {
	        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY[ko] MMMM[ren] D[a]',
	            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l : 'YYYY-M-D',
	            ll : 'YYYY[ko] MMM D[a]',
	            lll : 'YYYY[ko] MMM D[a] HH:mm',
	            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar : {
	            sameDay : '[gaur] LT[etan]',
	            nextDay : '[bihar] LT[etan]',
	            nextWeek : 'dddd LT[etan]',
	            lastDay : '[atzo] LT[etan]',
	            lastWeek : '[aurreko] dddd LT[etan]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s barru',
	            past : 'duela %s',
	            s : 'segundo batzuk',
	            ss : '%d segundo',
	            m : 'minutu bat',
	            mm : '%d minutu',
	            h : 'ordu bat',
	            hh : '%d ordu',
	            d : 'egun bat',
	            dd : '%d egun',
	            M : 'hilabete bat',
	            MM : '%d hilabete',
	            y : 'urte bat',
	            yy : '%d urte'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eu;
	
	})));


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    }, numberMap = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };
	
	    var fa = moment.defineLocale('fa', {
	        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar : {
	            sameDay : '[امروز ساعت] LT',
	            nextDay : '[فردا ساعت] LT',
	            nextWeek : 'dddd [ساعت] LT',
	            lastDay : '[دیروز ساعت] LT',
	            lastWeek : 'dddd [پیش] [ساعت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'در %s',
	            past : '%s پیش',
	            s : 'چند ثانیه',
	            ss : 'ثانیه d%',
	            m : 'یک دقیقه',
	            mm : '%d دقیقه',
	            h : 'یک ساعت',
	            hh : '%d ساعت',
	            d : 'یک روز',
	            dd : '%d روز',
	            M : 'یک ماه',
	            MM : '%d ماه',
	            y : 'یک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal : '%dم',
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return fa;
	
	})));


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	        numbersFuture = [
	            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	            numbersPast[7], numbersPast[8], numbersPast[9]
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                return isFuture ? 'sekunnin' : 'sekuntia';
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'Do MMMM[ta] YYYY',
	            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l : 'D.M.YYYY',
	            ll : 'Do MMM YYYY',
	            lll : 'Do MMM YYYY, [klo] HH.mm',
	            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar : {
	            sameDay : '[tänään] [klo] LT',
	            nextDay : '[huomenna] [klo] LT',
	            nextWeek : 'dddd [klo] LT',
	            lastDay : '[eilen] [klo] LT',
	            lastWeek : '[viime] dddd[na] [klo] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s päästä',
	            past : '%s sitten',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fi;
	
	})));


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fo = moment.defineLocale('fo', {
	        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Í dag kl.] LT',
	            nextDay : '[Í morgin kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[Í gjár kl.] LT',
	            lastWeek : '[síðstu] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'um %s',
	            past : '%s síðani',
	            s : 'fá sekund',
	            ss : '%d sekundir',
	            m : 'ein minutt',
	            mm : '%d minuttir',
	            h : 'ein tími',
	            hh : '%d tímar',
	            d : 'ein dagur',
	            dd : '%d dagar',
	            M : 'ein mánaði',
	            MM : '%d mánaðir',
	            y : 'eitt ár',
	            yy : '%d ár'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fo;
	
	})));


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fr = moment.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	
	})));


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        }
	    });
	
	    return frCa;
	
	})));


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return frCh;
	
	})));


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'oer %s',
	            past : '%s lyn',
	            s : 'in pear sekonden',
	            ss : '%d sekonden',
	            m : 'ien minút',
	            mm : '%d minuten',
	            h : 'ien oere',
	            hh : '%d oeren',
	            d : 'ien dei',
	            dd : '%d dagen',
	            M : 'ien moanne',
	            MM : '%d moannen',
	            y : 'ien jier',
	            yy : '%d jierren'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fy;
	
	})));


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	    ];
	
	    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParseExact : true,
	        weekdays : weekdays,
	        weekdaysShort : weekdaysShort,
	        weekdaysMin : weekdaysMin,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[An-diugh aig] LT',
	            nextDay : '[A-màireach aig] LT',
	            nextWeek : 'dddd [aig] LT',
	            lastDay : '[An-dè aig] LT',
	            lastWeek : 'dddd [seo chaidh] [aig] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ann an %s',
	            past : 'bho chionn %s',
	            s : 'beagan diogan',
	            ss : '%d diogan',
	            m : 'mionaid',
	            mm : '%d mionaidean',
	            h : 'uair',
	            hh : '%d uairean',
	            d : 'latha',
	            dd : '%d latha',
	            M : 'mìos',
	            MM : '%d mìosan',
	            y : 'bliadhna',
	            yy : '%d bliadhna'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	        ordinal : function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gd;
	
	})));


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var gl = moment.defineLocale('gl', {
	        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            lastDay : function () {
	                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	            },
	            lastWeek : function () {
	                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past : 'hai %s',
	            s : 'uns segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'unha hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gl;
	
	})));


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['thodde secondanim', 'thodde second'],
	            'ss': [number + ' secondanim', number + ' second'],
	            'm': ['eka mintan', 'ek minute'],
	            'mm': [number + ' mintanim', number + ' mintam'],
	            'h': ['eka horan', 'ek hor'],
	            'hh': [number + ' horanim', number + ' horam'],
	            'd': ['eka disan', 'ek dis'],
	            'dd': [number + ' disanim', number + ' dis'],
	            'M': ['eka mhoinean', 'ek mhoino'],
	            'MM': [number + ' mhoineanim', number + ' mhoine'],
	            'y': ['eka vorsan', 'ek voros'],
	            'yy': [number + ' vorsanim', number + ' vorsam']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	        monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	        weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'A h:mm [vazta]',
	            LTS : 'A h:mm:ss [vazta]',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY A h:mm [vazta]',
	            LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	        },
	        calendar : {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Ieta to] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fatlo] dddd[,] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s',
	            past : '%s adim',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /rati|sokalli|donparam|sanje/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokalli') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokalli';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        }
	    });
	
	    return gomLatn;
	
	})));


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	            '1': '૧',
	            '2': '૨',
	            '3': '૩',
	            '4': '૪',
	            '5': '૫',
	            '6': '૬',
	            '7': '૭',
	            '8': '૮',
	            '9': '૯',
	            '0': '૦'
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0'
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
	        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પેહલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ'
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return gu;
	
	})));


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var he = moment.defineLocale('he', {
	        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [ב]MMMM YYYY',
	            LLL : 'D [ב]MMMM YYYY HH:mm',
	            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	            l : 'D/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[היום ב־]LT',
	            nextDay : '[מחר ב־]LT',
	            nextWeek : 'dddd [בשעה] LT',
	            lastDay : '[אתמול ב־]LT',
	            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'בעוד %s',
	            past : 'לפני %s',
	            s : 'מספר שניות',
	            ss : '%d שניות',
	            m : 'דקה',
	            mm : '%d דקות',
	            h : 'שעה',
	            hh : function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d : 'יום',
	            dd : function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M : 'חודש',
	            MM : function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y : 'שנה',
	            yy : function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM : function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        }
	    });
	
	    return he;
	
	})));


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var hi = moment.defineLocale('hi', {
	        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm बजे',
	            LTS : 'A h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[कल] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[कल] LT',
	            lastWeek : '[पिछले] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s में',
	            past : '%s पहले',
	            s : 'कुछ ही क्षण',
	            ss : '%d सेकंड',
	            m : 'एक मिनट',
	            mm : '%d मिनट',
	            h : 'एक घंटा',
	            hh : '%d घंटे',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महीने',
	            MM : '%d महीने',
	            y : 'एक वर्ष',
	            yy : '%d वर्ष'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hi;
	
	})));


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months : {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	        },
	        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hr;
	
	})));


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY. MMMM D.',
	            LLL : 'YYYY. MMMM D. H:mm',
	            LLLL : 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar : {
	            sameDay : '[ma] LT[-kor]',
	            nextDay : '[holnap] LT[-kor]',
	            nextWeek : function () {
	                return week.call(this, true);
	            },
	            lastDay : '[tegnap] LT[-kor]',
	            lastWeek : function () {
	                return week.call(this, false);
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s múlva',
	            past : '%s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return hu;
	
	})));


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months : {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	        },
	        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY թ.',
	            LLL : 'D MMMM YYYY թ., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar : {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s հետո',
	            past : '%s առաջ',
	            s : 'մի քանի վայրկյան',
	            ss : '%d վայրկյան',
	            m : 'րոպե',
	            mm : '%d րոպե',
	            h : 'ժամ',
	            hh : '%d ժամ',
	            d : 'օր',
	            dd : '%d օր',
	            M : 'ամիս',
	            MM : '%d ամիս',
	            y : 'տարի',
	            yy : '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem : function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hyAm;
	
	})));


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var id = moment.defineLocale('id', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Besok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kemarin pukul] LT',
	            lastWeek : 'dddd [lalu pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lalu',
	            s : 'beberapa detik',
	            ss : '%d detik',
	            m : 'semenit',
	            mm : '%d menit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return id;
	
	})));


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar : {
	            sameDay : '[í dag kl.] LT',
	            nextDay : '[á morgun kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[í gær kl.] LT',
	            lastWeek : '[síðasta] dddd [kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'eftir %s',
	            past : 'fyrir %s síðan',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : 'klukkustund',
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return is;
	
	})));


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var it = moment.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return it;
	
	})));


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ja = moment.defineLocale('ja', {
	        months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日 dddd HH:mm',
	            l : 'YYYY/MM/DD',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日(ddd) HH:mm'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM : function (input) {
	            return input === '午後';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar : {
	            sameDay : '[今日] LT',
	            nextDay : '[明日] LT',
	            nextWeek : function (now) {
	                if (now.week() < this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay : '[昨日] LT',
	            lastWeek : function (now) {
	                if (this.week() < now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}日/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s後',
	            past : '%s前',
	            s : '数秒',
	            ss : '%d秒',
	            m : '1分',
	            mm : '%d分',
	            h : '1時間',
	            hh : '%d時間',
	            d : '1日',
	            dd : '%d日',
	            M : '1ヶ月',
	            MM : '%dヶ月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });
	
	    return ja;
	
	})));


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var jv = moment.defineLocale('jv', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar : {
	            sameDay : '[Dinten puniko pukul] LT',
	            nextDay : '[Mbenjang pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kala wingi pukul] LT',
	            lastWeek : 'dddd [kepengker pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'wonten ing %s',
	            past : '%s ingkang kepengker',
	            s : 'sawetawis detik',
	            ss : '%d detik',
	            m : 'setunggal menit',
	            mm : '%d menit',
	            h : 'setunggal jam',
	            hh : '%d jam',
	            d : 'sedinten',
	            dd : '%d dinten',
	            M : 'sewulan',
	            MM : '%d wulan',
	            y : 'setaun',
	            yy : '%d taun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return jv;
	
	})));


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ka = moment.defineLocale('ka', {
	        months : {
	            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays : {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	            isFormat: /(წინა|შემდეგ)/
	        },
	        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[დღეს] LT[-ზე]',
	            nextDay : '[ხვალ] LT[-ზე]',
	            lastDay : '[გუშინ] LT[-ზე]',
	            nextWeek : '[შემდეგ] dddd LT[-ზე]',
	            lastWeek : '[წინა] dddd LT-ზე',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                    s.replace(/ი$/, 'ში') :
	                    s + 'ში';
	            },
	            past : function (s) {
	                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if ((/წელი/).test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	            },
	            s : 'რამდენიმე წამი',
	            ss : '%d წამი',
	            m : 'წუთი',
	            mm : '%d წუთი',
	            h : 'საათი',
	            hh : '%d საათი',
	            d : 'დღე',
	            dd : '%d დღე',
	            M : 'თვე',
	            MM : '%d თვე',
	            y : 'წელი',
	            yy : '%d წელი'
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal : function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week : {
	            dow : 1,
	            doy : 7
	        }
	    });
	
	    return ka;
	
	})));


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші'
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгін сағат] LT',
	            nextDay : '[Ертең сағат] LT',
	            nextWeek : 'dddd [сағат] LT',
	            lastDay : '[Кеше сағат] LT',
	            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ішінде',
	            past : '%s бұрын',
	            s : 'бірнеше секунд',
	            ss : '%d секунд',
	            m : 'бір минут',
	            mm : '%d минут',
	            h : 'бір сағат',
	            hh : '%d сағат',
	            d : 'бір күн',
	            dd : '%d күн',
	            M : 'бір ай',
	            MM : '%d ай',
	            y : 'бір жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return kk;
	
	})));


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '១',
	        '2': '២',
	        '3': '៣',
	        '4': '៤',
	        '5': '៥',
	        '6': '៦',
	        '7': '៧',
	        '8': '៨',
	        '9': '៩',
	        '0': '០'
	    }, numberMap = {
	        '១': '1',
	        '២': '2',
	        '៣': '3',
	        '៤': '4',
	        '៥': '5',
	        '៦': '6',
	        '៧': '7',
	        '៨': '8',
	        '៩': '9',
	        '០': '0'
	    };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        dayOfMonthOrdinalParse : /ទី\d{1,2}/,
	        ordinal : 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return km;
	
	})));


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '೧',
	        '2': '೨',
	        '3': '೩',
	        '4': '೪',
	        '5': '೫',
	        '6': '೬',
	        '7': '೭',
	        '8': '೮',
	        '9': '೯',
	        '0': '೦'
	    },
	    numberMap = {
	        '೧': '1',
	        '೨': '2',
	        '೩': '3',
	        '೪': '4',
	        '೫': '5',
	        '೬': '6',
	        '೭': '7',
	        '೮': '8',
	        '೯': '9',
	        '೦': '0'
	    };
	
	    var kn = moment.defineLocale('kn', {
	        months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	        monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	        weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[ಇಂದು] LT',
	            nextDay : '[ನಾಳೆ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ನಿನ್ನೆ] LT',
	            lastWeek : '[ಕೊನೆಯ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ನಂತರ',
	            past : '%s ಹಿಂದೆ',
	            s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss : '%d ಸೆಕೆಂಡುಗಳು',
	            m : 'ಒಂದು ನಿಮಿಷ',
	            mm : '%d ನಿಮಿಷ',
	            h : 'ಒಂದು ಗಂಟೆ',
	            hh : '%d ಗಂಟೆ',
	            d : 'ಒಂದು ದಿನ',
	            dd : '%d ದಿನ',
	            M : 'ಒಂದು ತಿಂಗಳು',
	            MM : '%d ತಿಂಗಳು',
	            y : 'ಒಂದು ವರ್ಷ',
	            yy : '%d ವರ್ಷ'
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal : function (number) {
	            return number + 'ನೇ';
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return kn;
	
	})));


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ko = moment.defineLocale('ko', {
	        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY년 MMMM D일',
	            LLL : 'YYYY년 MMMM D일 A h:mm',
	            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	            l : 'YYYY.MM.DD.',
	            ll : 'YYYY년 MMMM D일',
	            lll : 'YYYY년 MMMM D일 A h:mm',
	            llll : 'YYYY년 MMMM D일 dddd A h:mm'
	        },
	        calendar : {
	            sameDay : '오늘 LT',
	            nextDay : '내일 LT',
	            nextWeek : 'dddd LT',
	            lastDay : '어제 LT',
	            lastWeek : '지난주 dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s 후',
	            past : '%s 전',
	            s : '몇 초',
	            ss : '%d초',
	            m : '1분',
	            mm : '%d분',
	            h : '한 시간',
	            hh : '%d시간',
	            d : '하루',
	            dd : '%d일',
	            M : '한 달',
	            MM : '%d달',
	            y : '일 년',
	            yy : '%d년'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse : /오전|오후/,
	        isPM : function (token) {
	            return token === '오후';
	        },
	        meridiem : function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    return ko;
	
	})));


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү'
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгүн саат] LT',
	            nextDay : '[Эртең саат] LT',
	            nextWeek : 'dddd [саат] LT',
	            lastDay : '[Кече саат] LT',
	            lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ичинде',
	            past : '%s мурун',
	            s : 'бирнече секунд',
	            ss : '%d секунд',
	            m : 'бир мүнөт',
	            mm : '%d мүнөт',
	            h : 'бир саат',
	            hh : '%d саат',
	            d : 'бир күн',
	            dd : '%d күн',
	            M : 'бир ай',
	            MM : '%d ай',
	            y : 'бир жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ky;
	
	})));


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10, firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime : {
	            future : processFutureTime,
	            past : processPastTime,
	            s : 'e puer Sekonnen',
	            ss : '%d Sekonnen',
	            m : processRelativeTime,
	            mm : '%d Minutten',
	            h : processRelativeTime,
	            hh : '%d Stonnen',
	            d : processRelativeTime,
	            dd : '%d Deeg',
	            M : processRelativeTime,
	            MM : '%d Méint',
	            y : processRelativeTime,
	            yy : '%d Joer'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lb;
	
	})));


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var lo = moment.defineLocale('lo', {
	        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar : {
	            sameDay : '[ມື້ນີ້ເວລາ] LT',
	            nextDay : '[ມື້ອື່ນເວລາ] LT',
	            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ອີກ %s',
	            past : '%sຜ່ານມາ',
	            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss : '%d ວິນາທີ' ,
	            m : '1 ນາທີ',
	            mm : '%d ນາທີ',
	            h : '1 ຊົ່ວໂມງ',
	            hh : '%d ຊົ່ວໂມງ',
	            d : '1 ມື້',
	            dd : '%d ມື້',
	            M : '1 ເດືອນ',
	            MM : '%d ເດືອນ',
	            y : '1 ປີ',
	            yy : '%d ປີ'
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal : function (number) {
	            return 'ທີ່' + number;
	        }
	    });
	
	    return lo;
	
	})));


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss' : 'sekundė_sekundžių_sekundes',
	        'm' : 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h' : 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd' : 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M' : 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y' : 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months : {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	        },
	        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays : {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	            isFormat: /dddd HH:mm/
	        },
	        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY [m.] MMMM D [d.]',
	            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY [m.] MMMM D [d.]',
	            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar : {
	            sameDay : '[Šiandien] LT',
	            nextDay : '[Rytoj] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[Vakar] LT',
	            lastWeek : '[Praėjusį] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'po %s',
	            past : 'prieš %s',
	            s : translateSeconds,
	            ss : translate,
	            m : translateSingular,
	            mm : translate,
	            h : translateSingular,
	            hh : translate,
	            d : translateSingular,
	            dd : translate,
	            M : translateSingular,
	            MM : translate,
	            y : translateSingular,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal : function (number) {
	            return number + '-oji';
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lt;
	
	})));


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY.',
	            LL : 'YYYY. [gada] D. MMMM',
	            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar : {
	            sameDay : '[Šodien pulksten] LT',
	            nextDay : '[Rīt pulksten] LT',
	            nextWeek : 'dddd [pulksten] LT',
	            lastDay : '[Vakar pulksten] LT',
	            lastWeek : '[Pagājušā] dddd [pulksten] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'pēc %s',
	            past : 'pirms %s',
	            s : relativeSeconds,
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithSingular,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithSingular,
	            hh : relativeTimeWithPlural,
	            d : relativeTimeWithSingular,
	            dd : relativeTimeWithPlural,
	            M : relativeTimeWithSingular,
	            MM : relativeTimeWithPlural,
	            y : relativeTimeWithSingular,
	            yy : relativeTimeWithPlural
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lv;
	
	})));


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mjesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return me;
	
	})));


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mi;
	
	})));


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mk = moment.defineLocale('mk', {
	        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Денес во] LT',
	            nextDay : '[Утре во] LT',
	            nextWeek : '[Во] dddd [во] LT',
	            lastDay : '[Вчера во] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'после %s',
	            past : 'пред %s',
	            s : 'неколку секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дена',
	            M : 'месец',
	            MM : '%d месеци',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mk;
	
	})));


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ml = moment.defineLocale('ml', {
	        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm -നു',
	            LTS : 'A h:mm:ss -നു',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm -നു',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar : {
	            sameDay : '[ഇന്ന്] LT',
	            nextDay : '[നാളെ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ഇന്നലെ] LT',
	            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s കഴിഞ്ഞ്',
	            past : '%s മുൻപ്',
	            s : 'അൽപ നിമിഷങ്ങൾ',
	            ss : '%d സെക്കൻഡ്',
	            m : 'ഒരു മിനിറ്റ്',
	            mm : '%d മിനിറ്റ്',
	            h : 'ഒരു മണിക്കൂർ',
	            hh : '%d മണിക്കൂർ',
	            d : 'ഒരു ദിവസം',
	            dd : '%d ദിവസം',
	            M : 'ഒരു മാസം',
	            MM : '%d മാസം',
	            y : 'ഒരു വർഷം',
	            yy : '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                    meridiem === 'വൈകുന്നേരം') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });
	
	    return ml;
	
	})));


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months : 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
	        monthsShort : '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort : 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin : 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY оны MMMMын D',
	            LLL : 'YYYY оны MMMMын D HH:mm',
	            LLLL : 'dddd, YYYY оны MMMMын D HH:mm'
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM : function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar : {
	            sameDay : '[Өнөөдөр] LT',
	            nextDay : '[Маргааш] LT',
	            nextWeek : '[Ирэх] dddd LT',
	            lastDay : '[Өчигдөр] LT',
	            lastWeek : '[Өнгөрсөн] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s дараа',
	            past : '%s өмнө',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        }
	    });
	
	    return mn;
	
	})));


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture)
	    {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's': output = 'काही सेकंद'; break;
	                case 'ss': output = '%d सेकंद'; break;
	                case 'm': output = 'एक मिनिट'; break;
	                case 'mm': output = '%d मिनिटे'; break;
	                case 'h': output = 'एक तास'; break;
	                case 'hh': output = '%d तास'; break;
	                case 'd': output = 'एक दिवस'; break;
	                case 'dd': output = '%d दिवस'; break;
	                case 'M': output = 'एक महिना'; break;
	                case 'MM': output = '%d महिने'; break;
	                case 'y': output = 'एक वर्ष'; break;
	                case 'yy': output = '%d वर्षे'; break;
	            }
	        }
	        else {
	            switch (string) {
	                case 's': output = 'काही सेकंदां'; break;
	                case 'ss': output = '%d सेकंदां'; break;
	                case 'm': output = 'एका मिनिटा'; break;
	                case 'mm': output = '%d मिनिटां'; break;
	                case 'h': output = 'एका तासा'; break;
	                case 'hh': output = '%d तासां'; break;
	                case 'd': output = 'एका दिवसा'; break;
	                case 'dd': output = '%d दिवसां'; break;
	                case 'M': output = 'एका महिन्या'; break;
	                case 'MM': output = '%d महिन्यां'; break;
	                case 'y': output = 'एका वर्षा'; break;
	                case 'yy': output = '%d वर्षां'; break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm वाजता',
	            LTS : 'A h:mm:ss वाजता',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm वाजता',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[उद्या] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mr;
	
	})));


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ms = moment.defineLocale('ms', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ms;
	
	})));


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var msMy = moment.defineLocale('ms-my', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return msMy;
	
	})));


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mt = moment.defineLocale('mt', {
	        months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
	        monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
	        weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Illum fil-]LT',
	            nextDay : '[Għada fil-]LT',
	            nextWeek : 'dddd [fil-]LT',
	            lastDay : '[Il-bieraħ fil-]LT',
	            lastWeek : 'dddd [li għadda] [fil-]LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'f’ %s',
	            past : '%s ilu',
	            s : 'ftit sekondi',
	            ss : '%d sekondi',
	            m : 'minuta',
	            mm : '%d minuti',
	            h : 'siegħa',
	            hh : '%d siegħat',
	            d : 'ġurnata',
	            dd : '%d ġranet',
	            M : 'xahar',
	            MM : '%d xhur',
	            y : 'sena',
	            yy : '%d sni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mt;
	
	})));


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    }, numberMap = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss : '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return my;
	
	})));


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nb = moment.defineLocale('nb', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'noen sekunder',
	            ss : '%d sekunder',
	            m : 'ett minutt',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dager',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nb;
	
	})));


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var ne = moment.defineLocale('ne', {
	        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'Aको h:mm बजे',
	            LTS : 'Aको h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[भोलि] LT',
	            nextWeek : '[आउँदो] dddd[,] LT',
	            lastDay : '[हिजो] LT',
	            lastWeek : '[गएको] dddd[,] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sमा',
	            past : '%s अगाडि',
	            s : 'केही क्षण',
	            ss : '%d सेकेण्ड',
	            m : 'एक मिनेट',
	            mm : '%d मिनेट',
	            h : 'एक घण्टा',
	            hh : '%d घण्टा',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महिना',
	            MM : '%d महिना',
	            y : 'एक बर्ष',
	            yy : '%d बर्ष'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ne;
	
	})));


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nl;
	
	})));


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nlBe;
	
	})));


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nn = moment.defineLocale('nn', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s sidan',
	            s : 'nokre sekund',
	            ss : '%d sekund',
	            m : 'eit minutt',
	            mm : '%d minutt',
	            h : 'ein time',
	            hh : '%d timar',
	            d : 'ein dag',
	            dd : '%d dagar',
	            M : 'ein månad',
	            MM : '%d månader',
	            y : 'eit år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nn;
	
	})));


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '੧',
	        '2': '੨',
	        '3': '੩',
	        '4': '੪',
	        '5': '੫',
	        '6': '੬',
	        '7': '੭',
	        '8': '੮',
	        '9': '੯',
	        '0': '੦'
	    },
	    numberMap = {
	        '੧': '1',
	        '੨': '2',
	        '੩': '3',
	        '੪': '4',
	        '੫': '5',
	        '੬': '6',
	        '੭': '7',
	        '੮': '8',
	        '੯': '9',
	        '੦': '0'
	    };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm ਵਜੇ',
	            LTS : 'A h:mm:ss ਵਜੇ',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	        },
	        calendar : {
	            sameDay : '[ਅਜ] LT',
	            nextDay : '[ਕਲ] LT',
	            nextWeek : '[ਅਗਲਾ] dddd, LT',
	            lastDay : '[ਕਲ] LT',
	            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ਵਿੱਚ',
	            past : '%s ਪਿਛਲੇ',
	            s : 'ਕੁਝ ਸਕਿੰਟ',
	            ss : '%d ਸਕਿੰਟ',
	            m : 'ਇਕ ਮਿੰਟ',
	            mm : '%d ਮਿੰਟ',
	            h : 'ਇੱਕ ਘੰਟਾ',
	            hh : '%d ਘੰਟੇ',
	            d : 'ਇੱਕ ਦਿਨ',
	            dd : '%d ਦਿਨ',
	            M : 'ਇੱਕ ਮਹੀਨਾ',
	            MM : '%d ਮਹੀਨੇ',
	            y : 'ਇੱਕ ਸਾਲ',
	            yy : '%d ਸਾਲ'
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return paIn;
	
	})));


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural(n) {
	        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix  ? 'godzina'  : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : '%s temu',
	            s : 'kilka sekund',
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : '1 dzień',
	            dd : '%d dni',
	            M : 'miesiąc',
	            MM : translate,
	            y : 'rok',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pl;
	
	})));


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var pt = moment.defineLocale('pt', {
	        months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
	        monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pt;
	
	})));


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
	        monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'poucos segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº'
	    });
	
	    return ptBr;
	
	})));


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                'ss': 'secunde',
	                'mm': 'minute',
	                'hh': 'ore',
	                'dd': 'zile',
	                'MM': 'luni',
	                'yy': 'ani'
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'peste %s',
	            past : '%s în urmă',
	            s : 'câteva secunde',
	            ss : relativeTimeWithPlural,
	            m : 'un minut',
	            mm : relativeTimeWithPlural,
	            h : 'o oră',
	            hh : relativeTimeWithPlural,
	            d : 'o zi',
	            dd : relativeTimeWithPlural,
	            M : 'o lună',
	            MM : relativeTimeWithPlural,
	            y : 'un an',
	            yy : relativeTimeWithPlural
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ro;
	
	})));


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months : {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	        },
	        monthsShort : {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	        },
	        weekdays : {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	        },
	        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соотвествует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., H:mm',
	            LLLL : 'dddd, D MMMM YYYY г., H:mm'
	        },
	        calendar : {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'через %s',
	            past : '%s назад',
	            s : 'несколько секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'час',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM : function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ru;
	
	})));


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوري',
	        'فيبروري',
	        'مارچ',
	        'اپريل',
	        'مئي',
	        'جون',
	        'جولاءِ',
	        'آگسٽ',
	        'سيپٽمبر',
	        'آڪٽوبر',
	        'نومبر',
	        'ڊسمبر'
	    ];
	    var days = [
	        'آچر',
	        'سومر',
	        'اڱارو',
	        'اربع',
	        'خميس',
	        'جمع',
	        'ڇنڇر'
	    ];
	
	    var sd = moment.defineLocale('sd', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[اڄ] LT',
	            nextDay : '[سڀاڻي] LT',
	            nextWeek : 'dddd [اڳين هفتي تي] LT',
	            lastDay : '[ڪالهه] LT',
	            lastWeek : '[گزريل هفتي] dddd [تي] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s پوء',
	            past : '%s اڳ',
	            s : 'چند سيڪنڊ',
	            ss : '%d سيڪنڊ',
	            m : 'هڪ منٽ',
	            mm : '%d منٽ',
	            h : 'هڪ ڪلاڪ',
	            hh : '%d ڪلاڪ',
	            d : 'هڪ ڏينهن',
	            dd : '%d ڏينهن',
	            M : 'هڪ مهينو',
	            MM : '%d مهينا',
	            y : 'هڪ سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sd;
	
	})));


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var se = moment.defineLocale('se', {
	        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'MMMM D. [b.] YYYY',
	            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s geažes',
	            past : 'maŋit %s',
	            s : 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m : 'okta minuhta',
	            mm : '%d minuhtat',
	            h : 'okta diimmu',
	            hh : '%d diimmut',
	            d : 'okta beaivi',
	            dd : '%d beaivvit',
	            M : 'okta mánnu',
	            MM : '%d mánut',
	            y : 'okta jahki',
	            yy : '%d jagit'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return se;
	
	})));


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'a h:mm',
	            LTS : 'a h:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY MMMM D',
	            LLL : 'YYYY MMMM D, a h:mm',
	            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar : {
	            sameDay : '[අද] LT[ට]',
	            nextDay : '[හෙට] LT[ට]',
	            nextWeek : 'dddd LT[ට]',
	            lastDay : '[ඊයේ] LT[ට]',
	            lastWeek : '[පසුගිය] dddd LT[ට]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sකින්',
	            past : '%sකට පෙර',
	            s : 'තත්පර කිහිපය',
	            ss : 'තත්පර %d',
	            m : 'මිනිත්තුව',
	            mm : 'මිනිත්තු %d',
	            h : 'පැය',
	            hh : 'පැය %d',
	            d : 'දිනය',
	            dd : 'දින %d',
	            M : 'මාසය',
	            MM : 'මාස %d',
	            y : 'වසර',
	            yy : 'වසර %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal : function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM : function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });
	
	    return si;
	
	})));


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	                break;
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months : months,
	        monthsShort : monthsShort,
	        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'pred %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sk;
	
	})));


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += withoutSuffix || isFuture ? 'sekund' : 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danes ob] LT',
	            nextDay  : '[jutri ob] LT',
	
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay  : '[včeraj ob] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'čez %s',
	            past   : 'pred %s',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : processRelativeTime,
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sl;
	
	})));


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sq = moment.defineLocale('sq', {
	        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Sot në] LT',
	            nextDay : '[Nesër në] LT',
	            nextWeek : 'dddd [në] LT',
	            lastDay : '[Dje në] LT',
	            lastWeek : 'dddd [e kaluar në] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'në %s',
	            past : '%s më parë',
	            s : 'disa sekonda',
	            ss : '%d sekonda',
	            m : 'një minutë',
	            mm : '%d minuta',
	            h : 'një orë',
	            hh : '%d orë',
	            d : 'një ditë',
	            dd : '%d ditë',
	            M : 'një muaj',
	            MM : '%d muaj',
	            y : 'një vit',
	            yy : '%d vite'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sq;
	
	})));


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'pre %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sr;
	
	})));


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay  : '[јуче у] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past   : 'пре %s',
	            s      : 'неколико секунди',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'дан',
	            dd     : translator.translate,
	            M      : 'месец',
	            MM     : translator.translate,
	            y      : 'годину',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return srCyrl;
	
	})));


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ss = moment.defineLocale('ss', {
	        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Namuhla nga] LT',
	            nextDay : '[Kusasa nga] LT',
	            nextWeek : 'dddd [nga] LT',
	            lastDay : '[Itolo nga] LT',
	            lastWeek : 'dddd [leliphelile] [nga] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'nga %s',
	            past : 'wenteka nga %s',
	            s : 'emizuzwana lomcane',
	            ss : '%d mzuzwana',
	            m : 'umzuzu',
	            mm : '%d emizuzu',
	            h : 'lihora',
	            hh : '%d emahora',
	            d : 'lilanga',
	            dd : '%d emalanga',
	            M : 'inyanga',
	            MM : '%d tinyanga',
	            y : 'umnyaka',
	            yy : '%d iminyaka'
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : '%d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ss;
	
	})));


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sv = moment.defineLocale('sv', {
	        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'för %s sedan',
	            s : 'några sekunder',
	            ss : '%d sekunder',
	            m : 'en minut',
	            mm : '%d minuter',
	            h : 'en timme',
	            hh : '%d timmar',
	            d : 'en dag',
	            dd : '%d dagar',
	            M : 'en månad',
	            MM : '%d månader',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'e' :
	                (b === 1) ? 'a' :
	                (b === 2) ? 'a' :
	                (b === 3) ? 'e' : 'e';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sv;
	
	})));


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sw = moment.defineLocale('sw', {
	        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[leo saa] LT',
	            nextDay : '[kesho saa] LT',
	            nextWeek : '[wiki ijayo] dddd [saat] LT',
	            lastDay : '[jana] LT',
	            lastWeek : '[wiki iliyopita] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s baadaye',
	            past : 'tokea %s',
	            s : 'hivi punde',
	            ss : 'sekunde %d',
	            m : 'dakika moja',
	            mm : 'dakika %d',
	            h : 'saa limoja',
	            hh : 'masaa %d',
	            d : 'siku moja',
	            dd : 'masiku %d',
	            M : 'mwezi mmoja',
	            MM : 'miezi %d',
	            y : 'mwaka mmoja',
	            yy : 'miaka %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sw;
	
	})));


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '௧',
	        '2': '௨',
	        '3': '௩',
	        '4': '௪',
	        '5': '௫',
	        '6': '௬',
	        '7': '௭',
	        '8': '௮',
	        '9': '௯',
	        '0': '௦'
	    }, numberMap = {
	        '௧': '1',
	        '௨': '2',
	        '௩': '3',
	        '௪': '4',
	        '௫': '5',
	        '௬': '6',
	        '௭': '7',
	        '௮': '8',
	        '௯': '9',
	        '௦': '0'
	    };
	
	    var ta = moment.defineLocale('ta', {
	        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, HH:mm',
	            LLLL : 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar : {
	            sameDay : '[இன்று] LT',
	            nextDay : '[நாளை] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[நேற்று] LT',
	            lastWeek : '[கடந்த வாரம்] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s இல்',
	            past : '%s முன்',
	            s : 'ஒரு சில விநாடிகள்',
	            ss : '%d விநாடிகள்',
	            m : 'ஒரு நிமிடம்',
	            mm : '%d நிமிடங்கள்',
	            h : 'ஒரு மணி நேரம்',
	            hh : '%d மணி நேரம்',
	            d : 'ஒரு நாள்',
	            dd : '%d நாட்கள்',
	            M : 'ஒரு மாதம்',
	            MM : '%d மாதங்கள்',
	            y : 'ஒரு வருடம்',
	            yy : '%d ஆண்டுகள்'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal : function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை';  // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ta;
	
	})));


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var te = moment.defineLocale('te', {
	        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[నేడు] LT',
	            nextDay : '[రేపు] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[నిన్న] LT',
	            lastWeek : '[గత] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s లో',
	            past : '%s క్రితం',
	            s : 'కొన్ని క్షణాలు',
	            ss : '%d సెకన్లు',
	            m : 'ఒక నిమిషం',
	            mm : '%d నిమిషాలు',
	            h : 'ఒక గంట',
	            hh : '%d గంటలు',
	            d : 'ఒక రోజు',
	            dd : '%d రోజులు',
	            M : 'ఒక నెల',
	            MM : '%d నెలలు',
	            y : 'ఒక సంవత్సరం',
	            yy : '%d సంవత్సరాలు'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}వ/,
	        ordinal : '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return te;
	
	})));


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tet = moment.defineLocale('tet', {
	        months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin : 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'iha %s',
	            past : '%s liuba',
	            s : 'minutu balun',
	            ss : 'minutu %d',
	            m : 'minutu ida',
	            mm : 'minutu %d',
	            h : 'oras ida',
	            hh : 'oras %d',
	            d : 'loron ida',
	            dd : 'loron %d',
	            M : 'fulan ida',
	            MM : 'fulan %d',
	            y : 'tinan ida',
	            yy : 'tinan %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tet;
	
	})));


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум'
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
	        weekdaysShort : 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin : 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Имрӯз соати] LT',
	            nextDay : '[Пагоҳ соати] LT',
	            lastDay : '[Дирӯз соати] LT',
	            nextWeek : 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek : 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'баъди %s',
	            past : '%s пеш',
	            s : 'якчанд сония',
	            m : 'як дақиқа',
	            mm : '%d дақиқа',
	            h : 'як соат',
	            hh : '%d соат',
	            d : 'як рӯз',
	            dd : '%d рӯз',
	            M : 'як моҳ',
	            MM : '%d моҳ',
	            y : 'як сол',
	            yy : '%d сол'
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1th is the first week of the year.
	        }
	    });
	
	    return tg;
	
	})));


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var th = moment.defineLocale('th', {
	        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY เวลา H:mm',
	            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar : {
	            sameDay : '[วันนี้ เวลา] LT',
	            nextDay : '[พรุ่งนี้ เวลา] LT',
	            nextWeek : 'dddd[หน้า เวลา] LT',
	            lastDay : '[เมื่อวานนี้ เวลา] LT',
	            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'อีก %s',
	            past : '%sที่แล้ว',
	            s : 'ไม่กี่วินาที',
	            ss : '%d วินาที',
	            m : '1 นาที',
	            mm : '%d นาที',
	            h : '1 ชั่วโมง',
	            hh : '%d ชั่วโมง',
	            d : '1 วัน',
	            dd : '%d วัน',
	            M : '1 เดือน',
	            MM : '%d เดือน',
	            y : '1 ปี',
	            yy : '%d ปี'
	        }
	    });
	
	    return th;
	
	})));


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'MM/D/YYYY',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY HH:mm',
	            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'sa loob ng %s',
	            past : '%s ang nakalipas',
	            s : 'ilang segundo',
	            ss : '%d segundo',
	            m : 'isang minuto',
	            mm : '%d minuto',
	            h : 'isang oras',
	            hh : '%d oras',
	            d : 'isang araw',
	            dd : '%d araw',
	            M : 'isang buwan',
	            MM : '%d buwan',
	            y : 'isang taon',
	            yy : '%d taon'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlPh;
	
	})));


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'leS' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'waQ' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'nem' :
	        time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'Hu’' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'wen' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'ben' :
	        time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	        ten = Math.floor((number % 100) / 10),
	        one = number % 10,
	        word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	        }
	        return (word === '') ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : translateFuture,
	            past : translatePast,
	            s : 'puS lup',
	            ss : translate,
	            m : 'wa’ tup',
	            mm : translate,
	            h : 'wa’ rep',
	            hh : translate,
	            d : 'wa’ jaj',
	            dd : translate,
	            M : 'wa’ jar',
	            MM : translate,
	            y : 'wa’ DIS',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlh;
	
	})));


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[yarın saat] LT',
	            nextWeek : '[gelecek] dddd [saat] LT',
	            lastDay : '[dün] LT',
	            lastWeek : '[geçen] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s önce',
	            s : 'birkaç saniye',
	            ss : '%d saniye',
	            m : 'bir dakika',
	            mm : '%d dakika',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir yıl',
	            yy : '%d yıl'
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {  // special case for zero
	                        return number + '\'ıncı';
	                    }
	                    var a = number % 10,
	                        b = number % 100 - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tr;
	
	})));


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM [dallas] YYYY',
	            LLL : 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM : function (input) {
	            return 'd\'o' === input.toLowerCase();
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar : {
	            sameDay : '[oxhi à] LT',
	            nextDay : '[demà à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[ieiri à] LT',
	            lastWeek : '[sür el] dddd [lasteu à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'osprei %s',
	            past : 'ja%s',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'ss': [number + ' secunds', '' + number + ' secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', '' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', '' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', '' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', '' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', '' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	    }
	
	    return tzl;
	
	})));


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzm = moment.defineLocale('tzm', {
	        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past : 'ⵢⴰⵏ %s',
	            s : 'ⵉⵎⵉⴽ',
	            ss : '%d ⵉⵎⵉⴽ',
	            m : 'ⵎⵉⵏⵓⴺ',
	            mm : '%d ⵎⵉⵏⵓⴺ',
	            h : 'ⵙⴰⵄⴰ',
	            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d : 'ⴰⵙⵙ',
	            dd : '%d oⵙⵙⴰⵏ',
	            M : 'ⴰⵢoⵓⵔ',
	            MM : '%d ⵉⵢⵢⵉⵔⵏ',
	            y : 'ⴰⵙⴳⴰⵙ',
	            yy : '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzm;
	
	})));


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dadkh s yan %s',
	            past : 'yan %s',
	            s : 'imik',
	            ss : '%d imik',
	            m : 'minuḍ',
	            mm : '%d minuḍ',
	            h : 'saɛa',
	            hh : '%d tassaɛin',
	            d : 'ass',
	            dd : '%d ossan',
	            M : 'ayowr',
	            MM : '%d iyyirn',
	            y : 'asgas',
	            yy : '%d isgasn'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzmLatn;
	
	})));


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js language configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل'
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ugCn;
	
	})));


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        };
	
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	            'accusative' :
	            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	                'genitive' :
	                'nominative');
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months : {
	            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	        },
	        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY р.',
	            LLL : 'D MMMM YYYY р., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar : {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past : '%s тому',
	            s : 'декілька секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'годину',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'місяць',
	            MM : relativeTimeWithPlural,
	            y : 'рік',
	            yy : relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return uk;
	
	})));


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوری',
	        'فروری',
	        'مارچ',
	        'اپریل',
	        'مئی',
	        'جون',
	        'جولائی',
	        'اگست',
	        'ستمبر',
	        'اکتوبر',
	        'نومبر',
	        'دسمبر'
	    ];
	    var days = [
	        'اتوار',
	        'پیر',
	        'منگل',
	        'بدھ',
	        'جمعرات',
	        'جمعہ',
	        'ہفتہ'
	    ];
	
	    var ur = moment.defineLocale('ur', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[آج بوقت] LT',
	            nextDay : '[کل بوقت] LT',
	            nextWeek : 'dddd [بوقت] LT',
	            lastDay : '[گذشتہ روز بوقت] LT',
	            lastWeek : '[گذشتہ] dddd [بوقت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s بعد',
	            past : '%s قبل',
	            s : 'چند سیکنڈ',
	            ss : '%d سیکنڈ',
	            m : 'ایک منٹ',
	            mm : '%d منٹ',
	            h : 'ایک گھنٹہ',
	            hh : '%d گھنٹے',
	            d : 'ایک دن',
	            dd : '%d دن',
	            M : 'ایک ماہ',
	            MM : '%d ماہ',
	            y : 'ایک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ur;
	
	})));


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uz = moment.defineLocale('uz', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бугун соат] LT [да]',
	            nextDay : '[Эртага] LT [да]',
	            nextWeek : 'dddd [куни соат] LT [да]',
	            lastDay : '[Кеча соат] LT [да]',
	            lastWeek : '[Утган] dddd [куни соат] LT [да]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Якин %s ичида',
	            past : 'Бир неча %s олдин',
	            s : 'фурсат',
	            ss : '%d фурсат',
	            m : 'бир дакика',
	            mm : '%d дакика',
	            h : 'бир соат',
	            hh : '%d соат',
	            d : 'бир кун',
	            dd : '%d кун',
	            M : 'бир ой',
	            MM : '%d ой',
	            y : 'бир йил',
	            yy : '%d йил'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return uz;
	
	})));


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	        monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	        weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bugun soat] LT [da]',
	            nextDay : '[Ertaga] LT [da]',
	            nextWeek : 'dddd [kuni soat] LT [da]',
	            lastDay : '[Kecha soat] LT [da]',
	            lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Yaqin %s ichida',
	            past : 'Bir necha %s oldin',
	            s : 'soniya',
	            ss : '%d soniya',
	            m : 'bir daqiqa',
	            mm : '%d daqiqa',
	            h : 'bir soat',
	            hh : '%d soat',
	            d : 'bir kun',
	            dd : '%d kun',
	            M : 'bir oy',
	            MM : '%d oy',
	            y : 'bir yil',
	            yy : '%d yil'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return uzLatn;
	
	})));


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var vi = moment.defineLocale('vi', {
	        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /sa|ch/i,
	        isPM : function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [năm] YYYY',
	            LLL : 'D MMMM [năm] YYYY HH:mm',
	            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	            l : 'DD/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s tới',
	            past : '%s trước',
	            s : 'vài giây',
	            ss : '%d giây' ,
	            m : 'một phút',
	            mm : '%d phút',
	            h : 'một giờ',
	            hh : '%d giờ',
	            d : 'một ngày',
	            dd : '%d ngày',
	            M : 'một tháng',
	            MM : '%d tháng',
	            y : 'một năm',
	            yy : '%d năm'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return vi;
	
	})));


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[T~ódá~ý át] LT',
	            nextDay : '[T~ómó~rró~w át] LT',
	            nextWeek : 'dddd [át] LT',
	            lastDay : '[Ý~ést~érdá~ý át] LT',
	            lastWeek : '[L~ást] dddd [át] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'í~ñ %s',
	            past : '%s á~gó',
	            s : 'á ~féw ~sécó~ñds',
	            ss : '%d s~écóñ~ds',
	            m : 'á ~míñ~úté',
	            mm : '%d m~íñú~tés',
	            h : 'á~ñ hó~úr',
	            hh : '%d h~óúrs',
	            d : 'á ~dáý',
	            dd : '%d d~áýs',
	            M : 'á ~móñ~th',
	            MM : '%d m~óñt~hs',
	            y : 'á ~ýéár',
	            yy : '%d ý~éárs'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return xPseudo;
	
	})));


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var yo = moment.defineLocale('yo', {
	        months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	        monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Ònì ni] LT',
	            nextDay : '[Ọ̀la ni] LT',
	            nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	            lastDay : '[Àna ni] LT',
	            lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ní %s',
	            past : '%s kọjá',
	            s : 'ìsẹjú aayá die',
	            ss :'aayá %d',
	            m : 'ìsẹjú kan',
	            mm : 'ìsẹjú %d',
	            h : 'wákati kan',
	            hh : 'wákati %d',
	            d : 'ọjọ́ kan',
	            dd : 'ọjọ́ %d',
	            M : 'osù kan',
	            MM : 'osù %d',
	            y : 'ọdún kan',
	            yy : 'ọdún %d'
	        },
	        dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	        ordinal : 'ọjọ́ %d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return yo;
	
	})));


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah点mm分',
	            LLLL : 'YYYY年M月D日ddddAh点mm分',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            ss : '%d 秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return zhCn;
	
	})));


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhHk;
	
	})));


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(452)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天] LT',
	            nextDay : '[明天] LT',
	            nextWeek : '[下]dddd LT',
	            lastDay : '[昨天] LT',
	            lastWeek : '[上]dddd LT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhTw;
	
	})));


/***/ }),
/* 577 */
/***/ (function(module, exports) {

	module.exports = {"version":"2018e","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT WET WEST CET|u.k 0 -10 -10|0121212121212121213121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 WET WEST|Q.M 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|012|-2le00 4i6N0","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|012342525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 XQp0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|01212121212121212121212121212121212121212121212121212121212121212121212121232121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|0120303030303030303030303030303030454545454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|01212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010|-1c1I0 LX0 16p0 1jz0 1Myp0 Rb0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST JST|-7A.G -80 -90 -90|0121312121212121212121212121212121212121212121212121212121212121212121|-2CFHA.G 1sEP6.G 1cL0 ylu 93X0 1qQu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1kL0 14N0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +04 +03|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212124|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212132121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST CDT|-7y.k -80 -90|012121212121212121212121212121212121212121|-2le80 1XO3u 1wn0 Rd0 1wn0 R9u 1wqu U10 1tz0 TVu 1tz0 17gu 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cOu 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cL0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|+08 +09|-80 -90|010101010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BAu|29e5","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|0123232323232323232323232323232323232323232323|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -9u -a0|0123141414141414135353|-2um8r.Q 97XV.Q 1m1zu kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rb0 1ld0 14n0 1zd0 On0 1zd0 On0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0|","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Etc/GMT-0|GMT|0|0|","Etc/GMT-1|+01|-10|0|","Pacific/Port_Moresby|+10|-a0|0||25e4","Pacific/Pohnpei|+11|-b0|0||34e3","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0|","Etc/GMT-14|+14|-e0|0|","Etc/GMT-2|+02|-20|0|","Etc/GMT-3|+03|-30|0|","Etc/GMT-4|+04|-40|0|","Etc/GMT-5|+05|-50|0|","Etc/GMT-6|+06|-60|0|","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0|","Pacific/Palau|+09|-90|0||21e3","Etc/GMT+1|-01|10|0|","Etc/GMT+10|-10|a0|0|","Etc/GMT+11|-11|b0|0|","Etc/GMT+12|-12|c0|0|","Etc/GMT+3|-03|30|0|","Etc/GMT+4|-04|40|0|","Etc/GMT+5|-05|50|0|","Etc/GMT+6|-06|60|0|","Etc/GMT+7|-07|70|0|","Etc/GMT+8|-08|80|0|","Etc/GMT+9|-09|90|0|","Etc/UCT|UCT|0|0|","Etc/UTC|UTC|0|0|","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET +03|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|01232323232323232121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0|","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 -12 +12|-b0 c0 -c0|012|-AX0 W9X0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","MST|MST|70|0|","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B7X0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST ChST|-a0 -a0|01|1fpq0|17e4","Pacific/Honolulu|HST HDT HST|au 9u a0|010102|-1thLu 8x0 lef0 8Pz0 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2","Pacific/Kosrae|+11 +12|-b0 -c0|010|-AX0 1bdz0|66e2","Pacific/Majuro|+11 +12|-b0 -c0|01|-AX0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E PvzB.E 5RCu 1ouJu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Los_Angeles|US/Pacific-New","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UCT|UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Etc/GMT-11","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Port_Moresby|Pacific/Chuuk","Pacific/Port_Moresby|Pacific/Truk","Pacific/Port_Moresby|Pacific/Yap","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"]}

/***/ }),
/* 578 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function typeOf(obj) {
	  return {}.toString.call(obj).split(' ')[1].slice(0, -1).toLowerCase();
	}
	
	exports.default = typeOf;

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./africa": 580,
		"./africa.js": 580,
		"./australia": 669,
		"./australia.js": 669,
		"./bangladesh": 670,
		"./bangladesh.js": 670,
		"./global": 671,
		"./global.js": 671,
		"./india": 672,
		"./india.js": 672,
		"./newzealand": 673,
		"./newzealand.js": 673,
		"./pakistan": 674,
		"./pakistan.js": 674,
		"./srilanka": 675,
		"./srilanka.js": 675,
		"./taboola": 667,
		"./taboola.js": 667,
		"./unitedkingdom": 676,
		"./unitedkingdom.js": 676,
		"./unitedstates": 677,
		"./unitedstates.js": 677
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 579;


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge2 = __webpack_require__(581);
	
	var _merge3 = _interopRequireDefault(_merge2);
	
	var _taboola = __webpack_require__(667);
	
	var _taboola2 = _interopRequireDefault(_taboola);
	
	var _taboolaDefaults = __webpack_require__(668);
	
	var _taboolaDefaults2 = _interopRequireDefault(_taboolaDefaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  'editionSettings': {
	    'key': 'espncricinfo-en-za',
	    'site': 'espncricinfo',
	    'countryName': 'africa',
	    'language': 'en',
	    'country': 'za',
	    'domain': 'www.espncricinfo.com',
	    'editionSiteId': '1',
	    'https': true
	  },
	  'navId': '18442505',
	  'dictionarySection': 'espn',
	  'javaLocale': {
	    'language': 'en',
	    'region': 'ZA'
	  },
	  'dateTime': {
	    'long': 'dddd MMMM d, yyyy',
	    'medium': 'MMMM d, yyyy',
	    'short': 'M/d',
	    'timeFormat': 'h:mm',
	    'firstDayOfWeek': 'Sunday',
	    'timeZone': 'Europe/London',
	    'defaultFormat': 'd MMM, yyyy',
	    'timeZoneString': 'GMT',
	    'timeZoneBucket': 'Europe/London',
	    'timeZoneDstOffset': 420,
	    'timeZoneDstString': 'BST',
	    'MMM D, YYYY': 'D MMM, YYYY',
	    'M/D/YYYY': 'D/M/YYYY',
	    'MM/DD/YYYY': 'DD/MM/YYYY',
	    'MMDDYYYY': 'DDMMYYYY',
	    'MMMM Do YYYY': 'Do MMMM YYYY',
	    'dddd, MMMM Do YYYY': 'dddd, Do MMMM YYYY',
	    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
	    'M/D': 'D/M',
	    'MMMM D, YYYY': 'D MMMM YYYY',
	    'dddd, M/D': 'dddd, D/M',
	    'age': {
	      'seconds': 's',
	      'minutes': 'm',
	      'hours': 'h',
	      'days': 'd'
	    }
	  },
	  'numberFormat': {
	    'long': '#,###',
	    'short': '###',
	    'currency': '#,###.00',
	    'percent': '#.00%'
	  },
	  'temperature': {
	    'scale': 'celsius',
	    'symbol': '&deg; C'
	  },
	  'sponsoredContentProviders': ['taboola', 'outbrain'],
	  'taboola': (0, _merge3.default)({}, _taboolaDefaults2.default, _taboola2.default),
	  'outbrain': {
	    'enabled': true,
	    'template': 'espncricinfo',
	    'desktop': {
	      'compliantId': 'AR_13',
	      'nonCompliantId': 'AR_16'
	    },
	    'mobile': {
	      'compliantId': 'MB_6',
	      'nonCompliantId': 'MB_9'
	    },
	    'scores': {
	      'desktop': {
	        'compliantId': 'AR_49'
	      },
	      'mobile': {
	        'compliantId': 'AR_49'
	      }
	    },
	    'game': {
	      'desktop': {
	        'compliantId': 'AR_48'
	      },
	      'mobile': {
	        'compliantId': 'MB_48'
	      }
	    },
	    'scorecard': {
	      'desktop': {
	        'compliantId': 'AR_49'
	      },
	      'mobile': {
	        'compliantId': 'AR_49'
	      }
	    },
	    'table': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'AR_43'
	      }
	    },
	    'report': {
	      'desktop': {
	        'compliantId': 'AR_30',
	        'nonCompliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'statistics': {
	      'desktop': {
	        'compliantId': 'AR_49',
	        'nonCompliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'schedule': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'AR_43'
	      }
	    }
	  },
	  'omniture': {
	    'enabled': true
	  },
	  'chartBeat': {
	    'enabled': true
	  },
	  'ads': {
	    'disabled': false,
	    'network': 1234,
	    'partnerAd': false,
	    'dev-config': 15039572,
	    'qa-config': 15039572,
	    'prod-config': 15039572
	  },
	  'partnerModules': {
	    'global': false,
	    'nba': false,
	    'womenbb': false,
	    'golf': false,
	    'endurance': false,
	    'horse': false,
	    'nascar': false
	  },
	  'sportBranding': [{
	    'sport': 'cricket',
	    'image': 'logo-uk-cricinfo',
	    'url': null
	  }, {
	    'sport': 'soccer',
	    'image': 'logo-uk-fc',
	    'url': null
	  }, {
	    'sport': 'rugby',
	    'image': 'logo-uk-scrum',
	    'url': null
	  }, {
	    'sport': 'ncaaw',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }, {
	    'sport': 'ncw',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }, {
	    'sport': 'wnba',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }, {
	    'sport': 'womenbb',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }],
	  'siteLogo': {
	    'class': 'sony-espn',
	    'featurePhone': {
	      'name': 'sonyespn-logo',
	      'width': 62,
	      'height': 34
	    }
	  },
	  'meta': {
	    'titleBranding': ' - ESPN',
	    'description': 'Visit ESPN to get up-to-the-minute sports news coverage, scores, highlights and commentary for cricket, rugby, football, F1, kabaddi and more.',
	    'defaultMetaImage': 'sonyespn_black.png',
	    'social': {
	      'twitter': {
	        'twitterId': '',
	        'card': 'summary',
	        'app_id_iphone': '317469184',
	        'site': 'ESPN',
	        'app_name_googleplay': 'ESPN',
	        'app_id_googleplay': 'com.espn.score_center',
	        'app_name_iphone': 'ESPN',
	        'language': 'en'
	      },
	      'facebook': {
	        'id': '116656161708917',
	        'og_site_name': 'ESPN',
	        'locale': 'en_US'
	      }
	    }
	  },
	  'shop': {
	    'enabled': false
	  },
	  'sportReplacements': {
	    'f1': 'f1',
	    'cycling': 'cycling'
	  },
	  'uriRewrites': {
	    'urls': {
	      'toEdition': {},
	      'toEnglish': {}
	    },
	    'roots': {
	      '/oly/summer/gymnastics/': '/oly/summer/gymnastics/',
	      '/oly/summer/cycling/': '/oly/summer/cycling/',
	      '/college-football/': '/ncf/',
	      '/football/': '/soccer/',
	      '/racing/nascar/': '/nascar/',
	      '/racing/': '/rpm/',
	      '/mens-college-basketball/': '/ncb/',
	      '/womens-college-basketball/': '/ncw/',
	      '/womens-basketball/': '/womenbb/',
	      '/olympics/': '/oly/',
	      '/cycling/': '/cycling/',
	      '/fixtures/': '/schedule',
	      '/figure-skating/': '/oly/',
	      '/college-sports/': '/ncaa/',
	      '/gymnastics/': '/oly/',
	      '/skiing/': '/oly/',
	      '/horse-racing/': '/horse/',
	      '/sports/womenbb/': '/womenbb/',
	      '/sports/horse/': '/horse/'
	    },
	    'pathSegments': {},
	    'paramKeys': {},
	    'paramValues': {}
	  },
	  'betting': {
	    'enabled': false,
	    'provider': 'Bet 365',
	    'game': {
	      'enabled': false,
	      'provider': 'Bet 365'
	    }
	  },
	  'ticketProvider': null,
	  'hasTickets': false,
	  'showFavorites': true,
	  'showInsider': false,
	  'showWatch': false,
	  'hideCategoryLinks': [600, 1700],
	  'categorySettings': {
	    'leagues': true,
	    'athletes': false,
	    'teams': false,
	    'tags': true
	  },
	  'showFCContent': true,
	  'showCricInfoContent': true,
	  'cookieConsent': false,
	  'scDeepLinking': true,
	  'allowShortUrl': false,
	  'allowPrintUrl': true,
	  'allowUserAccountManagement': true,
	  'nowFeed': false,
	  'searchUrl': 'http://search.espn.com/',
	  'hasSearch': true,
	  'gameSettings': {
	    'topEventsId': 19408127,
	    'promotedSoccerLeaguesCeId': 12032789,
	    'showBroadcast': false
	  },
	  'fallback': {
	    'rugby': 'espnuk-en-rugby-index',
	    'horse': 'espnuk-en-horse-index',
	    'nba': 'espn-en-nba-index',
	    'mlb': 'espn-en-mlb-index',
	    'nfl': 'espn-en-nfl-index',
	    'chalk': 'espn-en-chalk-index',
	    'nhl': 'espn-en-nhl-index',
	    'nascar': 'espn-en-nascar-index',
	    'womenbb': 'espn-en-womenbb-index',
	    'ncf': 'espn-en-ncf-index',
	    'ncb': 'espn-en-ncb-index',
	    'boxing': 'espn-en-boxing-index',
	    'mma': 'espn-en-mma-index',
	    'esports': 'espn-en-esports-index',
	    'nba-stephen-curry': 'espn-en-nba-stephen-curry-index',
	    'oly-summer-archery': 'espn-en-oly-summer-archery-index',
	    'oly-summer-athletics': 'espnuk-en-oly-summer-athletics-index',
	    'oly-summer-badminton': 'espn-en-oly-summer-badminton-index',
	    'oly-summer-basketball': 'espnuk-en-oly-summer-basketball-index',
	    'oly-summer-boxing': 'espnuk-en-oly-summer-boxing-index',
	    'oly-summer-canoe': 'espn-en-oly-summer-canoe-index',
	    'oly-summer-cycling': 'espn-en-oly-summer-cycling-index',
	    'oly-summer-equestrian': 'espn-en-oly-summer-equestrian-index',
	    'oly-summer-fencing': 'espn-en-oly-summer-fencing-index',
	    'oly-summer-field-hockey': 'espn-en-oly-summer-field-hockey-index',
	    'oly-summer-golf': 'espnuk-en-oly-summer-golf-index',
	    'oly-summer-gymnastics': 'espnuk-en-oly-summer-gymnastics-index',
	    'oly-summer-handball': 'espn-en-oly-summer-handball-index',
	    'oly-summer-judo': 'espn-en-oly-summer-judo-index',
	    'oly-summer-modern-pentathlon': 'espn-en-oly-summer-modern-pentathlon-index',
	    'oly-summer-rowing': 'espn-en-oly-summer-rowing-index',
	    'oly-summer-rugby': 'espnuk-en-oly-summer-rugby-index',
	    'oly-summer-sailing': 'espn-en-oly-summer-sailing-index',
	    'oly-summer-shooting': 'espn-en-oly-summer-shooting-index',
	    'oly-summer-soccer': 'espnuk-en-oly-summer-soccer-index',
	    'oly-summer-swimming': 'espnuk-en-oly-summer-swimming-index',
	    'oly-summer-table-tennis': 'espn-en-oly-summer-table-tennis-index',
	    'oly-summer-taekwondo': 'espn-en-oly-summer-taekwondo-index',
	    'oly-summer-tennis': 'espnuk-en-oly-summer-tennis-index',
	    'oly-summer-triathlon': 'espn-en-oly-summer-triathlon-index',
	    'oly-summer-volleyball': 'espnuk-en-oly-summer-volleyball-index',
	    'oly-summer-water-polo': 'espn-en-oly-summer-water-polo-index',
	    'oly-summer-weightlifting': 'espn-en-oly-summer-weightlifting-index',
	    'oly-summer-wrestling': 'espn-en-oly-summer-wrestling-index'
	  },
	  'editionAlert': {
	    'enabled': true,
	    'text': 'Welcome to Sony ESPN India Edition'
	  },
	  'feeds': {
	    'googlenews': {
	      'allowedContentTypes': ['Story', 'HeadlineNews']
	    }
	  },
	  'tier2NavIds': {
	    'boston': 12375278,
	    'chicago': 12505826,
	    'cleveland': 13977091,
	    'dallas': 12505828,
	    'los-angeles': 12505831,
	    'milwaukee': 13977360,
	    'new-york': 12505854,
	    'fantasy/basketball': 12405600,
	    'fantasy/football': 12405632,
	    'fantasy/baseball': 12405631,
	    'fantasy/hockey': 12405634,
	    'fantasy': 13609307,
	    'ncfrecruiting': 11588758,
	    'ncbrecruiting': 11588880,
	    'esports': 13663224,
	    'onenacion': 13309315,
	    'nba/stephen-curry': 14950765,
	    'league': {
	      'soccer': 13794648,
	      'ncf': 13886385,
	      'college-football': 13886385,
	      'cricket': 15609108
	    }
	  },
	  'tier3NavIds': {
	    'clubhouse': {
	      'nba': 12293424,
	      'mlb': 12343023,
	      'mens-college-basketball': 13884705,
	      'womens-college-basketball': 13930164,
	      'soccer': 12294454,
	      'nfl': 12509708,
	      'college-football': 13345157,
	      'cricket': 15368856
	    }
	  },
	  'indexAutoStart': false,
	  'useMongo': true,
	  'activeSite': true,
	  'countries': [{
	    'name': 'India',
	    'country-code': 'in',
	    'showHreflang': true
	  }, {
	    'name': 'Bangladesh',
	    'country-code': 'bd',
	    'showHreflang': false
	  }, {
	    'name': 'Bhutan',
	    'country-code': 'bt',
	    'showHreflang': false
	  }, {
	    'name': 'Maldives',
	    'country-code': 'mv',
	    'showHreflang': false
	  }, {
	    'name': 'Nepal',
	    'country-code': 'np',
	    'showHreflang': false
	  }, {
	    'name': 'Pakistan',
	    'country-code': 'pk',
	    'showHreflang': false
	  }, {
	    'name': 'Sri Lanka',
	    'country-code': 'lk',
	    'showHreflang': false
	  }]
	};

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(582),
	    createAssigner = __webpack_require__(657);
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(583),
	    assignMergeValue = __webpack_require__(621),
	    baseFor = __webpack_require__(624),
	    baseMergeDeep = __webpack_require__(626),
	    isObject = __webpack_require__(601),
	    keysIn = __webpack_require__(651),
	    safeGet = __webpack_require__(647);
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    if (isObject(srcValue)) {
	      stack || (stack = new Stack);
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	module.exports = baseMerge;


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(584),
	    stackClear = __webpack_require__(592),
	    stackDelete = __webpack_require__(593),
	    stackGet = __webpack_require__(594),
	    stackHas = __webpack_require__(595),
	    stackSet = __webpack_require__(596);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(585),
	    listCacheDelete = __webpack_require__(586),
	    listCacheGet = __webpack_require__(589),
	    listCacheHas = __webpack_require__(590),
	    listCacheSet = __webpack_require__(591);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 585 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(587);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(588);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 588 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(587);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(587);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(587);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(584);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 593 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 594 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 595 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(584),
	    Map = __webpack_require__(597),
	    MapCache = __webpack_require__(606);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(598),
	    root = __webpack_require__(261);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(599),
	    getValue = __webpack_require__(605);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(600),
	    isMasked = __webpack_require__(602),
	    isObject = __webpack_require__(601),
	    toSource = __webpack_require__(604);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(259),
	    isObject = __webpack_require__(601);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 601 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(603);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(261);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 604 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 605 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(607),
	    mapCacheDelete = __webpack_require__(615),
	    mapCacheGet = __webpack_require__(618),
	    mapCacheHas = __webpack_require__(619),
	    mapCacheSet = __webpack_require__(620);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(608),
	    ListCache = __webpack_require__(584),
	    Map = __webpack_require__(597);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(609),
	    hashDelete = __webpack_require__(611),
	    hashGet = __webpack_require__(612),
	    hashHas = __webpack_require__(613),
	    hashSet = __webpack_require__(614);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(610);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(598);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 611 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(610);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(610);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(610);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(616);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(617);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 617 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(616);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(616);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(616);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(622),
	    eq = __webpack_require__(588);
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignMergeValue;


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(623);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(598);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(625);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),
/* 625 */
/***/ (function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	var assignMergeValue = __webpack_require__(621),
	    cloneBuffer = __webpack_require__(627),
	    cloneTypedArray = __webpack_require__(628),
	    copyArray = __webpack_require__(631),
	    initCloneObject = __webpack_require__(632),
	    isArguments = __webpack_require__(635),
	    isArray = __webpack_require__(637),
	    isArrayLikeObject = __webpack_require__(638),
	    isBuffer = __webpack_require__(641),
	    isFunction = __webpack_require__(600),
	    isObject = __webpack_require__(601),
	    isPlainObject = __webpack_require__(258),
	    isTypedArray = __webpack_require__(643),
	    safeGet = __webpack_require__(647),
	    toPlainObject = __webpack_require__(648);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = safeGet(object, key),
	      srcValue = safeGet(source, key),
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	module.exports = baseMergeDeep;


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(261);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(269)(module)))

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(629);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(630);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(261);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 631 */
/***/ (function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(633),
	    getPrototype = __webpack_require__(265),
	    isPrototype = __webpack_require__(634);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(601);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ }),
/* 634 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(636),
	    isObjectLike = __webpack_require__(267);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(259),
	    isObjectLike = __webpack_require__(267);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 637 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(639),
	    isObjectLike = __webpack_require__(267);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(600),
	    isLength = __webpack_require__(640);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 640 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(261),
	    stubFalse = __webpack_require__(642);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(269)(module)))

/***/ }),
/* 642 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(644),
	    baseUnary = __webpack_require__(645),
	    nodeUtil = __webpack_require__(646);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(259),
	    isLength = __webpack_require__(640),
	    isObjectLike = __webpack_require__(267);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 645 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(262);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(269)(module)))

/***/ }),
/* 647 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key`, unless `key` is "__proto__".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function safeGet(object, key) {
	  return key == '__proto__'
	    ? undefined
	    : object[key];
	}
	
	module.exports = safeGet;


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(649),
	    keysIn = __webpack_require__(651);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(650),
	    baseAssignValue = __webpack_require__(622);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(622),
	    eq = __webpack_require__(588);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(652),
	    baseKeysIn = __webpack_require__(655),
	    isArrayLike = __webpack_require__(639);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(653),
	    isArguments = __webpack_require__(635),
	    isArray = __webpack_require__(637),
	    isBuffer = __webpack_require__(641),
	    isIndex = __webpack_require__(654),
	    isTypedArray = __webpack_require__(643);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 653 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 654 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(601),
	    isPrototype = __webpack_require__(634),
	    nativeKeysIn = __webpack_require__(656);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ }),
/* 656 */
/***/ (function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(658),
	    isIterateeCall = __webpack_require__(666);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(659),
	    overRest = __webpack_require__(660),
	    setToString = __webpack_require__(662);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),
/* 659 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(661);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),
/* 661 */
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(663),
	    shortOut = __webpack_require__(665);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(664),
	    defineProperty = __webpack_require__(623),
	    identity = __webpack_require__(659);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),
/* 664 */
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 665 */
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(588),
	    isArrayLike = __webpack_require__(639),
	    isIndex = __webpack_require__(654),
	    isObject = __webpack_require__(601);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),
/* 667 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Taboola defaults for cricket, all editions.
	//
	// Notes:
	// 1. '*_webview' only used in webview mode.
	// 2. 'publisher_webview' gets 'ios' or 'android' appended to it on those platforms.
	// 3. 'mode_webview' gets '-iOS' or '-Android' appended to it on those platforms.
	// 4. 'commentary' => 'gamepackage'
	// 5. 'coverage' => 'gamepackage'
	// 6. 'game' => 'gamepackage'
	// 7. 'hawkeye' => 'gamepackage'
	// 8. 'match' => 'gamepackage'
	// 9. 'preview' => 'article' (only available via gamepackage in Reduxion)
	// 10. 'report' => 'article' (only available via gamepackage in Reduxion)
	// 11. 'scorecard' => 'gamepackage'
	// 12. 'statistics' => 'gamepackage'
	// 13. 'video' => 'gamepackage'
	
	exports.default = {
	  'publisher_webview': 'espnappsnetwork-espncricinfo',
	  'commentary': {
	    'type': 'category',
	    'mode': 'thumbnails-3x2-a',
	    'mode_webview': 'thumbnails-2x2-Cricinfo',
	    'container': 'taboola-below-section-front-thumbnails',
	    'container_webview': 'taboola-below-section-front-thumbnails',
	    'target_type': 'mix'
	  },
	  'coverage': {
	    'type': 'category',
	    'mode': 'thumbnails-3x2-a',
	    'mode_webview': 'thumbnails-2x2-Cricinfo',
	    'container': 'taboola-below-section-front-thumbnails',
	    'container_webview': 'taboola-below-section-front-thumbnails',
	    'target_type': 'mix'
	  },
	  'game': {
	    'type': 'category',
	    'mode': 'thumbnails-3x2-a',
	    'mode_webview': 'thumbnails-2x2-Cricinfo',
	    'container': 'taboola-below-section-front-thumbnails',
	    'container_webview': 'taboola-below-section-front-thumbnails',
	    'target_type': 'mix'
	  },
	  'hawkeye': {
	    'type': 'category',
	    'mode': 'thumbnails-3x2-a',
	    'mode_webview': 'thumbnails-2x2-Cricinfo',
	    'container': 'taboola-below-section-front-thumbnails',
	    'container_webview': 'taboola-below-section-front-thumbnails',
	    'target_type': 'mix'
	  },
	  'match': {
	    'type': 'category',
	    'mode': 'thumbnails-3x2-a',
	    'mode_webview': 'thumbnails-2x2-Cricinfo',
	    'container': 'taboola-below-section-front-thumbnails',
	    'container_webview': 'taboola-below-section-front-thumbnails',
	    'target_type': 'mix'
	  },
	  'preview': {
	    'type': 'article',
	    'mode': 'thumbnails-3x2-a',
	    'mode_webview': 'thumbnails-2x2-Cricinfo',
	    'container': 'taboola-below-article-thumbnails',
	    'container_webview': 'taboola-below-article-thumbnails',
	    'target_type': 'mix'
	  },
	  'report': {
	    'type': 'article',
	    'mode': 'thumbnails-3x2-a',
	    'mode_webview': 'thumbnails-2x2-Cricinfo',
	    'container': 'taboola-below-article-thumbnails',
	    'container_webview': 'taboola-below-article-thumbnails',
	    'target_type': 'mix'
	  },
	  'scorecard': {
	    'type': 'category',
	    'mode': 'thumbnails-3x2-a',
	    'mode_webview': 'thumbnails-2x2-Cricinfo',
	    'container': 'taboola-below-section-front-thumbnails',
	    'container_webview': 'taboola-below-section-front-thumbnails',
	    'target_type': 'mix'
	  },
	  'statistics': {
	    'type': 'category',
	    'mode': 'thumbnails-3x2-a',
	    'mode_webview': 'thumbnails-2x2-Cricinfo',
	    'container': 'taboola-below-section-front-thumbnails',
	    'container_webview': 'taboola-below-section-front-thumbnails',
	    'target_type': 'mix'
	  },
	  'video': {
	    'type': 'category',
	    'mode': 'thumbnails-3x2-a',
	    'mode_webview': 'thumbnails-2x2-Cricinfo',
	    'container': 'taboola-below-section-front-thumbnails',
	    'container_webview': 'taboola-below-section-front-thumbnails',
	    'target_type': 'mix'
	  }
	};

/***/ }),
/* 668 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Taboola defaults for both rugby and cricket, all editions.
	//
	// Notes:
	// 1. 'scoreboard' => 'scores'
	// 2. 'table' => 'standings'
	
	exports.default = {
	  'enabled': true,
	  'publisher': 'espn-network',
	  'type': 'other',
	  'mode': 'thumbnails-3x2-a',
	  'container': 'taboola-below-content-thumbnails',
	  'target_type': 'mix',
	  'schedule': {
	    'type': 'other',
	    'mode': 'thumbnails-3x2-a',
	    'container': 'taboola-below-content-thumbnails',
	    'target_type': 'mix'
	  },
	  'scoreboard': {
	    'type': 'other',
	    'mode': 'thumbnails-3x2-a',
	    'container': 'taboola-below-content-thumbnails',
	    'target_type': 'mix',
	    'right-rail': {
	      'type': 'other',
	      'mode': 'thumbnails-1x3',
	      'container': 'taboola-right-rail-thumbnails',
	      'target_type': 'mix'
	    }
	  },
	  'scores': {
	    'type': 'other',
	    'mode': 'thumbnails-3x2-a',
	    'container': 'taboola-below-content-thumbnails',
	    'target_type': 'mix',
	    'right-rail': {
	      'type': 'other',
	      'mode': 'thumbnails-1x3',
	      'container': 'taboola-right-rail-thumbnails',
	      'target_type': 'mix'
	    }
	  },
	  'standings': {
	    'type': 'other',
	    'mode': 'thumbnails-3x2-a',
	    'container': 'taboola-below-content-thumbnails',
	    'target_type': 'mix'
	  },
	  'table': {
	    'type': 'other',
	    'mode': 'thumbnails-3x2-a',
	    'container': 'taboola-below-content-thumbnails',
	    'target_type': 'mix'
	  }
	};

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge2 = __webpack_require__(581);
	
	var _merge3 = _interopRequireDefault(_merge2);
	
	var _taboola = __webpack_require__(667);
	
	var _taboola2 = _interopRequireDefault(_taboola);
	
	var _taboolaDefaults = __webpack_require__(668);
	
	var _taboolaDefaults2 = _interopRequireDefault(_taboolaDefaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  'editionSettings': {
	    'key': 'espncricinfo-en-au',
	    'site': 'espncricinfo',
	    'language': 'en',
	    'country': 'au',
	    'countryName': 'australia',
	    'domain': 'www.espncricinfo.com',
	    'editionSiteId': '1',
	    'https': true
	  },
	  'navId': '18442121',
	  'dictionarySection': 'espn',
	  'javaLocale': {
	    'language': 'en',
	    'region': 'AU'
	  },
	  'dateTime': {
	    'long': 'dddd MMMM d, yyyy',
	    'medium': 'MMMM d, yyyy',
	    'short': 'M/d',
	    'timeFormat': 'h:mm',
	    'firstDayOfWeek': 'Monday',
	    'timeZone': 'Etc/GMT',
	    'defaultFormat': 'd MMM, yyyy',
	    'timeZoneString': 'GMT',
	    'timeZoneBucket': 'Australia/Melbourne',
	    'MMM D, YYYY': 'D MMM, YYYY',
	    'M/D/YYYY': 'D/M/YYYY',
	    'MM/DD/YYYY': 'DD/MM/YYYY',
	    'MMDDYYYY': 'DDMMYYYY',
	    'MMMM Do YYYY': 'Do MMMM YYYY',
	    'dddd, MMMM Do YYYY': 'dddd, Do MMMM YYYY',
	    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
	    'M/D': 'D/M',
	    'MMMM D, YYYY': 'D MMMM YYYY',
	    'dddd, M/D': 'dddd, D/M',
	    'age': {
	      'seconds': 's',
	      'minutes': 'm',
	      'hours': 'h',
	      'days': 'd'
	    }
	  },
	  'numberFormat': {
	    'long': '#,###',
	    'short': '###',
	    'currency': '#,###.00',
	    'percent': '#.00%'
	  },
	  'temperature': {
	    'scale': 'celsius',
	    'symbol': '&deg; C'
	  },
	  'sponsoredContentProviders': ['taboola', 'outbrain'],
	  'taboola': (0, _merge3.default)({}, _taboolaDefaults2.default, _taboola2.default),
	  'outbrain': {
	    'enabled': true,
	    'template': 'ESPNIndia',
	    'desktop': {
	      'compliantId': 'AR_13',
	      'nonCompliantId': 'AR_16'
	    },
	    'mobile': {
	      'compliantId': 'MB_6',
	      'nonCompliantId': 'MB_9'
	    },
	    'scores': {
	      'desktop': {
	        'compliantId': 'AR_49'
	      },
	      'mobile': {
	        'compliantId': 'AR_49'
	      }
	    },
	    'game': {
	      'desktop': {
	        'compliantId': 'AR_48'
	      },
	      'mobile': {
	        'compliantId': 'MB_48'
	      }
	    },
	    'scorecard': {
	      'desktop': {
	        'compliantId': 'AR_49'
	      },
	      'mobile': {
	        'compliantId': 'AR_49'
	      }
	    },
	    'table': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'AR_43'
	      }
	    },
	    'report': {
	      'desktop': {
	        'compliantId': 'AR_30',
	        'nonCompliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'statistics': {
	      'desktop': {
	        'compliantId': 'AR_49',
	        'nonCompliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'schedule': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'AR_43'
	      }
	    }
	  },
	  'omniture': {
	    'enabled': true
	  },
	  'chartBeat': {
	    'enabled': true
	  },
	  'ads': {
	    'disabled': false,
	    'network': 1234,
	    'partnerAd': false,
	    'dev-config': 15039572,
	    'qa-config': 15039572,
	    'prod-config': 15039572
	  },
	  'partnerModules': {
	    'global': false,
	    'nba': false,
	    'womenbb': false,
	    'golf': false,
	    'endurance': false,
	    'horse': false,
	    'nascar': false
	  },
	  'sportBranding': [{
	    'sport': 'cricket',
	    'image': 'logo-uk-cricinfo',
	    'url': null
	  }, {
	    'sport': 'soccer',
	    'image': 'logo-uk-fc',
	    'url': null
	  }, {
	    'sport': 'rugby',
	    'image': 'logo-uk-scrum',
	    'url': null
	  }, {
	    'sport': 'ncaaw',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }, {
	    'sport': 'ncw',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }, {
	    'sport': 'wnba',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }, {
	    'sport': 'womenbb',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }],
	  'siteLogo': {
	    'class': 'sony-espn',
	    'featurePhone': {
	      'name': 'sonyespn-logo',
	      'width': 62,
	      'height': 34
	    }
	  },
	  'meta': {
	    'titleBranding': ' - ESPN',
	    'description': 'Visit ESPN to get up-to-the-minute sports news coverage, scores, highlights and commentary for cricket, rugby, football, F1, kabaddi and more.',
	    'defaultMetaImage': 'sonyespn_black.png',
	    'social': {
	      'twitter': {
	        'twitterId': '',
	        'card': 'summary',
	        'app_id_iphone': '317469184',
	        'site': 'ESPN',
	        'app_name_googleplay': 'ESPN',
	        'app_id_googleplay': 'com.espn.score_center',
	        'app_name_iphone': 'ESPN',
	        'language': 'en'
	      },
	      'facebook': {
	        'id': '116656161708917',
	        'og_site_name': 'ESPN',
	        'locale': 'en_US'
	      }
	    }
	  },
	  'shop': {
	    'enabled': false
	  },
	  'sportReplacements': {
	    'f1': 'f1',
	    'cycling': 'cycling'
	  },
	  'uriRewrites': {
	    'urls': {
	      'toEdition': {},
	      'toEnglish': {}
	    },
	    'roots': {
	      '/oly/summer/gymnastics/': '/oly/summer/gymnastics/',
	      '/oly/summer/cycling/': '/oly/summer/cycling/',
	      '/college-football/': '/ncf/',
	      '/football/': '/soccer/',
	      '/racing/nascar/': '/nascar/',
	      '/racing/': '/rpm/',
	      '/mens-college-basketball/': '/ncb/',
	      '/womens-college-basketball/': '/ncw/',
	      '/womens-basketball/': '/womenbb/',
	      '/olympics/': '/oly/',
	      '/cycling/': '/cycling/',
	      '/fixtures/': '/schedule',
	      '/figure-skating/': '/oly/',
	      '/college-sports/': '/ncaa/',
	      '/gymnastics/': '/oly/',
	      '/skiing/': '/oly/',
	      '/horse-racing/': '/horse/',
	      '/sports/womenbb/': '/womenbb/',
	      '/sports/horse/': '/horse/'
	    },
	    'pathSegments': {},
	    'paramKeys': {},
	    'paramValues': {}
	  },
	  'betting': {
	    'enabled': false,
	    'provider': 'Bet 365',
	    'game': {
	      'enabled': false,
	      'provider': 'Bet 365'
	    }
	  },
	  'ticketProvider': null,
	  'hasTickets': false,
	  'showFavorites': true,
	  'showInsider': false,
	  'showWatch': false,
	  'hideCategoryLinks': [600, 1700],
	  'categorySettings': {
	    'leagues': true,
	    'athletes': false,
	    'teams': false,
	    'tags': true
	  },
	  'showFCContent': true,
	  'showCricInfoContent': true,
	  'cookieConsent': false,
	  'scDeepLinking': true,
	  'allowShortUrl': false,
	  'allowPrintUrl': true,
	  'allowUserAccountManagement': true,
	  'nowFeed': false,
	  'searchUrl': 'http://search.espn.com/',
	  'hasSearch': true,
	  'gameSettings': {
	    'topEventsId': 19408128,
	    'promotedSoccerLeaguesCeId': 12032789,
	    'showBroadcast': false
	  },
	  'fallback': {
	    'rugby': 'espnuk-en-rugby-index',
	    'horse': 'espnuk-en-horse-index',
	    'nba': 'espn-en-nba-index',
	    'mlb': 'espn-en-mlb-index',
	    'nfl': 'espn-en-nfl-index',
	    'chalk': 'espn-en-chalk-index',
	    'nhl': 'espn-en-nhl-index',
	    'nascar': 'espn-en-nascar-index',
	    'womenbb': 'espn-en-womenbb-index',
	    'ncf': 'espn-en-ncf-index',
	    'ncb': 'espn-en-ncb-index',
	    'boxing': 'espn-en-boxing-index',
	    'mma': 'espn-en-mma-index',
	    'esports': 'espn-en-esports-index',
	    'nba-stephen-curry': 'espn-en-nba-stephen-curry-index',
	    'oly-summer-archery': 'espn-en-oly-summer-archery-index',
	    'oly-summer-athletics': 'espnuk-en-oly-summer-athletics-index',
	    'oly-summer-badminton': 'espn-en-oly-summer-badminton-index',
	    'oly-summer-basketball': 'espnuk-en-oly-summer-basketball-index',
	    'oly-summer-boxing': 'espnuk-en-oly-summer-boxing-index',
	    'oly-summer-canoe': 'espn-en-oly-summer-canoe-index',
	    'oly-summer-cycling': 'espn-en-oly-summer-cycling-index',
	    'oly-summer-equestrian': 'espn-en-oly-summer-equestrian-index',
	    'oly-summer-fencing': 'espn-en-oly-summer-fencing-index',
	    'oly-summer-field-hockey': 'espn-en-oly-summer-field-hockey-index',
	    'oly-summer-golf': 'espnuk-en-oly-summer-golf-index',
	    'oly-summer-gymnastics': 'espnuk-en-oly-summer-gymnastics-index',
	    'oly-summer-handball': 'espn-en-oly-summer-handball-index',
	    'oly-summer-judo': 'espn-en-oly-summer-judo-index',
	    'oly-summer-modern-pentathlon': 'espn-en-oly-summer-modern-pentathlon-index',
	    'oly-summer-rowing': 'espn-en-oly-summer-rowing-index',
	    'oly-summer-rugby': 'espnuk-en-oly-summer-rugby-index',
	    'oly-summer-sailing': 'espn-en-oly-summer-sailing-index',
	    'oly-summer-shooting': 'espn-en-oly-summer-shooting-index',
	    'oly-summer-soccer': 'espnuk-en-oly-summer-soccer-index',
	    'oly-summer-swimming': 'espnuk-en-oly-summer-swimming-index',
	    'oly-summer-table-tennis': 'espn-en-oly-summer-table-tennis-index',
	    'oly-summer-taekwondo': 'espn-en-oly-summer-taekwondo-index',
	    'oly-summer-tennis': 'espnuk-en-oly-summer-tennis-index',
	    'oly-summer-triathlon': 'espn-en-oly-summer-triathlon-index',
	    'oly-summer-volleyball': 'espnuk-en-oly-summer-volleyball-index',
	    'oly-summer-water-polo': 'espn-en-oly-summer-water-polo-index',
	    'oly-summer-weightlifting': 'espn-en-oly-summer-weightlifting-index',
	    'oly-summer-wrestling': 'espn-en-oly-summer-wrestling-index'
	  },
	  'editionAlert': {
	    'enabled': true,
	    'text': 'Welcome to Sony ESPN India Edition'
	  },
	  'feeds': {
	    'googlenews': {
	      'allowedContentTypes': ['Story', 'HeadlineNews']
	    }
	  },
	  'tier2NavIds': {
	    'boston': 12375278,
	    'chicago': 12505826,
	    'cleveland': 13977091,
	    'dallas': 12505828,
	    'los-angeles': 12505831,
	    'milwaukee': 13977360,
	    'new-york': 12505854,
	    'fantasy/basketball': 12405600,
	    'fantasy/football': 12405632,
	    'fantasy/baseball': 12405631,
	    'fantasy/hockey': 12405634,
	    'fantasy': 13609307,
	    'ncfrecruiting': 11588758,
	    'ncbrecruiting': 11588880,
	    'esports': 13663224,
	    'onenacion': 13309315,
	    'nba/stephen-curry': 14950765,
	    'league': {
	      'soccer': 13794648,
	      'ncf': 13886385,
	      'college-football': 13886385,
	      'cricket': 15609108
	    }
	  },
	  'tier3NavIds': {
	    'clubhouse': {
	      'nba': 12293424,
	      'mlb': 12343023,
	      'mens-college-basketball': 13884705,
	      'womens-college-basketball': 13930164,
	      'soccer': 12294454,
	      'nfl': 12509708,
	      'college-football': 13345157,
	      'cricket': 15368856
	    }
	  },
	  'indexAutoStart': false,
	  'useMongo': true,
	  'activeSite': true,
	  'countries': [{
	    'name': 'India',
	    'country-code': 'in',
	    'showHreflang': true
	  }, {
	    'name': 'Bangladesh',
	    'country-code': 'bd',
	    'showHreflang': false
	  }, {
	    'name': 'Bhutan',
	    'country-code': 'bt',
	    'showHreflang': false
	  }, {
	    'name': 'Maldives',
	    'country-code': 'mv',
	    'showHreflang': false
	  }, {
	    'name': 'Nepal',
	    'country-code': 'np',
	    'showHreflang': false
	  }, {
	    'name': 'Pakistan',
	    'country-code': 'pk',
	    'showHreflang': false
	  }, {
	    'name': 'Sri Lanka',
	    'country-code': 'lk',
	    'showHreflang': false
	  }]
	};

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge2 = __webpack_require__(581);
	
	var _merge3 = _interopRequireDefault(_merge2);
	
	var _taboola = __webpack_require__(667);
	
	var _taboola2 = _interopRequireDefault(_taboola);
	
	var _taboolaDefaults = __webpack_require__(668);
	
	var _taboolaDefaults2 = _interopRequireDefault(_taboolaDefaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  'editionSettings': {
	    'key': 'espncricinfo-en-bd',
	    'site': 'espncricinfo',
	    'language': 'en',
	    'country': 'bd',
	    'countryName': 'bangladesh',
	    'domain': 'www.espncricinfo.com',
	    'editionSiteId': '1',
	    'https': true
	  },
	  'navId': '18442615',
	  'dictionarySection': 'espn',
	  'javaLocale': {
	    'language': 'en',
	    'region': 'BD'
	  },
	  'dateTime': {
	    'long': 'dddd MMMM d, yyyy',
	    'medium': 'MMMM d, yyyy',
	    'short': 'M/d',
	    'timeFormat': 'h:mm',
	    'firstDayOfWeek': 'Sunday',
	    'timeZone': 'Asia/Calcutta',
	    'defaultFormat': 'd MMM, yyyy',
	    'timeZoneString': 'IST',
	    'timeZoneBucket': 'Asia/Kolkata',
	    'MMM D, YYYY': 'D MMM, YYYY',
	    'M/D/YYYY': 'D/M/YYYY',
	    'MM/DD/YYYY': 'DD/MM/YYYY',
	    'MMDDYYYY': 'DDMMYYYY',
	    'MMMM Do YYYY': 'Do MMMM YYYY',
	    'dddd, MMMM Do YYYY': 'dddd, Do MMMM YYYY',
	    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
	    'M/D': 'D/M',
	    'MMMM D, YYYY': 'D MMMM YYYY',
	    'dddd, M/D': 'dddd, D/M',
	    'age': {
	      'seconds': 's',
	      'minutes': 'm',
	      'hours': 'h',
	      'days': 'd'
	    }
	  },
	  'numberFormat': {
	    'long': '#,###',
	    'short': '###',
	    'currency': '#,###.00',
	    'percent': '#.00%'
	  },
	  'temperature': {
	    'scale': 'celsius',
	    'symbol': '&deg; C'
	  },
	  'sponsoredContentProviders': ['taboola', 'outbrain'],
	  'taboola': (0, _merge3.default)({}, _taboolaDefaults2.default, _taboola2.default),
	  'outbrain': {
	    'enabled': true,
	    'template': 'ESPNIndia',
	    'desktop': {
	      'compliantId': 'AR_13',
	      'nonCompliantId': 'AR_16'
	    },
	    'mobile': {
	      'compliantId': 'MB_6',
	      'nonCompliantId': 'MB_9'
	    },
	    'scores': {
	      'desktop': {
	        'compliantId': 'AR_49'
	      },
	      'mobile': {
	        'compliantId': 'AR_49'
	      }
	    },
	    'game': {
	      'desktop': {
	        'compliantId': 'AR_48'
	      },
	      'mobile': {
	        'compliantId': 'MB_48'
	      }
	    },
	    'scorecard': {
	      'desktop': {
	        'compliantId': 'AR_49'
	      },
	      'mobile': {
	        'compliantId': 'AR_49'
	      }
	    },
	    'table': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'AR_43'
	      }
	    },
	    'report': {
	      'desktop': {
	        'compliantId': 'AR_30',
	        'nonCompliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'statistics': {
	      'desktop': {
	        'compliantId': 'AR_49',
	        'nonCompliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'schedule': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'AR_43'
	      }
	    }
	  },
	  'omniture': {
	    'enabled': true
	  },
	  'chartBeat': {
	    'enabled': true
	  },
	  'ads': {
	    'disabled': false,
	    'network': 1234,
	    'partnerAd': false,
	    'dev-config': 15039572,
	    'qa-config': 15039572,
	    'prod-config': 15039572
	  },
	  'partnerModules': {
	    'global': false,
	    'nba': false,
	    'womenbb': false,
	    'golf': false,
	    'endurance': false,
	    'horse': false,
	    'nascar': false
	  },
	  'sportBranding': [{
	    'sport': 'cricket',
	    'image': 'logo-uk-cricinfo',
	    'url': null
	  }, {
	    'sport': 'soccer',
	    'image': 'logo-uk-fc',
	    'url': null
	  }, {
	    'sport': 'rugby',
	    'image': 'logo-uk-scrum',
	    'url': null
	  }, {
	    'sport': 'ncaaw',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }, {
	    'sport': 'ncw',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }, {
	    'sport': 'wnba',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }, {
	    'sport': 'womenbb',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }],
	  'siteLogo': {
	    'class': 'sony-espn',
	    'featurePhone': {
	      'name': 'sonyespn-logo',
	      'width': 62,
	      'height': 34
	    }
	  },
	  'meta': {
	    'titleBranding': ' - ESPN',
	    'description': 'Visit ESPN to get up-to-the-minute sports news coverage, scores, highlights and commentary for cricket, rugby, football, F1, kabaddi and more.',
	    'defaultMetaImage': 'sonyespn_black.png',
	    'social': {
	      'twitter': {
	        'twitterId': '',
	        'card': 'summary',
	        'app_id_iphone': '317469184',
	        'site': 'ESPN',
	        'app_name_googleplay': 'ESPN',
	        'app_id_googleplay': 'com.espn.score_center',
	        'app_name_iphone': 'ESPN',
	        'language': 'en'
	      },
	      'facebook': {
	        'id': '116656161708917',
	        'og_site_name': 'ESPN',
	        'locale': 'en_US'
	      }
	    }
	  },
	  'shop': {
	    'enabled': false
	  },
	  'sportReplacements': {
	    'f1': 'f1',
	    'cycling': 'cycling'
	  },
	  'uriRewrites': {
	    'urls': {
	      'toEdition': {},
	      'toEnglish': {}
	    },
	    'roots': {
	      '/oly/summer/gymnastics/': '/oly/summer/gymnastics/',
	      '/oly/summer/cycling/': '/oly/summer/cycling/',
	      '/college-football/': '/ncf/',
	      '/football/': '/soccer/',
	      '/racing/nascar/': '/nascar/',
	      '/racing/': '/rpm/',
	      '/mens-college-basketball/': '/ncb/',
	      '/womens-college-basketball/': '/ncw/',
	      '/womens-basketball/': '/womenbb/',
	      '/olympics/': '/oly/',
	      '/cycling/': '/cycling/',
	      '/fixtures/': '/schedule',
	      '/figure-skating/': '/oly/',
	      '/college-sports/': '/ncaa/',
	      '/gymnastics/': '/oly/',
	      '/skiing/': '/oly/',
	      '/horse-racing/': '/horse/',
	      '/sports/womenbb/': '/womenbb/',
	      '/sports/horse/': '/horse/'
	    },
	    'pathSegments': {},
	    'paramKeys': {},
	    'paramValues': {}
	  },
	  'betting': {
	    'enabled': false,
	    'provider': 'Bet 365',
	    'game': {
	      'enabled': false,
	      'provider': 'Bet 365'
	    }
	  },
	  'ticketProvider': null,
	  'hasTickets': false,
	  'showFavorites': true,
	  'showInsider': false,
	  'showWatch': false,
	  'hideCategoryLinks': [600, 1700],
	  'categorySettings': {
	    'leagues': true,
	    'athletes': false,
	    'teams': false,
	    'tags': true
	  },
	  'showFCContent': true,
	  'showCricInfoContent': true,
	  'cookieConsent': false,
	  'scDeepLinking': true,
	  'allowShortUrl': false,
	  'allowPrintUrl': true,
	  'allowUserAccountManagement': true,
	  'nowFeed': false,
	  'searchUrl': 'http://search.espn.com/',
	  'hasSearch': true,
	  'gameSettings': {
	    'topEventsId': 19408130,
	    'promotedSoccerLeaguesCeId': 12032789,
	    'showBroadcast': false
	  },
	  'fallback': {
	    'rugby': 'espnuk-en-rugby-index',
	    'horse': 'espnuk-en-horse-index',
	    'nba': 'espn-en-nba-index',
	    'mlb': 'espn-en-mlb-index',
	    'nfl': 'espn-en-nfl-index',
	    'chalk': 'espn-en-chalk-index',
	    'nhl': 'espn-en-nhl-index',
	    'nascar': 'espn-en-nascar-index',
	    'womenbb': 'espn-en-womenbb-index',
	    'ncf': 'espn-en-ncf-index',
	    'ncb': 'espn-en-ncb-index',
	    'boxing': 'espn-en-boxing-index',
	    'mma': 'espn-en-mma-index',
	    'esports': 'espn-en-esports-index',
	    'nba-stephen-curry': 'espn-en-nba-stephen-curry-index',
	    'oly-summer-archery': 'espn-en-oly-summer-archery-index',
	    'oly-summer-athletics': 'espnuk-en-oly-summer-athletics-index',
	    'oly-summer-badminton': 'espn-en-oly-summer-badminton-index',
	    'oly-summer-basketball': 'espnuk-en-oly-summer-basketball-index',
	    'oly-summer-boxing': 'espnuk-en-oly-summer-boxing-index',
	    'oly-summer-canoe': 'espn-en-oly-summer-canoe-index',
	    'oly-summer-cycling': 'espn-en-oly-summer-cycling-index',
	    'oly-summer-equestrian': 'espn-en-oly-summer-equestrian-index',
	    'oly-summer-fencing': 'espn-en-oly-summer-fencing-index',
	    'oly-summer-field-hockey': 'espn-en-oly-summer-field-hockey-index',
	    'oly-summer-golf': 'espnuk-en-oly-summer-golf-index',
	    'oly-summer-gymnastics': 'espnuk-en-oly-summer-gymnastics-index',
	    'oly-summer-handball': 'espn-en-oly-summer-handball-index',
	    'oly-summer-judo': 'espn-en-oly-summer-judo-index',
	    'oly-summer-modern-pentathlon': 'espn-en-oly-summer-modern-pentathlon-index',
	    'oly-summer-rowing': 'espn-en-oly-summer-rowing-index',
	    'oly-summer-rugby': 'espnuk-en-oly-summer-rugby-index',
	    'oly-summer-sailing': 'espn-en-oly-summer-sailing-index',
	    'oly-summer-shooting': 'espn-en-oly-summer-shooting-index',
	    'oly-summer-soccer': 'espnuk-en-oly-summer-soccer-index',
	    'oly-summer-swimming': 'espnuk-en-oly-summer-swimming-index',
	    'oly-summer-table-tennis': 'espn-en-oly-summer-table-tennis-index',
	    'oly-summer-taekwondo': 'espn-en-oly-summer-taekwondo-index',
	    'oly-summer-tennis': 'espnuk-en-oly-summer-tennis-index',
	    'oly-summer-triathlon': 'espn-en-oly-summer-triathlon-index',
	    'oly-summer-volleyball': 'espnuk-en-oly-summer-volleyball-index',
	    'oly-summer-water-polo': 'espn-en-oly-summer-water-polo-index',
	    'oly-summer-weightlifting': 'espn-en-oly-summer-weightlifting-index',
	    'oly-summer-wrestling': 'espn-en-oly-summer-wrestling-index'
	  },
	  'editionAlert': {
	    'enabled': true,
	    'text': 'Welcome to Sony ESPN India Edition'
	  },
	  'feeds': {
	    'googlenews': {
	      'allowedContentTypes': ['Story', 'HeadlineNews']
	    }
	  },
	  'tier2NavIds': {
	    'boston': 12375278,
	    'chicago': 12505826,
	    'cleveland': 13977091,
	    'dallas': 12505828,
	    'los-angeles': 12505831,
	    'milwaukee': 13977360,
	    'new-york': 12505854,
	    'fantasy/basketball': 12405600,
	    'fantasy/football': 12405632,
	    'fantasy/baseball': 12405631,
	    'fantasy/hockey': 12405634,
	    'fantasy': 13609307,
	    'ncfrecruiting': 11588758,
	    'ncbrecruiting': 11588880,
	    'esports': 13663224,
	    'onenacion': 13309315,
	    'nba/stephen-curry': 14950765,
	    'league': {
	      'soccer': 13794648,
	      'ncf': 13886385,
	      'college-football': 13886385,
	      'cricket': 15609108
	    }
	  },
	  'tier3NavIds': {
	    'clubhouse': {
	      'nba': 12293424,
	      'mlb': 12343023,
	      'mens-college-basketball': 13884705,
	      'womens-college-basketball': 13930164,
	      'soccer': 12294454,
	      'nfl': 12509708,
	      'college-football': 13345157,
	      'cricket': 15368856
	    }
	  },
	  'indexAutoStart': false,
	  'useMongo': true,
	  'activeSite': true,
	  'countries': [{
	    'name': 'India',
	    'country-code': 'in',
	    'showHreflang': true
	  }, {
	    'name': 'Bangladesh',
	    'country-code': 'bd',
	    'showHreflang': false
	  }, {
	    'name': 'Bhutan',
	    'country-code': 'bt',
	    'showHreflang': false
	  }, {
	    'name': 'Maldives',
	    'country-code': 'mv',
	    'showHreflang': false
	  }, {
	    'name': 'Nepal',
	    'country-code': 'np',
	    'showHreflang': false
	  }, {
	    'name': 'Pakistan',
	    'country-code': 'pk',
	    'showHreflang': false
	  }, {
	    'name': 'Sri Lanka',
	    'country-code': 'lk',
	    'showHreflang': false
	  }]
	};

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge2 = __webpack_require__(581);
	
	var _merge3 = _interopRequireDefault(_merge2);
	
	var _taboola = __webpack_require__(667);
	
	var _taboola2 = _interopRequireDefault(_taboola);
	
	var _taboolaDefaults = __webpack_require__(668);
	
	var _taboolaDefaults2 = _interopRequireDefault(_taboolaDefaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  'editionSettings': {
	    'key': 'espncricinfo-en-ww',
	    'site': 'espncricinfo',
	    'language': 'en',
	    'country': 'ww',
	    'countryName': 'Global',
	    'domain': 'www.espncricinfo.com',
	    'editionSiteId': '1',
	    'https': true
	  },
	  'navId': '17951100',
	  'dictionarySection': 'espn',
	  'javaLocale': {
	    'language': 'en',
	    'region': 'US'
	  },
	  'dateTime': {
	    'long': 'dddd MMMM d, yyyy',
	    'medium': 'MMMM d, yyyy',
	    'short': 'M/d',
	    'timeFormat': 'h:mm',
	    'firstDayOfWeek': 'Sunday',
	    'timeZone': 'US/Eastern',
	    'defaultFormat': 'MMM d, yyyy',
	    'timeZoneString': 'ET',
	    'timeZoneBucket': 'America/New_York',
	    'MMM D, YYYY': 'D MMM, YYYY',
	    'M/D/YYYY': 'D/M/YYYY',
	    'MM/DD/YYYY': 'DD/MM/YYYY',
	    'MMDDYYYY': 'DDMMYYYY',
	    'MMMM Do YYYY': 'Do MMMM YYYY',
	    'dddd, MMMM Do YYYY': 'dddd, Do MMMM YYYY',
	    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
	    'M/D': 'D/M',
	    'MMMM D, YYYY': 'D MMMM YYYY',
	    'dddd, M/D': 'dddd, D/M',
	    'age': {
	      'seconds': 's',
	      'minutes': 'm',
	      'hours': 'h',
	      'days': 'd'
	    }
	  },
	  'numberFormat': {
	    'long': '#,###',
	    'short': '###',
	    'currency': '#,###.00',
	    'percent': '#.00%'
	  },
	  'temperature': {
	    'scale': 'celsius',
	    'symbol': '&deg; C'
	  },
	  'sponsoredContentProviders': ['taboola', 'outbrain'],
	  'taboola': (0, _merge3.default)({}, _taboolaDefaults2.default, _taboola2.default),
	  'outbrain': {
	    'enabled': true,
	    'template': 'ESPNIndia',
	    'desktop': {
	      'compliantId': 'AR_13',
	      'nonCompliantId': 'AR_16'
	    },
	    'mobile': {
	      'compliantId': 'MB_6',
	      'nonCompliantId': 'MB_9'
	    },
	    'scores': {
	      'desktop': {
	        'compliantId': 'AR_49'
	      },
	      'mobile': {
	        'compliantId': 'AR_49'
	      }
	    },
	    'game': {
	      'desktop': {
	        'compliantId': 'AR_48'
	      },
	      'mobile': {
	        'compliantId': 'MB_48'
	      }
	    },
	    'scorecard': {
	      'desktop': {
	        'compliantId': 'AR_49'
	      },
	      'mobile': {
	        'compliantId': 'AR_49'
	      }
	    },
	    'table': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'AR_43'
	      }
	    },
	    'report': {
	      'desktop': {
	        'compliantId': 'AR_30',
	        'nonCompliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'statistics': {
	      'desktop': {
	        'compliantId': 'AR_49',
	        'nonCompliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'schedule': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'AR_43'
	      }
	    }
	  },
	  'omniture': {
	    'enabled': true
	  },
	  'chartBeat': {
	    'enabled': true
	  },
	  'ads': {
	    'disabled': false,
	    'network': 1234,
	    'partnerAd': false,
	    'dev-config': 15039572,
	    'qa-config': 15039572,
	    'prod-config': 15039572
	  },
	  'partnerModules': {
	    'global': false,
	    'nba': false,
	    'womenbb': false,
	    'golf': false,
	    'endurance': false,
	    'horse': false,
	    'nascar': false
	  },
	  'sportBranding': [{
	    'sport': 'cricket',
	    'image': 'logo-uk-cricinfo',
	    'url': null
	  }, {
	    'sport': 'soccer',
	    'image': 'logo-uk-fc',
	    'url': null
	  }, {
	    'sport': 'rugby',
	    'image': 'logo-uk-scrum',
	    'url': null
	  }, {
	    'sport': 'ncaaw',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }, {
	    'sport': 'ncw',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }, {
	    'sport': 'wnba',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }, {
	    'sport': 'womenbb',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }],
	  'siteLogo': {
	    'class': 'sony-espn',
	    'featurePhone': {
	      'name': 'sonyespn-logo',
	      'width': 62,
	      'height': 34
	    }
	  },
	  'meta': {
	    'titleBranding': ' - ESPN',
	    'description': 'Visit ESPN to get up-to-the-minute sports news coverage, scores, highlights and commentary for cricket, rugby, football, F1, kabaddi and more.',
	    'defaultMetaImage': 'sonyespn_black.png',
	    'social': {
	      'twitter': {
	        'twitterId': '',
	        'card': 'summary',
	        'app_id_iphone': '317469184',
	        'site': 'ESPN',
	        'app_name_googleplay': 'ESPN',
	        'app_id_googleplay': 'com.espn.score_center',
	        'app_name_iphone': 'ESPN',
	        'language': 'en'
	      },
	      'facebook': {
	        'id': '116656161708917',
	        'og_site_name': 'ESPN',
	        'locale': 'en_US'
	      }
	    }
	  },
	  'shop': {
	    'enabled': false
	  },
	  'sportReplacements': {
	    'f1': 'f1',
	    'cycling': 'cycling'
	  },
	  'uriRewrites': {
	    'urls': {
	      'toEdition': {},
	      'toEnglish': {}
	    },
	    'roots': {
	      '/oly/summer/gymnastics/': '/oly/summer/gymnastics/',
	      '/oly/summer/cycling/': '/oly/summer/cycling/',
	      '/college-football/': '/ncf/',
	      '/football/': '/soccer/',
	      '/racing/nascar/': '/nascar/',
	      '/racing/': '/rpm/',
	      '/mens-college-basketball/': '/ncb/',
	      '/womens-college-basketball/': '/ncw/',
	      '/womens-basketball/': '/womenbb/',
	      '/olympics/': '/oly/',
	      '/cycling/': '/cycling/',
	      '/fixtures/': '/schedule',
	      '/figure-skating/': '/oly/',
	      '/college-sports/': '/ncaa/',
	      '/gymnastics/': '/oly/',
	      '/skiing/': '/oly/',
	      '/horse-racing/': '/horse/',
	      '/sports/womenbb/': '/womenbb/',
	      '/sports/horse/': '/horse/'
	    },
	    'pathSegments': {},
	    'paramKeys': {},
	    'paramValues': {}
	  },
	  'betting': {
	    'enabled': false,
	    'provider': 'Bet 365',
	    'game': {
	      'enabled': false,
	      'provider': 'Bet 365'
	    }
	  },
	  'ticketProvider': null,
	  'hasTickets': false,
	  'showFavorites': true,
	  'showInsider': false,
	  'showWatch': false,
	  'hideCategoryLinks': [600, 1700],
	  'categorySettings': {
	    'leagues': true,
	    'athletes': false,
	    'teams': false,
	    'tags': true
	  },
	  'showFCContent': true,
	  'showCricInfoContent': true,
	  'cookieConsent': false,
	  'scDeepLinking': true,
	  'allowShortUrl': false,
	  'allowPrintUrl': true,
	  'allowUserAccountManagement': true,
	  'nowFeed': false,
	  'searchUrl': 'http://search.espn.com/',
	  'hasSearch': true,
	  'gameSettings': {
	    'topEventsId': 18132049,
	    'promotedSoccerLeaguesCeId': 12032789,
	    'showBroadcast': false
	  },
	  'fallback': {
	    'rugby': 'espnuk-en-rugby-index',
	    'horse': 'espnuk-en-horse-index',
	    'nba': 'espn-en-nba-index',
	    'mlb': 'espn-en-mlb-index',
	    'nfl': 'espn-en-nfl-index',
	    'chalk': 'espn-en-chalk-index',
	    'nhl': 'espn-en-nhl-index',
	    'nascar': 'espn-en-nascar-index',
	    'womenbb': 'espn-en-womenbb-index',
	    'ncf': 'espn-en-ncf-index',
	    'ncb': 'espn-en-ncb-index',
	    'boxing': 'espn-en-boxing-index',
	    'mma': 'espn-en-mma-index',
	    'esports': 'espn-en-esports-index',
	    'nba-stephen-curry': 'espn-en-nba-stephen-curry-index',
	    'oly-summer-archery': 'espn-en-oly-summer-archery-index',
	    'oly-summer-athletics': 'espnuk-en-oly-summer-athletics-index',
	    'oly-summer-badminton': 'espn-en-oly-summer-badminton-index',
	    'oly-summer-basketball': 'espnuk-en-oly-summer-basketball-index',
	    'oly-summer-boxing': 'espnuk-en-oly-summer-boxing-index',
	    'oly-summer-canoe': 'espn-en-oly-summer-canoe-index',
	    'oly-summer-cycling': 'espn-en-oly-summer-cycling-index',
	    'oly-summer-equestrian': 'espn-en-oly-summer-equestrian-index',
	    'oly-summer-fencing': 'espn-en-oly-summer-fencing-index',
	    'oly-summer-field-hockey': 'espn-en-oly-summer-field-hockey-index',
	    'oly-summer-golf': 'espnuk-en-oly-summer-golf-index',
	    'oly-summer-gymnastics': 'espnuk-en-oly-summer-gymnastics-index',
	    'oly-summer-handball': 'espn-en-oly-summer-handball-index',
	    'oly-summer-judo': 'espn-en-oly-summer-judo-index',
	    'oly-summer-modern-pentathlon': 'espn-en-oly-summer-modern-pentathlon-index',
	    'oly-summer-rowing': 'espn-en-oly-summer-rowing-index',
	    'oly-summer-rugby': 'espnuk-en-oly-summer-rugby-index',
	    'oly-summer-sailing': 'espn-en-oly-summer-sailing-index',
	    'oly-summer-shooting': 'espn-en-oly-summer-shooting-index',
	    'oly-summer-soccer': 'espnuk-en-oly-summer-soccer-index',
	    'oly-summer-swimming': 'espnuk-en-oly-summer-swimming-index',
	    'oly-summer-table-tennis': 'espn-en-oly-summer-table-tennis-index',
	    'oly-summer-taekwondo': 'espn-en-oly-summer-taekwondo-index',
	    'oly-summer-tennis': 'espnuk-en-oly-summer-tennis-index',
	    'oly-summer-triathlon': 'espn-en-oly-summer-triathlon-index',
	    'oly-summer-volleyball': 'espnuk-en-oly-summer-volleyball-index',
	    'oly-summer-water-polo': 'espn-en-oly-summer-water-polo-index',
	    'oly-summer-weightlifting': 'espn-en-oly-summer-weightlifting-index',
	    'oly-summer-wrestling': 'espn-en-oly-summer-wrestling-index'
	  },
	  'editionAlert': {
	    'enabled': true,
	    'text': 'Welcome to Sony ESPN India Edition'
	  },
	  'feeds': {
	    'googlenews': {
	      'allowedContentTypes': ['Story', 'HeadlineNews']
	    }
	  },
	  'tier2NavIds': {
	    'boston': 12375278,
	    'chicago': 12505826,
	    'cleveland': 13977091,
	    'dallas': 12505828,
	    'los-angeles': 12505831,
	    'milwaukee': 13977360,
	    'new-york': 12505854,
	    'fantasy/basketball': 12405600,
	    'fantasy/football': 12405632,
	    'fantasy/baseball': 12405631,
	    'fantasy/hockey': 12405634,
	    'fantasy': 13609307,
	    'ncfrecruiting': 11588758,
	    'ncbrecruiting': 11588880,
	    'esports': 13663224,
	    'onenacion': 13309315,
	    'nba/stephen-curry': 14950765,
	    'league': {
	      'soccer': 13794648,
	      'ncf': 13886385,
	      'college-football': 13886385,
	      'cricket': 15609108
	    }
	  },
	  'tier3NavIds': {
	    'clubhouse': {
	      'nba': 12293424,
	      'mlb': 12343023,
	      'mens-college-basketball': 13884705,
	      'womens-college-basketball': 13930164,
	      'soccer': 12294454,
	      'nfl': 12509708,
	      'college-football': 13345157,
	      'cricket': 15368856
	    }
	  },
	  'indexAutoStart': false,
	  'useMongo': true,
	  'activeSite': true,
	  'countries': [{
	    'name': 'India',
	    'country-code': 'in',
	    'showHreflang': true
	  }, {
	    'name': 'Bangladesh',
	    'country-code': 'bd',
	    'showHreflang': false
	  }, {
	    'name': 'Bhutan',
	    'country-code': 'bt',
	    'showHreflang': false
	  }, {
	    'name': 'Maldives',
	    'country-code': 'mv',
	    'showHreflang': false
	  }, {
	    'name': 'Nepal',
	    'country-code': 'np',
	    'showHreflang': false
	  }, {
	    'name': 'Pakistan',
	    'country-code': 'pk',
	    'showHreflang': false
	  }, {
	    'name': 'Sri Lanka',
	    'country-code': 'lk',
	    'showHreflang': false
	  }]
	};

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge2 = __webpack_require__(581);
	
	var _merge3 = _interopRequireDefault(_merge2);
	
	var _taboola = __webpack_require__(667);
	
	var _taboola2 = _interopRequireDefault(_taboola);
	
	var _taboolaDefaults = __webpack_require__(668);
	
	var _taboolaDefaults2 = _interopRequireDefault(_taboolaDefaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  'editionSettings': {
	    'key': 'espncricinfo-en-in',
	    'site': 'espncricinfo',
	    'language': 'en',
	    'country': 'in',
	    'countryName': 'india',
	    'domain': 'www.espncricinfo.com',
	    'editionSiteId': '1',
	    'https': true
	  },
	  'navId': '18441974',
	  'dictionarySection': 'espn',
	  'javaLocale': {
	    'language': 'en',
	    'region': 'IN'
	  },
	  'dateTime': {
	    'long': 'dddd MMMM d, yyyy',
	    'medium': 'MMMM d, yyyy',
	    'short': 'M/d',
	    'timeFormat': 'h:mm',
	    'firstDayOfWeek': 'Sunday',
	    'timeZone': 'Asia/Calcutta',
	    'defaultFormat': 'd MMM, yyyy',
	    'timeZoneString': 'IST',
	    'timeZoneBucket': 'Asia/Kolkata',
	    'timeZoneDstOffset': 150,
	    'MMM D, YYYY': 'D MMM, YYYY',
	    'M/D/YYYY': 'D/M/YYYY',
	    'MM/DD/YYYY': 'DD/MM/YYYY',
	    'MMDDYYYY': 'DDMMYYYY',
	    'MMMM Do YYYY': 'Do MMMM YYYY',
	    'dddd, MMMM Do YYYY': 'dddd, Do MMMM YYYY',
	    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
	    'M/D': 'D/M',
	    'MMMM D, YYYY': 'D MMMM YYYY',
	    'dddd, M/D': 'dddd, D/M',
	    'age': {
	      'seconds': 's',
	      'minutes': 'm',
	      'hours': 'h',
	      'days': 'd'
	    }
	  },
	  'numberFormat': {
	    'long': '#,###',
	    'short': '###',
	    'currency': '#,###.00',
	    'percent': '#.00%'
	  },
	  'temperature': {
	    'scale': 'celsius',
	    'symbol': '&deg; C'
	  },
	  'sponsoredContentProviders': ['taboola', 'outbrain'],
	  'taboola': (0, _merge3.default)({}, _taboolaDefaults2.default, _taboola2.default),
	  'outbrain': {
	    'enabled': true,
	    'template': 'ESPNIndia',
	    'desktop': {
	      'compliantId': 'AR_13',
	      'nonCompliantId': 'AR_16'
	    },
	    'mobile': {
	      'compliantId': 'MB_6',
	      'nonCompliantId': 'MB_9'
	    },
	    'scores': {
	      'desktop': {
	        'compliantId': 'AR_49'
	      },
	      'mobile': {
	        'compliantId': 'AR_49'
	      }
	    },
	    'game': {
	      'desktop': {
	        'compliantId': 'AR_48'
	      },
	      'mobile': {
	        'compliantId': 'MB_48'
	      }
	    },
	    'scorecard': {
	      'desktop': {
	        'compliantId': 'AR_49'
	      },
	      'mobile': {
	        'compliantId': 'AR_49'
	      }
	    },
	    'table': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'AR_43'
	      }
	    },
	    'report': {
	      'desktop': {
	        'compliantId': 'AR_30',
	        'nonCompliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'statistics': {
	      'desktop': {
	        'compliantId': 'AR_49',
	        'nonCompliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'schedule': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'AR_43'
	      }
	    }
	  },
	  'omniture': {
	    'enabled': true
	  },
	  'chartBeat': {
	    'enabled': true
	  },
	  'ads': {
	    'disabled': false,
	    'network': 1234,
	    'partnerAd': false,
	    'dev-config': 15039572,
	    'qa-config': 15039572,
	    'prod-config': 15039572
	  },
	  'partnerModules': {
	    'global': false,
	    'nba': false,
	    'womenbb': false,
	    'golf': false,
	    'endurance': false,
	    'horse': false,
	    'nascar': false
	  },
	  'sportBranding': [{
	    'sport': 'cricket',
	    'image': 'logo-uk-cricinfo',
	    'url': null
	  }, {
	    'sport': 'soccer',
	    'image': 'logo-uk-fc',
	    'url': null
	  }, {
	    'sport': 'rugby',
	    'image': 'logo-uk-scrum',
	    'url': null
	  }, {
	    'sport': 'ncaaw',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }, {
	    'sport': 'ncw',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }, {
	    'sport': 'wnba',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }, {
	    'sport': 'womenbb',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }],
	  'siteLogo': {
	    'class': 'sony-espn',
	    'featurePhone': {
	      'name': 'sonyespn-logo',
	      'width': 62,
	      'height': 34
	    }
	  },
	  'meta': {
	    'titleBranding': ' - ESPN',
	    'description': 'Visit ESPN to get up-to-the-minute sports news coverage, scores, highlights and commentary for cricket, rugby, football, F1, kabaddi and more.',
	    'defaultMetaImage': 'sonyespn_black.png',
	    'social': {
	      'twitter': {
	        'twitterId': '',
	        'card': 'summary',
	        'app_id_iphone': '317469184',
	        'site': 'ESPN',
	        'app_name_googleplay': 'ESPN',
	        'app_id_googleplay': 'com.espn.score_center',
	        'app_name_iphone': 'ESPN',
	        'language': 'en'
	      },
	      'facebook': {
	        'id': '116656161708917',
	        'og_site_name': 'ESPN',
	        'locale': 'en_US'
	      }
	    }
	  },
	  'shop': {
	    'enabled': false
	  },
	  'sportReplacements': {
	    'f1': 'f1',
	    'cycling': 'cycling'
	  },
	  'uriRewrites': {
	    'urls': {
	      'toEdition': {},
	      'toEnglish': {}
	    },
	    'roots': {
	      '/oly/summer/gymnastics/': '/oly/summer/gymnastics/',
	      '/oly/summer/cycling/': '/oly/summer/cycling/',
	      '/college-football/': '/ncf/',
	      '/football/': '/soccer/',
	      '/racing/nascar/': '/nascar/',
	      '/racing/': '/rpm/',
	      '/mens-college-basketball/': '/ncb/',
	      '/womens-college-basketball/': '/ncw/',
	      '/womens-basketball/': '/womenbb/',
	      '/olympics/': '/oly/',
	      '/cycling/': '/cycling/',
	      '/fixtures/': '/schedule',
	      '/figure-skating/': '/oly/',
	      '/college-sports/': '/ncaa/',
	      '/gymnastics/': '/oly/',
	      '/skiing/': '/oly/',
	      '/horse-racing/': '/horse/',
	      '/sports/womenbb/': '/womenbb/',
	      '/sports/horse/': '/horse/'
	    },
	    'pathSegments': {},
	    'paramKeys': {},
	    'paramValues': {}
	  },
	  'betting': {
	    'enabled': false,
	    'provider': 'Bet 365',
	    'game': {
	      'enabled': false,
	      'provider': 'Bet 365'
	    }
	  },
	  'ticketProvider': null,
	  'hasTickets': false,
	  'showFavorites': true,
	  'showInsider': false,
	  'showWatch': false,
	  'hideCategoryLinks': [600, 1700],
	  'categorySettings': {
	    'leagues': true,
	    'athletes': false,
	    'teams': false,
	    'tags': true
	  },
	  'showFCContent': true,
	  'showCricInfoContent': true,
	  'cookieConsent': false,
	  'scDeepLinking': true,
	  'allowShortUrl': false,
	  'allowPrintUrl': true,
	  'allowUserAccountManagement': true,
	  'nowFeed': false,
	  'searchUrl': 'http://search.espn.com/',
	  'hasSearch': true,
	  'gameSettings': {
	    'topEventsId': 19408131,
	    'promotedSoccerLeaguesCeId': 12032789,
	    'showBroadcast': false
	  },
	  'fallback': {
	    'rugby': 'espnuk-en-rugby-index',
	    'horse': 'espnuk-en-horse-index',
	    'nba': 'espn-en-nba-index',
	    'mlb': 'espn-en-mlb-index',
	    'nfl': 'espn-en-nfl-index',
	    'chalk': 'espn-en-chalk-index',
	    'nhl': 'espn-en-nhl-index',
	    'nascar': 'espn-en-nascar-index',
	    'womenbb': 'espn-en-womenbb-index',
	    'ncf': 'espn-en-ncf-index',
	    'ncb': 'espn-en-ncb-index',
	    'boxing': 'espn-en-boxing-index',
	    'mma': 'espn-en-mma-index',
	    'esports': 'espn-en-esports-index',
	    'nba-stephen-curry': 'espn-en-nba-stephen-curry-index',
	    'oly-summer-archery': 'espn-en-oly-summer-archery-index',
	    'oly-summer-athletics': 'espnuk-en-oly-summer-athletics-index',
	    'oly-summer-badminton': 'espn-en-oly-summer-badminton-index',
	    'oly-summer-basketball': 'espnuk-en-oly-summer-basketball-index',
	    'oly-summer-boxing': 'espnuk-en-oly-summer-boxing-index',
	    'oly-summer-canoe': 'espn-en-oly-summer-canoe-index',
	    'oly-summer-cycling': 'espn-en-oly-summer-cycling-index',
	    'oly-summer-equestrian': 'espn-en-oly-summer-equestrian-index',
	    'oly-summer-fencing': 'espn-en-oly-summer-fencing-index',
	    'oly-summer-field-hockey': 'espn-en-oly-summer-field-hockey-index',
	    'oly-summer-golf': 'espnuk-en-oly-summer-golf-index',
	    'oly-summer-gymnastics': 'espnuk-en-oly-summer-gymnastics-index',
	    'oly-summer-handball': 'espn-en-oly-summer-handball-index',
	    'oly-summer-judo': 'espn-en-oly-summer-judo-index',
	    'oly-summer-modern-pentathlon': 'espn-en-oly-summer-modern-pentathlon-index',
	    'oly-summer-rowing': 'espn-en-oly-summer-rowing-index',
	    'oly-summer-rugby': 'espnuk-en-oly-summer-rugby-index',
	    'oly-summer-sailing': 'espn-en-oly-summer-sailing-index',
	    'oly-summer-shooting': 'espn-en-oly-summer-shooting-index',
	    'oly-summer-soccer': 'espnuk-en-oly-summer-soccer-index',
	    'oly-summer-swimming': 'espnuk-en-oly-summer-swimming-index',
	    'oly-summer-table-tennis': 'espn-en-oly-summer-table-tennis-index',
	    'oly-summer-taekwondo': 'espn-en-oly-summer-taekwondo-index',
	    'oly-summer-tennis': 'espnuk-en-oly-summer-tennis-index',
	    'oly-summer-triathlon': 'espn-en-oly-summer-triathlon-index',
	    'oly-summer-volleyball': 'espnuk-en-oly-summer-volleyball-index',
	    'oly-summer-water-polo': 'espn-en-oly-summer-water-polo-index',
	    'oly-summer-weightlifting': 'espn-en-oly-summer-weightlifting-index',
	    'oly-summer-wrestling': 'espn-en-oly-summer-wrestling-index'
	  },
	  'editionAlert': {
	    'enabled': true,
	    'text': 'Welcome to Sony ESPN India Edition'
	  },
	  'feeds': {
	    'googlenews': {
	      'allowedContentTypes': ['Story', 'HeadlineNews']
	    }
	  },
	  'tier2NavIds': {
	    'boston': 12375278,
	    'chicago': 12505826,
	    'cleveland': 13977091,
	    'dallas': 12505828,
	    'los-angeles': 12505831,
	    'milwaukee': 13977360,
	    'new-york': 12505854,
	    'fantasy/basketball': 12405600,
	    'fantasy/football': 12405632,
	    'fantasy/baseball': 12405631,
	    'fantasy/hockey': 12405634,
	    'fantasy': 13609307,
	    'ncfrecruiting': 11588758,
	    'ncbrecruiting': 11588880,
	    'esports': 13663224,
	    'onenacion': 13309315,
	    'nba/stephen-curry': 14950765,
	    'league': {
	      'soccer': 13794648,
	      'ncf': 13886385,
	      'college-football': 13886385,
	      'cricket': 15609108
	    }
	  },
	  'tier3NavIds': {
	    'clubhouse': {
	      'nba': 12293424,
	      'mlb': 12343023,
	      'mens-college-basketball': 13884705,
	      'womens-college-basketball': 13930164,
	      'soccer': 12294454,
	      'nfl': 12509708,
	      'college-football': 13345157,
	      'cricket': 15368856
	    }
	  },
	  'indexAutoStart': false,
	  'useMongo': true,
	  'activeSite': true,
	  'countries': [{
	    'name': 'India',
	    'country-code': 'in',
	    'showHreflang': true
	  }, {
	    'name': 'Bangladesh',
	    'country-code': 'bd',
	    'showHreflang': false
	  }, {
	    'name': 'Bhutan',
	    'country-code': 'bt',
	    'showHreflang': false
	  }, {
	    'name': 'Maldives',
	    'country-code': 'mv',
	    'showHreflang': false
	  }, {
	    'name': 'Nepal',
	    'country-code': 'np',
	    'showHreflang': false
	  }, {
	    'name': 'Pakistan',
	    'country-code': 'pk',
	    'showHreflang': false
	  }, {
	    'name': 'Sri Lanka',
	    'country-code': 'lk',
	    'showHreflang': false
	  }]
	};

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge2 = __webpack_require__(581);
	
	var _merge3 = _interopRequireDefault(_merge2);
	
	var _taboola = __webpack_require__(667);
	
	var _taboola2 = _interopRequireDefault(_taboola);
	
	var _taboolaDefaults = __webpack_require__(668);
	
	var _taboolaDefaults2 = _interopRequireDefault(_taboolaDefaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  'editionSettings': {
	    'key': 'espncricinfo-en-nz',
	    'site': 'espncricinfo',
	    'language': 'en',
	    'country': 'nz',
	    'countryName': 'newzealand',
	    'domain': 'www.espncricinfo.com',
	    'editionSiteId': '1',
	    'https': true
	  },
	  'navId': '18442642',
	  'dictionarySection': 'espn',
	  'javaLocale': {
	    'language': 'en',
	    'region': 'NZ'
	  },
	  'dateTime': {
	    'long': 'dddd MMMM d, yyyy',
	    'medium': 'MMMM d, yyyy',
	    'short': 'M/d',
	    'timeFormat': 'h:mm',
	    'firstDayOfWeek': 'Sunday',
	    'timeZone': 'Etc/GMT',
	    'defaultFormat': 'd MMM, yyyy',
	    'timeZoneString': 'GMT',
	    'timeZoneBucket': 'Australia/Melbourne',
	    'MMM D, YYYY': 'D MMM, YYYY',
	    'M/D/YYYY': 'D/M/YYYY',
	    'MM/DD/YYYY': 'DD/MM/YYYY',
	    'MMDDYYYY': 'DDMMYYYY',
	    'MMMM Do YYYY': 'Do MMMM YYYY',
	    'dddd, MMMM Do YYYY': 'dddd, Do MMMM YYYY',
	    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
	    'M/D': 'D/M',
	    'MMMM D, YYYY': 'D MMMM YYYY',
	    'dddd, M/D': 'dddd, D/M',
	    'age': {
	      'seconds': 's',
	      'minutes': 'm',
	      'hours': 'h',
	      'days': 'd'
	    }
	  },
	  'numberFormat': {
	    'long': '#,###',
	    'short': '###',
	    'currency': '#,###.00',
	    'percent': '#.00%'
	  },
	  'temperature': {
	    'scale': 'celsius',
	    'symbol': '&deg; C'
	  },
	  'sponsoredContentProviders': ['taboola', 'outbrain'],
	  'taboola': (0, _merge3.default)({}, _taboolaDefaults2.default, _taboola2.default),
	  'outbrain': {
	    'enabled': true,
	    'template': 'ESPNIndia',
	    'desktop': {
	      'compliantId': 'AR_13',
	      'nonCompliantId': 'AR_16'
	    },
	    'mobile': {
	      'compliantId': 'MB_6',
	      'nonCompliantId': 'MB_9'
	    },
	    'scores': {
	      'desktop': {
	        'compliantId': 'AR_49'
	      },
	      'mobile': {
	        'compliantId': 'AR_49'
	      }
	    },
	    'game': {
	      'desktop': {
	        'compliantId': 'AR_48'
	      },
	      'mobile': {
	        'compliantId': 'MB_48'
	      }
	    },
	    'scorecard': {
	      'desktop': {
	        'compliantId': 'AR_49'
	      },
	      'mobile': {
	        'compliantId': 'AR_49'
	      }
	    },
	    'table': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'AR_43'
	      }
	    },
	    'report': {
	      'desktop': {
	        'compliantId': 'AR_30',
	        'nonCompliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'statistics': {
	      'desktop': {
	        'compliantId': 'AR_49',
	        'nonCompliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'schedule': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'AR_43'
	      }
	    }
	  },
	  'omniture': {
	    'enabled': true
	  },
	  'chartBeat': {
	    'enabled': true
	  },
	  'ads': {
	    'disabled': false,
	    'network': 1234,
	    'partnerAd': false,
	    'dev-config': 15039572,
	    'qa-config': 15039572,
	    'prod-config': 15039572
	  },
	  'partnerModules': {
	    'global': false,
	    'nba': false,
	    'womenbb': false,
	    'golf': false,
	    'endurance': false,
	    'horse': false,
	    'nascar': false
	  },
	  'sportBranding': [{
	    'sport': 'cricket',
	    'image': 'logo-uk-cricinfo',
	    'url': null
	  }, {
	    'sport': 'soccer',
	    'image': 'logo-uk-fc',
	    'url': null
	  }, {
	    'sport': 'rugby',
	    'image': 'logo-uk-scrum',
	    'url': null
	  }, {
	    'sport': 'ncaaw',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }, {
	    'sport': 'ncw',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }, {
	    'sport': 'wnba',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }, {
	    'sport': 'womenbb',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }],
	  'siteLogo': {
	    'class': 'sony-espn',
	    'featurePhone': {
	      'name': 'sonyespn-logo',
	      'width': 62,
	      'height': 34
	    }
	  },
	  'meta': {
	    'titleBranding': ' - ESPN',
	    'description': 'Visit ESPN to get up-to-the-minute sports news coverage, scores, highlights and commentary for cricket, rugby, football, F1, kabaddi and more.',
	    'defaultMetaImage': 'sonyespn_black.png',
	    'social': {
	      'twitter': {
	        'twitterId': '',
	        'card': 'summary',
	        'app_id_iphone': '317469184',
	        'site': 'ESPN',
	        'app_name_googleplay': 'ESPN',
	        'app_id_googleplay': 'com.espn.score_center',
	        'app_name_iphone': 'ESPN',
	        'language': 'en'
	      },
	      'facebook': {
	        'id': '116656161708917',
	        'og_site_name': 'ESPN',
	        'locale': 'en_US'
	      }
	    }
	  },
	  'shop': {
	    'enabled': false
	  },
	  'sportReplacements': {
	    'f1': 'f1',
	    'cycling': 'cycling'
	  },
	  'uriRewrites': {
	    'urls': {
	      'toEdition': {},
	      'toEnglish': {}
	    },
	    'roots': {
	      '/oly/summer/gymnastics/': '/oly/summer/gymnastics/',
	      '/oly/summer/cycling/': '/oly/summer/cycling/',
	      '/college-football/': '/ncf/',
	      '/football/': '/soccer/',
	      '/racing/nascar/': '/nascar/',
	      '/racing/': '/rpm/',
	      '/mens-college-basketball/': '/ncb/',
	      '/womens-college-basketball/': '/ncw/',
	      '/womens-basketball/': '/womenbb/',
	      '/olympics/': '/oly/',
	      '/cycling/': '/cycling/',
	      '/fixtures/': '/schedule',
	      '/figure-skating/': '/oly/',
	      '/college-sports/': '/ncaa/',
	      '/gymnastics/': '/oly/',
	      '/skiing/': '/oly/',
	      '/horse-racing/': '/horse/',
	      '/sports/womenbb/': '/womenbb/',
	      '/sports/horse/': '/horse/'
	    },
	    'pathSegments': {},
	    'paramKeys': {},
	    'paramValues': {}
	  },
	  'betting': {
	    'enabled': false,
	    'provider': 'Bet 365',
	    'game': {
	      'enabled': false,
	      'provider': 'Bet 365'
	    }
	  },
	  'ticketProvider': null,
	  'hasTickets': false,
	  'showFavorites': true,
	  'showInsider': false,
	  'showWatch': false,
	  'hideCategoryLinks': [600, 1700],
	  'categorySettings': {
	    'leagues': true,
	    'athletes': false,
	    'teams': false,
	    'tags': true
	  },
	  'showFCContent': true,
	  'showCricInfoContent': true,
	  'cookieConsent': false,
	  'scDeepLinking': true,
	  'allowShortUrl': false,
	  'allowPrintUrl': true,
	  'allowUserAccountManagement': true,
	  'nowFeed': false,
	  'searchUrl': 'http://search.espn.com/',
	  'hasSearch': true,
	  'gameSettings': {
	    'topEventsId': 19408132,
	    'promotedSoccerLeaguesCeId': 12032789,
	    'showBroadcast': false
	  },
	  'fallback': {
	    'rugby': 'espnuk-en-rugby-index',
	    'horse': 'espnuk-en-horse-index',
	    'nba': 'espn-en-nba-index',
	    'mlb': 'espn-en-mlb-index',
	    'nfl': 'espn-en-nfl-index',
	    'chalk': 'espn-en-chalk-index',
	    'nhl': 'espn-en-nhl-index',
	    'nascar': 'espn-en-nascar-index',
	    'womenbb': 'espn-en-womenbb-index',
	    'ncf': 'espn-en-ncf-index',
	    'ncb': 'espn-en-ncb-index',
	    'boxing': 'espn-en-boxing-index',
	    'mma': 'espn-en-mma-index',
	    'esports': 'espn-en-esports-index',
	    'nba-stephen-curry': 'espn-en-nba-stephen-curry-index',
	    'oly-summer-archery': 'espn-en-oly-summer-archery-index',
	    'oly-summer-athletics': 'espnuk-en-oly-summer-athletics-index',
	    'oly-summer-badminton': 'espn-en-oly-summer-badminton-index',
	    'oly-summer-basketball': 'espnuk-en-oly-summer-basketball-index',
	    'oly-summer-boxing': 'espnuk-en-oly-summer-boxing-index',
	    'oly-summer-canoe': 'espn-en-oly-summer-canoe-index',
	    'oly-summer-cycling': 'espn-en-oly-summer-cycling-index',
	    'oly-summer-equestrian': 'espn-en-oly-summer-equestrian-index',
	    'oly-summer-fencing': 'espn-en-oly-summer-fencing-index',
	    'oly-summer-field-hockey': 'espn-en-oly-summer-field-hockey-index',
	    'oly-summer-golf': 'espnuk-en-oly-summer-golf-index',
	    'oly-summer-gymnastics': 'espnuk-en-oly-summer-gymnastics-index',
	    'oly-summer-handball': 'espn-en-oly-summer-handball-index',
	    'oly-summer-judo': 'espn-en-oly-summer-judo-index',
	    'oly-summer-modern-pentathlon': 'espn-en-oly-summer-modern-pentathlon-index',
	    'oly-summer-rowing': 'espn-en-oly-summer-rowing-index',
	    'oly-summer-rugby': 'espnuk-en-oly-summer-rugby-index',
	    'oly-summer-sailing': 'espn-en-oly-summer-sailing-index',
	    'oly-summer-shooting': 'espn-en-oly-summer-shooting-index',
	    'oly-summer-soccer': 'espnuk-en-oly-summer-soccer-index',
	    'oly-summer-swimming': 'espnuk-en-oly-summer-swimming-index',
	    'oly-summer-table-tennis': 'espn-en-oly-summer-table-tennis-index',
	    'oly-summer-taekwondo': 'espn-en-oly-summer-taekwondo-index',
	    'oly-summer-tennis': 'espnuk-en-oly-summer-tennis-index',
	    'oly-summer-triathlon': 'espn-en-oly-summer-triathlon-index',
	    'oly-summer-volleyball': 'espnuk-en-oly-summer-volleyball-index',
	    'oly-summer-water-polo': 'espn-en-oly-summer-water-polo-index',
	    'oly-summer-weightlifting': 'espn-en-oly-summer-weightlifting-index',
	    'oly-summer-wrestling': 'espn-en-oly-summer-wrestling-index'
	  },
	  'editionAlert': {
	    'enabled': true,
	    'text': 'Welcome to Sony ESPN India Edition'
	  },
	  'feeds': {
	    'googlenews': {
	      'allowedContentTypes': ['Story', 'HeadlineNews']
	    }
	  },
	  'tier2NavIds': {
	    'boston': 12375278,
	    'chicago': 12505826,
	    'cleveland': 13977091,
	    'dallas': 12505828,
	    'los-angeles': 12505831,
	    'milwaukee': 13977360,
	    'new-york': 12505854,
	    'fantasy/basketball': 12405600,
	    'fantasy/football': 12405632,
	    'fantasy/baseball': 12405631,
	    'fantasy/hockey': 12405634,
	    'fantasy': 13609307,
	    'ncfrecruiting': 11588758,
	    'ncbrecruiting': 11588880,
	    'esports': 13663224,
	    'onenacion': 13309315,
	    'nba/stephen-curry': 14950765,
	    'league': {
	      'soccer': 13794648,
	      'ncf': 13886385,
	      'college-football': 13886385,
	      'cricket': 15609108
	    }
	  },
	  'tier3NavIds': {
	    'clubhouse': {
	      'nba': 12293424,
	      'mlb': 12343023,
	      'mens-college-basketball': 13884705,
	      'womens-college-basketball': 13930164,
	      'soccer': 12294454,
	      'nfl': 12509708,
	      'college-football': 13345157,
	      'cricket': 15368856
	    }
	  },
	  'indexAutoStart': false,
	  'useMongo': true,
	  'activeSite': true,
	  'countries': [{
	    'name': 'India',
	    'country-code': 'in',
	    'showHreflang': true
	  }, {
	    'name': 'Bangladesh',
	    'country-code': 'bd',
	    'showHreflang': false
	  }, {
	    'name': 'Bhutan',
	    'country-code': 'bt',
	    'showHreflang': false
	  }, {
	    'name': 'Maldives',
	    'country-code': 'mv',
	    'showHreflang': false
	  }, {
	    'name': 'Nepal',
	    'country-code': 'np',
	    'showHreflang': false
	  }, {
	    'name': 'Pakistan',
	    'country-code': 'pk',
	    'showHreflang': false
	  }, {
	    'name': 'Sri Lanka',
	    'country-code': 'lk',
	    'showHreflang': false
	  }]
	};

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge2 = __webpack_require__(581);
	
	var _merge3 = _interopRequireDefault(_merge2);
	
	var _taboola = __webpack_require__(667);
	
	var _taboola2 = _interopRequireDefault(_taboola);
	
	var _taboolaDefaults = __webpack_require__(668);
	
	var _taboolaDefaults2 = _interopRequireDefault(_taboolaDefaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  'editionSettings': {
	    'key': 'espncricinfo-en-pk',
	    'site': 'espncricinfo',
	    'language': 'en',
	    'country': 'pk',
	    'countryName': 'pakistan',
	    'domain': 'www.espncricinfo.com',
	    'editionSiteId': '1',
	    'https': true
	  },
	  'navId': '18442689',
	  'dictionarySection': 'espn',
	  'javaLocale': {
	    'language': 'en',
	    'region': 'PK'
	  },
	  'dateTime': {
	    'long': 'dddd MMMM d, yyyy',
	    'medium': 'MMMM d, yyyy',
	    'short': 'M/d',
	    'timeFormat': 'h:mm',
	    'firstDayOfWeek': 'Sunday',
	    'timeZone': 'Asia/Calcutta',
	    'defaultFormat': 'd MMM, yyyy',
	    'timeZoneString': 'IST',
	    'timeZoneBucket': 'Asia/Kolkata',
	    'MMM D, YYYY': 'D MMM, YYYY',
	    'M/D/YYYY': 'D/M/YYYY',
	    'MM/DD/YYYY': 'DD/MM/YYYY',
	    'MMDDYYYY': 'DDMMYYYY',
	    'MMMM Do YYYY': 'Do MMMM YYYY',
	    'dddd, MMMM Do YYYY': 'dddd, Do MMMM YYYY',
	    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
	    'M/D': 'D/M',
	    'MMMM D, YYYY': 'D MMMM YYYY',
	    'dddd, M/D': 'dddd, D/M',
	    'age': {
	      'seconds': 's',
	      'minutes': 'm',
	      'hours': 'h',
	      'days': 'd'
	    }
	  },
	  'numberFormat': {
	    'long': '#,###',
	    'short': '###',
	    'currency': '#,###.00',
	    'percent': '#.00%'
	  },
	  'temperature': {
	    'scale': 'celsius',
	    'symbol': '&deg; C'
	  },
	  'sponsoredContentProviders': ['taboola', 'outbrain'],
	  'taboola': (0, _merge3.default)({}, _taboolaDefaults2.default, _taboola2.default),
	  'outbrain': {
	    'enabled': true,
	    'template': 'ESPNIndia',
	    'desktop': {
	      'compliantId': 'AR_13',
	      'nonCompliantId': 'AR_16'
	    },
	    'mobile': {
	      'compliantId': 'MB_6',
	      'nonCompliantId': 'MB_9'
	    },
	    'scores': {
	      'desktop': {
	        'compliantId': 'AR_49'
	      },
	      'mobile': {
	        'compliantId': 'AR_49'
	      }
	    },
	    'game': {
	      'desktop': {
	        'compliantId': 'AR_48'
	      },
	      'mobile': {
	        'compliantId': 'MB_48'
	      }
	    },
	    'scorecard': {
	      'desktop': {
	        'compliantId': 'AR_49'
	      },
	      'mobile': {
	        'compliantId': 'AR_49'
	      }
	    },
	    'table': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'AR_43'
	      }
	    },
	    'report': {
	      'desktop': {
	        'compliantId': 'AR_30',
	        'nonCompliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'statistics': {
	      'desktop': {
	        'compliantId': 'AR_49',
	        'nonCompliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'schedule': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'AR_43'
	      }
	    }
	  },
	  'omniture': {
	    'enabled': true
	  },
	  'chartBeat': {
	    'enabled': true
	  },
	  'ads': {
	    'disabled': false,
	    'network': 1234,
	    'partnerAd': false,
	    'dev-config': 15039572,
	    'qa-config': 15039572,
	    'prod-config': 15039572
	  },
	  'partnerModules': {
	    'global': false,
	    'nba': false,
	    'womenbb': false,
	    'golf': false,
	    'endurance': false,
	    'horse': false,
	    'nascar': false
	  },
	  'sportBranding': [{
	    'sport': 'cricket',
	    'image': 'logo-uk-cricinfo',
	    'url': null
	  }, {
	    'sport': 'soccer',
	    'image': 'logo-uk-fc',
	    'url': null
	  }, {
	    'sport': 'rugby',
	    'image': 'logo-uk-scrum',
	    'url': null
	  }, {
	    'sport': 'ncaaw',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }, {
	    'sport': 'ncw',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }, {
	    'sport': 'wnba',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }, {
	    'sport': 'womenbb',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }],
	  'siteLogo': {
	    'class': 'sony-espn',
	    'featurePhone': {
	      'name': 'sonyespn-logo',
	      'width': 62,
	      'height': 34
	    }
	  },
	  'meta': {
	    'titleBranding': ' - ESPN',
	    'description': 'Visit ESPN to get up-to-the-minute sports news coverage, scores, highlights and commentary for cricket, rugby, football, F1, kabaddi and more.',
	    'defaultMetaImage': 'sonyespn_black.png',
	    'social': {
	      'twitter': {
	        'twitterId': '',
	        'card': 'summary',
	        'app_id_iphone': '317469184',
	        'site': 'ESPN',
	        'app_name_googleplay': 'ESPN',
	        'app_id_googleplay': 'com.espn.score_center',
	        'app_name_iphone': 'ESPN',
	        'language': 'en'
	      },
	      'facebook': {
	        'id': '116656161708917',
	        'og_site_name': 'ESPN',
	        'locale': 'en_US'
	      }
	    }
	  },
	  'shop': {
	    'enabled': false
	  },
	  'sportReplacements': {
	    'f1': 'f1',
	    'cycling': 'cycling'
	  },
	  'uriRewrites': {
	    'urls': {
	      'toEdition': {},
	      'toEnglish': {}
	    },
	    'roots': {
	      '/oly/summer/gymnastics/': '/oly/summer/gymnastics/',
	      '/oly/summer/cycling/': '/oly/summer/cycling/',
	      '/college-football/': '/ncf/',
	      '/football/': '/soccer/',
	      '/racing/nascar/': '/nascar/',
	      '/racing/': '/rpm/',
	      '/mens-college-basketball/': '/ncb/',
	      '/womens-college-basketball/': '/ncw/',
	      '/womens-basketball/': '/womenbb/',
	      '/olympics/': '/oly/',
	      '/cycling/': '/cycling/',
	      '/fixtures/': '/schedule',
	      '/figure-skating/': '/oly/',
	      '/college-sports/': '/ncaa/',
	      '/gymnastics/': '/oly/',
	      '/skiing/': '/oly/',
	      '/horse-racing/': '/horse/',
	      '/sports/womenbb/': '/womenbb/',
	      '/sports/horse/': '/horse/'
	    },
	    'pathSegments': {},
	    'paramKeys': {},
	    'paramValues': {}
	  },
	  'betting': {
	    'enabled': false,
	    'provider': 'Bet 365',
	    'game': {
	      'enabled': false,
	      'provider': 'Bet 365'
	    }
	  },
	  'ticketProvider': null,
	  'hasTickets': false,
	  'showFavorites': true,
	  'showInsider': false,
	  'showWatch': false,
	  'hideCategoryLinks': [600, 1700],
	  'categorySettings': {
	    'leagues': true,
	    'athletes': false,
	    'teams': false,
	    'tags': true
	  },
	  'showFCContent': true,
	  'showCricInfoContent': true,
	  'cookieConsent': false,
	  'scDeepLinking': true,
	  'allowShortUrl': false,
	  'allowPrintUrl': true,
	  'allowUserAccountManagement': true,
	  'nowFeed': false,
	  'searchUrl': 'http://search.espn.com/',
	  'hasSearch': true,
	  'gameSettings': {
	    'topEventsId': 19408134,
	    'promotedSoccerLeaguesCeId': 12032789,
	    'showBroadcast': false
	  },
	  'fallback': {
	    'rugby': 'espnuk-en-rugby-index',
	    'horse': 'espnuk-en-horse-index',
	    'nba': 'espn-en-nba-index',
	    'mlb': 'espn-en-mlb-index',
	    'nfl': 'espn-en-nfl-index',
	    'chalk': 'espn-en-chalk-index',
	    'nhl': 'espn-en-nhl-index',
	    'nascar': 'espn-en-nascar-index',
	    'womenbb': 'espn-en-womenbb-index',
	    'ncf': 'espn-en-ncf-index',
	    'ncb': 'espn-en-ncb-index',
	    'boxing': 'espn-en-boxing-index',
	    'mma': 'espn-en-mma-index',
	    'esports': 'espn-en-esports-index',
	    'nba-stephen-curry': 'espn-en-nba-stephen-curry-index',
	    'oly-summer-archery': 'espn-en-oly-summer-archery-index',
	    'oly-summer-athletics': 'espnuk-en-oly-summer-athletics-index',
	    'oly-summer-badminton': 'espn-en-oly-summer-badminton-index',
	    'oly-summer-basketball': 'espnuk-en-oly-summer-basketball-index',
	    'oly-summer-boxing': 'espnuk-en-oly-summer-boxing-index',
	    'oly-summer-canoe': 'espn-en-oly-summer-canoe-index',
	    'oly-summer-cycling': 'espn-en-oly-summer-cycling-index',
	    'oly-summer-equestrian': 'espn-en-oly-summer-equestrian-index',
	    'oly-summer-fencing': 'espn-en-oly-summer-fencing-index',
	    'oly-summer-field-hockey': 'espn-en-oly-summer-field-hockey-index',
	    'oly-summer-golf': 'espnuk-en-oly-summer-golf-index',
	    'oly-summer-gymnastics': 'espnuk-en-oly-summer-gymnastics-index',
	    'oly-summer-handball': 'espn-en-oly-summer-handball-index',
	    'oly-summer-judo': 'espn-en-oly-summer-judo-index',
	    'oly-summer-modern-pentathlon': 'espn-en-oly-summer-modern-pentathlon-index',
	    'oly-summer-rowing': 'espn-en-oly-summer-rowing-index',
	    'oly-summer-rugby': 'espnuk-en-oly-summer-rugby-index',
	    'oly-summer-sailing': 'espn-en-oly-summer-sailing-index',
	    'oly-summer-shooting': 'espn-en-oly-summer-shooting-index',
	    'oly-summer-soccer': 'espnuk-en-oly-summer-soccer-index',
	    'oly-summer-swimming': 'espnuk-en-oly-summer-swimming-index',
	    'oly-summer-table-tennis': 'espn-en-oly-summer-table-tennis-index',
	    'oly-summer-taekwondo': 'espn-en-oly-summer-taekwondo-index',
	    'oly-summer-tennis': 'espnuk-en-oly-summer-tennis-index',
	    'oly-summer-triathlon': 'espn-en-oly-summer-triathlon-index',
	    'oly-summer-volleyball': 'espnuk-en-oly-summer-volleyball-index',
	    'oly-summer-water-polo': 'espn-en-oly-summer-water-polo-index',
	    'oly-summer-weightlifting': 'espn-en-oly-summer-weightlifting-index',
	    'oly-summer-wrestling': 'espn-en-oly-summer-wrestling-index'
	  },
	  'editionAlert': {
	    'enabled': true,
	    'text': 'Welcome to Sony ESPN India Edition'
	  },
	  'feeds': {
	    'googlenews': {
	      'allowedContentTypes': ['Story', 'HeadlineNews']
	    }
	  },
	  'tier2NavIds': {
	    'boston': 12375278,
	    'chicago': 12505826,
	    'cleveland': 13977091,
	    'dallas': 12505828,
	    'los-angeles': 12505831,
	    'milwaukee': 13977360,
	    'new-york': 12505854,
	    'fantasy/basketball': 12405600,
	    'fantasy/football': 12405632,
	    'fantasy/baseball': 12405631,
	    'fantasy/hockey': 12405634,
	    'fantasy': 13609307,
	    'ncfrecruiting': 11588758,
	    'ncbrecruiting': 11588880,
	    'esports': 13663224,
	    'onenacion': 13309315,
	    'nba/stephen-curry': 14950765,
	    'league': {
	      'soccer': 13794648,
	      'ncf': 13886385,
	      'college-football': 13886385,
	      'cricket': 15609108
	    }
	  },
	  'tier3NavIds': {
	    'clubhouse': {
	      'nba': 12293424,
	      'mlb': 12343023,
	      'mens-college-basketball': 13884705,
	      'womens-college-basketball': 13930164,
	      'soccer': 12294454,
	      'nfl': 12509708,
	      'college-football': 13345157,
	      'cricket': 15368856
	    }
	  },
	  'indexAutoStart': false,
	  'useMongo': true,
	  'activeSite': true,
	  'countries': [{
	    'name': 'India',
	    'country-code': 'in',
	    'showHreflang': true
	  }, {
	    'name': 'Bangladesh',
	    'country-code': 'bd',
	    'showHreflang': false
	  }, {
	    'name': 'Bhutan',
	    'country-code': 'bt',
	    'showHreflang': false
	  }, {
	    'name': 'Maldives',
	    'country-code': 'mv',
	    'showHreflang': false
	  }, {
	    'name': 'Nepal',
	    'country-code': 'np',
	    'showHreflang': false
	  }, {
	    'name': 'Pakistan',
	    'country-code': 'pk',
	    'showHreflang': false
	  }, {
	    'name': 'Sri Lanka',
	    'country-code': 'lk',
	    'showHreflang': false
	  }]
	};

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge2 = __webpack_require__(581);
	
	var _merge3 = _interopRequireDefault(_merge2);
	
	var _taboola = __webpack_require__(667);
	
	var _taboola2 = _interopRequireDefault(_taboola);
	
	var _taboolaDefaults = __webpack_require__(668);
	
	var _taboolaDefaults2 = _interopRequireDefault(_taboolaDefaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  'editionSettings': {
	    'key': 'espncricinfo-en-lk',
	    'site': 'espncricinfo',
	    'language': 'en',
	    'country': 'lk',
	    'countryName': 'srilanka',
	    'domain': 'www.espncricinfo.com',
	    'editionSiteId': '1',
	    'https': true
	  },
	  'navId': '18442808',
	  'dictionarySection': 'espn',
	  'javaLocale': {
	    'language': 'en',
	    'region': 'LK'
	  },
	  'dateTime': {
	    'long': 'dddd MMMM d, yyyy',
	    'medium': 'MMMM d, yyyy',
	    'short': 'M/d',
	    'timeFormat': 'h:mm',
	    'firstDayOfWeek': 'Sunday',
	    'timeZone': 'Asia/Calcutta',
	    'defaultFormat': 'd MMM, yyyy',
	    'timeZoneString': 'IST',
	    'timeZoneBucket': 'Asia/Kolkata',
	    'MMM D, YYYY': 'D MMM, YYYY',
	    'M/D/YYYY': 'D/M/YYYY',
	    'MM/DD/YYYY': 'DD/MM/YYYY',
	    'MMDDYYYY': 'DDMMYYYY',
	    'MMMM Do YYYY': 'Do MMMM YYYY',
	    'dddd, MMMM Do YYYY': 'dddd, Do MMMM YYYY',
	    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
	    'M/D': 'D/M',
	    'MMMM D, YYYY': 'D MMMM YYYY',
	    'dddd, M/D': 'dddd, D/M',
	    'age': {
	      'seconds': 's',
	      'minutes': 'm',
	      'hours': 'h',
	      'days': 'd'
	    }
	  },
	  'numberFormat': {
	    'long': '#,###',
	    'short': '###',
	    'currency': '#,###.00',
	    'percent': '#.00%'
	  },
	  'temperature': {
	    'scale': 'celsius',
	    'symbol': '&deg; C'
	  },
	  'sponsoredContentProviders': ['taboola', 'outbrain'],
	  'taboola': (0, _merge3.default)({}, _taboolaDefaults2.default, _taboola2.default),
	  'outbrain': {
	    'enabled': true,
	    'template': 'ESPNIndia',
	    'desktop': {
	      'compliantId': 'AR_13',
	      'nonCompliantId': 'AR_16'
	    },
	    'mobile': {
	      'compliantId': 'MB_6',
	      'nonCompliantId': 'MB_9'
	    },
	    'scores': {
	      'desktop': {
	        'compliantId': 'AR_49'
	      },
	      'mobile': {
	        'compliantId': 'AR_49'
	      }
	    },
	    'game': {
	      'desktop': {
	        'compliantId': 'AR_48'
	      },
	      'mobile': {
	        'compliantId': 'MB_48'
	      }
	    },
	    'scorecard': {
	      'desktop': {
	        'compliantId': 'AR_49'
	      },
	      'mobile': {
	        'compliantId': 'AR_49'
	      }
	    },
	    'table': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'AR_43'
	      }
	    },
	    'report': {
	      'desktop': {
	        'compliantId': 'AR_30',
	        'nonCompliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'statistics': {
	      'desktop': {
	        'compliantId': 'AR_49',
	        'nonCompliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'schedule': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'AR_43'
	      }
	    }
	  },
	  'omniture': {
	    'enabled': true
	  },
	  'chartBeat': {
	    'enabled': true
	  },
	  'ads': {
	    'disabled': false,
	    'network': 1234,
	    'partnerAd': false,
	    'dev-config': 15039572,
	    'qa-config': 15039572,
	    'prod-config': 15039572
	  },
	  'partnerModules': {
	    'global': false,
	    'nba': false,
	    'womenbb': false,
	    'golf': false,
	    'endurance': false,
	    'horse': false,
	    'nascar': false
	  },
	  'sportBranding': [{
	    'sport': 'cricket',
	    'image': 'logo-uk-cricinfo',
	    'url': null
	  }, {
	    'sport': 'soccer',
	    'image': 'logo-uk-fc',
	    'url': null
	  }, {
	    'sport': 'rugby',
	    'image': 'logo-uk-scrum',
	    'url': null
	  }, {
	    'sport': 'ncaaw',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }, {
	    'sport': 'ncw',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }, {
	    'sport': 'wnba',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }, {
	    'sport': 'womenbb',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }],
	  'siteLogo': {
	    'class': 'sony-espn',
	    'featurePhone': {
	      'name': 'sonyespn-logo',
	      'width': 62,
	      'height': 34
	    }
	  },
	  'meta': {
	    'titleBranding': ' - ESPN',
	    'description': 'Visit ESPN to get up-to-the-minute sports news coverage, scores, highlights and commentary for cricket, rugby, football, F1, kabaddi and more.',
	    'defaultMetaImage': 'sonyespn_black.png',
	    'social': {
	      'twitter': {
	        'twitterId': '',
	        'card': 'summary',
	        'app_id_iphone': '317469184',
	        'site': 'ESPN',
	        'app_name_googleplay': 'ESPN',
	        'app_id_googleplay': 'com.espn.score_center',
	        'app_name_iphone': 'ESPN',
	        'language': 'en'
	      },
	      'facebook': {
	        'id': '116656161708917',
	        'og_site_name': 'ESPN',
	        'locale': 'en_US'
	      }
	    }
	  },
	  'shop': {
	    'enabled': false
	  },
	  'sportReplacements': {
	    'f1': 'f1',
	    'cycling': 'cycling'
	  },
	  'uriRewrites': {
	    'urls': {
	      'toEdition': {},
	      'toEnglish': {}
	    },
	    'roots': {
	      '/oly/summer/gymnastics/': '/oly/summer/gymnastics/',
	      '/oly/summer/cycling/': '/oly/summer/cycling/',
	      '/college-football/': '/ncf/',
	      '/football/': '/soccer/',
	      '/racing/nascar/': '/nascar/',
	      '/racing/': '/rpm/',
	      '/mens-college-basketball/': '/ncb/',
	      '/womens-college-basketball/': '/ncw/',
	      '/womens-basketball/': '/womenbb/',
	      '/olympics/': '/oly/',
	      '/cycling/': '/cycling/',
	      '/fixtures/': '/schedule',
	      '/figure-skating/': '/oly/',
	      '/college-sports/': '/ncaa/',
	      '/gymnastics/': '/oly/',
	      '/skiing/': '/oly/',
	      '/horse-racing/': '/horse/',
	      '/sports/womenbb/': '/womenbb/',
	      '/sports/horse/': '/horse/'
	    },
	    'pathSegments': {},
	    'paramKeys': {},
	    'paramValues': {}
	  },
	  'betting': {
	    'enabled': false,
	    'provider': 'Bet 365',
	    'game': {
	      'enabled': false,
	      'provider': 'Bet 365'
	    }
	  },
	  'ticketProvider': null,
	  'hasTickets': false,
	  'showFavorites': true,
	  'showInsider': false,
	  'showWatch': false,
	  'hideCategoryLinks': [600, 1700],
	  'categorySettings': {
	    'leagues': true,
	    'athletes': false,
	    'teams': false,
	    'tags': true
	  },
	  'showFCContent': true,
	  'showCricInfoContent': true,
	  'cookieConsent': false,
	  'scDeepLinking': true,
	  'allowShortUrl': false,
	  'allowPrintUrl': true,
	  'allowUserAccountManagement': true,
	  'nowFeed': false,
	  'searchUrl': 'http://search.espn.com/',
	  'hasSearch': true,
	  'gameSettings': {
	    'topEventsId': 19408135,
	    'promotedSoccerLeaguesCeId': 12032789,
	    'showBroadcast': false
	  },
	  'fallback': {
	    'rugby': 'espnuk-en-rugby-index',
	    'horse': 'espnuk-en-horse-index',
	    'nba': 'espn-en-nba-index',
	    'mlb': 'espn-en-mlb-index',
	    'nfl': 'espn-en-nfl-index',
	    'chalk': 'espn-en-chalk-index',
	    'nhl': 'espn-en-nhl-index',
	    'nascar': 'espn-en-nascar-index',
	    'womenbb': 'espn-en-womenbb-index',
	    'ncf': 'espn-en-ncf-index',
	    'ncb': 'espn-en-ncb-index',
	    'boxing': 'espn-en-boxing-index',
	    'mma': 'espn-en-mma-index',
	    'esports': 'espn-en-esports-index',
	    'nba-stephen-curry': 'espn-en-nba-stephen-curry-index',
	    'oly-summer-archery': 'espn-en-oly-summer-archery-index',
	    'oly-summer-athletics': 'espnuk-en-oly-summer-athletics-index',
	    'oly-summer-badminton': 'espn-en-oly-summer-badminton-index',
	    'oly-summer-basketball': 'espnuk-en-oly-summer-basketball-index',
	    'oly-summer-boxing': 'espnuk-en-oly-summer-boxing-index',
	    'oly-summer-canoe': 'espn-en-oly-summer-canoe-index',
	    'oly-summer-cycling': 'espn-en-oly-summer-cycling-index',
	    'oly-summer-equestrian': 'espn-en-oly-summer-equestrian-index',
	    'oly-summer-fencing': 'espn-en-oly-summer-fencing-index',
	    'oly-summer-field-hockey': 'espn-en-oly-summer-field-hockey-index',
	    'oly-summer-golf': 'espnuk-en-oly-summer-golf-index',
	    'oly-summer-gymnastics': 'espnuk-en-oly-summer-gymnastics-index',
	    'oly-summer-handball': 'espn-en-oly-summer-handball-index',
	    'oly-summer-judo': 'espn-en-oly-summer-judo-index',
	    'oly-summer-modern-pentathlon': 'espn-en-oly-summer-modern-pentathlon-index',
	    'oly-summer-rowing': 'espn-en-oly-summer-rowing-index',
	    'oly-summer-rugby': 'espnuk-en-oly-summer-rugby-index',
	    'oly-summer-sailing': 'espn-en-oly-summer-sailing-index',
	    'oly-summer-shooting': 'espn-en-oly-summer-shooting-index',
	    'oly-summer-soccer': 'espnuk-en-oly-summer-soccer-index',
	    'oly-summer-swimming': 'espnuk-en-oly-summer-swimming-index',
	    'oly-summer-table-tennis': 'espn-en-oly-summer-table-tennis-index',
	    'oly-summer-taekwondo': 'espn-en-oly-summer-taekwondo-index',
	    'oly-summer-tennis': 'espnuk-en-oly-summer-tennis-index',
	    'oly-summer-triathlon': 'espn-en-oly-summer-triathlon-index',
	    'oly-summer-volleyball': 'espnuk-en-oly-summer-volleyball-index',
	    'oly-summer-water-polo': 'espn-en-oly-summer-water-polo-index',
	    'oly-summer-weightlifting': 'espn-en-oly-summer-weightlifting-index',
	    'oly-summer-wrestling': 'espn-en-oly-summer-wrestling-index'
	  },
	  'editionAlert': {
	    'enabled': true,
	    'text': 'Welcome to Sony ESPN India Edition'
	  },
	  'feeds': {
	    'googlenews': {
	      'allowedContentTypes': ['Story', 'HeadlineNews']
	    }
	  },
	  'tier2NavIds': {
	    'boston': 12375278,
	    'chicago': 12505826,
	    'cleveland': 13977091,
	    'dallas': 12505828,
	    'los-angeles': 12505831,
	    'milwaukee': 13977360,
	    'new-york': 12505854,
	    'fantasy/basketball': 12405600,
	    'fantasy/football': 12405632,
	    'fantasy/baseball': 12405631,
	    'fantasy/hockey': 12405634,
	    'fantasy': 13609307,
	    'ncfrecruiting': 11588758,
	    'ncbrecruiting': 11588880,
	    'esports': 13663224,
	    'onenacion': 13309315,
	    'nba/stephen-curry': 14950765,
	    'league': {
	      'soccer': 13794648,
	      'ncf': 13886385,
	      'college-football': 13886385,
	      'cricket': 15609108
	    }
	  },
	  'tier3NavIds': {
	    'clubhouse': {
	      'nba': 12293424,
	      'mlb': 12343023,
	      'mens-college-basketball': 13884705,
	      'womens-college-basketball': 13930164,
	      'soccer': 12294454,
	      'nfl': 12509708,
	      'college-football': 13345157,
	      'cricket': 15368856
	    }
	  },
	  'indexAutoStart': false,
	  'useMongo': true,
	  'activeSite': true,
	  'countries': [{
	    'name': 'India',
	    'country-code': 'in',
	    'showHreflang': true
	  }, {
	    'name': 'Bangladesh',
	    'country-code': 'bd',
	    'showHreflang': false
	  }, {
	    'name': 'Bhutan',
	    'country-code': 'bt',
	    'showHreflang': false
	  }, {
	    'name': 'Maldives',
	    'country-code': 'mv',
	    'showHreflang': false
	  }, {
	    'name': 'Nepal',
	    'country-code': 'np',
	    'showHreflang': false
	  }, {
	    'name': 'Pakistan',
	    'country-code': 'pk',
	    'showHreflang': false
	  }, {
	    'name': 'Sri Lanka',
	    'country-code': 'lk',
	    'showHreflang': false
	  }]
	};

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge2 = __webpack_require__(581);
	
	var _merge3 = _interopRequireDefault(_merge2);
	
	var _taboola = __webpack_require__(667);
	
	var _taboola2 = _interopRequireDefault(_taboola);
	
	var _taboolaDefaults = __webpack_require__(668);
	
	var _taboolaDefaults2 = _interopRequireDefault(_taboolaDefaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  'editionSettings': {
	    'key': 'espncricinfo-en-uk',
	    'site': 'espncricinfo',
	    'language': 'en',
	    'country': 'gb',
	    'countryName': 'unitedkingdom',
	    'domain': 'www.espncricinfo.com',
	    'editionSiteId': '1',
	    'https': true
	  },
	  'navId': '18444676',
	  'dictionarySection': 'espn',
	  'javaLocale': {
	    'language': 'en',
	    'region': 'GB'
	  },
	  'dateTime': {
	    'long': 'dddd MMMM d, yyyy',
	    'medium': 'MMMM d, yyyy',
	    'short': 'M/d',
	    'timeFormat': 'h:mm',
	    'firstDayOfWeek': 'Sunday',
	    'timeZone': 'Etc/GMT',
	    'defaultFormat': 'd MMM, yyyy',
	    'timeZoneString': 'GMT',
	    'timeZoneBucket': 'Europe/London',
	    'MMM D, YYYY': 'D MMM, YYYY',
	    'M/D/YYYY': 'D/M/YYYY',
	    'MM/DD/YYYY': 'DD/MM/YYYY',
	    'MMDDYYYY': 'DDMMYYYY',
	    'MMMM Do YYYY': 'Do MMMM YYYY',
	    'dddd, MMMM Do YYYY': 'dddd, Do MMMM YYYY',
	    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
	    'M/D': 'D/M',
	    'MMMM D, YYYY': 'D MMMM YYYY',
	    'dddd, M/D': 'dddd, D/M',
	    'age': {
	      'seconds': 's',
	      'minutes': 'm',
	      'hours': 'h',
	      'days': 'd'
	    }
	  },
	  'numberFormat': {
	    'long': '#,###',
	    'short': '###',
	    'currency': '#,###.00',
	    'percent': '#.00%'
	  },
	  'temperature': {
	    'scale': 'celsius',
	    'symbol': '&deg; C'
	  },
	  'sponsoredContentProviders': ['taboola', 'outbrain'],
	  'taboola': (0, _merge3.default)({}, _taboolaDefaults2.default, _taboola2.default),
	  'outbrain': {
	    'enabled': true,
	    'template': 'ESPNIndia',
	    'desktop': {
	      'compliantId': 'AR_13',
	      'nonCompliantId': 'AR_16'
	    },
	    'mobile': {
	      'compliantId': 'MB_6',
	      'nonCompliantId': 'MB_9'
	    },
	    'scores': {
	      'desktop': {
	        'compliantId': 'AR_49'
	      },
	      'mobile': {
	        'compliantId': 'AR_49'
	      }
	    },
	    'game': {
	      'desktop': {
	        'compliantId': 'AR_48'
	      },
	      'mobile': {
	        'compliantId': 'MB_48'
	      }
	    },
	    'scorecard': {
	      'desktop': {
	        'compliantId': 'AR_49'
	      },
	      'mobile': {
	        'compliantId': 'AR_49'
	      }
	    },
	    'table': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'AR_43'
	      }
	    },
	    'report': {
	      'desktop': {
	        'compliantId': 'AR_30',
	        'nonCompliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'statistics': {
	      'desktop': {
	        'compliantId': 'AR_49',
	        'nonCompliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'schedule': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'AR_43'
	      }
	    }
	  },
	  'omniture': {
	    'enabled': true
	  },
	  'chartBeat': {
	    'enabled': true
	  },
	  'ads': {
	    'disabled': false,
	    'network': 1234,
	    'partnerAd': false,
	    'dev-config': 15039572,
	    'qa-config': 15039572,
	    'prod-config': 15039572
	  },
	  'partnerModules': {
	    'global': false,
	    'nba': false,
	    'womenbb': false,
	    'golf': false,
	    'endurance': false,
	    'horse': false,
	    'nascar': false
	  },
	  'sportBranding': [{
	    'sport': 'cricket',
	    'image': 'logo-uk-cricinfo',
	    'url': null
	  }, {
	    'sport': 'soccer',
	    'image': 'logo-uk-fc',
	    'url': null
	  }, {
	    'sport': 'rugby',
	    'image': 'logo-uk-scrum',
	    'url': null
	  }, {
	    'sport': 'ncaaw',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }, {
	    'sport': 'ncw',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }, {
	    'sport': 'wnba',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }, {
	    'sport': 'womenbb',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }],
	  'siteLogo': {
	    'class': 'sony-espn',
	    'featurePhone': {
	      'name': 'sonyespn-logo',
	      'width': 62,
	      'height': 34
	    }
	  },
	  'meta': {
	    'titleBranding': ' - ESPN',
	    'description': 'Visit ESPN to get up-to-the-minute sports news coverage, scores, highlights and commentary for cricket, rugby, football, F1, kabaddi and more.',
	    'defaultMetaImage': 'sonyespn_black.png',
	    'social': {
	      'twitter': {
	        'twitterId': '',
	        'card': 'summary',
	        'app_id_iphone': '317469184',
	        'site': 'ESPN',
	        'app_name_googleplay': 'ESPN',
	        'app_id_googleplay': 'com.espn.score_center',
	        'app_name_iphone': 'ESPN',
	        'language': 'en'
	      },
	      'facebook': {
	        'id': '116656161708917',
	        'og_site_name': 'ESPN',
	        'locale': 'en_US'
	      }
	    }
	  },
	  'shop': {
	    'enabled': false
	  },
	  'sportReplacements': {
	    'f1': 'f1',
	    'cycling': 'cycling'
	  },
	  'uriRewrites': {
	    'urls': {
	      'toEdition': {},
	      'toEnglish': {}
	    },
	    'roots': {
	      '/oly/summer/gymnastics/': '/oly/summer/gymnastics/',
	      '/oly/summer/cycling/': '/oly/summer/cycling/',
	      '/college-football/': '/ncf/',
	      '/football/': '/soccer/',
	      '/racing/nascar/': '/nascar/',
	      '/racing/': '/rpm/',
	      '/mens-college-basketball/': '/ncb/',
	      '/womens-college-basketball/': '/ncw/',
	      '/womens-basketball/': '/womenbb/',
	      '/olympics/': '/oly/',
	      '/cycling/': '/cycling/',
	      '/fixtures/': '/schedule',
	      '/figure-skating/': '/oly/',
	      '/college-sports/': '/ncaa/',
	      '/gymnastics/': '/oly/',
	      '/skiing/': '/oly/',
	      '/horse-racing/': '/horse/',
	      '/sports/womenbb/': '/womenbb/',
	      '/sports/horse/': '/horse/'
	    },
	    'pathSegments': {},
	    'paramKeys': {},
	    'paramValues': {}
	  },
	  'betting': {
	    'enabled': false,
	    'provider': 'Bet 365',
	    'game': {
	      'enabled': false,
	      'provider': 'Bet 365'
	    }
	  },
	  'ticketProvider': null,
	  'hasTickets': false,
	  'showFavorites': true,
	  'showInsider': false,
	  'showWatch': false,
	  'hideCategoryLinks': [600, 1700],
	  'categorySettings': {
	    'leagues': true,
	    'athletes': false,
	    'teams': false,
	    'tags': true
	  },
	  'showFCContent': true,
	  'showCricInfoContent': true,
	  'cookieConsent': false,
	  'scDeepLinking': true,
	  'allowShortUrl': false,
	  'allowPrintUrl': true,
	  'allowUserAccountManagement': true,
	  'nowFeed': false,
	  'searchUrl': 'http://search.espn.com/',
	  'hasSearch': true,
	  'gameSettings': {
	    'topEventsId': 19408137,
	    'promotedSoccerLeaguesCeId': 12032789,
	    'showBroadcast': false
	  },
	  'fallback': {
	    'rugby': 'espnuk-en-rugby-index',
	    'horse': 'espnuk-en-horse-index',
	    'nba': 'espn-en-nba-index',
	    'mlb': 'espn-en-mlb-index',
	    'nfl': 'espn-en-nfl-index',
	    'chalk': 'espn-en-chalk-index',
	    'nhl': 'espn-en-nhl-index',
	    'nascar': 'espn-en-nascar-index',
	    'womenbb': 'espn-en-womenbb-index',
	    'ncf': 'espn-en-ncf-index',
	    'ncb': 'espn-en-ncb-index',
	    'boxing': 'espn-en-boxing-index',
	    'mma': 'espn-en-mma-index',
	    'esports': 'espn-en-esports-index',
	    'nba-stephen-curry': 'espn-en-nba-stephen-curry-index',
	    'oly-summer-archery': 'espn-en-oly-summer-archery-index',
	    'oly-summer-athletics': 'espnuk-en-oly-summer-athletics-index',
	    'oly-summer-badminton': 'espn-en-oly-summer-badminton-index',
	    'oly-summer-basketball': 'espnuk-en-oly-summer-basketball-index',
	    'oly-summer-boxing': 'espnuk-en-oly-summer-boxing-index',
	    'oly-summer-canoe': 'espn-en-oly-summer-canoe-index',
	    'oly-summer-cycling': 'espn-en-oly-summer-cycling-index',
	    'oly-summer-equestrian': 'espn-en-oly-summer-equestrian-index',
	    'oly-summer-fencing': 'espn-en-oly-summer-fencing-index',
	    'oly-summer-field-hockey': 'espn-en-oly-summer-field-hockey-index',
	    'oly-summer-golf': 'espnuk-en-oly-summer-golf-index',
	    'oly-summer-gymnastics': 'espnuk-en-oly-summer-gymnastics-index',
	    'oly-summer-handball': 'espn-en-oly-summer-handball-index',
	    'oly-summer-judo': 'espn-en-oly-summer-judo-index',
	    'oly-summer-modern-pentathlon': 'espn-en-oly-summer-modern-pentathlon-index',
	    'oly-summer-rowing': 'espn-en-oly-summer-rowing-index',
	    'oly-summer-rugby': 'espnuk-en-oly-summer-rugby-index',
	    'oly-summer-sailing': 'espn-en-oly-summer-sailing-index',
	    'oly-summer-shooting': 'espn-en-oly-summer-shooting-index',
	    'oly-summer-soccer': 'espnuk-en-oly-summer-soccer-index',
	    'oly-summer-swimming': 'espnuk-en-oly-summer-swimming-index',
	    'oly-summer-table-tennis': 'espn-en-oly-summer-table-tennis-index',
	    'oly-summer-taekwondo': 'espn-en-oly-summer-taekwondo-index',
	    'oly-summer-tennis': 'espnuk-en-oly-summer-tennis-index',
	    'oly-summer-triathlon': 'espn-en-oly-summer-triathlon-index',
	    'oly-summer-volleyball': 'espnuk-en-oly-summer-volleyball-index',
	    'oly-summer-water-polo': 'espn-en-oly-summer-water-polo-index',
	    'oly-summer-weightlifting': 'espn-en-oly-summer-weightlifting-index',
	    'oly-summer-wrestling': 'espn-en-oly-summer-wrestling-index'
	  },
	  'editionAlert': {
	    'enabled': true,
	    'text': 'Welcome to Sony ESPN India Edition'
	  },
	  'feeds': {
	    'googlenews': {
	      'allowedContentTypes': ['Story', 'HeadlineNews']
	    }
	  },
	  'tier2NavIds': {
	    'boston': 12375278,
	    'chicago': 12505826,
	    'cleveland': 13977091,
	    'dallas': 12505828,
	    'los-angeles': 12505831,
	    'milwaukee': 13977360,
	    'new-york': 12505854,
	    'fantasy/basketball': 12405600,
	    'fantasy/football': 12405632,
	    'fantasy/baseball': 12405631,
	    'fantasy/hockey': 12405634,
	    'fantasy': 13609307,
	    'ncfrecruiting': 11588758,
	    'ncbrecruiting': 11588880,
	    'esports': 13663224,
	    'onenacion': 13309315,
	    'nba/stephen-curry': 14950765,
	    'league': {
	      'soccer': 13794648,
	      'ncf': 13886385,
	      'college-football': 13886385,
	      'cricket': 15609108
	    }
	  },
	  'tier3NavIds': {
	    'clubhouse': {
	      'nba': 12293424,
	      'mlb': 12343023,
	      'mens-college-basketball': 13884705,
	      'womens-college-basketball': 13930164,
	      'soccer': 12294454,
	      'nfl': 12509708,
	      'college-football': 13345157,
	      'cricket': 15368856
	    }
	  },
	  'indexAutoStart': false,
	  'useMongo': true,
	  'activeSite': true,
	  'countries': [{
	    'name': 'India',
	    'country-code': 'in',
	    'showHreflang': true
	  }, {
	    'name': 'Bangladesh',
	    'country-code': 'bd',
	    'showHreflang': false
	  }, {
	    'name': 'Bhutan',
	    'country-code': 'bt',
	    'showHreflang': false
	  }, {
	    'name': 'Maldives',
	    'country-code': 'mv',
	    'showHreflang': false
	  }, {
	    'name': 'Nepal',
	    'country-code': 'np',
	    'showHreflang': false
	  }, {
	    'name': 'Pakistan',
	    'country-code': 'pk',
	    'showHreflang': false
	  }, {
	    'name': 'Sri Lanka',
	    'country-code': 'lk',
	    'showHreflang': false
	  }]
	};

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge2 = __webpack_require__(581);
	
	var _merge3 = _interopRequireDefault(_merge2);
	
	var _taboola = __webpack_require__(667);
	
	var _taboola2 = _interopRequireDefault(_taboola);
	
	var _taboolaDefaults = __webpack_require__(668);
	
	var _taboolaDefaults2 = _interopRequireDefault(_taboolaDefaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  'editionSettings': {
	    'key': 'espncricinfo-en-us',
	    'site': 'espncricinfo',
	    'language': 'en',
	    'country': 'us',
	    'countryName': 'unitedstates',
	    'domain': 'www.espncricinfo.com',
	    'editionSiteId': '1',
	    'https': true
	  },
	  'navId': '18441707',
	  'dictionarySection': 'espn',
	  'javaLocale': {
	    'language': 'en',
	    'region': 'US'
	  },
	  'dateTime': {
	    'long': 'dddd MMMM d, yyyy',
	    'medium': 'MMMM d, yyyy',
	    'short': 'M/d',
	    'timeFormat': 'h:mm',
	    'firstDayOfWeek': 'Sunday',
	    'timeZone': 'US/Eastern',
	    'defaultFormat': 'MMM d, yyyy',
	    'timeZoneString': 'ET',
	    'timeZoneBucket': 'America/New_York',
	    'MMM D, YYYY': 'D MMM, YYYY',
	    'M/D/YYYY': 'D/M/YYYY',
	    'MM/DD/YYYY': 'DD/MM/YYYY',
	    'MMDDYYYY': 'DDMMYYYY',
	    'MMMM Do YYYY': 'Do MMMM YYYY',
	    'dddd, MMMM Do YYYY': 'dddd, Do MMMM YYYY',
	    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
	    'M/D': 'D/M',
	    'MMMM D, YYYY': 'D MMMM YYYY',
	    'dddd, M/D': 'dddd, D/M',
	    'age': {
	      'seconds': 's',
	      'minutes': 'm',
	      'hours': 'h',
	      'days': 'd'
	    }
	  },
	  'numberFormat': {
	    'long': '#,###',
	    'short': '###',
	    'currency': '#,###.00',
	    'percent': '#.00%'
	  },
	  'temperature': {
	    'scale': 'celsius',
	    'symbol': '&deg; C'
	  },
	  'sponsoredContentProviders': ['taboola', 'outbrain'],
	  'taboola': (0, _merge3.default)({}, _taboolaDefaults2.default, _taboola2.default),
	  'outbrain': {
	    'enabled': true,
	    'template': 'ESPNIndia',
	    'desktop': {
	      'compliantId': 'AR_13',
	      'nonCompliantId': 'AR_16'
	    },
	    'mobile': {
	      'compliantId': 'MB_6',
	      'nonCompliantId': 'MB_9'
	    },
	    'scores': {
	      'desktop': {
	        'compliantId': 'AR_49'
	      },
	      'mobile': {
	        'compliantId': 'AR_49'
	      }
	    },
	    'game': {
	      'desktop': {
	        'compliantId': 'AR_48'
	      },
	      'mobile': {
	        'compliantId': 'MB_48'
	      }
	    },
	    'scorecard': {
	      'desktop': {
	        'compliantId': 'AR_49'
	      },
	      'mobile': {
	        'compliantId': 'AR_49'
	      }
	    },
	    'table': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'AR_43'
	      }
	    },
	    'report': {
	      'desktop': {
	        'compliantId': 'AR_30',
	        'nonCompliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'statistics': {
	      'desktop': {
	        'compliantId': 'AR_49',
	        'nonCompliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'schedule': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'AR_43'
	      }
	    }
	  },
	  'omniture': {
	    'enabled': true
	  },
	  'chartBeat': {
	    'enabled': true
	  },
	  'ads': {
	    'disabled': false,
	    'network': 1234,
	    'partnerAd': false,
	    'dev-config': 15039572,
	    'qa-config': 15039572,
	    'prod-config': 15039572
	  },
	  'partnerModules': {
	    'global': false,
	    'nba': false,
	    'womenbb': false,
	    'golf': false,
	    'endurance': false,
	    'horse': false,
	    'nascar': false
	  },
	  'sportBranding': [{
	    'sport': 'cricket',
	    'image': 'logo-uk-cricinfo',
	    'url': null
	  }, {
	    'sport': 'soccer',
	    'image': 'logo-uk-fc',
	    'url': null
	  }, {
	    'sport': 'rugby',
	    'image': 'logo-uk-scrum',
	    'url': null
	  }, {
	    'sport': 'ncaaw',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }, {
	    'sport': 'ncw',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }, {
	    'sport': 'wnba',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }, {
	    'sport': 'womenbb',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }],
	  'siteLogo': {
	    'class': 'sony-espn',
	    'featurePhone': {
	      'name': 'sonyespn-logo',
	      'width': 62,
	      'height': 34
	    }
	  },
	  'meta': {
	    'titleBranding': ' - ESPN',
	    'description': 'Visit ESPN to get up-to-the-minute sports news coverage, scores, highlights and commentary for cricket, rugby, football, F1, kabaddi and more.',
	    'defaultMetaImage': 'sonyespn_black.png',
	    'social': {
	      'twitter': {
	        'twitterId': '',
	        'card': 'summary',
	        'app_id_iphone': '317469184',
	        'site': 'ESPN',
	        'app_name_googleplay': 'ESPN',
	        'app_id_googleplay': 'com.espn.score_center',
	        'app_name_iphone': 'ESPN',
	        'language': 'en'
	      },
	      'facebook': {
	        'id': '116656161708917',
	        'og_site_name': 'ESPN',
	        'locale': 'en_US'
	      }
	    }
	  },
	  'shop': {
	    'enabled': false
	  },
	  'sportReplacements': {
	    'f1': 'f1',
	    'cycling': 'cycling'
	  },
	  'uriRewrites': {
	    'urls': {
	      'toEdition': {},
	      'toEnglish': {}
	    },
	    'roots': {
	      '/oly/summer/gymnastics/': '/oly/summer/gymnastics/',
	      '/oly/summer/cycling/': '/oly/summer/cycling/',
	      '/college-football/': '/ncf/',
	      '/football/': '/soccer/',
	      '/racing/nascar/': '/nascar/',
	      '/racing/': '/rpm/',
	      '/mens-college-basketball/': '/ncb/',
	      '/womens-college-basketball/': '/ncw/',
	      '/womens-basketball/': '/womenbb/',
	      '/olympics/': '/oly/',
	      '/cycling/': '/cycling/',
	      '/fixtures/': '/schedule',
	      '/figure-skating/': '/oly/',
	      '/college-sports/': '/ncaa/',
	      '/gymnastics/': '/oly/',
	      '/skiing/': '/oly/',
	      '/horse-racing/': '/horse/',
	      '/sports/womenbb/': '/womenbb/',
	      '/sports/horse/': '/horse/'
	    },
	    'pathSegments': {},
	    'paramKeys': {},
	    'paramValues': {}
	  },
	  'betting': {
	    'enabled': false,
	    'provider': 'Bet 365',
	    'game': {
	      'enabled': false,
	      'provider': 'Bet 365'
	    }
	  },
	  'ticketProvider': null,
	  'hasTickets': false,
	  'showFavorites': true,
	  'showInsider': false,
	  'showWatch': false,
	  'hideCategoryLinks': [600, 1700],
	  'categorySettings': {
	    'leagues': true,
	    'athletes': false,
	    'teams': false,
	    'tags': true
	  },
	  'showFCContent': true,
	  'showCricInfoContent': true,
	  'cookieConsent': false,
	  'scDeepLinking': true,
	  'allowShortUrl': false,
	  'allowPrintUrl': true,
	  'allowUserAccountManagement': true,
	  'nowFeed': false,
	  'searchUrl': 'http://search.espn.com/',
	  'hasSearch': true,
	  'gameSettings': {
	    'topEventsId': 19408139,
	    'promotedSoccerLeaguesCeId': 12032789,
	    'showBroadcast': false
	  },
	  'fallback': {
	    'rugby': 'espnuk-en-rugby-index',
	    'horse': 'espnuk-en-horse-index',
	    'nba': 'espn-en-nba-index',
	    'mlb': 'espn-en-mlb-index',
	    'nfl': 'espn-en-nfl-index',
	    'chalk': 'espn-en-chalk-index',
	    'nhl': 'espn-en-nhl-index',
	    'nascar': 'espn-en-nascar-index',
	    'womenbb': 'espn-en-womenbb-index',
	    'ncf': 'espn-en-ncf-index',
	    'ncb': 'espn-en-ncb-index',
	    'boxing': 'espn-en-boxing-index',
	    'mma': 'espn-en-mma-index',
	    'esports': 'espn-en-esports-index',
	    'nba-stephen-curry': 'espn-en-nba-stephen-curry-index',
	    'oly-summer-archery': 'espn-en-oly-summer-archery-index',
	    'oly-summer-athletics': 'espnuk-en-oly-summer-athletics-index',
	    'oly-summer-badminton': 'espn-en-oly-summer-badminton-index',
	    'oly-summer-basketball': 'espnuk-en-oly-summer-basketball-index',
	    'oly-summer-boxing': 'espnuk-en-oly-summer-boxing-index',
	    'oly-summer-canoe': 'espn-en-oly-summer-canoe-index',
	    'oly-summer-cycling': 'espn-en-oly-summer-cycling-index',
	    'oly-summer-equestrian': 'espn-en-oly-summer-equestrian-index',
	    'oly-summer-fencing': 'espn-en-oly-summer-fencing-index',
	    'oly-summer-field-hockey': 'espn-en-oly-summer-field-hockey-index',
	    'oly-summer-golf': 'espnuk-en-oly-summer-golf-index',
	    'oly-summer-gymnastics': 'espnuk-en-oly-summer-gymnastics-index',
	    'oly-summer-handball': 'espn-en-oly-summer-handball-index',
	    'oly-summer-judo': 'espn-en-oly-summer-judo-index',
	    'oly-summer-modern-pentathlon': 'espn-en-oly-summer-modern-pentathlon-index',
	    'oly-summer-rowing': 'espn-en-oly-summer-rowing-index',
	    'oly-summer-rugby': 'espnuk-en-oly-summer-rugby-index',
	    'oly-summer-sailing': 'espn-en-oly-summer-sailing-index',
	    'oly-summer-shooting': 'espn-en-oly-summer-shooting-index',
	    'oly-summer-soccer': 'espnuk-en-oly-summer-soccer-index',
	    'oly-summer-swimming': 'espnuk-en-oly-summer-swimming-index',
	    'oly-summer-table-tennis': 'espn-en-oly-summer-table-tennis-index',
	    'oly-summer-taekwondo': 'espn-en-oly-summer-taekwondo-index',
	    'oly-summer-tennis': 'espnuk-en-oly-summer-tennis-index',
	    'oly-summer-triathlon': 'espn-en-oly-summer-triathlon-index',
	    'oly-summer-volleyball': 'espnuk-en-oly-summer-volleyball-index',
	    'oly-summer-water-polo': 'espn-en-oly-summer-water-polo-index',
	    'oly-summer-weightlifting': 'espn-en-oly-summer-weightlifting-index',
	    'oly-summer-wrestling': 'espn-en-oly-summer-wrestling-index'
	  },
	  'editionAlert': {
	    'enabled': true,
	    'text': 'Welcome to Sony ESPN India Edition'
	  },
	  'feeds': {
	    'googlenews': {
	      'allowedContentTypes': ['Story', 'HeadlineNews']
	    }
	  },
	  'tier2NavIds': {
	    'boston': 12375278,
	    'chicago': 12505826,
	    'cleveland': 13977091,
	    'dallas': 12505828,
	    'los-angeles': 12505831,
	    'milwaukee': 13977360,
	    'new-york': 12505854,
	    'fantasy/basketball': 12405600,
	    'fantasy/football': 12405632,
	    'fantasy/baseball': 12405631,
	    'fantasy/hockey': 12405634,
	    'fantasy': 13609307,
	    'ncfrecruiting': 11588758,
	    'ncbrecruiting': 11588880,
	    'esports': 13663224,
	    'onenacion': 13309315,
	    'nba/stephen-curry': 14950765,
	    'league': {
	      'soccer': 13794648,
	      'ncf': 13886385,
	      'college-football': 13886385,
	      'cricket': 15609108
	    }
	  },
	  'tier3NavIds': {
	    'clubhouse': {
	      'nba': 12293424,
	      'mlb': 12343023,
	      'mens-college-basketball': 13884705,
	      'womens-college-basketball': 13930164,
	      'soccer': 12294454,
	      'nfl': 12509708,
	      'college-football': 13345157,
	      'cricket': 15368856
	    }
	  },
	  'indexAutoStart': false,
	  'useMongo': true,
	  'activeSite': true,
	  'countries': [{
	    'name': 'India',
	    'country-code': 'in',
	    'showHreflang': true
	  }, {
	    'name': 'Bangladesh',
	    'country-code': 'bd',
	    'showHreflang': false
	  }, {
	    'name': 'Bhutan',
	    'country-code': 'bt',
	    'showHreflang': false
	  }, {
	    'name': 'Maldives',
	    'country-code': 'mv',
	    'showHreflang': false
	  }, {
	    'name': 'Nepal',
	    'country-code': 'np',
	    'showHreflang': false
	  }, {
	    'name': 'Pakistan',
	    'country-code': 'pk',
	    'showHreflang': false
	  }, {
	    'name': 'Sri Lanka',
	    'country-code': 'lk',
	    'showHreflang': false
	  }]
	};

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./australia": 679,
		"./australia.js": 679,
		"./cricinfo/africa": 580,
		"./cricinfo/africa.js": 580,
		"./cricinfo/australia": 669,
		"./cricinfo/australia.js": 669,
		"./cricinfo/bangladesh": 670,
		"./cricinfo/bangladesh.js": 670,
		"./cricinfo/global": 671,
		"./cricinfo/global.js": 671,
		"./cricinfo/india": 672,
		"./cricinfo/india.js": 672,
		"./cricinfo/newzealand": 673,
		"./cricinfo/newzealand.js": 673,
		"./cricinfo/pakistan": 674,
		"./cricinfo/pakistan.js": 674,
		"./cricinfo/srilanka": 675,
		"./cricinfo/srilanka.js": 675,
		"./cricinfo/taboola": 667,
		"./cricinfo/taboola.js": 667,
		"./cricinfo/unitedkingdom": 676,
		"./cricinfo/unitedkingdom.js": 676,
		"./cricinfo/unitedstates": 677,
		"./cricinfo/unitedstates.js": 677,
		"./en-global": 681,
		"./en-global.js": 681,
		"./india": 682,
		"./india.js": 682,
		"./philippines": 683,
		"./philippines.js": 683,
		"./portuguese/brazil": 684,
		"./portuguese/brazil.js": 684,
		"./southafrica": 686,
		"./southafrica.js": 686,
		"./spanish/argentina": 687,
		"./spanish/argentina.js": 687,
		"./spanish/chile": 688,
		"./spanish/chile.js": 688,
		"./spanish/colombia": 689,
		"./spanish/colombia.js": 689,
		"./spanish/dominicanrepublic": 690,
		"./spanish/dominicanrepublic.js": 690,
		"./spanish/ecuador": 691,
		"./spanish/ecuador.js": 691,
		"./spanish/guatemala": 692,
		"./spanish/guatemala.js": 692,
		"./spanish/mexico": 693,
		"./spanish/mexico.js": 693,
		"./spanish/panama": 694,
		"./spanish/panama.js": 694,
		"./spanish/peru": 695,
		"./spanish/peru.js": 695,
		"./spanish/spain": 696,
		"./spanish/spain.js": 696,
		"./spanish/unitedstates": 697,
		"./spanish/unitedstates.js": 697,
		"./spanish/uruguay": 698,
		"./spanish/uruguay.js": 698,
		"./spanish/venezuela": 699,
		"./spanish/venezuela.js": 699,
		"./taboola": 680,
		"./taboola.js": 680,
		"./taboolaDefaults": 668,
		"./taboolaDefaults.js": 668,
		"./unitedkingdom": 700,
		"./unitedkingdom.js": 700,
		"./unitedstates": 701,
		"./unitedstates.js": 701
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 678;


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge2 = __webpack_require__(581);
	
	var _merge3 = _interopRequireDefault(_merge2);
	
	var _taboola = __webpack_require__(680);
	
	var _taboola2 = _interopRequireDefault(_taboola);
	
	var _taboolaDefaults = __webpack_require__(668);
	
	var _taboolaDefaults2 = _interopRequireDefault(_taboolaDefaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  'editionSettings': {
	    'key': 'espnau-en',
	    'site': 'espn',
	    'language': 'en',
	    'country': 'au',
	    'domain': 'www.espn.com.au',
	    'editionSiteId': '16',
	    'https': true
	  },
	  'navId': '14327376',
	  'dictionarySection': 'espn',
	  'javaLocale': {
	    'language': 'en',
	    'region': 'AU'
	  },
	  'dateTime': {
	    'long': 'dddd MMMM d, yyyy',
	    'medium': 'MMMM d, yyyy',
	    'short': 'M/d',
	    'timeFormat': 'h:mm',
	    'firstDayOfWeek': 'Monday',
	    'timeZone': 'Etc/GMT',
	    'defaultFormat': 'd MMM, yyyy',
	    'timeZoneString': 'GMT',
	    'timeZoneBucket': 'Australia/Melbourne',
	    'MMM D, YYYY': 'D MMM, YYYY',
	    'M/D/YYYY': 'D/M/YYYY',
	    'MM/DD/YYYY': 'DD/MM/YYYY',
	    'MMDDYYYY': 'DDMMYYYY',
	    'MMMM Do YYYY': 'Do MMMM YYYY',
	    'dddd, MMMM Do YYYY': 'dddd, Do MMMM YYYY',
	    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
	    'M/D': 'D/M',
	    'MMMM D, YYYY': 'D MMMM YYYY',
	    'dddd, M/D': 'dddd, D/M',
	    'age': {
	      'seconds': 's',
	      'minutes': 'm',
	      'hours': 'h',
	      'days': 'd'
	    }
	  },
	  'numberFormat': {
	    'long': '#,###',
	    'short': '###',
	    'currency': '#,###.00',
	    'percent': '#.00%'
	  },
	  'temperature': {
	    'scale': 'celsius',
	    'symbol': '&deg; C'
	  },
	  'sponsoredContentProviders': ['taboola', 'outbrain'],
	  'taboola': (0, _merge3.default)({}, _taboolaDefaults2.default, _taboola2.default),
	  'outbrain': {
	    'enabled': true,
	    'template': 'ESPNAustralia',
	    'desktop': {
	      'compliantId': 'AR_49',
	      'nonCompliantId': 'AR_12'
	    },
	    'mobile': {
	      'compliantId': 'AR_49',
	      'nonCompliantId': 'MB_5'
	    },
	    'table': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'MB_43'
	      }
	    },
	    'game': {
	      'desktop': {
	        'compliantId': 'AR_48'
	      },
	      'mobile': {
	        'compliantId': 'AR_48'
	      }
	    },
	    'team': {
	      'desktop': {
	        'compliantId': 'SB_1'
	      },
	      'mobile': {
	        'compliantId': 'SB_1'
	      }
	    }
	  },
	  'omniture': {
	    'site': 'espnau',
	    'account': 'wdgespaustralia',
	    'enabled': true
	  },
	  'chartBeat': {
	    'enabled': true
	  },
	  'ads': {
	    'disabled': false,
	    'network': 1234,
	    'partnerAd': false,
	    'dev-config': 14673100,
	    'qa-config': 14673100,
	    'prod-config': 14673100
	  },
	  'partnerModules': {
	    'global': false,
	    'nba': false,
	    'womenbb': false,
	    'golf': false,
	    'endurance': false,
	    'horse': false,
	    'nascar': false
	  },
	  'sportBranding': [{
	    'sport': 'cricket',
	    'image': 'logo-uk-cricinfo',
	    'url': 'https://www.espncricinfo.com'
	  }, {
	    'sport': 'soccer',
	    'image': 'logo-uk-fc',
	    'url': 'http://www.espnfc.com.au'
	  }, {
	    'sport': 'rugby',
	    'image': 'logo-uk-scrum',
	    'url': null
	  }, {
	    'sport': 'ncaaw',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'ncw',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'wnba',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'womenbb',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': 'http://espnw.com'
	  }],
	  'siteLogo': {
	    'class': 'beta',
	    'featurePhone': {
	      'name': 'espn-logo',
	      'width': 45,
	      'height': 11
	    }
	  },
	  'meta': {
	    'titleBranding': ' - ESPN',
	    'description': 'Visit ESPN to get up-to-the-minute sports news coverage, scores, highlights and commentary for AFL, NRL, NFL, MLB, NBA and more.',
	    'defaultMetaImage': 'espn_red.png',
	    'social': {
	      'twitter': {
	        'twitterId': '',
	        'card': 'summary',
	        'app_id_iphone': '317469184',
	        'site': 'espn',
	        'app_name_googleplay': 'ESPN',
	        'app_id_googleplay': 'com.espn.score_center',
	        'app_name_iphone': 'ESPN',
	        'language': 'en'
	      },
	      'facebook': {
	        'id': '116656161708917',
	        'og_site_name': 'ESPN.com',
	        'locale': 'en_US'
	      }
	    }
	  },
	  'shop': {
	    'enabled': false
	  },
	  'sportReplacements': {
	    'f1': 'f1'
	  },
	  'uriRewrites': {
	    'urls': {
	      'toEdition': {},
	      'toEnglish': {}
	    },
	    'roots': {
	      '/oly/summer/gymnastics/': '/oly/summer/gymnastics/',
	      '/oly/summer/cycling/': '/oly/summer/cycling/',
	      '/american-football/': '/nfl/',
	      '/college-football/': '/ncf/',
	      '/football/': '/soccer/',
	      '/racing/nascar/': '/nascar/',
	      '/racing/': '/rpm/',
	      '/mens-college-basketball/': '/ncb/',
	      '/womens-college-basketball/': '/ncw/',
	      '/womens-basketball/': '/womenbb/',
	      '/olympics/': '/oly/',
	      '/cycling/': '/cycling/',
	      '/fixtures/': '/schedule',
	      '/figure-skating/': '/oly/',
	      '/college-sports/': '/ncaa/',
	      '/gymnastics/': '/oly/',
	      '/skiing/': '/oly/',
	      '/horse-racing/': '/horse/',
	      '/sports/womenbb/': '/womenbb/',
	      '/sports/horse/': '/horse/'
	    },
	    'pathSegments': {},
	    'paramKeys': {},
	    'paramValues': {}
	  },
	  'betting': {
	    'enabled': false,
	    'provider': 'Bet 365',
	    'game': {
	      'enabled': false,
	      'provider': 'Bet 365'
	    }
	  },
	  'ticketProvider': null,
	  'hasTickets': false,
	  'showFavorites': true,
	  'showInsider': false,
	  'showWatch': false,
	  'hideCategoryLinks': [600, 1700],
	  'categorySettings': {
	    'leagues': true,
	    'athletes': false,
	    'teams': false,
	    'tags': true
	  },
	  'showFCContent': false,
	  'showCricInfoContent': false,
	  'cookieConsent': false,
	  'scDeepLinking': true,
	  'allowShortUrl': false,
	  'allowPrintUrl': true,
	  'allowUserAccountManagement': true,
	  'shimFavorites': true,
	  'nowFeed': true,
	  'searchUrl': 'http://search.espn.com/',
	  'hasSearch': true,
	  'gameSettings': {
	    'topEventsId': 14323671,
	    'promotedSoccerLeaguesCeId': 12032789,
	    'showBroadcast': false
	  },
	  'fallback': {
	    'nba': 'espn-en-nba-index',
	    'nfl': 'espn-en-nfl-index',
	    'nascar': 'espn-en-nascar-index',
	    'tennis': 'espn-en-tennis-index',
	    'mlb': 'espn-en-mlb-index',
	    'nhl': 'espn-en-nhl-index',
	    'f1': 'espnuk-en-f1-index',
	    'womenbb': 'espn-en-womenbb-index',
	    'ncf': 'espn-en-ncf-index',
	    'ncb': 'espn-en-ncb-index',
	    'ncaa': 'espn-en-ncaa-index',
	    'boxing': 'espn-en-boxing-index',
	    'mma': 'espn-en-mma-index',
	    'esports': 'espn-en-esports-index',
	    'cricket': 'espn-en-cricket-index',
	    'endurance': 'espn-en-endurance-index',
	    'golf': 'espn-en-golf-index',
	    'chalk': 'espn-en-chalk-index',
	    'nba-stephen-curry': 'espn-en-nba-stephen-curry-index',
	    'oly-summer-archery': 'espn-en-oly-summer-archery-index',
	    'oly-summer-athletics': 'espnuk-en-oly-summer-athletics-index',
	    'oly-summer-badminton': 'espn-en-oly-summer-badminton-index',
	    'oly-summer-basketball': 'espnuk-en-oly-summer-basketball-index',
	    'oly-summer-boxing': 'espnuk-en-oly-summer-boxing-index',
	    'oly-summer-canoe': 'espn-en-oly-summer-canoe-index',
	    'oly-summer-cycling': 'espn-en-oly-summer-cycling-index',
	    'oly-summer-equestrian': 'espn-en-oly-summer-equestrian-index',
	    'oly-summer-fencing': 'espn-en-oly-summer-fencing-index',
	    'oly-summer-field-hockey': 'espn-en-oly-summer-field-hockey-index',
	    'oly-summer-golf': 'espnuk-en-oly-summer-golf-index',
	    'oly-summer-gymnastics': 'espnuk-en-oly-summer-gymnastics-index',
	    'oly-summer-handball': 'espn-en-oly-summer-handball-index',
	    'oly-summer-judo': 'espn-en-oly-summer-judo-index',
	    'oly-summer-modern-pentathlon': 'espn-en-oly-summer-modern-pentathlon-index',
	    'oly-summer-rowing': 'espn-en-oly-summer-rowing-index',
	    'oly-summer-rugby': 'espnuk-en-oly-summer-rugby-index',
	    'oly-summer-sailing': 'espn-en-oly-summer-sailing-index',
	    'oly-summer-shooting': 'espn-en-oly-summer-shooting-index',
	    'oly-summer-soccer': 'espnuk-en-oly-summer-soccer-index',
	    'oly-summer-swimming': 'espnuk-en-oly-summer-swimming-index',
	    'oly-summer-table-tennis': 'espn-en-oly-summer-table-tennis-index',
	    'oly-summer-taekwondo': 'espn-en-oly-summer-taekwondo-index',
	    'oly-summer-tennis': 'espnuk-en-oly-summer-tennis-index',
	    'oly-summer-triathlon': 'espn-en-oly-summer-triathlon-index',
	    'oly-summer-volleyball': 'espnuk-en-oly-summer-volleyball-index',
	    'oly-summer-water-polo': 'espn-en-oly-summer-water-polo-index',
	    'oly-summer-weightlifting': 'espn-en-oly-summer-weightlifting-index',
	    'oly-summer-wrestling': 'espn-en-oly-summer-wrestling-index'
	  },
	  'editionAlert': {
	    'enabled': true,
	    'text': "You have reached ESPN's Australian edition. <a href=\"#\" class=\"stay\">Stay on current site</a> or <a href=\"https://www.espn.com/?country-view=us&amp;lang-view=en\">go to US version</a>."
	  },
	  'feeds': {
	    'googlenews': {
	      'allowedContentTypes': ['Story', 'HeadlineNews']
	    }
	  },
	  'tier2NavIds': {
	    'boston': 12375278,
	    'chicago': 12505826,
	    'cleveland': 13977091,
	    'dallas': 12505828,
	    'los-angeles': 12505831,
	    'milwaukee': 13977360,
	    'new-york': 12505854,
	    'horse-racing': 16987409,
	    'fantasy/basketball': 12405600,
	    'fantasy/football': 12405632,
	    'fantasy/baseball': 12405631,
	    'fantasy/hockey': 12405634,
	    'fantasy': 13609307,
	    'ncfrecruiting': 11588758,
	    'ncbrecruiting': 11588880,
	    'betting': 16984056,
	    'esports': 13663224,
	    'onenacion': 13309315,
	    'chalk': 14838513,
	    'nba/stephen-curry': 14950765,
	    'league': {
	      'soccer': 13794648,
	      'ncf': 13886385,
	      'college-football': 13886385,
	      'cricket': 15609108
	    },
	    'oly': 17101944
	  },
	  'tier3NavIds': {
	    'clubhouse': {
	      'nba': 12293424,
	      'mlb': 12343023,
	      'mens-college-basketball': 13884705,
	      'womens-college-basketball': 13930164,
	      'soccer': 12294454,
	      'nfl': 12509708,
	      'college-football': 13345157,
	      'cricket': 15368856
	    }
	  },
	  'indexAutoStart': false,
	  'useMongo': true,
	  'activeSite': true,
	  'countries': [{
	    'name': 'American Samoa',
	    'country-code': 'as',
	    'showHreflang': false
	  }, {
	    'name': 'Australia',
	    'country-code': 'au',
	    'showHreflang': true
	  }, {
	    'name': 'Cook Islands',
	    'country-code': 'ck',
	    'showHreflang': false
	  }, {
	    'name': 'Fiji',
	    'country-code': 'fj',
	    'showHreflang': false
	  }, {
	    'name': 'French Polynesia',
	    'country-code': 'pf',
	    'showHreflang': false
	  }, {
	    'name': 'Kiribati',
	    'country-code': 'ki',
	    'showHreflang': false
	  }, {
	    'name': 'Marshall Islands',
	    'country-code': 'mh',
	    'showHreflang': false
	  }, {
	    'name': 'Micronesia',
	    'country-code': 'fm',
	    'showHreflang': false
	  }, {
	    'name': 'Niue',
	    'country-code': 'nu',
	    'showHreflang': false
	  }, {
	    'name': 'Palau',
	    'country-code': 'pw',
	    'showHreflang': false
	  }, {
	    'name': 'Papua New Guinea',
	    'country-code': 'pg',
	    'showHreflang': false
	  }, {
	    'name': 'Tahiti',
	    'country-code': 'pf',
	    'showHreflang': false
	  }, {
	    'name': 'Tokelau',
	    'country-code': 'tk',
	    'showHreflang': false
	  }, {
	    'name': 'Tonga',
	    'country-code': 'to',
	    'showHreflang': false
	  }, {
	    'name': 'Tuvalu',
	    'country-code': 'tv',
	    'showHreflang': false
	  }, {
	    'name': 'Western Samoa',
	    'country-code': 'ws',
	    'showHreflang': false
	  }]
	};

/***/ }),
/* 680 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Taboola defaults for rugby, all editions.
	//
	// Notes:
	// 1. '*_webview' only used in webview mode.
	// 2. 'publisher_webview' gets 'ios' or 'android' appended to it on those platforms.
	// 3. 'publisher_webview' gets 'indiaios' or 'indiaandroid' appended to it on those platforms in India.
	// 4. 'mode_webview' gets '-iOS' or '-Android' appended to it on those platforms.
	// 5. 'mode_webview' gets 'India-iOS' or 'India-Android' appended to it on those platforms in India.
	// 6. 'commentary' => 'gamepackage'
	// 7. 'conversation' => 'gamepackage'
	// 8. 'game' => 'gamepackage'
	// 9. 'lineups' => 'gamepackage'
	// 10. 'match' => 'gamepackage'
	// 11. 'matchstats' => 'gamepackage'
	// 12. 'playerstats' => 'gamepackage'
	// 13. 'preview' => 'article' (only available via gamepackage in Reduxion)
	// 14. 'report' => 'article' (only available via gamepackage in Reduxion)
	// 15. 'team' => 'clubhouse', which only has a right-rail placement.
	
	exports.default = {
	  'publisher_webview': 'espnappsnetwork-espn',
	  'commentary': {
	    'type': 'category',
	    'mode': 'thumbnails-3x1-b',
	    'mode_webview': 'thumbnails-2x2-ESPN',
	    'container': 'taboola-below-section-front-thumbnails',
	    'container_webview': 'taboola-below-section-front-thumbnails',
	    'target_type': 'mix'
	  },
	  'conversation': {
	    'type': 'category',
	    'mode': 'thumbnails-3x1-b',
	    'mode_webview': 'thumbnails-2x2-ESPN',
	    'container': 'taboola-below-section-front-thumbnails',
	    'container_webview': 'taboola-below-section-front-thumbnails',
	    'target_type': 'mix'
	  },
	  'game': {
	    'type': 'category',
	    'mode': 'thumbnails-3x1-b',
	    'mode_webview': 'thumbnails-2x2-ESPN',
	    'container': 'taboola-below-section-front-thumbnails',
	    'container_webview': 'taboola-below-section-front-thumbnails',
	    'target_type': 'mix'
	  },
	  'lineups': {
	    'type': 'category',
	    'mode': 'thumbnails-3x1-b',
	    'mode_webview': 'thumbnails-2x2-ESPN',
	    'container': 'taboola-below-section-front-thumbnails',
	    'container_webview': 'taboola-below-section-front-thumbnails',
	    'target_type': 'mix'
	  },
	  'match': {
	    'type': 'category',
	    'mode': 'thumbnails-3x1-b',
	    'mode_webview': 'thumbnails-2x2-ESPN',
	    'container': 'taboola-below-section-front-thumbnails',
	    'container_webview': 'taboola-below-section-front-thumbnails',
	    'target_type': 'mix'
	  },
	  'matchstats': {
	    'type': 'category',
	    'mode': 'thumbnails-3x1-b',
	    'mode_webview': 'thumbnails-2x2-ESPN',
	    'container': 'taboola-below-section-front-thumbnails',
	    'container_webview': 'taboola-below-section-front-thumbnails',
	    'target_type': 'mix'
	  },
	  'playerstats': {
	    'type': 'category',
	    'mode': 'thumbnails-3x1-b',
	    'mode_webview': 'thumbnails-2x2-ESPN',
	    'container': 'taboola-below-section-front-thumbnails',
	    'container_webview': 'taboola-below-section-front-thumbnails',
	    'target_type': 'mix'
	  },
	  'preview': {
	    'type': 'category',
	    'mode': 'thumbnails-3x1-b',
	    'mode_webview': 'thumbnails-2x2-ESPN',
	    'container': 'taboola-below-section-front-thumbnails',
	    'container_webview': 'taboola-below-section-front-thumbnails',
	    'target_type': 'mix'
	  },
	  'report': {
	    'type': 'category',
	    'mode': 'thumbnails-3x1-b',
	    'mode_webview': 'thumbnails-2x2-ESPN',
	    'container': 'taboola-below-section-front-thumbnails',
	    'container_webview': 'taboola-below-section-front-thumbnails',
	    'target_type': 'mix'
	  },
	  'team': {
	    'right-rail': {
	      'type': 'other',
	      'mode': 'thumbnails-1x3',
	      'container': 'taboola-right-rail-thumbnails',
	      'target_type': 'mix'
	    }
	  }
	};

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge2 = __webpack_require__(581);
	
	var _merge3 = _interopRequireDefault(_merge2);
	
	var _taboola = __webpack_require__(680);
	
	var _taboola2 = _interopRequireDefault(_taboola);
	
	var _taboolaDefaults = __webpack_require__(668);
	
	var _taboolaDefaults2 = _interopRequireDefault(_taboolaDefaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  'editionSettings': {
	    'key': 'espnww-en',
	    'site': 'espn',
	    'language': 'en',
	    'country': 'ww',
	    'domain': 'global.espn.com',
	    'editionSiteId': '25',
	    'https': true
	  },
	  'navId': '21959715',
	  'dictionarySection': 'espn',
	  'javaLocale': {
	    'language': 'en',
	    'region': 'GB'
	  },
	  'dateTime': {
	    'long': 'dddd MMMM d, yyyy',
	    'medium': 'MMMM d, yyyy',
	    'short': 'M/d',
	    'timeFormat': 'h:mm',
	    'firstDayOfWeek': 'Sunday',
	    'timeZone': 'Etc/GMT',
	    'defaultFormat': 'd MMM, yyyy',
	    'timeZoneString': 'GMT',
	    'timeZoneBucket': 'America/New_York',
	    'MMM D, YYYY': 'D MMM, YYYY',
	    'M/D/YYYY': 'D/M/YYYY',
	    'MM/DD/YYYY': 'DD/MM/YYYY',
	    'MMDDYYYY': 'DDMMYYYY',
	    'MMMM Do YYYY': 'Do MMMM YYYY',
	    'dddd, MMMM Do YYYY': 'dddd, Do MMMM YYYY',
	    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
	    'M/D': 'D/M',
	    'ddd, M/D': 'ddd, D/M',
	    'MMMM D, YYYY': 'D MMMM YYYY',
	    'dddd, M/D': 'dddd, D/M',
	    'age': {
	      'seconds': 's',
	      'minutes': 'm',
	      'hours': 'h',
	      'days': 'd'
	    }
	  },
	  'numberFormat': {
	    'long': '#,###',
	    'short': '###',
	    'currency': '#,###.00',
	    'percent': '#.00%'
	  },
	  'temperature': {
	    'scale': 'celsius',
	    'symbol': '&deg; C'
	  },
	  'sponsoredContentProviders': ['taboola', 'outbrain'],
	  'taboola': (0, _merge3.default)({}, _taboolaDefaults2.default, _taboola2.default),
	  'outbrain': {
	    'enabled': true,
	    'template': 'ESPNGlobal',
	    'desktop': {
	      'compliantId': 'AR_15',
	      'nonCompliantId': 'AR_12'
	    },
	    'mobile': {
	      'compliantId': 'MR_4',
	      'nonCompliantId': 'MB_5'
	    },
	    'video': {
	      'desktop': {
	        'compliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6'
	      }
	    },
	    'recap': {
	      'desktop': {
	        'compliantId': 'AR_6',
	        'nonCompliantId': 'AR_30'
	      },
	      'mobile': {
	        'compliantId': 'MB_3',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'team': {
	      'desktop': {
	        'compliantId': 'SB_1'
	      },
	      'mobile': {
	        'compliantId': 'SB_1'
	      }
	    }
	  },
	  'omniture': {
	    'enabled': true
	  },
	  'chartBeat': {
	    'enabled': true
	  },
	  'ads': {
	    'disabled': false,
	    'partnerAd': false,
	    'dev-config': 22029728,
	    'qa-config': 22029728,
	    'prod-config': 22029728
	  },
	  'partnerModules': {
	    'global': true,
	    'nba': true,
	    'womenbb': true,
	    'golf': true,
	    'endurance': true,
	    'horse': true,
	    'nascar': true
	  },
	  'sportBranding': [{
	    'sport': 'cricket',
	    'image': 'logo-uk-cricinfo',
	    'url': null
	  }, {
	    'sport': 'soccer',
	    'image': 'logo-uk-fc',
	    'url': null
	  }, {
	    'sport': 'rugby',
	    'image': 'logo-uk-scrum',
	    'url': null
	  }, {
	    'sport': 'ncaaw',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': 'http://www.espnw.com'
	  }, {
	    'sport': 'ncw',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': 'http://www.espnw.com'
	  }, {
	    'sport': 'wnba',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': 'http://www.espnw.com'
	  }, {
	    'sport': 'womenbb',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': 'http://www.espnw.com'
	  }],
	  'siteLogo': {
	    'class': '',
	    'featurePhone': {
	      'name': 'espn-logo',
	      'width': 45,
	      'height': 11
	    }
	  },
	  'meta': {
	    'titleBranding': ' - ESPN',
	    'description': 'Visit ESPN to get up-to-the-minute sports news coverage, scores, highlights and commentary for Football, NBA, NFL, Cricket, Rugby, Golf and more.',
	    'defaultMetaImage': 'espn_red.png',
	    'social': {
	      'twitter': {
	        'twitterId': '',
	        'card': 'summary',
	        'app_id_iphone': '317469184',
	        'site': 'espn',
	        'app_name_googleplay': 'ESPN',
	        'app_id_googleplay': 'com.espn.score_center',
	        'app_name_iphone': 'ESPN',
	        'language': 'en'
	      },
	      'facebook': {
	        'id': '116656161708917',
	        'og_site_name': 'ESPN.com',
	        'locale': 'en_US'
	      }
	    }
	  },
	  'appDetails': {
	    'ios': {
	      'id': '317469184',
	      'name': 'ESPN',
	      'deepLinkUrl': 'ios-app://317469184/sportscenter',
	      'deepLinkUrlScheme': 'sportscenter'
	    },
	    'android': {
	      'id': 'com.espn.score_center',
	      'name': 'ESPN',
	      'deepLinkUrl': 'android-app://com.espn.score_center/sportscenter',
	      'deepLinkUrlScheme': 'sportscenter'
	    }
	  },
	  'shop': {
	    'enabled': false
	  },
	  'sportReplacements': {},
	  'uriRewrites': {
	    'urls': {
	      'toEdition': {},
	      'toEnglish': {}
	    },
	    'roots': {
	      '/oly/summer/gymnastics/': '/oly/summer/gymnastics/',
	      '/oly/summer/cycling/': '/oly/summer/cycling/',
	      '/college-football/': '/ncf/',
	      '/football/club': '/soccer/team',
	      '/football/': '/soccer/',
	      '/racing/nascar/': '/nascar/',
	      '/racing/': '/rpm/',
	      '/mens-college-basketball/': '/ncb/',
	      '/womens-college-basketball/': '/ncw/',
	      '/womens-basketball/': '/womenbb/',
	      '/olympics/': '/oly/',
	      '/cycling/': '/cycling/',
	      '/figure-skating/': '/oly/',
	      '/college-sports/': '/ncaa/',
	      '/gymnastics/': '/oly/',
	      '/skiing/': '/oly/',
	      '/horse-racing/': '/horse/',
	      '/sports/womenbb/': '/womenbb/',
	      '/sports/horse/': '/horse/',
	      '/nba-summer-league/': '/nba/summerleague/',
	      '/espn/rss/football/': '/espn/rss/soccer/'
	    },
	    'pathSegments': {
	      'table': 'standings',
	      'fixtures': 'schedule'
	    },
	    'paramKeys': {},
	    'paramValues': {}
	  },
	  'betting': {
	    'enabled': true,
	    'provider': 'Bet 365',
	    'affiliateCodes': {
	      'headerScoreboard': '365_728180',
	      'fixtures': '365_728181',
	      'soccerCommentary': '365_728182'
	    },
	    'game': {
	      'enabled': false,
	      'provider': 'Bet 365'
	    },
	    'incontentstrip': true,
	    'fractional': true
	  },
	  'ticketProvider': 'stubHub',
	  'showFavorites': true,
	  'showMobileScoresLink': true,
	  'favoriteSportsManagement': true,
	  'showInsider': false,
	  'showWatch': true,
	  'showCategory': true,
	  'hideCategoryLinks': [600, 1700],
	  'categorySettings': {
	    'leagues': true,
	    'athletes': true,
	    'teams': true,
	    'tags': true
	  },
	  'showFCContent': true,
	  'showCricInfoContent': true,
	  'cookieConsent': true,
	  'scDeepLinking': true,
	  'allowShortUrl': false,
	  'allowPrintUrl': true,
	  'allowUserAccountManagement': true,
	  'nowFeed': true,
	  'hasTickets': true,
	  'searchUrl': 'http://search.espn.com/',
	  'hasSearch': false,
	  'gameSettings': {
	    'topEventsId': 18748368,
	    'promotedSoccerLeaguesCeId': 18748573,
	    'showBroadcast': false
	  },
	  'fallback': {},
	  'editionAlert': {
	    'enabled': true,
	    'text': 'You have come to the all new Global edition, for other ESPN editions, click here.'
	  },
	  'feeds': {
	    'googlenews': {
	      'allowedContentTypes': ['Story', 'HeadlineNews']
	    }
	  },
	  'tier2NavIds': {},
	  'tier3NavIds': {},
	  'latestVideoCollectionId': 18749055,
	  'videoAutoStart': {
	    'index': false,
	    'scoreboard': false
	  },
	  'useMongo': true,
	  'activeSite': true,
	  'countries': []
	};

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge2 = __webpack_require__(581);
	
	var _merge3 = _interopRequireDefault(_merge2);
	
	var _taboola = __webpack_require__(680);
	
	var _taboola2 = _interopRequireDefault(_taboola);
	
	var _taboolaDefaults = __webpack_require__(668);
	
	var _taboolaDefaults2 = _interopRequireDefault(_taboolaDefaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  'editionSettings': {
	    'key': 'espnin-en',
	    'site': 'espn',
	    'language': 'en',
	    'country': 'in',
	    'domain': 'www.espn.in',
	    'editionSiteId': '24',
	    'https': true
	  },
	  'navId': '14327888',
	  'dictionarySection': 'espn',
	  'javaLocale': {
	    'language': 'en',
	    'region': 'IN'
	  },
	  'dateTime': {
	    'long': 'dddd MMMM d, yyyy',
	    'medium': 'MMMM d, yyyy',
	    'short': 'M/d',
	    'timeFormat': 'h:mm',
	    'firstDayOfWeek': 'Sunday',
	    'timeZone': 'Asia/Calcutta',
	    'defaultFormat': 'd MMM, yyyy',
	    'timeZoneString': 'IST',
	    'timeZoneBucket': 'Asia/Kolkata',
	    'MMM D, YYYY': 'D MMM, YYYY',
	    'M/D/YYYY': 'D/M/YYYY',
	    'MM/DD/YYYY': 'DD/MM/YYYY',
	    'MMDDYYYY': 'DDMMYYYY',
	    'MMMM Do YYYY': 'Do MMMM YYYY',
	    'dddd, MMMM Do YYYY': 'dddd, Do MMMM YYYY',
	    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
	    'M/D': 'D/M',
	    'MMMM D, YYYY': 'D MMMM YYYY',
	    'dddd, M/D': 'dddd, D/M',
	    'age': {
	      'seconds': 's',
	      'minutes': 'm',
	      'hours': 'h',
	      'days': 'd'
	    }
	  },
	  'numberFormat': {
	    'long': '#,###',
	    'short': '###',
	    'currency': '#,###.00',
	    'percent': '#.00%'
	  },
	  'temperature': {
	    'scale': 'celsius',
	    'symbol': '&deg; C'
	  },
	  'sponsoredContentProviders': ['taboola', 'outbrain'],
	  'taboola': (0, _merge3.default)({}, _taboolaDefaults2.default, _taboola2.default),
	  'outbrain': {
	    'enabled': true,
	    'template': 'ESPNIndia',
	    'desktop': {
	      'compliantId': 'AR_49',
	      'nonCompliantId': 'AR_12'
	    },
	    'mobile': {
	      'compliantId': 'AR_49',
	      'nonCompliantId': 'MB_5'
	    },
	    'report': {
	      'desktop': {
	        'compliantId': 'AR_30',
	        'nonCompliantId': 'AR_30'
	      },
	      'mobile': {
	        'compliantId': 'MB_9',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'table': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'MB_43'
	      }
	    },
	    'game': {
	      'desktop': {
	        'compliantId': 'AR_48'
	      },
	      'mobile': {
	        'compliantId': 'AR_48'
	      }
	    },
	    'team': {
	      'desktop': {
	        'compliantId': 'SB_1'
	      },
	      'mobile': {
	        'compliantId': 'SB_1'
	      }
	    }
	  },
	  'omniture': {
	    'enabled': true
	  },
	  'chartBeat': {
	    'enabled': true
	  },
	  'ads': {
	    'disabled': false,
	    'network': 1234,
	    'partnerAd': false,
	    'dev-config': 15039572,
	    'qa-config': 15039572,
	    'prod-config': 15039572
	  },
	  'partnerModules': {
	    'global': false,
	    'nba': false,
	    'womenbb': false,
	    'golf': false,
	    'endurance': false,
	    'horse': false,
	    'nascar': false
	  },
	  'sportBranding': [{
	    'sport': 'cricket',
	    'image': 'logo-uk-cricinfo',
	    'url': null
	  }, {
	    'sport': 'soccer',
	    'image': 'logo-uk-fc',
	    'url': null
	  }, {
	    'sport': 'rugby',
	    'image': 'logo-uk-scrum',
	    'url': null
	  }, {
	    'sport': 'ncaaw',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }, {
	    'sport': 'ncw',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }, {
	    'sport': 'wnba',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }, {
	    'sport': 'womenbb',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': null
	  }],
	  'siteLogo': {
	    'class': 'sony-espn',
	    'featurePhone': {
	      'name': 'sonyespn-logo',
	      'width': 62,
	      'height': 34
	    }
	  },
	  'meta': {
	    'titleBranding': ' - ESPN',
	    'description': 'Visit ESPN to get up-to-the-minute sports news coverage, scores, highlights and commentary for cricket, rugby, football, F1, kabaddi and more.',
	    'defaultMetaImage': 'sonyespn_black.png',
	    'social': {
	      'twitter': {
	        'twitterId': '',
	        'card': 'summary',
	        'app_id_iphone': '317469184',
	        'site': 'ESPN',
	        'app_name_googleplay': 'ESPN',
	        'app_id_googleplay': 'com.espn.score_center',
	        'app_name_iphone': 'ESPN',
	        'language': 'en'
	      },
	      'facebook': {
	        'id': '116656161708917',
	        'og_site_name': 'ESPN',
	        'locale': 'en_US'
	      }
	    }
	  },
	  'shop': {
	    'enabled': false
	  },
	  'sportReplacements': {
	    'f1': 'f1',
	    'cycling': 'cycling'
	  },
	  'uriRewrites': {
	    'urls': {
	      'toEdition': {},
	      'toEnglish': {}
	    },
	    'roots': {
	      '/oly/summer/gymnastics/': '/oly/summer/gymnastics/',
	      '/oly/summer/cycling/': '/oly/summer/cycling/',
	      '/college-football/': '/ncf/',
	      '/football/': '/soccer/',
	      '/racing/nascar/': '/nascar/',
	      '/racing/': '/rpm/',
	      '/mens-college-basketball/': '/ncb/',
	      '/womens-college-basketball/': '/ncw/',
	      '/womens-basketball/': '/womenbb/',
	      '/olympics/': '/oly/',
	      '/cycling/': '/cycling/',
	      '/fixtures/': '/schedule',
	      '/figure-skating/': '/oly/',
	      '/college-sports/': '/ncaa/',
	      '/gymnastics/': '/oly/',
	      '/skiing/': '/oly/',
	      '/horse-racing/': '/horse/',
	      '/sports/womenbb/': '/womenbb/',
	      '/sports/horse/': '/horse/'
	    },
	    'pathSegments': {},
	    'paramKeys': {},
	    'paramValues': {}
	  },
	  'betting': {
	    'enabled': false,
	    'provider': 'Bet 365',
	    'game': {
	      'enabled': false,
	      'provider': 'Bet 365'
	    }
	  },
	  'ticketProvider': null,
	  'hasTickets': false,
	  'showFavorites': true,
	  'showInsider': false,
	  'showWatch': false,
	  'hideCategoryLinks': [600, 1700],
	  'categorySettings': {
	    'leagues': true,
	    'athletes': false,
	    'teams': false,
	    'tags': true
	  },
	  'showFCContent': true,
	  'showCricInfoContent': true,
	  'cookieConsent': false,
	  'scDeepLinking': true,
	  'allowShortUrl': false,
	  'allowPrintUrl': true,
	  'allowUserAccountManagement': true,
	  'nowFeed': false,
	  'searchUrl': 'http://search.espn.com/',
	  'hasSearch': true,
	  'gameSettings': {
	    'topEventsId': 14327607,
	    'promotedSoccerLeaguesCeId': 12032789,
	    'showBroadcast': false
	  },
	  'fallback': {
	    'rugby': 'espnuk-en-rugby-index',
	    'horse': 'espnuk-en-horse-index',
	    'nba': 'espn-en-nba-index',
	    'mlb': 'espn-en-mlb-index',
	    'nfl': 'espn-en-nfl-index',
	    'chalk': 'espn-en-chalk-index',
	    'nhl': 'espn-en-nhl-index',
	    'nascar': 'espn-en-nascar-index',
	    'womenbb': 'espn-en-womenbb-index',
	    'ncf': 'espn-en-ncf-index',
	    'ncb': 'espn-en-ncb-index',
	    'boxing': 'espn-en-boxing-index',
	    'mma': 'espn-en-mma-index',
	    'esports': 'espn-en-esports-index',
	    'nba-stephen-curry': 'espn-en-nba-stephen-curry-index',
	    'oly-summer-archery': 'espn-en-oly-summer-archery-index',
	    'oly-summer-athletics': 'espnuk-en-oly-summer-athletics-index',
	    'oly-summer-badminton': 'espn-en-oly-summer-badminton-index',
	    'oly-summer-basketball': 'espnuk-en-oly-summer-basketball-index',
	    'oly-summer-boxing': 'espnuk-en-oly-summer-boxing-index',
	    'oly-summer-canoe': 'espn-en-oly-summer-canoe-index',
	    'oly-summer-cycling': 'espn-en-oly-summer-cycling-index',
	    'oly-summer-equestrian': 'espn-en-oly-summer-equestrian-index',
	    'oly-summer-fencing': 'espn-en-oly-summer-fencing-index',
	    'oly-summer-field-hockey': 'espn-en-oly-summer-field-hockey-index',
	    'oly-summer-golf': 'espnuk-en-oly-summer-golf-index',
	    'oly-summer-gymnastics': 'espnuk-en-oly-summer-gymnastics-index',
	    'oly-summer-handball': 'espn-en-oly-summer-handball-index',
	    'oly-summer-judo': 'espn-en-oly-summer-judo-index',
	    'oly-summer-modern-pentathlon': 'espn-en-oly-summer-modern-pentathlon-index',
	    'oly-summer-rowing': 'espn-en-oly-summer-rowing-index',
	    'oly-summer-rugby': 'espnuk-en-oly-summer-rugby-index',
	    'oly-summer-sailing': 'espn-en-oly-summer-sailing-index',
	    'oly-summer-shooting': 'espn-en-oly-summer-shooting-index',
	    'oly-summer-soccer': 'espnuk-en-oly-summer-soccer-index',
	    'oly-summer-swimming': 'espnuk-en-oly-summer-swimming-index',
	    'oly-summer-table-tennis': 'espn-en-oly-summer-table-tennis-index',
	    'oly-summer-taekwondo': 'espn-en-oly-summer-taekwondo-index',
	    'oly-summer-tennis': 'espnuk-en-oly-summer-tennis-index',
	    'oly-summer-triathlon': 'espn-en-oly-summer-triathlon-index',
	    'oly-summer-volleyball': 'espnuk-en-oly-summer-volleyball-index',
	    'oly-summer-water-polo': 'espn-en-oly-summer-water-polo-index',
	    'oly-summer-weightlifting': 'espn-en-oly-summer-weightlifting-index',
	    'oly-summer-wrestling': 'espn-en-oly-summer-wrestling-index'
	  },
	  'editionAlert': {
	    'enabled': true,
	    'text': 'Welcome to Sony ESPN India Edition'
	  },
	  'feeds': {
	    'googlenews': {
	      'allowedContentTypes': ['Story', 'HeadlineNews']
	    }
	  },
	  'tier2NavIds': {
	    'boston': 12375278,
	    'chicago': 12505826,
	    'cleveland': 13977091,
	    'dallas': 12505828,
	    'los-angeles': 12505831,
	    'milwaukee': 13977360,
	    'new-york': 12505854,
	    'fantasy/basketball': 12405600,
	    'fantasy/football': 12405632,
	    'fantasy/baseball': 12405631,
	    'fantasy/hockey': 12405634,
	    'fantasy': 13609307,
	    'ncfrecruiting': 11588758,
	    'ncbrecruiting': 11588880,
	    'esports': 13663224,
	    'onenacion': 13309315,
	    'nba/stephen-curry': 14950765,
	    'league': {
	      'soccer': 13794648,
	      'ncf': 13886385,
	      'college-football': 13886385,
	      'cricket': 15609108
	    }
	  },
	  'tier3NavIds': {
	    'clubhouse': {
	      'nba': 12293424,
	      'mlb': 12343023,
	      'mens-college-basketball': 13884705,
	      'womens-college-basketball': 13930164,
	      'soccer': 12294454,
	      'nfl': 12509708,
	      'college-football': 13345157,
	      'cricket': 15368856
	    }
	  },
	  'indexAutoStart': false,
	  'useMongo': true,
	  'activeSite': true,
	  'countries': [{
	    'name': 'India',
	    'country-code': 'in',
	    'showHreflang': true
	  }, {
	    'name': 'Bangladesh',
	    'country-code': 'bd',
	    'showHreflang': false
	  }, {
	    'name': 'Bhutan',
	    'country-code': 'bt',
	    'showHreflang': false
	  }, {
	    'name': 'Maldives',
	    'country-code': 'mv',
	    'showHreflang': false
	  }, {
	    'name': 'Nepal',
	    'country-code': 'np',
	    'showHreflang': false
	  }, {
	    'name': 'Pakistan',
	    'country-code': 'pk',
	    'showHreflang': false
	  }, {
	    'name': 'Sri Lanka',
	    'country-code': 'lk',
	    'showHreflang': false
	  }]
	};

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge2 = __webpack_require__(581);
	
	var _merge3 = _interopRequireDefault(_merge2);
	
	var _taboola = __webpack_require__(680);
	
	var _taboola2 = _interopRequireDefault(_taboola);
	
	var _taboolaDefaults = __webpack_require__(668);
	
	var _taboolaDefaults2 = _interopRequireDefault(_taboolaDefaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  'editionSettings': {
	    'key': 'espnph-en',
	    'site': 'espn',
	    'language': 'en',
	    'country': 'ph',
	    'domain': 'tv5.espn.com',
	    'editionSiteId': '30',
	    'https': true
	  },
	  'navId': '20341629',
	  'dictionarySection': 'espn',
	  'javaLocale': {
	    'language': 'en',
	    'region': 'GB'
	  },
	  'dateTime': {
	    'long': 'dddd MMMM d, yyyy',
	    'medium': 'MMMM d, yyyy',
	    'short': 'M/d',
	    'timeFormat': 'h:mm',
	    'firstDayOfWeek': 'Sunday',
	    'timeZone': 'Asia/Manila',
	    'defaultFormat': 'd MMM, yyyy',
	    'timeZoneString': 'PHT',
	    'timeZoneBucket': 'Australia/Melbourne',
	    'MMM D, YYYY': 'D MMM, YYYY',
	    'M/D/YYYY': 'D/M/YYYY',
	    'MM/DD/YYYY': 'DD/MM/YYYY',
	    'MMDDYYYY': 'DDMMYYYY',
	    'MMMM Do YYYY': 'Do MMMM YYYY',
	    'dddd, MMMM Do YYYY': 'dddd, Do MMMM YYYY',
	    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
	    'M/D': 'D/M',
	    'ddd, M/D': 'ddd, D/M',
	    'MMMM D, YYYY': 'D MMMM YYYY',
	    'dddd, M/D': 'dddd, D/M',
	    'age': {
	      'seconds': 's',
	      'minutes': 'm',
	      'hours': 'h',
	      'days': 'd'
	    }
	  },
	  'numberFormat': {
	    'long': '#,###',
	    'short': '###',
	    'currency': '#,###.00',
	    'percent': '#.00%'
	  },
	  'temperature': {
	    'scale': 'celsius',
	    'symbol': '&deg; C'
	  },
	  'sponsoredContentProviders': ['taboola', 'outbrain'],
	  'taboola': (0, _merge3.default)({}, _taboolaDefaults2.default, _taboola2.default),
	  'outbrain': {
	    'enabled': true,
	    'template': 'ESPNPhilippines',
	    'desktop': {
	      'compliantId': 'AR_15',
	      'nonCompliantId': 'AR_12'
	    },
	    'mobile': {
	      'compliantId': 'MR_4',
	      'nonCompliantId': 'MB_5'
	    },
	    'video': {
	      'desktop': {
	        'compliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6'
	      }
	    },
	    'recap': {
	      'desktop': {
	        'compliantId': 'AR_6',
	        'nonCompliantId': 'AR_30'
	      },
	      'mobile': {
	        'compliantId': 'MB_3',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'team': {
	      'desktop': {
	        'compliantId': 'SB_1'
	      },
	      'mobile': {
	        'compliantId': 'SB_1'
	      }
	    }
	  },
	  'omniture': {
	    'enabled': true
	  },
	  'chartBeat': {
	    'enabled': true
	  },
	  'ads': {
	    'disabled': false,
	    'partnerAd': false,
	    'dev-config': 22029737,
	    'qa-config': 22029737,
	    'prod-config': 22029737
	  },
	  'partnerModules': {
	    'global': true,
	    'nba': true,
	    'womenbb': true,
	    'golf': true,
	    'endurance': true,
	    'horse': true,
	    'nascar': true
	  },
	  'sportBranding': [{
	    'sport': 'cricket',
	    'image': 'logo-uk-cricinfo',
	    'url': null
	  }, {
	    'sport': 'soccer',
	    'image': 'logo-uk-fc',
	    'url': null
	  }, {
	    'sport': 'rugby',
	    'image': 'logo-uk-scrum',
	    'url': null
	  }, {
	    'sport': 'ncaaw',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': 'http://www.espnw.com'
	  }, {
	    'sport': 'ncw',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': 'http://www.espnw.com'
	  }, {
	    'sport': 'wnba',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': 'http://www.espnw.com'
	  }, {
	    'sport': 'womenbb',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': 'http://www.espnw.com'
	  }],
	  'siteLogo': {
	    'class': 'espn-tv5',
	    'featurePhone': {
	      'name': 'tv5-espn-logo',
	      'width': 94,
	      'height': 30
	    }
	  },
	  'meta': {
	    'titleBranding': ' - ESPN',
	    'description': 'Visit ESPN to get up-to-the-minute sports news coverage, scores, highlights and commentary for NBA, PBA, American NCAA Basketball, eSports, NFL, Boxing and more.',
	    'defaultMetaImage': 'espn_red.png',
	    'social': {
	      'twitter': {
	        'twitterId': '',
	        'card': 'summary',
	        'app_id_iphone': '317469184',
	        'site': 'espn',
	        'app_name_googleplay': 'ESPN',
	        'app_id_googleplay': 'com.espn.score_center',
	        'app_name_iphone': 'ESPN',
	        'language': 'en'
	      },
	      'facebook': {
	        'id': '116656161708917',
	        'og_site_name': 'ESPN.com',
	        'locale': 'en_US'
	      }
	    }
	  },
	  'appDetails': {
	    'ios': {
	      'id': '317469184',
	      'name': 'ESPN',
	      'deepLinkUrl': 'ios-app://317469184/sportscenter',
	      'deepLinkUrlScheme': 'sportscenter'
	    },
	    'android': {
	      'id': 'com.espn.score_center',
	      'name': 'ESPN',
	      'deepLinkUrl': 'android-app://com.espn.score_center/sportscenter',
	      'deepLinkUrlScheme': 'sportscenter'
	    }
	  },
	  'shop': {
	    'enabled': false
	  },
	  'sportReplacements': {},
	  'uriRewrites': {
	    'urls': {
	      'toEdition': {},
	      'toEnglish': {}
	    },
	    'roots': {
	      '/oly/summer/gymnastics/': '/oly/summer/gymnastics/',
	      '/oly/summer/cycling/': '/oly/summer/cycling/',
	      '/college-football/': '/ncf/',
	      '/football/club': '/soccer/team',
	      '/football/': '/soccer/',
	      '/racing/nascar/': '/nascar/',
	      '/racing/': '/rpm/',
	      '/mens-college-basketball/': '/ncb/',
	      '/womens-college-basketball/': '/ncw/',
	      '/womens-basketball/': '/womenbb/',
	      '/olympics/': '/oly/',
	      '/cycling/': '/cycling/',
	      '/figure-skating/': '/oly/',
	      '/college-sports/': '/ncaa/',
	      '/gymnastics/': '/oly/',
	      '/skiing/': '/oly/',
	      '/horse-racing/': '/horse/',
	      '/sports/womenbb/': '/womenbb/',
	      '/sports/horse/': '/horse/',
	      '/nba-summer-league/': '/nba/summerleague/',
	      '/espn/rss/football/': '/espn/rss/soccer/'
	    },
	    'pathSegments': {
	      'table': 'standings',
	      'fixtures': 'schedule'
	    },
	    'paramKeys': {},
	    'paramValues': {}
	  },
	  'betting': {
	    'enabled': false,
	    'game': {
	      'enabled': false
	    }
	  },
	  'ticketProvider': 'stubHub',
	  'showFavorites': true,
	  'showMobileScoresLink': true,
	  'favoriteSportsManagement': true,
	  'showInsider': false,
	  'showWatch': true,
	  'showCategory': true,
	  'hideCategoryLinks': [600, 1700],
	  'categorySettings': {
	    'leagues': true,
	    'athletes': true,
	    'teams': true,
	    'tags': true
	  },
	  'showFCContent': true,
	  'showCricInfoContent': true,
	  'cookieConsent': true,
	  'scDeepLinking': true,
	  'allowShortUrl': false,
	  'allowPrintUrl': true,
	  'allowUserAccountManagement': true,
	  'nowFeed': true,
	  'hasTickets': true,
	  'searchUrl': 'http://search.espn.com/',
	  'hasSearch': false,
	  'gameSettings': {
	    'topEventsId': 4379198,
	    'promotedSoccerLeaguesCeId': 20341678,
	    'showBroadcast': false
	  },
	  'fallback': {},
	  'editionAlert': {
	    'enabled': true,
	    'text': 'You have come to the Philippines Edition, for other ESPN editions, click here.'
	  },
	  'feeds': {
	    'googlenews': {
	      'allowedContentTypes': ['Story', 'HeadlineNews']
	    }
	  },
	  'tier2NavIds': {},
	  'tier3NavIds': {},
	  'latestVideoCollectionId': 20341683,
	  'videoAutoStart': {
	    'index': false,
	    'scoreboard': false
	  },
	  'useMongo': true,
	  'activeSite': true,
	  'countries': [{
	    'name': 'Philippines',
	    'country-code': 'ph',
	    'showHreflang': true
	  }]
	};

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(685);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _pathSegments;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//git hash 657b12df19f9a0382de75766eb33aa0b51010fb9
	exports.default = {
	  'editionSettings': {
	    'key': 'espn-pt-br',
	    'site': 'espn',
	    'language': 'pt',
	    'country': 'br',
	    'domain': 'www.espn.com.br',
	    'editionSiteId': '26',
	    'https': false,
	    'supportsOneSite': true
	  },
	  'navId': '2703654',
	  'dictionarySection': 'espn',
	  'javaLocale': {
	    'language': 'pt',
	    'region': 'BR'
	  },
	  'dateTime': {
	    'long': 'dddd MMMM d, yyyy',
	    'medium': 'MMMM d, yyyy',
	    'short': 'M/d',
	    'timeFormat': 'h:mm',
	    'firstDayOfWeek': 'Sunday',
	    'timeZone': 'US/Eastern',
	    'defaultFormat': 'd MMM, yyyy',
	    'timeZoneString': 'ET',
	    'timeZoneBucket': 'America/New_York',
	    'MMM D, YYYY': 'D MMM, YYYY',
	    'M/D/YYYY': 'D/M/YYYY',
	    'MM/DD/YYYY': 'DD/MM/YYYY',
	    'MMDDYYYY': 'DDMMYYYY',
	    'MMMM Do YYYY': 'Do MMMM YYYY',
	    'dddd, MMMM Do YYYY': 'dddd, Do MMMM YYYY',
	    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
	    'M/D': 'D/M',
	    'MMMM D, YYYY': 'D MMMM YYYY',
	    'dddd, M/D': 'dddd, D/M',
	    'age': {
	      'seconds': 's',
	      'minutes': 'm',
	      'hours': 'h',
	      'days': 'd'
	    }
	  },
	  'numberFormat': {
	    'long': '#,###',
	    'short': '###',
	    'currency': '#,###.00',
	    'percent': '#.00%'
	  },
	  'temperature': {
	    'scale': 'celsius',
	    'symbol': '&deg; C'
	  },
	  'outbrain': {
	    'enabled': true,
	    'template': 'ESPNBrazil',
	    'desktop': {
	      'compliantId': 'AR_15',
	      'nonCompliantId': 'AR_12'
	    },
	    'mobile': {
	      'compliantId': 'MB_4',
	      'nonCompliantId': 'MB_5'
	    },
	    'video': {
	      'desktop': {
	        'compliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6'
	      }
	    },
	    'report': {
	      'desktop': {
	        'compliantId': 'AR_6',
	        'nonCompliantId': 'AR_30'
	      },
	      'mobile': {
	        'compliantId': 'MB_3',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'table': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'MB_43'
	      }
	    },
	    'game': {
	      'desktop': {
	        'compliantId': 'AR_48'
	      },
	      'mobile': {
	        'compliantId': 'AR_48'
	      }
	    }
	  },
	  'omniture': {
	    'enabled': true
	  },
	  'chartBeat': {
	    'enabled': true
	  },
	  'ads': {
	    'disabled': false,
	    'network': 1234,
	    'partnerAd': false,
	    'dev-config': 21171680,
	    'qa-config': 21171680,
	    'prod-config': 21171680,
	    'outputType': 'js',
	    'featurePhone': {
	      'outputType': 'no-js'
	    }
	  },
	  'partnerModules': {
	    'global': false,
	    'nba': false,
	    'womenbb': false,
	    'golf': false,
	    'endurance': false,
	    'horse': false,
	    'nascar': false
	  },
	  'sportBranding': [{
	    'sport': 'espnw',
	    'image': 'espncom-apresentadopor-espnw',
	    'url': '/espnw/'
	  }],
	  'siteLogo': {
	    'class': '',
	    'featurePhone': {
	      'name': 'espn-logo',
	      'width': 45,
	      'height': 11
	    }
	  },
	  'meta': {
	    'titleBranding': ' - ESPN',
	    'description': 'ESPN',
	    'defaultMetaImage': 'espn_red.png',
	    'schema': {
	      'name': 'ESPN'
	    },
	    'social': {
	      'twitter': {
	        'twitterId': '',
	        'card': 'summary',
	        'app_id_iphone': '317469184',
	        'site': 'espn',
	        'app_name_googleplay': 'ESPN',
	        'app_id_googleplay': 'com.espn.score_center',
	        'app_name_iphone': 'ESPN',
	        'language': 'pt'
	      },
	      'facebook': {
	        'id': '116656161708917',
	        'og_site_name': 'ESPN.com.ar',
	        'locale': 'pt_BR'
	      }
	    }
	  },
	  'shop': {
	    'enabled': false
	  },
	  'sportReplacements': {
	    'f1': 'f1',
	    'cycling': 'cycling',
	    'bola-de-prata': 'soccer',
	    'data-espn': 'soccer',
	    'ranking-dos-treinadores': 'soccer',
	    'selecao-brasileira': 'soccer'
	  },
	  'uriRewrites': {
	    'urls': {
	      'toEdition': {
	        '/beisbol/mlb/': '/beisbol/'
	      },
	      'toEnglish': {}
	    },
	    'roots': {
	      'toEdition': {},
	      'toEnglish': {}
	    },
	    'pathSegments': (_pathSegments = {
	      'reporte': 'report',
	      'jogo': 'game',
	      'time': 'team',
	      'elenco': 'roster',
	      'estatisticas': 'stats',
	      'calendario': 'schedule',
	      'estadio': 'stadium',
	      'profundidad': 'depth',
	      'bate-papo': 'conversation',
	      'placar': 'boxscore',
	      'previa': 'preview',
	      'partida': 'match',
	      'minuto-a-minuto': 'playbyplay',
	      'cronica': 'recap',
	      'fotos': 'photos',
	      'confronto': 'matchup',
	      'classificacao': 'standings'
	    }, (0, _defineProperty3.default)(_pathSegments, 'classificacao', 'table'), (0, _defineProperty3.default)(_pathSegments, 'temporada', 'season'), (0, _defineProperty3.default)(_pathSegments, 'resultados', 'scoreboard'), (0, _defineProperty3.default)(_pathSegments, 'liga', 'league'), (0, _defineProperty3.default)(_pathSegments, 'ligas', 'leagues'), (0, _defineProperty3.default)(_pathSegments, 'artigo', 'story'), (0, _defineProperty3.default)(_pathSegments, 'olimpiadas', 'olympics'), (0, _defineProperty3.default)(_pathSegments, 'verao', 'summer'), (0, _defineProperty3.default)(_pathSegments, 'comentarios', 'commentary'), (0, _defineProperty3.default)(_pathSegments, 'escalacoes', 'lineups'), (0, _defineProperty3.default)(_pathSegments, 'escalacao', 'lineup'), (0, _defineProperty3.default)(_pathSegments, 'estatisticas-partida', 'matchstats'), (0, _defineProperty3.default)(_pathSegments, 'jogador-estatisticas', 'playerstats'), (0, _defineProperty3.default)(_pathSegments, 'deportes', 'sports'), (0, _defineProperty3.default)(_pathSegments, 'atletas', 'athletes'), (0, _defineProperty3.default)(_pathSegments, 'ranking', 'leaderboard'), (0, _defineProperty3.default)(_pathSegments, 'jogador', 'player'), (0, _defineProperty3.default)(_pathSegments, 'lesoes', 'injuries'), (0, _defineProperty3.default)(_pathSegments, 'rebatendo', 'batting'), (0, _defineProperty3.default)(_pathSegments, 'piloto', 'driver'), (0, _defineProperty3.default)(_pathSegments, 'clipe', 'clip'), (0, _defineProperty3.default)(_pathSegments, 'data', 'date'), _pathSegments),
	    'paramKeys': {
	      'jogoId': 'gameId',
	      'data': 'date',
	      'nome': 'name',
	      'partida': 'gameID',
	      'temporada': 'season',
	      'tipodetemporada': 'seasontype',
	      'ano': 'year',
	      'semana': 'week',
	      'modalidade': 'discipline',
	      'evento': 'event',
	      'tournamentId': 'tournamentId',
	      'atleta': 'athlete',
	      'vs-division': 'view',
	      'pais': 'country',
	      'pagina': 'page',
	      'continuo': 'continuous',
	      'rodada': 'round',
	      'posicao': 'position',
	      'time': 'team',
	      'ligas': 'leagues',
	      'liga': 'league'
	    },
	    'paramValues': {
	      'liga': 'league',
	      'ligas': 'leagues',
	      'todos': 'all',
	      'atletas': 'athletes',
	      'paises': 'countries'
	    }
	  },
	  'betting': {
	    'enabled': false,
	    'provider': '',
	    'game': {
	      'enabled': false,
	      'provider': ''
	    }
	  },
	  'ticketProvider': null,
	  'hasTickets': false,
	  'showFavorites': true,
	  'showInsider': false,
	  'showWatch': true,
	  'hideCategoryLinks': [600, 1700],
	  'categorySettings': {
	    'leagues': true,
	    'athletes': true,
	    'teams': true,
	    'tags': true
	  },
	  'showFCContent': true,
	  'showCricInfoContent': false,
	  'cookieConsent': false,
	  'scDeepLinking': true,
	  'allowShortUrl': false,
	  'allowPrintUrl': true,
	  'allowUserAccountManagement': true,
	  'nowFeed': false,
	  'searchUrl': 'http://buscar.espn.com/',
	  'gameSettings': {
	    'topEventsId': 2993187,
	    'promotedSoccerLeaguesCeId': 2993207,
	    'showBroadcast': true
	  },
	  fallback: {
	    'athletics': 'espn-pt-br-athletics-index',
	    'baseball': 'espn-pt-br-baseball-index',
	    'brazilian-basketball': 'espn-pt-br-brazilian-basketball-index',
	    'bola-de-prata': 'espn-pt-br-bola-de-prata-index',
	    'cycling': 'espn-pt-br-cycling-index',
	    'data-espn': 'espn-pt-br-data-espn-index',
	    'esports': 'espn-pt-br-esports-index',
	    'espnw': 'espn-pt-br-espnw-index',
	    'f1': 'espn-pt-br-f1-index',
	    'futsal': 'espn-pt-br-futsal-index',
	    'golf': 'espn-pt-br-golf-index',
	    'jogo-limpo': 'espn-pt-br-jogo-limpo-index',
	    'judo': 'espn-pt-br-judo-index',
	    'mlb': 'espn-pt-br-baseball-index',
	    'mma': 'espn-pt-br-mma-index',
	    'rpm': 'espn-pt-br-motorsports-index',
	    'nhl': 'espn-pt-br-nhl-index',
	    'olympics': 'espn-pt-br-olympics-index',
	    'poker': 'espn-pt-br-poker-index',
	    'ranking-dos-treinadores': 'espn-pt-br-ranking-dos-treinadores-index',
	    'rugby': 'espn-pt-br-rugby-index',
	    'selecao-brasileira': 'espn-pt-br-selecao-brasileira-index',
	    'soccer': 'espn-pt-br-soccer-index',
	    'swimming': 'espn-pt-br-swimming-index',
	    'surfing': 'espn-pt-br-surfing-index',
	    'tennis': 'espn-pt-br-tennis-index',
	    'volleyball': 'espn-pt-br-volleyball-index',
	    'x-games': 'espn-pt-br-x-games-index'
	  },
	  'editionAlert': {
	    'enabled': true,
	    'text': 'Você está na Edição Brasil. Para acessar edições de outras regiões, clique aqui.'
	  },
	  'feeds': {
	    'googlenews': {
	      'allowedContentTypes': ['TopStoryPackage', 'HeadlineNews', 'BlogEntry']
	    }
	  },
	  'tier2NavIds': {
	    'athletics': 3608032,
	    'baseball': 3608093,
	    'brazilian-basketball': 3688079,
	    'cycling': 3608094,
	    'esports': 3608105,
	    'espnw': 3608104,
	    'f1': 3608106,
	    'futsal': 3608108,
	    'golf': 3608116,
	    'jogo-limpo': 3608119,
	    'judo': 3608128,
	    'mlb': 3608093,
	    'mma': 3608120,
	    'rpm': 3608121,
	    'nba': 3608080,
	    'nfl': 3608122,
	    'nhl': 3608123,
	    'olympics': 3608283,
	    'poker': 3608138,
	    'rugby': 3608129,
	    'selecao-brasileira': 3688073,
	    'ranking-dos-treinadores': 3608107,
	    'bola-de-prata': 3608107,
	    'data-espn': 3608107,
	    'soccer': 3608107,
	    'surfing': 3608139,
	    'tennis': 3608140,
	    'volleyball': 3608141,
	    'x-games': 3608143,
	    'watch': 3046242
	  },
	  'tier3NavIds': {
	    'clubhouse': {
	      'nfl': 2993221,
	      'mlb': 2993223,
	      'nba': 2993227,
	      'soccer': 2993231
	    }
	  },
	  'indexAutoStart': false,
	  'useMongo': false,
	  'activeSite': true,
	  'countries': [{
	    'name': 'Brazil',
	    'country-code': 'br',
	    'showHreflang': true
	  }],
	  'reactOverride': {
	    'cricket': {
	      'scores': true
	    }
	  }
	};

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(308);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge2 = __webpack_require__(581);
	
	var _merge3 = _interopRequireDefault(_merge2);
	
	var _taboola = __webpack_require__(680);
	
	var _taboola2 = _interopRequireDefault(_taboola);
	
	var _taboolaDefaults = __webpack_require__(668);
	
	var _taboolaDefaults2 = _interopRequireDefault(_taboolaDefaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  'editionSettings': {
	    'key': 'espnza-en',
	    'site': 'espn',
	    'language': 'en',
	    'country': 'za',
	    'domain': 'africa.espn.com',
	    'editionSiteId': '27',
	    'https': true
	  },
	  'navId': '18748270',
	  'dictionarySection': 'espn',
	  'javaLocale': {
	    'language': 'en',
	    'region': 'GB'
	  },
	  'dateTime': {
	    'long': 'dddd MMMM d, yyyy',
	    'medium': 'MMMM d, yyyy',
	    'short': 'M/d',
	    'timeFormat': 'h:mm',
	    'firstDayOfWeek': 'Sunday',
	    'timeZone': 'Etc/GMT',
	    'defaultFormat': 'd MMM, yyyy',
	    'timeZoneString': 'GMT',
	    'timeZoneBucket': 'Europe/London',
	    'MMM D, YYYY': 'D MMM, YYYY',
	    'M/D/YYYY': 'D/M/YYYY',
	    'MM/DD/YYYY': 'DD/MM/YYYY',
	    'MMDDYYYY': 'DDMMYYYY',
	    'MMMM Do YYYY': 'Do MMMM YYYY',
	    'dddd, MMMM Do YYYY': 'dddd, Do MMMM YYYY',
	    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
	    'M/D': 'D/M',
	    'ddd, M/D': 'ddd, D/M',
	    'MMMM D, YYYY': 'D MMMM YYYY',
	    'dddd, M/D': 'dddd, D/M',
	    'age': {
	      'seconds': 's',
	      'minutes': 'm',
	      'hours': 'h',
	      'days': 'd'
	    }
	  },
	  'numberFormat': {
	    'long': '#,###',
	    'short': '###',
	    'currency': '#,###.00',
	    'percent': '#.00%'
	  },
	  'temperature': {
	    'scale': 'celsius',
	    'symbol': '&deg; C'
	  },
	  'sponsoredContentProviders': ['taboola', 'outbrain'],
	  'taboola': (0, _merge3.default)({}, _taboolaDefaults2.default, _taboola2.default),
	  'outbrain': {
	    'enabled': true,
	    'template': 'ESPNAfrica',
	    'desktop': {
	      'compliantId': 'AR_49',
	      'nonCompliantId': 'AR_4'
	    },
	    'mobile': {
	      'compliantId': 'AR_49',
	      'nonCompliantId': 'MB_6'
	    },
	    'video': {
	      'desktop': {
	        'compliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6'
	      }
	    },
	    'recap': {
	      'desktop': {
	        'compliantId': 'AR_30',
	        'nonCompliantId': 'AR_30'
	      },
	      'mobile': {
	        'compliantId': 'MB_9',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'report': {
	      'desktop': {
	        'compliantId': 'AR_30',
	        'nonCompliantId': 'AR_30'
	      },
	      'mobile': {
	        'compliantId': 'MB_9',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'table': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'MB_43'
	      }
	    },
	    'game': {
	      'desktop': {
	        'compliantId': 'AR_48'
	      },
	      'mobile': {
	        'compliantId': 'AR_48'
	      }
	    },
	    'team': {
	      'desktop': {
	        'compliantId': 'SB_1'
	      },
	      'mobile': {
	        'compliantId': 'SB_1'
	      }
	    }
	  },
	  'omniture': {
	    'enabled': true
	  },
	  'chartBeat': {
	    'enabled': true
	  },
	  'ads': {
	    'disabled': false,
	    'partnerAd': false,
	    'dev-config': 18968331,
	    'qa-config': 18968331,
	    'prod-config': 18968331
	  },
	  'partnerModules': {
	    'global': true,
	    'nba': true,
	    'womenbb': true,
	    'golf': true,
	    'endurance': true,
	    'horse': true,
	    'nascar': true
	  },
	  'sportBranding': [{
	    'sport': 'cricket',
	    'image': 'logo-uk-cricinfo',
	    'url': null
	  }, {
	    'sport': 'soccer',
	    'image': 'logo-uk-fc',
	    'url': null
	  }, {
	    'sport': 'rugby',
	    'image': 'logo-uk-scrum',
	    'url': null
	  }, {
	    'sport': 'ncaaw',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': 'http://www.espnw.com'
	  }, {
	    'sport': 'ncw',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': 'http://www.espnw.com'
	  }, {
	    'sport': 'wnba',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': 'http://www.espnw.com'
	  }, {
	    'sport': 'womenbb',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': 'http://www.espnw.com'
	  }],
	  'siteLogo': {
	    'class': 'africa',
	    'featurePhone': {
	      'name': 'kwese-espn-logo',
	      'width': 100,
	      'height': 20
	    }
	  },
	  'meta': {
	    'titleBranding': ' - ESPN',
	    'description': 'Visit ESPN to get up-to-the-minute sports news coverage, scores, highlights and commentary for NFL, MLB, NBA, College Football, NCAA Basketball and more.',
	    'defaultMetaImage': 'espn_red.png',
	    'social': {
	      'twitter': {
	        'twitterId': '',
	        'card': 'summary',
	        'app_id_iphone': '317469184',
	        'site': 'espn',
	        'app_name_googleplay': 'ESPN',
	        'app_id_googleplay': 'com.espn.score_center',
	        'app_name_iphone': 'ESPN',
	        'language': 'en'
	      },
	      'facebook': {
	        'id': '116656161708917',
	        'og_site_name': 'ESPN.com',
	        'locale': 'en_US'
	      }
	    }
	  },
	  'appDetails': {
	    'ios': {
	      'id': '317469184',
	      'name': 'ESPN',
	      'deepLinkUrl': 'ios-app://317469184/sportscenter',
	      'deepLinkUrlScheme': 'sportscenter'
	    },
	    'android': {
	      'id': 'com.espn.score_center',
	      'name': 'ESPN',
	      'deepLinkUrl': 'android-app://com.espn.score_center/sportscenter',
	      'deepLinkUrlScheme': 'sportscenter'
	    }
	  },
	  'shop': {
	    'enabled': false
	  },
	  'sportReplacements': {},
	  'uriRewrites': {
	    'urls': {
	      'toEdition': {},
	      'toEnglish': {}
	    },
	    'roots': {
	      '/oly/summer/gymnastics/': '/oly/summer/gymnastics/',
	      '/oly/summer/cycling/': '/oly/summer/cycling/',
	      '/college-football/': '/ncf/',
	      '/football/club': '/soccer/team',
	      '/football/': '/soccer/',
	      '/racing/nascar/': '/nascar/',
	      '/racing/': '/rpm/',
	      '/mens-college-basketball/': '/ncb/',
	      '/womens-college-basketball/': '/ncw/',
	      '/womens-basketball/': '/womenbb/',
	      '/olympics/': '/oly/',
	      '/cycling/': '/cycling/',
	      '/figure-skating/': '/oly/',
	      '/college-sports/': '/ncaa/',
	      '/gymnastics/': '/oly/',
	      '/skiing/': '/oly/',
	      '/horse-racing/': '/horse/',
	      '/sports/womenbb/': '/womenbb/',
	      '/sports/horse/': '/horse/'
	    },
	    'pathSegments': {},
	    'paramKeys': {},
	    'paramValues': {}
	  },
	  'betting': {
	    'enabled': true,
	    'game': {
	      'enabled': true
	    }
	  },
	  'ticketProvider': 'stubHub',
	  'showFavorites': true,
	  'showMobileScoresLink': true,
	  'favoriteSportsManagement': true,
	  'showInsider': false,
	  'showWatch': true,
	  'showCategory': true,
	  'hideCategoryLinks': [600, 1700],
	  'categorySettings': {
	    'leagues': true,
	    'athletes': true,
	    'teams': true,
	    'tags': true
	  },
	  'showFCContent': true,
	  'showCricInfoContent': true,
	  'cookieConsent': true,
	  'scDeepLinking': true,
	  'allowShortUrl': true,
	  'allowPrintUrl': true,
	  'allowUserAccountManagement': true,
	  'nowFeed': true,
	  'hasTickets': true,
	  'searchUrl': 'http://search.espn.com/',
	  'hasSearch': false,
	  'gameSettings': {
	    'topEventsId': 18748358,
	    'promotedSoccerLeaguesCeId': 18748551,
	    'showBroadcast': true
	  },
	  'fallback': {
	
	    // curated indices: soccer, nba, rugby, cricket
	    // automated indices: athletics, esports, cycling
	
	    // fallback
	
	    // UK
	    'f1': 'espnuk-en-f1-index',
	    'tennis': 'espnuk-en-tennis-index',
	    'golf': 'espnuk-en-golf-index',
	    'darts': 'espnuk-en-darts-index',
	    'snooker': 'espnuk-en-snooker-index',
	
	    // US
	    'mma': 'espn-en-mma-index',
	    'boxing': 'espn-en-boxing-index',
	    'nfl': 'espn-en-nfl-index',
	    'mlb': 'espn-en-mlb-index',
	    'nhl': 'espn-en-nhl-index',
	    'womenbb': 'espn-en-womenbb-index',
	    'wwe': 'espn-en-wwe-index',
	    'nascar': 'espn-en-nascar-index',
	    'ncf': 'espn-en-ncf-index',
	    'ncb': 'espn-en-ncb-index',
	    'ncaa': 'espn-en-ncaa-index',
	    'oly': 'espn-en-oly-index',
	    'endurance': 'espn-en-endurance-index',
	    'specialolympics': 'espn-en-specialolympics-index',
	
	    // AU
	    'motogp': 'espnau-en-motogp-index',
	    'afl': 'espnau-en-afl-index',
	    'netball': 'espnau-en-netball-index',
	    'indy-car': 'espnau-en-indy-car-index'
	  },
	  'editionAlert': {
	    'enabled': true,
	    'text': 'You have come to the all new KweseESPN.com, for other ESPN editions, click above.'
	  },
	  'feeds': {
	    'googlenews': {
	      'allowedContentTypes': ['Story', 'HeadlineNews']
	    }
	  },
	  'tier2NavIds': {
	    'boston': 12375278,
	    'chicago': 12505826,
	    'cleveland': 13977091,
	    'dallas': 12505828,
	    'los-angeles': 12505831,
	    'milwaukee': 13977360,
	    'new-york': 12505854,
	    'fantasy/basketball': 12405600,
	    'fantasy/football': 12405632,
	    'fantasy/baseball': 12405631,
	    'fantasy/hockey': 12405634,
	    'fantasy': 13609307,
	    'ncfrecruiting': 11588758,
	    'ncbrecruiting': 11588880,
	    'esports': 13663224,
	    'onenacion': 13309315,
	    'jayski': 16584380,
	    'ncf/weekday-walkthrough': 17165710,
	    'wwe': 17101058,
	    'sportsnation': 12544987,
	    'nba/stephen-curry': 14950765,
	    'league': {
	      'soccer': 13794648,
	      'ncf': 13886385,
	      'college-football': 13886385,
	      'cricket': 15609108
	    },
	    'watch': 15726903,
	    'espn/caponecup': 17140605,
	    'analytics': 17587818,
	    'espnenabled': 17538365,
	    'insider': 17779675,
	    'live': 17843176
	  },
	  'tier3NavIds': {
	    'clubhouse': {
	      'nba': 12293424,
	      'mlb': 12343023,
	      'mens-college-basketball': 13884705,
	      'womens-college-basketball': 13930164,
	      'soccer': 12294454,
	      'nfl': 12509708,
	      'college-football': 13345157,
	      'cricket': 15368856,
	      'rugby': 17326168
	    },
	    'doubletruck': 14830831
	  },
	  'latestVideoCollectionId': 18749053,
	  'videoAutoStart': {
	    'index': false,
	    'scoreboard': false
	  },
	  'useMongo': true,
	  'activeSite': false,
	  'countries': [{
	    'name': 'South Africa',
	    'country-code': 'za',
	    'showHreflang': true
	  }]
	};

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(685);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _pathSegments;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// git hash 39ee1c202ba64d2451c2db345eb88efc9fd9165c
	exports.default = {
	  'editionSettings': {
	    'key': 'espn-es-ar',
	    'site': 'espn',
	    'language': 'es',
	    'country': 'ar',
	    'domain': 'www.espn.com.ar',
	    'editionSiteId': '15',
	    'https': false,
	    'supportsOneSite': false
	  },
	  'navId': '2487587',
	  'dictionarySection': 'espn',
	  'javaLocale': {
	    'language': 'es',
	    'region': 'MX'
	  },
	  'dateTime': {
	    'long': 'dddd MMMM d, yyyy',
	    'medium': 'MMMM d, yyyy',
	    'short': 'M/d',
	    'timeFormat': 'h:mm',
	    'firstDayOfWeek': 'Sunday',
	    'timeZone': 'America/Santiago',
	    'defaultFormat': 'd MMM, yyyy',
	    'timeZoneString': 'AR',
	    'timeZoneBucket': 'America/New_York',
	    'MMM D, YYYY': 'D MMM, YYYY',
	    'M/D/YYYY': 'D/M/YYYY',
	    'MM/DD/YYYY': 'DD/MM/YYYY',
	    'MMDDYYYY': 'DDMMYYYY',
	    'MMMM Do YYYY': 'Do MMMM YYYY',
	    'dddd, MMMM Do YYYY': 'dddd, Do MMMM YYYY',
	    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
	    'M/D': 'D/M',
	    'MMMM D, YYYY': 'D MMMM YYYY',
	    'dddd, M/D': 'dddd, D/M',
	    'age': {
	      'seconds': 's',
	      'minutes': 'm',
	      'hours': 'h',
	      'days': 'd'
	    }
	  },
	  'numberFormat': {
	    'long': '#,###',
	    'short': '###',
	    'currency': '#,###.00',
	    'percent': '#.00%'
	  },
	  'temperature': {
	    'scale': 'celsius',
	    'symbol': '&deg; C'
	  },
	  'outbrain': {
	    'enabled': true,
	    'template': 'ESPNDeportesLATAM',
	    'desktop': {
	      'compliantId': 'AR_2',
	      'nonCompliantId': 'AR_4'
	    },
	    'mobile': {
	      'compliantId': 'MB_2',
	      'nonCompliantId': 'MB_6'
	    },
	    'video': {
	      'desktop': {
	        'compliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6'
	      }
	    },
	    'report': {
	      'desktop': {
	        'compliantId': 'AR_30',
	        'nonCompliantId': 'AR_30'
	      },
	      'mobile': {
	        'compliantId': 'MB_9',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'table': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'MB_43'
	      }
	    },
	    'game': {
	      'desktop': {
	        'compliantId': 'AR_48'
	      },
	      'mobile': {
	        'compliantId': 'AR_48'
	      }
	    }
	  },
	  'omniture': {
	    'enabled': true
	  },
	  'chartBeat': {
	    'enabled': true
	  },
	  'ads': {
	    'disabled': false,
	    'network': 1234,
	    'partnerAd': false,
	    'dev-config': 14005403,
	    'qa-config': 14005403,
	    'prod-config': 14005403,
	    'outputType': 'js',
	    'featurePhone': {
	      'outputType': 'no-js'
	    }
	  },
	  'partnerModules': {
	    'global': false,
	    'nba': false,
	    'womenbb': false,
	    'golf': false,
	    'endurance': false,
	    'horse': false,
	    'nascar': false
	  },
	  'sportBranding': [{
	    'sport': 'cricket',
	    'image': 'logo-uk-cricinfo',
	    'url': 'http://www.espncricinfo.com'
	  }, {
	    'sport': 'soccer',
	    'image': 'logo-deportes-fc',
	    'url': 'http://www.espn.com.ar/futbol/'
	  }, {
	    'sport': 'rugby',
	    'image': 'logo-deportes-scrum',
	    'url': 'http://www.espn.com.ar/rugby/'
	  }, {
	    'sport': 'ncaaw',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'ncw',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'wnba',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'womenbb',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }],
	  'siteLogo': {
	    'class': '',
	    'featurePhone': {
	      'name': 'espn-logo',
	      'width': 45,
	      'height': 11
	    }
	  },
	  'meta': {
	    'titleBranding': ' - ESPN',
	    'description': 'ESPN lo último del mundo deportivo. Información completa de todo tipo de deporte incluyendo Fútbol Mexicano, Fútbol Argentino, Fútbol Italiano, Fútbol de España, Fútbol de MLS, Fútbol de Estados Unidos, Fútbol Inglaterra, Fútbol de Alemania, Fútbol de Francia, Baloncesto Profesional, NBA, Básquetbol, Béisbol, Pelota, Fútbol Americano, NFL, Rugby, Tenis, Boxeo, Golf y Juegos de Fantasía.',
	    'defaultMetaImage': 'espn_red.png',
	    'schema': {
	      'name': 'ESPN'
	    },
	    'social': {
	      'twitter': {
	        'twitterId': '',
	        'card': 'summary',
	        'app_id_iphone': '317469184',
	        'site': 'espn',
	        'app_name_googleplay': 'ESPN',
	        'app_id_googleplay': 'com.espn.score_center',
	        'app_name_iphone': 'ESPN',
	        'language': 'es'
	      },
	      'facebook': {
	        'id': '116656161708917',
	        'og_site_name': 'ESPN.com.ar',
	        'locale': 'es_ES'
	      }
	    }
	  },
	  'shop': {
	    'enabled': false
	  },
	  'sportReplacements': {},
	  'uriRewrites': {
	    'urls': {
	      'toEdition': {
	        '/futbol-americano/nfl/': '/futbol-americano/',
	        '/beisbol/mlb/': '/beisbol/',
	        '/basquetbol/nba/': '/basquetbol/'
	      },
	      'toEnglish': {}
	    },
	    'roots': {
	      'toEdition': {},
	      'toEnglish': {}
	    },
	    'pathSegments': (_pathSegments = {
	      'reporte': 'report',
	      'juego': 'game',
	      'equipo': 'team',
	      'plantel': 'roster',
	      'estadisticas': 'stats',
	      'calendario': 'schedule',
	      'estadio': 'stadium',
	      'profundidad': 'depth',
	      'conversacion': 'conversation',
	      'ficha': 'boxscore',
	      'previa': 'preview',
	      'partido': 'match',
	      'jugadas': 'playbyplay',
	      'cronica': 'recap',
	      'fotos': 'photos',
	      'duelo': 'matchup',
	      'jugador': 'player',
	      'posiciones': 'standings',
	      'lesiones': 'injuries',
	      'bateo': 'batting',
	      'grilla': 'grid',
	      'piloto': 'driver',
	      'resultados': 'scoreboard',
	      'liga': 'league',
	      'ligas': 'leagues',
	      'nota': 'story',
	      'comentario': 'commentary',
	      'alineacion': 'lineups'
	    }, (0, _defineProperty3.default)(_pathSegments, 'estadisticas', 'matchstats'), (0, _defineProperty3.default)(_pathSegments, 'jugador-estadisticas', 'playerstats'), (0, _defineProperty3.default)(_pathSegments, 'medallas', 'medals'), (0, _defineProperty3.default)(_pathSegments, 'deportes', 'sports'), (0, _defineProperty3.default)(_pathSegments, 'deportistas', 'athletes'), (0, _defineProperty3.default)(_pathSegments, 'lideres', 'leaderboard'), (0, _defineProperty3.default)(_pathSegments, 'envivo', 'live'), (0, _defineProperty3.default)(_pathSegments, 'ronda', 'rounds'), (0, _defineProperty3.default)(_pathSegments, 'equipos', 'teams'), (0, _defineProperty3.default)(_pathSegments, 'posicion', 'positions'), (0, _defineProperty3.default)(_pathSegments, 'mejordisponible', 'bestavailable'), (0, _defineProperty3.default)(_pathSegments, 'noticias', 'news'), (0, _defineProperty3.default)(_pathSegments, 'noticiasdelequipo', 'teamnews'), (0, _defineProperty3.default)(_pathSegments, 'fecha', 'date'), _pathSegments),
	    'paramKeys': {
	      'juegoId': 'gameId',
	      'fecha': 'date',
	      'equipo': 'team',
	      'nombre': 'name',
	      'partido': 'gameID',
	      'liga': 'league',
	      'tipodetemporada': 'seasontype',
	      'ano': 'year',
	      'semana': 'week',
	      'deportes': 'discipline',
	      'evento': 'event',
	      'torneo': 'tournamentId',
	      'deportista': 'athlete',
	      'vista': 'view',
	      'pais': 'country',
	      'pagina': 'page',
	      'continuo': 'continuous'
	    },
	    'paramValues': {
	      'liga': 'league',
	      'todo': 'all',
	      'deportistas': 'athletes',
	      'paises': 'countries'
	    }
	  },
	  'betting': {
	    'enabled': false,
	    'provider': '',
	    'game': {
	      'enabled': false,
	      'provider': ''
	    }
	  },
	  'ticketProvider': null,
	  'hasTickets': false,
	  'showFavorites': true,
	  'showInsider': false,
	  'showWatch': false,
	  'hideCategoryLinks': [600, 1700],
	  'categorySettings': {
	    'leagues': true,
	    'athletes': true,
	    'teams': true,
	    'tags': true
	  },
	  'showFCContent': false,
	  'showCricInfoContent': false,
	  'cookieConsent': false,
	  'scDeepLinking': true,
	  'allowShortUrl': false,
	  'allowPrintUrl': true,
	  'allowUserAccountManagement': true,
	  'nowFeed': true,
	  'searchUrl': 'http://buscar.espn.com/',
	  'gameSettings': {
	    'topEventsId': 2524475,
	    'promotedSoccerLeaguesCeId': 2508964,
	    'showBroadcast': false
	  },
	  'fallback': {
	    'baseball': 'espn-es-us-baseball-index',
	    'basketball': 'espn-es-us-basketball-index',
	    'boxing': 'espn-es-us-boxing-index',
	    'ciclismo': 'espn-es-co-ciclismo-index',
	    'espn-run': 'espn-es-ar-espn-run-index',
	    'esports': 'espn-es-us-esports-index',
	    'espys': 'espn-es-us-espys-index',
	    'f1': 'espn-es-mx-f1-index',
	    'football': 'espn-es-us-football-index',
	    'golf': 'espn-es-ar-golf-index',
	    'los-angeles': 'espn-es-us-frontpage-index',
	    'mlb': 'espn-es-us-baseball-index',
	    'mlb-beisbolexperience': 'espn-es-us-mlb-beisbolexperience-index',
	    'mma': 'espn-es-mx-mma-index',
	    'motociclismo': 'espn-es-ar-motociclismo-index',
	    'nacion-espn': 'espn-es-us-nacion-espn-index',
	    'nba': 'espn-es-us-basketball-index',
	    'nba-summerleague': 'espn-es-us-nba-summerleague-index',
	    'nexoespn': 'espn-es-co-nexoespn-index',
	    'nfl': 'espn-es-us-football-index',
	    'oly-summer-archery': 'espn-es-mx-oly-summer-archery-index',
	    'oly-summer-athletics': 'espn-es-mx-oly-summer-athletics-index',
	    'oly-summer-badminton': 'espn-es-mx-oly-summer-badminton-index',
	    'oly-summer-basketball': 'espn-es-mx-oly-summer-basketball-index',
	    'oly-summer-boxing': 'espn-es-mx-oly-summer-boxing-index',
	    'oly-summer-canoe': 'espn-es-mx-oly-summer-canoe-index',
	    'oly-summer-cycling': 'espn-es-mx-oly-summer-cycling-index',
	    'oly-summer-equestrian': 'espn-es-mx-oly-summer-equestrian-index',
	    'oly-summer-fencing': 'espn-es-mx-oly-summer-fencing-index',
	    'oly-summer-field-hockey': 'espn-es-mx-oly-summer-field-hockey-index',
	    'oly-summer-golf': 'espn-es-mx-oly-summer-golf-index',
	    'oly-summer-gymnastics': 'espn-es-mx-oly-summer-gymnastics-index',
	    'oly-summer-handball': 'espn-es-mx-oly-summer-handball-index',
	    'oly-summer-judo': 'espn-es-mx-oly-summer-judo-index',
	    'oly-summer-modern-pentathlon': 'espn-es-mx-oly-summer-modern-pentathlon-index',
	    'oly-summer-rowing': 'espn-es-mx-oly-summer-rowing-index',
	    'oly-summer-rugby': 'espn-es-mx-oly-summer-rugby-index',
	    'oly-summer-sailing': 'espn-es-mx-oly-summer-sailing-index',
	    'oly-summer-shooting': 'espn-es-mx-oly-summer-shooting-index',
	    'oly-summer-soccer': 'espn-es-mx-oly-summer-soccer-index',
	    'oly-summer-swimming': 'espn-es-mx-oly-summer-swimming-index',
	    'oly-summer-table-tennis': 'espn-es-mx-oly-summer-table-tennis-index',
	    'oly-summer-taekwondo': 'espn-es-mx-oly-summer-taekwondo-index',
	    'oly-summer-tennis': 'espn-es-mx-oly-summer-tennis-index',
	    'oly-summer-triathlon': 'espn-es-mx-oly-summer-triathlon-index',
	    'oly-summer-volleyball': 'espn-es-mx-oly-summer-volleyball-index',
	    'oly-summer-water-polo': 'espn-es-mx-oly-summer-water-polo-index',
	    'oly-summer-weightlifting': 'espn-es-mx-oly-summer-weightlifting-index',
	    'oly-summer-wrestling': 'espn-es-mx-oly-summer-wrestling-index',
	    'olympics': 'espn-es-mx-olympics-index',
	    'other-sports': 'espn-es-us-other-sports-index',
	    'panamerican': 'espn-es-us-panamerican-index',
	    'poker': 'espn-es-ar-poker-index',
	    'polo': 'espn-es-ar-polo-index',
	    'rpm': 'espn-es-ar-rpm-index',
	    'rugby': 'espn-es-ar-rugby-index',
	    'serie-del-caribe': 'espn-es-us-serie-del-caribe-index',
	    'soccer': 'espn-es-mx-soccer-index',
	    'tennis': 'espn-es-ar-tennis-index',
	    'world-baseball-classic': 'espn-es-us-world-baseball-classic-index',
	    'wwe': 'espn-es-us-luchalibre-index',
	    'x-games': 'espn-es-ar-x-games-index'
	  },
	  'editionAlert': {
	    'enabled': true,
	    'text': 'Has llegado a la edición de Argentina. Quedarse en el sitio actual o ir a edición preferida.'
	  },
	  'feeds': {
	    'googlenews': {
	      'allowedContentTypes': ['TopStoryPackage', 'Story', 'BlogEntry', 'HeadlineNews']
	    }
	  },
	  'tier2NavIds': {
	    'league': {
	      'soccer': 2520885
	    },
	    'baseball': 3023264,
	    'basketball': 2474875,
	    'boxing': 2474907,
	    'espn-run': 2623345,
	    'espn-radio': 2639931,
	    'esports': 2882075,
	    'f1': 2474769, // 2474747 -> for rpm/deporte-motor
	    'football': 2474884,
	    'golf': 2475240,
	    'los-angeles': '', // legacy page
	    'mlb': 3023264,
	    'mma': 2475264,
	    'motociclismo': 3397504,
	    'nba': 2474875,
	    'nba/summerleague': 3316630,
	    'nacion-espn': 2652083,
	    'nfl': 2474884,
	    'oly/summer/archery': 2475258,
	    'oly/summer/athletics': 2475258,
	    'oly/summer/badminton': 2475258,
	    'oly/summer/basketball': 2475258,
	    'oly/summer/boxing': 2475258,
	    'oly/summer/canoe': 2475258,
	    'oly/summer/cycling': 2475258,
	    'oly/summer/equestrian': 2475258,
	    'oly/summer/fencing': 2475258,
	    'oly/summer/field-hockey': 2475258,
	    'oly/summer/golf': 2475258,
	    'oly/summer/gymnastics': 2475258,
	    'oly/summer/handball': 2475258,
	    'oly/summer/judo': 2475258,
	    'oly/summer/modern-pentathlon': 2475258,
	    'oly/summer/rowing': 2475258,
	    'oly/summer/rugby': 2475258,
	    'oly/summer/sailing': 2475258,
	    'oly/summer/shooting': 2475258,
	    'oly/summer/soccer': 2475258,
	    'oly/summer/swimming': 2475258,
	    'oly/summer/table-tennis': 2475258,
	    'oly/summer/taekwondo': 2475258,
	    'oly/summer/tennis': 2475258,
	    'oly/summer/triathlon': 2475258,
	    'oly/summer/volleyball': 2475258,
	    'oly/summer/water-polo': 2475258,
	    'oly/summer/weightlifting': 2475258,
	    'oly/summer/wrestling': 2475258,
	    'olympics': 2475258,
	    'other-sports': 2475272,
	    'panamerican': 2507636,
	    'poker': 2506302,
	    'polo': 2511033,
	    'rpm': 2474747,
	    'rugby': 2474293,
	    'serie-del-caribe': 2955159,
	    'tennis': 2474261,
	    'television': 2652305,
	    'x-games': 2475269,
	    'ciclismo': 2882281,
	    'wwe': 2946192,
	    'world-baseball-classic': 2978462,
	    'watch': 3046205,
	    'mlb/beisbolexperience': 3044646,
	    'nexoespn': 2652305,
	    'espys': 3121931,
	    'soccer': 2487619
	  },
	  'tier3NavIds': {
	    'clubhouse': {
	      'nfl': 2520032,
	      'mlb': 2523552,
	      'nba': 2525379,
	      'soccer': 2525397
	    }
	  },
	  'indexAutoStart': false,
	  'useMongo': true,
	  'activeSite': true,
	  'countries': [{
	    'name': 'Argentina',
	    'country-code': 'ar',
	    'showHreflang': true
	  }, {
	    'name': 'Uruguay',
	    'country-code': 'uy',
	    'showHreflang': false
	  }, {
	    'name': 'Paraguay',
	    'country-code': 'py',
	    'showHreflang': false
	  }, {
	    'name': 'Peru',
	    'country-code': 'pe',
	    'showHreflang': true
	  }, {
	    'name': 'Bolivia',
	    'country-code': 'bo',
	    'showHreflang': false
	  }],
	  'reactOverride': {
	    'cricket': {
	      'scores': true
	    }
	  }
	};

/***/ }),
/* 688 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// git hash 8ee6b172772eecafce6aa2c5c0f974c689aeb397
	exports.default = {
	  'editionSettings': {
	    'key': 'espn-es-cl',
	    'site': 'espn',
	    'language': 'es',
	    'country': 'cl',
	    'domain': 'www.espn.cl',
	    'editionSiteId': '18',
	    'https': false,
	    'supportsOneSite': false
	  },
	  'navId': '2464731',
	  'dictionarySection': 'espn',
	  'javaLocale': {
	    'language': 'es',
	    'region': 'MX'
	  },
	  'dateTime': {
	    'long': 'dddd MMMM d, yyyy',
	    'medium': 'MMMM d, yyyy',
	    'short': 'M/d',
	    'timeFormat': 'h:mm',
	    'firstDayOfWeek': 'Sunday',
	    'timeZone': 'America/Santiago',
	    'defaultFormat': 'd MMM, yyyy',
	    'timeZoneString': 'ST',
	    'timeZoneBucket': 'America/New_York',
	    'MMM D, YYYY': 'D MMM, YYYY',
	    'M/D/YYYY': 'D/M/YYYY',
	    'MM/DD/YYYY': 'DD/MM/YYYY',
	    'MMDDYYYY': 'DDMMYYYY',
	    'MMMM Do YYYY': 'Do MMMM YYYY',
	    'dddd, MMMM Do YYYY': 'dddd, Do MMMM YYYY',
	    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
	    'M/D': 'D/M',
	    'MMMM D, YYYY': 'D MMMM YYYY',
	    'dddd, M/D': 'dddd, D/M',
	    'age': {
	      'seconds': 's',
	      'minutes': 'm',
	      'hours': 'h',
	      'days': 'd'
	    }
	  },
	  'numberFormat': {
	    'long': '#,###',
	    'short': '###',
	    'currency': '#,###.00',
	    'percent': '#.00%'
	  },
	  'temperature': {
	    'scale': 'celsius',
	    'symbol': '&deg; C'
	  },
	  'outbrain': {
	    'enabled': true,
	    'template': 'ESPNDeportesLATAM',
	    'desktop': {
	      'compliantId': 'AR_2',
	      'nonCompliantId': 'AR_4'
	    },
	    'mobile': {
	      'compliantId': 'MB_2',
	      'nonCompliantId': 'MB_6'
	    },
	    'video': {
	      'desktop': {
	        'compliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6'
	      }
	    },
	    'report': {
	      'desktop': {
	        'compliantId': 'AR_30',
	        'nonCompliantId': 'AR_30'
	      },
	      'mobile': {
	        'compliantId': 'MB_9',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'table': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'MB_43'
	      }
	    },
	    'game': {
	      'desktop': {
	        'compliantId': 'AR_48'
	      },
	      'mobile': {
	        'compliantId': 'AR_48'
	      }
	    }
	  },
	  'omniture': {
	    'enabled': true
	  },
	  'chartBeat': {
	    'enabled': true
	  },
	  'ads': {
	    'disabled': false,
	    'network': 1234,
	    'partnerAd': false,
	    'dev-config': 13830809,
	    'qa-config': 13830809,
	    'prod-config': 13830809,
	    'outputType': 'js',
	    'featurePhone': {
	      'outputType': 'no-js'
	    }
	  },
	  'partnerModules': {
	    'global': false,
	    'nba': false,
	    'womenbb': false,
	    'golf': false,
	    'endurance': false,
	    'horse': false,
	    'nascar': false
	  },
	  'sportBranding': [{
	    'sport': 'cricket',
	    'image': 'logo-uk-cricinfo',
	    'url': 'http://www.espncricinfo.com'
	  }, {
	    'sport': 'soccer',
	    'image': 'logo-deportes-fc',
	    'url': 'http://www.espn.cl/futbol/'
	  }, {
	    'sport': 'rugby',
	    'image': 'logo-deportes-scrum',
	    'url': 'http://www.espn.cl/rugby/'
	  }, {
	    'sport': 'ncaaw',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'ncw',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'wnba',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'womenbb',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }],
	  'siteLogo': {
	    'class': '',
	    'featurePhone': {
	      'name': 'espn-logo',
	      'width': 45,
	      'height': 11
	    }
	  },
	  'meta': {
	    'titleBranding': ' - ESPN',
	    'description': 'ESPN lo último del mundo deportivo. Información completa de todo tipo de deporte incluyendo Fútbol Mexicano, Fútbol Argentino, Fútbol Italiano, Fútbol de España, Fútbol de MLS, Fútbol de Estados Unidos, Fútbol Inglaterra, Fútbol de Alemania, Fútbol de Francia, Baloncesto Profesional, NBA, Básquetbol, Béisbol, Pelota, Fútbol Americano, NFL, Rugby, Tenis, Boxeo, Golf y Juegos de Fantasía.',
	    'defaultMetaImage': 'espn_red.png',
	    'schema': {
	      'name': 'ESPN'
	    },
	    'social': {
	      'twitter': {
	        'twitterId': '',
	        'card': 'summary',
	        'app_id_iphone': '317469184',
	        'site': 'espn',
	        'app_name_googleplay': 'ESPN',
	        'app_id_googleplay': 'com.espn.score_center',
	        'app_name_iphone': 'ESPN',
	        'language': 'es'
	      },
	      'facebook': {
	        'id': '116656161708917',
	        'og_site_name': 'ESPN.cl',
	        'locale': 'es_ES'
	      }
	    }
	  },
	  'shop': {
	    'enabled': false
	  },
	  'sportReplacements': {},
	  'uriRewrites': {
	    'urls': {
	      'toEdition': {
	        '/futbol-americano/nfl/': '/futbol-americano/',
	        '/beisbol/mlb/': '/beisbol/',
	        '/basquetbol/nba/': '/basquetbol/'
	      },
	      'toEnglish': {}
	    },
	    'roots': {
	      'toEdition': {},
	      'toEnglish': {}
	    },
	    'pathSegments': {
	      'reporte': 'report',
	      'juego': 'game',
	      'equipo': 'team',
	      'plantel': 'roster',
	      'estadisticas': 'stats',
	      'calendario': 'schedule',
	      'estadio': 'stadium',
	      'profundidad': 'depth',
	      'conversacion': 'conversation',
	      'ficha': 'boxscore',
	      'previa': 'preview',
	      'partido': 'match',
	      'jugadas': 'playbyplay',
	      'cronica': 'recap',
	      'fotos': 'photos',
	      'duelo': 'matchup',
	      'jugador': 'player',
	      'posiciones': 'standings',
	      'lesiones': 'injuries',
	      'bateo': 'batting',
	      'grilla': 'grid',
	      'piloto': 'driver',
	      'resultados': 'scoreboard',
	      'liga': 'league',
	      'ligas': 'leagues',
	      'nota': 'story',
	      'comentario': 'commentary',
	      'alineaciones': 'lineups',
	      'estadisticas-juego': 'matchstats',
	      'jugador-estadistica': 'playerstats',
	      'medallas': 'medals',
	      'deportes': 'sports',
	      'deportistas': 'athletes',
	      'lideres': 'leaderboard',
	      'envivo': 'live',
	      'ronda': 'rounds',
	      'equipos': 'teams',
	      'posicion': 'positions',
	      'mejordisponible': 'bestavailable',
	      'noticias': 'news',
	      'noticiasdelequipo': 'teamnews',
	      'fecha': 'date'
	    },
	    'paramKeys': {
	      'juegoId': 'gameId',
	      'fecha': 'date',
	      'equipo': 'team',
	      'nombre': 'name',
	      'partido': 'gameID',
	      'liga': 'league',
	      'tipodetemporada': 'seasontype',
	      'ano': 'year',
	      'semana': 'week',
	      'deportes': 'discipline',
	      'evento': 'event',
	      'torneo': 'tournamentId',
	      'deportista': 'athlete',
	      'vista': 'view',
	      'pais': 'country',
	      'pagina': 'page',
	      'continuo': 'continuous',
	      'ronda': 'round',
	      'posicion': 'position'
	    },
	    'paramValues': {
	      'liga': 'league',
	      'todo': 'all',
	      'deportistas': 'athletes',
	      'paises': 'countries'
	    }
	  },
	  'betting': {
	    'enabled': false,
	    'provider': '',
	    'game': {
	      'enabled': false,
	      'provider': ''
	    }
	  },
	  'ticketProvider': null,
	  'hasTickets': false,
	  'showFavorites': true,
	  'showInsider': false,
	  'showWatch': false,
	  'hideCategoryLinks': [600, 1700],
	  'categorySettings': {
	    'leagues': true,
	    'athletes': true,
	    'teams': true,
	    'tags': true
	  },
	  'showFCContent': false,
	  'showCricInfoContent': false,
	  'cookieConsent': false,
	  'scDeepLinking': true,
	  'allowShortUrl': false,
	  'allowPrintUrl': true,
	  'allowUserAccountManagement': true,
	  'nowFeed': false,
	  'searchUrl': 'http://buscar.espn.com/',
	  'gameSettings': {
	    'topEventsId': 2524485,
	    'promotedSoccerLeaguesCeId': 2508918,
	    'showBroadcast': false
	  },
	  'fallback': {
	    'los-angeles': 'espn-es-us-frontpage-index',
	    'oly-summer-water-polo': 'espn-es-mx-oly-summer-water-polo-index',
	    'wwe': 'espn-es-us-luchalibre-index',
	    'oly-summer-volleyball': 'espn-es-mx-oly-summer-volleyball-index',
	    'f1': 'espn-es-mx-f1-index',
	    'other-sports': 'espn-es-us-other-sports-index',
	    'oly-summer-athletics': 'espn-es-mx-oly-summer-athletics-index',
	    'serie-del-caribe': 'espn-es-us-serie-del-caribe-index',
	    'ciclismo': 'espn-es-co-ciclismo-index',
	    'oly-summer-fencing': 'espn-es-mx-oly-summer-fencing-index',
	    'oly-summer-sailing': 'espn-es-mx-oly-summer-sailing-index',
	    'oly-summer-archery': 'espn-es-mx-oly-summer-archery-index',
	    'oly-summer-cycling': 'espn-es-mx-oly-summer-cycling-index',
	    'oly-summer-weightlifting': 'espn-es-mx-oly-summer-weightlifting-index',
	    'basketball': 'espn-es-us-basketball-index',
	    'oly-summer-equestrian': 'espn-es-mx-oly-summer-equestrian-index',
	    'oly-summer-golf': 'espn-es-mx-oly-summer-golf-index',
	    'oly-summer-swimming': 'espn-es-mx-oly-summer-swimming-index',
	    'oly-summer-basketball': 'espn-es-mx-oly-summer-basketball-index',
	    'mlb': 'espn-es-us-baseball-index',
	    'oly-summer-rugby': 'espn-es-mx-oly-summer-rugby-index',
	    'x-games': 'espn-es-ar-x-games-index',
	    'oly-summer-boxing': 'espn-es-mx-oly-summer-boxing-index',
	    'oly-summer-shooting': 'espn-es-mx-oly-summer-shooting-index',
	    'rugby': 'espn-es-ar-rugby-index',
	    'poker': 'espn-es-ar-poker-index',
	    'olympics': 'espn-es-ar-olympics-index',
	    'nba': 'espn-es-us-basketball-index',
	    'oly-summer-soccer': 'espn-es-ar-oly-summer-soccer-index',
	    'nexoespn': 'espn-es-cl-nexoespn-index',
	    'nfl': 'espn-es-us-football-index',
	    'boxing': 'espn-es-us-boxing-index',
	    'baseball': 'espn-es-us-baseball-index',
	    'oly-summer-taekwondo': 'espn-es-mx-oly-summer-taekwondo-index',
	    'mlb-beisbolexperience': 'espn-es-us-mlb-beisbolexperience-index',
	    'mma': 'espn-es-mx-mma-index',
	    'oly-summer-modern-pentathlon': 'espn-es-mx-oly-summer-modern-pentathlon-index',
	    'panamerican': 'espn-es-us-panamerican-index',
	    'golf': 'espn-es-ar-golf-index',
	    'oly-summer-table-tennis': 'espn-es-mx-oly-summer-table-tennis-index',
	    'esports': 'espn-es-us-esports-index',
	    'oly-summer-judo': 'espn-es-mx-oly-summer-judo-index',
	    'oly-summer-canoe': 'espn-es-mx-oly-summer-canoe-index',
	    'espys': 'espn-es-us-espys-index',
	    'oly-summer-triathlon': 'espn-es-mx-oly-summer-triathlon-index',
	    'nba-summerleague': 'espn-es-us-nba-summerleague-index',
	    'soccer': 'espn-es-cl-soccer-index',
	    'oly-summer-field-hockey': 'espn-es-mx-oly-summer-field-hockey-index',
	    'oly-summer-gymnastics': 'espn-es-mx-oly-summer-gymnastics-index',
	    'football': 'espn-es-us-football-index',
	    'oly/summer/2016': 'espn-es-ar-olympics-index',
	    'espn-run': 'espn-es-ar-espn-run-index',
	    'oly-summer-wrestling': 'espn-es-mx-oly-summer-wrestling-index',
	    'motociclismo': 'espn-es-ar-motociclismo-index',
	    'rpm': 'espn-es-ar-rpm-index',
	    'tennis': 'espn-es-ar-tennis-index',
	    'oly-summer-tennis': 'espn-es-mx-oly-summer-tennis-index',
	    'oly-summer-badminton': 'espn-es-mx-oly-summer-badminton-index',
	    'polo': 'espn-es-ar-polo-index',
	    'oly-summer-rowing': 'espn-es-mx-oly-summer-rowing-index',
	    'nacion-espn': 'espn-es-us-nacion-espn-index',
	    'oly-summer-handball': 'espn-es-mx-oly-summer-handball-index',
	    'world-baseball-classic': 'espn-es-us-world-baseball-classic-index'
	  },
	  'editionAlert': {
	    'enabled': true,
	    'text': 'Has llegado a la edición de Chile. Quedarse en el sitio actual o ir a edición preferida.'
	  },
	  'feeds': {
	    'googlenews': {
	      'allowedContentTypes': ['TopStoryPackage', 'BlogEntry', 'HeadlineNews']
	    }
	  },
	  'tier2NavIds': {
	    'league': {
	      'soccer': 2520885
	    },
	    'baseball': 3023264,
	    'basketball': 2474875,
	    'boxing': 2474907,
	    'ciclismo': 2882281,
	    'espn-run': 2623345,
	    'espnradio': 2639931,
	    'esports': 2774868,
	    'espys': 3121931,
	    'f1': 2474769,
	    'football': 2474884,
	    'golf': 2475240,
	    'los-angeles': '',
	    'mlb': 3023264,
	    'mlb/beisbolexperience': 3044646,
	    'mma': 2475264,
	    'motociclismo': 3397504,
	    'nacion-espn': 2652083,
	    'nba': 2474875,
	    'nba/summerleague': 3316630,
	    'nexoespn': 2652305,
	    'nfl': 2474884,
	    'oly/summer/archery': 2475258,
	    'oly/summer/athletics': 2475258,
	    'oly/summer/badminton': 2475258,
	    'oly/summer/basketball': 2475258,
	    'oly/summer/boxing': 2475258,
	    'oly/summer/canoe': 2475258,
	    'oly/summer/cycling': 2475258,
	    'oly/summer/equestrian': 2475258,
	    'oly/summer/fencing': 2475258,
	    'oly/summer/field-hockey': 2475258,
	    'oly/summer/golf': 2475258,
	    'oly/summer/gymnastics': 2475258,
	    'oly/summer/handball': 2475258,
	    'oly/summer/judo': 2475258,
	    'oly/summer/modern-pentathlon': 2475258,
	    'oly/summer/rowing': 2475258,
	    'oly/summer/rugby': 2475258,
	    'oly/summer/sailing': 2475258,
	    'oly/summer/shooting': 2475258,
	    'oly/summer/soccer': 2475258,
	    'oly/summer/swimming': 2475258,
	    'oly/summer/table-tennis': 2475258,
	    'oly/summer/taekwondo': 2475258,
	    'oly/summer/tennis': 2475258,
	    'oly/summer/triathlon': 2475258,
	    'oly/summer/volleyball': 2475258,
	    'oly/summer/water-polo': 2475258,
	    'oly/summer/weightlifting': 2475258,
	    'oly/summer/wrestling': 2475258,
	    'olympics': 2475258,
	    'other-sports': 2475272,
	    'panamerican': 2507636,
	    'poker': 2506302,
	    'polo': 2511033,
	    'rpm': 2474747,
	    'rugby': 2474293,
	    'serie-del-caribe': 2955159,
	    'soccer': 2465002,
	    'television': 2652305,
	    'tennis': 2474261,
	    'watch': 3046205,
	    'world-baseball-classic': 2978462,
	    'wwe': 2946192,
	    'x-games': 2475269
	  },
	  'tier3NavIds': {
	    'clubhouse': {
	      'nfl': 2520032,
	      'mlb': 2523552,
	      'nba': 2525379,
	      'soccer': 2525397
	    }
	  },
	  'indexAutoStart': false,
	  'useMongo': true,
	  'activeSite': true,
	  'countries': [{
	    'name': 'Chile',
	    'country-code': 'cl',
	    'showHreflang': true
	  }],
	  'reactOverride': {
	    'cricket': {
	      'scores': true
	    }
	  }
	};

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(685);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _pathSegments;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// git hash 8ee6b172772eecafce6aa2c5c0f974c689aeb397
	exports.default = {
	  'editionSettings': {
	    'key': 'espn-es-co',
	    'site': 'espn',
	    'language': 'es',
	    'country': 'co',
	    'domain': 'www.espn.com.co',
	    'editionSiteId': '19',
	    'https': false,
	    'supportsOneSite': false
	  },
	  'navId': '2487590',
	  'dictionarySection': 'espn',
	  'javaLocale': {
	    'language': 'es',
	    'region': 'MX'
	  },
	  'dateTime': {
	    'long': 'dddd MMMM d, yyyy',
	    'medium': 'MMMM d, yyyy',
	    'short': 'M/d',
	    'timeFormat': 'h:mm',
	    'firstDayOfWeek': 'Sunday',
	    'timeZone': 'America/Santiago',
	    'defaultFormat': 'd MMM, yyyy',
	    'timeZoneString': 'COT',
	    'timeZoneBucket': 'America/New_York',
	    'MMM D, YYYY': 'D MMM, YYYY',
	    'M/D/YYYY': 'D/M/YYYY',
	    'MM/DD/YYYY': 'DD/MM/YYYY',
	    'MMDDYYYY': 'DDMMYYYY',
	    'MMMM Do YYYY': 'Do MMMM YYYY',
	    'dddd, MMMM Do YYYY': 'dddd, Do MMMM YYYY',
	    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
	    'M/D': 'D/M',
	    'MMMM D, YYYY': 'D MMMM YYYY',
	    'dddd, M/D': 'dddd, D/M',
	    'age': {
	      'seconds': 's',
	      'minutes': 'm',
	      'hours': 'h',
	      'days': 'd'
	    }
	  },
	  'numberFormat': {
	    'long': '#,###',
	    'short': '###',
	    'currency': '#,###.00',
	    'percent': '#.00%'
	  },
	  'temperature': {
	    'scale': 'celsius',
	    'symbol': '&deg; C'
	  },
	  'outbrain': {
	    'enabled': true,
	    'template': 'ESPNDeportesLATAM',
	    'desktop': {
	      'compliantId': 'AR_2',
	      'nonCompliantId': 'AR_4'
	    },
	    'mobile': {
	      'compliantId': 'MB_2',
	      'nonCompliantId': 'MB_6'
	    },
	    'video': {
	      'desktop': {
	        'compliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6'
	      }
	    },
	    'report': {
	      'desktop': {
	        'compliantId': 'AR_30',
	        'nonCompliantId': 'AR_30'
	      },
	      'mobile': {
	        'compliantId': 'MB_9',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'table': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'MB_43'
	      }
	    },
	    'game': {
	      'desktop': {
	        'compliantId': 'AR_48'
	      },
	      'mobile': {
	        'compliantId': 'AR_48'
	      }
	    }
	  },
	  'omniture': {
	    'enabled': true
	  },
	  'chartBeat': {
	    'enabled': true
	  },
	  'ads': {
	    'disabled': false,
	    'network': 1234,
	    'partnerAd': false,
	    'dev-config': 14005420,
	    'qa-config': 14005420,
	    'prod-config': 14005420,
	    'outputType': 'js',
	    'featurePhone': {
	      'outputType': 'no-js'
	    }
	  },
	  'partnerModules': {
	    'global': false,
	    'nba': false,
	    'womenbb': false,
	    'golf': false,
	    'endurance': false,
	    'horse': false,
	    'nascar': false
	  },
	  'sportBranding': [{
	    'sport': 'cricket',
	    'image': 'logo-uk-cricinfo',
	    'url': 'http://www.espncricinfo.com'
	  }, {
	    'sport': 'soccer',
	    'image': 'logo-deportes-fc',
	    'url': 'http://www.espn.com.co/futbol/'
	  }, {
	    'sport': 'rugby',
	    'image': 'logo-deportes-scrum',
	    'url': 'http://www.espn.com.co/rugby/'
	  }, {
	    'sport': 'ncaaw',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'ncw',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'wnba',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'womenbb',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }],
	  'siteLogo': {
	    'class': '',
	    'featurePhone': {
	      'name': 'espn-logo',
	      'width': 45,
	      'height': 11
	    }
	  },
	  'meta': {
	    'titleBranding': ' - ESPN',
	    'description': 'ESPN lo último del mundo deportivo. Información completa de todo tipo de deporte incluyendo Fútbol Mexicano, Fútbol Argentino, Fútbol Italiano, Fútbol de España, Fútbol de MLS, Fútbol de Estados Unidos, Fútbol Inglaterra, Fútbol de Alemania, Fútbol de Francia, Baloncesto Profesional, NBA, Básquetbol, Béisbol, Pelota, Fútbol Americano, NFL, Rugby, Tenis, Boxeo, Golf y Juegos de Fantasía.',
	    'defaultMetaImage': 'espn_red.png',
	    'schema': {
	      'name': 'ESPN'
	    },
	    'social': {
	      'twitter': {
	        'twitterId': '',
	        'card': 'summary',
	        'app_id_iphone': '317469184',
	        'site': 'espn',
	        'app_name_googleplay': 'ESPN',
	        'app_id_googleplay': 'com.espn.score_center',
	        'app_name_iphone': 'ESPN',
	        'language': 'es'
	      },
	      'facebook': {
	        'id': '116656161708917',
	        'og_site_name': 'ESPN.com.co',
	        'locale': 'es_ES'
	      }
	    }
	  },
	  'shop': {
	    'enabled': false
	  },
	  'sportReplacements': {},
	  'uriRewrites': {
	    'urls': {
	      'toEdition': {
	        '/futbol-americano/nfl/': '/futbol-americano/',
	        '/beisbol/mlb/': '/beisbol/',
	        '/basquetbol/nba/': '/basquetbol/'
	      },
	      'toEnglish': {}
	    },
	    'roots': {
	      'toEdition': {},
	      'toEnglish': {}
	    },
	    'pathSegments': (_pathSegments = {
	      'reporte': 'report',
	      'juego': 'game',
	      'equipo': 'team',
	      'plantel': 'roster',
	      'estadisticas': 'stats',
	      'calendario': 'schedule',
	      'estadio': 'stadium',
	      'profundidad': 'depth',
	      'conversacion': 'conversation',
	      'ficha': 'boxscore',
	      'previa': 'preview',
	      'partido': 'match',
	      'jugadas': 'playbyplay',
	      'cronica': 'recap',
	      'fotos': 'photos',
	      'duelo': 'matchup',
	      'jugador': 'player',
	      'posiciones': 'standings',
	      'lesiones': 'injuries',
	      'bateo': 'batting',
	      'grilla': 'grid',
	      'piloto': 'driver',
	      'resultados': 'scoreboard',
	      'liga': 'league',
	      'ligas': 'leagues',
	      'nota': 'story',
	      'comentario': 'commentary',
	      'alineacion': 'lineups'
	    }, (0, _defineProperty3.default)(_pathSegments, 'estadisticas', 'matchstats'), (0, _defineProperty3.default)(_pathSegments, 'jugador-estadisticas', 'playerstats'), (0, _defineProperty3.default)(_pathSegments, 'medallas', 'medals'), (0, _defineProperty3.default)(_pathSegments, 'deportes', 'sports'), (0, _defineProperty3.default)(_pathSegments, 'deportistas', 'athletes'), (0, _defineProperty3.default)(_pathSegments, 'lideres', 'leaderboard'), (0, _defineProperty3.default)(_pathSegments, 'envivo', 'live'), (0, _defineProperty3.default)(_pathSegments, 'ronda', 'rounds'), (0, _defineProperty3.default)(_pathSegments, 'equipos', 'teams'), (0, _defineProperty3.default)(_pathSegments, 'posicion', 'positions'), (0, _defineProperty3.default)(_pathSegments, 'mejordisponible', 'bestavailable'), (0, _defineProperty3.default)(_pathSegments, 'noticias', 'news'), (0, _defineProperty3.default)(_pathSegments, 'noticiasdelequipo', 'teamnews'), (0, _defineProperty3.default)(_pathSegments, 'fecha', 'date'), _pathSegments),
	    'paramKeys': {
	      'juegoId': 'gameId',
	      'fecha': 'date',
	      'equipo': 'team',
	      'nombre': 'name',
	      'partido': 'gameID',
	      'liga': 'league',
	      'tipodetemporada': 'seasontype',
	      'ano': 'year',
	      'semana': 'week',
	      'deportes': 'discipline',
	      'evento': 'event',
	      'torneo': 'tournamentId',
	      'deportista': 'athlete',
	      'vista': 'view',
	      'pais': 'country',
	      'pagina': 'page',
	      'continuo': 'continuous',
	      'ronda': 'round',
	      'posicion': 'position'
	    },
	    'paramValues': {
	      'liga': 'league',
	      'todo': 'all',
	      'deportistas': 'athletes',
	      'paises': 'countries'
	    }
	  },
	  'betting': {
	    'enabled': false,
	    'provider': '',
	    'game': {
	      'enabled': false,
	      'provider': ''
	    }
	  },
	  'ticketProvider': null,
	  'hasTickets': false,
	  'showFavorites': true,
	  'showInsider': false,
	  'showWatch': false,
	  'hideCategoryLinks': [600, 1700],
	  'categorySettings': {
	    'leagues': true,
	    'athletes': true,
	    'teams': true,
	    'tags': true
	  },
	  'showFCContent': true,
	  'showCricInfoContent': false,
	  'cookieConsent': false,
	  'scDeepLinking': true,
	  'allowShortUrl': false,
	  'allowPrintUrl': true,
	  'allowUserAccountManagement': true,
	  'nowFeed': false,
	  'searchUrl': 'http://buscar.espn.com/',
	  'gameSettings': {
	    'topEventsId': 2524483,
	    'promotedSoccerLeaguesCeId': 2508965,
	    'showBroadcast': false
	  },
	  'fallback': {
	    'los-angeles': 'espn-es-us-frontpage-index',
	    'oly-summer-water-polo': 'espn-es-mx-oly-summer-water-polo-index',
	    'wwe': 'espn-es-us-luchalibre-index',
	    'oly-summer-volleyball': 'espn-es-mx-oly-summer-volleyball-index',
	    'f1': 'espn-es-mx-f1-index',
	    'other-sports': 'espn-es-us-other-sports-index',
	    'oly-summer-athletics': 'espn-es-mx-oly-summer-athletics-index',
	    'serie-del-caribe': 'espn-es-us-serie-del-caribe-index',
	    'ciclismo': 'espn-es-co-ciclismo-index',
	    'oly-summer-fencing': 'espn-es-mx-oly-summer-fencing-index',
	    'oly-summer-sailing': 'espn-es-mx-oly-summer-sailing-index',
	    'oly-summer-archery': 'espn-es-mx-oly-summer-archery-index',
	    'oly-summer-cycling': 'espn-es-mx-oly-summer-cycling-index',
	    'oly-summer-weightlifting': 'espn-es-mx-oly-summer-weightlifting-index',
	    'basketball': 'espn-es-us-basketball-index',
	    'oly-summer-equestrian': 'espn-es-mx-oly-summer-equestrian-index',
	    'oly-summer-golf': 'espn-es-mx-oly-summer-golf-index',
	    'oly-summer-swimming': 'espn-es-mx-oly-summer-swimming-index',
	    'oly-summer-basketball': 'espn-es-mx-oly-summer-basketball-index',
	    'mlb': 'espn-es-us-baseball-index',
	    'oly-summer-rugby': 'espn-es-mx-oly-summer-rugby-index',
	    'x-games': 'espn-es-ar-x-games-index',
	    'oly-summer-boxing': 'espn-es-mx-oly-summer-boxing-index',
	    'oly-summer-shooting': 'espn-es-mx-oly-summer-shooting-index',
	    'rugby': 'espn-es-ar-rugby-index',
	    'poker': 'espn-es-ar-poker-index',
	    'olympics': 'espn-es-co-olympics-index',
	    'nba': 'espn-es-us-basketball-index',
	    'oly-summer-soccer': 'espn-es-ar-oly-summer-soccer-index',
	    'nexoespn': 'espn-es-co-nexoespn-index',
	    'nfl': 'espn-es-us-football-index',
	    'boxing': 'espn-es-us-boxing-index',
	    'baseball': 'espn-es-us-baseball-index',
	    'oly-summer-taekwondo': 'espn-es-mx-oly-summer-taekwondo-index',
	    'mlb-beisbolexperience': 'espn-es-us-mlb-beisbolexperience-index',
	    'mma': 'espn-es-mx-mma-index',
	    'oly-summer-modern-pentathlon': 'espn-es-mx-oly-summer-modern-pentathlon-index',
	    'panamerican': 'espn-es-us-panamerican-index',
	    'golf': 'espn-es-ar-golf-index',
	    'oly-summer-table-tennis': 'espn-es-mx-oly-summer-table-tennis-index',
	    'esports': 'espn-es-us-esports-index',
	    'oly-summer-judo': 'espn-es-mx-oly-summer-judo-index',
	    'oly-summer-canoe': 'espn-es-mx-oly-summer-canoe-index',
	    'espys': 'espn-es-us-espys-index',
	    'oly-summer-triathlon': 'espn-es-mx-oly-summer-triathlon-index',
	    'nba-summerleague': 'espn-es-us-nba-summerleague-index',
	    'soccer': 'espn-es-co-soccer-index',
	    'oly-summer-field-hockey': 'espn-es-mx-oly-summer-field-hockey-index',
	    'oly-summer-gymnastics': 'espn-es-mx-oly-summer-gymnastics-index',
	    'football': 'espn-es-us-football-index',
	    'espn-run': 'espn-es-ar-espn-run-index',
	    'oly-summer-wrestling': 'espn-es-mx-oly-summer-wrestling-index',
	    'motociclismo': 'espn-es-ar-motociclismo-index',
	    'rpm': 'espn-es-ar-rpm-index',
	    'tennis': 'espn-es-ar-tennis-index',
	    'oly-summer-tennis': 'espn-es-mx-oly-summer-tennis-index',
	    'oly-summer-badminton': 'espn-es-mx-oly-summer-badminton-index',
	    'polo': 'espn-es-ar-polo-index',
	    'oly-summer-rowing': 'espn-es-mx-oly-summer-rowing-index',
	    'nacion-espn': 'espn-es-us-nacion-espn-index',
	    'oly-summer-handball': 'espn-es-mx-oly-summer-handball-index',
	    'world-baseball-classic': 'espn-es-us-world-baseball-classic-index'
	  },
	  'editionAlert': {
	    'enabled': true,
	    'text': 'Has llegado a la edición de Colombia. Quedarse en el sitio actual o ir a edición preferida.'
	  },
	  'feeds': {
	    'googlenews': {
	      'allowedContentTypes': ['TopStoryPackage', 'BlogEntry', 'HeadlineNews']
	    }
	  },
	  'tier2NavIds': {
	    'league': {
	      'soccer': 2520885
	    },
	    'baseball': 3023264,
	    'basketball': 2474875,
	    'boxing': 2474907,
	    'ciclismo': 2882281,
	    'espn-run': 2623345,
	    'espnradio': 2639931,
	    'esports': 2774868,
	    'espys': 3121931,
	    'f1': 2474769,
	    'football': 2474884,
	    'golf': 2475240,
	    'los-angeles': '',
	    'mlb': 3023264,
	    'mlb/beisbolexperience': 3044646,
	    'mma': 2475264,
	    'motociclismo': 3397504,
	    'nacion-espn': 2652083,
	    'nba': 2474875,
	    'nba/summerleague': 3316630,
	    'nexoespn': 2652309,
	    'nfl': 2474884,
	    'oly/summer/archery': 2475258,
	    'oly/summer/athletics': 2475258,
	    'oly/summer/badminton': 2475258,
	    'oly/summer/basketball': 2475258,
	    'oly/summer/boxing': 2475258,
	    'oly/summer/canoe': 2475258,
	    'oly/summer/cycling': 2475258,
	    'oly/summer/equestrian': 2475258,
	    'oly/summer/fencing': 2475258,
	    'oly/summer/field-hockey': 2475258,
	    'oly/summer/golf': 2475258,
	    'oly/summer/gymnastics': 2475258,
	    'oly/summer/handball': 2475258,
	    'oly/summer/judo': 2475258,
	    'oly/summer/modern-pentathlon': 2475258,
	    'oly/summer/rowing': 2475258,
	    'oly/summer/rugby': 2475258,
	    'oly/summer/sailing': 2475258,
	    'oly/summer/shooting': 2475258,
	    'oly/summer/soccer': 2475258,
	    'oly/summer/swimming': 2475258,
	    'oly/summer/table-tennis': 2475258,
	    'oly/summer/taekwondo': 2475258,
	    'oly/summer/tennis': 2475258,
	    'oly/summer/triathlon': 2475258,
	    'oly/summer/volleyball': 2475258,
	    'oly/summer/water-polo': 2475258,
	    'oly/summer/weightlifting': 2475258,
	    'oly/summer/wrestling': 2475258,
	    'olympics': 2475258,
	    'other-sports': 2475272,
	    'panamerican': 2507636,
	    'poker': 2506302,
	    'polo': 2511033,
	    'rpm': 2474747,
	    'rugby': 2474293,
	    'serie-del-caribe': 2955159,
	    'soccer': 2487743,
	    'television': 2652309,
	    'tennis': 2474261,
	    'watch': 3046205,
	    'world-baseball-classic': 2978462,
	    'wwe': 2946192,
	    'x-games': 2475269
	  },
	  'tier3NavIds': {
	    'clubhouse': {
	      'nfl': 2520032,
	      'mlb': 2523552,
	      'nba': 2525379,
	      'soccer': 2525397
	    }
	  },
	  'indexAutoStart': false,
	  'useMongo': true,
	  'activeSite': true,
	  'countries': [{
	    'name': 'Colombia',
	    'country-code': 'co',
	    'showHreflang': true
	  }],
	  'reactOverride': {
	    'cricket': {
	      'scores': true
	    }
	  }
	};

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(685);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _pathSegments;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// git hash 8ee6b172772eecafce6aa2c5c0f974c689aeb397
	exports.default = {
	  'editionSettings': {
	    'key': 'espn-es-do',
	    'site': 'espn',
	    'language': 'es',
	    'country': 'do',
	    'domain': 'www.espn.com',
	    'editionSiteId': '1',
	    'https': false,
	    'supportsOneSite': false
	  },
	  'navId': '3462144',
	  'dictionarySection': 'espn',
	  'javaLocale': {
	    'language': 'es',
	    'region': 'MX'
	  },
	  'dateTime': {
	    'long': 'dddd MMMM d, yyyy',
	    'medium': 'MMMM d, yyyy',
	    'short': 'M/d',
	    'timeFormat': 'h:mm',
	    'firstDayOfWeek': 'Sunday',
	    'timeZone': 'America/Santiago',
	    'defaultFormat': 'd MMM, yyyy',
	    'timeZoneString': 'CT',
	    'timeZoneBucket': 'America/New_York',
	    'MMM D, YYYY': 'D MMM, YYYY',
	    'M/D/YYYY': 'D/M/YYYY',
	    'MM/DD/YYYY': 'DD/MM/YYYY',
	    'MMDDYYYY': 'DDMMYYYY',
	    'MMMM Do YYYY': 'Do MMMM YYYY',
	    'dddd, MMMM Do YYYY': 'dddd, Do MMMM YYYY',
	    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
	    'M/D': 'D/M',
	    'MMMM D, YYYY': 'D MMMM YYYY',
	    'dddd, M/D': 'dddd, D/M',
	    'age': {
	      'seconds': 's',
	      'minutes': 'm',
	      'hours': 'h',
	      'days': 'd'
	    }
	  },
	  'numberFormat': {
	    'long': '#,###',
	    'short': '###',
	    'currency': '#,###.00',
	    'percent': '#.00%'
	  },
	  'temperature': {
	    'scale': 'celsius',
	    'symbol': '&deg; C'
	  },
	  'outbrain': {
	    'enabled': true,
	    'template': 'ESPNDeportesLATAM',
	    'desktop': {
	      'compliantId': 'AR_2',
	      'nonCompliantId': 'AR_4'
	    },
	    'mobile': {
	      'compliantId': 'MB_2',
	      'nonCompliantId': 'MB_6'
	    },
	    'video': {
	      'desktop': {
	        'compliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6'
	      }
	    },
	    'report': {
	      'desktop': {
	        'compliantId': 'AR_30',
	        'nonCompliantId': 'AR_30'
	      },
	      'mobile': {
	        'compliantId': 'MB_9',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'table': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'MB_43'
	      }
	    },
	    'game': {
	      'desktop': {
	        'compliantId': 'AR_48'
	      },
	      'mobile': {
	        'compliantId': 'AR_48'
	      }
	    }
	  },
	  'omniture': {
	    'enabled': true
	  },
	  'chartBeat': {
	    'enabled': true
	  },
	  'ads': {
	    'disabled': false,
	    'network': 1234,
	    'partnerAd': false,
	    'dev-config': 14005378,
	    'qa-config': 14005378,
	    'prod-config': 14005378,
	    'outputType': 'js',
	    'featurePhone': {
	      'outputType': 'no-js'
	    }
	  },
	  'partnerModules': {
	    'global': false,
	    'nba': false,
	    'womenbb': false,
	    'golf': false,
	    'endurance': false,
	    'horse': false,
	    'nascar': false
	  },
	  'sportBranding': [{
	    'sport': 'cricket',
	    'image': 'logo-uk-cricinfo',
	    'url': 'http://www.espncricinfo.com'
	  }, {
	    'sport': 'soccer',
	    'image': 'logo-deportes-fc',
	    'url': 'http://www.espn.com.mx/futbol/'
	  }, {
	    'sport': 'rugby',
	    'image': 'logo-deportes-scrum',
	    'url': 'http://www.espn.com.mx/rugby/'
	  }, {
	    'sport': 'ncaaw',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'ncw',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'wnba',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'womenbb',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }],
	  'siteLogo': {
	    'class': '',
	    'featurePhone': {
	      'name': 'espn-logo',
	      'width': 45,
	      'height': 11
	    }
	  },
	  'meta': {
	    'titleBranding': ' - ESPN',
	    'description': 'ESPN lo último del mundo deportivo.',
	    'defaultMetaImage': 'espn_red.png',
	    'schema': {
	      'name': 'ESPN'
	    },
	    'social': {
	      'twitter': {
	        'twitterId': '',
	        'card': 'summary',
	        'app_id_iphone': '317469184',
	        'site': 'espn',
	        'app_name_googleplay': 'ESPN',
	        'app_id_googleplay': 'com.espn.score_center',
	        'app_name_iphone': 'ESPN',
	        'language': 'es'
	      },
	      'facebook': {
	        'id': '116656161708917',
	        'og_site_name': 'ESPN.com.mx',
	        'locale': 'es_ES'
	      }
	    }
	  },
	  'shop': {
	    'enabled': false
	  },
	  'sportReplacements': {},
	  'uriRewrites': {
	    'urls': {
	      'toEdition': {
	        '/futbol-americano/nfl/': '/futbol-americano/',
	        '/beisbol/mlb/': '/beisbol/',
	        '/basquetbol/nba/': '/basquetbol/'
	      },
	      'toEnglish': {}
	    },
	    'roots': {
	      'toEdition': {},
	      'toEnglish': {}
	    },
	    'pathSegments': (_pathSegments = {
	      'reporte': 'report',
	      'juego': 'game',
	      'equipo': 'team',
	      'plantel': 'roster',
	      'estadisticas': 'stats',
	      'calendario': 'schedule',
	      'estadio': 'stadium',
	      'profundidad': 'depth',
	      'conversacion': 'conversation',
	      'ficha': 'boxscore',
	      'previa': 'preview',
	      'partido': 'match',
	      'jugadas': 'playbyplay',
	      'cronica': 'recap',
	      'fotos': 'photos',
	      'duelo': 'matchup',
	      'jugador': 'player',
	      'posiciones': 'standings',
	      'lesiones': 'injuries',
	      'bateo': 'batting',
	      'grilla': 'grid',
	      'piloto': 'driver',
	      'resultados': 'scoreboard',
	      'liga': 'league',
	      'ligas': 'leagues',
	      'nota': 'story',
	      'comentario': 'commentary',
	      'alineacion': 'lineups'
	    }, (0, _defineProperty3.default)(_pathSegments, 'estadisticas', 'matchstats'), (0, _defineProperty3.default)(_pathSegments, 'jugador-estadisticas', 'playerstats'), (0, _defineProperty3.default)(_pathSegments, 'medallas', 'medals'), (0, _defineProperty3.default)(_pathSegments, 'deportes', 'sports'), (0, _defineProperty3.default)(_pathSegments, 'deportistas', 'athletes'), (0, _defineProperty3.default)(_pathSegments, 'lideres', 'leaderboard'), (0, _defineProperty3.default)(_pathSegments, 'envivo', 'live'), (0, _defineProperty3.default)(_pathSegments, 'ronda', 'rounds'), (0, _defineProperty3.default)(_pathSegments, 'equipos', 'teams'), (0, _defineProperty3.default)(_pathSegments, 'posicion', 'positions'), (0, _defineProperty3.default)(_pathSegments, 'mejordisponible', 'bestavailable'), (0, _defineProperty3.default)(_pathSegments, 'noticias', 'news'), (0, _defineProperty3.default)(_pathSegments, 'noticiasdelequipo', 'teamnews'), (0, _defineProperty3.default)(_pathSegments, 'fecha', 'date'), _pathSegments),
	    'paramKeys': {
	      'juegoId': 'gameId',
	      'fecha': 'date',
	      'equipo': 'team',
	      'nombre': 'name',
	      'partido': 'gameID',
	      'liga': 'league',
	      'tipodetemporada': 'seasontype',
	      'ano': 'year',
	      'semana': 'week',
	      'deportes': 'discipline',
	      'evento': 'event',
	      'torneo': 'tournamentId',
	      'deportista': 'athlete',
	      'vista': 'view',
	      'pais': 'country',
	      'pagina': 'page',
	      'continuo': 'continuous',
	      'ronda': 'round',
	      'posicion': 'position'
	    },
	    'paramValues': {
	      'liga': 'league',
	      'todo': 'all',
	      'deportistas': 'athletes',
	      'paises': 'countries'
	    }
	  },
	  'betting': {
	    'enabled': true,
	    'provider': 'caliente',
	    'game': {
	      'enabled': false,
	      'provider': 'caliente'
	    }
	  },
	  'ticketProvider': null,
	  'hasTickets': false,
	  'showFavorites': true,
	  'showInsider': false,
	  'showWatch': false,
	  'hideCategoryLinks': [600, 1700],
	  'categorySettings': {
	    'leagues': true,
	    'athletes': true,
	    'teams': true,
	    'tags': true
	  },
	  'showFCContent': true,
	  'showCricInfoContent': false,
	  'cookieConsent': true,
	  'scDeepLinking': true,
	  'allowShortUrl': false,
	  'allowPrintUrl': true,
	  'allowUserAccountManagement': true,
	  'nowFeed': false,
	  'searchUrl': 'http://buscar.espn.com/',
	  'gameSettings': {
	    'topEventsId': 3466375,
	    'promotedSoccerLeaguesCeId': 3466625,
	    'showBroadcast': false
	  },
	  'fallback': {
	    'los-angeles': 'espn-es-us-frontpage-index',
	    'oly-summer-water-polo': 'espn-es-mx-oly-summer-water-polo-index',
	    'wwe': 'espn-es-us-luchalibre-index',
	    'oly-summer-volleyball': 'espn-es-mx-oly-summer-volleyball-index',
	    'f1': 'espn-es-mx-f1-index',
	    'other-sports': 'espn-es-us-other-sports-index',
	    'oly-summer-athletics': 'espn-es-mx-oly-summer-athletics-index',
	    'serie-del-caribe': 'espn-es-us-serie-del-caribe-index',
	    'ciclismo': 'espn-es-co-ciclismo-index',
	    'oly-summer-fencing': 'espn-es-mx-oly-summer-fencing-index',
	    'oly-summer-sailing': 'espn-es-mx-oly-summer-sailing-index',
	    'oly-summer-archery': 'espn-es-mx-oly-summer-archery-index',
	    'oly-summer-cycling': 'espn-es-mx-oly-summer-cycling-index',
	    'oly-summer-weightlifting': 'espn-es-mx-oly-summer-weightlifting-index',
	    'basketball': 'espn-es-us-basketball-index',
	    'oly-summer-equestrian': 'espn-es-mx-oly-summer-equestrian-index',
	    'oly-summer-golf': 'espn-es-mx-oly-summer-golf-index',
	    'oly-summer-swimming': 'espn-es-mx-oly-summer-swimming-index',
	    'oly-summer-basketball': 'espn-es-mx-oly-summer-basketball-index',
	    'mlb': 'espn-es-us-baseball-index',
	    'oly-summer-rugby': 'espn-es-mx-oly-summer-rugby-index',
	    'x-games': 'espn-es-ar-x-games-index',
	    'oly-summer-boxing': 'espn-es-mx-oly-summer-boxing-index',
	    'oly-summer-shooting': 'espn-es-mx-oly-summer-shooting-index',
	    'rugby': 'espn-es-ar-rugby-index',
	    'poker': 'espn-es-ar-poker-index',
	    'olympics': 'espn-es-mx-olympics-index',
	    'nba': 'espn-es-us-basketball-index',
	    'oly-summer-soccer': 'espn-es-mx-oly-summer-soccer-index',
	    'nexoespn': 'espn-es-co-nexoespn-index',
	    'nfl': 'espn-es-us-football-index',
	    'boxing': 'espn-es-us-boxing-index',
	    'baseball': 'espn-es-us-baseball-index',
	    'oly-summer-taekwondo': 'espn-es-mx-oly-summer-taekwondo-index',
	    'mlb-beisbolexperience': 'espn-es-us-mlb-beisbolexperience-index',
	    'mma': 'espn-es-mx-mma-index',
	    'oly-summer-modern-pentathlon': 'espn-es-mx-oly-summer-modern-pentathlon-index',
	    'panamerican': 'espn-es-us-panamerican-index',
	    'golf': 'espn-es-ar-golf-index',
	    'oly-summer-table-tennis': 'espn-es-mx-oly-summer-table-tennis-index',
	    'esports': 'espn-es-us-esports-index',
	    'oly-summer-judo': 'espn-es-mx-oly-summer-judo-index',
	    'oly-summer-canoe': 'espn-es-mx-oly-summer-canoe-index',
	    'espys': 'espn-es-us-espys-index',
	    'oly-summer-triathlon': 'espn-es-mx-oly-summer-triathlon-index',
	    'nba-summerleague': 'espn-es-us-nba-summerleague-index',
	    'soccer': 'espn-es-mx-soccer-index',
	    'oly-summer-field-hockey': 'espn-es-mx-oly-summer-field-hockey-index',
	    'oly-summer-gymnastics': 'espn-es-mx-oly-summer-gymnastics-index',
	    'football': 'espn-es-us-football-index',
	    'espn-run': 'espn-es-ar-espn-run-index',
	    'oly-summer-wrestling': 'espn-es-mx-oly-summer-wrestling-index',
	    'motociclismo': 'espn-es-ar-motociclismo-index',
	    'rpm': 'espn-es-ar-rpm-index',
	    'tennis': 'espn-es-ar-tennis-index',
	    'oly-summer-tennis': 'espn-es-mx-oly-summer-tennis-index',
	    'oly-summer-badminton': 'espn-es-mx-oly-summer-badminton-index',
	    'polo': 'espn-es-ar-polo-index',
	    'oly-summer-rowing': 'espn-es-mx-oly-summer-rowing-index',
	    'nacion-espn': 'espn-es-us-nacion-espn-index',
	    'oly-summer-handball': 'espn-es-mx-oly-summer-handball-index',
	    'world-baseball-classic': 'espn-es-us-world-baseball-classic-index'
	  },
	  'editionAlert': {
	    'enabled': true,
	    'text': 'Has llegado a la edición de México. Quedarse en el sitio actual o ir a edición preferida.'
	  },
	  'feeds': {
	    'googlenews': {
	      'allowedContentTypes': ['TopStoryPackage', 'BlogEntry', 'HeadlineNews']
	    }
	  },
	  'tier2NavIds': {
	    'baseball': 3023264,
	    'basketball': 2474875,
	    'boxing': 2474907,
	    'ciclismo': 2882281,
	    'espn-run': 2507524,
	    'esports': 2882075,
	    'espys': 3121931,
	    'f1': 2474769,
	    'football': 2474884,
	    'golf': 2475240,
	    'los-angeles': '',
	    'mlb': 3023264,
	    'mlb/beisbolexperience': 3044646,
	    'mma': 2475264,
	    'motociclismo': 3397504,
	    'nacion-espn': 2652083,
	    'nba': 2474875,
	    'nba/summerleague': 3316630,
	    'nexoespn': 2649285,
	    'nfl': 2474884,
	    'oly/summer/archery': 2475258,
	    'oly/summer/athletics': 2475258,
	    'oly/summer/badminton': 2475258,
	    'oly/summer/basketball': 2475258,
	    'oly/summer/boxing': 2475258,
	    'oly/summer/canoe': 2475258,
	    'oly/summer/cycling': 2475258,
	    'oly/summer/equestrian': 2475258,
	    'oly/summer/fencing': 2475258,
	    'oly/summer/field-hockey': 2475258,
	    'oly/summer/golf': 2475258,
	    'oly/summer/gymnastics': 2475258,
	    'oly/summer/handball': 2475258,
	    'oly/summer/judo': 2475258,
	    'oly/summer/modern-pentathlon': 2475258,
	    'oly/summer/rowing': 2475258,
	    'oly/summer/rugby': 2475258,
	    'oly/summer/sailing': 2475258,
	    'oly/summer/shooting': 2475258,
	    'oly/summer/soccer': 2475258,
	    'oly/summer/swimming': 2475258,
	    'oly/summer/table-tennis': 2475258,
	    'oly/summer/taekwondo': 2475258,
	    'oly/summer/tennis': 2475258,
	    'oly/summer/triathlon': 2475258,
	    'oly/summer/volleyball': 2475258,
	    'oly/summer/water-polo': 2475258,
	    'oly/summer/weightlifting': 2475258,
	    'oly/summer/wrestling': 2475258,
	    'olympics': 2475258,
	    'other-sports': 2475272,
	    'panamerican': 2507636,
	    'poker': 2506302,
	    'polo': 2511033,
	    'rpm': 2474747,
	    'rugby': 2474293,
	    'serie-del-caribe': 2955159,
	    'soccer': 2487614,
	    'tennis': 2474261,
	    'world-baseball-classic': 2978462,
	    'wwe': 2946192,
	    'x-games': 2475269
	  },
	  'tier3NavIds': {
	    'clubhouse': {
	      'nfl': 2520032,
	      'mlb': 2523552,
	      'nba': 2525379,
	      'soccer': 2525397
	    }
	  },
	  'indexAutoStart': false,
	  'useMongo': true,
	  'activeSite': true,
	  'countries': [{
	    'name': 'Dominican Republic',
	    'country-code': 'do',
	    'showHreflang': true
	  }],
	  'reactOverride': {
	    'cricket': {
	      'scores': true
	    }
	  }
	};

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(685);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _pathSegments;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// git hash 8ee6b172772eecafce6aa2c5c0f974c689aeb397
	exports.default = {
	  'editionSettings': {
	    'key': 'espn-es-ec',
	    'site': 'espn',
	    'language': 'es',
	    'country': 'ec',
	    'domain': 'www.espn.com',
	    'editionSiteId': '1',
	    'https': false,
	    'supportsOneSite': false
	  },
	  'navId': '3462153',
	  'dictionarySection': 'espn',
	  'javaLocale': {
	    'language': 'es',
	    'region': 'MX'
	  },
	  'dateTime': {
	    'long': 'dddd MMMM d, yyyy',
	    'medium': 'MMMM d, yyyy',
	    'short': 'M/d',
	    'timeFormat': 'h:mm',
	    'firstDayOfWeek': 'Sunday',
	    'timeZone': 'America/Santiago',
	    'defaultFormat': 'd MMM, yyyy',
	    'timeZoneString': 'CT',
	    'timeZoneBucket': 'America/New_York',
	    'MMM D, YYYY': 'D MMM, YYYY',
	    'M/D/YYYY': 'D/M/YYYY',
	    'MM/DD/YYYY': 'DD/MM/YYYY',
	    'MMDDYYYY': 'DDMMYYYY',
	    'MMMM Do YYYY': 'Do MMMM YYYY',
	    'dddd, MMMM Do YYYY': 'dddd, Do MMMM YYYY',
	    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
	    'M/D': 'D/M',
	    'MMMM D, YYYY': 'D MMMM YYYY',
	    'dddd, M/D': 'dddd, D/M',
	    'age': {
	      'seconds': 's',
	      'minutes': 'm',
	      'hours': 'h',
	      'days': 'd'
	    }
	  },
	  'numberFormat': {
	    'long': '#,###',
	    'short': '###',
	    'currency': '#,###.00',
	    'percent': '#.00%'
	  },
	  'temperature': {
	    'scale': 'celsius',
	    'symbol': '&deg; C'
	  },
	  'outbrain': {
	    'enabled': true,
	    'template': 'ESPNDeportesLATAM',
	    'desktop': {
	      'compliantId': 'AR_2',
	      'nonCompliantId': 'AR_4'
	    },
	    'mobile': {
	      'compliantId': 'MB_2',
	      'nonCompliantId': 'MB_6'
	    },
	    'video': {
	      'desktop': {
	        'compliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6'
	      }
	    },
	    'report': {
	      'desktop': {
	        'compliantId': 'AR_30',
	        'nonCompliantId': 'AR_30'
	      },
	      'mobile': {
	        'compliantId': 'MB_9',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'table': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'MB_43'
	      }
	    },
	    'game': {
	      'desktop': {
	        'compliantId': 'AR_48'
	      },
	      'mobile': {
	        'compliantId': 'AR_48'
	      }
	    }
	  },
	  'omniture': {
	    'enabled': true
	  },
	  'chartBeat': {
	    'enabled': true
	  },
	  'ads': {
	    'disabled': false,
	    'network': 1234,
	    'partnerAd': false,
	    'dev-config': 14005378,
	    'qa-config': 14005378,
	    'prod-config': 14005378,
	    'outputType': 'js',
	    'featurePhone': {
	      'outputType': 'no-js'
	    }
	  },
	  'partnerModules': {
	    'global': false,
	    'nba': false,
	    'womenbb': false,
	    'golf': false,
	    'endurance': false,
	    'horse': false,
	    'nascar': false
	  },
	  'sportBranding': [{
	    'sport': 'cricket',
	    'image': 'logo-uk-cricinfo',
	    'url': 'http://www.espncricinfo.com'
	  }, {
	    'sport': 'soccer',
	    'image': 'logo-deportes-fc',
	    'url': 'http://www.espn.com.mx/futbol/'
	  }, {
	    'sport': 'rugby',
	    'image': 'logo-deportes-scrum',
	    'url': 'http://www.espn.com.mx/rugby/'
	  }, {
	    'sport': 'ncaaw',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'ncw',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'wnba',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'womenbb',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }],
	  'siteLogo': {
	    'class': '',
	    'featurePhone': {
	      'name': 'espn-logo',
	      'width': 45,
	      'height': 11
	    }
	  },
	  'meta': {
	    'titleBranding': ' - ESPN',
	    'description': 'ESPN lo último del mundo deportivo.',
	    'defaultMetaImage': 'espn_red.png',
	    'schema': {
	      'name': 'ESPN'
	    },
	    'social': {
	      'twitter': {
	        'twitterId': '',
	        'card': 'summary',
	        'app_id_iphone': '317469184',
	        'site': 'espn',
	        'app_name_googleplay': 'ESPN',
	        'app_id_googleplay': 'com.espn.score_center',
	        'app_name_iphone': 'ESPN',
	        'language': 'es'
	      },
	      'facebook': {
	        'id': '116656161708917',
	        'og_site_name': 'ESPN.com.mx',
	        'locale': 'es_ES'
	      }
	    }
	  },
	  'shop': {
	    'enabled': false
	  },
	  'sportReplacements': {},
	  'uriRewrites': {
	    'urls': {
	      'toEdition': {
	        '/futbol-americano/nfl/': '/futbol-americano/',
	        '/beisbol/mlb/': '/beisbol/',
	        '/basquetbol/nba/': '/basquetbol/'
	      },
	      'toEnglish': {}
	    },
	    'roots': {
	      'toEdition': {},
	      'toEnglish': {}
	    },
	    'pathSegments': (_pathSegments = {
	      'reporte': 'report',
	      'juego': 'game',
	      'equipo': 'team',
	      'plantel': 'roster',
	      'estadisticas': 'stats',
	      'calendario': 'schedule',
	      'estadio': 'stadium',
	      'profundidad': 'depth',
	      'conversacion': 'conversation',
	      'ficha': 'boxscore',
	      'previa': 'preview',
	      'partido': 'match',
	      'jugadas': 'playbyplay',
	      'cronica': 'recap',
	      'fotos': 'photos',
	      'duelo': 'matchup',
	      'jugador': 'player',
	      'posiciones': 'standings',
	      'lesiones': 'injuries',
	      'bateo': 'batting',
	      'grilla': 'grid',
	      'piloto': 'driver',
	      'resultados': 'scoreboard',
	      'liga': 'league',
	      'ligas': 'leagues',
	      'nota': 'story',
	      'comentario': 'commentary',
	      'alineacion': 'lineups'
	    }, (0, _defineProperty3.default)(_pathSegments, 'estadisticas', 'matchstats'), (0, _defineProperty3.default)(_pathSegments, 'jugador-estadisticas', 'playerstats'), (0, _defineProperty3.default)(_pathSegments, 'medallas', 'medals'), (0, _defineProperty3.default)(_pathSegments, 'deportes', 'sports'), (0, _defineProperty3.default)(_pathSegments, 'deportistas', 'athletes'), (0, _defineProperty3.default)(_pathSegments, 'lideres', 'leaderboard'), (0, _defineProperty3.default)(_pathSegments, 'envivo', 'live'), (0, _defineProperty3.default)(_pathSegments, 'ronda', 'rounds'), (0, _defineProperty3.default)(_pathSegments, 'equipos', 'teams'), (0, _defineProperty3.default)(_pathSegments, 'posicion', 'positions'), (0, _defineProperty3.default)(_pathSegments, 'mejordisponible', 'bestavailable'), (0, _defineProperty3.default)(_pathSegments, 'noticias', 'news'), (0, _defineProperty3.default)(_pathSegments, 'noticiasdelequipo', 'teamnews'), (0, _defineProperty3.default)(_pathSegments, 'fecha', 'date'), _pathSegments),
	    'paramKeys': {
	      'juegoId': 'gameId',
	      'fecha': 'date',
	      'equipo': 'team',
	      'nombre': 'name',
	      'partido': 'gameID',
	      'liga': 'league',
	      'tipodetemporada': 'seasontype',
	      'ano': 'year',
	      'semana': 'week',
	      'deportes': 'discipline',
	      'evento': 'event',
	      'torneo': 'tournamentId',
	      'deportista': 'athlete',
	      'vista': 'view',
	      'pais': 'country',
	      'pagina': 'page',
	      'continuo': 'continuous',
	      'ronda': 'round',
	      'posicion': 'position'
	    },
	    'paramValues': {
	      'liga': 'league',
	      'todo': 'all',
	      'deportistas': 'athletes',
	      'paises': 'countries'
	    }
	  },
	  'betting': {
	    'enabled': true,
	    'provider': 'caliente',
	    'game': {
	      'enabled': false,
	      'provider': 'caliente'
	    }
	  },
	  'ticketProvider': null,
	  'hasTickets': false,
	  'showFavorites': true,
	  'showInsider': false,
	  'showWatch': false,
	  'hideCategoryLinks': [600, 1700],
	  'categorySettings': {
	    'leagues': true,
	    'athletes': true,
	    'teams': true,
	    'tags': true
	  },
	  'showFCContent': true,
	  'showCricInfoContent': false,
	  'cookieConsent': true,
	  'scDeepLinking': true,
	  'allowShortUrl': false,
	  'allowPrintUrl': true,
	  'allowUserAccountManagement': true,
	  'nowFeed': false,
	  'searchUrl': 'http://buscar.espn.com/',
	  'gameSettings': {
	    'topEventsId': 3466504,
	    'promotedSoccerLeaguesCeId': 3466771,
	    'showBroadcast': false
	  },
	  'fallback': {
	    'los-angeles': 'espn-es-us-frontpage-index',
	    'oly-summer-water-polo': 'espn-es-mx-oly-summer-water-polo-index',
	    'wwe': 'espn-es-us-luchalibre-index',
	    'oly-summer-volleyball': 'espn-es-mx-oly-summer-volleyball-index',
	    'f1': 'espn-es-mx-f1-index',
	    'other-sports': 'espn-es-us-other-sports-index',
	    'oly-summer-athletics': 'espn-es-mx-oly-summer-athletics-index',
	    'serie-del-caribe': 'espn-es-us-serie-del-caribe-index',
	    'ciclismo': 'espn-es-co-ciclismo-index',
	    'oly-summer-fencing': 'espn-es-mx-oly-summer-fencing-index',
	    'oly-summer-sailing': 'espn-es-mx-oly-summer-sailing-index',
	    'oly-summer-archery': 'espn-es-mx-oly-summer-archery-index',
	    'oly-summer-cycling': 'espn-es-mx-oly-summer-cycling-index',
	    'oly-summer-weightlifting': 'espn-es-mx-oly-summer-weightlifting-index',
	    'basketball': 'espn-es-us-basketball-index',
	    'oly-summer-equestrian': 'espn-es-mx-oly-summer-equestrian-index',
	    'oly-summer-golf': 'espn-es-mx-oly-summer-golf-index',
	    'oly-summer-swimming': 'espn-es-mx-oly-summer-swimming-index',
	    'oly-summer-basketball': 'espn-es-mx-oly-summer-basketball-index',
	    'mlb': 'espn-es-us-baseball-index',
	    'oly-summer-rugby': 'espn-es-mx-oly-summer-rugby-index',
	    'x-games': 'espn-es-ar-x-games-index',
	    'oly-summer-boxing': 'espn-es-mx-oly-summer-boxing-index',
	    'oly-summer-shooting': 'espn-es-mx-oly-summer-shooting-index',
	    'rugby': 'espn-es-ar-rugby-index',
	    'poker': 'espn-es-ar-poker-index',
	    'olympics': 'espn-es-mx-olympics-index',
	    'nba': 'espn-es-us-basketball-index',
	    'oly-summer-soccer': 'espn-es-mx-oly-summer-soccer-index',
	    'nexoespn': 'espn-es-co-nexoespn-index',
	    'nfl': 'espn-es-us-football-index',
	    'boxing': 'espn-es-us-boxing-index',
	    'baseball': 'espn-es-us-baseball-index',
	    'oly-summer-taekwondo': 'espn-es-mx-oly-summer-taekwondo-index',
	    'mlb-beisbolexperience': 'espn-es-us-mlb-beisbolexperience-index',
	    'mma': 'espn-es-mx-mma-index',
	    'oly-summer-modern-pentathlon': 'espn-es-mx-oly-summer-modern-pentathlon-index',
	    'panamerican': 'espn-es-us-panamerican-index',
	    'golf': 'espn-es-ar-golf-index',
	    'oly-summer-table-tennis': 'espn-es-mx-oly-summer-table-tennis-index',
	    'esports': 'espn-es-us-esports-index',
	    'oly-summer-judo': 'espn-es-mx-oly-summer-judo-index',
	    'oly-summer-canoe': 'espn-es-mx-oly-summer-canoe-index',
	    'espys': 'espn-es-us-espys-index',
	    'oly-summer-triathlon': 'espn-es-mx-oly-summer-triathlon-index',
	    'nba-summerleague': 'espn-es-us-nba-summerleague-index',
	    'soccer': 'espn-es-mx-soccer-index',
	    'oly-summer-field-hockey': 'espn-es-mx-oly-summer-field-hockey-index',
	    'oly-summer-gymnastics': 'espn-es-mx-oly-summer-gymnastics-index',
	    'football': 'espn-es-us-football-index',
	    'espn-run': 'espn-es-ar-espn-run-index',
	    'oly-summer-wrestling': 'espn-es-mx-oly-summer-wrestling-index',
	    'motociclismo': 'espn-es-ar-motociclismo-index',
	    'rpm': 'espn-es-ar-rpm-index',
	    'tennis': 'espn-es-ar-tennis-index',
	    'oly-summer-tennis': 'espn-es-mx-oly-summer-tennis-index',
	    'oly-summer-badminton': 'espn-es-mx-oly-summer-badminton-index',
	    'polo': 'espn-es-ar-polo-index',
	    'oly-summer-rowing': 'espn-es-mx-oly-summer-rowing-index',
	    'nacion-espn': 'espn-es-us-nacion-espn-index',
	    'oly-summer-handball': 'espn-es-mx-oly-summer-handball-index',
	    'world-baseball-classic': 'espn-es-us-world-baseball-classic-index'
	  },
	  'editionAlert': {
	    'enabled': true,
	    'text': 'Has llegado a la edición de México. Quedarse en el sitio actual o ir a edición preferida.'
	  },
	  'feeds': {
	    'googlenews': {
	      'allowedContentTypes': ['TopStoryPackage', 'BlogEntry', 'HeadlineNews']
	    }
	  },
	  'tier2NavIds': {
	    'baseball': 3023264,
	    'basketball': 2474875,
	    'boxing': 2474907,
	    'ciclismo': 2882281,
	    'espn-run': 2507524,
	    'esports': 2882075,
	    'espys': 3121931,
	    'f1': 2474769,
	    'football': 2474884,
	    'golf': 2475240,
	    'los-angeles': '',
	    'mlb': 3023264,
	    'mlb/beisbolexperience': 3044646,
	    'mma': 2475264,
	    'motociclismo': 3397504,
	    'nacion-espn': 2652083,
	    'nba': 2474875,
	    'nba/summerleague': 3316630,
	    'nexoespn': 2649285,
	    'nfl': 2474884,
	    'oly/summer/archery': 2475258,
	    'oly/summer/athletics': 2475258,
	    'oly/summer/badminton': 2475258,
	    'oly/summer/basketball': 2475258,
	    'oly/summer/boxing': 2475258,
	    'oly/summer/canoe': 2475258,
	    'oly/summer/cycling': 2475258,
	    'oly/summer/equestrian': 2475258,
	    'oly/summer/fencing': 2475258,
	    'oly/summer/field-hockey': 2475258,
	    'oly/summer/golf': 2475258,
	    'oly/summer/gymnastics': 2475258,
	    'oly/summer/handball': 2475258,
	    'oly/summer/judo': 2475258,
	    'oly/summer/modern-pentathlon': 2475258,
	    'oly/summer/rowing': 2475258,
	    'oly/summer/rugby': 2475258,
	    'oly/summer/sailing': 2475258,
	    'oly/summer/shooting': 2475258,
	    'oly/summer/soccer': 2475258,
	    'oly/summer/swimming': 2475258,
	    'oly/summer/table-tennis': 2475258,
	    'oly/summer/taekwondo': 2475258,
	    'oly/summer/tennis': 2475258,
	    'oly/summer/triathlon': 2475258,
	    'oly/summer/volleyball': 2475258,
	    'oly/summer/water-polo': 2475258,
	    'oly/summer/weightlifting': 2475258,
	    'oly/summer/wrestling': 2475258,
	    'olympics': 2475258,
	    'other-sports': 2475272,
	    'panamerican': 2507636,
	    'poker': 2506302,
	    'polo': 2511033,
	    'rpm': 2474747,
	    'rugby': 2474293,
	    'serie-del-caribe': 2955159,
	    'soccer': 2487614,
	    'tennis': 2474261,
	    'world-baseball-classic': 2978462,
	    'wwe': 2946192,
	    'x-games': 2475269
	  },
	  'tier3NavIds': {
	    'clubhouse': {
	      'nfl': 2520032,
	      'mlb': 2523552,
	      'nba': 2525379,
	      'soccer': 2525397
	    }
	  },
	  'indexAutoStart': false,
	  'useMongo': true,
	  'activeSite': true,
	  'countries': [{
	    'name': 'Ecuador',
	    'country-code': 'ec',
	    'showHreflang': true
	  }],
	  'reactOverride': {
	    'cricket': {
	      'scores': true
	    }
	  }
	};

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(685);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _pathSegments;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// git hash 8ee6b172772eecafce6aa2c5c0f974c689aeb397
	exports.default = {
	  'editionSettings': {
	    'key': 'espn-es-gt',
	    'site': 'espn',
	    'language': 'es',
	    'country': 'gt',
	    'domain': 'www.espn.com',
	    'editionSiteId': '1',
	    'https': false,
	    'supportsOneSite': false
	  },
	  'navId': '3462158',
	  'dictionarySection': 'espn',
	  'javaLocale': {
	    'language': 'es',
	    'region': 'MX'
	  },
	  'dateTime': {
	    'long': 'dddd MMMM d, yyyy',
	    'medium': 'MMMM d, yyyy',
	    'short': 'M/d',
	    'timeFormat': 'h:mm',
	    'firstDayOfWeek': 'Sunday',
	    'timeZone': 'America/Santiago',
	    'defaultFormat': 'd MMM, yyyy',
	    'timeZoneString': 'CT',
	    'timeZoneBucket': 'America/New_York',
	    'MMM D, YYYY': 'D MMM, YYYY',
	    'M/D/YYYY': 'D/M/YYYY',
	    'MM/DD/YYYY': 'DD/MM/YYYY',
	    'MMDDYYYY': 'DDMMYYYY',
	    'MMMM Do YYYY': 'Do MMMM YYYY',
	    'dddd, MMMM Do YYYY': 'dddd, Do MMMM YYYY',
	    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
	    'M/D': 'D/M',
	    'MMMM D, YYYY': 'D MMMM YYYY',
	    'dddd, M/D': 'dddd, D/M',
	    'age': {
	      'seconds': 's',
	      'minutes': 'm',
	      'hours': 'h',
	      'days': 'd'
	    }
	  },
	  'numberFormat': {
	    'long': '#,###',
	    'short': '###',
	    'currency': '#,###.00',
	    'percent': '#.00%'
	  },
	  'temperature': {
	    'scale': 'celsius',
	    'symbol': '&deg; C'
	  },
	  'outbrain': {
	    'enabled': true,
	    'template': 'ESPNDeportesLATAM',
	    'desktop': {
	      'compliantId': 'AR_2',
	      'nonCompliantId': 'AR_4'
	    },
	    'mobile': {
	      'compliantId': 'MB_2',
	      'nonCompliantId': 'MB_6'
	    },
	    'video': {
	      'desktop': {
	        'compliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6'
	      }
	    },
	    'report': {
	      'desktop': {
	        'compliantId': 'AR_30',
	        'nonCompliantId': 'AR_30'
	      },
	      'mobile': {
	        'compliantId': 'MB_9',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'table': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'MB_43'
	      }
	    },
	    'game': {
	      'desktop': {
	        'compliantId': 'AR_48'
	      },
	      'mobile': {
	        'compliantId': 'AR_48'
	      }
	    }
	  },
	  'omniture': {
	    'enabled': true
	  },
	  'chartBeat': {
	    'enabled': true
	  },
	  'ads': {
	    'disabled': false,
	    'network': 1234,
	    'partnerAd': false,
	    'dev-config': 14005378,
	    'qa-config': 14005378,
	    'prod-config': 14005378,
	    'outputType': 'js',
	    'featurePhone': {
	      'outputType': 'no-js'
	    }
	  },
	  'partnerModules': {
	    'global': false,
	    'nba': false,
	    'womenbb': false,
	    'golf': false,
	    'endurance': false,
	    'horse': false,
	    'nascar': false
	  },
	  'sportBranding': [{
	    'sport': 'cricket',
	    'image': 'logo-uk-cricinfo',
	    'url': 'http://www.espncricinfo.com'
	  }, {
	    'sport': 'soccer',
	    'image': 'logo-deportes-fc',
	    'url': 'http://www.espn.com.mx/futbol/'
	  }, {
	    'sport': 'rugby',
	    'image': 'logo-deportes-scrum',
	    'url': 'http://www.espn.com.mx/rugby/'
	  }, {
	    'sport': 'ncaaw',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'ncw',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'wnba',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'womenbb',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }],
	  'siteLogo': {
	    'class': '',
	    'featurePhone': {
	      'name': 'espn-logo',
	      'width': 45,
	      'height': 11
	    }
	  },
	  'meta': {
	    'titleBranding': ' - ESPN',
	    'description': 'ESPN lo último del mundo deportivo.',
	    'defaultMetaImage': 'espn_red.png',
	    'schema': {
	      'name': 'ESPN'
	    },
	    'social': {
	      'twitter': {
	        'twitterId': '',
	        'card': 'summary',
	        'app_id_iphone': '317469184',
	        'site': 'espn',
	        'app_name_googleplay': 'ESPN',
	        'app_id_googleplay': 'com.espn.score_center',
	        'app_name_iphone': 'ESPN',
	        'language': 'es'
	      },
	      'facebook': {
	        'id': '116656161708917',
	        'og_site_name': 'ESPN.com.mx',
	        'locale': 'es_ES'
	      }
	    }
	  },
	  'shop': {
	    'enabled': false
	  },
	  'sportReplacements': {},
	  'uriRewrites': {
	    'urls': {
	      'toEdition': {
	        '/futbol-americano/nfl/': '/futbol-americano/',
	        '/beisbol/mlb/': '/beisbol/',
	        '/basquetbol/nba/': '/basquetbol/'
	      },
	      'toEnglish': {}
	    },
	    'roots': {
	      'toEdition': {},
	      'toEnglish': {}
	    },
	    'pathSegments': (_pathSegments = {
	      'reporte': 'report',
	      'juego': 'game',
	      'equipo': 'team',
	      'plantel': 'roster',
	      'estadisticas': 'stats',
	      'calendario': 'schedule',
	      'estadio': 'stadium',
	      'profundidad': 'depth',
	      'conversacion': 'conversation',
	      'ficha': 'boxscore',
	      'previa': 'preview',
	      'partido': 'match',
	      'jugadas': 'playbyplay',
	      'cronica': 'recap',
	      'fotos': 'photos',
	      'duelo': 'matchup',
	      'jugador': 'player',
	      'posiciones': 'standings',
	      'lesiones': 'injuries',
	      'bateo': 'batting',
	      'grilla': 'grid',
	      'piloto': 'driver',
	      'resultados': 'scoreboard',
	      'liga': 'league',
	      'ligas': 'leagues',
	      'nota': 'story',
	      'comentario': 'commentary',
	      'alineacion': 'lineups'
	    }, (0, _defineProperty3.default)(_pathSegments, 'estadisticas', 'matchstats'), (0, _defineProperty3.default)(_pathSegments, 'jugador-estadisticas', 'playerstats'), (0, _defineProperty3.default)(_pathSegments, 'medallas', 'medals'), (0, _defineProperty3.default)(_pathSegments, 'deportes', 'sports'), (0, _defineProperty3.default)(_pathSegments, 'deportistas', 'athletes'), (0, _defineProperty3.default)(_pathSegments, 'lideres', 'leaderboard'), (0, _defineProperty3.default)(_pathSegments, 'envivo', 'live'), (0, _defineProperty3.default)(_pathSegments, 'ronda', 'rounds'), (0, _defineProperty3.default)(_pathSegments, 'equipos', 'teams'), (0, _defineProperty3.default)(_pathSegments, 'posicion', 'positions'), (0, _defineProperty3.default)(_pathSegments, 'mejordisponible', 'bestavailable'), (0, _defineProperty3.default)(_pathSegments, 'noticias', 'news'), (0, _defineProperty3.default)(_pathSegments, 'noticiasdelequipo', 'teamnews'), (0, _defineProperty3.default)(_pathSegments, 'fecha', 'date'), _pathSegments),
	    'paramKeys': {
	      'juegoId': 'gameId',
	      'fecha': 'date',
	      'equipo': 'team',
	      'nombre': 'name',
	      'partido': 'gameID',
	      'liga': 'league',
	      'tipodetemporada': 'seasontype',
	      'ano': 'year',
	      'semana': 'week',
	      'deportes': 'discipline',
	      'evento': 'event',
	      'torneo': 'tournamentId',
	      'deportista': 'athlete',
	      'vista': 'view',
	      'pais': 'country',
	      'pagina': 'page',
	      'continuo': 'continuous',
	      'ronda': 'round',
	      'posicion': 'position'
	    },
	    'paramValues': {
	      'liga': 'league',
	      'todo': 'all',
	      'deportistas': 'athletes',
	      'paises': 'countries'
	    }
	  },
	  'betting': {
	    'enabled': true,
	    'provider': 'caliente',
	    'game': {
	      'enabled': false,
	      'provider': 'caliente'
	    }
	  },
	  'ticketProvider': null,
	  'hasTickets': false,
	  'showFavorites': true,
	  'showInsider': false,
	  'showWatch': false,
	  'hideCategoryLinks': [600, 1700],
	  'categorySettings': {
	    'leagues': true,
	    'athletes': true,
	    'teams': true,
	    'tags': true
	  },
	  'showFCContent': true,
	  'showCricInfoContent': false,
	  'cookieConsent': true,
	  'scDeepLinking': true,
	  'allowShortUrl': false,
	  'allowPrintUrl': true,
	  'allowUserAccountManagement': true,
	  'nowFeed': false,
	  'searchUrl': 'http://buscar.espn.com/',
	  'gameSettings': {
	    'topEventsId': 3466543,
	    'promotedSoccerLeaguesCeId': 3466772,
	    'showBroadcast': false
	  },
	  'fallback': {
	    'baseball': 'espn-es-us-baseball-index',
	    'basketball': 'espn-es-us-basketball-index',
	    'boxing': 'espn-es-us-boxing-index',
	    'ciclismo': 'espn-es-co-ciclismo-index',
	    'espn-run': 'espn-es-ar-espn-run-index',
	    'esports': 'espn-es-us-esports-index',
	    'espys': 'espn-es-us-espys-index',
	    'f1': 'espn-es-mx-f1-index',
	    'football': 'espn-es-us-football-index',
	    'golf': 'espn-es-ar-golf-index',
	    'los-angeles': 'espn-es-us-frontpage-index',
	    'mlb': 'espn-es-us-baseball-index',
	    'mlb-beisbolexperience': 'espn-es-us-mlb-beisbolexperience-index',
	    'mma': 'espn-es-mx-mma-index',
	    'motociclismo': 'espn-es-ar-motociclismo-index',
	    'nacion-espn': 'espn-es-us-nacion-espn-index',
	    'nba': 'espn-es-us-basketball-index',
	    'nba-summerleague': 'espn-es-us-nba-summerleague-index',
	    'nexoespn': 'espn-es-co-nexoespn-index',
	    'nfl': 'espn-es-us-football-index',
	    'oly-summer-archery': 'espn-es-mx-oly-summer-archery-index',
	    'oly-summer-athletics': 'espn-es-mx-oly-summer-athletics-index',
	    'oly-summer-badminton': 'espn-es-mx-oly-summer-badminton-index',
	    'oly-summer-basketball': 'espn-es-mx-oly-summer-basketball-index',
	    'oly-summer-boxing': 'espn-es-mx-oly-summer-boxing-index',
	    'oly-summer-canoe': 'espn-es-mx-oly-summer-canoe-index',
	    'oly-summer-cycling': 'espn-es-mx-oly-summer-cycling-index',
	    'oly-summer-equestrian': 'espn-es-mx-oly-summer-equestrian-index',
	    'oly-summer-fencing': 'espn-es-mx-oly-summer-fencing-index',
	    'oly-summer-field-hockey': 'espn-es-mx-oly-summer-field-hockey-index',
	    'oly-summer-golf': 'espn-es-mx-oly-summer-golf-index',
	    'oly-summer-gymnastics': 'espn-es-mx-oly-summer-gymnastics-index',
	    'oly-summer-handball': 'espn-es-mx-oly-summer-handball-index',
	    'oly-summer-judo': 'espn-es-mx-oly-summer-judo-index',
	    'oly-summer-modern-pentathlon': 'espn-es-mx-oly-summer-modern-pentathlon-index',
	    'oly-summer-rowing': 'espn-es-mx-oly-summer-rowing-index',
	    'oly-summer-rugby': 'espn-es-mx-oly-summer-rugby-index',
	    'oly-summer-sailing': 'espn-es-mx-oly-summer-sailing-index',
	    'oly-summer-shooting': 'espn-es-mx-oly-summer-shooting-index',
	    'oly-summer-soccer': 'espn-es-mx-oly-summer-soccer-index',
	    'oly-summer-swimming': 'espn-es-mx-oly-summer-swimming-index',
	    'oly-summer-table-tennis': 'espn-es-mx-oly-summer-table-tennis-index',
	    'oly-summer-taekwondo': 'espn-es-mx-oly-summer-taekwondo-index',
	    'oly-summer-tennis': 'espn-es-mx-oly-summer-tennis-index',
	    'oly-summer-triathlon': 'espn-es-mx-oly-summer-triathlon-index',
	    'oly-summer-volleyball': 'espn-es-mx-oly-summer-volleyball-index',
	    'oly-summer-water-polo': 'espn-es-mx-oly-summer-water-polo-index',
	    'oly-summer-weightlifting': 'espn-es-mx-oly-summer-weightlifting-index',
	    'oly-summer-wrestling': 'espn-es-mx-oly-summer-wrestling-index',
	    'olympics': 'espn-es-mx-olympics-index',
	    'other-sports': 'espn-es-us-other-sports-index',
	    'panamerican': 'espn-es-us-panamerican-index',
	    'poker': 'espn-es-ar-poker-index',
	    'polo': 'espn-es-ar-polo-index',
	    'rpm': 'espn-es-ar-rpm-index',
	    'rugby': 'espn-es-ar-rugby-index',
	    'serie-del-caribe': 'espn-es-us-serie-del-caribe-index',
	    'soccer': 'espn-es-mx-soccer-index',
	    'tennis': 'espn-es-ar-tennis-index',
	    'world-baseball-classic': 'espn-es-us-world-baseball-classic-index',
	    'wwe': 'espn-es-us-luchalibre-index',
	    'x-games': 'espn-es-ar-x-games-index'
	  },
	  'editionAlert': {
	    'enabled': true,
	    'text': 'Has llegado a la edición de México. Quedarse en el sitio actual o ir a edición preferida.'
	  },
	  'feeds': {
	    'googlenews': {
	      'allowedContentTypes': ['TopStoryPackage', 'BlogEntry', 'HeadlineNews']
	    }
	  },
	  'tier2NavIds': {
	    'baseball': 3023264,
	    'basketball': 2474875,
	    'boxing': 2474907,
	    'ciclismo': 2882281,
	    'espn-run': 2507524,
	    'esports': 2882075,
	    'espys': 3121931,
	    'f1': 2474769,
	    'football': 2474884,
	    'golf': 2475240,
	    'los-angeles': '',
	    'mlb': 3023264,
	    'mlb/beisbolexperience': 3044646,
	    'mma': 2475264,
	    'motociclismo': 3397504,
	    'nacion-espn': 2652083,
	    'nba': 2474875,
	    'nba/summerleague': 3316630,
	    'nexoespn': 2649285,
	    'nfl': 2474884,
	    'oly/summer/archery': 2475258,
	    'oly/summer/athletics': 2475258,
	    'oly/summer/badminton': 2475258,
	    'oly/summer/basketball': 2475258,
	    'oly/summer/boxing': 2475258,
	    'oly/summer/canoe': 2475258,
	    'oly/summer/cycling': 2475258,
	    'oly/summer/equestrian': 2475258,
	    'oly/summer/fencing': 2475258,
	    'oly/summer/field-hockey': 2475258,
	    'oly/summer/golf': 2475258,
	    'oly/summer/gymnastics': 2475258,
	    'oly/summer/handball': 2475258,
	    'oly/summer/judo': 2475258,
	    'oly/summer/modern-pentathlon': 2475258,
	    'oly/summer/rowing': 2475258,
	    'oly/summer/rugby': 2475258,
	    'oly/summer/sailing': 2475258,
	    'oly/summer/shooting': 2475258,
	    'oly/summer/soccer': 2475258,
	    'oly/summer/swimming': 2475258,
	    'oly/summer/table-tennis': 2475258,
	    'oly/summer/taekwondo': 2475258,
	    'oly/summer/tennis': 2475258,
	    'oly/summer/triathlon': 2475258,
	    'oly/summer/volleyball': 2475258,
	    'oly/summer/water-polo': 2475258,
	    'oly/summer/weightlifting': 2475258,
	    'oly/summer/wrestling': 2475258,
	    'olympics': 2475258,
	    'other-sports': 2475272,
	    'panamerican': 2507636,
	    'poker': 2506302,
	    'polo': 2511033,
	    'rpm': 2474747,
	    'rugby': 2474293,
	    'serie-del-caribe': 2955159,
	    'soccer': 2487614,
	    'tennis': 2474261,
	    'world-baseball-classic': 2978462,
	    'wwe': 2946192,
	    'x-games': 2475269
	  },
	  'tier3NavIds': {
	    'clubhouse': {
	      'nfl': 2520032,
	      'mlb': 2523552,
	      'nba': 2525379,
	      'soccer': 2525397
	    }
	  },
	  'indexAutoStart': false,
	  'useMongo': true,
	  'activeSite': true,
	  'countries': [{
	    'name': 'Guatemala',
	    'country-code': 'gt',
	    'showHreflang': true
	  }],
	  'reactOverride': {
	    'cricket': {
	      'scores': true
	    }
	  }
	};

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(685);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _pathSegments;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// git hash 8ee6b172772eecafce6aa2c5c0f974c689aeb397
	exports.default = {
	  'editionSettings': {
	    'key': 'espn-es-mx',
	    'site': 'espn',
	    'language': 'es',
	    'country': 'mx',
	    'domain': 'www.espn.com.mx',
	    'editionSiteId': '20',
	    'https': false,
	    'supportsOneSite': false
	  },
	  'navId': '2487602',
	  'dictionarySection': 'espn',
	  'javaLocale': {
	    'language': 'es',
	    'region': 'MX'
	  },
	  'dateTime': {
	    'long': 'dddd MMMM d, yyyy',
	    'medium': 'MMMM d, yyyy',
	    'short': 'M/d',
	    'timeFormat': 'h:mm',
	    'firstDayOfWeek': 'Sunday',
	    'timeZone': 'America/Santiago',
	    'defaultFormat': 'd MMM, yyyy',
	    'timeZoneString': 'CT',
	    'timeZoneBucket': 'America/New_York',
	    'MMM D, YYYY': 'D MMM, YYYY',
	    'M/D/YYYY': 'D/M/YYYY',
	    'MM/DD/YYYY': 'DD/MM/YYYY',
	    'MMDDYYYY': 'DDMMYYYY',
	    'MMMM Do YYYY': 'Do MMMM YYYY',
	    'dddd, MMMM Do YYYY': 'dddd, Do MMMM YYYY',
	    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
	    'M/D': 'D/M',
	    'MMMM D, YYYY': 'D MMMM YYYY',
	    'dddd, M/D': 'dddd, D/M',
	    'age': {
	      'seconds': 's',
	      'minutes': 'm',
	      'hours': 'h',
	      'days': 'd'
	    }
	  },
	  'numberFormat': {
	    'long': '#,###',
	    'short': '###',
	    'currency': '#,###.00',
	    'percent': '#.00%'
	  },
	  'temperature': {
	    'scale': 'celsius',
	    'symbol': '&deg; C'
	  },
	  'outbrain': {
	    'enabled': true,
	    'template': 'ESPNDeportesLATAM',
	    'desktop': {
	      'compliantId': 'AR_2',
	      'nonCompliantId': 'AR_4'
	    },
	    'mobile': {
	      'compliantId': 'MB_2',
	      'nonCompliantId': 'MB_6'
	    },
	    'video': {
	      'desktop': {
	        'compliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6'
	      }
	    },
	    'report': {
	      'desktop': {
	        'compliantId': 'AR_30',
	        'nonCompliantId': 'AR_30'
	      },
	      'mobile': {
	        'compliantId': 'MB_9',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'table': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'MB_43'
	      }
	    },
	    'game': {
	      'desktop': {
	        'compliantId': 'AR_48'
	      },
	      'mobile': {
	        'compliantId': 'AR_48'
	      }
	    }
	  },
	  'omniture': {
	    'enabled': true
	  },
	  'chartBeat': {
	    'enabled': true
	  },
	  'ads': {
	    'disabled': false,
	    'network': 1234,
	    'partnerAd': false,
	    'dev-config': 14005378,
	    'qa-config': 14005378,
	    'prod-config': 14005378,
	    'outputType': 'js',
	    'featurePhone': {
	      'outputType': 'no-js'
	    }
	  },
	  'partnerModules': {
	    'global': false,
	    'nba': false,
	    'womenbb': false,
	    'golf': false,
	    'endurance': false,
	    'horse': false,
	    'nascar': false
	  },
	  'sportBranding': [{
	    'sport': 'cricket',
	    'image': 'logo-uk-cricinfo',
	    'url': 'http://www.espncricinfo.com'
	  }, {
	    'sport': 'soccer',
	    'image': 'logo-deportes-fc',
	    'url': 'http://www.espn.com.mx/futbol/'
	  }, {
	    'sport': 'rugby',
	    'image': 'logo-deportes-scrum',
	    'url': 'http://www.espn.com.mx/rugby/'
	  }, {
	    'sport': 'ncaaw',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'ncw',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'wnba',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'womenbb',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }],
	  'siteLogo': {
	    'class': '',
	    'featurePhone': {
	      'name': 'espn-logo',
	      'width': 45,
	      'height': 11
	    }
	  },
	  'meta': {
	    'titleBranding': ' - ESPN',
	    'description': 'ESPN lo último del mundo deportivo.',
	    'defaultMetaImage': 'espn_red.png',
	    'schema': {
	      'name': 'ESPN'
	    },
	    'social': {
	      'twitter': {
	        'twitterId': '',
	        'card': 'summary',
	        'app_id_iphone': '317469184',
	        'site': 'espn',
	        'app_name_googleplay': 'ESPN',
	        'app_id_googleplay': 'com.espn.score_center',
	        'app_name_iphone': 'ESPN',
	        'language': 'es'
	      },
	      'facebook': {
	        'id': '116656161708917',
	        'og_site_name': 'ESPN.com.mx',
	        'locale': 'es_ES'
	      }
	    }
	  },
	  'shop': {
	    'enabled': false
	  },
	  'sportReplacements': {},
	  'uriRewrites': {
	    'urls': {
	      'toEdition': {
	        '/futbol-americano/nfl/': '/futbol-americano/',
	        '/beisbol/mlb/': '/beisbol/',
	        '/basquetbol/nba/': '/basquetbol/'
	      },
	      'toEnglish': {}
	    },
	    'roots': {
	      'toEdition': {},
	      'toEnglish': {}
	    },
	    'pathSegments': (_pathSegments = {
	      'reporte': 'report',
	      'juego': 'game',
	      'equipo': 'team',
	      'plantel': 'roster',
	      'estadisticas': 'stats',
	      'calendario': 'schedule',
	      'estadio': 'stadium',
	      'profundidad': 'depth',
	      'conversacion': 'conversation',
	      'ficha': 'boxscore',
	      'previa': 'preview',
	      'partido': 'match',
	      'jugadas': 'playbyplay',
	      'cronica': 'recap',
	      'fotos': 'photos',
	      'duelo': 'matchup',
	      'jugador': 'player',
	      'posiciones': 'standings',
	      'lesiones': 'injuries',
	      'bateo': 'batting',
	      'grilla': 'grid',
	      'piloto': 'driver',
	      'resultados': 'scoreboard',
	      'liga': 'league',
	      'ligas': 'leagues',
	      'nota': 'story',
	      'comentario': 'commentary',
	      'alineacion': 'lineups'
	    }, (0, _defineProperty3.default)(_pathSegments, 'estadisticas', 'matchstats'), (0, _defineProperty3.default)(_pathSegments, 'jugador-estadisticas', 'playerstats'), (0, _defineProperty3.default)(_pathSegments, 'medallas', 'medals'), (0, _defineProperty3.default)(_pathSegments, 'deportes', 'sports'), (0, _defineProperty3.default)(_pathSegments, 'deportistas', 'athletes'), (0, _defineProperty3.default)(_pathSegments, 'lideres', 'leaderboard'), (0, _defineProperty3.default)(_pathSegments, 'envivo', 'live'), (0, _defineProperty3.default)(_pathSegments, 'ronda', 'rounds'), (0, _defineProperty3.default)(_pathSegments, 'equipos', 'teams'), (0, _defineProperty3.default)(_pathSegments, 'posicion', 'positions'), (0, _defineProperty3.default)(_pathSegments, 'mejordisponible', 'bestavailable'), (0, _defineProperty3.default)(_pathSegments, 'noticias', 'news'), (0, _defineProperty3.default)(_pathSegments, 'noticiasdelequipo', 'teamnews'), (0, _defineProperty3.default)(_pathSegments, 'fecha', 'date'), _pathSegments),
	    'paramKeys': {
	      'juegoId': 'gameId',
	      'fecha': 'date',
	      'equipo': 'team',
	      'nombre': 'name',
	      'partido': 'gameID',
	      'liga': 'league',
	      'tipodetemporada': 'seasontype',
	      'ano': 'year',
	      'semana': 'week',
	      'deportes': 'discipline',
	      'evento': 'event',
	      'torneo': 'tournamentId',
	      'deportista': 'athlete',
	      'vista': 'view',
	      'pais': 'country',
	      'pagina': 'page',
	      'continuo': 'continuous',
	      'ronda': 'round',
	      'posicion': 'position'
	    },
	    'paramValues': {
	      'liga': 'league',
	      'todo': 'all',
	      'deportistas': 'athletes',
	      'paises': 'countries'
	    }
	  },
	  'betting': {
	    'enabled': true,
	    'provider': 'caliente',
	    'game': {
	      'enabled': false,
	      'provider': 'caliente'
	    }
	  },
	  'ticketProvider': null,
	  'hasTickets': false,
	  'showFavorites': true,
	  'showInsider': false,
	  'showWatch': false,
	  'hideCategoryLinks': [600, 1700],
	  'categorySettings': {
	    'leagues': true,
	    'athletes': true,
	    'teams': true,
	    'tags': true
	  },
	  'showFCContent': true,
	  'showCricInfoContent': false,
	  'cookieConsent': true,
	  'scDeepLinking': true,
	  'allowShortUrl': false,
	  'allowPrintUrl': true,
	  'allowUserAccountManagement': true,
	  'nowFeed': false,
	  'searchUrl': 'http://buscar.espn.com/',
	  'gameSettings': {
	    'topEventsId': 2524470,
	    'promotedSoccerLeaguesCeId': 2508975,
	    'showBroadcast': false
	  },
	  'fallback': {
	    'baseball': 'espn-es-us-baseball-index',
	    'basketball': 'espn-es-us-basketball-index',
	    'boxing': 'espn-es-us-boxing-index',
	    'ciclismo': 'espn-es-co-ciclismo-index',
	    'espn-run': 'espn-es-ar-espn-run-index',
	    'esports': 'espn-es-us-esports-index',
	    'espys': 'espn-es-us-espys-index',
	    'f1': 'espn-es-mx-f1-index',
	    'football': 'espn-es-mx-football-index',
	    'golf': 'espn-es-ar-golf-index',
	    'los-angeles': 'espn-es-us-frontpage-index',
	    'mlb': 'espn-es-us-baseball-index',
	    'mlb-beisbolexperience': 'espn-es-us-mlb-beisbolexperience-index',
	    'mma': 'espn-es-mx-mma-index',
	    'motociclismo': 'espn-es-ar-motociclismo-index',
	    'nacion-espn': 'espn-es-us-nacion-espn-index',
	    'nba': 'espn-es-us-basketball-index',
	    'nba-summerleague': 'espn-es-us-nba-summerleague-index',
	    'nexoespn': 'espn-es-co-nexoespn-index',
	    'nfl': 'espn-es-mx-football-index',
	    'oly-summer-archery': 'espn-es-mx-oly-summer-archery-index',
	    'oly-summer-athletics': 'espn-es-mx-oly-summer-athletics-index',
	    'oly-summer-badminton': 'espn-es-mx-oly-summer-badminton-index',
	    'oly-summer-basketball': 'espn-es-mx-oly-summer-basketball-index',
	    'oly-summer-boxing': 'espn-es-mx-oly-summer-boxing-index',
	    'oly-summer-canoe': 'espn-es-mx-oly-summer-canoe-index',
	    'oly-summer-cycling': 'espn-es-mx-oly-summer-cycling-index',
	    'oly-summer-equestrian': 'espn-es-mx-oly-summer-equestrian-index',
	    'oly-summer-fencing': 'espn-es-mx-oly-summer-fencing-index',
	    'oly-summer-field-hockey': 'espn-es-mx-oly-summer-field-hockey-index',
	    'oly-summer-golf': 'espn-es-mx-oly-summer-golf-index',
	    'oly-summer-gymnastics': 'espn-es-mx-oly-summer-gymnastics-index',
	    'oly-summer-handball': 'espn-es-mx-oly-summer-handball-index',
	    'oly-summer-judo': 'espn-es-mx-oly-summer-judo-index',
	    'oly-summer-modern-pentathlon': 'espn-es-mx-oly-summer-modern-pentathlon-index',
	    'oly-summer-rowing': 'espn-es-mx-oly-summer-rowing-index',
	    'oly-summer-rugby': 'espn-es-mx-oly-summer-rugby-index',
	    'oly-summer-sailing': 'espn-es-mx-oly-summer-sailing-index',
	    'oly-summer-shooting': 'espn-es-mx-oly-summer-shooting-index',
	    'oly-summer-soccer': 'espn-es-mx-oly-summer-soccer-index',
	    'oly-summer-swimming': 'espn-es-mx-oly-summer-swimming-index',
	    'oly-summer-table-tennis': 'espn-es-mx-oly-summer-table-tennis-index',
	    'oly-summer-taekwondo': 'espn-es-mx-oly-summer-taekwondo-index',
	    'oly-summer-tennis': 'espn-es-mx-oly-summer-tennis-index',
	    'oly-summer-triathlon': 'espn-es-mx-oly-summer-triathlon-index',
	    'oly-summer-volleyball': 'espn-es-mx-oly-summer-volleyball-index',
	    'oly-summer-water-polo': 'espn-es-mx-oly-summer-water-polo-index',
	    'oly-summer-weightlifting': 'espn-es-mx-oly-summer-weightlifting-index',
	    'oly-summer-wrestling': 'espn-es-mx-oly-summer-wrestling-index',
	    'olympics': 'espn-es-mx-olympics-index',
	    'other-sports': 'espn-es-us-other-sports-index',
	    'panamerican': 'espn-es-us-panamerican-index',
	    'poker': 'espn-es-ar-poker-index',
	    'polo': 'espn-es-ar-polo-index',
	    'rpm': 'espn-es-ar-rpm-index',
	    'rugby': 'espn-es-ar-rugby-index',
	    'serie-del-caribe': 'espn-es-us-serie-del-caribe-index',
	    'soccer': 'espn-es-mx-soccer-index',
	    'tennis': 'espn-es-ar-tennis-index',
	    'world-baseball-classic': 'espn-es-us-world-baseball-classic-index',
	    'wwe': 'espn-es-us-luchalibre-index',
	    'x-games': 'espn-es-ar-x-games-index'
	  },
	  'editionAlert': {
	    'enabled': true,
	    'text': 'Has llegado a la edición de México. Quedarse en el sitio actual o ir a edición preferida.'
	  },
	  'feeds': {
	    'googlenews': {
	      'allowedContentTypes': ['TopStoryPackage', 'BlogEntry', 'HeadlineNews']
	    }
	  },
	  'tier2NavIds': {
	    'league': {
	      'soccer': 2520885
	    },
	    'baseball': 2627759,
	    'basketball': 2474875,
	    'boxing': 2627758,
	    'ciclismo': 2882281,
	    'espn-run': 2623345,
	    'espnradio': 2639931,
	    'esports': 2774868,
	    'espys': 3121931,
	    'f1': 2474769,
	    'football': 2627761,
	    'golf': 3323747,
	    'los-angeles': '',
	    'mlb': 3023264,
	    'mlb/beisbolexperience': 3044646,
	    'mma': 2475264,
	    'motociclismo': 3397504,
	    'nacion-espn': 2652083,
	    'nba': 2474875,
	    'nba/summerleague': 3316630,
	    'nexoespn': 2652719,
	    'nfl': 2627761,
	    'oly/summer/archery': 2475258,
	    'oly/summer/athletics': 2475258,
	    'oly/summer/badminton': 2475258,
	    'oly/summer/basketball': 2475258,
	    'oly/summer/boxing': 2475258,
	    'oly/summer/canoe': 2475258,
	    'oly/summer/cycling': 2475258,
	    'oly/summer/equestrian': 2475258,
	    'oly/summer/fencing': 2475258,
	    'oly/summer/field-hockey': 2475258,
	    'oly/summer/golf': 2475258,
	    'oly/summer/gymnastics': 2475258,
	    'oly/summer/handball': 2475258,
	    'oly/summer/judo': 2475258,
	    'oly/summer/modern-pentathlon': 2475258,
	    'oly/summer/rowing': 2475258,
	    'oly/summer/rugby': 2475258,
	    'oly/summer/sailing': 2475258,
	    'oly/summer/shooting': 2475258,
	    'oly/summer/soccer': 2475258,
	    'oly/summer/swimming': 2475258,
	    'oly/summer/table-tennis': 2475258,
	    'oly/summer/taekwondo': 2475258,
	    'oly/summer/tennis': 2475258,
	    'oly/summer/triathlon': 2475258,
	    'oly/summer/volleyball': 2475258,
	    'oly/summer/water-polo': 2475258,
	    'oly/summer/weightlifting': 2475258,
	    'oly/summer/wrestling': 2475258,
	    'olympics': 2475258,
	    'other-sports': 2475272,
	    'panamerican': 2507636,
	    'poker': 2506302,
	    'polo': 2511033,
	    'rpm': 2474747,
	    'rugby': 2474293,
	    'serie-del-caribe': 2955159,
	    'soccer': 2487614,
	    'television': 2652719,
	    'tennis': 2474261,
	    'watch': 3046205,
	    'world-baseball-classic': 2978462,
	    'wwe': 2946192,
	    'x-games': 2475269
	  },
	  'tier3NavIds': {
	    'clubhouse': {
	      'nfl': 2520032,
	      'mlb': 2523552,
	      'nba': 2525379,
	      'soccer': 2525397
	    }
	  },
	  'indexAutoStart': false,
	  'useMongo': true,
	  'activeSite': true,
	  'countries': [{
	    'name': 'Mexico',
	    'country-code': 'mx',
	    'showHreflang': true
	  }],
	  'reactOverride': {
	    'cricket': {
	      'scores': true
	    }
	  }
	};

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(685);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _pathSegments;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// git hash 8ee6b172772eecafce6aa2c5c0f974c689aeb397
	exports.default = {
	  'editionSettings': {
	    'key': 'espn-es-pa',
	    'site': 'espn',
	    'language': 'es',
	    'country': 'pa',
	    'domain': 'www.espn.com',
	    'editionSiteId': '1',
	    'https': false,
	    'supportsOneSite': true
	  },
	  'navId': '3462152',
	  'dictionarySection': 'espn',
	  'javaLocale': {
	    'language': 'es',
	    'region': 'MX'
	  },
	  'dateTime': {
	    'long': 'dddd MMMM d, yyyy',
	    'medium': 'MMMM d, yyyy',
	    'short': 'M/d',
	    'timeFormat': 'h:mm',
	    'firstDayOfWeek': 'Sunday',
	    'timeZone': 'America/Santiago',
	    'defaultFormat': 'd MMM, yyyy',
	    'timeZoneString': 'CT',
	    'timeZoneBucket': 'America/New_York',
	    'MMM D, YYYY': 'D MMM, YYYY',
	    'M/D/YYYY': 'D/M/YYYY',
	    'MM/DD/YYYY': 'DD/MM/YYYY',
	    'MMDDYYYY': 'DDMMYYYY',
	    'MMMM Do YYYY': 'Do MMMM YYYY',
	    'dddd, MMMM Do YYYY': 'dddd, Do MMMM YYYY',
	    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
	    'M/D': 'D/M',
	    'MMMM D, YYYY': 'D MMMM YYYY',
	    'dddd, M/D': 'dddd, D/M',
	    'age': {
	      'seconds': 's',
	      'minutes': 'm',
	      'hours': 'h',
	      'days': 'd'
	    }
	  },
	  'numberFormat': {
	    'long': '#,###',
	    'short': '###',
	    'currency': '#,###.00',
	    'percent': '#.00%'
	  },
	  'temperature': {
	    'scale': 'celsius',
	    'symbol': '&deg; C'
	  },
	  'outbrain': {
	    'enabled': true,
	    'template': 'ESPNDeportesLATAM',
	    'desktop': {
	      'compliantId': 'AR_2',
	      'nonCompliantId': 'AR_4'
	    },
	    'mobile': {
	      'compliantId': 'MB_2',
	      'nonCompliantId': 'MB_6'
	    },
	    'video': {
	      'desktop': {
	        'compliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6'
	      }
	    },
	    'report': {
	      'desktop': {
	        'compliantId': 'AR_30',
	        'nonCompliantId': 'AR_30'
	      },
	      'mobile': {
	        'compliantId': 'MB_9',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'table': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'MB_43'
	      }
	    },
	    'game': {
	      'desktop': {
	        'compliantId': 'AR_48'
	      },
	      'mobile': {
	        'compliantId': 'AR_48'
	      }
	    }
	  },
	  'omniture': {
	    'enabled': true
	  },
	  'chartBeat': {
	    'enabled': true
	  },
	  'ads': {
	    'disabled': false,
	    'network': 1234,
	    'partnerAd': false,
	    'dev-config': 14005378,
	    'qa-config': 14005378,
	    'prod-config': 14005378,
	    'outputType': 'js',
	    'featurePhone': {
	      'outputType': 'no-js'
	    }
	  },
	  'partnerModules': {
	    'global': false,
	    'nba': false,
	    'womenbb': false,
	    'golf': false,
	    'endurance': false,
	    'horse': false,
	    'nascar': false
	  },
	  'sportBranding': [{
	    'sport': 'cricket',
	    'image': 'logo-uk-cricinfo',
	    'url': 'http://www.espncricinfo.com'
	  }, {
	    'sport': 'soccer',
	    'image': 'logo-deportes-fc',
	    'url': 'http://www.espn.com.mx/futbol/'
	  }, {
	    'sport': 'rugby',
	    'image': 'logo-deportes-scrum',
	    'url': 'http://www.espn.com.mx/rugby/'
	  }, {
	    'sport': 'ncaaw',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'ncw',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'wnba',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'womenbb',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }],
	  'siteLogo': {
	    'class': '',
	    'featurePhone': {
	      'name': 'espn-logo',
	      'width': 45,
	      'height': 11
	    }
	  },
	  'meta': {
	    'titleBranding': ' - ESPN',
	    'description': 'ESPN lo último del mundo deportivo.',
	    'defaultMetaImage': 'espn_red.png',
	    'schema': {
	      'name': 'ESPN'
	    },
	    'social': {
	      'twitter': {
	        'twitterId': '',
	        'card': 'summary',
	        'app_id_iphone': '317469184',
	        'site': 'espn',
	        'app_name_googleplay': 'ESPN',
	        'app_id_googleplay': 'com.espn.score_center',
	        'app_name_iphone': 'ESPN',
	        'language': 'es'
	      },
	      'facebook': {
	        'id': '116656161708917',
	        'og_site_name': 'ESPN.com.mx',
	        'locale': 'es_ES'
	      }
	    }
	  },
	  'shop': {
	    'enabled': false
	  },
	  'sportReplacements': {},
	  'uriRewrites': {
	    'urls': {
	      'toEdition': {
	        '/futbol-americano/nfl/': '/futbol-americano/',
	        '/beisbol/mlb/': '/beisbol/',
	        '/basquetbol/nba/': '/basquetbol/'
	      },
	      'toEnglish': {}
	    },
	    'roots': {
	      'toEdition': {},
	      'toEnglish': {}
	    },
	    'pathSegments': (_pathSegments = {
	      'reporte': 'report',
	      'juego': 'game',
	      'equipo': 'team',
	      'plantel': 'roster',
	      'estadisticas': 'stats',
	      'calendario': 'schedule',
	      'estadio': 'stadium',
	      'profundidad': 'depth',
	      'conversacion': 'conversation',
	      'ficha': 'boxscore',
	      'previa': 'preview',
	      'partido': 'match',
	      'jugadas': 'playbyplay',
	      'cronica': 'recap',
	      'fotos': 'photos',
	      'duelo': 'matchup',
	      'jugador': 'player',
	      'posiciones': 'standings',
	      'lesiones': 'injuries',
	      'bateo': 'batting',
	      'grilla': 'grid',
	      'piloto': 'driver',
	      'resultados': 'scoreboard',
	      'liga': 'league',
	      'ligas': 'leagues',
	      'nota': 'story',
	      'comentario': 'commentary',
	      'alineacion': 'lineups'
	    }, (0, _defineProperty3.default)(_pathSegments, 'estadisticas', 'matchstats'), (0, _defineProperty3.default)(_pathSegments, 'jugador-estadisticas', 'playerstats'), (0, _defineProperty3.default)(_pathSegments, 'medallas', 'medals'), (0, _defineProperty3.default)(_pathSegments, 'deportes', 'sports'), (0, _defineProperty3.default)(_pathSegments, 'deportistas', 'athletes'), (0, _defineProperty3.default)(_pathSegments, 'lideres', 'leaderboard'), (0, _defineProperty3.default)(_pathSegments, 'envivo', 'live'), (0, _defineProperty3.default)(_pathSegments, 'ronda', 'rounds'), (0, _defineProperty3.default)(_pathSegments, 'equipos', 'teams'), (0, _defineProperty3.default)(_pathSegments, 'posicion', 'positions'), (0, _defineProperty3.default)(_pathSegments, 'mejordisponible', 'bestavailable'), (0, _defineProperty3.default)(_pathSegments, 'noticias', 'news'), (0, _defineProperty3.default)(_pathSegments, 'noticiasdelequipo', 'teamnews'), (0, _defineProperty3.default)(_pathSegments, 'fecha', 'date'), _pathSegments),
	    'paramKeys': {
	      'juegoId': 'gameId',
	      'fecha': 'date',
	      'equipo': 'team',
	      'nombre': 'name',
	      'partido': 'gameID',
	      'liga': 'league',
	      'tipodetemporada': 'seasontype',
	      'ano': 'year',
	      'semana': 'week',
	      'deportes': 'discipline',
	      'evento': 'event',
	      'torneo': 'tournamentId',
	      'deportista': 'athlete',
	      'vista': 'view',
	      'pais': 'country',
	      'pagina': 'page',
	      'continuo': 'continuous',
	      'ronda': 'round',
	      'posicion': 'position'
	    },
	    'paramValues': {
	      'liga': 'league',
	      'todo': 'all',
	      'deportistas': 'athletes',
	      'paises': 'countries'
	    }
	  },
	  'betting': {
	    'enabled': true,
	    'provider': 'caliente',
	    'game': {
	      'enabled': false,
	      'provider': 'caliente'
	    }
	  },
	  'ticketProvider': null,
	  'hasTickets': false,
	  'showFavorites': true,
	  'showInsider': false,
	  'showWatch': false,
	  'hideCategoryLinks': [600, 1700],
	  'categorySettings': {
	    'leagues': true,
	    'athletes': true,
	    'teams': true,
	    'tags': true
	  },
	  'showFCContent': true,
	  'showCricInfoContent': false,
	  'cookieConsent': true,
	  'scDeepLinking': true,
	  'allowShortUrl': false,
	  'allowPrintUrl': true,
	  'allowUserAccountManagement': true,
	  'nowFeed': false,
	  'searchUrl': 'http://buscar.espn.com/',
	  'gameSettings': {
	    'topEventsId': 3466494,
	    'promotedSoccerLeaguesCeId': 3466728,
	    'showBroadcast': false
	  },
	  'fallback': {
	    'baseball': 'espn-es-us-baseball-index',
	    'basketball': 'espn-es-us-basketball-index',
	    'boxing': 'espn-es-us-boxing-index',
	    'ciclismo': 'espn-es-co-ciclismo-index',
	    'espn-run': 'espn-es-ar-espn-run-index',
	    'esports': 'espn-es-us-esports-index',
	    'espys': 'espn-es-us-espys-index',
	    'f1': 'espn-es-mx-f1-index',
	    'football': 'espn-es-us-football-index',
	    'golf': 'espn-es-ar-golf-index',
	    'los-angeles': 'espn-es-us-frontpage-index',
	    'mlb': 'espn-es-us-baseball-index',
	    'mlb-beisbolexperience': 'espn-es-us-mlb-beisbolexperience-index',
	    'mma': 'espn-es-mx-mma-index',
	    'motociclismo': 'espn-es-ar-motociclismo-index',
	    'nacion-espn': 'espn-es-us-nacion-espn-index',
	    'nba': 'espn-es-us-basketball-index',
	    'nba-summerleague': 'espn-es-us-nba-summerleague-index',
	    'nexoespn': 'espn-es-co-nexoespn-index',
	    'nfl': 'espn-es-us-football-index',
	    'oly-summer-archery': 'espn-es-mx-oly-summer-archery-index',
	    'oly-summer-athletics': 'espn-es-mx-oly-summer-athletics-index',
	    'oly-summer-badminton': 'espn-es-mx-oly-summer-badminton-index',
	    'oly-summer-basketball': 'espn-es-mx-oly-summer-basketball-index',
	    'oly-summer-boxing': 'espn-es-mx-oly-summer-boxing-index',
	    'oly-summer-canoe': 'espn-es-mx-oly-summer-canoe-index',
	    'oly-summer-cycling': 'espn-es-mx-oly-summer-cycling-index',
	    'oly-summer-equestrian': 'espn-es-mx-oly-summer-equestrian-index',
	    'oly-summer-fencing': 'espn-es-mx-oly-summer-fencing-index',
	    'oly-summer-field-hockey': 'espn-es-mx-oly-summer-field-hockey-index',
	    'oly-summer-golf': 'espn-es-mx-oly-summer-golf-index',
	    'oly-summer-gymnastics': 'espn-es-mx-oly-summer-gymnastics-index',
	    'oly-summer-handball': 'espn-es-mx-oly-summer-handball-index',
	    'oly-summer-judo': 'espn-es-mx-oly-summer-judo-index',
	    'oly-summer-modern-pentathlon': 'espn-es-mx-oly-summer-modern-pentathlon-index',
	    'oly-summer-rowing': 'espn-es-mx-oly-summer-rowing-index',
	    'oly-summer-rugby': 'espn-es-mx-oly-summer-rugby-index',
	    'oly-summer-sailing': 'espn-es-mx-oly-summer-sailing-index',
	    'oly-summer-shooting': 'espn-es-mx-oly-summer-shooting-index',
	    'oly-summer-soccer': 'espn-es-mx-oly-summer-soccer-index',
	    'oly-summer-swimming': 'espn-es-mx-oly-summer-swimming-index',
	    'oly-summer-table-tennis': 'espn-es-mx-oly-summer-table-tennis-index',
	    'oly-summer-taekwondo': 'espn-es-mx-oly-summer-taekwondo-index',
	    'oly-summer-tennis': 'espn-es-mx-oly-summer-tennis-index',
	    'oly-summer-triathlon': 'espn-es-mx-oly-summer-triathlon-index',
	    'oly-summer-volleyball': 'espn-es-mx-oly-summer-volleyball-index',
	    'oly-summer-water-polo': 'espn-es-mx-oly-summer-water-polo-index',
	    'oly-summer-weightlifting': 'espn-es-mx-oly-summer-weightlifting-index',
	    'oly-summer-wrestling': 'espn-es-mx-oly-summer-wrestling-index',
	    'olympics': 'espn-es-mx-olympics-index',
	    'other-sports': 'espn-es-us-other-sports-index',
	    'panamerican': 'espn-es-us-panamerican-index',
	    'poker': 'espn-es-ar-poker-index',
	    'polo': 'espn-es-ar-polo-index',
	    'rpm': 'espn-es-ar-rpm-index',
	    'rugby': 'espn-es-ar-rugby-index',
	    'serie-del-caribe': 'espn-es-us-serie-del-caribe-index',
	    'soccer': 'espn-es-mx-soccer-index',
	    'tennis': 'espn-es-ar-tennis-index',
	    'world-baseball-classic': 'espn-es-us-world-baseball-classic-index',
	    'wwe': 'espn-es-us-luchalibre-index',
	    'x-games': 'espn-es-ar-x-games-index'
	  },
	  'editionAlert': {
	    'enabled': true,
	    'text': 'Has llegado a la edición de México. Quedarse en el sitio actual o ir a edición preferida.'
	  },
	  'feeds': {
	    'googlenews': {
	      'allowedContentTypes': ['TopStoryPackage', 'BlogEntry', 'HeadlineNews']
	    }
	  },
	  'tier2NavIds': {
	    'baseball': 3023264,
	    'basketball': 2474875,
	    'boxing': 2474907,
	    'ciclismo': 2882281,
	    'espn-run': 2507524,
	    'esports': 2882075,
	    'espys': 3121931,
	    'f1': 2474769,
	    'football': 2474884,
	    'golf': 2475240,
	    'los-angeles': '',
	    'mlb': 3023264,
	    'mlb/beisbolexperience': 3044646,
	    'mma': 2475264,
	    'motociclismo': 3397504,
	    'nacion-espn': 2652083,
	    'nba': 2474875,
	    'nba/summerleague': 3316630,
	    'nexoespn': 2649285,
	    'nfl': 2474884,
	    'oly/summer/archery': 2475258,
	    'oly/summer/athletics': 2475258,
	    'oly/summer/badminton': 2475258,
	    'oly/summer/basketball': 2475258,
	    'oly/summer/boxing': 2475258,
	    'oly/summer/canoe': 2475258,
	    'oly/summer/cycling': 2475258,
	    'oly/summer/equestrian': 2475258,
	    'oly/summer/fencing': 2475258,
	    'oly/summer/field-hockey': 2475258,
	    'oly/summer/golf': 2475258,
	    'oly/summer/gymnastics': 2475258,
	    'oly/summer/handball': 2475258,
	    'oly/summer/judo': 2475258,
	    'oly/summer/modern-pentathlon': 2475258,
	    'oly/summer/rowing': 2475258,
	    'oly/summer/rugby': 2475258,
	    'oly/summer/sailing': 2475258,
	    'oly/summer/shooting': 2475258,
	    'oly/summer/soccer': 2475258,
	    'oly/summer/swimming': 2475258,
	    'oly/summer/table-tennis': 2475258,
	    'oly/summer/taekwondo': 2475258,
	    'oly/summer/tennis': 2475258,
	    'oly/summer/triathlon': 2475258,
	    'oly/summer/volleyball': 2475258,
	    'oly/summer/water-polo': 2475258,
	    'oly/summer/weightlifting': 2475258,
	    'oly/summer/wrestling': 2475258,
	    'olympics': 2475258,
	    'other-sports': 2475272,
	    'panamerican': 2507636,
	    'poker': 2506302,
	    'polo': 2511033,
	    'rpm': 2474747,
	    'rugby': 2474293,
	    'serie-del-caribe': 2955159,
	    'soccer': 2487614,
	    'tennis': 2474261,
	    'world-baseball-classic': 2978462,
	    'wwe': 2946192,
	    'x-games': 2475269
	  },
	  'tier3NavIds': {
	    'clubhouse': {
	      'nfl': 2520032,
	      'mlb': 2523552,
	      'nba': 2525379,
	      'soccer': 2525397
	    }
	  },
	  'indexAutoStart': false,
	  'useMongo': true,
	  'activeSite': true,
	  'countries': [{
	    'name': 'Panama',
	    'country-code': 'pa',
	    'showHreflang': true
	  }],
	  'reactOverride': {
	    'cricket': {
	      'scores': true
	    }
	  }
	};

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(685);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _pathSegments;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// git hash 8ee6b172772eecafce6aa2c5c0f974c689aeb397
	exports.default = {
	  'editionSettings': {
	    'key': 'espn-es-pe',
	    'site': 'espn',
	    'language': 'es',
	    'country': 'pe',
	    'domain': 'www.espn.com',
	    'editionSiteId': '1',
	    'https': false,
	    'supportsOneSite': true
	  },
	  'navId': '3462149',
	  'dictionarySection': 'espn',
	  'javaLocale': {
	    'language': 'es',
	    'region': 'MX'
	  },
	  'dateTime': {
	    'long': 'dddd MMMM d, yyyy',
	    'medium': 'MMMM d, yyyy',
	    'short': 'M/d',
	    'timeFormat': 'h:mm',
	    'firstDayOfWeek': 'Sunday',
	    'timeZone': 'America/Santiago',
	    'defaultFormat': 'd MMM, yyyy',
	    'timeZoneString': 'CT',
	    'timeZoneBucket': 'America/New_York',
	    'MMM D, YYYY': 'D MMM, YYYY',
	    'M/D/YYYY': 'D/M/YYYY',
	    'MM/DD/YYYY': 'DD/MM/YYYY',
	    'MMDDYYYY': 'DDMMYYYY',
	    'MMMM Do YYYY': 'Do MMMM YYYY',
	    'dddd, MMMM Do YYYY': 'dddd, Do MMMM YYYY',
	    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
	    'M/D': 'D/M',
	    'MMMM D, YYYY': 'D MMMM YYYY',
	    'dddd, M/D': 'dddd, D/M',
	    'age': {
	      'seconds': 's',
	      'minutes': 'm',
	      'hours': 'h',
	      'days': 'd'
	    }
	  },
	  'numberFormat': {
	    'long': '#,###',
	    'short': '###',
	    'currency': '#,###.00',
	    'percent': '#.00%'
	  },
	  'temperature': {
	    'scale': 'celsius',
	    'symbol': '&deg; C'
	  },
	  'outbrain': {
	    'enabled': true,
	    'template': 'ESPNDeportesLATAM',
	    'desktop': {
	      'compliantId': 'AR_2',
	      'nonCompliantId': 'AR_4'
	    },
	    'mobile': {
	      'compliantId': 'MB_2',
	      'nonCompliantId': 'MB_6'
	    },
	    'video': {
	      'desktop': {
	        'compliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6'
	      }
	    },
	    'report': {
	      'desktop': {
	        'compliantId': 'AR_30',
	        'nonCompliantId': 'AR_30'
	      },
	      'mobile': {
	        'compliantId': 'MB_9',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'table': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'MB_43'
	      }
	    },
	    'game': {
	      'desktop': {
	        'compliantId': 'AR_48'
	      },
	      'mobile': {
	        'compliantId': 'AR_48'
	      }
	    }
	  },
	  'omniture': {
	    'enabled': true
	  },
	  'chartBeat': {
	    'enabled': true
	  },
	  'ads': {
	    'disabled': false,
	    'network': 1234,
	    'partnerAd': false,
	    'dev-config': 14005378,
	    'qa-config': 14005378,
	    'prod-config': 14005378,
	    'outputType': 'js',
	    'featurePhone': {
	      'outputType': 'no-js'
	    }
	  },
	  'partnerModules': {
	    'global': false,
	    'nba': false,
	    'womenbb': false,
	    'golf': false,
	    'endurance': false,
	    'horse': false,
	    'nascar': false
	  },
	  'sportBranding': [{
	    'sport': 'cricket',
	    'image': 'logo-uk-cricinfo',
	    'url': 'http://www.espncricinfo.com'
	  }, {
	    'sport': 'soccer',
	    'image': 'logo-deportes-fc',
	    'url': 'http://www.espn.com.mx/futbol/'
	  }, {
	    'sport': 'rugby',
	    'image': 'logo-deportes-scrum',
	    'url': 'http://www.espn.com.mx/rugby/'
	  }, {
	    'sport': 'ncaaw',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'ncw',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'wnba',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'womenbb',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }],
	  'siteLogo': {
	    'class': '',
	    'featurePhone': {
	      'name': 'espn-logo',
	      'width': 45,
	      'height': 11
	    }
	  },
	  'meta': {
	    'titleBranding': ' - ESPN',
	    'description': 'ESPN lo último del mundo deportivo.',
	    'defaultMetaImage': 'espn_red.png',
	    'schema': {
	      'name': 'ESPN'
	    },
	    'social': {
	      'twitter': {
	        'twitterId': '',
	        'card': 'summary',
	        'app_id_iphone': '317469184',
	        'site': 'espn',
	        'app_name_googleplay': 'ESPN',
	        'app_id_googleplay': 'com.espn.score_center',
	        'app_name_iphone': 'ESPN',
	        'language': 'es'
	      },
	      'facebook': {
	        'id': '116656161708917',
	        'og_site_name': 'ESPN.com.mx',
	        'locale': 'es_ES'
	      }
	    }
	  },
	  'shop': {
	    'enabled': false
	  },
	  'sportReplacements': {},
	  'uriRewrites': {
	    'urls': {
	      'toEdition': {
	        '/futbol-americano/nfl/': '/futbol-americano/',
	        '/beisbol/mlb/': '/beisbol/',
	        '/basquetbol/nba/': '/basquetbol/'
	      },
	      'toEnglish': {}
	    },
	    'roots': {
	      'toEdition': {},
	      'toEnglish': {}
	    },
	    'pathSegments': (_pathSegments = {
	      'reporte': 'report',
	      'juego': 'game',
	      'equipo': 'team',
	      'plantel': 'roster',
	      'estadisticas': 'stats',
	      'calendario': 'schedule',
	      'estadio': 'stadium',
	      'profundidad': 'depth',
	      'conversacion': 'conversation',
	      'ficha': 'boxscore',
	      'previa': 'preview',
	      'partido': 'match',
	      'jugadas': 'playbyplay',
	      'cronica': 'recap',
	      'fotos': 'photos',
	      'duelo': 'matchup',
	      'jugador': 'player',
	      'posiciones': 'standings',
	      'lesiones': 'injuries',
	      'bateo': 'batting',
	      'grilla': 'grid',
	      'piloto': 'driver',
	      'resultados': 'scoreboard',
	      'liga': 'league',
	      'ligas': 'leagues',
	      'nota': 'story',
	      'comentario': 'commentary',
	      'alineacion': 'lineups'
	    }, (0, _defineProperty3.default)(_pathSegments, 'estadisticas', 'matchstats'), (0, _defineProperty3.default)(_pathSegments, 'jugador-estadisticas', 'playerstats'), (0, _defineProperty3.default)(_pathSegments, 'medallas', 'medals'), (0, _defineProperty3.default)(_pathSegments, 'deportes', 'sports'), (0, _defineProperty3.default)(_pathSegments, 'deportistas', 'athletes'), (0, _defineProperty3.default)(_pathSegments, 'lideres', 'leaderboard'), (0, _defineProperty3.default)(_pathSegments, 'envivo', 'live'), (0, _defineProperty3.default)(_pathSegments, 'ronda', 'rounds'), (0, _defineProperty3.default)(_pathSegments, 'equipos', 'teams'), (0, _defineProperty3.default)(_pathSegments, 'posicion', 'positions'), (0, _defineProperty3.default)(_pathSegments, 'mejordisponible', 'bestavailable'), (0, _defineProperty3.default)(_pathSegments, 'noticias', 'news'), (0, _defineProperty3.default)(_pathSegments, 'noticiasdelequipo', 'teamnews'), (0, _defineProperty3.default)(_pathSegments, 'fecha', 'date'), _pathSegments),
	    'paramKeys': {
	      'juegoId': 'gameId',
	      'fecha': 'date',
	      'equipo': 'team',
	      'nombre': 'name',
	      'partido': 'gameID',
	      'liga': 'league',
	      'tipodetemporada': 'seasontype',
	      'ano': 'year',
	      'semana': 'week',
	      'deportes': 'discipline',
	      'evento': 'event',
	      'torneo': 'tournamentId',
	      'deportista': 'athlete',
	      'vista': 'view',
	      'pais': 'country',
	      'pagina': 'page',
	      'continuo': 'continuous',
	      'ronda': 'round',
	      'posicion': 'position'
	    },
	    'paramValues': {
	      'liga': 'league',
	      'todo': 'all',
	      'deportistas': 'athletes',
	      'paises': 'countries'
	    }
	  },
	  'betting': {
	    'enabled': true,
	    'provider': 'caliente',
	    'game': {
	      'enabled': false,
	      'provider': 'caliente'
	    }
	  },
	  'ticketProvider': null,
	  'hasTickets': false,
	  'showFavorites': true,
	  'showInsider': false,
	  'showWatch': false,
	  'hideCategoryLinks': [600, 1700],
	  'categorySettings': {
	    'leagues': true,
	    'athletes': true,
	    'teams': true,
	    'tags': true
	  },
	  'showFCContent': true,
	  'showCricInfoContent': false,
	  'cookieConsent': true,
	  'scDeepLinking': true,
	  'allowShortUrl': false,
	  'allowPrintUrl': true,
	  'allowUserAccountManagement': true,
	  'nowFeed': false,
	  'searchUrl': 'http://buscar.espn.com/',
	  'gameSettings': {
	    'topEventsId': 3466459,
	    'promotedSoccerLeaguesCeId': 3466687,
	    'showBroadcast': false
	  },
	  'fallback': {
	    'baseball': 'espn-es-us-baseball-index',
	    'basketball': 'espn-es-us-basketball-index',
	    'boxing': 'espn-es-us-boxing-index',
	    'ciclismo': 'espn-es-co-ciclismo-index',
	    'espn-run': 'espn-es-ar-espn-run-index',
	    'esports': 'espn-es-us-esports-index',
	    'espys': 'espn-es-us-espys-index',
	    'f1': 'espn-es-mx-f1-index',
	    'football': 'espn-es-us-football-index',
	    'golf': 'espn-es-ar-golf-index',
	    'los-angeles': 'espn-es-us-frontpage-index',
	    'mlb': 'espn-es-us-baseball-index',
	    'mlb-beisbolexperience': 'espn-es-us-mlb-beisbolexperience-index',
	    'mma': 'espn-es-mx-mma-index',
	    'motociclismo': 'espn-es-ar-motociclismo-index',
	    'nacion-espn': 'espn-es-us-nacion-espn-index',
	    'nba': 'espn-es-us-basketball-index',
	    'nba-summerleague': 'espn-es-us-nba-summerleague-index',
	    'nexoespn': 'espn-es-co-nexoespn-index',
	    'nfl': 'espn-es-us-football-index',
	    'oly-summer-archery': 'espn-es-mx-oly-summer-archery-index',
	    'oly-summer-athletics': 'espn-es-mx-oly-summer-athletics-index',
	    'oly-summer-badminton': 'espn-es-mx-oly-summer-badminton-index',
	    'oly-summer-basketball': 'espn-es-mx-oly-summer-basketball-index',
	    'oly-summer-boxing': 'espn-es-mx-oly-summer-boxing-index',
	    'oly-summer-canoe': 'espn-es-mx-oly-summer-canoe-index',
	    'oly-summer-cycling': 'espn-es-mx-oly-summer-cycling-index',
	    'oly-summer-equestrian': 'espn-es-mx-oly-summer-equestrian-index',
	    'oly-summer-fencing': 'espn-es-mx-oly-summer-fencing-index',
	    'oly-summer-field-hockey': 'espn-es-mx-oly-summer-field-hockey-index',
	    'oly-summer-golf': 'espn-es-mx-oly-summer-golf-index',
	    'oly-summer-gymnastics': 'espn-es-mx-oly-summer-gymnastics-index',
	    'oly-summer-handball': 'espn-es-mx-oly-summer-handball-index',
	    'oly-summer-judo': 'espn-es-mx-oly-summer-judo-index',
	    'oly-summer-modern-pentathlon': 'espn-es-mx-oly-summer-modern-pentathlon-index',
	    'oly-summer-rowing': 'espn-es-mx-oly-summer-rowing-index',
	    'oly-summer-rugby': 'espn-es-mx-oly-summer-rugby-index',
	    'oly-summer-sailing': 'espn-es-mx-oly-summer-sailing-index',
	    'oly-summer-shooting': 'espn-es-mx-oly-summer-shooting-index',
	    'oly-summer-soccer': 'espn-es-mx-oly-summer-soccer-index',
	    'oly-summer-swimming': 'espn-es-mx-oly-summer-swimming-index',
	    'oly-summer-table-tennis': 'espn-es-mx-oly-summer-table-tennis-index',
	    'oly-summer-taekwondo': 'espn-es-mx-oly-summer-taekwondo-index',
	    'oly-summer-tennis': 'espn-es-mx-oly-summer-tennis-index',
	    'oly-summer-triathlon': 'espn-es-mx-oly-summer-triathlon-index',
	    'oly-summer-volleyball': 'espn-es-mx-oly-summer-volleyball-index',
	    'oly-summer-water-polo': 'espn-es-mx-oly-summer-water-polo-index',
	    'oly-summer-weightlifting': 'espn-es-mx-oly-summer-weightlifting-index',
	    'oly-summer-wrestling': 'espn-es-mx-oly-summer-wrestling-index',
	    'olympics': 'espn-es-mx-olympics-index',
	    'other-sports': 'espn-es-us-other-sports-index',
	    'panamerican': 'espn-es-us-panamerican-index',
	    'poker': 'espn-es-ar-poker-index',
	    'polo': 'espn-es-ar-polo-index',
	    'rpm': 'espn-es-ar-rpm-index',
	    'rugby': 'espn-es-ar-rugby-index',
	    'serie-del-caribe': 'espn-es-us-serie-del-caribe-index',
	    'soccer': 'espn-es-mx-soccer-index',
	    'tennis': 'espn-es-ar-tennis-index',
	    'world-baseball-classic': 'espn-es-us-world-baseball-classic-index',
	    'wwe': 'espn-es-us-luchalibre-index',
	    'x-games': 'espn-es-ar-x-games-index'
	  },
	  'editionAlert': {
	    'enabled': true,
	    'text': 'Has llegado a la edición de México. Quedarse en el sitio actual o ir a edición preferida.'
	  },
	  'feeds': {
	    'googlenews': {
	      'allowedContentTypes': ['TopStoryPackage', 'BlogEntry', 'HeadlineNews']
	    }
	  },
	  'tier2NavIds': {
	    'baseball': 3023264,
	    'basketball': 2474875,
	    'boxing': 2474907,
	    'ciclismo': 2882281,
	    'espn-run': 2507524,
	    'esports': 2882075,
	    'espys': 3121931,
	    'f1': 2474769,
	    'football': 2474884,
	    'golf': 2475240,
	    'los-angeles': '',
	    'mlb': 3023264,
	    'mlb/beisbolexperience': 3044646,
	    'mma': 2475264,
	    'motociclismo': 3397504,
	    'nacion-espn': 2652083,
	    'nba': 2474875,
	    'nba/summerleague': 3316630,
	    'nexoespn': 2649285,
	    'nfl': 2474884,
	    'oly/summer/archery': 2475258,
	    'oly/summer/athletics': 2475258,
	    'oly/summer/badminton': 2475258,
	    'oly/summer/basketball': 2475258,
	    'oly/summer/boxing': 2475258,
	    'oly/summer/canoe': 2475258,
	    'oly/summer/cycling': 2475258,
	    'oly/summer/equestrian': 2475258,
	    'oly/summer/fencing': 2475258,
	    'oly/summer/field-hockey': 2475258,
	    'oly/summer/golf': 2475258,
	    'oly/summer/gymnastics': 2475258,
	    'oly/summer/handball': 2475258,
	    'oly/summer/judo': 2475258,
	    'oly/summer/modern-pentathlon': 2475258,
	    'oly/summer/rowing': 2475258,
	    'oly/summer/rugby': 2475258,
	    'oly/summer/sailing': 2475258,
	    'oly/summer/shooting': 2475258,
	    'oly/summer/soccer': 2475258,
	    'oly/summer/swimming': 2475258,
	    'oly/summer/table-tennis': 2475258,
	    'oly/summer/taekwondo': 2475258,
	    'oly/summer/tennis': 2475258,
	    'oly/summer/triathlon': 2475258,
	    'oly/summer/volleyball': 2475258,
	    'oly/summer/water-polo': 2475258,
	    'oly/summer/weightlifting': 2475258,
	    'oly/summer/wrestling': 2475258,
	    'olympics': 2475258,
	    'other-sports': 2475272,
	    'panamerican': 2507636,
	    'poker': 2506302,
	    'polo': 2511033,
	    'rpm': 2474747,
	    'rugby': 2474293,
	    'serie-del-caribe': 2955159,
	    'soccer': 2487614,
	    'tennis': 2474261,
	    'world-baseball-classic': 2978462,
	    'wwe': 2946192,
	    'x-games': 2475269
	  },
	  'tier3NavIds': {
	    'clubhouse': {
	      'nfl': 2520032,
	      'mlb': 2523552,
	      'nba': 2525379,
	      'soccer': 2525397
	    }
	  },
	  'indexAutoStart': false,
	  'useMongo': true,
	  'activeSite': true,
	  'countries': [{
	    'name': 'Peru',
	    'country-code': 'pe',
	    'showHreflang': true
	  }],
	  'reactOverride': {
	    'cricket': {
	      'scores': true
	    }
	  }
	};

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(685);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _pathSegments;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// git hash 8ee6b172772eecafce6aa2c5c0f974c689aeb397
	exports.default = {
	  'editionSettings': {
	    'key': 'espn-es-es',
	    'site': 'espn',
	    'language': 'es',
	    'country': 'es',
	    'domain': 'www.espn.com',
	    'editionSiteId': '1',
	    'https': false,
	    'supportsOneSite': true
	  },
	  'navId': '3462114',
	  'dictionarySection': 'espn',
	  'javaLocale': {
	    'language': 'es',
	    'region': 'MX'
	  },
	  'dateTime': {
	    'long': 'dddd MMMM d, yyyy',
	    'medium': 'MMMM d, yyyy',
	    'short': 'M/d',
	    'timeFormat': 'h:mm',
	    'firstDayOfWeek': 'Sunday',
	    'timeZone': 'America/Santiago',
	    'defaultFormat': 'd MMM, yyyy',
	    'timeZoneString': 'CT',
	    'timeZoneBucket': 'America/New_York',
	    'MMM D, YYYY': 'D MMM, YYYY',
	    'M/D/YYYY': 'D/M/YYYY',
	    'MM/DD/YYYY': 'DD/MM/YYYY',
	    'MMDDYYYY': 'DDMMYYYY',
	    'MMMM Do YYYY': 'Do MMMM YYYY',
	    'dddd, MMMM Do YYYY': 'dddd, Do MMMM YYYY',
	    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
	    'M/D': 'D/M',
	    'MMMM D, YYYY': 'D MMMM YYYY',
	    'dddd, M/D': 'dddd, D/M',
	    'age': {
	      'seconds': 's',
	      'minutes': 'm',
	      'hours': 'h',
	      'days': 'd'
	    }
	  },
	  'numberFormat': {
	    'long': '#,###',
	    'short': '###',
	    'currency': '#,###.00',
	    'percent': '#.00%'
	  },
	  'temperature': {
	    'scale': 'celsius',
	    'symbol': '&deg; C'
	  },
	  'outbrain': {
	    'enabled': true,
	    'template': 'ESPNDeportesLATAM',
	    'desktop': {
	      'compliantId': 'AR_2',
	      'nonCompliantId': 'AR_4'
	    },
	    'mobile': {
	      'compliantId': 'MB_2',
	      'nonCompliantId': 'MB_6'
	    },
	    'video': {
	      'desktop': {
	        'compliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6'
	      }
	    },
	    'report': {
	      'desktop': {
	        'compliantId': 'AR_30',
	        'nonCompliantId': 'AR_30'
	      },
	      'mobile': {
	        'compliantId': 'MB_9',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'table': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'MB_43'
	      }
	    },
	    'game': {
	      'desktop': {
	        'compliantId': 'AR_48'
	      },
	      'mobile': {
	        'compliantId': 'AR_48'
	      }
	    }
	  },
	  'omniture': {
	    'enabled': true
	  },
	  'chartBeat': {
	    'enabled': true
	  },
	  'ads': {
	    'disabled': false,
	    'network': 1234,
	    'partnerAd': false,
	    'dev-config': 14005378,
	    'qa-config': 14005378,
	    'prod-config': 14005378,
	    'outputType': 'js',
	    'featurePhone': {
	      'outputType': 'no-js'
	    }
	  },
	  'partnerModules': {
	    'global': false,
	    'nba': false,
	    'womenbb': false,
	    'golf': false,
	    'endurance': false,
	    'horse': false,
	    'nascar': false
	  },
	  'sportBranding': [{
	    'sport': 'cricket',
	    'image': 'logo-uk-cricinfo',
	    'url': 'http://www.espncricinfo.com'
	  }, {
	    'sport': 'soccer',
	    'image': 'logo-deportes-fc',
	    'url': 'http://www.espn.com.mx/futbol/'
	  }, {
	    'sport': 'rugby',
	    'image': 'logo-deportes-scrum',
	    'url': 'http://www.espn.com.mx/rugby/'
	  }, {
	    'sport': 'ncaaw',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'ncw',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'wnba',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'womenbb',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }],
	  'siteLogo': {
	    'class': '',
	    'featurePhone': {
	      'name': 'espn-logo',
	      'width': 45,
	      'height': 11
	    }
	  },
	  'meta': {
	    'titleBranding': ' - ESPN',
	    'description': 'ESPN lo último del mundo deportivo.',
	    'defaultMetaImage': 'espn_red.png',
	    'schema': {
	      'name': 'ESPN'
	    },
	    'social': {
	      'twitter': {
	        'twitterId': '',
	        'card': 'summary',
	        'app_id_iphone': '317469184',
	        'site': 'espn',
	        'app_name_googleplay': 'ESPN',
	        'app_id_googleplay': 'com.espn.score_center',
	        'app_name_iphone': 'ESPN',
	        'language': 'es'
	      },
	      'facebook': {
	        'id': '116656161708917',
	        'og_site_name': 'ESPN.com.mx',
	        'locale': 'es_ES'
	      }
	    }
	  },
	  'shop': {
	    'enabled': false
	  },
	  'sportReplacements': {},
	  'uriRewrites': {
	    'urls': {
	      'toEdition': {
	        '/futbol-americano/nfl/': '/futbol-americano/',
	        '/beisbol/mlb/': '/beisbol/',
	        '/basquetbol/nba/': '/basquetbol/'
	      },
	      'toEnglish': {}
	    },
	    'roots': {
	      'toEdition': {},
	      'toEnglish': {}
	    },
	    'pathSegments': (_pathSegments = {
	      'reporte': 'report',
	      'juego': 'game',
	      'equipo': 'team',
	      'plantel': 'roster',
	      'estadisticas': 'stats',
	      'calendario': 'schedule',
	      'estadio': 'stadium',
	      'profundidad': 'depth',
	      'conversacion': 'conversation',
	      'ficha': 'boxscore',
	      'previa': 'preview',
	      'partido': 'match',
	      'jugadas': 'playbyplay',
	      'cronica': 'recap',
	      'fotos': 'photos',
	      'duelo': 'matchup',
	      'jugador': 'player',
	      'posiciones': 'standings',
	      'lesiones': 'injuries',
	      'bateo': 'batting',
	      'grilla': 'grid',
	      'piloto': 'driver',
	      'resultados': 'scoreboard',
	      'liga': 'league',
	      'ligas': 'leagues',
	      'nota': 'story',
	      'comentario': 'commentary',
	      'alineacion': 'lineups'
	    }, (0, _defineProperty3.default)(_pathSegments, 'estadisticas', 'matchstats'), (0, _defineProperty3.default)(_pathSegments, 'jugador-estadisticas', 'playerstats'), (0, _defineProperty3.default)(_pathSegments, 'medallas', 'medals'), (0, _defineProperty3.default)(_pathSegments, 'deportes', 'sports'), (0, _defineProperty3.default)(_pathSegments, 'deportistas', 'athletes'), (0, _defineProperty3.default)(_pathSegments, 'lideres', 'leaderboard'), (0, _defineProperty3.default)(_pathSegments, 'envivo', 'live'), (0, _defineProperty3.default)(_pathSegments, 'ronda', 'rounds'), (0, _defineProperty3.default)(_pathSegments, 'equipos', 'teams'), (0, _defineProperty3.default)(_pathSegments, 'posicion', 'positions'), (0, _defineProperty3.default)(_pathSegments, 'mejordisponible', 'bestavailable'), (0, _defineProperty3.default)(_pathSegments, 'noticias', 'news'), (0, _defineProperty3.default)(_pathSegments, 'noticiasdelequipo', 'teamnews'), (0, _defineProperty3.default)(_pathSegments, 'fecha', 'date'), _pathSegments),
	    'paramKeys': {
	      'juegoId': 'gameId',
	      'fecha': 'date',
	      'equipo': 'team',
	      'nombre': 'name',
	      'partido': 'gameID',
	      'liga': 'league',
	      'tipodetemporada': 'seasontype',
	      'ano': 'year',
	      'semana': 'week',
	      'deportes': 'discipline',
	      'evento': 'event',
	      'torneo': 'tournamentId',
	      'deportista': 'athlete',
	      'vista': 'view',
	      'pais': 'country',
	      'pagina': 'page',
	      'continuo': 'continuous',
	      'ronda': 'round',
	      'posicion': 'position'
	    },
	    'paramValues': {
	      'liga': 'league',
	      'todo': 'all',
	      'deportistas': 'athletes',
	      'paises': 'countries'
	    }
	  },
	  'betting': {
	    'enabled': true,
	    'provider': 'caliente',
	    'game': {
	      'enabled': false,
	      'provider': 'caliente'
	    }
	  },
	  'ticketProvider': null,
	  'hasTickets': false,
	  'showFavorites': true,
	  'showInsider': false,
	  'showWatch': false,
	  'hideCategoryLinks': [600, 1700],
	  'categorySettings': {
	    'leagues': true,
	    'athletes': true,
	    'teams': true,
	    'tags': true
	  },
	  'showFCContent': true,
	  'showCricInfoContent': false,
	  'cookieConsent': true,
	  'scDeepLinking': true,
	  'allowShortUrl': false,
	  'allowPrintUrl': true,
	  'allowUserAccountManagement': true,
	  'nowFeed': false,
	  'searchUrl': 'http://buscar.espn.com/',
	  'gameSettings': {
	    'topEventsId': 3466354,
	    'promotedSoccerLeaguesCeId': 3466584,
	    'showBroadcast': false
	  },
	  'fallback': {
	    'baseball': 'espn-es-us-baseball-index',
	    'basketball': 'espn-es-us-basketball-index',
	    'boxing': 'espn-es-us-boxing-index',
	    'ciclismo': 'espn-es-co-ciclismo-index',
	    'espn-run': 'espn-es-ar-espn-run-index',
	    'esports': 'espn-es-us-esports-index',
	    'espys': 'espn-es-us-espys-index',
	    'f1': 'espn-es-mx-f1-index',
	    'football': 'espn-es-us-football-index',
	    'golf': 'espn-es-ar-golf-index',
	    'los-angeles': 'espn-es-us-frontpage-index',
	    'mlb': 'espn-es-us-baseball-index',
	    'mlb-beisbolexperience': 'espn-es-us-mlb-beisbolexperience-index',
	    'mma': 'espn-es-mx-mma-index',
	    'motociclismo': 'espn-es-ar-motociclismo-index',
	    'nacion-espn': 'espn-es-us-nacion-espn-index',
	    'nba': 'espn-es-us-basketball-index',
	    'nba-summerleague': 'espn-es-us-nba-summerleague-index',
	    'nexoespn': 'espn-es-co-nexoespn-index',
	    'nfl': 'espn-es-us-football-index',
	    'oly-summer-archery': 'espn-es-mx-oly-summer-archery-index',
	    'oly-summer-athletics': 'espn-es-mx-oly-summer-athletics-index',
	    'oly-summer-badminton': 'espn-es-mx-oly-summer-badminton-index',
	    'oly-summer-basketball': 'espn-es-mx-oly-summer-basketball-index',
	    'oly-summer-boxing': 'espn-es-mx-oly-summer-boxing-index',
	    'oly-summer-canoe': 'espn-es-mx-oly-summer-canoe-index',
	    'oly-summer-cycling': 'espn-es-mx-oly-summer-cycling-index',
	    'oly-summer-equestrian': 'espn-es-mx-oly-summer-equestrian-index',
	    'oly-summer-fencing': 'espn-es-mx-oly-summer-fencing-index',
	    'oly-summer-field-hockey': 'espn-es-mx-oly-summer-field-hockey-index',
	    'oly-summer-golf': 'espn-es-mx-oly-summer-golf-index',
	    'oly-summer-gymnastics': 'espn-es-mx-oly-summer-gymnastics-index',
	    'oly-summer-handball': 'espn-es-mx-oly-summer-handball-index',
	    'oly-summer-judo': 'espn-es-mx-oly-summer-judo-index',
	    'oly-summer-modern-pentathlon': 'espn-es-mx-oly-summer-modern-pentathlon-index',
	    'oly-summer-rowing': 'espn-es-mx-oly-summer-rowing-index',
	    'oly-summer-rugby': 'espn-es-mx-oly-summer-rugby-index',
	    'oly-summer-sailing': 'espn-es-mx-oly-summer-sailing-index',
	    'oly-summer-shooting': 'espn-es-mx-oly-summer-shooting-index',
	    'oly-summer-soccer': 'espn-es-mx-oly-summer-soccer-index',
	    'oly-summer-swimming': 'espn-es-mx-oly-summer-swimming-index',
	    'oly-summer-table-tennis': 'espn-es-mx-oly-summer-table-tennis-index',
	    'oly-summer-taekwondo': 'espn-es-mx-oly-summer-taekwondo-index',
	    'oly-summer-tennis': 'espn-es-mx-oly-summer-tennis-index',
	    'oly-summer-triathlon': 'espn-es-mx-oly-summer-triathlon-index',
	    'oly-summer-volleyball': 'espn-es-mx-oly-summer-volleyball-index',
	    'oly-summer-water-polo': 'espn-es-mx-oly-summer-water-polo-index',
	    'oly-summer-weightlifting': 'espn-es-mx-oly-summer-weightlifting-index',
	    'oly-summer-wrestling': 'espn-es-mx-oly-summer-wrestling-index',
	    'olympics': 'espn-es-mx-olympics-index',
	    'other-sports': 'espn-es-us-other-sports-index',
	    'panamerican': 'espn-es-us-panamerican-index',
	    'poker': 'espn-es-ar-poker-index',
	    'polo': 'espn-es-ar-polo-index',
	    'rpm': 'espn-es-ar-rpm-index',
	    'rugby': 'espn-es-ar-rugby-index',
	    'serie-del-caribe': 'espn-es-us-serie-del-caribe-index',
	    'soccer': 'espn-es-mx-soccer-index',
	    'tennis': 'espn-es-ar-tennis-index',
	    'world-baseball-classic': 'espn-es-us-world-baseball-classic-index',
	    'wwe': 'espn-es-us-luchalibre-index',
	    'x-games': 'espn-es-ar-x-games-index'
	  },
	  'editionAlert': {
	    'enabled': true,
	    'text': 'Has llegado a la edición de México. Quedarse en el sitio actual o ir a edición preferida.'
	  },
	  'feeds': {
	    'googlenews': {
	      'allowedContentTypes': ['TopStoryPackage', 'BlogEntry', 'HeadlineNews']
	    }
	  },
	  'tier2NavIds': {
	    'baseball': 3023264,
	    'basketball': 2474875,
	    'boxing': 2474907,
	    'ciclismo': 2882281,
	    'espn-run': 2507524,
	    'esports': 2882075,
	    'espys': 3121931,
	    'f1': 2474769,
	    'football': 2474884,
	    'golf': 2475240,
	    'los-angeles': '',
	    'mlb': 3023264,
	    'mlb/beisbolexperience': 3044646,
	    'mma': 2475264,
	    'motociclismo': 3397504,
	    'nacion-espn': 2652083,
	    'nba': 2474875,
	    'nba/summerleague': 3316630,
	    'nexoespn': 2649285,
	    'nfl': 2474884,
	    'oly/summer/archery': 2475258,
	    'oly/summer/athletics': 2475258,
	    'oly/summer/badminton': 2475258,
	    'oly/summer/basketball': 2475258,
	    'oly/summer/boxing': 2475258,
	    'oly/summer/canoe': 2475258,
	    'oly/summer/cycling': 2475258,
	    'oly/summer/equestrian': 2475258,
	    'oly/summer/fencing': 2475258,
	    'oly/summer/field-hockey': 2475258,
	    'oly/summer/golf': 2475258,
	    'oly/summer/gymnastics': 2475258,
	    'oly/summer/handball': 2475258,
	    'oly/summer/judo': 2475258,
	    'oly/summer/modern-pentathlon': 2475258,
	    'oly/summer/rowing': 2475258,
	    'oly/summer/rugby': 2475258,
	    'oly/summer/sailing': 2475258,
	    'oly/summer/shooting': 2475258,
	    'oly/summer/soccer': 2475258,
	    'oly/summer/swimming': 2475258,
	    'oly/summer/table-tennis': 2475258,
	    'oly/summer/taekwondo': 2475258,
	    'oly/summer/tennis': 2475258,
	    'oly/summer/triathlon': 2475258,
	    'oly/summer/volleyball': 2475258,
	    'oly/summer/water-polo': 2475258,
	    'oly/summer/weightlifting': 2475258,
	    'oly/summer/wrestling': 2475258,
	    'olympics': 2475258,
	    'other-sports': 2475272,
	    'panamerican': 2507636,
	    'poker': 2506302,
	    'polo': 2511033,
	    'rpm': 2474747,
	    'rugby': 2474293,
	    'serie-del-caribe': 2955159,
	    'soccer': 2487614,
	    'tennis': 2474261,
	    'world-baseball-classic': 2978462,
	    'wwe': 2946192,
	    'x-games': 2475269
	  },
	  'tier3NavIds': {
	    'clubhouse': {
	      'nfl': 2520032,
	      'mlb': 2523552,
	      'nba': 2525379,
	      'soccer': 2525397
	    }
	  },
	  'indexAutoStart': false,
	  'useMongo': true,
	  'activeSite': true,
	  'countries': [{
	    'name': 'Spain',
	    'country-code': 'es',
	    'showHreflang': true
	  }],
	  'reactOverride': {
	    'cricket': {
	      'scores': true
	    }
	  }
	};

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(685);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _pathSegments;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// git hash 8ee6b172772eecafce6aa2c5c0f974c689aeb397
	exports.default = {
	  'editionSettings': {
	    'key': 'espn-es-us',
	    'site': 'espn',
	    'language': 'es',
	    'country': 'us',
	    'domain': 'espndeportes.espn.com',
	    'editionSiteId': '22',
	    'https': false,
	    'supportsOneSite': true
	  },
	  'navId': '2488173',
	  'dictionarySection': 'espn',
	  'javaLocale': {
	    'language': 'es',
	    'region': 'MX'
	  },
	  'dateTime': {
	    'long': 'dddd MMMM d, yyyy',
	    'medium': 'MMMM d, yyyy',
	    'short': 'M/d',
	    'timeFormat': 'h:mm',
	    'firstDayOfWeek': 'Sunday',
	    'timeZone': 'US/Eastern',
	    'defaultFormat': 'd MMM, yyyy',
	    'timeZoneString': 'ET',
	    'timeZoneBucket': 'America/New_York',
	    'MMM D, YYYY': 'D MMM, YYYY',
	    'M/D/YYYY': 'D/M/YYYY',
	    'MM/DD/YYYY': 'DD/MM/YYYY',
	    'MMDDYYYY': 'DDMMYYYY',
	    'MMMM Do YYYY': 'Do MMMM YYYY',
	    'dddd, MMMM Do YYYY': 'dddd, Do MMMM YYYY',
	    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
	    'M/D': 'D/M',
	    'MMMM D, YYYY': 'D MMMM YYYY',
	    'dddd, M/D': 'dddd, D/M',
	    'age': {
	      'seconds': 's',
	      'minutes': 'm',
	      'hours': 'h',
	      'days': 'd'
	    }
	  },
	  'numberFormat': {
	    'long': '#,###',
	    'short': '###',
	    'currency': '#,###.00',
	    'percent': '#.00%'
	  },
	  'temperature': {
	    'scale': 'celsius',
	    'symbol': '&deg; C'
	  },
	  'outbrain': {
	    'enabled': true,
	    'template': 'espndeportes',
	    'desktop': {
	      'compliantId': 'AR_2',
	      'nonCompliantId': 'AR_4'
	    },
	    'mobile': {
	      'compliantId': 'MB_2',
	      'nonCompliantId': 'MB_6'
	    },
	    'video': {
	      'desktop': {
	        'compliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6'
	      }
	    },
	    'report': {
	      'desktop': {
	        'compliantId': 'AR_30',
	        'nonCompliantId': 'AR_30'
	      },
	      'mobile': {
	        'compliantId': 'MB_9',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'table': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'MB_43'
	      }
	    },
	    'game': {
	      'desktop': {
	        'compliantId': 'AR_48'
	      },
	      'mobile': {
	        'compliantId': 'AR_48'
	      }
	    }
	  },
	  'omniture': {
	    'enabled': true
	  },
	  'chartBeat': {
	    'enabled': true
	  },
	  'ads': {
	    'disabled': false,
	    'network': 1234,
	    'partnerAd': false,
	    'dev-config': 14004659,
	    'qa-config': 14004659,
	    'prod-config': 14004659,
	    'outputType': 'js',
	    'featurePhone': {
	      'outputType': 'no-js'
	    }
	  },
	  'partnerModules': {
	    'global': false,
	    'nba': false,
	    'womenbb': false,
	    'golf': false,
	    'endurance': false,
	    'horse': false,
	    'nascar': false
	  },
	  'sportBranding': [{
	    'sport': 'cricket',
	    'image': 'logo-uk-cricinfo',
	    'url': 'http://www.espncricinfo.com'
	  }, {
	    'sport': 'soccer',
	    'image': 'logo-deportes-fc',
	    'url': 'http://espndeportes.espn.com/futbol/'
	  }, {
	    'sport': 'rugby',
	    'image': 'logo-deportes-scrum',
	    'url': 'http://espndeportes.espn.com/rugby/'
	  }, {
	    'sport': 'ncaaw',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'ncw',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'wnba',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'womenbb',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }],
	  'siteLogo': {
	    'class': 'deportes',
	    'featurePhone': {
	      'name': 'espndeportes-logo',
	      'width': 76,
	      'height': 30
	    }
	  },
	  'meta': {
	    'titleBranding': ' - ESPNDeportes',
	    'description': 'ESPN lo último del mundo deportivo. Información completa de todo tipo de deporte incluyendo Fútbol Mexicano, Fútbol Argentino, Fútbol Italiano, Fútbol de España, Fútbol de MLS, Fútbol de Estados Unidos, Fútbol Inglaterra, Fútbol de Alemania, Fútbol de Francia, Baloncesto Profesional, NBA, Básquetbol, Béisbol, Pelota, Fútbol Americano, NFL, Rugby, Tenis, Boxeo, Golf y Juegos de Fantasía.',
	    'defaultMetaImage': 'espndeportes_white.png',
	    'schema': {
	      'name': 'ESPN'
	    },
	    'social': {
	      'twitter': {
	        'twitterId': '',
	        'card': 'summary',
	        'app_id_iphone': '317469184',
	        'site': 'espn',
	        'app_name_googleplay': 'ESPN',
	        'app_id_googleplay': 'com.espn.score_center',
	        'app_name_iphone': 'ESPN',
	        'language': 'es'
	      },
	      'facebook': {
	        'id': '116656161708917',
	        'og_site_name': 'ESPNdeportes.com',
	        'locale': 'es_ES'
	      }
	    }
	  },
	  'shop': {
	    'enabled': false
	  },
	  'sportReplacements': {},
	  'uriRewrites': {
	    'urls': {
	      'toEdition': {
	        '/futbol-americano/nfl/': '/futbol-americano/',
	        '/beisbol/mlb/': '/beisbol/',
	        '/basquetbol/nba/': '/basquetbol/'
	      },
	      'toEnglish': {}
	    },
	    'roots': {
	      'toEdition': {},
	      'toEnglish': {}
	    },
	    'pathSegments': (_pathSegments = {
	      'reporte': 'report',
	      'juego': 'game',
	      'equipo': 'team',
	      'plantel': 'roster',
	      'estadisticas': 'stats',
	      'calendario': 'schedule',
	      'estadio': 'stadium',
	      'profundidad': 'depth',
	      'conversacion': 'conversation',
	      'ficha': 'boxscore',
	      'previa': 'preview',
	      'partido': 'match',
	      'jugadas': 'playbyplay',
	      'cronica': 'recap',
	      'fotos': 'photos',
	      'duelo': 'matchup',
	      'jugador': 'player',
	      'posiciones': 'standings',
	      'lesiones': 'injuries',
	      'bateo': 'batting',
	      'grilla': 'grid',
	      'piloto': 'driver',
	      'resultados': 'scoreboard',
	      'liga': 'league',
	      'ligas': 'leagues',
	      'nota': 'story',
	      'comentario': 'commentary',
	      'alineacion': 'lineups'
	    }, (0, _defineProperty3.default)(_pathSegments, 'estadisticas', 'matchstats'), (0, _defineProperty3.default)(_pathSegments, 'jugador-estadisticas', 'playerstats'), (0, _defineProperty3.default)(_pathSegments, 'medallas', 'medals'), (0, _defineProperty3.default)(_pathSegments, 'deportes', 'sports'), (0, _defineProperty3.default)(_pathSegments, 'deportistas', 'athletes'), (0, _defineProperty3.default)(_pathSegments, 'lideres', 'leaderboard'), (0, _defineProperty3.default)(_pathSegments, 'envivo', 'live'), (0, _defineProperty3.default)(_pathSegments, 'ronda', 'rounds'), (0, _defineProperty3.default)(_pathSegments, 'equipos', 'teams'), (0, _defineProperty3.default)(_pathSegments, 'posicion', 'positions'), (0, _defineProperty3.default)(_pathSegments, 'mejordisponible', 'bestavailable'), (0, _defineProperty3.default)(_pathSegments, 'noticias', 'news'), (0, _defineProperty3.default)(_pathSegments, 'noticiasdelequipo', 'teamnews'), (0, _defineProperty3.default)(_pathSegments, 'fecha', 'date'), _pathSegments),
	    'paramKeys': {
	      'juegoId': 'gameId',
	      'fecha': 'date',
	      'equipo': 'team',
	      'nombre': 'name',
	      'partido': 'gameID',
	      'liga': 'league',
	      'tipodetemporada': 'seasontype',
	      'ano': 'year',
	      'semana': 'week',
	      'deportes': 'discipline',
	      'evento': 'event',
	      'torneo': 'tournamentId',
	      'deportista': 'athlete',
	      'vista': 'view',
	      'pais': 'country',
	      'pagina': 'page',
	      'continuo': 'continuous',
	      'ronda': 'round',
	      'posicion': 'position'
	    },
	    'paramValues': {
	      'liga': 'league',
	      'todo': 'all',
	      'deportistas': 'athletes',
	      'paises': 'countries'
	    }
	  },
	  'betting': {
	    'enabled': false,
	    'provider': '',
	    'game': {
	      'enabled': false,
	      'provider': ''
	    }
	  },
	  'ticketProvider': null,
	  'hasTickets': false,
	  'showFavorites': true,
	  'showInsider': false,
	  'showWatch': true,
	  'hideCategoryLinks': [600, 1700, 850],
	  'categorySettings': {
	    'leagues': true,
	    'athletes': true,
	    'teams': true,
	    'tags': true
	  },
	  'showFCContent': true,
	  'showCricInfoContent': false,
	  'cookieConsent': false,
	  'scDeepLinking': true,
	  'allowShortUrl': false,
	  'allowPrintUrl': true,
	  'allowUserAccountManagement': true,
	  'nowFeed': false,
	  'searchUrl': 'http://buscar.espn.com/',
	  'gameSettings': {
	    'topEventsId': 2143829,
	    'promotedSoccerLeaguesCeId': 2508966,
	    'showBroadcast': false
	  },
	  'fallback': {
	    'baseball': 'espn-es-us-baseball-index',
	    'basketball': 'espn-es-us-basketball-index',
	    'boxing': 'espn-es-us-boxing-index',
	    'ciclismo': 'espn-es-co-ciclismo-index',
	    'espn-run': 'espn-es-ar-espn-run-index',
	    'esports': 'espn-es-us-esports-index',
	    'espys': 'espn-es-us-espys-index',
	    'f1': 'espn-es-mx-f1-index',
	    'football': 'espn-es-us-football-index',
	    'golf': 'espn-es-ar-golf-index',
	    'los-angeles': 'espn-es-us-frontpage-index',
	    'mlb': 'espn-es-us-baseball-index',
	    'mlb-beisbolexperience': 'espn-es-us-mlb-beisbolexperience-index',
	    'mma': 'espn-es-mx-mma-index',
	    'motociclismo': 'espn-es-ar-motociclismo-index',
	    'nacion-espn': 'espn-es-us-nacion-espn-index',
	    'nba': 'espn-es-us-basketball-index',
	    'nba-summerleague': 'espn-es-us-nba-summerleague-index',
	    'nexoespn': 'espn-es-co-nexoespn-index',
	    'nfl': 'espn-es-us-football-index',
	    'oly-summer-archery': 'espn-es-mx-oly-summer-archery-index',
	    'oly-summer-athletics': 'espn-es-mx-oly-summer-athletics-index',
	    'oly-summer-badminton': 'espn-es-mx-oly-summer-badminton-index',
	    'oly-summer-basketball': 'espn-es-mx-oly-summer-basketball-index',
	    'oly-summer-boxing': 'espn-es-mx-oly-summer-boxing-index',
	    'oly-summer-canoe': 'espn-es-mx-oly-summer-canoe-index',
	    'oly-summer-cycling': 'espn-es-mx-oly-summer-cycling-index',
	    'oly-summer-equestrian': 'espn-es-mx-oly-summer-equestrian-index',
	    'oly-summer-fencing': 'espn-es-mx-oly-summer-fencing-index',
	    'oly-summer-field-hockey': 'espn-es-mx-oly-summer-field-hockey-index',
	    'oly-summer-golf': 'espn-es-mx-oly-summer-golf-index',
	    'oly-summer-gymnastics': 'espn-es-mx-oly-summer-gymnastics-index',
	    'oly-summer-handball': 'espn-es-mx-oly-summer-handball-index',
	    'oly-summer-judo': 'espn-es-mx-oly-summer-judo-index',
	    'oly-summer-modern-pentathlon': 'espn-es-mx-oly-summer-modern-pentathlon-index',
	    'oly-summer-rowing': 'espn-es-mx-oly-summer-rowing-index',
	    'oly-summer-rugby': 'espn-es-mx-oly-summer-rugby-index',
	    'oly-summer-sailing': 'espn-es-mx-oly-summer-sailing-index',
	    'oly-summer-shooting': 'espn-es-mx-oly-summer-shooting-index',
	    'oly-summer-soccer': 'espn-es-mx-oly-summer-soccer-index',
	    'oly-summer-swimming': 'espn-es-mx-oly-summer-swimming-index',
	    'oly-summer-table-tennis': 'espn-es-mx-oly-summer-table-tennis-index',
	    'oly-summer-taekwondo': 'espn-es-mx-oly-summer-taekwondo-index',
	    'oly-summer-tennis': 'espn-es-mx-oly-summer-tennis-index',
	    'oly-summer-triathlon': 'espn-es-mx-oly-summer-triathlon-index',
	    'oly-summer-volleyball': 'espn-es-mx-oly-summer-volleyball-index',
	    'oly-summer-water-polo': 'espn-es-mx-oly-summer-water-polo-index',
	    'oly-summer-weightlifting': 'espn-es-mx-oly-summer-weightlifting-index',
	    'oly-summer-wrestling': 'espn-es-mx-oly-summer-wrestling-index',
	    'olympics': 'espn-es-us-olympics-index',
	    'other-sports': 'espn-es-us-other-sports-index',
	    'panamerican': 'espn-es-us-panamerican-index',
	    'poker': 'espn-es-ar-poker-index',
	    'polo': 'espn-es-ar-polo-index',
	    'rpm': 'espn-es-ar-rpm-index',
	    'rugby': 'espn-es-ar-rugby-index',
	    'serie-del-caribe': 'espn-es-us-serie-del-caribe-index',
	    'soccer': 'espn-es-us-soccer-index',
	    'tennis': 'espn-es-ar-tennis-index',
	    'world-baseball-classic': 'espn-es-us-world-baseball-classic-index',
	    'wwe': 'espn-es-us-luchalibre-index',
	    'x-games': 'espn-es-ar-x-games-index'
	  },
	  'editionAlert': {
	    'enabled': true,
	    'text': 'Has llegado a la edición de ESPN Deportes. Quedarse en el sitio actual o ir a edición preferida.'
	  },
	  'feeds': {
	    'googlenews': {
	      'allowedContentTypes': ['TopStoryPackage', 'BlogEntry', 'HeadlineNews']
	    }
	  },
	  'tier2NavIds': {
	    'league': {
	      'soccer': 2520885
	    },
	    'los-angeles': '',
	    'baseball': 3023264,
	    'basketball': 2474875,
	    'boxing': 2474907,
	    'ciclismo': 2882281,
	    'espn-run': 2623345,
	    'espnradio': 2639931,
	    'esports': 2774868,
	    'espys': 3121931,
	    'f1': 2474769,
	    'football': 2474884,
	    'golf': 2475240,
	    'mlb': 3023264,
	    'mlb/beisbolexperience': 3044646,
	    'mma': 2475264,
	    'motociclismo': 3397504,
	    'nacion-espn': 2652083,
	    'nba': 2474875,
	    'nba/summerleague': 3316630,
	    'nexoespn': 2649285,
	    'nfl': 2474884,
	    'oly/summer/archery': 2475258,
	    'oly/summer/athletics': 2475258,
	    'oly/summer/badminton': 2475258,
	    'oly/summer/basketball': 2475258,
	    'oly/summer/boxing': 2475258,
	    'oly/summer/canoe': 2475258,
	    'oly/summer/cycling': 2475258,
	    'oly/summer/equestrian': 2475258,
	    'oly/summer/fencing': 2475258,
	    'oly/summer/field-hockey': 2475258,
	    'oly/summer/golf': 2475258,
	    'oly/summer/gymnastics': 2475258,
	    'oly/summer/handball': 2475258,
	    'oly/summer/judo': 2475258,
	    'oly/summer/modern-pentathlon': 2475258,
	    'oly/summer/rowing': 2475258,
	    'oly/summer/rugby': 2475258,
	    'oly/summer/sailing': 2475258,
	    'oly/summer/shooting': 2475258,
	    'oly/summer/soccer': 2475258,
	    'oly/summer/swimming': 2475258,
	    'oly/summer/table-tennis': 2475258,
	    'oly/summer/taekwondo': 2475258,
	    'oly/summer/tennis': 2475258,
	    'oly/summer/triathlon': 2475258,
	    'oly/summer/volleyball': 2475258,
	    'oly/summer/water-polo': 2475258,
	    'oly/summer/weightlifting': 2475258,
	    'oly/summer/wrestling': 2475258,
	    'olympics': 2475258,
	    'other-sports': 2475272,
	    'panamerican': 2507636,
	    'poker': 2506302,
	    'polo': 2511033,
	    'rpm': 2474747,
	    'rugby': 2474293,
	    'serie-del-caribe': 2955159,
	    'soccer': 2488185,
	    'television': 2649285,
	    'tennis': 2474261,
	    'world-baseball-classic': 2978462,
	    'wwe': 2946192,
	    'x-games': 2475269
	  },
	  'tier3NavIds': {
	    'clubhouse': {
	      'nfl': 2520032,
	      'mlb': 2523552,
	      'nba': 2525379,
	      'soccer': 2525397
	    }
	  },
	  'indexAutoStart': false,
	  'useMongo': true,
	  'activeSite': true,
	  'countries': [{
	    'name': 'United States',
	    'country-code': 'us',
	    'showHreflang': true
	  }, {
	    'name': 'Puerto Rico',
	    'country-code': 'pr',
	    'showHreflang': false
	  }, {
	    'name': 'Spain',
	    'country-code': 'es',
	    'showHreflang': true
	  }],
	  'reactOverride': {
	    'cricket': {
	      'scores': true
	    }
	  }
	};

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(685);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _pathSegments;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// git hash 8ee6b172772eecafce6aa2c5c0f974c689aeb397
	exports.default = {
	  'editionSettings': {
	    'key': 'espn-es-uy',
	    'site': 'espn',
	    'language': 'es',
	    'country': 'uy',
	    'domain': 'www.espn.com',
	    'editionSiteId': '1',
	    'https': false,
	    'supportsOneSite': true
	  },
	  'navId': '3462146',
	  'dictionarySection': 'espn',
	  'javaLocale': {
	    'language': 'es',
	    'region': 'MX'
	  },
	  'dateTime': {
	    'long': 'dddd MMMM d, yyyy',
	    'medium': 'MMMM d, yyyy',
	    'short': 'M/d',
	    'timeFormat': 'h:mm',
	    'firstDayOfWeek': 'Sunday',
	    'timeZone': 'America/Santiago',
	    'defaultFormat': 'd MMM, yyyy',
	    'timeZoneString': 'CT',
	    'timeZoneBucket': 'America/New_York',
	    'MMM D, YYYY': 'D MMM, YYYY',
	    'M/D/YYYY': 'D/M/YYYY',
	    'MM/DD/YYYY': 'DD/MM/YYYY',
	    'MMDDYYYY': 'DDMMYYYY',
	    'MMMM Do YYYY': 'Do MMMM YYYY',
	    'dddd, MMMM Do YYYY': 'dddd, Do MMMM YYYY',
	    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
	    'M/D': 'D/M',
	    'MMMM D, YYYY': 'D MMMM YYYY',
	    'dddd, M/D': 'dddd, D/M',
	    'age': {
	      'seconds': 's',
	      'minutes': 'm',
	      'hours': 'h',
	      'days': 'd'
	    }
	  },
	  'numberFormat': {
	    'long': '#,###',
	    'short': '###',
	    'currency': '#,###.00',
	    'percent': '#.00%'
	  },
	  'temperature': {
	    'scale': 'celsius',
	    'symbol': '&deg; C'
	  },
	  'outbrain': {
	    'enabled': true,
	    'template': 'ESPNDeportesLATAM',
	    'desktop': {
	      'compliantId': 'AR_2',
	      'nonCompliantId': 'AR_4'
	    },
	    'mobile': {
	      'compliantId': 'MB_2',
	      'nonCompliantId': 'MB_6'
	    },
	    'video': {
	      'desktop': {
	        'compliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6'
	      }
	    },
	    'report': {
	      'desktop': {
	        'compliantId': 'AR_30',
	        'nonCompliantId': 'AR_30'
	      },
	      'mobile': {
	        'compliantId': 'MB_9',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'table': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'MB_43'
	      }
	    },
	    'game': {
	      'desktop': {
	        'compliantId': 'AR_48'
	      },
	      'mobile': {
	        'compliantId': 'AR_48'
	      }
	    }
	  },
	  'omniture': {
	    'enabled': true
	  },
	  'chartBeat': {
	    'enabled': true
	  },
	  'ads': {
	    'disabled': false,
	    'network': 1234,
	    'partnerAd': false,
	    'dev-config': 14005378,
	    'qa-config': 14005378,
	    'prod-config': 14005378,
	    'outputType': 'js',
	    'featurePhone': {
	      'outputType': 'no-js'
	    }
	  },
	  'partnerModules': {
	    'global': false,
	    'nba': false,
	    'womenbb': false,
	    'golf': false,
	    'endurance': false,
	    'horse': false,
	    'nascar': false
	  },
	  'sportBranding': [{
	    'sport': 'cricket',
	    'image': 'logo-uk-cricinfo',
	    'url': 'http://www.espncricinfo.com'
	  }, {
	    'sport': 'soccer',
	    'image': 'logo-deportes-fc',
	    'url': 'http://www.espn.com.mx/futbol/'
	  }, {
	    'sport': 'rugby',
	    'image': 'logo-deportes-scrum',
	    'url': 'http://www.espn.com.mx/rugby/'
	  }, {
	    'sport': 'ncaaw',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'ncw',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'wnba',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'womenbb',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }],
	  'siteLogo': {
	    'class': '',
	    'featurePhone': {
	      'name': 'espn-logo',
	      'width': 45,
	      'height': 11
	    }
	  },
	  'meta': {
	    'titleBranding': ' - ESPN',
	    'description': 'ESPN lo último del mundo deportivo.',
	    'defaultMetaImage': 'espn_red.png',
	    'schema': {
	      'name': 'ESPN'
	    },
	    'social': {
	      'twitter': {
	        'twitterId': '',
	        'card': 'summary',
	        'app_id_iphone': '317469184',
	        'site': 'espn',
	        'app_name_googleplay': 'ESPN',
	        'app_id_googleplay': 'com.espn.score_center',
	        'app_name_iphone': 'ESPN',
	        'language': 'es'
	      },
	      'facebook': {
	        'id': '116656161708917',
	        'og_site_name': 'ESPN.com.mx',
	        'locale': 'es_ES'
	      }
	    }
	  },
	  'shop': {
	    'enabled': false
	  },
	  'sportReplacements': {},
	  'uriRewrites': {
	    'urls': {
	      'toEdition': {
	        '/futbol-americano/nfl/': '/futbol-americano/',
	        '/beisbol/mlb/': '/beisbol/',
	        '/basquetbol/nba/': '/basquetbol/'
	      },
	      'toEnglish': {}
	    },
	    'roots': {
	      'toEdition': {},
	      'toEnglish': {}
	    },
	    'pathSegments': (_pathSegments = {
	      'reporte': 'report',
	      'juego': 'game',
	      'equipo': 'team',
	      'plantel': 'roster',
	      'estadisticas': 'stats',
	      'calendario': 'schedule',
	      'estadio': 'stadium',
	      'profundidad': 'depth',
	      'conversacion': 'conversation',
	      'ficha': 'boxscore',
	      'previa': 'preview',
	      'partido': 'match',
	      'jugadas': 'playbyplay',
	      'cronica': 'recap',
	      'fotos': 'photos',
	      'duelo': 'matchup',
	      'jugador': 'player',
	      'posiciones': 'standings',
	      'lesiones': 'injuries',
	      'bateo': 'batting',
	      'grilla': 'grid',
	      'piloto': 'driver',
	      'resultados': 'scoreboard',
	      'liga': 'league',
	      'ligas': 'leagues',
	      'nota': 'story',
	      'comentario': 'commentary',
	      'alineacion': 'lineups'
	    }, (0, _defineProperty3.default)(_pathSegments, 'estadisticas', 'matchstats'), (0, _defineProperty3.default)(_pathSegments, 'jugador-estadisticas', 'playerstats'), (0, _defineProperty3.default)(_pathSegments, 'medallas', 'medals'), (0, _defineProperty3.default)(_pathSegments, 'deportes', 'sports'), (0, _defineProperty3.default)(_pathSegments, 'deportistas', 'athletes'), (0, _defineProperty3.default)(_pathSegments, 'lideres', 'leaderboard'), (0, _defineProperty3.default)(_pathSegments, 'envivo', 'live'), (0, _defineProperty3.default)(_pathSegments, 'ronda', 'rounds'), (0, _defineProperty3.default)(_pathSegments, 'equipos', 'teams'), (0, _defineProperty3.default)(_pathSegments, 'posicion', 'positions'), (0, _defineProperty3.default)(_pathSegments, 'mejordisponible', 'bestavailable'), (0, _defineProperty3.default)(_pathSegments, 'noticias', 'news'), (0, _defineProperty3.default)(_pathSegments, 'noticiasdelequipo', 'teamnews'), (0, _defineProperty3.default)(_pathSegments, 'fecha', 'date'), _pathSegments),
	    'paramKeys': {
	      'juegoId': 'gameId',
	      'fecha': 'date',
	      'equipo': 'team',
	      'nombre': 'name',
	      'partido': 'gameID',
	      'liga': 'league',
	      'tipodetemporada': 'seasontype',
	      'ano': 'year',
	      'semana': 'week',
	      'deportes': 'discipline',
	      'evento': 'event',
	      'torneo': 'tournamentId',
	      'deportista': 'athlete',
	      'vista': 'view',
	      'pais': 'country',
	      'pagina': 'page',
	      'continuo': 'continuous',
	      'ronda': 'round',
	      'posicion': 'position'
	    },
	    'paramValues': {
	      'liga': 'league',
	      'todo': 'all',
	      'deportistas': 'athletes',
	      'paises': 'countries'
	    }
	  },
	  'betting': {
	    'enabled': true,
	    'provider': 'caliente',
	    'game': {
	      'enabled': true,
	      'provider': 'caliente'
	    }
	  },
	  'ticketProvider': null,
	  'hasTickets': false,
	  'showFavorites': true,
	  'showInsider': false,
	  'showWatch': false,
	  'hideCategoryLinks': [600, 1700],
	  'categorySettings': {
	    'leagues': true,
	    'athletes': true,
	    'teams': true,
	    'tags': true
	  },
	  'showFCContent': true,
	  'showCricInfoContent': false,
	  'cookieConsent': true,
	  'scDeepLinking': true,
	  'allowShortUrl': false,
	  'allowPrintUrl': true,
	  'allowUserAccountManagement': true,
	  'nowFeed': false,
	  'searchUrl': 'http://buscar.espn.com/',
	  'gameSettings': {
	    'topEventsId': 3466416,
	    'promotedSoccerLeaguesCeId': 3466657,
	    'showBroadcast': false
	  },
	  'fallback': {
	    'baseball': 'espn-es-us-baseball-index',
	    'basketball': 'espn-es-us-basketball-index',
	    'boxing': 'espn-es-us-boxing-index',
	    'ciclismo': 'espn-es-co-ciclismo-index',
	    'espn-run': 'espn-es-ar-espn-run-index',
	    'esports': 'espn-es-us-esports-index',
	    'espys': 'espn-es-us-espys-index',
	    'f1': 'espn-es-mx-f1-index',
	    'football': 'espn-es-us-football-index',
	    'golf': 'espn-es-ar-golf-index',
	    'los-angeles': 'espn-es-us-frontpage-index',
	    'mlb': 'espn-es-us-baseball-index',
	    'mlb-beisbolexperience': 'espn-es-us-mlb-beisbolexperience-index',
	    'mma': 'espn-es-mx-mma-index',
	    'motociclismo': 'espn-es-ar-motociclismo-index',
	    'nacion-espn': 'espn-es-us-nacion-espn-index',
	    'nba': 'espn-es-us-basketball-index',
	    'nba-summerleague': 'espn-es-us-nba-summerleague-index',
	    'nexoespn': 'espn-es-co-nexoespn-index',
	    'nfl': 'espn-es-us-football-index',
	    'oly-summer-archery': 'espn-es-mx-oly-summer-archery-index',
	    'oly-summer-athletics': 'espn-es-mx-oly-summer-athletics-index',
	    'oly-summer-badminton': 'espn-es-mx-oly-summer-badminton-index',
	    'oly-summer-basketball': 'espn-es-mx-oly-summer-basketball-index',
	    'oly-summer-boxing': 'espn-es-mx-oly-summer-boxing-index',
	    'oly-summer-canoe': 'espn-es-mx-oly-summer-canoe-index',
	    'oly-summer-cycling': 'espn-es-mx-oly-summer-cycling-index',
	    'oly-summer-equestrian': 'espn-es-mx-oly-summer-equestrian-index',
	    'oly-summer-fencing': 'espn-es-mx-oly-summer-fencing-index',
	    'oly-summer-field-hockey': 'espn-es-mx-oly-summer-field-hockey-index',
	    'oly-summer-golf': 'espn-es-mx-oly-summer-golf-index',
	    'oly-summer-gymnastics': 'espn-es-mx-oly-summer-gymnastics-index',
	    'oly-summer-handball': 'espn-es-mx-oly-summer-handball-index',
	    'oly-summer-judo': 'espn-es-mx-oly-summer-judo-index',
	    'oly-summer-modern-pentathlon': 'espn-es-mx-oly-summer-modern-pentathlon-index',
	    'oly-summer-rowing': 'espn-es-mx-oly-summer-rowing-index',
	    'oly-summer-rugby': 'espn-es-mx-oly-summer-rugby-index',
	    'oly-summer-sailing': 'espn-es-mx-oly-summer-sailing-index',
	    'oly-summer-shooting': 'espn-es-mx-oly-summer-shooting-index',
	    'oly-summer-soccer': 'espn-es-mx-oly-summer-soccer-index',
	    'oly-summer-swimming': 'espn-es-mx-oly-summer-swimming-index',
	    'oly-summer-table-tennis': 'espn-es-mx-oly-summer-table-tennis-index',
	    'oly-summer-taekwondo': 'espn-es-mx-oly-summer-taekwondo-index',
	    'oly-summer-tennis': 'espn-es-mx-oly-summer-tennis-index',
	    'oly-summer-triathlon': 'espn-es-mx-oly-summer-triathlon-index',
	    'oly-summer-volleyball': 'espn-es-mx-oly-summer-volleyball-index',
	    'oly-summer-water-polo': 'espn-es-mx-oly-summer-water-polo-index',
	    'oly-summer-weightlifting': 'espn-es-mx-oly-summer-weightlifting-index',
	    'oly-summer-wrestling': 'espn-es-mx-oly-summer-wrestling-index',
	    'olympics': 'espn-es-mx-olympics-index',
	    'other-sports': 'espn-es-us-other-sports-index',
	    'panamerican': 'espn-es-us-panamerican-index',
	    'poker': 'espn-es-ar-poker-index',
	    'polo': 'espn-es-ar-polo-index',
	    'rpm': 'espn-es-ar-rpm-index',
	    'rugby': 'espn-es-ar-rugby-index',
	    'serie-del-caribe': 'espn-es-us-serie-del-caribe-index',
	    'soccer': 'espn-es-mx-soccer-index',
	    'tennis': 'espn-es-ar-tennis-index',
	    'world-baseball-classic': 'espn-es-us-world-baseball-classic-index',
	    'wwe': 'espn-es-us-luchalibre-index',
	    'x-games': 'espn-es-ar-x-games-index'
	  },
	  'editionAlert': {
	    'enabled': true,
	    'text': 'Has llegado a la edición de México. Quedarse en el sitio actual o ir a edición preferida.'
	  },
	  'feeds': {
	    'googlenews': {
	      'allowedContentTypes': ['TopStoryPackage', 'BlogEntry', 'HeadlineNews']
	    }
	  },
	  'tier2NavIds': {
	    'baseball': 3023264,
	    'basketball': 2474875,
	    'boxing': 2474907,
	    'ciclismo': 2882281,
	    'espn-run': 2507524,
	    'esports': 2882075,
	    'espys': 3121931,
	    'f1': 2474769,
	    'football': 2474884,
	    'golf': 2475240,
	    'los-angeles': '',
	    'mlb': 3023264,
	    'mlb/beisbolexperience': 3044646,
	    'mma': 2475264,
	    'motociclismo': 3397504,
	    'nacion-espn': 2652083,
	    'nba': 2474875,
	    'nba/summerleague': 3316630,
	    'nexoespn': 2649285,
	    'nfl': 2474884,
	    'oly/summer/archery': 2475258,
	    'oly/summer/athletics': 2475258,
	    'oly/summer/badminton': 2475258,
	    'oly/summer/basketball': 2475258,
	    'oly/summer/boxing': 2475258,
	    'oly/summer/canoe': 2475258,
	    'oly/summer/cycling': 2475258,
	    'oly/summer/equestrian': 2475258,
	    'oly/summer/fencing': 2475258,
	    'oly/summer/field-hockey': 2475258,
	    'oly/summer/golf': 2475258,
	    'oly/summer/gymnastics': 2475258,
	    'oly/summer/handball': 2475258,
	    'oly/summer/judo': 2475258,
	    'oly/summer/modern-pentathlon': 2475258,
	    'oly/summer/rowing': 2475258,
	    'oly/summer/rugby': 2475258,
	    'oly/summer/sailing': 2475258,
	    'oly/summer/shooting': 2475258,
	    'oly/summer/soccer': 2475258,
	    'oly/summer/swimming': 2475258,
	    'oly/summer/table-tennis': 2475258,
	    'oly/summer/taekwondo': 2475258,
	    'oly/summer/tennis': 2475258,
	    'oly/summer/triathlon': 2475258,
	    'oly/summer/volleyball': 2475258,
	    'oly/summer/water-polo': 2475258,
	    'oly/summer/weightlifting': 2475258,
	    'oly/summer/wrestling': 2475258,
	    'olympics': 2475258,
	    'other-sports': 2475272,
	    'panamerican': 2507636,
	    'poker': 2506302,
	    'polo': 2511033,
	    'rpm': 2474747,
	    'rugby': 2474293,
	    'serie-del-caribe': 2955159,
	    'soccer': 2487614,
	    'tennis': 2474261,
	    'world-baseball-classic': 2978462,
	    'wwe': 2946192,
	    'x-games': 2475269
	  },
	  'tier3NavIds': {
	    'clubhouse': {
	      'nfl': 2520032,
	      'mlb': 2523552,
	      'nba': 2525379,
	      'soccer': 2525397
	    }
	  },
	  'indexAutoStart': false,
	  'useMongo': true,
	  'activeSite': true,
	  'countries': [{
	    'name': 'Uruguay',
	    'country-code': 'uy',
	    'showHreflang': true
	  }],
	  'reactOverride': {
	    'cricket': {
	      'scores': true
	    }
	  }
	};

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(685);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _pathSegments;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// git hash 8ee6b172772eecafce6aa2c5c0f974c689aeb397
	exports.default = {
	  'editionSettings': {
	    'key': 'espn-es-ve',
	    'site': 'espn',
	    'language': 'es',
	    'country': 've',
	    'domain': 'www.espn.com.ve',
	    'editionSiteId': '21',
	    'https': false,
	    'supportsOneSite': true
	  },
	  'navId': '2488163',
	  'dictionarySection': 'espn',
	  'javaLocale': {
	    'language': 'es',
	    'region': 'MX'
	  },
	  'dateTime': {
	    'long': 'dddd MMMM d, yyyy',
	    'medium': 'MMMM d, yyyy',
	    'short': 'M/d',
	    'timeFormat': 'h:mm',
	    'firstDayOfWeek': 'Sunday',
	    'timeZone': 'America/Santiago',
	    'defaultFormat': 'd MMM, yyyy',
	    'timeZoneString': 'VET',
	    'timeZoneBucket': 'America/New_York',
	    'MMM D, YYYY': 'D MMM, YYYY',
	    'M/D/YYYY': 'D/M/YYYY',
	    'MM/DD/YYYY': 'DD/MM/YYYY',
	    'MMDDYYYY': 'DDMMYYYY',
	    'MMMM Do YYYY': 'Do MMMM YYYY',
	    'dddd, MMMM Do YYYY': 'dddd, Do MMMM YYYY',
	    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
	    'M/D': 'D/M',
	    'MMMM D, YYYY': 'D MMMM YYYY',
	    'dddd, M/D': 'dddd, D/M',
	    'age': {
	      'seconds': 's',
	      'minutes': 'm',
	      'hours': 'h',
	      'days': 'd'
	    }
	  },
	  'numberFormat': {
	    'long': '#,###',
	    'short': '###',
	    'currency': '#,###.00',
	    'percent': '#.00%'
	  },
	  'temperature': {
	    'scale': 'celsius',
	    'symbol': '&deg; C'
	  },
	  'outbrain': {
	    'enabled': true,
	    'template': 'ESPNDeportesLATAM',
	    'desktop': {
	      'compliantId': 'AR_2',
	      'nonCompliantId': 'AR_4'
	    },
	    'mobile': {
	      'compliantId': 'MB_2',
	      'nonCompliantId': 'MB_6'
	    },
	    'video': {
	      'desktop': {
	        'compliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6'
	      }
	    },
	    'report': {
	      'desktop': {
	        'compliantId': 'AR_30',
	        'nonCompliantId': 'AR_30'
	      },
	      'mobile': {
	        'compliantId': 'MB_9',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'table': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'MB_43'
	      }
	    },
	    'game': {
	      'desktop': {
	        'compliantId': 'AR_48'
	      },
	      'mobile': {
	        'compliantId': 'AR_48'
	      }
	    }
	  },
	  'omniture': {
	    'enabled': true
	  },
	  'chartBeat': {
	    'enabled': true
	  },
	  'ads': {
	    'disabled': false,
	    'network': 1234,
	    'partnerAd': false,
	    'dev-config': 14005417,
	    'qa-config': 14005417,
	    'prod-config': 14005417,
	    'outputType': 'js',
	    'featurePhone': {
	      'outputType': 'no-js'
	    }
	  },
	  'partnerModules': {
	    'global': false,
	    'nba': false,
	    'womenbb': false,
	    'golf': false,
	    'endurance': false,
	    'horse': false,
	    'nascar': false
	  },
	  'sportBranding': [{
	    'sport': 'cricket',
	    'image': 'logo-uk-cricinfo',
	    'url': 'http://www.espncricinfo.com'
	  }, {
	    'sport': 'soccer',
	    'image': 'logo-deportes-fc',
	    'url': 'http://www.espn.com.ve/futbol/'
	  }, {
	    'sport': 'rugby',
	    'image': 'logo-deportes-scrum',
	    'url': 'http://www.espn.com.ve/rugby/'
	  }, {
	    'sport': 'ncaaw',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'ncw',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'wnba',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'womenbb',
	    'image': 'espncom-presentadopor-espnw',
	    'url': 'http://espnw.com'
	  }],
	  'siteLogo': {
	    'class': '',
	    'featurePhone': {
	      'name': 'espn-logo',
	      'width': 45,
	      'height': 11
	    }
	  },
	  'meta': {
	    'titleBranding': ' - ESPN',
	    'description': 'ESPN lo último del mundo deportivo. Información completa de todo tipo de deporte incluyendo Fútbol Mexicano, Fútbol Argentino, Fútbol Italiano, Fútbol de España, Fútbol de MLS, Fútbol de Estados Unidos, Fútbol Inglaterra, Fútbol de Alemania, Fútbol de Francia, Baloncesto Profesional, NBA, Básquetbol, Béisbol, Pelota, Fútbol Americano, NFL, Rugby, Tenis, Boxeo, Golf y Juegos de Fantasía.',
	    'defaultMetaImage': 'espn_red.png',
	    'schema': {
	      'name': 'ESPN'
	    },
	    'social': {
	      'twitter': {
	        'twitterId': '',
	        'card': 'summary',
	        'app_id_iphone': '317469184',
	        'site': 'espn',
	        'app_name_googleplay': 'ESPN',
	        'app_id_googleplay': 'com.espn.score_center',
	        'app_name_iphone': 'ESPN',
	        'language': 'es'
	      },
	      'facebook': {
	        'id': '116656161708917',
	        'og_site_name': 'ESPN.com.ve',
	        'locale': 'es_ES'
	      }
	    }
	  },
	  'shop': {
	    'enabled': false
	  },
	  'sportReplacements': {},
	  'uriRewrites': {
	    'urls': {
	      'toEdition': {
	        '/futbol-americano/nfl/': '/futbol-americano/',
	        '/beisbol/mlb/': '/beisbol/',
	        '/basquetbol/nba/': '/basquetbol/'
	      },
	      'toEnglish': {}
	    },
	    'roots': {
	      'toEdition': {},
	      'toEnglish': {}
	    },
	    'pathSegments': (_pathSegments = {
	      'reporte': 'report',
	      'juego': 'game',
	      'equipo': 'team',
	      'plantel': 'roster',
	      'estadisticas': 'stats',
	      'calendario': 'schedule',
	      'estadio': 'stadium',
	      'profundidad': 'depth',
	      'conversacion': 'conversation',
	      'ficha': 'boxscore',
	      'previa': 'preview',
	      'partido': 'match',
	      'jugadas': 'playbyplay',
	      'cronica': 'recap',
	      'fotos': 'photos',
	      'duelo': 'matchup',
	      'jugador': 'player',
	      'posiciones': 'standings',
	      'lesiones': 'injuries',
	      'bateo': 'batting',
	      'grilla': 'grid',
	      'piloto': 'driver',
	      'resultados': 'scoreboard',
	      'liga': 'league',
	      'ligas': 'leagues',
	      'nota': 'story',
	      'comentario': 'commentary',
	      'alineacion': 'lineups'
	    }, (0, _defineProperty3.default)(_pathSegments, 'estadisticas', 'matchstats'), (0, _defineProperty3.default)(_pathSegments, 'jugador-estadisticas', 'playerstats'), (0, _defineProperty3.default)(_pathSegments, 'medallas', 'medals'), (0, _defineProperty3.default)(_pathSegments, 'deportes', 'sports'), (0, _defineProperty3.default)(_pathSegments, 'deportistas', 'athletes'), (0, _defineProperty3.default)(_pathSegments, 'lideres', 'leaderboard'), (0, _defineProperty3.default)(_pathSegments, 'envivo', 'live'), (0, _defineProperty3.default)(_pathSegments, 'ronda', 'rounds'), (0, _defineProperty3.default)(_pathSegments, 'equipos', 'teams'), (0, _defineProperty3.default)(_pathSegments, 'posicion', 'positions'), (0, _defineProperty3.default)(_pathSegments, 'mejordisponible', 'bestavailable'), (0, _defineProperty3.default)(_pathSegments, 'noticias', 'news'), (0, _defineProperty3.default)(_pathSegments, 'noticiasdelequipo', 'teamnews'), (0, _defineProperty3.default)(_pathSegments, 'fecha', 'date'), _pathSegments),
	    'paramKeys': {
	      'juegoId': 'gameId',
	      'fecha': 'date',
	      'equipo': 'team',
	      'nombre': 'name',
	      'partido': 'gameID',
	      'liga': 'league',
	      'tipodetemporada': 'seasontype',
	      'ano': 'year',
	      'semana': 'week',
	      'deportes': 'discipline',
	      'evento': 'event',
	      'torneo': 'tournamentId',
	      'deportista': 'athlete',
	      'vista': 'view',
	      'pais': 'country',
	      'pagina': 'page',
	      'continuo': 'continuous',
	      'ronda': 'round',
	      'posicion': 'position'
	    },
	    'paramValues': {
	      'liga': 'league',
	      'todo': 'all',
	      'deportistas': 'athletes',
	      'paises': 'countries'
	    }
	  },
	  'betting': {
	    'enabled': false,
	    'provider': '',
	    'game': {
	      'enabled': false,
	      'provider': ''
	    }
	  },
	  'ticketProvider': null,
	  'hasTickets': false,
	  'showFavorites': true,
	  'showInsider': false,
	  'showWatch': false,
	  'hideCategoryLinks': [600, 1700],
	  'categorySettings': {
	    'leagues': true,
	    'athletes': true,
	    'teams': true,
	    'tags': true
	  },
	  'showFCContent': true,
	  'showCricInfoContent': false,
	  'cookieConsent': true,
	  'scDeepLinking': true,
	  'allowShortUrl': false,
	  'allowPrintUrl': true,
	  'allowUserAccountManagement': true,
	  'nowFeed': false,
	  'searchUrl': 'http://buscar.espn.com/',
	  'gameSettings': {
	    'topEventsId': 2524480,
	    'promotedSoccerLeaguesCeId': 2508978,
	    'showBroadcast': false
	  },
	  'fallback': {
	    'baseball': 'espn-es-ve-baseball-index',
	    'basketball': 'espn-es-us-basketball-index',
	    'boxing': 'espn-es-us-boxing-index',
	    'ciclismo': 'espn-es-co-ciclismo-index',
	    'espn-run': 'espn-es-ar-espn-run-index',
	    'esports': 'espn-es-us-esports-index',
	    'espys': 'espn-es-us-espys-index',
	    'f1': 'espn-es-mx-f1-index',
	    'football': 'espn-es-mx-football-index',
	    'golf': 'espn-es-ar-golf-index',
	    'los-angeles': 'espn-es-us-frontpage-index',
	    'mlb': 'espn-es-ve-baseball-index',
	    'mlb-beisbolexperience': 'espn-es-us-mlb-beisbolexperience-index',
	    'mma': 'espn-es-mx-mma-index',
	    'motociclismo': 'espn-es-ar-motociclismo-index',
	    'nacion-espn': 'espn-es-us-nacion-espn-index',
	    'nba': 'espn-es-us-basketball-index',
	    'nba-summerleague': 'espn-es-us-nba-summerleague-index',
	    'nexoespn': 'espn-es-co-nexoespn-index',
	    'nfl': 'espn-es-mx-football-index',
	    'oly-summer-archery': 'espn-es-mx-oly-summer-archery-index',
	    'oly-summer-athletics': 'espn-es-mx-oly-summer-athletics-index',
	    'oly-summer-badminton': 'espn-es-mx-oly-summer-badminton-index',
	    'oly-summer-basketball': 'espn-es-mx-oly-summer-basketball-index',
	    'oly-summer-boxing': 'espn-es-mx-oly-summer-boxing-index',
	    'oly-summer-canoe': 'espn-es-mx-oly-summer-canoe-index',
	    'oly-summer-cycling': 'espn-es-mx-oly-summer-cycling-index',
	    'oly-summer-equestrian': 'espn-es-mx-oly-summer-equestrian-index',
	    'oly-summer-fencing': 'espn-es-mx-oly-summer-fencing-index',
	    'oly-summer-field-hockey': 'espn-es-mx-oly-summer-field-hockey-index',
	    'oly-summer-golf': 'espn-es-mx-oly-summer-golf-index',
	    'oly-summer-gymnastics': 'espn-es-mx-oly-summer-gymnastics-index',
	    'oly-summer-handball': 'espn-es-mx-oly-summer-handball-index',
	    'oly-summer-judo': 'espn-es-mx-oly-summer-judo-index',
	    'oly-summer-modern-pentathlon': 'espn-es-mx-oly-summer-modern-pentathlon-index',
	    'oly-summer-rowing': 'espn-es-mx-oly-summer-rowing-index',
	    'oly-summer-rugby': 'espn-es-mx-oly-summer-rugby-index',
	    'oly-summer-sailing': 'espn-es-mx-oly-summer-sailing-index',
	    'oly-summer-shooting': 'espn-es-mx-oly-summer-shooting-index',
	    'oly-summer-soccer': 'espn-es-ar-oly-summer-soccer-index',
	    'oly-summer-swimming': 'espn-es-mx-oly-summer-swimming-index',
	    'oly-summer-table-tennis': 'espn-es-mx-oly-summer-table-tennis-index',
	    'oly-summer-taekwondo': 'espn-es-mx-oly-summer-taekwondo-index',
	    'oly-summer-tennis': 'espn-es-mx-oly-summer-tennis-index',
	    'oly-summer-triathlon': 'espn-es-mx-oly-summer-triathlon-index',
	    'oly-summer-volleyball': 'espn-es-mx-oly-summer-volleyball-index',
	    'oly-summer-water-polo': 'espn-es-mx-oly-summer-water-polo-index',
	    'oly-summer-weightlifting': 'espn-es-mx-oly-summer-weightlifting-index',
	    'oly-summer-wrestling': 'espn-es-mx-oly-summer-wrestling-index',
	    'olympics': 'espn-es-ve-olympics-index',
	    'other-sports': 'espn-es-us-other-sports-index',
	    'panamerican': 'espn-es-us-panamerican-index',
	    'poker': 'espn-es-ar-poker-index',
	    'polo': 'espn-es-ar-polo-index',
	    'rpm': 'espn-es-ar-rpm-index',
	    'rugby': 'espn-es-ar-rugby-index',
	    'serie-del-caribe': 'espn-es-us-serie-del-caribe-index',
	    'soccer': 'espn-es-ve-soccer-index',
	    'tennis': 'espn-es-ar-tennis-index',
	    'world-baseball-classic': 'espn-es-us-world-baseball-classic-index',
	    'wwe': 'espn-es-us-luchalibre-index',
	    'x-games': 'espn-es-ar-x-games-index'
	  },
	  'editionAlert': {
	    'enabled': true,
	    'text': 'Has llegado a la edición de Venezuela. Quedarse en el sitio actual o ir a edición preferida.'
	  },
	  'feeds': {
	    'googlenews': {
	      'allowedContentTypes': ['TopStoryPackage', 'BlogEntry', 'HeadlineNews']
	    }
	  },
	  'tier2NavIds': {
	    'league': {
	      'soccer': 2520885
	    },
	    'baseball': 2716209,
	    'basketball': 2474875,
	    'boxing': 2474907,
	    'ciclismo': 2882281,
	    'espn-run': 2623345,
	    'espnradio': 2639931,
	    'esports': 2774868,
	    'espys': 3121931,
	    'f1': 2474769,
	    'football': 2627761,
	    'golf': 2475240,
	    'los-angeles': '',
	    'mlb': 2716209,
	    'mlb/beisbolexperience': 3044646,
	    'mma': 2475264,
	    'motociclismo': 3397504,
	    'nacion-espn': 2652083,
	    'nba': 2474875,
	    'nba/summerleague': 3316630,
	    'nexoespn': 2652309,
	    'nfl': 2627761,
	    'oly/summer/archery': 2475258,
	    'oly/summer/athletics': 2475258,
	    'oly/summer/badminton': 2475258,
	    'oly/summer/basketball': 2475258,
	    'oly/summer/boxing': 2475258,
	    'oly/summer/canoe': 2475258,
	    'oly/summer/cycling': 2475258,
	    'oly/summer/equestrian': 2475258,
	    'oly/summer/fencing': 2475258,
	    'oly/summer/field-hockey': 2475258,
	    'oly/summer/golf': 2475258,
	    'oly/summer/gymnastics': 2475258,
	    'oly/summer/handball': 2475258,
	    'oly/summer/judo': 2475258,
	    'oly/summer/modern-pentathlon': 2475258,
	    'oly/summer/rowing': 2475258,
	    'oly/summer/rugby': 2475258,
	    'oly/summer/sailing': 2475258,
	    'oly/summer/shooting': 2475258,
	    'oly/summer/soccer': 2475258,
	    'oly/summer/swimming': 2475258,
	    'oly/summer/table-tennis': 2475258,
	    'oly/summer/taekwondo': 2475258,
	    'oly/summer/tennis': 2475258,
	    'oly/summer/triathlon': 2475258,
	    'oly/summer/volleyball': 2475258,
	    'oly/summer/water-polo': 2475258,
	    'oly/summer/weightlifting': 2475258,
	    'oly/summer/wrestling': 2475258,
	    'olympics': 2475258,
	    'other-sports': 2475272,
	    'panamerican': 2507636,
	    'poker': 2506302,
	    'polo': 2511033,
	    'rpm': 2474747,
	    'rugby': 2474293,
	    'serie-del-caribe': 2955159,
	    'soccer': 2488171,
	    'television': 2652309,
	    'tennis': 2474261,
	    'watch': 3046205,
	    'world-baseball-classic': 2978462,
	    'wwe': 2946192,
	    'x-games': 2475269
	  },
	  'tier3NavIds': {
	    'clubhouse': {
	      'nfl': 2520032,
	      'mlb': 2523552,
	      'nba': 2525379,
	      'soccer': 2525397
	    }
	  },
	  'indexAutoStart': false,
	  'useMongo': true,
	  'activeSite': true,
	  'countries': [{
	    'name': 'Venezuela',
	    'country-code': 've',
	    'showHreflang': true
	  }, {
	    'name': 'Belize',
	    'country-code': 'bz',
	    'showHreflang': false
	  }, {
	    'name': 'Costa Rica',
	    'country-code': 've',
	    'showHreflang': false
	  }, {
	    'name': 'Cuba',
	    'country-code': 'cr',
	    'showHreflang': true
	  }, {
	    'name': 'Dominica',
	    'country-code': 'dm',
	    'showHreflang': false
	  }, {
	    'name': 'Dominican Republic',
	    'country-code': 'do',
	    'showHreflang': false
	  }, {
	    'name': 'El Salvador',
	    'country-code': 'sv',
	    'showHreflang': false
	  }, {
	    'name': 'Grenada',
	    'country-code': 'gd',
	    'showHreflang': false
	  }, {
	    'name': 'Guatemala',
	    'country-code': 'gt',
	    'showHreflang': true
	  }, {
	    'name': 'Honduras',
	    'country-code': 'hn',
	    'showHreflang': false
	  }, {
	    'name': 'Nicaragua',
	    'country-code': 'ni',
	    'showHreflang': false
	  }, {
	    'name': 'Panama',
	    'country-code': 'pa',
	    'showHreflang': false
	  }, {
	    'name': 'St. Kitts and Nevis',
	    'country-code': 'kn',
	    'showHreflang': false
	  }, {
	    'name': 'St. Lucia',
	    'country-code': 'lc',
	    'showHreflang': false
	  }, {
	    'name': 'St. Vincent and The Grenadines',
	    'country-code': 'vc',
	    'showHreflang': false
	  }],
	  'reactOverride': {
	    'cricket': {
	      'scores': true
	    }
	  }
	};

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge2 = __webpack_require__(581);
	
	var _merge3 = _interopRequireDefault(_merge2);
	
	var _taboola = __webpack_require__(680);
	
	var _taboola2 = _interopRequireDefault(_taboola);
	
	var _taboolaDefaults = __webpack_require__(668);
	
	var _taboolaDefaults2 = _interopRequireDefault(_taboolaDefaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  'editionSettings': {
	    'key': 'espnuk-en',
	    'site': 'espnuk',
	    'language': 'en',
	    'country': 'gb',
	    'domain': 'www.espn.co.uk',
	    'editionSiteId': '15',
	    'https': true
	  },
	  'navId': '11665684',
	  'dictionarySection': 'espn',
	  'javaLocale': {
	    'language': 'en',
	    'region': 'GB'
	  },
	  'dateTime': {
	    'long': 'dddd MMMM d, yyyy',
	    'medium': 'MMMM d, yyyy',
	    'short': 'M/d',
	    'timeFormat': 'h:mm',
	    'firstDayOfWeek': 'Sunday',
	    'timeZone': 'Etc/GMT',
	    'defaultFormat': 'd MMM, yyyy',
	    'timeZoneString': 'GMT',
	    'timeZoneBucket': 'Europe/London',
	    'MMM D, YYYY': 'D MMM, YYYY',
	    'M/D/YYYY': 'D/M/YYYY',
	    'MM/DD/YYYY': 'DD/MM/YYYY',
	    'MMDDYYYY': 'DDMMYYYY',
	    'MMMM Do YYYY': 'Do MMMM YYYY',
	    'dddd, MMMM Do YYYY': 'dddd, Do MMMM YYYY',
	    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
	    'M/D': 'D/M',
	    'MMMM D, YYYY': 'D MMMM YYYY',
	    'dddd, M/D': 'dddd, D/M',
	    'age': {
	      'seconds': 's',
	      'minutes': 'm',
	      'hours': 'h',
	      'days': 'd'
	    }
	  },
	  'numberFormat': {
	    'long': '#,###',
	    'short': '###',
	    'currency': '#,###.00',
	    'percent': '#.00%'
	  },
	  'temperature': {
	    'scale': 'celsius',
	    'symbol': '&deg; C'
	  },
	  'sponsoredContentProviders': ['taboola', 'outbrain'],
	  'taboola': (0, _merge3.default)({}, _taboolaDefaults2.default, _taboola2.default),
	  'outbrain': {
	    'enabled': true,
	    'template': 'espnuk',
	    'desktop': {
	      'compliantId': 'AR_49',
	      'nonCompliantId': 'AR_4'
	    },
	    'mobile': {
	      'compliantId': 'AR_49',
	      'nonCompliantId': 'MB_4'
	    },
	    'video': {
	      'desktop': {
	        'compliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6'
	      }
	    },
	    'report': {
	      'desktop': {
	        'compliantId': 'AR_30',
	        'nonCompliantId': 'AR_30'
	      },
	      'mobile': {
	        'compliantId': 'MB_9',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'table': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'MB_43'
	      }
	    },
	    'game': {
	      'desktop': {
	        'compliantId': 'AR_48'
	      },
	      'mobile': {
	        'compliantId': 'AR_48'
	      }
	    },
	    'team': {
	      'desktop': {
	        'compliantId': 'SB_1'
	      },
	      'mobile': {
	        'compliantId': 'SB_1'
	      }
	    }
	  },
	  'omniture': {
	    'enabled': true
	  },
	  'chartBeat': {
	    'enabled': true
	  },
	  'ads': {
	    'disabled': false,
	    'network': 1234,
	    'partnerAd': false,
	    'dev-config': 12128704,
	    'qa-config': 12129252,
	    'prod-config': 12129255
	  },
	  'partnerModules': {
	    'global': false,
	    'nba': false,
	    'womenbb': false,
	    'golf': false,
	    'endurance': false,
	    'horse': false,
	    'nascar': false
	  },
	  'sportBranding': [{
	    'sport': 'cricket',
	    'image': 'logo-uk-cricinfo',
	    'url': 'https://www.espncricinfo.com'
	  }, {
	    'sport': 'soccer',
	    'image': 'logo-uk-fc',
	    'url': 'http://www.espnfc.co.uk'
	  }, {
	    'sport': 'rugby',
	    'image': 'logo-uk-scrum',
	    'url': null
	  }, {
	    'sport': 'ncaaw',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'ncw',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'wnba',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'womenbb',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': 'http://espnw.com'
	  }],
	  'siteLogo': {
	    'class': '',
	    'featurePhone': {
	      'name': 'espn-logo',
	      'width': 45,
	      'height': 11
	    }
	  },
	  'meta': {
	    'titleBranding': ' - ESPN',
	    'description': 'Visit ESPN to get up-to-the-minute sports news coverage, scores, highlights and commentary for NFL, MLB, NBA, College Football, NCAA Basketball and more.',
	    'defaultMetaImage': 'espn_red.png',
	    'social': {
	      'twitter': {
	        'twitterId': '',
	        'card': 'summary',
	        'app_id_iphone': '317469184',
	        'site': 'espn',
	        'app_name_googleplay': 'ESPN',
	        'app_id_googleplay': 'com.espn.score_center',
	        'app_name_iphone': 'ESPN',
	        'language': 'en'
	      },
	      'facebook': {
	        'id': '116656161708917',
	        'og_site_name': 'ESPN.com',
	        'locale': 'en_US'
	      }
	    }
	  },
	  'shop': {
	    'enabled': true
	  },
	  'sportReplacements': {
	    'f1': 'f1',
	    'cycling': 'cycling'
	  },
	  'uriRewrites': {
	    'urls': {
	      'toEdition': {},
	      'toEnglish': {}
	    },
	    'roots': {
	      '/oly/summer/gymnastics/': '/oly/summer/gymnastics/',
	      '/oly/summer/cycling/': '/oly/summer/cycling/',
	      '/american-fb/': '/nfl/',
	      '/college-football/': '/ncf/',
	      '/football/club': '/soccer/team',
	      '/football/': '/soccer/',
	      '/racing/nascar/': '/nascar/',
	      '/racing/': '/rpm/',
	      '/mens-college-basketball/': '/ncb/',
	      '/womens-college-basketball/': '/ncw/',
	      '/womens-basketball/': '/womenbb/',
	      '/olympics/': '/oly/',
	      '/cycling/': '/cycling/',
	      '/figure-skating/': '/oly/',
	      '/college-sports/': '/ncaa/',
	      '/gymnastics/': '/oly/',
	      '/skiing/': '/oly/',
	      '/horse-racing/': '/horse/',
	      '/sports/womenbb/': '/womenbb/',
	      '/sports/horse/': '/horse/'
	    },
	    'pathSegments': {},
	    'paramKeys': {},
	    'paramValues': {}
	  },
	  'betting': {
	    'enabled': true,
	    'provider': 'Bet 365',
	    'game': {
	      'enabled': false,
	      'provider': 'Bet 365'
	    }
	  },
	  'ticketProvider': null,
	  'hasTickets': false,
	  'showFavorites': true,
	  'showInsider': false,
	  'showWatch': false,
	  'hideCategoryLinks': [600, 1700],
	  'categorySettings': {
	    'leagues': true,
	    'athletes': false,
	    'teams': false,
	    'tags': true
	  },
	  'showFCContent': true,
	  'showCricInfoContent': false,
	  'cookieConsent': true,
	  'scDeepLinking': true,
	  'allowShortUrl': false,
	  'allowPrintUrl': true,
	  'allowUserAccountManagement': true,
	  'nowFeed': true,
	  'searchUrl': 'http://search.espn.com/',
	  'gameSettings': {
	    'topEventsId': 12128075,
	    'promotedSoccerLeaguesCeId': 12032789,
	    'showBroadcast': false
	  },
	  'fallback': {
	    'nfl': 'espn-en-nfl-index',
	    'chalk': 'espn-en-chalk-index',
	    'mlb': 'espn-en-mlb-index',
	    'nba': 'espn-en-nba-index',
	    'nhl': 'espn-en-nhl-index',
	    'ncf': 'espn-en-ncf-index',
	    'mma': 'espn-en-mma-index',
	    'esports': 'espn-en-esports-index',
	    'nba-stephen-curry': 'espn-en-nba-stephen-curry-index',
	    'oly-summer-archery': 'espn-en-oly-summer-archery-index',
	    'oly-summer-badminton': 'espn-en-oly-summer-badminton-index',
	    'oly-summer-canoe': 'espn-en-oly-summer-canoe-index',
	    'oly-summer-cycling': 'espn-en-oly-summer-cycling-index',
	    'oly-summer-equestrian': 'espn-en-oly-summer-equestrian-index',
	    'oly-summer-fencing': 'espn-en-oly-summer-fencing-index',
	    'oly-summer-field-hockey': 'espn-en-oly-summer-field-hockey-index',
	    'oly-summer-handball': 'espn-en-oly-summer-handball-index',
	    'oly-summer-judo': 'espn-en-oly-summer-judo-index',
	    'oly-summer-modern-pentathlon': 'espn-en-oly-summer-modern-pentathlon-index',
	    'oly-summer-rowing': 'espn-en-oly-summer-rowing-index',
	    'oly-summer-sailing': 'espn-en-oly-summer-sailing-index',
	    'oly-summer-shooting': 'espn-en-oly-summer-shooting-index',
	    'oly-summer-table-tennis': 'espn-en-oly-summer-table-tennis-index',
	    'oly-summer-taekwondo': 'espn-en-oly-summer-taekwondo-index',
	    'oly-summer-triathlon': 'espn-en-oly-summer-triathlon-index',
	    'oly-summer-water-polo': 'espn-en-oly-summer-water-polo-index',
	    'oly-summer-weightlifting': 'espn-en-oly-summer-weightlifting-index',
	    'oly-summer-wrestling': 'espn-en-oly-summer-wrestling-index'
	  },
	  'editionAlert': {
	    'enabled': true,
	    'text': "You have reached ESPN's UK edition. <a href=\"#\" class=\"stay\">Stay on current site</a> or <a href=\"https://www.espn.com/?country-view=us&amp;lang-view=en\">go to US version</a>."
	  },
	  'feeds': {
	    'googlenews': {
	      'allowedContentTypes': ['Story', 'HeadlineNews']
	    }
	  },
	  'tier2NavIds': {
	    'boston': 12375278,
	    'chicago': 12505826,
	    'cleveland': 13977091,
	    'dallas': 12505828,
	    'los-angeles': 12505831,
	    'milwaukee': 13977360,
	    'new-york': 12505854,
	    'fantasy/basketball': 12405600,
	    'fantasy/football': 12405632,
	    'fantasy/baseball': 12405631,
	    'fantasy/hockey': 12405634,
	    'fantasy': 13609307,
	    'ncfrecruiting': 11588758,
	    'ncbrecruiting': 11588880,
	    'esports': 13663224,
	    'onenacion': 13309315,
	    'nba/stephen-curry': 14950765,
	    'caribbean': 15355343,
	    'league': {
	      'soccer': 13794648,
	      'ncf': 13886385,
	      'college-football': 13886385,
	      'cricket': 15609108
	    },
	    'soccer/espninn': 15594937
	  },
	  'tier3NavIds': {
	    'clubhouse': {
	      'nba': 12293424,
	      'mlb': 12343023,
	      'mens-college-basketball': 13884705,
	      'womens-college-basketball': 13930164,
	      'soccer': 12294454,
	      'nfl': 12509708,
	      'college-football': 13345157,
	      'cricket': 15368856
	    }
	  },
	  'indexAutoStart': false,
	  'useMongo': true,
	  'activeSite': true,
	  'countries': [{
	    'name': 'United Kingdom',
	    'country-code': 'gb',
	    'showHreflang': true
	  }],
	  'reactOverride': {
	    'cricket': {
	      'scores': true
	    }
	  }
	};

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge2 = __webpack_require__(581);
	
	var _merge3 = _interopRequireDefault(_merge2);
	
	var _taboola = __webpack_require__(680);
	
	var _taboola2 = _interopRequireDefault(_taboola);
	
	var _taboolaDefaults = __webpack_require__(668);
	
	var _taboolaDefaults2 = _interopRequireDefault(_taboolaDefaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  'editionSettings': {
	    'key': 'espn-en',
	    'site': 'espn',
	    'language': 'en',
	    'country': 'us',
	    'domain': 'www.espn.com',
	    'editionSiteId': '1',
	    'https': true
	  },
	  'navId': '11929946',
	  'dictionarySection': 'espn',
	  'javaLocale': {
	    'language': 'en',
	    'region': 'US'
	  },
	  'dateTime': {
	    'long': 'dddd MMMM d, yyyy',
	    'medium': 'MMMM d, yyyy',
	    'short': 'M/d',
	    'timeFormat': 'h:mm',
	    'firstDayOfWeek': 'Sunday',
	    'timeZone': 'US/Eastern',
	    'timeZoneBucket': 'America/New_York',
	    'defaultFormat': 'MMM d, yyyy',
	    'timeZoneString': 'ET',
	    'age': {
	      'seconds': 's',
	      'minutes': 'm',
	      'hours': 'h',
	      'days': 'd'
	    }
	  },
	  'numberFormat': {
	    'long': '#,###',
	    'short': '###',
	    'currency': '#,###.00',
	    'percent': '#.00%'
	  },
	  'temperature': {
	    'scale': 'fahrenheit',
	    'symbol': '&deg; F'
	  },
	  'sponsoredContentProviders': ['taboola', 'outbrain'],
	  'taboola': (0, _merge3.default)({}, _taboolaDefaults2.default, _taboola2.default),
	  'outbrain': {
	    'enabled': true,
	    'template': 'espn',
	    'desktop': {
	      'compliantId': 'AR_49',
	      'nonCompliantId': 'AR_12'
	    },
	    'mobile': {
	      'compliantId': 'AR_49',
	      'nonCompliantId': 'MB_5'
	    },
	    'video': {
	      'desktop': {
	        'compliantId': 'AR_16'
	      },
	      'mobile': {
	        'compliantId': 'MB_6'
	      }
	    },
	    'recap': {
	      'desktop': {
	        'compliantId': 'AR_30'
	      },
	      'mobile': {
	        'compliantId': 'MB_9'
	      }
	    },
	    'report': {
	      'desktop': {
	        'compliantId': 'AR_30',
	        'nonCompliantId': 'AR_30'
	      },
	      'mobile': {
	        'compliantId': 'MB_9',
	        'nonCompliantId': 'MB_9'
	      }
	    },
	    'table': {
	      'desktop': {
	        'compliantId': 'AR_43'
	      },
	      'mobile': {
	        'compliantId': 'MB_43'
	      }
	    },
	    'game': {
	      'desktop': {
	        'compliantId': 'AR_48'
	      },
	      'mobile': {
	        'compliantId': 'AR_48'
	      }
	    },
	    'team': {
	      'desktop': {
	        'compliantId': 'SB_1'
	      },
	      'mobile': {
	        'compliantId': 'SB_1'
	      }
	    }
	  },
	  'omniture': {
	    'enabled': true
	  },
	  'chartBeat': {
	    'enabled': true
	  },
	  'ads': {
	    'disabled': false,
	    'partnerAd': false,
	    'dev-config': 12129261,
	    'qa-config': 12129262,
	    'prod-config': 12129264
	  },
	  'partnerModules': {
	    'global': true,
	    'nba': true,
	    'womenbb': true,
	    'golf': true,
	    'endurance': true,
	    'horse': true,
	    'nascar': true
	  },
	  'sportBranding': [{
	    'sport': 'cricket',
	    'image': 'logo-uk-cricinfo',
	    'url': 'https://www.espncricinfo.com'
	  }, {
	    'sport': 'soccer',
	    'image': 'logo-uk-fc',
	    'url': 'http://www.espnfc.us'
	  }, {
	    'sport': 'rugby',
	    'image': 'logo-uk-scrum',
	    'url': null
	  }, {
	    'sport': 'ncaaw',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'ncw',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'wnba',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': 'http://espnw.com'
	  }, {
	    'sport': 'womenbb',
	    'image': 'ESPNcom-powerby-espnw',
	    'url': 'http://espnw.com'
	  }],
	  'siteLogo': {
	    'class': '',
	    'featurePhone': {
	      'name': 'espn-logo',
	      'width': 45,
	      'height': 11
	    }
	  },
	  'meta': {
	    'titleBranding': ' - ESPN',
	    'description': 'Visit ESPN to get up-to-the-minute sports news coverage, scores, highlights and commentary for NFL, MLB, NBA, College Football, NCAA Basketball and more.',
	    'defaultMetaImage': 'espn_red.png',
	    'social': {
	      'twitter': {
	        'twitterId': '',
	        'card': 'summary',
	        'app_id_iphone': '317469184',
	        'site': 'espn',
	        'app_name_googleplay': 'ESPN',
	        'app_id_googleplay': 'com.espn.score_center',
	        'app_name_iphone': 'ESPN',
	        'language': 'en'
	      },
	      'facebook': {
	        'id': '116656161708917',
	        'og_site_name': 'ESPN.com',
	        'locale': 'en_US'
	      }
	    }
	  },
	  'shop': {
	    'enabled': true
	  },
	  'sportReplacements': {},
	  'uriRewrites': {
	    'urls': {
	      'toEdition': {},
	      'toEnglish': {}
	    },
	    'roots': {
	      'toEdition': {
	        '/horse/': '/horse-racing/',
	        '/nascar/': '/racing/nascar/',
	        '/ncaa/': '/college-sports/',
	        '/ncb/': '/mens-college-basketball/',
	        '/ncf/': '/college-football/',
	        '/oly/': '/olympics/',
	        '/rpm/': '/racing/',
	        '/womenbb/': '/womens-basketball/',
	        '/flb/': '/fantasy/baseball/',
	        '/fba/': '/fantasy/basketball/',
	        '/ffl/': '/fantasy/football/',
	        '/fhl/': '/fantasy/hockey/'
	      },
	      'toEnglish': {
	        '/oly/summer/gymnastics/': '/oly/summer/gymnastics/',
	        '/oly/summer/cycling/': '/oly/summer/cycling/',
	        '/racing/nascar/': '/nascar/',
	        '/racing/': '/rpm/',
	        '/college-football/': '/ncf/',
	        '/college-football/rumors': '/college-football/rumors',
	        '/mens-college-basketball/': '/ncb/',
	        '/mens-college-basketball/rumors': '/mens-college-basketball/rumors',
	        '/womens-college-basketball/': '/ncw/',
	        '/womens-basketball/': '/womenbb/',
	        '/olympics/': '/oly/',
	        '/cycling/': '/oly/',
	        '/figure-skating/': '/oly/',
	        '/college-sports/': '/ncaa/',
	        '/gymnastics/': '/oly/',
	        '/skiing/': '/oly/',
	        '/horse-racing/': '/horse/',
	        '/sports/womenbb/': '/womenbb/',
	        '/sports/horse/': '/horse/',
	        '/sports/endurance/': '/endurance/',
	        '/losangeles/': '/los-angeles/',
	        '/newyork/': '/new-york/',
	        '/espn/onenacion/': '/onenacion/',
	        '/fantasy/baseball/': '/flb/',
	        '/fantasy/basketball/': '/fba/',
	        '/fantasy/football/': '/ffl/',
	        '/fantasy/hockey/': '/fhl/'
	      }
	    },
	    'pathSegments': {},
	    'paramKeys': {},
	    'paramValues': {}
	  },
	  'betting': {
	    'enabled': true,
	    'game': {
	      'enabled': true
	    }
	  },
	  'ticketProvider': 'stubHub',
	  'showFavorites': true,
	  'showInsider': true,
	  'showWatch': true,
	  'showCategory': true,
	  'hideCategoryLinks': [600, 1700],
	  'categorySettings': {
	    'leagues': true,
	    'athletes': true,
	    'teams': true,
	    'tags': true
	  },
	  'showFCContent': false,
	  'showCricInfoContent': false,
	  'cookieConsent': false,
	  'scDeepLinking': true,
	  'allowShortUrl': true,
	  'allowPrintUrl': true,
	  'allowUserAccountManagement': true,
	  'nowFeed': true,
	  'hasTickets': true,
	  'searchUrl': 'http://search.espn.com/',
	  'gameSettings': {
	    'topEventsId': 4379198,
	    'promotedSoccerLeaguesCeId': 12032789,
	    'showBroadcast': true
	  },
	  'fallback': {
	    'football': 'espnuk-en-soccer-index',
	    'cricket': 'espn-en-cricket-index'
	  },
	  'editionAlert': {
	    'enabled': false,
	    'text': ''
	  },
	  'feeds': {
	    'googlenews': {
	      'allowedContentTypes': ['TopStoryPackage', 'HeadlineNews', 'BlogEntry']
	    }
	  },
	  'tier2NavIds': {
	    'boston': 12375278,
	    'chicago': 12505826,
	    'cleveland': 13977091,
	    'dallas': 12505828,
	    'los-angeles': 12505831,
	    'milwaukee': 13977360,
	    'new-york': 12505854,
	    'fantasy/basketball': 12405600,
	    'fantasy/football': 12405632,
	    'fantasy/baseball': 12405631,
	    'fantasy/hockey': 12405634,
	    'fantasy': 13609307,
	    'ncfrecruiting': 11588758,
	    'ncbrecruiting': 11588880,
	    'esports': 13663224,
	    'onenacion': 13309315,
	    'jayski': 16584380,
	    'ncf/weekday-walkthrough': 17165710,
	    'wwe': 17101058,
	    'sportsnation': 12544987,
	    'nba/stephen-curry': 14950765,
	    'league': {
	      'soccer': 13794648,
	      'ncf': 13886385,
	      'college-football': 13886385,
	      'cricket': 15609108
	    },
	    'watch': 15726903,
	    'espn/caponecup': 17140605
	  },
	  'tier3NavIds': {
	    'clubhouse': {
	      'nba': 12293424,
	      'mlb': 12343023,
	      'mens-college-basketball': 13884705,
	      'womens-college-basketball': 13930164,
	      'soccer': 12294454,
	      'nfl': 12509708,
	      'college-football': 13345157,
	      'cricket': 15368856
	    },
	    'doubletruck': 14830831
	  },
	  'indexAutoStart': false,
	  'useMongo': true,
	  'activeSite': true,
	  'countries': [{
	    'name': 'United States',
	    'country-code': 'us',
	    'showHreflang': true
	  }]
	};

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(703),
	    baseIteratee = __webpack_require__(704),
	    baseMap = __webpack_require__(754),
	    isArray = __webpack_require__(637);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ }),
/* 703 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(705),
	    baseMatchesProperty = __webpack_require__(736),
	    identity = __webpack_require__(659),
	    isArray = __webpack_require__(637),
	    property = __webpack_require__(751);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(706),
	    getMatchData = __webpack_require__(733),
	    matchesStrictComparable = __webpack_require__(735);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(583),
	    baseIsEqual = __webpack_require__(707);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(708),
	    isObjectLike = __webpack_require__(267);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(583),
	    equalArrays = __webpack_require__(709),
	    equalByTag = __webpack_require__(715),
	    equalObjects = __webpack_require__(718),
	    getTag = __webpack_require__(728),
	    isArray = __webpack_require__(637),
	    isBuffer = __webpack_require__(641),
	    isTypedArray = __webpack_require__(643);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(710),
	    arraySome = __webpack_require__(713),
	    cacheHas = __webpack_require__(714);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(606),
	    setCacheAdd = __webpack_require__(711),
	    setCacheHas = __webpack_require__(712);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),
/* 711 */
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),
/* 712 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),
/* 713 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),
/* 714 */
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(260),
	    Uint8Array = __webpack_require__(630),
	    eq = __webpack_require__(588),
	    equalArrays = __webpack_require__(709),
	    mapToArray = __webpack_require__(716),
	    setToArray = __webpack_require__(717);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),
/* 716 */
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),
/* 717 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(719);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(720),
	    getSymbols = __webpack_require__(722),
	    keys = __webpack_require__(725);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(721),
	    isArray = __webpack_require__(637);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 721 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(723),
	    stubArray = __webpack_require__(724);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 723 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 724 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(652),
	    baseKeys = __webpack_require__(726),
	    isArrayLike = __webpack_require__(639);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(634),
	    nativeKeys = __webpack_require__(727);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(266);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(729),
	    Map = __webpack_require__(597),
	    Promise = __webpack_require__(730),
	    Set = __webpack_require__(731),
	    WeakMap = __webpack_require__(732),
	    baseGetTag = __webpack_require__(259),
	    toSource = __webpack_require__(604);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(598),
	    root = __webpack_require__(261);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(598),
	    root = __webpack_require__(261);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(598),
	    root = __webpack_require__(261);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(598),
	    root = __webpack_require__(261);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(734),
	    keys = __webpack_require__(725);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(601);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),
/* 735 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(707),
	    get = __webpack_require__(737),
	    hasIn = __webpack_require__(748),
	    isKey = __webpack_require__(740),
	    isStrictComparable = __webpack_require__(734),
	    matchesStrictComparable = __webpack_require__(735),
	    toKey = __webpack_require__(747);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(738);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(739),
	    toKey = __webpack_require__(747);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(637),
	    isKey = __webpack_require__(740),
	    stringToPath = __webpack_require__(742),
	    toString = __webpack_require__(745);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(637),
	    isSymbol = __webpack_require__(741);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(259),
	    isObjectLike = __webpack_require__(267);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(743);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(744);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(606);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(746);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(260),
	    arrayMap = __webpack_require__(703),
	    isArray = __webpack_require__(637),
	    isSymbol = __webpack_require__(741);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(741);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(749),
	    hasPath = __webpack_require__(750);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ }),
/* 749 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(739),
	    isArguments = __webpack_require__(635),
	    isArray = __webpack_require__(637),
	    isIndex = __webpack_require__(654),
	    isLength = __webpack_require__(640),
	    toKey = __webpack_require__(747);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(752),
	    basePropertyDeep = __webpack_require__(753),
	    isKey = __webpack_require__(740),
	    toKey = __webpack_require__(747);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),
/* 752 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(738);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(755),
	    isArrayLike = __webpack_require__(639);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(756),
	    createBaseEach = __webpack_require__(757);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(624),
	    keys = __webpack_require__(725);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(639);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ }),
/* 758 */
/***/ (function(module, exports) {

	/**
	 * Creates an array with all falsey values removed. The values `false`, `null`,
	 * `0`, `""`, `undefined`, and `NaN` are falsey.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to compact.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * _.compact([0, 1, false, 2, '', 3]);
	 * // => [1, 2, 3]
	 */
	function compact(array) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = compact;


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var punycode = __webpack_require__(760);
	var util = __webpack_require__(761);
	
	exports.parse = urlParse;
	exports.resolve = urlResolve;
	exports.resolveObject = urlResolveObject;
	exports.format = urlFormat;
	
	exports.Url = Url;
	
	function Url() {
	  this.protocol = null;
	  this.slashes = null;
	  this.auth = null;
	  this.host = null;
	  this.port = null;
	  this.hostname = null;
	  this.hash = null;
	  this.search = null;
	  this.query = null;
	  this.pathname = null;
	  this.path = null;
	  this.href = null;
	}
	
	// Reference: RFC 3986, RFC 1808, RFC 2396
	
	// define these here so at least they only have to be
	// compiled once on the first module load.
	var protocolPattern = /^([a-z0-9.+-]+:)/i,
	    portPattern = /:[0-9]*$/,
	
	    // Special case for a simple path URL
	    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,
	
	    // RFC 2396: characters reserved for delimiting URLs.
	    // We actually just auto-escape these.
	    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],
	
	    // RFC 2396: characters not allowed for various reasons.
	    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),
	
	    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	    autoEscape = ['\''].concat(unwise),
	    // Characters that are never ever allowed in a hostname.
	    // Note that any invalid chars are also handled, but these
	    // are the ones that are *expected* to be seen, so we fast-path
	    // them.
	    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
	    hostEndingChars = ['/', '?', '#'],
	    hostnameMaxLen = 255,
	    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
	    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
	    // protocols that can allow "unsafe" and "unwise" chars.
	    unsafeProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that never have a hostname.
	    hostlessProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that always contain a // bit.
	    slashedProtocol = {
	      'http': true,
	      'https': true,
	      'ftp': true,
	      'gopher': true,
	      'file': true,
	      'http:': true,
	      'https:': true,
	      'ftp:': true,
	      'gopher:': true,
	      'file:': true
	    },
	    querystring = __webpack_require__(762);
	
	function urlParse(url, parseQueryString, slashesDenoteHost) {
	  if (url && util.isObject(url) && url instanceof Url) return url;
	
	  var u = new Url;
	  u.parse(url, parseQueryString, slashesDenoteHost);
	  return u;
	}
	
	Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
	  if (!util.isString(url)) {
	    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
	  }
	
	  // Copy chrome, IE, opera backslash-handling behavior.
	  // Back slashes before the query string get converted to forward slashes
	  // See: https://code.google.com/p/chromium/issues/detail?id=25916
	  var queryIndex = url.indexOf('?'),
	      splitter =
	          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
	      uSplit = url.split(splitter),
	      slashRegex = /\\/g;
	  uSplit[0] = uSplit[0].replace(slashRegex, '/');
	  url = uSplit.join(splitter);
	
	  var rest = url;
	
	  // trim before proceeding.
	  // This is to support parse stuff like "  http://foo.com  \n"
	  rest = rest.trim();
	
	  if (!slashesDenoteHost && url.split('#').length === 1) {
	    // Try fast path regexp
	    var simplePath = simplePathPattern.exec(rest);
	    if (simplePath) {
	      this.path = rest;
	      this.href = rest;
	      this.pathname = simplePath[1];
	      if (simplePath[2]) {
	        this.search = simplePath[2];
	        if (parseQueryString) {
	          this.query = querystring.parse(this.search.substr(1));
	        } else {
	          this.query = this.search.substr(1);
	        }
	      } else if (parseQueryString) {
	        this.search = '';
	        this.query = {};
	      }
	      return this;
	    }
	  }
	
	  var proto = protocolPattern.exec(rest);
	  if (proto) {
	    proto = proto[0];
	    var lowerProto = proto.toLowerCase();
	    this.protocol = lowerProto;
	    rest = rest.substr(proto.length);
	  }
	
	  // figure out if it's got a host
	  // user@server is *always* interpreted as a hostname, and url
	  // resolution will treat //foo/bar as host=foo,path=bar because that's
	  // how the browser resolves relative URLs.
	  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
	    var slashes = rest.substr(0, 2) === '//';
	    if (slashes && !(proto && hostlessProtocol[proto])) {
	      rest = rest.substr(2);
	      this.slashes = true;
	    }
	  }
	
	  if (!hostlessProtocol[proto] &&
	      (slashes || (proto && !slashedProtocol[proto]))) {
	
	    // there's a hostname.
	    // the first instance of /, ?, ;, or # ends the host.
	    //
	    // If there is an @ in the hostname, then non-host chars *are* allowed
	    // to the left of the last @ sign, unless some host-ending character
	    // comes *before* the @-sign.
	    // URLs are obnoxious.
	    //
	    // ex:
	    // http://a@b@c/ => user:a@b host:c
	    // http://a@b?@c => user:a host:c path:/?@c
	
	    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
	    // Review our test case against browsers more comprehensively.
	
	    // find the first instance of any hostEndingChars
	    var hostEnd = -1;
	    for (var i = 0; i < hostEndingChars.length; i++) {
	      var hec = rest.indexOf(hostEndingChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	
	    // at this point, either we have an explicit point where the
	    // auth portion cannot go past, or the last @ char is the decider.
	    var auth, atSign;
	    if (hostEnd === -1) {
	      // atSign can be anywhere.
	      atSign = rest.lastIndexOf('@');
	    } else {
	      // atSign must be in auth portion.
	      // http://a@b/c@d => host:b auth:a path:/c@d
	      atSign = rest.lastIndexOf('@', hostEnd);
	    }
	
	    // Now we have a portion which is definitely the auth.
	    // Pull that off.
	    if (atSign !== -1) {
	      auth = rest.slice(0, atSign);
	      rest = rest.slice(atSign + 1);
	      this.auth = decodeURIComponent(auth);
	    }
	
	    // the host is the remaining to the left of the first non-host char
	    hostEnd = -1;
	    for (var i = 0; i < nonHostChars.length; i++) {
	      var hec = rest.indexOf(nonHostChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	    // if we still have not hit it, then the entire thing is a host.
	    if (hostEnd === -1)
	      hostEnd = rest.length;
	
	    this.host = rest.slice(0, hostEnd);
	    rest = rest.slice(hostEnd);
	
	    // pull out port.
	    this.parseHost();
	
	    // we've indicated that there is a hostname,
	    // so even if it's empty, it has to be present.
	    this.hostname = this.hostname || '';
	
	    // if hostname begins with [ and ends with ]
	    // assume that it's an IPv6 address.
	    var ipv6Hostname = this.hostname[0] === '[' &&
	        this.hostname[this.hostname.length - 1] === ']';
	
	    // validate a little.
	    if (!ipv6Hostname) {
	      var hostparts = this.hostname.split(/\./);
	      for (var i = 0, l = hostparts.length; i < l; i++) {
	        var part = hostparts[i];
	        if (!part) continue;
	        if (!part.match(hostnamePartPattern)) {
	          var newpart = '';
	          for (var j = 0, k = part.length; j < k; j++) {
	            if (part.charCodeAt(j) > 127) {
	              // we replace non-ASCII char with a temporary placeholder
	              // we need this to make sure size of hostname is not
	              // broken by replacing non-ASCII by nothing
	              newpart += 'x';
	            } else {
	              newpart += part[j];
	            }
	          }
	          // we test again with ASCII char only
	          if (!newpart.match(hostnamePartPattern)) {
	            var validParts = hostparts.slice(0, i);
	            var notHost = hostparts.slice(i + 1);
	            var bit = part.match(hostnamePartStart);
	            if (bit) {
	              validParts.push(bit[1]);
	              notHost.unshift(bit[2]);
	            }
	            if (notHost.length) {
	              rest = '/' + notHost.join('.') + rest;
	            }
	            this.hostname = validParts.join('.');
	            break;
	          }
	        }
	      }
	    }
	
	    if (this.hostname.length > hostnameMaxLen) {
	      this.hostname = '';
	    } else {
	      // hostnames are always lower case.
	      this.hostname = this.hostname.toLowerCase();
	    }
	
	    if (!ipv6Hostname) {
	      // IDNA Support: Returns a punycoded representation of "domain".
	      // It only converts parts of the domain name that
	      // have non-ASCII characters, i.e. it doesn't matter if
	      // you call it with a domain that already is ASCII-only.
	      this.hostname = punycode.toASCII(this.hostname);
	    }
	
	    var p = this.port ? ':' + this.port : '';
	    var h = this.hostname || '';
	    this.host = h + p;
	    this.href += this.host;
	
	    // strip [ and ] from the hostname
	    // the host field still retains them, though
	    if (ipv6Hostname) {
	      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
	      if (rest[0] !== '/') {
	        rest = '/' + rest;
	      }
	    }
	  }
	
	  // now rest is set to the post-host stuff.
	  // chop off any delim chars.
	  if (!unsafeProtocol[lowerProto]) {
	
	    // First, make 100% sure that any "autoEscape" chars get
	    // escaped, even if encodeURIComponent doesn't think they
	    // need to be.
	    for (var i = 0, l = autoEscape.length; i < l; i++) {
	      var ae = autoEscape[i];
	      if (rest.indexOf(ae) === -1)
	        continue;
	      var esc = encodeURIComponent(ae);
	      if (esc === ae) {
	        esc = escape(ae);
	      }
	      rest = rest.split(ae).join(esc);
	    }
	  }
	
	
	  // chop off from the tail first.
	  var hash = rest.indexOf('#');
	  if (hash !== -1) {
	    // got a fragment string.
	    this.hash = rest.substr(hash);
	    rest = rest.slice(0, hash);
	  }
	  var qm = rest.indexOf('?');
	  if (qm !== -1) {
	    this.search = rest.substr(qm);
	    this.query = rest.substr(qm + 1);
	    if (parseQueryString) {
	      this.query = querystring.parse(this.query);
	    }
	    rest = rest.slice(0, qm);
	  } else if (parseQueryString) {
	    // no query string, but parseQueryString still requested
	    this.search = '';
	    this.query = {};
	  }
	  if (rest) this.pathname = rest;
	  if (slashedProtocol[lowerProto] &&
	      this.hostname && !this.pathname) {
	    this.pathname = '/';
	  }
	
	  //to support http.request
	  if (this.pathname || this.search) {
	    var p = this.pathname || '';
	    var s = this.search || '';
	    this.path = p + s;
	  }
	
	  // finally, reconstruct the href based on what has been validated.
	  this.href = this.format();
	  return this;
	};
	
	// format a parsed object into a url string
	function urlFormat(obj) {
	  // ensure it's an object, and not a string url.
	  // If it's an obj, this is a no-op.
	  // this way, you can call url_format() on strings
	  // to clean up potentially wonky urls.
	  if (util.isString(obj)) obj = urlParse(obj);
	  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
	  return obj.format();
	}
	
	Url.prototype.format = function() {
	  var auth = this.auth || '';
	  if (auth) {
	    auth = encodeURIComponent(auth);
	    auth = auth.replace(/%3A/i, ':');
	    auth += '@';
	  }
	
	  var protocol = this.protocol || '',
	      pathname = this.pathname || '',
	      hash = this.hash || '',
	      host = false,
	      query = '';
	
	  if (this.host) {
	    host = auth + this.host;
	  } else if (this.hostname) {
	    host = auth + (this.hostname.indexOf(':') === -1 ?
	        this.hostname :
	        '[' + this.hostname + ']');
	    if (this.port) {
	      host += ':' + this.port;
	    }
	  }
	
	  if (this.query &&
	      util.isObject(this.query) &&
	      Object.keys(this.query).length) {
	    query = querystring.stringify(this.query);
	  }
	
	  var search = this.search || (query && ('?' + query)) || '';
	
	  if (protocol && protocol.substr(-1) !== ':') protocol += ':';
	
	  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	  // unless they had them to begin with.
	  if (this.slashes ||
	      (!protocol || slashedProtocol[protocol]) && host !== false) {
	    host = '//' + (host || '');
	    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
	  } else if (!host) {
	    host = '';
	  }
	
	  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
	  if (search && search.charAt(0) !== '?') search = '?' + search;
	
	  pathname = pathname.replace(/[?#]/g, function(match) {
	    return encodeURIComponent(match);
	  });
	  search = search.replace('#', '%23');
	
	  return protocol + host + pathname + search + hash;
	};
	
	function urlResolve(source, relative) {
	  return urlParse(source, false, true).resolve(relative);
	}
	
	Url.prototype.resolve = function(relative) {
	  return this.resolveObject(urlParse(relative, false, true)).format();
	};
	
	function urlResolveObject(source, relative) {
	  if (!source) return relative;
	  return urlParse(source, false, true).resolveObject(relative);
	}
	
	Url.prototype.resolveObject = function(relative) {
	  if (util.isString(relative)) {
	    var rel = new Url();
	    rel.parse(relative, false, true);
	    relative = rel;
	  }
	
	  var result = new Url();
	  var tkeys = Object.keys(this);
	  for (var tk = 0; tk < tkeys.length; tk++) {
	    var tkey = tkeys[tk];
	    result[tkey] = this[tkey];
	  }
	
	  // hash is always overridden, no matter what.
	  // even href="" will remove it.
	  result.hash = relative.hash;
	
	  // if the relative url is empty, then there's nothing left to do here.
	  if (relative.href === '') {
	    result.href = result.format();
	    return result;
	  }
	
	  // hrefs like //foo/bar always cut to the protocol.
	  if (relative.slashes && !relative.protocol) {
	    // take everything except the protocol from relative
	    var rkeys = Object.keys(relative);
	    for (var rk = 0; rk < rkeys.length; rk++) {
	      var rkey = rkeys[rk];
	      if (rkey !== 'protocol')
	        result[rkey] = relative[rkey];
	    }
	
	    //urlParse appends trailing / to urls like http://www.example.com
	    if (slashedProtocol[result.protocol] &&
	        result.hostname && !result.pathname) {
	      result.path = result.pathname = '/';
	    }
	
	    result.href = result.format();
	    return result;
	  }
	
	  if (relative.protocol && relative.protocol !== result.protocol) {
	    // if it's a known url protocol, then changing
	    // the protocol does weird things
	    // first, if it's not file:, then we MUST have a host,
	    // and if there was a path
	    // to begin with, then we MUST have a path.
	    // if it is file:, then the host is dropped,
	    // because that's known to be hostless.
	    // anything else is assumed to be absolute.
	    if (!slashedProtocol[relative.protocol]) {
	      var keys = Object.keys(relative);
	      for (var v = 0; v < keys.length; v++) {
	        var k = keys[v];
	        result[k] = relative[k];
	      }
	      result.href = result.format();
	      return result;
	    }
	
	    result.protocol = relative.protocol;
	    if (!relative.host && !hostlessProtocol[relative.protocol]) {
	      var relPath = (relative.pathname || '').split('/');
	      while (relPath.length && !(relative.host = relPath.shift()));
	      if (!relative.host) relative.host = '';
	      if (!relative.hostname) relative.hostname = '';
	      if (relPath[0] !== '') relPath.unshift('');
	      if (relPath.length < 2) relPath.unshift('');
	      result.pathname = relPath.join('/');
	    } else {
	      result.pathname = relative.pathname;
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    result.host = relative.host || '';
	    result.auth = relative.auth;
	    result.hostname = relative.hostname || relative.host;
	    result.port = relative.port;
	    // to support http.request
	    if (result.pathname || result.search) {
	      var p = result.pathname || '';
	      var s = result.search || '';
	      result.path = p + s;
	    }
	    result.slashes = result.slashes || relative.slashes;
	    result.href = result.format();
	    return result;
	  }
	
	  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
	      isRelAbs = (
	          relative.host ||
	          relative.pathname && relative.pathname.charAt(0) === '/'
	      ),
	      mustEndAbs = (isRelAbs || isSourceAbs ||
	                    (result.host && relative.pathname)),
	      removeAllDots = mustEndAbs,
	      srcPath = result.pathname && result.pathname.split('/') || [],
	      relPath = relative.pathname && relative.pathname.split('/') || [],
	      psychotic = result.protocol && !slashedProtocol[result.protocol];
	
	  // if the url is a non-slashed url, then relative
	  // links like ../.. should be able
	  // to crawl up to the hostname, as well.  This is strange.
	  // result.protocol has already been set by now.
	  // Later on, put the first path part into the host field.
	  if (psychotic) {
	    result.hostname = '';
	    result.port = null;
	    if (result.host) {
	      if (srcPath[0] === '') srcPath[0] = result.host;
	      else srcPath.unshift(result.host);
	    }
	    result.host = '';
	    if (relative.protocol) {
	      relative.hostname = null;
	      relative.port = null;
	      if (relative.host) {
	        if (relPath[0] === '') relPath[0] = relative.host;
	        else relPath.unshift(relative.host);
	      }
	      relative.host = null;
	    }
	    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
	  }
	
	  if (isRelAbs) {
	    // it's absolute.
	    result.host = (relative.host || relative.host === '') ?
	                  relative.host : result.host;
	    result.hostname = (relative.hostname || relative.hostname === '') ?
	                      relative.hostname : result.hostname;
	    result.search = relative.search;
	    result.query = relative.query;
	    srcPath = relPath;
	    // fall through to the dot-handling below.
	  } else if (relPath.length) {
	    // it's relative
	    // throw away the existing file, and take the new path instead.
	    if (!srcPath) srcPath = [];
	    srcPath.pop();
	    srcPath = srcPath.concat(relPath);
	    result.search = relative.search;
	    result.query = relative.query;
	  } else if (!util.isNullOrUndefined(relative.search)) {
	    // just pull out the search.
	    // like href='?foo'.
	    // Put this after the other two cases because it simplifies the booleans
	    if (psychotic) {
	      result.hostname = result.host = srcPath.shift();
	      //occationaly the auth can get stuck only in host
	      //this especially happens in cases like
	      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	      var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                       result.host.split('@') : false;
	      if (authInHost) {
	        result.auth = authInHost.shift();
	        result.host = result.hostname = authInHost.shift();
	      }
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    //to support http.request
	    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
	      result.path = (result.pathname ? result.pathname : '') +
	                    (result.search ? result.search : '');
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  if (!srcPath.length) {
	    // no path at all.  easy.
	    // we've already handled the other stuff above.
	    result.pathname = null;
	    //to support http.request
	    if (result.search) {
	      result.path = '/' + result.search;
	    } else {
	      result.path = null;
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  // if a url ENDs in . or .., then it must get a trailing slash.
	  // however, if it ends in anything else non-slashy,
	  // then it must NOT get a trailing slash.
	  var last = srcPath.slice(-1)[0];
	  var hasTrailingSlash = (
	      (result.host || relative.host || srcPath.length > 1) &&
	      (last === '.' || last === '..') || last === '');
	
	  // strip single dots, resolve double dots to parent dir
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = srcPath.length; i >= 0; i--) {
	    last = srcPath[i];
	    if (last === '.') {
	      srcPath.splice(i, 1);
	    } else if (last === '..') {
	      srcPath.splice(i, 1);
	      up++;
	    } else if (up) {
	      srcPath.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (!mustEndAbs && !removeAllDots) {
	    for (; up--; up) {
	      srcPath.unshift('..');
	    }
	  }
	
	  if (mustEndAbs && srcPath[0] !== '' &&
	      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
	    srcPath.unshift('');
	  }
	
	  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
	    srcPath.push('');
	  }
	
	  var isAbsolute = srcPath[0] === '' ||
	      (srcPath[0] && srcPath[0].charAt(0) === '/');
	
	  // put the host back
	  if (psychotic) {
	    result.hostname = result.host = isAbsolute ? '' :
	                                    srcPath.length ? srcPath.shift() : '';
	    //occationaly the auth can get stuck only in host
	    //this especially happens in cases like
	    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	    var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                     result.host.split('@') : false;
	    if (authInHost) {
	      result.auth = authInHost.shift();
	      result.host = result.hostname = authInHost.shift();
	    }
	  }
	
	  mustEndAbs = mustEndAbs || (result.host && srcPath.length);
	
	  if (mustEndAbs && !isAbsolute) {
	    srcPath.unshift('');
	  }
	
	  if (!srcPath.length) {
	    result.pathname = null;
	    result.path = null;
	  } else {
	    result.pathname = srcPath.join('/');
	  }
	
	  //to support request.http
	  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
	    result.path = (result.pathname ? result.pathname : '') +
	                  (result.search ? result.search : '');
	  }
	  result.auth = relative.auth || result.auth;
	  result.slashes = result.slashes || relative.slashes;
	  result.href = result.format();
	  return result;
	};
	
	Url.prototype.parseHost = function() {
	  var host = this.host;
	  var port = portPattern.exec(host);
	  if (port) {
	    port = port[0];
	    if (port !== ':') {
	      this.port = port.substr(1);
	    }
	    host = host.substr(0, host.length - port.length);
	  }
	  if (host) this.hostname = host;
	};


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/punycode v1.3.2 by @mathias */
	;(function(root) {
	
		/** Detect free variables */
		var freeExports = typeof exports == 'object' && exports &&
			!exports.nodeType && exports;
		var freeModule = typeof module == 'object' && module &&
			!module.nodeType && module;
		var freeGlobal = typeof global == 'object' && global;
		if (
			freeGlobal.global === freeGlobal ||
			freeGlobal.window === freeGlobal ||
			freeGlobal.self === freeGlobal
		) {
			root = freeGlobal;
		}
	
		/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
		var punycode,
	
		/** Highest positive signed 32-bit float value */
		maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1
	
		/** Bootstring parameters */
		base = 36,
		tMin = 1,
		tMax = 26,
		skew = 38,
		damp = 700,
		initialBias = 72,
		initialN = 128, // 0x80
		delimiter = '-', // '\x2D'
	
		/** Regular expressions */
		regexPunycode = /^xn--/,
		regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
		regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators
	
		/** Error messages */
		errors = {
			'overflow': 'Overflow: input needs wider integers to process',
			'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
			'invalid-input': 'Invalid input'
		},
	
		/** Convenience shortcuts */
		baseMinusTMin = base - tMin,
		floor = Math.floor,
		stringFromCharCode = String.fromCharCode,
	
		/** Temporary variable */
		key;
	
		/*--------------------------------------------------------------------------*/
	
		/**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
		function error(type) {
			throw RangeError(errors[type]);
		}
	
		/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
		function map(array, fn) {
			var length = array.length;
			var result = [];
			while (length--) {
				result[length] = fn(array[length]);
			}
			return result;
		}
	
		/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
		function mapDomain(string, fn) {
			var parts = string.split('@');
			var result = '';
			if (parts.length > 1) {
				// In email addresses, only the domain name should be punycoded. Leave
				// the local part (i.e. everything up to `@`) intact.
				result = parts[0] + '@';
				string = parts[1];
			}
			// Avoid `split(regex)` for IE8 compatibility. See #17.
			string = string.replace(regexSeparators, '\x2E');
			var labels = string.split('.');
			var encoded = map(labels, fn).join('.');
			return result + encoded;
		}
	
		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		function ucs2decode(string) {
			var output = [],
			    counter = 0,
			    length = string.length,
			    value,
			    extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
		function ucs2encode(array) {
			return map(array, function(value) {
				var output = '';
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
				return output;
			}).join('');
		}
	
		/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
		function basicToDigit(codePoint) {
			if (codePoint - 48 < 10) {
				return codePoint - 22;
			}
			if (codePoint - 65 < 26) {
				return codePoint - 65;
			}
			if (codePoint - 97 < 26) {
				return codePoint - 97;
			}
			return base;
		}
	
		/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
		function digitToBasic(digit, flag) {
			//  0..25 map to ASCII a..z or A..Z
			// 26..35 map to ASCII 0..9
			return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
		}
	
		/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * http://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
		function adapt(delta, numPoints, firstTime) {
			var k = 0;
			delta = firstTime ? floor(delta / damp) : delta >> 1;
			delta += floor(delta / numPoints);
			for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
				delta = floor(delta / baseMinusTMin);
			}
			return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
		}
	
		/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
		function decode(input) {
			// Don't use UCS-2
			var output = [],
			    inputLength = input.length,
			    out,
			    i = 0,
			    n = initialN,
			    bias = initialBias,
			    basic,
			    j,
			    index,
			    oldi,
			    w,
			    k,
			    digit,
			    t,
			    /** Cached calculation results */
			    baseMinusT;
	
			// Handle the basic code points: let `basic` be the number of input code
			// points before the last delimiter, or `0` if there is none, then copy
			// the first basic code points to the output.
	
			basic = input.lastIndexOf(delimiter);
			if (basic < 0) {
				basic = 0;
			}
	
			for (j = 0; j < basic; ++j) {
				// if it's not a basic code point
				if (input.charCodeAt(j) >= 0x80) {
					error('not-basic');
				}
				output.push(input.charCodeAt(j));
			}
	
			// Main decoding loop: start just after the last delimiter if any basic code
			// points were copied; start at the beginning otherwise.
	
			for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {
	
				// `index` is the index of the next character to be consumed.
				// Decode a generalized variable-length integer into `delta`,
				// which gets added to `i`. The overflow checking is easier
				// if we increase `i` as we go, then subtract off its starting
				// value at the end to obtain `delta`.
				for (oldi = i, w = 1, k = base; /* no condition */; k += base) {
	
					if (index >= inputLength) {
						error('invalid-input');
					}
	
					digit = basicToDigit(input.charCodeAt(index++));
	
					if (digit >= base || digit > floor((maxInt - i) / w)) {
						error('overflow');
					}
	
					i += digit * w;
					t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
	
					if (digit < t) {
						break;
					}
	
					baseMinusT = base - t;
					if (w > floor(maxInt / baseMinusT)) {
						error('overflow');
					}
	
					w *= baseMinusT;
	
				}
	
				out = output.length + 1;
				bias = adapt(i - oldi, out, oldi == 0);
	
				// `i` was supposed to wrap around from `out` to `0`,
				// incrementing `n` each time, so we'll fix that now:
				if (floor(i / out) > maxInt - n) {
					error('overflow');
				}
	
				n += floor(i / out);
				i %= out;
	
				// Insert `n` at position `i` of the output
				output.splice(i++, 0, n);
	
			}
	
			return ucs2encode(output);
		}
	
		/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
		function encode(input) {
			var n,
			    delta,
			    handledCPCount,
			    basicLength,
			    bias,
			    j,
			    m,
			    q,
			    k,
			    t,
			    currentValue,
			    output = [],
			    /** `inputLength` will hold the number of code points in `input`. */
			    inputLength,
			    /** Cached calculation results */
			    handledCPCountPlusOne,
			    baseMinusT,
			    qMinusT;
	
			// Convert the input in UCS-2 to Unicode
			input = ucs2decode(input);
	
			// Cache the length
			inputLength = input.length;
	
			// Initialize the state
			n = initialN;
			delta = 0;
			bias = initialBias;
	
			// Handle the basic code points
			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue < 0x80) {
					output.push(stringFromCharCode(currentValue));
				}
			}
	
			handledCPCount = basicLength = output.length;
	
			// `handledCPCount` is the number of code points that have been handled;
			// `basicLength` is the number of basic code points.
	
			// Finish the basic string - if it is not empty - with a delimiter
			if (basicLength) {
				output.push(delimiter);
			}
	
			// Main encoding loop:
			while (handledCPCount < inputLength) {
	
				// All non-basic code points < n have been handled already. Find the next
				// larger one:
				for (m = maxInt, j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue >= n && currentValue < m) {
						m = currentValue;
					}
				}
	
				// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
				// but guard against overflow
				handledCPCountPlusOne = handledCPCount + 1;
				if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
					error('overflow');
				}
	
				delta += (m - n) * handledCPCountPlusOne;
				n = m;
	
				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];
	
					if (currentValue < n && ++delta > maxInt) {
						error('overflow');
					}
	
					if (currentValue == n) {
						// Represent delta as a generalized variable-length integer
						for (q = delta, k = base; /* no condition */; k += base) {
							t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
							if (q < t) {
								break;
							}
							qMinusT = q - t;
							baseMinusT = base - t;
							output.push(
								stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
							);
							q = floor(qMinusT / baseMinusT);
						}
	
						output.push(stringFromCharCode(digitToBasic(q, 0)));
						bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
						delta = 0;
						++handledCPCount;
					}
				}
	
				++delta;
				++n;
	
			}
			return output.join('');
		}
	
		/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
		function toUnicode(input) {
			return mapDomain(input, function(string) {
				return regexPunycode.test(string)
					? decode(string.slice(4).toLowerCase())
					: string;
			});
		}
	
		/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */
		function toASCII(input) {
			return mapDomain(input, function(string) {
				return regexNonASCII.test(string)
					? 'xn--' + encode(string)
					: string;
			});
		}
	
		/*--------------------------------------------------------------------------*/
	
		/** Define the public API */
		punycode = {
			/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
			'version': '1.3.2',
			/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
			'ucs2': {
				'decode': ucs2decode,
				'encode': ucs2encode
			},
			'decode': decode,
			'encode': encode,
			'toASCII': toASCII,
			'toUnicode': toUnicode
		};
	
		/** Expose `punycode` */
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return punycode;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (freeExports && freeModule) {
			if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = punycode;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (key in punycode) {
					punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.punycode = punycode;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(269)(module), (function() { return this; }())))

/***/ }),
/* 761 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  isString: function(arg) {
	    return typeof(arg) === 'string';
	  },
	  isObject: function(arg) {
	    return typeof(arg) === 'object' && arg !== null;
	  },
	  isNull: function(arg) {
	    return arg === null;
	  },
	  isNullOrUndefined: function(arg) {
	    return arg == null;
	  }
	};


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(763);
	exports.encode = exports.stringify = __webpack_require__(764);


/***/ }),
/* 763 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ }),
/* 764 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ }),
/* 765 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mapPageToTemplate = mapPageToTemplate;
	/**
	 * Map the page type to the template
	 * @param  {String} options.pageType Page type
	 * @param  {String} options.platform  web view platform
	 * @param  {String} options.sport    Sport
	 * @return {String|undefined} Handlebars template name
	 */
	function mapPageToTemplate(_ref) {
	  var pageType = _ref.pageType,
	      sport = _ref.sport,
	      _ref$platform = _ref.platform,
	      platform = _ref$platform === undefined ? '' : _ref$platform;
	
	  var webview = platform ? '-webview' + '-' + platform : '';
	  var map = {
	    scores: 'scoreboard',
	    scoreboard: 'scoreboard',
	    team: 'clubhouse',
	    standings: 'standings',
	    table: 'standings',
	    game: 'gamepackage',
	    scorecard: 'gamepackage',
	    recap: 'gamepackage',
	    report: 'gamepackage',
	    preview: 'gamepackage',
	    commentary: 'gamepackage',
	    statistics: 'gamepackage',
	    coverage: 'gamepackage',
	    video: 'gamepackage',
	    lineups: 'gamepackage',
	    matchstats: 'gamepackage',
	    playerstats: 'gamepackage',
	    conversation: 'gamepackage',
	    match: 'gamepackage',
	    hawkeye: 'gamepackage',
	    fixtures: 'schedule',
	    results: 'schedule',
	    schedule: 'schedule',
	    // Example: when standings are called tables
	    // or scoreboard is called scores
	    cricket: {
	      match: 'gamepackage',
	      table: 'standings'
	    }
	  };
	  var template = map[sport] && map[sport][pageType] || map[pageType];
	  return template ? template + webview : undefined;
	}
	
	exports.default = mapPageToTemplate;

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _requestHandler = __webpack_require__(767);
	
	var _requestHandler2 = _interopRequireDefault(_requestHandler);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  get: function get(url, opts) {
	    var duration = opts && opts.duration;
	    var cachePolicy = opts && opts.cachePolicy;
	
	    if (duration && !cachePolicy) {
	      cachePolicy = 'max-age=' + duration;
	    }
	
	    return (0, _requestHandler2.default)(url, {
	      cachePolicy: cachePolicy
	    });
	  }
	};

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var getRequestHandler = __webpack_require__(768);
	var httpConfig = __webpack_require__(423).http;
	var requestHandler = getRequestHandler({
	  config: httpConfig
	});
	
	module.exports = requestHandler;

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {var fitt = __webpack_require__(425),
	http = __webpack_require__(769),
	isBrowser = process.browser,
	empty = fitt.empty,
	MOCK_DATA = 'mock-data',
	PRODUCTION = 'production',
	MUST_REVALIDATE = 'no-cache, no-store, must-revalidate',
	MOCK = 'mock',
	READ = 'read',
	WRITE = 'write';
	
	
	function getRequestHandler(options)
	{
	    var config = options && options.config,
	    httpCollapsing = options && options.httpCollapsing || true,
	    mockDataDir = options && options.mockDataDir,
	    baseHttpConfig = getHttpConfig(config),
	    dataHandler,
	    requestHandler;
	
	    if (isBrowser) {
	        requestHandler = function (url, opts) {
	            var httpConfig = opts && opts.httpConfig || baseHttpConfig;
	
	            return http.get.call(http, url, httpConfig);
	        };
	    } else {
	
	        var Cache = __webpack_require__(788),
	        cache = void 0;
	
	        if (httpCollapsing) {
	            // require datahandler (server-only)
	            dataHandler = __webpack_require__(804);
	
	            // Initialize datahandler in the cluster/fork
	            dataHandler.initialize('api_message');
	        } else {
	            cache = new Cache();
	        }
	
	        requestHandler = function (url, opts) {
	            var cachePolicy = opts && opts.cachePolicy,
	            httpConfig = opts && opts.config || baseHttpConfig,
	            mockData = opts && opts.mockData,
	            ret;
	
	            httpConfig = httpConfig || baseHttpConfig;
	
	            if (!empty(mockData) && ("production") !== PRODUCTION) {
	                var Path = __webpack_require__(427),
	                dataParam = mockData && mockData.type,
	                resource = mockData && mockData.resource,
	                endpoint = mockData.endpoint || '',
	                mockfileName = mockData.fileName || '',
	                endpoints = endpoint.split(','),
	                fileNames = mockfileName.split(','),
	                resourceIdx = endpoints.indexOf(resource),
	                fileName = void 0;
	
	                mockDataDir = mockDataDir || Path.resolve(process.cwd(), MOCK_DATA);
	
	                if (resourceIdx > -1 && fileNames.length > resourceIdx) {
	
	                    // grab corresponding file name
	                    fileName = fileNames[resourceIdx];
	
	                    // if the provided endpoint matches the name of the resource currently being requested
	                    if (dataParam === MOCK || dataParam === READ) {
	
	                        url = Path.resolve(mockDataDir, fileName);
	                        cachePolicy = MUST_REVALIDATE;
	
	                        httpConfig =
	                        {
	                            dispatch: MOCK };
	
	
	                    } else if (dataParam === WRITE) {
	
	                        httpConfig =
	                        {
	                            writeResponse:
	                            {
	                                path: Path.resolve(mockDataDir, fileName) } };
	
	
	                    }
	                }
	            }
	
	            if (httpCollapsing) {
	                ret = dataHandler.makeRequest(url, cachePolicy, httpConfig);
	            } else {
	                ret = cache.getHttp(url, httpConfig, cachePolicy);
	            }
	
	            return ret;
	        };
	    }
	
	    return requestHandler;
	}
	
	function getHttpConfig(options)
	{
	    var httpConfig = options && options.config,
	
	    attempts,tracing,timeout,dnsTimeout,
	    serverTimeout,clientTimeout;
	
	    if (httpConfig) {
	        return httpConfig;
	    }
	
	    attempts = options && options.attempts || 2,
	    tracing = options && options.tracing || false,
	    timeout = options && options.timeout,
	    dnsTimeout = timeout && timeout.dns || 2000,
	    serverTimeout = timeout && timeout.server || 5000,
	    clientTimeout = timeout && timeout.client || 10000;
	
	    if (isBrowser) {
	
	        httpConfig =
	        {
	            attempts: attempts,
	            timeout: clientTimeout };
	
	
	    } else {
	
	        httpConfig =
	        {
	            headers:
	            {
	                'Accept-Encoding': 'gzip,deflate' },
	
	            timeout: serverTimeout,
	            dnsTimeout: dnsTimeout,
	            attempts: attempts,
	            tracing: tracing };
	
	
	    }
	
	    return httpConfig;
	}
	
	module.exports = getRequestHandler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	var TYPE_UNDEF = 'undefined',
	PROTO = 'prototype',
	fitt = __webpack_require__(425),
	fittForEach = fitt.forEach,
	cnum = fitt.cnum,
	cstr = fitt.cstr,
	mix = fitt.mix,
	strlc = fitt.strlc,
	idxOf = fitt.idxOf,
	keys = fitt.keys,
	subStr = fitt.subStr,
	fittDOM = __webpack_require__(770),
	fittDOMCreate = fittDOM.make,
	fittDOMAttr = fittDOM.attr,
	clsURL = __webpack_require__(773).URL,
	sendRequest = __webpack_require__(777),
	defaults = __webpack_require__(778),
	Canceler = __webpack_require__(787),
	debug = __webpack_require__(441)('fitt-http'),
	oFITTHTTP = null,
	
	CACHE_CONTROL_HEADER = 'cache-control',
	CACHE_CONTROL_HEADER_PROP = 'cacheControl',
	CACHE_CONTROL_HEADER_PROP_LC = strlc(CACHE_CONTROL_HEADER_PROP, true),
	MAX_AGE_SUB_HEADER = 'max-age',
	MAX_AGE_SUB_HEADER_PROP = 'maxAge',
	MAX_AGE_SUB_HEADER_PROP_LC = strlc(MAX_AGE_SUB_HEADER_PROP, true);
	
	/**
	                                                                    * Lightweight isomorphic HTTP requester<br><br>
	                                                                    *
	                                                                    * Config supports:<br>
	                                                                    * baseURL(instances)<br>
	                                                                    * request cancellation<br>
	                                                                    * request headers<br>
	                                                                    * timeout<br>
	                                                                    * response data transforms<br>
	                                                                    * success validation<br><br>
	                                                                    *
	                                                                    * Usage:<br>
	                                                                    * <pre>
	                                                                     	http.get('http://httpbin.org/get');
	                                                                     	var canceler = http.getCanceler();
	                                                                    	http.post('http://httpbin.org/post',
	                                                                    			{canceler: canceler, data: {key1: 'value1', key2: 'value2'}})
	                                                                     		.then(function(data) {
	                                                                     			console.log(data);
	                                                                    		})
	                                                                    		.catch(function(reason) {
	                                                                    			console.log(reason);
	                                                                    		});
	                                                                     	canceler.cancel('I changed my mind.');
	                                                                    * </pre>
	                                                                    *
	                                                                    * @class
	                                                                    * @name fitt.http
	                                                                    * @param {Object} defaultConfig Contains default configuration options
	                                                                    */
	
	function http(defaultConfig) {
	  this.defaults = defaultConfig ? mix({}, [defaults, defaultConfig]) : mix({}, defaults);
	}
	
	/**
	   * Main request method
	   *
	   * @name fitt.http#request
	   * @function
	   * @public
	   * @param {String} url The resource to request
	   * @param {Object} config The object containing all incoming config parameters
	   * @return {Promise}
	   */
	
	http[PROTO].request = function (url, config) {
	
	  var newURL, confBaseURL;
	
	  config = mix(config, [defaults, this.defaults, config], false, false, true, true);
	  confBaseURL = config.baseURL;
	
	  // Support baseURL config
	  if (confBaseURL && !clsURL.isAbsolute(url)) {
	    //input url is a path that's relative so treat it as such
	    newURL = new clsURL(confBaseURL, '', cstr(url));
	    if (!newURL.isValid()) {
	      throw new Error('Invalid URL input specified base:' + confBaseURL + ', input url:' + cstr(url));
	    }
	    url = cstr(newURL);
	  }
	
	  debug('request', url);
	
	  return sendRequest(url, config);
	};
	
	/**
	    * Returns a Canceler object to be used should you need to cancel a request
	    *
	    * @name fitt.http#getCanceler
	    * @function
	    * @public
	    * @return {Canceler}
	    */
	
	http[PROTO].getCanceler = function () {
	  return new Canceler();
	};
	
	/**
	    * Convenience methods for supported request types
	    *
	    * @name fitt.http#get
	    * @function
	    * @public
	    * @param {String} url The resource to request
	    * @param {Object} config The object containing all incoming config parameters
	    * @return {Promise}
	    */
	/**
	        * @name fitt.http#delete
	        * @function
	        * @public
	        * @param {String} url The resource to request
	        * @param {Object} config The object containing all incoming config parameters
	        * @return {Promise}
	        */
	/**
	            * @name fitt.http#head
	            * @function
	            * @public
	            * @param {String} url The resource to request
	            * @param {Object} config The object containing all incoming config parameters
	            * @return {Promise}
	            */
	/**
	                * @name fitt.http#post
	                * @function
	                * @public
	                * @param {String} url The resource to request
	                * @param {Object} data The object containing all key/value data pairs
	                * @param {Object} config The object containing all incoming config parameters
	                * @return {Promise}
	                */
	/**
	                    * @name fitt.http#put
	                    * @function
	                    * @public
	                    * @param {String} url The resource to request
	                    * @param {Object} data The object containing all key/value data pairs
	                    * @param {Object} config The object containing all incoming config parameters
	                    * @return {Promise}
	                    */
	/**
	                        * @name fitt.http#patch
	                        * @function
	                        * @public
	                        * @param {String} url The resource to request
	                        * @param {Object} data The object containing all key/value data pairs
	                        * @param {Object} config The object containing all incoming config parameters
	                        * @return {Promise}
	                        */
	
	// Provide aliases for supported request methods
	fittForEach(['delete', 'get', 'head'], function (method) {
	  http[PROTO][method] = function (url, config) {
	    return this.request(url, mix(config || {}, {
	      method: method }));
	
	  };
	});
	
	fittForEach(['post', 'put', 'patch'], function (method) {
	  http[PROTO][method] = function (url, data, config) {
	    return this.request(url, mix(config || {}, {
	      method: method,
	      data: data }));
	
	  };
	});
	
	
	/**
	     * Retrieve and insert a script into browser document
	     *
	     * @name fitt.http#script
	     * @function
	     * @public
	     * @param {String} url The script to request and execute
	     * @return {Promise}
	     */
	
	http[PROTO].script = function (url, attributes) {
	  return new Promise(function (resolve, reject) {
	    var oScpt = fittDOMCreate('script') || {};
	
	    fittForEach(attributes, function (value, name) {
	      fittDOMAttr(oScpt, name, value);
	    });
	
	    oScpt.onload = function () {
	      resolve();
	    };
	    oScpt.onerror = function (e) {
	      reject(e);
	    };
	
	    oScpt.src = url;
	
	    fittDOM.append(fittDOM.head(), oScpt);
	  });
	};
	
	/**
	    * Search a string or object (typically a representation of an HTTP header), for a 'max-age' cache control directive.
	    *
	    * @name fitt.http.parseMaxAge
	    * @function
	    * @param {Object|String} header  If input is a string, searches the string for max-age and returns that numeric value if available.
	    *								  If input is an object, it can be a 'headers' object from a standard http response, containing the
	    *								  keys mapping to each header entry, and their respective values, in which cache a 'cache-control' header
	    *								  is looked for and then max age is parsed from the value of that entry.  Altrenatively it could be an object
	    *								  of a header item itself, and in that case a 'max-age' property is looked for and it's numeric value is returned.
	    *								  In either case, the property names are normalized to lower case to avoid issues not finding the key in an object
	    * 								  or string that is formatted slightly different than standard.
	    *
	    * @param {Number} [defaultValue=0] Optionally allows you to pass a custom default value to be used in case a 'max-age' value cannot be found.
	    * @return {Number}
	   */
	
	function parseMaxAge(header, defaultValue)
	{
	  var headerType = header && typeof header || '',
	  strIndex = -1,
	  foundSomething = false,
	  breakLoop = false,
	  headerKeyIndex = 0,
	  headerKeyCount = 0,
	  subStrStart = 0,
	  ret,headerStr,headerKeys,headerKey,headerKeyLC,headerVal;
	
	  if (headerType) {
	    if (headerType === 'object') {
	      if (MAX_AGE_SUB_HEADER_PROP in header) {
	        /* look for [obj].maxAge */
	
	        ret = cnum(header[MAX_AGE_SUB_HEADER_PROP], 0, 0);
	        foundSomething = true;
	
	      } else if (MAX_AGE_SUB_HEADER_PROP_LC in header) {
	        /* look for [obj].maxage */
	
	        ret = cnum(header[MAX_AGE_SUB_HEADER_PROP_LC], 0, 0);
	        foundSomething = true;
	      } else if (MAX_AGE_SUB_HEADER in header) {
	        /* look for [obj]['max-age'] */
	
	        ret = cnum(header[MAX_AGE_SUB_HEADER], 0, 0);
	      } else if (CACHE_CONTROL_HEADER in header) {
	        /* look for [obj]['cache-control'] */
	
	        headerStr = header[CACHE_CONTROL_HEADER];
	        ret = parseMaxAge(headerStr, defaultValue);
	        foundSomething = true;
	      } else if (CACHE_CONTROL_HEADER_PROP in header) {
	        /* look for [obj]['cacheControl'], recurse down one level */
	
	        headerStr = header[CACHE_CONTROL_HEADER_PROP];
	        ret = parseMaxAge(headerStr, defaultValue);
	        foundSomething = true;
	      } else if (CACHE_CONTROL_HEADER_PROP_LC in header) {
	        /* look for [obj]['cachecontrol'], recurse down one level */
	
	        headerStr = header[CACHE_CONTROL_HEADER_PROP_LC];
	        ret = parseMaxAge(headerStr, defaultValue);
	        foundSomething = true;
	      } else {
	        /* nothing found, so either 'cache-control' or 'max-age' may be formatted with camel case
	               * or some other weirdness, so iterate over the keys of the object
	              */
	
	        headerKeys = keys(header);
	        headerKeyCount = headerKeys.length;
	        for (; headerKeyIndex < headerKeyCount; headerKeyIndex++)
	        {
	          headerKey = headerKeys[headerKeyIndex];
	          headerVal = header[headerKey];
	          headerKeyLC = strlc(headerKey, true);
	
	          switch (headerKeyLC) {
	
	            case MAX_AGE_SUB_HEADER:
	            case MAX_AGE_SUB_HEADER_PROP:
	            case MAX_AGE_SUB_HEADER_PROP_LC:
	              /* matches any of the same above formats for max-age */
	
	              ret = cnum(headerVal, 0, 0);
	              foundSomething = true;
	              breakLoop = true;
	              break;
	            case CACHE_CONTROL_HEADER:
	            case CACHE_CONTROL_HEADER_PROP:
	            case CACHE_CONTROL_HEADER_PROP_LC:
	              /* found a cache-control entry, so now recurse down one level
	                                                * and get max-age out of it
	                                               */
	
	              breakLoop = true;
	              ret = parseMaxAge(headerVal, defaultValue);
	              foundSomething = true;
	              break;}
	
	
	          if (breakLoop) {
	            break;
	          }
	        }
	      }
	    } else {
	      headerStr = strlc(header);
	      strIndex = idxOf(headerStr, MAX_AGE_SUB_HEADER + '=');
	      subStrStart = strIndex != -1 ? strIndex + MAX_AGE_SUB_HEADER.length + 1 : 0;
	
	      if (strIndex === -1) {
	        strIndex = idxOf(headerStr, MAX_AGE_SUB_HEADER + ':');
	        subStrStart = strIndex != -1 ? strIndex + MAX_AGE_SUB_HEADER.length + 1 : 0;
	      }
	
	      if (strIndex === -1) {
	        strIndex = idxOf(headerStr, MAX_AGE_SUB_HEADER_PROP_LC + '=');
	        subStrStart = strIndex != -1 ? strIndex + MAX_AGE_SUB_HEADER_PROP_LC.length + 1 : 0;
	      }
	
	      if (strIndex === -1) {
	        strIndex = idxOf(headerStr, MAX_AGE_SUB_HEADER_PROP_LC + ':');
	        subStrStart = strIndex != -1 ? strIndex + MAX_AGE_SUB_HEADER_PROP_LC.length + 1 : 0;
	      }
	
	      if (strIndex !== -1) {
	        ret = cnum(subStr(headerStr, subStrStart), false, 0);
	        if (ret !== false) {
	          foundSomething = true;
	        }
	      }
	    }
	  }
	
	  if (!foundSomething) {
	    defaultValue = cnum(defaultValue, 0, 0);
	    ret = defaultValue;
	  }
	
	  return ret;
	}
	
	/* no need to document parseMaxAge function as it's documented
	   * in the file itself
	  */
	
	http[PROTO].parseMaxAge = parseMaxAge;
	
	oFITTHTTP = new http();
	
	if (typeof module !== TYPE_UNDEF) {
	  module.exports = oFITTHTTP;
	}
	
	fitt.ns("fitt.http", oFITTHTTP);

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	if (true) {
	    module.exports = __webpack_require__(771);
	}

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	
	
	var TRUE = true,
	FALSE = false,
	PROTO = "prototype",
	TYPE_UNDEF = "undefined",
	NEG_ONE = -1,
	NULL = null,
	DOC_NODE_TYPE = 9,
	EL_NODE_TYPE = 1,
	LEN = "length",
	DOC = "document",
	DOC_EL = DOC + "Element",
	CLASS_NAME = "className",
	SCROLL_TO = "scrollTo",
	BODY = "body",
	
	BACK_COMPAT = "BackCompat",
	SCROLL = "scroll",
	OVER = "overflow",
	PAR_NODE = "parentNode",
	OFFSET = "offset",
	OFF_PAR = OFFSET + "Parent",
	OFF_TOP = OFFSET + "Top",
	OFF_LEFT = OFFSET + "Left",
	OFSW = OFFSET + "Width",
	OFSH = OFFSET + "Height",
	CLW = "clientWidth",
	CLH = "clientHeight",
	SCRW = SCROLL + "Width",
	SCRH = SCROLL + "Height",
	SCRT = SCROLL + "Top",
	SCRL = SCROLL + "Left",
	
	fitt = __webpack_require__(425),
	rtrue = fitt.rtrue,
	rfalse = fitt.rfalse,
	getWindow = fitt.getGlobal,
	ParamHash = __webpack_require__(772),
	FittURL = __webpack_require__(773),
	UA = __webpack_require__(776),
	ieVer = UA && UA.ie || 0,
	wbVer = UA && UA.webkit || 0,
	geckVer = UA && UA.gecko || 0,
	iosVer = UA && UA.ios || 0,
	
	exp = {},
	
	cstr = fitt.cstr,
	strlc = fitt.strlc,
	cnum = fitt.cnum,
	rxp = fitt.regx,
	rxSearch = fitt.regxSearch,
	rxTest = fitt.test,
	callSafe = fitt.callSafe,
	operaVer = UA.opera,
	nativeMax = Math.max;
	
	/**
	                       * Singleton class used for holding general HTML DOM manipulation. Uses shorter names,and provides small amount of cross-browser functionality and/or type safety.
	                       * @name fitt.dom
	                       * @namespace
	                      */
	
	/**
	                          * Get the node type of a given node/HTML element.
	                          * See <a href="https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType" target="_blank">MDN</a> for
	                          * the list of values that a returned if the given 1st argument is truly a dom node of some type.
	                          * If the 1st argument is not a valid node, or any other issue occurs, -1 is returned.
	                          *
	                          * @name fitt.dom.nodeType
	                          * @function
	                          * @static
	                          * @param {HTMLElement|Node|Document|DocumentFragment} el
	                          * @param {Boolean} [unsafe=false] If you know for sure the 1st argument is a node, passing true will force the function to not use a try / catch block which
	                          *                                 slightly improves performance.
	                          * @return {Number}
	                         */
	
	function nodeType(el)
	{
	  var n_type;
	
	  try {
	    n_type = cnum(el && el.nodeType, NEG_ONE);
	  } catch (e) {
	    n_type = NEG_ONE;
	  }
	  return n_type;
	}
	
	/**
	   * Get a reference to an HTMLDocument, either the current document you are in, or if you pass
	   * a dom reference in of some type the document for that given reference is returned (which may or may not be the same).
	   * Returns null if no document is found, or if an invalid dom reference is passed in for the first argument.
	   *
	   * @name fitt.dom.doc
	   * @function
	   * @static
	   * @param {HTMLElement|Node|Document|DocumentFragment|Window} [el=null]
	   * @return {HTMLDocument|null}
	  */
	
	function doc(el)
	{
	  var win = getWindow(),d = NULL,n_type;
	
	  if (!arguments[LEN]) {
	    d = win && win[DOC] || NULL;
	  } else {
	    n_type = nodeType(el);
	    if (n_type === DOC_NODE_TYPE) {
	      d = el;
	    } else {
	      try {
	        d = el[DOC] || el.ownerDocument || NULL;
	      } catch (e) {
	        d = NULL;
	      }
	    }
	  }
	  return d;
	}
	
	
	/**
	   * Get or set the current location of the page loaded in the web browser.
	   * Function is assumed to be run in a browser (in fact all the functions in this
	   * package are assuming that though they are save to run in other environments).
	   * If no arguments are passed, it is assumed you just want to read the current
	   * page URL and this function is essentially an alias for {@link fitt.URL.loc()}.
	   *
	   * If you pass any arguments it is assumed you want to set the location, a boolean
	   * is returned to indicate the set was successful or not. It can fail if you
	   * ran this function somewhere other than a browser or in scenarios where
	   * security measures of the browser prevent you from setting the location.
	   * Setting the location triggers an async navigation to occur.
	   *
	   * @name fitt.dom.loc
	   * @function
	   * @public
	   * @param {String|fitt.URL} [newURL=''] A new URL to be set. If you pass any argument here it is assumed you want to reload the window/document with the given URL.
	   *                                      If the URL passed in is invalid or empty, this will trigger a reload on the curent page.
	   * @param {Boolean} [doReplace=false] Replace the current history entry with the given URL. Not relavent if the first argument is an invalid URL of some kind.
	   * @return {fitt.URL|Boolean}
	  */
	function loc(newURL, doReplace) {
	
	  var argCnt = arguments.length,
	  doReload = FALSE,
	  ret,win,loc;
	
	  if (argCnt) {
	    if (!newURL) {
	      doReload = true;
	    } else if (typeof newURL !== 'string') {
	      if (newURL instanceof FittURL) {
	        newURL = cstr(newURL);
	        if (!newURL) {
	          doReload = TRUE;
	        }
	      } else {
	        newURL = cstr(newURL);
	        newURL = new FittURL(newURL);
	        newURL = cstr(newURL);
	        if (!newURL) {
	          doReload = TRUE;
	        }
	      }
	    }
	    win = getWindow();
	    try {
	      loc = win && win.location;
	    } catch (e) {
	      loc = NULL;
	    }
	    if (loc) {
	      if (doReload) {
	        loc.reload(TRUE);
	      } else if (doReplace) {
	        loc.replace(newURL);
	      } else {
	        loc.href = newURL;
	      }
	      ret = true;
	    } else {
	      ret = false;
	    }
	  } else {
	    ret = FittURL.loc() || false;
	  }
	
	  return ret;
	}
	
	
	/**
	  * Retrieve the host window object for a given HTML Element. Note that this is NOT the same as {@link fitt.dom.iframes.view}, which
	  * returns the window reference INSIDE the IFRAME element.
	  *
	  * @name fitt.dom.view
	  * @public
	  * @function
	  * @param {HTMLElement} [el=null] the HTML element for which you wish to find it's parent window, if not specified, or is falsy,
	  *                                returns the main window in which this code is running.
	  * @return {Document|null} null if nothing found
	  *
	  */
	
	function view(el)
	{
	  var elWin = NULL,
	  IE_WIN_PROP = "parentWindow",
	  W3C_WIN_PROP = "defaultView",
	  d;
	
	  try {
	    if (el) {
	      elWin = el[IE_WIN_PROP] || el[W3C_WIN_PROP] || NULL;
	      if (!elWin) {
	        d = doc(el);
	        elWin = d && (d[IE_WIN_PROP] || d[W3C_WIN_PROP]) || NULL;
	      }
	    } else {
	      elWin = getWindow();
	    }
	  } catch (e) {
	    elWin = NULL;
	  }
	  return elWin;
	}
	
	/**
	   * Wrapper for document.getElementById, also allowing you to pass in a
	   * reference node, window, document from which to get the element by
	   * id in cases of reaching across frames / windows.
	   *
	   * @name fitt.dom.elt
	   * @function
	   * @static
	   * @param {String} id The id of the element to search for
	   * @param {HTMLElement|Node|Document|DocumentFragment|Window} [otherWin=null] A DOM reference in another window to get the correct document to use
	   * @return {HTMLElement|null}
	  */
	
	function elt(id, otherWin)
	{
	  var args = arguments,len = args[LEN],dc,ret = NULL;
	
	  if (len > 1) {
	    dc = doc(args[1]);
	  } else {
	    dc = doc();
	  }
	  try {
	    ret = id && dc.getElementById(id) || NULL;
	  } catch (e) {
	    ret = NULL;
	  }
	  return ret;
	}
	
	
	/**
	   * Wrapper for document.querySelectorAll/querySelector, also allowing you to pass in a
	   * reference node, window, document from which to get the element by
	   * id in cases of reaching across frames / windows.
	   *
	   * @name fitt.dom.qsa
	   * @function
	   * @static
	   * @param {String} sel The CSS selector to use to find a given element
	   * @param {Boolean} [firstOne=false] If true, return a NodeList for the given selector, rather than only the 1st item found.
	   * @param {HTMLElement|Node|Document|DocumentFragment|Window} [otherWin=null] A DOM reference in another window, document, or element to use a the parent for the call
	   * @return {NodeList|HTMLElement|null}
	  */
	
	function qsa(sel, firstOne, otherWin)
	{
	  var args = arguments,len = args[LEN],dc,useNode,ret = NULL;
	
	  if (len > 2) {
	    useNode = args[2];
	    if (isElement(useNode)) {
	      dc = useNode;
	    } else {
	      dc = doc(useNode);
	    }
	  } else {
	    dc = doc();
	  }
	
	  try {
	    ret = sel && dc.querySelectorAll(sel) || NULL;
	  } catch (e) {
	    ret = NULL;
	  }
	  if (ret && firstOne && ret[LEN]) {
	    ret = ret[0];
	  }
	
	  return ret;
	
	}
	
	/**
	  * A wrapper around retrieving a list of tags by name.
	  *
	  * @name fitt.dom.tags
	  * @public
	  * @function
	  * @param {String} name The name of the tags that you wish to look for, note that you can pass in "*" to find all.
	  * @param {HTMLElement|Document} parNode (Optional) the parent node that you wish to look in, defaults to the current main document where this code runs.
	  * @param {Boolean|String} [use_class_name=false] If boolean true is used, use the name argument as if it were a CSS class name rather than a tag name.
	  *												  If a string is used, you can do a search on both tag name and CSS class name.
	  * @return {HTMLElementCollection} List of tags found. Note that is NOT a real JavaScript Array
	  *
	  */
	
	function tags(name, parNode, use_class_name)
	{
	  var ret = [],method = "getElementsByTagName",method_2 = "getElementsByClassName",
	  tag_list,tag,tag_cnt,idx,match_ex = NULL;
	
	  try {
	    if (!parNode) parNode = doc();
	
	    if (parNode) {
	      if (use_class_name) {
	        if (typeof use_class_name == "string") {
	          if (parNode[method_2]) {
	            tag_list = parNode[method_2](use_class_name);
	            tag_cnt = tag_list && tag_list[LEN];
	            idx = 0;
	            if (tag_cnt) {
	              /* eslint-disable no-cond-assign */
	              while (tag = tag_list[idx++]) {
	                if (tagName(tag) == name) {
	                  ret.push(tag);
	                }
	              }
	              /* eslint-enable no-cond-assign */
	            }
	          } else if (parNode[method]) {
	            tag_list = parNode[method](name);
	            tag_cnt = tag_list && tag_list[LEN];
	            idx = 0;
	            match_ex = name ? new rxp('(?:^|\\s+)' + use_class_name + '(?:\\s+|$)') : NULL;
	            if (tag_cnt && match_ex) {
	              /* eslint-disable no-cond-assign */
	              while (tag = tag_list[idx++]) {
	                if (rxSearch(match_ex, tag[CLASS_NAME]) != -1) {
	                  ret.push(tag);
	                }
	              }
	              /* eslint-enable no-cond-assign */
	            }
	          }
	        } else {
	          if (parNode[method_2]) {
	            ret = parNode[method_2](name);
	          } else if (parNode[method]) {
	            tag_list = parNode[method]("*");
	            tag_cnt = tag_list && tag_list[LEN];
	            idx = 0;
	            match_ex = name ? new rxp('(?:^|\\s+)' + name + '(?:\\s+|$)') : NULL;
	            if (tag_cnt && match_ex) {
	              /* eslint-disable no-cond-assign */
	              while (tag = tag_list[idx++]) {
	                if (rxSearch(match_ex, tag[CLASS_NAME]) != -1) {
	                  ret.push(tag);
	                }
	              }
	              /* eslint-enable no-cond-assign */
	            }
	          }
	        }
	      } else if (parNode[method]) {
	        ret = parNode[method](name);
	      }
	    }
	  } catch (e) {
	    ret = [];
	  }
	  return ret;
	}
	
	/**
	   * Return whether or not the given reference is an HTMLElement
	   *
	   * @name fitt.dom.isElement
	   * @function
	   * @public
	   * @param {HTMLElement} el
	   * @return {Boolean}
	  */
	
	
	function isElement(el) {return nodeType(el) === EL_NODE_TYPE;}
	
	/**
	                                                               * Retrieve/Set/Delete an element's attribute. Note that this handle's
	                                                               * slight differences in the way HTML attributes are handled across browsers
	                                                               * as well as being shorthand
	                                                               *
	                                                               * @name fitt.dom.attr
	                                                               * @public
	                                                               * @function
	                                                               * @param {HTMLElement} el (Required) the HTML element to manipulate
	                                                               * @param {String} attrName (Required) the attribute to set/get
	                                                               * @param {String} [attrVal=void], if specified will set the value of the attribute for this element.  Passing null will remove the attribute completely
	                                                               * @return {String} the value of the attribute normalized to a string (may be empty)
	                                                               */
	
	function attr(el, attrName, attrVal)
	{
	  var retVal = '';
	
	
	  attrName = cstr(attrName);
	  if (!attrName) return retVal;
	
	  if (arguments[LEN] > 2) {
	    try {
	      if (attrVal === NULL) {
	        el.removeAttribute(attrName);
	      } else {
	        attrVal = cstr(attrVal);
	        if (strlc(attrName) == "class") {
	          el[CLASS_NAME] = attrVal;
	        } else {
	          el.setAttribute(attrName, attrVal);
	        }
	      }
	    } catch (e) {}
	  }
	
	  retVal = cstr(el.getAttribute(attrName));
	
	  return retVal;
	}
	
	/**
	  * A wrapper method for removing elements from a document rather than calling parentNode.removeChild raw.
	  * Silences any errors that might occur.
	  *
	  * @name fitt.dom.purge
	  * @public
	  * @function
	  * @param {HTMLElement} node The HTML element to be removed from the dom
	  * @return {Boolean} Whether or not the element was successfully removed
	  *
	  */
	
	function purge(node)
	{
	  var success = FALSE,parNode;
	
	  try {
	    parNode = par(node);
	    if (parNode) {
	      parNode.removeChild(node);
	      success = TRUE;
	    }
	  } catch (e) {}
	
	  node = parNode = NULL;
	  return success;
	}
	
	/**
	   * A wrapper for replacing elements from a document rather than calling [parentElement|parentNode].removeChild
	   * raw, preventing unintended errors and returning true/false if successfull
	   *
	   * @name fitt.dom.swap
	   * @function
	   * @public
	   * @param {HTMLElement} oldNode The node to be replaced / removed
	   * @param {HTMLElement} [newNode=null] The replacement (can be null)
	   * @return {Boolean}
	  */
	
	function swap(oldNode, newNode)
	{
	  var success = FALSE,parNode;
	  try {
	    parNode = par(oldNode);
	    if (parNode) {
	      parNode.replaceChild(newNode, oldNode);
	      success = TRUE;
	    }
	  } catch (e) {}
	
	  oldNode = newNode = parNode = NULL;
	  return success;
	
	}
	
	/**
	  * Append and HTMLElement to another HTMLElement
	  *
	  * @name fitt.dom.append
	  * @public
	  * @function
	  * @param {HTMLElement} parNode (Required) the HTML element to manipulate
	  * @param {HTMLElement} child (Required) the new HTML element to add to the parent
	  * return {HTMLElement|null} the new reference to the child element that was appended, or null if failure
	  *
	  */
	
	function append(parNode, child)
	{
	  var ret = NULL;
	  try {
	    ret = parNode.appendChild(child);
	  } catch (e) {
	    ret = NULL;
	  }
	
	  return ret;
	}
	
	/**
	   * Retrive the parent element of an HTML element
	   *
	   * @name fitt.dom.par
	   * @public
	   * @function
	   * @param {HTMLElement} el (Required) the HTML element to check
	   * return {HTMLElement} the new reference to the parent element or null if there is an error or the element has no parent
	   *
	  */
	function par(el)
	{
	  var ret = NULL;
	  try {
	    ret = el && (el.parentNode || el.parentElement) || NULL;
	  } catch (e) {
	    ret = NULL;
	  }
	  return ret;
	}
	
	/*
	   * Detect if a given CSS selector can be used to find / match the given node
	   *
	   * @name fitt.dom.matches
	   * @public
	   * @function
	   * @param {String} sel (Required) CSS selector string
	   * @param {HTMLElement} tgt (Required) the node
	   * @return {Boolean}
	  */
	
	function matches(sel, tgt) {
	
	  var idx = 0,
	  result = false,
	  matchResults,matchResult;
	
	  sel = cstr(sel);
	
	  if (isElement(tgt) && sel) {
	    matchResults = qsa(sel, false, view(tgt)) || [];
	    while (matchResult = matchResults[idx++]) {
	      if (matchResult === tgt) {
	        result = true;
	        break;
	      }
	    }
	  }
	
	  return result;
	}
	
	
	/**
	   * Find an ancestor / parent node of the current node with a given
	   * node/element name
	   *
	   * @name fitt.dom.closest
	   * @public
	   * @function
	   * @param {HTMLElement} target (Required) the HTML element to check
	   * @param {string} nodeName (Required) the name of the parent node to check
	   * @param {Object} [opts=null] Additional options for the function
	   * @param {String} [opts.strType='name'] The string passed as a 2nd argument is treated as a 'nodeName' by default. Pass 'css' to treat the string
	   *                                       as a selector.
	   * return {HTMLElement|Null} the new reference to the closest parent element that has nodeName if nothing found or invalid arguments passed in
	   *
	  */
	
	function closest(target, nodeName, opts)
	{
	  var tgtPath = cstr(target && target.path),
	  path = tgtPath || buildPath(target), // safari/firefox don't support path property
	  i = 0,
	  retNode = null,
	  pathNode;
	
	  if (!opts) opts = {};
	
	  if (nodeName) {
	    if (opts.strType === 'css') {
	      if (!matches(nodeName, target)) {
	        while (pathNode = path[++i]) {
	          if (matches(nodeName, pathNode)) {
	            retNode = pathNode;
	            break;
	          }
	        }
	      }
	    } else {
	      if (target && tagName(target, TRUE) !== nodeName) {
	        while (pathNode = path[++i]) {
	          if (tagName(pathNode, TRUE) === nodeName) {
	            retNode = pathNode;
	            break;
	          }
	        }
	      }
	    }
	  }
	  return retNode;
	}
	
	/**
	   * Retrive a path to the given element from ancestor elements.
	   * By default returns items in an ordered array, but can also be used
	   * to return a string for XPath or CSS Selectors.
	   *
	   * @name fitt.dom.buildPath
	   * @public
	   * @function
	   * @param {HTMLElement} elem (Required) the HTML element to check
	   * @param {Object} [opts] Optional configuration for the function
	   * @param {String} [opts.retType='node'] Valid values, 'node' or 'string'. Defaults to 'node' and returns an array of elements.
	   *                                When set to string the path is returned as a string.
	   * @param {String} [opts.strType='xpath']  Valid values, 'xpath', or 'css'. Defaults to 'xpath'
	   * return {array} array of build path for the element
	   *
	  */
	function buildPath(elem, opts) {
	
	  var pathArray = [],
	  output = pathArray,
	  parNode;
	
	  if (!opts) opts = {};
	
	  if (isElement(elem)) {
	    if (opts.retType === 'string') {
	      pathArray.push(tagName(elem, TRUE));
	      while (parNode = par(elem)) {
	        if (!isElement(parNode)) break;
	
	        pathArray.push(tagName(parNode, TRUE));
	        elem = parNode;
	      }
	
	      pathArray = pathArray.reverse();
	
	      if (opts.strType === 'css') {
	        output = pathArray.join(' > ');
	      } else {
	        pathArray.unshift('');
	        output = pathArray.join('/');
	      }
	    } else {
	      pathArray.push(elem);
	
	      while (parNode = par(elem)) {
	        if (!isElement(parNode)) break;
	
	        pathArray.push(parNode);
	        elem = parNode;
	      }
	    }
	  } else {
	    if (opts.retType === 'string') {
	      output = '';
	    }
	  }
	
	  return output;
	}
	
	/**
	  * Checks to see if an element is contained within another element
	  *
	  * @name fitt.dom.contains
	  * @public
	  * @function
	  * @param {HTMLElement} element The HTML element in which you wish to search
	  * @param {HTMLElement} needle The HTML element being looked for
	  * @return {Boolean} True/false whether needle is within element
	  *
	  */
	
	function contains(element, needle)
	{
	  var ret = FALSE,
	  el_node_type = nodeType(element),
	  needle_node_type = nodeType(needle),
	  elDoc = doc(element),
	  elDocEl = elDoc && elDoc[DOC_EL],
	  elDocBody = elDoc && elDoc[BODY],
	  CONTAINS = "contains",
	  COMPARE_DOC_POS = "compareDocumentPosition";
	
	  if (el_node_type == EL_NODE_TYPE && needle_node_type != NEG_ONE && elDoc && elDocEl && elDocBody) {
	    if (element[CONTAINS]) {
	      if (operaVer || needle_node_type == EL_NODE_TYPE) {
	        try {
	          ret = element[CONTAINS](needle);
	        } catch (e) {
	          ret = FALSE;
	        }
	      } else {
	        while (needle)
	        {
	          if (element === needle) {
	            ret = TRUE;
	            break;
	          }
	          needle = par(needle);
	          if (needle === elDocEl || needle === elDocBody) break;
	        }
	      }
	    } else if (element[COMPARE_DOC_POS]) {
	      try {
	        ret = element === needle || !!(element[COMPARE_DOC_POS](needle) & 16);
	      } catch (e) {
	        ret = FALSE;
	      }
	    }
	  }
	  return ret;
	}
	
	/**
	  * Check whether or not a given element is actually rendered in the document.
	  *
	  * @name fitt.dom.inDoc
	  * @public
	  * @function
	  * @param {HTMLElement} el (Required) the HTML element to check
	  * @param {Document} [doc=null] (Optional), the document to check within, if not passed in document associated with this class is used
	  * @return {Boolean} true/false whether element is in given document
	  *
	  */
	
	function inDoc(el, arg_doc)
	{
	  if (arguments[LEN] > 1) {
	    arg_doc = doc(el);
	  } else {
	    arg_doc = doc();
	  }
	  return arg_doc && el && contains(arg_doc[DOC_EL], el);
	}
	
	/**
	  * Retrieve the element associated as the root of a document
	  * depending on the current mode of the page, returns either the document.documentElement
	  * or document.body properties
	  *
	  * @name fitt.dom.docNode
	  * @public
	  * @function
	  * @param {HTMLElement|HTMLWindow|HTMLDocument} el The element for which to look for the doc, if invalid, document where this class runs is assumed
	  * @return {HTMLElement|null} The document root element or null if not found
	  *
	  */
	
	function docNode(el)
	{
	  var d = el && doc(el) || doc(),
	  compatMode = d && d.compatMode,
	  root = d && d[DOC_EL] || NULL;
	
	  if (compatMode && !operaVer && compatMode != 'CSS1Compat')
	  root = d && d[BODY] || NULL;
	
	  return root;
	}
	
	/**
	  * Retrieve the head element associated of an HTML document
	  *
	  * @name fitt.dom.head
	  * @public
	  * @function
	  * @param {HTMLElement|HTMLWindow|HTMLDocument} [el=null] An element, window, document, reference to use as an alternative to current global document object
	  * @return {HTMLElement|null} The document head element or null if not found
	  *
	  */
	
	function head(el)
	{
	  var d = el && doc(el) || doc(),
	  hd = NULL;
	
	  try {
	    hd = d && d.head || tags('head', el)[0] || NULL;
	  } catch (e) {
	    hd = NULL;
	  }
	
	  return hd;
	}
	
	/**
	   * Create an element
	   *
	   * @name fitt.dom.make
	   * @public
	   * @function
	   * @param {String} [tagName='div'] The name of the tag to create.
	   * @param {HTMLElement|Node|Document|DocumentFragment|Window} [otherWin=null] A DOM reference in another window to get the correct document to use
	   * @return {HTMLElement} A new element
	  */
	
	
	function make(tname, pe)
	{
	  var d;
	
	  tname = cstr(tname) || 'div';
	  d = pe && doc(pe) || doc();
	
	  return d.createElement(tname);
	}
	
	/**
	   * A wrapper around retrieving the tagName of an HTML element (normalizes values to lower case strings).
	   *
	   * @name fitt.dom.tagName
	   * @public
	   * @function
	   * @param {HTMLElement} el The HTML element for which to get the tag name.
	   * @return {String} The tag name in all lower case of an HTML element, if it cannot be successfully retrieved, alwasys returns an empty string (which will evaluate to FALSE).
	   *
	  */
	
	function tagName(el, isel)
	{
	  return (isel || isElement(el)) && strlc(el.tagName) || "";
	}
	
	/**
	  * Get the inner text of an element.  If element is a script / style blockw with a "text" property, that is used,
	  * otherwise innerText/textContent are used
	  *
	  * @name fitt.dom.txt
	  * @public
	  * @function
	  * @param {HTMLElement} el The HTML element to read text content from
	  * @return {String} The text content
	  *
	  */
	function txt(el) {return el && (el.text || el.innerText || el.textContent) || "";}
	
	/**
	                                                                                   * Set/Get the CSS text of an HTML element, note that if you are just doing a get
	                                                                                   * of a CSS value, this only reads from the style object of an element, and DOES not
	                                                                                   * include style rules set from style sheets or inheritence.
	                                                                                   *
	                                                                                   * @name fitt.dom.css
	                                                                                   * @public
	                                                                                   * @function
	                                                                                   * @param {HTMLElement} el (Required) the HTML element to manipulate
	                                                                                   * @param {String|Object} val (Optional) the CSS string to set if specified (e.g. "background-color:transparent;position:absolute;top:0px;left:0px").
	                                                                                   *                                       You may also specify an object with keys that are the css property names and their corresponding values.
	                                                                                   *                                       Note that you must use CSS property names. For example {"background-color": "blue"}, rather than camel-case.
	                                                                                   * @return {String} the value of the attribute normalized to a string (may be empty)
	                                                                                   */
	
	function css(el, val)
	{
	  var st;
	  try {
	    st = el.style;
	
	    if (arguments[LEN] > 1) {
	      if (typeof val === "object" && val) {
	        if (!(val instanceof ParamHash)) {
	          val = new ParamHash(val, ";", ":", TRUE, FALSE, TRUE);
	          val = val.toString(";", ":", FALSE, TRUE);
	        }
	      } else {
	        st.cssText = cstr(val);
	      }
	    } else {
	      val = st.cssText;
	    }
	  } catch (e) {
	    val = "";
	  }
	  return val;
	}
	
	/**
	   * Get the current style object or an attribute
	   * of the current style on an HTMLElement using W3C methods
	   *
	   * @name fitt.dom.currentStyle
	   * @public
	   * @function
	   * @param {HTMLElement} el The element to get style info from
	   * @param {String} [attr] The style attribute (in JS format of camel-case, not with dashes) to get a value of
	   * @param {String} [psuedoClass]
	   * @return {Object|String} The current style object or a string value of the style attribute. Returns empty string or NULL on failure.
	  */
	
	function currentStyle(el, attr, psuedoClass)
	{
	  var st,val = "";
	  try {
	    st = view(el).getComputedStyle(el, cstr(psuedoClass) || NULL);
	  } catch (e) {
	    st = NULL;
	  }
	
	  if (arguments[LEN] > 1 && attr && st) {
	    try {
	      val = st[attr];
	    } catch (e) {
	      val = "";
	    }
	  } else {
	    val = st;
	  }
	  return val;
	}
	
	/**
	   * Create a non-visible Image object used for pre-caching or firing HTTP beacons.
	   * (Note that no validation of the src URI occurs).
	   *
	   * @name fitt.dom.img
	   * @public
	   * @function
	   * @param {String} src The URI to set for the Image object
	   * @return {Image} a new Image object
	   *
	  */
	
	function img(src, f_onload, f_onerr)
	{
	  var o = new Image();
	
	  function HANDLE_imgEvents()
	  {
	    callSafe(f_onload, o);
	    callSafe(f_onerr, o);
	    o.onload = o.onerror = NULL;
	    f_onload = f_onerr = o = NULL;
	  }
	  o.onload =
	  o.onerror = HANDLE_imgEvents;
	  o.src = src;
	  return o;
	}
	
	
	/**
	   * Attach an event handler to an HTMLElement
	   *
	   * @name fitt.dom.attach
	   * @public
	   * @function
	   * @param {HTMLElement} el the HTML element to attach an event handler too
	   * @param {String} name  the name of the event to listen too
	   * @param {Function} cb  the function used to handle the particular event
	   *
	  */
	
	function attach(obj, name, cb, do_capture)
	{
	  var bOK = FALSE,call_inf = {};
	
	  do_capture = do_capture || FALSE;
	
	  callSafe(obj && obj.addEventListener, obj, call_inf, name, cb, do_capture);
	
	  if (!call_inf.err) bOK = TRUE;
	
	  obj = cb = NULL;
	  return bOK;
	}
	
	/**
	   * Detach an event handler to an HTMLElement
	   *
	   * @name fitt.dom.detach
	   * @public
	   * @function
	   * @param {HTMLElement} el the HTML element to attach an event handler too
	   * @param {String} name the name of the event to listen too
	   * @param {Function} cb the function used to handle the particular event
	   *
	  */
	
	function detach(obj, name, cb, do_capture)
	{
	  var bOK = FALSE,call_inf = {};
	
	  do_capture = do_capture || FALSE;
	
	  callSafe(obj && obj.removeEventListener, obj, call_inf, name, cb, do_capture);
	
	  if (!call_inf.err) bOK = TRUE;
	
	  obj = cb = NULL;
	  return bOK;
	}
	
	/**
	   *
	   * Wrapper to get the target / src element of a given event object
	   * that is passed to event handler functions in the dom.
	   *
	   * @name fitt.dom.evtTgt
	   * @public
	   * @function
	   * @param {Event} evt The event object
	   * @return {HTMLElement|Document|Window|null} target object for the event if available, otherwise null
	  */
	
	function evtTgt(evt)
	{
	  var tgt = NULL;
	
	  try {
	    tgt = evt && (evt.target || evt.srcElement) || NULL;
	  } catch (e) {
	    tgt = NULL;
	  }
	
	  return tgt;
	}
	
	/**
	   * Calls DOM event supported cancellation methods, called
	   * from {@link fitt.dom.evtCancel}.
	   *
	   * @name @fitt.dom-evtCanceller
	   * @private
	   * @function
	   * @param {DOMEvent} evt The dom event to be cancelled
	   *
	  */
	function evtCanceller() {}
	
	evtCanceller = function () {
	  var win = getWindow(),
	  doc = win && win[DOC],
	  evt_create = "createEvent",
	  evt_type = "UIEvent",
	  evtCancelMethods =
	  {
	    "preventDefault": 0,
	    "stopImmediatePropagation": 0,
	    "stopPropagation": 0,
	    "preventBubble": 0 },
	
	  prop,bufferFunc,helperFunc,evt;
	
	  evt = callSafe(doc && doc[evt_create], doc, NULL, evt_type);
	  evt = evt || callSafe(doc && doc[evt_create], doc, NULL, evt_type + 's');
	
	  if (evt) {
	    bufferFunc = ['function evtCanceller(evt) {\n'];
	
	    for (prop in evtCancelMethods) {
	      if (evt[prop]) {
	
	        bufferFunc.push('try { evt.', prop, '(); } catch (e) {}\n');
	      }
	    }
	
	    bufferFunc.push('return false; \n }\n return evtCanceller;');
	
	    helperFunc = fitt.func(cstr(bufferFunc));
	    return helperFunc();
	  }
	}() || evtCanceller;
	
	/**
	                      * Cancel DOM event all further bubbling / propagation and prevent the default
	                      * actions
	                      *
	                      * @name fitt.dom.evtCancel
	                      * @function
	                      * @public
	                      * @param {DOMEvent} evt The dom event object
	                      * @param {Boolean} [retTrue=false] Whether to return true or false after cancellation. For most event handling function, returning true will act as a cancellation
	                      *                                  but some handler function (namely onerror events) must return true.
	                      * @return {Boolean}
	                     */
	
	function evtCancel(evt, retTrue) {
	
	  if (evt) {
	    /* old school ie, cancel event and bubble
	               however we also use this for when event handling overrides
	               take place so that we can cancel things */
	    try {
	      evt.returnValue = FALSE;
	    } catch (e) {}
	    try {
	      evt.cancelBubble = TRUE;
	    } catch (e) {}
	
	    /*
	                    * custom to denote cancellation occured
	                   */
	    try {
	      evt.stopped = TRUE;
	    } catch (e) {}
	
	    /*
	                    * function is generated at startup, checking the environment
	                    * for supported known cancelation methods, and calls them all
	                   */
	
	    evtCanceller(evt);
	  }
	
	  return retTrue ? TRUE : FALSE;
	}
	
	/**
	   * Simple Rectangle data structure class
	   *
	   * @name fitt.Rect2D
	   * @public
	   * @class
	   * @param {Number} [t = 0]
	   * @param {Number} [r = 0]
	   * @param {Number} [b = 0]
	   * @param {Number} [l = 0]
	   * @property {Number} t  The top pixel coordinate
	   * @property {Number} l  The left pixel coordinate
	   * @property {Number} r  The right pixel coordinate
	   * @property {Number} b  The bottom pixel coordinate
	   * @property {Number} w  READ-ONLY gets the current width of the rectangle based on the r & l props
	   * @property {Number} h  READ-ONLY gets the current height of the rectangle based on the b & t props
	  */
	
	function Rect2D(t, r, b, l)
	{
	  var me = this,
	  args = arguments,
	  argLen = args.length,
	  argT = argLen >= 1 ? cnum(t, 0) : 0,
	  argR = argLen >= 2 ? cnum(r, 0) : 0,
	  argB = argLen >= 3 ? cnum(b, 0) : 0,
	  argL = argLen >= 4 ? cnum(l, 0) : 0;
	
	  me.t = argT;
	  me.l = argL;
	  me.r = argR;
	  me.b = argB;
	}
	
	/**
	   * Compute the width of the rectangle
	   *
	   * @name fitt.dom-Rect2D_getW
	   * @private
	   * @function
	   * @return {Number}
	  */
	
	function Rect2D_getW()
	{
	  return this.r - this.l;
	}
	
	/**
	   * Compute the height of the rectangle
	   *
	   * @name fitt.dom-Rect2D_getH
	   * @private
	   * @function
	   * @return {Number}
	  */
	
	function Rect2D_getH()
	{
	  return this.b - this.t;
	}
	
	fitt.cprop(Rect2D[PROTO], 'w', NULL, TRUE, TRUE, FALSE, Rect2D_getW, NULL, TRUE);
	fitt.cprop(Rect2D[PROTO], 'h', NULL, TRUE, TRUE, FALSE, Rect2D_getH, NULL, TRUE);
	
	function DefaultDOMScrollInfo()
	{
	  var me = this;
	
	  me[SCRL] =
	  me[SCRT] =
	  me[SCRW] =
	  me[SCRH] = 0;
	}
	
	DefaultDOMScrollInfo = new DefaultDOMScrollInfo();
	
	/**
	                                                    * Simple constructor representing scroll information
	                                                    *
	                                                    * @name fitt.ScrollInfo
	                                                    * @class
	                                                    * @public
	                                                    * @property {Number} x Horizontal scroll position
	                                                    * @property {Number} y Vertical scroll position
	                                                    * @property {Number} w Scroll width available
	                                                    * @property {Number} h Scroll height available
	                                                   */
	
	function ScrollInfo()
	{
	  var me = this;
	
	  me.x =
	  me.y =
	  me.w =
	  me.h = 0;
	}
	
	/**
	   * Checks of the string value passed in is CSS pixel format (suffix "px")
	   *
	   * @name fitt.dom-isPX
	   * @private
	   * @function
	   * @param {String} val The string to check
	   * @return {Boolean}
	  */
	
	function isPX(val)
	{
	  val = cstr(val);
	
	  if (val && rxSearch(/\D+/g, val, TRUE, TRUE) == -1) return TRUE;
	  if (val && rxSearch(/px/gi, val, TRUE, TRUE) != -1) return TRUE;
	}
	
	/**
	   * Read border values of a given element, and adjust a rect object if necessary
	   *
	   * @name fitt.dom-calcBorders
	   * @private
	   * @function
	   * @param {HTMLElement} el The element to look at
	   * @param {Object} [r] The rectangle to adjust if passed in
	   * @param {Object} [st] The current style object of an element
	   * @return {Object} the original rect passed in with top and left position adjusted for borders, or a new rect at 0,0 with borders adjusted
	  */
	
	function calcBorders(el, r, st)
	{
	  var t = 0,l = 0,re = /^t(?:able|d|h|r|head|foot)$/i;
	
	  st = st || currentStyle(el);
	  if (st) {
	    t = st.borderTopWidth;
	    l = st.borderLeftWidth;
	    t = isPX(t) ? cnum(t, 0) : 0;
	    l = isPX(l) ? cnum(l, 0) : 0;
	
	    if (geckVer && rxTest(re, tagName(el))) {
	      t = l = 0;
	    }
	  }
	  r = r || { t: 0, l: 0 };
	
	  r.t += t;
	  r.l += l;
	  return r;
	}
	
	
	/**
	   * Scroll the window to the given coordinates
	   *
	   * @name fitt.dom.scrollTo
	   * @function
	   * @param {Number} [x=0] The x coordinate with 0 being the farthest left. Number is normalized and defaulted to 0 if invalid.
	   * @param {Number} [y=0] The y coordinate with 0 being the farthest top/up.  Number is normalized and defaulted to 0 if invalid.
	   * @param {HTMLWindow} [argWin=null] The given window to scroll.
	   * @return {Boolean} true/false if the action succeeded which will trigger an async scroll of the window. Note the window still
	   *                              may not have actually scroll if it's alread at the given position, boolean just denotes success
	   *                              of execution and a good environment (i.e. if you ran this in a NodeJS server it will return false).
	  */
	
	function scrollTo(x, y, argWin) {
	
	  var ret = FALSE,win;
	
	  try {
	    if (argWin) {
	      if (argWin[SCROLL_TO]) {
	        win = argWin;
	      } else {
	        win = view(argWin);
	      }
	    } else {
	      win = getWindow();
	    }
	  } catch (e) {
	    win = NULL;
	  }
	  if (win) {
	    x = cnum(x, 0, 0);
	    y = cnum(y, 0, 0);
	    try {
	      win[SCROLL_TO](x, y);
	      ret = TRUE;
	    } catch (e) {
	      ret = FALSE;
	    }
	  }
	  return ret;
	}
	
	/**
	   * Retrieve the current document scroll information
	   *
	   * @name fitt.dom.docScroll
	   * @public
	   * @function
	   * @param {HTMLElement} [el=null] The element that resides in a given document to be checked, if not specified defaults to using the current document
	   * @return {ScrollInfo} x, y, w, h properties relating to the document scroll position see {@link fitt.ScrollInfo}
	  */
	
	function docScroll(el)
	{
	  var pos = new ScrollInfo(),
	  def = DefaultDOMScrollInfo,
	  offsetX = 0,
	  offsetY = 0,
	  pre = "page",
	  suf = "Offset",
	  pgX = pre + "X" + suf,
	  pgY = pre + "Y" + suf,
	  usePageProps = FALSE,
	  win = getWindow(),
	  d,de,db,dv;
	
	  if (el) {
	    d = doc(el);
	    if (d) {
	      dv = view(el);
	    } else {
	      d = win[DOC];
	      dv = win;
	    }
	  } else {
	    d = win[DOC];
	    dv = win;
	  }
	  de = d && d[DOC_EL] || def;
	  db = d && d[BODY] || def;
	
	  try {
	    usePageProps = !!(dv && dv != top && pgX in dv);
	  } catch (e) {
	    usePageProps = FALSE;
	  }
	
	  if (usePageProps) {
	    offsetX = cnum(dv[pgX], 0);
	    offsetY = cnum(dv[pgY], 0);
	  }
	
	  pos.x = nativeMax(de[SCRL], db[SCRL], offsetX);
	  pos.y = nativeMax(de[SCRT], db[SCRT], offsetY);
	  pos.w = nativeMax(de[SCRW], db[SCRW], 0);
	  pos.h = nativeMax(de[SCRH], db[SCRH], 0);
	  return pos;
	}
	
	/**
	   * Retrieve whether or not the given environment is a touch screen environment or not
	   * note that we cache the information so if you use dev tools to change the environment
	   * you have to refresh the browser window / restart the host process for updated information
	   * to be returned
	   *
	   * @name fitt.dom.isTouch
	   * @function
	   * @return {Boolean}
	  */
	
	function isTouchDevice() {}
	
	isTouchDevice = function () {
	
	  var docObj = doc(),ret = rfalse,docEl;
	
	  try {
	    docEl = docObj && docObj[DOC_EL] || null;
	    ret = docEl && 'ontouchstart' in docEl ? rtrue : rfalse;
	  } catch (e) {
	    ret = rfalse;
	  }
	
	  return ret;
	}();
	
	/**
	      * Retrieve the rectangle info object for a given element including
	      * width, height, top, left, right, bottom corners see {@link fitt.Rect2D}.
	      *
	      * @name fitt.dom.rect
	      * @function
	      * @param {HTMLElement} el  The element to get info on
	      * @return {Rect2D}
	     */
	
	function rect(el)
	{
	  var r = new Rect2D(),
	  BOUNDING = "getBoundingClientRect",
	  scrollTop = 0,
	  scrollLeft = 0,
	  w = 0,
	  h = 0,
	  bCheck = FALSE,
	  win = getWindow(),
	  d = doc(el) || win && win[DOC] || {},
	  compatMode = d.compatMode || '',
	  docMode = d.documentMode || 0,
	  root,scroll,parentNode,last_par,cur_st,par_cur_st,
	  offX,offY,box,use_brute;
	
	  if (isElement(el)) {
	    try {
	      cur_st = currentStyle(el);
	      root = docNode(el);
	      scroll = docScroll(el);
	      r.l = el[OFF_LEFT] || 0;
	      r.t = el[OFF_TOP] || 0;
	      parentNode = el;
	      last_par = NULL;
	      bCheck = geckVer || wbVer > 519;
	      use_brute = el === root;
	
	      if (!use_brute) {
	        if (ieVer > 0 && ieVer <= 9) {
	          if (!docMode || docMode > 0 && docMode < 8 || compatMode === BACK_COMPAT) {
	            offX = root.clientLeft;
	            offY = root.clientTop;
	          }
	        }
	        box = el[BOUNDING]();
	        r.t = box.top;
	        r.l = box.left;
	
	        if (offX || offY) {
	          r.l -= offX;
	          r.t -= offY;
	        }
	        if (scroll.y || scroll.x) {
	          if (!iosVer || iosVer >= 4.2) {
	            r.l += scroll.x;
	            r.t += scroll.y;
	          }
	        }
	      } else {
	        while (parentNode = parentNode[OFF_PAR])
	        {
	          if (!isElement(parentNode) || last_par === parentNode) break;
	
	          offX = parentNode[OFF_LEFT];
	          offY = parentNode[OFF_TOP];
	
	          r.t += offY;
	          r.l += offX;
	          if (bCheck) r = calcBorders(parentNode, r);
	
	          last_par = parentNode;
	        }
	
	        if (cur_st.position != "fixed") {
	          parentNode = el;
	          last_par = NULL;
	
	          while (parentNode = parentNode[PAR_NODE])
	          {
	            if (!isElement(parentNode) || last_par === parentNode) break;
	            if (parentNode == root) break;
	
	            scrollTop = parentNode[SCRT];
	            scrollLeft = parentNode[SCRL];
	
	            if (geckVer) {
	              //Firefox does something funky with borders when overflow is not visible.
	              par_cur_st = currentStyle(parentNode);
	              if (par_cur_st[OVER] != "visible") {
	                r = calcBorders(parentNode, r, par_cur_st);
	              }
	            }
	            if (scrollTop || scrollLeft) {
	              r.l -= scrollLeft;
	              r.t -= scrollTop;
	            }
	            last_par = parentNode;
	          }
	
	          r.l += scroll.x;
	          r.t += scroll.y;
	        } else {
	          r.l += scroll.x;
	          r.t += scroll.y;
	        }
	      }
	      if (el == root) {
	        h = el[CLH];
	        w = el[CLW];
	      } else {
	        h = el[OFSH];
	        w = el[OFSW];
	      }
	
	      r.b = r.t + h;
	      r.r = r.l + w;
	      r.w = nativeMax(w, 0);
	      r.h = nativeMax(h, 0);
	    } catch (e) {
	      r = new Rect2D();
	    }
	  }
	  return r;
	}
	
	/**
	    * Get the window dimensions
	    *
	    * @name fitt.dom.winRect
	    * @function
	    * @public
	    * @param {HTMLElement} [el] The element from which to grab the window to measure, if invalid assumed to be the window where this class runs.
	    * @return {Object} t,l,b,r,w,h
	    *
	   */
	
	function winRect(el)
	{
	  var ret = new Rect2D(),
	  wi = el && view(el) || getWindow(),
	  h = wi.innerHeight || 0,
	  w = wi.innerWidth || 0,
	  t = wi.screenY || wi.screenTop || 0,
	  b = h + t,
	  l = wi.screenX || wi.screenLeft || 0,
	  r = w + l,
	  root = docNode(el);
	
	  if (!h && !w && root) {
	    h = root[CLH] || 0;
	    w = root[CLW] || 0;
	    r = l + w;
	    b = t + h;
	  }
	
	  ret.t = t;
	  ret.l = l;
	  ret.b = b;
	  ret.r = r;
	
	  return ret;
	}
	
	function callNativeRAF(f) {
	  return requestAnimationFrame(f);
	}
	
	function callFakeRAF(f) {
	  return setTimeout(f, 17); //60 FPS
	}
	
	/**
	   * Simple requestAnimationFrame polyfill
	   *
	   * @name fitt.dom.rAF
	   * @function
	   * @public
	   * @param {Function} f The function to be called
	   *
	  */
	
	function rAF(cb) {}
	
	rAF = typeof requestAnimationFrame == 'function' ? callNativeRAF : callFakeRAF;
	exp =
	{
	  doc: doc,
	  docNode: docNode,
	  head: head,
	  elt: elt,
	  view: view,
	  qsa: qsa,
	  tags: tags,
	  nodeType: nodeType,
	  isElement: isElement,
	  tagName: tagName,
	  attr: attr,
	  append: append,
	  purge: purge,
	  swap: swap,
	  contains: contains,
	  par: par,
	  closest: closest,
	  matches: matches,
	  buildPath: buildPath,
	  inDoc: inDoc,
	  make: make,
	  txt: txt,
	  css: css,
	  currentStyle: currentStyle,
	  attach: attach,
	  detach: detach,
	  img: img,
	  Rect2D: Rect2D,
	  ScrollInfo: ScrollInfo,
	  rect: rect,
	  winRect: winRect,
	  docScroll: docScroll,
	  scrollTo: scrollTo,
	  evtTgt: evtTgt,
	  evtCancel: evtCancel,
	  loc: loc,
	  isTouch: isTouchDevice,
	  rAF: rAF };
	
	
	
	if (typeof module !== TYPE_UNDEF) {
	  module.exports = exp;
	}
	
	if (fitt) {
	  if (!fitt.Rect2D) fitt.Rect2D = Rect2D;
	  if (!fitt.ScrollInfo) fitt.ScrollInfo = ScrollInfo;
	  if (!fitt.dom) fitt.dom = exp;
	}

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	
	
	var FALSE = false,
	TRUE = true,
	TYPE_OBJ = "object",
	TYPE_FUNC = "function",
	LEN = "length",
	TYPE_UNDEF = "undefined",
	PROTO = "prototype",
	
	exp = {},
	fitt = __webpack_require__(425),
	isAry = fitt.isAry,
	mix = fitt.mix,
	cstr = fitt.cstr,
	es = fitt.es,
	ues = fitt.ues,
	subStr = fitt.subStr,
	idxOf = fitt.idxOf,
	charAt = fitt.charAt,
	keys = fitt.keys,
	ParamHashProto = null,
	a = "&",
	eq = "=",
	q = "?";
	
	/**
	         * Intantiable class used to convert a delimited string into an object.<br />
	         * For example querystrings: "name_1=value_1&name_2=value_2" ==> {name_1:value_1,name_2:value_2};<br/>
	         *
	         * Note that unescaped property values
	         * that are added into this object, that also contain the same sPropDelim and sValueDelim strings will be recursively
	         * converted into their own ParamHash objects.  Therefore if you do not want this recursion to occur, you must make sure
	         * that the values are encoded/escaped properly.
	         *
	         * This class basically has 3 major usecases:
	         * <ol>
	         *  <li>Creation of URL parameters for a query-string, or form-encoded posts</li>
	         *  <li>Creation of inline style attribute values</li>
	         *  <li>Serialization / deserialization of objects where you do not want to use JSON. In many
	         *      cases this object will do such work faster</li>
	         * </ol>
	         *
	         * <b style='color:maroon'>DO NOT PASS IN DOM Nodes to this constructor.  DOM Nodes have cyclical references which will cause never-ending loops</b>
	         *
	         * @class
	         * @name fitt.ParamHash
	         * @param {String|Object} sString  The delimited string to be converted, or an object to be converted into a ParamHash.  Objects are basically
	         *                                 dealt with by copying the properties that show up into a clone. Note that ALL enumerable properties are copyied (recursively
	         *                                 if desired), whether they are inherited via the prototype chain or not (unless bOwned argument is set too true).
	         *
	         * @param {String} [sPropDelim='&']  The substring delimiter used to separate properties. Default is "&".
	         * @param {String} [sValueDelim='=']  The substring delimited used to separate values.  Default is "=".
	         * @param {Boolean} [bNoOverwrite=false]  If true, when a name is encountered more than 1 time in the string it will be ignored.
	         * @param {Boolean} [bRecurse=false]  If true, when a value of a property that is parsed also has both the sPropDelim
	         *                                    and sValueDelim inside, convert that value to another ParamHash object automatically
	         * @param {Boolean} [bOwned=false] Only iterate over owned properties if passing in an object to convert into a ParamHash instance.
	         */
	
	function ParamHash(sString, sPropDelim, sValueDelim, bNoOverwrite, bRecurse, bOwned)
	{
		var doAdd = FALSE,firstChar,idx,idx2,idx3,sTemp,sTemp2,sTemp3,me = this,pairs,nv,nm,added,cnt,obj,len,len2;
	
		if (!me || !(me instanceof ParamHash)) return new ParamHash(sString, sPropDelim, sValueDelim, bNoOverwrite, bRecurse, bOwned);
		if (!arguments[LEN]) return me;
	
		if (sString && typeof sString == TYPE_OBJ) return mix(new ParamHash('', sPropDelim, sValueDelim, bNoOverwrite, bRecurse, bOwned), sString, bOwned, TRUE);
	
		sString = cstr(sString);
		sPropDelim = cstr(sPropDelim) || a;
		sValueDelim = cstr(sValueDelim) || eq;
	
		if (!sString) return me;
	
		firstChar = charAt(sString, 0);
	
		if (sPropDelim != q && sValueDelim != q && firstChar == q || firstChar == sPropDelim) sString = subStr(sString, 1);
	
		pairs = sString.split(sPropDelim);
		cnt = pairs[LEN];
		idx = 0;
		while (cnt--)
		{
			sTemp = pairs[idx++];
			added =
			doAdd = FALSE;
			if (sTemp) {
				nv = sTemp.split(sValueDelim);
				len = nv[LEN];
				if (len > 2) {
					nm = ues(nv[0]);
					nv.shift();
	
					if (bRecurse) {
						/* Its possible that someone screws up and doesn't have a value encoded properly and but have multiple delimiters
	                    * As if recursion was going to take place. So here we know that's the case and try to handle it if we can detect
	                    * the end points as well
	                   */
	
						sTemp2 = nm + sValueDelim;
						idx2 = idxOf(sString, sTemp2);
						len = sTemp2[LEN];
						sTemp3 = subStr(sString, idx2 + len);
						sTemp2 = sPropDelim + sPropDelim;
						len2 = sTemp2[LEN];
						idx3 = idxOf(sTemp3, sTemp2);
						if (idx3 != -1) {
							sTemp3 = sString.substr(idx2 + len, idx3 + len2);
							obj = new ParamHash(sTemp3, sPropDelim, sValueDelim, bNoOverwrite, bRecurse);
							sTemp3 = '';
							len = 0;
							for (sTemp3 in obj) {len++;}
	
							if (len > 0) idx += len - 1;
							sTemp = obj;
						} else {
							sTemp = ues(nv.join(sValueDelim));
						}
	
					} else {
						sTemp = ues(nv.join(sValueDelim));
					}
					doAdd = TRUE;
				} else if (len == 2) {
					nm = ues(nv[0]);
					sTemp = ues(nv[1]);
					doAdd = TRUE;
				}
				if (doAdd) {
					if (bNoOverwrite) {
						if (!(nm in me)) {
							me[nm] = sTemp;
							added = TRUE;
						}
					} else {
						/*
	             * if we get a duplicate key, convert the current
	             * key / value pair into an array the first time
	             * and add to that array from there on
	            */
						if (nm in me) {
							obj = me[nm];
							if (!obj.push) {
								me[nm] = [obj, sTemp];
							} else {
								obj.push(sTemp);
							}
							added = TRUE;
						} else {
							me[nm] = sTemp;
							added = TRUE;
						}
					}
					if (bRecurse && added && nm && sTemp && typeof sTemp != TYPE_OBJ && (idxOf(sTemp, sPropDelim) >= 0 || idxOf(sTemp, sValueDelim) >= 0)) {
						me[nm] = new ParamHash(sTemp, sPropDelim, sValueDelim, bNoOverwrite, bRecurse, bOwned);
					}
				}
			}
		}
	}
	
	ParamHashProto = ParamHash[PROTO];
	
	function ParamHashArrayItemInfo(p, i)
	{
		var me = this;
	
		me.p = p;
		me.i = i;
	}
	
	/** @ignore */
	function _param_hash_tostring(sPropDelim, sValueDelim, bOnlyValidValues, escapeProp, dontEscapeValue)
	{
		var prop,buffer = [],me = this,idx = 0,props,propAry,propAryKey,propAryIdx,itemType,item,len;
	
		sPropDelim = sPropDelim || a;
		sValueDelim = sValueDelim || eq;
		props = keys(me);
		bOnlyValidValues = bOnlyValidValues !== false;
	
		if (props && props[LEN]) {
			/*jsl:ignore*/
			while (prop = props[idx++])
			/*jsl:end*/
			{
				if (typeof prop === TYPE_OBJ && prop && prop instanceof ParamHashArrayItemInfo) {
					/*
	                                                                                     * props is orginally a list of keys in this object, so an array of strings
	                                                                                     * but if the value of a prop is an array we want to handle that case
	                                                                                     * below we'll construct a temporary object which in turn we'll add/store
	                                                                                     * in this given list, and then handle those
	                                                                                    */
	
					propAryKey = prop.p;
					propAryIdx = prop.i;
					propAry = me[propAryKey];
					if (propAry && isAry(propAry)) {
						item = propAry[propAryIdx];
						prop = propAryKey;
					} else {
						continue;
					}
				} else {
					item = me[prop];
				}
				itemType = typeof item;
	
				if (itemType == TYPE_FUNC) continue;
				if (isAry(item)) {
					/*
	                      * if the item is an array, then add additional entries to our list of props to
	                      * loop through, one for each index in the array, above we'll check for a specific
	                      * object item signature for said prop
	                      *
	                     */
					len = item[LEN];
					propAry = new Array(len);
	
					for (propAryIdx = 0; propAryIdx < len; propAryIdx++)
					{
						propAry[propAryIdx] = new ParamHashArrayItemInfo(prop, propAryIdx);
					}
	
					/* insert the repeated items into our props list from the current index
	       * as opposed to pushing onto the end
	      */
	
					propAry.unshift(0); //2nd arg of splice is delete count, which is always 0
					propAry.unshift(idx); //1st arg of splice whish is our starting point, which is current idx + 1 of props
					props.splice.apply(props, propAry);
					continue;
				}
				if (itemType == TYPE_OBJ && item) {
					/*
	                                       * ideally i'd like a better solution here, but there's really nothing
	                                       * that will work 100% of the time any better than this. . .
	                                      */
	
					if (item.tagName || item.nodeType) {
						item = "#node";
					} else {
						item = _param_hash_tostring.call(item, sPropDelim, sValueDelim, bOnlyValidValues, escapeProp, dontEscapeValue);
					}
				}
				if (escapeProp) prop = es(prop);
				if (!dontEscapeValue) item = es(item);
	
				if (!(itemType === TYPE_UNDEF && bOnlyValidValues)) buffer.push(prop, sValueDelim, item, sPropDelim);
			}
		}
	
		len = buffer[LEN];
		if (len) buffer[len - 1] = '';
		return cstr(buffer);
	}
	
	/**
	   * Converts a ParamHash object back into a string using the property and value delimiters specifed (defaults to "&" and "=").
	   * Again this method works recursively.  If an object is found as a property, it will convert that object into a ParamHash string
	   * and then escape it. Note also that this class's valueOf method is equal to this method.
	   *
	   * @name fitt.ParamHash#toString
	   * @function
	   * @param {String} sPropDelim  The substring delimiter used to seperate properties. Default is "&".
	   * @param {String} sValueDelim  The substring delimited used to seperate values.  Default is "=".
	   * @param {Boolean} bOnlyValidValues If true, will prevent undefined values from being ouput. Default is true.
	   * @return {String} the encoded string representation of the object.
	   *
	  */
	ParamHashProto.toString = ParamHashProto.valueOf = _param_hash_tostring;
	
	/* we don't care if it's old-school and doesn't support freezing */
	try {fitt.freeze(ParamHash[PROTO]);} catch (e) {};
	
	exp.ParamHash = ParamHash;
	
	if (typeof module !== TYPE_UNDEF) {
		module.exports = ParamHash;
	}
	
	fitt.ns("fitt.ParamHash", ParamHash);

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	if (true) {
	    module.exports = __webpack_require__(774);
	}

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	var FALSE = false,
	TRUE = true,
	NULL = null,
	LEN = "length",
	TYPE_STR = "string",
	TYPE_OBJ = "object",
	TYPE_UNDEF = "undefined",
	NEG_ONE = -1,
	fitt = __webpack_require__(425),
	fittStrReplace = fitt.strReplace,
	ParamHash = __webpack_require__(772),
	nodeURL = typeof XMLHttpRequest === TYPE_UNDEF ? __webpack_require__(775) : NULL,
	exp = {},
	mix = fitt.mix,
	cstr = fitt.cstr,
	subStr = fitt.subStr,
	strlc = fitt.strlc,
	idxOf = fitt.idxOf,
	charAt = fitt.charAt,
	strMatch = fitt.strMatch,
	regxTest = fitt.regxTest,
	strReplace = fitt.strReplace,
	trim = fitt.trim,
	
	PATH = "path",
	PRTCL = "protocol",
	HOST = "host",
	HASH = "hash",
	PARAMS = "params",
	PORT = "port",
	FWD_SLASH = "/",
	COLON = ":",
	HASHTAG = "#",
	QUEST = "?",
	EQ = "=",
	AMP = "&",
	SCHEME_SEP = COLON + FWD_SLASH + FWD_SLASH,
	DOUBLE_SLASH = FWD_SLASH + FWD_SLASH,
	URL_MAX_LENGTH = 4096,
	URLClassProto = {},
	
	
	rURLSplitter = /^(http\:|https\:|file\:|ftp\:)*?(?:\/)+([-\w\.]+)(\:\d+)?(([^\s\?#]*)(\?\S[^#]*)*(#\S*)*)/i,
	rProtocolSearch = /http\:|https\:|file\:|ftp:\:/gi,
	rIsRelative = /^(\.\.\/|\.\/|\/)/,
	rStripRelPath = /^(\/*)(\.*)/g,
	rURLPathEnd = /\S[^\?#]*/,
	rGoUp = /(^\.\.\/)/,
	rStayHere = /(^\.\/)/,
	rRoot = /(^\/)/,
	rColonMatch = /\:/g,
	rDigitMatch = /^\d+/,
	
	prevLocStr = "", /* store the last known browser window location string if avail */
	prevRefStr = "", /* store the last known browser window location document referrer if avail */
	
	oBrowserLoc = NULL, /* store the current / last known browser location as an {@link fitt.URL} instance */
	oBrowserRef = NULL; /* store the current / last known document referrer as an {@link fitt.URL} instance */
	
	
	/**
	                                                                                                            * Utility function to get the URL value for either the current browser document, or the document referrer,
	                                                                                                            * from the browser.  Not used server-side.
	                                                                                                            *
	                                                                                                            * @name fitt.URL-getDocURL
	                                                                                                            * @function
	                                                                                                            * @static
	                                                                                                            * @private
	                                                                                                            * @param {Number} mode Which URL to get at, 0/default being the current window/document location, 1 being the document referrer.
	                                                                                                            * @return {fitt.URL} an instance of the fitt.URL object representing the given/requested URL string.
	                                                                                                            *
	                                                                                                           */
	
	function getDocURL(mode)
	{
		var url = NULL,href;
		if (!mode) {
			/*
	              * location.href may be inaccessible due to weirdness with document.domain in
	                       * in IE.  So use try/catches and also look at document.URL if needed.
	              		*/
	
			try {
				href = location.href;
			} catch (e) {
				href = '';
			}
			if (!href) {
				try {
					href = document.URL;
				} catch (e) {
					href = '';
				}
			}
			if (href) {
				/*
	              * only reconstruct the URL object if the location has changed
	             */
				if (href != prevLocStr) {
					prevLocStr = href;
					url =
					oBrowserLoc = new URLClass(href);
				} else {
					url = oBrowserLoc;
				}
			}
		} else {
			try {
				href = document.referrer;
			} catch (e) {
				href = '';
			}
			if (href) {
				if (href != prevRefStr) {
					prevRefStr = href;
					url =
					oBrowserRef = new URLClass(href);
				} else {
					url = oBrowserRef;
				}
			}
		}
		return url;
	}
	
	/**
	   * Get the current document location as an {@link fitt.URL} object
	   * Note that this function currently returns NULL when run server-side since
	   * it's not really viable but that could change in the future (say if we wanted
	   * to run this code with some sort of virutal document server side).
	   *
	   * @name fitt.URL.loc
	   * @function
	   * @public
	   * @static
	   * @return {fitt.URL}
	  */
	
	function loc() {return getDocURL();}
	
	/**
	                                      * Get the current document referrer as an {@link fitt.URL} object
	                                         * Returns null if document.refferer is not available (i.e. server-side,
	                                         * or when a the given document has no referrer);
	                                         *
	                                         * @name fitt.URL.ref
	                                         * @function
	                                         * @public
	                                         * @static
	                                         * @return {fitt.URL|Null}
	                                        */
	
	
	function ref() {return getDocURL(1);}
	
	/**
	                                       * A utility function for the {@link fitt.URL.resolve} method that
	                                       * mixes the URL object properties into another object
	                                       *
	                                       * @name fitt-resolve_mixForOutput
	                                       * @private
	                                       * @function
	                                       * @param {URLClass} retURL
	                                       * @param {Object} out
	                                       * @return {URLClass} retURL
	                                      */
	
	function resolve_mixForOutput(retURL, out)
	{
		if (retURL && retURL instanceof URLClass && retURL.isValid()) {
			if (out) {
				mix(out, retURL, TRUE, TRUE, FALSE, TRUE);
			}
		} else {
			retURL = NULL;
		}
		return retURL;
	}
	
	/**
	   * Converts a relative path string to a fully qualified absolute URL, using either
	   * the base URL string passed in or if not provided will use the document/page location
	   * See {@link fitt.URL.resolve} for more information
	   *
	   * @name fitt-resolve_clientSide
	   * @function
	   * @private
	   * @param {String} str The URL string
	  * @param {String} [base] An optional base URL to use for converting the relative path.  When running client-side, this value will default to the current
	  *                        document location that the code is running in.  Server-Side this defaults to an empty string, and becomes a REQUIRED parameter.
	  * @param {Object} out  The object to be used as an output parameter, which will mix in properties that make it look like a {@link fitt.URL} object (having
	  *                      host, path and protocol properties set if the conversion the relative URL to absolute is successful).
	  * @return {fitt.URL}
	  */
	
	function resolve_clientSide(str, base, out) {
		var idx = 0,retURL = NULL,sProto,sPort,sHost,sPath,sMyPath,execResult,sHash,oBaseURL;
	
		if (base) {
			oBaseURL = new URLClass(base);
		} else if (oBrowserLoc) {
			oBaseURL = oBrowserLoc;
		}
	
		if (!oBaseURL || !oBaseURL.isValid()) {
			throw new Error("fitt.URL.resolve failed, no URL base provided or detected " + str);
		}
	
		out = out || {};
		sProto = oBaseURL[PRTCL];
		sHost = oBaseURL[HOST];
		sMyPath = oBaseURL[PATH];
		sPort = oBaseURL[PORT];
		sHash = oBaseURL[HASH];
		sPath = strMatch(str, rURLPathEnd);
		if (sPath) {
			sPath = sPath[0];
		}
	
		if (!regxTest(rRoot, sPath)) {
			if (regxTest(rStayHere, sPath)) {
				sPath = strReplace(sPath, rStayHere, '', TRUE, TRUE);
				idx = idxOf(sMyPath, FWD_SLASH, 1);
				if (idx != NEG_ONE)
				sPath = subStr(sMyPath, 0, idx + 1) + sPath;
	
			} else {
				while (execResult = rGoUp.exec(sPath))
				{
					idx = idxOf(sMyPath, FWD_SLASH, 1);
					if (idx != NEG_ONE) {
						sMyPath = subStr(sMyPath, 0, idx);
						sPath = strReplace(sPath, execResult[1], '', FALSE, TRUE);
					} else {
						break;
					}
				}
				sPath = cstr([sMyPath, FWD_SLASH, sPath]);
			}
		}
	
		if (sPath) {
			sPath = strReplace(sPath, rStripRelPath, '');
			sPath = idxOf(sPath, FWD_SLASH) !== 0 ? FWD_SLASH + sPath : sPath;
		}
		retURL = new URLClass(cstr([sProto, SCHEME_SEP, sHost, sPort ? COLON : '', sPort, sPath, sHash ? HASHTAG : '', sHash]));
	
		return resolve_mixForOutput(retURL, out);
	}
	
	/**
	   * Converts a relative path string to a fully qualified absolute URL, using
	   * the base URL string passed in. This method takes advantage of using the NodeJS 'url'
	   * module for functionality.
	   * See {@link fitt.URL.resolve} for more information
	   *
	   * @name fitt-resolve_serverSide
	   * @function
	   * @private
	   * @param {String} str The URL string
	  * @param {String} [base] An optional base URL to use for converting the relative path.  When running client-side, this value will default to the current
	  *                        document location that the code is running in.  Server-Side this defaults to an empty string, and becomes a REQUIRED parameter.
	  * @param {Object} out  The object to be used as an output parameter, which will mix in properties that make it look like a {@link fitt.URL} object (having
	  *                      host, path and protocol properties set if the conversion the relative URL to absolute is successful).
	  * @return {fitt.URL}
	  */
	
	function resolve_serverSide(str, base, out)
	{
		var retURL = NULL,resolvedStr,oBaseURL;
	
		if (!nodeURL) {
			throw new Error("fitt.URL.resolve, node 'url' module not found");
		}
	
		if (base) {
			oBaseURL = new URLClass(base);
		}
	
		if (!oBaseURL || !oBaseURL.isValid()) {
			throw new Error("fitt.URL.resolve failed, no URL base provided or detected " + str);
		}
	
		resolvedStr = nodeURL.resolve(base, str);
		retURL = new URLClass(resolvedStr);
		out = out || {};
	
		return resolve_mixForOutput(retURL, out);
	
	}
	
	/**
	  * A method for converting relative URLs to absolute URLs.
	  *
	  *
	  * @name fitt.URL.resolve
	  * @static
	  * @param {String} str The URL string
	  * @param {String} [base] An optional base URL to use for converting the relative path.  When running client-side, this value will default to the current
	  *                        document location that the code is running in.  Server-Side this defaults to an empty string, and becomes a REQUIRED parameter.
	  * @param {Object} out  The object to be used as an output parameter, which will mix in properties that make it look like a {@link fitt.URL} object (having
	  *                      host, path and protocol properties set if the conversion the relative URL to absolute is successful).
	  * @return {fitt.URL}
	  *
	  */
	
	function resolve(str, base, out) {};
	
	
	resolve = nodeURL ? resolve_serverSide : resolve_clientSide;
	
	
	/**
	                                                              * Parses a string representation of a URL, using the NodeJS url module, parse method.
	                                                              *
	                                                              * @name fitt.URL-parse_serverSide
	                                                              * @function
	                                                              * @private
	                                                              * @param {String} str  The URL string
	                                                              * @param {Object} out  The object to be used as an output parameter, which will have host, path, port, params, and protocol properties set if the conversion the relative URL to absolute is successful.
	                                                              * @param {Boolean} [ret=false] Also return a new fully qualified URL object if desired.
	                                                              * @return {Object}
	                                                              *
	                                                             */
	
	function parse_serverSide(str)
	{
		var out = {},resolvedNodeURL;
	
		if (!nodeURL) {
			throw new Error("fitt.URL.parse, node 'url' module not found");
		}
	
		resolvedNodeURL = nodeURL.parse(str, TRUE, TRUE);
	
		out[HOST] = cstr(resolvedNodeURL.hostname);
		out[PATH] = fittStrReplace(cstr(resolvedNodeURL[PATH]), /\?.*$/, '', TRUE, TRUE);
		out[PARAMS] = fittStrReplace(cstr(resolvedNodeURL.search), /^\?/, '', TRUE, TRUE);
		out[PORT] = cstr(resolvedNodeURL[PORT]);
		out[HASH] = cstr(resolvedNodeURL[HASH]);
		out[PRTCL] = fittStrReplace(cstr(resolvedNodeURL[PRTCL]), /\:/g, '', TRUE, TRUE);
	
		return out;
	}
	
	/**
	      * Parses a string representation of a URL.
	      *
	      * @name fitt.URL-parse_clientSide
	      * @function
	      * @private
	      * @param {String} str  The URL string
	      * @param {Object} out  The object to be used as an output parameter, which will have host, path, port, params, and protocol properties set if the conversion the relative URL to absolute is successful.
	      * @param {Boolean} [ret=false] Also return a new fully qualified URL object if desired.
	      * @return {fitt.URL|void} return a new {@link fitt.URL} object if ret param is set to true, otherwise return undefined (relying on the object in the out param).
	      *
	     */
	
	function parse_clientSide(str)
	{
		var out = {},sProtocol = '',sHost = '',sPath = '',sParams = '',sHash = '',match,sPort = '',idx = 0;
	
		if (str) {
			if (!str.search(rIsRelative)) {
				if (idxOf(str, DOUBLE_SLASH) != 0) {
					resolve_clientSide(str, null, out);
					str = cstr([out[PRTCL], SCHEME_SEP, out[HOST], out[PORT] ? COLON + out[PORT] : '', FWD_SLASH, out[PATH]]);
				} else {
					//it's protocol relative, not a relative path
				}
			}
			match = strMatch(str, rURLSplitter);
			if (match) {
				sProtocol = match[1] || '';
				sHost = match[2] || '';
				sPort = match[3] || '';
				sPath = match[5] || '';
				sParams = match[6] || '';
				sHash = match[7] || '';
			}
	
			if (sProtocol) {
				sProtocol = strReplace(sProtocol, rColonMatch, '', TRUE, TRUE);
				if (strlc(sProtocol, TRUE) == "file" && sHost && sPath && charAt(sPath, 0) == COLON) {
					sPath = sHost + sPath;
					sHost = '';
				}
			}
	
			if (sPort) sPort = strReplace(sPort, rColonMatch, '', TRUE, TRUE);
			if (sParams && charAt(sParams, 0) == QUEST) sParams = subStr(sParams, 1);
			if (sHash && charAt(sHash, 0) == HASHTAG) sHash = subStr(sHash, 1);
			//if (sPath && charAt(sPath,0) == FWD_SLASH) sPath = subStr(sPath,1);
	
			if (sHash) {
				idx = idxOf(sHash, QUEST);
				if (idx != NEG_ONE) {
					sParams = subStr(sHash, idx + 1);
					sHash = subStr(sHash, 0, idx);
				}
			}
		}
		out[PRTCL] = sProtocol;
		out[HOST] = sHost;
		out[PORT] = sPort;
		out[PATH] = sPath;
		out[PARAMS] = sParams;
		out[HASH] = sHash;
	
		return out;
	
	}
	
	/**
	      * Parses a string representation of a URL
	      *
	      * @name fitt.URL.parse
	      * @function
	      * @public
	      * @param {String} str  The URL string
	      * @return {Object}
	      *
	     */
	
	function parse(str)
	{
		if (nodeURL) return parse_serverSide(str);
	
		return parse_clientSide(str);
	}
	
	/**
	   * Instantiable class used to convert a URL string into an object.
	   * For example:
	   * <pre>
	        var str  = "http://localhost:8080/foo/bar.html?cb=0293842034&#hello";
	        var oURL = new fitt.URL(str);
	        alert(oURL.protocol); //echo's "http"
	        alert(oURL.port); //echo's "8080"
	        alert(oURL.host); //echo's localhost
	        alert(oURL.path); //echo's "foo/bar.html"
	        alert(oURL.params); //echo's "cb=0293842034&"
	        alert(oURL.hash); //echo's "#hello"
	   * </pre>
	   *
	   *
	   *
	   * @class
	   * @name fitt.URL
	   * @param {String} sProtocolOrURLString  A string representing a URL in total if it is the only argument specified to the constructor.  Otherwise it is treated as the protocol string part of a URL.
	   * @param {String} sHost  A string representing a URL host name
	   * @param {String} sPath  A string representing a URL path
	   * @param {String/Object} oParams  A string representation or object representation of a fitt.ParamHash object that is used as query string parameters on a URL.
	   * @param {String} sHash  A string representing a URL hash
	   * @param {String} sPort  A string representing a URL port
	   *
	   * @property {String} protocol The protocol of the URL.  Supported values are "http", "https", "ftp", and "file"
	   * @property {String} host The host name (cname) of the URL.  Will be empty for file URLs
	   * @property {String} path The path of the URL, including the file name/mime type.  Note that nested URLs
	      *                         will be treated as part of the path.<br />
	      *
	      * <pre>
	  Example: http://www.yahoo.com/rds**http%3A//sports.yahoo.com/nfl/blog/shutdown_corner/post/The-best-and-worst-of-the-2010-draft%3Furn=nfl,236463
	                              |                                                                                                                  |
	                              |--------------------------------------------- PATH ---------------------------------------------------------------|
	       </pre>
	      *
	      * @property {String} port The port number string of the URL.  Will be empty for file URLs
	      * @property {String} hash The hash value of the URL.<br /> <pre>(e.g. "#hashvalue")</pre>
	      * @property {fitt.ParamHash} params The query string parameters of the URL. <br /> <pre>(e.g. "?foo=bar&name=value&")</pre>
	   *
	  */
	function URLClass(sProtocolOrURLString, sHost, sPath, oParams, sHash, sPort) {
	
		if (!this || !(this instanceof URLClass)) return new URLClass(sProtocolOrURLString, sHost, sPath, oParams, sHash, sPort);
	
		var me = this,argLen = arguments[LEN],match,isRelative = FALSE,sProto,obj,objTyp,
		failedResolve = FALSE;
	
		me[PRTCL] =
		me[HOST] =
		me[PATH] =
		me[HASH] =
		me[PORT] = '';
		me[PARAMS] = NULL;
	
		if (!argLen) return me;
	
		sProtocolOrURLString = cstr(sProtocolOrURLString);
	
		if (argLen == 1 || sProtocolOrURLString && !sHost && !sPath && !oParams && !sHash && !sPort) {
			obj = parse(sProtocolOrURLString);
			mix(me, obj, TRUE, TRUE);
		} else {
			if (idxOf(sProtocolOrURLString, COLON) == -1) sProtocolOrURLString += COLON;
			match = strMatch(sProtocolOrURLString, rProtocolSearch, 0);
			if (match) {
				sProto =
				me[PRTCL] = match;
				sProto =
				me[PRTCL] = strReplace(me[PRTCL], rColonMatch, '', TRUE, TRUE);
			}
	
			sHost = cstr(sHost);
			if (sHost) {
				me[HOST] = sHost;
			} else {
				obj = parse_clientSide(sProtocolOrURLString);
				if (obj[HOST]) me[HOST] = obj[HOST];
			}
	
			if (sPort && strMatch(sPort, rDigitMatch)) {
				me[PORT] = sPort;
			} else {
				obj = obj || parse_clientSide(sProtocolOrURLString);
				if (obj[PORT]) me[PORT] = obj[PORT];
			}
	
			sPath = cstr(sPath);
			if (sPath) {
				isRelative = !!strMatch(sPath, rIsRelative);
	
				if (isRelative) {
					try {
						resolve_clientSide(sPath, me[PRTCL] && me[HOST] ? cstr([me[PRTCL], SCHEME_SEP, me[HOST]]) : NULL, me);
					} catch (e) {
						failedResolve = true;
						/* if we fail converting relative, note that and
	                            * just use what was passed
	                           */
					}
	
					if (sHost && sHost != me[HOST]) {
						me[HOST] = sHost;
					}
					if (sProto && sProto != me[PRTCL]) {
						me[PRTCL] = sProto;
					}
					if (sPort != me[PORT]) {
						me[PORT] = sPort;
					}
	
					if (failedResolve) {
						//Remove any relative paths if we can't resolve as they don't make sense
						me[PATH] = sPath;
					}
	
					if (me[PATH]) {
						me[PATH] = strReplace(me[PATH], rStripRelPath, '');
						me[PATH] = idxOf(me[PATH], FWD_SLASH) !== 0 ? FWD_SLASH + me[PATH] : me[PATH];
					}
	
				} else {
					me[PATH] = sPath;
				}
			} else {
				obj = obj || parse_clientSide(sProtocolOrURLString);
				if (obj[PATH]) me[PATH] = obj[PATH];
			}
	
			if (sHash) {
				me[HASH] = sHash;
			} else {
				obj = obj || parse_clientSide(sProtocolOrURLString);
				if (obj[HASH]) me[HASH] = obj[HASH];
			}
	
			if (oParams) {
				me[PARAMS] = oParams;
			} else {
				obj = obj || parse_clientSide(sProtocolOrURLString);
				if (obj[PARAMS]) me[PARAMS] = obj[PARAMS];
			}
		}
	
		//if hash and query string are transposed, and there is no path, the hash will show up as the path so fix it here
		if (!idxOf(me[PATH], HASHTAG)) {
			me[HASH] = subStr(me[PATH], 1);
			me[PATH] = '';
		}
	
		try {
			obj = me[PARAMS];
			objTyp = obj && typeof obj || '';
	
			if (objTyp == TYPE_STR) {
				me[PARAMS] = ParamHash(obj, AMP, EQ);
			} else if (objTyp == TYPE_OBJ) {
				if (!(obj instanceof ParamHash)) {
					me[PARAMS] = ParamHash(obj, AMP, EQ);
				} else {
					me[PARAMS] = obj;
				}
			}
		} catch (e) {
			me[PARAMS] = NULL;
		}
	}
	
	
	/**
	  * Checks whether or not an instance of a fitt.URL class is valid or not.  This method checks that all pieces of a URL
	  * are set properly, as well as checking the maximum length.
	  *
	  * @name fitt.URL#isValid
	  * @function
	  * @public
	  * @return {Boolean} if the URL instance validates
	  *
	  */
	function isValid(oURL)
	{
		var tmpStr = '',me = oURL || this || {},protocol = me[PRTCL],host = me[HOST],port = me[PORT];
	
		if (protocol != "file") {
			if (!host) return FALSE;
			if (port && !strMatch(port, rDigitMatch)) return FALSE;
			protocol += COLON;
			if (!protocol.search(rProtocolSearch)) {
				tmpStr = cstr([protocol, SCHEME_SEP, host, port ? COLON + port : '', FWD_SLASH, me[PATH]]);
				if (tmpStr[LEN] > URL_MAX_LENGTH) return FALSE;
				if (!strMatch(host, /^[-\w\.]+/i)) return FALSE;
				return !!tmpStr;
			} else {
				return TRUE;
			}
		} else {
			return !!host;
		}
	}
	
	/**
	   * A static method to validate a URL string. See isValid method for more details.
	   *
	   * @name fitt.URL.validate
	   * @function
	   * @static
	   * @param {String} str  A string representation of a URL.
	   * @return {Boolean} if the URL validates.
	   *
	  */
	
	function validate(str)
	{
		var strtyp = str && typeof str || '';
	
		switch (strtyp) {
	
			case 'string':
				return isValid(new URLClass(str));
			case 'object':
				return str instanceof URLClass ? isValid(str) : isValid(new URLClass(cstr(str)));}
	
		return FALSE;
	}
	
	/**
	   * Whether or not a given URL is using SSL (https protocol)
	   *
	   * @name fitt.URL#isSSL
	   * @function
	   * @public
	   * @return {Boolean}
	  */
	
	/**
	      * Whether or not a given URL is using SSL (https protocol)
	      *
	      * @name fitt.URL.isSSL
	      * @function
	      * @public
	      * @static
	      * @param {fitt.URL|String} str The URL to process
	      * @return {Boolean}
	     */
	
	function isSSL(str)
	{
		var url = str || this || NULL,
		urltyp = url && typeof url || '';
	
		switch (urltyp) {
	
			case 'string':
				url = new URLClass(url);
				break;
			case 'object':
				url = url instanceof URLClass ? url : new URLClass(cstr(url));
				break;}
	
	
		return url && cstr(url[PRTCL]).search(/^https/i) === 0;
	}
	
	/**
	   * A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	   * RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	   * by any combination of letters, digits, plus, period, or hyphen.
	   *
	   * @name fitt.URL.isAbsolute
	   * @function
	   * @public
	   * @static
	   * @param {String|fitt.URL} url The URL to check
	   * @return {Boolean} whether or not the URL is absolute
	  */
	
	function isAbsolute(url)
	{
		return (/^(http\:|https\:|file\:|ftp:\:)/i.test(cstr(url)));
	}
	
	/**
	  * Outputs a {@link fitt.URL} object as a string (assuming it's valid)
	  *
	  * @name fitt.URL#toString
	  * @function
	  * @public
	  * @return {String} representation of a URL
	  *
	  */
	
	function URLClass_toString()
	{
		var buf,me = this,sProtcl,path,params,aHash,sPort,l;
	
		try {
			if (!isValid(me)) return '';
		} catch (e) {
			return '';
		}
	
		sProtcl = me[PRTCL];
		sProtcl = strReplace(sProtcl, rColonMatch, '');
		params = me[PARAMS];
		path = me[PATH];
		aHash = me[HASH];
		sPort = me[PORT];
		buf = [sProtcl, sProtcl ? SCHEME_SEP : DOUBLE_SLASH, me[HOST]];
	
		if (sPort)
		buf.push(COLON, sPort);
	
		if (!path) {
			buf.push(FWD_SLASH);
		} else if (strMatch(path, /\/|\w+/g)) {
			buf.push(charAt(path, 0) !== FWD_SLASH ? FWD_SLASH : '', path);
		}
	
		if (params && params instanceof ParamHash) {
			params = trim(cstr(params), TRUE) || '';
			if (params) {
				l = params[LEN];
				if (l && charAt(params, l - 1) == AMP) params = subStr(params, 0, l - 1);
			}
			/* Only push a question mark char on the end if we do indeed have querystring params */
			if (params) {
				buf.push(QUEST, params);
			}
		}
	
		if (aHash)
		buf.push(HASHTAG, aHash);
	
		return cstr(buf);
	}
	
	/**
	   * Return a string representation of a URL minus any query string, port, or hash tag values
	   *
	   * @name fitt.URL#toStripString
	   * @function
	   * @public
	   * @return {String}
	  */
	
	function URLClass_toStripString()
	{
		var ret = '',me = this || {},prot = me[PRTCL],pt = me[PATH],hst = me[HOST];
		if (hst) ret = cstr([prot, prot ? SCHEME_SEP : DOUBLE_SLASH, hst, charAt(pt, 0) !== FWD_SLASH ? FWD_SLASH : '', pt]);
		return ret;
	}
	
	/**
	  * Return host name optionally with protocol and port number
	  * Used for cases such as calling postMessage where you need those
	  * values in addition to just the cname. By default includes the protocol, since
	  * otherwise you could just ask for [oURL].host
	  *
	  * @name fitt.URL#toHostString
	  * @function
	  * @public
	  * @param {Boolean} [withProto=true] Include the protocol with the host name, defaults to true, must past false to have this ignored (falsy values such as 0/null will still behave as defaulting to true)
	  * @param {Boolean} [withPort=false] Include the port number in the string, defaults to false
	  * @param {Number} [subCount=*] Include a number to limit the number of sub domains that are repoted on the host
	  *                              Must be a number of 2 or greater (since any hostname must have at least 2 words seperated by '.'
	  *                              to be a valid domain).  For example if you have a URL with a host of 'foo.bar.espn.com',
	  *                              and you passed a value 3 as the subCount you'd get a string with a host of 'bar.espn.com'
	  * @return {String}
	  *
	  */
	
	function URLClass_toHostString(withProto, withPort, subCount)
	{
		var ret = '',me = this,buffer = [],hst,val,
		hstSplit,hstSplitLen;
	
		if (me instanceof URLClass && isValid(me)) {
			hst = me[HOST] || '';
	
			if (hst) {
				hstSplit = hst.split('.');
				hstSplitLen = hstSplit.length;
	
				if (subCount < 0) {
					hstSplit.splice(0, subCount * -1);
					hst = hstSplit.join('.');
	
				} else if (subCount >= 2) {
					if (hstSplitLen > subCount) {
						hstSplit.splice(0, hstSplitLen - subCount);
						hst = hstSplit.join('.');
					}
				}
	
				buffer.push(hst);
			}
	
			if (withProto !== FALSE) {
				val = me[PRTCL] || '';
				if (val) {
					buffer.unshift(val, SCHEME_SEP);
				} else {
					buffer.unshift(DOUBLE_SLASH);
				}
			}
	
			if (withPort && hst) {
				val = me[PORT] || '';
				if (val) buffer.push(COLON, val);
			}
	
			ret = cstr(buffer);
		}
		return ret;
	}
	
	/**
	   * Return whether or not the given URL has the same or similar origin to this URL.
	   * For example (new fitt.URL('http://foo.espn.com')).isSub(new fitt.URL('http://espn.com')) == true.
	   *
	   * @name fitt.URL#isSub
	   * @function
	   * @public
	   * @param {fitt.URL} other_url
	   * @return {Boolean}
	  */
	
	function URLClass_isSub(other_url)
	{
		var ret = FALSE,
		me = NULL,
		idx = -1;
	
		if (other_url && other_url instanceof URLClass) {
			me = other_url;
		} else {
			me = this;
			me = me && me instanceof URLClass ? me : NULL;
		}
	
		if (me) {
			if (me[PORT] === other_url[PORT] && me[PRTCL] === other_url[PRTCL]) {
				idx = me[HOST].lastIndexOf(other_url[HOST]);
				ret = !!(idx != -1 && idx + other_url[HOST][LEN] == me[HOST][LEN]);
			}
		}
		return ret;
	}
	
	/**
	   * convert request from SEO to normal query string format
	   *
	   * SEO: http://www.espn.com/espn/story/_/id/23403800/mariano-rivera-misty-treanor-herschel-walker-designated-chair-president-council-sports-fitness-nutrition
	   * query string: http://www.espn.com/espn/story?id=23403800&_slug_=mariano-rivera-misty-treanor-herschel-walker-designated-chair-president-council-sports-fitness-nutrition
	   *
	   * @name fitt.URL#undoSEO
	   * @function
	   * @public
	   * @param  {String} Request url like above example
	   * @return {String} query string format of url
	   */
	
	function URLClass_undoSEO(url) {
		var result = url,
		ampersand = '',
		questRegEx = /\?/,
		query,parts;
	
		if (typeof url === TYPE_STR && url.length) {
			parts = url.split('/_/');
	
			if (parts.length > 1) {
				result = [parts[0], QUEST]; //part before query string
				query = parts[1].split(FWD_SLASH);
	
				while (query.length > 1) {
					result.push(ampersand, query.shift(), EQ, fittStrReplace(query.shift(), questRegEx, AMP, FALSE, TRUE));
					ampersand = AMP;
				}
	
				if (query.length === 1) {
					result.push(ampersand, '_slug_=', fittStrReplace(query.shift(), questRegEx, AMP, FALSE, TRUE));
				}
	
				result = cstr(result);
			}
		}
	
		return result;
	}
	
	/**
	   * The maximum number of characters a URL can be before it is considered invalid.
	   *
	   * @name fitt.URL.MAX_LENGTH
	   * @type {Number}
	   * @constant
	   * @default 4096
	   * @static
	   *
	  */
	
	URLClass.MAX_LENGTH = URL_MAX_LENGTH;
	
	URLClass.parse = parse;
	
	URLClass.resolve = resolve;
	
	URLClass.validate = validate;
	
	URLClass.isSSL = isSSL;
	
	URLClass.isAbsolute = isAbsolute;
	
	URLClass.isSub = URLClass_isSub;
	
	URLClass.loc = loc;
	
	URLClass.ref = ref;
	
	URLClass.undoSEO = URLClass_undoSEO;
	
	URLClassProto.isValid = isValid;
	
	URLClassProto.isSSL = isSSL;
	
	URLClassProto.toStripString = URLClass_toStripString;
	URLClassProto.toHostString = URLClass_toHostString;
	URLClassProto.isSub = URLClass_isSub;
	
	URLClassProto.toString =
	URLClassProto.valueOf = URLClass_toString;
	URLClass.prototype = URLClassProto;
	
	/*
	                                     * populate the prevLocStr, oBrowserLoc, prevRefStr, and oBrowserRef state objects
	                                     * if possible
	                                    */
	
	if (!nodeURL) {
		loc();
		ref();
	}
	
	exp.URL = URLClass;
	
	if (typeof module !== TYPE_UNDEF) {
		module.exports = URLClass;
	}
	
	if (!fitt.URL) {
		fitt.URL = URLClass;
	}

/***/ }),
/* 775 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {
	
	var TRUE = true,
	FALSE = false,
	TYPE_OBJ = 'object',
	PROTO = 'prototype',
	WINDOWS = 'windows',
	GECKO = 'gecko',
	TYPE_UNDEF = "undefined",
	MAX_UA_CACHE_SIZE = 10,
	exp = {},
	fitt = __webpack_require__(425),
	
	cstr = fitt.cstr,
	cnum = fitt.cnum,
	mix = fitt.mix,
	kindOf = fitt.kindOf,
	keys = fitt.keys,
	regxTest = fitt.regxTest,
	strMatch = fitt.strMatch,
	strReplace = fitt.strReplace,
	strlc = fitt.strlc,
	oUAStrCache = {},
	$UA = {},
	sNavUA = function ()
	{
	    var ret = "";
	
	    try {
	        ret = typeof navigator == TYPE_OBJ ? cstr(navigator.userAgent) : '';
	    } catch (e) {
	        ret = '';
	    }
	    return ret;
	}();
	
	/**
	      * Static utility function for doing string replace, where we guarantee
	      * that the 1st argument and 3rd arguments are strings (hence being private,
	      * and therefore speeding things up slightly since we don't have to convert).
	      *
	      * @name fitt.UA-strReplaceSafe
	      * @function
	      * @static
	      * @private
	      * @param {String} s The string in which to replace characters
	      * @param {RegExp} ex The regular expression to use for replacement
	      * @param {String|Function} r The replacement substring
	      * @return {String}
	      *
	     */
	
	function strReplaceSafe(s, ex, r)
	{
	    return strReplace(s, ex, r, TRUE, TRUE);
	}
	
	/**
	   * Static utility function for doing a regular expression match on a string safely
	   * (guaranteeing that the 1st argument is indeed a string, skipping any conversion),
	   * and returning the array-like match object or a specific item out of said object
	   * see {@link fitt.strMatch}
	   *
	   * @name fitt.UA-strMatchSafe
	   * @function
	   * @static
	   * @private
	   * @param {String} str
	   * @param {RegExp} regEx
	   * @param {Number} [idx=null] If null the return value is the array-like match result object or null, if idx is a number, then
	   *                            it returns the item at the given index inside said match result object or null if not present
	   * @return {Array|Null|String}
	  */
	
	function strMatchSafe(str, regEx, idx)
	{
	    return strMatch(str, regEx, idx, TRUE);
	}
	
	/**
	   * Static utility function for doing a regular expression boolean match (test) on a string
	   * safely  (guaranteeing that the 1st argument is indeed a regular expression and the 2nd
	   * argument is a string, skipping any conversion).  See {@link fitt.regxTest}.
	   *
	   * @name fitt.UA-regxTestSafe
	   * @function
	   * @static
	   * @private
	   * @param {RegExp} rx
	   * @param {String} str
	   * @return {Boolean}
	  */
	
	function regxTestSafe(rx, str)
	{
	    return regxTest(rx, str, TRUE, TRUE);
	}
	
	/**
	   * Converts a multi-dot version string into a numeric value
	   * by replacing all dot characters except the first one.
	   *
	   * @name fitt.UA-convertVersionStringToNum
	   * @function
	   * @static
	   * @private
	   * @param {String} s A version number string (expected format of x.x.x).
	   * @return {Number} Note that invalid strings which result in NaN values are converted to 0
	   *
	  */
	
	function convertVersionStringToNum(s)
	{
	    var c = 0;
	
	    function convertVersionStringToNumLogic()
	    {
	        return c++ == 1 ? '' : '.';
	    }
	
	    return cnum(strReplaceSafe(s, /\./g, convertVersionStringToNumLogic), 0);
	}
	
	
	/**
	   * Parse a user-agent string, and mix the results into the given object
	   *
	   * @name fitt.UA-doParse
	   * @function
	   * @static
	   * @private
	   * @param {Object|fitt.UA} oUA An object to set the properties of; based on the information parsed from the given string. Properties
	   *                             set map to the {@link fitt.UA} class properties.
	   * @param {String} subUA A user-agent string to parse
	   * @return oUA (the input object in the 1st argument is returned as well)
	   *
	  */
	
	function doParse(oUA, subUA)
	{
	    var match, cached, keyList, keyListCnt;
	
	    if (subUA) {
	        cached = oUAStrCache[subUA];
	
	        if (cached) {
	            mix(oUA, cached);
	        } else {
	            if (regxTestSafe(/windows|win32/i, subUA)) {
	                oUA.os = WINDOWS;
	            } else if (regxTestSafe(/macintosh|mac_powerpc/i, subUA)) {
	                oUA.os = 'macintosh';
	            } else if (regxTestSafe(/android/i, subUA)) {
	                oUA.os = 'android';
	            } else if (regxTestSafe(/symbos/i, subUA)) {
	                oUA.os = 'symbos';
	            } else if (regxTestSafe(/linux/i, subUA)) {
	                oUA.os = 'linux';
	            } else if (regxTestSafe(/rhino/i, subUA)) {
	                oUA.os = 'rhino';
	            }
	
	            /*
	               * Edge browser actually includes sub strings for chrome,webkit, and safari
	               * making you think it could be one of those browsers if your not careful,
	               * so do that first
	              */
	
	            match = strMatchSafe(subUA, /Edge\/(\d+)\.*?(\d+)/, 1);
	            if (match) {
	                oUA.edge = convertVersionStringToNum(match);
	                oUA.os = WINDOWS;
	                match = strMatchSafe(subUA, /(Windows\s+?Phone)|(Mobile\s+?)Safari/i);
	
	                if (match) {
	                    oUA.mobile = WINDOWS;
	                }
	            } else {
	                // Modern KHTML browsers should qualify as Safari X-Grade
	                if (regxTestSafe(/KHTML/, subUA)) {
	                    oUA.webkit = 1;
	                }
	
	                if (regxTestSafe(/IEMobile|XBLWP7/, subUA)) {
	                    oUA.mobile = WINDOWS;
	                }
	                if (regxTestSafe(/Fennec/, subUA)) {
	                    oUA.mobile = GECKO;
	                }
	
	                // Modern WebKit browsers are at least X-Grade
	                match = strMatchSafe(subUA, /AppleWebKit\/([^\s]*)/, 1);
	
	                if (match) {
	                    oUA.webkit = convertVersionStringToNum(match);
	                    oUA.safari = oUA.webkit;
	
	                    if (regxTestSafe(/PhantomJS/, subUA)) {
	                        match = strMatchSafe(subUA, /PhantomJS\/([^\s]*)/, 1);
	                        if (match) {
	                            oUA.phantomjs = convertVersionStringToNum(match);
	                        }
	                    }
	
	                    // Mobile browser check
	                    if (regxTestSafe(/ Mobile\//, subUA) || regxTestSafe(/iPad|iPod|iPhone/, subUA)) {
	                        oUA.mobile = 'Apple'; // iPhone or iPod Touch
	
	                        match = strMatchSafe(subUA, /OS ([^\s]*)/, 1);
	                        match = match && convertVersionStringToNum(strReplaceSafe(match, /_/, '.'));
	                        oUA.ios = match;
	                        oUA.ipad = oUA.ipod = oUA.iphone = 0;
	
	                        match = strMatchSafe(subUA, /iPad|iPod|iPhone/, 0);
	
	                        if (match) {
	                            oUA[strlc(match, TRUE)] = oUA.ios;
	                        }
	
	                    } else {
	                        match = strMatchSafe(subUA, /NokiaN[^\/]*|Android \d\.\d|webOS\/\d\.\d/, 0);
	
	                        if (match) {
	                            // Nokia N-series, Android, webOS, ex: NokiaN95
	                            oUA.mobile = match;
	                        }
	
	                        if (regxTestSafe(/webOS/, subUA)) {
	                            oUA.mobile = 'WebOS';
	                            match = strMatchSafe(subUA, /webOS\/([^\s]*);/, 1);
	
	                            if (match) {
	                                oUA.webos = convertVersionStringToNum(match);
	                            }
	                        }
	
	                        if (regxTestSafe(/ Android/, subUA)) {
	                            oUA.mobile = 'Android';
	                            match = strMatchSafe(subUA, /Android ([^\s]*);/, 1);
	
	                            if (match) {
	                                oUA.android = convertVersionStringToNum(match);
	                            }
	                        }
	
	                        if (regxTestSafe(/Silk/, subUA)) {
	                            match = strMatchSafe(subUA, /Silk\/([^\s]*)\)/, 1);
	
	                            if (match) {
	                                oUA.silk = convertVersionStringToNum(match);
	                            }
	
	                            if (!oUA.android) {
	                                oUA.android = 2.34; //Hack for desktop mode in Kindle
	                                oUA.os = 'Android';
	                            }
	
	                            if (regxTestSafe(/Accelerated=true/, subUA)) {
	                                oUA.accel = true;
	                            }
	                        }
	                    }
	
	                    match = strMatchSafe(subUA, /(Chrome|CrMo)\/([^\s]*)/);
	                    if (match && match[1] && match[2]) {
	                        oUA.chrome = convertVersionStringToNum(match[2]); // Chrome
	                        oUA.safari = 0; //Reset safari back to 0
	
	                        if (match[1] === 'CrMo') {
	                            oUA.mobile = 'chrome';
	                        }
	
	                    } else {
	                        match = strMatchSafe(subUA, /AdobeAIR\/([^\s]*)/);
	
	                        if (match) {
	                            oUA.air = match[0]; // Adobe AIR 1.0 or better
	                        }
	                    }
	                }
	
	                if (!oUA.webkit) {
	                    match = strMatchSafe(subUA, /Opera[\s\/]([^\s]*)/, 1);
	                    if (match) {
	                        oUA.opera = convertVersionStringToNum(match);
	                        match = strMatchSafe(subUA, /Opera Mini[^;]*/, 0);
	
	                        if (match) {
	                            oUA.mobile = match; // ex: Opera Mini/2.0.4509/1316
	                        }
	                    } else {// not opera or webkit
	
	                        match = strMatchSafe(subUA, /MSIE ([^;]*)|Trident.*; rv:([0-9.]+)/);
	
	                        if (match) {
	                            match = match[1] || match[2];
	                            oUA.ie = convertVersionStringToNum(match);
	                        } else {// not opera, webkit, or ie
	                            match = strMatchSafe(subUA, /Gecko\/([^\s]*)/);
	
	                            if (match) {
	                                oUA[GECKO] = 1; // Gecko detected, look for revision
	                                match = strMatchSafe(subUA, /rv:([^\s\)]*)/, 1);
	
	                                if (match) {
	                                    oUA[GECKO] = convertVersionStringToNum(match);
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	
	            keyList = keys(oUAStrCache);
	            keyListCnt = keyList && keyList.length || 0;
	            if (keyListCnt > MAX_UA_CACHE_SIZE) {
	                delete oUAStrCache[keyList[0]];
	            }
	            oUAStrCache[subUA] = oUA;
	        }
	    }
	    try {
	        if (typeof process == TYPE_OBJ) {
	            if (process.versions && process.versions.node) {
	                oUA.os = process.platform;
	                oUA.nodejs = convertVersionStringToNum(process.versions.node);
	            }
	        }
	    } catch (e) {
	        oUA.nodejs = 0;
	    }
	
	    return oUA;
	}
	
	/**
	   * A formal data object carrying user-agent and browser feature information
	   *
	   * @name fitt.UA
	   * @class
	   * @param {String} [str=''] The user-agent string to use to set properties in the object. If not specified,
	   *                          it will attempt use the user-agent string from the browser dom (if running in a browser),
	   *                          via navigator.userAgent
	  */
	
	/**
	      * Carries the major version number of the browser if it's Internet Explorer, otherwise 0
	      *
	      * @name fitt.UA#ie
	      * @type {Number}
	      * @default 0
	      *
	     */
	
	/**
	         * Carries the major version number of the browser if it's Microsoft Edge, otherwise 0
	         *
	         * @name fitt.UA#edge
	         * @type {Number}
	         * @default 0
	        */
	
	/**
	            * Carries the major version number of the browser if it's Opera, otherwise 0
	            *
	            * @name fitt.UA#opera
	            * @type {Number}
	            * @default 0
	           */
	
	/**
	               * Carries the major version number of the browser if it's Gecko (thunderbird, firefox, old school mozilla/netscape), otherwise 0
	               *
	               * @name fitt.UA#gecko
	               * @type {Number}
	               * @default 0
	               *
	              */
	
	/**
	                  * Carries the major version number of the browser if it's Webkit based (usually Safari, old Chrome), otherwise 0
	                  *
	                  * @name fitt.UA#webkit
	                  * @type {Number}
	                  * @default 0
	                 */
	
	/**
	                     * Carries the major version number of the browser if it's Safari, otherwise 0
	                     *
	                     * @name fitt.UA#safari
	                     * @type {Number}
	                     * @default 0
	                    */
	
	/**
	                        * Carries the major version number of the browser if it's Chrome, otherwise 0
	                        *
	                        * @name fitt.UA#chrome
	                        * @type {Number}
	                        * @default 0
	                       */
	
	/**
	                           * Carries the major version number of the browser if it's Adobe Air, otherwise 0
	                           *
	                           * @name fitt.UA#air
	                           * @type {Number}
	                           * @default 0
	                          */
	
	function UA(str)
	{
	    var me = this;
	
	    if (!kindOf(me, $UA)) return new UA();
	
	    if (str) {
	        me = mix(me, UA_parse(str), TRUE, TRUE);
	    } else {
	        me = mix(me, $UA, TRUE, TRUE);
	    }
	    return me;
	}
	
	function UA_parse(str)
	{
	    var oUA = new UA();
	
	    return doParse(oUA, str);
	}
	
	function UA_isMobile(str)
	{
	    var oUA = new UA();
	
	    doParse(oUA, str);
	
	    return !!oUA.mobile;
	}
	
	$UA.ie =
	$UA.edge =
	$UA.opera =
	$UA.gecko =
	$UA.webkit =
	$UA.safari =
	$UA.chrome =
	$UA.air =
	$UA.ipod =
	$UA.ipad =
	$UA.iphone =
	$UA.android =
	$UA.webos =
	$UA.silk =
	$UA.nodejs =
	$UA.phantomjs = 0;
	
	$UA.accel = FALSE;
	$UA.mobile =
	$UA.ios =
	$UA.os =
	$UA.caja = "";
	$UA.parse =
	UA.parse = UA_parse;
	UA[PROTO] = $UA;
	
	if (sNavUA) {
	    doParse($UA, sNavUA);
	}
	
	exp.UA = UA;
	exp.isMobile = UA_isMobile;
	
	if (typeof module !== TYPE_UNDEF) {
	    module.exports = exp;
	}
	
	fitt.ns("fitt.UA", UA);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {var fitt = __webpack_require__(425),
	getDispatch = __webpack_require__(778).getDispatch,
	PromiseRetry = __webpack_require__(785),
	debug = __webpack_require__(441)('fitt-http'),
	ECONNABORTED = 'ECONNABORTED',
	ERR_MULTIPLIER = 1.65,
	traceWrap,writer,
	promiseRetry;
	
	/**
	               * Internal function that handles returned promise from dispatch and request preparations
	               *
	               * @name fitt-http#sendRequest
	               * @function
	               * @param {String} url - The resource to request
	               * @param {Object} config - The object containing all incoming config parameters
	               * @return {Promise}
	               */
	
	function sendRequest(url, config) {
	
		// Flatten headers
		config.headers = fitt.mix({}, [config.method_headers[config.method] || {}, config.headers || {}]);
	
		var dispatch = getDispatch(config.dispatch),
		attempts = config && config.attempts,
		retryConfig;
	
		if (config.transformRequest) {
			fitt.forEach(config.transformRequest, function (fn) {
				config.data = fn(config.data, config.headers);
			});
		}
	
		if (config.tracing) {
			if (!process.browser) {// Enable http tracing on server-only
				traceWrap = __webpack_require__(784);
				dispatch = traceWrap(dispatch, url, config);
			}
		}
	
		if (attempts) {
			retryConfig = { attempts: attempts };
		}
	
		function sendRequestRetry(err, retries) {
			// If request times out, try w/ a slightly higher timeout
			if (err && err.code === ECONNABORTED && retries) {
				config = fitt.mix({}, [config, { timeout: getTimeout(config.timeout, retries) }]);
			}
			return dispatch(url, config);
		}
	
		promiseRetry = new PromiseRetry(sendRequestRetry, retryConfig);
	
		return promiseRetry.try().then(
		function (response) {
			debug('Response received', url, response.status);
	
			// Validate? Transform?
			if (config.transformResponse) {
				fitt.forEach(config.transformResponse, function (fn) {
					response.data = fn(response.data, response.headers);
				});
			}
	
			// Write response to disk?
			if (!process.browser) {
				if (config.writeResponse) {
					writer = __webpack_require__(786);
					writer(config.writeResponse, response);
				}
			}
	
			return response;
		},
		function (reason) {
			return Promise.reject(reason);
		});
	
	}
	
	/**
	   * Calculate request timeout based on retries
	   *
	   * @param  {Number} timeout  Original timeout
	   * @param  {Number} retries  Number of times, request was retried
	   * @return {Number}
	   */
	
	function getTimeout(timeout, retries) {
		return Math.floor(timeout * Math.pow(ERR_MULTIPLIER, retries));
	}
	
	if (typeof module !== fitt.TYPE_UNDEF) {
		module.exports = sendRequest;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {
	var fitt = __webpack_require__(425),
	encURIComp = fitt.encURIComp,
	cstr = fitt.cstr,
	cnum = fitt.cnum,
	isObj = fitt.isObj,
	owns = fitt.owns,
	default_headers = {
		'Content-Type': 'application/x-www-form-urlencoded' };
	
	
	var JSON_EXP = /\bjson\b/,
	FORM_EXP = /\bx-www-form-urlencoded\b/;
	
	function getDispatch(descriptor) {
		var dispatch;
		if (process.browser) {
			// For browsers use XHR
			dispatch = __webpack_require__(779);
		} else {
			// For node use HTTP or mock loader
			if (descriptor === 'mock') {
				dispatch = __webpack_require__(782);
			} else {
				dispatch = __webpack_require__(784);
			}
		}
		return dispatch;
	}
	
	function transformJSON(data, headers) {
		var contentTypeHeader = cstr(headers && headers['content-type']),
		isJSON = contentTypeHeader && JSON_EXP.test(contentTypeHeader);
	
		if (data && !isObj(data) && isJSON) {
			return JSON.parse(data);
		}
		return data;
	}
	
	function transformHeaderData(data, headers) {
		var contentTypeHeader = cstr(headers && headers['Content-Type']),
		str = [],
		p,pval;
	
		if (contentTypeHeader && FORM_EXP.test(contentTypeHeader)) {
			for (p in data) {
				pval = owns(data, p) ? cstr(data[p]) : '';
				if (pval) {
					str.push(encURIComp(p) + "=" + encURIComp(pval));
				}
			}
			return str.join("&");
		}
		return data;
	}
	
	if (typeof module !== fitt.TYPE_UNDEF) {
		module.exports = {
	
			getDispatch: getDispatch,
	
			headers: {
				'Accept': 'application/json, text/plain, */*' },
	
	
			method: 'GET',
	
			method_headers: {
				patch: default_headers,
				post: default_headers,
				put: default_headers },
	
	
			timeout: process.browser ? 5000 : 3000,
	
			tracing: false,
	
			transformRequest: [transformHeaderData],
	
			transformResponse: [transformJSON],
	
			validateResponse: function (response) {
				var httpConfig = response && response.config,
				httpMethod = cstr(httpConfig && httpConfig.method),
				httpStatus = cnum(response && response.status, 0),
				ret = false;
	
				if (httpMethod === 'head') {
					ret = httpStatus === 404;
				} else {
					ret = httpStatus >= 200 && httpStatus < 300;
				}
				return ret;
			} };
	
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	var TYPE_UNDEF = 'undefined',
	WITH_CREDS = 'withCredentials',
	SET_REQ_HEADER = 'setRequestHeader',
	RESP_TYPE = 'responseType',
	LOAD_EVT = 'onreadystatechange',
	TIMEOUT_EVT = 'ontimeout',
	ERR_EVT = 'onerror',
	PROGRESS_EVT = 'onprogress',
	MAX_TIMEOUT = 60000,
	
	fitt = __webpack_require__(425),
	_get = __webpack_require__(737),
	cstr = fitt.cstr,
	cnum = fitt.cnum,
	struc = fitt.struc,
	strlc = fitt.strlc,
	mix = fitt.mix,
	forEach = fitt.forEach,
	
	FittURL = __webpack_require__(773),
	FittParamHash = __webpack_require__(772),
	
	FittHTTPCoreUtils = __webpack_require__(780),
	createErr = FittHTTPCoreUtils.createError,
	parseHeaders = FittHTTPCoreUtils.parseHeaders,
	
	fittHTTPCoreSettle = __webpack_require__(781);
	
	function FittXHRHttpResponse(responseData, respStatus, statusText, respHeaders, config, url) {
	
		var me = this,
		isIE204 = respStatus === 1223;
	
		me.data = responseData;
		me.status = isIE204 ? 204 : respStatus;
		me.statusText = isIE204 ? 'No Content' : cstr(statusText);
		me.headers = respHeaders;
		me.config = config;
		me.url = url;
	}
	
	function removeXHREvtHandlers(requestXHR) {
		if (requestXHR) {
			try {
				requestXHR[LOAD_EVT] =
				requestXHR[ERR_EVT] =
				requestXHR[TIMEOUT_EVT] = null;
			} catch (e) {}
		}
	}
	
	/**
	   * Handles dispatching duties for browser usage (client-side)
	   *
	   * @param {String} url - The resource to request
	   * @param {Object} config - The object containing all incoming config parameters
	   * @returns {Promise}
	   */
	function xhr(url, config) {
		return new Promise(function (resolve, reject) {
			var requestData = config && config.data,
			requestHeaders = config && config.headers,
			request = new XMLHttpRequest(),
			/**
	                                   * [Client-only]
	                                   * Set the `directUrl` flag to true, to make a request without parsing the url and its params.
	                                   * Can be used to make a REST API request that accepts duplicate params.
	                                   *
	                                   * Example: http://fan.core.api.qa.espn.go.com/apis/v2/fans/{SWID}/preferences?id=ABC&id=DEF&id=GHI
	                                   *
	                                   * NOTE THAT AS of Jan 2018 the above comment is invalid b/c fitt-paramhash was updated
	                                   * to support the above use case
	                                   *
	                                   */
			directUrl = config && config.directUrl,
			oURL = new FittURL(url),
			httpMethod = struc(config && config.method) || 'GET',
			canceler = config && config.canceler,
			cancelerPromise = canceler && canceler.promise,
			confRespType = config && config[RESP_TYPE],
			configTimeout = cnum(config && config.timeout, 100, 100),
			inProgress = false,
			timer;
	
			oURL.params = new FittParamHash(mix({}, [oURL.params, config && config.params]));
	
			request.open(httpMethod, directUrl ? url : cstr(oURL), true);
	
			// Set up cancellation
			if (cancelerPromise) {
				cancelerPromise.then(function (reason) {
					removeXHREvtHandlers(request);
					try {request.abort();} catch (e) {}
					reject(reason);
					request = null;
				});
			}
	
			// Set the request timeout in MS
			request.timeout = configTimeout;
	
			// Listen to the progress event
			request[PROGRESS_EVT] = function xhr_onProgress(e) {
				var loaded = e && e.loaded || _get(this, 'response.length') || 0;
	
				// Update the `inProgress` flag, if we've actually started receiving a response
				if (loaded) {
					inProgress = true;
				}
			};
	
			// Listen for ready state
			request[LOAD_EVT] = function () {
	
				var responseHeaders,
				responseData,
				requestStatus,
				requestRespURL,
				response;
	
				if (!request || request.readyState !== 4) {
					return;
				}
	
				// Response has been received so kill timer that handles request timeout
				xhr_clearTimeout();
	
				requestStatus = request.status;
				requestRespURL = cstr(request.responseURL);
	
				// The request errored out and we didn't get a response, this will be
				// handled by onerror instead
				// With one exception: request that using file: protocol, most browsers
				// will return status as 0 even though it's a successful request
				if (requestStatus === 0 && !(requestRespURL && requestRespURL.indexOf('file:') === 0)) {
					return;
				}
	
				// Prepare the response
				try {
					responseHeaders = request.getAllResponseHeaders();
					responseHeaders = parseHeaders(responseHeaders);
				} catch (e) {
					responseHeaders = {};
				}
				try {
					responseData = !confRespType || confRespType === 'text' ? request.responseText : request.response;
				} catch (e) {
					responseData = null;
				}
	
				response = new FittXHRHttpResponse(responseData, requestStatus,
				request.statusText, responseHeaders,
				config, url);
	
				fittHTTPCoreSettle(resolve, reject, response);
	
				// Clean up request
				removeXHREvtHandlers(request);
				request = null;
			};
	
			// Handle low level network errors
			request[ERR_EVT] = function xhr_onError() {
				xhr_clearTimeout();
	
				// Real errors are hidden from us by the browser
				// onerror should only fire if it's a network error
				reject(createErr('Network Error', url, config));
	
				// Clean up request
				removeXHREvtHandlers(request);
				request = null;
			};
	
			// Handle timeout
			request[TIMEOUT_EVT] = function xhr_onTimeout() {
				var timeout = configTimeout;
	
				if (inProgress && !timer) {
					// Response is being received, defer reject by setting a longer timeout
					timeout = Math.max(MAX_TIMEOUT - configTimeout, 0);
					xhr_setTimeout(timeout);
				} else {
					xhr_endRequest(timeout);
				}
	
			};
	
			function xhr_setTimeout(timeout) {
				timer = setTimeout(function xhr_extendedTimeout() {
					xhr_endRequest(timeout);
				}, timeout);
			}
	
			function xhr_clearTimeout() {
				clearTimeout(timer);
				timer = null;
			}
	
			function xhr_endRequest(timeout) {
				reject(createErr('timeout of ' + timeout + 'ms exceeded', url, config, 'ECONNABORTED'));
	
				inProgress = false;
	
				if (request) {
					// Clean up request
					request = null;
				}
			}
	
			// Add headers to the request
			if (SET_REQ_HEADER in request) {
				forEach(requestHeaders, function (val, key) {
					if (typeof requestData == TYPE_UNDEF && strlc(key) === 'content-type') {
						// Remove Content-Type if data is undefined
						delete requestHeaders[key];
					} else {
						// Otherwise add header to the request
						try {request[SET_REQ_HEADER](key, val);} catch (e) {}
					}
				});
			}
	
			// Add withCredentials to request if needed
			if (config && config[WITH_CREDS]) {
				request[WITH_CREDS] = true;
			}
	
			// Add responseType to request if needed
			if (confRespType) {
				try {
					request[RESP_TYPE] = confRespType;
				} catch (e) {
					if (request[RESP_TYPE] !== 'json') {
						throw e;
					}
				}
			}
	
			if (typeof requestData == TYPE_UNDEF) {
				requestData = null;
			}
	
			// Send the request
			request.send(requestData);
		});
	}
	
	if (typeof module !== TYPE_UNDEF) {
		module.exports = xhr;
	}

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	var fitt = __webpack_require__(425),
	forEach = fitt.forEach,
	cstr = fitt.cstr,
	trim = fitt.trim,
	strlc = fitt.strlc;
	
	/**
	                     * Parse headers into an object
	                     *
	                     * ```
	                     * Date: Wed, 27 Aug 2014 08:58:49 GMT
	                     * Content-Type: application/json
	                     * Connection: keep-alive
	                     * Transfer-Encoding: chunked
	                     * ```
	                     *
	                     * @param {String} headers Headers needing to be parsed
	                     * @returns {Object} Headers parsed into an object
	                     */
	function parseHeaders(headers) {
	  var parsed = {},
	  parsedItem,
	  key,
	  val,
	  i;
	
	  headers = cstr(headers);
	
	  if (headers) {
	    forEach(headers.split('\n'), function parser(line) {
	      i = line ? line.indexOf(':') : -1;
	      if (i != -1) {
	        key = strlc(trim(line.substr(0, i)));
	        val = trim(line.substr(i + 1));
	
	        if (key) {
	          parsedItem = parsed[key];
	          parsed[key] = parsedItem ? parsedItem + ', ' + val : val;
	        }
	      }
	    });
	  }
	
	  return parsed;
	}
	
	/**
	   * Create an Error with the specified message, config, error code, and response.
	   *
	   * @param {string} message The error message.
	   * @param {string} url The URL being requested.
	   * @param {Object} config The config.
	   * @param {string} [code] The error code (for example, 'ECONNABORTED').
	   * @param {number} [status] The response status (for example, 404).
	   * @param {string|Object} [data] Response data.
	   * @returns {Error} The created error.
	   */
	function createError(message, url, config, code, status, data) {
	  var error = new Error(message);
	
	  error.config = config;
	  error.url = url;
	
	  if (code) {
	    error.code = code;
	  }
	
	  if (status) {
	    error.status = status;
	  }
	
	  if (data) {
	    error.data = data;
	  }
	
	  return error;
	}
	
	if (true) {
	  module.exports = {
	    parseHeaders: parseHeaders,
	    createError: createError };
	
	}

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	var FittHTTPCoreUtils = __webpack_require__(780),
	createError = FittHTTPCoreUtils.createError;
	
	/**
	                                              * Resolve or reject a Promise based on response status.
	                                              *
	                                              * @param {Function} resolve - A function that resolves the promise.
	                                              * @param {Function} reject - A function that rejects the promise.
	                                              * @param {Object} response - The response.
	                                              */
	function settle(resolve, reject, response) {
	
	  var respConfig = response && response.config,
	  validateResponse = respConfig && respConfig.validateResponse,
	  respStatus = response && response.status,
	  respURL = response && response.url,
	  respData = response && response.data,
	  options = respConfig && respConfig.options,
	  allowError = options && options.allowError,
	  err;
	
	  if (allowError || !respStatus || typeof validateResponse != 'function' || validateResponse(response)) {
	    resolve(response);
	    return;
	  }
	
	  err = createError('HTTP request failed with status code ' + respStatus + ': ' + respURL,
	  respURL,
	  respConfig,
	  null,
	  respStatus,
	  respData);
	
	
	  reject(err);
	}
	
	if (true) {
	  module.exports = settle;
	}

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {/**
	 Intended for use with mock data
	 **/
	
	var fitt = __webpack_require__(425),
	fs = __webpack_require__(783),
	utils = __webpack_require__(780);
	
	
	function mock(url, config) {
	    return new Promise(function (resolve, reject) {
	        // change url to be the path + filename of file on disk
	        if (url) {
	            fs.readFile(url, 'utf8', function (err, data) {
	                if (err) {
	                    reject(utils.createError(
	                    'Mock data request failed.',
	                    url,
	                    config));
	
	                } else {
	                    var response = JSON.parse(data);
	                    resolve(response);
	                }
	            });
	        } else {
	            console.log('Mock data dispatch used but no file path provided.');
	        }
	    });
	}
	
	
	if (typeof module !== fitt.TYPE_UNDEF) {
	    module.exports = mock;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 783 */
/***/ (function(module, exports) {



/***/ }),
/* 784 */
/***/ (function(module, exports) {

	module.exports = undefined;

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	var fitt = __webpack_require__(425),
	isFunc = fitt.isFunc,
	PROTO = fitt.PROTO,
	MAX_ATTEMPTS = 2;
	
	
	/**
	                   * A utility to retry Promises.
	                   *
	                   * @param {Function} fn       Function to retry
	                   * @param {Object} options    Options
	                   */
	function PromiseRetry(fn, options) {
	    var me = this,
	    attempts = options && options.attempts || MAX_ATTEMPTS,
	    getWaitTime = options && options.getWaitTime;
	
	    if (!isFunc(fn)) {
	        throw new Error('Missing `function` argument.');
	    }
	
	    if (isFunc(getWaitTime)) {
	        me.getWaitTime = getWaitTime;
	    }
	
	    me.fn = fn;
	    me.retries = 0;
	    me.attempts = attempts;
	}
	
	
	function PromiseRetry_try(err) {
	    var me = this;
	
	    return new Promise(function PromiseRetryWrapper(resolve, reject) {
	
	        var wrappedPromise = me.fn(err, me.retries);
	
	        if (!(wrappedPromise instanceof Promise)) {
	            reject('Function did not return a Promise.');
	        }
	
	        wrappedPromise.
	        then(function PromiseRetry_onSuccess(response) {
	            resolve(response);
	        }).
	        catch(function PromiseRetry_onError(error) {
	
	            var timeout;
	
	            if (++me.retries < me.attempts) {
	
	                if (me.getWaitTime) {
	                    timeout = me.getWaitTime.apply(me, arguments);
	                }
	
	                if (timeout) {
	                    setTimeout(function () {
	                        resolve(me.try(error));
	                    }, timeout);
	                } else {
	                    resolve(me.try(error));
	                }
	
	            } else {
	                reject(error);
	            }
	
	        });
	
	    });
	}
	
	
	PromiseRetry[PROTO] = {
	    try: PromiseRetry_try };
	
	
	module.exports = PromiseRetry;

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {var fitt = __webpack_require__(425),
	fs = __webpack_require__(783),
	path = __webpack_require__(427);
	
	module.exports = function (config, response) {
	    var writePath = config && config.path,
	    callback = config && config.callback,
	    dirname = path.dirname(writePath);
	
	    if (!fs.existsSync(dirname)) {
	        fs.mkdirSync(path.resolve(dirname));
	    }
	
	    if (fitt.isObj(response)) {
	        response = JSON.stringify(response);
	    }
	
	    // async write to disk
	    fs.writeFile(writePath, response, function (err) {
	        if (err) {
	            console.log('fitt-http write error');
	        }
	        callback && callback(err, writePath, response);
	    });
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	var fitt = __webpack_require__(425);
	
	/**
	                             * 	Wrapped promise that allows for canceling of initiated requests
	                             *
	                             * @name {Object} Canceler
	                             * @constructor
	                             * @public
	                             */
	
	function Canceler() {
		// Internal methods to resolve promise
		this.cancel = null;
	
		this.promise = new Promise(function (resolve, reject) {
			/**
	                                                         * @name Canceler.cancel
	                                                         * @instance
	                                                         * @param {String | Object} - object that gets passed through to caller's catch function
	                                                         */
			this.cancel = resolve;
		}.bind(this));
		Object.freeze(this);
	}
	
	if (typeof module !== fitt.TYPE_UNDEF) {
		module.exports = Canceler;
	}

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	var fitt = __webpack_require__(425),
	memSize = __webpack_require__(789),
	http = __webpack_require__(769),
	parseMaxAge = http.parseMaxAge,
	LRUCache = __webpack_require__(794),
	_orderBy = __webpack_require__(796),
	_clamp = __webpack_require__(801),
	ns = 'fitt-cache',
	debug = __webpack_require__(441)(ns),
	now = Date.now,
	PROTOTYPE = fitt.PROTO,
	empty = fitt.empty,
	
	MAX_MEM_SIZE = 134217728, // 128MB max (actual shallow size)
	MAX_CACHE_SIZE = 4096, // number of items, not actual size
	MAX_PURGE_ATTEMPTS = 5,
	ONE_HUNDRED = 100,
	MAX_PCT = 50,
	MIN_PCT = 10,
	MAX_PURGE_INTERVAL = 45000,
	MIN_PURGE_INTERVAL = 5000,
	
	PROP_USED = 'used',
	PROP_SIZE = 'size',
	PROP_MAXAGE = 'maxAge',
	SORT_ASC = 'asc',
	SORT_DESC = 'desc',
	PROP_MEMSIZE = '__memsize';
	
	/**
	                             * In-memory caching behavior
	                             *
	                             * <pre>
	                             Usage:
	                             var cache = new Cache();
	                            
	                             // HTTP caching
	                             cache.getHttp('https://httpbin.org/get')
	                                .then((response) => {
	                                    // response.fromCache will be a boolean indicating whether the response came from cache or request
	                                });
	                            
	                             // Get/Set
	                             cache.set('foo', 'bar'); // returns true
	                             cache.get('foo'); // returns 'bar'
	                             </pre>
	                             *
	                             * @class
	                             * @name fitt.Cache
	                             * @param {Object} config Contains configuration options for instance
	                             * @public
	                             */
	
	function Cache(config) {
	    var me = this,
	    defaults = {
	        maxSize: MAX_CACHE_SIZE,
	        /*
	                                  * Re-enabling, and ensuring in our request handler that we check
	                                  * our meta-data on the response so we don't inadvertantly re-set the
	                                  * expire time
	                                 */
	        staleWhileRevalidate: 300 };
	
	
	    if (config) {
	        config = fitt.mix({}, [defaults, config]);
	    } else {
	        config = defaults;
	    }
	
	    me.store = new LRUCache(config);
	    me.timer =
	    me.lastPurger =
	    me.lastPurgeDate =
	    me.currentMaxPct =
	    me.currentInterval =
	    me.lastPurgeAt = null;
	    me.purgeAttempts =
	    me.lastPurgeItemCount =
	    me.totalSuccessfulPurges =
	    me.totalPurgeIterations =
	    me.lastPurgeMemFreed = 0;
	    me.maxMemSize = config.maxMemSize || MAX_MEM_SIZE;
	    me.maxPurgeAttemps = config.maxPurgeAttemps || MAX_PURGE_ATTEMPTS;
	    me.maxPurgeInterval = config.maxPurgeInterval || MAX_PURGE_INTERVAL;
	    me.minPurgeInterval = config.minPurgeInterval || MIN_PURGE_INTERVAL;
	    me.minPurgePct = config.minPurgePct || MIN_PCT;
	    me.maxPurgePct = config.maxPurgePct || MAX_PCT;
	}
	
	/**
	   * Removes an item from the cache
	   *
	   * @name fitt.Cache#delete
	   * @function
	   * @public
	   * @param key
	   * @returns {Boolean} Indicates whether or not the operation was successful
	   */
	
	function deleteItem(key) {
	    return this.store.delete(key);
	}
	
	/**
	   * Get an item from the cache
	   *
	   * @name fitt.Cache#get
	   * @function
	   * @public
	   * @param key
	   * @returns {Object|String|Array|Number} Item from the cache if exists, or undefined if item does not exist
	   */
	
	function get(key) {
	    debug('Get', key);
	    return this.store.get(key);
	}
	
	/**
	   * Convenience method that enables caching/retrieving/validation of HTTP responses. Allows for custom caching
	   * policy on a per-call basis. Promise is resolved with entire normalized response object including headers, body, etc.
	   *
	   * @name fitt.Cache#getHttp
	   * @function
	   * @public
	   * @param {String} url URL to request. Also doubles as the caching key.
	   * @param {Object} httpConfig Config object that gets passed to fitt-http module.
	   * @param {String|Function|Object} cachePolicy Either a string/object representing caching policy or a function that will return a string/object representing policy. See: https://github.com/cyberthom/stale-lru-cache#setkey-value-options
	   * @returns {Promise} Will get resolved with normalized response object either from cache or from HTTP operation
	   */
	
	function getHttp(url, httpConfig, cachePolicy) {
	
	    return new Promise(function (resolve, reject) {
	
	        // Function that gets called by stale-lru-cache to revalidate stale content
	        function revalidate(url, callback) {
	            var startRequest = now();
	
	            debug('Revalidating URL', url, cachePolicy);
	
	            http.request(url, httpConfig).
	            then(function (response) {
	                var curTime = now(),
	                maxAge = 0,
	                cachePolicyType,
	                _cachePolicy;
	
	                /*
	                               * setup response meta-data
	                               *
	                               *  .fetched == Timestamp in ms that the response was received
	                               *  .age == Number of ms that this response has been in cache
	                               *  .used == Number of times the response was returned from cache
	                               *  .responseTime == Amount of time it took to receive a response
	                               *  .cachePolicy == The cache policy handling for the response
	                               *  .expireTime == The timestamp in ms that the response should expire, if not cacheable
	                               *                 defaults to the current time of the response
	                               *
	                               *  .fromCache == boolean true/false if the response was not in cache
	                              */
	
	                response.fetched = curTime;
	                response.age = 0;
	                response.used = 0;
	                response.responseTime = curTime - startRequest;
	
	                if (cachePolicy) {
	                    cachePolicyType = typeof cachePolicy;
	                    if (cachePolicyType === 'string' || cachePolicyType === 'object') {
	                        _cachePolicy = cachePolicy;
	                    } else if (cachePolicyType === 'function') {
	                        _cachePolicy = cachePolicy(response);
	                    }
	                }
	                /*
	                  *
	                  * Add a stricter check for `_cachePolicy`.
	                  *
	                  * In certain cases, the cachePolicy would default to an empty Object and a truthy check was insufficient,
	                  * that would prevent the response cache headers from being honored.
	                  */
	                if (empty(_cachePolicy)) {
	                    /**
	                                           * Read the cach-control header from the response or fallback to max-age=0
	                                           */
	                    _cachePolicy = response.headers['cache-control'] || 'max-age=0';
	                }
	
	                response.cachePolicy = _cachePolicy;
	
	                if (_cachePolicy) {
	                    maxAge = parseMaxAge(_cachePolicy);
	                }
	
	                response.maxAge = maxAge;
	                response.expireTime = curTime + maxAge * 1000;
	
	                // Calculate response size if prop is absent
	                if (!response[PROP_MEMSIZE]) {
	                    response[PROP_MEMSIZE] = memSize(response);
	                }
	
	                callback(null, response, _cachePolicy);
	            }).
	            catch(function (error) {
	                callback(error);
	            });
	        }
	        this.store.wrap(url, revalidate, function (error, response) {
	            if (error) {
	                reject(error);
	            } else {
	                response.age = now() - response.fetched;
	                if (!response.used) {
	                    response.used = 1;
	                    response.fromCache = false;
	                } else {
	                    response.used++;
	                    response.fromCache = true;
	                }
	                debug('HTTP response retrieved', 'fromCache: ' + response.fromCache, 'timestamp: ' + response.fetched);
	                resolve(response);
	            }
	        });
	    }.bind(this));
	}
	
	/**
	   * Returns a boolean indicating whether a value matching the provided key exists in the cache
	   *
	   * @name fitt.Cache#has
	   * @function
	   * @public
	   * @param {String} key Caching key to look up
	   * @returns {Boolean}
	   */
	
	function has(key) {
	    return this.store.has(key);
	}
	
	/**
	   * Returns a boolean indicating whether a particular cached value is stale based on provided rules
	   *
	   * @name fitt.Cache#isStale
	   * @function
	   * @public
	   * @param key Caching key to look up
	   * @returns {Boolean}
	   */
	
	function isStale(key) {
	    return this.store.isStale(key);
	}
	
	/**
	   * Returns all the keys stored in the cache instance
	   *
	   * @name fitt.Cache#keys
	   * @function
	   * @public
	   * @returns {Array} An array of all the keys stored in the cache
	   */
	
	function keys() {
	    return this.store.keys();
	}
	
	/**
	   * Removes all cache entries that are past configured maxAge + staleWhileRevalidate timeframe
	   * Unless explicitly forced to clear.
	   *
	   * @name fitt.Cache#purge
	   * @function
	   * @public
	   *
	   * @param  {Number}     maxPct      Max percentage of memory to be cleared in a single operation
	   * @param  {Boolean}    force       Force clears memory while still fresh.
	   * @param  {Number}     interval    Timer interval
	   * @return {Object}                 Stats for the purge operation
	   */
	
	function purge(maxPct, force, interval) {
	    var me = this,
	    maxMemSize = me.maxMemSize,
	    purgeAttempts = me.purgeAttempts,
	    manifest = me.getManifest(),
	    totalMemUsed = me.getMemSize(manifest),
	    memExceedsLimit = totalMemUsed > maxMemSize,
	    forcePurge = memExceedsLimit && me.purgeAttempts === me.maxPurgeAttemps,
	    totalSuccessfulPurges,
	    maxMemToClear,
	    totalMemCleared,
	    itemsCleared,
	    clearedKeys,
	    lastPurger,
	    purger,
	    purgerStats;
	
	    // Try `force` purge if usage exceeds limit after max purge attempts
	    if (forcePurge) {
	        force = true;
	        me.purgeAttempts = 0;
	    }
	
	    maxPct = getMaxPctByMemUsage(totalMemUsed, maxMemSize, MIN_PCT, maxPct);
	    // percentage of total memory used that can be removed at once
	    maxMemToClear = Math.round(totalMemUsed * (maxPct / ONE_HUNDRED));
	
	    purger = getPurger(++me.totalPurgeIterations);
	    purgerStats = purger.call(me, manifest, maxMemToClear, forcePurge, interval);
	    totalMemCleared = purgerStats.totalMemCleared;
	    itemsCleared = purgerStats.itemsCleared;
	    clearedKeys = purgerStats.clearedKeys;
	
	    // If used memory exceeds limit and we haven't cleared anything,
	    // bump purge attempts
	    if (memExceedsLimit && totalMemCleared === 0 && purgerStats.default) {
	        me.purgeAttempts++;
	    }
	
	    if (itemsCleared) {
	        me.lastPurgeAt = new Date();
	        me.lastPurgeItemCount = itemsCleared;
	        me.lastPurgeMemFreed = totalMemCleared;
	
	        me.totalSuccessfulPurges++;
	    }
	
	    lastPurger = me.lastPurger =
	    purgerStats.name;
	    totalSuccessfulPurges = me.totalSuccessfulPurges;
	
	    me.lastPurgeDate = new Date();
	    me.currentMaxPct = maxPct;
	
	    return {
	        purgeAttempts: purgeAttempts,
	        totalSuccessfulPurges: totalSuccessfulPurges,
	        totalMemUsed: totalMemUsed,
	        totalMemCleared: totalMemCleared,
	        clearedKeys: clearedKeys,
	        itemsCleared: itemsCleared,
	        lastPurger: lastPurger,
	        force: force };
	
	}
	
	/**
	   * Calculate the amount of memory to purge based on mem usage.
	   *
	   * @param  {Number} memUsed     Total memory used
	   * @param  {Number} memSize     Max memory size
	   * @param  {Number} minPct      Min percentage
	   * @param  {Number} maxPct      Max percentage
	   * @return {Number}
	   */
	function getMaxPctByMemUsage(memUsed, maxMem, minPct, maxPct) {
	    return Math.round(_clamp(ONE_HUNDRED * normalizeRange(memUsed, maxMem, 0), minPct, maxPct));
	}
	
	/**
	   * Calculate the interval before next purge run based on mem usage.
	   *
	   * @param  {Number} memUsed         Total memory used
	   * @param  {Number} memSize         Max memory size
	   * @param  {Number} minInterval     Min interval
	   * @param  {Number} maxInterval     Max interval
	   * @return {Number}
	   */
	function getIntervalByMemUsage(memUsed, maxMem, minInterval, maxInterval) {
	    return Math.round(_clamp((minInterval + (maxInterval - minInterval)) * normalizeRange(maxMem - memUsed, maxMem, 0), minInterval, maxInterval));
	}
	
	/**
	   * min-max normalization
	   *
	   * @param  {Number} val Input
	   * @param  {Number} max Maximum
	   * @param  {Number} min Minimum
	   * @return {Number}
	   */
	function normalizeRange(val, max, min) {
	    var maxMinDiff = max - min;
	
	    if (maxMinDiff === 0) {
	        return 1;
	    }
	
	    return (val - min) / maxMinDiff;
	}
	
	/**
	   * Get the Purger function that needs to execute,
	   * based on the arguments.
	   *
	   * @param  {Number} totalPurgeIterations    Total purge iterations
	   * @return {Function}                       Purger function to execute
	   */
	function getPurger(totalPurgeIterations) {
	    /**
	                                           * On every 3rd run, clear longlived least used items.
	                                           * TODO: Factor memory available and used?
	                                           */
	    return totalPurgeIterations % 3 === 0 ? purgeLongLivedLeastUsed : purgeStale;
	}
	
	/**
	   * Purge long lived items that are least used.
	   *
	   * @param  {Array} manifest         Cache manifest
	   * @param  {Number} maxMemToClear   Max memory to clean
	   * @param  {Boolean} force          Force clears memory while still fresh.
	   * @param  {Number} interval        Timer interval
	   * @return {Object}                 Purger activity stats
	   */
	function purgeLongLivedLeastUsed(manifest, maxMemToClear, force, interval) {
	    var me = this,
	    orderedManifest = _orderBy(manifest,
	    [
	    PROP_MAXAGE,
	    PROP_USED],
	
	    [
	    SORT_DESC,
	    SORT_ASC]),
	
	
	    clearedKeys = [],
	    cnt = orderedManifest && orderedManifest.length,
	    totalMemCleared = 0,
	    idx = 0,
	    itemsCleared = 0,
	    cacheEntry,
	    key,
	    used,
	    size,
	    age;
	
	    for (; idx < cnt; idx++) {
	        cacheEntry = orderedManifest[idx];
	        key = cacheEntry && cacheEntry.key;
	        used = cacheEntry && cacheEntry.used;
	        age = cacheEntry && cacheEntry.age;
	        size = cacheEntry && cacheEntry.size;
	
	        if (totalMemCleared < maxMemToClear) {
	            if (used <= 1 && age >= interval) {
	                me.delete(key);
	                clearedKeys.push(key);
	                itemsCleared++;
	                totalMemCleared += size;
	                debug('deleted', key, size, totalMemCleared, force);
	            }
	        } else {
	            break;
	        }
	
	    }
	
	    return {
	        name: 'purgeLongLivedLeastUsed',
	        totalMemCleared: totalMemCleared,
	        clearedKeys: clearedKeys,
	        itemsCleared: itemsCleared };
	
	
	}
	
	/**
	   * Stale items purger
	   * (default)
	   *
	   * @param  {Array} manifest         Cache manifest
	   * @param  {Number} maxMemToClear   Max memory to clean
	   * @param  {Boolean} force          Force clears memory while still fresh.
	   * @return {Object}                 Purger activity stats
	   */
	function purgeStale(manifest, maxMemToClear, force) {
	    var me = this,
	    orderedManifest = orderByPurgingPriority(manifest, force),
	    cnt = orderedManifest && orderedManifest.length,
	    clearedKeys = [],
	    totalMemCleared = 0,
	    idx = 0,
	    itemsCleared = 0,
	    cacheEntry,
	    key,
	    size;
	
	    for (; idx < cnt; idx++) {
	        cacheEntry = orderedManifest[idx];
	        key = cacheEntry && cacheEntry.key;
	        size = cacheEntry && cacheEntry.size;
	
	        if (totalMemCleared < maxMemToClear) {
	            // (has == false) - technically the cache still has the item,
	            // but it has expired and is past revalidation timeframe
	            if (!me.has(key) || force) {
	                clearedKeys.push(key);
	                me.delete(key);
	                itemsCleared++;
	                totalMemCleared += size;
	                debug('deleted', key, size, totalMemCleared, force);
	            }
	        } else {
	            break;
	        }
	    }
	
	    return {
	        name: 'purgeStale',
	        default: true,
	        clearedKeys: clearedKeys,
	        totalMemCleared: totalMemCleared,
	        itemsCleared: itemsCleared };
	
	}
	
	/**
	   * Enables purge timer
	   *
	   * @name fitt.Cache#enablePurger
	   * @function
	   * @public
	   *
	   * @param  {Number} interval    Polling interval
	   * @param  {Function} cb        Callback
	   * @return {undefined}
	   */
	function enablePurger(interval, cb) {
	    var me = this,
	    maxInterval = interval || me.maxPurgeInterval,
	    maxPct = me.maxPurgePct,
	    nextInterval,
	    memUsed,
	    stats;
	
	    me.timer = setTimeout(function cachePurgeTimer() {
	        stats = me.purge(maxPct, null, maxInterval);
	        memUsed = stats.totalMemUsed - stats.totalMemCleared;
	        nextInterval = getIntervalByMemUsage(memUsed, me.maxMemSize, me.minPurgeInterval, me.maxPurgeInterval);
	
	        me.currentInterval = nextInterval;
	
	        if (fitt.isFunc(cb)) {
	            cb(stats, nextInterval);
	        }
	
	        if (me.timer) {
	            me.enablePurger(nextInterval, cb);
	        }
	    }, maxInterval);
	}
	
	/**
	   * Clears the purge timer
	   *
	   * @name fitt.Cache#disablePurger
	   * @function
	   * @public
	   *
	   * @return {undefined}
	   */
	function disablePurger() {
	    var me = this;
	
	    clearTimeout(me.timer);
	    me.timer = null;
	}
	
	/**
	   * Get `memUsed`, actual memory size of LRU cache
	   *
	   * @name fitt.Cache#getMemSize
	   * @function
	   * @public
	   *
	   * @param {Array} manifest  Cache manifest
	   * @return {Number}         Memory size in bytes
	   */
	
	function getMemSize(manifest) {
	    var me = this,
	    totalSize = 0;
	
	    manifest = manifest || me.getManifest();
	
	    fitt.forEach(manifest, function (val) {
	        totalSize += val.size;
	    });
	
	    return totalSize;
	}
	
	/**
	   * Builds a cache manifest file, based on the stored values
	   *
	   * @name fitt.Cache#getManifest
	   * @function
	   * @public
	   *
	   * @return {Array}      Cache manifest
	   */
	
	function getManifest() {
	    var me = this,
	    // LRU's internal cache Map
	    map = me && me.store && me.store._map,
	    cacheManifest = [],
	    curTime = now();
	
	    if (map instanceof Map) {
	        map.forEach(function (v, key) {
	            var src = v && v.value && v.value.value,
	            maxAge,size,used,responseTime,
	            fromCache,fetched,age,expireTime,cachePolicy,memSize;
	
	            if (src) {
	                maxAge = src.maxAge;
	                size = src[PROP_MEMSIZE];
	                used = src.used;
	                responseTime = src.responseTime;
	                fromCache = src.fromCache;
	                fetched = src.fetched;
	                expireTime = src.expireTime;
	                cachePolicy = src.cachePolicy;
	                age = src.age;
	                memSize = src.__memsize;
	
	                if (fetched > 0 && fetched <= curTime) {
	                    src.age = curTime - fetched;
	                }
	
	                // Normalize use count
	                if (!used || used < 0) {
	                    src.used = 1;
	                }
	
	                cacheManifest.push(
	                new CacheManifest(key, maxAge, size, used, responseTime, fromCache, fetched, age, expireTime, cachePolicy, memSize));
	
	            }
	        });
	    }
	
	    return cacheManifest;
	}
	
	/**
	   * CacheManifest
	   *
	   * @param {String} key          Cache Key
	   * @param {Number} maxAge       Max Age for the corresponding key
	   * @param {Number} size         Memory used
	   * @param {Number} used         Number of times, resource was used from Cache
	   * @param {Number} responseTime Time taken for receive API response
	   * @param {Boolean} fromCache   Indicates if response if from cache
	   * @param {Number} fetched      Timestamp in ms that the response was received
	   * @param {Number} age          Number of ms that this response has been in cache
	   * @param {Number} expireTime   The date/time after which the response is considered stale
	   * @param {Number} cachePolicy  Cache policy used for requesting the resource
	   * @param {Number} memSize      Size in memory
	   */
	
	function CacheManifest(key, maxAge, size, used, responseTime, fromCache, fetched, age, expireTime, cachePolicy, memSize) {
	
	    var me = this;
	
	    me.key = key;
	    me.maxAge = maxAge;
	    me.size = size;
	    me.used = used;
	    me.responseTime = responseTime;
	    me.fromCache = fromCache;
	    me.fetched = fetched;
	    me.expireTime = expireTime;
	    me.cachePolicy = cachePolicy;
	    me.age = age;
	    me.memSize = memSize;
	}
	
	
	/**
	   * Orders the Cache Manifest, based on purging priority
	   *
	   * @param  {Array}      cacheManifest   Cache Manifest
	   * @param  {Boolean}    forcePurge      Is being force purged
	   * @return {Array}                      Ordered cacheManifest
	   */
	
	function orderByPurgingPriority(cacheManifest, forcePurge) {
	    var sortProps = [
	    PROP_SIZE,
	    PROP_MAXAGE,
	    PROP_USED],
	
	    sortOrder = [
	    SORT_DESC,
	    SORT_DESC,
	    SORT_ASC];
	
	
	    // As usage exceeds limit, we may often end up force clearing,
	    // Change the sort order, to prioritize based on least used > maxAge > size
	    // TODO: revisit and tweak as required
	    if (forcePurge) {
	        sortProps = [
	        PROP_USED,
	        PROP_MAXAGE,
	        PROP_SIZE];
	
	
	        sortOrder = [
	        SORT_ASC,
	        SORT_DESC,
	        SORT_DESC];
	
	    }
	
	    return _orderBy(
	    cacheManifest,
	    sortProps,
	    sortOrder);
	
	}
	
	/**
	   * Removes all items from the cache
	   *
	   * @name fitt.Cache#reset
	   * @function
	   * @public
	   */
	
	function reset() {
	    this.store.reset();
	}
	
	/**
	   * Sets a key/value pair in the cache, applying the supplied caching policy or the default
	   *
	   * @name fitt.Cache#set
	   * @function
	   * @public
	   * @param {String} key
	   * @param {Object|String|Array|Number} value Value to be stored in the cache
	   * @param {Object|String} options Either an object or string representing caching policy. See: https://github.com/cyberthom/stale-lru-cache#setkey-value-options
	   */
	
	function set(key, value, options) {
	    var size = value && value[PROP_MEMSIZE];
	
	    if (value && !size) {
	        size = memSize(value);
	        value[PROP_MEMSIZE] = size;
	    }
	
	    debug('Set', key, value, options);
	    return this.store.set(key, value, options);
	}
	
	/**
	   * Returns the size of all the stored items in the cache
	   *
	   * @name fitt.Cache#size
	   * @function
	   * @public
	   * @returns {Number} Size of all the stored items
	   */
	
	function size() {
	    return this.store.size;
	}
	
	Cache[PROTOTYPE] = {
	    getMemSize: getMemSize,
	    getManifest: getManifest,
	    delete: deleteItem,
	    get: get,
	    getHttp: getHttp,
	    has: has,
	    isStale: isStale,
	    keys: keys,
	    purge: purge,
	    enablePurger: enablePurger,
	    disablePurger: disablePurger,
	    reset: reset,
	    set: set,
	    size: size };
	
	
	module.exports = Cache;

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var fitt = __webpack_require__(425),
	fittKeys = fitt.keys,
	fittCstr = fitt.cstr,
	TYPE_STR = fitt.TYPE_STR,
	TYPE_OBJ = fitt.TYPE_OBJ,
	TYPE_NUM = fitt.TYPE_NUM,
	TYPE_BOOL = fitt.TYPE_BOOL,
	
	// http://www.ecma-international.org/ecma-262/5.1/#sec-4.3.16
	// String is represented by 16-bit unsigned integer
	SIZE_STRING = 2,
	SIZE_BOOLEAN = 4,
	// http://www.ecma-international.org/ecma-262/5.1/#sec-4.3.19
	// Number is represented by 64-bit IEEE floating point number
	SIZE_NUMBER = 8,
	MAX_DEPTH = 64;
	
	/**
	                 * Calculates the size of Input in memory,
	                 *
	                 * @param  {Object|String|Number|Boolean} input     Type for which size is to be calculated
	                 * @param  {Object} options                         Specify Options  (maxDepth, errMode)
	                 * @param  {Number} depth                           Current recursion depth
	                 * @return {Number}                                 Size in bytes
	                 */
	function memSize(input, options, depth) {
	    var inputType = typeof input,
	    maxDepth = options && options.maxDepth || MAX_DEPTH,
	    errMode = options && options.errMode,
	    sizeInBytes = 0,
	    idx = 0,
	    cnt,
	    keys,
	    key,
	    val;
	
	    depth = depth || 0;
	
	    if (depth === maxDepth) {
	        return memSize_errorHandler(errMode, sizeInBytes);
	    }
	
	    depth++;
	
	    switch (inputType) {
	        case TYPE_OBJ:
	
	            if (input !== null) {
	                if (Buffer.isBuffer(input)) {
	                    return input.length;
	                } else if (input instanceof Date || input instanceof RegExp) {
	                    return memSize(fittCstr(input), options, depth);
	                } else {
	                    keys = fittKeys(input);
	                    cnt = keys && keys.length;
	
	                    for (; idx < cnt; idx++) {
	
	                        key = keys[idx];
	                        val = input[key];
	
	                        sizeInBytes += memSize(key, options, depth);
	
	                        try {
	                            sizeInBytes += memSize(val, options, depth);
	                        } catch (e) {
	                            return memSize_errorHandler(errMode, sizeInBytes);
	                        }
	                    }
	
	                    return sizeInBytes;
	                }
	            } else {
	                return 0;
	            }
	
	        case TYPE_STR:
	            return input.length * SIZE_STRING;
	
	        case TYPE_BOOL:
	            return SIZE_BOOLEAN;
	
	        case TYPE_NUM:
	            return isNaN(input) ? 0 : SIZE_NUMBER;
	
	        default:
	            return 0;}
	
	}
	
	function memSize_errorHandler(errMode, sizeInBytes) {
	    return errMode == 0 ? 0 : sizeInBytes;
	}
	
	module.exports = memSize;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(790).Buffer))

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(791)
	var ieee754 = __webpack_require__(792)
	var isArray = __webpack_require__(793)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 791 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  for (var i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(
	      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
	    ))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),
/* 792 */
/***/ (function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 793 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	var DoublyLinkedList = __webpack_require__(795);
	
	function StaleLRU(options) {
	    if (!(this instanceof StaleLRU)) {
	        return new StaleLRU(options);
	    }
	
	    if (typeof options === 'number') {
	        options = { maxSize: options };
	    } else if (!options) {
	        options = {};
	    }
	
	    this._maxSize = options.max || options.maximumSize || options.maxSize;
	    this._getSize = options.length || options.getSize || simpleSize;
	    this._maxAge = (typeof options.maxAge === 'number') ? options.maxAge : Infinity;
	    this._staleWhileRevalidate = (typeof options.staleWhileRevalidate === 'number') ? options.staleWhileRevalidate : 0;
	    this._revalidate = options.revalidate;
	    this._callbackQueue = new Map(); // Holds revalidate callbacks
	
	    this.reset();
	}
	
	StaleLRU.prototype.reset = function() {
	    this._lruList = new DoublyLinkedList(); // Holds cache items in order of recent-ness
	    this._map = new Map(); // Maps cache keys to LRU list nodes
	    this._size = 0;
	}
	
	Object.defineProperty(StaleLRU.prototype, 'size', {
	    get: function () { return this._size; }
	});
	
	Object.defineProperty(StaleLRU.prototype, 'maxSize', {
	    get: function () { return this._maxSize; }
	});
	
	StaleLRU.prototype.has = function (key) {
	    var node = this._map.get(key);
	    if (node) {
	        var item = node.value;
	        return !isPastStale(this, item);
	    }
	    return false;
	}
	
	StaleLRU.prototype.isStale = function (key) {
	    var node = this._map.get(key);
	    if (node) {
	        var item = node.value;
	        return isStale(this, item);
	    }
	    return false;
	}
	
	StaleLRU.prototype.get = function (key) {
	    var node = this._map.get(key);
	    if (node) {
	        var item = node.value;
	        if (!isPastStale(this, item)) {
	            this._lruList.unshiftNode(node);
	            if (isStale(this, item)) revalidate(this, item);
	            return item.value;
	        } else {
	            del(this, node);
	        }
	    }
	}
	
	StaleLRU.prototype.set = function (key, value, options) {
	    if (typeof options === 'string') {
	        options = parseCacheControl(options);
	    } else if (!options) {
	        options = {};
	    }
	    var now = Date.now();
	    var size = this._getSize(value, key);
	    var node = this._map.get(key);
	    var item;
	
	    if (node) {
	        item = node.value;
	
	        // Have it but will not make it in
	        if (size > this.maxSize) {
	            del(this, node);
	            return false;
	        }
	
	        // Have it and will make it in
	        item.now = now;
	        item.maxAge = options.maxAge;
	        item.staleWhileRevalidate = options.staleWhileRevalidate;
	
	        if (isPastStale(this, item)) {
	            del(this, node);
	            return false;
	        }
	
	        if (options.revalidate) {
	            item.revalidate = options.revalidate;
	        }
	        item.value = value;
	        this._size += size - item.size;
	        item.size = size;
	
	        this._lruList.unshiftNode(node);
	        trim(this);
	
	        return true;
	    }
	
	    // Do not have it and will not make it in
	    if (size > this.maxSize) {
	        return false;
	    }
	
	    // Do not have it but will make it in
	    item = new Item(key, value, size, now, options.maxAge, options.staleWhileRevalidate, options.revalidate);
	
	    if (isPastStale(this, item)) {
	        return false;
	    }
	
	    this._size += size;
	
	    this._lruList.unshift(item);
	    this._map.set(key, this._lruList.head);
	    trim(this);
	
	    return true;
	}
	
	StaleLRU.prototype.delete = function (key) {
	    var node = this._map.get(key);
	    if (node) {
	        del(this, node);
	        return true;
	    }
	    return false;
	}
	
	StaleLRU.prototype.keys = function () {
	    return this._lruList.toArray().map(function (item) { return item.key; }, this);
	}
	
	StaleLRU.prototype.values = function () {
	    return this._lruList.toArray().map(function (item) { return item.value; }, this);
	}
	
	StaleLRU.prototype.wrap = function (key, work, callback) {
	    var self = this;
	    if (self.has(key)) {
	        callback(null, self.get(key));
	        return;
	    }
	
	    if (self._callbackQueue.has(key)) {
	        self._callbackQueue.get(key).push(callback);
	        return;
	    }
	    self._callbackQueue.set(key, [callback]);
	
	    work(key, fulfillQueue);
	
	    function fulfillQueue(error, value, options) {
	        if (typeof options === 'string') {
	            options = parseCacheControl(options);
	        } else if (!options) {
	            options = {};
	        }
	        options.revalidate || (options.revalidate = work);
	        if (!error) self.set(key, value, options);
	        var callbacks = self._callbackQueue.get(key);
	        self._callbackQueue.delete(key);
	        for (var i = 0; i < callbacks.length; i++) {
	            var done = callbacks[i];
	            done(error, value);
	        }
	    }
	}
	
	function isStale(self, item) {
	    var maxAge = (typeof item.maxAge === 'number') ? item.maxAge : self._maxAge;
	    var staleWhileRevalidate = (typeof item.staleWhileRevalidate === 'number') ? item.staleWhileRevalidate : self._staleWhileRevalidate;
	    var now = Date.now();
	    var expires = item.now + maxAge * 1000;
	    return (expires <= now) && (now < expires + staleWhileRevalidate * 1000);
	}
	
	function isPastStale(self, item) {
	    var maxAge = (typeof item.maxAge === 'number') ? item.maxAge : self._maxAge;
	    var staleWhileRevalidate = (typeof item.staleWhileRevalidate === 'number') ? item.staleWhileRevalidate : self._staleWhileRevalidate;
	    return (item.now + maxAge * 1000 + staleWhileRevalidate * 1000) <= Date.now();
	}
	
	function revalidate(self, item) {
	    var key = item.key;
	    var work = item.revalidate || self._revalidate;
	    if (!work) return;
	
	    if (self._callbackQueue.has(key)) return;
	    self._callbackQueue.set(key, []);
	
	    work(key, fulfillQueue);
	
	    function fulfillQueue(error, value, options) {
	        if (!error) self.set(key, value, options);
	        var callbacks = self._callbackQueue.get(key);
	        self._callbackQueue.delete(key);
	        for (var i = 0; i < callbacks.length; i++) {
	            var done = callbacks[i];
	            done(error, value);
	        }
	    }
	}
	
	function trim(self) {
	    if (self._size > self._maxSize) {
	        for (var node = self._lruList.tail; self._size > self._maxSize && node !== null;) {
	            var prev = node.prev;
	            del(self, node);
	            node = prev;
	        }
	    }
	}
	
	function del(self, node) {
	    var item = node.value;
	    self._size -= item.size;
	    self._map.delete(item.key);
	    self._lruList.removeNode(node);
	}
	
	module.exports = StaleLRU;
	
	
	function Item(key, value, size, now, maxAge, staleWhileRevalidate, revalidate) {
	    this.key = key;
	    this.value = value;
	    this.size = size;
	    this.now = now;
	    this.maxAge = maxAge;
	    this.staleWhileRevalidate = staleWhileRevalidate;
	    this.revalidate = revalidate;
	}
	
	function simpleSize() {
	    return 1;
	}
	
	// Ain't pretty but is fast - Parsing 3,000,000 cache-control headers on node v4.2.1:
	// 
	// substr: 1,038 ms (below)
	// split: 2,435 ms (https://github.com/yahoo/storage-lru/blob/master/src/StorageLRU.js#L601)
	// regex: 9,691 ms (https://github.com/roryf/parse-cache-control/blob/master/index.js#L15)
	function parseCacheControl(header) {
	    var options = {};
	    if (header) {
	        header = header.toLowerCase();
	        if (header.indexOf('no-cache') !== -1 || header.indexOf('no-store') !== -1 || header.indexOf('private') !== -1) {
	            options.maxAge = 0;
	            options.staleWhileRevalidate = 0;
	        } else {
	            var pos, seconds;
	
	            pos = header.indexOf('max-age=');
	            seconds = (pos !== -1) ? parseInt(header.substr(pos + 8), 10) : NaN;
	            if (seconds) options.maxAge = seconds;
	
	            pos = header.indexOf('stale-while-revalidate=');
	            seconds = (pos !== -1) ? parseInt(header.substr(pos + 23), 10) : NaN;
	            if (seconds) options.staleWhileRevalidate = seconds;
	        }
	    }
	    return options;
	}


/***/ }),
/* 795 */
/***/ (function(module, exports) {

	module.exports = Yallist
	
	Yallist.Node = Node
	Yallist.create = Yallist
	
	function Yallist (list) {
	  var self = this
	  if (!(self instanceof Yallist)) {
	    self = new Yallist()
	  }
	
	  self.tail = null
	  self.head = null
	  self.length = 0
	
	  if (list && typeof list.forEach === 'function') {
	    list.forEach(function (item) {
	      self.push(item)
	    })
	  } else if (arguments.length > 0) {
	    for (var i = 0, l = arguments.length; i < l; i++) {
	      self.push(arguments[i])
	    }
	  }
	
	  return self
	}
	
	Yallist.prototype.removeNode = function (node) {
	  if (node.list !== this) {
	    throw new Error('removing node which does not belong to this list')
	  }
	
	  var next = node.next
	  var prev = node.prev
	
	  if (next) {
	    next.prev = prev
	  }
	
	  if (prev) {
	    prev.next = next
	  }
	
	  if (node === this.head) {
	    this.head = next
	  }
	  if (node === this.tail) {
	    this.tail = prev
	  }
	
	  node.list.length--
	  node.next = null
	  node.prev = null
	  node.list = null
	}
	
	Yallist.prototype.unshiftNode = function (node) {
	  if (node === this.head) {
	    return
	  }
	
	  if (node.list) {
	    node.list.removeNode(node)
	  }
	
	  var head = this.head
	  node.list = this
	  node.next = head
	  if (head) {
	    head.prev = node
	  }
	
	  this.head = node
	  if (!this.tail) {
	    this.tail = node
	  }
	  this.length++
	}
	
	Yallist.prototype.pushNode = function (node) {
	  if (node === this.tail) {
	    return
	  }
	
	  if (node.list) {
	    node.list.removeNode(node)
	  }
	
	  var tail = this.tail
	  node.list = this
	  node.prev = tail
	  if (tail) {
	    tail.next = node
	  }
	
	  this.tail = node
	  if (!this.head) {
	    this.head = node
	  }
	  this.length++
	}
	
	Yallist.prototype.push = function () {
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    push(this, arguments[i])
	  }
	  return this.length
	}
	
	Yallist.prototype.unshift = function () {
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    unshift(this, arguments[i])
	  }
	  return this.length
	}
	
	Yallist.prototype.pop = function () {
	  if (!this.tail) {
	    return undefined
	  }
	
	  var res = this.tail.value
	  this.tail = this.tail.prev
	  if (this.tail) {
	    this.tail.next = null
	  } else {
	    this.head = null
	  }
	  this.length--
	  return res
	}
	
	Yallist.prototype.shift = function () {
	  if (!this.head) {
	    return undefined
	  }
	
	  var res = this.head.value
	  this.head = this.head.next
	  if (this.head) {
	    this.head.prev = null
	  } else {
	    this.tail = null
	  }
	  this.length--
	  return res
	}
	
	Yallist.prototype.forEach = function (fn, thisp) {
	  thisp = thisp || this
	  for (var walker = this.head, i = 0; walker !== null; i++) {
	    fn.call(thisp, walker.value, i, this)
	    walker = walker.next
	  }
	}
	
	Yallist.prototype.forEachReverse = function (fn, thisp) {
	  thisp = thisp || this
	  for (var walker = this.tail, i = this.length - 1; walker !== null; i--) {
	    fn.call(thisp, walker.value, i, this)
	    walker = walker.prev
	  }
	}
	
	Yallist.prototype.get = function (n) {
	  for (var i = 0, walker = this.head; walker !== null && i < n; i++) {
	    // abort out of the list early if we hit a cycle
	    walker = walker.next
	  }
	  if (i === n && walker !== null) {
	    return walker.value
	  }
	}
	
	Yallist.prototype.getReverse = function (n) {
	  for (var i = 0, walker = this.tail; walker !== null && i < n; i++) {
	    // abort out of the list early if we hit a cycle
	    walker = walker.prev
	  }
	  if (i === n && walker !== null) {
	    return walker.value
	  }
	}
	
	Yallist.prototype.map = function (fn, thisp) {
	  thisp = thisp || this
	  var res = new Yallist()
	  for (var walker = this.head; walker !== null;) {
	    res.push(fn.call(thisp, walker.value, this))
	    walker = walker.next
	  }
	  return res
	}
	
	Yallist.prototype.mapReverse = function (fn, thisp) {
	  thisp = thisp || this
	  var res = new Yallist()
	  for (var walker = this.tail; walker !== null;) {
	    res.push(fn.call(thisp, walker.value, this))
	    walker = walker.prev
	  }
	  return res
	}
	
	Yallist.prototype.reduce = function (fn, initial) {
	  var acc
	  var walker = this.head
	  if (arguments.length > 1) {
	    acc = initial
	  } else if (this.head) {
	    walker = this.head.next
	    acc = this.head.value
	  } else {
	    throw new TypeError('Reduce of empty list with no initial value')
	  }
	
	  for (var i = 0; walker !== null; i++) {
	    acc = fn(acc, walker.value, i)
	    walker = walker.next
	  }
	
	  return acc
	}
	
	Yallist.prototype.reduceReverse = function (fn, initial) {
	  var acc
	  var walker = this.tail
	  if (arguments.length > 1) {
	    acc = initial
	  } else if (this.tail) {
	    walker = this.tail.prev
	    acc = this.tail.value
	  } else {
	    throw new TypeError('Reduce of empty list with no initial value')
	  }
	
	  for (var i = this.length - 1; walker !== null; i--) {
	    acc = fn(acc, walker.value, i)
	    walker = walker.prev
	  }
	
	  return acc
	}
	
	Yallist.prototype.toArray = function () {
	  var arr = new Array(this.length)
	  for (var i = 0, walker = this.head; walker !== null; i++) {
	    arr[i] = walker.value
	    walker = walker.next
	  }
	  return arr
	}
	
	Yallist.prototype.toArrayReverse = function () {
	  var arr = new Array(this.length)
	  for (var i = 0, walker = this.tail; walker !== null; i++) {
	    arr[i] = walker.value
	    walker = walker.prev
	  }
	  return arr
	}
	
	Yallist.prototype.slice = function (from, to) {
	  to = to || this.length
	  if (to < 0) {
	    to += this.length
	  }
	  from = from || 0
	  if (from < 0) {
	    from += this.length
	  }
	  var ret = new Yallist()
	  if (to < from || to < 0) {
	    return ret
	  }
	  if (from < 0) {
	    from = 0
	  }
	  if (to > this.length) {
	    to = this.length
	  }
	  for (var i = 0, walker = this.head; walker !== null && i < from; i++) {
	    walker = walker.next
	  }
	  for (; walker !== null && i < to; i++, walker = walker.next) {
	    ret.push(walker.value)
	  }
	  return ret
	}
	
	Yallist.prototype.sliceReverse = function (from, to) {
	  to = to || this.length
	  if (to < 0) {
	    to += this.length
	  }
	  from = from || 0
	  if (from < 0) {
	    from += this.length
	  }
	  var ret = new Yallist()
	  if (to < from || to < 0) {
	    return ret
	  }
	  if (from < 0) {
	    from = 0
	  }
	  if (to > this.length) {
	    to = this.length
	  }
	  for (var i = this.length, walker = this.tail; walker !== null && i > to; i--) {
	    walker = walker.prev
	  }
	  for (; walker !== null && i > from; i--, walker = walker.prev) {
	    ret.push(walker.value)
	  }
	  return ret
	}
	
	Yallist.prototype.reverse = function () {
	  var head = this.head
	  var tail = this.tail
	  for (var walker = head; walker !== null; walker = walker.prev) {
	    var p = walker.prev
	    walker.prev = walker.next
	    walker.next = p
	  }
	  this.head = tail
	  this.tail = head
	  return this
	}
	
	function push (self, item) {
	  self.tail = new Node(item, self.tail, null, self)
	  if (!self.head) {
	    self.head = self.tail
	  }
	  self.length++
	}
	
	function unshift (self, item) {
	  self.head = new Node(item, null, self.head, self)
	  if (!self.tail) {
	    self.tail = self.head
	  }
	  self.length++
	}
	
	function Node (value, prev, next, list) {
	  if (!(this instanceof Node)) {
	    return new Node(value, prev, next, list)
	  }
	
	  this.list = list
	  this.value = value
	
	  if (prev) {
	    prev.next = this
	    this.prev = prev
	  } else {
	    this.prev = null
	  }
	
	  if (next) {
	    next.prev = this
	    this.next = next
	  } else {
	    this.next = null
	  }
	}


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	var baseOrderBy = __webpack_require__(797),
	    isArray = __webpack_require__(637);
	
	/**
	 * This method is like `_.sortBy` except that it allows specifying the sort
	 * orders of the iteratees to sort by. If `orders` is unspecified, all values
	 * are sorted in ascending order. Otherwise, specify an order of "desc" for
	 * descending or "asc" for ascending sort order of corresponding values.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @param {string[]} [orders] The sort orders of `iteratees`.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 34 },
	 *   { 'user': 'fred',   'age': 40 },
	 *   { 'user': 'barney', 'age': 36 }
	 * ];
	 *
	 * // Sort by `user` in ascending order and by `age` in descending order.
	 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	 */
	function orderBy(collection, iteratees, orders, guard) {
	  if (collection == null) {
	    return [];
	  }
	  if (!isArray(iteratees)) {
	    iteratees = iteratees == null ? [] : [iteratees];
	  }
	  orders = guard ? undefined : orders;
	  if (!isArray(orders)) {
	    orders = orders == null ? [] : [orders];
	  }
	  return baseOrderBy(collection, iteratees, orders);
	}
	
	module.exports = orderBy;


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(703),
	    baseIteratee = __webpack_require__(704),
	    baseMap = __webpack_require__(754),
	    baseSortBy = __webpack_require__(798),
	    baseUnary = __webpack_require__(645),
	    compareMultiple = __webpack_require__(799),
	    identity = __webpack_require__(659);
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  var index = -1;
	  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseOrderBy;


/***/ }),
/* 798 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	var compareAscending = __webpack_require__(800);
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(741);
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClamp = __webpack_require__(802),
	    toNumber = __webpack_require__(803);
	
	/**
	 * Clamps `number` within the inclusive `lower` and `upper` bounds.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Number
	 * @param {number} number The number to clamp.
	 * @param {number} [lower] The lower bound.
	 * @param {number} upper The upper bound.
	 * @returns {number} Returns the clamped number.
	 * @example
	 *
	 * _.clamp(-10, -5, 5);
	 * // => -5
	 *
	 * _.clamp(10, -5, 5);
	 * // => 5
	 */
	function clamp(number, lower, upper) {
	  if (upper === undefined) {
	    upper = lower;
	    lower = undefined;
	  }
	  if (upper !== undefined) {
	    upper = toNumber(upper);
	    upper = upper === upper ? upper : 0;
	  }
	  if (lower !== undefined) {
	    lower = toNumber(lower);
	    lower = lower === lower ? lower : 0;
	  }
	  return baseClamp(toNumber(number), lower, upper);
	}
	
	module.exports = clamp;


/***/ }),
/* 802 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.clamp` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {number} number The number to clamp.
	 * @param {number} [lower] The lower bound.
	 * @param {number} upper The upper bound.
	 * @returns {number} Returns the clamped number.
	 */
	function baseClamp(number, lower, upper) {
	  if (number === number) {
	    if (upper !== undefined) {
	      number = number <= upper ? number : upper;
	    }
	    if (lower !== undefined) {
	      number = number >= lower ? number : lower;
	    }
	  }
	  return number;
	}
	
	module.exports = baseClamp;


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(601),
	    isSymbol = __webpack_require__(741);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(805);

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	var fitt = __webpack_require__(425),
	Messenger = __webpack_require__(784),
	Cache = __webpack_require__(788),
	debug = __webpack_require__(441)('fitt-datahandler'),
	cluster = __webpack_require__(784);
	
	/**
	                               * Description of the structure used for the pending object for illustrative purposes
	                               *
	                               *  <pre>
	                               pending: {
	                              	 http://site.api.prod.espninfra.starwave.com/apis/v2/scoreboard/header?_ceID=4379198&lang=en&region=us&contentorigin=espn:
	                              	 [
	                              		function,
	                              		function
	                              	 ]
	                               }
	                               </pre>
	                               **/
	
	/**
	                                    * Master/worker process functionality for interacting with an external data service, enabling an external caching mechanism,
	                                    * and aggregating identical incoming requests for data from multiple workers.
	                                    *
	                                    * @class
	                                    * @name fitt.DataHandler
	                                    * @returns {Object} Public interface
	                                    */
	
	/**
	                                        * Master DataHandler function that is used by the master process.
	                                        */
	
	function DataHandler() {
	    var oMessenger = void 0,
	    cache = new Cache(),
	    pending = {};
	
	    /**
	                   * Adds an incoming request to the structure of pending requests. These are requests that cannot be resolved
	                   * immediately and we must wait for result.
	                   */
	    function addPendingRequest(url, respond) {
	        pending[url] = [respond];
	    }
	
	    /**
	       * Checks the pending structure to see if we are already waiting for an identical data request. If so, it
	       * returns the responderID to reference in the pending.responders structure.
	       */
	    function checkForSamePendingRequest(url) {
	        return typeof pending[url] !== 'undefined';
	    }
	
	    /**
	       * Main incoming message handler. It checks for identical requests and then initiates data retrieval.
	       */
	    function handleDataRequest(message, respond) {
	        var messageData = message.data,
	        url = messageData.url,
	        cachePolicy = messageData.cache,
	        httpConfig = messageData.httpConfig;
	
	        if (checkForSamePendingRequest(url)) {
	            // identical request in progress - append respond function to existing row
	            pending[url].push(respond);
	            debug('Identical request detected. Size of queue: ' + pending[url].length);
	            return;
	        }
	        addPendingRequest(url, respond);
	        // Retrieve data
	        retrieveData(url, cachePolicy, httpConfig).
	        then(function (data) {
	            // Respond to all pendings
	            respondToRequest(url, data);
	        }).
	        catch(function (err) {
	            // Let the worker know there was a failure
	            respondToRequest(url, null, err);
	        }).
	        then(function () {
	            removePendingRequest(url);
	        });
	    }
	
	    /**
	       * Retrieves internal cache info and responds
	       *
	       * @param message
	       * @param respond
	       */
	    function handleInfoRequest(message, respond) {
	        var data = message && message.data,
	        method = data && data.method,
	        response = void 0;
	
	        switch (method) {
	            case 'getCacheInfo':
	                var manifest = cache.getManifest();
	
	                response = {
	                    items: manifest,
	                    size: cache.getMemSize(manifest),
	                    lastPurgeAt: cache.lastPurgeAt,
	                    lastPurgeDate: cache.lastPurgeDate,
	                    lastPurgeItems: cache.lastPurgeItemCount,
	                    lastPurgeFreed: cache.lastPurgeMemFreed,
	                    count: cache.size(),
	                    lastPurger: cache.lastPurger,
	                    currentMaxPct: cache.currentMaxPct,
	                    currentInterval: cache.currentInterval,
	                    totalSuccessfulPurges: cache.totalSuccessfulPurges };
	
	                break;}
	
	        respond(response);
	    }
	
	    /**
	       * Removes request from the pending structure
	       */
	    function removePendingRequest(url) {
	        delete pending[url];
	    }
	
	    /**
	       * Responds to all pending responders for a given request
	       */
	    function respondToRequest(url, data, error) {
	        var responders = pending[url];
	        debug('Responding to all data requesters', url, error);
	        fitt.forEach(responders, function (responder) {
	            responder(data, error);
	        });
	    }
	
	    /**
	       * Main data retrieval logic. Checks cache before requesting via HTTP.
	       * Re: caching policy: Either a string/object representing caching policy or a function that will return a string/object representing policy. See: https://github.com/cyberthom/stale-lru-cache#setkey-value-options
	       */
	    function retrieveData(url, cachePolicy, httpConfig) {
	        // Return from cache if present and hasn't expired, revalidate via http in background
	        return cache.getHttp(url, httpConfig, cachePolicy);
	    }
	
	    return {
	
	        /**
	              * Returns the local cache instance
	              *
	              * @returns {fitt.Cache}
	              */
	        getCacheInstance: function getCacheInstance() {
	            return cache;
	        },
	
	        /**
	            * Set the cache instance
	            *
	            * @param {Object} cacheInstance FITT cache instance
	            * @return {Boolean} True if set successfully
	            */
	        setCacheInstance: function setCacheInstance(cacheInstance) {
	            var ret = false;
	
	            if (cacheInstance instanceof Cache) {
	                cache = cacheInstance;
	                ret = true;
	            }
	
	            return ret;
	        },
	
	        /**
	            * Instantiates messenger object and adds message listeners for master
	            *
	            * @name fitt.DataHandler#initialize
	            * @function
	            * @param {String} messageNamespace Name of namespace to use for inter-process messaging
	            */
	        initialize: function initialize(messageNamespace) {
	            oMessenger = new Messenger(messageNamespace);
	            if (cluster.isMaster) {
	                oMessenger.addListener('dataRequest', function (message, respond) {
	                    handleDataRequest(message, respond);
	                });
	                oMessenger.addListener('cacheAdmin', function (message, respond) {
	                    handleInfoRequest(message, respond);
	                });
	            }
	        },
	
	        /**
	            * Sends a message to the master process with a request for data. (WORKER ONLY)
	            *
	            * @name fitt.DataHandler#makeRequest
	            * @function
	            * @param {String} url URL of data to be requested
	            * @param {String|Function|Object} cachePolicy Either a string/object representing caching policy or a function that will return a string/object representing policy. See: https://github.com/cyberthom/stale-lru-cache#setkey-value-options
	            * @returns {Promise}
	            */
	        makeRequest: function makeRequest(url, cachePolicy, httpConfig) {
	            var dataRequest = {
	                url: url,
	                cache: cachePolicy,
	                httpConfig: httpConfig };
	
	            debug('makeRequest called', url, cachePolicy, 'Worker ' + cluster.worker.id);
	            return oMessenger.request('dataRequest', dataRequest, cluster.worker);
	        } };
	
	
	}
	
	module.exports = DataHandler();

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.onGetLeagues = onGetLeagues;
	exports.onGetEditorial = onGetEditorial;
	exports.onGetStandings = onGetStandings;
	exports.onGetScoreboard = onGetScoreboard;
	exports.onGetTopEventScores = onGetTopEventScores;
	exports.onGetGamePackage = onGetGamePackage;
	exports.onGetGeoLocation = onGetGeoLocation;
	exports.onGetPlayByPlay = onGetPlayByPlay;
	exports.onGetVideos = onGetVideos;
	exports.onGetSchedule = onGetSchedule;
	exports.onGetClubhouse = onGetClubhouse;
	exports.getMoreMidColFeed = getMoreMidColFeed;
	exports.getMidColFeed = getMidColFeed;
	
	var _parsers = __webpack_require__(807);
	
	var parsers = _interopRequireWildcard(_parsers);
	
	var _helpers = __webpack_require__(855);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * Leagues transformer
	 * @param  {Object} res    Result from API
	 * @param  {Object} edition   edition config
	 * @param  {Object} params    Request oarams
	 * @return {Object}           leagues and current league
	 */
	/**
	 * API data normalizer or transformation layer
	 */
	
	function onGetLeagues(_ref) {
	  var res = _ref.res,
	      _ref$edition = _ref.edition,
	      edition = _ref$edition === undefined ? {} : _ref$edition,
	      _ref$params = _ref.params,
	      params = _ref$params === undefined ? {} : _ref$params;
	
	  return parsers.common.leagues.processData(res, edition, params);
	}
	
	function onGetEditorial(_ref2) {
	  var _ref2$res = _ref2.res,
	      res = _ref2$res === undefined ? {} : _ref2$res,
	      _ref2$edition = _ref2.edition,
	      edition = _ref2$edition === undefined ? {} : _ref2$edition;
	
	  var data = res && res.data || {};
	  var columns = data && data.columns || {};
	  var rightColumn = parsers.flex.getColumnByName(columns, 'rightcolumn');
	
	  var items = rightColumn && rightColumn.items || [];
	  //Editorial comes with the type editorial and moduleType featuredImgVid
	  var module = parsers.flex.getModuleByType(items, 'featuredImgVid');
	  var feed = module && module.feed || [];
	  var editorialItems = parsers.flex.buildEditorialItems(feed, edition);
	
	  return { editorialItems: editorialItems };
	}
	
	/**
	 * Standings transformer
	 * @param  {Object} res         Result from API
	 * @param  {Object} edition     Edition config
	 * @param  {Object} params      Request params
	 * @param  {Object} location    Router location
	 * @param  {Object} appProps  App props
	 * @return {Object}             Standings, seasons, currentSeason, leagueTitle
	 */
	function onGetStandings(_ref3) {
	  var _ref3$res = _ref3.res,
	      res = _ref3$res === undefined ? {} : _ref3$res,
	      _ref3$leagueRes = _ref3.leagueRes,
	      leagueRes = _ref3$leagueRes === undefined ? {} : _ref3$leagueRes,
	      _ref3$edition = _ref3.edition,
	      edition = _ref3$edition === undefined ? {} : _ref3$edition,
	      _ref3$params = _ref3.params,
	      params = _ref3$params === undefined ? {} : _ref3$params,
	      _ref3$location = _ref3.location,
	      location = _ref3$location === undefined ? {} : _ref3$location,
	      _ref3$appProps = _ref3.appProps,
	      appProps = _ref3$appProps === undefined ? {} : _ref3$appProps;
	
	  return parsers.standings.processData(res, leagueRes, edition, params, location, appProps);
	}
	
	/**
	 * @param  {Object} res Result from the API
	 * @param  {Object} edition   edition config
	 * @param  {Object} params    Request Params
	 * @param  {Object} location  Router location
	 * @param  {Object} appProps  App props
	 * @return {Object}           leagues and date
	 */
	function onGetScoreboard(_ref4) {
	  var _ref4$res = _ref4.res,
	      res = _ref4$res === undefined ? {} : _ref4$res,
	      _ref4$edition = _ref4.edition,
	      edition = _ref4$edition === undefined ? {} : _ref4$edition,
	      _ref4$params = _ref4.params,
	      params = _ref4$params === undefined ? {} : _ref4$params,
	      _ref4$location = _ref4.location,
	      location = _ref4$location === undefined ? {} : _ref4$location,
	      _ref4$appProps = _ref4.appProps,
	      appProps = _ref4$appProps === undefined ? {} : _ref4$appProps,
	      _ref4$topEvents = _ref4.topEvents,
	      topEvents = _ref4$topEvents === undefined ? [] : _ref4$topEvents;
	
	  // TODO: call game specific parsers based on params.sport
	  return parsers.cricket.scoreboard.processData(res, edition, params, location, appProps, topEvents);
	}
	
	/**
	 * @param  {Object} res Result from the API
	 * @param  {Object} edition   edition config
	 * @param  {Object} params    Request Params
	 * @return {Object}           leagues and date
	 */
	function onGetTopEventScores(_ref5) {
	  var _ref5$res = _ref5.res,
	      res = _ref5$res === undefined ? {} : _ref5$res,
	      _ref5$edition = _ref5.edition,
	      edition = _ref5$edition === undefined ? {} : _ref5$edition;
	
	  // TODO: call game specific parsers based on params.sport
	  return parsers.cricket.scoreboard.processTopEventScores(res, edition);
	}
	
	/**
	 * @param  {Object} res Result from the API
	 * @param  {Object} edition   edition config
	 * @param  {Object} params    Request Params
	 * @param  {Object} location  Router location
	 * @param  {Object} appProps  App props
	 * @return {Object}           leagues and date
	 */
	function onGetGamePackage(_ref6) {
	  var _ref6$res = _ref6.res,
	      res = _ref6$res === undefined ? {} : _ref6$res,
	      _ref6$edition = _ref6.edition,
	      edition = _ref6$edition === undefined ? {} : _ref6$edition,
	      _ref6$params = _ref6.params,
	      params = _ref6$params === undefined ? {} : _ref6$params,
	      _ref6$location = _ref6.location,
	      location = _ref6$location === undefined ? {} : _ref6$location,
	      _ref6$appProps = _ref6.appProps,
	      appProps = _ref6$appProps === undefined ? {} : _ref6$appProps;
	
	  // TODO: call game specific parsers based on params.sport
	  switch (params.sport) {
	    case 'cricket':
	      return parsers.cricket.gamePackage.processData(res, edition, params, location, appProps);
	    case 'rugby-league':
	    case 'rugby':
	      return parsers.rugby.gamePackage.processData(res, edition, params, location);
	    default:
	      return {};
	  }
	}
	
	function onGetGeoLocation(_ref7) {
	  var _ref7$res = _ref7.res,
	      res = _ref7$res === undefined ? {} : _ref7$res,
	      _ref7$edition = _ref7.edition,
	      edition = _ref7$edition === undefined ? {} : _ref7$edition,
	      _ref7$params = _ref7.params,
	      params = _ref7$params === undefined ? {} : _ref7$params,
	      _ref7$query = _ref7.query,
	      query = _ref7$query === undefined ? {} : _ref7$query;
	
	  return parsers.common.common.getCountryFromGeoLocation(res, edition, params, query);
	}
	
	/**
	 * Process play by play
	 * @param  {Object} res       request response
	 * @param  {Object} edition   edition config
	 * @param  {Object} params    router params
	 * @param  {Object} location  Router location
	 * @return {Object}           action.data to be comsumed by reducers
	 */
	function onGetPlayByPlay(_ref8) {
	  var _ref8$res = _ref8.res,
	      res = _ref8$res === undefined ? {} : _ref8$res,
	      _ref8$edition = _ref8.edition,
	      edition = _ref8$edition === undefined ? {} : _ref8$edition,
	      _ref8$params = _ref8.params,
	      params = _ref8$params === undefined ? {} : _ref8$params,
	      _ref8$location = _ref8.location,
	      location = _ref8$location === undefined ? {} : _ref8$location;
	
	  // TODO: call game specific parsers based on params.sport
	  return parsers.cricket.gamePackage.processPlayByPlay(res, edition, params, location);
	}
	
	/**
	 * Process play by play
	 * @param  {Object} res       request response
	 * @param  {Object} edition   edition config
	 * @param  {Object} params    router params
	 * @param  {Object} location  Router location
	 * @return {Object}           action.data to be comsumed by reducers
	 */
	function onGetVideos(_ref9) {
	  var _ref9$res = _ref9.res,
	      res = _ref9$res === undefined ? {} : _ref9$res,
	      _ref9$edition = _ref9.edition,
	      edition = _ref9$edition === undefined ? {} : _ref9$edition,
	      _ref9$params = _ref9.params,
	      params = _ref9$params === undefined ? {} : _ref9$params,
	      _ref9$location = _ref9.location,
	      location = _ref9$location === undefined ? {} : _ref9$location;
	
	  // TODO: call game specific parsers based on params.sport
	  return parsers.cricket.gamePackage.processVideos(res, edition, params, location);
	}
	
	/**
	* Process play by play
	* @param  {Object} scheduleRes   Request response for schedule
	* @param  {Object} leagueRes     Request response for leagues
	* @param  {Object} displayDate   Request response for calculated display date
	* @param  {Object} edition       Edition config
	* @param  {Object} params        Router params
	* @param  {Object} location      Router location
	* @param  {Object} appProps      Application properties
	* @return {Object}               Action.data to be comsumed by reducers
	*/
	function onGetSchedule(_ref10) {
	  var _ref10$scheduleRes = _ref10.scheduleRes,
	      scheduleRes = _ref10$scheduleRes === undefined ? {} : _ref10$scheduleRes,
	      _ref10$leagueRes = _ref10.leagueRes,
	      leagueRes = _ref10$leagueRes === undefined ? {} : _ref10$leagueRes,
	      _ref10$displayDate = _ref10.displayDate,
	      displayDate = _ref10$displayDate === undefined ? '' : _ref10$displayDate,
	      _ref10$edition = _ref10.edition,
	      edition = _ref10$edition === undefined ? {} : _ref10$edition,
	      _ref10$params = _ref10.params,
	      params = _ref10$params === undefined ? {} : _ref10$params,
	      _ref10$location = _ref10.location,
	      location = _ref10$location === undefined ? {} : _ref10$location,
	      _ref10$appProps = _ref10.appProps,
	      appProps = _ref10$appProps === undefined ? {} : _ref10$appProps;
	
	  // TODO: call game specific parsers based on params.sport
	  return parsers.schedule.processData(scheduleRes, leagueRes, displayDate, edition, params, location, appProps);
	}
	
	/**
	 * [onGetClubhouse Clubhouse page]
	 * @param  {[type]} res      [Response from Flex API]
	 * @param  {Object} edition  [edition details]
	 * @param  {Object} params   [params object]
	 * @param  {Object} location [location details]
	 * @return {[type]}          [return formatted flex API]
	 */
	function onGetClubhouse(_ref11) {
	  var _ref11$res = _ref11.res,
	      res = _ref11$res === undefined ? {} : _ref11$res,
	      _ref11$edition = _ref11.edition,
	      edition = _ref11$edition === undefined ? {} : _ref11$edition,
	      _ref11$params = _ref11.params,
	      params = _ref11$params === undefined ? {} : _ref11$params,
	      _ref11$location = _ref11.location,
	      location = _ref11$location === undefined ? {} : _ref11$location;
	
	
	  var data = res && res.data || {};
	  var columns = data && data.columns || {};
	  var teamData = data && data.team || {};
	
	  var leftColumnFeed = parsers.flex.getColumnByName(columns, 'leftcolumn');
	  var rightColumnFeed = parsers.flex.getColumnByName(columns, 'rightcolumn');
	  var team = parsers.flex.getClubhouseTeam(teamData, params);
	  var schedule = parsers.flex.getSchedules(leftColumnFeed, edition, params, team);
	  var standings = parsers.flex.getStandings(rightColumnFeed);
	  var standingsFeed = standings && standings.feed || {};
	  var standingsLeague = standings && standings.league || {};
	  var leaders = parsers.flex.getLeaders(rightColumnFeed);
	  var meta = {};
	
	  var leftColumn = {
	    name: leftColumnFeed.name || '',
	    description: leftColumnFeed.description || '',
	    schedule: {}
	  };
	  var rightColumn = {
	    name: rightColumnFeed.name || '',
	    description: rightColumnFeed.description || '',
	    standings: {},
	    leaders: {}
	  };
	  if (params.sport === 'rugby') {
	    rightColumn.teamRankings = parsers.rugby.clubhouse.modules.getTeamRankings(standings, team, edition);
	    standings = parsers.rugby.clubhouse.modules.getStandings(standingsFeed, standingsLeague, params, edition);
	    leaders = parsers.rugby.clubhouse.modules.getTopScorers(leaders, team, params, edition);
	    meta = parsers.rugby.clubhouse.getMetaData(edition, params, team, location);
	  }
	  if (params.sport == 'cricket') {
	    standings = parsers.cricket.gamePackage.modules.getStandings(standingsFeed, params);
	  }
	
	  leftColumn.schedule = schedule;
	  rightColumn.standings = standings;
	  rightColumn.leaders = leaders;
	
	  var loadNowAPI = false;
	  var middleColumn = getMidColFeed(res, edition, params, loadNowAPI);
	  return { leftColumn: leftColumn, middleColumn: middleColumn, rightColumn: rightColumn, team: team, meta: meta };
	}
	
	function getMoreMidColFeed(res, edition, params, currentArticleCount) {
	  var loadNowAPI = true;
	  var middleColumn = getMidColFeed(res, edition, params, currentArticleCount, loadNowAPI);
	  return { middleColumn: middleColumn };
	}
	
	function getMidColFeed() {
	  var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var edition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var currentArticleCount = arguments[3];
	  var loadNowAPI = arguments[4];
	
	  var data = res && res.data || {};
	  var columns = data && data.columns || {};
	  var middleColumn = loadNowAPI ? data : parsers.flex.getColumnByName(columns, 'middlecolumn');
	  var newsfeed = parsers.flex.getNewsFeed(middleColumn, params.sport, edition.domain, params.pageType, currentArticleCount, loadNowAPI) || {};
	  var totalResultsCount = newsfeed.resultsCount; //total counts unfiltered items for this team
	  var currentCount = newsfeed.length; //count the items in current array, this array has items only those are included types
	  var totalCount = newsfeed.countBF;
	  var excludedCount = totalCount - currentCount; //count those are not included
	  var noContentText = _helpers2.default.getNoContentText(params.pageType, edition);
	  return {
	    newsfeed: newsfeed,
	    resultsCount: newsfeed.resultsCount,
	    resultsOffset: newsfeed.resultsOffset,
	    hasMore: totalResultsCount > totalCount ? true : false,
	    page: 1,
	    excludedCount: excludedCount,
	    totalCount: totalCount,
	    sport: params.sport,
	    noContentText: noContentText
	  };
	}

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.standings = exports.schedule = exports.flex = exports.common = exports.rugby = exports.cricket = undefined;
	
	var _cricket = __webpack_require__(808);
	
	var _cricket2 = _interopRequireDefault(_cricket);
	
	var _rugby = __webpack_require__(840);
	
	var _rugby2 = _interopRequireDefault(_rugby);
	
	var _common = __webpack_require__(814);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _flex = __webpack_require__(850);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _standings = __webpack_require__(852);
	
	var _standings2 = _interopRequireDefault(_standings);
	
	var _schedule = __webpack_require__(854);
	
	var _schedule2 = _interopRequireDefault(_schedule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.cricket = _cricket2.default;
	exports.rugby = _rugby2.default;
	exports.common = _common2.default;
	exports.flex = _flex2.default;
	exports.schedule = _schedule2.default;
	exports.standings = _standings2.default;
	exports.default = {
	  cricket: _cricket2.default,
	  rugby: _rugby2.default,
	  common: _common2.default,
	  flex: _flex2.default,
	  schedule: _schedule2.default,
	  standings: _standings2.default
	};

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.gamePackage = exports.scoreboard = undefined;
	
	var _index = __webpack_require__(809);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(837);
	
	var _index4 = _interopRequireDefault(_index3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @fileOverview Cricket data parsers.
	 * Aggregates and exports cricket specific data parsers
	 */
	
	exports.scoreboard = _index2.default;
	exports.gamePackage = _index4.default;
	exports.default = {
	  scoreboard: _index2.default,
	  gamePackage: _index4.default
	};

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.scoreboard = undefined;
	
	var _extends2 = __webpack_require__(364);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(419);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _slicedToArray2 = __webpack_require__(810);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _toConsumableArray2 = __webpack_require__(410);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _selectn = __webpack_require__(438);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	var _common = __webpack_require__(814);
	
	var _momentTimezone = __webpack_require__(450);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _queryString = __webpack_require__(207);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _helpers = __webpack_require__(834);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _common2 = __webpack_require__(430);
	
	var _dateformat = __webpack_require__(449);
	
	var _dateformat2 = _interopRequireDefault(_dateformat);
	
	var _eventSummary = __webpack_require__(836);
	
	var _eventSummary2 = _interopRequireDefault(_eventSummary);
	
	var _translate = __webpack_require__(833);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	var _translateURI = __webpack_require__(832);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @fileOverview Scoreboard (/cricket/scores) page parser functions
	 */
	
	var scoreboard = exports.scoreboard = {
	
	  setLocalTime: function setLocalTime() {
	    var leagues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var scoreboardType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var sport = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	
	    leagues.map(function (league) {
	      var events = league.events || [];
	      events.map(function (event) {
	        var timeValid = typeof event.timeValid !== 'undefined' ? event.timeValid : true;
	        var tzOptions = {
	          timeZone: _momentTimezone2.default.tz.guess(),
	          timeFormat: sport == 'cricket' && !_dateformat2.default.isTheGameToday(event.date) ? 'ddd D/M - hh:mm a z' : 'hh:mm a z'
	        };
	        if (event.gameState === 'pregame') {
	          var displayTime = timeValid ? _dateformat2.default.convertDateTime(event.date, tzOptions) : '';
	          event.statusText = displayTime && displayTime.toUpperCase() || '';
	        }
	      });
	    });
	  },
	
	  processTopEventScores: function processTopEventScores() {
	    var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var edition = arguments[1];
	
	    var topEventLeagues = [];
	    var defaultLeagues = [];
	    var allSports = (0, _selectn2.default)('data.sports', res) || [];
	    var topGameEvents = [];
	
	    if (!res.hasOwnProperty('data')) {
	      return defaultLeagues;
	    }
	
	    for (var i = 0; i < allSports.length; i++) {
	      var data = allSports[i] || {};
	      var sportType = data.name ? data.name.toLowerCase() : '';
	      if (sportType == 'cricket') {
	        var _data$leagues = data.leagues,
	            leagues = _data$leagues === undefined ? [] : _data$leagues;
	
	        for (var j = 0; j < leagues.length; j++) {
	          var league = leagues[j];
	          var events = scoreboard.parseTopEvents(league.events, edition, sportType) || [];
	          topGameEvents.push.apply(topGameEvents, (0, _toConsumableArray3.default)(events));
	        }
	      }
	    }
	    topEventLeagues.push({
	      name: 'Top Events',
	      text: 'Top Events',
	      abbreviation: 'Top Events',
	      id: '',
	      events: topGameEvents,
	      seriesHome: '',
	      isTopEvents: true
	    });
	
	    return {
	      topEventLeagues: topEventLeagues
	    };
	  },
	
	  parseTopEvents: function parseTopEvents() {
	    var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var edition = arguments[1];
	    var sport = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'cricket';
	
	    if (events.length === 0) {
	      return events;
	    }
	
	    var parsedEvents = events.map(function () {
	      var ev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var date = (0, _momentTimezone2.default)(ev.date || '').format('MMMM Do, YYYY');
	      var state = (0, _selectn2.default)('fullStatus.type.state', ev);
	      var fullStatus = ev.fullStatus || {};
	      var competitors = ev.competitors || [];
	      var links = ev.links || [];
	
	      var gameState = _common.common.getGameState(state);
	      var teams = scoreboard.getTopEventTeams(competitors, gameState, fullStatus);
	      var eventSummaryData = _eventSummary2.default.getSummaryFromDetails(sport, edition, competitors, []);
	      var eventClock = (0, _selectn2.default)('fullStatus.displayClock', ev) || '0\'';
	
	      var session = (0, _selectn2.default)('fullStatus.session', ev) || '';
	      if (session) {
	        session = session + ': ';
	      }
	      var gameNote = session + (0, _selectn2.default)('fullStatus.summary', ev) || '';
	      var timeValid = ev.timeValid || false;
	      var parsedEvent = {
	        gameId: ev.id || '',
	        gameDate: date,
	        date: ev.date,
	        teams: teams,
	        gameState: gameState,
	        statusText: scoreboard.getTopEventStatus(state, ev, edition.timeZoneBucket, sport),
	        winnerClass: _common.common.getWinnerClass(competitors, sport),
	        links: _common.common.getGameLinks(links, sport, edition, false, gameState),
	        gameUrl: _common.common.getUrlByRel({ links: links }, 'match', edition.domain, sport),
	        note: gameNote,
	        info: ev.description || '',
	        favInfo: ev.description || '',
	        eventSummary: eventSummaryData,
	        eventClock: eventClock,
	        timeValid: timeValid,
	        odds: ev.odds || {} // odds is a single objects in headerscoreboard api
	      };
	      return parsedEvent;
	    });
	    return parsedEvents;
	  },
	
	  /**
	   * Get home and away teams details
	   * @param  {Array}  competitors competitors array from feed
	   * @param  {String} gameState pregame/live/final
	   * @param {Object} fullStatus full status of the event
	   * @return {Object}             teams object with {home, away}
	   */
	  getTopEventTeams: function getTopEventTeams() {
	    var competitors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var gameState = arguments[1];
	    var fullStatus = arguments[2];
	
	    var teams = {};
	    var teamsOrder = [];
	    var isTeamBattingNow = false;
	    if (competitors.length > 1 && (0, _selectn2.default)('[0].homeAway', competitors) === (0, _selectn2.default)('[1].homeAway', competitors)) {
	      competitors[0].homeAway = 'home';
	      competitors[1].homeAway = 'away';
	    }
	    competitors.map(function (competitor) {
	      var teamScore = scoreboard.getTeamScores(competitor);
	
	      var _common$splitScore = _common.common.splitScore(teamScore),
	          _common$splitScore2 = (0, _slicedToArray3.default)(_common$splitScore, 2),
	          runDetails = _common$splitScore2[0],
	          overDetails = _common$splitScore2[1];
	
	      if (gameState === 'live' && fullStatus.battingTeamId === competitor.id) {
	        isTeamBattingNow = true;
	      }
	
	      var scoreMarkup = _common.common.getFullScoreMarkup(teamScore, 'sm', 'div', true, isTeamBattingNow, false);
	      var scoreMarkupSpan = _common.common.getFullScoreMarkup(teamScore, 'cscore_overs', 'span', true, isTeamBattingNow, true);
	
	      teams[competitor.homeAway] = {
	        name: competitor.displayName,
	        id: competitor.id,
	        abbr: competitor.abbreviation,
	        logo: _common.common.getTeamLogo(competitor),
	        href: '#',
	        score: teamScore,
	        runDetails: runDetails,
	        overDetails: overDetails,
	        scoreMarkup: scoreMarkup,
	        scoreMarkupSpan: scoreMarkupSpan,
	        links: '#',
	        winner: competitor.winner || false,
	        record: 'Form: ' + competitor.form || '-',
	        order: competitor.order
	      };
	    });
	    var homeTeamOrder = (0, _selectn2.default)('home.order', teams) || 0;
	    var awayTeamOrder = (0, _selectn2.default)('away.order', teams) || 0;
	    var gameInfo = (teams.home && teams.home.name) + '_vs_' + (teams.away && teams.away.name);
	    if (homeTeamOrder > 0 && awayTeamOrder > 0) {
	      teamsOrder = homeTeamOrder == 1 ? ['home', 'away'] : ['away', 'home'];
	    } else {
	      (0, _keys2.default)(teams).map(function (key) {
	        teamsOrder.push(key);
	      });
	    }
	    return (0, _extends3.default)({}, teams, { teamsOrder: teamsOrder, gameInfo: gameInfo });
	  },
	
	  /**
	   * Wrapper function for passing cricket specific options to getGameStatusText
	   * @param  {String} state  game state
	   * @param  {Object} events events
	   * @param  {String} timeZoneBucket  timeZoneBucket
	   * @param  {String} sport  sport
	   * @return {String}        Output of getGameStatusText
	   */
	  getTopEventStatus: function getTopEventStatus(state, events, timeZoneBucket, sport) {
	    var statusText = '';
	    var tzOptions = {
	      // Set time zone to IST
	      // TODO: use time zones based on editions
	      timeZone: process.browser && _momentTimezone2.default.tz.guess() || timeZoneBucket,
	      //timeFormat : 'hh:mm a z',
	      timeFormat: sport === 'cricket' && !_dateformat2.default.isTheGameToday(events.date) ? 'ddd D/M - hh:mm a z' : 'hh:mm a z'
	    };
	    switch (state) {
	      case 'pre':
	        statusText = _dateformat2.default.convertDateTime(events.date, tzOptions);
	        break;
	
	      case 'in':
	      case 'post':
	        statusText = (0, _selectn2.default)('fullStatus.type.description', events) || (0, _selectn2.default)('fullStatus.type.detail', events) || (0, _selectn2.default)('fullStatus.type.shortDetail', events) || state;
	        break;
	    }
	    statusText = statusText.toUpperCase();
	    return statusText;
	  },
	
	  /**
	   * Process data received from the APIs
	   * @param  {Object} res       results from API
	   * @param  {Object} edition   edition config
	   * @param  {Object} params    params
	   * @param  {Object} location  Router location
	   * @param  {Object} appProps  app Props
	   * @param  {Array}  topEventIds topevents list
	   * @return {Object}           leagues and date
	   */
	
	  processData: function processData(res, edition, params, location, appProps) {
	    var topEventIds = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
	
	    // Default return types
	    var query = location.query || _queryString2.default.parse(location.search);
	    var device = appProps.device || {};
	    var adblock = (0, _selectn2.default)('_adblock', query) === 'true' ? true : false;
	    var siteType = appProps.siteType;
	    var isDataLite = siteType === 'data-lite' ? true : false;
	    var defaultLeagues = [];
	    var defaultDate = new Date();
	    var meta = {};
	    var teamName = '';
	    var seriesName = '';
	    var siteNameMap = {
	      'www.espncricinfo.com': 'ESPNCricinfo',
	      'www.espncricinfosb.com': 'ESPNCricinfo'
	    };
	    var siteName = siteNameMap[edition.domain] || 'ESPN';
	    var title = '';
	    var FixturesResultsText = '';
	    var heading = '';
	    var defaultActiveDates = [];
	    var showWeek = false;
	    var multipleLeagues = true;
	    var gamesPresent = false;
	    var seriesId = '';
	    var scoreboardType = 'default';
	    var currYear = new Date().getFullYear();
	    var firstSeries = '';
	    // consutruct year array from current calender year to last 6 year
	    var dateFilter = (0, _common2.getYearDropDown)();
	    var desktopScoreboard = edition.isEspnCricinfo && device && device.desktop && scoreboard.getDesktopScoreboard() || {};
	    var domain = edition.domain || '';
	    var standings = [];
	    var filters = {};
	    var downloadFixtureUrl = '';
	    // if year is passed as query then current year will fetch from query string else current calender year
	    var queryDate = query.date;
	    if (typeof queryDate !== 'undefined' && queryDate !== '') {
	      currYear = (0, _momentTimezone2.default)(queryDate, 'YYYYMMDD').format('YYYY') || queryDate;
	    }
	
	    // Extract sport from params
	    var sport = void 0;
	    if (params && (0, _keys2.default)(params).length > 0) {
	      sport = 'sport' in params ? params.sport : 'cricket';
	    }
	
	    // Default scoreboard data
	    var defaultData = {
	      leagues: defaultLeagues,
	      date: defaultDate,
	      title: (0, _translate2.default)(edition, 'dropdown.leagues.default.' + sport) || '',
	      heading: heading,
	      activeDates: defaultActiveDates,
	      showWeek: showWeek
	
	      // Return default data if res evaluates to a falsy value
	    };if (!res || res.hasOwnProperty('data') === false) {
	      return defaultData;
	    }
	
	    var ucSport = sport.charAt(0).toUpperCase() + sport.slice(1);
	    var ucDomain = domain.replace('www.', '').replace('espn', 'ESPN');
	    var page = {
	      ucSport: ucSport,
	      ucDomain: ucDomain,
	      currYear: currYear,
	      seriesName: '',
	      teamName: '',
	      heading: '',
	      title: 'Live ' + ucSport + ' Scores & Fixtures | ' + siteName,
	      description: 'Get live ' + ucSport + ' scores and performance stats for tours, leagues, and championship matches on ESPN',
	      keywords: 'live ' + sport + ' score, latest, update, ball by ball, match scores'
	
	      // Return default data if scores are undefined or not an array
	    };var allScores = void 0;
	    var newSlug = '';
	    if ((0, _selectn2.default)('data.scores', res)) {
	
	      allScores = (0, _selectn2.default)('data.scores', res);
	
	      if (typeof params.team !== 'undefined') {
	        teamName = (0, _selectn2.default)('data.team.displayName', res) || '';
	        if (sport == 'cricket') {
	          title = heading = (0, _selectn2.default)('data.scores[0].displayName', res) || teamName || '';
	          title = heading = '' + heading + (heading.length > 0 ? ' - ' : '') + 'Fixtures & Results';
	          multipleLeagues = false;
	        } else {
	          title = heading = (0, _selectn2.default)('data.scores[0].leagues[0].name', res) || '';
	          multipleLeagues = false;
	        }
	        scoreboardType = 'team';
	        page.teamName = teamName !== '' ? teamName : '';
	
	        if (typeof query.series !== 'undefined') {
	          seriesId = query.series;
	        } else {
	          firstSeries = (0, _selectn2.default)('data.scores[0].leagues[0].id', res) || '';
	          if (firstSeries) {
	            seriesId = scoreboard.getCurrentLeague(allScores, firstSeries) || '';
	          }
	        }
	      } else {
	        multipleLeagues = true;
	
	        // use translation tool to get correct key
	        var defaultKey = 'dropdown.leagues.default.' + sport;
	        title = (0, _translate2.default)(edition, defaultKey);
	        if (title === defaultKey) {
	          title = (0, _translate2.default)(edition, 'dropdown.leagues.default.sport');
	        }
	
	        //title = 'All Series'
	        heading = 'Live Cricket Scores';
	        if (sport === 'rugby') {
	          heading = (0, _translate2.default)(edition, 'Rugby Scores');
	          //title = translate(edition, 'dropdown.leagues.default.rugby')
	        } else if (sport === 'rugby-league') {
	          heading = 'Rugby League Scores';
	          //title = translate(edition, 'dropdown.leagues.default.rugby')
	        }
	      }
	    } else if ((0, _selectn2.default)('data.leagues', res)) {
	      scoreboardType = 'series';
	      multipleLeagues = false;
	      allScores = [res.data];
	      seriesName = title = heading = (0, _selectn2.default)('data.leagues[0].name', res) || '';
	      FixturesResultsText = (0, _translate2.default)(edition, 'Fixtures and Results');
	      title = heading = '' + heading + (heading.length > 0 ? ' - ' : '') + FixturesResultsText;
	      page.seriesName = seriesName !== '' ? seriesName : '';
	      standings = (0, _selectn2.default)('data.standings', res) || [];
	      newSlug = (0, _selectn2.default)('data.leagues[0].slug', res) || '';
	    }
	    if (typeof allScores === 'undefined' || Array.isArray(allScores) === false) {
	      return defaultData;
	    }
	
	    var team = res.data && res.data.team || {};
	
	    if (team && params.team) {
	      newSlug = team && (team.slug || team.displayName) || '';
	    } else if (newSlug && params.league) {
	      newSlug = (0, _selectn2.default)('data.leagues[0].slug', res) || '';
	    }
	    page.slug = _common.common.getSafeSlug(newSlug);
	    // Process date of returned games from first game's date
	    var apiDate = (0, _selectn2.default)('data.scores[0].events[0].date', res) || (0, _selectn2.default)('data.events[0].date', res);
	    // use default value if date was not found
	    var date = typeof apiDate !== 'undefined' ? apiDate : defaultDate;
	
	    date = scoreboard.getDate(date, params, query);
	
	    var polling = scoreboard.shouldPoll(date, params);
	
	    // By default, set fastcast to false
	    var fastCastMeta = {
	      enabled: false
	
	      /**
	       * Fastcast should be enabled only for scores page
	       *
	       * Fastcast should not be enabled for team & series bases scores pages
	       * since we do not have dedicated for those.
	       *
	       * Also, it should not be enabled for any date other than today's date
	       */
	    };if (params.hasOwnProperty('sport') && params.sport === 'cricket') {
	      // Do not enable for team & series scores pages
	      if (params.hasOwnProperty('team') === false && params.hasOwnProperty('league') === false) {
	        fastCastMeta = {
	          enabled: polling.enabled,
	          scoresTopic: 'scoreboard-cricket',
	          topEventTopic: edition.headerSBTopicId ? 'event-topevents-' + edition.headerSBTopicId : ''
	          // Check if date is passed via query string
	        };if (query && query.hasOwnProperty('date')) {
	          var curDate = _momentTimezone2.default.utc().format('YYYYMMDD');
	          // If queried date is different than current date, disable fastcast
	          if (query.date !== curDate) {
	            fastCastMeta.enabled = false;
	            fastCastMeta.scoresTopic = undefined;
	            fastCastMeta.topEventTopic = undefined;
	          }
	        }
	      }
	    }
	
	    //console.info('scoreboard parser', fastCastMeta)
	
	    // Iterate over the scores and extract league information
	    if (fastCastMeta.enabled) {
	      polling.duration = 15000;
	    }
	    var leagues = [];
	    var isToday = false;
	    var topEvents = [];
	    if (sport === 'cricket' && scoreboardType === 'default') {
	      isToday = !query.date || _dateformat2.default.dateToObject(query.date || '').setHours(0, 0, 0, 0) == defaultDate.setHours(0, 0, 0, 0);
	      if (isToday) {
	        topEvents = topEventIds.length ? topEventIds : scoreboard.getTopEvents(params.sport, allScores);
	      }
	    }
	    if (sport === 'cricket' && scoreboardType === 'series') {
	      var leagueClasses = (0, _selectn2.default)('data.leagues[0].classId', res) || [];
	      var leagueTeams = (0, _selectn2.default)('data.teams', res) || [];
	      filters = scoreboard.getFilters(leagueClasses, leagueTeams, query, location);
	      var legacyLeagueId = (0, _selectn2.default)('data.leagues[0].mappings.cricinfo', res) || '';
	      var currDate = (0, _momentTimezone2.default)(new Date()).format() || '';
	      var endDate = (0, _momentTimezone2.default)((0, _selectn2.default)('data.leagues[0].calendarEndDate', res)).format() || '';
	      downloadFixtureUrl = currDate < endDate ? scoreboard.getDownloadFixtureUrl(legacyLeagueId) : '';
	    }
	
	    for (var i = 0; i < allScores.length; i++) {
	      var data = allScores[i];
	      /**
	       * data object has 2 properties.
	       * extract league information from leagues.
	       * extract matches information from events.
	       */
	      var league = (0, _selectn2.default)('leagues[0]', data);
	      if (typeof league !== 'undefined' && (0, _keys2.default)(league).length > 0) {
	        // set default matches for this league
	        var matches = [];
	        var classId = void 0;
	        var geoRank = void 0;
	        var classIdGroup = void 0;
	        if (scoreboardType === 'team' && sport !== 'cricket') {
	          if (seriesId === league.id) {
	            var _ref = scoreboard.parseEvents(params.sport, data.events, edition, topEvents, filters, scoreboardType, query) || {};
	
	            var _ref$matches = _ref.matches;
	            matches = _ref$matches === undefined ? [] : _ref$matches;
	
	            title = heading = league.name || '';
	          }
	        } else {
	          var _ref2 = scoreboard.parseEvents(params.sport, data.events, edition, topEvents, filters, scoreboardType, query) || {};
	
	          var _ref2$matches = _ref2.matches;
	          matches = _ref2$matches === undefined ? [] : _ref2$matches;
	          var _ref2$classId = _ref2.classId;
	          classId = _ref2$classId === undefined ? '' : _ref2$classId;
	          var _ref2$geoRank = _ref2.geoRank;
	          geoRank = _ref2$geoRank === undefined ? 0 : _ref2$geoRank;
	          var _ref2$classIdGroup = _ref2.classIdGroup;
	          classIdGroup = _ref2$classIdGroup === undefined ? 5 : _ref2$classIdGroup;
	        }
	        if (!gamesPresent) {
	          gamesPresent = matches.length > 0 ? true : false;
	        }
	        var name = league.name;
	        if (scoreboardType === 'team' && league.abbreviation) {
	          name = league.abbreviation;
	        }
	        var leagueLinks = {
	          links: [league.links || {}]
	        };
	        if (matches.length) {
	          leagues.push({
	            name: name,
	            text: name,
	            abbreviation: league.abbreviation,
	            calendar: league.calendar,
	            slug: _common.common.getSafeSlug(league.slug || ''),
	            id: league.id,
	            events: matches,
	            sport: sport,
	            seriesHome: _common.common.extractUrl(leagueLinks, 'Series Home', 'desktop', edition.domain, sport),
	            classId: classId,
	            geoRank: geoRank,
	            classIdGroup: classIdGroup
	          });
	        }
	      }
	    }
	
	    if (!allScores.length) {
	      gamesPresent = false;
	    }
	    var sortedLeagues = [];
	    if (sport == 'cricket') {
	      sortedLeagues = leagues.sort(function (a, b) {
	        return a.classIdGroup - b.classIdGroup || b.geoRank - a.geoRank || a.classId - b.classId;
	      });
	    } else {
	      sortedLeagues = leagues;
	    }
	    var noGamesText = '';
	    if (!gamesPresent) {
	      noGamesText = (0, _translate2.default)(edition, 'No_Games_On_This_Date') || '';
	    }
	
	    var viewTodayText = (0, _translate2.default)(edition, 'ViewToday') || '';
	    var scoresForText = (0, _translate2.default)(edition, 'Scores for') || '';
	    var outbrainHeadline = (0, _translate2.default)(edition, 'sponsoredHeadlines') || '';
	
	    var activeDates = scoreboard.getActiveDates(leagues);
	    //console.info('processData output', { leagues, date, activeDates, title })
	    page.heading = heading;
	    meta = scoreboard.getMetaData(edition, params, page);
	
	    var analytics = scoreboard.getAnalytics(meta, page, edition);
	    var trackingImg = (0, _common2.getTrackingImg)(edition, params.pageType, page.seriesName, page.slug, '', location.pathname, siteType, '', query, '', scoreboardType); // analytics
	
	    return {
	      standings: standings,
	      noGamesText: noGamesText,
	      viewTodayText: viewTodayText,
	      scoresForText: scoresForText,
	      outbrainHeadline: outbrainHeadline,
	      device: device,
	      meta: meta,
	      analytics: analytics,
	      leagues: sortedLeagues,
	      date: date,
	      apiDate: apiDate,
	      ISOdate: date.format(),
	      activeDates: activeDates,
	      title: title,
	      polling: polling,
	      fastCastMeta: fastCastMeta,
	      heading: heading,
	      showWeek: showWeek,
	      multipleLeagues: multipleLeagues,
	      scoreboardType: scoreboardType,
	      currYear: currYear,
	      dateFilter: dateFilter,
	      desktopScoreboard: desktopScoreboard,
	      topEvents: topEvents,
	      domain: domain,
	      isToday: isToday,
	      adblock: adblock,
	      isDataLite: isDataLite,
	      trackingImg: trackingImg,
	      filters: filters,
	      downloadFixtureUrl: downloadFixtureUrl
	    };
	  },
	
	  getTopEvents: function getTopEvents() {
	    var sport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'cricket';
	    var allScores = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    var topEvents = [];
	    if (sport === 'cricket') {
	      allScores.map(function (data) {
	        if (data.events) {
	          data.events.map(function (event) {
	            if (event.isTopEvent) {
	              topEvents.push(event.id);
	            }
	          });
	        }
	      });
	    }
	
	    return topEvents;
	  },
	
	
	  getAnalytics: function getAnalytics(meta) {
	    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var edition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    var omniture = {};
	    //override analytics only for cricinfo
	    if (edition.isEspnCricinfo) {
	      if (page.slug !== '' || page.teamName !== '' || page.seriesName !== '') {
	        omniture = {
	          pageName: (page.slug || page.teamName || page.seriesName) + ':scoreboard',
	          channel: '' + (page.slug || page.teamName || page.seriesName),
	          eVar11: 'cricinfo:' + (page.slug || page.teamName || page.seriesName) + ':scoreboard',
	          prop5: (page.slug || page.teamName || page.seriesName) + ':scoreboard',
	          prop26: '' + (page.slug || page.teamName || page.seriesName),
	          eVar21: '' + (page.slug || page.teamName || page.seriesName)
	        };
	      } else {
	        omniture = {
	          pageName: 'scoreboard:index',
	          channel: 'scoreboard'
	        };
	      }
	    }
	    return {
	      chartbeat: {
	        title: meta.title
	      },
	      omniture: omniture
	    };
	  },
	
	  getMetaData: function getMetaData() {
	    var edition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    // TODO : check for 'All Series' and restrict from inserting
	    var leagueTitle = page.heading;
	    var league = params.league || '';
	    var sport = params && (params.sport || '');
	    var ucSport = page.ucSport || sport;
	    var transKeyObj = {};
	    if (params.sport === 'cricket') {
	      if (!page.teamName && !page.seriesName) {
	        transKeyObj = {
	          title: {
	            key: 'meta.title.cricket.scoreboard',
	            domain: page.ucDomain
	          },
	          description: {
	            key: 'meta.description.cricket.scoreboard',
	            domain: page.ucDomain,
	            year: page.currYear
	          },
	          keywords: {
	            key: 'meta.keywords.cricket.scoreboard'
	          }
	        };
	      }
	      if (page.teamName !== '') {
	        transKeyObj = {
	          title: {
	            key: 'meta.title.cricket.scoreboard.team',
	            team: page.teamName,
	            year: page.currYear,
	            domain: page.ucDomain
	          },
	          description: {
	            key: 'meta.description.cricket.scoreboard.team',
	            team: page.teamName,
	            year: page.currYear,
	            domain: page.ucDomain
	          },
	          keywords: {
	            key: 'meta.keywords.cricket.scoreboard.team',
	            team: page.teamName
	          }
	        };
	      }
	      if (page.seriesName !== '') {
	        transKeyObj = {
	          title: {
	            key: 'meta.title.cricket.scoreboard.series',
	            series: page.seriesName,
	            domain: page.ucDomain
	          },
	          description: {
	            key: 'meta.description.cricket.scoreboard.series',
	            series: page.seriesName,
	            domain: page.ucDomain
	          },
	          keywords: {
	            key: 'meta.keywords.cricket.scoreboard.series',
	            series: page.seriesName
	          }
	        };
	      }
	    }
	
	    if (sport === 'rugby') {
	      if (league && league !== '') {
	        transKeyObj = {
	          title: {
	            key: 'meta.title.rugby.scoreboard',
	            leagueHeading: leagueTitle
	          },
	          keywords: {
	            key: 'meta.keywords.rugby.scoreboard',
	            leagueHeading: leagueTitle
	          },
	          description: {
	            key: 'meta.description.rugby.scoreboard',
	            leagueHeading: leagueTitle
	          }
	        };
	      }
	    }
	
	    var hrefConfig = { showSport: true };
	    if (edition.site === 'espncricinfo') {
	      hrefConfig.showSport = false;
	    }
	    var canonical = _common.common.createCanonical(edition, params, hrefConfig, page.slug);
	    return {
	      title: (0, _translate2.default)(edition, transKeyObj.title) || page.title,
	      description: (0, _translate2.default)(edition, transKeyObj.description) || page.description,
	      keywords: (0, _translate2.default)(edition, transKeyObj.keywords) || page.keywords,
	      canonical: canonical,
	      website: 'article',
	      sport: ucSport && ucSport.toLowerCase()
	    };
	  },
	
	  /**
	  * getDesktopScoreboard builds desktop scoreboard info for RHS
	  * @param  {Object} device   deviceInfo
	  * @return {Object} Object {title , textDescription, href, linkText}
	  **/
	  getDesktopScoreboard: function getDesktopScoreboard() {
	    var title = 'Desktop Scoreboard' || '';
	    var textDescription = 'A mini scoreboard that stays with you and updates all the current matches' || '';
	    var href = '/ci/engine/match/scores/desktop.html' || '#';
	    var linkText = 'Launch Now' || '';
	    return {
	      title: title,
	      textDescription: textDescription,
	      link: {
	        href: href,
	        text: linkText
	      }
	    };
	  },
	
	  /**
	   * Check if videos information present
	   * @param  {Array}  highlights details
	   * @param  {String}  country details
	   * @return {Boolean} false if empty else true
	   */
	  isHighlightPresent: function isHighlightPresent() {
	    var highlights = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var country = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	    var highlightVideo = highlights;
	    if (highlightVideo.length > 0) {
	      highlightVideo = highlightVideo.filter(function (v) {
	        return !(0, _common2.isGeoRestricted)(v.geoRestrictions, country.toUpperCase());
	      });
	    }
	    return highlightVideo.length > 0 ? true : false;
	  },
	
	  /**
	   * Parse events/games for cricket
	   * @param  {String} sport     The current sport
	   * @param  {Array}  events    list of sports matches
	   * @param  {Object} edition   edition
	   * @param  {Array}  topEvents topEvent Ids to filter
	   * @param  {Object} filters filters for series filter (team/match type)
	   * @param  {String} scoreboardType   scoreboardType
	   * @param  {String} query     URL Query objects
	   * @return {Array}            program friendly parsed list of matches.Each Match
	   *                            object will have keys {details, gameState, links,
	   *                            statusText, teams, weather, winnerClass}
	   */
	  parseEvents: function parseEvents() {
	    var sport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var events = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	    var edition = arguments[2];
	    var topEvents = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	    var filters = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	    var scoreboardType = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'default';
	    var query = arguments[6];
	
	    // Return empty array if there are no events
	    if (events.length === 0) {
	      return events;
	    }
	
	    // Iterate over each event/game and extract information
	    var classIds = [];
	    var geos = [];
	    var filterType = filters.type;
	    var filterValue = filters.value;
	    var exclClassIds = [1, 2, 3];
	    var lang = edition.language || 'en';
	    // grouping classIds as International, domestic, women, youth etc
	    var classIdGroups = {
	      1: 1,
	      2: 1,
	      3: 1,
	      4: 4,
	      5: 4,
	      6: 2,
	      7: 4,
	      8: 3,
	      9: 3,
	      10: 3,
	      11: 5,
	      12: 5,
	      13: 5,
	      14: 5,
	      15: 5,
	      16: 5
	    };
	    var parsedEvents = [],
	        queryDate = query.date;
	    for (var i = 0; i < events.length; i++) {
	      var ev = events[i];
	      var gameId = ev['id'];
	      if (topEvents.indexOf(gameId) >= 0) {
	        continue;
	      }
	      var date = (0, _momentTimezone2.default)(ev['date']).format('MMMM Do, YYYY');
	      var competition = (0, _selectn2.default)('competitions[0]', ev) || {};
	
	      var filterClassId = parseInt((0, _selectn2.default)('class.internationalClassId', competition)) || parseInt((0, _selectn2.default)('class.generalClassId', competition));
	      classIds.push(filterClassId);
	
	      if (filterValue && filterType === 'class') {
	        if (filterValue === 'others') {
	          if (exclClassIds.indexOf(filterClassId) !== -1) {
	            // skiping test, odi n t20i class ids
	            continue;
	          }
	        } else if (filterValue !== parseInt(filterClassId)) {
	          continue;
	        }
	      }
	
	      var state = (0, _selectn2.default)('status.type.state', ev);
	      var competitors = competition.competitors || [];
	      var odds = (0, _selectn2.default)('[0]', competition.odds) || {}; // odds are array of objects in scorepanel api
	      var details = competition.details || [];
	      //const status = ev.status || {}
	      var links = (0, _selectn2.default)('links', ev) || [];
	
	      //do not show articles for es and pt
	      if (lang === 'es' || lang === 'pt') {
	        var esLinks = [];
	        var linksLen = links.length || 0;
	        for (var _i = 0; _i < linksLen; _i++) {
	          var item = links[_i] || {};
	          var rel = item.rel || [];
	          if (!(rel.indexOf('recap') > -1 || rel.indexOf('match') > -1)) {
	            esLinks.push(item);
	          }
	        }
	        links = esLinks;
	      }
	
	      var highlights = competition.highlights || [];
	      var timeValid = competition.timeValid || false;
	      var gameState = _common.common.getGameState(state);
	      var teams = scoreboard.getTeams(competitors, gameState);
	
	      var homeTeamId = (0, _selectn2.default)('home.id', teams) || 0;
	      var awayTeamId = (0, _selectn2.default)('away.id', teams) || 0;
	
	      if (filterType == 'team' && filterValue && !(filterValue === homeTeamId || filterValue === awayTeamId)) {
	        continue;
	      }
	
	      // for favourite module pick description rest sombination of shortdescription + date from description
	      var matchDesc = ev['description'];
	      var eventDateInfo = typeof matchDesc === 'undefined' ? '' : matchDesc.substring(matchDesc.lastIndexOf(','), matchDesc.length);
	      var info = competition.shortDescription;
	      var isTopEvent = ev.isTopEvent || false;
	
	      var eventSummaryData = _eventSummary2.default.getSummaryFromDetails(sport, edition, competitors, details);
	      var eventClock = (0, _selectn2.default)('status.displayClock', competition) || '0\'';
	
	      geos = geos.concat(teams.teamGeo || []);
	
	      var gameUrl = _common.common.getUrlByRel({ links: links }, 'match', edition.domain, sport, edition.isEspnCricinfo);
	
	      // CTOI-35558
	      // hack for generating gameUrl from code till API is fixed
	      if (lang === 'es' || lang === 'pt') {
	        gameUrl = _common.common.getUrlByRel({ links: links }, 'summary', edition.domain, sport);
	      }
	
	      //Translate URLs
	      var localizedHref = (0, _translateURI.translateURI)(edition, { url: gameUrl }, false);
	      gameUrl = localizedHref.url;
	
	      var parsedEvent = {
	        gameId: gameId,
	        gameDate: date,
	        date: ev['date'],
	        teams: teams,
	        gameState: gameState,
	        statusText: scoreboard.getCricketGameStatus(sport, competition, edition.timeZoneBucket, queryDate, timeValid),
	        winnerClass: _common.common.getWinnerClass(competitors, sport),
	        links: _common.common.getGameLinks(links, sport, edition, scoreboard.isHighlightPresent(highlights, edition.userGeo), gameState),
	        gameUrl: gameUrl,
	        note: scoreboard.getGameNote(ev),
	        info: info + eventDateInfo,
	        favInfo: matchDesc,
	        eventSummary: eventSummaryData,
	        eventClock: eventClock,
	        odds: odds,
	        isTopEvent: isTopEvent,
	        timeValid: timeValid
	      };
	
	      parsedEvents.push(parsedEvent);
	    }
	    var _edition$userGeo = edition.userGeo,
	        userGeo = _edition$userGeo === undefined ? '' : _edition$userGeo;
	
	    var geoRank = geos.indexOf(userGeo.toUpperCase()) >= 0 ? 1 : 0;
	    var classId = Math.min.apply(Math, classIds);
	    var classIdGroup = classIdGroups[classId] || 0;
	    return { matches: parsedEvents, classId: classId, geoRank: geoRank, classIdGroup: classIdGroup };
	  },
	
	  /**
	   * Wrapper function for passing cricket specific options to getGameStatusText
	   * @param  {[type]} sport           Sport
	   * @param  {[type]} competition     competition object describing game
	   * @param  {String} timeZoneBucket  timeZoneBucket
	   * @param {Object} queryDate Date for which scoreboard is being displayed
	   * @param {Boolean} timeValid timeValid
	   * @return {[type]}                 Output of getGameStatusText
	   */
	  getCricketGameStatus: function getCricketGameStatus(sport, competition, timeZoneBucket, queryDate) {
	    var timeValid = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
	
	    var competitionDate = competition.date,
	        tzOptions = {
	      // Set time zone to IST
	      // TODO: use time zones based on editions
	      timeZone: process.browser && _momentTimezone2.default.tz.guess() || timeZoneBucket,
	      timeFormat: sport === 'cricket' && !_dateformat2.default.isTheGameToday(competitionDate, queryDate) ? 'ddd D/M - hh:mm a z' : 'hh:mm a z'
	      //console.info('tzOptions', tzOptions)
	    };return _common.common.getGameStatusText(sport, competition, tzOptions, timeValid).toUpperCase();
	  },
	
	  /**
	   * Get game note
	   * @param  {Object} ev event/game object
	   * @return {String}    game note if found else empty string
	   */
	  getGameNote: function getGameNote() {
	    var ev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var defaultNote = '';
	    var session = (0, _selectn2.default)('status.session', ev) || '';
	    if (session) {
	      session = session + ': ';
	    }
	    var gameNote = session + (0, _selectn2.default)('status.summary', ev);
	    // Return game note if found else return default game note
	    return typeof gameNote !== 'undefined' ? gameNote : defaultNote;
	  },
	
	  /**
	   * Get home and away teams details
	   * @param  {Array}  competitors competitors array from feed
	   * @param  {String} gameState pregame/live/final
	   * @return {Object}             teams object with {home, away}
	   */
	  getTeams: function getTeams() {
	    var competitors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var gameState = arguments[1];
	
	    var teams = {};
	    var teamsOrder = [];
	    var teamGeo = [];
	    if (competitors.length > 1 && (0, _selectn2.default)('[0].homeAway', competitors) === (0, _selectn2.default)('[1].homeAway', competitors)) {
	      competitors[0].homeAway = 'home';
	      competitors[1].homeAway = 'away';
	    }
	    competitors.map(function (competitor) {
	      // default to empty object if not available
	      var team = competitor.team || {};
	      var teamScore = scoreboard.getTeamScores(competitor);
	      // Get breakup of runs and overs/target
	
	      var _common$splitScore3 = _common.common.splitScore(teamScore),
	          _common$splitScore4 = (0, _slicedToArray3.default)(_common$splitScore3, 2),
	          runDetails = _common$splitScore4[0],
	          overDetails = _common$splitScore4[1];
	      // Is this team batting now?
	
	
	      var isTeamBattingNow = _helpers2.default.isTeamBattingNow(competitor, gameState);
	      // If team is batting in current innings, suffix * as per cricket convention
	      var scoreMarkup = _common.common.getFullScoreMarkup(teamScore, 'sm', 'div', true, isTeamBattingNow, false);
	      var scoreMarkupSpan = _common.common.getFullScoreMarkup(teamScore, 'cscore_overs', 'span', true, isTeamBattingNow, true);
	      // Populate teams object with home and away data
	      teams[competitor.homeAway] = {
	        name: team.name,
	        id: team.id,
	        abbr: team.abbreviation,
	        logo: _common.common.getTeamLogo(team),
	        href: _common.common.getTeamUrl(team),
	        score: teamScore,
	        runDetails: runDetails,
	        overDetails: overDetails,
	        scoreMarkup: scoreMarkup,
	        scoreMarkupSpan: scoreMarkupSpan,
	        links: scoreboard.getTeamLinks(team),
	        winner: competitor.winner || false,
	        record: 'Form: ' + competitor.form || '-',
	        order: competitor.order,
	        countryCode: team.countryCode
	      };
	    });
	
	    var homeTeamGeo = ((0, _selectn2.default)('home.countryCode', teams) || '').toUpperCase();
	    var awayTeamGeo = ((0, _selectn2.default)('away.countryCode', teams) || '').toUpperCase();
	
	    var gameInfo = (teams.home && teams.home.name) + '_vs_' + (teams.away && teams.away.name);
	    teamGeo = [homeTeamGeo, awayTeamGeo];
	
	    var homeTeamOrder = (0, _selectn2.default)('home.order', teams) || 0;
	    var awayTeamOrder = (0, _selectn2.default)('away.order', teams) || 0;
	    if (homeTeamOrder > 0 && awayTeamOrder > 0) {
	      teamsOrder = homeTeamOrder == 1 ? ['home', 'away'] : ['away', 'home'];
	    } else {
	      (0, _keys2.default)(teams).map(function (key) {
	        teamsOrder.push(key);
	      });
	    }
	
	    return (0, _extends3.default)({}, teams, { teamsOrder: teamsOrder, teamGeo: teamGeo, gameInfo: gameInfo });
	  },
	
	  getCurrentLeague: function getCurrentLeague() {
	    var scores = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var prevSeriesId = arguments[1];
	
	    var startDate = '';
	    var endDate = '';
	    var calendar = [];
	    var currDate = _momentTimezone2.default.utc(new Date()).format();
	    var currSeries = '';
	
	    for (var i = 0; i < scores.length; i++) {
	      var score = scores[i];
	      calendar = (0, _selectn2.default)('leagues[0].calendar', score);
	      if (calendar.length > 0) {
	        startDate = calendar[0];
	        startDate = (0, _momentTimezone2.default)(startDate).format();
	        endDate = calendar[calendar.length - 1];
	        endDate = (0, _momentTimezone2.default)(endDate).format();
	        var iscurr = (0, _common2.isCurrentLeague)(startDate, endDate, currDate);
	        //currSeries = selectn('leagues[0].id', score)
	        //console.info('calendar:::::::::', currDate, startDate, endDate, iscurr, currSeries)
	        //console.info('comparassion:::::', currDate > startDate, prevSeriesId)
	        if (iscurr) {
	          currSeries = (0, _selectn2.default)('leagues[0].id', score);
	          break;
	        } else if (currDate > startDate) {
	          currSeries = prevSeriesId;
	        } else if (currDate < startDate) {
	          prevSeriesId = (0, _selectn2.default)('leagues[0].id', score);
	        }
	      }
	    }
	    //console.info('currSeries::::::::::', currSeries)
	    return currSeries;
	  },
	
	  /**
	   * Get score of a team
	   * @param  {Object} competitor Each competitior from competitors array
	   * @return {String}            Score if found else empty string
	   */
	  getTeamScores: function getTeamScores() {
	    var competitor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    return 'score' in competitor ? competitor.score : '';
	  },
	
	  /**
	   * Filter links for teams. Used as a callback function.
	   * @param  {Object} obj Link Object
	   * @return {Boolean}     true if link text is found in valid array else false
	   */
	  filterLinks: function filterLinks(obj) {
	    // Lookup links with text
	    var valid = ['Fixtures', 'Statistics', 'Squad', 'Clubhouse'];
	    var linkText = obj.text;
	    // Return false If valid string is not found in the link text
	    if (valid.indexOf(linkText) === -1) {
	      return false;
	    }
	    // Get link type object
	    var linkType = obj.rel;
	    // valid link type
	    var validType = 'desktop';
	    // Return true if desktop is found in rel array of the link object
	    if (Array.isArray(linkType) === true) {
	      if (linkType.indexOf(validType) > -1) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  /**
	   * Get team links for 'Fixtures', 'Statistics', 'Squad'
	   * @param  {Object} team team Object
	   * @return {Array}       Array of team links
	   */
	  getTeamLinks: function getTeamLinks(team) {
	    var teamLinks = [];
	    //console.info('inside getTeamLinks', team)
	    var links = team.links;
	    // filter out required links
	    teamLinks = links.filter(scoreboard.filterLinks);
	    //console.info('links, size', links, links.length)
	    //console.info('teamLinks, size', teamLinks, teamLinks.length)
	    var href = (0, _selectn2.default)('[0].href', teamLinks) || '';
	    if (href !== '') {
	      teamLinks[0].href = _common.common.buildURL(href);
	    }
	
	    return teamLinks;
	  },
	
	  getActiveDates: function getActiveDates(leagues) {
	    var dates = {};
	    var calendar = [];
	
	    if (typeof leagues !== 'undefined') {
	      leagues.map(function (league) {
	        calendar = calendar.concat(league.calendar);
	      });
	
	      calendar.map(function (date) {
	        dates[new Date(date).setHours(0, 0, 0, 0)] = 1;
	      });
	
	      return dates;
	    }
	  },
	
	  getDate: function getDate(date) {
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    var dateQuery = query.date && (0, _momentTimezone2.default)(query.date, 'YYYYMMDD') || null;
	    var leagueQuery = params.league || query.league;
	    var eventDate = typeof date !== 'undefined' ? (0, _momentTimezone2.default)(date, 'YYYYMMDD') : _momentTimezone2.default.utc();
	    // default date is the date passed as this is the one got from the first match in the results
	    var finalDate = params.sport !== 'cricket' ? eventDate : _momentTimezone2.default.utc();
	
	    // if league query, use event date
	    if (leagueQuery) {
	      finalDate = eventDate;
	    }
	
	    // dateQuery supercedes all dates
	    if (dateQuery) {
	      finalDate = dateQuery;
	    }
	
	    return finalDate;
	  },
	  getDownloadFixtureUrl: function getDownloadFixtureUrl(id) {
	    var legacyurl = '';
	    if (id.length > 0) {
	      legacyurl = 'http://www.espncricinfo.com/ci/content/series/' + id + '.ics?template=ical';
	    }
	    return legacyurl;
	  },
	  shouldPoll: function shouldPoll(date) {
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var duration = 20000;
	    var enabled = false;
	    if (params.hasOwnProperty('team') || params.hasOwnProperty('league')) {
	      return { enabled: enabled, duration: duration };
	    }
	    var startTime = _momentTimezone2.default.utc();
	    var endTime = (0, _momentTimezone2.default)(date);
	    var diff = endTime.diff(startTime, 'days');
	    // console.log(startTime.format(), endTime.format(), diff)
	    // TODO: update and optimize logic
	    // polling 5 days, before and after the game, considering test games
	    if (Math.abs(diff) <= 5) {
	      enabled = true;
	    }
	    return { enabled: enabled, duration: duration };
	  },
	  getFilters: function getFilters() {
	    var classIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var teams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	    var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var location = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	    var filters = {
	      list: []
	    };
	    var classIdMapping = {
	      1: 'Tests',
	      2: 'ODI',
	      3: 'T20i'
	    };
	    var pushedIds = [];
	    var pushedFilters = [];
	    var link = location.pathname;
	    if (classIds.length || teams.length) {
	      filters.list.push({
	        text: 'All',
	        href: location.pathname
	      });
	    }
	    if (classIds.length > 1) {
	      filters.type = 'class';
	      for (var i = 0; i < classIds.length; i++) {
	        var displayText = classIdMapping[classIds[i]] || 'Others';
	        if (pushedIds.indexOf(classIds[i]) === -1 && pushedFilters.indexOf(displayText) === -1) {
	          pushedIds.push(classIds[i] || 'others');
	          pushedFilters.push(displayText);
	          filters.list.push({
	            text: displayText,
	            href: link + '?type=' + displayText.toLowerCase()
	          });
	        }
	        if (query.type == displayText.toLowerCase()) {
	          filters.displayValue = displayText;
	          filters.value = [1, 2, 3].indexOf(parseInt(classIds[i])) == -1 ? 'others' : parseInt(classIds[i]);
	        }
	      }
	    } else if (teams.length) {
	      filters.type = 'team';
	      for (var _i2 = 0; _i2 < teams.length; _i2++) {
	        var ithTeam = teams[_i2] || {};
	        var teamId = ithTeam.id || '';
	        var teamName = ithTeam.displayName || ithTeam.name || '';
	        if (query.teamid && query.teamid == teamId) {
	          filters.value = teamId;
	          filters.displayValue = teamName;
	        }
	        if (pushedIds.indexOf(teamId) == -1 && teamName && teamId) {
	          pushedIds.push(teamId);
	          filters.list.push({
	            text: teamName,
	            href: link + '?teamid=' + teamId
	          });
	        }
	      }
	    }
	    return filters;
	  }
	};
	
	exports.default = scoreboard;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(811);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(435);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(812), __esModule: true };

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(336);
	__webpack_require__(315);
	module.exports = __webpack_require__(813);


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(373);
	var ITERATOR = __webpack_require__(335)('iterator');
	var Iterators = __webpack_require__(320);
	module.exports = __webpack_require__(288).isIterable = function (it) {
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    // eslint-disable-next-line no-prototype-builtins
	    || Iterators.hasOwnProperty(classof(O));
	};


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.leagues = exports.common = undefined;
	
	var _getIterator2 = __webpack_require__(435);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _isFinite = __webpack_require__(815);
	
	var _isFinite2 = _interopRequireDefault(_isFinite);
	
	var _keys = __webpack_require__(419);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _entries = __webpack_require__(818);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _slicedToArray2 = __webpack_require__(810);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _assign = __webpack_require__(365);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(364);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(416);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _selectn = __webpack_require__(438);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	var _queryString = __webpack_require__(207);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _espnUrl = __webpack_require__(821);
	
	var _espnUrl2 = _interopRequireDefault(_espnUrl);
	
	var _dateformat = __webpack_require__(449);
	
	var _dateformat2 = _interopRequireDefault(_dateformat);
	
	var _isReactPath = __webpack_require__(829);
	
	var _isReactPath2 = _interopRequireDefault(_isReactPath);
	
	var _parseURI = __webpack_require__(830);
	
	var _parseURI2 = _interopRequireDefault(_parseURI);
	
	var _translate = __webpack_require__(833);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	var _helpers = __webpack_require__(834);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _translateURI = __webpack_require__(832);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var URL_BLACKLIST_REGEX = '(espnfc|gamecast|watchespn|stubhub|insider|cricinfo|ncaa\.com|en\.espn)'; /* global window */
	/**
	 * @fileOverview common parsers which are common across sports.
	 */
	
	var common = {
	
	  defaultUrls: {
	    teamLogo: 'https://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/default-team-logo-500.png',
	    playerLogo: 'https://a.espncdn.com/combiner/i?img=/i/headshots/cricket/players/default-player-logo-500.png'
	  },
	
	  buildURL: function buildURL() {
	    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var domain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	    /**
	     * If url is for espncricinfo.com, return it as is.
	     * Else use url as returned by espn-url.
	     * If an exception is thrown, return url as is
	     */
	    try {
	      url = typeof url === 'string' ? url : '';
	      domain = typeof domain === 'string' ? domain : '';
	
	      var urlObj = (0, _parseURI2.default)(url) || {};
	
	      var isEspnCricinfoSBUrl = url.indexOf('espncricinfosb.com') > -1 ? true : false;
	      var isEspnUKUrl = url.indexOf('en.espn.co.uk') > -1 ? true : false;
	      var isWatchEspnUrl = url.indexOf('espn.com/watch') > -1 ? true : false;
	      var isEspnCricinfoUrl = url.indexOf('espncricinfo.com') > -1 ? true : false;
	      var isEspnAUDomain = domain.indexOf('espn.com.au') > -1 ? true : false;
	      var isEspnAfricaDomain = domain.indexOf('africa.espn.com') > -1 ? true : false;
	      var isEspnCricinfoDomain = domain.indexOf('espncricinfo.com') > -1 ? true : false;
	      var isEspnCricinfoLegacy = url.indexOf('espncricinfo.com') > -1 && /(\/content\/|\/engine\/)/.test(url) ? true : false;
	      var isTcmUrl = url.indexOf('thecricketmonthly.com') > -1 ? true : false;
	
	      if ((isEspnCricinfoSBUrl || isEspnUKUrl || isWatchEspnUrl || isEspnCricinfoUrl) && !domain) {
	        return url;
	      } else if (isEspnCricinfoLegacy || isTcmUrl) {
	        return url;
	      } else if (!isEspnCricinfoUrl && isEspnCricinfoDomain) {
	        var relativeUrl = urlObj.relative;
	        // remove `/cricket' for espncricinfo
	        relativeUrl = relativeUrl.replace(/^\/cricket/, '');
	        if (urlObj.protocol) {
	          return urlObj.protocol + '://' + (domain + relativeUrl);
	        } else {
	          return relativeUrl;
	        }
	      } else if (isEspnCricinfoUrl && isEspnCricinfoDomain) {
	        return url;
	      } else if (isEspnCricinfoUrl && !isEspnCricinfoDomain) {
	        var _relativeUrl = urlObj.relative || {};
	        // Add `/cricket' to cricket links for non-espncricinfo domains if /cricket is not in path
	        if (_relativeUrl.indexOf('/cricket/') === -1) {
	          _relativeUrl = _relativeUrl.replace(/^/, '/cricket');
	        }
	        return _relativeUrl;
	      } else if ((isEspnAfricaDomain || isEspnAUDomain) && url.indexOf('/cricket') !== -1) {
	        return (0, _parseURI2.default)(url).relative;
	      } else if (domain) {
	        return (0, _espnUrl2.default)(url, domain);
	      } else {
	        return (0, _parseURI2.default)(url).relative;
	      }
	    } catch (e) {
	      return url;
	    }
	  },
	
	  /**
	   * Creates href from params
	   * @param  {String} options.pageType PageType
	   * @param  {String} options.sport    Sport
	   * @param  {String} options.leagueId League Id
	   * @param  {String} options.gameId   Game Id
	   * @param  {String} options.slug     Slug
	   * @param  {String} options.webview  webview
	   * @param  {String} options.platform  platform
	   * @param  {Object} options.query    Query params
	   * @return {String}                  Created href/url
	   */
	  createHref: function createHref(_ref) {
	    var pageType = _ref.pageType,
	        sport = _ref.sport,
	        sortKey = _ref.sortKey,
	        sortDir = _ref.sortDir,
	        leagueId = _ref.leagueId,
	        league = _ref.league,
	        season = _ref.season,
	        gameId = _ref.gameId,
	        slug = _ref.slug,
	        date = _ref.date,
	        seasontype = _ref.seasontype,
	        _ref$query = _ref.query,
	        query = _ref$query === undefined ? {} : _ref$query,
	        platform = _ref.platform,
	        webview = _ref.webview,
	        team = _ref.team,
	        day = _ref.day,
	        teamId = _ref.teamId,
	        _ref$showSport = _ref.showSport,
	        showSport = _ref$showSport === undefined ? true : _ref$showSport;
	
	
	    league = league || leagueId;
	    team = team || teamId;
	
	    var filter = query.filter,
	        innings = query.innings,
	        rest = (0, _objectWithoutProperties3.default)(query, ['filter', 'innings']);
	
	    var href = (showSport ? '/' + sport : '') + '/' + pageType;
	    var queryObject = (0, _extends3.default)({}, rest);
	    var leagueKey = 'league';
	
	    if (sport === 'cricket') {
	      leagueKey = 'series';
	    }
	
	    if (league == slug) {
	      slug = '';
	    }
	
	    switch (pageType) {
	      case 'fixtures':
	      case 'schedule':
	      case 'results':
	        if (league || date || team || season) {
	          href += '/_';
	        }
	        href += '' + (team ? '/team/' + team : '') + (league ? '/' + leagueKey + '/' + league : '') + (season ? '/season/' + season : '') + (date ? '/date/' + date : '') + (slug ? '/' + slug : '');
	        break;
	
	      case 'standings':
	      case 'table':
	        if (sport !== 'cricket') {
	          href += '/_';
	          slug = '';
	        }
	        href += '' + (sortKey ? '/sort/' + sortKey : '') + (sortDir ? '/dir/' + sortDir : '') + (league ? '/' + leagueKey + '/' + league : '') + (season ? '/season/' + season : '') + (seasontype ? '/seasontype/' + seasontype : '') + (slug ? '/' + slug : '');
	        break;
	
	      case 'scoreboard':
	      case 'scores':
	        if (sport !== 'cricket' && league) {
	          href += '/_';
	        }
	        href += '' + (team ? '/team/' + team : '') + (league ? '/' + leagueKey + '/' + league : '') + (season ? '/season/' + season : '') + (slug ? '/' + slug : '');
	        break;
	
	      case 'game':
	      case 'match':
	      case 'scorecard':
	      case 'statistics':
	      case 'matchstats':
	      case 'playerstats':
	      case 'lineups':
	      case 'conversation':
	      case 'coverage':
	      case 'video':
	      case 'hawkeye':
	        if (sport === 'cricket') {
	          // Appends a default slug 'webview' if the webview param exists.
	          // This is necessary as the sendJSONMessage method replaces it
	          // with the encoded JSON string, using window.location. This triggers a page reload
	          // but keeps the user on the same page.
	          href = (showSport ? '/' + sport : '') + '/series/' + league + '/' + pageType + '/' + gameId + (slug ? '/' + slug : '') + (platform ? '/' + platform : '') + (webview ? '/' + 'webview' : '');
	        } else if (sport === 'rugby' || sport === 'rugby-league') {
	          href = (showSport ? '/' + sport : '') + '/' + pageType + (platform ? '/' + platform : '') + (webview ? '/webview' : '');
	          queryObject = (0, _extends3.default)({ gameId: gameId }, rest, { league: league });
	        } else {
	          href = (showSport ? '/' + sport : '') + '/' + pageType;
	          queryObject = (0, _extends3.default)({ gameId: gameId }, rest, { league: league });
	        }
	        break;
	      case 'preview':
	      case 'recap':
	      case 'report':
	        if (sport === 'cricket') {
	          href = (showSport ? '/' + sport : '') + '/series/' + league + '/' + pageType + '/' + gameId + (day ? '/day/' + day : '') + (slug ? '/' + slug : '') + (platform ? '/' + platform : '') + (webview ? '/' + 'webview' : '');
	        } else if (sport === 'rugby' || sport === 'rugby-league') {
	          href = (showSport ? '/' + sport : '') + '/' + pageType + (platform ? '/' + platform : '') + (webview ? '/webview' : '');
	          queryObject = (0, _extends3.default)({ gameId: gameId }, rest, { league: league });
	        } else {
	          href = (showSport ? '/' + sport : '') + '/' + pageType;
	          queryObject = (0, _extends3.default)({ gameId: gameId }, rest, { league: league });
	        }
	        break;
	      case 'commentary':
	        if (sport === 'cricket') {
	          href = (showSport ? '/' + sport : '') + '/series/' + league + '/' + pageType + '/' + gameId + (slug ? '/' + slug : '') + (platform ? '/' + platform : '') + (webview ? '/' + 'webview' : '');
	          queryObject = (0, _extends3.default)({ filter: filter, innings: innings }, rest);
	        } else if (sport === 'rugby' || sport === 'rugby-league') {
	          href = (showSport ? '/' + sport : '') + '/' + pageType + (platform ? '/' + platform : '') + (webview ? '/webview' : '');
	          queryObject = (0, _extends3.default)({ gameId: gameId }, rest, { league: league });
	        } else {
	          href = (showSport ? '/' + sport : '') + '/' + pageType;
	          queryObject = (0, _extends3.default)({ gameId: gameId }, rest, { league: league });
	        }
	        break;
	      case 'team':
	        href = (showSport ? '/' + sport : '') + '/' + pageType + (team ? '/_/id/' + team : '') + '/' + (slug ? slug : '');
	        break;
	    }
	
	    var queryString = _queryString2.default.stringify(queryObject);
	
	    queryString = queryString ? '?' + queryString : '';
	
	    href += queryString;
	
	    return href;
	  },
	  /**
	   * Function to clean up slug and convert it to lowercase
	   * @param {String} slug will have the string to be filtered
	   * @return {String} returns slug as a sting, lowercase, hypehnated
	   */
	  getSafeSlug: function getSafeSlug(slug) {
	    var cleanSlug = '';
	    if (slug && slug != '') {
	      cleanSlug = slug.replace(/\//g, '');
	      cleanSlug = cleanSlug.replace(/\s+/g, '-').toLowerCase();
	    }
	    return cleanSlug;
	  },
	
	  /**
	   * [getSlugFromUrl Get the correct slug from URL, mostly used from API link]
	   * @param  {String} offset [gameId or teamId etc which comes before the slug]
	   * @param  {String} path   [path from the API or location from which slug has to be extracted]
	   * @return {String}        [returns the slug, lowercase, hyphen separated, and remove extra slash]
	   */
	  getSlugFromUrl: function getSlugFromUrl(offset, path) {
	    var slug = '';
	    var pathArr = path.split(offset);
	    slug = pathArr.length > 1 ? pathArr && pathArr[1] : '';
	    if (slug && slug != '') {
	      slug = slug.replace(/\//g, '');
	      slug = slug.replace(/\s+/g, '-').toLowerCase();
	    }
	    return slug;
	  },
	
	  /**
	   * [createCanonical Create a normalized canonical which is unique, which has a single slug]
	   * @param  {Object} edition    [editions data]
	   * @param  {Object} params     [normalized route params]
	   * @param  {Object} hrefConfig [hrefConfig params for creating advanced links]
	   * @param  {String} newSlug    [new slug which will be unique from API]
	   * @return {String}            [returns relative canonical url]
	   */
	  createCanonical: function createCanonical() {
	    var edition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var hrefConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var newSlug = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	
	    //clone the params, except the slug
	    var cloneParams = (0, _assign2.default)({}, params);
	    var cloneHrefConfig = (0, _assign2.default)({}, hrefConfig);
	    var canonical = '';
	    cloneParams.slug = newSlug;
	
	    cloneHrefConfig.showSport = true;
	
	    if (edition.site === 'espncricinfo') {
	      cloneHrefConfig.showSport = false;
	    }
	
	    if (params.sport === 'cricket' && edition.site === 'espn') {
	      cloneHrefConfig.showSport = false;
	    }
	    //remove platform and webview params for keeping correct sharing URL in sapp
	    if (cloneParams.platform) {
	      cloneParams.platform = '';
	      cloneParams.webview = '';
	    }
	
	    //create canonical url from params and hrefConfig and add new slug
	    canonical = common.createHref((0, _extends3.default)({}, cloneParams, cloneHrefConfig));
	    return canonical;
	  },
	
	
	  createTrackingName: function createTrackingName() {
	    var trackingParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    var trackingName = '';
	    trackingName = '&lpos=' + trackingParams.join(':');
	    return trackingName;
	  },
	
	  /**
	  * Function to build a structured object that AnchorLink will accept as {...link}
	  * based around the common.createHref function, If used to create every link it will
	  * represent a singular place to modify and validate URLS.
	  * @param    {Object}  noname    Object of params none are required all will default
	  * @return   {Object}            Link Object
	  **/
	  buildLinkObject: function buildLinkObject(_ref2) {
	    var _ref2$params = _ref2.params,
	        params = _ref2$params === undefined ? {} : _ref2$params,
	        _ref2$query = _ref2.query,
	        query = _ref2$query === undefined ? {} : _ref2$query,
	        _ref2$edition = _ref2.edition,
	        edition = _ref2$edition === undefined ? {} : _ref2$edition,
	        _ref2$text = _ref2.text,
	        text = _ref2$text === undefined ? null : _ref2$text,
	        _ref2$external = _ref2.external,
	        external = _ref2$external === undefined ? false : _ref2$external,
	        _ref2$dataRoute = _ref2.dataRoute,
	        dataRoute = _ref2$dataRoute === undefined ? false : _ref2$dataRoute,
	        _ref2$href = _ref2.href,
	        href = _ref2$href === undefined ? '' : _ref2$href,
	        _ref2$tracking = _ref2.tracking,
	        tracking = _ref2$tracking === undefined ? [] : _ref2$tracking,
	        _ref2$classes = _ref2.classes,
	        classes = _ref2$classes === undefined ? [] : _ref2$classes,
	        hrefConfig = _ref2.hrefConfig;
	
	
	    var routerLink = false;
	
	    if (params.pageType && !href) {
	      href = common.createHref((0, _extends3.default)({ query: query }, params, hrefConfig)) || '';
	
	      if (edition.language === 'es' || edition.language === 'pt') {
	        //Translate URLs
	        var localizedHref = (0, _translateURI.translateURI)(edition, { url: href }, false);
	        href = localizedHref.url;
	      }
	    }
	
	    if (!href) {
	      href = '#';
	    }
	
	    if (external || dataRoute) {
	      dataRoute = false;
	    } else if (!href.match(URL_BLACKLIST_REGEX)) {
	
	      var parsedURI = (0, _parseURI2.default)(href) || {};
	      var relativePath = parsedURI.path || '';
	      var validatePath = relativePath;
	
	      if (parsedURI.host) {
	        validatePath = 'http://' + edition.domain + relativePath;
	      }
	
	      routerLink = (0, _isReactPath2.default)(edition.host, validatePath, edition);
	
	      if (routerLink) {
	        href = relativePath;
	        if (parsedURI.query) {
	          href += '?' + parsedURI.query;
	        }
	      }
	    }
	
	    if (classes && classes.constructor !== Array) {
	      console.warn('classes expects an array');
	      var tmpArr = [];
	      tmpArr.push(classes);
	      classes = tmpArr;
	    }
	
	    if (tracking && tracking.constructor !== Array) {
	      console.warn('classes expects an array');
	      var _tmpArr = [];
	      _tmpArr.push(tracking);
	      tracking = _tmpArr;
	    }
	
	    return {
	      text: text || '',
	      pageType: params.pageType,
	      to: href,
	      href: href, /* backward compatability */
	      trackingName: common.createTrackingName(tracking) || '',
	      external: external,
	      isRouterLink: routerLink,
	      dataRoute: dataRoute,
	      classes: classes,
	      league: params.league
	    };
	  },
	
	  /**
	   * filter and order stats by names and pageType
	   * @param  {Array}  stats stats node
	   * @param  {Object} names stats to filter, ex:{ name: '', index: 0 }
	   * @param  {String} pageType name of the page
	   * @return {Array}       [description]
	   */
	  filterStatsByNames: function filterStatsByNames() {
	    var stats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var names = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var extractedStats = [];
	    var filteredStat = {};
	    for (var i = 0; i < stats.length; i++) {
	      var currentStat = stats[i] || {};
	
	      filteredStat = names[currentStat.name];
	      if (filteredStat) {
	        var position = typeof filteredStat.index === 'number' ? filteredStat.index : extractedStats.length;
	        // make default maiden value to 0 if api returns blank/empty
	        if (currentStat.name === 'maidens') {
	          currentStat.displayValue = currentStat.displayValue || '0';
	        }
	        extractedStats[position] = {
	          name: currentStat.name,
	          displayName: currentStat.displayName,
	          abbreviation: currentStat.abbreviation,
	          text: filteredStat.text,
	          value: currentStat.displayValue ? currentStat.displayValue : '-'
	        };
	      }
	    }
	
	    return extractedStats;
	  },
	
	  getCountryFromGeoLocation: function getCountryFromGeoLocation() {
	    var geoLocation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var country = ((0, _selectn2.default)('country.isoCodeAlpha2', geoLocation) || '').toUpperCase();
	    return {
	      country: country
	    };
	  },
	
	  /**
	   * Convert detailed stats array to an object for easier lookup. Keys are the
	   * stat name (stat.name)
	   * @param  {Array}  stats Detailed stats from statistics node
	   * @return {Object}       keys are stat name, value is an object in array
	   */
	  createStatsMap: function createStatsMap() {
	    var stats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    var namedStats = {};
	    for (var i = 0; i < stats.length; i++) {
	      var stat = stats[i];
	      if (stat.hasOwnProperty('name') === true) {
	        namedStats[stat.name] = stat;
	      }
	    }
	    return namedStats;
	  },
	
	  /**
	   * get player by id
	   * @param  {Array}  rosters Rosters node
	   * @param  {String} id      Player id
	   * @return {Object|null}         [description]
	   */
	  getPlayerById: function getPlayerById() {
	    var rosters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var id = arguments[1];
	
	    for (var i = 0; i < rosters.length; i++) {
	      var roster = rosters[i];
	      var athleteId = (0, _selectn2.default)('athlete.id', roster);
	      if (athleteId == id) {
	        return roster;
	      }
	    }
	    return null;
	  },
	
	  /**
	   * get multiple players by ids
	   * @param  {Array} rosters  Rosters node
	   * @param  {Array} ids      Player ids to filter
	   * @return {Object}         Players w/ their ids as keys
	   */
	  getPlayersByIds: function getPlayersByIds() {
	    var rosters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var ids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    var players = {};
	    for (var i = 0; i < rosters.length; i++) {
	      var roster = rosters[i];
	      var id = (0, _selectn2.default)('athlete.id', roster);
	      if (ids.indexOf(id) !== -1) {
	        players[id] = roster;
	      }
	    }
	    return players;
	  },
	
	  /**
	   * get leaders
	   * @param  {Array}  leadersNode leaders node
	   * @param  {Object}  roleMap    maps role to text
	   * @param  {Object}  statMap    maps stats to text
	   * @param  {Object}  homeTeamId id of hometeam
	   * @return {Object}             leaders categorized by roles
	   */
	  getLeaders: function getLeaders() {
	    var leadersNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var roleMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var statMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var homeTeamId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	
	    var roles = {};
	    leadersNode.map(function () {
	      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var teamId = (0, _selectn2.default)('team.id', t) || '';
	      var leaders = t.leaders || [];
	      if (leaders.length === 0) {
	        roles.tbdTeam = (0, _selectn2.default)('team.abbreviation', t) || '';
	      }
	
	      leaders.map(function () {
	        var leaderRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        var teamAbbr = (0, _selectn2.default)('team.abbreviation', t) || '';
	        var roleName = roleMap[leaderRole.name] || leaderRole.name;
	        var leaders = leaderRole.leaders || [];
	        var statMapForRole = statMap[leaderRole.name];
	        var playersByRole = [];
	
	        leaders.slice(0, 2).map(function (leader) {
	          var headshot = (0, _selectn2.default)('athlete.headshot.href', leader) || '';
	          headshot = headshot ? common.resizeCombinerLogo(headshot, { w: 108, h: 108, transparent: true, scale: 'crop' }) : '';
	          var statistics = leader.statistics || [];
	          var stats = statMapForRole ? common.filterStatsByNames(statistics, statMap[leaderRole.name]) : statistics;
	          roles[roleName] = roles[roleName] || {};
	          roles[roleName].players = roles[roleName].players || [];
	          var athleteLinkText = _helpers2.default.getAthleteLinkText(leader.athlete);
	          playersByRole.push({
	            name: (0, _selectn2.default)('athlete.displayName', leader),
	            team: teamAbbr,
	            href: common.extractUrl(leader.athlete, athleteLinkText, 'desktop'),
	            stats: stats,
	            img: headshot
	          });
	        });
	
	        /*
	         * prepend to roles[roleName].players only
	         * if homeTeamId available and matching with team id
	        */
	        if (homeTeamId && homeTeamId == teamId) {
	          var _roles$roleName$playe;
	
	          (_roles$roleName$playe = roles[roleName].players).unshift.apply(_roles$roleName$playe, playersByRole);
	        }
	        /*
	         * else append to roles[roleName].players
	         * if no homeTeamId or by default
	         */
	        else {
	            var _roles$roleName$playe2;
	
	            (_roles$roleName$playe2 = roles[roleName].players).push.apply(_roles$roleName$playe2, playersByRole);
	          }
	      });
	    });
	
	    return roles;
	  },
	
	  /**
	   * get group from standings in which teams are playing
	   * @param  {Object} standingsNode standings node
	   * @param  {Object} teams         teams
	   * @return {Object}               group
	   */
	  getGroupFromTeams: function getGroupFromTeams() {
	    var standingsNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var teams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var children = standingsNode.children || [];
	    var homeId = (0, _selectn2.default)('home.id', teams);
	    var awayId = (0, _selectn2.default)('away.id', teams);
	    var group = {};
	
	    children.map(function (c) {
	      var entries = (0, _selectn2.default)('standings.entries', c) || [];
	      entries.map(function (entry) {
	        var team = entry.team || {};
	        if (team.id == homeId || team.id == awayId) {
	          group = c;
	        }
	      });
	    });
	
	    return group;
	  },
	  /**
	   * get standings data for col-c
	   * @param  {Object} standings       node from summary API
	   * @param  {Array}  columns         Columns to show
	   * @param  {String} sport           sport
	   * @param  {String} section         section of website shown on
	   * @param {Object} edition edition information
	   * @return {Object}                 standings data
	   */
	  getStandingsData: function getStandingsData() {
	    var standings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var columns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	    var sport = arguments[2];
	    var section = arguments[3];
	    var edition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	
	
	    var children = standings.children || [];
	    var title = standings.name || '';
	    var uid = standings.uid || '';
	    var iChildLen = children.length || 0;
	    var iColLen = columns.length || 0;
	    var lang = edition && edition.language;
	    // team links for rugby-league should be inactive
	    var isTeamLinkActive = common.getIsTeamLinkActive(sport, lang);
	    var teams = [];
	    var keys = [];
	    for (var a = 0; a < iChildLen; a++) {
	      var entries = (0, _selectn2.default)('standings.entries', children[a]) || [];
	      var iEntriesLen = entries.length || 0;
	      var groupedTeams = [];
	
	      for (var b = 0; b < iEntriesLen; b++) {
	        var entry = entries[b];
	        var stats = (0, _selectn2.default)('stats', entry) || [];
	        var iStatLen = stats.length;
	        var tableData = [];
	        var oStatCache = {};
	
	        /* itterate and cache Stats */
	        for (var c = 0; c < iStatLen; c++) {
	          oStatCache[stats[c].type] = stats[c];
	        }
	
	        for (var d = 0; d < iColLen; d++) {
	          var statType = columns[d];
	          if (typeof oStatCache[statType] !== 'undefined') {
	            if (a === 0 && b === 0) {
	              keys.push({
	                text: oStatCache[statType].abbreviation,
	                tooltip: oStatCache[statType].description,
	                type: statType
	              });
	            }
	            tableData.push(oStatCache[statType].displayValue || oStatCache[statType].value);
	          } else {
	            /* TODO langauage support */
	            if (statType === 'team') {
	              if (a === 0 && b === 0) {
	                keys.push({
	                  text: (0, _translate2.default)(edition, 'Team'),
	                  tooltip: (0, _translate2.default)(edition, 'Team'),
	                  type: 'team'
	                });
	              }
	              tableData.push('');
	            }
	          }
	        }
	        var hData = {
	          href: common.getTeamUrl(entry.team),
	          abbrev: (0, _selectn2.default)('team.abbreviation', entry) || '',
	          displayName: (0, _selectn2.default)('team.displayName', entry) || '',
	          stats: tableData,
	          trackingName: sport && section ? common.createTrackingName([sport, section, 'Standings', 'Team']) : '',
	          id: entry.team.id
	        };
	
	        groupedTeams.push(hData);
	      }
	
	      teams.push({
	        keys: keys,
	        teams: groupedTeams,
	        abbreviation: children[a].name || children[a].abbreviation || ''
	      });
	    }
	
	    return { title: title, uid: uid, teams: teams, isTeamLinkActive: isTeamLinkActive };
	  },
	
	  /**
	   * Get standings link details
	   * @param  {Object} params Router params
	   * @param  {Object} query  Router query
	   * @param  {Object} section  section name
	   * @param  {Object} hrefConfig config object for create href function
	   * @param  {Number} year  year of the league
	   *  @param {Object} edition edition information
	   * @return {Object}        link title and href
	   */
	  getStandingsLink: function getStandingsLink() {
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var section = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'game';
	    var hrefConfig = arguments[3];
	    var year = arguments[4];
	    var edition = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
	
	    var leagueId = params.leagueId || params.league;
	    var link = {
	      title: (0, _translate2.default)(edition, 'Full Table'),
	      trackingName: common.createTrackingName([params.sport, section, 'Standings', 'Full'])
	    };
	
	    if (leagueId) {
	      link.href = common.createHref((0, _extends3.default)({ query: query }, params, { pageType: 'table' }, hrefConfig, { season: year }));
	    }
	
	    return link;
	  },
	
	  /**
	   * get game summary
	   * @param  {Object} competition Competition object
	   * @return {String}             summary
	   */
	  getGameSummary: function getGameSummary() {
	    var competition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var session = (0, _selectn2.default)('status.session', competition) || '';
	    if (session) {
	      session = session + ': ';
	    }
	    var summary = session + (0, _selectn2.default)('status.summary', competition);
	    return summary;
	  },
	
	  /**
	   * get Gamestrip data
	   * @param  {Object} competition       Competition object
	   * @param  {String} matchDescription  description of the match
	   * @param  {String} gameState         game status
	   * @param  {String} sport             Sport
	   * @param  {String} timeZoneBucket    timeZoneBucket
	   * @param  {Object} params            params object
	   * @param  {String} domain            domain rel e.g. espn.in, espncricinfo.com etc
	   * @param {Boolean} timeValid timeValid
	   * @return {Object}                   Gamestrip data
	   */
	  getGameStrip: function getGameStrip() {
	    var competition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var matchDescription = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var gameState = arguments[2];
	    var sport = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'cricket';
	    var timeZoneBucket = arguments[4];
	    var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
	    var domain = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';
	    var timeValid = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : true;
	    var language = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 'en';
	
	
	    // is game odi or test
	    //const { limitedOvers } = competition
	    // is game live
	    var competitors = (0, _selectn2.default)('competitors', competition);
	    var reducedOvers = (0, _selectn2.default)('reducedOvers', competition);
	    var state = (0, _selectn2.default)('status.type.state', competition);
	    var isMobile = (0, _selectn2.default)('mobile', params) || false;
	    var teams = common.getTeams(competitors, sport, gameState, reducedOvers, state, isMobile, domain);
	    var stateDesc = (0, _selectn2.default)('status.type.description', competition);
	    var matchTime = (0, _selectn2.default)('status.displayClock', competition) || '-';
	    var header = matchDescription;
	    var network = '';
	    // team links for rugby-league should be inactive
	    var isTeamLinkActive = common.getIsTeamLinkActive(params.sport, language);
	    var winner = common.getWinner(competitors);
	    var winnerClass = void 0;
	    var winnerClassMobile = void 0;
	    var winnerClassFeature = void 0;
	    var date = _dateformat2.default.dateFormat(competition.date, 'DD/MM', timeZoneBucket);
	    var time = _dateformat2.default.dateFormat(competition.date, 'h:mm A z', timeZoneBucket);
	    var target = '';
	    var isoDate = competition.date;
	    var dateTimeFormat = 'DD/MM - hh:mm A z';
	    if (winner.home === true) {
	      winnerClass = 'team-a-winner';
	      winnerClassMobile = 'cscore--home-winner';
	      winnerClassFeature = 'cscore__home--winner';
	    } else if (winner.away === true) {
	      winnerClass = 'team-b-winner';
	      winnerClassMobile = 'cscore--away-winner';
	      winnerClassFeature = 'cscore__away--winner';
	    }
	
	    switch (state) {
	      case 'pre':
	        if (sport === 'cricket') {
	          date = timeValid ? _dateformat2.default.dateFormat(isoDate, dateTimeFormat, timeZoneBucket) : '';
	          time = '';
	        }
	        break;
	      case 'in':
	        // If winner class is empty, check if target needs to be shown
	        if (winnerClass === '' && sport === 'cricket') {
	          target = gameState === 'live' ? common.getTarget(competitors) : '';
	        }
	
	        time = stateDesc;
	
	        if (sport !== 'cricket') {
	          time = matchTime;
	        }
	
	        break;
	      case 'post':
	        time = stateDesc;
	    }
	
	    return { teams: teams, header: header, network: network, date: date, time: time, winnerClass: winnerClass, winnerClassMobile: winnerClassMobile, winnerClassFeature: winnerClassFeature, target: target, gameState: gameState, isTeamLinkActive: isTeamLinkActive, isoDate: isoDate, timeValid: timeValid };
	  },
	
	  /**
	    * [ getIsTeamLinkActive returns true/false based on the sport]
	    * @param  {string} sport           [sport to check if active or inactive]
	    * @param  {lang} lang           [SEWEB-13325 language es / pt has inactive teams temporarily for rugby ]
	    * @return {boolen}                  [returns true /  false]
	    */
	  getIsTeamLinkActive: function getIsTeamLinkActive() {
	    var sport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
	
	    // team links for rugby-league should return false (inactive)
	    return sport === 'rugby-league' || lang === 'es' || lang === 'pt' ? false : true;
	  },
	
	  /**
	   * [getDetailsHeaderClass create details-header class for webview only]
	   * @param  {String} matchDescription [if match note is present class will be set]
	   * @param  {[type]} params           [params to check if platform is ios,android or windows]
	   * @return {[type]}                  [returns class name details-header]
	   */
	  getDetailsHeaderClass: function getDetailsHeaderClass() {
	    var matchDescription = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var params = arguments[1];
	
	    var platform = '';
	    var detailsHeaderClass = '';
	    if (params) {
	      if (params.hasOwnProperty('platform') === true) {
	        platform = params.platform;
	        if (matchDescription !== 'undefined' && typeof platform !== 'undefined') {
	          detailsHeaderClass = 'details-header';
	        }
	      }
	    }
	    return detailsHeaderClass;
	  },
	
	  /**
	   * Extract the league name
	   * @param  {Object} league league object
	   * @return {String}        league name
	   */
	  getLeagueName: function getLeagueName() {
	    var league = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    return league.name || '';
	  },
	
	  /**
	   * get teams info
	   * @param  {Array}  competitors Competitors array
	   * @param  {String} sport       Sport
	   * @param  {String} gameState   Game state
	   * @param  {Boolean}  reducedOvers - True if match with reduced overs
	   * @param  {String}  state of the match
	   * @param  {Boolean}  isMobile - True if device is mobile
	   * @param  {String} domain   domain rel e.g. espn.in, espncricinfo.com etc
	   * @return {Object}             teams
	   */
	  getTeams: function getTeams() {
	    var competitors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var sport = arguments[1];
	    var gameState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	    var reducedOvers = arguments[3];
	    var state = arguments[4];
	    var isMobile = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
	    var domain = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';
	
	    var teams = {};
	    var team1Name = (0, _selectn2.default)('[0].team.name', competitors);
	    var team2Name = (0, _selectn2.default)('[1].team.name', competitors);
	    if (competitors.length > 1 && (0, _selectn2.default)('[0].homeAway', competitors) === (0, _selectn2.default)('[1].homeAway', competitors)) {
	      competitors[0].homeAway = 'home';
	      competitors[1].homeAway = 'away';
	    }
	    competitors.map(function (competitor, i) {
	      var teamId = (0, _selectn2.default)('team.id', competitor);
	      var score = competitor.score || '';
	      // split score on runs & overs
	
	      var _common$splitScore = common.splitScore(score),
	          _common$splitScore2 = (0, _slicedToArray3.default)(_common$splitScore, 2),
	          runDetails = _common$splitScore2[0],
	          overDetails = _common$splitScore2[1];
	
	      if (typeof teamId !== 'undefined') {
	        var homeAway = competitor.homeAway;
	        // If both teams are TBD, teams[homeAway] gets overwritten.
	        // Update homeAway for 2nd TBD team
	        if (team1Name === 'TBD' && team2Name === 'TBD' && i === 1) {
	          homeAway = 'away';
	        }
	        teams[homeAway] = teams[homeAway] || {};
	        teams[homeAway].id = competitor.team.id, teams[homeAway].name = competitor.team.name;
	        teams[homeAway].shortName = competitor.team.nickname;
	        teams[homeAway].abbrev = competitor.team.abbreviation;
	        // cache color and assign color to team
	        var color = competitor.team.color;
	        teams[homeAway].color = color;
	        teams[homeAway].score = score;
	        teams[homeAway].record = gameState == 'pregame' ? common.getTeamForm(competitor) : '';
	        teams[homeAway].runDetails = runDetails;
	        teams[homeAway].overDetails = overDetails;
	        //because gameState is live for 2 hours after game is over, passing actual state
	        var actualState = common.getGameState(state);
	        var isTeamBattingNow = _helpers2.default.isTeamBattingNow(competitor, actualState);
	
	        // show target markup for live matches and reduced overs post matches.
	        var showTarget = gameState === 'live' || gameState === 'final' && reducedOvers ? true : false;
	        teams[homeAway].scoreMarkup = common.getFullScoreMarkup(score, 'over', 'span', false, false, showTarget, isMobile);
	        teams[homeAway].scoreMarkupMobile = common.getFullScoreMarkup(score, 'cscore_overs', 'span', true, isTeamBattingNow, showTarget, isMobile);
	        teams[homeAway].href = common.getTeamUrl(competitor.team, '', '', domain, sport);
	        teams[homeAway].logo = common.getTeamLogo(competitor.team, { h: 42, w: 42 });
	        teams[homeAway].bannerLogo = common.getTeamLogo(competitor.team, { h: 288, w: 288 });
	        // Set winner and flag to check if this team batted first
	        teams[homeAway].winner = competitor.winner;
	        teams[homeAway].battedFirst = (0, _selectn2.default)('linescores[0].isBatting', competitor);
	        teams[homeAway].order = competitor.order || 0;
	        // Reset color if it's not available in feed based on who batted first
	        if (typeof color === 'undefined' || color === '') {
	          teams[homeAway].color = teams[homeAway].battedFirst ? '#40b5e5' : '#ef3a49';
	        }
	        if (sport) {
	          teams[homeAway].trackingName = common.createTrackingName([sport, 'game', 'game', 'clubhouse', 'team']);
	        }
	        teams[homeAway].uid = (0, _selectn2.default)('team.uid', competitor);
	      }
	    });
	    return teams;
	  },
	
	  getTeamForm: function getTeamForm() {
	    var competitor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var teamForm = (0, _selectn2.default)('form', competitor) || '';
	    if (teamForm) {
	      return 'Form: ' + teamForm;
	    }
	    return '';
	  },
	
	  /**
	   * get the target for chasing team
	   * @param  {Array}  competitors - all teams
	   * @return {String}             - target score
	   */
	  getTarget: function getTarget() {
	    var competitors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    var target = '';
	
	    competitors.map(function (c) {
	      // return if target already constructed
	      if (target !== '') {
	        return;
	      }
	
	      (c.linescores || []).map(function (ls) {
	        // get target of batting team
	        if (ls.isCurrent === 1 && ls.isBatting) {
	          // Display target only when it's a non zero value
	          if (ls.target !== 0) {
	            target = 'TARGET: ' + ls.target;
	          }
	        }
	      });
	    });
	
	    return target;
	  },
	
	  /**
	   * construct the score for an innings of a team in header
	   * @param  {Object}  competitor    - any team
	   * @param  {Boolean}  limitedOvers - type of match
	   * @param  {Boolean} isLive        - is match live
	   * @return {String}                - score string
	   */
	  getFullScore: function getFullScore() {
	    var competitor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var limitedOvers = arguments[1];
	    var isLive = arguments[2];
	    var _competitor$linescore = competitor.linescores,
	        linescores = _competitor$linescore === undefined ? [] : _competitor$linescore;
	
	    var delimiter = ' ';
	    var score = '';
	    var statsByInn = [];
	    // let totalBatInn
	
	    // populate the stats by innings
	    linescores.map(function (ls) {
	      var statsNode = void 0;
	      var stats = {
	        all: {},
	        brief: {}
	      };
	
	      if (!ls.isBatting) {
	        return;
	      }
	
	      // get stats node
	      statsNode = (0, _selectn2.default)('statistics.categories[0].stats', ls) || '';
	
	      // get all stats mapped
	      stats.all = statsNode ? common.createStatsMap(statsNode) : {};
	
	      // get brief stats
	      for (var k in ls) {
	        var v = ls[k];
	        // Skip any object value
	        if (v instanceof Object === false) {
	          stats.brief[k] = v;
	        }
	      }
	
	      // append to stats list
	      statsByInn.push(stats);
	    });
	
	    // total number of batting innings
	    // totalBatInn = statsByInn.length
	
	    // construct the score string
	    statsByInn.map(function (stats, index) {
	      var briefStats = stats.brief;
	      //console.info('stats', stats)
	
	      // set flag check if team is playing live now
	      var isPlayingNow = isLive && briefStats.isBatting && briefStats.isCurrent === 1 ? true : false;
	
	      // over limit from stats
	      var overLimit = (0, _selectn2.default)('all.overLimit.displayValue', stats) || '';
	      //console.info('overLimit', overLimit)
	
	      // set flag check if batting at last innings
	      //const isAllInnEnd = totalBatInn === (index + 1) ? true : false
	
	      // overs played
	      var overs = '';
	
	      // added a break for consecutive innings (not 1st inn)
	      if (index !== 0) {
	        score += delimiter + '&' + delimiter + '<br>';
	      }
	
	      // append the score
	      score += briefStats.runs;
	      /**
	       * Check if it's All out - # wickets is 10 or description is all out
	       * There might be a case of because of injuries #wickets is 9
	       * and yet, it is all out. So do not reply on just the #wickets.
	       */
	      var isAllOut = (0, _selectn2.default)('brief.wickets', stats) == 10 || (0, _selectn2.default)('brief.description', stats) == 'all out';
	
	      // append wickets for all cases where it not all out
	      if (!isAllOut) {
	        score += '/' + briefStats.wickets;
	      }
	
	      // append marker if team is playing live
	      if (isPlayingNow) {
	        score += '*';
	      }
	
	      // append marker if inn is 'declared'
	      if (briefStats.description === 'declared') {
	        score += 'd';
	      }
	
	      // append marker if inn is 'follow on'
	      if (briefStats.followOn === 1) {
	        score += delimiter + '(f/o)';
	      }
	
	      // append overs if winner at last inn or team is playing live
	      if (limitedOvers) {
	
	        // construct overs for odi or test
	        if (overLimit) {
	          overs = briefStats.overs + '/' + overLimit;
	        } else {
	          overs = briefStats.overs;
	        }
	
	        score += delimiter + '<span class="over">(' + overs + ' ov)</span>';
	      }
	    });
	
	    return score;
	  },
	
	  /**
	   * get game officials
	   * @param  {Array}  officials gameInfo.officials
	   * @param {Object} params which will page info
	   * @return {Object}           Grouped Officials object
	   */
	  getOfficials: function getOfficials() {
	    var officials = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var officialsObj = {};
	    officials.map(function (o, i) {
	      var position = (0, _selectn2.default)('position.displayName', o) || i;
	      var oimg = (0, _selectn2.default)('flag.href', o) || '';
	      var oImgAlt = (0, _selectn2.default)('flag.alt', o) || '';
	      officialsObj[position] = officialsObj[position] || [];
	      officialsObj[position].push({
	        name: o.displayName,
	        img: oimg,
	        href: (0, _selectn2.default)('links.href', o) || '#',
	        imgicon: common.resizeCombinerLogo(oimg, { w: 25, h: 25 }),
	        imgAlt: oImgAlt,
	        trackingName: common.createTrackingName([params.sport, 'game', params.pageType, 'player'])
	      });
	    });
	
	    return officialsObj;
	  },
	
	  /**
	   * Get man of the match or man of the series
	   * @param  {Array}  featuredAthletes node from the feed
	   * @param  {String} award            displayName property value ("Player Of The Match")
	   * @param  {Object} params           router params
	   * @return {Array}                   list of player details (name, img, href)
	   */
	  getAwardedPlayer: function getAwardedPlayer() {
	    var featuredAthletes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var award = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    // default return value
	    var players = [];
	    // Iterate over all awarded players and pick up player details
	    for (var i = 0; i < featuredAthletes.length; i++) {
	      var p = featuredAthletes[i] || {};
	      if (p.displayName === award) {
	        var pimg = (0, _selectn2.default)('team.logos[0].href', p) || '';
	        var headshot = (0, _selectn2.default)('athlete.headshot.href', p) || '';
	        headshot = headshot ? common.resizeCombinerLogo(headshot, { w: 168, h: 168, transparent: true, scale: 'crop' }) : '';
	        var awardedPlayer = {
	          id: (0, _selectn2.default)('playerId', p) || '',
	          name: (0, _selectn2.default)('athlete.name', p) || '',
	          displayName: (0, _selectn2.default)('athlete.displayName', p) || '',
	          shortName: (0, _selectn2.default)('athlete.shortName', p) || '',
	          headshot: headshot,
	          img: pimg,
	          imgicon: common.resizeCombinerLogo(pimg, { w: 25, h: 25 }),
	          href: (0, _selectn2.default)('athlete.links[0].href', p) || '#',
	          team: (0, _selectn2.default)('team.name', p) || '',
	          trackingName: common.createTrackingName([params.sport, 'game', params.pageType, 'player'])
	        };
	        players.push(awardedPlayer);
	      }
	    }
	    return players;
	  },
	
	  /**
	   * Get game details
	   * @param  {Object} game info
	   * @param  {Array} notes Notes
	   * @param  {Array} featuredAthletes man of the match and man of the series
	   * @param {Object} params to hold page info
	   * @return {Object}             game details
	   */
	  getGameDetails: function getGameDetails(game, notes, featuredAthletes, params) {
	    var venue = common.getVenueName(game);
	    var venueLink = common.getVenueLink(game);
	    // TODO: replace defaults
	    var temperature = common.getTemperature(game);
	    var weatherClass = common.getClassNameForSkyCode(game);
	    var location = common.getLocation(game);
	    var officials = common.getOfficials(game.officials, params);
	    var playerOfMatch = common.getAwardedPlayer(featuredAthletes, 'Player Of The Match', params);
	    var playerOfSeries = common.getAwardedPlayer(featuredAthletes, 'Player Of The Series', params);
	    var featuredAthletesDetails = common.getFeaturedAthletes(featuredAthletes, params);
	    var otherNotes = common.getNotesWithLink(notes, ['hoursofplay', 'toss', 'seriesnote', 'matchnumber', 'season', 'matchdays', 'points', 'ballsperover', 'playersperside']);
	    var hoursOfPlay = otherNotes.hoursofplay,
	        toss = otherNotes.toss,
	        seriesResult = otherNotes.seriesnote,
	        matchNo = otherNotes.matchnumber,
	        season = otherNotes.season,
	        matchDays = otherNotes.matchdays,
	        points = otherNotes.points,
	        ballsPerOver = otherNotes.ballsperover,
	        playersperside = otherNotes.playersperside;
	
	    var playerReplacement = common.getPlayerReplacement(notes);
	
	    return { venue: venue, venueLink: venueLink, temperature: temperature, weatherClass: weatherClass, location: location, officials: officials, hoursOfPlay: hoursOfPlay, toss: toss, playerOfMatch: playerOfMatch, playerOfSeries: playerOfSeries, seriesResult: seriesResult, matchNo: matchNo, season: season, matchDays: matchDays, points: points, ballsPerOver: ballsPerOver, playersperside: playersperside, featuredAthletesDetails: featuredAthletesDetails, playerReplacement: playerReplacement };
	  },
	
	  /**
	   * Get featured athletes for match details
	   * @param  {Array}  featuredAthletes node from the feed
	   * @param  {Object} params           router params
	   * @return {Array}                   list of featured athletes details (name, img, href)
	   */
	  getFeaturedAthletes: function getFeaturedAthletes() {
	    var featuredAthletes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    // default return value
	    var athletesTypes = [];
	    featuredAthletes.map(function () {
	      var featuredAthlete = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      var athleteId = (0, _selectn2.default)('playerId', featuredAthlete) || '';
	      if (typeof athleteId !== 'undefined' && athleteId !== '') {
	        var featuredAthleteName = featuredAthlete.name || '';
	        var pimg = (0, _selectn2.default)('team.logos[0].href', featuredAthlete) || '';
	        var featuredPlayer = {
	          id: athleteId,
	          name: (0, _selectn2.default)('athlete.name', featuredAthlete) || '',
	          displayName: (0, _selectn2.default)('athlete.displayName', featuredAthlete) || '',
	          shortName: (0, _selectn2.default)('athlete.shortName', featuredAthlete) || '',
	          img: pimg,
	          imgicon: common.resizeCombinerLogo(pimg, { w: 25, h: 25 }),
	          href: (0, _selectn2.default)('athlete.links[0].href', featuredAthlete) || '#',
	          team: (0, _selectn2.default)('team.name', featuredAthlete) || '',
	          trackingName: common.createTrackingName([params.sport, 'game', params.pageType, 'player']),
	          featuredAthletesType: featuredAthlete.displayName,
	          featuredAthletesLabel: featuredAthleteName
	        };
	        athletesTypes[featuredAthleteName] && athletesTypes[featuredAthleteName].push(featuredPlayer) || (athletesTypes[featuredAthleteName] = [featuredPlayer]);
	      }
	    });
	    athletesTypes = (0, _entries2.default)(athletesTypes) || {};
	    return athletesTypes;
	  },
	
	  /**
	   * Get player replacement for match details
	   * @param  {Array}  notesNode notes from the feed
	   * @return {Array}                   player replacement details
	   */
	  getPlayerReplacement: function getPlayerReplacement() {
	    var notesNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    var playerReplacement = [];
	
	    for (var i = notesNode.length - 1; i >= 0; i--) {
	      var note = notesNode[i] || {};
	      if (note.type === 'playerreplacement') {
	        var items = note.items;
	
	        items.map(function () {
	          var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	          playerReplacement.push({
	            text: item.teamName + ' replacement',
	            links: item.text || []
	          });
	        });
	        break;
	      }
	    }
	
	    return playerReplacement;
	  },
	
	
	  /**
	   * get game videos
	   * @param  {Array}  videos data.videos
	   * @return {Array}  parsed videos
	   */
	  getVideos: function getVideos() {
	    var videos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    // Handle error, if the API returns an Object instead of on Array
	    videos = !videos.length ? [] : videos;
	    return videos.map(common.getVideo);
	  },
	
	  /**
	   * get game video
	   * @param  {Object} video parsed video
	   * @return {Object}  parsed video
	   */
	  getVideo: function getVideo() {
	    var video = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var id = video.id || '';
	    var cerebroId = video.cerebroId || '';
	    var headline = video.headline || '';
	    var description = video.description || '';
	    var source = video.source || '';
	    var ad = video.ad || {};
	    var thumbnail = video.thumbnail || '';
	    var coverageType = (0, _selectn2.default)('tracking.coverageType', video) || '';
	    var tracking = (0, _selectn2.default)('tracking', video);
	    var deviceRestrictions = (0, _selectn2.default)('deviceRestrictions', video);
	    var geoRestrictions = (0, _selectn2.default)('geoRestrictions', video);
	    var links = (0, _selectn2.default)('links', video);
	    var duration = video.duration || -1; // As per App requirment
	    return { id: id, cerebroId: cerebroId, headline: headline, ad: ad, description: description, source: source, thumbnail: thumbnail, coverageType: coverageType, tracking: tracking, deviceRestrictions: deviceRestrictions, geoRestrictions: geoRestrictions, links: links, duration: duration };
	  },
	
	  /**
	   * get Note by type
	   * @param  {Array} notes Notes
	   * @param  {String} type Note type
	   * @return {String}      Note
	   */
	  getNote: function getNote() {
	    var notes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	    var note = '';
	
	    notes.map(function (n) {
	      if (n.type === type && n.text) {
	        note = n.text;
	      }
	    });
	    return note;
	  },
	  /**
	   * get Note and hyperlink by type
	   * @param {Array} notes Notes
	   * @param {Array} types Notes type
	   * @return {Object} notesObj Notes object
	   */
	  getNotesWithLink: function getNotesWithLink() {
	    var notes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var types = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    if (!(notes.length && types.length)) {
	      return {};
	    }
	    var notesObj = {};
	    for (var i = 0; i < notes.length; i++) {
	      var type = notes[i].type;
	      if (typeof type !== 'undefined' && types.indexOf(type) !== -1) {
	        if (notes[i].href) {
	          notesObj[type] = {
	            name: notes[i].text || '',
	            href: notes[i].href || '',
	            trackingName: common.createTrackingName(['cricket', 'game', 'game', 'matchDetails'])
	          };
	        } else {
	          notesObj[type] = notes[i].text || '';
	        }
	      }
	    }
	    return notesObj;
	  },
	  /**
	   * Get venue location summary
	   * @param  {Object} game details
	   * @return {String}             venue location
	   */
	  getLocation: function getLocation(game) {
	    var venue = game.venue || {};
	    var address = venue.address || {};
	    var summary = address.summary || '';
	    var shortName = venue.shortName || '';
	    var city = address.city || '';
	    return { summary: summary, shortName: shortName, city: city };
	  },
	
	  /**
	   * Get venue name
	   * @param  {Object} game details
	   * @return {String}             venue if found else empty string
	   */
	  getVenueName: function getVenueName(game) {
	    return (0, _selectn2.default)('venue.fullName', game) || '';
	  },
	
	  /**
	   * Get venue link
	   * @param  {Object} game details
	   * @return {String}             venue link if found else empty string
	   */
	  getVenueLink: function getVenueLink(game) {
	    return (0, _selectn2.default)('venue.links[0].href', game) || '';
	  },
	
	  /**
	   * Is venue information present
	   * @param  {Object}  game details
	   * @return {Boolean}             true if venue is found else false
	   */
	  isVenuePresent: function isVenuePresent(game) {
	    return common.getVenueName(game) != '' ? true : false;
	  },
	
	  /**
	   * Is weather information present for this game
	   * @param  {Object}  game Event object
	   * @return {Boolean}    true if weather info is found else false
	   */
	  isWeatherInfoPresent: function isWeatherInfoPresent(game) {
	    return typeof (0, _selectn2.default)('weather', game) !== 'undefined' ? true : false;
	  },
	
	  /**
	   * Get temperature at the venue
	   * @param  {Object} game Event Object
	   * @return {String}    Temperature if present else empty string
	   */
	  getTemperature: function getTemperature(game) {
	    var temperature = (0, _selectn2.default)('weather.temperature', game);
	    // Convert to Celcius only if temp is not undefined or empty string
	    return typeof temperature !== 'undefined' && temperature !== '' ? common.convertToCelsius(temperature) : '';
	  },
	
	  convertToCelsius: function convertToCelsius(value) {
	    return Math.round((value - 32) * (5 / 9));
	  },
	
	  /**
	   * Get class name for the weather cloud
	   * @param  {Object} game Event object
	   * @return {String}    class name for the weather cloud
	   */
	  getClassNameForSkyCode: function getClassNameForSkyCode(game) {
	    // Get sky image weather code
	    var skycode = (0, _selectn2.default)('weather.skyImage.alt', game);
	    // Default class name string
	    var classname = '';
	
	    /*
	    // Classname for which an icon font class exists
	    let validClassNames = [
	      'sun', 'cloudy', 'partly-cloudy', 'fog', 'rain',
	      'snow', 'sleet', 'night-clear', 'night-cloudy'
	    ]
	    */
	
	    /**
	     * Map to convert the sky code text string to icon font classes
	     * workaround since the sky code is not the same as the toolkit classes
	     * @type {Object}
	     */
	    var skycodeToIconfont = {
	      'Sunny': 'sun',
	      'Mostly Sunny': 'sun',
	      'Partly Cloudy/Wind': 'partly-cloudy',
	      'Partly Cloudy': 'partly-cloudy',
	      'AM Clouds/PM Sun': 'partly-cloudy',
	      'Mostly Cloudy': 'cloudy',
	      'Rain/Wind': 'rain',
	      'Showers Early': 'rain',
	      'Showers': 'rain',
	      'PM Showers': 'rain',
	      'Rain': 'rain',
	      'Light Rain': 'rain',
	      'AM Rain/Wind': 'rain',
	      'AM Light Rain/Wind': 'rain',
	      'AM Light Rain': 'rain'
	      //console.info('skycode, found', skycode, skycode in skycodeToIconfont)
	
	      // Return if skycode is found in skycodeToIconfont
	    };if (skycode in skycodeToIconfont) {
	      return skycodeToIconfont[skycode];
	    }
	    // Default empty string if not found
	    return classname;
	  },
	
	  /**
	   * Resize if an image is on CDN and resize as per passed opts. If url is not
	   * from CDN, return image URL as is.
	   * Copied word for word from score - global scorecard main.js
	   *
	   * @param  {String} href url of the image
	   * @param  {Object} opts options for the required image
	   * @return {String}      image URL
	   *
	   * @example
	   * resizeCombinerLogo(imageUrl, { w:35, h:35 })
	   */
	  resizeCombinerLogo: function resizeCombinerLogo() {
	    var href = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var baseHeight = opts && opts.h || 25;
	    var baseWidth = opts && opts.w || 25;
	    var dpr = opts.dpr || typeof window !== 'undefined' ? window.devicePixelRatio : 1;
	    var scale = opts.scale;
	    var transparent = opts.transparent;
	    var newW = void 0;
	    var newH = void 0;
	
	    var widthRegex = /&w=(\d)+/;
	    var heightRegex = /&h=(\d)+/;
	
	    if (dpr > 3) {
	      dpr = 3;
	    }
	
	    if (href) {
	
	      // convert non-combiner cdn urls
	      if (href.indexOf('/combiner/') === -1) {
	        href = href.replace(/a(?:\d|ssets)?\.(?:espncdn|espn\.go)\.com\/i\//i, function () {
	          return 'a1.espncdn.com/combiner/i?img=/i/';
	        });
	      }
	
	      // only proceed if we have a combiner url
	      if (href.indexOf('/combiner/') === -1) {
	        return href;
	      }
	
	      if (opts.h !== false) {
	        newH = '&h=' + Math.ceil(baseHeight * dpr);
	        if (href.match(heightRegex)) {
	          href = href.replace(heightRegex, newH);
	        } else {
	          href += newH;
	        }
	      }
	
	      if (opts.w !== false) {
	        newW = '&w=' + Math.ceil(baseWidth * dpr);
	        if (href.match(widthRegex)) {
	          href = href.replace(widthRegex, newW);
	        } else {
	          href += newW;
	        }
	      }
	
	      if (scale) {
	        href += '&scale=' + scale;
	      }
	
	      if (transparent) {
	        href += '&transparent=true';
	      }
	    }
	
	    return href;
	  },
	
	  /**
	   * convert the image URL into combiner image URL
	   * @param  {String} href image URL
	   * @return {String}      combiner image URL
	   */
	  getCombinerImage: function getCombinerImage() {
	    var href = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	    // return unmodified if href empty or combiner URL
	    if (href === '' || href.indexOf('/combiner/') !== -1) {
	      return href;
	    }
	
	    return href.replace(/a(?:\d|ssets)?\.(?:espncdn|espn\.go)\.com\//i, function () {
	      return 'a1.espncdn.com/combiner/i?img=/';
	    });
	  },
	
	  /**
	  * Get team's logo if available else return default team logo
	  * @param  {Object}  team  team object from feed
	  * @param  {Object}  opts  options for the required image
	  * @return {String}        url of the team logo
	  */
	  getTeamLogo: function getTeamLogo() {
	    var team = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	    var combinerLogo = '';
	
	    if (team.logos && team.logos.length > 0) {
	      combinerLogo = (0, _selectn2.default)('logos[0].href', team) || '';
	    } else if (team.logo) {
	      combinerLogo = team.logo;
	    }
	
	    var combinerOpts = {
	      w: opts.w || 35,
	      h: opts.h || 35
	    };
	
	    return common.resizeCombinerLogo(combinerLogo || common.defaultUrls.teamLogo, combinerOpts);
	  },
	
	  /**
	   * Get team Url
	   * @param  {Object} team      team object from feed
	   * @param  {String} linkText  link text for which link needs to be extracted
	   * @param  {String} device    link rel e.g. desktop, mobile etc
	   * @param  {String} domain    domain rel e.g. espn.in, espncricinfo.com etc
	   * @param  {String} sport     sports e.g. cricket, rugby etc
	   * @return {String}      team URL
	   */
	  getTeamUrl: function getTeamUrl() {
	    var team = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var linkText = arguments[1];
	    var device = arguments[2];
	    var domain = arguments[3];
	    var sport = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
	
	    // Default to Clubhouse link if falsy value is passed to linkText
	    if (!linkText) {
	      linkText = 'Clubhouse';
	    }
	    // Default to desktop link if falsy value is passed to device
	    if (!device) {
	      device = 'desktop';
	    }
	    // Get link whose text is Clubhouse and rel contains desktop
	    return common.extractUrl(team, linkText, device, domain, sport);
	  },
	
	  /**
	   * Extract a link url from an object (team Object, athlete Object etc)
	   * @param  {Object} input     input Object
	   * @param  {String} linkText link text for which link needs to be extracted
	   *                           e.g. Clubhouse, Fixtures etc
	   * @param  {String} device   link rel e.g. desktop, mobile etc
	   * @param  {String} domain   domain rel e.g. espn.in, espncricinfo.com etc
	   * @param  {String} sport    sports e.g. cricket, rugby etc
	   * @param  {String} key      custom prop
	   * @return {String}          extracted link url
	   */
	  extractUrl: function extractUrl() {
	    var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var linkText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var device = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	    var domain = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	    var sport = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
	    var key = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'text';
	
	    // Get links else default to an empty Array
	    var links = input.links || [];
	    var defaultLink = '#';
	    var link = defaultLink;
	    // Iterate over links array
	    for (var i = links.length - 1; i >= 0; i--) {
	      // Get link object
	      var linkObj = links[i] || {};
	      //console.info('linkObj', linkObj)
	      // Get link rel info
	      var linkRel = linkObj.rel || [];
	      /**
	       * Get the href only if - link text matches with the linkText arg &
	       * this link has device in the rel list
	       */
	      if (linkObj[key] === linkText && linkRel.indexOf(device) > -1) {
	        link = linkObj.href || defaultLink;
	        break;
	      }
	    }
	    if (sport === 'cricket') {
	      link = common.buildURL(link, domain);
	    } else {
	      link = common.buildURL(link);
	    }
	    //console.info('link', link)
	    return link;
	  },
	
	  getUrlByRel: function getUrlByRel() {
	    var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var rel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var domain = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	    var sport = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	
	    // Get links else default to an empty Array
	    var links = input.links || [];
	    var defaultLink = '#';
	    var link = defaultLink;
	    // Iterate over links array
	    for (var i = links.length - 1; i >= 0; i--) {
	      // Get link object
	      var linkObj = links[i] || {};
	      //console.info('linkObj', linkObj)
	      // Get link rel info
	      var linkRel = linkObj.rel || [];
	      /**
	       * Get the href only if - link text matches with the linkText arg &
	       * this link has device in the rel list
	       */
	      if (linkRel.indexOf(rel) > -1) {
	        link = linkObj.href || defaultLink;
	        break;
	      }
	    }
	    var relLink = '';
	    if (sport == 'cricket') {
	      relLink = common.buildURL(link, domain);
	    } else {
	      relLink = common.buildURL(link);
	    }
	    return relLink;
	  },
	
	  /**
	   * Get current game status
	   * @param  {Object} sport       The current sport
	   * @param  {Object} competition competition object describing game
	   * @param  {Object} tzOptions   time zone options for formatting
	   * @param {Boolean} timeValid   timeValid
	   * @return {String}             Start time clock/Live/Final
	   */
	  getGameStatusText: function getGameStatusText() {
	    var sport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var competition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var tzOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var timeValid = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	    var statusText = '';
	    var state = (0, _selectn2.default)('status.type.state', competition) || 'pre';
	
	    if (sport !== 'cricket') {
	      switch (state) {
	        case 'pre':
	          statusText = _dateformat2.default.convertDateTime(competition.date, tzOptions);
	          break;
	        case 'in':
	          statusText = (0, _selectn2.default)('status.displayClock', competition) || '0\'';
	          break;
	        case 'post':
	          statusText = (0, _selectn2.default)('status.type.shortDetail', competition) || (0, _selectn2.default)('status.type.detail', competition) || (0, _selectn2.default)('status.type.description', competition) || state;
	          break;
	      }
	    } else {
	
	      // Hard coded cricket needs to be set to correct data driven!
	
	      // For pre game state, get start time clock
	      switch (state) {
	        case 'pre':
	          statusText = timeValid ? _dateformat2.default.convertDateTime(competition.date, tzOptions) : '';
	          break;
	
	        case 'in':
	        case 'post':
	          statusText = (0, _selectn2.default)('status.type.description', competition) || (0, _selectn2.default)('status.type.detail', competition) || (0, _selectn2.default)('status.type.shortDetail', competition) || state;
	          break;
	      }
	    }
	    return statusText;
	  },
	
	  /**
	   * [getGameBreakInfo gets games break detail]
	   * @param  {[type]} state [state]
	   * @return {[type]}       [string as in Lunch, Dinner etc]
	   */
	  getGameBreakInfo: function getGameBreakInfo(state) {
	    var breakInfo = state;
	    var breakState = void 0;
	    if (typeof breakInfo !== 'undefined') {
	
	      breakInfo = breakInfo.toLowerCase();
	      var sessionmap = {
	        'current innings': 'current',
	        'drinks break': 'drinks',
	        'innings break': 'innings',
	        'lunch break': 'lunch',
	        'tea break': 'tea',
	        'dinner break': 'dinner'
	      };
	
	      (0, _keys2.default)(sessionmap).forEach(function (value, index) {
	        if (index > 0) {
	          if (breakInfo.indexOf(sessionmap[value]) > -1 && breakInfo.indexOf('current') === -1) {
	            breakState = sessionmap[value];
	          }
	        }
	      });
	    }
	    return breakState || '';
	  },
	  /**
	   * Get state of a event/game
	   * @param  {String} state state
	   * @return {String}       pregame/live/final
	   */
	  getGameState: function getGameState(state) {
	    var stateMap = {
	      'pre': 'pregame',
	      'in': 'live',
	      'post': 'final'
	    };
	    return stateMap[state] || 'pregame';
	  },
	
	  /**
	   * Get CSS classname based on game state
	   * @param  {String} state state
	   * @return {String}       pre/live/post
	   */
	  getGameStateClass: function getGameStateClass(state) {
	    var stateMap = {
	      'pregame': 'pre',
	      'pre': 'pre',
	      'in': 'live',
	      'live': 'live',
	      'post': 'post',
	      'final': 'post'
	    };
	    return stateMap[state] || 'pre';
	  },
	
	  /**
	   * Get class which will be applied for game strip to indicate winner
	   * @param  {Array}  competitors competitors array from feed
	   * @param  {String} sport sport
	   * @param  {Boolean} teamFormat flag to return in team-[a|b]-winner format
	   * @return {String}             home-winner or away-winner
	   */
	  getWinnerClass: function getWinnerClass() {
	    var competitors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var sport = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var teamFormat = arguments[2];
	
	    var classString = '';
	    for (var i = 0; i < competitors.length; i++) {
	      var competitor = competitors[i] || {};
	      // check for both string and boolean types of winner property
	      if (competitor.winner === true || competitor.winner === 'true') {
	        if (sport === 'cricket') {
	          classString = competitor.homeAway;
	        } else if (teamFormat) {
	          classString = (competitor.homeAway == 'home' ? 'team-a' : 'team-b') + '-winner';
	        } else {
	          classString = competitor.homeAway + '-winner';
	        }
	        // Break aftrer a winner is found
	        break;
	      }
	    }
	    //console.info('classString', classString)
	    return classString;
	  },
	
	  /**
	   * Get winner team which will be used to apply winner class on game strip
	   * @param  {Array}  competitors competitors array from feed
	   * @return {Object}             { home: true } or { away: true }
	   */
	  // TODO: remove `getWinnerClass()` Fn once `getWinner()` Fn is tested and approved
	  getWinner: function getWinner() {
	    var competitors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    var winner = {};
	    for (var i = 0; i < competitors.length; i++) {
	      var competitor = competitors[i] || {};
	      // check for both string and boolean types of winner property
	      if (competitor.winner === true || competitor.winner === 'true') {
	        winner[competitor.homeAway] = true;
	        // Break aftrer a winner is found
	        break;
	      }
	    }
	
	    return winner;
	  },
	
	  /**
	   * Get links for a game
	   * @param  {Array}  links links (scoreboard/preview/highlghts etc)
	   * @param  {String} sport sport
	   * @param  {Object} edition   editionConfig
	   * @param {Boolean} isHighlight flag if highlghts present
	   * @param {String} gameState game status
	   * @return {Array}        link objects, each with href, name and rel properties
	   */
	  getGameLinks: function getGameLinks() {
	    var links = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var sport = arguments[1];
	    var edition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var isHighlight = arguments[3];
	    var gameState = arguments[4];
	
	    var gamePageLinks = [];
	    var constructHighlightUrl = '';
	    var _edition$userGeo = edition.userGeo,
	        userGeo = _edition$userGeo === undefined ? '' : _edition$userGeo,
	        _edition$domain = edition.domain,
	        domain = _edition$domain === undefined ? '' : _edition$domain;
	
	    for (var i = 0; i < links.length; i++) {
	      var link = links[i] || {};
	      if (link.text === 'WatchESPN' && userGeo !== 'us') {
	        continue;
	      }
	      var rel = link.rel || [];
	      var href = '';
	      if (sport == 'cricket') {
	        href = common.buildURL(link.href, domain);
	      } else {
	        href = common.buildURL(link.href);
	      }
	
	      var gameLinks = {
	        href: href,
	        text: link.text,
	        rel: rel,
	        trackingName: '&lpos=' + sport + ':scoreboard:' + rel[2]
	        // Set react flag for game package pages
	      };if (common.isLinkReactEnabled(link.href)) {
	        gameLinks.react = true;
	      }
	      if (gamePageLinks.length >= 3 && sport != 'cricket') {
	        return gamePageLinks;
	      }
	      // Summary Link will be avaiable for pre, live and post games Link list, so added condition to pick Summary link to construct highlight link
	      if (isHighlight && link.text === 'Summary') {
	        constructHighlightUrl = common.constructUrl(href);
	      }
	
	      gamePageLinks.push(gameLinks);
	    }
	
	    if (isHighlight) {
	      gamePageLinks.push({
	        href: constructHighlightUrl,
	        text: 'Highlights',
	        react: true,
	        trackingName: '&lpos=' + sport + ':scoreboard:highlights}',
	        rel: []
	      });
	    }
	    if (sport === 'cricket') {
	      var filterLinks = common.getFilterLinks(gameState, gamePageLinks);
	      return filterLinks;
	    } else {
	      return gamePageLinks;
	    }
	  },
	
	  getFilterLinks: function getFilterLinks() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var links = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	
	    var results = [];
	    var gameLinkType = {
	      pregame: ['Summary', 'Preview', 'Series Home'],
	      live: ['WatchESPN', 'Summary', 'Highlights', 'Scorecard', 'Report', 'Series Home'],
	      final: ['Scorecard', 'Highlights', 'Report', 'Summary', 'Series Home']
	    };
	
	    if (gameLinkType[state]) {
	      gameLinkType[state].forEach(function (key) {
	        links.filter(function (item) {
	          if (item.text === key) {
	            if (state === 'live') {
	              if (item.text === 'Summary') {
	                item.text = 'Live';
	              } else if (item.text === 'WatchESPN') {
	                item.text = 'Watch';
	              }
	            }
	            if (item.href) {
	              var isEspnCricinfoLegacy = item.href.indexOf('espncricinfo.com') > -1 && /(\/content\/|\/engine\/)/.test(item.href) ? true : false;
	              item.href = isEspnCricinfoLegacy === true ? item.href : (0, _parseURI2.default)(item.href).relative || '';
	            }
	            results.push(item);
	          }
	        });
	      });
	    }
	    results.splice(3);
	    return results;
	  },
	  /**
	   * Get watch ESPN link
	   * @param  {Array}  links links (summary/recap/watchESPN etc)
	   * @param  {String} userGeo edition geo code
	   * @return {Object} link object with href, name and rel properties
	   * @param  {String} device   link rel e.g. desktop, mobile etc
	   */
	  getWatchESPNLink: function getWatchESPNLink() {
	    var links = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var userGeo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var device = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    var watchESPNLink = {};
	    //loops over the links array and pick only the WatchESPN, only for US geo users and only if device type is desktop
	    for (var i = 0; i < links.length; i++) {
	      var link = links[i] || {};
	      if (link.text === 'WatchESPN' && userGeo === 'us' && device.desktop === true) {
	        var rel = link.rel || [];
	        var href = common.buildURL(link.href);
	        watchESPNLink = {
	          href: href,
	          text: link.text,
	          rel: rel
	        };
	      }
	    }
	
	    return watchESPNLink;
	  },
	
	  // Construct hightlights page url from summary url
	  constructUrl: function constructUrl(href) {
	    var hightlightLink = '';
	    hightlightLink = href.replace('/game', '/video');
	    return hightlightLink;
	  },
	
	  // TODO: Add more checks and conditions
	  // presently only a palceholder used for game package links
	  // on scoreboard
	  isLinkReactEnabled: function isLinkReactEnabled(href) {
	    return (/game|scorecard|preview|report|video/i.test(href || '')
	    );
	  },
	
	  /**
	   * For a sport, Should All Series option be shown in leagues dropdown?
	   * @param  {String} sport name of sport
	   * @return {Boolean}       true if allscores option should be shown else false
	   */
	  showAllScoresOption: function showAllScoresOption(sport) {
	    // default return type
	    var showAllScores = false;
	    // List of sports in which all series option is required
	    var sportsAllscores = ['cricket', 'rugby'];
	    // If sport is found in array of sports (in which option should be shown)
	    if (sportsAllscores.indexOf(sport) > -1) {
	      showAllScores = true;
	    }
	    return showAllScores;
	  },
	
	  /**
	   * Get active players for a live match
	   * This is a wrapper function to get active players for a live game.
	   * Specific players (e.g. batsman/bowlers in cricket) should be processed in
	   * sport specific files.
	   *
	   * @param  {Array}  teams teams
	   * @return {Array}      list of all active players.
	   */
	  getActivePlayers: function getActivePlayers() {
	    var teams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    var activePlayers = [];
	    for (var i = 0; teams && i < teams.length; i++) {
	      var team = teams[i];
	      var isRosterPresent = team.hasOwnProperty('roster') && team.roster.length > 0;
	      if (isRosterPresent === false) {
	        continue;
	      }
	      var roster = team.roster;
	      roster.map(function () {
	        var player = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        if (player.hasOwnProperty('active') && player.active === true) {
	          activePlayers.push(player);
	        }
	      });
	    }
	    return activePlayers;
	  },
	
	  /**
	   * Returns a comparator function to compare 2 objects on a property name.
	   * @param  {String} entityName property name on which 2 objects should be
	   *                             compared
	   * @return {Function}          comparator function
	   *
	   *@example
	   * To sort person objects in persons array on age property, Use this:
	   * persons.sort(compareEntities('age'))
	   */
	  compareEntities: function compareEntities(entityName) {
	    return function (p1, p2) {
	      //console.info('p1,p2, entityName', p1,p2, entityName)
	
	      // Return if property name is missing in both objects
	      if (p1.hasOwnProperty(entityName) === false && p2.hasOwnProperty(entityName) === false) {
	        return 0;
	      }
	      // default values
	      var value1 = void 0;
	      var value2 = void 0;
	      // Try to compare the integer values else compare as is
	      try {
	        value1 = parseInt(p1[entityName], 10);
	        value2 = parseInt(p2[entityName], 10);
	      } catch (e) {
	        value1 = p1[entityName];
	        value2 = p2[entityName];
	      }
	
	      // return -1 if object p1 needs to be placed before p2
	      if (value1 < value2) {
	        return -1;
	      }
	      // return +1 if object p1 needs to be placed after p2
	      if (value1 > value2) {
	        return 1;
	      }
	      // Keep order as is
	      return 0;
	    };
	  },
	
	  /**
	   * Split score into runs and overs/target string
	   * @param  {String} score Full score
	   * @return {Array}        [ runs , overs/target ]
	   */
	  splitScore: function splitScore(score) {
	    /**
	     * Split score into runs and overs since the markup requires it
	     */
	    var runDetails = score;
	    var overDetails = '';
	    // placeholder for split string
	    var runs = void 0;
	    var overs = void 0;
	
	    // On which character score needs to be split?
	    var splitOn = '(';
	    // If teamscore has ( n overs) text, split on (
	    if (score.indexOf(splitOn) > -1) {
	      // Extract overs/target components from score
	      var splitScores = score.split('(');
	      // Proceed only if array has 2 elememts score & overs/target
	      if (splitScores.length === 2) {
	        // Update final variables only if values are found
	        var _splitScores = (0, _slicedToArray3.default)(splitScores, 2);
	
	        runs = _splitScores[0];
	        overs = _splitScores[1];
	        if (runs && runs !== '') {
	          runDetails = runs;
	        }
	        if (overs && overs !== '') {
	          // Prepend character on which score was split on earlier
	          overDetails = '' + splitOn + overs;
	        }
	      }
	    }
	
	    return [runDetails, overDetails];
	  },
	
	  /**
	   * Get the markup of full score.
	   * e.g. Returns 157/9 <span class='over'>(20/20 ov)</span>
	   *
	   * @param  {String}  score     score of a team
	   * @param  {String}  className name of class that needs to be used to show overs
	   * @param  {String}  elem      element p/span/div etc
	   * @param  {Boolean} displayIndicator does * needs to be displayed if innings is current
	   * @param  {Boolean} isBatting Is this team batting? If yes, display * after the score
	   * @param  {Boolean} showTarget show target in score markup?
	   * @param  {Boolean} isMobile - True if device is mobile
	   * @return {String}           returns full markup.
	   */
	  getFullScoreMarkup: function getFullScoreMarkup() {
	    var score = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'over';
	    var elem = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'span';
	    var displayIndicator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	    var isBatting = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	    var showTarget = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
	    var isMobile = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
	
	    var scoreMarkup = score;
	    try {
	      scoreMarkup = score.replace(/\([^)]+\)/gmi, function (text) {
	        // Remove the target text from the string
	        if (typeof text === 'string') {
	          if (showTarget === false) {
	            text = text.split(', target')[0];
	          }
	          text += text.lastIndexOf(')') > 0 ? '' : ')';
	          if (isMobile && text.indexOf('target') !== -1) {
	            text = text.replace('target', 'tgt');
	          }
	        }
	        var sections = ['<' + elem + ' class=\'' + className + '\'>' + text + '</' + elem + '>'];
	        // Prepend * after the score only if required and this team is currently batting, don't add for (f/o) text
	        if (displayIndicator === true && isBatting === true && text !== '(f/o)') {
	          sections.unshift('*');
	        }
	        return sections.join(' ');
	      });
	    } catch (e) {
	      //console.info('e', e)
	    }
	    return scoreMarkup;
	  },
	
	  /**
	   * Determine link (href) passed is external. Articles/ news feed item opens
	   * up a new window and have icon for external links
	   *
	   * @param  {String}  href     href of an article
	   * @param  {String}  domain     domain
	   * @return {Boolean}
	   */
	
	  isLinkExternal: function isLinkExternal(href, domain) {
	    var isLinkExternal = false;
	    var hostReplaces = /www\.|-qa|qa\.|preview\./;
	
	    if (typeof domain === 'string') {
	      domain = domain.replace(hostReplaces, '');
	    }
	
	    if (href.startsWith('http') && href.indexOf('espn.go.com') === -1 && href.indexOf('en.espn.co.uk') === -1 && href.indexOf(domain) === -1 || href.indexOf('xgames') != -1 || href.indexOf('espnfc.') != -1 || href.indexOf('/espnw/') != -1 || href.indexOf('thecricketmonthly.') != -1) {
	      isLinkExternal = true;
	    }
	
	    return isLinkExternal;
	  },
	
	  /**
	   * Prepare commentary - API gives commentary in a object. Sort the objects
	   * based on sortOrder key. Later, sort the array in descending order so that
	   * latest ball commentary is on top.
	   *
	   * sortOrder is floating point number (eg. 1000.04),
	   * so use another key (sortOrder converted to Integer) for sorting
	   *
	   * @param  {Object} commsMap commentary object as received from API
	   * @return {Array}           Commentary ordered on sortOrder
	   */
	  prepareCommentary: function prepareCommentary() {
	    var commsMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    // Init default return value
	    var sortedComms = [];
	    // name of key that needs to be looked up in object
	    var lookup = 'sortOrder';
	    // name of new key which will be used for sorting
	    var sortKey = 'intSortOrder';
	
	    // Iterate over all keys and push value to sortedComms
	    for (var commId in commsMap) {
	      // Continue to next key if it is not property of commsMap
	      if (commsMap.hasOwnProperty(commId) === false) {
	        continue;
	      }
	      // Cache the object for reference
	      var commDetails = commsMap[commId] || {};
	      // Set a new property only if sortOrder value is a valid number
	      if (commDetails.hasOwnProperty(lookup)) {
	        // Value which will be used for sorting should be integer
	        if ((0, _isFinite2.default)(commDetails[lookup])) {
	          // Ensure that sortOrder has 2 values after decimal point
	          var val = commDetails[lookup].toFixed(2);
	          //console.info('val', val)
	          // Set new sort key = val multiplied by 100
	          commDetails[sortKey] = val * 100;
	          //console.info('commDetails.intSortOrder', commDetails[sortKey])
	        }
	      }
	      sortedComms.push(commDetails);
	    }
	    // Sort the array on sortKey(new key set as above)
	    sortedComms.sort(common.compareEntities(sortKey));
	    // compareEntities sorts in ascending order , so reverse it
	    sortedComms.reverse();
	    //console.info('sortedComms', sortedComms)
	    return sortedComms;
	  },
	
	  /**
	   * Create and normalize query string object
	   * @param {Object} edition   edition
	   * @param {Object} params    params
	   * @param {Object} location  locations
	   * @param {Object} appProps  appProps
	   * @return {Object} query object
	   */
	  getQuery: function getQuery(edition, params, location, appProps) {
	    var query = location.query || _queryString2.default.parse(location.search);
	    if (!query.device && edition.isEspnCricinfo && params.webview === 'webview' && (0, _selectn2.default)('device.featurephone', appProps)) {
	      query.device = 'featurephone';
	    }
	
	    return query;
	  },
	
	  getLeagueLink: function getLeagueLink() {
	    var links = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var domain = arguments[1];
	
	    var leagueLink = '';
	    links.map(function () {
	      var link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      if (link.text && link.text.indexOf('Series Home') !== -1) {
	        leagueLink = link.href;
	      }
	    });
	    return common.buildURL(leagueLink, domain);
	  },
	  getNoContentText: function getNoContentText(pageType, edition) {
	    return pageType === 'team' ? (0, _translate2.default)(edition, 'content.unavailable.clubhouse') : '';
	  }
	
	  // Closing tag of common module
	
	
	  /**
	   * Parser functions for leagues dropdown
	   * @type {Object}
	   */
	};var leagues = {
	
	  /**
	   * process data from APIs
	   * @param  {Object} res         API response
	   * @param  {Object} edition     edition config
	   * @param  {Object} params      router params
	   * @return {Object}             league items, current league
	   */
	  processData: function processData(res) {
	    var edition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var pageType = params.pageType;
	
	    var data = (0, _selectn2.default)('data.leagues', res);
	    // Default return types
	    var processedData = {
	      items: [],
	      currentLeague: {}
	    };
	    var filterByStandings = void 0;
	
	    // If response or params are empty, return default data
	    if (typeof data === 'undefined' || params !== null && typeof params !== 'undefined' && (0, _keys2.default)(params).length === 0) {
	      return processedData;
	    }
	
	    if (/table|standings/gi.test(pageType)) {
	      filterByStandings = true;
	    }
	
	    // Get all leagues
	    processedData.items = leagues.get(data, filterByStandings);
	    //const items = leagues.filterLeagues(res.data.leagues, params)
	
	    // Upon validation, append All Series options to league
	    leagues.appendAllScoresToLeagues(edition, processedData.items, params.pageType, params.sport);
	
	    processedData.currentLeague = leagues.getCurrentLeague(data, params);
	
	    //console.info('items, currentLeague', items, currentLeague)
	    return processedData;
	  },
	
	  /**
	   * Get all leagues
	   * @param  {Array}  leagues leagues array
	   * @param {Boolean} filterByStandings flag if leagues to be filtered by standings
	   * @return {Array}          array of league objexts. Each league object has
	   *                                id, name amd hasStandings boolean
	   */
	  get: function get() {
	    var leagues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var filterByStandings = arguments[1];
	
	    var allLeagues = [];
	    leagues.map(function (league) {
	      if (filterByStandings === true && league.hasStandings === false) {
	        return;
	      }
	
	      var name = league.name;
	
	      if (filterByStandings && league.abbreviation) {
	        name = league.abbreviation;
	      }
	
	      if (league.id) {
	        allLeagues.push({
	          id: league.id,
	          name: name,
	          text: name,
	          hasStandings: (0, _selectn2.default)('season.type.hasStandings', league),
	          slug: league.slug,
	          trackingName: common.createTrackingName([league.id, 'standings', 'filter', 'league'])
	        });
	      }
	    });
	    return allLeagues;
	  },
	
	  /**
	   * Append All Series option to leagues array.
	   * Append this option only on scoreboard page and showAllScores is true.
	   * Before appending, make sure it's not present already.
	   * @param  {Object}  	edition  Editions Object
	   * @param  {Array}  	items    list of leagues
	   * @param  {String} 	pageType page type
	   * @param  {String} 	sport    name of sport
	   * @return {undefined}          undefined
	   */
	  appendAllScoresToLeagues: function appendAllScoresToLeagues() {
	    var edition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var items = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	    var pageType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	    var sport = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	
	    //console.info('appendAllScoresToLeagues', items, pageType, sport)
	    var showAllScores = common.showAllScoresOption(sport);
	    // Append all series only on scoreboard page and showAllScores is true
	    if (/scoreboard|scores/.test(pageType) && showAllScores) {
	      // Append only if all_series is not already appended and it's not undefined
	      var firstItemId = (0, _selectn2.default)('[0].id', items);
	      //console.info('firstItemId', firstItemId)
	
	      var defaultKey = 'dropdown.leagues.default.' + sport;
	      var leagueDesc = (0, _translate2.default)(edition, defaultKey);
	      if (leagueDesc === defaultKey) {
	        leagueDesc = (0, _translate2.default)(edition, 'dropdown.leagues.default.sport');
	      }
	
	      if (firstItemId !== 'all_series' && firstItemId !== 'undefined') {
	        items.unshift({
	          'href': '/page/scoreboard',
	          'text': leagueDesc,
	          'name': leagueDesc,
	          'abbr': leagueDesc,
	          'id': ''
	        });
	      }
	    }
	  },
	
	  /**
	   * get list of valid leagues
	   * @param  {Array} leagueItems - raw data of list of leagues
	   * @return {Array}             - valid leagues
	   */
	  getLeaguesWithStandings: function getLeaguesWithStandings(leagueItems) {
	    var filterItems = [];
	
	    try {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(leagueItems), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var item = _step.value;
	
	          // filter league with stansings
	          if ((0, _selectn2.default)('season.type.hasStandings', item) === 'true') {
	            filterItems.push({
	              id: item.id,
	              name: item.name,
	              text: item.name,
	              trackingName: '&lpos=' + item.id + ':standings:filter:league'
	            });
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return filterItems;
	    } catch (err) {
	      return [];
	    }
	  },
	
	  /**
	   * get current league object
	   * @param  {Array} leagues  - list of valid leagues
	   * @param  {Object} params  - router params
	   * @return {Object}          league object
	   */
	  getCurrentLeague: function getCurrentLeague() {
	    var leagues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var _params$league = params.league,
	        leagueId = _params$league === undefined ? '' : _params$league,
	        _params$slug = params.slug,
	        slug = _params$slug === undefined ? '' : _params$slug;
	
	    var leagueObj = {};
	
	    // get current league details from the leagues list
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	      for (var _iterator2 = (0, _getIterator3.default)(leagues), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	        var league = _step2.value;
	
	        // match with league id
	        if (league.id === leagueId) {
	          leagueObj = {
	            id: league.id,
	            name: league.name,
	            abbr: league.abbreviation || league.name,
	            slug: league.slug
	          };
	        }
	      }
	
	      // fallback current league to params if not available in list
	    } catch (err) {
	      _didIteratorError2 = true;
	      _iteratorError2 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion2 && _iterator2.return) {
	          _iterator2.return();
	        }
	      } finally {
	        if (_didIteratorError2) {
	          throw _iteratorError2;
	        }
	      }
	    }
	
	    if ((0, _keys2.default)(leagueObj).length === 0) {
	      leagueObj = {
	        id: leagueId,
	        slug: slug
	      };
	    }
	
	    return leagueObj;
	  },
	
	  /**
	   * Method to organize search result response
	   * @param {Object} res       response
	   * @param {Object} domain   domain object
	   * @param {Object} appProps  appProps
	   * @return {Object} search results object
	  */
	  searchLeagueResults: function searchLeagueResults(res, domain) {
	    var status = (0, _selectn2.default)('status', res);
	    var resultObj = {};
	    var deviceRel = 'desktop';
	    var leagueRel = 'serieshome';
	    var defaultImage = 'http://a.espncdn.com/combiner/i?img=/redesign/assets/img/icons/espn-icon-cricket.png';
	    defaultImage = common.resizeCombinerLogo(defaultImage, { w: 30, h: 30 });
	    if (res && res.status === 200) {
	      var data = (0, _selectn2.default)('data.items', res) || [];
	
	      var dataLen = data.length || 0;
	      var totalRecords = (0, _selectn2.default)('data.count', res) || 0;
	      totalRecords = parseInt(totalRecords, 10);
	      var resultsArr = [];
	      var message = '';
	      var href = '';
	      if (totalRecords > 0) {
	        for (var i = 0; i < dataLen; i++) {
	          var item = data[i] !== 'undefined' ? data[i] : undefined;
	
	          if (item) {
	            var id = (0, _selectn2.default)('id', item) || 0;
	            var type = (0, _selectn2.default)('type', item) === 'league' ? 'sport' : (0, _selectn2.default)('type', item);
	            var links = (0, _selectn2.default)('links', item) || [];
	
	            if (links.length > 0) {
	              links.forEach(function (l) {
	                if (l.rel && l.rel.indexOf(leagueRel) > -1 && l.rel.indexOf(deviceRel) > -1) {
	                  href = l.href;
	                }
	              });
	            }
	            var imgs = (0, _selectn2.default)('logos', item) || (0, _selectn2.default)('assets', item) || [];
	            var img = defaultImage;
	
	            if (imgs.length > 0) {
	              imgs.forEach(function (i) {
	                if (i.rel && i.rel.indexOf('default') > -1) {
	                  img = i.href && common.resizeCombinerLogo(i.href, { w: 30, h: 30 });
	                } else {
	                  img = i.href;
	                }
	              });
	            }
	            if (id) {
	              var _resultObj = {
	                id: id,
	                text: item.displayName || '',
	                href: common.buildURL(href, domain),
	                img: img,
	                label: type
	              };
	              resultsArr.push(_resultObj);
	            }
	          }
	        }
	      } else {
	        message = 'No results found.';
	      }
	      resultObj = {
	        totalRecords: totalRecords,
	        results: resultsArr,
	        status: status,
	        message: message
	      };
	    } else {
	      resultObj = {
	        status: status,
	        error: (0, _selectn2.default)('statusText', res)
	      };
	    }
	    return resultObj;
	  }
	};
	
	exports.common = common;
	exports.leagues = leagues;
	exports.default = {
	  common: common,
	  leagues: leagues
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(816), __esModule: true };

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(817);
	module.exports = __webpack_require__(288).Number.isFinite;


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(293);
	var _isFinite = __webpack_require__(289).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(819), __esModule: true };

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(820);
	module.exports = __webpack_require__(288).Object.entries;


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(293);
	var $entries = __webpack_require__(434)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	var domains = __webpack_require__(822);
	var editions = __webpack_require__(823);
	var editionConfigs = __webpack_require__(824);
	var editionSettings = __webpack_require__(825);
	var langs = __webpack_require__(826);
	var hostPaths = __webpack_require__(827);
	var parseUri = __webpack_require__(828);
	
	function buildURL(scheme, domain, path, query, fragment, shouldUndoSEO) {
		var location = this.window ? this.window.location : {
			protocol: 'http:',
			host: domains['espn']
		};
	
		if (arguments.length === 0) {
			domain = 'espn';
		}
	
		if (typeof scheme !== 'string') {
			scheme = location.protocol;
		}
		else if (/[^:]$/.test(scheme)) {
			scheme += ':';
		}
	
		if (scheme === 'https:' && (domain + '-secure') in domains) {
			domain = domain + '-secure';
		}
	
		var host = domains[domain];
	
		if (!path) {
			path = '';
		}
		else if (/^[^\/]/.test(path)) {
			path = '/' + path;
		}
	
		var queryString = '';
		if (typeof query === 'string') {
			queryString = query;
		}
		else if (query && typeof query === 'object') {
			queryString = Object.keys(query).map(function(k) {
				if ((shouldUndoSEO || k !== '_slug_') && query[k] != null) {
					return encodeURIComponent(k) + '=' + encodeURIComponent(query[k]);
				}
				else {
					return encodeURIComponent(query[k]);
				}
			}).join('&');
		}
		if (/^[^?]/.test(queryString)) {
			queryString = '?' + queryString;
		}
	
		if (typeof fragment !== 'string') {
			fragment = '';
		}
		else if (/^[^#]/.test(fragment)) {
			fragment = '#' + encodeURIComponent(fragment);
		}
	
		if ((queryString || fragment) && !path) {
			path = '/';
		}
	
		return scheme + '//' + host + path + queryString + fragment;
	}
	
	
	function underscorePathSEO(URL) {
		return URL.replace(/\/?\?/,'/_/').replace(/&|=/g,'/');
	}
	
	
	var domainEditionCache = {};
	function getEditionByLocation(host, testHost) {
		if (!host) {
			if (this.window) {
				host = this.window.location.host;
			} else {
				host = testHost;
			}
		}
		if (domainEditionCache[host]) {
			return domainEditionCache[host];
		}
		for (var ed in editions) {
			var editionRE = new RegExp(editions[ed], 'i');
			if (editionRE.test(host)) {
				domainEditionCache[host] = ed;
				return ed;
			}
		}
	}
	
	function rewritePath(path, configs) {
		for (var i = 0; i < configs.length; i++) {
			var config = configs[i];
	
			langs.map(function(lang) {
				for (var root in config.roots[lang]) {
					var rootValue = config.roots[lang][root];
	
					var rootRE = new RegExp('^'+root, 'i');
					path = path.replace(rootRE, function(match, $1, offset, original){
						return rootValue;
					});
				}
				for (var seg in config.pathSegments[lang]) {
					var segment = config.pathSegments[lang][seg];
	
					var segRE = new RegExp('/'+seg+'(/|$)', 'i');
					path = path.replace(segRE, function(match, $1, offset, original){
						return '/'+segment+$1;
					});
				}
			});
		}
		return path;
	}
	
	function rewriteQuery(query, configs) {
		for (var i = 0; i < configs.length; i++) {
			var config = configs[i];
			langs.map(function(lang) {
				var newQuery = {};
				for (var key in query) {
					key = decodeURIComponent(key);
					if (query.hasOwnProperty(key)) {
						var newKey = config.paramKeys[lang][key] || key,
							oldVal = query[key]==null ? null : decodeURIComponent(query[key]),
							newValue = config.paramValues[lang][oldVal] || oldVal;
	
						newQuery[newKey] = newValue;
					}
				}
				query = newQuery;
			});
		}
		return query;
	}
	
	function overrideUrl(url, configs) {
		for (var i = 0; i < configs.length; i++) {
			var config = configs[i];
	
			langs.map(function(lang) {
				for (var u in config.urls[lang]) {
					var urlValue = config.urls[lang][u];
					url = url.replace(u, urlValue);
				}
			});
		}
	
		url = url.replace(/%2C/g, ','); // commas cause issues in the Android app (as of 2017-01-06)
	
		return url;
	}
	
	function rewriteUrl(url, editionOverride, options) {
		var parsed = parseUri(url),
			edition = getEditionByLocation.call(this, editionOverride, parsed.host),
			path = parsed.path,
			query = parsed.queryKey,
			hash = parsed.anchor,
			splitIndex = path.indexOf('/_/'),
			configs = [],
			config = editionConfigs[edition],
			rewrites,
			seo = true,
			shouldUndoSEO = false;
	
	
		if (!edition) {
			return url;
		}
		if (config !== undefined) {
			rewrites = config.rewrites;
		}
		var urlEdition = getEditionByLocation(parsed.host || editionOverride);
		if(!urlEdition){
			return url;
		}
		var urlConfig = editionConfigs[urlEdition];
		if (urlConfig && urlConfig.seo !== undefined) {
			seo = urlConfig.seo;
		}
	
		if ((config && config.notActuallyAnEdition) || (urlConfig && urlConfig.notActuallyAnEdition)) {
			//no rewrites if either is not an edition
			rewrites = undefined;
			
			var baseEdition = urlEdition.replace(/-(go|qa)$/, '');
			if (/-qa$/.test(edition) && editionConfigs[baseEdition+'-qa']) {
				edition = baseEdition+'-qa';
			} else if (/-go$/.test(edition) && editionConfigs[baseEdition+'-go']) {
				edition = baseEdition+'-go';
			} else {
				edition = baseEdition;
			}
		}
	
		if (splitIndex > -1) {
			var queryString = path.substring(splitIndex + 3);
			path = path.substring(0, splitIndex);
	
			var parts = queryString.split('/');
			while (parts.length > 1) {
				query[parts.shift()] = parts.shift();
			}
			if (parts.length == 1) {
				query['_slug_'] = parts.shift();
			}
		}
	
		if (rewrites !== undefined) {
			query = rewriteQuery(query, configs);
			for (var ed in rewrites) {
				if (rewrites.hasOwnProperty(ed)) {
					var config = editionSettings[rewrites[ed]];
					if (config !== undefined) {
						configs.push(config);
					}
				}
			}
	
			for(var host in hostPaths){
				if (hostPaths.hasOwnProperty(host)) {
					if(parsed.host.match(new RegExp(host, 'i')) &&
						!path.match(new RegExp("^"+hostPaths[host]), 'i')){
						path = hostPaths[host]+path;
						break;
					}
				}
			}
	
			path = rewritePath(path, configs);
			query = rewriteQuery(query, configs);
		}
	
		if (hash) {
			hash = '#'+hash;
		}
	
		if(options && typeof options==='object'){
			if(typeof options.seo==='boolean'){
				seo = options.seo;
	
				if(options.seo===false){
					shouldUndoSEO = true;
				}
			}
		}
	
		var result = buildURL(parsed.protocol, edition, path, query, hash, shouldUndoSEO);
	
		if (seo) {
			result = underscorePathSEO(result);
		}
		else if(shouldUndoSEO){
			result = undoSEO(result);
		}
	
		return overrideUrl(result, configs);
	}
	
	function undoSEO(url){
		/**
		 * convert request from SEO to normal query string format
		 *
		 * SEO: http://www.espn.com/espn/story/_/id/23403800/mariano-rivera-misty-treanor-herschel-walker-designated-chair-president-council-sports-fitness-nutrition
		 * query string: http://www.espn.com/espn/story?id=23403800&_slug_=mariano-rivera-misty-treanor-herschel-walker-designated-chair-president-council-sports-fitness-nutrition
		 *
		 * @param  {String} Request url like above example
		 * @return {String} query string format of url
		 */
	
		var result    = url,
			ampersand = '',
			query, parts;
	
		if(typeof url === 'string' && url.length>0){
			parts = url.split('/_/');
	
			if (parts.length > 1) {
				result = parts[0]+'?'; //part before query string
	
				query = parts[1].split('/');
	
				while (query.length > 1) {
					result+=ampersand+query.shift()+'='+query.shift();
					ampersand='&'
				}
	
				if (query.length == 1) {
					result+=ampersand+'_slug_='+query.shift().replace('?', '&');
				}
			}
		}
	
		return result;
	}
	
	module.exports = function espnURL(rewriteURL, options) {
		if (typeof rewriteURL !== 'string') {
			rewriteURL = 'http://www.espn.com';
		}
		if(options && typeof options==='object'){
			var editionOverride = options && options.editionOverride;
			return rewriteUrl(rewriteURL, editionOverride, options);
		}
		return rewriteUrl(rewriteURL, options);
	};


/***/ }),
/* 822 */
/***/ (function(module, exports) {

	module.exports = {"admin":"admin.espn.com","admin-go":"admin.espn.go.com","admin-qa":"admin.espnqa.com","api-app":"api-app.espn.com","api-app-qa":"api-app.espnqa.com","app":"x-callback-url","broadband":"broadband.espn.com","broadband-go":"broadband.espn.go.com","broadband-qa":"broadband.espnqa.com","cdn":"cdn.espn.com","cdn-qa":"cdn.espnqa.com","cdn-qa-secure":"secure.espnqa.com","cdn-secure":"secure.espn.com","cdn-assets":"a.espncdn.com","cdn-assets-secure":"secure.espncdn.com","cdn-games":"g.espncdn.com","cdn-games-secure":"g.secure.espncdn.com","cdn-s":"s.espncdn.com","cdn-s-secure":"s.secure.espncdn.com","cricinfo":"www.espncricinfo.com","deportes":"espndeportes.espn.com","deportes-go":"espndeportes.espn.go.com","deportes-qa":"espndeportes.espnqa.com","espn":"www.espn.com","espn-go":"espn.go.com","espn-qa":"www.espnqa.com","espn-ar":"www.espn.com.ar","espn-ar-qa":"www.espnqa.com.ar","espn-au":"www.espn.com.au","espn-au-qa":"www.espnqa.com.au","espn-cl":"www.espn.cl","espn-cl-qa":"www.espnqa.cl","espn-co":"www.espn.com.co","espn-co-qa":"www.espnqa.com.co","espn-in":"www.espn.in","espn-in-qa":"www.espnqa.in","espn-mx":"www.espn.com.mx","espn-mx-qa":"www.espnqa.com.mx","espn-pt-br":"www.espn.com.br","espn-pt-br-qa":"www.espnqa.com.br","espn-uk":"www.espn.co.uk","espn-uk-qa":"www.espnqa.co.uk","espn-ve":"www.espn.com.ve","espn-ve-qa":"qa.espn.com.ve","espn-za":"kwese.espn.com","espn-za-qa":"kwese.espnqa.com","espn-ph":"tv5.espn.com","espn-ph-qa":"tv5.espnqa.com","espn-ww":"global.espn.com","espn-ww-qa":"global.espnqa.com","fan-api":"fan.api.espn.com","fan-api-qa":"fan.api.qa.espnqa.com","fan-api-go":"fan.api.espn.go.com","fan-core":"fan.core.api.espn.com","fan-core-qa":"fan.core.api.qa.espnqa.com","fan-core-go":"fan.core.api.espn.go.com","fc":"www.espnfc.com","fc-asia":"www.espnfcasia.com","fc-asia-qa":"qa.espnfcasia.com","fc-au":"www.espnfc.com.au","fc-au-qa":"qa.espnfc.com.au","fc-qa":"qa.espnfc.com","fc-uk":"www.espnfc.co.uk","fc-uk-qa":"qa.espnfc.co.uk","fc-us":"www.espnfc.us","fc-us-qa":"qa.espnfc.us","games":"games.espn.com","games-go":"games.espn.go.com","games-qa":"games.espnqa.com","insider":"insider.espn.com","insider-go":"insider.espn.go.com","insider-qa":"insider.espnqa.com","log":"log.espn.com","log-go":"log.go.com","log-qa":"log.espnqa.com","m":"m.espn.com","m-go":"m.espn.go.com","m-qa":"m.espnqa.com","proxy":"proxy.espn.com","proxy-go":"proxy.espn.go.com","proxy-qa":"proxy.espnqa.com","r":"r.espn.com","r-go":"r.espn.go.com","r-qa":"r.espnqa.com","search":"search.espn.com","send":"sendtofriend.espn.com","send-go":"sendtofriend.espn.go.com","sportscenter":"sportscenter.api.espn.com","sportscenter-qa":"sportscenter.api.qa.espn.com","streak":"streak.espn.com","streak-qa":"streak.espnqa.com","sw88":"sw88.espn.com","sw88-go":"sw88.go.com","sw88-qa":"sw88.espnqa.com","tredir":"tredir.espn.com","tredir-go":"tredir.go.com","tredir-qa":"tredir.espnqa.com","w88":"w88.espn.com","w88-go":"w88.go.com","w88-qa":"w88.espnqa.com","w88-qa-secure":"sw88.espn.com","w88-secure":"sw88.espn.com","xgames":"xgames.espn.com","xgames-go":"xgames.espn.go.com","xgames-qa":"xgames.espnqa.com"}

/***/ }),
/* 823 */
/***/ (function(module, exports) {

	module.exports = {"admin":"admin.espn.com","admin-go":"admin.espn.go.com","admin-qa":"admin.espnqa.com","api-backchannel":"NOMATCHapi(-app)?.prod.espninfra.starwave.com$","api-backchannel-qa":"api(-app)?.qa.espninfra.starwave.com$","api-app":"api-app.espn.(go.)?com","api-app-qa":"(api-app.espnqa|api-dev.espn).com","app":"x-callback-url","broadband":"broadband.espn.com","broadband-go":"broadband(-qa)?.espn.go.com","broadband-qa":"broadband.espnqa.com","cdn":"^cdn.espn.com$|^(sports-ak|scores|cdn)\\.espn\\.go\\.com$","cdn-qa":"^cdn.espnqa.com$","cdn-secure":"secure.espn.(go.)?com","cdn-qa-secure":"secure.espnqa.com","cdn-assets":"^a\\d?\\.espncdn\\.com$|^assets\\.espn\\.go\\.com$","cdn-assets-secure":"^secure\\.espncdn\\.com$","cdn-games":"^g\\.espncdn\\.com$|^games-ak\\.espn\\.go\\.com$","cdn-games-secure":"^g\\.secure\\.espncdn\\.com$","cdn-s":"^s\\.espncdn\\.com$","cdn-s-secure":"^s\\.secure\\.espncdn\\.com$","cricinfo":"www.espncricinfo.com","deportes":"espndeportes.espn.com","deportes-go":"espndeportes.espn.go.com","deportes-qa":"(espndeportes.espnqa|qa.espndeportes|espndeportes-qa.espn.go).com","espn":"^www.espn.com$","espn-go":"^espn.go.com$","espn-qa":"^(www|local).espnqa.com$","espn-ar":"www.espn.com.ar","espn-ar-qa":"www.espnqa.com.ar","espn-au":"www.espn.com.au","espn-au-qa":"www.espnqa.com.au","espn-cl":"www.espn.cl","espn-cl-qa":"www.espnqa.cl","espn-co":"www.espn.com.co","espn-co-qa":"www.espnqa.com.co","espn-in":"www.espn.in","espn-in-qa":"www.espnqa.in","espn-pt-br":"^www.espn.com.br$","espn-pt-br-qa":"^(www|local).espnqa.com.br$","espn-mx":"www.espn.com.mx","espn-mx-qa":"www.espnqa.com.mx","espn-uk":"www.espn.co.uk","espn-uk-qa":"www.espnqa.co.uk","espn-ve":"www.espn.com.ve","espn-ve-qa":"qa.espn.com.ve","espn-za":"kwese.espn.com","espn-za-qa":"kwese.espnqa.com","espn-ph":"tv5.espn.com","espn-ph-qa":"tv5.espnqa.com","espn-ww":"global.espn.com","espn-ww-qa":"global.espnqa.com","fan-api":"fan.api.espn.com","fan-api-qa":"fan.api.qa.(espnqa|espn.go).com","fan-api-go":"fan.api.espn.go.com","fan-core":"fan.core.api.espn.com","fan-core-qa":"fan.core.api.qa.(espnqa|espn.go).com","fan-core-go":"fan.core.api.espn.go.com","fc":"www.espnfc.com$","fc-qa":"qa.espnfc.com$","fc-asia":"www.espnfcasia.com","fc-asia-qa":"qa.espnfcasia.com","fc-au":"www.espnfc.com.au","fc-au-qa":"qa.espnfc.com.au","fc-uk":"www.espnfc.co.uk","fc-uk-qa":"qa.espnfc.co.uk","fc-us":"www.espnfc.us","fc-us-qa":"qa.espnfc.us","games":"games.espn.com","games-go":"games.espn.go.com","games-qa":"^games(\\.qa\\.espn\\.go|\\.espnqa)\\.com$","insider":"insider.espn.com","insider-go":"insider.espn.go.com","insider-qa":"insider.espnqa.com","log":"log.espn.com","log-go":"log.go.com","log-qa":"log.espnqa.com","m":"^m.espn.com","m-go":"^m.espn.go.com","m-qa":"^m.espnqa.com","proxy":"proxy.espn.com","proxy-go":"proxy.espn.go.com","proxy-qa":"proxy.espnqa.com","r":"^r.espn.com","r-go":"^r.espn.go.com","r-qa":"^(r.espnqa|rqa.espn.go).com","sportscenter":"sportscenter.api.espn.(go.)?com","sportscenter-qa":"sportscenter.api.qa.espn.(go.)?com","search":"^search\\.espn\\.(go\\.)?com$","send":"sendtofriend.espn.com","send-go":"sendtofriend.espn.go.com","streak":"streak\\.espn\\.(go\\.)?com","streak-qa":"streak.espnqa.com","sw88":"^sw88\\.(go|espn)\\.com$","sw88-qa":"^sw88\\.espnqa\\.com$","tredir":"tredir.espn.com","tredir-go":"tredir.go.com","tredir-qa":"tredir.espnqa.com","w88":"^w88\\.(go|espn)\\.com$","w88-qa":"^w88\\.espnqa\\.com$","xgames":"xgames.espn.com","xgames-go":"xgames.espn.go.com","xgames-qa":"xgames.espnqa.com"}

/***/ }),
/* 824 */
/***/ (function(module, exports) {

	module.exports = {"admin":{"seo":false,"notActuallyAnEdition":true},"admin-go":{"seo":false,"notActuallyAnEdition":true},"admin-qa":{"seo":false,"notActuallyAnEdition":true},"api-app":{"seo":false,"notActuallyAnEdition":true},"api-app-qa":{"seo":false,"notActuallyAnEdition":true},"api-backchannel":{"seo":false,"notActuallyAnEdition":true},"api-backchannel-qa":{"seo":false,"notActuallyAnEdition":true},"app":{"seo":false,"notActuallyAnEdition":true},"broadband":{"seo":false,"notActuallyAnEdition":true},"broadband-go":{"seo":false,"notActuallyAnEdition":true},"broadband-qa":{"seo":false,"notActuallyAnEdition":true},"cdn":{"seo":false,"notActuallyAnEdition":true},"cdn-qa":{"seo":false,"notActuallyAnEdition":true},"cdn-secure":{"seo":false,"notActuallyAnEdition":true},"cdn-qa-secure":{"seo":false,"notActuallyAnEdition":true},"cdn-assets":{"seo":false,"notActuallyAnEdition":true},"cdn-assets-secure":{"seo":false,"notActuallyAnEdition":true},"cdn-games":{"seo":false,"notActuallyAnEdition":true},"cdn-games-secure":{"seo":false,"notActuallyAnEdition":true},"cdn-s":{"seo":false,"notActuallyAnEdition":true},"cdn-s-secure":{"seo":false,"notActuallyAnEdition":true},"cricinfo":{"seo":false,"notActuallyAnEdition":true},"deportes":{"rewrites":["spanish"]},"deportes-go":{"rewrites":["spanish"]},"deportes-qa":{"rewrites":["spanish"]},"espn":{"rewrites":["espn"]},"espn-ar":{"rewrites":["spanish"]},"espn-ar-qa":{"rewrites":["spanish"]},"espn-au":{"rewrites":["queens","au"]},"espn-au-qa":{"rewrites":["queens","au"]},"espn-cl":{"rewrites":["spanish"]},"espn-cl-qa":{"rewrites":["spanish"]},"espn-co":{"rewrites":["spanish"]},"espn-co-qa":{"rewrites":["spanish"]},"espn-go":{"rewrites":["espn"]},"espn-in":{"rewrites":["queens"]},"espn-in-qa":{"rewrites":["queens"]},"espn-mx":{"rewrites":["spanish"]},"espn-mx-qa":{"rewrites":["spanish"]},"espn-pt-br":{"rewrites":["portuguese"]},"espn-pt-br-qa":{"rewrites":["portuguese"]},"espn-qa":{"rewrites":["espn"]},"espn-uk":{"rewrites":["queens"]},"espn-uk-qa":{"rewrites":["queens"]},"espn-ve":{"rewrites":["spanish"]},"espn-ve-qa":{"rewrites":["spanish"]},"espn-za":{"rewrites":["queens"]},"espn-za-qa":{"rewrites":["queens"]},"espn-ph":{"rewrites":["queens"]},"espn-ph-qa":{"rewrites":["queens"]},"espn-ww":{"rewrites":["queens"]},"espn-ww-qa":{"rewrites":["queens"]},"fan-api":{"seo":false,"notActuallyAnEdition":true},"fan-api-go":{"seo":false,"notActuallyAnEdition":true},"fan-api-qa":{"seo":false,"notActuallyAnEdition":true},"fan-core":{"seo":false,"notActuallyAnEdition":true},"fan-core-go":{"seo":false,"notActuallyAnEdition":true},"fan-core-qa":{"seo":false,"notActuallyAnEdition":true},"fc":{"seo":false,"notActuallyAnEdition":true},"fc-asia":{"seo":false,"notActuallyAnEdition":true},"fc-asia-qa":{"seo":false,"notActuallyAnEdition":true},"fc-au":{"seo":false,"notActuallyAnEdition":true},"fc-au-qa":{"seo":false,"notActuallyAnEdition":true},"fc-qa":{"seo":false,"notActuallyAnEdition":true},"fc-uk":{"seo":false,"notActuallyAnEdition":true},"fc-uk-qa":{"seo":false,"notActuallyAnEdition":true},"fc-us":{"seo":false,"notActuallyAnEdition":true},"fc-us-qa":{"seo":false,"notActuallyAnEdition":true},"games":{"seo":false,"notActuallyAnEdition":true},"games-go":{"seo":false,"notActuallyAnEdition":true},"games-qa":{"seo":false,"notActuallyAnEdition":true},"insider":{"seo":true,"notActuallyAnEdition":true},"insider-go":{"seo":true,"notActuallyAnEdition":true},"insider-qa":{"seo":true,"notActuallyAnEdition":true},"log":{"seo":false,"notActuallyAnEdition":true},"log-go":{"seo":false,"notActuallyAnEdition":true},"log-qa":{"seo":false,"notActuallyAnEdition":true},"m":{"seo":false,"notActuallyAnEdition":true},"m-go":{"seo":false,"notActuallyAnEdition":true},"m-qa":{"seo":false,"notActuallyAnEdition":true},"proxy":{"seo":false,"notActuallyAnEdition":true},"proxy-go":{"seo":false,"notActuallyAnEdition":true},"proxy-qa":{"seo":false,"notActuallyAnEdition":true},"r":{"seo":false,"notActuallyAnEdition":true},"r-go":{"seo":false,"notActuallyAnEdition":true},"r-qa":{"seo":false,"notActuallyAnEdition":true},"search":{"seo":false,"notActuallyAnEdition":true},"send":{"seo":false,"notActuallyAnEdition":true},"send-go":{"seo":false,"notActuallyAnEdition":true},"sportscenter":{"seo":false,"notActuallyAnEdition":true},"sportscenter-qa":{"seo":false,"notActuallyAnEdition":true},"streak":{"seo":false,"notActuallyAnEdition":true},"streak-qa":{"seo":false,"notActuallyAnEdition":true},"sw88":{"seo":false,"notActuallyAnEdition":true},"sw88-go":{"seo":false,"notActuallyAnEdition":true},"sw88-qa":{"seo":false,"notActuallyAnEdition":true},"tredir":{"seo":false,"notActuallyAnEdition":true},"tredir-go":{"seo":false,"notActuallyAnEdition":true},"tredir-qa":{"seo":false,"notActuallyAnEdition":true},"w88":{"seo":false,"notActuallyAnEdition":true},"w88-go":{"seo":false,"notActuallyAnEdition":true},"w88-qa":{"seo":false,"notActuallyAnEdition":true},"xgames":{"seo":false,"notActuallyAnEdition":true},"xgames-go":{"seo":false,"notActuallyAnEdition":true},"xgames-qa":{"seo":false,"notActuallyAnEdition":true}}

/***/ }),
/* 825 */
/***/ (function(module, exports) {

	module.exports = {"queens":{"paramKeys":{"toEdition":{},"toEnglish":{}},"pathSegments":{"toEdition":{"standings":"table"},"toEnglish":{"table":"standings"}},"roots":{"toEdition":{"/horse/":"/horse-racing/","/nascar/":"/racing/nascar/","/ncaa/":"/college-sports/","/ncb/":"/mens-college-basketball/","/ncf/":"/college-football/","/ncw/":"/womens-college-basketball/","/oly/":"/olympics/","/rpm/":"/racing/","/soccer/":"/football/","/soccer/team":"/football/club","/womenbb/":"/womens-basketball/"},"toEnglish":{"/american-fb/":"/nfl/","/college-sports/":"/ncaa/","/football/":"/soccer/","/football/club":"/soccer/team","/horse-racing/":"/horse/","/mens-college-basketball/":"/ncb/","/olympics/":"/oly/","/racing/":"/rpm/","/racing/nascar/":"/nascar/","/sports/horse/":"/horse/","/sports/womenbb/":"/womenbb/","/womens-basketball/":"/womenbb/","/womens-college-basketball/":"/ncw/"}},"urls":{"toEdition":{},"toEnglish":{}},"paramValues":{"toEdition":{},"toEnglish":{}}},"espn":{"paramKeys":{"toEdition":{},"toEnglish":{"ano":"year","fecha":"date","juegoId":"gameId","liga":"league","nombre":"name","partido":"gameID","semana":"week","tipodetemporada":"seasontype","jogoId":"gameId","data":"date","nome":"name","partida":"gameID","modalidade":"discipline","evento":"event","atleta":"athlete","pais":"country","pagina":"page","continuo":"continuous","rodada":"round","posicao":"position","time":"team","ligas":"leagues","grupo":"group","temporada":"season","ordenar":"sort","vista":"view"}},"pathSegments":{"toEdition":{"club":"team","clubs":"teams","table":"standings"},"toEnglish":{"alineacion":"lineups","bateo":"batting","calendario":"schedule","comentario":"commentary","narracao":"commentary","clubes":"teams","conversacion":"conversation","cronica":"report","duelo":"matchup","equipo":"team","equipos":"teams","estadio":"stadium","estadisticas":"stats","ficha":"boxscore","fotos":"photos","grilla":"grid","juego":"game","jugadas":"playbyplay","jugador":"player","jugadores":"players","lideres":"leaderboard","lesiones":"injuries","liga":"league","nota":"story","numeritos":"matchstats","partido":"match","piloto":"driver","plantel":"roster","posiciones":"standings","previa":"preview","profundidad":"depth","reporte":"report","resultados":"scoreboard","jogo":"game","time":"team","times":"teams","elenco":"roster","estatisticas":"stats","bate-papo":"conversation","placar":"boxscore","partida":"match","minuto-a-minuto":"playbyplay","confronto":"matchup","classificacao":"standings","ligas":"leagues","artigo":"story","olimpiadas":"olympics","verao":"summer","escalacoes":"lineups","escalacao":"lineup","deportes":"sports","atletas":"athletes","jogador":"player","lesoes":"injuries","rebatendo":"batting","clipe":"clip","carrera":"race","circuito":"circuit","corrida":"race","resultados-carrera":"results","resultados-corrida":"results","previo":"preview","transferencias":"transfers","mercado-da-bola":"transfers"}},"roots":{"toEdition":{"/football/":"/soccer/","/college-sports/soccer":"/college-sports/football"},"toEnglish":{"/artes-marciales-mixtas/":"/mma/","/basquetbol/colegial-hombres/":"/mens-college-basketball/","/basquetbol/colegial-mujeres/":"/womens-college-basketball/","/basquetbol/nba/":"/nba/","/basquetbol/nba-g-league/":"/nba-g-league/","/basquetbol/nba/deportes/gamecast":"/nba/gamecast","/basquetbol/nba/estadisticas/":"/nba/statistics/","/basquetbol/nba/estadisticas/equipo":"/nba/statistics/team","/basquetbol/":"/nba/","/beisbol/mlb/":"/mlb/","/beisebol/mlb/":"/mlb/","/beisbol/":"/mlb/","/boxeo/":"/boxing/","/college-sports/football":"/college-sports/soccer","/deporte-motor/f1/":"/f1/","/deporte-motor/":"/rpm/","/futbol-americano/colegial/":"/college-football/","/futbol-americano/nfl/":"/nfl/","/futbol-americano/":"/nfl/","/futbol/equipo/resultados":"/soccer/team/results","/futbol/equipo/calendario":"/soccer/team/fixtures","/futbol/equipo/plantel":"/soccer/team/squad","/futbol/":"/soccer/","/olimpicos/":"/olympics/","/otros-deportes/":"/other-sports/","/otros-deportes/polo/":"/polo/","/panamericanos/":"/panamerican/","/tenis/":"/tennis/","/futebol/time/resultados":"/soccer/team/results","/futebol/time/calendario":"/soccer/team/fixtures","/futebol/time/elenco":"/soccer/team/squad","/futebol/bola-de-prata/":"/bola-de-prata/","/futebol/data-espn/":"/data-espn/","/futebol/ranking-dos-treinadores/":"/ranking-dos-treinadores/","/futebol/selecao-brasileira/":"/selecao-brasileira/","/futebol/":"/soccer/","/f1/":"/f1/","/esportes-a-motor/":"/rpm/","/liga-de-verao-de-la-nba/":"/nba-summer-league/","/olimpiadas/verao/":"/olympics/summer/","/olimpiadas/verao/basquete/":"/oly/summer/basketball/","/olimpiadas/verao/2012/resultados":"/olympics/summer/2012/results","/olimpiadas/verao/2016/resultados":"/olympics/summer/2016/results","/olimpiadas/inverno/":"/olympics/winter/","/olimpiadas/":"/oly/","/tiro-con-arco/":"/archery/","/atletismo/":"/athletics/","/canoagem/":"/canoe/","/ciclismo/":"/cycling/","/ecuestre/":"/equestrian/","/esgrima/":"/fencing/","/hoquei-na-grama/":"/field-hockey/","/ginastica/":"/gymnastics/","/handebol/":"/handball/","/pentatlo-moderno/":"/modern-pentathlon/","/remo/":"/rowing/","/vela/":"/sailing/","/tiro/":"/shooting/","/natacao/":"/swimming/","/tenis-de-mesa/":"/table-tennis/","/triatlo/":"/triathlon/","/voleibol/":"/volleyball/","/polo-aquatico/":"/water-polo/","/levantamento-de-peso/":"/weightlifting/","/luta/":"/wrestling/","/golfe/":"/golf/","/basquete/":"/brazilian-basketball/","/surfe/":"/surfing/"}},"urls":{"toEdition":{"espn.go.com/cricket/":"www.espncricinfo.com/","www.espn.com/fantasy/soccer/":"www.espn.com/fantasy/football/","/beisebol/":"/mlb/"},"toEnglish":{}},"paramValues":{"toEdition":{},"toEnglish":{"liga":"league","todo":"all","todos":"all","ligas":"leagues","atletas":"athletes","paises":"countries","constructores":"constructors","construtores":"constructors","pontos":"points","puntos":"points","sobe":"asc","desce":"desc","gols":"scoring","anotaciones":"scoring","cartoes":"discipline","tarjetas":"discipline","rendimento":"performance","rendimiento":"performance"}}},"au":{"paramKeys":{"toEdition":{},"toEnglish":{}},"pathSegments":{"toEdition":{},"toEnglish":{}},"roots":{"toEdition":{},"toEnglish":{}},"urls":{"toEdition":{"www.espn.com.au/cricket/":"www.espncricinfo.com/"},"toEnglish":{}},"paramValues":{"toEdition":{},"toEnglish":{}}},"spanish":{"paramKeys":{"toEdition":{"date":"fecha","gameID":"partido","gameId":"juegoId","league":"liga","name":"nombre","seasontype":"tipodetemporada","tournamentId":"torneo","view":"vista","week":"semana","year":"ano","group":"grupo","season":"temporada","sort":"ordenar"},"toEnglish":{"ano":"year","fecha":"date","juegoId":"gameId","liga":"league","nombre":"name","partido":"gameID","semana":"week","torneo":"tournamentId","tipodetemporada":"seasontype","grupo":"group","temporada":"season","ordenar":"sort"}},"pathSegments":{"toEdition":{"batting":"bateo","boxscore":"ficha","commentary":"comentario","conversation":"conversacion","depth":"profundidad","driver":"piloto","game":"juego","grid":"grilla","injuries":"lesiones","leaderboard":"lideres","league":"liga","lineups":"alineacion","match":"partido","matchstats":"numeritos","matchup":"duelo","photos":"fotos","playbyplay":"jugadas","player":"jugador","players":"jugadores","preview":"previo","recap":"cronica","report":"reporte","roster":"plantel","schedule":"calendario","scoreboard":"resultados","stadium":"estadio","standings":"posiciones","stats":"estadisticas","story":"nota","team":"equipo","teams":"equipos","race":"carrera","circuit":"circuito","results":"resultados","fixtures":"calendario","transfers":"transferencias","squad":"plantel"},"toEnglish":{"alineacion":"lineups","bateo":"batting","calendario":"schedule","comentario":"commentary","conversacion":"conversation","cronica":"recap","duelo":"matchup","equipo":"team","estadio":"stadium","estadisticas":"stats","ficha":"boxscore","fotos":"photos","grilla":"grid","juego":"game","jugadas":"playbyplay","jugador":"player","jugadores":"players","lesiones":"injuries","liga":"league","nota":"story","numeritos":"matchstats","partido":"match","piloto":"driver","plantel":"roster","posiciones":"standings","previa":"preview","profundidad":"depth","reporte":"report","resultados":"scoreboard","carrera":"race","circuito":"circuit","resultados-carrera":"results","previo":"preview","transferencias":"transfers"}},"roots":{"toEdition":{"/baseball/":"/beisbol/","/basketball/":"/basquetbol/","/boxing/":"/boxeo/","/college-football/":"/futbol-americano/colegial/","/f1/results":"/f1/resultados-carrera","/f1/":"/deporte-motor/f1/","/football/":"/futbol-americano/","/mens-college-basketball/":"/basquetbol/colegial-hombres/","/mlb/":"/beisbol/mlb/","/mma/":"/artes-marciales-mixtas/","/nba/":"/basquetbol/nba/","/nba-g-league/":"/basquetbol/nba-g-league/","/nba/gamecast":"/basquetbol/nba/deportes/gamecast","/nba/statistics/":"/basquetbol/nba/estadisticas/","/nba/statistics/team":"/basquetbol/nba/estadisticas/equipo","/nfl/":"/futbol-americano/nfl/","/nhl/":"/hockey/nhl/","/olympics/":"/olimpicos/","/other-sports/":"/otros-deportes/","/panamerican/":"/panamericanos/","/rpm/":"/deporte-motor/","/soccer/":"/futbol/","/tennis/":"/tenis/","/womens-college-basketball/":"/basquetbol/colegial-mujeres/"},"toEnglish":{"/artes-marciales-mixtas/":"/mma/","/basquetbol/colegial-hombres/":"/mens-college-basketball/","/basquetbol/colegial-mujeres/":"/womens-college-basketball/","/basquetbol/nba/":"/nba/","/basquetbol/nba-g-league/":"/nba-g-league/","/basquetbol/nba/deportes/gamecast":"/nba/gamecast","/basquetbol/nba/estadisticas/":"/nba/statistics/","/basquetbol/nba/estadisticas/equipo":"/nba/statistics/team","/beisbol/mlb/":"/mlb/","/boxeo/":"/boxing/","/deporte-motor/f1/":"/f1/","/futbol-americano/colegial/":"/college-football/","/futbol-americano/nfl/":"/nfl/","/futbol/":"/soccer/","/olimpicos/":"/olympics/","/otros-deportes/":"/other-sports/","/panamericanos/":"/panamerican/","/tenis/":"/tennis/"}},"urls":{"toEdition":{},"toEnglish":{"/nfl/index":"/football/index","/nba/index":"/basketball/index","/mlb/index":"/baseball/index"}},"paramValues":{"toEdition":{"all":"todo","discipline":"tarjetas","league":"liga","constructors":"construtores","performance":"rendimiento","scoring":"anotaciones","points":"puntos"},"toEnglish":{"liga":"league","todo":"all","construtores":"constructors","puntos":"points"}}},"portuguese":{"urls":{"toEdition":{},"toEnglish":{}},"roots":{"toEdition":{"/bola-de-prata/":"/futebol/bola-de-prata/","/data-espn/":"/futebol/data-espn/","/ranking-dos-treinadores/":"/futebol/ranking-dos-treinadores/","/selecao-brasileira/":"/futebol/selecao-brasileira/","/brazilian-basketball/":"/basquete/","/mlb/":"/beisebol/mlb/","/soccer/team/results":"/futebol/time/resultados","/soccer/":"/futebol/","/f1/":"/f1/","/rpm/":"/esportes-a-motor/","/tennis/":"/tenis/","/oly/summer/":"/olimpiadas/verao/","/oly/summer/basketball/":"/olimpiadas/verao/basquete/","/olympics/summer/":"/olimpiadas/verao/","/olympics/summer/2012/results":"/olimpiadas/verao/2012/resultados","/olympics/summer/2016/results":"/olimpiadas/verao/2016/resultados","/oly/winter/":"/olimpiadas/inverno/","/olympics/winter/":"/olimpiadas/inverno/","/olympics/":"/olimpiadas/","/oly/":"/olimpiadas/","/boxing/":"/boxeo/","/polo/":"/otros-deportes/polo/","/other-sports/":"/otros-deportes/","/panamerican/":"/panamericanos/","/archery/":"/tiro-con-arco/","/athletics/":"/atletismo/","/canoe/":"/canoagem/","/badminton/":"/badminton/","/nba-summer-league/":"/liga-de-verao-de-la-nba/","/cycling/":"/ciclismo/","/equestrian/":"/ecuestre/","/fencing/":"/esgrima/","/field-hockey/":"/hoquei-na-grama/","/gymnastics/":"/ginastica/","/handball/":"/handebol/","/modern-pentathlon/":"/pentatlo-moderno/","/rowing/":"/remo/","/sailing/":"/vela/","/shooting/":"/tiro/","/swimming/":"/natacao/","/table-tennis/":"/tenis-de-mesa/","/triathlon/":"/triatlo/","/volleyball/":"/voleibol/","/water-polo/":"/polo-aquatico/","/weightlifting/":"/levantamento-de-peso/","/wrestling/":"/luta/","/golf/":"/golfe/","/surfing/":"/surfe/"},"toEnglish":{"/basquete/":"/brazilian-basketball/","/beisebol/mlb/":"/mlb/","/futebol/bola-de-prata/":"/bola-de-prata/","/futebol/data-espn/":"/data-espn/","/futebol/ranking-dos-treinadores/":"/ranking-dos-treinadores/","/futebol/selecao-brasileira/":"/selecao-brasileira/","/futebol/":"/soccer/","/f1/":"/f1/","/esportes-a-motor/":"/rpm/","/tenis/":"/tennis/","/liga-de-verao-de-la-nba/":"/nba-summer-league/","/olimpiadas/verao/":"/olympics/summer/","/olimpiadas/verao/basquete/":"/oly/summer/basketball/","/olimpiadas/verao/2012/resultados":"/olympics/summer/2012/results","/olimpiadas/verao/2016/resultados":"/olympics/summer/2016/results","/olimpiadas/inverno/":"/olympics/winter/","/olimpiadas/":"/oly/","/boxeo/":"/boxing/","/otros-deportes/polo/":"/polo/","/otros-deportes/":"/other-sports/","/panamericanos/":"/panamerican/","/tiro-con-arco/":"/archery/","/atletismo/":"/athletics/","/canoagem/":"/canoe/","/badminton/":"/badminton/","/ciclismo/":"/cycling/","/ecuestre/":"/equestrian/","/esgrima/":"/fencing/","/hoquei-na-grama/":"/field-hockey/","/ginastica/":"/gymnastics/","/handebol/":"/handball/","/pentatlo-moderno/":"/modern-pentathlon/","/remo/":"/rowing/","/vela/":"/sailing/","/tiro/":"/shooting/","/natacao/":"/swimming/","/tenis-de-mesa/":"/table-tennis/","/triatlo/":"/triathlon/","/voleibol/":"/volleyball/","/polo-aquatico/":"/water-polo/","/levantamento-de-peso/":"/weightlifting/","/luta/":"/wrestling/","/golfe/":"/golf/","/surfe/":"/surfing/"}},"pathSegments":{"toEnglish":{"clipe":"clip","reporte":"report","jogo":"game","time":"team","elenco":"roster","estatisticas":"stats","calendario":"schedule","estadio":"stadium","profundidad":"depth","bate-papo":"conversation","placar":"boxscore","previa":"preview","partida":"match","minuto-a-minuto":"playbyplay","cronica":"report","fotos":"photos","confronto":"matchup","classificacao":"standings","resultados":"scoreboard","liga":"league","ligas":"leagues","artigo":"story","olimpiadas":"olympics","verao":"summer","comentario":"commentary","escalacoes":"lineups","escalacao":"lineup","numeritos":"matchstats","deportes":"sports","atletas":"athletes","lideres":"leaderboard","jogador":"player","lesoes":"injuries","rebatendo":"batting","piloto":"driver","corrida":"race","circuito":"circuit","resultados-corrida":"results","narracao":"commentary","mercado-da-bola":"transfers"},"toEdition":{"clip":"clipe","report":"cronica","game":"jogo","team":"time","teams":"times","roster":"elenco","stats":"estatisticas","schedule":"calendario","stadium":"estadio","depth":"profundidad","conversation":"bate-papo","boxscore":"placar","preview":"previa","match":"partida","playbyplay":"minuto-a-minuto","recap":"cronica","photos":"fotos","matchup":"confronto","standings":"classificacao","scoreboard":"resultados","league":"liga","leagues":"ligas","story":"artigo","olympics":"olimpiadas","summer":"verao","commentary":"narracao","lineups":"escalacoes","lineup":"escalacao","matchstats":"numeritos","sports":"deportes","athletes":"atletas","leaderboard":"lideres","player":"jogador","injuries":"lesoes","batting":"rebatendo","driver":"piloto","race":"corrida","circuit":"circuito","results":"resultados-corrida","fixtures":"calendario","transfers":"mercado-da-bola","squad":"elenco"}},"paramKeys":{"toEnglish":{"jogoId":"gameId","data":"date","nome":"name","partida":"gameID","liga":"league","tipodetemporada":"seasontype","ano":"year","semana":"week","modalidade":"discipline","evento":"event","tournamentId":"tournamentId","atleta":"athlete","vista":"view","pais":"country","pagina":"page","continuo":"continuous","rodada":"round","posicao":"position","time":"team","ligas":"leagues","grupo":"group","temporada":"season","ordenar":"sort"},"toEdition":{"gameId":"jogoId","date":"data","name":"nome","gameID":"partida","league":"liga","seasontype":"tipodetemporada","year":"ano","week":"semana","discipline":"modalidade","event":"evento","tournamentId":"tournamentId","athlete":"atleta","view":"vista","country":"pais","page":"pagina","continuous":"continuo","round":"rodada","position":"posicao","team":"time","leagues":"ligas","group":"grupo","season":"temporada","sort":"ordenar"}},"paramValues":{"toEnglish":{"liga":"league","ligas":"leagues","todos":"all","atletas":"athletes","paises":"countries","constructores":"constructors","pontos":"points","sobe":"asc","desce":"desc","gols":"scoring","cartoes":"discipline","rendimento":"performance"},"toEdition":{"league":"liga","leagues":"ligas","all":"todos","athletes":"atletas","countries":"paises","constructors":"constructores","points":"pontos","asc":"sobe","desc":"desce","scoring":"gols","discipline":"cartoes","performance":"rendimento"}}}}

/***/ }),
/* 826 */
/***/ (function(module, exports) {

	module.exports = ["toEnglish","toEdition"]

/***/ }),
/* 827 */
/***/ (function(module, exports) {

	module.exports = {"(^|\\.)espnfc\\.":"/football","(^|\\.)espncricinfo\\.":"/cricket"}

/***/ }),
/* 828 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * URL parsing tool
	 * (c) Steven Levithan <stevenlevithan.com>
	 * MIT License
	 *
	 * @param {string} str string to parse
	 *
	 * @return {Object.<string, string>} result data
	 */
	function parseUri ( str ) {
	    var o   = parseUri.options,
	        m   = o.parser[o.strictMode ? 'strict' : 'loose'].exec(str),
	        uri = {},
	        i   = 14;
	
	    while ( i-- ) { uri[o.key[i]] = m[i] || ''; }
	
	    uri[o.q.name] = {};
	
	    /* eslint no-unused-vars: 0 */
	    uri[o.key[12]].replace(o.q.parser, function ( $0, $1, $2 ) {
	        if ( $1 ) { uri[o.q.name][$1] = $2; }
	    });
	
	    return uri;
	}
	
	parseUri.options = {
	    strictMode: false,
	    key:        ['source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'],
	    q:          {
	        name:   'queryKey',
	        parser: /(?:^|&)([^&=]*)=?([^&]*)/g
	    },
	    parser:     {
	        strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
	        loose:  /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
	    }
	};
	
	
	// public
	module.exports = parseUri;

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(365);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.default = isReactPath;
	
	var _parseURI = __webpack_require__(830);
	
	var _parseURI2 = _interopRequireDefault(_parseURI);
	
	var _getSportFromRoot = __webpack_require__(831);
	
	var _getSportFromRoot2 = _interopRequireDefault(_getSportFromRoot);
	
	var _translateURI = __webpack_require__(832);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * These are the default react pages that are currently available, setting to false
	 * here will stop that page type from being recognised as a react page and will stop
	 * the links from working.
	 * NOTE: this can be overridden on a per edition basis by adding
	 * a key to the config called `reactOverride` and following the sport -> pageType structure
	 * the editions boolean value will always take precedent over the values set here...
	 */
	var REACT_PAGE_TYPES = {
	  'cricket': {
	    'table': true,
	    'scores': true,
	    'statistics': true,
	    'report': true,
	    'preview': true,
	    'game': true,
	    'scorecard': true,
	    'commentary': true,
	    'coverage': true,
	    'video': true,
	    'static': true,
	    'hawkeye': true
	  },
	  'rugby': {
	    'standings': true,
	    'table': true,
	    'fixtures': true,
	    'schedule': true,
	    'report': true,
	    'preview': true,
	    'match': true,
	    'game': true,
	    'playerstats': true,
	    'matchstats': true,
	    'commentary': true,
	    'lineups': true,
	    'conversation': true,
	    'scores': true,
	    'scoreboard': true,
	    'results': true,
	    'team': true
	  },
	  'rugby-league': {
	    'standings': true,
	    'table': true,
	    'fixtures': true,
	    'schedule': true,
	    'preview': true,
	    'match': true,
	    'game': true,
	    'playerstats': true,
	    'matchstats': true,
	    'commentary': true,
	    'lineups': true,
	    'conversation': true,
	    'scores': true,
	    'scoreboard': true,
	    'results': true
	  },
	  'soccer': {
	    'table': false,
	    'schedule': false
	  }
	
	  /**
	   * NOTE: this assumes the domain will not change and will not jump editions. i.e. going
	   * from espn.com/rugby/tables to espn.co.uk/rugby/tables will be seen as an external link
	   * and therfore not be dealt with by react-router
	  **/
	
	};function isReactPath() {
	  var hostname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var URI = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var edition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	
	  if (typeof URI === 'string' && typeof hostname === 'string') {
	    var reactPages = edition.reactOverride || {};
	    var parsedURI = (0, _parseURI2.default)(URI) || {};
	    var hostReplaces = /localhost|local\.|www\.|-qa|qa\.|preview\./;
	    //console.info('edition', edition)
	    //console.info('parseURI', parsedURI)
	    /* default if relative or localhost */
	    if (parsedURI.host === 'localhost' || parsedURI.host === '') {
	      parsedURI.host = edition.domain;
	    }
	
	    var simpleHost = (parsedURI.host || '').replace(hostReplaces, '') || '';
	    var editionHost = (edition.domain || '').replace(hostReplaces, '') || '';
	    //console.info('simpleHost, editionHost', simpleHost, editionHost)
	    /* Validate the domain */
	    if (simpleHost === editionHost) {
	      var uriPath = parsedURI.path || '';
	      if (uriPath) {
	        // prepend `/` separator if the uripath starts with no `/`
	        if (/^\//.test(uriPath) === false) {
	          uriPath = '/' + uriPath;
	        }
	        // prepend `edition.defaultSport` if edition is not multi-sports
	        var hasSport = new RegExp('^\/' + edition.defaultSport);
	        if (edition.isMultiSports === false && hasSport.test(uriPath) === false) {
	          uriPath = edition.defaultSport + uriPath;
	        }
	        var sport = pathToSport(uriPath) || '';
	        var pageType = pathToPageType(uriPath) || '';
	
	        //Translate PageType
	        var translatedUriPath = (0, _translateURI.translatePath)(edition, uriPath, true);
	        pageType = pathToPageType(translatedUriPath);
	
	        var configTypes = reactPages[sport] || {};
	        var availTypes = REACT_PAGE_TYPES[sport] || {};
	        var mergedTypes = {};
	        (0, _assign2.default)(mergedTypes, availTypes, configTypes);
	        if (mergedTypes[pageType]) {
	          return true;
	        }
	      }
	    }
	  }
	  return false;
	}
	
	function splitURI(uriPath) {
	
	  uriPath = uriPath.replace(/^\//, '');
	  var pathSections = uriPath.split('/') || [];
	  return pathSections;
	}
	
	function pathToSport(uriPath) {
	
	  var pathSections = splitURI(uriPath) || [];
	  return (0, _getSportFromRoot2.default)(pathSections[0]) || '';
	}
	
	function pathToPageType(uriPath) {
	
	  var pathSections = splitURI(uriPath) || [];
	  var sport = pathToSport(uriPath) || '';
	
	  if (sport === 'cricket' && pathSections[1] === 'series' && pathSections[2] !== '_') {
	    return pathSections[3];
	  }
	
	  return pathSections[1];
	}

/***/ }),
/* 830 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * URL parsing tool
	 * (c) Steven Levithan <stevenlevithan.com>
	 * MIT License
	 *
	 * @param {string} str string to parse
	 *
	 * @return {Object.<string, string>} result data
	 */
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function parseUri(str) {
	  var o = parseUri.options;
	  var m = o.parser[o.strictMode ? 'strict' : 'loose'].exec(str);
	  var uri = {};
	  var i = 14;
	
	  while (i--) {
	    uri[o.key[i]] = m[i] || '';
	  }
	
	  uri[o.q.name] = {};
	
	  /* eslint no-unused-vars: 0 */
	  uri[o.key[12]].replace(o.q.parser, function ($0, $1, $2) {
	    if ($1) {
	      uri[o.q.name][$1] = $2;
	    }
	  });
	
	  return uri;
	}
	
	parseUri.options = {
	  strictMode: false,
	  key: ['source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'],
	  q: {
	    name: 'queryKey',
	    parser: /(?:^|&)([^&=]*)=?([^&]*)/g
	  },
	  parser: {
	    strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
	    loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
	  }
	
	  // public
	};exports.default = parseUri;

/***/ }),
/* 831 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getSportFromRoot;
	/* \score\tea\core-tea\src\main\tea\util\getSportDetails.tea */
	
	/* Commented out sports we are not yet using so they can be stripped out by complier
	 * NOTE: to save space as well any root that matches the sport does not need a map
	 * i.e. 'soccer' : 'soccer' is not required as we can pass the root through as the sport
	 */
	var ROOT_TO_SPORT = {
	  'nba': 'basketball',
	  //'womenbb' :       'basketball',
	  //'sports/womenbb' :'basketball',
	  //'ncb' :           'basketball',
	  //'nfl' :           'football',
	  //'ncf' :           'football',
	  //'nhl' :           'hockey',
	  //'mlb' :           'baseball',
	  //'atp' :           'tennis',
	  //'wtp' :           'tennis',
	  //'pga' :           'golf',
	  //'college-sports' :'ncaa',
	  //'rpm' :           'racing',
	  //'f1' :            'racing',
	  //'indy-car' :      'racing',
	  //'v8-supercars' :  'racing',
	  //'motogp' :        'racing',
	  //'nascar' :        'racing',
	  'football': 'soccer'
	};
	
	function getSportFromRoot(urlRoot) {
	
	  var sport = '';
	  if (typeof urlRoot === 'string') {
	    sport = urlRoot.toLowerCase().trim();
	    sport = ROOT_TO_SPORT[sport] || sport;
	  }
	
	  return sport;
	}

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(419);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.translateURI = translateURI;
	exports.translatePath = translatePath;
	exports.translateQueryKey = translateQueryKey;
	exports.translateValue = translateValue;
	exports.translatePageType = translatePageType;
	
	var _parseURI = __webpack_require__(830);
	
	var _parseURI2 = _interopRequireDefault(_parseURI);
	
	var _queryString = __webpack_require__(207);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _selectn = __webpack_require__(438);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * [translateURI helper function to translate a URL]
	 * @param  {Object}  edition   edition data
	 * @param  {Object}  req       request object
	 * @param  {Boolean} localized localize to the current edition language
	 * @return {Object}            return translated url
	 */
	function translateURI() {
	  var edition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var req = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var localized = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	
	  //console.log('req.url => ', req.url)
	
	  var url = req.url ? req.url : '';
	
	  var translatedUrlObj = { url: '' };
	
	  if (url) {
	
	    var pathObj = (0, _parseURI2.default)(url);
	
	    var translatedPath = translatePath(edition, pathObj.path, localized);
	    var queryObject = translateQueryKey(edition, pathObj.queryKey, localized);
	
	    var queryString = _queryString2.default.stringify(queryObject);
	    queryString = queryString ? '?' + queryString : '';
	
	    translatedUrlObj = { url: translatedPath + queryString };
	  }
	
	  //console.log('translated url: ==>', translatedUrlObj.url,'\n')
	
	  return translatedUrlObj;
	}
	/**
	 * [translatePath Translates a relative path to the local edition language]
	 * @param  {Object}  edition   edition data
	 * @param  {String}  path      relative path to be translated
	 * @param  {Boolean} localized localize to the current edition language
	 * @return {String}            return translated path
	 */
	function translatePath(edition) {
	  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var localized = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	
	  var pathOffset = '/';
	  var newPathArr = [''];
	  var newPathArrString = '';
	  var pathSegments = (0, _selectn2.default)('uriRewrites.pathSegments', edition) || {};
	
	  if (path) {
	    //split path based on / and translate
	    var pathArr = path.split('/') || [];
	    var pathArrLen = pathArr.length;
	
	    for (var i = 0; i < pathArrLen; i++) {
	      var item = pathArr[i];
	      if (item) {
	        var value = '';
	        if (localized) {
	          value = pathSegments[item] || item;
	        } else {
	          var objKeys = (0, _keys2.default)(pathSegments) || [];
	          var objKeysLen = objKeys.length;
	          for (var j = 0; j < objKeysLen; j++) {
	            if (pathSegments[objKeys[j]] === item) {
	              value = objKeys[j];
	              break;
	            } else {
	              value = item;
	            }
	          }
	        }
	        if (value) {
	          newPathArr.push(value);
	        }
	      }
	    }
	    newPathArrString = newPathArr.join(pathOffset);
	  }
	  if (!newPathArrString) {
	    return path;
	  }
	
	  return newPathArrString;
	}
	
	/**
	 * [translateQueryKey Translates queryKey object from location]
	 * @param  {Object}  edition   edition data
	 * @param  {Object}  queryKey  queryKey object from location
	 * @param  {Boolean} localized localize to the current edition language
	 * @return {Object}            translated queryKey
	 */
	function translateQueryKey(edition) {
	  var queryKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var localized = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	
	  var newQueryKey = {};
	  var newQueryKeyLen = {};
	  var paramKeys = (0, _selectn2.default)('uriRewrites.paramKeys', edition) || {};
	  var paramValues = (0, _selectn2.default)('uriRewrites.paramValues', edition) || {};
	
	  (0, _keys2.default)(queryKey).map(function (item) {
	    if (item) {
	      var value = queryKey[item];
	      var name = '';
	      if (localized) {
	        name = paramKeys[item] || item;
	      } else {
	        var objKeys = (0, _keys2.default)(paramKeys) || [];
	        var objKeysLen = objKeys.length;
	        for (var j = 0; j < objKeysLen; j++) {
	          if (paramKeys[objKeys[j]] === item) {
	            name = objKeys[j];
	            break;
	          } else {
	            name = item;
	          }
	        }
	      }
	      if (name) {
	        newQueryKey[name] = translateValue(value, paramValues, localized);
	      }
	    }
	  });
	  newQueryKeyLen = (0, _keys2.default)(newQueryKey).length || 0;
	  if (newQueryKeyLen === 0) {
	    return queryKey;
	  }
	  return newQueryKey;
	}
	
	/**
	 * [translateValue translates value of key value pair in queryKey using pathSegments]
	 * @param  {String}  value       Value of particular key in key-value
	 * @param  {Object}  paramValues paramValues in edition config
	 * @param  {Boolean} localized   localize to the current edition language
	 * @return {String}              Translated value
	 */
	function translateValue() {
	  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var paramValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var localized = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  var newValue = '';
	
	  if (localized) {
	    newValue = paramValues[value] || value;
	  } else {
	    var objKeys = (0, _keys2.default)(paramValues) || [];
	    var objKeysLen = objKeys.length;
	    for (var j = 0; j < objKeysLen; j++) {
	      if (paramValues[objKeys[j]] === value) {
	        newValue = objKeys[j];
	        break;
	      } else {
	        newValue = value;
	      }
	    }
	  }
	  return newValue;
	}
	
	/**
	 * [translatePageType Translate pageType using pathSegments]
	 * @param  {Object}   edition   edition data
	 * @param  {String}   pageType  pageType value to be converted
	 * @param  {Boolean}  localized localize to the current edition language
	 * @return {String}             translated pageType
	 */
	function translatePageType() {
	  var edition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var pageType = arguments[1];
	  var localized = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	
	  var pathSegments = (0, _selectn2.default)('uriRewrites.pathSegments', edition) || {};
	
	  var path = ['/', pageType, '/'].join('');
	  var translatedPath = translatePath(pathSegments, path, localized);
	  var pathArr = translatedPath.split('/') || [];
	  var translatedPageType = pathArr.length > 1 ? pathArr[1] : '';
	  return translatedPageType;
	}

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _selectn = __webpack_require__(438);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	var _typeOf = __webpack_require__(578);
	
	var _typeOf2 = _interopRequireDefault(_typeOf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	* function to translate keys into their respective languages
	* espn.i18n.translations
	**/
	
	function translate() {
	  var edition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var transObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	
	  if (process.browser) {
	    var search = (0, _selectn2.default)('location.search', window) || '';
	    if (search.indexOf('_translate=true') !== -1) {
	      return '{{{' + transObj + '}}}';
	    }
	  }
	
	  var translations = (0, _selectn2.default)('translations', edition) || {};
	  var tranObjType = (0, _typeOf2.default)(transObj) || '';
	  var key = '';
	  var translation = '';
	
	  // direct translation
	  if (tranObjType === 'string') {
	    key = transObj;
	
	    // variable translation
	  } else if (tranObjType === 'object') {
	
	    key = transObj['key'] || '';
	    for (var k in transObj) {
	      if (transObj.hasOwnProperty(k) && k !== 'key') {
	        key = key + '_%{' + k + '}';
	      }
	    }
	  } else if (tranObjType === 'number') {
	    translation = transObj;
	  }
	
	  if (key) {
	
	    var phrase = translations[key] || '';
	
	    if (phrase) {
	
	      if (tranObjType === 'string') {
	        translation = phrase;
	      } else if (tranObjType === 'object') {
	        translation = phrase;
	
	        // find variable placeholders and replace with actual values
	        var varArr = translation.match(/[%|\$]\{(\w+)\}/g) || [];
	        var mapLen = varArr.length;
	        for (var i = 0; i < mapLen; i++) {
	          var varValue = varArr[i].replace(/[%|\$]|{|}/g, '');
	          translation = translation.replace(varArr[i], transObj[varValue] || varArr[i]);
	        }
	      }
	
	      if ((0, _typeOf2.default)(params) === 'object') {
	        var _varArr = translation.match(/\$\{(\w+)\}/g) || [];
	        var _mapLen = _varArr.length;
	        for (var _i = 0; _i < _mapLen; _i++) {
	          var _varValue = _varArr[_i].replace(/\$|{|}/g, '');
	          translation = translation.replace(_varArr[_i], params[_varValue] || _varArr[_i]);
	        }
	      }
	    } else {
	      // don't show null, show something clever here ie, show cleaned up key
	      // there are fallbacks by locale in the getLabel method
	      translation = key;
	    }
	  }
	
	  // prevent translation process from returning null and potentially causing NPEs
	  if (!translation && key) {
	    translation = key;
	  } else if (!translation && !key) {
	    translation = '';
	  }
	
	  return translation;
	}
	
	exports.default = translate;
	
	/*
	
	For documentation on how to use this file:
	https://confluence.espn.com/pages/viewpage.action?pageId=18098169

	Usage:

	  Direct literal translation

	    translate( edition, 'hello' )

	    In translate tool:
	      hello       Hola

	    Returns: String
	      "Hola"

	  Using variables in a translation

	    const groupTranslation = {
	      key :     'groupStandings',
	      group :     'GROUP A',
	      season :    'YEAR',
	    }

	    // the key that will show up in the translate tool is the key you pass in plus the variables like groupStandings_%{group}_%{season}

	    translate( edition, groupTranslation )

	    In translate tool:
	      groupStandings_%{group}_%{season}   Posciones de %{group} en %{season}

	    Returns: String
	      "Posiciones de GROUP A en YEAR"

	  Using placeholders in translations

	    const paramsdata = {
	      displayName :   'DISPLAY NAME',
	      readableDate :  'READABLE DATE'
	    }

	    translate( edition, 'thereAreNoEventsByDisplayNameByDate', paramsdata )

	    In translate tool:
	      thereAreNoEventsByDisplayNameByDate   Posciones de ${displayName} en ${readableDate}

	    Returns: String
	      "Posiciones de DISPLAY NAME en READABLE DATE"

	*/
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.helpers = undefined;
	
	var _getIterator2 = __webpack_require__(435);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _toConsumableArray2 = __webpack_require__(410);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(364);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(365);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _typeof2 = __webpack_require__(312);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(419);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _momentTimezone = __webpack_require__(450);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _selectn = __webpack_require__(438);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	var _common = __webpack_require__(814);
	
	var _common2 = __webpack_require__(430);
	
	var _metahelpers = __webpack_require__(835);
	
	var _metahelpers2 = _interopRequireDefault(_metahelpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TWEET_CLASS = 'twitter-tweet',
	    SCRIPT_TAG = '<script';
	
	var helpers = exports.helpers = {
	  /**
	  * Get numeric period of the current innings
	  * Earlier we used competition.details[0].period but now we are
	  * using status.period
	  *
	  * @param  {Object} competition competition
	  * @return {Number}         period of current innings
	  */
	  getCurrentPeriod: function getCurrentPeriod() {
	    var competition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    return (0, _selectn2.default)('status.period', competition);
	  },
	
	  /**
	   * [getMatchCards Get match cards]
	   * @param  {Array}  cards [cards array]
	   * @return {[type]}       [array]
	   */
	  getMatchCards: function getMatchCards() {
	    var cards = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    return cards;
	  },
	
	  /**
	   * Get frequently used flags for a match
	   * @param  {Object} competition  competitions node from API
	   * @param {Number}  ballsPerOver balls per over info from notes node
	   * @return {Object}              flags {limitedOvers, updatesOnly etc}
	   */
	  getMatchFlags: function getMatchFlags() {
	    var competition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var ballsPerOver = arguments[1];
	
	    // By default, set all flags to undefined
	    var flags = {
	      liveAvailable: undefined,
	      updatesOnly: undefined,
	      limitedOvers: undefined,
	      onWatchESPN: undefined,
	      fastcastAvailable: undefined,
	      isTestMatch: undefined,
	      id: undefined,
	      isBallPerOverSix: undefined
	
	      // Get an array of flags to pick
	    };var flagsToPick = (0, _keys2.default)(flags);
	    var numFlags = flagsToPick.length;
	    // Iterate over required flags and set their values
	    for (var i = 0; i < numFlags; i++) {
	      var currentFlag = flagsToPick[i];
	      if (competition.hasOwnProperty(currentFlag)) {
	        flags[currentFlag] = competition[currentFlag];
	      }
	    }
	
	    //check if match is multiday
	    var classEventType = (0, _selectn2.default)('class.eventType', competition) || '';
	    flags.isTestMatch = classEventType.toLowerCase() === 'test' ? true : false;
	
	    // Set default value of flag
	    flags.international = undefined;
	    // Get class id from the feed
	    var classId = (0, _selectn2.default)('class.internationalClassId', competition);
	    /**
	     * As of now, only below 3 class ids are considered as international
	     * for fastcast implementation.
	     * @type {Array}
	     */
	    var validIntlIds = ['1', '2', '3'];
	    // Set flag to true only if value is found in above array
	    if (validIntlIds.indexOf(classId) > -1) {
	      flags.international = true;
	    }
	
	    //This flag is for showing '6 balls per over' text, if the no. of balls per over not equals to 6
	    flags.showBallPerOverSix = (typeof ballsPerOver === 'undefined' ? 'undefined' : (0, _typeof3.default)(ballsPerOver)) !== undefined && ballsPerOver !== '' && ballsPerOver !== 6 ? true : false;
	
	    return flags;
	  },
	
	
	  /**
	   * Commentary team wants to embed tweets in the commentary text from CMS.
	   * Twitter script embedded in the page breaking the content on the screen
	   * Get htmlString without script tag if exists
	   * Implemented only for tweets. Can be used for other social media like instagram, with additional checks, if needed
	   * @param  {String}  htmlString String htmlString with/out embedded tweet
	   * @return {String} htmlString - returns htmlString without <script if exists, otherwise input is returned as is
	   *
	   */
	  removeScriptTag: function removeScriptTag(htmlString) {
	    if (htmlString.indexOf(TWEET_CLASS) !== -1 && htmlString.indexOf(SCRIPT_TAG) !== -1) {
	      return htmlString.replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '');
	    }
	    return htmlString;
	  },
	
	
	  /**
	   * Get information about all possible extra runs
	   * @param  {Boolean}  forScorecard Is this for full scorecard or commentary
	   * @return {Object} allExtras - map of extra name & abbreviation
	   *                  abbreviations - array of `extra` abbreviations
	   */
	  getAllExtras: function getAllExtras() {
	    var forScorecard = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    // API has different property names for scorecard & commentary
	    var byeKey = forScorecard ? 'byes' : 'byes';
	    var wideKey = forScorecard ? 'wides' : 'wide';
	    var noballKey = forScorecard ? 'noballs' : 'noBall';
	    var legbyeKey = forScorecard ? 'legbyes' : 'legByes';
	
	    // sequence in which extras should be displayed
	    var allExtras = [{ name: byeKey, abbreviation: 'b' }, { name: legbyeKey, abbreviation: 'lb' }, { name: noballKey, abbreviation: 'nb' }, { name: wideKey, abbreviation: 'w' }, { name: 'penalties', abbreviation: 'pen' }];
	
	    var abbreviations = [];
	    for (var i = 0; i < allExtras.length; i++) {
	      var extra = allExtras[i];
	      abbreviations.push(extra.abbreviation);
	    }
	
	    return { allExtras: allExtras, abbreviations: abbreviations };
	  },
	
	
	  /**
	   * Get total runs for an innings.
	   * @param  {Object}   stats           stats object from all innings array
	   * @param  {Object}   matchFlags      flags for this match
	   * @param  {Boolean}  showOtherStats  true if Run Rate/Minutes should be shown
	   * @return {String}   runs / wickets (overs, RR/minutes)
	   */
	  getInningsTotal: function getInningsTotal() {
	    var stats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var matchFlags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var showOtherStats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    // default variables
	    var total = '';
	    var runsWickets = '';
	    var otherStats = [];
	    var otherStatsString = '';
	    var ballsPerOverText = '';
	    // set empty string as default value
	    var val = '';
	    //console.info('\ninput stats', stats)
	
	    /**
	     * Extract stats for this innings.
	     * Set stats to empty strings only if not availble.
	     * Do not use stats directly in a boolean operation since 0 is a valid stat
	     * & falsy value.
	     *
	     * e.g. DO NOT use - let runs = selectn('brief.runs',stats) || ''
	     */
	    var runs = (0, _selectn2.default)('brief.runs', stats);
	    runs = typeof runs !== 'undefined' ? runs : val;
	
	    var wickets = (0, _selectn2.default)('brief.wickets', stats);
	    wickets = typeof wickets !== 'undefined' ? wickets : val;
	
	    var overs = (0, _selectn2.default)('brief.overs', stats);
	    overs = typeof overs !== 'undefined' ? overs : val;
	
	    var rr = (0, _selectn2.default)('all.runRate.displayValue', stats);
	    rr = typeof rr !== 'undefined' ? rr : val;
	
	    var duration = (0, _selectn2.default)('all.minutes.displayValue', stats);
	    duration = typeof duration !== 'undefined' ? duration : val;
	
	    var description = (0, _selectn2.default)('brief.description', stats) || '';
	    var isFollowOn = (0, _selectn2.default)('brief.followOn', stats) == 1 ? true : false;
	
	    //console.info('runs=%s wickets=%s overs=%s rr=%s minutes=%s', runs, wickets, overs, rr, duration)
	
	    // Return default total if overs is an empty string
	    if (overs === '') {
	      return total;
	    }
	
	    // Handle runs wickets
	    if (runs !== '' && wickets !== '') {
	      // Append all out (hide wickets) if innings description is all out
	      if (description === 'all out') {
	        runsWickets = [runs, 'all out'].join(' ');
	      }
	      /**
	       * Display runs/wickets if number of wickets is not 10.
	       * Do not use ===. In case typeof 10 changes in feed, front end code
	       * should still work.
	       */
	      else if (wickets != '10') {
	          runsWickets = [runs, wickets].join('/');
	        }
	        // default to runs
	        else {
	            runsWickets = runs;
	          }
	    }
	
	    // Handle declared & follow on cases
	    if (description === 'declared') {
	      runsWickets += 'd';
	    }
	    if (isFollowOn === true) {
	      runsWickets += ' (f/o)';
	    }
	
	    // Format overs if present
	    if (overs !== '') {
	      otherStats.push(overs + ' Overs');
	    }
	
	    // Display additional stats if showOtherStats option is true
	    if (showOtherStats === true) {
	      // Display run rate
	      if (rr !== '') {
	        //We are calculating run rate as 6 balls per over
	        //This is for the matches, where balls per over is other than 6
	        if (matchFlags.showBallPerOverSix === true) {
	          ballsPerOverText = ' per 6 ball';
	        }
	        otherStats.push('RR: ' + rr + ballsPerOverText);
	      }
	      // Display innings duration for test matches
	      if (matchFlags.limitedOvers === false) {
	        if (duration !== '') {
	          otherStats.push(duration + ' minutes');
	        }
	      }
	    }
	
	    if (otherStats.length !== 0) {
	      otherStatsString = '(' + otherStats.join(', ') + ')';
	    }
	    //console.info('otherStatsString', otherStatsString)
	    total = runsWickets + ' ' + otherStatsString;
	    //console.info('total', total)
	    return total;
	  },
	
	
	  /**
	   * Get total extras with split of byes, wides, no balls, leg byes, penalties.
	   * Also get the total number of extras
	   *
	   * @param  {Object} stats stats object from all innings array
	   * @return {String}       Total (Nb, Nw, Nnb, Nlb, Npen)
	   */
	  getExtras: function getExtras() {
	    var stats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    // For final string = total extras (split string)
	    var totalExtras = [];
	    var totalExtrasString = '';
	    // For split string Nb, Nw, Nn, Nlb
	    var extraSplit = [];
	    var extraSplitString = '';
	
	    // Get count of number of extras given
	    var count = (0, _selectn2.default)('all.extras.displayValue', stats);
	    if (typeof count !== 'undefined') {
	      totalExtras.push(count);
	    }
	
	    var extraDetails = helpers.getAllExtras(true) || {};
	    var whichExtras = extraDetails.allExtras;
	    var numExtras = whichExtras.length;
	    // Iterate over required extra stats and get their values
	    for (var i = 0; i < numExtras; i++) {
	      var extra = whichExtras[i];
	      var extraValue = (0, _selectn2.default)('all[' + extra.name + '].displayValue', stats);
	      //console.info('%s = %s', extra.name, extraValue)
	      if (typeof extraValue !== 'undefined' && extraValue != 0) {
	        extraSplit.push(extra.abbreviation + ' ' + extraValue);
	      }
	    }
	
	    // Join the split only if any extras are found
	    if (extraSplit.length !== 0) {
	      extraSplitString = '(' + extraSplit.join(', ') + ')';
	      totalExtras.push(extraSplitString);
	    }
	    // Join the total string only if total count or split count is found
	    if (totalExtras.length !== 0) {
	      totalExtrasString = totalExtras.join(' ');
	    }
	    //console.info('totalExtrasString', totalExtrasString)
	    return totalExtrasString;
	  },
	
	
	  /**
	   * Get title(s) of innings.
	   * For Limited over matches, get team name Innings
	   * For Test matches, get team name 1st/2nd Innings
	   *
	   * @param  {Object} competitor an object from competitions.competitors array
	   * @param  {Object} matchFlags flags for this match
	   * @param  {Object} score      linescores node
	   * @return {String}            title for the innings
	   */
	  getInningsTitle: function getInningsTitle(competitor, matchFlags, score) {
	    var innText = 'Innings';
	    var innNum = '';
	    var delimiter = ' - ';
	    // Default titles to return
	    var titles = {
	      full: 'Innings',
	      brief: 'Innings'
	    };
	
	    var teamDisplayName = (0, _selectn2.default)('team.displayName', competitor);
	    var teamAbbreviation = (0, _selectn2.default)('team.abbreviation', competitor);
	    // Use 1st as default for test matches
	    if (matchFlags.limitedOvers === false) {
	      innNum = '1st';
	    }
	    // Use this to construct full string - team name nth Innings
	    var inningsTitle = [teamDisplayName];
	    // Use this to construct brief string - team aabreviation nth
	    var inningsAbbrev = [teamAbbreviation];
	
	    var period = parseInt(score.period, 10);
	
	    // Build all innings array only if period is positive integer and team is batting
	    if (score.isBatting === true && period >= 0) {
	      if (period >= 3) {
	        innNum = '2nd';
	      }
	      // Do not append if inn num is empty string (for limited over matches)
	      if (innNum !== '') {
	        inningsAbbrev.push(innNum);
	        inningsTitle.push(innNum);
	      }
	      inningsTitle.push(innText);
	      // Full innings title
	      titles = {
	        full: inningsTitle.join(delimiter),
	        brief: inningsAbbrev.join(delimiter)
	      };
	    }
	    return titles;
	  },
	
	
	  /**
	   * Get active batsmen & bowlers.
	   *
	   * @param  {Array}  activePlayers  Array of currently active players
	   * @param  {String} role           batsmen/bowlers
	   * @param {String}  currentPeriod  ongoing innings
	   * @return {Array}                 Active batmen/bowlers
	   */
	  getActivePlayersByRole: function getActivePlayersByRole() {
	    var activePlayers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var role = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var currentPeriod = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	    // Map to lookup activeName keys of batsmen and bowlers
	    var roleToName = {
	      batting: ['striker', 'non-striker'],
	      bowling: ['current bowler', 'previous bowler']
	
	      // Map required for allInnings array lookup
	    };var periodToInnings = {
	      '1': 0,
	      '2': 1,
	      '3': 2,
	      '4': 3
	
	      // Default players to return
	    };var playersByRole = [];
	
	    // Return players as is if role is not batsmen/bowlers or current period
	    // is not found in periodToInnings
	    if (roleToName.hasOwnProperty(role) === false || periodToInnings.hasOwnProperty(currentPeriod) === false) {
	      return playersByRole;
	    }
	
	    // Valid strings for players
	    var lookup = roleToName[role];
	
	    var numActivePlayers = activePlayers.length;
	    /**
	     * Loop over active players. Clone the player object so that original object
	     * is not modified. Extract the stats for the live/ongoing innings by
	     * finding out the current innings. If the period property in extracted
	     * stats matches with current period, assign all stats, bowling/batting
	     * stats to combinedStats object.
	     */
	    for (var i = 0; i < numActivePlayers; i++) {
	      var player = activePlayers[i];
	      // continue if activeName is not found
	      if (player.hasOwnProperty('activeName') === false) {
	        continue;
	      }
	      // continue if activeName value is not found in roleToName
	      var activeName = player.activeName;
	      if (lookup.indexOf(activeName) === -1) {
	        continue;
	      }
	      // This is valid active player
	      // Clone the object so that original object is not modified
	      var currentPlayer = (0, _assign2.default)({}, player);
	      var combinedStats = {};
	      // array indexes are period - 1
	      var idx = periodToInnings[currentPeriod];
	      // try to get current innings stats
	      var currentInningStats = (0, _selectn2.default)('linescores[' + idx + ']', currentPlayer);
	      // continue if stats are not found
	      if (typeof currentInningStats === 'undefined') {
	        continue;
	      }
	      // Continue only if period in stats matches with current period
	      if (currentInningStats.period == currentPeriod) {
	        var stats = currentInningStats.statistics;
	        // lookup batting/bowling stats
	        if (stats.hasOwnProperty(role) === true) {
	          combinedStats.brief = stats[role];
	        }
	        // lookup detailed stats
	        if (typeof (0, _selectn2.default)('categories[0].stats', stats) != 'undefined') {
	          combinedStats.all = _common.common.createStatsMap(stats.categories[0].stats);
	        }
	        //
	        if (currentPlayer.stats) {
	          combinedStats.career = _common.common.createStatsMap(currentPlayer.stats);
	        }
	
	        // populate a new property combinedStats for easier lookup
	        currentPlayer.combinedStats = combinedStats;
	        playersByRole.push(currentPlayer);
	      }
	    }
	
	    // Custom comparator - to sort active players by 'striker'/'current bowler'
	    var preferredRole = lookup[0];
	    playersByRole.sort(function (p1, p2) {
	      // p1 should be placed before p2
	      if (p1.activeName === preferredRole) {
	        return -1;
	      }
	      // p1 should be placed after p2
	      if (p2.activeName === preferredRole) {
	        return 1;
	      }
	      // no change
	      return 0;
	    });
	
	    //console.info('playersByRole', playersByRole)
	    return playersByRole;
	  },
	
	  /**
	   * Get Player vs Player stats. Used in This Bowler & Last N overs thead
	   * in batsman table
	   *
	   * @param  {Object} pvp pvp data from current batsmen
	   * @return {String}     String in format runs (n balls)
	   */
	  getPVP: function getPVP() {
	    var pvp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    // default return string
	    var pvpString = '';
	    // Return empty string if data not found
	    if (typeof pvp === 'undefined') {
	      return pvpString;
	    }
	    // container object to create pvp data
	    var pvpItems = [];
	    var pvpRuns = pvp.runs;
	    var pvpBalls = pvp.balls;
	    // Push runs and balls to array if not empty
	    if (typeof pvpRuns !== 'undefined') {
	      pvpItems.push(pvpRuns);
	    }
	    if (typeof pvpBalls !== 'undefined') {
	      pvpItems.push('(' + pvpBalls + 'b)');
	    }
	    // Create string if array is not empty
	    if (pvpItems.length !== 0) {
	      pvpString = pvpItems.join('');
	    }
	    return pvpString || '-';
	  },
	
	
	  /**
	   * Get standings link details
	   * @param  {Object} params      Router params
	   * @param  {Object} query       Router query
	   * @return {Object}             Link title and href
	   */
	  getStandingsLink: function getStandingsLink() {
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var leagueId = params.leagueId || params.league;
	    var link = {
	      title: 'Full Table',
	      trackingName: _common.common.createTrackingName([params.sport, 'game', params.pageType, 'fullstandings'])
	    };
	
	    if (leagueId) {
	      link.href = _common.common.createHref((0, _extends3.default)({ query: query }, params, { pageType: 'table' }));
	    }
	
	    return link;
	  },
	
	
	  /**
	   * get Debutants
	   * @param  {Array}  debutsNode debut node
	   * @param  {Object} params router params
	   * @return {Array}             list of debuts
	   */
	  getDebutants: function getDebutants() {
	    var debutsNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    // default return debutants list array
	    var debutants = [];
	    // Iterate over debutsNode and get each rosters
	    debutsNode.map(function () {
	      var d = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      // Iterate over rosters and get the information on each debutans
	      var debutRoster = d.roster || [];
	      debutRoster.map(function () {
	        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        var athleteNode = e && e.athlete;
	        var dimg = (0, _selectn2.default)('flag.href', athleteNode) || '';
	        var athleteLinkText = helpers.getAthleteLinkText(athleteNode);
	        // Append debut players information to debutants list array
	        debutants.push({
	          name: (0, _selectn2.default)('displayName', athleteNode) || '',
	          img: '',
	          href: _common.common.extractUrl(athleteNode, athleteLinkText, 'desktop'),
	          trackingName: _common.common.createTrackingName([params.sport, 'game', params.pageType, 'player']),
	          imgicon: _common.common.resizeCombinerLogo(dimg, { w: 25, h: 25 })
	        });
	      });
	    });
	    return debutants;
	  },
	
	
	  /**
	   * Get displayable value for a ball. This is used in both recent overs and
	   * bbb commentary.
	   *
	   * @param  {Object} item commentary item
	   * @return {String}      value for that ball ({0 to 6}lb,nb,b,wd)
	   */
	  getBallValue: function getBallValue() {
	    var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	
	    // Set default value to runs scored on this ball
	    var eventValue = item.scoreValue;
	
	    var dismissal = (0, _selectn2.default)('dismissal.dismissal', item) ? true : false;
	    // If there is wicket, set value to W and return.
	    if (dismissal === true) {
	      eventValue = 'W';
	      //console.info('getBallValue', eventValue)
	      return eventValue;
	    }
	
	    // Get data from over object which has extra runs information
	    var over = item.over || {};
	
	    // Extract lookup for extra runs
	    var extraDetails = helpers.getAllExtras() || {};
	    var whichExtras = extraDetails.allExtras;
	    var numExtras = whichExtras.length;
	
	    /**
	     * Iterate over required extra stats, check if current ball has an extra
	     * run assoicated with it. If it has, show in format of
	     * number of runs + extra abbreviation e.g. 1w, 1nb, 1wd
	     */
	    for (var i = 0; i < numExtras; i++) {
	      var currentExtra = whichExtras[i] || {};
	      var extraName = currentExtra.name;
	      var extraAbbr = currentExtra.abbreviation;
	      if (over.hasOwnProperty(extraName)) {
	        var extraRuns = over[extraName];
	        if (extraRuns > 0) {
	          //eventValue = `${extraRuns}${extraAbbr}`
	          eventValue = '' + eventValue + extraAbbr;
	        }
	      }
	    }
	    //console.info('getBallValue', eventValue)
	    return eventValue;
	  },
	
	
	  /**
	   * split details into recent n overs
	   * @param  {Array}  details - details node
	   * @param {Number}  currentPeriod - current period being played
	   * @return {Array}          overs
	   */
	  getRecentOvers: function getRecentOvers() {
	    var details = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var currentPeriod = arguments[1];
	
	    var currentOver = 0;
	    var recentOvers = [];
	    var over = [];
	
	    details.map(function (detail) {
	      var currentBall = '';
	
	      // skip if previous innings
	      if (detail.period !== currentPeriod) {
	        return;
	      }
	
	      if (currentOver !== detail.over.number) {
	        currentOver = detail.over.number;
	        over = [];
	        recentOvers.push(over);
	      }
	      currentBall = helpers.getBallValue(detail);
	      over.push(currentBall);
	    });
	    //console.info('recentOvers', recentOvers)
	    return recentOvers;
	  },
	
	
	  /**
	   * Get player roles
	   * @param  {Object} p player details object
	   * @return {String}   captain or wicket keeper or both
	   */
	  getPlayerRoles: function getPlayerRoles() {
	    var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    // Add provision for multiple roles for a player (e.g. captain, keeper)
	    var playerRoles = [];
	    var playerRolesString = '';
	
	    // check if keeper is captain
	    if (p.captain) {
	      playerRoles.push('(c)');
	    }
	
	    /**
	     * Check if player is wicket keeper
	     * Wicket keeper position id is present in either player.keeper or
	     * player.position.id so check in both.
	     */
	    // Valid wicket keeper position ids
	    var validKeeperIds = ['WK', 'WBT'];
	    // Get position id for the player
	    var positionId = (0, _selectn2.default)('position.id', p) || '';
	    // Check for both properties
	    if (validKeeperIds.indexOf(positionId) > -1 || (0, _common2.isPropertyTruthy)(p, 'keeper')) {
	      playerRoles.push('&dagger;');
	    }
	    // Concatenate roles if any
	    if (playerRoles.length !== 0) {
	      playerRolesString = playerRoles.join(' ');
	    }
	    //console.info('playerRolesString', playerRolesString)
	    return playerRolesString;
	  },
	
	
	  /**
	   * Get details of other team which will bat in second innings
	   * @param  {Object} otherTeam details of other team
	   * @return {Object} details   object with props name & players.
	   *                            Name is name of team batting second
	   *                            players is an array containing all players
	   */
	  getOtherTeamDetails: function getOtherTeamDetails() {
	    var otherTeam = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    //console.info('otherTeam', otherTeam)
	    // Default data structure to return
	    var details = {
	      name: '',
	      players: []
	      // If other team does not have team roster available, return default
	    };if (otherTeam.hasOwnProperty('roster') === false) {
	      return details;
	    }
	    // Extract name of the team which will bat in second innings
	    var name = (0, _selectn2.default)('team.displayName', otherTeam) || '';
	    // Get the lineup
	    var lineup = otherTeam.roster || [];
	
	    var numOtherPlayers = lineup.length;
	    // prep return data structure
	    var players = [];
	    // Iterate over players and get the information on each player
	    for (var i = 0; i < numOtherPlayers; i++) {
	      var player = lineup[i];
	      var athleteRole = (0, _selectn2.default)('position.name', player);
	      var athleteLinkText = helpers.getAthleteLinkText(player.athlete);
	      if (typeof athleteRole === 'undefined' || athleteRole === 'Unknown') {
	        athleteRole = '';
	      }
	      var info = {
	        name: (0, _selectn2.default)('athlete.displayName', player),
	        athleteRole: athleteRole,
	        href: _common.common.extractUrl(player.athlete, athleteLinkText, 'desktop'),
	        captain: player.captain,
	        roles: helpers.getPlayerRoles(player)
	        // Append to players
	      };players.push(info);
	    }
	    details = { name: name, players: players
	      //console.info('getOtherTeamDetails', details)
	    };return details;
	  },
	
	
	  /**
	   * Function to pick link text based on API value for athlete links
	   * @param {Object} athlete athlete node from rosters
	   * @return {String} as Player Card or Player Profile
	   */
	  getAthleteLinkText: function getAthleteLinkText(athlete) {
	    var linkText = (0, _selectn2.default)('links[0].text', athlete) || 'Player Profile';
	    return linkText;
	  },
	
	
	  /**
	   * get ordered innings
	   * @param  {Array}  rosters Rosters node
	   * @param  {Array}  allInnings  details of all innings
	   * @param  {Number} currentPeriod current innings
	   * @param  {String} gameState  game state
	   * @param  {Object} matchFlags    flags for this match
	   * @param  {Object} params  contains params for the page like pagename, sport etc
	   * @param  {Object} device gives device info
	   * @param {Number} stateTypeId gives state type Id which indicates match state. 5 if it is abandoned
	   * @return {Object}         ordered innings
	   */
	  getOrderedInnings: function getOrderedInnings() {
	    var rosters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var allInnings = arguments[1];
	    var currentPeriod = arguments[2];
	    var gameState = arguments[3];
	    var matchFlags = arguments[4];
	    var params = arguments[5];
	    var device = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
	    var stateTypeId = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 1;
	
	    var teamA = (0, _selectn2.default)('[0]', rosters) || [];
	    var teamB = (0, _selectn2.default)('[1]', rosters) || [];
	    var showSquads = false;
	    //console.info('teamA, teamB', teamA, teamB)
	    /**
	     * Placeholders to get details for other team i.e. team which will bat in
	     * second innings. These details should be populated only when first
	     * innings is live
	     */
	    var otherTeam = {};
	    var otherTeamDetails = {};
	    //console.info('allInnings', allInnings)
	    //console.info('\ncurrentPeriod, gameState', currentPeriod, gameState)
	    // Remaining batsmen text should be set to did not bat / yet to bat
	    var remainingBatsmen = void 0;
	    var notBatted = 'Did not bat';
	    var notBattedYet = 'Yet to bat';
	    // If match is over, show did not bat
	    if (gameState === 'final') {
	      remainingBatsmen = notBatted;
	    }
	
	    var battingStatMap = {
	      runs: { text: 'R', index: 0 },
	      ballsFaced: { text: 'B', index: 1 },
	      minutes: { text: 'M', index: 2 },
	      fours: { text: '4s', index: 3 },
	      sixes: { text: '6s', index: 4 },
	      strikeRate: { text: 'SR', index: 5 }
	    };
	
	    var bowlingStatMap = {
	      overs: { text: 'O', index: 0 },
	      maidens: { text: 'M', index: 1 },
	      conceded: { text: 'R', index: 2 },
	      wickets: { text: 'W', index: 3 },
	      economyRate: { text: 'Econ', index: 4 }
	      // 0s, 4s and 6s should be shown only for limited over matches.
	    };if (matchFlags.limitedOvers === true) {
	      bowlingStatMap.dots = { text: '0s', index: 5 };
	      bowlingStatMap.foursConceded = { text: '4s', index: 6 };
	      bowlingStatMap.sixesConceded = { text: '6s', index: 7 };
	    }
	
	    var bowlingStatIdx = matchFlags.limitedOvers === true ? 8 : 5;
	    if (device.desktop == true) {
	      bowlingStatMap.wides = { text: 'WD', index: bowlingStatIdx }, bowlingStatMap.noballs = { text: 'NB', index: bowlingStatIdx + 1 };
	    }
	    var innings = {};
	
	    [teamA, teamB].map(function (team) {
	      // Cache current team's ID
	      var currentTeamId = (0, _selectn2.default)('team.id', team);
	      var roster = team.roster || [];
	      roster.map(function () {
	        var roster = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { linescores: [] };
	
	        //console.info('team.roster', roster)
	        var isStarter = roster.starter;
	        //console.info('athlete, starter', roster.athlete.displayName, isStarter)
	        var linescoresLen = roster.linescores.length || 0;
	        roster.linescores.map(function (l) {
	          var inning = l.period;
	          var idx = inning - 1;
	          // Get id of the team which was batting in this innings
	          var battingTeamId = (0, _selectn2.default)('[' + idx + '].teamId', allInnings);
	          /**
	           * If currentPeriod is 1, other team is yet to Bat, so show full
	           * squad. If batting team id is not equal to current iterating team,
	           * we are in second team so equate that to other team.
	           */
	          //console.info('battingTeamId, currentTeamId', battingTeamId, currentTeamId)
	          if (currentPeriod == 1 && battingTeamId !== currentTeamId) {
	            otherTeam = team;
	          }
	          /**
	           * If innings is 1 and match state is abandoned (5) then
	           *  other team player details need to be shown. Same logic as innings break
	           */
	          if ((stateTypeId == 4 || stateTypeId == 5) && linescoresLen == 1 && battingTeamId !== currentTeamId) {
	            otherTeam = team;
	          }
	          // Get title for the innings
	          var inningsTitle = (0, _selectn2.default)('[' + idx + '].title', allInnings) || 'Innings';
	          // Get stats for this innings
	          var inningStats = (0, _selectn2.default)('[' + idx + '].stats', allInnings) || {};
	          // Get fall of wickets for this innings
	          var inningFows = (0, _selectn2.default)('[' + idx + '].fows', allInnings) || [];
	          //console.info('inning, idx, battingTeamId', inning, idx, battingTeamId)
	          var inningStatus = (0, _selectn2.default)('[' + idx + '].inningStatus', allInnings) || '';
	          innings[inning] = innings[inning] || {};
	          // Init properties for the final object
	          innings[inning].title = inningsTitle;
	          innings[inning].inningStatus = inningStatus;
	          innings[inning].isCurrent = (0, _selectn2.default)('[' + idx + '].isCurrent', allInnings) || false;
	          innings[inning]['batsmen'] = innings[inning]['batsmen'] || [];
	          innings[inning]['bowlers'] = innings[inning]['bowlers'] || [];
	          innings[inning]['didNotBat'] = innings[inning]['didNotBat'] || [];
	          innings[inning]['absent'] = innings[inning]['absent'] || [];
	          var statistics = (0, _selectn2.default)('statistics', l);
	          var battingOrder = (0, _selectn2.default)('batting.order', statistics);
	          var bowlingOrder = (0, _selectn2.default)('bowling.order', statistics);
	          var statsNode = (0, _selectn2.default)('categories[0].stats', statistics);
	          // Create a map of stats for easier lookup
	          var namedStats = _common.common.createStatsMap(statsNode);
	          // Array index is period/inning-1
	          var currentLinescores = (0, _selectn2.default)('linescores[' + idx + ']', roster) || {};
	          // hasVideoId flag checks if a player has video associated
	          var athleteLinkText = helpers.getAthleteLinkText(roster.athlete);
	          var athleteDisplayName = (0, _selectn2.default)('athlete.displayName', roster);
	          var athleteName = (0, _selectn2.default)('athlete.battingName', roster) || athleteDisplayName;
	          var player = {
	            name: athleteName,
	            displayName: athleteDisplayName,
	            href: _common.common.extractUrl(roster.athlete, athleteLinkText, 'desktop'),
	            captain: roster.captain,
	            roles: helpers.getPlayerRoles(roster),
	            trackingName: params.sport && params.pageType ? _common.common.createTrackingName([params.sport, 'game', params.pageType, 'player']) : '',
	            hasVideoId: false
	            // Check if this player has video id associated with it
	          };var hasVideoId = typeof (0, _selectn2.default)('media.id', currentLinescores) !== 'undefined' ? true : false;
	          // If video is available, set video details on player object & update flag
	          if (hasVideoId === true) {
	            player.hasVideoId = true;
	            player.videoId = (0, _selectn2.default)('media.id', currentLinescores);
	            player.video = currentLinescores.media || {};
	          }
	
	          //Check if any player absent hurt
	          var absentHurt = (0, _selectn2.default)('absentDescription.displayValue', namedStats) == 'absent' ? true : false;
	          if (battingOrder) {
	            player.stats = _common.common.filterStatsByNames(statsNode, battingStatMap);
	            // Check if player is not out
	            var isNotOut = (0, _selectn2.default)('statistics.batting.outDetails.dismissalCard', currentLinescores) === 'not out' ? true : false;
	            // Add flag on player object to detect not out
	            player.isNotOut = isNotOut;
	            //console.info('player %s is not out? %s', player.name, isNotOut)
	            player.commentary = (0, _selectn2.default)('statistics.batting.outDetails.details.text', currentLinescores) || '';
	            player.runningScore = (0, _selectn2.default)('statistics.batting.outDetails.details.innings', currentLinescores) || {};
	            player.runningOver = (0, _selectn2.default)('statistics.batting.outDetails.details.over', currentLinescores) || {};
	            // Pick how out dismissal string as is from feed
	            player.shortText = (0, _selectn2.default)('statistics.batting.outDetails.shortText', currentLinescores) || '';
	
	            // Array index is order-1
	            innings[inning]['batsmen'][battingOrder - 1] = player;
	          }
	
	          if (absentHurt === true) {
	            player.shortText = 'absent hurt';
	            innings[inning]['absent'].push(player);
	          }
	
	          // Has this player batted in this innings?
	          var hasBatted = (0, _selectn2.default)('batted.displayValue', namedStats) == '1' ? true : false;
	          //console.info('%s has batted in innings #%s?', player.name, inning, hasBatted)
	          /**
	           * Populate did not bat array only if current team id (iterator)
	           * matches with team that has batted in this innings and
	           * player's hasBatted property is false and
	           * player has started the match i.e. he is not a substitute
	           */
	          if (currentTeamId == battingTeamId && hasBatted === false && isStarter === true && absentHurt === false) {
	            innings[inning]['didNotBat'].push(player);
	          }
	          if (bowlingOrder) {
	            player.stats = _common.common.filterStatsByNames(statsNode, bowlingStatMap);
	            innings[inning]['bowlers'][bowlingOrder - 1] = player;
	          }
	          if (currentTeamId == battingTeamId) {
	            innings[inning].total = helpers.getInningsTotal(inningStats, matchFlags, true);
	            innings[inning].extras = helpers.getExtras(inningStats);
	            innings[inning].fows = inningFows;
	          }
	          //hides extras, total row for forfeited innings
	          if (inningStatus === 'forfeit') {
	            innings[inning].total = '';
	            innings[inning].extras = '';
	            innings[inning].fows = '';
	          }
	
	          /**
	           * Set text for remaining batsmen in case match state is not final.
	           * If live innings, display yet to bat.
	           * For older innings, display did not bat
	           */
	          if (gameState !== 'final') {
	            remainingBatsmen = inning === currentPeriod ? notBattedYet : notBatted;
	            //console.info('inning=%s currentPeriod=%s remainingBatsmen=%s' , inning, currentPeriod, remainingBatsmen)
	          }
	          innings[inning].remainingBatsmen = remainingBatsmen;
	          innings[inning].headerInfo = helpers.inningsHeaderInfo(allInnings[idx], inning, matchFlags) || '';
	        });
	      });
	    });
	    //following code will checkif any of the stats is not available
	    // for all the players to avoid empty column in the stats table
	    for (var key in innings) {
	      var batsmen = (0, _selectn2.default)('[' + key + '].batsmen', innings);
	      var bowlers = (0, _selectn2.default)('[' + key + '].bowlers', innings);
	      innings[key].batsmenKeys = helpers.checkIfStatsAreValid(battingStatMap, batsmen) || {};
	      innings[key].bowlerKeys = helpers.checkIfStatsAreValid(bowlingStatMap, bowlers) || {};
	    }
	
	    if ((0, _keys2.default)(innings).length === 0) {
	      showSquads = true;
	    }
	    //console.info('innings', innings)
	    // Get details of the other team
	    otherTeamDetails = helpers.getOtherTeamDetails(otherTeam);
	    return { innings: innings, otherTeamDetails: otherTeamDetails, showSquads: showSquads };
	  },
	
	  /**
	  * Innings header info text
	  * @param  {Object}  inning innings details as object
	  * @param  {Number}  idx innings number
	  * @param  {Object}  matchFlags match flags details
	  * @return {String}  header info
	  */
	  inningsHeaderInfo: function inningsHeaderInfo(inning, idx, matchFlags) {
	    var inningsHeaderInfo = '',
	        headInfo1 = {},
	        headInfo2 = {},
	        headInfo3 = {},
	        headInfo4 = {},
	        headInfo1Text = '',
	        headInfo2Text = '',
	        headInfo3Text = '',
	        headInfo4Text = '',
	        oversLabel = '',
	        inningStatus = '',
	        inningStatusDesc = '';
	
	    if (matchFlags.limitedOvers === true) {
	      headInfo1.value = (0, _selectn2.default)('stats.all.overLimit.displayValue', inning) || '';
	      headInfo2.value = (0, _selectn2.default)('stats.all.target.displayValue', inning) || '';
	      if (!headInfo1.value) {
	        return inningsHeaderInfo;
	      }
	
	      headInfo1.description = (0, _selectn2.default)('stats.all.overs.displayName', inning) || '';
	      headInfo2.description = (0, _selectn2.default)('stats.all.target.displayName', inning) || '';
	      headInfo1.value = headInfo1.value ? parseFloat(headInfo1.value) : '';
	      headInfo2.value = headInfo2.value ? parseInt(headInfo2.value, 10) : '';
	
	      oversLabel = headInfo2.value < 2 ? 'run' : 'runs';
	
	      headInfo1Text = '(' + headInfo1.value + ' ' + headInfo1.description + ' maximum)';
	      headInfo1Text = headInfo1Text.toLowerCase();
	
	      if (headInfo1.value && headInfo2.value) {
	        headInfo2Text = '(' + headInfo2.description + ': ' + headInfo2.value + ' ' + oversLabel + ' from ' + headInfo1.value + ' ' + headInfo1.description + ')';
	        headInfo2Text = headInfo2Text.toLowerCase();
	      }
	    } else if (matchFlags.isTestMatch === true) {
	
	      headInfo3.value = (0, _selectn2.default)('stats.brief.followOn', inning);
	      headInfo4.value = (0, _selectn2.default)('stats.all.target.displayValue', inning);
	      headInfo4.value = headInfo4.value ? parseInt(headInfo4.value, 10) : '';
	      headInfo4.description = (0, _selectn2.default)('stats.all.target.displayName', inning) || '';
	      inningStatus = (0, _selectn2.default)('inningStatus', inning) || '';
	      inningStatusDesc = (0, _selectn2.default)('inningStatusDesc', inning) || '';
	
	      headInfo3Text = headInfo3.value === 1 ? '(following on)' : '';
	
	      oversLabel = headInfo4.value < 2 ? 'run' : 'runs';
	      if (headInfo4.value) {
	        headInfo4Text = '(' + headInfo4.description + ': ' + headInfo4.value + ' ' + oversLabel + ')';
	        headInfo4Text = headInfo4Text.toLowerCase();
	      }
	    }
	
	    switch (idx) {
	
	      //case 1: 1st innings max overs
	      case 1:
	        inningsHeaderInfo = headInfo1Text;
	        break;
	      //case 2: 2nd innings target and max overs
	      case 2:
	        inningsHeaderInfo = headInfo2Text;
	        break;
	      //case 3: 3rd if followon yes
	      case 3:
	        inningsHeaderInfo = headInfo3Text;
	        break;
	      //case 4: 4th target text with no overs
	      case 4:
	        inningsHeaderInfo = headInfo4Text;
	        break;
	    }
	    if (matchFlags.isTestMatch === true) {
	      if (inningStatus === 'forfeit') {
	        inningsHeaderInfo = inningsHeaderInfo + ' (' + inningStatusDesc + ')';
	      }
	    }
	    return inningsHeaderInfo;
	  },
	
	
	  /**
	   * Get information on fall of wicket
	   * fall of wicket = runs/wicket num (overs ov)   *
	   * @param  {Array}  allFows all fall of wickets
	   * @return {String}         fowString
	   */
	  getLastFOWDetails: function getLastFOWDetails() {
	    var allFows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    // default values for fall of wicket & last wicket (last out player)
	    var fowString = '';
	    // Proceed only if fall of wickets exists
	    if (allFows.length > 0) {
	      var numWickets = allFows.length;
	      var lastFow = allFows[numWickets - 1] || {};
	      // Extract fall of wicket details
	      if (lastFow.hasOwnProperty('wicketNumber') && lastFow.hasOwnProperty('runs')) {
	        var fow = [lastFow.runs, lastFow.wicketNumber].join('/');
	        fowString = fow;
	        // Append over data if available
	        if (lastFow.hasOwnProperty('wicketOver')) {
	          fowString = fow + ' (' + lastFow.wicketOver + ' ov)';
	        }
	      }
	    }
	    //console.info('getLastFOWDetails', fowDetails)
	
	    return fowString;
	  },
	
	
	  /**
	   * get last Bat Info by comparing currentInningsFows and rosters
	   * eg: lastBat = Saqlain Haider c SF Burger b Williams 29 (125m 100b 1x4 0x6) SR: 29.00
	   * @param {Object} currentInnings current Innings Info
	   * @param {Object} rostersNode complete rosters node
	   * @returns {String} lastBatInfo
	   */
	  getLastBatInfo: function getLastBatInfo() {
	    var currentInnings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var rostersNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var currPeriod = currentInnings.period || '';
	    var currBatTeam = currentInnings.teamId || '';
	    var rosters = [];
	    var rawFows = currentInnings.rawFows || [];
	    //do the rest if atleast one fow exists
	    if (!rawFows.length) {
	      return '';
	    }
	    var lastFow = rawFows[rawFows.length - 1] || {};
	    var lastFowId = (0, _selectn2.default)('athlete.id', lastFow) || '';
	    var lastFowInfo = {};
	    if (currPeriod && currBatTeam) {
	      //get current batting team rosters
	      for (var i = 0; i < rostersNode.length; i++) {
	        var teamId = (0, _selectn2.default)('[' + i + '].team.id', rostersNode) || '';
	        if (teamId == currBatTeam) {
	          rosters = (0, _selectn2.default)('[' + i + '].roster', rostersNode);
	        }
	      }
	    }
	    //get lastfow player's roster
	    if (rosters.length && lastFowId) {
	      lastFowInfo = _common.common.getPlayerById(rosters, lastFowId);
	    }
	    var linescore = (0, _selectn2.default)('linescores[' + (currPeriod - 1) + ']', lastFowInfo) || {};
	    var athleteName = (0, _selectn2.default)('athlete.displayName', lastFowInfo);
	    // build lastBat markup using linescore of lastFow taken from rosters node
	    var lastBatMarkup = helpers.getLastBatMarkup(linescore, athleteName) || '';
	    return lastBatMarkup;
	  },
	
	  /**
	   * helper to reduce complexity framing lastFow markup
	   * @param {Object} linescore linescores taken from roster node
	   * @param {String} athlete athlete name for whom lastfowMarkup is being constructed
	   * @returns {String} full markup of lastFow
	   */
	  getLastBatMarkup: function getLastBatMarkup() {
	    var linescore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var athlete = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	    var outDetail = '';
	    var lastBatMarkup = '';
	    var stats = {};
	    if (athlete.length) {
	      outDetail = (0, _selectn2.default)('statistics.batting.outDetails.shortText', linescore) || '';
	      var categories = (0, _selectn2.default)('statistics.categories[0].stats', linescore) || [];
	      for (var i = 0; i < categories.length; i++) {
	        var iCat = categories[i] || {};
	        switch (iCat.name) {
	          case 'minutes':
	            stats.mins = iCat.displayValue ? iCat.displayValue + 'm' : '';
	            break;
	          case 'runs':
	            stats.runs = iCat.displayValue || '';
	            break;
	          case 'ballsFaced':
	            stats.balls = iCat.displayValue ? iCat.displayValue + 'b' : '';
	            break;
	          case 'fours':
	            stats.fours = iCat.displayValue ? iCat.displayValue + 'X4' : '';
	            break;
	          case 'sixes':
	            stats.sixes = iCat.displayValue ? iCat.displayValue + 'X6' : '';
	            break;
	          case 'strikeRate':
	            stats.sr = iCat.displayValue ? 'SR: ' + iCat.displayValue : '';
	            break;
	        }
	      }
	      lastBatMarkup = athlete + ' ' + outDetail + ' ' + (stats.runs || '') + ' ';
	      lastBatMarkup += '(' + (stats.mins || '') + ' ' + (stats.balls || '') + ' ' + (stats.fours || '') + ' ' + (stats.sixes || '') + ') ' + (stats.sr || '');
	    }
	    return lastBatMarkup;
	  },
	
	  /**
	   * Get last partnership information
	   * It frames markup like " 20 runs, 7.5 overs, RR: 2.55 (Sharma 18, Pandya 2) "
	   * @param  {Array}  allPships all partnerships from innings
	   * @return {String}           runs scored and overs taken for last partnership
	   */
	  getLastPship: function getLastPship() {
	    var allPships = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    // default string to return
	    var pshipMrkp = '';
	    // Proceed only if partnerships array exists
	    if (allPships.length > 0) {
	      var numPships = allPships.length;
	      // Get last node for latest partnership
	      var lastPship = allPships[numPships - 1] || {};
	      var pshipRuns = lastPship.hasOwnProperty('runs') ? lastPship.runs + ' ' + (lastPship.runs == 1 ? 'run' : 'runs') : '';
	      var pshipRR = lastPship.hasOwnProperty('runRate') ? 'RR: ' + lastPship.runRate : '';
	      var pshipOvers = lastPship.hasOwnProperty('overs') ? lastPship.overs + ' overs' : '';
	      var pshipPlayer1 = (0, _selectn2.default)('batsmen[0].athlete.displayName', lastPship);
	      var pshipPlayer1Runs = (0, _selectn2.default)('batsmen[0].runs', lastPship) || '';
	      var pshipPlayer2 = (0, _selectn2.default)('batsmen[1].athlete.displayName', lastPship);
	      var pshipPlayer2Runs = (0, _selectn2.default)('batsmen[1].runs', lastPship) || '';
	      pshipMrkp += pshipRuns + ', ' + pshipOvers + ', ' + pshipRR + ' ';
	      if (pshipPlayer1 && pshipPlayer2) {
	        pshipMrkp += '(' + pshipPlayer1 + ' ' + pshipPlayer1Runs + ', ' + pshipPlayer2 + ' ' + pshipPlayer2Runs + ')';
	      }
	    }
	    return pshipMrkp;
	  },
	
	
	  /**
	   * Get runs scored in last N overs for an innings.
	   * recentOvers and runInRecentOvers are available only for live innings
	   *
	   * @param  {Object} innings innings object from all innings
	   * @return {Object}         showModule: show this module or not
	   *                          duration : pick up value from feed, usually 5/10
	   *                          runs: number of runs scored in this duration
	   */
	  getLastNForInnings: function getLastNForInnings() {
	    var innings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    // default return object
	    var lastNForInnings = {
	      showModule: true,
	      duration: (0, _selectn2.default)('stats.all.recentOvers.displayValue', innings) || '',
	      runs: (0, _selectn2.default)('stats.all.runInRecentOvers.displayValue', innings) || '',
	      wickets: (0, _selectn2.default)('stats.all.wicketInRecentOvers.displayValue', innings) || '',
	      rr: (0, _selectn2.default)('stats.all.runRateInRecentOvers.displayValue', innings) || ''
	      // if either of duration or runs is empty string, do now show this module
	    };if (lastNForInnings.duration == '' || lastNForInnings.runs == '' || lastNForInnings.wickets == '') {
	      lastNForInnings.showModule = false;
	    }
	    return lastNForInnings;
	  },
	  getCurrentInnings: function getCurrentInnings() {
	    var competition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var details = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	    var rostersNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	    var allInnings = arguments[3];
	    var sessionInfo = arguments[4];
	    var gameState = arguments[5];
	    var params = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
	    var host = arguments[7];
	    var matchFlags = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : {};
	    var device = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : {};
	
	    // First get active players. Then split them in active batsmen & bowlers
	    var currentPeriod = helpers.getCurrentPeriod(competition);
	    var recentOvers = helpers.getRecentOvers(details, currentPeriod);
	    var activePlayers = _common.common.getActivePlayers(rostersNode);
	    var activeBatsmen = helpers.getActivePlayersByRole(activePlayers, 'batting', currentPeriod);
	    var activeBowlers = helpers.getActivePlayersByRole(activePlayers, 'bowling', currentPeriod);
	    var idx = currentPeriod - 1;
	    //console.info('activeBatsmen', activeBatsmen)
	    //console.info('activeBowlers', activeBowlers)
	    var showFullStats = device.desktop === true || device.tablet === true;
	    var currentInnings = helpers.getCurrentInningsDetails(allInnings);
	    var crr = (0, _selectn2.default)('stats.all.runRate.displayValue', currentInnings) || '';
	
	    // Return crr if current innings and active players data is not found (required as gp2.0 design)
	    if (typeof currentInnings.period === 'undefined' || activePlayers.length === 0) {
	      return {
	        sessionInfo: sessionInfo,
	        crr: crr
	      };
	    }
	
	    var playerTrackingName = _common.common.createTrackingName([params.sport, 'game', params.pageType, 'player']);
	    //console.info('playerTrackingName', playerTrackingName)
	
	    // Prep data structure for current players
	    var activePlayerStats = {
	      batsmen: {
	        player1: {
	          href: '#',
	          name: '',
	          stats: [],
	          trackingName: playerTrackingName
	        },
	        player2: {
	          href: '#',
	          name: '',
	          stats: [],
	          trackingName: playerTrackingName
	        }
	      },
	      bowlers: {
	        player1: {
	          href: '#',
	          name: '',
	          stats: [],
	          trackingName: playerTrackingName
	        },
	        player2: {
	          href: '#',
	          name: '',
	          stats: [],
	          trackingName: playerTrackingName
	        }
	      }
	
	      // For Batsman table: limited overs - Last 5 ovs. For tests - Last 10 ovs.
	    };var lastN = 5;
	    var lastNOvers = 'Last ' + lastN + ' ovs';
	
	    var numActiveBatsmen = activeBatsmen.length;
	    var numActiveBowlers = activeBowlers.length;
	
	    // set default values for featurephone current players
	    var liteBatsmen = [];
	    var liteBowlers = [];
	
	    // loop over batmen and extract required stats
	    for (var i = 0; i < numActiveBatsmen; i++) {
	      var batsman = activeBatsmen[i];
	      // Suffix * to batsmen display name since batsman is on strike - e.g. Sachin Tendulkar*
	      var isStriker = batsman.activeName === 'striker' ? true : false;
	      var target = activePlayerStats.batsmen['player' + (i + 1)] || {};
	      var athleteName = (0, _selectn2.default)('athlete.name', batsman);
	      var athleteDisplayName = (0, _selectn2.default)('athlete.battingName', batsman) || (0, _selectn2.default)('athlete.displayName', batsman);
	      var athleteLinkText = helpers.getAthleteLinkText(batsman.athlete);
	
	      target.name = isStriker === true ? athleteName + '*' : athleteName;
	      target.displayName = isStriker === true ? athleteDisplayName + '*' : athleteDisplayName;
	      target.playerId = (0, _selectn2.default)('athlete.id', batsman);
	      target.href = _common.common.extractUrl(batsman.athlete, athleteLinkText, 'desktop');
	      // Batting style is in style[0]
	      var playerStyle = (0, _selectn2.default)('athlete.style[0].shortDescription', batsman) || '';
	      if (playerStyle !== '' && typeof playerStyle === 'string') {
	        playerStyle = playerStyle.toLowerCase();
	      }
	      target.style = playerStyle;
	
	      var _runs = (0, _selectn2.default)('combinedStats.all.runs.displayValue', batsman) || '';
	      var _ballsFaced = (0, _selectn2.default)('combinedStats.all.ballsFaced.displayValue', batsman) || '';
	      var _fours = (0, _selectn2.default)('combinedStats.all.fours.displayValue', batsman) || '';
	      var _sixes = (0, _selectn2.default)('combinedStats.all.sixes.displayValue', batsman) || '';
	      var _strikeRate = (0, _selectn2.default)('combinedStats.all.strikeRate.displayValue', batsman) || '';
	
	      // Create an array of required stats
	      target.stats = [_runs, _ballsFaced, _fours, _sixes, _strikeRate];
	
	      if (showFullStats) {
	        target.stats = target.stats.concat([helpers.getPVP((0, _selectn2.default)('combinedStats.brief.pvp', batsman)), helpers.getPVP((0, _selectn2.default)('combinedStats.brief.battingRecent', batsman)), (0, _selectn2.default)('combinedStats.career.matches.displayValue', batsman) || '', (0, _selectn2.default)('combinedStats.career.runs.displayValue', batsman) || '', (0, _selectn2.default)('combinedStats.career.highScore.displayValue', batsman) || '', (0, _selectn2.default)('combinedStats.career.battingAverage.displayValue', batsman) || '']);
	      }
	
	      lastN = (0, _selectn2.default)('combinedStats.brief.battingRecent.overSpan', batsman) || '';
	      lastNOvers = 'Last ' + lastN + ' ovs';
	      // Check if this player has video id associated with it
	      var batVideoId = typeof (0, _selectn2.default)('linescores[' + idx + '].media.id', batsman) !== 'undefined' ? true : false;
	      //console.info('batVideoId', batVideoId)
	      // If video is available, set video details on player object & update flag
	      if (batVideoId === true) {
	        target.hasVideoId = true;
	        target.videoId = (0, _selectn2.default)('linescores[' + idx + '].media.id', batsman);
	        target.video = batsman.media || {};
	      }
	      // Stats for featurephone
	      var liteStats = {
	        playerid: target.playerId,
	        name: target.name,
	        style: target.style,
	        stats: [{ text: 'R', value: _runs }, { text: 'B', value: _ballsFaced }, { text: '4S', value: _fours }, { text: '6S', value: _sixes }, { text: 'SR', value: _strikeRate }]
	      };
	      liteBatsmen.push(liteStats);
	    }
	
	    // loop over bowlers and extract required stats
	    for (var j = 0; j < numActiveBowlers; j++) {
	      var bowler = activeBowlers[j];
	      //console.info('bowler', bowler)
	      var _target = activePlayerStats.bowlers['player' + (j + 1)] || {};
	      _target.name = (0, _selectn2.default)('athlete.name', bowler);
	      _target.displayName = (0, _selectn2.default)('athlete.battingName', bowler) || (0, _selectn2.default)('athlete.displayName', bowler);
	      _target.playerId = (0, _selectn2.default)('athlete.id', bowler);
	      var _athleteLinkText = helpers.getAthleteLinkText(bowler.athlete);
	      _target.href = _common.common.extractUrl(bowler.athlete, _athleteLinkText, 'desktop');
	
	      // Bowling style
	      var playerStyleArray = (0, _selectn2.default)('athlete.style', bowler) || [];
	      var _playerStyle = '';
	      //usually one bowler has one batting style and one bowling style
	      //Added for the case: if a bowler has more than one bowling style like for player Tendai Chisoro(id: "235519")
	      if (playerStyleArray.length > 2) {
	        (function () {
	          var bowlerStyleMap = [];
	          playerStyleArray.map(function () {
	            var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	            var _s$type = s.type,
	                bowlerStyleType = _s$type === undefined ? '' : _s$type,
	                _s$shortDescription = s.shortDescription,
	                bowlerStyleTypeDesc = _s$shortDescription === undefined ? '' : _s$shortDescription;
	
	            if (bowlerStyleTypeDesc && bowlerStyleType && bowlerStyleType === 'bowling') {
	              bowlerStyleMap.push(bowlerStyleTypeDesc);
	            }
	          });
	          _playerStyle = bowlerStyleMap.join('/');
	        })();
	      } else {
	        _playerStyle = (0, _selectn2.default)('athlete.style[1].shortDescription', bowler) || '';
	      }
	      if (_playerStyle !== '' && typeof _playerStyle === 'string') {
	        _playerStyle = _playerStyle.toLowerCase();
	      }
	      _target.style = _playerStyle;
	
	      var _overs = (0, _selectn2.default)('combinedStats.all.overs.displayValue', bowler) || '';
	      var _maidens = (0, _selectn2.default)('combinedStats.all.maidens.displayValue', bowler) || '0';
	      var _conceded = (0, _selectn2.default)('combinedStats.all.conceded.displayValue', bowler) || '';
	      var _wickets = (0, _selectn2.default)('combinedStats.all.wickets.displayValue', bowler) || '';
	      var _economyRate = (0, _selectn2.default)('combinedStats.all.economyRate.displayValue', bowler) || '';
	
	      // Create an array of required stats
	      _target.stats = [_overs, _maidens, _conceded, _wickets, _economyRate];
	
	      if (showFullStats) {
	        _target.stats = _target.stats.concat([(0, _selectn2.default)('combinedStats.all.dots.displayValue', bowler) || '-', (0, _selectn2.default)('combinedStats.all.foursConceded.displayValue', bowler) || '-', (0, _selectn2.default)('combinedStats.all.sixesConceded.displayValue', bowler) || '-', helpers.getSpellDetails((0, _selectn2.default)('combinedStats.brief.currentSpell', bowler)), (0, _selectn2.default)('combinedStats.career.matches.displayValue', bowler) || '', (0, _selectn2.default)('combinedStats.career.wickets.displayValue', bowler) || '', (0, _selectn2.default)('combinedStats.career.bestBowlingFigures.displayValue', bowler) || '', (0, _selectn2.default)('combinedStats.career.bowlingAverage.displayValue', bowler) || '']);
	      }
	
	      // Check if this player has video id associated with it
	      var bowlVideoId = typeof (0, _selectn2.default)('linescores[' + idx + '].media.id', bowler) !== 'undefined' ? true : false;
	      //console.info('bowlVideoId', bowlVideoId)
	      // If video is available, set video details on player object & update flag
	      if (bowlVideoId === true) {
	        _target.hasVideoId = true;
	        _target.videoId = (0, _selectn2.default)('linescores[' + idx + '].media.id', bowler);
	        _target.video = bowler.media || {};
	      }
	
	      // Stats for featurephone
	      var _liteStats = {
	        playerid: _target.playerId,
	        name: _target.name,
	        style: _target.style,
	        stats: [{ text: 'O', value: _overs }, { text: 'M', value: _maidens }, { text: 'R', value: _conceded }, { text: 'W', value: _wickets }, { text: 'ECON', value: _economyRate }]
	      };
	      liteBowlers.push(_liteStats);
	    }
	
	    //console.info('liteBatsmen', liteBatsmen)
	    //console.info('liteBowlers', liteBowlers)
	    //const lastOver = details[0] || { batsman:{}, otherBatsman:{}, bowler:{}, otherBowler:{} }
	
	    // Get last wicket, fall of wicket and current partnership details
	    var lastFowInfo = helpers.getLastFOWDetails(currentInnings.rawFows);
	    var partnership = helpers.getLastPship(currentInnings.rawPartnerships);
	    var lastNForInnings = helpers.getLastNForInnings(currentInnings);
	    var reviews = helpers.getReviews(competition);
	    var generalClassCard = void 0;
	    var lastBatInfo = helpers.getLastBatInfo(currentInnings, rostersNode);
	    var innings = {
	      heading: currentInnings.title || '',
	      sessionInfo: sessionInfo,
	      crr: crr,
	      rrr: (0, _selectn2.default)('stats.all.requiredRunRate.displayValue', currentInnings) || '',
	      minRemainingOvers: (0, _selectn2.default)('stats.all.remainingOvers.displayValue', currentInnings) || '',
	      lastNForInnings: lastNForInnings,
	      lastBat: lastBatInfo,
	      reviews: reviews,
	      fow: lastFowInfo,
	      partnership: partnership,
	      activePlayers: activePlayers,
	      players: {
	        batsmen: {
	          keys: [{ id: 'R' }, { id: 'B' }, { id: '4s', className: 'u-tt-l' }, { id: '6s', className: 'u-tt-l' }, { id: 'SR' }],
	          list: [activePlayerStats.batsmen.player1, activePlayerStats.batsmen.player2]
	        },
	        bowlers: {
	          keys: [{ id: 'O' }, { id: 'M' }, { id: 'R' }, { id: 'W' }, { id: 'Econ' }],
	          list: [activePlayerStats.bowlers.player1, activePlayerStats.bowlers.player2]
	        }
	      },
	      liteBatsmen: liteBatsmen,
	      liteBowlers: liteBowlers
	    };
	
	    if (showFullStats) {
	      generalClassCard = (0, _selectn2.default)('class.generalClassCard', competition) || '';
	
	      if (typeof generalClassCard === 'string') {
	        generalClassCard = generalClassCard.toUpperCase() + ' CAREER';
	      }
	
	      // Append batsmen live-career data
	      innings.players.batsmen.keys = innings.players.batsmen.keys.concat([{ id: 'This Bowler', colspan: '3' }, { id: lastNOvers, className: 'col-highlight' }, { id: 'mat' }, { id: 'runs' }, { id: 'hs' }, { id: 'ave' }]);
	
	      // Append bowler live-career data
	      innings.players.bowlers.keys = innings.players.bowlers.keys.concat([{ id: '0s', className: 'u-tt-l' }, { id: '4s', className: 'u-tt-l' }, { id: '6s', className: 'u-tt-l' }, { id: 'This Spell', className: 'col-highlight' }, { id: 'mat' }, { id: 'wkts' }, { id: 'bbi' }, { id: 'ave' }]);
	    }
	
	    return (0, _extends3.default)({ recentOvers: recentOvers }, innings, { generalClassCard: generalClassCard, showFullStats: showFullStats });
	  },
	
	
	  /**
	    * Join players name & style - e.g. Sachin Tendulkar (rhb)
	    * @param  {string} playerName  player name
	    * @param  {string} playerStyle player style
	    * @return {string}             playerJoinString
	    */
	  getPlayerDisplayName: function getPlayerDisplayName() {
	    var playerName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var playerStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	    // Default return value should be name of player
	    var playerDisplayName = playerName;
	    // Array to hold name & style
	    var display = [];
	    // Push name only if it is not empty
	    if (playerName !== '') {
	      display.push(playerName);
	    }
	    // Push formatted style only if it is not empty
	    if (playerStyle !== '' && typeof playerStyle === 'string') {
	      // Convert to lowercase
	      var lcStyle = playerStyle.toLowerCase();
	      display.push('(' + lcStyle + ')');
	    }
	    // Update displayable only if display array is not empty
	    if (display.length !== 0) {
	      playerDisplayName = display.join(' ');
	    }
	    return playerDisplayName;
	  },
	
	  /**
	   * Forms an array of current batsmen and bowlers
	   * @param  {Object} rosters rosters node
	   * @param  {Object} period   innings period
	   * @return {Array}        current batsmen and bowlers
	   */
	  getCurrentPlayersIds: function getCurrentPlayersIds() {
	    var rosters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var period = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	    var batsmen = [];
	    var bowlers = [];
	
	    rosters.map(function (r) {
	      var activeName = r.activeName || '';
	      var playerId = (0, _selectn2.default)('athlete.id', r);
	      switch (activeName) {
	        case 'striker':
	          batsmen.unshift({ playerId: playerId, period: period });
	          break;
	
	        case 'non-striker':
	          batsmen.push({ playerId: playerId, period: period });
	          break;
	
	        case 'current bowler':
	          bowlers.unshift({ playerId: playerId, period: period });
	          break;
	
	        case 'previous bowler':
	          bowlers.push({ playerId: playerId, period: period });
	          break;
	      }
	    });
	    return { bowlers: bowlers, batsmen: batsmen };
	  },
	
	
	  /**
	   * Get best players from a match (across all innings).
	   * Pick up 2 best bowlers and 2 best batmen.
	   *
	   * @param  {Array}  leadersNode leaders node from feed
	   * @return {Object}             object with list of 2 batsmen and bowlers
	   */
	  getBestPlayersFromMatch: function getBestPlayersFromMatch() {
	    var leadersNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    //console.info('getBestPlayersFromMatch, leadersNode', leadersNode)
	
	    // Default return type
	    var batsmen = [];
	    var bowlers = [];
	    // Store list of all top players in these arrays
	    var allBatters = [];
	    var allBowlers = [];
	
	    var numLeaders = leadersNode.length;
	
	    // Iterate over leaders node and extract top players
	    for (var i = 0; i < numLeaders; i++) {
	      var team = leadersNode[i];
	      var ls = team.linescores || [];
	      var numLS = ls.length;
	      // Iterate over each linescore. it could be either batting/bowling
	      for (var j = 0; j < numLS; j++) {
	        var batOrBowl = ls[j] || {};
	        // In which period this performance happened?
	        var period = batOrBowl.period || '';
	        // Get all(3) top players for each innings
	        var players = (0, _selectn2.default)('leaders[0].leaders', batOrBowl) || [];
	        // If top players are found and isBatting property exists
	        if (players.length !== 0 && batOrBowl.hasOwnProperty('isBatting')) {
	          // Store for easier lookup
	          var pushTo = [];
	          // Append a player to batters array if isBatting is true
	          if (batOrBowl.isBatting === true) {
	            pushTo = allBatters;
	          }
	          // Append a player to bowlers array if isBatting is false
	          if (batOrBowl.isBatting === false) {
	            pushTo = allBowlers;
	          }
	          // Iterate over best players and append them to allBatters/allBowlers
	          for (var k = 0; k < players.length; k++) {
	            var player = players[k] || {};
	            var playerId = (0, _selectn2.default)('athlete.id', player);
	            /**
	             * Append to array only if player id is found.
	             * Also set a period property which will be used by other functions
	             */
	            if (typeof playerId !== 'undefined') {
	              //console.info('player', player)
	              player.period = period;
	              pushTo.push(player);
	            }
	          }
	        }
	      }
	    }
	
	    /**
	     * If top batsmen and bowler arrays are not empty, sort them on order key
	     * Then get the first 2 elements (since top 2 batman and bowlers need to be
	     * shown)
	     */
	    if (allBatters.length !== 0) {
	      allBatters.sort(_common.common.compareEntities('order'));
	      batsmen = allBatters.slice(0, 2);
	    }
	
	    if (allBowlers.length !== 0) {
	      allBowlers.sort(_common.common.compareEntities('order'));
	      bowlers = allBowlers.slice(0, 2);
	    }
	
	    return { batsmen: batsmen, bowlers: bowlers };
	  },
	
	
	  /**
	   * Get athlete ids and periods of best batsmen and bowlers
	   * @param  {Object} bestPlayers object with batsmen and bowlers arrays
	   * @return {Object}             players object with batsmen & bowlers array
	   */
	  getBestPlayersIds: function getBestPlayersIds() {
	    var bestPlayers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    // default return type
	    var players = {
	      batsmen: [],
	      bowlers: []
	      // Iterate over best players and get the player ids.
	    };for (var bb in bestPlayers) {
	      // bb should be either batsmen or bowlers
	      if (bestPlayers.hasOwnProperty(bb) === false || players.hasOwnProperty(bb) === false) {
	        continue;
	      }
	      // batsmen/bowlers array
	      var batOrBowl = bestPlayers[bb];
	      var numPlayers = batOrBowl.length;
	      // loop over players and extract player id and respective period of play
	      for (var i = 0; i < numPlayers; i++) {
	        var player = batOrBowl[i];
	        var playerId = (0, _selectn2.default)('athlete.id', player);
	        var period = (0, _selectn2.default)('period', player);
	        if (playerId !== undefined) {
	          players[bb].push({ playerId: playerId, period: period });
	        }
	      }
	    }
	    //console.info('players', players)
	    return players;
	  },
	
	
	  /**
	   * Get team details of an athlete.
	   * Create a map to lookup athlete ids to their team objects.
	   * @param  {Array}  rosters rosters node
	   * @return {Object}         keys are athlete ids, value is team object
	   */
	  getTeamOfAthletes: function getTeamOfAthletes() {
	    var rosters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    // default return value
	    var athleteToTeam = {};
	
	    var numRosters = rosters.length;
	    // Iterate over rosters of both the teams
	    for (var j = 0; j < numRosters; j++) {
	      var team = rosters[j].team || {};
	      var teamRoster = rosters[j].roster || [];
	      // iterate over each player and populate object
	      for (var k = 0; k < teamRoster.length; k++) {
	        var athlete = teamRoster[k];
	        var athleteId = (0, _selectn2.default)('athlete.id', athlete);
	        if (typeof athleteId !== 'undefined') {
	          athleteToTeam[athleteId] = team;
	        }
	      }
	    }
	    return athleteToTeam;
	  },
	
	
	  /**
	   * Get all statistics of an innings from linescores node
	   * @param  {Object} inputStats linescores node
	   * @return {Object}            stats.brief = top level stats
	   *                             stats.all = statistics array converted to map
	   */
	  getInningsStats: function getInningsStats() {
	    var inputStats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    // default stats to return
	    var stats = {
	      all: {},
	      brief: {}
	      //console.info('inputStats', inputStats)
	
	      // Get all detailed stats
	    };var allStats = (0, _selectn2.default)('statistics.categories[0].stats', inputStats) || {};
	    stats.all = _common.common.createStatsMap(allStats);
	
	    // Iterate over top level stats and populate brief node
	    for (var k in inputStats) {
	      // cache value
	      var v = inputStats[k];
	      // Skip any properties containing an object
	      if (v instanceof Object === false) {
	        stats.brief[k] = v;
	      }
	    }
	    //console.info('stats', stats)
	    return stats;
	  },
	
	
	  /**
	   * Get fall of wickets
	   * @param  {Object} inn Innings object
	   * @return {Array}     fall of wickets in array format.
	   *                     Each item in array is string of format
	   *                     wicket num - runs on which wicket fell (player
	   *                     who got out, overs at which player got out)
	   */
	  getInningsFOW: function getInningsFOW() {
	    var inn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    //console.info('inn', inn)
	    var fows = [];
	    // Return empty array if fall of wickets is not found
	    if (inn.hasOwnProperty('fow') === false) {
	      return fows;
	    }
	    // declare default strings
	    var wicketRuns = '';
	    var playerOvers = '';
	    // Extract fall of wickets node
	    var fowickets = inn.fow || [];
	    var numFOW = fowickets.length;
	    // iterate over each of fall of wicket and prep the required string.
	    for (var i = 0; i < numFOW; i++) {
	      var fow = fowickets[i];
	      var fowType = fow.fowType || '';
	      if (fow.hasOwnProperty('wicketNumber') === false) {
	        continue;
	      }
	      // Get #wicket fallen and runs on scoreboard
	      var wicketNum = fow.wicketNumber;
	      var runs = fow.runs;
	      // If runs is undefined, make runs as empty string
	      if (typeof runs === 'undefined') {
	        runs = '';
	      }
	      if (parseInt(runs) > 0 && fowType !== 'out') {
	        runs = runs + '*';
	      }
	      // Join on - only if wicketNum is not falsy and runs is not empty
	      if (wicketNum) {
	        wicketRuns = [wicketNum, runs].join('-');
	        //console.info('wicketRuns', wicketRuns)
	      }
	      // Get name of batsman who got out and overs
	      var player = (0, _selectn2.default)('athlete.displayName', fow) || '';
	      var overs = fow.wicketOver || '';
	
	      // Join on , only if player name is not empty
	      if (player !== '') {
	        playerOvers = '' + player + (fowType == 'out' ? overs ? ', ' + overs + ' ov' : '' : fowType.length ? ', ' + fowType : '');
	      }
	      // If player & over details are missing, push only wicket/run otherwise push both to fall of wickets array
	      if (wicketRuns !== '') {
	        if (playerOvers !== '') {
	          fows.push(wicketRuns + ' (' + playerOvers + ')');
	        } else {
	          fows.push('' + wicketRuns);
	        }
	      }
	    }
	    //console.info('fows', fows)
	    return fows;
	  },
	
	
	  /**
	   * Get array of all innings
	   * @param  {Object}   competition   competitors and other details
	   * @param  {Object}   params        router params
	   * @param  {Object}   query         router query
	   * @param  {Boolean}  detailedStats true if all stats for this innings are required
	   * @param  {Object}   matchFlags    flags for this match
	   * @param  {Object}   hrefConfig    config object for create href function
	   * @return {Array}                   Details of each innings
	   */
	  getAllInnings: function getAllInnings() {
	    var competition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var detailedStats = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	    var matchFlags = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	    var hrefConfig = arguments[5];
	
	    var allInnings = [];
	    // Return empty array If competitors array is missing
	    if (competition.hasOwnProperty('competitors') === false) {
	      return allInnings;
	    }
	    var innText = 'Innings';
	    // default delimiter for innings related strings
	    var delimiter = ' ';
	    var competitors = competition.competitors;
	    competitors.map(function (competitor) {
	      var teamAbbreviation = (0, _selectn2.default)('team.abbreviation', competitor);
	      var teamDisplayName = (0, _selectn2.default)('team.displayName', competitor);
	      var teamId = (0, _selectn2.default)('team.id', competitor);
	
	      /**
	       * Construct the string for a team in innings dropdown
	       * For limited over matches, it should be teamName Innings
	       * For non limited over matches, it should be teamName 1st/2nd Innings
	       */
	      var innNum = '';
	      //console.info('competitor', competitor)
	      // Create a clone before modifying the original Array
	      var linescores = competitor && Array.isArray(competitor.linescores) ? competitor.linescores.slice(0) : [];
	      // reordering linescores
	      linescores = linescores.sort(function (a, b) {
	        return a.period - b.period;
	      });
	      if (matchFlags.limitedOvers === false) {
	        innNum = '1st';
	      }
	      linescores.map(function (score) {
	        // Used to build team name & team innings string
	        var teamInn = [teamAbbreviation];
	        // Use this to construct full string - team name nth Innings
	        var inningsTitle = [teamDisplayName];
	        // Use this to construct innings display - nth Innings
	        var inningsDesc = [innText];
	        var period = parseInt(score.period, 10);
	        // Build all innings array only if period is positive integer and team is batting
	        if (score.isBatting === true && period >= 0) {
	          if (period >= 3) {
	            innNum = '2nd';
	          }
	          // Do not append if inn num is empty string (for limited over matches)
	          if (innNum !== '') {
	            teamInn.push(innNum);
	            inningsTitle.push(innNum);
	            inningsDesc.unshift(innNum);
	          }
	          teamInn.push(innText);
	          inningsTitle.push(innText);
	          // Join the teamInn array on space char
	          var linkName = teamInn.join(delimiter);
	          // Full innings title
	          var inningsTitleString = inningsTitle.join(delimiter);
	          // construct url for innings commentary
	          var baseUrl = '#';
	          var linkUrl = '#';
	          var matchId = 'gameId' in params ? parseInt(params.gameId, 10) : '';
	          var leagueId = 'league' in params ? parseInt(params.league, 10) : '';
	          if (matchId !== '' && leagueId !== '') {
	
	            linkUrl = _common.common.createHref((0, _extends3.default)({}, params, hrefConfig, { pageType: 'commentary', query: { innings: period, filter: query.filter, 'edition-host': query['edition-host'] } }));
	            baseUrl = _common.common.createHref((0, _extends3.default)({}, params, hrefConfig, { pageType: 'commentary', query: { innings: period, 'edition-host': query['edition-host'] } }));
	          }
	          // Create info object for this innings
	          var innDetails = {
	            period: period,
	            teamName: teamAbbreviation,
	            teamDisplayName: teamDisplayName,
	            innDisplayName: inningsDesc.join(delimiter),
	            teamId: teamId,
	            text: linkName,
	            name: linkName,
	            href: linkUrl,
	            baseUrl: baseUrl,
	            title: inningsTitleString,
	            isCurrent: score.isCurrent == 1 ? true : false,
	            stats: {}
	            // Get all stats for this innings if detailedStats flag is true
	          };if (detailedStats === true) {
	            innDetails.stats = helpers.getInningsStats(score);
	            innDetails.fows = helpers.getInningsFOW(score);
	            innDetails.rawFows = score.fow || [], innDetails.rawPartnerships = score.partnerships || [];
	          }
	          if (score.score === 'forfeit') {
	            innDetails.inningStatus = score.score;
	            innDetails.inningStatusDesc = score.description;
	          } else if (score.description === 'declared') {
	            innDetails.inningStatus = 'declared';
	            innDetails.inningStatusDesc = score.description;
	          }
	          allInnings.push(innDetails);
	        }
	      });
	    });
	
	    // Sort the innings on the period key
	    allInnings.sort(function (inn1, inn2) {
	      if (inn1.hasOwnProperty('period') && inn2.hasOwnProperty('period')) {
	        if (inn1.period > inn2.period) {
	          return 1;
	        }
	        if (inn1.period < inn2.period) {
	          return -1;
	        }
	      }
	      // By default, keep them as is
	      return 0;
	    });
	    return allInnings;
	  },
	
	
	  /**
	   * Get innings which will be selected in the innings dropdown filter
	   * @param  {Array}  allInnings  details of all innings
	   * @param  {Array}  cmtryInns   details of commentary innings
	   * @param  {Object} query       request query
	   * @param  {Object} showSuperOver flag to check if super over
	   * @return {String}             innings which will be selected
	   */
	  getSelectedInnings: function getSelectedInnings() {
	    var allInnings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var cmtryInns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	    var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var showSuperOver = arguments[3];
	
	    // Default to latest element from the allInnings array
	    var selectedInnings = allInnings[allInnings.length - 1] || {};
	
	    if (showSuperOver) {
	      selectedInnings = cmtryInns[cmtryInns.length - 1];
	      return selectedInnings;
	    }
	
	    // Check if User has requested any particular innings
	    if (query.hasOwnProperty('innings') && /^superover$/ig.test(query.innings) === false) {
	      var period = query.innings;
	      //console.info('period', period)
	      // Map required for allInnings array lookup
	      var periodToInnings = {
	        '1': 0,
	        '2': 1,
	        '3': 2,
	        '4': 3
	        // Number of available innings
	      };var totalInnings = allInnings.length;
	      // Proceed only if requested period is valid
	      if (periodToInnings.hasOwnProperty(period)) {
	        var innings = periodToInnings[period];
	        // Make sure the requested innings falls in the total innings of match
	        if (innings <= totalInnings) {
	          selectedInnings = allInnings[innings] || {};
	        }
	      }
	    }
	    //console.info('selectedInnings', selectedInnings)
	    return selectedInnings;
	  },
	  getLeadersId: function getLeadersId() {
	    var leadersNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    var leaders = (0, _selectn2.default)('[0].leaders', leadersNode) || [];
	    var playersId = [];
	
	    // Pick the first 2 players
	    leaders.slice(0, 2).map(function (leader) {
	      var id = (0, _selectn2.default)('athlete.id', leader);
	      if (id) playersId.push(id);
	    });
	
	    return playersId;
	  },
	  getLeadersData: function getLeadersData() {
	    var players = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var statMap = arguments[1];
	    var period = arguments[2];
	
	    var leadersData = [];
	
	    (0, _keys2.default)(players).map(function (b) {
	
	      var currentPlayer = players[b];
	      var linescores = currentPlayer.linescores || [];
	      var athleteLinkText = helpers.getAthleteLinkText(currentPlayer.athlete);
	      linescores.map(function (l) {
	        if (l.period !== period) {
	          return;
	        }
	        var href = _common.common.extractUrl(currentPlayer.athlete, athleteLinkText, 'desktop');
	        var statsNode = (0, _selectn2.default)('statistics.categories[0].stats', l) || [];
	        var stats = !statMap ? statsNode : _common.common.createStatsMap(_common.common.filterStatsByNames(statsNode, statMap));
	
	        leadersData.push({
	          name: (0, _selectn2.default)('athlete.displayName', currentPlayer),
	          href: href,
	          stats: stats
	        });
	      });
	    });
	
	    return leadersData;
	  },
	
	
	  /**
	   * Build the innings dcropdown for commentary
	   *
	   * @param {Array} allInnings  all the innings
	   * @param {Array} tieBreaker  tiebreaker arrary
	   * @param {Object} params     params
	   * @param {Object} hrefConfig href config
	   * @returns {Array} commenatryInnings
	   */
	  getCmtryInns: function getCmtryInns() {
	    var allInnings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var tieBreaker = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	    var params = arguments[2];
	    var hrefConfig = arguments[3];
	
	    var innings = [].concat((0, _toConsumableArray3.default)(allInnings));
	
	    if (tieBreaker.length > 0) {
	      innings.push({
	        text: 'Super Over',
	        href: _common.common.createHref((0, _extends3.default)({}, params, hrefConfig, { pageType: 'commentary', query: { innings: 'superover' } }))
	      });
	    }
	
	    return innings;
	  },
	
	
	  /**
	   * build filter dropdown data for commentary
	   * @param  {Object} selInnings selected innings
	   * @return {Array}             array of dropdown item
	   */
	  getCmtryFilter: function getCmtryFilter(selInnings) {
	    // innings hyperlink of selected inngings
	    var innBaseUrl = (0, _selectn2.default)('baseUrl', selInnings) || '';
	    var stats = (0, _selectn2.default)('stats.brief', selInnings) || {};
	    var _stats$wickets = stats.wickets,
	        wickets = _stats$wickets === undefined ? 0 : _stats$wickets,
	        _stats$fours = stats.fours,
	        fours = _stats$fours === undefined ? 0 : _stats$fours,
	        _stats$sixes = stats.sixes,
	        sixes = _stats$sixes === undefined ? 0 : _stats$sixes;
	
	    var filterItems = [];
	
	    // add full commentary as first filter
	    filterItems.push({
	      text: 'Full commentary',
	      playtype: 'full',
	      href: innBaseUrl + '&filter=full'
	    });
	
	    // add 'wicket' filter item if any wickets
	    if (wickets > 0) {
	      filterItems.push({
	        text: 'Wickets',
	        playtype: 'wickets',
	        href: innBaseUrl + '&filter=wickets'
	      });
	    }
	
	    // add 'boundaries' filter item if 4's / 6's
	    if (fours + sixes > 0) {
	      filterItems.push({
	        text: 'Boundary',
	        playtype: 'boundary',
	        href: innBaseUrl + '&filter=boundary'
	      });
	    }
	
	    filterItems.push({
	      text: 'Highlights',
	      playtype: 'highlight',
	      href: innBaseUrl + '&filter=highlight'
	    });
	    return filterItems;
	  },
	
	
	  /**
	   * select current filter for based on query-string or default
	   * @param  {Array}  cmtryFilter array of filters
	   * @param  {Object} query       router query
	   * @return {Object}             selected filter
	   */
	  getSelCmtryFilter: function getSelCmtryFilter() {
	    var cmtryFilter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    // select full commentary by default
	    var filter = query.filter || 'full';
	    var selFilter = void 0;
	
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = (0, _getIterator3.default)(cmtryFilter), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var item = _step.value;
	
	        // select the current filter based router query
	        if (item.playtype === filter) {
	          selFilter = item;
	          break;
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    return selFilter;
	  },
	  getMetaData: function getMetaData(params) {
	    var competition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var gameStrip = arguments[2];
	    var matchDetails = arguments[3];
	    var standings = arguments[4];
	    var gameState = arguments[5];
	    var league = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
	    var matchDescription = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
	    var matchTitle = arguments[8];
	    var matchLink = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : '';
	    var edition = arguments[10];
	    var season = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : {};
	    var hrefConfig = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : {};
	    var article = arguments[13];
	    var isTournament = arguments[14];
	    var leagueName = arguments[15];
	    var slugOfLeague = arguments[16];
	
	    var meta = {};
	
	    var date = competition.date;
	    var dateValid = date ? new Date(date) : null;
	    date = (0, _momentTimezone2.default)(dateValid).format('D MMM, YYYY');
	    var matchYear = (0, _momentTimezone2.default)(dateValid).format('YYYY');
	    var teams = gameStrip.teams || {};
	    var homeTeam = teams.home || {};
	    var homeTeamName = homeTeam.name || '';
	    var awayTeam = teams.away || {};
	    var awayTeamName = awayTeam.name || '';
	    var seasonYear = (0, _selectn2.default)('year', season) || '';
	    var _params$sport = params.sport,
	        sport = _params$sport === undefined ? '' : _params$sport,
	        _params$pageType = params.pageType,
	        pageType = _params$pageType === undefined ? '' : _params$pageType;
	
	    var articleImage = (0, _selectn2.default)('images[0].url', article) || '';
	    // team abbreviations
	    var homeTeamAbbr = (0, _selectn2.default)('home.abbrev', teams) || '';
	    var awayTeamAbbr = (0, _selectn2.default)('away.abbrev', teams) || '';
	    var leagueAbbr = league.abbreviation || '';
	    var matchNum = competition.description || ' ';
	    var matchWinner = homeTeam.winner === 'true' ? homeTeamName : awayTeamName;
	    var matchLoser = homeTeam.winner === 'false' ? homeTeamName : awayTeamName;
	    var matchSummary = competition.status.summary || '';
	    var matchName = competition.name;
	    var fullScoreWithTitle = competition.title;
	
	    // If abbreviation is not found, set abbreviation to team name
	    if (homeTeamAbbr === '') {
	      homeTeamAbbr = homeTeamName;
	    }
	    if (awayTeamAbbr === '') {
	      awayTeamAbbr = awayTeamName;
	    }
	
	    var matchDataForMeta = {
	      fullScore: fullScoreWithTitle,
	      homeTeamName: homeTeamName,
	      homeTeamAbbr: homeTeamAbbr,
	      awayTeamName: awayTeamName,
	      awayTeamAbbr: awayTeamAbbr,
	      matchNum: matchNum,
	      matchSummary: matchSummary,
	      gameState: gameState,
	      seasonYear: seasonYear,
	      leagueName: leagueName,
	      leagueAbbr: leagueAbbr,
	      isTournament: isTournament,
	      matchWinner: matchWinner,
	      matchLoser: matchLoser,
	      matchName: matchName,
	      matchYear: matchYear
	    };
	
	    var gamepackageMetaObject = _metahelpers2.default.getGamePackageMetaObject(matchDataForMeta, pageType, edition);
	
	    var newSlug = _common.common.getSlugFromUrl(params.gameId, matchLink);
	    // Additional info required by Native APP
	    meta.gameId = competition.id || '';
	    meta.gameState = (0, _selectn2.default)('status.type.state', competition) || '';
	    meta.leagueId = league.id || '';
	    meta.leagueUID = league.uid || '';
	    meta.leagueName = league.name || '';
	    meta.leagueSlug = slugOfLeague || '';
	    meta.matchDescription = matchDescription;
	    meta.sport = sport;
	    meta.title = gamepackageMetaObject.titleText;
	    meta.description = gamepackageMetaObject.metaDescriptionText;
	    meta.keywords = gamepackageMetaObject.metaKeywordsText;
	    meta.canonical = _common.common.createCanonical(edition, params, hrefConfig, newSlug);
	    meta.shareurl = meta.canonical;
	    meta.website = 'article';
	    meta.shortTitle = homeTeamAbbr + ' vs ' + awayTeamAbbr;
	    meta.competitionUID = competition.uid || '';
	    meta.image = articleImage || 'https://a.espncdn.com/combiner/i?img=/i/espn/espn_logos/espncricinfo.png';
	
	    return meta;
	  },
	  isHidden: function isHidden(_ref) {
	    var _ref$standingsNode = _ref.standingsNode,
	        standingsNode = _ref$standingsNode === undefined ? {} : _ref$standingsNode,
	        _ref$article = _ref.article,
	        article = _ref$article === undefined ? {} : _ref$article,
	        _ref$partCommentary = _ref.partCommentary,
	        partCommentary = _ref$partCommentary === undefined ? {} : _ref$partCommentary,
	        _ref$statistics = _ref.statistics,
	        statistics = _ref$statistics === undefined ? {} : _ref$statistics,
	        _ref$videos = _ref.videos,
	        videos = _ref$videos === undefined ? [] : _ref$videos,
	        _ref$matchCoverage = _ref.matchCoverage,
	        matchCoverage = _ref$matchCoverage === undefined ? [] : _ref$matchCoverage,
	        _ref$hawkEye = _ref.hawkEye,
	        hawkEye = _ref$hawkEye === undefined ? {} : _ref$hawkEye;
	
	
	    var previewAvailable = false;
	    var reportAvailable = false;
	
	    if (article.type === 'Preview') {
	      if (article.id) {
	        previewAvailable = true;
	      }
	    }
	
	    if (article.type === 'Recap' || article.type === 'Report') {
	      if (article.id) {
	        reportAvailable = true;
	      }
	    }
	    return {
	      preview: !previewAvailable,
	      report: !reportAvailable,
	      commentary: !partCommentary.enabled,
	      statistics: !statistics.enabled,
	      video: !videos.length,
	      coverage: !matchCoverage.length,
	      table: !(0, _keys2.default)(standingsNode).length,
	      hawkeye: !hawkEye.show
	    };
	  },
	
	  /**
	   * Logic to determine if polling should be enabled
	   * for the game
	   * @param  {String} date      competition.date
	   * @param  {String} gameState game state
	   * @return {Object}           Polling details
	   */
	  shouldPoll: function shouldPoll(date, gameState) {
	    var duration = 20000;
	    var durationInSec = duration / 1000;
	    var enabled = false;
	
	    if (gameState === 'live') {
	      enabled = true;
	    }
	    var startTime = _momentTimezone2.default.utc(new Date());
	    var endTime = (0, _momentTimezone2.default)(date);
	    var diff = endTime.diff(startTime, 'hours');
	    // console.log(startTime.format(), endTime.format(), diff)
	    // TODO: update logic
	    // polling 12 hours, before and after the game
	    if (Math.abs(diff) <= 12) {
	      enabled = true;
	    }
	    return { enabled: enabled, duration: duration, durationInSec: durationInSec };
	  },
	  isRosterAvailable: function isRosterAvailable() {
	    var rostersNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    var teamA = (0, _selectn2.default)('[0].roster', rostersNode) || [];
	    var teamB = (0, _selectn2.default)('[1].roster', rostersNode) || [];
	    return teamA.length && teamB.length;
	  },
	
	
	  /**
	   * Get DRS - decision reviews system or umpire reviews data
	   * @param  {Object} competition competition details
	   * @return {Array}             Object with team name and reviews
	   */
	  getReviews: function getReviews() {
	    var competition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    // default return data
	    var drsData = [];
	    var competitors = competition.competitors || [];
	    // iterate over competitors
	    for (var i = 0; i < competitors.length; i++) {
	      var teamInfo = competitors[i] || {};
	      // Skip to next team if linescores are not found
	      if (teamInfo.hasOwnProperty('linescores') === false) {
	        continue;
	      }
	      // Get linescores
	      var linescores = teamInfo.linescores || [];
	      var numLS = linescores.length;
	      for (var j = 0; j < numLS; j++) {
	        var inn = linescores[j] || {};
	        // Append reviews only for current innings
	        if (inn.hasOwnProperty('isCurrent') && inn.isCurrent == 1) {
	          if (inn.hasOwnProperty('reviews')) {
	            /** reviews have this structure
	              {
	                'remaining': '2',
	                'reviewsPermitted': '2',
	                'successful': '1',
	                'unsuccessful': '0'
	              }
	             *
	             **/
	            // Prepare input to default data
	            var input = {
	              name: (0, _selectn2.default)('team.displayName', teamInfo) || '',
	              abbreviation: (0, _selectn2.default)('team.abbreviation', teamInfo) || '',
	              reviews: inn.reviews || {}
	            };
	            drsData.push(input);
	          }
	        }
	      }
	    }
	    //console.info('drsData', drsData)
	    return drsData;
	  },
	  getAnalytics: function getAnalytics() {
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var teams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var gameState = arguments[3];
	    var edition = arguments[4];
	
	    var site = 'cricinfo';
	    var _teams$home = teams.home,
	        home = _teams$home === undefined ? {} : _teams$home,
	        _teams$away = teams.away,
	        away = _teams$away === undefined ? {} : _teams$away;
	
	    var homeTeam = home.name || '';
	    var awayTeam = away.name || '';
	    var gameInfo = homeTeam + ' vs ' + awayTeam;
	    gameInfo = gameInfo && gameInfo.toLowerCase();
	    var isSummary = params.pageType === 'game';
	    var isLive = gameState === 'live';
	    var type = isSummary ? isLive ? 'live' : 'summary' : params.pageType;
	    type = type === 'video' ? 'videos' : type;
	    var contentType = 'game' + (type ? ':' + type : '');
	    var metaSlug = meta.leagueSlug || '';
	    var gameStateProp = 'pre';
	    switch (gameState) {
	      case 'live':
	        gameStateProp = 'in';
	        break;
	      case 'final':
	        gameStateProp = 'post';
	        break;
	    }
	
	    var omniture = {
	      gameState: gameStateProp,
	      pageName: params.sport + ':' + contentType,
	      gameInfo: params.gameId + '+' + gameInfo,
	      eVar44: 'gamepackage',
	      contentType: contentType
	    };
	
	    if (edition.isEspnCricinfo) {
	
	      omniture = {
	        c1: site,
	        gameState: gameStateProp,
	        pageName: gameInfo + ':' + contentType,
	        prop5: metaSlug + ':game',
	        prop26: '' + metaSlug,
	        eVar21: '' + metaSlug,
	        eVar11: 'cricinfo:' + metaSlug + ':game',
	        channel: '' + metaSlug,
	        gameInfo: params.gameId + '+' + gameInfo,
	        contentType: 'match'
	      };
	    }
	
	    var data = {
	      omniture: omniture,
	      chartbeat: {
	        title: meta.title
	      }
	    };
	
	    return data;
	  },
	
	
	  /**
	   * extract markup for dismissalnode from current wicket
	   * @param  {Object}  wicket wicket node from overs node of competition linescores
	   * @return {String}  Formatted markup for current wicket
	   */
	  getWicketStats: function getWicketStats() {
	    var wicket = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    //console.info('wicket', wicket)
	    var allDetails = [];
	    var runDetails = [];
	
	    var shortText = wicket.shortText || '';
	    if (shortText !== '') {
	      allDetails.push(shortText);
	    }
	    var runs = wicket.runs || '';
	    if (runs !== '') {
	      allDetails.push(runs);
	    }
	
	    var minutes = typeof wicket.minutes != 'undefined' ? wicket.minutes : '';
	    if (minutes !== '') {
	      runDetails.push(minutes + 'm');
	    }
	    var ballsFaced = typeof wicket.ballsFaced != 'undefined' ? wicket.ballsFaced : '';
	    if (ballsFaced !== '') {
	      runDetails.push(ballsFaced + 'b');
	    }
	    var fours = typeof wicket.fours != 'undefined' ? wicket.fours : '';
	    if (fours !== '') {
	      runDetails.push(fours + 'x4');
	    }
	    var sixes = typeof wicket.sixes != 'undefined' ? wicket.sixes : '';
	    if (sixes !== '') {
	      runDetails.push(sixes + 'x6');
	    }
	
	    var runsString = '';
	    var finalString = '';
	
	    if (runDetails.length !== 0) {
	      runsString = '(' + runDetails.join(' ') + ')';
	      allDetails.push(runsString);
	    }
	
	    if (allDetails.length !== 0) {
	      finalString = allDetails.join(' ');
	    }
	    //console.info('allDetails', allDetails)
	    //console.info('finalString', finalString)
	    return '<strong> ' + finalString + ' </strong> ';
	  },
	
	
	  /**
	   * Is this team batting in current innings
	   * @param  {Object}  competitor competitor node from competitions
	   * @param  {String} gameState pregame/live/final
	   * @return {Boolean}            true if isBatting and isCurrent are true
	   */
	  isTeamBattingNow: function isTeamBattingNow() {
	    var competitor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var gameState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	    // default return value
	    var isTeamBatting = false;
	    // Cache linescores node
	    var linescores = competitor.linescores || [];
	    // is game live
	    var isLive = gameState === 'live' ? true : false;
	    var numLS = linescores.length;
	    // Iterate over linescores and check isBatting and isCurrent flags
	    for (var i = 0; i < numLS; i++) {
	      var inn = linescores[i];
	      //console.info('inn', inn, inn.isBatting, inn.isCurrent)
	      if (isLive && inn.hasOwnProperty('isBatting') && inn.isBatting == true) {
	        if (inn.hasOwnProperty('isCurrent') && inn.isCurrent == 1) {
	          isTeamBatting = true;
	          // current batting team found so break
	          break;
	        }
	      }
	    }
	    return isTeamBatting;
	  },
	
	  /**
	   * Get spell details of bowler.
	   * @param  {Object} spell Object with keys - overs, maidens, runs and wickets
	   * @return {String}       String in format overs-maidens-runs-wickets
	   */
	  getSpellDetails: function getSpellDetails() {
	    var spell = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    // default spell details
	    var spellDetails = '';
	    var delimiter = '-';
	    // Return default spell If spell is undefined
	    if (typeof spell === 'undefined') {
	      return spellDetails;
	    }
	    var spellStats = [spell.overs, spell.maidens, spell.conceded, spell.wickets];
	    spellDetails = spellStats.join(delimiter);
	    if (/^(.)\1+$/.test(spellDetails)) {
	      spellDetails = '-';
	    }
	    return spellDetails;
	  },
	
	  /**
	   * Get current innings object.
	   * Iterate over all innings array and pickup latest innings where
	   * isCurrent flag is true
	   *
	   * @param  {Array}  allInnings all innings array
	   * @return {Object}            current innings object
	   */
	  getCurrentInningsDetails: function getCurrentInningsDetails() {
	    var allInnings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    var currentInnings = {};
	    for (var i = 0; i < allInnings.length; i++) {
	      var innings = allInnings[i];
	      if (innings.hasOwnProperty('isCurrent') && innings.isCurrent === true) {
	        currentInnings = (0, _assign2.default)({}, innings);
	        break;
	      }
	    }
	    return currentInnings;
	  },
	
	  /**
	   * get scoring source details
	   * @param  {Object} competition competition
	   * @return {Object}             isScoringScource isFeedback, isOptafeed and isDougie
	   */
	  getScoringSource: function getScoringSource() {
	    var competition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var scoringSource = (0, _selectn2.default)('competitors[0].linescores[0].source.description', competition) || '';
	    var isFeedback = false,
	        isOptafeed = false,
	        isDougie = false,
	        isEmma = false;
	    switch (scoringSource.toLowerCase()) {
	      case 'feedback':
	        isFeedback = true;
	        break;
	      case 'optafeed':
	        isOptafeed = true;
	        break;
	      case 'dougie':
	        isDougie = true;
	        break;
	      case 'emma':
	        isEmma = true;
	        break;
	    }
	    return {
	      isFeedback: isFeedback,
	      isOptafeed: isOptafeed,
	      isDougie: isDougie,
	      isEmma: isEmma
	    };
	  },
	
	
	  /**
	   * checks whether a stat is default(-) for all players
	   * @param {Object} statsMap statsMap
	   * @param {Array} players players
	   * @return {Object} statKeys with truthValues
	   */
	  checkIfStatsAreValid: function checkIfStatsAreValid() {
	    var statsMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var players = arguments[1];
	
	    var statKeys = {};
	    for (var key in statsMap) {
	      statKeys[key] = false;
	    }
	    for (var i = 0; i < players.length; i++) {
	      var player = players[i] || {};
	      var stats = player.stats || [];
	      if (helpers.checkTruthsOfStatsMap(statKeys)) {
	        break;
	      } else {
	        for (var _i = 0; _i < stats.length; _i++) {
	          if (stats[_i].value != '-' && typeof statKeys[stats[_i].name] != 'undefined') {
	            statKeys[stats[_i].name] = true;
	          }
	        }
	      }
	    }
	    return statKeys;
	  },
	
	  /**
	  * checks if all the keys of stat map are true to avoid unnecessary loops
	  * @param {Object} statKeys statkeys
	  * @return {Boolean} true/false
	  */
	  checkTruthsOfStatsMap: function checkTruthsOfStatsMap(statKeys) {
	    var truthFlag = true;
	    for (var stat in statKeys) {
	      truthFlag = truthFlag && statKeys[stat];
	    }
	    return truthFlag;
	  }
	};
	exports.default = helpers;

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.metahelpers = undefined;
	
	var _translate = __webpack_require__(833);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var metahelpers = exports.metahelpers = {
	  getGamePackageMetaObject: function getGamePackageMetaObject(matchData, pageType, edition) {
	    var domain = edition.domain || '';
	    var hostInfo = domain.replace('www.', '').replace('espn', 'ESPN');
	    var gamePackageMetaObject = {};
	    var fullScore = matchData.fullScore;
	    var homeTeamName = matchData.homeTeamName;
	    var homeTeamAbbr = matchData.homeTeamAbbr;
	    var awayTeamName = matchData.awayTeamName;
	    var awayTeamAbbr = matchData.awayTeamAbbr;
	    var matchNum = matchData.matchNum;
	    var matchSummary = matchData.matchSummary,
	        matchSummaryText = void 0;
	    var gameState = matchData.gameState;
	    var matchYear = matchData.matchYear;
	    var leagueName = matchData.leagueName;
	    var leagueAbbr = matchData.leagueAbbr;
	    var isTournament = matchData.isTournament;
	    var matchWinner = matchData.matchWinner;
	    var matchLoser = matchData.matchLoser;
	    var matchName = matchData.matchName;
	    var translatedKeyObjectForGamePackage = {};
	
	    var pagetypeLower = pageType.toLowerCase();
	
	    if (isTournament) {
	      switch (pagetypeLower) {
	        case 'game':
	          if (gameState === 'pregame') {
	            translatedKeyObjectForGamePackage = {
	              title: {
	                key: 'meta.title.cricket.multination.gamepackage.game.pre',
	                homeTeamName: homeTeamName,
	                awayTeamName: awayTeamName,
	                leagueName: leagueName,
	                matchYear: matchYear,
	                matchNum: matchNum,
	                domain: hostInfo
	              },
	              description: {
	                key: 'meta.description.cricket.multination.gamepackage.game.pre',
	                homeTeamName: homeTeamName,
	                awayTeamName: awayTeamName,
	                leagueName: leagueName,
	                matchYear: matchYear,
	                matchNum: matchNum,
	                domain: hostInfo
	              }
	            };
	          } else if (gameState === 'live') {
	            translatedKeyObjectForGamePackage = {
	              title: {
	                key: 'meta.title.cricket.multination.gamepackage.game.in',
	                fullScore: fullScore,
	                homeTeamName: homeTeamName,
	                awayTeamName: awayTeamName,
	                leagueName: leagueName,
	                matchYear: matchYear,
	                matchNum: matchNum,
	                domain: hostInfo
	              },
	              description: {
	                key: 'meta.description.cricket.multination.gamepackage.game.in',
	                homeTeamName: homeTeamName,
	                awayTeamName: awayTeamName,
	                leagueName: leagueName,
	                matchYear: matchYear,
	                matchNum: matchNum,
	                domain: hostInfo
	              }
	            };
	          } else {
	            if (matchSummary.indexOf('by') !== -1) {
	              matchSummaryText = matchSummary.substring(matchSummary.indexOf('by'), matchSummary.length);
	              translatedKeyObjectForGamePackage = {
	                title: {
	                  key: 'meta.title.cricket.multination.gamepackage.game.post.result',
	                  matchWinner: matchWinner,
	                  matchLoser: matchLoser,
	                  matchSummaryText: matchSummaryText,
	                  homeTeamName: homeTeamName,
	                  awayTeamName: awayTeamName,
	                  leagueName: leagueName,
	                  matchNum: matchNum,
	                  domain: hostInfo
	                }
	              };
	            } else {
	              translatedKeyObjectForGamePackage = {
	                title: {
	                  key: 'meta.title.cricket.multination.gamepackage.game.post.noresult',
	                  matchSummaryText: matchSummary,
	                  homeTeamName: homeTeamName,
	                  awayTeamName: awayTeamName,
	                  leagueName: leagueName,
	                  matchNum: matchNum,
	                  domain: hostInfo
	                }
	              };
	            } //result match checks end
	            translatedKeyObjectForGamePackage.description = {
	              key: 'meta.description.cricket.multination.gamepackage.game.post',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              leagueName: leagueName,
	              matchYear: matchYear,
	              matchNum: matchNum,
	              domain: hostInfo
	            };
	          } //gameState checks end
	          translatedKeyObjectForGamePackage.keywords = {
	            key: 'meta.keywords.cricket.multination.gamepackage.game',
	            homeTeamName: homeTeamName,
	            awayTeamName: awayTeamName,
	            matchNum: matchNum,
	            matchYear: matchYear,
	            homeTeamAbbr: homeTeamAbbr,
	            awayTeamAbbr: awayTeamAbbr,
	            leagueName: leagueName
	          };
	          break;
	        case 'scorecard':
	          translatedKeyObjectForGamePackage = {
	            title: {
	              key: 'meta.title.cricket.multination.gamepackage.scoreboard',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              leagueName: leagueName,
	              matchYear: matchYear,
	              matchNum: matchNum,
	              domain: hostInfo
	            },
	            description: {
	              key: 'meta.description.cricket.multination.gamepackage.scoreboard',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              leagueName: leagueName,
	              matchYear: matchYear,
	              matchName: matchName,
	              matchNum: matchNum,
	              domain: hostInfo
	            },
	            keywords: {
	              key: 'meta.keywords.cricket.multination.gamepackage.scoreboard',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              matchNum: matchNum,
	              homeTeamAbbr: homeTeamAbbr,
	              awayTeamAbbr: awayTeamAbbr,
	              leagueName: leagueName
	            }
	          };
	          break;
	        case 'commentary':
	          translatedKeyObjectForGamePackage = {
	            title: {
	              key: 'meta.title.cricket.multination.gamepackage.commentary',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              leagueName: leagueName,
	              matchYear: matchYear,
	              matchNum: matchNum,
	              domain: hostInfo
	            },
	            description: {
	              key: 'meta.description.cricket.multination.gamepackage.commentary',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              leagueName: leagueName,
	              matchYear: matchYear,
	              matchNum: matchNum,
	              domain: hostInfo
	            },
	            keywords: {
	              key: 'meta.keywords.cricket.multination.gamepackage.commentary',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              matchNum: matchNum,
	              matchYear: matchYear,
	              homeTeamAbbr: homeTeamAbbr,
	              awayTeamAbbr: awayTeamAbbr,
	              leagueName: leagueName
	            }
	          };
	          break;
	        case 'preview':
	          translatedKeyObjectForGamePackage = {
	            title: {
	              key: 'meta.title.cricket.multination.gamepackage.preview',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              leagueName: leagueName,
	              matchYear: matchYear,
	              matchNum: matchNum,
	              domain: hostInfo
	            },
	            description: {
	              key: 'meta.description.multination.cricket.gamepackage.preview',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              leagueName: leagueName,
	              matchYear: matchYear,
	              matchNum: matchNum,
	              domain: hostInfo
	            },
	            keywords: {
	              key: 'meta.keywords.multination.cricket.gamepackage.preview',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              matchNum: matchNum,
	              homeTeamAbbr: homeTeamAbbr,
	              awayTeamAbbr: awayTeamAbbr,
	              leagueName: leagueName,
	              matchYear: matchYear,
	              leagueAbbr: leagueAbbr
	            }
	          };
	          break;
	        case 'report':
	          translatedKeyObjectForGamePackage = {
	            title: {
	              key: 'meta.title.cricket.multination.gamepackage.report',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              leagueName: leagueName,
	              matchYear: matchYear,
	              matchNum: matchNum,
	              domain: hostInfo
	            },
	            description: {
	              key: 'meta.description.multination.cricket.gamepackage.report',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              leagueName: leagueName,
	              matchYear: matchYear,
	              matchNum: matchNum,
	              domain: hostInfo
	            },
	            keywords: {
	              key: 'meta.keywords.multination.cricket.gamepackage.report',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              matchNum: matchNum,
	              homeTeamAbbr: homeTeamAbbr,
	              awayTeamAbbr: awayTeamAbbr,
	              leagueName: leagueName
	            }
	          };
	          break;
	        case 'video':
	          translatedKeyObjectForGamePackage = {
	            title: {
	              key: 'meta.title.cricket.multination.gamepackage.video',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              leagueName: leagueName,
	              matchYear: matchYear,
	              matchNum: matchNum,
	              domain: hostInfo
	            },
	            description: {
	              key: 'meta.description.cricket.multination.gamepackage.video',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              leagueName: leagueName,
	              matchYear: matchYear,
	              matchNum: matchNum,
	              domain: hostInfo
	            },
	            keywords: {
	              key: 'meta.keywords.cricket.multination.gamepackage.video',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              matchNum: matchNum,
	              matchYear: matchYear,
	              homeTeamAbbr: homeTeamAbbr,
	              awayTeamAbbr: awayTeamAbbr,
	              leagueName: leagueName
	            }
	          };
	          break;
	        case 'statistics':
	          translatedKeyObjectForGamePackage = {
	            title: {
	              key: 'meta.title.cricket.multination.gamepackage.statistics',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              leagueName: leagueName,
	              matchYear: matchYear,
	              matchNum: matchNum,
	              domain: hostInfo
	            },
	            description: {
	              key: 'meta.description.cricket.multination.gamepackage.statistics',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              leagueName: leagueName,
	              matchYear: matchYear,
	              matchNum: matchNum,
	              domain: hostInfo
	            },
	            keywords: {
	              key: 'meta.keywords.cricket.multination.gamepackage.statistics',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              matchNum: matchNum,
	              matchYear: matchYear,
	              homeTeamAbbr: homeTeamAbbr,
	              awayTeamAbbr: awayTeamAbbr,
	              leagueName: leagueName
	            }
	          };
	          break;
	        case 'coverage':
	          translatedKeyObjectForGamePackage = {
	            title: {
	              key: 'meta.title.cricket.multination.gamepackage.coverage',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              leagueName: leagueName,
	              matchYear: matchYear,
	              matchNum: matchNum,
	              domain: hostInfo
	            },
	            description: {
	              key: 'meta.description.multination.cricket.gamepackage.coverage',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              leagueName: leagueName,
	              matchYear: matchYear,
	              matchNum: matchNum,
	              domain: hostInfo
	            },
	            keywords: {
	              key: 'meta.keywords.cricket.multination.gamepackage.coverage',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              matchNum: matchNum,
	              matchYear: matchYear,
	              homeTeamAbbr: homeTeamAbbr,
	              awayTeamAbbr: awayTeamAbbr,
	              leagueName: leagueName
	            }
	          };
	          break;
	        case 'hawkeye':
	          translatedKeyObjectForGamePackage = {
	            title: {
	              key: 'meta.title.cricket.multination.gamepackage.hawkeye',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              leagueName: leagueName,
	              matchYear: matchYear,
	              matchNum: matchNum,
	              domain: hostInfo
	            },
	            description: {
	              key: 'meta.description.cricket.multination.gamepackage.hawkeye',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              leagueName: leagueName,
	              matchYear: matchYear,
	              matchNum: matchNum,
	              domain: hostInfo
	            },
	            keywords: {
	              key: 'meta.keywords.cricket.multination.gamepackage.hawkeye',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              matchNum: matchNum,
	              matchYear: matchYear,
	              homeTeamAbbr: homeTeamAbbr,
	              awayTeamAbbr: awayTeamAbbr,
	              leagueName: leagueName
	            }
	          };
	          break;
	      } //TOURNEY SWITCH END
	    } else {
	      switch (pagetypeLower) {
	        case 'game':
	          if (gameState === 'pregame') {
	            translatedKeyObjectForGamePackage = {
	              title: {
	                key: 'meta.title.cricket.bilateral.gamepackage.game.pre',
	                homeTeamName: homeTeamName,
	                awayTeamName: awayTeamName,
	                matchNum: matchNum,
	                domain: hostInfo
	              },
	              description: {
	                key: 'meta.description.cricket.bilateral.gamepackage.game.pre',
	                homeTeamName: homeTeamName,
	                awayTeamName: awayTeamName,
	                leagueName: leagueName,
	                matchYear: matchYear,
	                matchNum: matchNum,
	                domain: hostInfo
	              }
	            };
	          } else if (gameState === 'live') {
	            translatedKeyObjectForGamePackage = {
	              title: {
	                key: 'meta.title.cricket.bilateral.gamepackage.game.in',
	                fullScore: fullScore,
	                homeTeamName: homeTeamName,
	                awayTeamName: awayTeamName,
	                matchNum: matchNum,
	                domain: hostInfo
	              },
	              description: {
	                key: 'meta.description.cricket.bilateral.gamepackage.game.in',
	                homeTeamName: homeTeamName,
	                awayTeamName: awayTeamName,
	                leagueName: leagueName,
	                matchYear: matchYear,
	                matchNum: matchNum,
	                domain: hostInfo
	              }
	            };
	          } else {
	            if (matchSummary.indexOf('by') !== -1) {
	              matchSummaryText = matchSummary.substring(matchSummary.indexOf('by'), matchSummary.length);
	              translatedKeyObjectForGamePackage = {
	                title: {
	                  key: 'meta.title.cricket.bilateral.gamepackage.game.post.result',
	                  matchWinner: matchWinner,
	                  matchLoser: matchLoser,
	                  matchSummaryText: matchSummaryText,
	                  homeTeamName: homeTeamName,
	                  awayTeamName: awayTeamName,
	                  matchNum: matchNum,
	                  domain: hostInfo
	                }
	              };
	            } else {
	              translatedKeyObjectForGamePackage = {
	                title: {
	                  key: 'meta.title.cricket.bilateral.gamepackage.game.post.noresult',
	                  matchSummaryText: matchSummary,
	                  homeTeamName: homeTeamName,
	                  awayTeamName: awayTeamName,
	                  matchNum: matchNum,
	                  domain: hostInfo
	                }
	              };
	            } //result match checks end
	            translatedKeyObjectForGamePackage.description = {
	              key: 'meta.description.cricket.bilateral.gamepackage.game.post',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              leagueName: leagueName,
	              matchYear: matchYear,
	              matchNum: matchNum,
	              domain: hostInfo
	            };
	          } //gameState checks end
	          translatedKeyObjectForGamePackage.keywords = {
	            key: 'meta.keywords.cricket.bilateral.gamepackage.game',
	            homeTeamName: homeTeamName,
	            awayTeamName: awayTeamName,
	            matchYear: matchYear,
	            matchNum: matchNum,
	            homeTeamAbbr: homeTeamAbbr,
	            awayTeamAbbr: awayTeamAbbr,
	            leagueName: leagueName
	          };
	          break;
	        case 'scorecard':
	          translatedKeyObjectForGamePackage = {
	            title: {
	              key: 'meta.title.cricket.bilateral.gamepackage.scoreboard',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              matchYear: matchYear,
	              matchNum: matchNum,
	              domain: hostInfo
	            },
	            description: {
	              key: 'meta.description.cricket.bilateral.gamepackage.scoreboard',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              leagueName: leagueName,
	              matchYear: matchYear,
	              matchName: matchName,
	              matchNum: matchNum,
	              domain: hostInfo
	            },
	            keywords: {
	              key: 'meta.keywords.cricket.bilateral.gamepackage.scoreboard',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              matchNum: matchNum,
	              homeTeamAbbr: homeTeamAbbr,
	              awayTeamAbbr: awayTeamAbbr,
	              leagueName: leagueName,
	              matchYear: matchYear
	            }
	          };
	          break;
	        case 'commentary':
	          translatedKeyObjectForGamePackage = {
	            title: {
	              key: 'meta.title.cricket.bilateral.gamepackage.commentary',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              matchNum: matchNum,
	              matchYear: matchYear,
	              domain: hostInfo
	            },
	            description: {
	              key: 'meta.description.cricket.bilateral.gamepackage.commentary',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              leagueName: leagueName,
	              matchYear: matchYear,
	              matchNum: matchNum,
	              domain: hostInfo
	            },
	            keywords: {
	              key: 'meta.keywords.cricket.bilateral.gamepackage.commentary',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              matchNum: matchNum,
	              matchYear: matchYear,
	              homeTeamAbbr: homeTeamAbbr,
	              awayTeamAbbr: awayTeamAbbr,
	              leagueName: leagueName
	            }
	          };
	          break;
	        case 'preview':
	          translatedKeyObjectForGamePackage = {
	            title: {
	              key: 'meta.title.cricket.bilateral.gamepackage.preview',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              matchNum: matchNum,
	              matchYear: matchYear,
	              domain: hostInfo
	            },
	            description: {
	              key: 'meta.description.cricket.bilateral.gamepackage.preview',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              leagueName: leagueName,
	              matchYear: matchYear,
	              matchNum: matchNum,
	              domain: hostInfo
	            },
	            keywords: {
	              key: 'meta.keywords.cricket.bilateral.gamepackage.preview',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              matchNum: matchNum,
	              homeTeamAbbr: homeTeamAbbr,
	              awayTeamAbbr: awayTeamAbbr,
	              leagueName: leagueName,
	              matchYear: matchYear
	            }
	          };
	          break;
	        case 'report':
	          translatedKeyObjectForGamePackage = {
	            title: {
	              key: 'meta.title.cricket.bilateral.gamepackage.report',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              matchNum: matchNum,
	              matchYear: matchYear,
	              domain: hostInfo
	            },
	            description: {
	              key: 'meta.description.cricket.bilateral.gamepackage.report',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              leagueName: leagueName,
	              matchYear: matchYear,
	              matchNum: matchNum,
	              domain: hostInfo
	            },
	            keywords: {
	              key: 'meta.keywords.cricket.bilateral.gamepackage.report',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              matchNum: matchNum,
	              homeTeamAbbr: homeTeamAbbr,
	              awayTeamAbbr: awayTeamAbbr,
	              leagueName: leagueName,
	              matchYear: matchYear
	            }
	          };
	          break;
	        case 'video':
	          translatedKeyObjectForGamePackage = {
	            title: {
	              key: 'meta.title.cricket.bilateral.gamepackage.video',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              matchNum: matchNum,
	              matchYear: matchYear,
	              domain: hostInfo
	            },
	            description: {
	              key: 'meta.description.cricket.bilateral.gamepackage.video',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              leagueName: leagueName,
	              matchYear: matchYear,
	              matchNum: matchNum,
	              domain: hostInfo
	            },
	            keywords: {
	              key: 'meta.keywords.cricket.bilateral.gamepackage.video',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              matchNum: matchNum,
	              homeTeamAbbr: homeTeamAbbr,
	              awayTeamAbbr: awayTeamAbbr,
	              leagueName: leagueName,
	              matchYear: matchYear
	            }
	          };
	          break;
	        case 'statistics':
	          translatedKeyObjectForGamePackage = {
	            title: {
	              key: 'meta.title.cricket.bilateral.gamepackage.statistics',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              matchNum: matchNum,
	              matchYear: matchYear,
	              domain: hostInfo
	            },
	            description: {
	              key: 'meta.description.cricket.bilateral.gamepackage.statistics',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              leagueName: leagueName,
	              matchYear: matchYear,
	              matchNum: matchNum,
	              domain: hostInfo
	            },
	            keywords: {
	              key: 'meta.keywords.cricket.bilateral.gamepackage.statistics',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              matchNum: matchNum,
	              homeTeamAbbr: homeTeamAbbr,
	              awayTeamAbbr: awayTeamAbbr,
	              leagueName: leagueName,
	              matchYear: matchYear
	            }
	          };
	          break;
	        case 'coverage':
	          translatedKeyObjectForGamePackage = {
	            title: {
	              key: 'meta.title.cricket.bilateral.gamepackage.coverage',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              matchNum: matchNum,
	              matchYear: matchYear,
	              domain: hostInfo
	            },
	            description: {
	              key: 'meta.description.cricket.bilateral.gamepackage.coverage',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              leagueName: leagueName,
	              matchYear: matchYear,
	              matchNum: matchNum,
	              domain: hostInfo
	            },
	            keywords: {
	              key: 'meta.keywords.cricket.bilateral.gamepackage.coverage',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              matchNum: matchNum,
	              homeTeamAbbr: homeTeamAbbr,
	              awayTeamAbbr: awayTeamAbbr,
	              leagueName: leagueName,
	              matchYear: matchYear
	            }
	          };
	          break;
	        case 'hawkeye':
	          translatedKeyObjectForGamePackage = {
	            title: {
	              key: 'meta.title.cricket.bilateral.gamepackage.hawkeye',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              matchNum: matchNum,
	              matchYear: matchYear,
	              domain: hostInfo
	            },
	            description: {
	              key: 'meta.description.cricket.bilateral.gamepackage.hawkeye',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              leagueName: leagueName,
	              matchYear: matchYear,
	              matchNum: matchNum,
	              domain: hostInfo
	            },
	            keywords: {
	              key: 'meta.keywords.cricket.bilateral.gamepackage.hawkeye',
	              homeTeamName: homeTeamName,
	              awayTeamName: awayTeamName,
	              matchNum: matchNum,
	              homeTeamAbbr: homeTeamAbbr,
	              awayTeamAbbr: awayTeamAbbr,
	              leagueName: leagueName,
	              matchYear: matchYear
	            }
	          };
	          break;
	      } //NON-TOURNEY SWITCH END
	    }
	
	    gamePackageMetaObject.titleText = (0, _translate2.default)(edition, translatedKeyObjectForGamePackage.title) || '';
	    gamePackageMetaObject.metaDescriptionText = (0, _translate2.default)(edition, translatedKeyObjectForGamePackage.description) || '';
	    gamePackageMetaObject.metaKeywordsText = (0, _translate2.default)(edition, translatedKeyObjectForGamePackage.keywords) || '';
	
	    return gamePackageMetaObject;
	  }
	};
	exports.default = metahelpers;

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.eventSummary = undefined;
	
	var _selectn = __webpack_require__(438);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	var _translate = __webpack_require__(833);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventSummary = exports.eventSummary = {
	
	  getSummaryTypes: function getSummaryTypes() {
	    var sport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'rugby';
	
	
	    var summaryDetails = {
	      1: 'tries',
	      2: 'conversiongoals',
	      3: 'penalties',
	      4: 'dropgoalsconverted',
	      //5 : 'yellowcards',
	      6: 'redcards'
	    };
	
	    if (sport == 'rugby-league') {
	      summaryDetails = {
	        1: 'tries',
	        2: 'conversiongoals',
	        3: 'penalties',
	        4: 'dropgoalsconverted',
	        6: 'redcards',
	        24: 'tries',
	        26: 'tries'
	      };
	    }
	
	    return summaryDetails;
	  },
	
	  getSummaryFromDetails: function getSummaryFromDetails() {
	    var sport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'rugby';
	    var edition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var competitiors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	    var details = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	
	
	    var summaryDetails = eventSummary.getSummaryTypes(sport);
	    var teamAHomeAway = (0, _selectn2.default)('[0].homeAway', competitiors) || 'home';
	    var homeTeamId = teamAHomeAway === 'home' ? (0, _selectn2.default)('[0].id', competitiors) : (0, _selectn2.default)('[1].id', competitiors);
	    var detsLen = details.length || 0;
	    var players = {
	      home: {
	        squad: [],
	        playerMap: {}
	      },
	      away: {
	        squad: [],
	        playerMap: {}
	      },
	      penalties: {
	        home: [],
	        away: []
	      }
	    };
	
	    for (var i = 0; i < detsLen; i++) {
	      var detail = details[i];
	      var detailType = (0, _selectn2.default)('type.id', detail);
	      var eventTime = (0, _selectn2.default)('clock.displayValue', detail) || 0;
	
	      if (typeof summaryDetails[detailType] !== 'undefined') {
	        var athleteId = (0, _selectn2.default)('athletesInvolved[0].id', detail) || 0;
	        var athleteName = (0, _selectn2.default)('athletesInvolved[0].displayName', detail) || '-';
	        var athleteLink = (0, _selectn2.default)('athletesInvolved[0].links[0].href', detail) || '';
	
	        var homeAway = (0, _selectn2.default)('team.id', detail) === homeTeamId ? 'home' : 'away';
	
	        if (typeof players[homeAway].playerMap[athleteId] === 'undefined') {
	          players[homeAway].playerMap[athleteId] = players[homeAway].squad.length;
	          players[homeAway].squad.push({
	            name: athleteName,
	            url: athleteLink,
	            eventTimes: {}
	          });
	        }
	        var currPlayer = players[homeAway].squad[players[homeAway].playerMap[athleteId]];
	        if (typeof currPlayer.eventTimes[detailType] === 'undefined') {
	          currPlayer.eventTimes[detailType] = [];
	        }
	
	        currPlayer.eventTimes[detailType].push(eventTime);
	      } else if (detailType == 14) {
	        var penTeamId = (0, _selectn2.default)('team.id', detail) || 0;
	        if (homeTeamId == penTeamId) {
	          players.penalties.home.push(eventTime);
	        } else {
	          players.penalties.away.push(eventTime);
	        }
	      }
	    }
	
	    return eventSummary.getMatchSummary(sport, edition, players);
	  },
	
	  getMatchSummary: function getMatchSummary() {
	    var sport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'rugby';
	    var edition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	
	    var homeSquad = (0, _selectn2.default)('home.squad', data) || [];
	    var awaySquad = (0, _selectn2.default)('away.squad', data) || [];
	    var homePens = (0, _selectn2.default)('penalties.home', data) || [];
	    var awayPens = (0, _selectn2.default)('penalties.away', data) || [];
	
	    return {
	      home: eventSummary.getTeamSummary(sport, edition, homeSquad, homePens),
	      away: eventSummary.getTeamSummary(sport, edition, awaySquad, awayPens)
	    };
	  },
	
	  getTeamSummary: function getTeamSummary() {
	    var sport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'rugby';
	    var edition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	    var pens = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	
	
	    var summaryDetails = eventSummary.getSummaryTypes(sport);
	    var iSquadLen = data.length || 0;
	    var summary = {};
	
	    //for each type check the every player to see if we have the data.
	    for (var stat in summaryDetails) {
	
	      for (var i = 0; i < iSquadLen; i++) {
	
	        var eventTimes = (0, _selectn2.default)('[' + i + '].eventTimes.' + stat, data) || [];
	        if (eventTimes.length >= 1) {
	
	          eventTimes.sort(function (a, b) {
	            var aVal = parseInt(a.replace(/\D+/g, '')) || 0;
	            var bVal = parseInt(b.replace(/\D+/g, '')) || 0;
	            return aVal - bVal;
	          }); /* sort times */
	          if (typeof summary[summaryDetails[stat]] === 'undefined') {
	            summary[summaryDetails[stat]] = [];
	          }
	          // If player has multiple summaryDetails stats, group and sort stats to single player stats.
	          var hasSimilarName = false;
	          if (summary[summaryDetails[stat]].length) {
	            for (var k in summary[summaryDetails[stat]]) {
	              if ((0, _selectn2.default)('name', summary[summaryDetails[stat]][k]) === (0, _selectn2.default)('[' + i + '].name', data)) {
	                summary[summaryDetails[stat]][k].times.push(eventTimes.join(''));
	                hasSimilarName = true;
	                summary[summaryDetails[stat]][k].times.sort(function (a, b) {
	                  var aVal = parseInt(a.replace(/\D+/g, '')) || 0;
	                  var bVal = parseInt(b.replace(/\D+/g, '')) || 0;
	                  return aVal - bVal;
	                });
	              }
	            }
	          }
	          if (!hasSimilarName) {
	            summary[summaryDetails[stat]].push({
	              name: (0, _selectn2.default)('[' + i + '].name', data) || '',
	              guid: (0, _selectn2.default)('[' + i + '].guid', data) || '',
	              uid: (0, _selectn2.default)('[' + i + '].uid', data) || '',
	              times: eventTimes,
	              link: (0, _selectn2.default)('[' + i + '].url', data) || '',
	              rawClock: 0
	            });
	          }
	        }
	      }
	
	      if (typeof summary[summaryDetails[stat]] != 'undefined') {
	        summary[summaryDetails[stat]].sort(function (a, b) {
	          var aVal = parseInt(a.times[0].replace(/\D+/g, '')) || 0;
	          var bVal = parseInt(b.times[0].replace(/\D+/g, '')) || 0;
	          return aVal - bVal;
	        });
	      }
	    }
	
	    if (pens.length >= 1) {
	      if (typeof summary['tries'] === 'undefined') {
	        summary['tries'] = [];
	      }
	      summary['tries'].push({
	        name: (0, _translate2.default)(edition, 'Penalty Try'),
	        times: pens,
	        link: '#',
	        rawClock: 0
	      });
	    }
	
	    return summary;
	  }
	
	};
	
	exports.default = eventSummary;

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.gamePackage = undefined;
	
	var _assign = __webpack_require__(365);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _defineProperty2 = __webpack_require__(685);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _selectn = __webpack_require__(438);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	var _common = __webpack_require__(814);
	
	var _modules = __webpack_require__(838);
	
	var _modules2 = _interopRequireDefault(_modules);
	
	var _helpers = __webpack_require__(834);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _cricket = __webpack_require__(839);
	
	var _cricket2 = _interopRequireDefault(_cricket);
	
	var _common2 = __webpack_require__(430);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var page = {
	  /**
	   * compose data for scorecard page
	   * @param  {Array}  rostersNode   rosters node
	   * @param  {Array}  allInnings    details of all innings
	   * @param  {Number} currentPeriod current innings
	   * @param  {String} gameState  game state
	   * @param  {Object} matchFlags    flags for this match
	   * @param  {Object} params    page params
	   * @param {Object}  device    device info
	   * @param {Number} stateTypeId stateTypeId
	   * @return {Object}             scorecard data
	   */
	  getScorecard: function getScorecard() {
	    var rostersNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var allInnings = arguments[1];
	    var currentPeriod = arguments[2];
	    var gameState = arguments[3];
	    var matchFlags = arguments[4];
	    var params = arguments[5];
	    var device = arguments[6];
	    var stateTypeId = arguments[7];
	
	    var inningInfo = _helpers2.default.getOrderedInnings(rostersNode, allInnings, currentPeriod, gameState, matchFlags, params, device, stateTypeId);
	    var scorecard = inningInfo;
	    return scorecard;
	  },
	
	
	  /**
	   * @param {Object} articleNode  article node
	   * @param {Object} edition      edition config
	   * @param {Boolean} isAppLite
	   * return required data to fetch related markup for sCore
	   * @return {Object} article data required to fetch rendered markup
	   */
	  getArticleInfo: function getArticleInfo() {
	    var articleNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var edition = arguments[1];
	    var isAppLite = arguments[2];
	
	    var id = articleNode.id;
	    var headline = articleNode.headline;
	    var slug = void 0;
	    var href = '#';
	
	    if (typeof headline === 'string') {
	      slug = headline.replace(/[^a-zA-Z0-9 ]/g, '').replace(/\s/g, '-').toLowerCase();
	    }
	
	    if (isAppLite) {
	      href = '/story/_/id/' + id + '/' + slug;
	    } else {
	      href = _common.common.buildURL((0, _selectn2.default)('links.web.href', articleNode), edition.domain);
	    }
	
	    return {
	      id: id || null,
	      type: articleNode.type || null,
	      headline: articleNode.headline || '',
	      description: articleNode.description || '',
	      source: articleNode.byline || '',
	      date: articleNode.lastModified || '',
	      // TODO: pick href based on device?
	      href: href,
	      video: articleNode.video,
	      images: articleNode.images
	    };
	  }
	};
	
	var gamePackage = exports.gamePackage = {
	  processPlayByPlay: function processPlayByPlay(res, edition, params, location) {
	    var _location$query = location.query,
	        query = _location$query === undefined ? {} : _location$query;
	
	    var page = (0, _selectn2.default)('data.commentary.pageIndex', res);
	    var pageCount = (0, _selectn2.default)('data.commentary.pageCount', res);
	    var items = void 0;
	    var tiebreaker = void 0;
	
	    var isTiebreaker = query.innings === 'superover' ? true : false;
	
	    if (isTiebreaker) {
	      tiebreaker = (0, _selectn2.default)('data.commentary.items', res);
	    } else {
	      items = (0, _selectn2.default)('data.commentary.items', res);
	    }
	    var fullCommentary = _modules2.default.getCommentary(items, tiebreaker, params, query) || {};
	
	    //get lec clips to be added to the app state
	    var lecclips = _modules2.default.getLecClips(items || tiebreaker);
	
	    // total page count
	    fullCommentary.pageCount = pageCount;
	
	    // current commentary page number used by lazyload to identify next page to load
	    fullCommentary.page = page;
	
	    // arrange overs by page number
	    fullCommentary.oversByPage = (0, _defineProperty3.default)({}, page, fullCommentary.overs);
	
	    return { fullCommentary: fullCommentary, lecclips: lecclips };
	  },
	  processVideos: function processVideos(res) {
	    var videosNode = (0, _selectn2.default)('data.videos', res) || [];
	
	    var _ref = (0, _selectn2.default)('data', res) || {},
	        resultsCount = _ref.resultsCount,
	        resultsLimit = _ref.resultsLimit,
	        resultsOffset = _ref.resultsOffset;
	
	    var allVideos = _modules2.default.getAllVideos(videosNode);
	    var currentVideosCount = (allVideos.videos || []).length;
	    var hasMore = resultsOffset + currentVideosCount < resultsCount;
	
	    (0, _assign2.default)(allVideos, {
	      resultsCount: resultsCount,
	      resultsLimit: resultsLimit,
	      resultsOffset: resultsOffset,
	      currentVideosCount: currentVideosCount,
	      hasMore: hasMore
	    });
	
	    return { allVideos: allVideos };
	  },
	  processData: function processData(res, edition, params, location, appProps) {
	
	    var isAppLite = appProps && appProps.isAppLite || false;
	    var siteType = appProps && appProps.siteType || '';
	    var device = appProps && appProps.device || {};
	    var query = _common.common.getQuery(edition, params, location, appProps);
	    var adblock = (0, _selectn2.default)('_adblock', query) === 'true' ? true : false;
	    var timeZoneBucket = edition.timeZoneBucket,
	        host = edition.host,
	        isMultiSports = edition.isMultiSports;
	
	    var isWebView = params.webview === 'webview' ? true : false;
	    var hrefConfig = { showSport: isMultiSports ? true : params.webview === 'webview' ? true : false
	      // Select Nodes from API response
	    };var matchTitle = (0, _selectn2.default)('data.header.title', res) || '';
	    var competition = (0, _selectn2.default)('data.header.competitions[0]', res) || {};
	    competition.name = (0, _selectn2.default)('data.header.name', res) || ' ';
	    competition.title = matchTitle || '';
	    var timeValid = (0, _selectn2.default)('data.header.timeValid', res);
	    var date = competition && competition.date || '';
	    var league = (0, _selectn2.default)('data.header.league', res) || {};
	    var leagueName = league && league.name || '';
	    var isTournament = (0, _selectn2.default)('data.header.league.isTournament', res);
	    var season = (0, _selectn2.default)('data.header.season', res) || {};
	    var year = season && season.year || 0;
	    var seasonLeagueSlug = season && season.slug || '';
	    var rostersNode = (0, _selectn2.default)('data.rosters', res) || [];
	    var squadNode = (0, _selectn2.default)('data.squads', res) || null;
	    var leadersNode = (0, _selectn2.default)('data.leaders', res) || [];
	    var gameInfo = (0, _selectn2.default)('data.gameInfo', res) || {};
	    var state = (0, _selectn2.default)('status.type.state', competition);
	    var stateTypeId = (0, _selectn2.default)('status.type.id', competition);
	    var presentLocalTime = (0, _selectn2.default)('status.presentLocalTime', competition);
	    var notesNode = (0, _selectn2.default)('data.notes', res) || [];
	    var debutsNode = (0, _selectn2.default)('data.debuts', res) || [];
	    var sessionInfo = (0, _selectn2.default)('status.session', competition);
	    var articleNode = (0, _selectn2.default)('data.article', res) || {};
	    var matchDescription = (0, _selectn2.default)('data.header.description', res) || '';
	    var matchLink = (0, _selectn2.default)('data.header.links[0].href', res) || '';
	    var matchShortName = (0, _selectn2.default)('data.header.shortName', res) || '';
	    var scorer = _common.common.getNote(notesNode, 'livescorer') || '';
	    var commentator = _common.common.getNote(notesNode, 'livecommentator') || '';
	    var ballsPerOver = _common.common.getNote(notesNode, 'ballsperover') || '';
	    var featuredAthletes = (0, _selectn2.default)('status.featuredAthletes', competition) || [];
	    var leagueSlug = league && league.slug || '';
	    var slugOfLeague = seasonLeagueSlug ? seasonLeagueSlug : leagueSlug;
	    var odds = (0, _selectn2.default)('data.odds', res) || [];
	    var situationNode = (0, _selectn2.default)('data.situation', res) || [];
	    var scoringSource = _helpers2.default.getScoringSource(competition);
	    var headerLinks = (0, _selectn2.default)('data.header.links', res) || '';
	    var watchESPNLink = _common.common.getWatchESPNLink(headerLinks, edition.userGeo, device);
	    var tieBreaker = competition.tiebreaker || [];
	    var showSuperOver = /^superover$/ig.test(query.innings) === true;
	
	    var bet365 = { showInEdition: false };
	    var isRecent = competition.recent || false;
	    // gameStateActual give game state class as returns from API
	    var gameStateActual = _common.common.getGameState(state);
	
	    // set state to 'in' if recently completed match
	    if (isRecent === true && state === 'post') {
	      state = 'in';
	    }
	    // Call helpers
	    var matchFlags = _helpers2.default.getMatchFlags(competition, ballsPerOver);
	    var currentPeriod = _helpers2.default.getCurrentPeriod(competition);
	    var allInnings = _helpers2.default.getAllInnings(competition, params, query, true, matchFlags, hrefConfig);
	    var gameState = _common.common.getGameState(state);
	    var summary = _common.common.getGameSummary(competition);
	    /**
	     * Compose function to get cricket specific gamestrip.
	     * common.getGameStrip is called with all arguments that are passed to
	     * cricketGameStrip.
	     * modifiers.gameStrip is called with result of common.getGameStrip
	     */
	    var cricketGameStrip = (0, _common2.compose)(_cricket2.default.gameStrip, _common.common.getGameStrip);
	    // Call cricket specific gamestrip with appropriate data
	    var gameStrip = cricketGameStrip(competition, matchDescription, gameState, params.sport, timeZoneBucket, device, edition.domain, timeValid);
	
	    var gameStateClass = _common.common.getGameStateClass(gameState);
	    var article = page.getArticleInfo(articleNode, edition, isAppLite);
	
	    // Get new commentaries node from API
	    var commsMap = competition.commentaries || {};
	    // Set default value of commentary to competition.details
	    var comms = competition.details || [];
	    // If commsMap is not an empty object, Convert commentary map to sorted array
	    if ((0, _common2.isObjectEmpty)(commsMap) === false) {
	      comms = _common.common.prepareCommentary(commsMap);
	    }
	
	    // Call current innnings data after getting details of all innings
	    var innings = _helpers2.default.getCurrentInnings(competition, comms, rostersNode, allInnings, sessionInfo, gameState, params, host, matchFlags, device);
	    var editionSite = edition.site || '';
	
	    if (editionSite === 'espncricinfo' || editionSite === 'espnuk' || isWebView) {
	      var oddNode = (0, _selectn2.default)('[0]', odds) || {}; // odds are array of objects in summary api
	      bet365 = (0, _common2.getBet365)(oddNode, odds, editionSite, situationNode, gameState, device, params.pageType);
	    }
	
	    // Build data for modules
	    var matchFormat = (0, _selectn2.default)('class.generalClassCard', competition) || '';
	    var matchDetails = _modules2.default.getMatchDetails(gameInfo, notesNode, debutsNode, featuredAthletes, params, matchFormat, league, edition);
	
	    /**
	     * Number of balls for which bbb commentary should appear.
	     * For Lite App - 12 balls
	     * For Web App - 18 balls
	     * @type {Number}
	     */
	    var numBBBComms = isAppLite ? 12 : 18;
	    var partCommentary = _modules2.default.getCommentary(comms, competition.tiebreaker, params, query, scorer, commentator, gameState, true, presentLocalTime, numBBBComms, hrefConfig, matchFlags.updatesOnly);
	
	    var rosters = _modules2.default.getRosters(squadNode, rostersNode, gameStrip.teams, notesNode);
	    var scorecardSummary = _modules2.default.getScorecardSummary(leadersNode, rostersNode, allInnings, params, query, hrefConfig);
	
	    // Build data for page/tabs
	    var scorecard = page.getScorecard(rostersNode, allInnings, currentPeriod, gameState, matchFlags, params, device, stateTypeId);
	    var polling = _helpers2.default.shouldPoll(date, gameState);
	    var showGameDetailFooter = true;
	    var tossStatus = false;
	    // In pre game state, we need to show only toss info but not schedule as it is already a part of gamestrip
	    if (gameState === 'pregame') {
	      var toss = _common.common.getNote(notesNode, 'toss') || '';
	      tossStatus = toss.length ? true : false;
	      showGameDetailFooter = toss.length > 0 ? true : false;
	    }
	    var showScoreCellHeader = true;
	    var gameStateClassMobile = 'cscore--' + gameStateActual;
	    var gameStateClassFeature = 'cscore__' + gameState;
	
	    var showBtmAdModule = (0, _common2.showBottomAdModule)(params.pageType);
	
	    var trackingImg = (0, _common2.getTrackingImg)(edition, params.pageType, leagueName, slugOfLeague, params.gameId, location.pathname, siteType, state, query, gameStrip.teams, '');
	    var gameStatusText = _common.common.getGameStatusText(params.sport, competition, '', timeValid) || '';
	
	    if (typeof gameStatusText === 'string') {
	      gameStatusText = gameStatusText.toLowerCase().replace(' ', '');
	    }
	
	    var hiddenLinks = void 0;
	    var standings = {};
	    var cmtryInns = _helpers2.default.getCmtryInns(allInnings, tieBreaker, params, hrefConfig);
	    var selInnings = _helpers2.default.getSelectedInnings(allInnings, cmtryInns, query, showSuperOver);
	
	    if (!competition.description) {
	      competition.description = selInnings.innDisplayName;
	    }
	
	    var processedData = {
	      article: article,
	      summary: summary,
	      showGameHeader: true,
	      showGameDetailFooter: showGameDetailFooter,
	      scorecardSummary: scorecardSummary,
	      scorecard: scorecard,
	      rosters: rosters,
	      matchFlags: matchFlags,
	      matchDetails: matchDetails,
	      innings: innings,
	      gameStrip: gameStrip,
	      gameStateClass: gameStateClass,
	      gameStateClassMobile: gameStateClassMobile,
	      gameStateClassFeature: gameStateClassFeature,
	      gameState: gameState,
	      gameStatusText: gameStatusText,
	      gameStateActual: gameStateActual,
	      stateTypeId: stateTypeId,
	      presentLocalTime: presentLocalTime,
	      polling: polling,
	      showScoreCellHeader: showScoreCellHeader,
	      matchShortName: matchShortName,
	      trackingImg: trackingImg,
	      tossStatus: tossStatus,
	      showBtmAdModule: showBtmAdModule,
	      siteType: siteType,
	      scoringSource: scoringSource,
	      bet365: bet365,
	      watchESPNLink: watchESPNLink,
	      adblock: adblock
	    };
	
	    if (isAppLite === false) {
	      var standingsNode = (0, _selectn2.default)('data.standings', res) || {};
	      var h2hEvents = (0, _selectn2.default)('data.headToHeadGames[0].events', res) || [];
	      var h2hRef = (0, _selectn2.default)('data.headToHeadGames[0].team', res) || {};
	      var matchcardsNode = (0, _selectn2.default)('data.matchcards', res) || [];
	      var videosNode = (0, _selectn2.default)('data.videos', res) || [];
	      var leagueUid = (0, _selectn2.default)('data.header.league.uid', res) || {};
	      var newsNode = (0, _selectn2.default)('data.news', res) || {};
	
	      // Call helpers
	      var cmtryFilter = !showSuperOver ? _helpers2.default.getCmtryFilter(selInnings) : [];
	      var selCmtryFilter = !showSuperOver ? _helpers2.default.getSelCmtryFilter(cmtryFilter, query) : {};
	      var allVideos = _modules2.default.getAllVideos(videosNode);
	
	      var videoSlider = _modules2.default.getSliderVideos(article, videosNode, params, gameState, siteType);
	      var gameBreakStatus = _common.common.getGameBreakInfo(sessionInfo);
	
	      var headToHead = _modules2.default.getHeadToHead(edition, h2hEvents, gameStrip.teams, h2hRef);
	      var noteGroups = _modules2.default.getMatchNotes(notesNode, matchFlags, gameState, allInnings);
	      var closeOfPlay = _modules2.default.getCloseOfPlay(notesNode);
	      var comparison = _modules2.default.getComparisons(competition, matchFlags);
	      var statistics = _modules2.default.getStatistics(rostersNode, leadersNode, params, gameState, currentPeriod, competition, matchFlags, query, hrefConfig, scoringSource, comparison);
	      var playersToWatch = _modules2.default.getPlayersToWatch(leadersNode, gameStrip);
	      var news = _modules2.default.getNews(newsNode, edition, params, query, hrefConfig);
	      var matchCoverage = _modules2.default.getMatchCoverage(newsNode, edition, params, query, hrefConfig);
	      // Get all videos from rosters node
	      var rosterVideos = _modules2.default.getRosterVideos(rostersNode);
	      var matchcards = _helpers2.default.getMatchCards(matchcardsNode);
	      var detailsHeaderClass = _common.common.getDetailsHeaderClass(matchDescription, params);
	      var hawkEye = _modules2.default.getHawkEye(notesNode, device);
	      var fastCastMeta = {
	        enabled: false
	        /**
	         * Fastcast is available only if liveAvailable flag is set to true &&
	         * match is international.
	         * matchFlags.liveAvailable === true && matchFlags.international === true
	         *
	         * For now, we reply on fastcastAvailable flag from API to enable fastcast
	         * Update the topic name if available.
	         */
	      };if (matchFlags.fastcastAvailable === true) {
	        // Rely on the polling logic which takes care of game states & dates
	        fastCastMeta.enabled = polling.enabled;
	        var gameId = params.gameId;
	        var leagueId = params.league;
	        fastCastMeta.topic = 'gp-cricket-' + leagueId + '-' + gameId;
	        polling.duration = 15000;
	      }
	
	      standings = _modules2.default.getStandings(standingsNode, params, query, slugOfLeague, hrefConfig, year);
	      hiddenLinks = _helpers2.default.isHidden({ standingsNode: standingsNode, article: article, partCommentary: partCommentary, statistics: statistics, videos: allVideos.videos, matchCoverage: matchCoverage, hawkEye: hawkEye });
	
	      processedData = (0, _assign2.default)({}, processedData, {
	        allInnings: allInnings,
	        statistics: statistics,
	        standings: standings,
	        selInnings: selInnings,
	        playersToWatch: playersToWatch,
	        noteGroups: noteGroups,
	        closeOfPlay: closeOfPlay,
	        matchCoverage: matchCoverage,
	        matchcards: matchcards,
	        headToHead: headToHead,
	        leagueUid: leagueUid,
	        cmtryFilter: cmtryFilter,
	        selCmtryFilter: selCmtryFilter,
	        cmtryInns: cmtryInns,
	        news: news,
	        allVideos: allVideos,
	        videoSlider: videoSlider,
	        gameBreakStatus: gameBreakStatus,
	        comparison: comparison,
	        detailsHeaderClass: detailsHeaderClass,
	        rosterVideos: rosterVideos,
	        date: date,
	        fastCastMeta: fastCastMeta,
	        hawkEye: hawkEye,
	        adblock: adblock
	      });
	    } else {
	      hiddenLinks = _helpers2.default.isHidden({ standingsNode: false, article: {}, partCommentary: {}, statistics: false, videos: [], matchCoverage: false, hawkEye: {} });
	    }
	
	    var meta = _helpers2.default.getMetaData(params, competition, gameStrip, matchDetails, standings, gameState, league, matchDescription, matchTitle, matchLink, edition, season, hrefConfig, article, isTournament, leagueName, slugOfLeague);
	    // Build the nav
	    var links = _modules2.default.buildNav(params, query, hiddenLinks, gameState, slugOfLeague, hrefConfig, year);
	    var analytics = _helpers2.default.getAnalytics(params, gameStrip.teams, meta, gameState, edition);
	
	    return (0, _assign2.default)({}, processedData, {
	      partCommentary: partCommentary,
	      meta: meta,
	      links: links,
	      analytics: analytics
	    });
	  },
	
	
	  page: page,
	
	  modules: _modules2.default,
	
	  helpers: _helpers2.default
	
	};
	
	exports.default = gamePackage;

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.modules = undefined;
	
	var _assign = __webpack_require__(365);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(419);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(364);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _typeof2 = __webpack_require__(312);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _momentTimezone = __webpack_require__(450);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _selectn = __webpack_require__(438);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	var _common = __webpack_require__(814);
	
	var _helpers = __webpack_require__(834);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UNDEFINED = (0, _typeof3.default)(void 0);
	
	var modules = exports.modules = {
	  /**
	   * build ordered array of article groups, sorted by game days, then previews, then other
	   * @param  {Object} newsNode   news node
	   * @param  {Object} edition    edition config
	   * @param  {Object} params     router params
	   * @param  {Object} query      router query
	   * @param  {Object} hrefConfig config object for create href function
	   * @return {Object} Match Coverage Groups, each with a label and array of articles stats
	   */
	  getMatchCoverage: function getMatchCoverage() {
	    var newsNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var edition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var query = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	    var hrefConfig = arguments[4];
	
	    var coverageGroups = [];
	    // copy articles array so sorting doesn't affect source data in case other modules depend on this data
	    if (newsNode.type && newsNode.type == 'series') {
	      return coverageGroups;
	    }
	    var articles = newsNode.articles || [];
	    if (articles['constructor'] !== Array) {
	      articles = [];
	    }
	    articles = articles.concat();
	    var specialGameDays = {
	      MATCH_DAY: 0,
	      PREVIEW: -1,
	      OTHERS: -2
	    };
	
	    if (!articles.length) {
	      return coverageGroups;
	    }
	
	    var articlesHaveGameDay = false;
	    for (var i = 0; i < articles.length; i++) {
	      var currArticle = articles[i] || {};
	      if (typeof currArticle.gameDay === 'number') {
	        articlesHaveGameDay = true;
	        break;
	      }
	    }
	
	    var getArticleGameDay = articlesHaveGameDay ? function (article) {
	      return article.gameDay || specialGameDays.OTHERS;
	    } : function (article) {
	      var articleType = (article.type || '').toLowerCase();
	      return articleType === 'preview' ? specialGameDays.PREVIEW : specialGameDays.MATCH_DAY;
	    };
	
	    var articleTypeWeights = {
	      'preview': 1,
	      'recap': 3
	    };
	
	    var getArticleTypeWeight = function getArticleTypeWeight(article) {
	      return articleTypeWeights[(article.type || '').toLowerCase()] || 2;
	    };
	
	    // sort by gameDay (if present), article type, published date
	    articles.sort(function (articleA, articleB) {
	      var articleAGameDay = getArticleGameDay(articleA);
	      var articleBGameDay = getArticleGameDay(articleB);
	
	      var articleATypeWeight = getArticleTypeWeight(articleA);
	      var articleBTypeWeight = getArticleTypeWeight(articleB);
	
	      var articleAPublishedDate = +articleA.published || -Infinity;
	      var articleBPublishedDate = +articleB.published || -Infinity;
	
	      if (articleAGameDay === articleBGameDay) {
	        if (articleATypeWeight === articleBTypeWeight) {
	          return articleAPublishedDate - articleBPublishedDate;
	        } else {
	          return articleATypeWeight < articleBTypeWeight ? 1 : -1;
	        }
	      } else {
	        return articleAGameDay < articleBGameDay ? 1 : -1;
	      }
	    });
	
	    var specialDayLabels = {
	      '0': 'Match Day',
	      '-1': 'Preview',
	      '-2': 'Others'
	    };
	
	    var supportedReactLinkTypes = {
	      Preview: 'preview',
	      Recap: 'report'
	    };
	
	    var coverageGroup = null,
	        currentGroupGameDay = NaN;
	
	    var stripTags = /(<([^>]+)>)/ig;
	
	    articles.forEach(function (article) {
	      var articleGameDay = getArticleGameDay(article);
	
	      if (currentGroupGameDay !== articleGameDay) {
	        currentGroupGameDay = articleGameDay;
	        coverageGroup = {
	          label: String(articleGameDay) in specialDayLabels ? specialDayLabels[String(articleGameDay)] : 'Day ' + articleGameDay,
	          articles: []
	        };
	        coverageGroups.push(coverageGroup);
	      }
	
	      var href = (0, _selectn2.default)('links.web.href', article) || '#';
	      var isReactEnabledLink = false;
	      var reactLinkType = supportedReactLinkTypes[article.type];
	
	      if (reactLinkType && _common.common.isLinkReactEnabled(href)) {
	        href = _common.common.createHref((0, _extends3.default)({ query: query }, params, { day: article.gameDay, pageType: reactLinkType }, hrefConfig));
	        isReactEnabledLink = true;
	      } else {
	        href = params.platform ? href : _common.common.buildURL(href, edition.domain);
	      }
	
	      coverageGroup.articles.push({ // similar to flex.buildNewsItems... do we want to consolidate?
	        id: article.id,
	        headline: article.headline || article.linkText || '',
	        type: article.type,
	        gameDay: article.gameDay,
	        description: article.description || (article.story || '').replace(stripTags, '').substring(0, 200),
	        isReactEnabledLink: isReactEnabledLink,
	        href: href,
	        image: (0, _selectn2.default)('images[0]', article),
	        video: (0, _selectn2.default)('video[0]', article),
	        published: article.published,
	        author: article.author || article.byline,
	        trackingName: _common.common.createTrackingName([params.sport, 'game', params.pageType, 'cricketnews', article.id])
	      });
	    });
	
	    return coverageGroups;
	  },
	  getPlayersToWatch: function getPlayersToWatch(leadersNode, gameStrip) {
	    var homeTeamId = (0, _selectn2.default)('teams.home.id', gameStrip);
	
	    var roleMap = {
	      runs: 'Batsmen', wickets: 'Bowlers'
	    };
	
	    var statsMap = {
	      wickets: {
	        matches: { text: 'MAT', index: 0 },
	        wickets: { text: 'W', index: 1 },
	        economyRate: { text: 'ECO', index: 2 },
	        bowlingStrikeRate: { text: 'SR', index: 3 }
	      },
	      runs: {
	        matches: { text: 'MAT', index: 0 },
	        runs: { text: 'RUNS', index: 1 },
	        battingAverage: { text: 'AVG', index: 2 },
	        battingStrikeRate: { text: 'SR', index: 3 }
	      }
	    };
	
	    var players = _common.common.getLeaders(leadersNode, roleMap, statsMap, homeTeamId);
	    var isAvailable = players.Batsmen || players.Bowlers ? true : false;
	
	    return {
	      Batsmen: players.Batsmen,
	      Bowlers: players.Bowlers,
	      tbdTeam: (0, _selectn2.default)('tbdTeam', players) || '',
	      isAvailable: isAvailable
	    };
	  },
	
	  /**
	   * build stats data for React components
	   * @param  {Array}  rosters      Rosters node
	   * @param  {Object} leadersNode  leaders node
	   * @param  {Object} params       router params
	   * @param  {String} gameState    game state
	   * @param  {Number} period       inning number
	   * @param  {Object} competition  competition node
	   * @param  {Object} matchFlags   flags for this match
	   * @param  {Object} query        router query
	   * @param  {Object} hrefConfig   config object for create href function
	   * @param  {Object} scoringSource scoring source
	   * @param  {Object} comparison statistics comparison
	   * @return {Object}         Batsman and Bowler stats
	   */
	  getStatistics: function getStatistics() {
	    var rosters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var leadersNode = arguments[1];
	    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var gameState = arguments[3];
	    var period = arguments[4];
	    var competition = arguments[5];
	    var matchFlags = arguments[6];
	    var query = arguments[7];
	    var hrefConfig = arguments[8];
	    var scoringSource = arguments[9];
	    var comparison = arguments[10];
	
	
	    // TODO: improve, optimize logic, add error checks
	    var link = _common.common.createHref((0, _extends3.default)({ query: query }, params, { pageType: 'statistics' }, hrefConfig));
	    var trackingName = _common.common.createTrackingName([params.sport, 'game', params.pageType, 'stats', 'morestatistics']);
	    var teamAroster = (0, _selectn2.default)('[0].roster', rosters) || [];
	    var teamBroster = (0, _selectn2.default)('[1].roster', rosters) || [];
	    var combinedRosters = teamAroster.concat(teamBroster);
	    var battingStatMap = {
	      runs: { text: 'R', index: 0 },
	      ballsFaced: { text: 'B', index: 1 },
	      fours: { text: '4S', index: 2 },
	      sixes: { text: '6S', index: 3 }
	    };
	    var bowlingStatMap = {
	      overs: { text: 'O', index: 0 },
	      maidens: { text: 'M', index: 1 },
	      conceded: { text: 'R', index: 2 },
	      wickets: { text: 'W', index: 3 },
	      economyRate: { text: 'Eco', index: 4 }
	    };
	    var currentPlayersIds = {
	      batsmen: [],
	      bowlers: []
	    };
	    var enabled = false;
	
	    var bestPerformersBatTitle = (gameState != 'final' ? 'Current' : 'Best performances -') + ' Batsmen';
	    var bestPerformersBowlTitle = (gameState != 'final' ? 'Current' : 'Best performances -') + ' Bowlers';
	
	    // Object to lookup team details of an athlete
	    var athleteToTeam = _helpers2.default.getTeamOfAthletes(rosters);
	
	    // Default object to store best players (batsmen and bowlers)
	    var bestPlayers = {};
	    // If gameState is fInal, Look in the leaders node for best performances
	    // else pick current players
	    if (gameState === 'final') {
	      // Get full details of best players
	      bestPlayers = _helpers2.default.getBestPlayersFromMatch(leadersNode);
	      // Extract just the player IDs and their period of best play
	      currentPlayersIds = _helpers2.default.getBestPlayersIds(bestPlayers);
	    } else {
	      currentPlayersIds = _helpers2.default.getCurrentPlayersIds(combinedRosters, period);
	    }
	
	    // Get Array of batsman and bowler ids
	    var currBatsmanIds = currentPlayersIds.batsmen.map(function () {
	      var batsman = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      return batsman.playerId;
	    });
	    var currBowlerIds = currentPlayersIds.bowlers.map(function () {
	      var bowler = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      return bowler.playerId;
	    });
	
	    // Get object to lookup batsman and bowlers
	    var currentBatsmen = _common.common.getPlayersByIds(combinedRosters, currBatsmanIds) || {};
	    var currentBowlers = _common.common.getPlayersByIds(combinedRosters, currBowlerIds) || {};
	
	    var bowlers = [];
	    // Iterate over current bowlers(keys are ids) (in order) and extract stats
	
	    currentPlayersIds.bowlers.map(function (player) {
	      // Lookup details of this bowler
	      var currentPlayer = {};
	      if (player.hasOwnProperty('playerId')) {
	        currentPlayer = currentBowlers[player.playerId] || {};
	      }
	      var linescores = currentPlayer.linescores || [];
	      linescores.map(function (l) {
	        var bowlingNode = (0, _selectn2.default)('statistics.bowling', l);
	        // By default, flag is current period  == this line score period
	        var flag = period == l.period;
	        /**
	         * If game is completed state & playerToPeriod has this player id,
	         * then flag is player's best performance was in this line score period
	         */
	        if (gameState === 'final') {
	          flag = player.period == l.period;
	        }
	        // Append to bowlers only if it's a bowling linescore and flag is true
	        if (bowlingNode && flag) {
	          var statsNode = (0, _selectn2.default)('statistics.categories[0].stats', l);
	          var stats = _common.common.filterStatsByNames(statsNode, bowlingStatMap);
	          var team = (0, _selectn2.default)('[' + player + '].abbreviation', athleteToTeam) || '';
	          var headshot = (0, _selectn2.default)('athlete.headshot.href', currentPlayer) || '';
	          var bowlName = (0, _selectn2.default)('athlete.battingName', currentPlayer) || (0, _selectn2.default)('athlete.displayName', currentPlayer);
	          headshot = headshot ? _common.common.resizeCombinerLogo(headshot, { w: 108, h: 108, transparent: true, scale: 'crop' }) : '';
	          bowlers.push({
	            team: team,
	            img: headshot,
	            name: bowlName,
	            href: (0, _selectn2.default)('athlete.links[0].href', currentPlayer),
	            pitchMap: {
	              rhb: {
	                map: (0, _selectn2.default)('statistics.bowling.pitchMapRhb', l),
	                totalBalls: (0, _selectn2.default)('statistics.bowling.overallRhb.balls', l)
	              },
	              lhb: {
	                map: (0, _selectn2.default)('statistics.bowling.pitchMapLhb', l),
	                totalBalls: (0, _selectn2.default)('statistics.bowling.overallLhb.balls', l)
	              }
	            },
	            stats: stats
	          });
	        }
	      });
	    });
	    var batsmen = [];
	    // Iterate over current batsmen(keys are ids) (in order) and extract stats
	    currentPlayersIds.batsmen.map(function (player) {
	      // Lookup details of this batsman
	      var currentPlayer = {};
	      if (player.hasOwnProperty('playerId')) {
	        currentPlayer = currentBatsmen[player.playerId] || {};
	      }
	      var linescores = currentPlayer.linescores || [];
	
	      linescores.map(function (l) {
	        var summary = (0, _selectn2.default)('statistics.batting.preferredShot.runsSummary', l) || [];
	        var wagonZone = (0, _selectn2.default)('statistics.batting.wagonZone', l) || [];
	        var pie = wagonZone.map(function () {
	          var zone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	          return zone.runs;
	        });
	        var battingNode = (0, _selectn2.default)('statistics.batting', l);
	        // By default, flag is current period  == this line score period
	        var flag = period == l.period;
	        /**
	         * If game is completed state & playerToPeriod has this player id,
	         * then flag is player's best performance was in this line score period
	         */
	        if (gameState === 'final') {
	          flag = player.period == l.period;
	        }
	        // Append to batsmen only if it's a batting linescore and flag is true
	        if (battingNode && flag) {
	          var statsNode = (0, _selectn2.default)('statistics.categories[0].stats', l);
	          var stats = _common.common.filterStatsByNames(statsNode, battingStatMap);
	          var team = (0, _selectn2.default)('[' + player + '].abbreviation', athleteToTeam) || '';
	          var headshot = (0, _selectn2.default)('athlete.headshot.href', currentPlayer) || '';
	          var batName = (0, _selectn2.default)('athlete.battingName', currentPlayer) || (0, _selectn2.default)('athlete.displayName', currentPlayer);
	          headshot = headshot ? _common.common.resizeCombinerLogo(headshot, { w: 108, h: 108, transparent: true, scale: 'crop' }) : '';
	          batsmen.push({
	            team: team,
	            img: headshot,
	            name: batName,
	            href: (0, _selectn2.default)('athlete.links[0].href', currentPlayer),
	            control: (0, _selectn2.default)('statistics.batting.controlPercentage', l),
	            runs: stats[0].value + '(' + stats[1].value + ') <span>' + stats[2].value + 'x4 - ' + stats[3].value + 'x6</span>',
	            pie: pie,
	            productive: {
	              shotType: (0, _selectn2.default)('statistics.batting.preferredShot.shotName', l),
	              runs: (0, _selectn2.default)('statistics.batting.preferredShot.runs', l),
	              details: (summary[4] || 0) + 'x4 - ' + (summary[6] || 0) + 'x6'
	            }
	          });
	        }
	      });
	    });
	
	    var allPartnerships = modules.getPartnerships(matchFlags, competition);
	    var partnerships = modules.getCurrentPartnerships(matchFlags, competition, period);
	
	    // Build an array of innings (ordered by period)
	    var pshipByInnings = [];
	    // iterate over home and away
	    for (var ha in allPartnerships) {
	      var side = allPartnerships[ha];
	      // iterate over # innings
	      for (var p in side) {
	        // extract innings object
	        var inn = side[p];
	        var titlePresent = (0, _selectn2.default)('titles.brief', inn) !== 'undefined';
	        var _period = parseInt(p, 10);
	        // populate array only if period is valid & title is present
	        if (_period >= 1 && titlePresent) {
	          pshipByInnings[_period - 1] = (0, _extends3.default)({}, inn, { period: _period, ha: ha });
	        }
	      }
	    }
	
	    // Set of UI controls for stats modules
	    var uiControls = {
	      showButtons: false,
	      showTabs: false,
	      showCharts: false
	      /**
	       * Display tabs for tests and buttons for limited over matches. Show charts
	       * only for limited over matches
	       */
	    };if (matchFlags.limitedOvers) {
	      uiControls.showButtons = true;
	      uiControls.showCharts = true;
	    } else {
	      uiControls.showTabs = true;
	    }
	
	    var showStatsCharts = (0, _selectn2.default)('comparison.length', comparison) !== 0 ? true : false;
	    if (scoringSource.isFeedback && (batsmen.length || bowlers.length || partnerships.length) || uiControls.showCharts && showStatsCharts) {
	      enabled = true;
	    }
	
	    return {
	      partnerships: partnerships,
	      allPartnerships: allPartnerships,
	      bowlers: bowlers,
	      batsmen: batsmen,
	      link: link,
	      uiControls: uiControls,
	      pshipByInnings: pshipByInnings,
	      enabled: enabled,
	      trackingName: trackingName,
	      bestPerformersBatTitle: bestPerformersBatTitle,
	      bestPerformersBowlTitle: bestPerformersBowlTitle
	    };
	  },
	
	
	  /**
	  * Builds the data structure required to draw the table for the right hand column
	  * @param  {Object} standingsNode      Raw data from the standings node returned in summary call
	  * @param  {Object} params             Router params
	  * @param  {Object} query              Router query
	  * @param  {string} slugOfLeague       Slug of League
	  * @param  {Object} hrefConfig         Config object for create href function
	  * @param  {Number} year  year of the league
	  * @return {Object}                    Standings data and table link
	  **/
	  getStandings: function getStandings(standingsNode, params, query, slugOfLeague, hrefConfig, year) {
	
	    var typesToShow = [/* stats type in order of display + special team to show teamname */
	    'team', 'matchesplayed', 'matcheswon', 'matcheslost', 'matchesdraw', 'matchpoints', 'nrr'];
	    var standings = _common.common.getStandingsData(standingsNode, typesToShow, params.sport, 'gamepackage');
	    if (!params.leagueId) {
	      params.leagueId = standingsNode.id;
	    }
	    params = (0, _extends3.default)({}, params, { slug: slugOfLeague });
	    var standingsLink = _common.common.getStandingsLink(params, query, '', hrefConfig, year);
	
	    return (0, _extends3.default)({}, standings, { link: (0, _extends3.default)({}, standingsLink, { external: true }), params: params });
	  },
	
	  getMatchDetails: function getMatchDetails(gameInfo, notesNode, debutsNode, featuredAthletes, params, matchFormat, league, edition) {
	    var matchDetails = _common.common.getGameDetails(gameInfo, notesNode, featuredAthletes, params);
	    var debuts = _helpers2.default.getDebutants(debutsNode, params);
	    /* @var {Array} series - have array just to align with other match detail items */
	    var series = [{
	      name: league.name || '',
	      href: _common.common.buildURL((0, _selectn2.default)('link.href', league), edition.domain) || '#',
	      trackingName: _common.common.createTrackingName([params.sport, 'game', 'game', 'matchDetails'])
	    }];
	    return (0, _extends3.default)({}, matchDetails, { debuts: debuts, matchFormat: matchFormat, series: series });
	  },
	  getScorecardSummary: function getScorecardSummary() {
	    var leadersNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var rosters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	    var allInnings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	    var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	    var query = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	    var hrefConfig = arguments[5];
	
	    var teamAroster = (0, _selectn2.default)('[0].roster', rosters) || [];
	    var teamBroster = (0, _selectn2.default)('[1].roster', rosters) || [];
	    var combinedRosters = teamAroster.concat(teamBroster);
	
	    var summary = {};
	    var allInningsMapped = {};
	
	    var fullSummaryLink = _common.common.createHref((0, _extends3.default)({ query: query }, params, { pageType: 'scorecard' }, hrefConfig));
	
	    summary.fullSummaryLink = fullSummaryLink;
	
	    allInnings.map(function (inn) {
	      var period = inn.period;
	      allInningsMapped[period] = inn;
	    });
	
	    leadersNode.map(function () {
	      var ln = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var _ln$linescores = ln.linescores,
	          linescores = _ln$linescores === undefined ? [] : _ln$linescores;
	
	      summary.innings = summary.innings || {};
	
	      linescores.map(function () {
	        var ls = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	        var period = ls.period,
	            leaders = ls.leaders,
	            isBatting = ls.isBatting;
	
	        var currentInn = allInningsMapped[period];
	        var leadersData = void 0;
	        var playersType = void 0;
	        var statMap = void 0;
	        var inningStatus = void 0;
	        var followOn = void 0;
	
	        var leadersId = _helpers2.default.getLeadersId(leaders);
	
	        var players = _common.common.getPlayersByIds(combinedRosters, leadersId);
	
	        if (isBatting) {
	          playersType = 'batsmen';
	          statMap = {
	            runs: { text: 'RUNS', index: 0 },
	            ballsFaced: { text: 'BF', index: 1 },
	            notouts: { text: 'Not Out', index: 2 }
	          };
	        } else {
	          playersType = 'bowlers';
	          statMap = {
	            overs: { text: 'O', index: 0 },
	            conceded: { text: 'R', index: 1 },
	            wickets: { text: 'E', index: 2 }
	          };
	        }
	
	        leadersData = _helpers2.default.getLeadersData(players, statMap, period);
	        inningStatus = (0, _selectn2.default)('inningStatus', currentInn) || '';
	        followOn = (0, _selectn2.default)('stats.brief.followOn', currentInn) || 0;
	
	        summary.innings[period] = summary.innings[period] || {};
	        summary.innings[period][playersType] = leadersData;
	
	        //show empty data for forfeited and declared innings and not scored
	        if (inningStatus === 'forfeit' || inningStatus === 'declared') {
	          var runs = (0, _selectn2.default)('stats.brief.runs', currentInn) || '',
	              overs = (0, _selectn2.default)('stats.brief.overs', currentInn) || '',
	              defaultPlayer = {
	            name: '',
	            href: '',
	            stats: {
	              runs: '',
	              overs: ''
	            }
	          };
	          if (runs === '' && overs === '') {
	            summary.innings[period][playersType] = [defaultPlayer, defaultPlayer];
	          }
	        }
	
	        if (isBatting && (0, _typeof3.default)(summary.innings[period].team) === UNDEFINED) {
	          var _runs = (0, _selectn2.default)('stats.brief.runs', currentInn) || '',
	              _overs = (0, _selectn2.default)('stats.brief.overs', currentInn) || '',
	              description = (0, _selectn2.default)('stats.brief.description', currentInn) || '',
	              wickets = (0, _selectn2.default)('stats.brief.wickets', currentInn) || 0;
	
	          var inningsRunWicket = _runs || '0';
	          if (inningStatus === 'forfeit') {
	            inningsRunWicket = inningStatus;
	          } else {
	            if (description != 'all out') {
	              inningsRunWicket = inningsRunWicket + ('/' + wickets);
	            }
	            if (inningStatus === 'declared') {
	              inningsRunWicket = inningsRunWicket + 'd';
	            }
	            if (followOn) {
	              inningsRunWicket = inningsRunWicket + ' f/o';
	            }
	          }
	
	          summary.innings[period].team = {
	            teamDisplayName: ((0, _selectn2.default)('teamDisplayName', currentInn) || '').toUpperCase(),
	            innDisplayName: ((0, _selectn2.default)('innDisplayName', currentInn) || '').toUpperCase(),
	            runs: _runs,
	            overs: _overs,
	            wickets: wickets,
	            description: description,
	            inningsRunWicket: inningsRunWicket,
	            inningStatus: inningStatus
	          };
	        }
	      });
	    });
	    summary.isAvailable = (0, _keys2.default)(summary.innings).length ? true : false;
	
	    return summary;
	  },
	
	  /**
	   * get Head To Head data.
	   * @param  {Object} edition   details to get domain name
	   * @param  {Array}  events    events node from h2h
	   * @param  {Object} teams     teams node
	   * @param  {Object} h2hRef    reference team for h2h events
	   * @param  {Array}  notesNode notes from the feed
	   * @return {Object}           games and table keys
	   */
	  getHeadToHead: function getHeadToHead() {
	    var edition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var events = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	    var teams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var h2hRef = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	    var home = teams.home;
	    var away = teams.away;
	    var games = [];
	    var keys = [{
	      title: 'LAST FIVE MATCHES',
	      colSpan: 7
	    }, {
	      title: 'DATE'
	    }, {
	      title: 'SERIES/TOURNAMENT'
	    }];
	    var isAvailable = events.length ? true : false;
	
	    // Iterate over all events that these 2 teams have played before
	    events.map(function (event) {
	      // Get team id of the team which was at home for past event
	      var homeTeamId = event.homeTeamId || '';
	      // Get home and away team score for past event
	      var homeScore = event.homeTeamScore || '';
	      var awayScore = event.awayTeamScore || '';
	
	      //console.info('homeTeam, h2hRef', homeTeamId, h2hRef.id)
	
	      /**
	       * If home team id of this past event does not match with the reference
	       * team id (home team id of current game):
	       *
	       * Swap the scores so that hometeamId and homeTeamScore will match in past
	       * event.
	       *
	       * We need to swap the scores and not the team names because as per the
	       * product, home team needs to be listed on left in H2H area and the
	       * result of a past event is in reference of the team object of that event.
	       */
	      if (homeTeamId !== h2hRef.id) {
	        homeScore = event.awayTeamScore || '';
	        awayScore = event.homeTeamScore || '';
	      }
	
	      // Create a new object with score of the
	      var homeTeam = (0, _assign2.default)({}, home, { score: modules.getSplitTeamScores(homeScore) });
	      var awayTeam = (0, _assign2.default)({}, away, { score: modules.getSplitTeamScores(awayScore) });
	
	      var result = '';
	
	      switch (event.gameResult) {
	        case 'W':
	          result = 'beat';
	          break;
	
	        case 'L':
	          result = 'lost to';
	          break;
	
	        case 'T':
	          result = 'tied with';
	          break;
	
	        case 'D':
	          result = 'drew with';
	          break;
	
	        case 'NR':
	          result = 'no result';
	          break;
	
	        case 'ABN':
	          result = 'match abandoned';
	          break;
	
	        case 'PPD':
	          result = 'match postponed';
	          break;
	
	        case 'CNCL':
	          result = 'match cancelled';
	          break;
	      }
	
	      /**
	       * Create absolute link for the h2h game so that webview can open it in
	       * minibrowser
	       */
	      var h2hHref = _common.common.buildURL((0, _selectn2.default)('links[0].href', event), edition.domain);
	
	      games.push({
	        home: event.atVs == 'vs' ? homeTeam : awayTeam,
	        away: event.atVs == 'vs' ? awayTeam : homeTeam,
	        result: result,
	        // TODO: format date
	        date: (0, _momentTimezone2.default)(event.gameDate).format('DD/MM/YY'),
	        leagueName: event.leagueName,
	        url: h2hHref || '#'
	      });
	    });
	
	    return { keys: keys, games: games, isAvailable: isAvailable };
	  },
	
	
	  /**
	    * Get string and and check for 'ov' or 'target'
	    * @param {String} str score string
	    * @return {Boolean}  containOverOrTarget true if string contains 'ov' or 'target' else false
	    */
	  isOverOrTarget: function isOverOrTarget(str) {
	    var containOverOrTarget = str.indexOf('ov') !== -1 || str.indexOf('target') !== -1;
	    return containOverOrTarget;
	  },
	
	
	  /**
	    * Get team score string and remove overs and targets wrapped inside brackets "()"
	    * Split second team score to new <span /> element after "&".
	    * @param {String}  score  combined first & second innings score of a team
	    * @return {String}  teamScore  formated team score
	    */
	  getSplitTeamScores: function getSplitTeamScores(score) {
	    // default return value
	    var teamScore = score;
	    var delimiter = '&';
	    // Proceed only if score contains overs or target identified by 'ov' or 'target'
	    if (modules.isOverOrTarget(teamScore)) {
	      // split score at '(' to a array
	      var teamScoreArr = teamScore.split('(');
	      // ittrate over split score array to get overs and target string from score
	      for (var i = 1; i < teamScoreArr.length; i++) {
	        var iOvrTrgt = teamScoreArr[i];
	        // Proceed only if score contains overs or target
	        if (modules.isOverOrTarget(iOvrTrgt)) {
	          // split iOvrTrgt string at ')' and re-wrap the ov/target with '()'
	          var ovrTrgtStr = '(' + iOvrTrgt.split(')')[0] + ')';
	          // Replace overs or target inside () in team score with empty string
	          teamScore = teamScore.replace(ovrTrgtStr, '');
	        }
	      }
	    }
	
	    // Proceed only if score contains '2nd inning score' identified by '&'.
	    if (teamScore.indexOf(delimiter) !== -1) {
	      // split the score at 'demiliter'
	      var scores = teamScore.split(delimiter);
	      // assign 2nd inning score to new <span />
	      teamScore = '' + scores[0] + delimiter + '<span class=\'break\'>' + scores[1] + '</span>';
	    }
	    return teamScore;
	  },
	
	
	  /**
	   * Get heading/title for match notes in during a limited over live game.
	   * This is a workaround since during a live limited over game, match notes
	   * do not have innings title. But in post game state, they have the innings
	   * title.
	   *
	   * @param {String}  currentNum  current number of the note (section number/daynumber)
	   * @param {Object}  matchFlags  flags for this match
	   * @param {String}  gameState   state of match
	   * @param {Array}   allInnings  all Innings for this match
	   * @return {String}             heading for notes if found
	   */
	  getNoteHeadingForLiveGame: function getNoteHeadingForLiveGame() {
	    var currentNum = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var matchFlags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var gameState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	    var allInnings = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	
	    // default return value
	    var heading = '';
	    //console.info('matchFlags, gameState', matchFlags, gameState)
	
	    // Proceed only if it's a limited over match in live state
	    if (matchFlags.limitedOvers === true && gameState === 'live') {
	      //console.info('currentNum', currentNum, typeof currentNum)
	
	      // Procced only if current section number is 1/2
	      if (['1', '2'].indexOf(currentNum) != -1) {
	        // Used for looking up innings details which is 0 indexed array
	        var innIndex = currentNum - 1;
	        // Get innings title
	        var innTitle = (0, _selectn2.default)('[' + innIndex + '].title', allInnings) || '';
	        if (innTitle !== '') {
	          heading = innTitle;
	        }
	        //console.info('currentNum, innTitle', currentNum, innTitle)
	      }
	    }
	    return heading;
	  },
	
	
	  /**
	   * Categorize match notes into Arrays based on days/innings.
	   * For test matches, notes will be grouped by days. If day is 0, it should be
	   * grouped under General.
	   * For limited over matches, notes will be grouped by team name Innigs
	   *
	   * @param  {Array}  notesNode   Notes node from API
	   * @param {Object}  matchFlags  flags for this match
	   * @param {String}  gameState   state of match
	   * @param {Array}   allInnings  all Innings for this match
	   * @return {Array}            Notes for this match grouped by days/innings
	   */
	  getMatchNotes: function getMatchNotes() {
	    var notesNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var matchFlags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var gameState = arguments[2];
	    var allInnings = arguments[3];
	
	    // default return data
	    var noteGroups = [];
	    //console.info('matchFlags', matchFlags)
	    /**
	     * Contain title and notes for a group (day of a test match or innings of
	     * limited over match)
	     * @type {Object}
	     */
	    var group = {};
	    // Number of the group. e.g. 1/2/3/4/5 for test or 1/2 for ODI
	    var groupNum = void 0;
	    // Flag to start getting data for next group
	    var isNewGroup = void 0;
	    // Current number of the note
	    var currentNum = void 0;
	    // Title of the group
	    var title = void 0;
	
	    // Notes are identified by which key - dayNumber for test, section for ODI
	    var lookup = matchFlags.limitedOvers === true ? 'section' : 'dayNumber';
	
	    var numNotes = notesNode.length;
	    // Iterate over all match notes and group them day or innings wise
	    for (var i = 0; i < numNotes; i++) {
	      var note = notesNode[i] || {};
	      /**
	       * Continue to next note if note is not a matchnote or
	       * note does not have section/dayNumber key
	       */
	      if (note.type !== 'matchnote' || note.hasOwnProperty(lookup) === false) {
	        continue;
	      }
	
	      // Get number of this note
	      currentNum = note[lookup];
	      // Update flag if current Number is not equal to existing group number
	      isNewGroup = currentNum != groupNum;
	
	      // For ODIS, title is Team Name Innings
	      if (matchFlags.limitedOvers === true) {
	        title = '' + note.text;
	      }
	      // For test matches, title is either Day N or General (if day is 0)
	      else {
	          title = currentNum == 0 ? 'General' : 'Day ' + currentNum;
	        }
	
	      //console.info('isNewGroup, currentNum, title', isNewGroup, currentNum, title)
	
	      // If note is for a new group, update groupNum, reset group & push to noteGroups
	      if (isNewGroup) {
	        var heading = modules.getNoteHeadingForLiveGame(currentNum, matchFlags, gameState, allInnings);
	        //console.info('heading', heading)
	        title = heading !== '' ? heading : title;
	        groupNum = currentNum;
	        group = {
	          title: title,
	          notes: []
	        };
	        noteGroups.push(group);
	      }
	
	      /**
	       * Make sure that section heading and note title are not same before
	       * inserting note in notes array
	       */
	      var noteText = note.text || '';
	      var groupTitle = group.title || '';
	      var isNoteHeadingDifferent = void 0;
	      try {
	        isNoteHeadingDifferent = noteText.toLowerCase() != groupTitle.toLowerCase();
	      } catch (e) {
	        isNoteHeadingDifferent = true;
	      }
	
	      // Push current note details to notes array
	      if (note.hasOwnProperty(lookup) && group.hasOwnProperty('notes') && isNoteHeadingDifferent) {
	        group.notes.push({
	          id: note.id,
	          day: note[lookup],
	          text: note.text
	        });
	      }
	    }
	
	    // Iterate over note groups and set expanded flag on each group
	    var numNotegroups = noteGroups.length;
	    for (var j = 0; j < numNotegroups; j++) {
	      var g = noteGroups[j] || {};
	      /**
	       * If the group is last element in array, set expanded to true
	       * i.e. We always expand notes of the last section of match notes
	       */
	      g.expanded = numNotegroups === j + 1 ? true : false;
	    }
	
	    // Reverse display of match notes for test matches
	    if (matchFlags.limitedOvers === false && noteGroups.length > 1) {
	      noteGroups.reverse();
	    }
	    //console.info('noteGroups', noteGroups)
	
	    return { noteGroups: noteGroups };
	  },
	
	
	  /**
	   * For multiday matches, supposed to be avaialanle in the API at the end of the day
	   *
	   * @param  {Array}  notesNode   Notes node from API, type `closeofplay`
	   * @return {Array}  cop for this match
	   */
	  getCloseOfPlay: function getCloseOfPlay() {
	    var notesNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    // default return data
	    var cop = [];
	
	    for (var i = 0; i < notesNode.length; i++) {
	      var note = notesNode[i] || {};
	
	      if (note.type === 'closeofplay') {
	        cop.push({
	          date: note.date || '',
	          text: note.text || ''
	        });
	      }
	    }
	
	    return { cop: cop };
	  },
	
	
	  /**
	   * build links for tertiary nav
	   * TODO: Add logic to hide/show links based on available data
	   * @param  {Object} params        router params
	   * @param  {Object} query         router query
	   * @param  {Object} hidden        links to be displayed
	   * @param  {String} gameState     game state
	   * @param  {string} slugOfLeague  Slug of League
	   * @param  {Object} hrefConfig    Config object for create href function
	   * @param  {Number} year  year of the league
	   * @return {Array}                game package links
	   */
	  buildNav: function buildNav() {
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var hidden = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var gameState = arguments[3];
	    var slugOfLeague = arguments[4];
	    var hrefConfig = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
	    var year = arguments[6];
	
	    var linksToShow = {
	      pregame: ['game', 'preview', 'commentary', 'video', 'coverage', 'table', 'hawkeye'],
	      live: ['game', 'scorecard', 'report', 'commentary', 'video', 'coverage', 'statistics', 'table', 'hawkeye'],
	      final: ['game', 'scorecard', 'report', 'commentary', 'video', 'coverage', 'statistics', 'table', 'hawkeye']
	    };
	    var linkDescriptors = {
	      game: {
	        text: 'Summary'
	      },
	      scorecard: {
	        text: 'Scorecard'
	      },
	      commentary: {
	        text: 'Commentary'
	      },
	      statistics: {
	        text: 'Statistics'
	      },
	      coverage: {
	        text: 'Coverage'
	      },
	      video: {
	        text: 'Videos'
	      },
	      table: {
	        text: 'Table',
	        external: 'standings'
	      },
	      preview: {
	        text: 'Preview'
	      },
	      report: {
	        text: 'Report'
	      },
	      hawkeye: {
	        text: 'Hawk-Eye'
	      }
	    };
	    var links = [];
	
	    (linksToShow[gameState] || []).map(function (link) {
	      if (!hidden[link]) {
	        var details = linkDescriptors[link];
	
	        // skip if details not available
	        if ((typeof details === 'undefined' ? 'undefined' : (0, _typeof3.default)(details)) === UNDEFINED) {
	          return;
	        }
	
	        var hrefArgs = (0, _extends3.default)({ query: query }, params, { pageType: link, day: '' }, hrefConfig);
	
	        if (link === 'table') {
	          hrefArgs.slug = slugOfLeague;
	          hrefArgs.season = year;
	        }
	
	        var text = details.text;
	        var linkDetails = {
	          text: link === 'game' && gameState === 'live' ? 'Live' : text,
	          pageType: link,
	          href: _common.common.createHref(hrefArgs),
	          trackingName: _common.common.createTrackingName([params.sport, 'game', 'subnav', link])
	        };
	        if (details.external) {
	          linkDetails.external = details.external;
	          linkDetails.trackingName = '&lpos=' + params.sport + ':game:' + link + '::fullstandings';
	        }
	        links.push(linkDetails);
	      }
	    });
	
	    return links;
	  },
	
	  /**
	   * get rosters, the method considers input from
	   * both `squads` node and `rosters` node
	   * @param  {Array}  squadNode   squad node
	   * @param  {Array}  rostersNode rosters node
	   * @param  {Object} teams       teams object
	   * @param  {Array}  notesNode   notes from the feed
	   * @return {Object}             rosters
	   */
	  getRosters: function getRosters() {
	    var squadNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var rostersNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	    var teams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var notesNode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	
	    var sourceNode = void 0;
	    var rosters = {};
	    var tossInfo = _common.common.getNote(notesNode, 'toss') || '';
	
	    if (_helpers2.default.isRosterAvailable(rostersNode)) {
	      sourceNode = rostersNode;
	    } else {
	      sourceNode = squadNode || [];
	    }
	
	    sourceNode.map(function (team) {
	      var homeAway = void 0;
	      var currentTeamId = (0, _selectn2.default)('team.id', team);
	      var homeTeamId = (0, _selectn2.default)('home.id', teams);
	      var awayTeamId = (0, _selectn2.default)('away.id', teams);
	
	      if (currentTeamId == homeTeamId) {
	        homeAway = 'home';
	      } else if (currentTeamId == awayTeamId) {
	        homeAway = 'away';
	      }
	      // Proceed only if teams.home/away.id property exists
	      if (typeof (0, _selectn2.default)('[' + homeAway + '].id', teams) !== 'undefined') {
	        rosters[homeAway] = rosters[homeAway] || {};
	        rosters[homeAway].name = teams[homeAway].name;
	        rosters[homeAway].shortName = teams[homeAway].shortName;
	        rosters[homeAway].abbrev = teams[homeAway].abbrev;
	        rosters[homeAway].href = teams[homeAway].href;
	        rosters[homeAway].logo = teams[homeAway].logo;
	        rosters[homeAway].uid = teams[homeAway].uid;
	        rosters[homeAway].isDisabledTab = teams[homeAway].name === 'TBD' ? true : teams[homeAway].name === 'TBA' ? true : false;
	
	        var athletes = team.roster || team.athletes || [];
	
	        var players = athletes.map(function (player) {
	          var playerRoles = _helpers2.default.getPlayerRoles(player);
	          // Looks for links array, to extract profile url
	          var playerNode = player.links && player.links.length ? player : player.athlete;
	          var name = (0, _selectn2.default)('athlete.displayName', player) || '';
	          name = player.displayName || player.name || name;
	          var role = (0, _selectn2.default)('position.name', player);
	          var athleteLinkText = _helpers2.default.getAthleteLinkText(playerNode);
	          return {
	            id: player.id,
	            name: name + ' ' + playerRoles,
	            role: role === 'Unknown' ? '' : role,
	            href: _common.common.extractUrl(playerNode, athleteLinkText, 'desktop')
	          };
	        });
	        rosters[homeAway].players = players;
	      }
	    });
	    var homePlayers = rosters.home && rosters.home.players ? rosters.home.players.length : 0;
	    var awayPlayers = rosters.away && rosters.away.players ? rosters.away.players.length : 0;
	    var isAvailable = homePlayers || awayPlayers || 0;
	    rosters.isAvailable = isAvailable === 0 ? false : true;
	    rosters.isPlayingXI = tossInfo && homePlayers === 11 && awayPlayers === 11 ? true : false;
	    return rosters;
	  },
	
	
	  /**
	   * Get details of bowlers for End Of Over module
	   * @param  {Object} item node from items in commentary/details
	   * @return {Array}      bowlers at the end of over
	   */
	  getEodBowlers: function getEodBowlers() {
	    var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    // Order in which bowlers needs to be iterated over
	    var overBowlers = ['bowler', 'otherBowler'];
	    // default return data
	    var bowlers = [];
	
	    // Iterate over bowlers, extract details and populate bowlers array
	    for (var j = 0; j < overBowlers.length; j++) {
	      // bowler / other bowler
	      var currentBowler = overBowlers[j];
	      // Get player id
	      var playerId = (0, _selectn2.default)(currentBowler + '.athlete.id', item);
	
	      // Process stats only if key is found and player id is present
	      if (item.hasOwnProperty(currentBowler) && typeof playerId !== 'undefined') {
	        // player data
	        var d = item[currentBowler] || {};
	        var playerName = (0, _selectn2.default)('athlete.displayName', d);
	        // bowler stats which need to be picked
	        var pickStats = ['overs', 'maidens', 'conceded', 'wickets'];
	        var stats = [];
	        // iterater over pickStats and populate stats array
	        for (var k = 0; k < pickStats.length; k++) {
	          var currentStat = pickStats[k];
	          if (d.hasOwnProperty(currentStat)) {
	            stats.push(d[currentStat]);
	          }
	        }
	        // create stats string
	        var playerStats = stats.join('-');
	        // push to current player to bowlers array
	        bowlers.push({
	          name: playerName,
	          stat: playerStats
	        });
	      }
	    }
	    //console.info('bowlers', bowlers)
	    return bowlers;
	  },
	
	  /**
	   * Get details of batsmen for End Of Over module
	   * @param  {Object} item node from items in commentary/details
	   * @return {Array}      batsmen at the end of over
	   */
	  getEodBatsmen: function getEodBatsmen() {
	    var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    // Order in which batsmen needs to be iterated over
	    var overBatsmen = ['batsman', 'otherBatsman'];
	    // default return data
	    var batsmen = [];
	    var batsmenOutId = '';
	    var dismissal = (0, _selectn2.default)('dismissal.dismissal', item) ? true : false;
	    // check if the batsman out based on above dismissal
	    if (dismissal) {
	      batsmenOutId = (0, _selectn2.default)('dismissal.batsman.athlete.id', item) || '';
	    }
	
	    // Iterate over batsmen, extract details and populate batsmen array
	    for (var j = 0; j < overBatsmen.length; j++) {
	      // batsman / otherBatsman
	      var currentBatsman = overBatsmen[j];
	      // Get player id
	      var playerId = (0, _selectn2.default)(currentBatsman + '.athlete.id', item);
	
	      // Process stats only if key is found and player id is present
	      if (item.hasOwnProperty(currentBatsman) && typeof playerId !== 'undefined' && playerId !== batsmenOutId) {
	        // player data
	        var d = item[currentBatsman] || {};
	        var playerName = (0, _selectn2.default)('athlete.displayName', d);
	        // bowler stats which need to be picked
	        var pickStats = ['totalRuns', 'faced' /*,'fours', 'sixes'*/];
	        var stats = [];
	        // iterater over pickStats and populate stats array
	        for (var k = 0; k < pickStats.length; k++) {
	          var currentStat = pickStats[k];
	          if (d.hasOwnProperty(currentStat)) {
	            var statValue = d[currentStat];
	            if (currentStat === 'faced') {
	              statValue = '(' + statValue + 'b)';
	            }
	            stats.push(statValue);
	          }
	        }
	        // create stats string
	        var playerStats = stats.join(' ');
	        // push to current player to batsmen array
	        batsmen.push({
	          name: playerName,
	          stat: playerStats
	        });
	      }
	    }
	    //console.info('batsmen', batsmen)
	    return batsmen;
	  },
	
	  /**
	   * Get Score details at the end of over
	   * @param  {Object} item node from items in commentary/details
	   * @param  {Object} over over object from item
	   * @param  {Object} isTiebreaker  flag if tie-breaker innings
	   * @return {String} over number | Runs Wkts| inningsScore
	   */
	  getEodScore: function getEodScore() {
	    var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var over = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var isTiebreaker = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    // Get runs, over, wickets in this over
	    var overNumber = typeof over.number === 'undefined' ? '' : over.number;
	    var overRuns = typeof over.runs === 'undefined' ? '' : over.runs;
	    var overWickets = typeof over.wickets === 'undefined' ? '' : over.wickets;
	    var team = item.team || {};
	    var teamName = typeof team.abbreviation === 'undefined' ? team.displayName || '' : team.abbreviation;
	    // default return value
	    var endOfOverDisplayable = '';
	    // Since over number is 0, hide end of over
	    if (overNumber === 0) {
	      return endOfOverDisplayable;
	    }
	
	    // get score of the team from innings node (runs/wickets)
	    var runs = (0, _selectn2.default)('innings.runs', item);
	    var wickets = (0, _selectn2.default)('innings.wickets', item);
	    var overScore = '';
	    if (typeof runs != 'undefined' && typeof wickets != 'undefined' && runs !== '' && wickets !== '') {
	      overScore = runs + '/' + wickets;
	    }
	    /*
	    console.info('item', item)
	    console.info('overNumber %s, overRuns %s, overWickets %s, overScore %s',
	      overNumber, overRuns, overWickets, overScore)
	    */
	
	    /**
	     * Array to hold end of over data:
	     * over number, runs scored, wickets fallen, innings score
	     * @type {Array}
	     */
	    var endOfOver = [];
	
	    if (overNumber !== '' && overNumber != 0) {
	      endOfOver.push(overNumber);
	    }
	
	    // default value for runs and wickets info
	    var runsWickets = '';
	
	    // Check if this over is maiden
	    if (overRuns === 0) {
	      runsWickets = '(maiden)';
	      if (overWickets > 0) {
	        runsWickets = '(wicket maiden)';
	      }
	    }
	    // Check If over is not maiden
	    else {
	        if (overRuns !== '') {
	          runsWickets = overRuns + ' ' + (overRuns == 1 ? 'Run' : 'Runs');
	        }
	        if (overWickets != 0) {
	          runsWickets += ' ' + overWickets + ' ' + (overWickets == 1 ? 'Wkt' : 'Wkts');
	        }
	      }
	
	    if (isTiebreaker) {
	      runsWickets = '';
	    }
	
	    if (runsWickets !== '') {
	      endOfOver.push(runsWickets);
	    }
	    if (overScore !== '') {
	      // Add team name only if it is not empty
	      if (teamName !== '') {
	        endOfOver.push(teamName + ': ' + overScore);
	      } else {
	        endOfOver.push(overScore);
	      }
	    }
	    // Join only if array is not empty
	    if (endOfOver.length !== 0) {
	      endOfOverDisplayable = endOfOver.join(' | ');
	    }
	    return endOfOverDisplayable;
	  },
	
	  /**
	   * Get x runs required from y balls/overs, RR: x.xx, RRR: y.yy. Only for limited overs matches (handled in the jsx)
	   * @param  {Object} item node from items in commentary/details
	   * @param  {Object} over over object from item
	   * @return {String} over number | Runs Wkts| inningsScore
	   */
	  getEodRunsReq: function getEodRunsReq() {
	    var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	
	    // default return value
	    var endOfOverRunsReqDisplayable = '';
	
	    var remainingOverOrBalls = 0;
	
	    // get innings number, balls/overs remaining, current run rate, required run rate from innings node
	    var inningsNumber = (0, _selectn2.default)('innings.number', item);
	    var remainingBalls = (0, _selectn2.default)('innings.remainingBalls', item);
	    var remainingOvers = (0, _selectn2.default)('innings.remainingOvers', item);
	    var currentRunRate = (0, _selectn2.default)('innings.runRate', item);
	    var requiredRunRate = (0, _selectn2.default)('innings.requiredRunRate', item);
	    var requiredRuns = (0, _selectn2.default)('innings.remainingRuns', item) ? (0, _selectn2.default)('innings.remainingRuns', item) : 0;
	
	    /*console.info('inningsNumber %s, requiredRuns %s, remainingOvers %s, remainingBalls %s, currentRunRate %s, requiredRunRate %s',
	      inningsNumber, requiredRuns, remainingOvers, remainingBalls, currentRunRate, requiredRunRate)*/
	
	    //Overs or Ball/Balls remaining
	    if (remainingOvers > 10) {
	      remainingOverOrBalls = ' from ' + remainingOvers + ' overs';
	    } else if (remainingBalls > 0) {
	      remainingOverOrBalls = ' from ' + remainingBalls + (remainingBalls > 1 ? ' balls' : ' ball');
	    }
	
	    /**
	     * Array to hold end of over data:
	     * runs required, from overs or balls, current run rate, required run rate
	     * @type {Array}
	     */
	    var endOfOverRunsReq = [];
	
	    //current run rate for 1st innings
	    if (inningsNumber && inningsNumber === 1) {
	      if (currentRunRate) {
	        endOfOverRunsReq.push('| RR: ' + currentRunRate.toFixed(2));
	      }
	    }
	
	    //runs required from y balls/overs, RR: x.xx, RRR: y.yy for 2nd Innings
	    if (inningsNumber && inningsNumber === 2) {
	      if (requiredRuns) {
	        endOfOverRunsReq.push(requiredRuns + (requiredRuns > 1 ? ' runs' : ' run') + ' required');
	      }
	      if (requiredRuns > 0 && remainingOverOrBalls) {
	        endOfOverRunsReq.push(remainingOverOrBalls);
	      }
	      if (currentRunRate) {
	        endOfOverRunsReq.push((requiredRuns > 0 ? ', RR: ' : '| RR: ') + currentRunRate.toFixed(2));
	      }
	      if (requiredRunRate) {
	        endOfOverRunsReq.push(', RRR: ' + parseFloat(requiredRunRate).toFixed(2));
	      }
	    }
	
	    // Join only if array is not empty
	    if (endOfOverRunsReq.length !== 0) {
	      endOfOverRunsReqDisplayable = inningsNumber === 2 && requiredRuns > 0 ? '(' + endOfOverRunsReq.join('') + ')' : endOfOverRunsReq.join('');
	    }
	
	    return endOfOverRunsReqDisplayable;
	  },
	
	  /**
	   * get commentary
	   * @param  {Array}   items             items node
	   * @param  {Array}   tiebreaker        super over node
	   * @param  {Object}  params            router params
	   * @param  {Object}  query             router query
	   * @param  {String}  scorer            scorer of the match
	   * @param  {String}  commentator       commentator of the match
	   * @param  {String}  gameState         state of the match
	   * @param  {Boolean} isPartcomms       is partial commentary requested
	   * @param  {String}  presentLocalTime  present local time
	   * @param  {Number}  maxBalls          maximum number of balls to show in the commentary
	   * @param  {Object}  hrefConfig        Config object for create href function
	   * @param  {Boolean} updatesOnly       matchFlags updatesOnly
	   * @return {Object}        commentary
	   */
	  getCommentary: function getCommentary() {
	    var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var tiebreaker = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var query = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	    var scorer = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
	    var commentator = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
	    var gameState = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';
	    var isPartcomms = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
	    var presentLocalTime = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : '';
	    var maxBalls = arguments[9];
	    var hrefConfig = arguments[10];
	    var updatesOnly = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : false;
	
	    /**
	     * If game state is final, show only 6 balls in the
	     * partial commentary module on summary tab.
	     *
	     */
	    if (gameState === 'final' && isPartcomms === true && items instanceof Array === true) {
	      items = items.slice(0, 6);
	    }
	
	    // Display required number of balls in commentary
	    if (typeof maxBalls == 'number') {
	      items = items.slice(0, maxBalls);
	    }
	
	    var isTiebreaker = tiebreaker.length > 0 ? true : false;
	
	    // prepend super over commentary (show full super over even if match is over)
	    items = tiebreaker.concat(items);
	
	    /**
	     * Display ground time only when game state is not final and module is
	     * partial commentary.
	     * @type {String}
	     */
	    var groundTime = '';
	    if (gameState !== 'final' && isPartcomms === true) {
	      groundTime = presentLocalTime;
	    }
	
	    var comments = [];
	    var overs = [];
	    var overDiscrete = {};
	    var currentOver = -1;
	    var currentInn = -1;
	    var enabled = false;
	    var commentPreText = '';
	    var filterActive = query.filter;
	    var showFullCommentary = !filterActive || filterActive.toUpperCase() === 'FULL';
	    var isHighlight = filterActive && filterActive.toUpperCase() === 'HIGHLIGHT';
	    var href = _common.common.createHref((0, _extends3.default)({ query: query }, params, { pageType: 'commentary' }, hrefConfig));
	    var trackingName = _common.common.createTrackingName([params.sport, 'game', params.pageType, 'fullcommentary']);
	
	    items.map(function () {
	      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	
	      //console.info('item', item)
	      // if over changed reset comments and update currentOver
	      if (currentOver !== item.over.number || isTiebreaker && currentInn !== item.innings.number) {
	
	        currentOver = item.over.number;
	
	        if (isTiebreaker) {
	          currentInn = item.innings.number;
	        }
	
	        comments = [];
	        overDiscrete = {
	          comments: comments,
	          overNo: currentOver,
	          completed: item.over.complete || false
	          // append the discrete over to overs list
	        };overs.push(overDiscrete);
	      }
	
	      if (commentPreText === '' && showFullCommentary) {
	        commentPreText = item.preText || '';
	      }
	
	      var over = item.over || {};
	      var commsText = item.text || '';
	      // default full text to commentary
	      var fullText = commsText;
	      var event = _helpers2.default.getBallValue(item);
	      var shortText = item.shortText || '';
	      var dismissalText = '';
	      if ((0, _selectn2.default)('dismissal.dismissal', item) == true || (0, _selectn2.default)('dismissal.retiredText', item) == 'hurt') {
	        dismissalText = (0, _selectn2.default)('dismissal.text', item) || '';
	      }
	      if (event == 4 || event == 6 || event == 'W') {
	        var regex = /\b(FOUR|SIX|OUT|four|six|out)\b/g;
	        shortText = shortText.replace(regex, '<b>$1</b>');
	      }
	      // Check if bowler to batsman, event test is available
	      if (shortText !== '') {
	        fullText = [shortText, commsText].join(', ');
	        //console.info('fullText', fullText)
	      }
	
	      var currentComment = {
	        timeStamp: over.actual,
	        text: _helpers2.default.removeScriptTag(fullText),
	        event: event,
	        commId: item.id,
	        commSeq: item.sequence,
	        dismissalText: dismissalText
	      };
	
	      if (showFullCommentary || isHighlight) {
	        currentComment.pre = _helpers2.default.removeScriptTag(item.preText);
	        currentComment.post = _helpers2.default.removeScriptTag(item.postText);
	      }
	
	      // Check if current commentary has valid video id associated with it
	      var hasVideoId = typeof (0, _selectn2.default)('media.id', item) !== 'undefined' ? true : false;
	      currentComment.hasVideoId = hasVideoId;
	      // Set video object for current commentary
	      if (hasVideoId === true) {
	        var video = item.media || {};
	        currentComment.video = video;
	        currentComment.videoId = video.id || '';
	        //console.info('video', video)
	      }
	
	      comments.push(currentComment);
	
	      // flag to check if this over is complete
	      var isOverComplete = over.complete == true ? true : false;
	      //let isOverBeingBowled = over.number > 0 ? true : false
	
	      // if over is complete, parse end-of-over
	      if (isOverComplete && showFullCommentary) {
	        (0, _assign2.default)(overDiscrete, {
	          endOfOver: modules.getEodScore(item, over, isTiebreaker),
	          endOfOverRunsReq: modules.getEodRunsReq(item, over)
	        });
	
	        if (isTiebreaker === false) {
	          (0, _assign2.default)(overDiscrete, {
	            batsmen: modules.getEodBatsmen(item),
	            bowlers: modules.getEodBowlers(item)
	          });
	        }
	      }
	      // condition added if No result (abandoned with a toss) - need to show comment pre text
	      if (!updatesOnly && (overs.length || overs.length === 0 && commentPreText.length > 0)) {
	        enabled = true;
	      }
	    });
	    return { overs: overs, href: href, enabled: enabled, scorer: scorer, commentator: commentator, commentPreText: commentPreText, trackingName: trackingName, groundTime: groundTime, currentOver: currentOver };
	  },
	
	
	  /**
	   * [getLecClips Get LEC clips into array like allVideos]
	   * @param  {[type]} items [data from fullcommentary]
	   * @return {[type]}       [retursn array]
	   */
	  getLecClips: function getLecClips(items) {
	    var lec_arr = [];
	    items.map(function (vid) {
	      var item = vid.media;
	      if (item) {
	        if (item.id) {
	          lec_arr.push(item);
	          //console.info('lec item',item)
	        }
	      }
	    });
	    return lec_arr;
	  },
	
	
	  /**
	   * Get videos associated with each player from the roster
	   * @param  {Array}  rostersNode rosters for a match
	   * @return {Array}              video objects associated with each player
	   */
	  getRosterVideos: function getRosterVideos() {
	    var rostersNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    // default return value
	    var rosterVideos = [];
	    //console.info('rostersNode', rostersNode)
	    /**
	     * Iterate over roster of each team. Within each team, iterate over all
	     * players, If a player has video associated with it, append to rosterVideos
	     */
	    for (var i = 0; i < rostersNode.length; i++) {
	      // get current team
	      var currentTeam = rostersNode[i] || {};
	      // get roster of current team
	      var roster = currentTeam.roster || [];
	      var rosterLen = roster.length || 0;
	      // iterate over all players from this team
	      for (var j = 0; j < rosterLen; j++) {
	        var playerRoster = roster[j] || {};
	        var playerLinescores = playerRoster.linescores || [];
	        var playerLinescoresLen = playerLinescores.length || 0;
	        for (var k = 0; k < playerLinescoresLen; k++) {
	          var playerLinescore = playerLinescores[k] || {};
	          var playerMediaObject = playerLinescore.media || {};
	          if (typeof playerMediaObject !== 'undefined') {
	            rosterVideos.push(playerMediaObject);
	          }
	        }
	      }
	    }
	    return rosterVideos;
	  },
	
	
	  /**
	   * get Partnerships
	   * @param {Object} matchFlags flags for this match
	   * @param  {Object} competition  competition node
	   * @param  {Function} filter     callback to filter innings
	   * @return {Array|Object}        Partnerships
	   */
	  getPartnerships: function getPartnerships() {
	    var matchFlags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var competition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
	      return 0;
	    };
	
	    var partnerships = {};
	    var filteredPartnerships = [];
	    var competitors = competition.competitors || [];
	    //console.info('competition', competition)
	    competitors.map(function () {
	      var competitor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      //console.info('competitor', competitor)
	      var linescores = competitor.linescores || [];
	      var homeAway = competitor.homeAway;
	
	      //console.info('team %s homeAway %s', teamName, homeAway)
	      partnerships[homeAway] = partnerships[homeAway] || {};
	
	      linescores.map(function () {
	        var score = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        var period = score.period;
	        var partnershipsNode = score.partnerships || [];
	
	        var titles = _helpers2.default.getInningsTitle(competitor, matchFlags, score);
	        //partnerships[homeAway].title = inningTitle
	        partnershipsNode.map(function () {
	          var partnership = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	          var notOut = '';
	          var playerAfaced = (0, _selectn2.default)('batsmen[0].balls', partnership);
	          var playerAruns = (0, _selectn2.default)('batsmen[0].runs', partnership);
	          var playerBfaced = (0, _selectn2.default)('batsmen[1].balls', partnership);
	          var playerBruns = (0, _selectn2.default)('batsmen[1].runs', partnership);
	          if (partnership && partnership.fowType != 'out') {
	            notOut = '*';
	          }
	          // Get both player's run(balls faced) value for a partnership
	          var playerAStat = playerAruns;
	          if (typeof playerAfaced !== 'undefined') {
	            playerAStat = playerAruns + ' (' + playerAfaced + ')';
	          }
	          var playerBStat = playerBruns;
	          if (typeof playerBfaced !== 'undefined') {
	            playerBStat = playerBruns + ' (' + playerBfaced + ')';
	          }
	
	          var ply1Name = (0, _selectn2.default)('batsmen[0].athlete.battingName', partnership) || (0, _selectn2.default)('batsmen[0].athlete.displayName', partnership);
	          var ply2Name = (0, _selectn2.default)('batsmen[1].athlete.battingName', partnership) || (0, _selectn2.default)('batsmen[1].athlete.displayName', partnership);
	          var formattedPartnership = {
	            total: partnership.runs + notOut,
	            playerA: {
	              name: ply1Name,
	              value: playerAStat,
	              runs: playerAruns
	              // TODO: calc and pass percentage for bar widths
	            },
	            playerB: {
	              name: ply2Name,
	              value: playerBStat,
	              runs: playerBruns
	              // TODO: calc and pass percentage for bar widths
	            }
	          };
	
	          if (score.partnerships) {
	            if (filter(score)) {
	              // Only append if runs for either player is available
	              if (playerAruns || playerBruns) {
	                filteredPartnerships.push(formattedPartnership);
	              }
	            } else {
	              // Init home/away.1/2 to an empty object
	              partnerships[homeAway][period] = partnerships[homeAway][period] || {};
	              // Init home/away.1/2.data to an empty array - This will hold actual formattedPartnership objects
	              partnerships[homeAway][period].data = partnerships[homeAway][period].data || [];
	              //console.info('partnerships[homeAway][period].data', partnerships[homeAway][period].data)
	              // Append each partnership in that period to data array
	              // Only append if runs for either player is available
	              if (typeof playerAruns !== 'undefined' || typeof playerBruns !== 'undefined') {
	                //console.info('formattedPartnership', formattedPartnership)
	                partnerships[homeAway][period].data.push(formattedPartnership);
	              }
	              // Set title of home/away.1/2 innings
	              partnerships[homeAway][period].titles = titles;
	            }
	          }
	        });
	      });
	    });
	    //console.info('partnerships', partnerships)
	    return filteredPartnerships.length ? filteredPartnerships : partnerships;
	  },
	
	  /**
	   * get current inning partnerships
	   * @param {Object} matchFlags flags for this match
	   * @param  {Object} competition competition node
	   * @param  {Number} period      inning number and period
	   * @return {Array|Object}       partnerships
	   */
	  getCurrentPartnerships: function getCurrentPartnerships(matchFlags) {
	    var competition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var period = arguments[2];
	
	    return modules.getPartnerships(matchFlags, competition, function (score) {
	      return score.period == period;
	    });
	  },
	  getSliderVideos: function getSliderVideos(article, videosNode, params) {
	    var articleVideos = article.video || [];
	    var articleVidIds = [];
	    var videos = [];
	    var highlightVideos = [];
	    var otherVideos = [];
	    var HIGHLIGHT = 'highlight';
	    videosNode = !videosNode.length ? [] : videosNode;
	
	    articleVidIds = articleVideos.map(function (v) {
	      return v.id;
	    });
	
	    articleVideos.map(function (video) {
	      var coverageType = (0, _selectn2.default)('tracking.coverageType', video) || '';
	      coverageType = coverageType.toLowerCase();
	
	      if (coverageType === HIGHLIGHT) {
	        highlightVideos.push(video);
	      } else {
	        otherVideos.push(video);
	      }
	    });
	
	    videosNode.map(function (video) {
	      var coverageType = (0, _selectn2.default)('tracking.coverageType', video) || '';
	      coverageType = coverageType.toLowerCase();
	
	      if (articleVidIds.indexOf(video.id) == -1) {
	        if (coverageType === HIGHLIGHT) {
	          highlightVideos.push(video);
	        } else {
	          otherVideos.push(video);
	        }
	      }
	    });
	
	    videos = highlightVideos.concat(otherVideos);
	
	    return {
	      articleVideos: articleVideos,
	      highlightVideos: highlightVideos,
	      videos: videos,
	      hasMoreVideosTab: videosNode.length > 0 ? true : false,
	      image: (0, _selectn2.default)('images[0]', article),
	      href: _common.common.createHref((0, _extends3.default)({}, params, { pageType: 'video' }))
	    };
	  },
	  getAllVideos: function getAllVideos(videosNode) {
	    var videos = _common.common.getVideos(videosNode);
	    var hasMore = videos.length > 1 ? true : false;
	    var tabs = {
	      all: { displayValue: 'All Videos', type: 'all' },
	      highlight: { displayValue: 'Match Highlights', type: 'highlight' }
	    };
	
	    return { videos: videos, hasMore: hasMore, tabs: tabs };
	  },
	  getComparisons: function getComparisons() {
	    var competition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var matchFlags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var competitors = competition.competitors || [];
	    var parsed = { home: { 1: {}, 2: {} }, away: { 1: {}, 2: {} }
	
	      // default return data
	    };var comparison = [];
	    // Charts should not appear for tests so no need to parse data
	    if (matchFlags.limitedOvers === false) {
	      return { comparison: comparison };
	    }
	
	    competitors.map(function (competitor) {
	      var teamName = (0, _selectn2.default)('team.displayName', competitor) || '';
	      var teamAbbr = (0, _selectn2.default)('team.abbreviation', competitor) || '';
	      var homeAway = competitor.homeAway;
	      var linescores = competitor.linescores || [];
	      linescores.map(function (linescore) {
	
	        var totalRuns = 0;
	        var overs = (0, _selectn2.default)('statistics.overs[0]', linescore) || [];
	        var period = linescore.period;
	
	        parsed[homeAway] = parsed[homeAway] || {};
	        parsed[homeAway][period] = {
	          name: homeAway,
	          teamName: teamName,
	          teamAbbr: teamAbbr,
	          values: []
	        };
	
	        overs.map(function () {
	          var over = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	          //console.info('over', over)
	          var data = {};
	          var runs = Number(over.runs);
	          totalRuns = totalRuns + runs;
	
	          var overNumber = Number(over.number);
	          var currentRate = Number((totalRuns / overNumber).toFixed(2));
	
	          data.over = overNumber;
	          data.runs = runs;
	          data.totalRuns = totalRuns;
	          data.rate = currentRate;
	          data.wickets = (over.wicket || []).map(function () {
	            var wicket = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            //console.info('wicket', wicket)
	            // Default text to show in tooltip
	            var finalText = '';
	            // Append all wicket related to details to this array
	            var allDetails = [];
	            /**
	             * Default strings for over number, comment, how out + batsman stats
	             * , strike rate and FOW
	             */
	            var overNumString = '';
	            var commentString = '';
	            var wicketTextString = '';
	            var srString = '';
	            var fowString = '';
	            var wicketStats = '';
	            var shortText = (0, _selectn2.default)('details.shortText', wicket) || '';
	            var wicketOver = wicket.over || '';
	            //console.info('wicket.over', wicket.over)
	            // Get ove number
	            overNumString = '<strong>' + wicketOver + ' ' + shortText + ' </strong>';
	            // Get actual comment for wicket
	            var comment = (0, _selectn2.default)('details.text', wicket);
	            if (typeof comment !== 'undefined') {
	              commentString = comment;
	            }
	            // Get strike rate of fallen batsman
	            if (wicket.hasOwnProperty('strikeRate')) {
	              srString = '<strong>SR: ' + wicket.strikeRate + '</strong>';
	            }
	            // Get FOW
	            if (wicket.hasOwnProperty('fow')) {
	              fowString = 'Fall of wicket: ' + wicket.fow;
	            }
	            wicketStats = _helpers2.default.getWicketStats(wicket);
	            // Prep textDetails array - order should be as per design
	            var textDetails = [overNumString, commentString, wicketTextString, wicketStats, srString, fowString];
	            // Loop over all details & append to allDetails if not empty string
	            for (var i = 0; i < textDetails.length; i++) {
	              var detailInfo = textDetails[i];
	              if (detailInfo !== '') {
	                allDetails.push(detailInfo);
	              }
	            }
	            // Construct finalText only if at least one detail is present
	            if (allDetails.length > 0) {
	              finalText = allDetails.join('<br/>');
	            }
	            return {
	              text: finalText
	            };
	          });
	
	          parsed[homeAway][period].values.push(data);
	        });
	      });
	    });
	
	    if ((0, _selectn2.default)('home[1].values.length', parsed) || (0, _selectn2.default)('away[2].values.length', parsed)) {
	      comparison.push([parsed.home[1], parsed.away[2]]);
	    }
	
	    if ((0, _selectn2.default)('home[2].values.length', parsed) || (0, _selectn2.default)('away[1].values.length', parsed)) {
	      comparison.push([parsed.home[2], parsed.away[1]]);
	    }
	
	    return { comparison: comparison };
	  },
	  getNews: function getNews() {
	    var newsNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var edition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var query = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	    var hrefConfig = arguments[4];
	
	    var items = [];
	    var count = 5;
	    var articles = newsNode.articles || [];
	    var news = {};
	    if (articles['constructor'] !== Array) {
	      articles = [];
	    }
	    articles.map(function (article) {
	      var headline = article.headline,
	          _article$type = article.type,
	          type = _article$type === undefined ? '' : _article$type;
	
	      var image = (0, _selectn2.default)('images[0]', article) || {};
	      var video = (0, _selectn2.default)('video[0]', article) || {};
	
	      // skip to next iteration if headline invalid
	      if (typeof headline !== 'string' || headline === '') {
	        return;
	      }
	
	      image.url = _common.common.getCombinerImage(image.url);
	      video.thumbnail = _common.common.getCombinerImage(video.thumbnail);
	
	      if (items.length < count && type.toLowerCase() !== 'media') {
	        items.push({
	          headline: article.headline,
	          description: article.description,
	          href: _common.common.buildURL((0, _selectn2.default)('links.web.href', article), edition.domain) || '#',
	          image: image,
	          video: video,
	          trackingName: _common.common.createTrackingName([params.sport, 'game', params.pageType, 'cricketnews', article.id])
	        });
	      }
	    });
	    if (newsNode.type && newsNode.type == 'series') {
	      news = {
	        items: items,
	        title: newsNode.header || ''
	      };
	    } else {
	      news = {
	        linkText: 'All Match News',
	        href: _common.common.createHref((0, _extends3.default)({ query: query }, params, { pageType: 'coverage' }, hrefConfig)),
	        trackingName: _common.common.createTrackingName([params.sport, 'game', params.pageType, 'cricketnews', 'all']),
	        items: items
	      };
	    }
	    return news;
	  },
	  getHawkEye: function getHawkEye() {
	    var notesNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var device = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var hawkEyeSrc = '';
	    var show = false;
	    if (notesNode.length) {
	      notesNode.map(function (n) {
	        if (n.type === 'hawkeye' && n.href) {
	          hawkEyeSrc = n.href;
	          if (hawkEyeSrc.indexOf('http:') !== -1) {
	            hawkEyeSrc = hawkEyeSrc.replace('http:', 'https:');
	          }
	        }
	      });
	    }
	    if ((device.desktop == true || device.tablet == true) && hawkEyeSrc.length > 0) {
	      show = true;
	    }
	    return { hawkEyeSrc: hawkEyeSrc, show: show };
	  }
	};
	
	exports.default = modules;

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.modifiers = undefined;
	
	var _extends2 = __webpack_require__(364);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _selectn = __webpack_require__(438);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Modifier functions
	 * @type {Object}
	 */
	var modifiers = exports.modifiers = {
	  /**
	   * Update gamestrip data
	   * @param  {Object} gameStrip gamestrip data
	   * @return {object}           Updated gamestrip
	   */
	  gameStrip: function gameStrip() {
	    var _gameStrip = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var winnerClass = _gameStrip.winnerClass || '';
	    var winnerClassMobile = _gameStrip.winnerClassMobile || '';
	    var winnerClassFeature = _gameStrip.winnerClassFeature || '';
	    var gameState = _gameStrip.gameState || '';
	    // check if home team batted first based on order
	    var homeTeamOrder = (0, _selectn2.default)('teams.home.order', _gameStrip);
	    var homeTeamBattedFirst = homeTeamOrder == 1 ? true : false;
	    if (gameState !== 'pregame') {
	      /**
	       * Only if match has a winner -
	       * If home team has not batted first, it will be shown on right side.
	       * So swap winner class. (By default it assumes that home team is on left)
	       */
	      //console.info('homeTeamBattedFirst, winnerClass', homeTeamBattedFirst, winnerClass)
	      if (winnerClass !== '' && homeTeamBattedFirst === false) {
	        _gameStrip.winnerClass = winnerClass === 'team-a-winner' ? 'team-b-winner' : 'team-a-winner';
	        _gameStrip.winnerClassMobile = winnerClassMobile === 'cscore--home-winner' ? 'cscore--away-winner' : 'cscore--home-winner';
	        _gameStrip.winnerClassFeature = winnerClassFeature === 'cscore__home--winner' ? 'cscore__away--winner' : 'cscore__home--winner';
	      }
	    }
	    return (0, _extends3.default)({ homeTeamBattedFirst: homeTeamBattedFirst }, _gameStrip);
	  }
	}; /**
	    * @fileOverview Modifier functions for cricket specific data.
	    *
	    * This file contains functions which modify data structures for common sports
	    * with cricket specific data
	    */
	
	exports.default = modifiers;

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.clubhouse = exports.gamePackage = undefined;
	
	var _gamePackage = __webpack_require__(841);
	
	var _gamePackage2 = _interopRequireDefault(_gamePackage);
	
	var _index = __webpack_require__(847);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @fileOverview Rugby data parser. Makes use of common parsers wherever
	 * possible.
	 */
	exports.gamePackage = _gamePackage2.default;
	exports.clubhouse = _index2.default;
	exports.default = {
	  gamePackage: _gamePackage2.default,
	  clubhouse: _index2.default
	};

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.gamePackage = undefined;
	
	var _assign = __webpack_require__(365);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getIterator2 = __webpack_require__(435);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _keys = __webpack_require__(419);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(364);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _typeof2 = __webpack_require__(312);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _selectn = __webpack_require__(438);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	var _common = __webpack_require__(814);
	
	var _htmlEntities = __webpack_require__(842);
	
	var _moment = __webpack_require__(452);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _translate = __webpack_require__(833);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	var _dateformat = __webpack_require__(449);
	
	var _dateformat2 = _interopRequireDefault(_dateformat);
	
	var _ucFirst = __webpack_require__(846);
	
	var _ucFirst2 = _interopRequireDefault(_ucFirst);
	
	var _eventSummary = __webpack_require__(836);
	
	var _eventSummary2 = _interopRequireDefault(_eventSummary);
	
	var _parseURI = __webpack_require__(830);
	
	var _parseURI2 = _interopRequireDefault(_parseURI);
	
	var _translateURI = __webpack_require__(832);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var entities = new _htmlEntities.XmlEntities();
	var UNDEFINED = (0, _typeof3.default)(void 0);
	var TEAM_STATS_FILTER = {
	  metres: 1,
	  tackles: 1,
	  missedtackles: 1,
	  turnoverknockon: 1,
	  territory: 1,
	  possession: 1,
	  runs: 1,
	  passes: 1,
	  kicksfromhand: 1,
	  kickpercentsuccess: 1,
	  penaltygoals: 1,
	  tries: 1,
	  conversiongoals: 1,
	  pcpossessionfirst: 1,
	  pcterritoryfirst: 1,
	  pcpossessionsecond: 1,
	  pcterritorysecond: 1,
	  cleanbreaks: 1,
	  defendersbeaten: 1,
	  offload: 1,
	  ruckswon: 1,
	  ruckstotal: 1,
	  turnoversconceded: 1,
	  maulswon: 1,
	  maulstotal: 1,
	  totalfreekicksconceded: 1,
	  totallineouts: 1,
	  lineoutswon: 1,
	  scrumstotal: 1,
	  scrumswon: 1,
	  penaltiesconceded: 1,
	  yellowcards: 1,
	  redcards: 1
	};
	var PLAYER_STATS_FILTER = {
	  tries: 1,
	  tryassists: 1,
	  points: 1,
	  kicks: 1,
	  passes: 1,
	  runs: 1,
	  metres: 1,
	  cleanbreaks: 1,
	  defendersbeaten: 1,
	  offload: 1,
	  lineoutwonsteal: 1,
	  turnoversconceded: 1,
	  tackles: 1,
	  missedtackles: 1,
	  lineoutswon: 1,
	  penaltiesconceded: 1,
	  yellowcards: 1,
	  redcards: 1,
	  penalties: 1,
	  penaltygoals: 1,
	  conversiongoals: 1,
	  dropgoalsconverted: 1
	};
	var DETAIL_TO_STATISTIC = {
	  1: 'tries',
	  2: 'conversiongoals',
	  3: 'penalties',
	  5: 'yellowcards',
	  6: 'redcards'
	};
	var SUPRESS_EVENT_DUPLICATES = {
	  9: 1,
	  10: 1,
	  11: 1,
	  12: 1
	};
	
	var helpers = {
	
	  formatNubmer: function formatNubmer(x) {
	    var parts = x.toString().split('.');
	    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	    return parts.join('.');
	  },
	
	  roundValue: function roundValue(x) {
	    return parseInt(x);
	    //Math.round
	    //parseInt
	  },
	
	  sumArray: function sumArray(arrayVal) {
	    if (arrayVal && arrayVal.constructor === Array) {
	      return arrayVal.reduce(function (total, num) {
	        return total + num * 1;
	        //Number()
	      }, 0);
	    }
	    return arrayVal * 1;
	  },
	
	  percentValue: function percentValue(total, quantity) {
	    /* default */
	    total = total || 0;
	    quantity = quantity || 0;
	
	    /* format */
	    total = this.sumArray(total);
	    quantity = this.sumArray(quantity);
	
	    if (!total) {
	      return 0;
	    }
	    return this.roundValue(quantity / total * 100);
	  },
	
	  /**
	   * Get standings link details
	   * @param  {Object} edition   Edition details
	   * @param  {Object} params    Router params
	   * @return {Object}           Link title and href
	   */
	  getStandingsLink: function getStandingsLink() {
	    var edition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	    var league = params.league || 0;
	    var link = {
	      title: (0, _translate2.default)(edition, 'Full Table')
	    };
	
	    if (league) {
	      link.href = _common.common.createHref((0, _extends3.default)({}, params, {
	        pageType: edition.language === 'es' || edition.language === 'pt' ? 'standings' : 'table'
	      }));
	    }
	
	    //Translate the url
	    var localizedHref = (0, _translateURI.translateURI)(edition, { url: link.href }, false);
	    link.href = localizedHref.url;
	
	    return link;
	  },
	
	  /**
	   * Logic to determine if polling should be enabled
	   * for the game
	   * @param  {String} date      competition.date
	   * @param  {String} gameState game state
	   * @return {Object}           Polling details
	   */
	  shouldPoll: function shouldPoll() {
	    var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var gameState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	    var duration = 45000;
	    var enabled = false;
	
	    if (gameState === 'live') {
	      enabled = true;
	    }
	    var startTime = _moment2.default.utc(new Date());
	    var endTime = (0, _moment2.default)(date);
	    var diff = endTime.diff(startTime, 'hours');
	    // console.log(startTime.format(), endTime.format(), diff)
	    // TODO: update logic
	    // polling 12 hours, before and after the game
	    if (Math.abs(diff) <= 1) {
	      enabled = true;
	    }
	    return {
	      enabled: enabled,
	      duration: duration
	    };
	  },
	
	  getAnalytics: function getAnalytics() {
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var teams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var gameState = arguments[3];
	    var _teams$home = teams.home,
	        home = _teams$home === undefined ? {} : _teams$home,
	        _teams$away = teams.away,
	        away = _teams$away === undefined ? {} : _teams$away;
	
	    var isSummary = params.pageType === 'game';
	    var isLive = gameState === 'live';
	    var type = isSummary ? isLive ? 'live' : 'summary' : params.pageType;
	    type = type === 'video' ? 'videos' : type;
	    var contentType = 'game' + (type ? ':' + type : '');
	    var gameStateProp = 'pre';
	
	    switch (gameState) {
	      case 'live':
	        gameStateProp = 'Live';
	        break;
	      case 'final':
	        gameStateProp = 'post';
	        break;
	    }
	
	    var data = {
	      omniture: {
	        gameState: gameStateProp,
	        pageName: params.sport + ':' + contentType,
	        gameInfo: params.gameId + '+' + home.name + ' vs ' + away.name,
	        eVar44: 'gamepackage',
	        league: params.league,
	        contentType: contentType
	      },
	      chartbeat: {
	        title: meta.title
	      }
	    };
	    return data;
	  },
	
	
	  getMetaData: function getMetaData() {
	    var edition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var params = arguments[1];
	    var competition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var gameStrip = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	    var matchDetails = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	    var leagueName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
	    var gameState = arguments[6];
	    var league = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : {};
	    var matchCoverage = arguments[8];
	    var matchDescription = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : '';
	    var hrefConfig = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : {};
	
	    var meta = {};
	
	    var date = _dateformat2.default.dateFormat(competition.date, 'D MMM, YYYY', edition.timeZoneBucket);
	    var teams = gameStrip.teams || {};
	    var homeTeam = teams.home || {};
	    var homeTeamName = homeTeam.name || '';
	    var awayTeam = teams.away || {};
	    var awayTeamName = awayTeam.name || '';
	
	    var _params$sport = params.sport,
	        sport = _params$sport === undefined ? '' : _params$sport,
	        _params$pageType = params.pageType,
	        pageType = _params$pageType === undefined ? '' : _params$pageType;
	
	    var titleInsert = '';
	    var metaDescSuffix = '';
	    var regex = /\/(ios|android)\/webview/g;
	    var gameTitle = '';
	    var gameKeywords = '';
	    var gameDescription = '';
	
	    // team abbreviations
	    var homeTeamAbbr = (0, _selectn2.default)('home.abbrev', teams) || '';
	    var awayTeamAbbr = (0, _selectn2.default)('away.abbrev', teams) || '';
	
	    // If abbreviation is not found, set abbreviation to team name
	    if (homeTeamAbbr === '') {
	      homeTeamAbbr = homeTeamName;
	    }
	    if (awayTeamAbbr === '') {
	      awayTeamAbbr = awayTeamName;
	    }
	
	    switch (pageType.toLowerCase()) {
	      case 'game':
	      case 'match':
	        titleInsert = 'Summary';
	        metaDescSuffix = 'Get a summary of';
	        break;
	      case 'report':
	        titleInsert = 'Report';
	        metaDescSuffix = 'Get a report of';
	        break;
	      case 'preview':
	        titleInsert = 'Preview';
	        metaDescSuffix = 'Get a preview of';
	        break;
	      case 'matchstats':
	        titleInsert = 'Match Statistics';
	        metaDescSuffix = 'Get match statistics of';
	        break;
	      case 'playerstats':
	        titleInsert = 'Player Statistics';
	        metaDescSuffix = 'Get the player statistics of';
	        break;
	      case 'commentary':
	        titleInsert = 'Commentary';
	        metaDescSuffix = 'Follow commentary on';
	        break;
	      case 'lineups':
	        titleInsert = 'Line-up';
	        metaDescSuffix = 'Get the match line-ups of';
	        break;
	      case 'conversation':
	        titleInsert = 'Conversation';
	        metaDescSuffix = 'Follow live conversation of';
	        break;
	    }
	
	    // Additional info required by Native APP
	    var canonical = _common.common.createHref((0, _extends3.default)({}, params, hrefConfig)) || '';
	    var shareurl = canonical.replace(regex, '');
	    var vs = (0, _translate2.default)(edition, 'schedule.vs');
	    meta.gameId = competition.id || '';
	    meta.gameState = (0, _selectn2.default)('status.type.state', competition) || '';
	    meta.leagueId = league.id || '';
	    meta.leagueUID = league.uid || '';
	    meta.leagueName = league.name || '';
	    meta.matchDescription = matchDescription;
	    meta.sport = sport;
	    meta.title = homeTeamName + ' vs ' + awayTeamName + ' - ' + titleInsert + ' - ' + leagueName + ' - ' + date + ' - ESPN';
	    meta.keywords = homeTeamName + ' vs ' + awayTeamName + ', ' + titleInsert.toLowerCase() + ', ' + leagueName + ', rugby';
	    meta.description = metaDescSuffix + ' the ' + homeTeamName + ' vs ' + awayTeamName + ' ' + leagueName + ' rugby match.';
	    meta.canonical = canonical;
	    meta.shareurl = shareurl;
	    meta.website = 'article';
	    meta.shortTitle = meta.shortTitle = homeTeamAbbr + ' vs ' + awayTeamAbbr;
	    meta.competitionUID = competition.uid || '';
	    meta.image = 'https://a.espncdn.com/combiner/i?img=%2Fi%2Fespn%2Fespn_logos%2Fespn_red.png';
	    gameTitle = homeTeamName + ' ' + vs + ' ' + awayTeamName + ' - ' + titleInsert + ' - ' + leagueName + ' - ' + date;
	    gameKeywords = homeTeamName + ' ' + vs + ' ' + awayTeamName + ', ' + titleInsert + ', ' + leagueName + ' ' + date;
	    gameDescription = homeTeamName + ' ' + vs + ' ' + awayTeamName + ', ' + leagueName + ' ' + date;
	    if (params.sport === 'rugby' && params.gameId != '' && params.league != '') {
	      var titleTransObj = {
	        key: 'meta.title.rugby.gamepackage',
	        game: gameTitle
	      };
	      var descriptionTransObj = {
	        key: 'meta.description.rugby.gamepackage',
	        game: gameDescription
	      };
	      var keywordsTransObj = {
	        key: 'meta.keywords.rugby.gamepackage',
	        game: gameKeywords
	      };
	      meta.title = (0, _translate2.default)(edition, titleTransObj) || '';
	      meta.description = (0, _translate2.default)(edition, descriptionTransObj) || '';
	      meta.keywords = (0, _translate2.default)(edition, keywordsTransObj) || '';
	    } else {
	      meta.title = homeTeamName + ' ' + vs + ' ' + awayTeamName + ' - ' + titleInsert + ' - ' + leagueName + ' - ' + date + ' - ESPN';
	      meta.keywords = homeTeamName + ' ' + vs + ' ' + awayTeamName + ', ' + titleInsert.toLowerCase() + ', ' + leagueName + ', rugby';
	      meta.description = metaDescSuffix + ' the ' + homeTeamName + ' ' + vs + ' ' + awayTeamName + ' ' + leagueName + ' rugby match.';
	    }
	    return meta;
	  }
	};
	
	var modules = {
	
	  setMatchDetails: function setMatchDetails() {
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var rosters = arguments[1];
	    var competition = arguments[2];
	    var boxScore = arguments[3];
	
	
	    var sport = params.sport || 'rugby';
	    var rPlayers = {};
	    var rPlayerOrder = {
	      home: {
	        playerList: [],
	        playerMap: {}
	      },
	      away: {
	        playerList: [],
	        playerMap: {}
	      }
	    };
	    var rTeam = {};
	    var aEventData = [];
	    var penalties = {
	      home: [],
	      away: []
	    };
	    var rGlossary = {
	      teamStats: {},
	      playerStats: {},
	      playerPositons: {}
	    };
	    var teamSize = 15;
	    var subOnId = 8;
	    var subOffId = 7;
	
	    if (sport == 'rugby-league') {
	      subOffId = 17;
	    }
	
	    /* Get Team details from competition node */
	    var aCompetitors = (0, _selectn2.default)('competitors', competition) || [];
	    var iCompetitorLen = aCompetitors !== null ? aCompetitors.length : 0;
	    for (var i = 0; i < iCompetitorLen; i++) {
	      var oTeam = this.setTeamDetails(aCompetitors[i], boxScore, rGlossary);
	      rTeam[oTeam.homeAway] = oTeam;
	    }
	
	    /* Get initial player data from roster node */
	    for (var _i in rosters) {
	
	      /* don't rely on API order for rugby league - NEEDS API amended in future */
	      var currentRoster = rosters[_i].roster || [];
	      if (sport === 'rugby-league') {
	        currentRoster.sort(function (a, b) {
	          if (isNaN(a.jersey) || isNaN(b.jersey)) {
	            return -1;
	          }
	          return parseInt(a.jersey) - parseInt(b.jersey);
	        });
	      }
	
	      for (var x in currentRoster) {
	        var oPlayer = this.setPlayerDetails(sport, currentRoster[x], rGlossary);
	        oPlayer.homeAway = (0, _selectn2.default)('homeAway', rosters[_i]) || '';
	        if (x < teamSize) {
	          oPlayer.onPitch = true;
	          oPlayer.wasActive = true;
	        }
	
	        if (!oPlayer.homeAway) {
	          continue;
	        }
	
	        /* store player in map and in team */
	        rPlayers[oPlayer.id] = oPlayer;
	        rPlayerOrder[oPlayer.homeAway].playerList.push(oPlayer.id);
	        rPlayerOrder[oPlayer.homeAway].playerMap[oPlayer.id] = rPlayerOrder[oPlayer.homeAway].playerList.length - 1;
	      }
	    }
	
	    /* loop every event and build up player activities and times */
	    var aEvents = (0, _selectn2.default)('details', competition) || [];
	    var iEventLen = aEvents !== null ? aEvents.length : 0;
	    var oSub = {};
	    var showOnce = {};
	    for (var _i2 = 0; _i2 < iEventLen; _i2++) {
	      var oEvent = aEvents[_i2];
	      var sType = parseInt((0, _selectn2.default)('type.id', oEvent)) || 0;
	
	      if (SUPRESS_EVENT_DUPLICATES[sType]) {
	        if (!showOnce[sType]) {
	          showOnce[sType] = 1;
	        } else {
	          continue;
	        }
	      }
	
	      var iAthleteId = (0, _selectn2.default)('participants[0].athlete.id', oEvent) || 0;
	      var sEventTime = (0, _selectn2.default)('clock.displayValue', oEvent) || (0, _selectn2.default)('time.displayValue', oEvent) || '';
	      var sEventText = (0, _selectn2.default)('text', oEvent) || (0, _selectn2.default)('type.text', oEvent) || '';
	
	      if (sType <= 8 && sport != 'rugby-league') {
	        sEventText += ' - ' + (0, _selectn2.default)('participants[0].athlete.displayName', oEvent) + ' , ' + (0, _selectn2.default)('team.displayName', oEvent);
	      }
	
	      if (sType != 9999) {
	        sEventText = (0, _ucFirst2.default)(sEventText);
	      }
	
	      /* Store the event data */
	      var oEventData = {
	        type: sType,
	        text: entities.encode(sEventText),
	        /* for performance check to see if has html */
	        time: sEventTime,
	        homeScore: (0, _selectn2.default)('homeScore', oEvent) || 0,
	        awayScore: (0, _selectn2.default)('awayScore', oEvent) || 0
	      };
	      aEventData.push(oEventData);
	
	      if (!iAthleteId || typeof rPlayers[iAthleteId] === 'undefined') {
	        if (sType === 14) {
	          /* Penalty Try */
	          var penTeamId = (0, _selectn2.default)('team.id', oEvent) || 0;
	          if ((0, _selectn2.default)('home.id', rTeam) == penTeamId) {
	            penalties.home.push(sEventTime);
	          } else {
	            penalties.away.push(sEventTime);
	          }
	        }
	        continue;
	      }
	
	      if (sType === subOnId || sType === subOffId) {
	
	        // assume if this tryp then they got some pitch time
	        rPlayers[iAthleteId].wasActive = true;
	        var sTeam = rPlayers[iAthleteId]['homeAway'] || '';
	        var sTime = (0, _selectn2.default)('clock.value', oEvent) || '';
	
	        if (typeof oSub[sTeam] === 'undefined') {
	          oSub[sTeam] = {};
	        }
	
	        if (typeof oSub[sTeam][sTime] === 'undefined') {
	          oSub[sTeam][sTime] = {
	            in: null,
	            out: null
	          };
	        }
	
	        if (sType === subOffId) {
	          oSub[sTeam][sTime].displayTime = sEventTime;
	          oSub[sTeam][sTime].out = iAthleteId;
	          rPlayers[iAthleteId].onPitch = false;
	        } else {
	          oSub[sTeam][sTime].displayTime = sEventTime;
	          oSub[sTeam][sTime].in = iAthleteId;
	          rPlayers[iAthleteId].onPitch = true;
	        }
	      } else {
	        // build an array of every type and time.
	        if (typeof rPlayers[iAthleteId].eventTimes[sType] === 'undefined') {
	          rPlayers[iAthleteId].eventTimes[sType] = [];
	        }
	        rPlayers[iAthleteId].eventTimes[sType].push((0, _selectn2.default)('clock.displayValue', oEvent) || 0);
	      }
	    }
	
	    /* for some reason details can have more data than stats so we now overide player stats data with accumulated detail data */
	    for (var key in rPlayers) {
	      if (!rPlayers.hasOwnProperty(key)) {
	        continue;
	      }
	      for (var eventKey in rPlayers[key].eventTimes) {
	        if (!rPlayers[key].eventTimes.hasOwnProperty(eventKey)) {
	          continue;
	        }
	        if (typeof DETAIL_TO_STATISTIC[eventKey] !== 'undefined') {
	          var _iEventLen = typeof rPlayers[key].eventTimes[eventKey] !== 'undefined' ? rPlayers[key].eventTimes[eventKey].length : 0;
	          rPlayers[key][DETAIL_TO_STATISTIC[eventKey]].value = _iEventLen;
	        }
	      }
	    }
	
	    /* now we know who subbed who we need to map these changes into positions. */
	
	    for (var _sTeam in oSub) {
	      if (oSub.hasOwnProperty(_sTeam)) {
	
	        // sort by time
	        var aTime = (0, _keys2.default)(oSub[_sTeam]).sort();
	        var iLen = aTime.length;
	
	        for (var _i3 = 0; _i3 < iLen; _i3++) {
	          var oSubstitute = oSub[_sTeam][aTime[_i3]];
	
	          if (oSubstitute.in !== null && oSubstitute.out !== null) {
	            /*
	            const iCurrPosIn = rPlayerOrder[sTeam].playerMap[oSubstitute.in]
	            const iCurrPosOut = rPlayerOrder[sTeam].playerMap[oSubstitute.out]
	              // move the player
	            rPlayerOrder[sTeam].playerList[iCurrPosIn] = oSubstitute.out
	            rPlayerOrder[sTeam].playerList[iCurrPosOut] = oSubstitute.in
	            rPlayerOrder[sTeam].playerMap[oSubstitute.out] = iCurrPosIn
	            rPlayerOrder[sTeam].playerMap[oSubstitute.in] = iCurrPosOut
	                // set tooltip text
	            rPlayers[oSubstitute.in].subToolTip = '(' + oSubstitute.displayTime + ') ' + rPlayers[oSubstitute.out].name
	            rPlayers[oSubstitute.in].subbed = true
	            */
	          }
	        }
	      }
	    }
	
	    /* put players into team in order */
	    for (var _sTeam2 in rTeam) {
	      if (rTeam.hasOwnProperty(_sTeam2)) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(rPlayerOrder[_sTeam2].playerList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var iPlayerId = _step.value;
	
	            rTeam[_sTeam2].squad.push(rPlayers[iPlayerId]);
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      }
	    }
	
	    rTeam.events = aEventData.reverse() || [];
	    rTeam.glossary = rGlossary;
	    rTeam.gameState = _common.common.getGameState((0, _selectn2.default)('status.type.state', competition));
	    rTeam.penalties = penalties;
	    return rTeam;
	  },
	
	  setPlayerDetails: function setPlayerDetails() {
	    var sport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'rugby';
	    var rosterData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var glossary = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	
	    var playerUrl = '';
	    if (sport == 'rugby') {
	      playerUrl = (0, _selectn2.default)('athlete.links[0].href', rosterData) || '';
	    }
	    /* Set initial player values and defaults based on roster */
	    var oPlayer = {
	      id: (0, _selectn2.default)('athlete.id', rosterData) || 0,
	      uid: (0, _selectn2.default)('athlete.uid', rosterData) || '',
	      guid: (0, _selectn2.default)('athlete.guid', rosterData) || '',
	      url: playerUrl,
	      name: (0, _selectn2.default)('athlete.displayName', rosterData) || '',
	      number: (0, _selectn2.default)('jersey', rosterData) || 0,
	      position: (0, _selectn2.default)('position.abbreviation', rosterData) || '',
	      captain: (0, _selectn2.default)('capatin', rosterData) || false,
	      subbed: false,
	      homeAway: '',
	      subToolTip: '',
	      eventTimes: {},
	      onPitch: false,
	      wasActive: false
	
	      /* loop filter to build defaults */
	    };for (var key in PLAYER_STATS_FILTER) {
	      if (PLAYER_STATS_FILTER.hasOwnProperty(key)) {
	        oPlayer[key] = {};
	        oPlayer[key].value = '0';
	        oPlayer[key].name = key;
	      }
	    }
	
	    /* loop stats and pull out the filtered stats */
	    var aStats = (0, _selectn2.default)('stats', rosterData) || [];
	    var iStatsLen = aStats !== null ? aStats.length : 0;
	    for (var i = 0; i < iStatsLen; i++) {
	      var oStat = aStats[i];
	      var sStatName = oStat.type;
	      if (PLAYER_STATS_FILTER[sStatName]) {
	        oPlayer[sStatName].value = oStat.displayValue;
	        oPlayer[sStatName].name = oStat.displayName;
	        if (typeof glossary.playerStats[sStatName] === 'undefined') {
	          glossary.playerStats[sStatName] = {};
	          glossary.playerStats[sStatName].abbr = oStat.abbreviation;
	          glossary.playerStats[sStatName].desc = oStat.description || oStat.displayName;
	        }
	      }
	    }
	
	    return oPlayer;
	  },
	
	  setTeamDetails: function setTeamDetails(competitorData, boxScoreData, glossary) {
	
	    var oTeam = {
	      id: (0, _selectn2.default)('id', competitorData) || 0,
	      url: (0, _selectn2.default)('team.links[0].href', competitorData) || '',
	      name: (0, _selectn2.default)('team.displayName', competitorData) || '',
	      abbreviation: (0, _selectn2.default)('team.abbreviation', competitorData) || '',
	      color: (0, _selectn2.default)('team.color', competitorData) ? '#' + (0, _selectn2.default)('team.color', competitorData) : (0, _selectn2.default)('homeAway', competitorData) == 'home' ? '#999' : '#d7d7d7',
	      homeAway: (0, _selectn2.default)('homeAway', competitorData) || '',
	      form: (0, _selectn2.default)('form', competitorData) || '',
	      winner: (0, _selectn2.default)('winner', competitorData) || false,
	      squad: [],
	      logo: _common.common.getTeamLogo((0, _selectn2.default)('team', competitorData) || {})
	
	      /* loop filter to build defaults */
	    };for (var key in TEAM_STATS_FILTER) {
	      if (TEAM_STATS_FILTER.hasOwnProperty(key)) {
	        oTeam[key] = {};
	        oTeam[key].value = '0';
	        oTeam[key].name = '';
	      }
	    }
	
	    /* find the team stats in the boxscore and pull out the filtered values */
	    var iTeamAId = (0, _selectn2.default)('teams[0].team.id', boxScoreData) || 0;
	    var aStats = iTeamAId === oTeam.id ? (0, _selectn2.default)('teams[0].statistics[0].stats', boxScoreData) || [] : (0, _selectn2.default)('teams[1].statistics[0].stats', boxScoreData) || [];
	    var iStatsLen = aStats !== null ? aStats.length : 0;
	    for (var i = 0; i < iStatsLen; i++) {
	      var oStat = aStats[i];
	      var sStatName = oStat.type;
	      if (TEAM_STATS_FILTER[sStatName]) {
	        oTeam[sStatName].name = oStat.displayName;
	        if (sStatName === 'possession' || sStatName === 'territory' || sStatName === 'kickpercentsuccess' || sStatName === 'pcpossessionfirst' || sStatName === 'pcterritoryfirst' || sStatName === 'pcpossessionsecond' || sStatName === 'pcterritorysecond') {
	          oTeam[sStatName].value = helpers.roundValue(Math.round(oStat.displayValue * 100));
	        } else {
	          oTeam[sStatName].value = oStat.displayValue;
	        }
	        if (typeof glossary.teamStats[sStatName] === 'undefined') {
	          glossary.teamStats[sStatName] = {};
	          glossary.teamStats[sStatName].abbr = oStat.abbreviation;
	          glossary.teamStats[sStatName].desc = oStat.description || oStat.displayName;
	        }
	      }
	    }
	
	    return oTeam;
	  },
	
	  getMatchDetails: function getMatchDetails(edition, gameInfo, competition) {
	
	    var attendance = (0, _selectn2.default)('attendance', gameInfo) || 0;
	    var capacity = (0, _selectn2.default)('venue.capacity', gameInfo) || 0;
	    var date = competition.date || '';
	    var percent = 0;
	
	    if (attendance && capacity) {
	      percent = helpers.percentValue(capacity, attendance);
	      if (percent > 100) {
	        percent = 100;
	      }
	    }
	
	    attendance = helpers.formatNubmer(attendance);
	    capacity = helpers.formatNubmer(capacity);
	
	    if (date !== '') {
	      date = _dateformat2.default.dateFormat(date, 'dateTime1', edition.timeZoneBucket);
	    }
	
	    return {
	      coverage: '',
	      venue: (0, _selectn2.default)('venue.fullName', gameInfo) || (0, _selectn2.default)('venue.shortName', gameInfo) || '',
	      address: (0, _selectn2.default)('venue.address.summry', gameInfo) || '',
	      attendance: attendance,
	      percent: percent,
	      capacity: capacity,
	      date: date,
	      text: {
	        attendance: (0, _translate2.default)(edition, 'Attendance'),
	        heading: (0, _translate2.default)(edition, 'Game Info'),
	        capacity: (0, _translate2.default)(edition, 'Capacity'),
	        venue: (0, _translate2.default)(edition, 'Venue'),
	        coverage: (0, _translate2.default)(edition, 'Coverage')
	      }
	    };
	  },
	
	  getArticle: function getArticle() {
	    var articleData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	    var sport = params.sport || 'rugby';
	    var articleLink = (0, _selectn2.default)('links.web.href', articleData) || '';
	    var isWebView = params.platform ? true : false;
	    var oArticle = {
	      id: (0, _selectn2.default)('id', articleData) || 0,
	      type: (0, _selectn2.default)('type', articleData) || 0,
	      headline: (0, _selectn2.default)('headline', articleData) || '',
	      description: (0, _selectn2.default)('description', articleData) || '',
	      source: (0, _selectn2.default)('byline', articleData) || '',
	      date: (0, _selectn2.default)('originallyPosted', articleData) || (0, _selectn2.default)('lastModified', articleData) || '',
	      href: articleLink,
	      video: (0, _selectn2.default)('video', articleData) || {},
	      images: (0, _selectn2.default)('images', articleData) || []
	
	      //let editionsHost = this.window ? this.window.location.host : 'www.espn.co.uk'
	      //this.data.Article.link = espnURL(this.data.Article.link,editionsHost);
	
	      // Due to the migration of the links the url is wrong this will correct it
	    };if (articleLink.indexOf('recap') > -1 || articleLink.indexOf('report') > -1) {
	      articleLink = _common.common.createHref({
	        pageType: 'report',
	        sport: sport,
	        league: params.league,
	        gameId: params.gameId,
	        platform: params.platform,
	        webview: params.webview
	      });
	    } else if (articleLink.indexOf('preview') > -1) {
	      articleLink = _common.common.createHref({
	        pageType: 'preview',
	        sport: sport,
	        league: params.league,
	        gameId: params.gameId,
	        platform: params.platform,
	        webview: params.webview
	      });
	    }
	
	    oArticle.href = !isWebView ? _common.common.buildURL(articleLink) : articleLink;
	
	    return oArticle;
	  },
	
	  getMatchStats: function getMatchStats(edition, params, query, data, boxScoreNode) {
	
	    var sport = params.sport || 'rugby';
	    var lang = edition && edition.language;
	    var isTeamLinkActive = _common.common.getIsTeamLinkActive(params.sport, lang);
	    var possessionText = (0, _selectn2.default)('away.possession.name', data) || '';
	    var territoryText = (0, _selectn2.default)('away.territory.name', data) || '';
	    var statsNode = (0, _selectn2.default)('teams[0].statistics', boxScoreNode) || [];
	    var isStatsAvailable = !!statsNode.length;
	    return {
	      sport: sport,
	      isStatsAvailable: isStatsAvailable,
	      title: (0, _translate2.default)(edition, 'Match Stats'),
	      link: _common.common.buildLinkObject({
	        text: (0, _translate2.default)(edition, 'Full Match Stats'),
	        tracking: [sport, 'game', 'subnav', 'matchstats'],
	        params: {
	          pageType: 'matchstats',
	          sport: sport,
	          league: params.league,
	          gameId: params.gameId,
	          platform: params.platform,
	          webview: params.webview
	        },
	        query: query,
	        edition: edition
	      }),
	      home: {
	        name: (0, _selectn2.default)('home.abbreviation', data),
	        logo: (0, _selectn2.default)('home.logo', data),
	        color: (0, _selectn2.default)('home.color', data)
	      },
	      away: {
	        name: (0, _selectn2.default)('away.abbreviation', data),
	        logo: (0, _selectn2.default)('away.logo', data),
	        color: (0, _selectn2.default)('away.color', data)
	      },
	      table: [{
	        homeValue: (0, _selectn2.default)('home.runs.value', data),
	        awayValue: (0, _selectn2.default)('away.runs.value', data),
	        text: (0, _selectn2.default)('away.runs.name', data)
	      }, {
	        homeValue: (0, _selectn2.default)('home.metres.value', data),
	        awayValue: (0, _selectn2.default)('away.metres.value', data),
	        text: (0, _selectn2.default)('away.metres.name', data)
	      }, {
	        homeValue: (0, _selectn2.default)('home.cleanbreaks.value', data),
	        awayValue: (0, _selectn2.default)('away.cleanbreaks.value', data),
	        text: (0, _selectn2.default)('away.cleanbreaks.name', data)
	      }, {
	        homeValue: (0, _selectn2.default)('home.tackles.value', data),
	        awayValue: (0, _selectn2.default)('away.tackles.value', data),
	        text: (0, _selectn2.default)('away.tackles.name', data)
	      }, {
	        homeValue: (0, _selectn2.default)('home.missedtackles.value', data),
	        awayValue: (0, _selectn2.default)('away.missedtackles.value', data),
	        text: (0, _selectn2.default)('away.missedtackles.name', data)
	      }, {
	        homeValue: (0, _selectn2.default)('home.turnoverknockon.value', data),
	        awayValue: (0, _selectn2.default)('away.turnoverknockon.value', data),
	        text: (0, _selectn2.default)('away.turnoverknockon.name', data)
	      }],
	      dataVis: [{
	        homeValue: (0, _selectn2.default)('home.possession.value', data),
	        awayValue: (0, _selectn2.default)('away.possession.value', data),
	        homeText: (0, _selectn2.default)('home.possession.value', data) ? (0, _selectn2.default)('home.possession.value', data) + '%' : '0%',
	        awayText: (0, _selectn2.default)('away.possession.value', data) ? (0, _selectn2.default)('away.possession.value', data) + '%' : '0%',
	        text: (0, _translate2.default)(edition, possessionText)
	      }, {
	        homeValue: (0, _selectn2.default)('home.territory.value', data),
	        awayValue: (0, _selectn2.default)('away.territory.value', data),
	        homeText: (0, _selectn2.default)('home.territory.value', data) ? (0, _selectn2.default)('home.territory.value', data) + '%' : '0%',
	        awayText: (0, _selectn2.default)('away.territory.value', data) ? (0, _selectn2.default)('away.territory.value', data) + '%' : '0%',
	        text: (0, _translate2.default)(edition, territoryText)
	      }],
	      isTeamLinkActive: isTeamLinkActive // Added to check active/inactive team links
	    };
	  },
	
	  getMatchEvents: function getMatchEvents(edition, data) {
	
	    var percVal = helpers.percentValue([(0, _selectn2.default)('home.metres.value', data), (0, _selectn2.default)('away.metres.value', data)], (0, _selectn2.default)('home.metres.value', data));
	
	    return {
	      title: [(0, _translate2.default)(edition, 'Match Events'), (0, _translate2.default)(edition, 'Kick/Pass/Run')],
	      split: true,
	      home: {
	        name: (0, _selectn2.default)('home.abbreviation', data),
	        logo: (0, _selectn2.default)('home.logo', data),
	        color: (0, _selectn2.default)('home.color', data)
	      },
	      away: {
	        name: (0, _selectn2.default)('away.abbreviation', data),
	        logo: (0, _selectn2.default)('away.logo', data),
	        color: (0, _selectn2.default)('away.color', data)
	      },
	      col: [[{
	        type: 'table',
	        data: [{
	          homeValue: (0, _selectn2.default)('home.tries.value', data),
	          awayValue: (0, _selectn2.default)('away.tries.value', data),
	          text: (0, _selectn2.default)('away.tries.name', data)
	        }, {
	          homeValue: (0, _selectn2.default)('home.conversiongoals.value', data),
	          awayValue: (0, _selectn2.default)('away.conversiongoals.value', data),
	          text: (0, _selectn2.default)('away.conversiongoals.name', data)
	        }, {
	          homeValue: (0, _selectn2.default)('home.penaltygoals.value', data),
	          awayValue: (0, _selectn2.default)('away.penaltygoals.value', data),
	          text: (0, _selectn2.default)('away.penaltygoals.name', data)
	        }, {
	          homeValue: (0, _selectn2.default)('home.kickpercentsuccess.value', data) ? (0, _selectn2.default)('home.kickpercentsuccess.value', data) + '%' : '0%',
	          awayValue: (0, _selectn2.default)('away.kickpercentsuccess.value', data) ? (0, _selectn2.default)('away.kickpercentsuccess.value', data) + '%' : '0%',
	          text: (0, _selectn2.default)('away.kickpercentsuccess.name', data) || 'Kick at Goal Success'
	        }]
	      }], [{
	        type: 'dataVis',
	        data: {
	          homeValue: percVal,
	          homeText: (0, _selectn2.default)('home.metres.value', data),
	          awayText: (0, _selectn2.default)('away.metres.value', data),
	          text: (0, _selectn2.default)('away.metres.name', data)
	        }
	      }, {
	        type: 'table',
	        data: [{
	          homeValue: (0, _selectn2.default)('home.kicksfromhand.value', data),
	          awayValue: (0, _selectn2.default)('away.kicksfromhand.value', data),
	          text: (0, _selectn2.default)('away.kicksfromhand.name', data)
	        }, {
	          homeValue: (0, _selectn2.default)('home.passes.value', data),
	          awayValue: (0, _selectn2.default)('away.passes.value', data),
	          text: (0, _selectn2.default)('away.passes.name', data)
	        }, {
	          homeValue: (0, _selectn2.default)('home.runs.value', data),
	          awayValue: (0, _selectn2.default)('away.runs.value', data),
	          text: (0, _selectn2.default)('away.runs.name', data)
	        }]
	      }]]
	    };
	  },
	
	  getMatchAttacking: function getMatchAttacking(edition, data) {
	
	    var homePos = (0, _selectn2.default)('home.pcpossessionfirst.value', data) + '% / ' + (0, _selectn2.default)('home.pcpossessionsecond.value', data) + '%';
	    var awayPos = (0, _selectn2.default)('away.pcpossessionfirst.value', data) + '% / ' + (0, _selectn2.default)('away.pcpossessionsecond.value', data) + '%';
	    var homeTer = (0, _selectn2.default)('home.pcterritoryfirst.value', data) + '% / ' + (0, _selectn2.default)('home.pcterritorysecond.value', data) + '%';
	    var awayTer = (0, _selectn2.default)('away.pcterritoryfirst.value', data) + '% / ' + (0, _selectn2.default)('away.pcterritorysecond.value', data) + '%';
	    var homeRuck = (0, _selectn2.default)('home.ruckswon.value', data) + ' / ' + (0, _selectn2.default)('home.ruckstotal.value', data) + ' (' + helpers.percentValue((0, _selectn2.default)('home.ruckstotal.value', data), (0, _selectn2.default)('home.ruckswon.value', data)) + '%)';
	    var awayRuck = (0, _selectn2.default)('away.ruckswon.value', data) + ' / ' + (0, _selectn2.default)('away.ruckstotal.value', data) + ' (' + helpers.percentValue((0, _selectn2.default)('away.ruckstotal.value', data), (0, _selectn2.default)('away.ruckswon.value', data)) + '%)';
	    var homeMaul = (0, _selectn2.default)('home.maulswon.value', data) + ' / ' + (0, _selectn2.default)('home.maulstotal.value', data) + ' (' + helpers.percentValue((0, _selectn2.default)('home.maulstotal.value', data), (0, _selectn2.default)('home.maulswon.value', data)) + '%)';
	    var awayMaul = (0, _selectn2.default)('away.maulswon.value', data) + ' / ' + (0, _selectn2.default)('away.maulstotal.value', data) + ' (' + helpers.percentValue((0, _selectn2.default)('away.maulstotal.value', data), (0, _selectn2.default)('away.maulswon.value', data)) + '%)';
	
	    return {
	      title: (0, _translate2.default)(edition, 'Attacking'),
	      split: false,
	      home: {
	        name: (0, _selectn2.default)('home.abbreviation', data),
	        logo: (0, _selectn2.default)('home.logo', data),
	        color: (0, _selectn2.default)('home.color', data)
	      },
	      away: {
	        name: (0, _selectn2.default)('away.abbreviation', data),
	        logo: (0, _selectn2.default)('away.logo', data),
	        color: (0, _selectn2.default)('away.color', data)
	      },
	      col: [[{
	        type: 'dataVis',
	        data: {
	          homeValue: (0, _selectn2.default)('home.possession.value', data),
	          awayValue: (0, _selectn2.default)('away.possession.value', data),
	          homeText: (0, _selectn2.default)('home.possession.value', data) ? (0, _selectn2.default)('home.possession.value', data) + '%' : '0%',
	          awayText: (0, _selectn2.default)('away.possession.value', data) ? (0, _selectn2.default)('away.possession.value', data) + '%' : '0%',
	          text: (0, _selectn2.default)('away.possession.name', data)
	        }
	      }, {
	        type: 'dataVis',
	        size: 'large',
	        data: {
	          homeValue: (0, _selectn2.default)('home.territory.value', data),
	          awayValue: (0, _selectn2.default)('away.territory.value', data),
	          homeText: (0, _selectn2.default)('home.territory.value', data) ? (0, _selectn2.default)('home.territory.value', data) + '%' : '0%',
	          awayText: (0, _selectn2.default)('away.territory.value', data) ? (0, _selectn2.default)('away.territory.value', data) + '%' : '0%',
	          text: (0, _selectn2.default)('away.territory.name', data)
	        }
	      }], [{
	        type: 'table',
	        data: [{
	          homeValue: homePos,
	          awayValue: awayPos,
	          text: (0, _translate2.default)(edition, 'Possession 1H/2H')
	        }, {
	          homeValue: homeTer,
	          awayValue: awayTer,
	          text: (0, _translate2.default)(edition, 'Territory 1H/2H')
	        }, {
	          homeValue: (0, _selectn2.default)('home.cleanbreaks.value', data),
	          awayValue: (0, _selectn2.default)('away.cleanbreaks.value', data),
	          text: (0, _selectn2.default)('away.cleanbreaks.name', data)
	        }, {
	          homeValue: (0, _selectn2.default)('home.defendersbeaten.value', data),
	          awayValue: (0, _selectn2.default)('away.defendersbeaten.value', data),
	          text: (0, _selectn2.default)('away.defendersbeaten.name', data)
	        }, {
	          homeValue: (0, _selectn2.default)('home.offload.value', data),
	          awayValue: (0, _selectn2.default)('away.offload.value', data),
	          text: (0, _selectn2.default)('away.offload.name', data)
	        }, {
	          homeValue: homeRuck,
	          awayValue: awayRuck,
	          text: (0, _selectn2.default)('away.ruckswon.name', data)
	        }, {
	          homeValue: homeMaul,
	          awayValue: awayMaul,
	          text: (0, _selectn2.default)('away.maulswon.name', data)
	        }, {
	          homeValue: (0, _selectn2.default)('home.turnoversconceded.value', data),
	          awayValue: (0, _selectn2.default)('away.turnoversconceded.value', data),
	          text: (0, _selectn2.default)('away.turnoversconceded.name', data)
	        }]
	      }]]
	    };
	  },
	
	  getMatchAttackingRL: function getMatchAttackingRL(edition, data) {
	
	    var homePos = (0, _selectn2.default)('home.pcpossessionfirst.value', data) + '% / ' + (0, _selectn2.default)('home.pcpossessionsecond.value', data) + '%';
	    var awayPos = (0, _selectn2.default)('away.pcpossessionfirst.value', data) + '% / ' + (0, _selectn2.default)('away.pcpossessionsecond.value', data) + '%';
	    var homeTer = (0, _selectn2.default)('home.pcterritoryfirst.value', data) + '% / ' + (0, _selectn2.default)('home.pcterritorysecond.value', data) + '%';
	    var awayTer = (0, _selectn2.default)('away.pcterritoryfirst.value', data) + '% / ' + (0, _selectn2.default)('away.pcterritorysecond.value', data) + '%';
	
	    return {
	      title: [(0, _translate2.default)(edition, 'Attacking'), (0, _translate2.default)(edition, 'Defending')],
	      split: true,
	      home: {
	        name: (0, _selectn2.default)('home.abbreviation', data),
	        logo: (0, _selectn2.default)('home.logo', data),
	        color: (0, _selectn2.default)('home.color', data)
	      },
	      away: {
	        name: (0, _selectn2.default)('away.abbreviation', data),
	        logo: (0, _selectn2.default)('away.logo', data),
	        color: (0, _selectn2.default)('away.color', data)
	      },
	      col: [[{
	        type: 'table',
	        data: [{
	          homeValue: homePos,
	          awayValue: awayPos,
	          text: (0, _translate2.default)(edition, 'Possession 1H/2H')
	        }, {
	          homeValue: homeTer,
	          awayValue: awayTer,
	          text: (0, _translate2.default)(edition, 'Territory 1H/2H')
	        }, {
	          homeValue: (0, _selectn2.default)('home.cleanbreaks.value', data),
	          awayValue: (0, _selectn2.default)('away.cleanbreaks.value', data),
	          text: (0, _selectn2.default)('away.cleanbreaks.name', data)
	        }, {
	          homeValue: (0, _selectn2.default)('home.defendersbeaten.value', data),
	          awayValue: (0, _selectn2.default)('away.defendersbeaten.value', data),
	          text: (0, _selectn2.default)('away.defendersbeaten.name', data)
	        }, {
	          homeValue: (0, _selectn2.default)('home.offload.value', data),
	          awayValue: (0, _selectn2.default)('away.offload.value', data),
	          text: (0, _selectn2.default)('away.offload.name', data)
	        }, {
	          homeValue: (0, _selectn2.default)('home.turnoversconceded.value', data),
	          awayValue: (0, _selectn2.default)('away.turnoversconceded.value', data),
	          text: (0, _selectn2.default)('away.turnoversconceded.name', data)
	        }]
	      }], [{
	        type: 'dataVisPie',
	        data: {
	          homeTotal: (0, _selectn2.default)('home.tackles.value', data),
	          homeWon: (0, _selectn2.default)('home.tackles.value', data) - (0, _selectn2.default)('home.missedtackles.value', data),
	          awayTotal: (0, _selectn2.default)('away.tackles.value', data),
	          awayWon: (0, _selectn2.default)('away.tackles.value', data) - (0, _selectn2.default)('away.missedtackles.value', data),
	          text: (0, _selectn2.default)('away.tackles.name', data)
	        }
	      }]]
	    };
	  },
	
	  getMatchDefending: function getMatchDefending(edition, data) {
	
	    return {
	      title: [(0, _translate2.default)(edition, 'Set Pieces'), (0, _translate2.default)(edition, 'Defending')],
	      split: true,
	      home: {
	        name: (0, _selectn2.default)('home.abbreviation', data) || 'TBC',
	        logo: (0, _selectn2.default)('home.logo', data) || '',
	        color: (0, _selectn2.default)('home.color', data) || ''
	      },
	      away: {
	        name: (0, _selectn2.default)('away.abbreviation', data) || 'TBC',
	        logo: (0, _selectn2.default)('away.logo', data) || '',
	        color: (0, _selectn2.default)('away.color', data) || ''
	      },
	      col: [[{
	        type: 'dataVisIcons',
	        data: {
	          homeTotal: (0, _selectn2.default)('home.scrumstotal.value', data),
	          homeWon: (0, _selectn2.default)('home.scrumswon.value', data),
	          awayTotal: (0, _selectn2.default)('away.scrumstotal.value', data),
	          awayWon: (0, _selectn2.default)('away.scrumswon.value', data),
	          text: (0, _selectn2.default)('away.scrumswon.name', data)
	        }
	      }, {
	        type: 'dataVisIcons',
	        data: {
	          homeTotal: (0, _selectn2.default)('home.totallineouts.value', data),
	          homeWon: (0, _selectn2.default)('home.lineoutswon.value', data),
	          awayTotal: (0, _selectn2.default)('away.totallineouts.value', data),
	          awayWon: (0, _selectn2.default)('away.lineoutswon.value', data),
	          text: (0, _selectn2.default)('away.lineoutswon.name', data)
	        }
	      }], [{
	        type: 'dataVisPie',
	        data: {
	          homeTotal: (0, _selectn2.default)('home.tackles.value', data),
	          homeWon: (0, _selectn2.default)('home.tackles.value', data) - (0, _selectn2.default)('home.missedtackles.value', data),
	          awayTotal: (0, _selectn2.default)('away.tackles.value', data),
	          awayWon: (0, _selectn2.default)('away.tackles.value', data) - (0, _selectn2.default)('away.missedtackles.value', data),
	          text: (0, _selectn2.default)('away.tackles.name', data)
	        }
	      }]]
	    };
	  },
	
	  getMatchDefendingRL: function getMatchDefendingRL() {
	    return {};
	  },
	
	  getMatchDiscipline: function getMatchDiscipline(edition, data) {
	
	    return {
	      title: (0, _translate2.default)(edition, 'Discipline'),
	      split: false,
	      home: {
	        name: (0, _selectn2.default)('home.abbreviation', data) || 'TBC',
	        logo: (0, _selectn2.default)('home.logo', data) || '',
	        color: (0, _selectn2.default)('home.color', data) || ''
	      },
	      away: {
	        name: (0, _selectn2.default)('away.abbreviation', data) || 'TBC',
	        logo: (0, _selectn2.default)('away.logo', data) || '',
	        color: (0, _selectn2.default)('away.color', data) || ''
	      },
	      col: [[{
	        type: 'dataVisCount',
	        data: {
	          homeTotal: (0, _selectn2.default)('home.penaltiesconceded.value', data),
	          homeWon: (0, _selectn2.default)('home.penaltiesconceded.value', data),
	          awayTotal: (0, _selectn2.default)('away.penaltiesconceded.value', data),
	          awayWon: (0, _selectn2.default)('away.penaltiesconceded.value', data),
	          text: (0, _selectn2.default)('away.penaltiesconceded.name', data)
	        }
	      }], [{
	        type: 'table',
	        data: [{
	          homeValue: (0, _selectn2.default)('home.redcards.value', data),
	          awayValue: (0, _selectn2.default)('away.redcards.value', data),
	          text: (0, _selectn2.default)('away.redcards.name', data)
	        }, {
	          homeValue: (0, _selectn2.default)('home.yellowcards.value', data),
	          awayValue: (0, _selectn2.default)('away.yellowcards.value', data),
	          text: (0, _selectn2.default)('away.yellowcards.name', data)
	        }, {
	          homeValue: (0, _selectn2.default)('home.totalfreekicksconceded.value', data),
	          awayValue: (0, _selectn2.default)('away.totalfreekicksconceded.value', data),
	          text: (0, _selectn2.default)('away.totalfreekicksconceded.name', data)
	        }]
	      }]]
	    };
	  },
	
	  /*
	  getTeamStats: function(oData){
	    // takes the home team and the away team and searches the table if available to calculate the positions.
	    var aStatsBox = [];
	    if(typeof oData !== 'undefined' &&
	      typeof oData.standings !== 'undefined' &&
	      typeof oData.standings.children !== 'undefined'
	    ){
	      var aGroups     = oData.standings.children || [];
	      var oStandings  = {};
	      var iGroupLen   = aGroups.length;
	      var hHomeTeam   = this.getHomeTeam();
	      var hAwayTeam   = this.getAwayTeam();
	      var bFound      = false;
	      var aEntries    = [];
	        if(iGroupLen > 1){
	        // we have more then 1 group we need to find the correct group
	        for (var i = 0; i < iGroupLen; i++) {
	          oStandings = aGroups[i];
	          aEntries = (oStandings.standings && oStandings.standings.entries) ? oStandings.standings.entries : [];
	          for (var x = 0; x < aEntries.length; x++) {
	            var hTeam = aEntries[x];
	            if(hTeam.team.id == hHomeTeam.id){
	               bFound = true;
	            }
	            if(bFound){
	               break;
	            }
	          }
	          if(bFound){
	            break;
	          }
	        }
	      }else{
	        // only one group so must be in that group
	        oStandings = aGroups[0];
	        aEntries = (oStandings.standings && oStandings.standings.entries) ? oStandings.standings.entries : [];
	      }
	        var iEntryLen   = aEntries.length;
	      var hStatsData  = {};
	        for (var x = 0; x < iEntryLen; x++) {
	          var hTeam = aEntries[x];
	          for (var j = 0; j < hTeam.stats.length; j++) {
	              if(typeof hStatsData[hTeam.stats[j].type] === 'undefined'){
	                  hStatsData[hTeam.stats[j].type] = [];
	              }
	              var hTmpdata = {
	                  value: (hTeam.stats[j].value*1),
	                  description: hTeam.stats[j].description,
	                  displayValue: hTeam.stats[j].displayValue,
	                  team: hTeam.team.id
	              };
	              hStatsData[hTeam.stats[j].type].push(hTmpdata);
	          }
	      }
	        // if neither team has played again don't show the stats.
	      if(typeof hStatsData['gamesplayed'] !== 'undefined'){
	        if(typeof hStatsData['gamesplayed'][0] !== 'undefined' && hStatsData['gamesplayed'][0].value == 0 && typeof hStatsData['gamesplayed'][1] !== 'undefined' && hStatsData['gamesplayed'][1].value == 0){
	          return;
	        }
	      }else{
	        return; // no played data so i assume never played.
	      }
	        // priority order of the stats, so if i can't find 1 move on to the next
	      var aPriorityStats  = ['pointsfor','pointsagainst','pointsdifference','triesfor','triesagainst','triesdifference','gameswon','gameslost','gamesdrawn','bonuspoints','bonuspointslosing','bonuspointstry','gamesbye','points','gamesplayed'];
	      var aReverseStats   = [true,false,true,true,false,true,true,false,true,true,false,true,true,true,true];
	      var iPriorityLen = aPriorityStats.length;
	      var aStatsToSort = [];
	      for (var x = 0; x < iPriorityLen; x++) {
	        if(typeof hStatsData[aPriorityStats[x]] !== 'undefined'){
	          aStatsToSort.push(aPriorityStats[x]) ;
	        }
	        if(aStatsToSort.length >= 4){
	          break;
	        }
	      }
	        // sort each piece of data
	      var iStatLen = aStatsToSort.length;
	      for (var x = 0; x < iStatLen; x++) {
	          var aStats = hStatsData[aStatsToSort[x]];
	          var aSorted = aStats.sort(fValueCompare);
	          var bReverse = aReverseStats[x] || false;
	          if(bReverse){
	              aSorted.reverse();
	          }
	            // loop the records looking for teams
	          var iSortedLen = aSorted.length;
	          var hBoxData = {
	              name: aSorted[0].description,
	              home:{
	                  abbreviation:'',
	                  position:0,
	                  value:0,
	                  displayValue:0
	              },
	              away:{
	                  abbreviation:'',
	                  position:0,
	                  value:0,
	                  displayValue:0
	              }
	          };
	          var iTeamWatch = 0;
	          for (var i = 0; i < iSortedLen; i++) {
	              var oStatData = aSorted[i];
	              if(oStatData.team == hHomeTeam.id){
	                  hBoxData.home.color = hHomeTeam.color;
	                  hBoxData.home.abbreviation = hHomeTeam.abbreviation;
	                  hBoxData.home.position = i+1;
	                  hBoxData.home.value = oStatData.value;
	                  hBoxData.home.displayValue = oStatData.displayValue;
	                  iTeamWatch++;
	              }else if(oStatData.team == hAwayTeam.id){
	                  hBoxData.away.color = hAwayTeam.color;
	                  hBoxData.away.abbreviation = hAwayTeam.abbreviation;
	                  hBoxData.away.position = i+1;
	                  hBoxData.away.value = oStatData.value;
	                  hBoxData.away.displayValue = oStatData.displayValue;
	                  iTeamWatch++;
	              }
	          }
	          // if we have found at least 1 team allow it to continue.
	          if(iTeamWatch == 2){
	              aStatsBox.push(hBoxData);
	          }
	      }
	        function fValueCompare(a,b) {
	        if(a.value < b.value){
	          return -1;
	        }
	        if(a.value > b.value){
	          return 1;
	        }
	        return 0;
	      }
	    }
	    this.data.teamStatsBox = aStatsBox;
	  },
	  */
	
	  getMatchLineUp: function getMatchLineUp(edition, params, data) {
	
	    var teamSize = params.sport === 'rugby-league' ? 13 : 15; /* split the team here */
	    var homeSquad = (0, _selectn2.default)('home.squad', data) || [];
	    var homeTeam = homeSquad.slice(0, teamSize);
	    var homeReserve = homeSquad.slice(teamSize);
	    var awaySquad = (0, _selectn2.default)('away.squad', data) || [];
	    var awayTeam = awaySquad.slice(0, teamSize);
	    var awayReserve = awaySquad.slice(teamSize);
	    var show = homeTeam.length > 0 && awayTeam.length > 0;
	
	    return {
	      text: {
	        col2: (0, _translate2.default)(edition, 'No.'),
	        col3: (0, _translate2.default)(edition, 'Name'),
	        split: (0, _translate2.default)(edition, 'Replacements'),
	        scoring: (0, _translate2.default)(edition, 'Scoring'),
	        attacking: (0, _translate2.default)(edition, 'Attacking'),
	        defending: (0, _translate2.default)(edition, 'Defending'),
	        discipline: (0, _translate2.default)(edition, 'Discipline'),
	        note: (0, _translate2.default)(edition, '*Players currently on the pitch are shown in bold')
	      },
	      home: {
	        name: (0, _selectn2.default)('home.abbreviation', data),
	        logo: (0, _selectn2.default)('home.logo', data),
	        team: homeTeam || [],
	        reserves: homeReserve || []
	      },
	      away: {
	        name: (0, _selectn2.default)('away.abbreviation', data),
	        logo: (0, _selectn2.default)('away.logo', data),
	        team: awayTeam || [],
	        reserves: awayReserve || []
	      },
	      gameState: (0, _selectn2.default)('gameState', data),
	      sport: params.sport,
	      show: show
	    };
	  },
	
	  getGlossary: function getGlossary(edition) {
	    var sport = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'rugby';
	    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	
	    if (sport === 'rugby-league') {
	      delete data.glossary.teamStats.lineoutwonsteal;
	      delete data.glossary.teamStats.lineoutswon;
	      delete data.glossary.playerStats.lineoutwonsteal;
	      delete data.glossary.playerStats.lineoutswon;
	    }
	
	    data.glossary.glossaryTitle = (0, _translate2.default)(edition, 'Glossary') || '';
	
	    return data.glossary;
	  },
	
	  getStandings: function getStandings(edition, standingsNode, params) {
	
	    var typesToShow = [/* stats type in order of display + special team to show teamname */
	    'rank', 'team', 'gamesplayed', 'pointsdifference', 'points'];
	
	    var standingsCopy = (0, _assign2.default)({}, standingsNode);
	    standingsCopy.name = (0, _translate2.default)(edition, 'Standings');
	
	    var standings = _common.common.getStandingsData(standingsCopy, typesToShow, params.sport, 'gamepackage', edition);
	    var standingsLink = helpers.getStandingsLink(edition, params);
	
	    return (0, _extends3.default)({}, standings, { link: (0, _extends3.default)({}, standingsLink, { external: false }) });
	  },
	
	  getMatchCommentary: function getMatchCommentary(edition, params, query, data) {
	    return {
	      text: {
	        viewAll: (0, _translate2.default)(edition, 'Match Commentary'),
	        viewKey: (0, _translate2.default)(edition, 'Key Events'),
	        allBtn: (0, _translate2.default)(edition, 'All Commentary'),
	        keyBtn: (0, _translate2.default)(edition, 'Key Events')
	      },
	      sport: params.sport,
	      events: (0, _selectn2.default)('events', data) || [],
	      link: _common.common.buildLinkObject({
	        text: (0, _translate2.default)(edition, 'Full Commentary'),
	        tracking: ['rugby', 'game', 'subnav', 'commentary'],
	        params: {
	          pageType: 'commentary',
	          sport: params.sport,
	          league: params.league,
	          gameId: params.gameId,
	          platform: params.platform,
	          webview: params.webview
	        },
	        query: query,
	        edition: edition
	      })
	    };
	  },
	
	  getLastFive: function getLastFive(edition, params, data, teamId) {
	    var headToHead = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	    var query = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
	
	
	    var dataLen = data.length;
	    var currTeam = {};
	    for (var i = 0; i < dataLen; i++) {
	      var dataTeamId = (0, _selectn2.default)('team.id', data[i]) || 0;
	      if (dataTeamId === teamId) {
	        currTeam = data[i];
	        break;
	      }
	    }
	
	    var dataEvents = (0, _selectn2.default)('events', currTeam) || [];
	    var evtLen = dataEvents.length;
	    var homeTeamURL = _common.common.buildURL((0, _selectn2.default)('team.links[0].href', currTeam) || '#');
	    var homeTeamLink = _common.common.buildLinkObject({
	      tracking: ['rugby', 'game', 'subnav', 'history'],
	      href: homeTeamURL,
	      edition: edition
	    });
	
	    var team = {
	      name: (0, _selectn2.default)('team.abbreviation', currTeam) || (0, _selectn2.default)('team.displayName', currTeam) || '',
	      abbreviation: (0, _selectn2.default)('team.abbreviation', currTeam) || '',
	      logo: _common.common.getTeamLogo((0, _selectn2.default)('team', currTeam)) || '',
	      link: homeTeamLink || {},
	      uid: (0, _selectn2.default)('team.uid', currTeam) || ''
	    };
	    var events = [];
	
	    for (var _i4 = 0; _i4 < evtLen; _i4++) {
	
	      var eventDetails = dataEvents[_i4];
	      var awayTeamURL = _common.common.buildURL((0, _selectn2.default)('opponent.links[0].href', eventDetails) || '#');
	      var awayTeamLink = _common.common.buildLinkObject({
	        tracking: ['rugby', 'game', 'subnav', 'history'],
	        href: awayTeamURL,
	        edition: edition
	      });
	      var opposition = {
	        name: (0, _selectn2.default)('opponent.abbreviation', eventDetails) || (0, _selectn2.default)('opponent.displayName', eventDetails) || '',
	        abbreviation: (0, _selectn2.default)('opponent.abbreviation', eventDetails) || '',
	        logo: _common.common.getTeamLogo((0, _selectn2.default)('opponent', eventDetails)) || '',
	        link: awayTeamLink || {},
	        uid: (0, _selectn2.default)('opponent.uid', eventDetails) || ''
	      };
	
	      var matchURL = _common.common.buildURL((0, _selectn2.default)('links[0].href', eventDetails) || '#');
	      //open match head to head links in app itself
	      //but top stories will not refresh, need to fix
	
	      if (params.platform && params.webview) {
	        var newPageType = 'match';
	        if (edition.language === 'es' && params.pageType === 'match') {
	          newPageType = 'game';
	        }
	        var uriObj = (0, _parseURI2.default)(matchURL) || {};
	        var queryObj = (0, _assign2.default)({}, (0, _extends3.default)({}, query, uriObj.queryKey));
	        var hrefConfig = (0, _assign2.default)({}, (0, _extends3.default)({}, params, uriObj.queryKey, { query: queryObj, pageType: newPageType }));
	        matchURL = _common.common.createHref((0, _extends3.default)({ pageType: newPageType }, hrefConfig));
	      }
	      var matchLink = _common.common.buildLinkObject({
	        tracking: ['rugby', 'game', 'subnav', 'history'],
	        href: matchURL,
	        edition: edition,
	        params: params
	      });
	
	      var game = {
	        home: {},
	        away: {},
	        date: (0, _selectn2.default)('gameDate', eventDetails) || '',
	        league: (0, _selectn2.default)('leagueName', eventDetails) || '',
	        score: (0, _selectn2.default)('homeTeamScore', eventDetails) + '-' + (0, _selectn2.default)('awayTeamScore', eventDetails),
	        link: matchLink || {},
	        result: (0, _selectn2.default)('gameResult', eventDetails) || '',
	        resultValue: (0, _selectn2.default)('gameResult', eventDetails) || ''
	      };
	
	      if (eventDetails.homeTeamId === currTeam.team.id) {
	        game.home = team;
	        game.away = opposition;
	      } else {
	        game.home = opposition;
	        game.away = team;
	      }
	
	      events.push(game);
	    }
	
	    var sDisplayTitle = headToHead ? (0, _translate2.default)(edition, 'Head To Head Record') : (0, _selectn2.default)('team.displayName', currTeam) + ' ' + (0, _translate2.default)(edition, 'Form');
	    var displayMessage = '';
	    if (events.length < 1) {
	      displayMessage = (0, _translate2.default)(edition, 'No Data Available');
	    }
	    return {
	      text: {
	        title: sDisplayTitle,
	        col1: (0, _translate2.default)(edition, 'Last Five Games'),
	        col2: (0, _translate2.default)(edition, 'Date'),
	        col3: (0, _translate2.default)(edition, 'Competition')
	      },
	      team: team,
	      data: events,
	      displayMessage: displayMessage
	    };
	  },
	
	  /**
	   * build links for tertiary nav
	   * @param  {Object} edition    Edition details
	   * @param  {Object} params     Router params
	   * @param  {Object} query      Request query params
	   * @param  {Object} hidden     Links to be displayed
	   * @param  {String} gameState  Game state
	   * @return {Array}             Game package links
	   */
	  buildNav: function buildNav() {
	    var edition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var hidden = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	    var gameState = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
	    var rostersNode = arguments[5];
	
	    var LINEUPS = 'lineups';
	    var standingsPageType = 'table';
	    var matchPageType = 'match';
	    if (edition.language === 'es' || edition.language === 'pt') {
	      standingsPageType = 'standings';
	      hidden.standings = hidden.table;
	    }
	    if (edition.language === 'es') {
	      matchPageType = 'game';
	    }
	    var linksToShow = {
	      pregame: [matchPageType, 'preview', 'commentary', LINEUPS, standingsPageType, 'conversation'],
	      live: [matchPageType, 'commentary', 'matchstats', 'playerstats', LINEUPS, standingsPageType, 'conversation'],
	      final: [matchPageType, 'report', 'commentary', 'matchstats', 'playerstats', LINEUPS, standingsPageType, 'conversation']
	    };
	
	    var linkDescriptors = {
	      match: {
	        text: (0, _translate2.default)(edition, 'links.event.summary.metadata.text.rugby')
	      },
	      game: {
	        text: (0, _translate2.default)(edition, 'links.event.summary.metadata.text.rugby')
	      },
	      report: {
	        text: (0, _translate2.default)(edition, 'links.event.recap.metadata.text.rugby')
	      },
	      preview: {
	        text: (0, _translate2.default)(edition, 'links.event.preview.metadata.text.rugby')
	      },
	      commentary: {
	        text: (0, _translate2.default)(edition, 'links.event.commentary.metadata.text.rugby')
	      },
	      matchstats: {
	        text: (0, _translate2.default)(edition, 'links.event.matchstats.metadata.text.rugby')
	      },
	      playerstats: {
	        text: (0, _translate2.default)(edition, 'links.event.playerstats.metadata.text.rugby')
	      },
	      lineups: {
	        text: (0, _translate2.default)(edition, 'links.event.lineups.metadata.text.rugby')
	      },
	      table: {
	        text: (0, _translate2.default)(edition, 'links.event.table.metadata.text.rugby'),
	        external: 'standings'
	      },
	      standings: {
	        text: (0, _translate2.default)(edition, 'links.event.table.metadata.text.rugby'),
	        external: 'standings'
	      },
	      conversation: {
	        text: (0, _translate2.default)(edition, 'links.event.conversation.metadata.text.rugby')
	      }
	    };
	
	    var links = [];
	    var linkList = linksToShow[gameState] || [];
	    var linkLen = linkList.length;
	    var isLineupsAvailable = (0, _selectn2.default)('[0].roster', rostersNode);
	    for (var i = 0; i < linkLen; i++) {
	      var linkName = linkList[i] || '';
	      if (linkName === LINEUPS && (typeof isLineupsAvailable === 'undefined' ? 'undefined' : (0, _typeof3.default)(isLineupsAvailable)) === UNDEFINED) continue;
	      if (!hidden[linkName]) {
	        var details = linkDescriptors[linkName];
	
	        // skip if details not available
	        if ((typeof details === 'undefined' ? 'undefined' : (0, _typeof3.default)(details)) !== UNDEFINED) {
	          var queryClone = (0, _assign2.default)({}, query);
	          if ((linkName === 'table' || linkName == 'standings') && details.external) {
	            delete queryClone.gameId;
	            delete queryClone.league;
	          }
	          var linkDetails = _common.common.buildLinkObject({
	            text: linkName === 'match' && gameState === 'live' ? (0, _translate2.default)(edition, 'links.event.live.metadata.text.rugby') : details.text,
	            external: details.external,
	            tracking: [params.sport, 'game', 'subnav', linkName],
	            params: {
	              pageType: linkName,
	              sport: params.sport,
	              league: params.league,
	              gameId: params.gameId,
	              platform: params.platform,
	              webview: params.webview
	            },
	            query: queryClone,
	            edition: edition
	          });
	          //make link external for webviews to remove react-router-link class
	          if (params.platform) {
	            if (details.external) {
	              linkDetails.external = details.external;
	            }
	          }
	          links.push(linkDetails);
	        }
	      }
	    }
	
	    return links;
	  },
	
	  getMatchConversation: function getMatchConversation() {
	    var edition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return {
	      text: {
	        heading: (0, _translate2.default)(edition, 'Conversation'),
	        description: (0, _translate2.default)(edition, 'facebook.conversation.account_policy')
	      },
	      href: edition.domain + _common.common.createHref({
	        sport: params.sport,
	        league: params.league,
	        gameId: params.gameId,
	        pageType: 'conversation'
	      })
	    };
	  },
	
	  getNews: function getNews() {
	    var edition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var newsNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var leagueName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	    var items = [];
	    var articles = newsNode.articles || [];
	    if (articles['constructor'] !== Array) {
	      articles = [];
	    }
	    articles.map(function (article) {
	      var headline = article.headline;
	
	      var image = void 0;
	
	      // skip to next iteration if headline invalid
	      if (typeof headline !== 'string' || headline === '') {
	        return;
	      }
	
	      image = {
	        url: _common.common.getCombinerImage((0, _selectn2.default)('images[0].url', article))
	      };
	
	      var articleURI = (0, _selectn2.default)('links.web.href', article) || '#';
	      articleURI = _common.common.buildURL(articleURI);
	
	      items.push({
	        headline: article.headline,
	        description: article.description,
	        //href : selectn('links.web.href', article) || '#',
	        href: articleURI,
	        image: image
	      });
	    });
	
	    var newsTitle = [];
	    if (leagueName) {
	      newsTitle.push(leagueName);
	    }
	    newsTitle.push((0, _translate2.default)(edition, 'News'));
	    return {
	      //href : common.createHref({
	      //  ...params,
	      //  pageType : 'match-coverage'
	      //}),
	      items: items,
	      title: newsTitle.join(' ')
	    };
	  }
	};
	
	var page = {
	  /**
	   * compose data for scorecard page
	   * @param  {Array}  rostersNode   rosters node
	   * @param  {Array}  allInnings    details of all innings
	   * @param  {Number} currentPeriod current innings
	   * @param  {String} gameState     game state
	   * @param  {Object} matchFlags    flags for this match
	   * @return {Object}               scorecard data
	   */
	  getScorecard: function getScorecard() {
	    var rostersNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var allInnings = arguments[1];
	    var currentPeriod = arguments[2];
	    var gameState = arguments[3];
	    var matchFlags = arguments[4];
	
	    var inningInfo = helpers.getOrderedInnings(rostersNode, allInnings, currentPeriod, gameState, matchFlags);
	    var scorecard = inningInfo;
	    return scorecard;
	  },
	
	  /**
	   * @param {Object} articleNode article node
	   * return required data to fetch related markup for sCore
	   * @return {Object} article data required to fetch rendered markup
	   */
	  getArticleInfo: function getArticleInfo(articleNode) {
	    return articleNode ? {
	      id: articleNode.id || null,
	      type: articleNode.type || null
	    } : null;
	  }
	};
	
	var gamePackage = exports.gamePackage = {
	
	  processData: function processData(res, edition, params, location) {
	
	    //const { query = {} } = location
	    var query = _common.common.getQuery(edition, params, location);
	    // Select Nodes from API response
	    var gameInfo = (0, _selectn2.default)('data.gameInfo', res) || {};
	    var competitionNode = (0, _selectn2.default)('data.header.competitions[0]', res) || {};
	    var rostersNode = (0, _selectn2.default)('data.rosters', res) || [];
	    var boxScoreNode = (0, _selectn2.default)('data.boxscore', res) || [];
	    var articleNode = (0, _selectn2.default)('data.article', res) || {};
	    var standingsNode = (0, _selectn2.default)('data.standings', res) || {};
	    var newsNode = (0, _selectn2.default)('data.news', res) || {};
	    var lastFiveNode = (0, _selectn2.default)('data.lastFiveGames', res) || {};
	    var HeadToHeadNode = (0, _selectn2.default)('data.headToHeadGames', res) || {};
	
	    /* Process data */
	    var filteredDetails = modules.setMatchDetails(params, rostersNode, competitionNode, boxScoreNode);
	
	    /* Build data for modules */
	    var matchDetails = modules.getMatchDetails(edition, gameInfo, competitionNode);
	    var matchStats = modules.getMatchStats(edition, params, query, filteredDetails, boxScoreNode);
	    var matchLineUp = modules.getMatchLineUp(edition, params, filteredDetails);
	    var matchCommentary = modules.getMatchCommentary(edition, params, query, filteredDetails);
	    var matchEvents = modules.getMatchEvents(edition, filteredDetails);
	    var matchAttacking = '';
	    var matchDefending = '';
	    if (params.sport === 'rugby') {
	      matchAttacking = modules.getMatchAttacking(edition, filteredDetails);
	      matchDefending = modules.getMatchDefending(edition, filteredDetails);
	    } else {
	      matchAttacking = modules.getMatchAttackingRL(edition, filteredDetails);
	      matchDefending = modules.getMatchDefendingRL(edition, filteredDetails);
	    }
	    var matchDiscipline = modules.getMatchDiscipline(edition, filteredDetails);
	    var matchGlossary = modules.getGlossary(edition, params.sport, filteredDetails);
	    var article = modules.getArticle(articleNode, params);
	    var headToHead = modules.getLastFive(edition, params, HeadToHeadNode, filteredDetails.home.id || 0, true, query);
	    var matchHomeForm = modules.getLastFive(edition, params, lastFiveNode, filteredDetails.home.id || 0, false, query);
	    var matchAwayForm = modules.getLastFive(edition, params, lastFiveNode, filteredDetails.away.id || 0, false, query);
	    var matchConversation = modules.getMatchConversation(edition, params);
	    var matchSummary = _eventSummary2.default.getMatchSummary(params.sport || 'rugby', edition, filteredDetails);
	    var leagueUid = (0, _selectn2.default)('data.header.league.uid', res) || {};
	    var leagueSeason = (0, _selectn2.default)('data.header.season.year', res) || '';
	    var leagueName = (0, _selectn2.default)('data.header.league.name', res) || '';
	    leagueName += leagueSeason ? ' ' + leagueSeason : '';
	
	    var league = {
	      'id': (0, _selectn2.default)('data.header.league.id', res) || '',
	      'uid': leagueUid,
	      'name': leagueName,
	      'season': leagueSeason,
	      'isTournament': (0, _selectn2.default)('data.header.league.isTournament', res)
	    };
	    var standings = league.isTournament ? modules.getStandings(edition, standingsNode, params) : {};
	
	    var matchDescription = '';
	    var gameState = _common.common.getGameState((0, _selectn2.default)('status.type.state', competitionNode));
	    var gameStrip = _common.common.getGameStrip(competitionNode, leagueName, gameState, 'rugby', edition.timeZoneBucket, params, '', true, edition.language);
	
	    var gameStateClass = _common.common.getGameStateClass(gameState);
	    var news = modules.getNews(edition, newsNode, leagueName);
	    var matchCoverage = {};
	    var meta = helpers.getMetaData(edition, params, competitionNode, gameStrip, gameInfo, leagueName, gameState, league, matchCoverage, matchDescription);
	
	    /* Build the nav */
	    var isWebView = params.platform ? true : false;
	    var hiddenLinks = {};
	    var hasStats = (0, _selectn2.default)('home.possession.value', filteredDetails) || (0, _selectn2.default)('home.metres.value', filteredDetails) || 0;
	
	    /* hide links flag if no data */
	    if (standings.teams && standings.teams.length === 0 || league.isTournament === false) {
	      hiddenLinks.table = 1;
	      hiddenLinks.standings = 1;
	    }
	    if (article.id === 0) {
	      hiddenLinks.preview = 1;
	      hiddenLinks.report = 1;
	    }
	    if (matchCommentary.events && matchCommentary.events.length === 0) {
	      hiddenLinks.commentary = 1;
	    }
	    if (hasStats <= 1) {
	      hiddenLinks.matchstats = 1;
	      hiddenLinks.playerstats = 1;
	    }
	
	    if (isWebView === true) {
	      hiddenLinks.conversation = 1;
	      hiddenLinks.table = 1;
	    }
	    var links = modules.buildNav(edition, params, query, hiddenLinks, gameState, rostersNode);
	    var polling = helpers.shouldPoll(competitionNode.date, gameState);
	    var analytics = helpers.getAnalytics(params, gameStrip.teams, meta, gameState);
	
	    return {
	      standings: standings,
	      links: links,
	      headToHead: headToHead,
	      gameStrip: gameStrip,
	      gameStateClass: gameStateClass,
	      gameState: gameState,
	      leagueUid: leagueUid,
	      meta: meta,
	      news: news,
	      polling: polling,
	      analytics: analytics,
	
	      matchDetails: matchDetails,
	      matchStats: matchStats,
	      matchLineUp: matchLineUp,
	      matchCommentary: matchCommentary,
	      matchEvents: matchEvents,
	      matchAttacking: matchAttacking,
	      matchDefending: matchDefending,
	      matchDiscipline: matchDiscipline,
	      matchGlossary: matchGlossary,
	      matchHomeForm: matchHomeForm,
	      matchAwayForm: matchAwayForm,
	      matchConversation: matchConversation,
	      matchSummary: matchSummary,
	      showGameStrip: true,
	      showGameDetailFooter: true,
	      article: article,
	      HeadToHeadNode: HeadToHeadNode
	    };
	  },
	
	  page: page,
	
	  modules: modules,
	
	  helpers: helpers
	
	};
	
	exports.default = gamePackage;

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = {
	  XmlEntities: __webpack_require__(843),
	  Html4Entities: __webpack_require__(844),
	  Html5Entities: __webpack_require__(845),
	  AllHtmlEntities: __webpack_require__(845)
	};


/***/ }),
/* 843 */
/***/ (function(module, exports) {

	var ALPHA_INDEX = {
	    '&lt': '<',
	    '&gt': '>',
	    '&quot': '"',
	    '&apos': '\'',
	    '&amp': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&apos;': '\'',
	    '&amp;': '&'
	};
	
	var CHAR_INDEX = {
	    60: 'lt',
	    62: 'gt',
	    34: 'quot',
	    39: 'apos',
	    38: 'amp'
	};
	
	var CHAR_S_INDEX = {
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    '\'': '&apos;',
	    '&': '&amp;'
	};
	
	/**
	 * @constructor
	 */
	function XmlEntities() {}
	
	/**
	 * @param {String} str
	 * @returns {String}
	 */
	XmlEntities.prototype.encode = function(str) {
	    if (!str || !str.length) {
	        return '';
	    }
	    return str.replace(/<|>|"|'|&/g, function(s) {
	        return CHAR_S_INDEX[s];
	    });
	};
	
	/**
	 * @param {String} str
	 * @returns {String}
	 */
	 XmlEntities.encode = function(str) {
	    return new XmlEntities().encode(str);
	 };
	
	/**
	 * @param {String} str
	 * @returns {String}
	 */
	XmlEntities.prototype.decode = function(str) {
	    if (!str || !str.length) {
	        return '';
	    }
	    return str.replace(/&#?[0-9a-zA-Z]+;?/g, function(s) {
	        if (s.charAt(1) === '#') {
	            var code = s.charAt(2).toLowerCase() === 'x' ?
	                parseInt(s.substr(3), 16) :
	                parseInt(s.substr(2));
	
	            if (isNaN(code) || code < -32768 || code > 65535) {
	                return '';
	            }
	            return String.fromCharCode(code);
	        }
	        return ALPHA_INDEX[s] || s;
	    });
	};
	
	/**
	 * @param {String} str
	 * @returns {String}
	 */
	 XmlEntities.decode = function(str) {
	    return new XmlEntities().decode(str);
	 };
	
	/**
	 * @param {String} str
	 * @returns {String}
	 */
	XmlEntities.prototype.encodeNonUTF = function(str) {
	    if (!str || !str.length) {
	        return '';
	    }
	    var strLength = str.length;
	    var result = '';
	    var i = 0;
	    while (i < strLength) {
	        var c = str.charCodeAt(i);
	        var alpha = CHAR_INDEX[c];
	        if (alpha) {
	            result += "&" + alpha + ";";
	            i++;
	            continue;
	        }
	        if (c < 32 || c > 126) {
	            result += '&#' + c + ';';
	        } else {
	            result += str.charAt(i);
	        }
	        i++;
	    }
	    return result;
	};
	
	/**
	 * @param {String} str
	 * @returns {String}
	 */
	 XmlEntities.encodeNonUTF = function(str) {
	    return new XmlEntities().encodeNonUTF(str);
	 };
	
	/**
	 * @param {String} str
	 * @returns {String}
	 */
	XmlEntities.prototype.encodeNonASCII = function(str) {
	    if (!str || !str.length) {
	        return '';
	    }
	    var strLenght = str.length;
	    var result = '';
	    var i = 0;
	    while (i < strLenght) {
	        var c = str.charCodeAt(i);
	        if (c <= 255) {
	            result += str[i++];
	            continue;
	        }
	        result += '&#' + c + ';';
	        i++;
	    }
	    return result;
	};
	
	/**
	 * @param {String} str
	 * @returns {String}
	 */
	 XmlEntities.encodeNonASCII = function(str) {
	    return new XmlEntities().encodeNonASCII(str);
	 };
	
	module.exports = XmlEntities;


/***/ }),
/* 844 */
/***/ (function(module, exports) {

	var HTML_ALPHA = ['apos', 'nbsp', 'iexcl', 'cent', 'pound', 'curren', 'yen', 'brvbar', 'sect', 'uml', 'copy', 'ordf', 'laquo', 'not', 'shy', 'reg', 'macr', 'deg', 'plusmn', 'sup2', 'sup3', 'acute', 'micro', 'para', 'middot', 'cedil', 'sup1', 'ordm', 'raquo', 'frac14', 'frac12', 'frac34', 'iquest', 'Agrave', 'Aacute', 'Acirc', 'Atilde', 'Auml', 'Aring', 'Aelig', 'Ccedil', 'Egrave', 'Eacute', 'Ecirc', 'Euml', 'Igrave', 'Iacute', 'Icirc', 'Iuml', 'ETH', 'Ntilde', 'Ograve', 'Oacute', 'Ocirc', 'Otilde', 'Ouml', 'times', 'Oslash', 'Ugrave', 'Uacute', 'Ucirc', 'Uuml', 'Yacute', 'THORN', 'szlig', 'agrave', 'aacute', 'acirc', 'atilde', 'auml', 'aring', 'aelig', 'ccedil', 'egrave', 'eacute', 'ecirc', 'euml', 'igrave', 'iacute', 'icirc', 'iuml', 'eth', 'ntilde', 'ograve', 'oacute', 'ocirc', 'otilde', 'ouml', 'divide', 'oslash', 'ugrave', 'uacute', 'ucirc', 'uuml', 'yacute', 'thorn', 'yuml', 'quot', 'amp', 'lt', 'gt', 'OElig', 'oelig', 'Scaron', 'scaron', 'Yuml', 'circ', 'tilde', 'ensp', 'emsp', 'thinsp', 'zwnj', 'zwj', 'lrm', 'rlm', 'ndash', 'mdash', 'lsquo', 'rsquo', 'sbquo', 'ldquo', 'rdquo', 'bdquo', 'dagger', 'Dagger', 'permil', 'lsaquo', 'rsaquo', 'euro', 'fnof', 'Alpha', 'Beta', 'Gamma', 'Delta', 'Epsilon', 'Zeta', 'Eta', 'Theta', 'Iota', 'Kappa', 'Lambda', 'Mu', 'Nu', 'Xi', 'Omicron', 'Pi', 'Rho', 'Sigma', 'Tau', 'Upsilon', 'Phi', 'Chi', 'Psi', 'Omega', 'alpha', 'beta', 'gamma', 'delta', 'epsilon', 'zeta', 'eta', 'theta', 'iota', 'kappa', 'lambda', 'mu', 'nu', 'xi', 'omicron', 'pi', 'rho', 'sigmaf', 'sigma', 'tau', 'upsilon', 'phi', 'chi', 'psi', 'omega', 'thetasym', 'upsih', 'piv', 'bull', 'hellip', 'prime', 'Prime', 'oline', 'frasl', 'weierp', 'image', 'real', 'trade', 'alefsym', 'larr', 'uarr', 'rarr', 'darr', 'harr', 'crarr', 'lArr', 'uArr', 'rArr', 'dArr', 'hArr', 'forall', 'part', 'exist', 'empty', 'nabla', 'isin', 'notin', 'ni', 'prod', 'sum', 'minus', 'lowast', 'radic', 'prop', 'infin', 'ang', 'and', 'or', 'cap', 'cup', 'int', 'there4', 'sim', 'cong', 'asymp', 'ne', 'equiv', 'le', 'ge', 'sub', 'sup', 'nsub', 'sube', 'supe', 'oplus', 'otimes', 'perp', 'sdot', 'lceil', 'rceil', 'lfloor', 'rfloor', 'lang', 'rang', 'loz', 'spades', 'clubs', 'hearts', 'diams'];
	var HTML_CODES = [39, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 34, 38, 60, 62, 338, 339, 352, 353, 376, 710, 732, 8194, 8195, 8201, 8204, 8205, 8206, 8207, 8211, 8212, 8216, 8217, 8218, 8220, 8221, 8222, 8224, 8225, 8240, 8249, 8250, 8364, 402, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 977, 978, 982, 8226, 8230, 8242, 8243, 8254, 8260, 8472, 8465, 8476, 8482, 8501, 8592, 8593, 8594, 8595, 8596, 8629, 8656, 8657, 8658, 8659, 8660, 8704, 8706, 8707, 8709, 8711, 8712, 8713, 8715, 8719, 8721, 8722, 8727, 8730, 8733, 8734, 8736, 8743, 8744, 8745, 8746, 8747, 8756, 8764, 8773, 8776, 8800, 8801, 8804, 8805, 8834, 8835, 8836, 8838, 8839, 8853, 8855, 8869, 8901, 8968, 8969, 8970, 8971, 9001, 9002, 9674, 9824, 9827, 9829, 9830];
	
	var alphaIndex = {};
	var numIndex = {};
	
	var i = 0;
	var length = HTML_ALPHA.length;
	while (i < length) {
	    var a = HTML_ALPHA[i];
	    var c = HTML_CODES[i];
	    alphaIndex[a] = String.fromCharCode(c);
	    numIndex[c] = a;
	    i++;
	}
	
	/**
	 * @constructor
	 */
	function Html4Entities() {}
	
	/**
	 * @param {String} str
	 * @returns {String}
	 */
	Html4Entities.prototype.decode = function(str) {
	    if (!str || !str.length) {
	        return '';
	    }
	    return str.replace(/&(#?[\w\d]+);?/g, function(s, entity) {
	        var chr;
	        if (entity.charAt(0) === "#") {
	            var code = entity.charAt(1).toLowerCase() === 'x' ?
	                parseInt(entity.substr(2), 16) :
	                parseInt(entity.substr(1));
	
	            if (!(isNaN(code) || code < -32768 || code > 65535)) {
	                chr = String.fromCharCode(code);
	            }
	        } else {
	            chr = alphaIndex[entity];
	        }
	        return chr || s;
	    });
	};
	
	/**
	 * @param {String} str
	 * @returns {String}
	 */
	Html4Entities.decode = function(str) {
	    return new Html4Entities().decode(str);
	};
	
	/**
	 * @param {String} str
	 * @returns {String}
	 */
	Html4Entities.prototype.encode = function(str) {
	    if (!str || !str.length) {
	        return '';
	    }
	    var strLength = str.length;
	    var result = '';
	    var i = 0;
	    while (i < strLength) {
	        var alpha = numIndex[str.charCodeAt(i)];
	        result += alpha ? "&" + alpha + ";" : str.charAt(i);
	        i++;
	    }
	    return result;
	};
	
	/**
	 * @param {String} str
	 * @returns {String}
	 */
	Html4Entities.encode = function(str) {
	    return new Html4Entities().encode(str);
	};
	
	/**
	 * @param {String} str
	 * @returns {String}
	 */
	Html4Entities.prototype.encodeNonUTF = function(str) {
	    if (!str || !str.length) {
	        return '';
	    }
	    var strLength = str.length;
	    var result = '';
	    var i = 0;
	    while (i < strLength) {
	        var cc = str.charCodeAt(i);
	        var alpha = numIndex[cc];
	        if (alpha) {
	            result += "&" + alpha + ";";
	        } else if (cc < 32 || cc > 126) {
	            result += "&#" + cc + ";";
	        } else {
	            result += str.charAt(i);
	        }
	        i++;
	    }
	    return result;
	};
	
	/**
	 * @param {String} str
	 * @returns {String}
	 */
	Html4Entities.encodeNonUTF = function(str) {
	    return new Html4Entities().encodeNonUTF(str);
	};
	
	/**
	 * @param {String} str
	 * @returns {String}
	 */
	Html4Entities.prototype.encodeNonASCII = function(str) {
	    if (!str || !str.length) {
	        return '';
	    }
	    var strLength = str.length;
	    var result = '';
	    var i = 0;
	    while (i < strLength) {
	        var c = str.charCodeAt(i);
	        if (c <= 255) {
	            result += str[i++];
	            continue;
	        }
	        result += '&#' + c + ';';
	        i++;
	    }
	    return result;
	};
	
	/**
	 * @param {String} str
	 * @returns {String}
	 */
	Html4Entities.encodeNonASCII = function(str) {
	    return new Html4Entities().encodeNonASCII(str);
	};
	
	module.exports = Html4Entities;


/***/ }),
/* 845 */
/***/ (function(module, exports) {

	var ENTITIES = [['Aacute', [193]], ['aacute', [225]], ['Abreve', [258]], ['abreve', [259]], ['ac', [8766]], ['acd', [8767]], ['acE', [8766, 819]], ['Acirc', [194]], ['acirc', [226]], ['acute', [180]], ['Acy', [1040]], ['acy', [1072]], ['AElig', [198]], ['aelig', [230]], ['af', [8289]], ['Afr', [120068]], ['afr', [120094]], ['Agrave', [192]], ['agrave', [224]], ['alefsym', [8501]], ['aleph', [8501]], ['Alpha', [913]], ['alpha', [945]], ['Amacr', [256]], ['amacr', [257]], ['amalg', [10815]], ['amp', [38]], ['AMP', [38]], ['andand', [10837]], ['And', [10835]], ['and', [8743]], ['andd', [10844]], ['andslope', [10840]], ['andv', [10842]], ['ang', [8736]], ['ange', [10660]], ['angle', [8736]], ['angmsdaa', [10664]], ['angmsdab', [10665]], ['angmsdac', [10666]], ['angmsdad', [10667]], ['angmsdae', [10668]], ['angmsdaf', [10669]], ['angmsdag', [10670]], ['angmsdah', [10671]], ['angmsd', [8737]], ['angrt', [8735]], ['angrtvb', [8894]], ['angrtvbd', [10653]], ['angsph', [8738]], ['angst', [197]], ['angzarr', [9084]], ['Aogon', [260]], ['aogon', [261]], ['Aopf', [120120]], ['aopf', [120146]], ['apacir', [10863]], ['ap', [8776]], ['apE', [10864]], ['ape', [8778]], ['apid', [8779]], ['apos', [39]], ['ApplyFunction', [8289]], ['approx', [8776]], ['approxeq', [8778]], ['Aring', [197]], ['aring', [229]], ['Ascr', [119964]], ['ascr', [119990]], ['Assign', [8788]], ['ast', [42]], ['asymp', [8776]], ['asympeq', [8781]], ['Atilde', [195]], ['atilde', [227]], ['Auml', [196]], ['auml', [228]], ['awconint', [8755]], ['awint', [10769]], ['backcong', [8780]], ['backepsilon', [1014]], ['backprime', [8245]], ['backsim', [8765]], ['backsimeq', [8909]], ['Backslash', [8726]], ['Barv', [10983]], ['barvee', [8893]], ['barwed', [8965]], ['Barwed', [8966]], ['barwedge', [8965]], ['bbrk', [9141]], ['bbrktbrk', [9142]], ['bcong', [8780]], ['Bcy', [1041]], ['bcy', [1073]], ['bdquo', [8222]], ['becaus', [8757]], ['because', [8757]], ['Because', [8757]], ['bemptyv', [10672]], ['bepsi', [1014]], ['bernou', [8492]], ['Bernoullis', [8492]], ['Beta', [914]], ['beta', [946]], ['beth', [8502]], ['between', [8812]], ['Bfr', [120069]], ['bfr', [120095]], ['bigcap', [8898]], ['bigcirc', [9711]], ['bigcup', [8899]], ['bigodot', [10752]], ['bigoplus', [10753]], ['bigotimes', [10754]], ['bigsqcup', [10758]], ['bigstar', [9733]], ['bigtriangledown', [9661]], ['bigtriangleup', [9651]], ['biguplus', [10756]], ['bigvee', [8897]], ['bigwedge', [8896]], ['bkarow', [10509]], ['blacklozenge', [10731]], ['blacksquare', [9642]], ['blacktriangle', [9652]], ['blacktriangledown', [9662]], ['blacktriangleleft', [9666]], ['blacktriangleright', [9656]], ['blank', [9251]], ['blk12', [9618]], ['blk14', [9617]], ['blk34', [9619]], ['block', [9608]], ['bne', [61, 8421]], ['bnequiv', [8801, 8421]], ['bNot', [10989]], ['bnot', [8976]], ['Bopf', [120121]], ['bopf', [120147]], ['bot', [8869]], ['bottom', [8869]], ['bowtie', [8904]], ['boxbox', [10697]], ['boxdl', [9488]], ['boxdL', [9557]], ['boxDl', [9558]], ['boxDL', [9559]], ['boxdr', [9484]], ['boxdR', [9554]], ['boxDr', [9555]], ['boxDR', [9556]], ['boxh', [9472]], ['boxH', [9552]], ['boxhd', [9516]], ['boxHd', [9572]], ['boxhD', [9573]], ['boxHD', [9574]], ['boxhu', [9524]], ['boxHu', [9575]], ['boxhU', [9576]], ['boxHU', [9577]], ['boxminus', [8863]], ['boxplus', [8862]], ['boxtimes', [8864]], ['boxul', [9496]], ['boxuL', [9563]], ['boxUl', [9564]], ['boxUL', [9565]], ['boxur', [9492]], ['boxuR', [9560]], ['boxUr', [9561]], ['boxUR', [9562]], ['boxv', [9474]], ['boxV', [9553]], ['boxvh', [9532]], ['boxvH', [9578]], ['boxVh', [9579]], ['boxVH', [9580]], ['boxvl', [9508]], ['boxvL', [9569]], ['boxVl', [9570]], ['boxVL', [9571]], ['boxvr', [9500]], ['boxvR', [9566]], ['boxVr', [9567]], ['boxVR', [9568]], ['bprime', [8245]], ['breve', [728]], ['Breve', [728]], ['brvbar', [166]], ['bscr', [119991]], ['Bscr', [8492]], ['bsemi', [8271]], ['bsim', [8765]], ['bsime', [8909]], ['bsolb', [10693]], ['bsol', [92]], ['bsolhsub', [10184]], ['bull', [8226]], ['bullet', [8226]], ['bump', [8782]], ['bumpE', [10926]], ['bumpe', [8783]], ['Bumpeq', [8782]], ['bumpeq', [8783]], ['Cacute', [262]], ['cacute', [263]], ['capand', [10820]], ['capbrcup', [10825]], ['capcap', [10827]], ['cap', [8745]], ['Cap', [8914]], ['capcup', [10823]], ['capdot', [10816]], ['CapitalDifferentialD', [8517]], ['caps', [8745, 65024]], ['caret', [8257]], ['caron', [711]], ['Cayleys', [8493]], ['ccaps', [10829]], ['Ccaron', [268]], ['ccaron', [269]], ['Ccedil', [199]], ['ccedil', [231]], ['Ccirc', [264]], ['ccirc', [265]], ['Cconint', [8752]], ['ccups', [10828]], ['ccupssm', [10832]], ['Cdot', [266]], ['cdot', [267]], ['cedil', [184]], ['Cedilla', [184]], ['cemptyv', [10674]], ['cent', [162]], ['centerdot', [183]], ['CenterDot', [183]], ['cfr', [120096]], ['Cfr', [8493]], ['CHcy', [1063]], ['chcy', [1095]], ['check', [10003]], ['checkmark', [10003]], ['Chi', [935]], ['chi', [967]], ['circ', [710]], ['circeq', [8791]], ['circlearrowleft', [8634]], ['circlearrowright', [8635]], ['circledast', [8859]], ['circledcirc', [8858]], ['circleddash', [8861]], ['CircleDot', [8857]], ['circledR', [174]], ['circledS', [9416]], ['CircleMinus', [8854]], ['CirclePlus', [8853]], ['CircleTimes', [8855]], ['cir', [9675]], ['cirE', [10691]], ['cire', [8791]], ['cirfnint', [10768]], ['cirmid', [10991]], ['cirscir', [10690]], ['ClockwiseContourIntegral', [8754]], ['clubs', [9827]], ['clubsuit', [9827]], ['colon', [58]], ['Colon', [8759]], ['Colone', [10868]], ['colone', [8788]], ['coloneq', [8788]], ['comma', [44]], ['commat', [64]], ['comp', [8705]], ['compfn', [8728]], ['complement', [8705]], ['complexes', [8450]], ['cong', [8773]], ['congdot', [10861]], ['Congruent', [8801]], ['conint', [8750]], ['Conint', [8751]], ['ContourIntegral', [8750]], ['copf', [120148]], ['Copf', [8450]], ['coprod', [8720]], ['Coproduct', [8720]], ['copy', [169]], ['COPY', [169]], ['copysr', [8471]], ['CounterClockwiseContourIntegral', [8755]], ['crarr', [8629]], ['cross', [10007]], ['Cross', [10799]], ['Cscr', [119966]], ['cscr', [119992]], ['csub', [10959]], ['csube', [10961]], ['csup', [10960]], ['csupe', [10962]], ['ctdot', [8943]], ['cudarrl', [10552]], ['cudarrr', [10549]], ['cuepr', [8926]], ['cuesc', [8927]], ['cularr', [8630]], ['cularrp', [10557]], ['cupbrcap', [10824]], ['cupcap', [10822]], ['CupCap', [8781]], ['cup', [8746]], ['Cup', [8915]], ['cupcup', [10826]], ['cupdot', [8845]], ['cupor', [10821]], ['cups', [8746, 65024]], ['curarr', [8631]], ['curarrm', [10556]], ['curlyeqprec', [8926]], ['curlyeqsucc', [8927]], ['curlyvee', [8910]], ['curlywedge', [8911]], ['curren', [164]], ['curvearrowleft', [8630]], ['curvearrowright', [8631]], ['cuvee', [8910]], ['cuwed', [8911]], ['cwconint', [8754]], ['cwint', [8753]], ['cylcty', [9005]], ['dagger', [8224]], ['Dagger', [8225]], ['daleth', [8504]], ['darr', [8595]], ['Darr', [8609]], ['dArr', [8659]], ['dash', [8208]], ['Dashv', [10980]], ['dashv', [8867]], ['dbkarow', [10511]], ['dblac', [733]], ['Dcaron', [270]], ['dcaron', [271]], ['Dcy', [1044]], ['dcy', [1076]], ['ddagger', [8225]], ['ddarr', [8650]], ['DD', [8517]], ['dd', [8518]], ['DDotrahd', [10513]], ['ddotseq', [10871]], ['deg', [176]], ['Del', [8711]], ['Delta', [916]], ['delta', [948]], ['demptyv', [10673]], ['dfisht', [10623]], ['Dfr', [120071]], ['dfr', [120097]], ['dHar', [10597]], ['dharl', [8643]], ['dharr', [8642]], ['DiacriticalAcute', [180]], ['DiacriticalDot', [729]], ['DiacriticalDoubleAcute', [733]], ['DiacriticalGrave', [96]], ['DiacriticalTilde', [732]], ['diam', [8900]], ['diamond', [8900]], ['Diamond', [8900]], ['diamondsuit', [9830]], ['diams', [9830]], ['die', [168]], ['DifferentialD', [8518]], ['digamma', [989]], ['disin', [8946]], ['div', [247]], ['divide', [247]], ['divideontimes', [8903]], ['divonx', [8903]], ['DJcy', [1026]], ['djcy', [1106]], ['dlcorn', [8990]], ['dlcrop', [8973]], ['dollar', [36]], ['Dopf', [120123]], ['dopf', [120149]], ['Dot', [168]], ['dot', [729]], ['DotDot', [8412]], ['doteq', [8784]], ['doteqdot', [8785]], ['DotEqual', [8784]], ['dotminus', [8760]], ['dotplus', [8724]], ['dotsquare', [8865]], ['doublebarwedge', [8966]], ['DoubleContourIntegral', [8751]], ['DoubleDot', [168]], ['DoubleDownArrow', [8659]], ['DoubleLeftArrow', [8656]], ['DoubleLeftRightArrow', [8660]], ['DoubleLeftTee', [10980]], ['DoubleLongLeftArrow', [10232]], ['DoubleLongLeftRightArrow', [10234]], ['DoubleLongRightArrow', [10233]], ['DoubleRightArrow', [8658]], ['DoubleRightTee', [8872]], ['DoubleUpArrow', [8657]], ['DoubleUpDownArrow', [8661]], ['DoubleVerticalBar', [8741]], ['DownArrowBar', [10515]], ['downarrow', [8595]], ['DownArrow', [8595]], ['Downarrow', [8659]], ['DownArrowUpArrow', [8693]], ['DownBreve', [785]], ['downdownarrows', [8650]], ['downharpoonleft', [8643]], ['downharpoonright', [8642]], ['DownLeftRightVector', [10576]], ['DownLeftTeeVector', [10590]], ['DownLeftVectorBar', [10582]], ['DownLeftVector', [8637]], ['DownRightTeeVector', [10591]], ['DownRightVectorBar', [10583]], ['DownRightVector', [8641]], ['DownTeeArrow', [8615]], ['DownTee', [8868]], ['drbkarow', [10512]], ['drcorn', [8991]], ['drcrop', [8972]], ['Dscr', [119967]], ['dscr', [119993]], ['DScy', [1029]], ['dscy', [1109]], ['dsol', [10742]], ['Dstrok', [272]], ['dstrok', [273]], ['dtdot', [8945]], ['dtri', [9663]], ['dtrif', [9662]], ['duarr', [8693]], ['duhar', [10607]], ['dwangle', [10662]], ['DZcy', [1039]], ['dzcy', [1119]], ['dzigrarr', [10239]], ['Eacute', [201]], ['eacute', [233]], ['easter', [10862]], ['Ecaron', [282]], ['ecaron', [283]], ['Ecirc', [202]], ['ecirc', [234]], ['ecir', [8790]], ['ecolon', [8789]], ['Ecy', [1069]], ['ecy', [1101]], ['eDDot', [10871]], ['Edot', [278]], ['edot', [279]], ['eDot', [8785]], ['ee', [8519]], ['efDot', [8786]], ['Efr', [120072]], ['efr', [120098]], ['eg', [10906]], ['Egrave', [200]], ['egrave', [232]], ['egs', [10902]], ['egsdot', [10904]], ['el', [10905]], ['Element', [8712]], ['elinters', [9191]], ['ell', [8467]], ['els', [10901]], ['elsdot', [10903]], ['Emacr', [274]], ['emacr', [275]], ['empty', [8709]], ['emptyset', [8709]], ['EmptySmallSquare', [9723]], ['emptyv', [8709]], ['EmptyVerySmallSquare', [9643]], ['emsp13', [8196]], ['emsp14', [8197]], ['emsp', [8195]], ['ENG', [330]], ['eng', [331]], ['ensp', [8194]], ['Eogon', [280]], ['eogon', [281]], ['Eopf', [120124]], ['eopf', [120150]], ['epar', [8917]], ['eparsl', [10723]], ['eplus', [10865]], ['epsi', [949]], ['Epsilon', [917]], ['epsilon', [949]], ['epsiv', [1013]], ['eqcirc', [8790]], ['eqcolon', [8789]], ['eqsim', [8770]], ['eqslantgtr', [10902]], ['eqslantless', [10901]], ['Equal', [10869]], ['equals', [61]], ['EqualTilde', [8770]], ['equest', [8799]], ['Equilibrium', [8652]], ['equiv', [8801]], ['equivDD', [10872]], ['eqvparsl', [10725]], ['erarr', [10609]], ['erDot', [8787]], ['escr', [8495]], ['Escr', [8496]], ['esdot', [8784]], ['Esim', [10867]], ['esim', [8770]], ['Eta', [919]], ['eta', [951]], ['ETH', [208]], ['eth', [240]], ['Euml', [203]], ['euml', [235]], ['euro', [8364]], ['excl', [33]], ['exist', [8707]], ['Exists', [8707]], ['expectation', [8496]], ['exponentiale', [8519]], ['ExponentialE', [8519]], ['fallingdotseq', [8786]], ['Fcy', [1060]], ['fcy', [1092]], ['female', [9792]], ['ffilig', [64259]], ['fflig', [64256]], ['ffllig', [64260]], ['Ffr', [120073]], ['ffr', [120099]], ['filig', [64257]], ['FilledSmallSquare', [9724]], ['FilledVerySmallSquare', [9642]], ['fjlig', [102, 106]], ['flat', [9837]], ['fllig', [64258]], ['fltns', [9649]], ['fnof', [402]], ['Fopf', [120125]], ['fopf', [120151]], ['forall', [8704]], ['ForAll', [8704]], ['fork', [8916]], ['forkv', [10969]], ['Fouriertrf', [8497]], ['fpartint', [10765]], ['frac12', [189]], ['frac13', [8531]], ['frac14', [188]], ['frac15', [8533]], ['frac16', [8537]], ['frac18', [8539]], ['frac23', [8532]], ['frac25', [8534]], ['frac34', [190]], ['frac35', [8535]], ['frac38', [8540]], ['frac45', [8536]], ['frac56', [8538]], ['frac58', [8541]], ['frac78', [8542]], ['frasl', [8260]], ['frown', [8994]], ['fscr', [119995]], ['Fscr', [8497]], ['gacute', [501]], ['Gamma', [915]], ['gamma', [947]], ['Gammad', [988]], ['gammad', [989]], ['gap', [10886]], ['Gbreve', [286]], ['gbreve', [287]], ['Gcedil', [290]], ['Gcirc', [284]], ['gcirc', [285]], ['Gcy', [1043]], ['gcy', [1075]], ['Gdot', [288]], ['gdot', [289]], ['ge', [8805]], ['gE', [8807]], ['gEl', [10892]], ['gel', [8923]], ['geq', [8805]], ['geqq', [8807]], ['geqslant', [10878]], ['gescc', [10921]], ['ges', [10878]], ['gesdot', [10880]], ['gesdoto', [10882]], ['gesdotol', [10884]], ['gesl', [8923, 65024]], ['gesles', [10900]], ['Gfr', [120074]], ['gfr', [120100]], ['gg', [8811]], ['Gg', [8921]], ['ggg', [8921]], ['gimel', [8503]], ['GJcy', [1027]], ['gjcy', [1107]], ['gla', [10917]], ['gl', [8823]], ['glE', [10898]], ['glj', [10916]], ['gnap', [10890]], ['gnapprox', [10890]], ['gne', [10888]], ['gnE', [8809]], ['gneq', [10888]], ['gneqq', [8809]], ['gnsim', [8935]], ['Gopf', [120126]], ['gopf', [120152]], ['grave', [96]], ['GreaterEqual', [8805]], ['GreaterEqualLess', [8923]], ['GreaterFullEqual', [8807]], ['GreaterGreater', [10914]], ['GreaterLess', [8823]], ['GreaterSlantEqual', [10878]], ['GreaterTilde', [8819]], ['Gscr', [119970]], ['gscr', [8458]], ['gsim', [8819]], ['gsime', [10894]], ['gsiml', [10896]], ['gtcc', [10919]], ['gtcir', [10874]], ['gt', [62]], ['GT', [62]], ['Gt', [8811]], ['gtdot', [8919]], ['gtlPar', [10645]], ['gtquest', [10876]], ['gtrapprox', [10886]], ['gtrarr', [10616]], ['gtrdot', [8919]], ['gtreqless', [8923]], ['gtreqqless', [10892]], ['gtrless', [8823]], ['gtrsim', [8819]], ['gvertneqq', [8809, 65024]], ['gvnE', [8809, 65024]], ['Hacek', [711]], ['hairsp', [8202]], ['half', [189]], ['hamilt', [8459]], ['HARDcy', [1066]], ['hardcy', [1098]], ['harrcir', [10568]], ['harr', [8596]], ['hArr', [8660]], ['harrw', [8621]], ['Hat', [94]], ['hbar', [8463]], ['Hcirc', [292]], ['hcirc', [293]], ['hearts', [9829]], ['heartsuit', [9829]], ['hellip', [8230]], ['hercon', [8889]], ['hfr', [120101]], ['Hfr', [8460]], ['HilbertSpace', [8459]], ['hksearow', [10533]], ['hkswarow', [10534]], ['hoarr', [8703]], ['homtht', [8763]], ['hookleftarrow', [8617]], ['hookrightarrow', [8618]], ['hopf', [120153]], ['Hopf', [8461]], ['horbar', [8213]], ['HorizontalLine', [9472]], ['hscr', [119997]], ['Hscr', [8459]], ['hslash', [8463]], ['Hstrok', [294]], ['hstrok', [295]], ['HumpDownHump', [8782]], ['HumpEqual', [8783]], ['hybull', [8259]], ['hyphen', [8208]], ['Iacute', [205]], ['iacute', [237]], ['ic', [8291]], ['Icirc', [206]], ['icirc', [238]], ['Icy', [1048]], ['icy', [1080]], ['Idot', [304]], ['IEcy', [1045]], ['iecy', [1077]], ['iexcl', [161]], ['iff', [8660]], ['ifr', [120102]], ['Ifr', [8465]], ['Igrave', [204]], ['igrave', [236]], ['ii', [8520]], ['iiiint', [10764]], ['iiint', [8749]], ['iinfin', [10716]], ['iiota', [8489]], ['IJlig', [306]], ['ijlig', [307]], ['Imacr', [298]], ['imacr', [299]], ['image', [8465]], ['ImaginaryI', [8520]], ['imagline', [8464]], ['imagpart', [8465]], ['imath', [305]], ['Im', [8465]], ['imof', [8887]], ['imped', [437]], ['Implies', [8658]], ['incare', [8453]], ['in', [8712]], ['infin', [8734]], ['infintie', [10717]], ['inodot', [305]], ['intcal', [8890]], ['int', [8747]], ['Int', [8748]], ['integers', [8484]], ['Integral', [8747]], ['intercal', [8890]], ['Intersection', [8898]], ['intlarhk', [10775]], ['intprod', [10812]], ['InvisibleComma', [8291]], ['InvisibleTimes', [8290]], ['IOcy', [1025]], ['iocy', [1105]], ['Iogon', [302]], ['iogon', [303]], ['Iopf', [120128]], ['iopf', [120154]], ['Iota', [921]], ['iota', [953]], ['iprod', [10812]], ['iquest', [191]], ['iscr', [119998]], ['Iscr', [8464]], ['isin', [8712]], ['isindot', [8949]], ['isinE', [8953]], ['isins', [8948]], ['isinsv', [8947]], ['isinv', [8712]], ['it', [8290]], ['Itilde', [296]], ['itilde', [297]], ['Iukcy', [1030]], ['iukcy', [1110]], ['Iuml', [207]], ['iuml', [239]], ['Jcirc', [308]], ['jcirc', [309]], ['Jcy', [1049]], ['jcy', [1081]], ['Jfr', [120077]], ['jfr', [120103]], ['jmath', [567]], ['Jopf', [120129]], ['jopf', [120155]], ['Jscr', [119973]], ['jscr', [119999]], ['Jsercy', [1032]], ['jsercy', [1112]], ['Jukcy', [1028]], ['jukcy', [1108]], ['Kappa', [922]], ['kappa', [954]], ['kappav', [1008]], ['Kcedil', [310]], ['kcedil', [311]], ['Kcy', [1050]], ['kcy', [1082]], ['Kfr', [120078]], ['kfr', [120104]], ['kgreen', [312]], ['KHcy', [1061]], ['khcy', [1093]], ['KJcy', [1036]], ['kjcy', [1116]], ['Kopf', [120130]], ['kopf', [120156]], ['Kscr', [119974]], ['kscr', [120000]], ['lAarr', [8666]], ['Lacute', [313]], ['lacute', [314]], ['laemptyv', [10676]], ['lagran', [8466]], ['Lambda', [923]], ['lambda', [955]], ['lang', [10216]], ['Lang', [10218]], ['langd', [10641]], ['langle', [10216]], ['lap', [10885]], ['Laplacetrf', [8466]], ['laquo', [171]], ['larrb', [8676]], ['larrbfs', [10527]], ['larr', [8592]], ['Larr', [8606]], ['lArr', [8656]], ['larrfs', [10525]], ['larrhk', [8617]], ['larrlp', [8619]], ['larrpl', [10553]], ['larrsim', [10611]], ['larrtl', [8610]], ['latail', [10521]], ['lAtail', [10523]], ['lat', [10923]], ['late', [10925]], ['lates', [10925, 65024]], ['lbarr', [10508]], ['lBarr', [10510]], ['lbbrk', [10098]], ['lbrace', [123]], ['lbrack', [91]], ['lbrke', [10635]], ['lbrksld', [10639]], ['lbrkslu', [10637]], ['Lcaron', [317]], ['lcaron', [318]], ['Lcedil', [315]], ['lcedil', [316]], ['lceil', [8968]], ['lcub', [123]], ['Lcy', [1051]], ['lcy', [1083]], ['ldca', [10550]], ['ldquo', [8220]], ['ldquor', [8222]], ['ldrdhar', [10599]], ['ldrushar', [10571]], ['ldsh', [8626]], ['le', [8804]], ['lE', [8806]], ['LeftAngleBracket', [10216]], ['LeftArrowBar', [8676]], ['leftarrow', [8592]], ['LeftArrow', [8592]], ['Leftarrow', [8656]], ['LeftArrowRightArrow', [8646]], ['leftarrowtail', [8610]], ['LeftCeiling', [8968]], ['LeftDoubleBracket', [10214]], ['LeftDownTeeVector', [10593]], ['LeftDownVectorBar', [10585]], ['LeftDownVector', [8643]], ['LeftFloor', [8970]], ['leftharpoondown', [8637]], ['leftharpoonup', [8636]], ['leftleftarrows', [8647]], ['leftrightarrow', [8596]], ['LeftRightArrow', [8596]], ['Leftrightarrow', [8660]], ['leftrightarrows', [8646]], ['leftrightharpoons', [8651]], ['leftrightsquigarrow', [8621]], ['LeftRightVector', [10574]], ['LeftTeeArrow', [8612]], ['LeftTee', [8867]], ['LeftTeeVector', [10586]], ['leftthreetimes', [8907]], ['LeftTriangleBar', [10703]], ['LeftTriangle', [8882]], ['LeftTriangleEqual', [8884]], ['LeftUpDownVector', [10577]], ['LeftUpTeeVector', [10592]], ['LeftUpVectorBar', [10584]], ['LeftUpVector', [8639]], ['LeftVectorBar', [10578]], ['LeftVector', [8636]], ['lEg', [10891]], ['leg', [8922]], ['leq', [8804]], ['leqq', [8806]], ['leqslant', [10877]], ['lescc', [10920]], ['les', [10877]], ['lesdot', [10879]], ['lesdoto', [10881]], ['lesdotor', [10883]], ['lesg', [8922, 65024]], ['lesges', [10899]], ['lessapprox', [10885]], ['lessdot', [8918]], ['lesseqgtr', [8922]], ['lesseqqgtr', [10891]], ['LessEqualGreater', [8922]], ['LessFullEqual', [8806]], ['LessGreater', [8822]], ['lessgtr', [8822]], ['LessLess', [10913]], ['lesssim', [8818]], ['LessSlantEqual', [10877]], ['LessTilde', [8818]], ['lfisht', [10620]], ['lfloor', [8970]], ['Lfr', [120079]], ['lfr', [120105]], ['lg', [8822]], ['lgE', [10897]], ['lHar', [10594]], ['lhard', [8637]], ['lharu', [8636]], ['lharul', [10602]], ['lhblk', [9604]], ['LJcy', [1033]], ['ljcy', [1113]], ['llarr', [8647]], ['ll', [8810]], ['Ll', [8920]], ['llcorner', [8990]], ['Lleftarrow', [8666]], ['llhard', [10603]], ['lltri', [9722]], ['Lmidot', [319]], ['lmidot', [320]], ['lmoustache', [9136]], ['lmoust', [9136]], ['lnap', [10889]], ['lnapprox', [10889]], ['lne', [10887]], ['lnE', [8808]], ['lneq', [10887]], ['lneqq', [8808]], ['lnsim', [8934]], ['loang', [10220]], ['loarr', [8701]], ['lobrk', [10214]], ['longleftarrow', [10229]], ['LongLeftArrow', [10229]], ['Longleftarrow', [10232]], ['longleftrightarrow', [10231]], ['LongLeftRightArrow', [10231]], ['Longleftrightarrow', [10234]], ['longmapsto', [10236]], ['longrightarrow', [10230]], ['LongRightArrow', [10230]], ['Longrightarrow', [10233]], ['looparrowleft', [8619]], ['looparrowright', [8620]], ['lopar', [10629]], ['Lopf', [120131]], ['lopf', [120157]], ['loplus', [10797]], ['lotimes', [10804]], ['lowast', [8727]], ['lowbar', [95]], ['LowerLeftArrow', [8601]], ['LowerRightArrow', [8600]], ['loz', [9674]], ['lozenge', [9674]], ['lozf', [10731]], ['lpar', [40]], ['lparlt', [10643]], ['lrarr', [8646]], ['lrcorner', [8991]], ['lrhar', [8651]], ['lrhard', [10605]], ['lrm', [8206]], ['lrtri', [8895]], ['lsaquo', [8249]], ['lscr', [120001]], ['Lscr', [8466]], ['lsh', [8624]], ['Lsh', [8624]], ['lsim', [8818]], ['lsime', [10893]], ['lsimg', [10895]], ['lsqb', [91]], ['lsquo', [8216]], ['lsquor', [8218]], ['Lstrok', [321]], ['lstrok', [322]], ['ltcc', [10918]], ['ltcir', [10873]], ['lt', [60]], ['LT', [60]], ['Lt', [8810]], ['ltdot', [8918]], ['lthree', [8907]], ['ltimes', [8905]], ['ltlarr', [10614]], ['ltquest', [10875]], ['ltri', [9667]], ['ltrie', [8884]], ['ltrif', [9666]], ['ltrPar', [10646]], ['lurdshar', [10570]], ['luruhar', [10598]], ['lvertneqq', [8808, 65024]], ['lvnE', [8808, 65024]], ['macr', [175]], ['male', [9794]], ['malt', [10016]], ['maltese', [10016]], ['Map', [10501]], ['map', [8614]], ['mapsto', [8614]], ['mapstodown', [8615]], ['mapstoleft', [8612]], ['mapstoup', [8613]], ['marker', [9646]], ['mcomma', [10793]], ['Mcy', [1052]], ['mcy', [1084]], ['mdash', [8212]], ['mDDot', [8762]], ['measuredangle', [8737]], ['MediumSpace', [8287]], ['Mellintrf', [8499]], ['Mfr', [120080]], ['mfr', [120106]], ['mho', [8487]], ['micro', [181]], ['midast', [42]], ['midcir', [10992]], ['mid', [8739]], ['middot', [183]], ['minusb', [8863]], ['minus', [8722]], ['minusd', [8760]], ['minusdu', [10794]], ['MinusPlus', [8723]], ['mlcp', [10971]], ['mldr', [8230]], ['mnplus', [8723]], ['models', [8871]], ['Mopf', [120132]], ['mopf', [120158]], ['mp', [8723]], ['mscr', [120002]], ['Mscr', [8499]], ['mstpos', [8766]], ['Mu', [924]], ['mu', [956]], ['multimap', [8888]], ['mumap', [8888]], ['nabla', [8711]], ['Nacute', [323]], ['nacute', [324]], ['nang', [8736, 8402]], ['nap', [8777]], ['napE', [10864, 824]], ['napid', [8779, 824]], ['napos', [329]], ['napprox', [8777]], ['natural', [9838]], ['naturals', [8469]], ['natur', [9838]], ['nbsp', [160]], ['nbump', [8782, 824]], ['nbumpe', [8783, 824]], ['ncap', [10819]], ['Ncaron', [327]], ['ncaron', [328]], ['Ncedil', [325]], ['ncedil', [326]], ['ncong', [8775]], ['ncongdot', [10861, 824]], ['ncup', [10818]], ['Ncy', [1053]], ['ncy', [1085]], ['ndash', [8211]], ['nearhk', [10532]], ['nearr', [8599]], ['neArr', [8663]], ['nearrow', [8599]], ['ne', [8800]], ['nedot', [8784, 824]], ['NegativeMediumSpace', [8203]], ['NegativeThickSpace', [8203]], ['NegativeThinSpace', [8203]], ['NegativeVeryThinSpace', [8203]], ['nequiv', [8802]], ['nesear', [10536]], ['nesim', [8770, 824]], ['NestedGreaterGreater', [8811]], ['NestedLessLess', [8810]], ['nexist', [8708]], ['nexists', [8708]], ['Nfr', [120081]], ['nfr', [120107]], ['ngE', [8807, 824]], ['nge', [8817]], ['ngeq', [8817]], ['ngeqq', [8807, 824]], ['ngeqslant', [10878, 824]], ['nges', [10878, 824]], ['nGg', [8921, 824]], ['ngsim', [8821]], ['nGt', [8811, 8402]], ['ngt', [8815]], ['ngtr', [8815]], ['nGtv', [8811, 824]], ['nharr', [8622]], ['nhArr', [8654]], ['nhpar', [10994]], ['ni', [8715]], ['nis', [8956]], ['nisd', [8954]], ['niv', [8715]], ['NJcy', [1034]], ['njcy', [1114]], ['nlarr', [8602]], ['nlArr', [8653]], ['nldr', [8229]], ['nlE', [8806, 824]], ['nle', [8816]], ['nleftarrow', [8602]], ['nLeftarrow', [8653]], ['nleftrightarrow', [8622]], ['nLeftrightarrow', [8654]], ['nleq', [8816]], ['nleqq', [8806, 824]], ['nleqslant', [10877, 824]], ['nles', [10877, 824]], ['nless', [8814]], ['nLl', [8920, 824]], ['nlsim', [8820]], ['nLt', [8810, 8402]], ['nlt', [8814]], ['nltri', [8938]], ['nltrie', [8940]], ['nLtv', [8810, 824]], ['nmid', [8740]], ['NoBreak', [8288]], ['NonBreakingSpace', [160]], ['nopf', [120159]], ['Nopf', [8469]], ['Not', [10988]], ['not', [172]], ['NotCongruent', [8802]], ['NotCupCap', [8813]], ['NotDoubleVerticalBar', [8742]], ['NotElement', [8713]], ['NotEqual', [8800]], ['NotEqualTilde', [8770, 824]], ['NotExists', [8708]], ['NotGreater', [8815]], ['NotGreaterEqual', [8817]], ['NotGreaterFullEqual', [8807, 824]], ['NotGreaterGreater', [8811, 824]], ['NotGreaterLess', [8825]], ['NotGreaterSlantEqual', [10878, 824]], ['NotGreaterTilde', [8821]], ['NotHumpDownHump', [8782, 824]], ['NotHumpEqual', [8783, 824]], ['notin', [8713]], ['notindot', [8949, 824]], ['notinE', [8953, 824]], ['notinva', [8713]], ['notinvb', [8951]], ['notinvc', [8950]], ['NotLeftTriangleBar', [10703, 824]], ['NotLeftTriangle', [8938]], ['NotLeftTriangleEqual', [8940]], ['NotLess', [8814]], ['NotLessEqual', [8816]], ['NotLessGreater', [8824]], ['NotLessLess', [8810, 824]], ['NotLessSlantEqual', [10877, 824]], ['NotLessTilde', [8820]], ['NotNestedGreaterGreater', [10914, 824]], ['NotNestedLessLess', [10913, 824]], ['notni', [8716]], ['notniva', [8716]], ['notnivb', [8958]], ['notnivc', [8957]], ['NotPrecedes', [8832]], ['NotPrecedesEqual', [10927, 824]], ['NotPrecedesSlantEqual', [8928]], ['NotReverseElement', [8716]], ['NotRightTriangleBar', [10704, 824]], ['NotRightTriangle', [8939]], ['NotRightTriangleEqual', [8941]], ['NotSquareSubset', [8847, 824]], ['NotSquareSubsetEqual', [8930]], ['NotSquareSuperset', [8848, 824]], ['NotSquareSupersetEqual', [8931]], ['NotSubset', [8834, 8402]], ['NotSubsetEqual', [8840]], ['NotSucceeds', [8833]], ['NotSucceedsEqual', [10928, 824]], ['NotSucceedsSlantEqual', [8929]], ['NotSucceedsTilde', [8831, 824]], ['NotSuperset', [8835, 8402]], ['NotSupersetEqual', [8841]], ['NotTilde', [8769]], ['NotTildeEqual', [8772]], ['NotTildeFullEqual', [8775]], ['NotTildeTilde', [8777]], ['NotVerticalBar', [8740]], ['nparallel', [8742]], ['npar', [8742]], ['nparsl', [11005, 8421]], ['npart', [8706, 824]], ['npolint', [10772]], ['npr', [8832]], ['nprcue', [8928]], ['nprec', [8832]], ['npreceq', [10927, 824]], ['npre', [10927, 824]], ['nrarrc', [10547, 824]], ['nrarr', [8603]], ['nrArr', [8655]], ['nrarrw', [8605, 824]], ['nrightarrow', [8603]], ['nRightarrow', [8655]], ['nrtri', [8939]], ['nrtrie', [8941]], ['nsc', [8833]], ['nsccue', [8929]], ['nsce', [10928, 824]], ['Nscr', [119977]], ['nscr', [120003]], ['nshortmid', [8740]], ['nshortparallel', [8742]], ['nsim', [8769]], ['nsime', [8772]], ['nsimeq', [8772]], ['nsmid', [8740]], ['nspar', [8742]], ['nsqsube', [8930]], ['nsqsupe', [8931]], ['nsub', [8836]], ['nsubE', [10949, 824]], ['nsube', [8840]], ['nsubset', [8834, 8402]], ['nsubseteq', [8840]], ['nsubseteqq', [10949, 824]], ['nsucc', [8833]], ['nsucceq', [10928, 824]], ['nsup', [8837]], ['nsupE', [10950, 824]], ['nsupe', [8841]], ['nsupset', [8835, 8402]], ['nsupseteq', [8841]], ['nsupseteqq', [10950, 824]], ['ntgl', [8825]], ['Ntilde', [209]], ['ntilde', [241]], ['ntlg', [8824]], ['ntriangleleft', [8938]], ['ntrianglelefteq', [8940]], ['ntriangleright', [8939]], ['ntrianglerighteq', [8941]], ['Nu', [925]], ['nu', [957]], ['num', [35]], ['numero', [8470]], ['numsp', [8199]], ['nvap', [8781, 8402]], ['nvdash', [8876]], ['nvDash', [8877]], ['nVdash', [8878]], ['nVDash', [8879]], ['nvge', [8805, 8402]], ['nvgt', [62, 8402]], ['nvHarr', [10500]], ['nvinfin', [10718]], ['nvlArr', [10498]], ['nvle', [8804, 8402]], ['nvlt', [60, 8402]], ['nvltrie', [8884, 8402]], ['nvrArr', [10499]], ['nvrtrie', [8885, 8402]], ['nvsim', [8764, 8402]], ['nwarhk', [10531]], ['nwarr', [8598]], ['nwArr', [8662]], ['nwarrow', [8598]], ['nwnear', [10535]], ['Oacute', [211]], ['oacute', [243]], ['oast', [8859]], ['Ocirc', [212]], ['ocirc', [244]], ['ocir', [8858]], ['Ocy', [1054]], ['ocy', [1086]], ['odash', [8861]], ['Odblac', [336]], ['odblac', [337]], ['odiv', [10808]], ['odot', [8857]], ['odsold', [10684]], ['OElig', [338]], ['oelig', [339]], ['ofcir', [10687]], ['Ofr', [120082]], ['ofr', [120108]], ['ogon', [731]], ['Ograve', [210]], ['ograve', [242]], ['ogt', [10689]], ['ohbar', [10677]], ['ohm', [937]], ['oint', [8750]], ['olarr', [8634]], ['olcir', [10686]], ['olcross', [10683]], ['oline', [8254]], ['olt', [10688]], ['Omacr', [332]], ['omacr', [333]], ['Omega', [937]], ['omega', [969]], ['Omicron', [927]], ['omicron', [959]], ['omid', [10678]], ['ominus', [8854]], ['Oopf', [120134]], ['oopf', [120160]], ['opar', [10679]], ['OpenCurlyDoubleQuote', [8220]], ['OpenCurlyQuote', [8216]], ['operp', [10681]], ['oplus', [8853]], ['orarr', [8635]], ['Or', [10836]], ['or', [8744]], ['ord', [10845]], ['order', [8500]], ['orderof', [8500]], ['ordf', [170]], ['ordm', [186]], ['origof', [8886]], ['oror', [10838]], ['orslope', [10839]], ['orv', [10843]], ['oS', [9416]], ['Oscr', [119978]], ['oscr', [8500]], ['Oslash', [216]], ['oslash', [248]], ['osol', [8856]], ['Otilde', [213]], ['otilde', [245]], ['otimesas', [10806]], ['Otimes', [10807]], ['otimes', [8855]], ['Ouml', [214]], ['ouml', [246]], ['ovbar', [9021]], ['OverBar', [8254]], ['OverBrace', [9182]], ['OverBracket', [9140]], ['OverParenthesis', [9180]], ['para', [182]], ['parallel', [8741]], ['par', [8741]], ['parsim', [10995]], ['parsl', [11005]], ['part', [8706]], ['PartialD', [8706]], ['Pcy', [1055]], ['pcy', [1087]], ['percnt', [37]], ['period', [46]], ['permil', [8240]], ['perp', [8869]], ['pertenk', [8241]], ['Pfr', [120083]], ['pfr', [120109]], ['Phi', [934]], ['phi', [966]], ['phiv', [981]], ['phmmat', [8499]], ['phone', [9742]], ['Pi', [928]], ['pi', [960]], ['pitchfork', [8916]], ['piv', [982]], ['planck', [8463]], ['planckh', [8462]], ['plankv', [8463]], ['plusacir', [10787]], ['plusb', [8862]], ['pluscir', [10786]], ['plus', [43]], ['plusdo', [8724]], ['plusdu', [10789]], ['pluse', [10866]], ['PlusMinus', [177]], ['plusmn', [177]], ['plussim', [10790]], ['plustwo', [10791]], ['pm', [177]], ['Poincareplane', [8460]], ['pointint', [10773]], ['popf', [120161]], ['Popf', [8473]], ['pound', [163]], ['prap', [10935]], ['Pr', [10939]], ['pr', [8826]], ['prcue', [8828]], ['precapprox', [10935]], ['prec', [8826]], ['preccurlyeq', [8828]], ['Precedes', [8826]], ['PrecedesEqual', [10927]], ['PrecedesSlantEqual', [8828]], ['PrecedesTilde', [8830]], ['preceq', [10927]], ['precnapprox', [10937]], ['precneqq', [10933]], ['precnsim', [8936]], ['pre', [10927]], ['prE', [10931]], ['precsim', [8830]], ['prime', [8242]], ['Prime', [8243]], ['primes', [8473]], ['prnap', [10937]], ['prnE', [10933]], ['prnsim', [8936]], ['prod', [8719]], ['Product', [8719]], ['profalar', [9006]], ['profline', [8978]], ['profsurf', [8979]], ['prop', [8733]], ['Proportional', [8733]], ['Proportion', [8759]], ['propto', [8733]], ['prsim', [8830]], ['prurel', [8880]], ['Pscr', [119979]], ['pscr', [120005]], ['Psi', [936]], ['psi', [968]], ['puncsp', [8200]], ['Qfr', [120084]], ['qfr', [120110]], ['qint', [10764]], ['qopf', [120162]], ['Qopf', [8474]], ['qprime', [8279]], ['Qscr', [119980]], ['qscr', [120006]], ['quaternions', [8461]], ['quatint', [10774]], ['quest', [63]], ['questeq', [8799]], ['quot', [34]], ['QUOT', [34]], ['rAarr', [8667]], ['race', [8765, 817]], ['Racute', [340]], ['racute', [341]], ['radic', [8730]], ['raemptyv', [10675]], ['rang', [10217]], ['Rang', [10219]], ['rangd', [10642]], ['range', [10661]], ['rangle', [10217]], ['raquo', [187]], ['rarrap', [10613]], ['rarrb', [8677]], ['rarrbfs', [10528]], ['rarrc', [10547]], ['rarr', [8594]], ['Rarr', [8608]], ['rArr', [8658]], ['rarrfs', [10526]], ['rarrhk', [8618]], ['rarrlp', [8620]], ['rarrpl', [10565]], ['rarrsim', [10612]], ['Rarrtl', [10518]], ['rarrtl', [8611]], ['rarrw', [8605]], ['ratail', [10522]], ['rAtail', [10524]], ['ratio', [8758]], ['rationals', [8474]], ['rbarr', [10509]], ['rBarr', [10511]], ['RBarr', [10512]], ['rbbrk', [10099]], ['rbrace', [125]], ['rbrack', [93]], ['rbrke', [10636]], ['rbrksld', [10638]], ['rbrkslu', [10640]], ['Rcaron', [344]], ['rcaron', [345]], ['Rcedil', [342]], ['rcedil', [343]], ['rceil', [8969]], ['rcub', [125]], ['Rcy', [1056]], ['rcy', [1088]], ['rdca', [10551]], ['rdldhar', [10601]], ['rdquo', [8221]], ['rdquor', [8221]], ['CloseCurlyDoubleQuote', [8221]], ['rdsh', [8627]], ['real', [8476]], ['realine', [8475]], ['realpart', [8476]], ['reals', [8477]], ['Re', [8476]], ['rect', [9645]], ['reg', [174]], ['REG', [174]], ['ReverseElement', [8715]], ['ReverseEquilibrium', [8651]], ['ReverseUpEquilibrium', [10607]], ['rfisht', [10621]], ['rfloor', [8971]], ['rfr', [120111]], ['Rfr', [8476]], ['rHar', [10596]], ['rhard', [8641]], ['rharu', [8640]], ['rharul', [10604]], ['Rho', [929]], ['rho', [961]], ['rhov', [1009]], ['RightAngleBracket', [10217]], ['RightArrowBar', [8677]], ['rightarrow', [8594]], ['RightArrow', [8594]], ['Rightarrow', [8658]], ['RightArrowLeftArrow', [8644]], ['rightarrowtail', [8611]], ['RightCeiling', [8969]], ['RightDoubleBracket', [10215]], ['RightDownTeeVector', [10589]], ['RightDownVectorBar', [10581]], ['RightDownVector', [8642]], ['RightFloor', [8971]], ['rightharpoondown', [8641]], ['rightharpoonup', [8640]], ['rightleftarrows', [8644]], ['rightleftharpoons', [8652]], ['rightrightarrows', [8649]], ['rightsquigarrow', [8605]], ['RightTeeArrow', [8614]], ['RightTee', [8866]], ['RightTeeVector', [10587]], ['rightthreetimes', [8908]], ['RightTriangleBar', [10704]], ['RightTriangle', [8883]], ['RightTriangleEqual', [8885]], ['RightUpDownVector', [10575]], ['RightUpTeeVector', [10588]], ['RightUpVectorBar', [10580]], ['RightUpVector', [8638]], ['RightVectorBar', [10579]], ['RightVector', [8640]], ['ring', [730]], ['risingdotseq', [8787]], ['rlarr', [8644]], ['rlhar', [8652]], ['rlm', [8207]], ['rmoustache', [9137]], ['rmoust', [9137]], ['rnmid', [10990]], ['roang', [10221]], ['roarr', [8702]], ['robrk', [10215]], ['ropar', [10630]], ['ropf', [120163]], ['Ropf', [8477]], ['roplus', [10798]], ['rotimes', [10805]], ['RoundImplies', [10608]], ['rpar', [41]], ['rpargt', [10644]], ['rppolint', [10770]], ['rrarr', [8649]], ['Rrightarrow', [8667]], ['rsaquo', [8250]], ['rscr', [120007]], ['Rscr', [8475]], ['rsh', [8625]], ['Rsh', [8625]], ['rsqb', [93]], ['rsquo', [8217]], ['rsquor', [8217]], ['CloseCurlyQuote', [8217]], ['rthree', [8908]], ['rtimes', [8906]], ['rtri', [9657]], ['rtrie', [8885]], ['rtrif', [9656]], ['rtriltri', [10702]], ['RuleDelayed', [10740]], ['ruluhar', [10600]], ['rx', [8478]], ['Sacute', [346]], ['sacute', [347]], ['sbquo', [8218]], ['scap', [10936]], ['Scaron', [352]], ['scaron', [353]], ['Sc', [10940]], ['sc', [8827]], ['sccue', [8829]], ['sce', [10928]], ['scE', [10932]], ['Scedil', [350]], ['scedil', [351]], ['Scirc', [348]], ['scirc', [349]], ['scnap', [10938]], ['scnE', [10934]], ['scnsim', [8937]], ['scpolint', [10771]], ['scsim', [8831]], ['Scy', [1057]], ['scy', [1089]], ['sdotb', [8865]], ['sdot', [8901]], ['sdote', [10854]], ['searhk', [10533]], ['searr', [8600]], ['seArr', [8664]], ['searrow', [8600]], ['sect', [167]], ['semi', [59]], ['seswar', [10537]], ['setminus', [8726]], ['setmn', [8726]], ['sext', [10038]], ['Sfr', [120086]], ['sfr', [120112]], ['sfrown', [8994]], ['sharp', [9839]], ['SHCHcy', [1065]], ['shchcy', [1097]], ['SHcy', [1064]], ['shcy', [1096]], ['ShortDownArrow', [8595]], ['ShortLeftArrow', [8592]], ['shortmid', [8739]], ['shortparallel', [8741]], ['ShortRightArrow', [8594]], ['ShortUpArrow', [8593]], ['shy', [173]], ['Sigma', [931]], ['sigma', [963]], ['sigmaf', [962]], ['sigmav', [962]], ['sim', [8764]], ['simdot', [10858]], ['sime', [8771]], ['simeq', [8771]], ['simg', [10910]], ['simgE', [10912]], ['siml', [10909]], ['simlE', [10911]], ['simne', [8774]], ['simplus', [10788]], ['simrarr', [10610]], ['slarr', [8592]], ['SmallCircle', [8728]], ['smallsetminus', [8726]], ['smashp', [10803]], ['smeparsl', [10724]], ['smid', [8739]], ['smile', [8995]], ['smt', [10922]], ['smte', [10924]], ['smtes', [10924, 65024]], ['SOFTcy', [1068]], ['softcy', [1100]], ['solbar', [9023]], ['solb', [10692]], ['sol', [47]], ['Sopf', [120138]], ['sopf', [120164]], ['spades', [9824]], ['spadesuit', [9824]], ['spar', [8741]], ['sqcap', [8851]], ['sqcaps', [8851, 65024]], ['sqcup', [8852]], ['sqcups', [8852, 65024]], ['Sqrt', [8730]], ['sqsub', [8847]], ['sqsube', [8849]], ['sqsubset', [8847]], ['sqsubseteq', [8849]], ['sqsup', [8848]], ['sqsupe', [8850]], ['sqsupset', [8848]], ['sqsupseteq', [8850]], ['square', [9633]], ['Square', [9633]], ['SquareIntersection', [8851]], ['SquareSubset', [8847]], ['SquareSubsetEqual', [8849]], ['SquareSuperset', [8848]], ['SquareSupersetEqual', [8850]], ['SquareUnion', [8852]], ['squarf', [9642]], ['squ', [9633]], ['squf', [9642]], ['srarr', [8594]], ['Sscr', [119982]], ['sscr', [120008]], ['ssetmn', [8726]], ['ssmile', [8995]], ['sstarf', [8902]], ['Star', [8902]], ['star', [9734]], ['starf', [9733]], ['straightepsilon', [1013]], ['straightphi', [981]], ['strns', [175]], ['sub', [8834]], ['Sub', [8912]], ['subdot', [10941]], ['subE', [10949]], ['sube', [8838]], ['subedot', [10947]], ['submult', [10945]], ['subnE', [10955]], ['subne', [8842]], ['subplus', [10943]], ['subrarr', [10617]], ['subset', [8834]], ['Subset', [8912]], ['subseteq', [8838]], ['subseteqq', [10949]], ['SubsetEqual', [8838]], ['subsetneq', [8842]], ['subsetneqq', [10955]], ['subsim', [10951]], ['subsub', [10965]], ['subsup', [10963]], ['succapprox', [10936]], ['succ', [8827]], ['succcurlyeq', [8829]], ['Succeeds', [8827]], ['SucceedsEqual', [10928]], ['SucceedsSlantEqual', [8829]], ['SucceedsTilde', [8831]], ['succeq', [10928]], ['succnapprox', [10938]], ['succneqq', [10934]], ['succnsim', [8937]], ['succsim', [8831]], ['SuchThat', [8715]], ['sum', [8721]], ['Sum', [8721]], ['sung', [9834]], ['sup1', [185]], ['sup2', [178]], ['sup3', [179]], ['sup', [8835]], ['Sup', [8913]], ['supdot', [10942]], ['supdsub', [10968]], ['supE', [10950]], ['supe', [8839]], ['supedot', [10948]], ['Superset', [8835]], ['SupersetEqual', [8839]], ['suphsol', [10185]], ['suphsub', [10967]], ['suplarr', [10619]], ['supmult', [10946]], ['supnE', [10956]], ['supne', [8843]], ['supplus', [10944]], ['supset', [8835]], ['Supset', [8913]], ['supseteq', [8839]], ['supseteqq', [10950]], ['supsetneq', [8843]], ['supsetneqq', [10956]], ['supsim', [10952]], ['supsub', [10964]], ['supsup', [10966]], ['swarhk', [10534]], ['swarr', [8601]], ['swArr', [8665]], ['swarrow', [8601]], ['swnwar', [10538]], ['szlig', [223]], ['Tab', [9]], ['target', [8982]], ['Tau', [932]], ['tau', [964]], ['tbrk', [9140]], ['Tcaron', [356]], ['tcaron', [357]], ['Tcedil', [354]], ['tcedil', [355]], ['Tcy', [1058]], ['tcy', [1090]], ['tdot', [8411]], ['telrec', [8981]], ['Tfr', [120087]], ['tfr', [120113]], ['there4', [8756]], ['therefore', [8756]], ['Therefore', [8756]], ['Theta', [920]], ['theta', [952]], ['thetasym', [977]], ['thetav', [977]], ['thickapprox', [8776]], ['thicksim', [8764]], ['ThickSpace', [8287, 8202]], ['ThinSpace', [8201]], ['thinsp', [8201]], ['thkap', [8776]], ['thksim', [8764]], ['THORN', [222]], ['thorn', [254]], ['tilde', [732]], ['Tilde', [8764]], ['TildeEqual', [8771]], ['TildeFullEqual', [8773]], ['TildeTilde', [8776]], ['timesbar', [10801]], ['timesb', [8864]], ['times', [215]], ['timesd', [10800]], ['tint', [8749]], ['toea', [10536]], ['topbot', [9014]], ['topcir', [10993]], ['top', [8868]], ['Topf', [120139]], ['topf', [120165]], ['topfork', [10970]], ['tosa', [10537]], ['tprime', [8244]], ['trade', [8482]], ['TRADE', [8482]], ['triangle', [9653]], ['triangledown', [9663]], ['triangleleft', [9667]], ['trianglelefteq', [8884]], ['triangleq', [8796]], ['triangleright', [9657]], ['trianglerighteq', [8885]], ['tridot', [9708]], ['trie', [8796]], ['triminus', [10810]], ['TripleDot', [8411]], ['triplus', [10809]], ['trisb', [10701]], ['tritime', [10811]], ['trpezium', [9186]], ['Tscr', [119983]], ['tscr', [120009]], ['TScy', [1062]], ['tscy', [1094]], ['TSHcy', [1035]], ['tshcy', [1115]], ['Tstrok', [358]], ['tstrok', [359]], ['twixt', [8812]], ['twoheadleftarrow', [8606]], ['twoheadrightarrow', [8608]], ['Uacute', [218]], ['uacute', [250]], ['uarr', [8593]], ['Uarr', [8607]], ['uArr', [8657]], ['Uarrocir', [10569]], ['Ubrcy', [1038]], ['ubrcy', [1118]], ['Ubreve', [364]], ['ubreve', [365]], ['Ucirc', [219]], ['ucirc', [251]], ['Ucy', [1059]], ['ucy', [1091]], ['udarr', [8645]], ['Udblac', [368]], ['udblac', [369]], ['udhar', [10606]], ['ufisht', [10622]], ['Ufr', [120088]], ['ufr', [120114]], ['Ugrave', [217]], ['ugrave', [249]], ['uHar', [10595]], ['uharl', [8639]], ['uharr', [8638]], ['uhblk', [9600]], ['ulcorn', [8988]], ['ulcorner', [8988]], ['ulcrop', [8975]], ['ultri', [9720]], ['Umacr', [362]], ['umacr', [363]], ['uml', [168]], ['UnderBar', [95]], ['UnderBrace', [9183]], ['UnderBracket', [9141]], ['UnderParenthesis', [9181]], ['Union', [8899]], ['UnionPlus', [8846]], ['Uogon', [370]], ['uogon', [371]], ['Uopf', [120140]], ['uopf', [120166]], ['UpArrowBar', [10514]], ['uparrow', [8593]], ['UpArrow', [8593]], ['Uparrow', [8657]], ['UpArrowDownArrow', [8645]], ['updownarrow', [8597]], ['UpDownArrow', [8597]], ['Updownarrow', [8661]], ['UpEquilibrium', [10606]], ['upharpoonleft', [8639]], ['upharpoonright', [8638]], ['uplus', [8846]], ['UpperLeftArrow', [8598]], ['UpperRightArrow', [8599]], ['upsi', [965]], ['Upsi', [978]], ['upsih', [978]], ['Upsilon', [933]], ['upsilon', [965]], ['UpTeeArrow', [8613]], ['UpTee', [8869]], ['upuparrows', [8648]], ['urcorn', [8989]], ['urcorner', [8989]], ['urcrop', [8974]], ['Uring', [366]], ['uring', [367]], ['urtri', [9721]], ['Uscr', [119984]], ['uscr', [120010]], ['utdot', [8944]], ['Utilde', [360]], ['utilde', [361]], ['utri', [9653]], ['utrif', [9652]], ['uuarr', [8648]], ['Uuml', [220]], ['uuml', [252]], ['uwangle', [10663]], ['vangrt', [10652]], ['varepsilon', [1013]], ['varkappa', [1008]], ['varnothing', [8709]], ['varphi', [981]], ['varpi', [982]], ['varpropto', [8733]], ['varr', [8597]], ['vArr', [8661]], ['varrho', [1009]], ['varsigma', [962]], ['varsubsetneq', [8842, 65024]], ['varsubsetneqq', [10955, 65024]], ['varsupsetneq', [8843, 65024]], ['varsupsetneqq', [10956, 65024]], ['vartheta', [977]], ['vartriangleleft', [8882]], ['vartriangleright', [8883]], ['vBar', [10984]], ['Vbar', [10987]], ['vBarv', [10985]], ['Vcy', [1042]], ['vcy', [1074]], ['vdash', [8866]], ['vDash', [8872]], ['Vdash', [8873]], ['VDash', [8875]], ['Vdashl', [10982]], ['veebar', [8891]], ['vee', [8744]], ['Vee', [8897]], ['veeeq', [8794]], ['vellip', [8942]], ['verbar', [124]], ['Verbar', [8214]], ['vert', [124]], ['Vert', [8214]], ['VerticalBar', [8739]], ['VerticalLine', [124]], ['VerticalSeparator', [10072]], ['VerticalTilde', [8768]], ['VeryThinSpace', [8202]], ['Vfr', [120089]], ['vfr', [120115]], ['vltri', [8882]], ['vnsub', [8834, 8402]], ['vnsup', [8835, 8402]], ['Vopf', [120141]], ['vopf', [120167]], ['vprop', [8733]], ['vrtri', [8883]], ['Vscr', [119985]], ['vscr', [120011]], ['vsubnE', [10955, 65024]], ['vsubne', [8842, 65024]], ['vsupnE', [10956, 65024]], ['vsupne', [8843, 65024]], ['Vvdash', [8874]], ['vzigzag', [10650]], ['Wcirc', [372]], ['wcirc', [373]], ['wedbar', [10847]], ['wedge', [8743]], ['Wedge', [8896]], ['wedgeq', [8793]], ['weierp', [8472]], ['Wfr', [120090]], ['wfr', [120116]], ['Wopf', [120142]], ['wopf', [120168]], ['wp', [8472]], ['wr', [8768]], ['wreath', [8768]], ['Wscr', [119986]], ['wscr', [120012]], ['xcap', [8898]], ['xcirc', [9711]], ['xcup', [8899]], ['xdtri', [9661]], ['Xfr', [120091]], ['xfr', [120117]], ['xharr', [10231]], ['xhArr', [10234]], ['Xi', [926]], ['xi', [958]], ['xlarr', [10229]], ['xlArr', [10232]], ['xmap', [10236]], ['xnis', [8955]], ['xodot', [10752]], ['Xopf', [120143]], ['xopf', [120169]], ['xoplus', [10753]], ['xotime', [10754]], ['xrarr', [10230]], ['xrArr', [10233]], ['Xscr', [119987]], ['xscr', [120013]], ['xsqcup', [10758]], ['xuplus', [10756]], ['xutri', [9651]], ['xvee', [8897]], ['xwedge', [8896]], ['Yacute', [221]], ['yacute', [253]], ['YAcy', [1071]], ['yacy', [1103]], ['Ycirc', [374]], ['ycirc', [375]], ['Ycy', [1067]], ['ycy', [1099]], ['yen', [165]], ['Yfr', [120092]], ['yfr', [120118]], ['YIcy', [1031]], ['yicy', [1111]], ['Yopf', [120144]], ['yopf', [120170]], ['Yscr', [119988]], ['yscr', [120014]], ['YUcy', [1070]], ['yucy', [1102]], ['yuml', [255]], ['Yuml', [376]], ['Zacute', [377]], ['zacute', [378]], ['Zcaron', [381]], ['zcaron', [382]], ['Zcy', [1047]], ['zcy', [1079]], ['Zdot', [379]], ['zdot', [380]], ['zeetrf', [8488]], ['ZeroWidthSpace', [8203]], ['Zeta', [918]], ['zeta', [950]], ['zfr', [120119]], ['Zfr', [8488]], ['ZHcy', [1046]], ['zhcy', [1078]], ['zigrarr', [8669]], ['zopf', [120171]], ['Zopf', [8484]], ['Zscr', [119989]], ['zscr', [120015]], ['zwj', [8205]], ['zwnj', [8204]]];
	
	var alphaIndex = {};
	var charIndex = {};
	
	createIndexes(alphaIndex, charIndex);
	
	/**
	 * @constructor
	 */
	function Html5Entities() {}
	
	/**
	 * @param {String} str
	 * @returns {String}
	 */
	Html5Entities.prototype.decode = function(str) {
	    if (!str || !str.length) {
	        return '';
	    }
	    return str.replace(/&(#?[\w\d]+);?/g, function(s, entity) {
	        var chr;
	        if (entity.charAt(0) === "#") {
	            var code = entity.charAt(1) === 'x' ?
	                parseInt(entity.substr(2).toLowerCase(), 16) :
	                parseInt(entity.substr(1));
	
	            if (!(isNaN(code) || code < -32768 || code > 65535)) {
	                chr = String.fromCharCode(code);
	            }
	        } else {
	            chr = alphaIndex[entity];
	        }
	        return chr || s;
	    });
	};
	
	/**
	 * @param {String} str
	 * @returns {String}
	 */
	 Html5Entities.decode = function(str) {
	    return new Html5Entities().decode(str);
	 };
	
	/**
	 * @param {String} str
	 * @returns {String}
	 */
	Html5Entities.prototype.encode = function(str) {
	    if (!str || !str.length) {
	        return '';
	    }
	    var strLength = str.length;
	    var result = '';
	    var i = 0;
	    while (i < strLength) {
	        var charInfo = charIndex[str.charCodeAt(i)];
	        if (charInfo) {
	            var alpha = charInfo[str.charCodeAt(i + 1)];
	            if (alpha) {
	                i++;
	            } else {
	                alpha = charInfo[''];
	            }
	            if (alpha) {
	                result += "&" + alpha + ";";
	                i++;
	                continue;
	            }
	        }
	        result += str.charAt(i);
	        i++;
	    }
	    return result;
	};
	
	/**
	 * @param {String} str
	 * @returns {String}
	 */
	 Html5Entities.encode = function(str) {
	    return new Html5Entities().encode(str);
	 };
	
	/**
	 * @param {String} str
	 * @returns {String}
	 */
	Html5Entities.prototype.encodeNonUTF = function(str) {
	    if (!str || !str.length) {
	        return '';
	    }
	    var strLength = str.length;
	    var result = '';
	    var i = 0;
	    while (i < strLength) {
	        var c = str.charCodeAt(i);
	        var charInfo = charIndex[c];
	        if (charInfo) {
	            var alpha = charInfo[str.charCodeAt(i + 1)];
	            if (alpha) {
	                i++;
	            } else {
	                alpha = charInfo[''];
	            }
	            if (alpha) {
	                result += "&" + alpha + ";";
	                i++;
	                continue;
	            }
	        }
	        if (c < 32 || c > 126) {
	            result += '&#' + c + ';';
	        } else {
	            result += str.charAt(i);
	        }
	        i++;
	    }
	    return result;
	};
	
	/**
	 * @param {String} str
	 * @returns {String}
	 */
	 Html5Entities.encodeNonUTF = function(str) {
	    return new Html5Entities().encodeNonUTF(str);
	 };
	
	/**
	 * @param {String} str
	 * @returns {String}
	 */
	Html5Entities.prototype.encodeNonASCII = function(str) {
	    if (!str || !str.length) {
	        return '';
	    }
	    var strLength = str.length;
	    var result = '';
	    var i = 0;
	    while (i < strLength) {
	        var c = str.charCodeAt(i);
	        if (c <= 255) {
	            result += str[i++];
	            continue;
	        }
	        result += '&#' + c + ';';
	        i++
	    }
	    return result;
	};
	
	/**
	 * @param {String} str
	 * @returns {String}
	 */
	 Html5Entities.encodeNonASCII = function(str) {
	    return new Html5Entities().encodeNonASCII(str);
	 };
	
	/**
	 * @param {Object} alphaIndex Passed by reference.
	 * @param {Object} charIndex Passed by reference.
	 */
	function createIndexes(alphaIndex, charIndex) {
	    var i = ENTITIES.length;
	    var _results = [];
	    while (i--) {
	        var e = ENTITIES[i];
	        var alpha = e[0];
	        var chars = e[1];
	        var chr = chars[0];
	        var addChar = (chr < 32 || chr > 126) || chr === 62 || chr === 60 || chr === 38 || chr === 34 || chr === 39;
	        var charInfo;
	        if (addChar) {
	            charInfo = charIndex[chr] = charIndex[chr] || {};
	        }
	        if (chars[1]) {
	            var chr2 = chars[1];
	            alphaIndex[alpha] = String.fromCharCode(chr) + String.fromCharCode(chr2);
	            _results.push(addChar && (charInfo[chr2] = alpha));
	        } else {
	            alphaIndex[alpha] = String.fromCharCode(chr);
	            _results.push(addChar && (charInfo[''] = alpha));
	        }
	    }
	}
	
	module.exports = Html5Entities;


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeOf = __webpack_require__(578);
	
	var _typeOf2 = _interopRequireDefault(_typeOf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ucFirst(string) {
	  if ((0, _typeOf2.default)(string) === 'string') {
	    return string.charAt(0).toUpperCase() + string.slice(1);
	  }
	  return string;
	}
	
	exports.default = ucFirst;

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.clubhouse = undefined;
	
	var _modules = __webpack_require__(848);
	
	var _common = __webpack_require__(814);
	
	var _translate = __webpack_require__(833);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @fileOverview Clubhouse (/team/1/england) page parser functions
	 */
	
	/**
	 * Rugby Clubhouse data parsers
	 * @type {Object}
	 */
	var clubhouse = exports.clubhouse = {
	  modules: _modules.modules,
	  /**
	   * [getMetaData updates meta data]
	   * @param  {[type]} edition [editions data]
	   * @param  {[type]} params   [normalized params]
	   * @param  {[type]} team     [team information]
	   * @param  {[type]} location [location information]
	   * @return {[type]}          [returns object]
	   */
	  getMetaData: function getMetaData() {
	    var edition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var team = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    var title = '';
	    var description = '';
	    var keywords = '';
	
	    if (typeof team !== 'undefined') {
	      if (team.hasOwnProperty('name') === true) {
	        var team_name = team.name ? team.name : '';
	        var team_logo = team.logoLarge ? team.logoLarge : '';
	        var slug = team.displayName ? team.displayName : team_name;
	        slug = _common.common.getSafeSlug(slug);
	
	        var canonical = _common.common.createCanonical(edition, params, null, slug);
	
	        if (params.sport === 'rugby' && params.slug) {
	          var titleTransObj = {
	            key: 'meta.title.rugby.clubhouse',
	            team: team_name
	          };
	          var descriptionTransObj = {
	            key: 'meta.description.rugby.clubhouse',
	            team: team_name
	          };
	          var keywordsTransObj = {
	            key: 'meta.keywords.rugby.clubhouse',
	            team: team_name
	          };
	          title = (0, _translate2.default)(edition, titleTransObj) || '';
	          description = (0, _translate2.default)(edition, descriptionTransObj) || '';
	          keywords = (0, _translate2.default)(edition, keywordsTransObj) || '';
	        }
	
	        return {
	          slug: slug,
	          title: title || team_name + ' News and Scores - ESPN',
	          description: description || 'Get the latest ' + team_name + ' news, scores, stats, standings, rumours, and more from ESPN.',
	          keywords: keywords || team_name + ', rugby, rugby union, scores, news, schedule, highlights',
	          website: 'article',
	          canonical: canonical,
	          image: team_logo
	        };
	      }
	    }
	  }
	};
	
	exports.default = clubhouse;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.modules = undefined;
	
	var _extends2 = __webpack_require__(364);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _selectn = __webpack_require__(438);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	var _common = __webpack_require__(814);
	
	var _helpers = __webpack_require__(849);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _translate = __webpack_require__(833);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modules = exports.modules = {
	  /**
	    * [getStandings get Rugby standings data]
	    * @param  {[type]} standingsData [raw data object]
	    * @param  {[type]} league [raw data object]
	    * @param  {[type]} params [raw data object]
	    * @param {Object} edition edition information
	    * @return {[type]} [object]
	    */
	  getStandings: function getStandings(standingsData, league) {
	    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var edition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	    var typesToShow = [/* stats type in order of display + special team to show teamname */
	    'rank', 'team', 'gamesplayed', 'pointsdifference', 'points'];
	    var standings = _common.common.getStandingsData(standingsData, typesToShow, params.sport, 'TeamClubhouse', edition);
	    var standingsLink = _common.common.getStandingsLink((0, _extends3.default)({}, params, { leagueId: standingsData.id }), {}, 'TeamClubhouse', {}, '', edition);
	    var transObj = {
	      key: 'rugby.table.heading',
	      season: (0, _selectn2.default)('season.year', league) || '',
	      leaguename: standings.title
	    };
	    standings.title = (0, _translate2.default)(edition, transObj);
	    return (0, _extends3.default)({}, standings, { link: (0, _extends3.default)({}, standingsLink, { external: true }), displayKey: 'displayName', params: params });
	  },
	
	
	  /**
	   * get ordered array of chart input data which is a comparison of current team vs highest rated team
	   * @param  {Object} standingsData [raw data object]
	   * @param  {Object} team [raw data object]
	   * @return {Object}           [object]
	   */
	
	  getTeamRankings: function getTeamRankings(standingsData) {
	    var team = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var edition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    var processedStats = _helpers2.default.getProcessedStats((0, _selectn2.default)('feed.children', standingsData));
	    if (!processedStats.length) {
	      return;
	    }
	    var triesComp = _helpers2.default.getStatComparison(processedStats, 'triesfor', team.id, edition);
	    var pointsComp = _helpers2.default.getStatComparison(processedStats, 'pointsdifference', team.id, edition);
	    var triesChart = (0, _extends3.default)({}, triesComp, {
	      heading: (0, _translate2.default)(edition, 'Tries Scored'),
	      subHeading: '',
	      chartType: 'curve',
	      statName: 'Tries'
	    });
	    triesChart.subHeading = _helpers2.default.getChartSubHeading((0, _extends3.default)({}, triesComp, { type: 'Tries Scored', edition: edition }));
	    var pointsChart = (0, _extends3.default)({}, pointsComp, {
	      heading: (0, _translate2.default)(edition, 'Points Difference'),
	      subHeading: '',
	      chartType: 'line',
	      statName: 'points'
	    });
	    pointsChart.subHeading = _helpers2.default.getChartSubHeading((0, _extends3.default)({}, pointsComp, { type: 'Points Difference', edition: edition }));
	    var season = '' + (0, _selectn2.default)('league.season.year', standingsData);
	    var subtitle = (0, _selectn2.default)('league.name', standingsData);
	    // check if current team is top in all the comparison of stats
	    var tracking = _common.common.createTrackingName(['Rugby', 'TeamClubhouse', 'Rankings', 'Full']);
	    var isAllTop = (0, _selectn2.default)('homeTeam.rank', pointsComp) == 1 && (0, _selectn2.default)('homeTeam.rank', triesComp) == 1 ? true : false;
	    var link = {
	      href: _helpers2.default.getStatsguruLink(team.id),
	      title: (0, _translate2.default)(edition, 'Full Statistics'),
	      external: true,
	      trackingName: tracking
	    };
	    var transObj = {
	      key: 'Season_Wise_Rankings',
	      seasonYear: season
	    };
	    var title = (0, _translate2.default)(edition, transObj);
	    return {
	      title: title,
	      subtitle: subtitle,
	      isAllTop: isAllTop,
	      charts: [triesChart, pointsChart],
	      link: link,
	      teamColor: '#' + team.color
	    };
	  },
	
	
	  /**
	   * get getTopScorers
	   * @param  {Object} leaders [raw data object]
	   * @param  {Object} team [raw data object]
	   * @param  {[type]} params [raw data object]
	   * @return {Object} topScorers categorized by points / tries [object]
	   */
	
	  getTopScorers: function getTopScorers(leadersNode) {
	    var team = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var edition = arguments[3];
	
	    var season = (0, _selectn2.default)('league.season.year', leadersNode) || '';
	    var transObj = {
	      key: 'Top_Scorers',
	      season: season
	    };
	    var topScorers = {
	      season: (0, _selectn2.default)('league.season.year', leadersNode) || '',
	      title: (0, _translate2.default)(edition, transObj) || '',
	      trackingName: _common.common.createTrackingName([params.sport, params.pageType + 'clubhouse', 'performers', 'player']),
	      players: [],
	      subtitle: (0, _selectn2.default)('league.name', leadersNode) || '',
	      link: {
	        href: _common.common.buildURL(_helpers2.default.getStatsguruLink(team.id)) || '#',
	        title: (0, _translate2.default)(edition, 'Full Team Statistics'),
	        external: true,
	        teamColor: '#' + team.color,
	        trackingName: _common.common.createTrackingName([params.sport, params.pageType + 'clubhouse', 'performers', 'full']) || ''
	      }
	    };
	    var players = (0, _selectn2.default)('feed[0]', leadersNode) || [];
	    var playLen = players.length || 0;
	    var pointsTries = '';
	    var displayCat = '';
	    for (var i = 0; i < playLen; i++) {
	      var leaders = [];
	      var player = (0, _selectn2.default)('statCategories[0].leaders', players[i]) || [];
	      var playerLen = player.length || 0;
	      pointsTries = (0, _selectn2.default)('statCategories[0].displayName', players[i]) || '';
	      displayCat = (0, _selectn2.default)('name', players[i]) || '';
	      for (var e = 0; e < playerLen; e++) {
	        var ePlayer = player[e];
	        if (!playerLen || ePlayer.displayValue === 'undefined') {
	          return;
	        }
	        var playerStats = ePlayer.displayValue.split(', ');
	        var playerStLen = playerStats.length || 0;
	        var stats = [];
	        for (var _e = 0; _e < playerStLen; _e++) {
	          var stat = playerStats[_e].split(': ');
	          stats[stat[0]] = stat[1];
	        }
	        var headshot = (0, _selectn2.default)('headshot', ePlayer.athlete) || '';
	        headshot = headshot ? _common.common.resizeCombinerLogo(headshot, { w: 108, h: 75, transparent: true, scale: 'crop' }) : '';
	        var position = (0, _selectn2.default)('position.abbreviation', ePlayer.athlete) || '';
	        position = position !== '' ? ', ' + position : '';
	        leaders.push({
	          name: (0, _selectn2.default)('displayName', ePlayer.athlete) || '',
	          position: position,
	          href: _common.common.buildURL((0, _selectn2.default)('links[0].href', ePlayer.athlete)) || '#',
	          stats: displayCat === 'points' ? stats.P : stats.T || '',
	          matches: (0, _translate2.default)(edition, 'Matches') + ' ' + stats.M || '',
	          img: headshot || ''
	        });
	      }
	      topScorers.players.push({
	        displayCat: displayCat,
	        displayName: pointsTries,
	        leaders: leaders
	      });
	    }
	    return topScorers;
	  }
	};
	
	exports.default = modules;

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.helpers = undefined;
	
	var _extends2 = __webpack_require__(364);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _selectn = __webpack_require__(438);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	var _common = __webpack_require__(814);
	
	var _translate = __webpack_require__(833);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var helpers = exports.helpers = {
	  /**
	  * Get all Team's stats info in one single array insted of grouping into pools just to ease ranking based on some stats
	  * @param  {Array} standingsData Teams grouped into pools
	  * @return {Array}  one single array having all Team's stats by removing the grouping
	  */
	  getProcessedStats: function getProcessedStats() {
	    var standingsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    var processedStats = [];
	    if (!standingsData) {
	      return;
	    }
	    standingsData.map(function (s) {
	      var entries = (0, _selectn2.default)('standings.entries', s) || [];
	      entries.map(function (entry) {
	        var stats = {};
	        if (entry.stats) {
	          entry.stats.map(function (stat) {
	            stats[stat.type] = stat;
	          });
	        }
	        processedStats.push({
	          stats: stats,
	          team: entry.team
	        });
	      });
	    });
	    return processedStats;
	  },
	
	
	  /**
	  * Get Current Team stats and Highest Team stats by comparing standings accross all the teams
	  * @param  {Array} stats processed stats having data of all the teams
	  * @param {String} statName Name of the stat based on which the comparison need to be done
	  * @param {Number} homeTeamId Id of the team on which user is landing
	  * @param {Object} edition edition information
	  * @return {Object}  Object having some flags and selected Team Stats along with Team ranking first based on current Stat
	  */
	  getStatComparison: function getStatComparison() {
	    var stats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var statName = arguments[1];
	    var homeTeamId = arguments[2];
	    var edition = arguments[3];
	
	    var sortedStats = [];
	    //push all the stats into sortedStats to avoid manupulation of source array and extract obnly the stat required for comparison
	    for (var i = 0; i < stats.length; i++) {
	      sortedStats.push({ team: stats[i].team, stats: stats[i].stats[statName] || {} });
	    }
	
	    //sort in descending order based on statName
	    sortedStats.sort(function (a, b) {
	      var aVal = (0, _selectn2.default)('stats.value', a) || 0;
	      var bVal = (0, _selectn2.default)('stats.value', b) || 0;
	      return bVal - aVal;
	    });
	
	    // add ranking to all the teams ordered from max to min
	    sortedStats.map(function (s, index) {
	      s.rank = index + 1;
	      return s;
	    });
	
	    // handle ranking for dupes
	    sortedStats = this.getRankingForDups(sortedStats);
	
	    // extract stats of selected team based on homeTeamId param
	    var homeTeamStats = {};
	    for (var _i = 0; _i < sortedStats.length; _i++) {
	      var ithStat = sortedStats[_i];
	      if ((0, _selectn2.default)('team.id', ithStat) == homeTeamId) {
	        homeTeamStats = ithStat;
	      }
	    }
	    var awayTeamStats = {};
	    // extract all the Teams ranked first in the sorted array
	    var firstRankTeams = sortedStats.filter(function (a) {
	      return a.rank == 1;
	    });
	    var isTied = false;
	    var isOnlyMax = false;
	
	    // check if only one team ranked first, if so and current team itself is top then update accordingly
	    if (firstRankTeams.length == 1) {
	      if (homeTeamStats.rank == 1) {
	        isOnlyMax = true;
	      } else {
	        awayTeamStats = firstRankTeams[0];
	      }
	    }
	    // if morethan one team ranked first then sort all first rank teams in alphabetical order
	    //extract the first element of array which is a team landed by user
	    // if current team is also one of the teams ranked first then update the flags
	    else {
	        // sort first ranked teams based on alphabetical order
	        firstRankTeams.sort(function (prev, next) {
	          var prevName = (0, _selectn2.default)('team.name', prev) || '';
	          var nextName = (0, _selectn2.default)('team.name', next) || '';
	          return prevName.localeCompare(nextName);
	        });
	        if (homeTeamStats.rank != 1) {
	          awayTeamStats = firstRankTeams[0];
	        } else {
	          var maxStatVal = (0, _selectn2.default)('[0].stats.value', firstRankTeams);
	          if (maxStatVal > 0) {
	            isTied = true;
	          }
	          for (var _i2 = 0; _i2 < firstRankTeams.length; _i2++) {
	            if ((0, _selectn2.default)('team.id', firstRankTeams[_i2]) != homeTeamId) {
	              awayTeamStats = firstRankTeams[_i2];
	              break;
	            }
	          }
	        }
	      }
	    var homeRankMarkup = (0, _translate2.default)(edition, {
	      key: 'rugby.formattedRank',
	      rank: homeTeamStats.rank,
	      ordinal: this.getOrdinalSuffix(homeTeamStats.rank)
	    });
	    var awayRankMarkup = (0, _translate2.default)(edition, {
	      key: 'rugby.formattedRank',
	      rank: awayTeamStats.rank,
	      ordinal: this.getOrdinalSuffix(awayTeamStats.rank)
	    });
	    return {
	      isTied: isTied,
	      isOnlyMax: isOnlyMax,
	      homeTeam: (0, _extends3.default)({}, homeTeamStats.team, {
	        rank: homeTeamStats.rank,
	        rankMarkup: homeRankMarkup,
	        stats: (0, _selectn2.default)('stats.value', homeTeamStats) || 0,
	        teamLogo: _common.common.getTeamLogo(homeTeamStats.team)
	      }),
	      awayTeam: isOnlyMax ? '' : (0, _extends3.default)({}, awayTeamStats.team || {}, {
	        rank: awayTeamStats.rank || 0,
	        rankMarkup: awayRankMarkup,
	        stats: (0, _selectn2.default)('stats.value', awayTeamStats) || 0,
	        teamLogo: _common.common.getTeamLogo(awayTeamStats.team)
	      })
	    };
	  },
	
	
	  /**
	  * When teams are given with a rank there might be ties. This method will handle all those ties and rectify ranking accordingly
	  * @param {Array} stats array of stats ordered in descending order along with ranking but not handled for dupes
	  * @return {Array} array of stats ordered in descending order along with ranking handled for dupes
	  */
	  getRankingForDups: function getRankingForDups(stats) {
	    // only sorted stats having a rank property already
	    var sortedStats = stats;
	    var counter = 1;
	    for (var k = 0; k < sortedStats.length - 1; k++) {
	      if ((0, _selectn2.default)('stats.value', sortedStats[k]) == (0, _selectn2.default)('stats.value', sortedStats[k + 1])) {
	        sortedStats[k + 1].rank = sortedStats[k].rank;
	        counter++;
	      } else {
	        sortedStats[k + 1].rank = sortedStats[k].rank + counter;
	        counter = 1;
	      }
	    }
	    return sortedStats;
	  },
	
	  /**
	  * get markup for team rank along with respective <sup></sup> tags Eg : 1<sup>st<sup>
	  * @param {Number} rank rank for which markup is required
	  * @return {String} conditionally framed markup for rank
	  */
	  getOrdinalSuffix: function getOrdinalSuffix() {
	    var rank = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	    var ordinal = '';
	    if (isNaN(rank) || rank == 0) {
	      return '';
	    }
	    var j = rank % 10;
	    var k = rank % 100;
	    if (j === 1 && k !== 11) {
	      ordinal = 'st';
	    } else if (j === 2 && k !== 12) {
	      ordinal = 'nd';
	    } else if (j === 3 && k !== 13) {
	      ordinal = 'rd';
	    } else {
	      ordinal = 'th';
	    }
	    return ordinal;
	  },
	
	
	  /**
	  * get conditionally built subheading for chart module based on some flags
	  * @param {Object} homeTeam stats of team on which user has landed
	  * @param {Object} awayTeam stats of Team ranked first
	  * @param {Boolean} isTied flag that indicates if selected Team is tied with team ranked first
	  * @param {Boolean} isOnlyMax flag that indicates if selected team is the only team rankled first
	  * @param {String} text indicating for what type of stat the subheading need to be framed
	  * @return {String} conditionally framed subheading based on all inputs
	  */
	  getChartSubHeading: function getChartSubHeading(_ref) {
	    var _ref$homeTeam = _ref.homeTeam,
	        homeTeam = _ref$homeTeam === undefined ? {} : _ref$homeTeam,
	        _ref$awayTeam = _ref.awayTeam,
	        awayTeam = _ref$awayTeam === undefined ? {} : _ref$awayTeam,
	        isTied = _ref.isTied,
	        isOnlyMax = _ref.isOnlyMax,
	        _ref$type = _ref.type,
	        type = _ref$type === undefined ? '' : _ref$type,
	        _ref$edition = _ref.edition,
	        edition = _ref$edition === undefined ? {} : _ref$edition;
	
	    var subHeading = '';
	    var homeTeamName = homeTeam.shortDisplayName || homeTeam.displayName || '';
	    var awayTeamName = awayTeam.shortDisplayName || awayTeam.displayName || '';
	    var transObj = void 0;
	    if (isTied) {
	      transObj = {
	        key: 'rugby.rankings.tied',
	        homeTeam: homeTeamName,
	        awayTeam: awayTeamName,
	        rank: homeTeam.rank + '<sup>' + this.getOrdinalSuffix(homeTeam.rank) + '</sup>'
	      };
	      subHeading = (0, _translate2.default)(edition, transObj);
	    } else if (isOnlyMax) {
	      subHeading = '';
	    } else {
	      transObj = {
	        key: 'rugby.formattedRank',
	        rank: awayTeam.rank,
	        ordinal: this.getOrdinalSuffix(awayTeam.rank)
	      };
	      subHeading = (0, _translate2.default)(edition, transObj) + ' ' + awayTeamName + ' : ' + awayTeam.stats + ' ' + (0, _translate2.default)(edition, type);
	    }
	    return subHeading;
	  },
	
	
	  /**
	  * Build 'Full Statistics' link based on team Id
	  * @param {Number} teamId Id of team on whcih user has landed
	  * @return {String} full url of statsguru page built from teamId
	  */
	  getStatsguruLink: function getStatsguruLink(teamId) {
	    if (teamId) {
	      return 'http://en.espn.co.uk/statsguru/rugby/team/' + teamId + '.html?class=1;type=team';
	    } else {
	      return '#';
	    }
	  }
	};
	
	exports.default = helpers;

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.flex = undefined;
	
	var _values = __webpack_require__(431);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _assign = __webpack_require__(365);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _selectn = __webpack_require__(438);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	var _common = __webpack_require__(814);
	
	var _momentTimezone = __webpack_require__(450);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _dateformat = __webpack_require__(449);
	
	var _dateformat2 = _interopRequireDefault(_dateformat);
	
	var _common2 = __webpack_require__(430);
	
	var _classnames = __webpack_require__(851);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _translate = __webpack_require__(833);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: Refactor after third column scoreboard APIs are ready
	var flex = exports.flex = {
	  getColumnByName: function getColumnByName(columns, columnName) {
	    try {
	      for (var i = 0, len = columns.length; i < len; i++) {
	        var column = columns[i];
	        if (column.name === columnName) {
	          return column;
	        }
	      }
	      return {};
	    } catch (e) {
	      return {};
	    }
	  },
	  getModuleByType: function getModuleByType(items, moduleType) {
	    try {
	      for (var i = 0, len = items.length; i < len; i++) {
	        var item = items[i];
	        if (item.moduleType === moduleType) {
	          return item;
	        }
	      }
	      return {};
	    } catch (e) {
	      return {};
	    }
	  },
	  buildNewsItems: function buildNewsItems() {
	    var feed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
	    var domain = arguments[2];
	
	    var newsModule = [];
	    var ignoreTypes = ['VideoCollection'];
	    var ignoreDisplayTypes = ['Multi-card Collection', 'Headline Collection'];
	    var ignoreModuleType = ['collection'];
	    var availableRelatedTypes = ['StoryTrio', 'StoryDuo'];
	
	    try {
	      for (var i = 0, len = feed.length; i < len; i++) {
	        var feedItem = feed[i];
	        var webLinks = (0, _selectn2.default)('links.web', feedItem) || {};
	
	        // ignore videoCollection type in the news feed
	        if (ignoreTypes.indexOf(feedItem.type) === -1 && ignoreDisplayTypes.indexOf(feedItem.feedDisplayType) === -1 && ignoreModuleType.indexOf(feedItem.moduleType) === -1) {
	
	          // if feed type is StoryTrio or StoryDuo, then consider the related items as news headlines
	          if (availableRelatedTypes.indexOf(feedItem.type) > -1) {
	            var related = feedItem.related;
	            if (related.length > 0) {
	              for (var j = 0; j < related.length; j++) {
	                var relatedItem = related[j];
	                var relatedWebLinks = (0, _selectn2.default)('links.web', relatedItem) || {};
	                newsModule.push({
	                  headline: relatedItem.headline,
	                  type: relatedItem.type,
	                  description: relatedItem.description,
	                  href: _common.common.buildURL(relatedWebLinks.href || (0, _selectn2.default)('headline.href', relatedWebLinks), domain) || '#',
	                  image: (0, _selectn2.default)('images[0]', relatedItem) || {}
	                });
	              }
	            }
	          } else {
	            newsModule.push({
	              headline: feedItem.headline,
	              type: feedItem.type,
	              description: feedItem.description,
	              href: _common.common.buildURL(webLinks.href || (0, _selectn2.default)('headline.href', webLinks), domain) || '#',
	              image: (0, _selectn2.default)('images[0]', feedItem) || {}
	            });
	          }
	        }
	      }
	
	      newsModule = newsModule.slice(0, limit);
	
	      return newsModule;
	    } catch (e) {
	      console.log(e);
	    }
	    return newsModule;
	  },
	  buildEditorialItems: function buildEditorialItems() {
	    var feed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var edition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var editorialContent = [];
	    var domain = edition && edition.domain || '';
	    var userGeo = edition && edition.userGeo || '';
	    var site = edition && edition.site || '';
	    var isNonSonyRightContent = true;
	
	    try {
	      for (var i = 0, len = feed.length; i < len; i++) {
	        var feedItem = feed[i];
	        var webLinks = (0, _selectn2.default)('links.web', feedItem) || {},
	            images = (0, _selectn2.default)('images[0]', feedItem),
	            image = images && {
	          url: images.url || '#',
	          name: images.name || '',
	          caption: images.caption || ''
	        },
	            videos = (0, _selectn2.default)('video[0]', feedItem),
	            vidLinks = videos && videos.links.web || '#',
	            video = videos && {
	          id: videos.id,
	          cerebroId: videos.cerebroId || '',
	          headline: videos.headline,
	          caption: videos.caption || '',
	          href: _common.common.buildURL(webLinks.href || vidLinks.href, domain) || '#',
	          trackingName: videos.tracking.trackingName,
	          thumbnail: videos.thumbnail || '',
	          title: videos.title || '',
	          duration: videos.duration || '',
	          deviceRestrictions: videos.deviceRestrictions || {},
	          geoRestrictions: videos.geoRestrictions || {}
	        };
	        var isVideoGeoRestricted = videos && (0, _common2.isGeoRestricted)(videos.geoRestrictions, userGeo.toUpperCase()) || false;
	        if (videos) {
	          var copyRightsOptions = {
	            site: site,
	            domain: domain,
	            userGeo: userGeo,
	            isWebView: false
	          };
	          isNonSonyRightContent = (0, _common2.showCopyrightVideo)(videos.ad, copyRightsOptions);
	        } else {
	          isNonSonyRightContent = true;
	        }
	
	        var href = _common.common.buildURL(webLinks.href || (0, _selectn2.default)('headline.href', webLinks), domain) || '#';
	        var isLinkExternal = _common.common.isLinkExternal(href, domain);
	
	        if (isNonSonyRightContent && !isVideoGeoRestricted && feedItem.headline && (images || videos)) {
	          editorialContent.push({
	            headline: feedItem.headline,
	            type: feedItem.type,
	            description: feedItem.description,
	            href: href,
	            isLinkExternal: isLinkExternal,
	            target: isLinkExternal ? '_blank' : '',
	            externalLinkClass: isLinkExternal ? 'external' : '',
	            image: image,
	            video: video
	          });
	        }
	      }
	    } catch (e) {
	      console.log(e);
	    }
	    return editorialContent;
	  },
	  /**
	   * [getSchedulesItems gets all fixtures, results as an object]
	   * @param  {[type]} data [raw api data]
	   * @param  {[type]} sport [sport type]
	   * @param  {[type]} edition [edition type]
	   * @param  {[type]} pageType [page type]
	   * @param  {[type]} limit [number of rows]
	   * @param  {[type]} team [clubhouse team info]
	   * @return {[type]}      [array]
	   */
	  getSchedulesItems: function getSchedulesItems(data, sport, edition, pageType, limit, team) {
	
	    var fixtures = [],
	        results = [],
	        live = [];
	    var schedule = { fixtures: fixtures, results: results, live: live };
	
	    var tzOptions = {
	      // Set time zone to IST
	      // TODO: use time zones based on editions
	      timeZone: edition.timeZoneBucket,
	      timeFormat: 'hh:mm a'
	    };
	    tzOptions.timeZoneAbbr = (0, _momentTimezone2.default)().tz(tzOptions.timeZone).format('z') || '';
	    var transObj = {
	      key: 'All times in',
	      timezone: tzOptions.timeZoneAbbr || ''
	    };
	    var heading = {
	      text: (0, _translate2.default)(edition, 'Matches'),
	      timeZone: tzOptions.timeZoneAbbr ? (0, _translate2.default)(edition, transObj) : ''
	    };
	    var notes = team.recordSummary ? team.recordSummary : '';
	    if (typeof team.standingSummary !== 'undefined') {
	      notes += team.standingSummary ? ', ' + team.standingSummary : '';
	    }
	
	    var dataLen = typeof data.length !== 'undefined' ? data.length : 0;
	    for (var i = 0; i < dataLen; i++) {
	
	      var game = data[i] || {};
	      //console.info('======>game',game)
	      //add local date and time
	
	
	      var trackingName = _common.common.createTrackingName([sport, 'TeamClubhouse', 'Schedule', game.status]);
	      var gameObj = {
	        date: game.date,
	        status: game.status || '',
	        id: game.id || '',
	        shortDetail: game.shortDetail || '',
	        leagueName: game.leagueName || '',
	        leagueAbbreviation: game.leagueAbbreviation || '',
	        score: game.score || '',
	        homeAway: game.homeAway || '',
	        href: _common.common.buildURL(game.link) || '',
	        trackingName: trackingName,
	        isHTScoreAvailable: false
	      };
	      gameObj = flex.updateGameDateFormat(gameObj, tzOptions);
	
	      //add default logo
	      var opponentLogo = game.opponentLogo ? game.opponentLogo : _common.common.defaultUrls['teamLogo'];
	      game.opponentLogo = _common.common.resizeCombinerLogo(opponentLogo, { w: 25, h: 25 });
	
	      var teamLogo = team.logo ? team.logo : _common.common.defaultUrls['teamLogo'];
	      team.logo = _common.common.resizeCombinerLogo(teamLogo, { w: 25, h: 25 });
	
	      var teamA = {
	        score: game.homeTeamScore || '',
	        htscore: game.homeTeamHTScore || '',
	        teamId: game.homeTeamId || '',
	        className: 'team-a'
	      };
	      var teamB = {
	        score: game.awayTeamScore || '',
	        htscore: game.awayTeamHTScore || '',
	        teamId: game.awayTeamId || '',
	        className: 'team-b'
	      };
	      if (team.id === game.homeTeamId) {
	        (0, _assign2.default)(teamA, {
	          logo: teamLogo,
	          name: team.name || '',
	          abbreviation: team.abbreviation || '',
	          record: team.recordSummary ? 'Form: ' + team.recordSummary : ''
	        });
	        (0, _assign2.default)(teamB, {
	          logo: game.opponentLogo,
	          name: game.opponentName,
	          abbreviation: game.opponentAbbreviation,
	          record: game.record ? 'Form: ' + game.record : ''
	        });
	      } else {
	        (0, _assign2.default)(teamB, {
	          logo: teamLogo,
	          name: team.name || '',
	          abbreviation: team.abbreviation || '',
	          record: team.recordSummary ? 'Form: ' + team.recordSummary : ''
	        });
	        (0, _assign2.default)(teamA, {
	          logo: game.opponentLogo,
	          name: game.opponentName || '',
	          abbreviation: game.opponentAbbreviation,
	          record: game.record ? 'Form: ' + game.record : ''
	        });
	      }
	
	      teamA.isWinner = teamA.teamId === game.winnerTeamId ? true : false;
	      teamB.isWinner = teamA.isWinner === true ? false : true;
	
	      gameObj.teamA = teamA;
	      gameObj.teamB = teamB;
	
	      //calculate HT scores like HT 12-15
	      if (gameObj.teamA.hasOwnProperty('htscore') && gameObj.teamB.hasOwnProperty('htscore')) {
	        gameObj.isHTScoreAvailable = true;
	        if (gameObj.status === 'in' || gameObj.status === 'post') {
	          if (gameObj.teamA.htscore && gameObj.teamB.htscore) {
	            gameObj.htGameDetail = 'HT ' + gameObj.teamA.htscore + ' - ' + gameObj.teamB.htscore || '';
	          }
	        }
	      }
	      //hide HT score for 1st half CIREARCH-1281, 1271
	      if (gameObj.status === 'in') {
	        gameObj.htGameDetail = '';
	      }
	
	      if (gameObj.teamA.teamId === game.winnerTeamId) {
	        gameObj.teamWinnerClassName = gameObj.teamA.className + '-winner';
	      } else {
	        gameObj.teamWinnerClassName = gameObj.teamB.className + '-winner';
	      }
	
	      var gameTimeMap = {
	        'pre': gameObj.displayTimeFormatted ? gameObj.displayTimeFormatted : '',
	        'in': 'LIVE',
	        'post': gameObj.shortDetail ? gameObj.shortDetail : ''
	      };
	      gameObj.gameTime = gameTimeMap[gameObj.status] || '';
	
	      var getGameStateClass = _common.common.getGameStateClass(gameObj.status);
	
	      var gameDetailsClassname = (0, _classnames2.default)('game-details', 'footer', sport, getGameStateClass);
	      var gameStripClassname = (0, _classnames2.default)('game-strip', sport, getGameStateClass, game.broadcast);
	      if (gameObj.status === 'post') {
	        gameStripClassname = (0, _classnames2.default)(gameStripClassname, gameObj.teamWinnerClassName);
	      }
	
	      gameObj.scrollToLiveClass = gameObj.status === 'in' ? 'liveGame' : '';
	
	      gameObj.gameStripClassname = gameStripClassname;
	      gameObj.gameDetailsClassname = gameDetailsClassname;
	
	      if (gameObj.status === 'post' && results.length < limit) {
	        results.push(gameObj);
	      }
	      if (gameObj.status === 'pre' && fixtures.length < limit) {
	        fixtures.push(gameObj);
	      }
	      if (gameObj.status === 'in' && live.length < limit) {
	        live.push(gameObj);
	      }
	    }
	    //reverse only fixtures to display in chronological order
	    fixtures = fixtures.reverse();
	    schedule = { fixtures: fixtures, results: results, live: live, heading: heading, notes: notes };
	
	    return schedule;
	  },
	  updateGameDateFormat: function updateGameDateFormat(gameObj, tzOptions) {
	    var displayTimeFormatted = gameObj.date ? _dateformat2.default.convertDateTime(gameObj.date, tzOptions) : '';
	    gameObj.displayTimeFormatted = displayTimeFormatted ? displayTimeFormatted.toUpperCase() : '';
	    gameObj.dateFormatted = gameObj.date ? _dateformat2.default.dateFormat(gameObj.date, 'date8', tzOptions.timeZone) : '';
	    return gameObj;
	  },
	  /**
	   * [updateGameDates update game date format]
	   * @param  {array} arr       [array of games]
	   * @param  {object} tzOptions [timezone options]
	   * @return {object}           [returns games]
	   */
	  updateGameDates: function updateGameDates(arr, tzOptions) {
	    var arrLen = typeof arr.length !== 'undefined' ? arr.length : 0;
	    for (var i = 0; i < arrLen; i++) {
	      var gameObj = flex.updateGameDateFormat(arr[i], tzOptions);
	      var gameTimeMap = {
	        'pre': gameObj.displayTimeFormatted ? gameObj.displayTimeFormatted : '',
	        'in': 'LIVE',
	        'post': gameObj.shortDetail ? gameObj.shortDetail : ''
	      };
	      gameObj.gameTime = gameTimeMap[gameObj.status] || '';
	      arr[i] = gameObj;
	    }
	    return arr;
	  },
	  /**
	   * [updateLeftColumnTimezones update timezones for all the games in left column]
	   * @param  {object} leftcolumn [left column from flex api]
	   * @param  {object} tzOptions  [timezone options]
	   * @param {Object} edition edition information
	   * @return {object}            [return left column]
	   */
	  updateLeftColumnTimezones: function updateLeftColumnTimezones(leftcolumn, tzOptions, edition) {
	    var newTzOptions = {
	      timeZone: tzOptions.zone,
	      timeZoneAbbr: tzOptions.zoneAbbr,
	      timeFormat: 'hh:mm a'
	    };
	    var schedule = (0, _selectn2.default)('schedule', leftcolumn);
	    if (schedule) {
	      var transObj = {
	        key: 'All times in',
	        timezone: newTzOptions.timeZoneAbbr || ''
	      };
	
	      var headingTimeZone = newTzOptions.timeZoneAbbr ? (0, _translate2.default)(edition, transObj) : '';
	      var heading = (0, _selectn2.default)('heading', schedule);
	
	      if (heading) {
	        var isheadingTimeZonePresent = (0, _selectn2.default)('heading.timeZone', schedule) ? true : false;
	        leftcolumn.schedule.heading.timeZone = isheadingTimeZonePresent ? headingTimeZone : '';
	      }
	
	      var fixturesItems = (0, _selectn2.default)('fixtures.items', schedule) || [];
	      var resultsItems = (0, _selectn2.default)('results.items', schedule) || [];
	      var mobileItems = (0, _selectn2.default)('mobile', schedule) || [];
	
	      leftcolumn.schedule.fixtures.items = flex.updateGameDates(fixturesItems, newTzOptions) || [];
	      leftcolumn.schedule.results.items = flex.updateGameDates(resultsItems, newTzOptions) || [];
	      leftcolumn.schedule.mobile = flex.updateGameDates(mobileItems, newTzOptions) || [];
	    }
	    return leftcolumn;
	  },
	  /**
	   * [getClubhouseTeam get clubhouse team details]
	   * @param  {Object} data   [team details from api]
	   * @param  {Object} params [template params]
	   * @return {object}        [team details]
	   */
	  getClubhouseTeam: function getClubhouseTeam() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var logo = data.logo ? data.logo : _common.common.defaultUrls.teamLogo;
	    data.recordSummary = data.recordSummary ? data.recordSummary : '';
	    data.seasonSummary = data.seasonSummary ? data.seasonSummary : '';
	    data.logo = _common.common.resizeCombinerLogo(logo, { w: 0, h: 0 });
	    data.logoLarge = _common.common.resizeCombinerLogo(logo, { w: 100, h: 100 });
	    data.href = _common.common.createHref({ sport: params.sport, slug: params.slug, team: params.team, pageType: params.pageType }) || '';
	    return data;
	  },
	  /**
	   * [getSchedulesMobile Get schedules data for mobile carousel]
	   * @param  {Object} data  [schedule data]
	   * @param  {Number} limit [number of games to be displayed, default=5]
	   * @return {[array]}      [array of objects]
	   */
	  getSchedulesMobile: function getSchedulesMobile() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
	    var _data$fixtures = data.fixtures,
	        fixtures = _data$fixtures === undefined ? [] : _data$fixtures,
	        _data$results = data.results,
	        results = _data$results === undefined ? [] : _data$results,
	        _data$live = data.live,
	        live = _data$live === undefined ? [] : _data$live;
	
	    var isLiveGamesPresent = live.length > 0 ? true : false;
	    var matchesArr = [];
	
	    //add two results to matches array by default
	    for (var c = 0; c < 2; c++) {
	      if (results[c]) {
	        matchesArr.push(results[c]);
	      }
	    }
	    //add live game in the middle
	    if (isLiveGamesPresent) {
	      matchesArr.push(live[0]);
	    }
	    //add rest of fixtures
	    for (var e = 0; e < fixtures.length; e++) {
	      if (fixtures[e]) {
	        matchesArr.push(fixtures[e]);
	      }
	      if (matchesArr.length === limit) break;
	    }
	    return matchesArr;
	  },
	  /**
	   * [getSchedules get Fixtures from the left column in the flex api]
	   * @param  {[object]} leftcolumn [default left column data from flex api]
	   * @param  {[object]} edition    [edition details]
	   * @param  {[object]} params     [template params]
	   * @param  {[object]} team       [clubhouse team details]
	   * @return {[object]}            [schedules formatted with pre,post,live with tab details]
	   */
	  getSchedules: function getSchedules(leftcolumn, edition, params, team) {
	    var sport = params.sport,
	        pageType = params.pageType;
	
	    var data = flex.getModuleByType(leftcolumn.items, 'schedule') || {};
	    var schedule = { fixtures: {}, results: {}, live: {}, heading: {}, notes: '', mobile: [] };
	
	    if (typeof data.feed !== 'undefined') {
	
	      var scheduleItems = flex.getSchedulesItems(data.feed, sport, edition, pageType, 20, team) || {};
	      var scheduleItemsMobile = flex.getSchedulesMobile(scheduleItems, 5) || [];
	
	      //adding live games to top of fixtures tab
	      var liveArr = scheduleItems.live || [];
	      var fixturesArr = liveArr.concat(scheduleItems.fixtures) || [];
	
	      schedule = {
	        fixtures: {
	          name: 'fixtures',
	          text: (0, _translate2.default)(edition, 'Fixtures'),
	          items: fixturesArr,
	          link: _common.common.createHref({ sport: params.sport, team: params.team, pageType: 'fixtures' }) || ''
	        },
	        results: {
	          name: 'results',
	          text: (0, _translate2.default)(edition, 'Results'),
	          items: scheduleItems.results || [],
	          link: _common.common.createHref({ sport: params.sport, team: params.team, pageType: 'results' }) || ''
	        },
	        moduleTitle: data.moduleTitle || '',
	        moduleType: data.moduleType || '',
	        heading: scheduleItems.heading || {},
	        mobile: scheduleItemsMobile,
	        fixturesLinkText: (0, _translate2.default)(edition, 'All Fixtures'),
	        resultsLinkText: (0, _translate2.default)(edition, 'All Results'),
	        notes: scheduleItems.notes || ''
	      };
	    }
	
	    return schedule;
	  },
	  getStandings: function getStandings(rightcolumn) {
	    var data = this.getModuleByType(rightcolumn.items, 'standings') || {};
	    var standings = {};
	    var feed = data && data.feed && data.feed[0] || [];
	    standings.moduleType = data.moduleType;
	    standings.moduleTitle = data.moduleTitle;
	    standings.sport = data.sport;
	    standings.league = data.league;
	    standings.feed = feed;
	    return standings;
	  },
	  getLeaders: function getLeaders(rightcolumn) {
	    var data = this.getModuleByType(rightcolumn.items, 'teamleaders');
	    var leaders = {};
	    leaders.moduleType = data.moduleType || '';
	    leaders.moduleTitle = data.moduleTitle || '';
	    leaders.season = data.seasonSummary || '';
	    leaders.feed = data.feed || [];
	    leaders.league = data.league || {};
	    return leaders;
	  },
	  /**
	   * [getTypesByPageSport, This needs ot be updated as we add more page or to include addiotional type of content]
	   * @param  {string} pageType  [page type - 'clubhouse or team', 'series', 'frontpage']
	   * @param  {string} sport   [sport]
	   * @return {typeForPageSport} [returns  types of items to keep in the actual feed for a page]
	   */
	  getTypesByPageSport: function getTypesByPageSport(pageType, sport) {
	    var typeForPageSport = [];
	    var acceptedType = {
	      'team': [//page type
	      {
	        'rugby': ['Story', 'Recap', 'Preview', 'HeadlineNews', 'Media', 'External'], // sport : [types that are accespted]
	        'cricket': ['Blog', 'Story', 'Recap', 'Preview', 'HeadlineNews', 'Media', 'External'],
	        'soccer': ['Blog', 'Story', 'Recap', 'Preview', 'HeadlineNews', 'Media', 'External']
	      }],
	      'default': ['Story', 'Blog', 'Recap', 'Previews', 'HeadlineNews', 'Media']
	    };
	
	    typeForPageSport = acceptedType['default'];
	
	    if (acceptedType.hasOwnProperty(pageType)) {
	      var getPageType = acceptedType[pageType];
	      if (getPageType[0].hasOwnProperty(sport)) {
	        typeForPageSport = getPageType[0][sport];
	      }
	    }
	
	    return typeForPageSport;
	  },
	  getNewsItems: function getNewsItems(feed, limit, sport, domain, pageType) {
	    var newsItems = [];
	    var typesAccepted = this.getTypesByPageSport(pageType, sport);
	    (0, _values2.default)(feed).forEach(function (v, i) {
	      var item = feed[i] || {};
	      if (typesAccepted.indexOf(item.type) > -1) {
	        //get the type of content required for the page sport
	        var webLinks = (0, _selectn2.default)('links.web', item) || {};
	        var href = _common.common.buildURL(webLinks.href || (0, _selectn2.default)('headline.href', webLinks), domain) || '#';
	
	        //makikng urls to be relative
	        if (sport === 'rugby' && item.type === 'Recap') {
	          href = _common.common.buildURL(webLinks.href || (0, _selectn2.default)('headline.href', webLinks)) || '#'; //for recap keep as is from API,
	        } else {
	          href = _common.common.buildURL(href || (0, _selectn2.default)('headline.href', webLinks)) || '#'; //for others have formated urls
	        }
	
	        var isLinkExternal = _common.common.isLinkExternal(href, domain);
	        var imgCombinerUrl = _common.common.getCombinerImage((0, _selectn2.default)('images[0][url]', item)) || '#';
	        var imgAvailable = imgCombinerUrl === '#' ? false : true;
	        newsItems.push({
	          id: item.id,
	          type: item.type,
	          headline: item.headline,
	          linktext: item.linkText,
	          description: item.description,
	          href: href,
	          isLinkExternal: isLinkExternal,
	          target: isLinkExternal ? '_blank' : '',
	          aLinkClass: isLinkExternal ? 'external realStory' : 'realStory',
	          image: (0, _selectn2.default)('images[0]', item) || {},
	          imgCombinerUrl: imgCombinerUrl,
	          imgAvailable: imgAvailable,
	          video: (0, _selectn2.default)('video[0]', item) || {},
	          published: (0, _common2.relativeDate)(new Date(item.published)),
	          byline: item.byline,
	          related: item.related,
	          imgUrl: (0, _selectn2.default)('images[0][url]', item) || '#'
	        });
	      }
	    });
	
	    newsItems = newsItems.slice(0, limit);
	    return newsItems;
	  },
	  getNewsFeed: function getNewsFeed(middlecolumn, sport, domain, pageType, currentArticleCount, loadNowAPI) {
	    var data = loadNowAPI ? middlecolumn : this.getModuleByType(middlecolumn.items);
	    var feed = data && data.feed || [];
	    var newsfeed = {};
	    var resultsCount = data.resultsCount;
	    var resultsOffset = data.resultsOffset;
	
	    newsfeed = this.getNewsItems(feed, 25, sport, domain, pageType, currentArticleCount); //actual feed
	    newsfeed.resultsCount = resultsCount; //total results
	    newsfeed.resultsOffset = resultsOffset; //offset count
	    newsfeed.countBF = feed.length;
	
	    return newsfeed;
	  }
	};
	
	exports.default = {
	  buildEditorialItems: flex.buildEditorialItems,
	  buildNewsItems: flex.buildNewsItems,
	  getModuleByType: flex.getModuleByType,
	  getColumnByName: flex.getColumnByName,
	  getSchedules: flex.getSchedules,
	  getClubhouseTeam: flex.getClubhouseTeam,
	  getSchedulesItems: flex.getSchedulesItems,
	  getSchedulesMobile: flex.getSchedulesMobile,
	  getStandings: flex.getStandings,
	  getLeaders: flex.getLeaders,
	  getTypesByPageSport: flex.getTypesByPageSport,
	  getNewsItems: flex.getNewsItems,
	  getNewsFeed: flex.getNewsFeed,
	  updateLeftColumnTimezones: flex.updateLeftColumnTimezones,
	  updateGameDateFormat: flex.updateGameDateFormat
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _values = __webpack_require__(431);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _assign = __webpack_require__(365);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(419);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(312);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _selectn = __webpack_require__(438);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	var _common = __webpack_require__(814);
	
	var _queryString = __webpack_require__(207);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _config = __webpack_require__(853);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _common2 = __webpack_require__(430);
	
	var _translate = __webpack_require__(833);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UNDEFINED = (0, _typeof3.default)(void 0);
	var TEAM_COL_KEY = '__team__';
	
	/* Helpers need to be moved to utils but for now until merged it will be kept here */
	var helpers = {
	
	  /**
	  * Take in dates as strings and extract years to return year string
	  *
	  * @param  {Object}    edition     Edition config
	  * @param  {Object}    params      Router params
	  * @param  {Object}    location    Router location
	  * @return {boolean}               Merged super object for ease of transportation
	  **/
	  requestObj: function requestObj() {
	    var edition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var location = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	
	    return {
	      edition: edition,
	      params: params,
	      location: location
	    };
	  },
	
	  /**
	  * Compares dates string to regex as a rudimentry check for a date value
	  *
	  * @param  {string}  date  Date ("2015-10-01T07:00Z")
	  * @return   {boolean}           true/false
	  **/
	  isDateString: function isDateString(date) {
	    return (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}Z$/.test(date)
	    );
	  },
	
	  /**
	  * Take in dates as strings and extract years to return year string
	  *
	  * @param  {string}  date  Start date ("2015-10-01T07:00Z")
	  * @param  {integer} size  2 or 4
	  * @return {string}        Year as YYYY or YY
	  **/
	  getYearFromDateString: function getYearFromDateString() {
	    var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;
	
	    if (helpers.isDateString(date) && (size !== 2 || size !== 4)) {
	      return date.substring(4 - size, 4);
	    }
	    return '';
	  },
	
	  /**
	  * Splits string on ' ' and joins with '+' to create a single key for tracking
	  *
	  * @param    {String}  description     Description of element or link
	  * @return   {String}                  Join string
	  **/
	  descriptionToKey: function descriptionToKey(description) {
	    var res = description.replace(' ', '+');
	    return res;
	  }
	};
	
	var standings = {
	
	  /**
	  * Process data from APIs
	  *
	  * @param  {Object}  standingRes     API response from standings API
	  * @param  {Object}  leagueRes       API response from league API
	  * @param  {Object}  edition         edition config
	  * @param  {Object}  params          router params
	  * @param  {Object}  location        router location
	  * @param  {Object}  appProps        app Props
	  * @return {Object}                  standings, seasons, current-season & league-title
	  *
	  **/
	  processData: function processData() {
	    var standingRes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var leagueRes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var edition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	    var location = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	    var appProps = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
	
	
	    var standingsData = (0, _selectn2.default)('data', standingRes);
	    var leaguesData = (0, _selectn2.default)('data.leagues', leagueRes) || [];
	    var request = helpers.requestObj(edition, params, location); /* until such time as we have 1 var i will fake it */
	    var hrefConfig = { showSport: edition.isMultiSports };
	    var query = location.query || _queryString2.default.parse(location.search);
	    var currentLeague = standings.getLeagueName(standingsData);
	    var leagueSlug = currentLeague.replace(/'/g, '').replace(/[^A-Z0-9]+/ig, '-').toLowerCase() || '';
	
	    var siteType = appProps.siteType;
	    // Default return types
	    var processedData = {
	      seasons: [],
	      leagues: [],
	      currentSeason: '',
	      currentLeague: '',
	      leagueTitle: '',
	      glossaries: [],
	      rules: '',
	      meta: {},
	      analytics: {},
	      standingsTable: {},
	      notes: [],
	      typeOptions: {},
	      noTableText: (0, _translate2.default)(edition, 'Table_not_yet_available') || '',
	      adblock: (0, _selectn2.default)('_adblock', query) === 'true' ? true : false
	
	      // If response or params are empty, return default data
	    };if ((typeof standingsData === 'undefined' ? 'undefined' : (0, _typeof3.default)(standingsData)) === UNDEFINED || params !== null && (typeof params === 'undefined' ? 'undefined' : (0, _typeof3.default)(params)) !== UNDEFINED && (0, _keys2.default)(params).length === 0) {
	      return processedData;
	    }
	
	    try {
	
	      // get the config
	      var config = _config2.default.get({
	        sport: params.sport,
	        root: params.sport,
	        page: params.pageType,
	        params: params
	      });
	
	      var formattedData = standings.formatData(request, config, standingsData, edition, hrefConfig) || {};
	
	      // Get list of valid seasons - those who have standings
	      processedData.seasons = standings.filterSeasons(request, standingsData, hrefConfig, edition);
	      processedData.leagues = standings.filterLeagues(request, leaguesData, hrefConfig, edition);
	
	      // Get current season
	      processedData.currentSeason = formattedData.seasonText || params.season || '-';
	      processedData.currentLeague = currentLeague;
	      processedData.currentLeagueId = standings.getLeagueId(processedData.currentLeague, leaguesData);
	
	      // get the league name
	      processedData.leagueTitle = standings.getLeagueTitle(processedData.currentLeague, processedData.currentSeason, params, edition);
	      processedData.leagueTableLink = standings.getLeagueLink(params, processedData.leagues, processedData.currentLeague, params);
	      processedData.rules = standings.getRules(standingsData);
	      processedData.meta = standings.getMetaData(edition, processedData.leagueTitle, processedData.leagueTableLink, params, location);
	      processedData.analytics = standings.getAnalytics(processedData.meta, processedData.currentLeague, edition.isEspnCricinfo);
	      processedData.standingsTable = {
	        data: formattedData.data || [],
	        header: formattedData.header || {},
	        columns: formattedData.columns || [],
	        merged: config.mergeTable || false
	      };
	      processedData.glossaries = formattedData.glossary;
	      processedData.notes = (0, _selectn2.default)('data.notes', formattedData) || [];
	      processedData.typeOptions = formattedData.typeOptions || {};
	      processedData.showBtmAdModule = (0, _common2.showBottomAdModule)(params.pageType);
	      processedData.siteType = siteType;
	      processedData.trackingImg = (0, _common2.getTrackingImg)(edition, params.pageType, processedData.currentLeague, leagueSlug, processedData.currentLeagueId, location.pathname, siteType, '', query, '');
	    } catch (e) {
	      console.log(e);
	    }
	    //console.log(processedData.seasons)
	    return processedData;
	  },
	
	  /**
	  * Builds meta data object recognised by 'updateMeta' function
	  *
	  * @param  {Object}  edition           Edition doc
	  * @param  {String}  leagueTitle       Current league name
	  * @param  {String}  leagueTableLink   league table link url
	  * @param  {Object}  params       route params
	  * @return   {Object}                Object
	  **/
	  getMetaData: function getMetaData() {
	    var edition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var leagueTitle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var leagueTableLink = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	    var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	    var sport = params.sport || '';
	    var title = '';
	    var description = '';
	    var keywords = '';
	    if (sport === 'rugby') {
	      var transKeyObjs = {
	        title: {
	          key: 'meta.title.rugby.standings',
	          league: leagueTitle
	        },
	        keywords: {
	          key: 'meta.keywords.rugby.standings',
	          league: leagueTitle
	        },
	        description: {
	          key: 'meta.description.rugby.standings',
	          league: leagueTitle
	        }
	      };
	      title = (0, _translate2.default)(edition, transKeyObjs.title) || '';
	      description = (0, _translate2.default)(edition, transKeyObjs.description) || '';
	      keywords = (0, _translate2.default)(edition, transKeyObjs.keywords) || '';
	    }
	    return {
	      title: title || leagueTitle + ' - ESPN',
	      description: description || 'Take a look at the latest ' + leagueTitle + '.',
	      keywords: keywords || leagueTitle + ', ' + sport,
	      website: 'article',
	      canonical: leagueTableLink,
	      sport: sport && sport.toLowerCase()
	    };
	  },
	
	  /**
	  * Builds analytics data object recognised by 'analytics' function
	  *
	  * @param    {Object}  meta        Meta object returned from 'getMetaData'
	  * @param {String} league league league
	  * @param {Boolean} isEspnCricinfo check if it is cricinfo
	  * @return   {Object}                Object
	  **/
	  getAnalytics: function getAnalytics(meta, league, isEspnCricinfo) {
	    var omniture = {};
	    var metaLeague = league ? league.replace(/'/g, '').replace(/[^A-Z0-9]+/ig, '-').toLowerCase() : '';
	    //override analytics only for cricinfo
	    if (isEspnCricinfo && metaLeague !== '') {
	      omniture = {
	        pageName: metaLeague + ':standings',
	        channel: '' + metaLeague,
	        eVar11: 'cricinfo:' + metaLeague + ':standings',
	        prop5: metaLeague + ':standings',
	        prop26: '' + metaLeague,
	        eVar21: '' + metaLeague
	      };
	    }
	    return {
	      chartbeat: {
	        title: meta.title
	      },
	      omniture: omniture
	    };
	  },
	
	  /**
	  * Function to itterate the standings API return value and calculate the headings
	  * data values and other sundary elements the components need to build the standings page
	  *
	  * @param    {Object}  request     Request Object made from 'editions', 'location' and 'params'
	  * @param    {Object}  config      Config values
	  * @param    {Object}  data        Standings API return value (unmolested)
	  * @param    {Object} edition      edition object
	  * @param    {Object} hrefConfig   config object for create href function
	  * @return   {Object}                Object
	  **/
	  formatData: function formatData() {
	    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var edition = arguments[3];
	    var hrefConfig = arguments[4];
	
	
	    var sport = (0, _selectn2.default)('params.sport', request) || '';
	    var standingsData = standings.getFirstStandings(data) || {};
	    var validTypes = standings.getColumnFilter(config, standingsData) || {};
	    var season = standings.getStandingsSeason(config, standingsData) || '';
	    var seasonType = standings.getStandingsSeasonType(config, standingsData) || 0;
	    var seasonData = standings.getCurrentSeasonData(season, data) || {};
	    var headerData = standings.getHeader(request, config, validTypes, edition, hrefConfig) || {};
	    var typeOptions = standings.getSeasonTypes(request, seasonData, seasonType, edition) || {};
	    var seasonText = standings.formatSeason((0, _selectn2.default)('startDate', seasonData) || '', (0, _selectn2.default)('endDate', seasonData) || '') || '';
	
	    if (sport === 'rugby') {
	      // don't use a year range for ruby seasons
	      seasonText = seasonData && seasonData.year || '';
	    }
	
	    return {
	      data: standings.getChildren(request, config, validTypes, data, edition) || {},
	      header: {
	        data: headerData.data,
	        sortDir: headerData.sortDir,
	        sortCol: headerData.sortCol
	      },
	      columns: headerData.columns || [],
	      glossary: headerData.glossary || [],
	      season: season,
	      seasonType: seasonType,
	      seasonText: seasonText,
	      typeOptions: typeOptions
	    };
	  },
	
	  /**
	  * Parent function to itterate the actual groups and standings. NOTE it uses recursion to itterate
	  * through the children values. It will look for any children and itterate though them, if no
	  * children it will look for standings to extract the entries from.
	  *
	  * @param    {Object}  request     Request Object made from 'editions', 'location' and 'params'
	  * @param    {Object}  config      Config values
	  * @param    {Object}  validTypes    Object returned from  'standings.getColumnFilter'
	  * @param    {Object}  data        Standings API return value (unmolested)
	  * @return   {Object}                Object of filtered data
	  **/
	  getChildren: function getChildren() {
	    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var validTypes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	    var edition = arguments[4];
	
	
	    var standingsData = {
	      groups: [],
	      entries: [],
	      name: standings.getLeagueName(data),
	      abbreviation: standings.abbreviationMod((0, _selectn2.default)('abbreviation', data) || ''),
	      notes: []
	    };
	
	    if (data.hasOwnProperty('children')) {
	      var childData = (0, _selectn2.default)('children', data) || [];
	      var childLen = childData.length || 0;
	      for (var i = 0; i < childLen; i++) {
	        var groupData = standings.getChildren(request, config, validTypes, childData[i], edition);
	        if (groupData.groups.length || groupData.entries.length) {
	          if (groupData.name.toLowerCase() === standingsData.name.toLowerCase()) {
	            groupData.name = groupData.abbreviation;
	          }
	          standingsData.groups.push(groupData);
	          standingsData.notes = groupData.notes;
	        }
	      }
	    } else if (data.hasOwnProperty('standings')) {
	      var entries = (0, _selectn2.default)('standings.entries', data) || [];
	      var entriesData = standings.getEntries(request, config, validTypes, entries, edition);
	      standingsData.entries = entriesData.entries;
	      standingsData.notes = entriesData.notes;
	    }
	
	    return standingsData;
	  },
	
	  /**
	  * Modifies any value matching regex to remove '/' and replace with '-'
	  *
	  * @param    {String}  abbrev      Looking for strings like '2015/16'
	  * @return   {String}                Object of filtered data
	  **/
	  abbreviationMod: function abbreviationMod() {
	    var abbrev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	    if (/^\d{4}\/\d{2}/.test(abbrev)) {
	      return abbrev.replace('/', '-');
	    }
	    return abbrev;
	  },
	
	  /**
	  * Itterates the entries of a standings node to pull out the required stats and
	  * team information for each row of the table.
	  *
	  * @param    {Object}  request     Request Object made from 'editions', 'location' and 'params'
	  * @param    {Object}  config      Config values
	  * @param    {Object}  validTypes    Object returned from 'standings.getColumnFilter'
	  * @param    {Object}  data        Standings node of standings API
	  * @return   {Object}                Object of filtered data
	  **/
	  getEntries: function getEntries() {
	    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var validTypes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	    var edition = arguments[4];
	
	
	    /* filter the entries */
	    var entryLen = data.length || 0;
	    var leagueId = (0, _selectn2.default)('params.league', request) || '';
	    var sport = (0, _selectn2.default)('params.sport', request) || '';
	    var isCollege = false;
	    var entryData = [];
	    var previousRank = null;
	    var prevQualified = null;
	    var notesData = [];
	    var lang = edition.language || 'en';
	
	    if (leagueId === 'ncf' || leagueId === 'ncb' || leagueId === 'ncw') {
	      isCollege = true;
	    }
	
	    for (var i = 0; i < entryLen; i++) {
	      var stats = (0, _selectn2.default)('stats', data[i]) || [];
	      var statLen = stats.length || 0;
	      var isActive = (0, _selectn2.default)('team.isActive', data[i]) || false;
	      var hasSprite = false;
	      var dataRoute = false;
	      var entryVals = {};
	
	      /* HACK for cricket */
	      //SEWEB-13325 hide team links for es/pt
	      if (sport === 'cricket') {
	        isActive = true;
	        dataRoute = true;
	      } else if (sport === 'rugby-league' || lang === 'es' || lang === 'pt') {
	        isActive = false; /* HACK to hide links until API corrected */
	      }
	
	      for (var x = 0; x < statLen; x++) {
	        var key = (0, _selectn2.default)('type', stats[x]) || '';
	        if (validTypes[key] || key === 'rank' || key === 'seed' || key === 'qualified') {
	          entryVals[key] = (0, _selectn2.default)('displayValue', stats[x]) || '';
	          if (validTypes[key] && validTypes[key].colorize === true) {
	            if (entryVals[key] > 0 && entryVals[key].charAt(0) !== '+') {
	              entryVals[key] = '+' + entryVals[key];
	            }
	          }
	        }
	      }
	
	      if (isActive && (leagueId === 'nba' || leagueId === 'mlb' || leagueId === 'nfl' || leagueId === 'nhl')) {
	        hasSprite = true;
	      }
	
	      var displayName = '';
	      if (!config.useDisplayName) {
	        displayName = (0, _selectn2.default)('team.location', data[i]) || '';
	      } else {
	        displayName = (0, _selectn2.default)('team.displayName', data[i]) || '';
	      }
	
	      var seedValue = '';
	      if (config.showPlayoffSeed) {
	        if ((0, _typeof3.default)(entryVals.seed) !== UNDEFINED && entryVals.seed) {
	          var seedNo = parseInt(entryVals.seed) || null;
	          if (seedNo !== null && seedNo <= config.playoffCutoff) {
	            seedValue = seedNo;
	          }
	        } else if ((0, _typeof3.default)(entryVals.rank) !== UNDEFINED && (previousRank === null || previousRank != entryVals.rank)) {
	          seedValue = entryVals.rank;
	          previousRank = entryVals.rank;
	        }
	      }
	      //highlight qualified teams only if the content is not sorted by any key
	      if (config.highlightQualified && typeof (0, _selectn2.default)('params.sortKey', request) === 'undefined') {
	        if (entryVals.qualified === 'Y') {
	          prevQualified = 'Y';
	        } else if (prevQualified === 'Y' && typeof entryVals.qualified === 'undefined') {
	          prevQualified = 'N';
	          entryVals.drawLine = true;
	        }
	      }
	      /* set the team up */
	      entryVals[TEAM_COL_KEY] = {
	        name: displayName,
	        abbreviation: (0, _selectn2.default)('team.abbreviation', data[i]) || '',
	        logo: {
	          href: _common.common.getTeamLogo((0, _selectn2.default)('team', data[i]) || {}, { w: 50, h: 50 }),
	          hasSprite: hasSprite,
	          teamId: (0, _selectn2.default)('team.id', data[i]) || 0,
	          leagueId: leagueId
	        },
	        isActive: isActive,
	        seedShow: config.showPlayoffSeed || false,
	        seedValue: seedValue || '',
	        seedSubShow: '',
	        clincher: '',
	        isCollege: isCollege
	      };
	
	      var teamUrl = _common.common.getTeamUrl((0, _selectn2.default)('team', data[i]));
	      if (teamUrl && isActive) {
	        entryVals[TEAM_COL_KEY].link = _common.common.buildLinkObject({
	          href: teamUrl,
	          query: request.query,
	          tracking: [leagueId, 'standings', 'team'],
	          routerLink: false,
	          dataRoute: dataRoute,
	          edition: request.edition
	        });
	      }
	
	      /* capture notes data */
	      var noteDesc = (0, _selectn2.default)('note.description', data[i]) || '';
	      var noteRank = (0, _selectn2.default)('note.rank', data[i]) || 0;
	      if (noteDesc) {
	        notesData[noteRank] = noteDesc;
	      }
	
	      entryData.push(entryVals);
	    }
	
	    return {
	      entries: entryData || [],
	      notes: standings.formatNotes(notesData, edition) || []
	    };
	  },
	
	  /**
	  * Takes an array of notes and condenses them down where the description is similar
	  *
	  * @param    {Array}   notesData     Array of notes from each entry in standings table
	  * @return   {Array}               Condensed Notes
	  **/
	  formatNotes: function formatNotes() {
	    var notesData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var edition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	    var notesLen = notesData.length || 0;
	    var prevNote = '';
	    var ranks = [];
	    var formattedNotes = [];
	
	    function formatNote() {
	      var ranks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var note = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	
	      var noteRank = 'Position ' + ranks[0];
	      if (ranks.length > 1) {
	        noteRank = 'Positions ' + ranks[0] + '-' + ranks[ranks.length - 1];
	      }
	      return noteRank + ': ' + note;
	    }
	
	    for (var i = 0; i < notesLen; i++) {
	      if (notesData[i]) {
	        if (prevNote && notesData[i] !== prevNote) {
	          formattedNotes.push(formatNote(ranks, prevNote));
	          ranks = [];
	        }
	        prevNote = notesData[i];
	        ranks.push(i);
	      }
	    }
	
	    if (prevNote) {
	      formattedNotes.push(formatNote(ranks, prevNote));
	    }
	
	    if (formattedNotes.length === 0) {
	      var translatedNotes = (0, _translate2.default)(edition, 'standings.glossary.notes') || '';
	      formattedNotes.push(translatedNotes);
	    }
	
	    return formattedNotes;
	  },
	
	  /**
	  * Searches the returned API data to look for the first valid standings data node
	  * this is to be used to find default values about the API result i.e. season
	  *
	  * @param    {Object}  data      Standings API return value (unmolested)
	  * @return   {Object}              First valid standings node
	  **/
	  getFirstStandings: function getFirstStandings(data) {
	
	    var firstStandings = {};
	
	    if (data.hasOwnProperty('standings')) {
	      var standingsData = (0, _selectn2.default)('standings', data) || {};
	      if (standings.hasStandingsData(standingsData)) {
	        firstStandings = standingsData;
	      }
	    } else if (data.hasOwnProperty('children')) {
	      var childData = (0, _selectn2.default)('children', data) || [];
	      var childLen = childData.length || 0;
	      for (var i = 0; i < childLen; i++) {
	        var _standingsData = standings.getFirstStandings(childData[i]);
	        if (standings.hasStandingsData(_standingsData)) {
	          firstStandings = _standingsData;
	          continue;
	        }
	      }
	    }
	
	    return firstStandings;
	  },
	
	  /**
	  * Simple function to determine if the standings node has valid data
	  *
	  * @param  {Object}  data      Standings node from API
	  * @return {Boolean}           returns true if has standings or false if not
	  **/
	  hasStandingsData: function hasStandingsData(data) {
	    var season = (0, _selectn2.default)('season', data) || '';
	    return season ? true : false;
	  },
	
	  /**
	  * Takes the first entry and checks to see if all the columns we want are there
	  * and produces a definative col list based around the config and whats available
	  *
	  * @param  {Object}  config          Config values
	  * @param  {Array}   standingsData   Standings node from API
	  * @return {Object}                  Map of valid columns with key as column name
	  **/
	  getColumnFilter: function getColumnFilter() {
	    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var standingsData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	    /* build map of all content cats we are allowed in config */
	    var categories = config.categories || [];
	    var catLen = categories.length;
	    var catMap = {};
	    var columnFilter = {};
	
	    for (var a = 0; a < catLen; a++) {
	      var key = (0, _selectn2.default)('key', categories[a]) || '';
	      if (key) {
	        catMap[key] = {
	          abbreviation: '',
	          sortable: (0, _selectn2.default)('sortable', categories[a]) || 0,
	          colgroup: (0, _selectn2.default)('colgroup', categories[a]) || 0,
	          description: '',
	          colorize: (0, _selectn2.default)('colorize', categories[a]) || false
	        };
	      }
	    }
	
	    /* build filtered list based on first set of data, this is to hide values if cols not in API */
	    var stats = (0, _selectn2.default)('entries[0].stats', standingsData) || [];
	    var statsLen = stats.length;
	    for (var i = 0; i < statsLen; i++) {
	      var _key = (0, _selectn2.default)('type', stats[i]) || '';
	      if (catMap[_key]) {
	        catMap[_key].abbreviation = (0, _selectn2.default)('abbreviation', stats[i]) || '';
	        catMap[_key].description = (0, _selectn2.default)('description', stats[i]) || '';
	        columnFilter[_key] = catMap[_key];
	      }
	    }
	
	    return columnFilter;
	  },
	
	  /**
	  * Uses the config and the values stored in the validTypes to build the header values
	  * and the links if required.
	  *
	  * @param    {Object}  request       Request Object made from 'editions', 'location' and 'params'
	  * @param    {Object}  config        Config values
	  * @param    {Object}  validTypes    Object returned from 'standings.getColumnFilter'
	  * @param    {Object}  edition       Edition object
	  * @param    {Object}  hrefConfig    Config object for create href function
	  * @return   {Object}                Object of data attributes used to build table header
	  **/
	  getHeader: function getHeader() {
	    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var validTypes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var edition = arguments[3];
	    var hrefConfig = arguments[4];
	
	
	    var categories = config.categories || [];
	    var catLen = categories.length;
	    var header = {};
	    var glossary = [];
	    var columns = [{ key: TEAM_COL_KEY, colorize: false }];
	
	    /* set the team up */
	    header[TEAM_COL_KEY] = {
	      colgroup: 1,
	      tooltip: '',
	      text: 'Team'
	
	      /* build an array of link objects in order. */
	    };for (var a = 0; a < catLen; a++) {
	      var key = (0, _selectn2.default)('key', categories[a]) || '';
	      if (validTypes[key]) {
	        var _validTypes$key = validTypes[key],
	            _validTypes$key$abbre = _validTypes$key.abbreviation,
	            abbreviation = _validTypes$key$abbre === undefined ? '' : _validTypes$key$abbre,
	            _validTypes$key$descr = _validTypes$key.description,
	            description = _validTypes$key$descr === undefined ? '' : _validTypes$key$descr;
	
	
	        header[key] = {
	          colgroup: validTypes[key].colgroup || 0,
	          tooltip: validTypes[key].description || ''
	        };
	
	        if (typeof abbreviation == 'string' && typeof description == 'string') {
	          if (abbreviation.toLowerCase() != description.toLowerCase()) {
	            glossary.push({
	              title: validTypes[key].abbreviation || '',
	              description: validTypes[key].description || ''
	            });
	          }
	        }
	
	        if (validTypes[key].sortable) {
	
	          var linkParams = (0, _assign2.default)({}, request.params);
	          delete linkParams['sortDir'];
	          linkParams.sortKey = key;
	
	          if (request.params.sortKey === key) {
	
	            linkParams.sortDir = (0, _selectn2.default)('parameters.dir', config) === 'asc' ? 'desc' : 'asc';
	
	            if (linkParams.sortDir === (0, _selectn2.default)('oDefaultSortDirections.' + key, config)) {
	              delete linkParams.sortDir;
	            }
	          }
	
	          header[key].link = _common.common.buildLinkObject({
	            edition: edition,
	            text: validTypes[key].abbreviation,
	            params: linkParams,
	            query: request.query,
	            tracking: [request.params.league, 'standings', 'sort', helpers.descriptionToKey(validTypes[key].description)],
	            hrefConfig: hrefConfig
	          });
	        } else {
	          header[key].text = validTypes[key].abbreviation || '';
	        }
	
	        columns.push({
	          key: key,
	          colorize: validTypes[key].colorize || false
	        });
	      }
	    }
	
	    return {
	      data: header,
	      sortDir: request.params.sortDir || '',
	      sortCol: request.params.sortKey || '',
	      glossary: glossary,
	      columns: columns
	    };
	  },
	
	  /**
	  * Get a list of link objects for all seasons with at least 1 type that
	  * has standings
	  *
	  * @param  {Object}    request    Request object
	  * @param  {Object}    data       Standings API return value (unmolested)
	  * @param  {Object}    hrefConfig config object for create href function
	  * @param  {Object}    edition    edition object
	  * @return {Array}                Array of link objects
	  **/
	  filterSeasons: function filterSeasons(request, data, hrefConfig, edition) {
	
	    var seasonsRaw = (0, _selectn2.default)('seasons', data) || [];
	    var seasonLen = seasonsRaw.length || 0;
	    var seasons = [];
	    var language = edition && edition.language || 'en';
	    var sport = request.params.sport;
	    var pageTypeStandings = 'table';
	    if (sport === 'rugby' && (language === 'es' || language === 'pt')) {
	      pageTypeStandings = 'standings';
	    }
	
	    for (var i = 0; i < seasonLen; i++) {
	      var season = seasonsRaw[i];
	      /* need to actually filter by season type as well for other sports */
	      var types = (0, _selectn2.default)('types', season) || [];
	      var typeLen = types.length;
	      var hasStanding = 0;
	
	      for (var x = 0; x < typeLen; x++) {
	        if ((0, _selectn2.default)('types[' + x + '].hasStandings', season) === true) {
	          hasStanding = (0, _selectn2.default)('types[' + x + '].id', season) || 0;
	          continue;
	        }
	      }
	
	      if (hasStanding) {
	
	        /* build out split years if required */
	
	        var year = (0, _selectn2.default)('year', season) || '';
	        var params = {
	          pageType: pageTypeStandings,
	          sport: sport,
	          league: request.params.league,
	          season: year,
	          slug: request.params.slug
	        };
	        var seasonText = standings.formatSeason((0, _selectn2.default)('startDate', season), (0, _selectn2.default)('endDate', season));
	        if (sport === 'rugby') {
	          seasonText = season && season.year;
	        }
	
	        if (hasStanding > 1) {
	          params.seasontype = hasStanding;
	        }
	
	        seasons.push(_common.common.buildLinkObject({
	          text: seasonText,
	          query: request.query,
	          params: params,
	          tracking: [request.params.league, 'standings', 'filter', 'year'],
	          hrefConfig: hrefConfig,
	          edition: edition
	        }));
	      }
	    }
	
	    return seasons;
	  },
	
	  /**
	  * Take in dates as strings and extract years to return
	  * formatted year YYYY-YY or YYYY
	  *
	  * @param  {string}  startDate   Start date ("2015-10-01T07:00Z")
	  * @param    {string}  endDate     End date ("2015-10-01T07:00Z")
	  * @return   {string}              Formatted string
	  **/
	  formatSeason: function formatSeason() {
	    var startDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var endDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	    var start = helpers.getYearFromDateString(startDate, 4);
	    var end = helpers.getYearFromDateString(endDate, 4);
	    var endSub = helpers.getYearFromDateString(endDate, 2);
	    if (start === end) {
	      return start;
	    }
	    return start + '-' + endSub;
	  },
	
	  /**
	  * Get a list of link objects for all valid leagues that have standings
	  *
	  * @param  {Object}  request    Request object
	  * @param  {Object}  data       Return value from leagues API (unmolested)
	  * @param  {Object}  hrefConfig config object for create href function
	  * @param  {Object}  edition    edition object
	  * @return {Array}             valid seasons
	  **/
	  filterLeagues: function filterLeagues() {
	    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	    var hrefConfig = arguments[2];
	    var edition = arguments[3];
	
	
	    var leagueLen = data.length || 0;
	    var leagues = [];
	    var sport = request.params.sport;
	    var pageTypeStandings = 'table';
	    var language = edition && edition.language || 'en';
	
	    for (var i = 0; i < leagueLen; i++) {
	      var league = data[i];
	      /* need to actually filter by season type as well for other sports */
	      if ((0, _selectn2.default)('hasStandings', league) === true) {
	        var leagueId = (0, _selectn2.default)('midsizeName', league) || '';
	        var slug = '';
	        if (sport === 'cricket') {
	          leagueId = (0, _selectn2.default)('id', league) || '';
	          slug = (0, _selectn2.default)('slug', league) || '';
	        }
	        if (sport === 'rugby' && (language === 'es' || language === 'pt')) {
	          pageTypeStandings = 'standings';
	        }
	        leagues.push(_common.common.buildLinkObject({
	          text: standings.getLeagueName(league) || '-',
	          params: {
	            pageType: pageTypeStandings,
	            sport: sport,
	            league: leagueId.toLowerCase(),
	            slug: slug
	          },
	          query: request.query,
	          tracking: [leagueId, 'standings', 'filter', 'league'],
	          hrefConfig: hrefConfig,
	          edition: edition
	        }));
	      }
	    }
	
	    return leagues;
	  },
	
	  /**
	  * Construct the league title from league name, season and type
	  *
	  * @param  {String}  leagueName    Current league name
	  * @param  {String}  seasonDesc    Current league name
	  * @param  {Object}  params        Router params
	  * @param  {Object}  edition        Edition params
	  * @return {String}                league title
	  **/
	  getLeagueTitle: function getLeagueTitle(leagueName, seasonDesc, params, edition) {
	    var sport = params.sport,
	        pageType = params.pageType;
	
	    var leagueTitle = '';
	    /*
	    * capitalize pagetype and prefix with '-'
	    * @Example : - Table
	    * @Example : - Standings
	    */
	    if (typeof pageType === 'string') {
	      pageType = pageType.replace(/^([a-z])/i, function (char) {
	        return char.toUpperCase();
	      });
	    } else {
	      pageType = '';
	    }
	
	    if (params.sport === 'cricket') {
	      leagueTitle = leagueName + ' ' + seasonDesc;
	    } else {
	      leagueTitle = leagueName + ' ' + pageType + ' - ' + seasonDesc;
	    }
	
	    //concat league title and pagetype
	    if (sport === 'rugby' && (pageType === 'standings' || pageType === 'Table')) {
	      var transObj = {
	        key: 'rugby.standings.leaguetitle',
	        league: leagueName,
	        season: seasonDesc
	      };
	      leagueTitle = (0, _translate2.default)(edition, transObj) || '';
	    } else {
	      leagueTitle = leagueName + ' ' + pageType + ' - ' + seasonDesc;
	    }
	    return leagueTitle;
	  },
	  getLeagueLink: function getLeagueLink() {
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var leagues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    var leagueStr = params.league ? params.league.toString() : '0';
	    var items = (0, _values2.default)(leagues) || [];
	    var itemsLen = items.length || 0;
	    for (var i = 0; i < itemsLen; i++) {
	      if (items[i].league === leagueStr) {
	        return _common.common.createHref(params) || items[i].href || ''; // Call common.createHref to create the canonical link again, with season param (CTOI-31014)
	      }
	    }
	  },
	
	  /**
	  * Gets the league name from the data and formats accordingly
	  *
	  * @param  {Object}  data      League Object
	  * @return {String}                  league title
	  **/
	  getLeagueName: function getLeagueName(data) {
	    return standings.removeYearfromName((0, _selectn2.default)('name', data) || '').trim();
	  },
	
	  /**
	   * @param  {String} currLeague current League
	   * @param  {Array} leagues league array
	   * @return {[type]} leagueId league id
	   */
	  getLeagueId: function getLeagueId() {
	    var currLeague = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var leagues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    var leagueId = void 0;
	    for (var i = leagues.length - 1; i >= 0; i--) {
	      var league = leagues[i] || {};
	      var leagueName = league.name || '';
	      if (leagueName.trim() === currLeague) {
	        leagueId = league.id;
	      }
	    }
	    return leagueId || '';
	  },
	
	  /**
	  * Takes the league name and looks for years patters to remove from the name
	  *
	  * @param  {String}  name      League name
	  * @return {String}                  formatted string
	  **/
	  removeYearfromName: function removeYearfromName(name) {
	    var retName = name;
	    retName = retName.replace(/ \d{4}$/, '');
	    retName = retName.replace(/ \d{4}\/\d{2}$/, '');
	    retName = retName.replace(/^\d{4}\/\d{4} /, '');
	    retName = retName.replace(/^\d{4}\/\d{2} /, '');
	    return retName;
	  },
	
	  /**
	  * finds the rules string in the API seperates by \n then joins back together
	  * wrapped in HTML tags
	  * NOTE this should be passed as an array to the react elements to deal with
	  *
	  * @param  {Object}  data  Return value from standings API (unmolested)
	  * @return {String}        HTML string of rules
	  **/
	  getRules: function getRules(data) {
	    var rules = (0, _selectn2.default)('rules.Story', data);
	    var rulesParsed = '';
	
	    // return empty string if rules are not string
	    if (typeof rules !== 'string') {
	      return rulesParsed;
	    }
	
	    rulesParsed = rules.split('\n\n').map(function (text) {
	      return '<p>' + text + '</p>';
	    }).join('');
	
	    return rulesParsed;
	  },
	
	  /**
	  * Finds or defaults the year/season from the season node
	  *
	  * @param    {Object}  config      Config values
	  * @param    {Object}  data        Season Node from Standings API
	  * @return   {String}                Object of filtered data
	  **/
	  getStandingsSeason: function getStandingsSeason() {
	    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return (0, _selectn2.default)('season', data) || '';
	  },
	
	  /**
	  * Finds or defaults the season type from the season node
	  *
	  * @param    {Object}  config      Config values
	  * @param    {Object}  data        Season Node from Standings API
	  * @return   {String}              Object of filtered data
	  **/
	  getStandingsSeasonType: function getStandingsSeasonType() {
	    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return (0, _selectn2.default)('seasonType', data) || config.parameters.seasontype || 0;
	  },
	
	  /**
	  * Finds the season node for a defined year from the seasons Array in the standings data
	  *
	  * @param    {String}  season      Season as year e.g. 2016
	  * @param    {Object}  data        Return value from standings API (unmolested)
	  * @return   {String}                Object of filtered data
	  **/
	  getCurrentSeasonData: function getCurrentSeasonData() {
	    var season = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	    var seasonsRaw = (0, _selectn2.default)('seasons', data) || [];
	    var seasonLen = seasonsRaw.length || 0;
	
	    if (!season && seasonLen) {
	      // no current season is available because the latest season has no data
	      // to prevent the site from displaying empty season dropdown selections, just pick
	      // the first season in the season list
	      return seasonsRaw[0];
	    }
	
	    for (var i = 0; i < seasonLen; i++) {
	      var year = (0, _selectn2.default)('year', seasonsRaw[i]) || '';
	      if (year === season) {
	        return seasonsRaw[i];
	      }
	    }
	
	    return {};
	  },
	
	  /**
	  * Builds an object that can be passed straight to 'Dropdown' component i.e. {...values}
	  *
	  * @param    {Object}  request     Request object
	  * @param    {Object}  data        Current season node from seasons array
	  * @param    {String}  seasonType      Current season type
	  * @param    {Object}  edition     edition object
	  * @return   {String}                Object of filtered data
	  **/
	  getSeasonTypes: function getSeasonTypes() {
	    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var seasonType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	    var edition = arguments[3];
	
	
	    var types = (0, _selectn2.default)('types', data) || [];
	    var typeLen = types.length || 0;
	    var items = [];
	    var selected = '';
	
	    for (var i = 0; i < typeLen; i++) {
	      var typeData = types[i];
	
	      if ((0, _selectn2.default)('hasStandings', typeData) === true) {
	
	        var name = (0, _selectn2.default)('name', typeData) || '';
	        var type = (0, _selectn2.default)('id', typeData) || 1;
	
	        if (!selected || type == seasonType) {
	          selected = name;
	        }
	
	        var params = {
	          pageType: 'table',
	          sport: request.params.sport,
	          league: request.params.league,
	          season: request.params.season,
	          slug: request.params.slug,
	          seasontype: type
	        };
	
	        items.push(_common.common.buildLinkObject({
	          text: name,
	          query: request.query,
	          tracking: [request.params.league, 'standings', 'filter', helpers.descriptionToKey(name)],
	          params: params,
	          edition: edition
	        }));
	      }
	    }
	
	    return {
	      selected: selected || '',
	      items: items || []
	    };
	  }
	
	};
	
	exports.default = standings;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	    Action:     Config for the standings table
	    Original:   /tea/core-tea/redesign/src/main/tea/api/v0/modules/standings/config.tea
	    Orginator:  ben.hobden@espn.com
	*/
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(419);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StandingConfig = {
	
	  get: function get() {
	    var oRequest = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	
	    if (Object.prototype.toString.call(oRequest) !== '[object Object]' || (0, _keys2.default)(oRequest).length === 0) {
	      return {};
	    }
	
	    /* default the objects values */
	    var oConfig = {
	      'views': [],
	      'groups': [],
	      'links': [],
	      'categories': [],
	      'parameters': {
	        'view': '',
	        'group': '',
	        'sort': '',
	        'dir': '',
	        'season': false,
	        'seasontype': 1
	      },
	      'type': false,
	      'groupType': false,
	      'playoffCutoff': 1000,
	      'showPlayoffSeed': 0,
	      'showPlayoffSeedSubscript': 0,
	      'showSeasonDropdown': true,
	      'showLeagueDropdown': false,
	      'useDisplayName': 1,
	      'teamPosition': 0,
	      'mergeTable': false,
	      'splitSeason': false, // sets the format of the season from 2015 to 2014/15
	      'shiftSeasonForward': false, // when used with splitSeason will set the date from 2015 to 2015/16
	      'highlightQualified': false
	    };
	    var oCategoryMap = {};
	    var oDefaultSortDirections = {};
	    var i = 0;
	    var defaults = {
	      'view': 'standings',
	      'group': '',
	      'sort': 'rank',
	      'dir': 'asc',
	      'season': false,
	      'seasontype': 1
	
	      /* individual config could this be abstracted elswehere or passed in? */
	    };if (oRequest.sport == 'soccer') {
	
	      oConfig.type = 0;
	      oConfig.teamPosition = 0;
	      oConfig.splitSeason = true;
	      oConfig.shiftSeasonForward = true;
	      oConfig.showLeagueDropdown = true;
	      oConfig.showSeasonDropdown = true;
	      oConfig.mergeTable = true;
	
	      oCategoryMap = {
	        'standings': [{ key: 'gamesplayed', colgroup: 2, sortable: 1 }, { key: 'wins', colgroup: 2, sortable: 1 }, { key: 'ties', colgroup: 2, sortable: 1 }, { key: 'losses', colgroup: 2, sortable: 1 }, { key: 'pointsfor', colgroup: 2, sortable: 1 }, { key: 'pointsagainst', colgroup: 2, sortable: 1 }, { key: 'pointdifferential', colgroup: 3, sortable: 1, colorize: true }, { key: 'points', colgroup: 4, sortable: 1 }]
	      };
	
	      oDefaultSortDirections = {
	        'rank': 'asc',
	        'gamesplayed': 'desc',
	        'wins': 'desc',
	        'ties': 'desc',
	        'losses': 'asc',
	        'pointsfor': 'desc',
	        'pointsagainst': 'asc',
	        'pointdifferential': 'desc',
	        'points': 'desc'
	      };
	    } else if (oRequest.sport == 'cricket') {
	
	      oConfig.type = 0;
	      oConfig.teamPosition = 0;
	      oConfig.splitSeason = true;
	      oConfig.shiftSeasonForward = true;
	      oConfig.showLeagueDropdown = true;
	      oConfig.showSeasonDropdown = true;
	      oConfig.highlightQualified = true;
	      oCategoryMap = {
	        'standings': [{ key: 'matchesplayed', colgroup: 2, sortable: 1 }, { key: 'matcheswon', colgroup: 2, sortable: 1 }, { key: 'matcheslost', colgroup: 2, sortable: 1 }, { key: 'matchestied', colgroup: 2, sortable: 1 }, { key: 'matchesdraw', colgroup: 2, sortable: 1 }, { key: 'noresult', colgroup: 2, sortable: 1 }, { key: 'matchpoints', colgroup: 2, sortable: 1 }, { key: 'quotient', colgroup: 2, sortable: 1 }, { key: 'nrr', colgroup: 3, sortable: 1 }, { key: 'for', colgroup: 3, sortable: 1 }, { key: 'against', colgroup: 3, sortable: 1 }]
	      };
	    } else if (oRequest.sport == 'rugby') {
	
	      oConfig.type = 0;
	      oConfig.teamPosition = 0;
	      oConfig.splitSeason = true;
	      oConfig.shiftSeasonForward = true;
	      oConfig.showLeagueDropdown = true;
	      oConfig.showSeasonDropdown = true;
	      oConfig.mergeTable = true;
	
	      oCategoryMap = {
	        'standings': [{ key: 'gamesplayed', colgroup: 2, sortable: 1 }, { key: 'gameswon', colgroup: 2, sortable: 1 }, { key: 'gamesdrawn', colgroup: 2, sortable: 1 }, { key: 'gameslost', colgroup: 2, sortable: 1 }, { key: 'gamesbye', colgroup: 2, sortable: 0 }, { key: 'pointsfor', colgroup: 2, sortable: 1 }, { key: 'pointsagainst', colgroup: 2, sortable: 1 }, { key: 'triesfor', colgroup: 2, sortable: 1 }, { key: 'triesagainst', colgroup: 2, sortable: 1 }, { key: 'bonuspointstry', colgroup: 2, sortable: 1 }, { key: 'bonuspointslosing', colgroup: 2, sortable: 1 }, { key: 'bonuspoints', colgroup: 2, sortable: 1 }, { key: 'pointsdifference', colgroup: 3, sortable: 1, colorize: true }, { key: 'points', colgroup: 4, sortable: 1 }]
	      };
	
	      oDefaultSortDirections = {
	        rank: 'asc',
	        gamesplayed: 'desc',
	        gameswon: 'desc',
	        gamesdrawn: 'desc',
	        gameslost: 'asc',
	        pointsfor: 'desc',
	        pointsagainst: 'asc',
	        triesfor: 'desc',
	        triesagainst: 'asc',
	        bonuspointstry: 'desc',
	        bonuspointslosing: 'desc',
	        bonuspoints: 'desc',
	        pointsdifference: 'desc',
	        points: 'desc'
	      };
	    } else if (oRequest.sport == 'rugby-league') {
	
	      oConfig.type = 0;
	      oConfig.teamPosition = 0;
	      oConfig.splitSeason = true;
	      oConfig.shiftSeasonForward = true;
	      oConfig.showLeagueDropdown = true;
	      oConfig.showSeasonDropdown = true;
	      oConfig.mergeTable = true;
	
	      oCategoryMap = {
	        'standings': [{ key: 'gamesplayed', colgroup: 2, sortable: 1 }, { key: 'gameswon', colgroup: 2, sortable: 1 }, { key: 'gamesdrawn', colgroup: 2, sortable: 1 }, { key: 'gameslost', colgroup: 2, sortable: 1 }, { key: 'gamesbye', colgroup: 2, sortable: 0 }, { key: 'pointsfor', colgroup: 2, sortable: 1 }, { key: 'pointsagainst', colgroup: 2, sortable: 1 }, { key: 'triesfor', colgroup: 2, sortable: 1 }, { key: 'triesagainst', colgroup: 2, sortable: 1 },
	        //{ key:'bonuspointstry', colgroup:2, sortable:1 },
	        //{ key:'bonuspointslosing', colgroup:2, sortable:1 },
	        //{ key:'bonuspoints', colgroup:2, sortable:1 },
	        { key: 'pointsdifference', colgroup: 3, sortable: 1, colorize: true }, { key: 'points', colgroup: 4, sortable: 1 }]
	      };
	
	      oDefaultSortDirections = {
	        rank: 'asc',
	        gamesplayed: 'desc',
	        gameswon: 'desc',
	        gamesdrawn: 'desc',
	        gameslost: 'asc',
	        pointsfor: 'desc',
	        pointsagainst: 'asc',
	        triesfor: 'desc',
	        triesagainst: 'asc',
	        //bonuspointstry :'desc',
	        //bonuspointslosing : 'desc',
	        //bonuspoints :   'desc',
	        pointsdifference: 'desc',
	        points: 'desc'
	      };
	    } else {
	      return {};
	    }
	
	    /* check params for view if found and valid mark as active else default */
	    var sParamView = oRequest.params.view || '',
	        bViewFound = 0;
	
	    for (i = 0; i < oConfig.views.length; ++i) {
	      if (oConfig.views[i].key === sParamView) {
	        bViewFound = 1;
	        oConfig.parameters.view = sParamView;
	      }
	    }
	    if (!bViewFound) {
	      oConfig.parameters.view = defaults.view;
	    }
	
	    for (i = 0; i < oConfig.views.length; ++i) {
	      if (oConfig.views[i].key === oConfig.parameters.view) {
	        oConfig.views[i].active = 1;
	        oConfig.type = oConfig.views[i].type; /* set the type here */
	      }
	    }
	
	    /* check params for group if found and valid mark as active else default */
	    var sParamGroup = oRequest.params.group || '',
	        bGroupFound = 0;
	
	    for (i = 0; i < oConfig.groups.length; ++i) {
	      if (oConfig.groups[i].key === sParamGroup) {
	        bGroupFound = 1;
	        oConfig.parameters.group = sParamGroup;
	      }
	    }
	    if (!bGroupFound) {
	      oConfig.parameters.group = defaults.group;
	    }
	    for (i = 0; i < oConfig.groups.length; ++i) {
	      if (oConfig.groups[i].key === oConfig.parameters.group) {
	        oConfig.groups[i].active = 1;
	        oConfig.groupType = oConfig.groups[i].type; /* set the group type here */
	      }
	    }
	
	    /* set the category map. */
	    oConfig.categories = oCategoryMap[oConfig.parameters.view] || [];
	
	    /* check params for sort and make sure you are allowed to sort */
	    //const calLen  = oConfig.categories.length
	    var sParamSort = oRequest.params.sortKey || '';
	    var sParamDir = oRequest.params.sortDir || '';
	    var bSortFound = 0;
	
	    /* check its valid else nerf it */
	    if (sParamDir !== 'asc' && sParamDir !== 'desc') {
	      sParamDir = '';
	    }
	
	    /* find the sort direction and make sure it is ok. */
	    for (i = 0; i < oConfig.categories.length; ++i) {
	      if (oConfig.categories[i].key === sParamSort && typeof oConfig.categories[i].sortable !== 'undefined' && oConfig.categories[i].sortable) {
	        bSortFound = 1;
	        oConfig.parameters.sort = sParamSort;
	
	        /* get this sorts default direction */
	        var sDefaultDir = defaults.dir;
	        if (typeof oDefaultSortDirections[oConfig.parameters.sort] !== 'undefined') {
	          sDefaultDir = oDefaultSortDirections[oConfig.parameters.sort];
	          defaults.dir = sDefaultDir;
	        }
	
	        if (!sParamDir) {
	          oConfig.parameters.dir = sDefaultDir;
	        } else {
	          oConfig.parameters.dir = sParamDir;
	        }
	      }
	    }
	    if (!bSortFound) {
	      oConfig.parameters.sort = defaults.sort;
	      oConfig.parameters.dir = defaults.dir;
	    }
	
	    /* TODO: do data validation on year na type */
	    oConfig.parameters.season = oRequest.params.season || defaults.season;
	    oConfig.parameters.seasontype = oRequest.params.seasontype || defaults.seasontype;
	
	    /* Now some of the data has been determined further config can be made. */
	    if (oRequest.league == 'nfl') {
	
	      oConfig.metaTitle = 'NFL Regular Season Standings';
	
	      if (oConfig.parameters.seasontype == 'pre') {
	        oConfig.metaTitle = 'NFL Preseason Standings';
	        oConfig.subHeader = oConfig.metaTitle;
	        oConfig.views = {};
	        oConfig.groups = {};
	      }
	
	      if (oConfig.parameters.group == 'conference') {
	        oConfig.mergeTable = true;
	      }
	
	      if (oConfig.parameters.view == 'playoff') {
	
	        oConfig.type = 1; // view
	        oConfig.groupType = 2; // group
	        oConfig.metaTitle = 'NFL Playoff Standings';
	        oConfig.subHeader = 'NFL Playoff Standings';
	        oConfig.groups = {};
	        oConfig.parameters.group = 'conference';
	        oConfig.showPlayoffSeed = true;
	        oConfig.showSeasonDropdown = false;
	
	        /* no sorting here! */
	        oConfig.parameters.sort = 'conferencerank';
	        oConfig.parameters.dir = 'asc';
	      } else if (oConfig.parameters.view == 'expanded') {
	        oConfig.showSeasonDropdown = false;
	        oConfig.subHeader = 'NFL Expanded Standings';
	      } else if (oConfig.parameters.view == 'vs-division') {
	        oConfig.showSeasonDropdown = false;
	        oConfig.subHeader = 'NFL Division Standings';
	      }
	
	      oConfig.metaTitle = oConfig.seasonDisplay & ' ' & oConfig.metaTitle & ' - National Football League';
	    } else if (oRequest.sport == 'soccer') {
	
	      /* switches on the rank next to the team */
	      if (oConfig.parameters.sort === defaults.sort) {
	        oConfig.showPlayoffSeed = 1;
	      }
	
	      /* for some reason? */
	      if (oRequest.params.league === 'usa.1') {
	        oConfig.splitSeason = false;
	      }
	    } else if (oRequest.sport == 'rugby' || oRequest.sport == 'rugby-league' || oRequest.sport == 'cricket') {
	
	      /* switches on the rank next to the team */
	      if (oConfig.parameters.sort === defaults.sort) {
	        oConfig.showPlayoffSeed = 1;
	      }
	    }
	
	    return oConfig;
	  }
	
	};
	
	exports.default = StandingConfig;

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(364);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _selectn = __webpack_require__(438);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	var _common = __webpack_require__(814);
	
	var _dateformat = __webpack_require__(449);
	
	var _dateformat2 = _interopRequireDefault(_dateformat);
	
	var _translate = __webpack_require__(833);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* Helpers need to be moved to utils but for now until merged it will be kept here */
	var helpers = {
	
	  /**
	  * Take in dates as strings and extract years to return year string
	  *
	  * @param  {Object}    edition     Edition config
	  * @param  {Object}    params      Router params
	  * @param  {Object}    location    Router location
	  * @return {boolean}               Merged super object for ease of transportation
	  **/
	  requestObj: function requestObj() {
	    var edition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var location = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    return {
	      edition: edition,
	      params: params,
	      location: location
	    };
	  },
	
	  numberWithCommas: function numberWithCommas(x) {
	    var parts = x.toString().split('.');
	    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	    return parts.join('.');
	  },
	
	  getOrdinal: function getOrdinal(n) {
	    var s = ['th', 'st', 'nd', 'rd'];
	    var v = n % 100;
	    return n + (s[(v - 20) % 10] || s[v] || s[0]);
	  }
	};
	
	var schedule = {
	
	  /**
	  * Process data from APIs
	  *
	  * @param  {Object}  scheduleRes     API response from standings API
	  * @param  {Object}  leagueRes       API response from league API
	  * @param  {String}  displayDate     ISO Date of the data ( the action has to make decisions and get a default which can be based on data or params )
	  * @param  {Object}  edition         Edition config
	  * @param  {Object}  params          Router params
	  * @param  {Object}  location        Router location
	  * @param  {Object}  appProps        Application properties
	  * @return {Object}                  Standings, seasons, current-season & league-title
	  **/
	  processData: function processData() {
	    var scheduleRes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var leagueRes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var displayDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	    var edition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	    var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	    var location = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
	
	
	    var request = helpers.requestObj(edition, params, location); /* until such time as we have 1 var i will fake it */
	    var groupData = schedule.getGroups(request, params.sport, params.league ? true : false, (0, _selectn2.default)('data', scheduleRes) || {});
	    var leagueWhiteList = groupData.leagues || {};
	    var metaData = schedule.getMetaData(edition, request, (0, _selectn2.default)('data', scheduleRes) || {}, leagueWhiteList, location) || {};
	    var pageTitle = metaData.pageTitle || '';
	
	    var scheduleData = {
	      groups: groupData.groups || {},
	      config: schedule.getConfig(params.sport, params.league, params.team, edition),
	      leagues: schedule.filterLeagues(edition, request, (0, _selectn2.default)('data.leagues', leagueRes) || [], params.team ? leagueWhiteList : null),
	      seasons: schedule.getSeasons(request, edition),
	      activeDates: schedule.getActiveDates((0, _selectn2.default)('data', scheduleRes) || {}),
	      title: pageTitle,
	      date: displayDate,
	      sport: params.sport,
	      noGames: (0, _translate2.default)(edition, 'No fixtures available'),
	      viewTodayText: (0, _translate2.default)(edition, 'ViewToday'),
	      meta: metaData,
	      analytics: schedule.getAnalytics(metaData),
	      teamFixtures: params.team ? true : false
	    };
	
	    return scheduleData;
	  },
	
	  /**
	  * Builds meta data object recognised by 'updateMeta' function
	  * @param    {Object}  edition       Edition Object
	  * @param    {Object}  request       Request Object
	  * @param    {Object}  scheduleData  Schedule Data
	  * @param    {Object}  leagueData    League Data
	  * @param    {Object}  location      Router location
	  * @return   {Object}                Object
	  **/
	  getMetaData: function getMetaData() {
	    var edition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var request = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var scheduleData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var leagueData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	    var location = arguments[4];
	
	
	    var reqParams = (0, _selectn2.default)('params', request) || {};
	    var sport = reqParams.sport || '';
	    var league = reqParams.league || '';
	    var team = reqParams.team || '';
	    var season = reqParams.season || '';
	    var pageType = reqParams.pageType || '';
	    var title = (0, _translate2.default)(edition, 'Fixtures and Results');
	    var subTitle = (0, _translate2.default)(edition, 'Rugby');
	    var subTitle2 = (0, _translate2.default)(edition, 'fixtures and results');
	    var keywords = ['rugby', 'rugby union', 'scores', 'news', 'schedule'];
	    var pageHeading = [];
	    var logo = '';
	    var description = 'Get the latest ' + subTitle + ' ' + subTitle2 + ' from ESPN.';
	
	    if (sport == 'rugby-league') {
	      subTitle = (0, _translate2.default)(edition, 'Rugby League');
	      keywords = ['rugby', 'rugby league', 'scores', 'news', 'schedule'];
	    }
	
	    if (team) {
	      var teamName = schedule.getTeamTitle(request, scheduleData) || '';
	      var competitors = (0, _selectn2.default)('scores[0].events[0].competitions[0].competitors', scheduleData) || [];
	
	      for (var i = 0; i < competitors.length; i++) {
	        var competitor = competitors[i];
	        if (competitor.id == team) {
	          logo = (0, _selectn2.default)('team.logo', competitor) || _common.common.defaultUrls.teamLogo;
	          logo = _common.common.resizeCombinerLogo(logo, { w: 100, h: 100 });
	        }
	      }
	
	      if (teamName) {
	        if (pageType === 'results') {
	          title = 'Results';
	          keywords.push('results');
	          subTitle2 = 'results';
	        } else {
	          title = 'Fixtures';
	          keywords.push('fixtures');
	          subTitle2 = 'fixtures';
	        }
	        pageHeading.push(teamName);
	        subTitle = teamName;
	        keywords.push('highlights');
	        keywords.unshift(typeof teamName == 'string' && teamName.toLowerCase());
	      }
	    } else {
	      if (league) {
	        var leagueName = schedule.getLeagueTitle(request, leagueData) || '';
	        if (leagueName) {
	          pageHeading.push(leagueName);
	          subTitle = leagueName;
	        }
	      } else {
	        pageHeading.push(subTitle);
	      }
	      keywords.push('fixtures');
	      keywords.push('results');
	    }
	    pageHeading.push(title);
	
	    if (season) {
	      pageHeading.push('-');
	      pageHeading.push(season);
	    }
	
	    var mainTitle = pageHeading.join(' ');
	
	    if (sport === 'rugby') {
	      title = '';
	      keywords = '';
	      description = '';
	      if (league) {
	        var _leagueName = schedule.getLeagueTitle(request, leagueData) || '';
	        var transKeyObjs2 = {
	          title: {
	            key: 'meta.title.rugby.fixtures',
	            league: _leagueName
	          },
	          keywords: {
	            key: 'meta.keywords.rugby.fixtures',
	            league: _leagueName
	          },
	          description: {
	            key: 'meta.description.rugby.fixtures',
	            league: _leagueName
	          }
	        };
	        title = (0, _translate2.default)(edition, transKeyObjs2.title) || '';
	        description = (0, _translate2.default)(edition, transKeyObjs2.description) || '';
	        keywords = (0, _translate2.default)(edition, transKeyObjs2.keywords) || '';
	      } else if (team) {
	        var _teamName = schedule.getTeamTitle(request, scheduleData) || '';
	        var _transKeyObjs = {
	          title: {
	            key: 'meta.title.rugby.fixtures',
	            team: _teamName
	          },
	          keywords: {
	            key: 'meta.keywords.rugby.fixtures',
	            team: _teamName
	          },
	          description: {
	            key: 'meta.description.rugby.fixtures',
	            team: _teamName
	          }
	        };
	        title = (0, _translate2.default)(edition, _transKeyObjs.title) || '';
	        description = (0, _translate2.default)(edition, _transKeyObjs.description) || '';
	        keywords = (0, _translate2.default)(edition, _transKeyObjs.keywords) || '';
	      } else {
	        title = (0, _translate2.default)(edition, 'meta.title.rugby.fixtures') || '';
	        description = (0, _translate2.default)(edition, 'meta.description.rugby.fixtures') || '';
	        keywords = (0, _translate2.default)(edition, 'meta.keywords.rugby.fixtures') || '';
	      }
	    }
	
	    return {
	      title: title || mainTitle + ' - ESPN',
	      pageTitle: '' + mainTitle,
	      description: description,
	      keywords: keywords || keywords.join(', '),
	      website: 'article',
	      canonical: location.pathname,
	      image: logo
	    };
	  },
	
	  /**
	  * Builds analytics data object recognised by 'analytics' function
	  *
	  * @param    {Object}  meta        Meta object returned from 'getMetaData'
	  * @return   {Object}              Object
	  **/
	  getAnalytics: function getAnalytics(meta) {
	    return {
	      chartbeat: {
	        title: meta.title
	      },
	      omniture: {}
	    };
	  },
	
	  getActiveDates: function getActiveDates(scheduleData) {
	
	    var scores = (0, _selectn2.default)('scores', scheduleData) || [];
	    var scoreLen = scores.length || 0;
	    var activeDates = {};
	
	    for (var i = 0; i < scoreLen; i++) {
	      var calendarData = (0, _selectn2.default)('leagues[0].calendar', scores[i]) || [];
	      var calLen = calendarData.length;
	      for (var a = 0; a < calLen; a++) {
	        var loopDateObj = _dateformat2.default.dateToObject(calendarData[a]) || new Date();
	        var epochTime = loopDateObj.setHours(0, 0, 0, 0);
	        activeDates[epochTime] = 1;
	      }
	    }
	
	    return activeDates;
	  },
	
	  getLeagueTitle: function getLeagueTitle() {
	    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var leagueData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var reqParams = (0, _selectn2.default)('params', request) || {};
	    var league = reqParams.league || '';
	    return leagueData[league] || '';
	  },
	
	  getTeamTitle: function getTeamTitle() {
	    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var scheduleData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var reqParams = (0, _selectn2.default)('params', request) || {};
	    var team = reqParams.team || '';
	    var teamName = '';
	    if (team) {
	      var firstCompetitor = (0, _selectn2.default)('scores[0].events[0].competitions[0].competitors[0].team', scheduleData) || {};
	      if (firstCompetitor.id === team) {
	        teamName = firstCompetitor.displayName || '';
	      } else {
	        var secondCompetitor = (0, _selectn2.default)('scores[0].events[0].competitions[0].competitors[1].team', scheduleData) || {};
	        teamName = secondCompetitor.displayName || '';
	      }
	    }
	    return teamName;
	  },
	
	  getPageHeading: function getPageHeading() {
	    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var scheduleData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var leagueData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	
	    var reqParams = (0, _selectn2.default)('params', request) || {};
	    var league = reqParams.league || '';
	    var team = reqParams.team || '';
	    var season = reqParams.season || '';
	    var pageType = reqParams.pageType || '';
	    var title = 'Fixtures and Results';
	    var pageHeading = [];
	
	    if (team) {
	      var teamName = schedule.getTeamTitle(request, scheduleData) || '';
	      if (teamName) {
	        if (pageType === 'results') {
	          title = 'Results';
	        } else {
	          title = 'Fixtures';
	        }
	        pageHeading.push(teamName);
	      }
	    }
	
	    if (league) {
	      var leagueName = schedule.getLeagueTitle(request, leagueData) || '';
	      if (leagueName) {
	        pageHeading.push(leagueName);
	      }
	    } else {
	      pageHeading.push('Rugby');
	    }
	
	    pageHeading.push(title);
	
	    if (season) {
	      pageHeading.push('-');
	      pageHeading.push(season);
	    }
	
	    return pageHeading.join(' ');
	  },
	
	  getConfig: function getConfig() {
	    var sport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var league = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var team = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	    var edition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	
	    var config = {};
	    var commonKeys = {
	      date: { key: 'date', name: (0, _translate2.default)(edition, 'Date').toUpperCase() },
	      matchup: { key: 'matchup', name: (0, _translate2.default)(edition, 'Match').toUpperCase() },
	      time: { key: 'time', name: (0, _translate2.default)(edition, 'time').toUpperCase() },
	      tv: { key: 'tv', name: 'TV' },
	      league: { key: 'league', name: (0, _translate2.default)(edition, 'Competition').toUpperCase() },
	      location: { key: 'location', name: (0, _translate2.default)(edition, 'location').toUpperCase() },
	      result: { key: 'result', name: (0, _translate2.default)(edition, 'result').toUpperCase() },
	      attendance: { key: 'attendance', name: (0, _translate2.default)(edition, 'Attendance').toUpperCase() }
	    };
	    if (league === 'nba') {
	
	      config = {
	        'states': {
	          'pre': [{ key: 'matchup', name: 'MATCHUP' }, { key: 'time', name: 'TIME' }, { key: 'tv', name: 'NAT TV' }, { key: 'awayTv', name: 'AWAY TV' }, { key: 'homeTv', name: 'Home TV' }, { key: 'tickets', name: 'TICKETS' }],
	          'post': [{ key: 'matchup', name: 'MATCHUP' }, { key: 'result', name: 'RESULT' }, { key: 'nbaWinnerLeader', name: 'WINNER HIGH' }, { key: 'nbaLoserLeader', name: 'LOSER HIGH' }]
	        },
	        'cols': { 'col1': 'points', 'col2': 'points' }
	      };
	    } else if (league === 'mlb') {
	
	      config = {
	        'states': {
	          'pre': [{ key: 'matchup', name: 'MATCHUP' }, { key: 'time', name: 'TIME' }, { key: 'tv', name: 'NAT TV' }, { key: 'pitchingMatchup', name: 'PITCHING MATCHUP' }, { key: 'tickets', name: 'TICKETS' }],
	          'post': [{ key: 'matchup', name: 'MATCHUP' }, { key: 'result', name: 'RESULT' }, { key: 'pitchLeader', name: 'WIN' }, { key: 'pitchLoser', name: 'LOSS' }, { key: 'pitchSaver', name: 'SAVE' }]
	        }
	      };
	    } else if (sport === 'soccer') {
	
	      var oSoccerPre = [{ key: 'matchup', name: 'MATCH' }, { key: 'time', name: 'TIME' }, { key: 'tv', name: 'TV' }, { key: 'betting', name: 'BETTING' }];
	
	      if (league === 'usa.1') {
	        oSoccerPre = [{ key: 'matchup', name: 'MATCH' }, { key: 'time', name: 'TIME' }, { key: 'tv', name: 'TV' }, { key: 'location', name: 'LOCATION' }];
	      }
	
	      config = {
	        'states': {
	          'pre': oSoccerPre,
	          'post': [{ key: 'matchup', name: 'MATCH' }, { key: 'result', name: 'RESULT' }, { key: 'location', name: 'LOCATION' }, { key: 'attendance', name: 'ATTENDANCE' }]
	        }
	      };
	    } else if (league === 'nfl') {
	
	      config = {
	        'states': {
	          'pre': [{ key: 'matchup', name: 'MATCHUP' }, { key: 'time', name: 'TIME' }, { key: 'tv', name: 'NAT TV' }, { key: 'location', name: 'LOCATION' }, { key: 'tickets', name: 'TICKETS' }],
	          'post': [{ key: 'matchup', name: 'MATCHUP' }, { key: 'result', name: 'RESULT' }, { key: 'passingLeader', name: 'PASSING LEADER' }, { key: 'rushingLeader', name: 'RUSHING LEADER' }, { key: 'receivingLeader', name: 'RECEIVING LEADER' }]
	        }
	      };
	    } else if (sport === 'rugby' || sport === 'rugby-league') {
	
	      if (team) {
	        config = {
	          'states': {
	            'pre': [commonKeys.date, commonKeys.matchup, commonKeys.time, commonKeys.league, commonKeys.location],
	
	            'post': [commonKeys.date, commonKeys.matchup, commonKeys.result, commonKeys.league, commonKeys.location]
	          }
	        };
	      } else {
	        config = {
	          'states': {
	            'pre': [commonKeys.matchup, commonKeys.time, commonKeys.tv, commonKeys.location],
	            'post': [commonKeys.matchup, commonKeys.result, commonKeys.location, commonKeys.attendance]
	          },
	          'sportClass': 'soccer'
	        };
	      }
	    }
	
	    return config;
	  },
	
	  getGroups: function getGroups() {
	    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var sport = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var showDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	    var scheduleData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	
	    var scores = (0, _selectn2.default)('scores', scheduleData) || [];
	    var scoreLen = scores.length || 0;
	    var scoreData = [];
	    var leagueMap = {};
	
	    for (var i = 0; i < scoreLen; i++) {
	      var leagueData = scores[i] || {};
	      var eventData = (0, _selectn2.default)('events', leagueData) || [];
	      var leagueInfo = (0, _selectn2.default)('leagues[0]', leagueData) || {};
	      var leagueName = schedule.getLeagueName(leagueInfo);
	      var leagueId = schedule.getLeagueId(leagueInfo);
	
	      leagueMap[leagueId] = leagueName;
	      if (eventData.length) {
	        scoreData.push((0, _extends3.default)({
	          groupName: schedule.getGroupName(showDate, leagueData)
	        }, schedule.getEvents(request, sport, leagueId, eventData, leagueName)));
	      }
	    }
	
	    if ((0, _selectn2.default)('params.team', request)) {
	      return schedule.groupByMonth(request, scoreData);
	    }
	
	    return {
	      groups: scoreData,
	      leagues: leagueMap
	    };
	  },
	
	  /**
	  * Reorder the groups and insert the events into months, This will also
	  * filter the events based on league and season
	  * @param  {Object}  request       Unified request data object
	  * @param  {Object}  scheduleData  Output from getGroups ( grouped events )
	  * @return {Object}                Array of objects ( grouped events )
	  **/
	  groupByMonth: function groupByMonth() {
	    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var scheduleData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	    var dataLen = scheduleData.length || 0;
	    var season = (0, _selectn2.default)('params.season', request) || new Date().getFullYear();
	    var league = (0, _selectn2.default)('params.league', request) || '';
	    var pageType = (0, _selectn2.default)('params.pageType', request) || '';
	    var complete = [];
	    var incomplete = [];
	    var leagueMap = {};
	
	    for (var i = 0; i < dataLen; i++) {
	      var groupData = scheduleData[i];
	      complete = complete.concat(groupData.complete);
	      incomplete = incomplete.concat(groupData.incomplete);
	    }
	
	    function compare(a, b) {
	      var aVal = (0, _selectn2.default)('date', a) || 0;
	      var bVal = (0, _selectn2.default)('date', b) || 0;
	      aVal = _dateformat2.default.dateToKey(aVal);
	      bVal = _dateformat2.default.dateToKey(bVal);
	      if (aVal < bVal) {
	        return -1;
	      }
	      if (aVal > bVal) {
	        return 1;
	      }
	      return 0;
	    }
	
	    complete.sort(compare);
	    incomplete.sort(compare);
	
	    var sortedData = [];
	
	    for (var _i = 0; _i < 12; _i++) {
	      var date = season + '-' + ('0' + (_i + 1)).slice(-2) + '-01T00:00:00Z';
	      sortedData.push({
	        complete: [],
	        incomplete: [],
	        groupName: _dateformat2.default.dateFormat(date, 'MMMM, YYYY')
	      });
	    }
	
	    var events = complete;
	    var eventType = 'complete';
	
	    if (pageType !== 'results') {
	      events = incomplete;
	      eventType = 'incomplete';
	    }
	
	    var completeLen = events.length || 0;
	    for (var _i2 = 0; _i2 < completeLen; _i2++) {
	      var evtDate = (0, _selectn2.default)('[' + _i2 + '].date', events);
	      var evtLeague = (0, _selectn2.default)('[' + _i2 + '].leagueId', events);
	      var month = _dateformat2.default.dateFormat(evtDate, 'MM') * 1 - 1;
	      var year = _dateformat2.default.dateFormat(evtDate, 'YYYY') * 1;
	      if (season == year) {
	        if (league === '' || evtLeague == league) {
	          sortedData[month][eventType].push(events[_i2]);
	        }
	        leagueMap[evtLeague] = (0, _selectn2.default)('[' + _i2 + '].league', events) || evtLeague;
	      }
	    }
	
	    var returnData = [];
	    for (var _i3 = 0; _i3 < 12; _i3++) {
	      if (sortedData[_i3].complete.length > 0 || sortedData[_i3].incomplete.length > 0) {
	        if (pageType == 'results' && sortedData[_i3].complete.length > 0) {
	          sortedData[_i3].complete.reverse();
	        }
	        returnData.push(sortedData[_i3]);
	      }
	    }
	
	    if (pageType == 'results') {
	      returnData.reverse();
	    }
	
	    return {
	      groups: returnData,
	      leagues: leagueMap
	    };
	  },
	
	  getGroupName: function getGroupName() {
	    var showDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    var leagueData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    if (showDate) {
	      return _dateformat2.default.dateFormat((0, _selectn2.default)('events[0].date', leagueData) || new Date(), 'date14');
	    }
	    return schedule.getLeagueName((0, _selectn2.default)('leagues[0]', leagueData)) || '';
	  },
	
	  getEvents: function getEvents() {
	    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var sport = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var leagueId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	    var eventsData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	    var leagueName = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
	
	
	    var eventLen = eventsData.length || 0;
	    var dateForm = 'time1';
	    var edition = request && request.edition;
	    var lang = edition && edition.language;
	    var processedEvents = {
	      incomplete: [],
	      complete: []
	    };
	
	    for (var i = 0; i < eventLen; i++) {
	
	      var eventData = eventsData[i];
	      var competition = (0, _selectn2.default)('competitions[0]', eventData) || {}; /* original code makes and assuption there is only 1 competition so i will do the same. */
	      var competitors = (0, _selectn2.default)('competitors', competition) || {};
	      var links = (0, _selectn2.default)('links', eventData) || [];
	      var linkMap = schedule.getLinkMap(links);
	      var eventDate = (0, _selectn2.default)('date', eventData) || '';
	      var homeTeam = schedule.getTeam(request, competitors, leagueId, 'home') || {};
	      var awayTeam = schedule.getTeam(request, competitors, leagueId, 'away') || {};
	      var gameState = (0, _selectn2.default)('status.type.state', eventData) || 'pre';
	      var gameLink = schedule.getEventLink(sport, gameState, linkMap);
	      var period = (0, _selectn2.default)('status.period', eventData) || 0;
	      var gameUrl = _common.common.getUrlByRel({ links: links }, 'summary', edition.domain, sport);
	
	      var note = '';
	      var record = 'v';
	      var betLink = {};
	
	      /* build post game data */
	      if (gameState === 'post') {
	
	        if (sport === 'soccer' || sport === 'rugby' || sport === 'rugby-league') {
	
	          var iLeg = (0, _selectn2.default)('leg.value', competition) || 0;
	
	          /* build the score */
	          if (iLeg == 2 && homeTeam.aggregateScore != null && awayTeam.aggregateScore != null) {
	            record = homeTeam.score + ' (' + homeTeam.aggregateScore + ') - (' + awayTeam.aggregateScore + ') ' + awayTeam.score;
	          } else {
	            record = homeTeam.score + ' - ' + awayTeam.score;
	          }
	
	          if (iLeg > 0) {
	
	            if (note !== '') {
	              note += ' - ';
	            }
	
	            note += helpers.getOrdinal(iLeg) + ' Leg';
	
	            /* build aggeragate winner text */
	            if (gameState !== 'pre') {
	              note += schedule.getSoccerNote(homeTeam, awayTeam, iLeg, 'aggregate', period);
	            }
	          }
	
	          /* build penalties text */
	          if (gameState !== 'pre' && (homeTeam.shootoutScore > 0 || awayTeam.shootoutScore > 0)) {
	            note += schedule.getSoccerNote(homeTeam, awayTeam, iLeg, 'penalties', period);
	          }
	        } else {
	          //console.log('damned lint')
	        }
	      } else {
	
	        /* build the betting links */
	        betLink = linkMap.bet365 || {};
	        if (betLink) {
	          betLink.href = '#';
	          betLink.linkTrack = 'bet365';
	          betLink.text = 'Football Odds with Bet365';
	        } else {
	          betLink.href = '#';
	          betLink.text = '';
	          betLink.linkTrack = '';
	        }
	      }
	
	      var linkDefaults = {
	        edition: request.edition,
	        href: gameUrl,
	        external: gameLink.external,
	        tracking: [leagueId, 'schedule', 'score']
	      };
	
	      var resultLink = _common.common.buildLinkObject((0, _extends3.default)({
	        text: (0, _selectn2.default)('status.type.shortDetail', eventData) || ''
	      }, linkDefaults));
	
	      var timeLink = _common.common.buildLinkObject((0, _extends3.default)({
	        text: gameState === 'in' ? 'LIVE' : ''
	      }, linkDefaults));
	
	      var recordLink = _common.common.buildLinkObject((0, _extends3.default)({
	        text: record
	      }, linkDefaults));
	
	      //SEWEB-13325 hide team links for es/pt
	      if (lang === 'es' || lang === 'pt') {
	        homeTeam.link.href = null;
	        awayTeam.link.href = null;
	      }
	
	      var processedEvent = {
	        homeTeam: homeTeam,
	        awayTeam: awayTeam,
	        dateData: eventDate,
	        dateFormat: dateForm,
	        displayTime: timeLink,
	        result: resultLink,
	        note: note,
	        gameId: competition.id || 0,
	        tv: null,
	        betting: betLink,
	        tickets: null,
	        soccerRecord: recordLink,
	        timeValid: competition.timeValid || false,
	        gameState: gameState,
	        period: period,
	        attendance: schedule.getAttendance(competition),
	        location: schedule.getEventVenue(competition),
	        date: eventDate,
	        league: leagueName,
	        leagueId: leagueId
	      };
	
	      if (processedEvent.gameState !== 'post') {
	        processedEvents.incomplete.push(processedEvent);
	      } else {
	        processedEvents.complete.push(processedEvent);
	      }
	    }
	
	    return processedEvents;
	  },
	
	  getAttendance: function getAttendance() {
	    var competition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var attendance = (0, _selectn2.default)('attendance', competition) || 0;
	    if (attendance > 0) {
	      return helpers.numberWithCommas(competition.attendance);
	    }
	    return 'N/A';
	  },
	
	  getLinkMap: function getLinkMap() {
	    var links = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	
	    var linkLen = links.length;
	    var rLinkMap = {};
	
	    for (var i = 0; i < linkLen; i++) {
	      var linkData = links[i];
	      var sLinkKey = linkData.text.toLowerCase().replace(' ', '');
	
	      rLinkMap[sLinkKey] = {
	        href: linkData.href || '#',
	        text: linkData.text || '',
	        external: linkData.isExternal || false
	      };
	    }
	
	    return rLinkMap;
	  },
	
	  getEventLink: function getEventLink() {
	    var sport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var gameState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'pre';
	    var rLinkMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	
	    var linkHref = {};
	    var linkBlank = {
	      href: '#',
	      external: false,
	      text: '-'
	
	      /* Build the game links */
	    };var rLinkTypeMap = {
	      default: 'conversation',
	      preLink: 'preview',
	      liveLink: 'gamecast',
	      secondLiveLink: 'play-by-play',
	      postLink: 'recap',
	      secondPostLink: 'box score'
	    };
	
	    if (sport === 'soccer') {
	      rLinkTypeMap = {
	        default: 'statistics',
	        postLink: 'report',
	        secondLiveLink: 'statistics',
	        secondPostLink: 'statistics'
	      };
	    } else if (sport === 'rugby' || sport === 'rugby-league') {
	      rLinkTypeMap = {
	        default: 'match',
	        postLink: 'report',
	        secondLiveLink: 'statistics',
	        secondPostLink: 'statistics'
	      };
	    }
	
	    if (gameState === 'pre') {
	      linkHref = rLinkMap[rLinkTypeMap['preLink']] ? rLinkMap[rLinkTypeMap['preLink']] : rLinkMap[rLinkTypeMap['default']];
	    } else if (gameState === 'live') {
	      linkHref = rLinkMap[rLinkTypeMap['liveLink']] ? rLinkMap[rLinkTypeMap['liveLink']] : rLinkMap[rLinkTypeMap['secondLiveLink']];
	    } else if (gameState === 'post') {
	      linkHref = rLinkMap[rLinkTypeMap['postLink']] ? rLinkMap[rLinkTypeMap['postLink']] : rLinkMap[rLinkTypeMap['secondPostLink']];
	    }
	
	    if (!(0, _selectn2.default)('href', linkHref)) {
	      linkHref = rLinkMap[rLinkTypeMap['default']] ? rLinkMap[rLinkTypeMap['default']] : linkBlank;
	    }
	
	    if ((0, _selectn2.default)('href', linkHref) !== '#') {
	      linkHref.href = _common.common.buildURL(linkHref.href);
	    }
	
	    return linkHref;
	  },
	
	  getEventVenue: function getEventVenue() {
	    var competition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var league = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	
	    var venue = (0, _selectn2.default)('venue.fullName', competition) || '';
	    var country = (0, _selectn2.default)('venue.address.country', competition) || null;
	    var city = (0, _selectn2.default)('venue.address.city', competition) || null;
	
	    if (city != null) {
	      venue = venue + ', ' + city;
	    }
	
	    if (country != null && league != 'usa.1') {
	      venue = venue + ', ' + country;
	    }
	
	    return venue;
	  },
	
	  getSoccerNote: function getSoccerNote() {
	    var homeTeam = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var awayTeam = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var leg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	    var sType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	    var period = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	
	
	    if (leg <= 1) {
	      return '';
	    }
	
	    var homeScore = sType === 'aggregate' ? homeTeam.aggregateScore : homeTeam.shootoutScore;
	    var awayScore = sType === 'aggregate' ? awayTeam.aggregateScore : awayTeam.shootoutScore;
	    var note = '';
	    var sResult = '';
	    var bTied = false;
	    var sWillAdvance = homeTeam.name;
	    //var sWonMatch       = homeTeam.name
	    var sWinning = null;
	    var iFirstScore = homeScore;
	    var iSecondScore = awayScore;
	
	    if (awayScore > homeScore) {
	      sWinning = awayTeam.name;
	    } else if (awayScore < homeScore) {
	      sWinning = homeTeam.name;
	    }
	
	    if (awayTeam.willAdvance) {
	      sWillAdvance = awayTeam.name;
	      iFirstScore = awayScore;
	      iSecondScore = homeScore;
	    }
	
	    //if (awayTeam.isWinner) {
	    //    sWonMatch = awayTeam.name;
	    //}
	
	    sResult = sWillAdvance + ' win';
	    if (homeScore === awayScore) {
	      sResult = 'Tied';
	      if (sType === 'aggregate' && period != 5) {
	        bTied = true;
	      }
	    } else if (sWinning != null && sWillAdvance !== sWinning) {
	      sResult = sWinning + ' lead';
	    }
	
	    note = ' - ' + sResult + ' ' + iFirstScore + '-' + iSecondScore + ' on ' + sType;
	
	    if (bTied) {
	      note += ' - ' + sWillAdvance + ' advances';
	    }
	
	    return note;
	  },
	
	  getTeam: function getTeam() {
	    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var competitors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	    var leagueId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	    var homeAway = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'home';
	
	
	    var team = {};
	    var compLen = competitors.length;
	
	    for (var i = 0; i < compLen; i++) {
	      var oCompetitor = competitors[i] || {};
	      if (oCompetitor.homeAway === homeAway) {
	        team = schedule.getTeamInformation(request, leagueId, oCompetitor.team);
	        team.isWinner = oCompetitor.winner || false;
	        team.willAdvance = oCompetitor.advance || false;
	        team.score = oCompetitor.score || 0;
	        team.aggregateScore = oCompetitor.aggregateScore || 0;
	        team.shootoutScore = oCompetitor.shootoutScore || 0;
	        return team;
	      }
	    }
	
	    return team;
	  },
	
	  getTeamInformation: function getTeamInformation() {
	    var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var leagueId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    var oTeamData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	
	    var edition = request.edition;
	    var linkText = 'Clubhouse';
	    if (edition.language === 'es' || edition.language === 'pt') {
	      linkText = 'Sede';
	    }
	
	    var rTmpTeam = {
	      id: parseInt(oTeamData.id) || null,
	      name: oTeamData.name || null,
	      abbrev: oTeamData.abbreviation || null,
	      displayName: oTeamData.displayName || null,
	      hasLogo: true,
	      logo: _common.common.getTeamLogo(oTeamData || {}, { w: 50, h: 50 }),
	      link: _common.common.buildLinkObject({
	        text: oTeamData.name,
	        href: _common.common.getTeamUrl(oTeamData || {}, linkText) || '',
	        query: request.query || {},
	        edition: request.edition || {},
	        tracking: [leagueId, 'schedule', 'team'],
	        classes: ['team-name']
	      }),
	      isActive: oTeamData.isActive || false,
	      willAdvance: false,
	      advance: false,
	      score: null,
	      aggregateScore: null,
	      shootoutScore: null
	    };
	
	    return rTmpTeam;
	  },
	
	  /**
	  * Get a list of link objects for all valid leagues
	  * @param  {Object}  edition   Edition object
	  * @param  {Object}  request   Request object
	  * @param  {Object}  data      Return value from leagues API (unmolested)
	  * @param  {Object}  whitelist Object keys are leagueIds and values are league names
	  * @return {Array}             valid leagues
	  **/
	  filterLeagues: function filterLeagues() {
	    var edition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var request = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	    var whitelist = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	
	    var reqParams = (0, _selectn2.default)('params', request) || {};
	    var translateKey = 'dropdown.leagues.default.' + reqParams.sport;
	    var leagueLen = data.length || 0;
	    var selected = (0, _translate2.default)(edition, translateKey);
	    if (selected === translateKey) {
	      selected = (0, _translate2.default)(edition, 'dropdown.leagues.default.sport');
	    }
	    var leagues = [];
	    var defaultParams = {
	      pageType: reqParams.pageType || 'fixtures',
	      sport: reqParams.sport
	    };
	
	    if (reqParams.team) {
	      defaultParams.team = reqParams.team;
	    }
	    if (reqParams.season) {
	      defaultParams.season = reqParams.season;
	    }
	
	    leagues.push(_common.common.buildLinkObject({
	      text: selected,
	      params: defaultParams,
	      query: request.query,
	      edition: request.edition,
	      tracking: ['all', 'schedule', 'filter', 'league']
	    }));
	
	    for (var i = 0; i < leagueLen; i++) {
	
	      var league = data[i];
	      var leagueName = schedule.getLeagueName(league) || '';
	      var leagueId = (0, _selectn2.default)('midsizeName', league) || '';
	      var slug = '';
	
	      if (reqParams.sport === 'cricket') {
	        leagueId = (0, _selectn2.default)('id', league) || '';
	        slug = (0, _selectn2.default)('slug', league) || '';
	      }
	
	      if (whitelist && !whitelist[leagueId]) {
	        continue;
	      }
	
	      if (leagueId === reqParams.league) {
	        selected = leagueName;
	      }
	
	      leagues.push(_common.common.buildLinkObject({
	        text: leagueName,
	        params: (0, _extends3.default)({}, defaultParams, {
	          league: leagueId.toLowerCase(),
	          slug: slug
	        }),
	        query: request.query,
	        edition: request.edition,
	        tracking: [leagueId, 'schedule', 'filter', 'league']
	      }));
	    }
	
	    return {
	      items: leagues,
	      selected: selected
	    };
	  },
	
	  /**
	  * Get a list of link objects for the last 10 years
	  * @param  {Object}    request   Request object
	  * @param  {Object}    edition   edition object
	  * @return {Array}               Array of link objects
	  **/
	  getSeasons: function getSeasons(request, edition) {
	
	    var reqParams = (0, _selectn2.default)('params', request) || {};
	    var endYear = new Date().getFullYear();
	    var startYear = endYear - 10;
	    var selected = reqParams.season || endYear;
	
	    var seasons = [];
	
	    if (reqParams.team && reqParams.pageType === 'results') {
	
	      for (var i = startYear; i <= endYear; i++) {
	
	        var params = {
	          pageType: reqParams.pageType || 'fixtures',
	          sport: reqParams.sport,
	          team: reqParams.team,
	          season: i,
	          slug: reqParams.slug
	        };
	
	        seasons.push(_common.common.buildLinkObject({
	          text: i,
	          query: request.query,
	          params: params,
	          tracking: [reqParams.team, 'fixtures', 'filter', 'year'],
	          edition: edition
	        }));
	      }
	    }
	
	    return {
	      items: seasons.reverse(),
	      selected: selected
	    };
	  },
	
	  /**
	  * Gets the league name from the data and formats accordingly
	  * @param  {Object}  data      League Object
	  * @return {String}            League title
	  **/
	  getLeagueName: function getLeagueName() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    return (0, _selectn2.default)('name', data).trim() || '';
	  },
	
	  /**
	  * Gets the league name from the data and formats accordingly
	  * @param  {Object}  data      League Object
	  * @param  {String}  sport     Sport name
	  * @return {String}            League id
	  **/
	  getLeagueId: function getLeagueId() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var sport = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	    if (sport === 'cricket') {
	      return (0, _selectn2.default)('id', data) || '';
	    }
	    return (0, _selectn2.default)('midsizeName', data) || (0, _selectn2.default)('id', data) || '';
	  }
	};
	
	exports.default = schedule;

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.filterVideoContent = undefined;
	
	var _objectWithoutProperties2 = __webpack_require__(416);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _toConsumableArray2 = __webpack_require__(410);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _keys = __webpack_require__(419);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(364);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(365);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.filterActivePlayerVideos = filterActivePlayerVideos;
	exports.filterScorecardVideos = filterScorecardVideos;
	exports.filterCommentaryVideos = filterCommentaryVideos;
	exports.updateCommentary = updateCommentary;
	exports.checkLastEndOfOver = checkLastEndOfOver;
	exports.updateVideos = updateVideos;
	exports.updateLecClips = updateLecClips;
	exports.setLocalTime = setLocalTime;
	exports.filterEvent = filterEvent;
	exports.extractFavEvents = extractFavEvents;
	exports.updateMidColFeed = updateMidColFeed;
	exports.midColVidGeoFilter = midColVidGeoFilter;
	exports.filterBet365 = filterBet365;
	exports.updateNavLinks = updateNavLinks;
	exports.updateArticle = updateArticle;
	exports.updateGameStrip = updateGameStrip;
	exports.getNoContentText = getNoContentText;
	
	var _common = __webpack_require__(430);
	
	var _dateformat = __webpack_require__(449);
	
	var _dateformat2 = _interopRequireDefault(_dateformat);
	
	var _selectn = __webpack_require__(438);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	var _momentTimezone = __webpack_require__(450);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _common2 = __webpack_require__(814);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Filter out geo restricted videos on live tab - innings summary section.
	 * This data is created from rostersNode.
	 * Iterate over players and reset video object if necessary.
	 *
	 * @param  {Object} innings current innings details
	 * @param  {String} country user's country
	 * @param  {Object} copyRightOptions user's domain, site etc information
	 * @return {undefined}           undefined
	 */
	function filterActivePlayerVideos() {
	  var innings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var country = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var copyRightOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  // Do not filter out videos if country is not passed
	  if (country === '') {
	    return;
	  }
	  // Get active players for this innings
	  var activePlayers = innings.players || [];
	  // Active players are split in batsmen & bowlers
	  var sections = ['batsmen', 'bowlers'];
	  // iterater over batsmen and bowlers sections of current innings
	  for (var j = 0; j < sections.length; j++) {
	    var section = sections[j];
	    if (activePlayers.hasOwnProperty(section) === false) {
	      continue;
	    }
	    // extract players for current section
	    var players = (0, _selectn2.default)('[' + section + '].list', activePlayers) || [];
	    //console.info('players', players)
	    // Iterate over all players from this section & call reset fn
	    for (var k = 0; k < players.length; k++) {
	      var player = players[k] || {};
	      //console.info('player', player)
	      var video = player.video || {};
	
	      //check for copyright video for a country and show/hide
	      if (!(0, _common.showCopyrightVideo)(video.ad, copyRightOptions)) {
	        player.video = {};
	        player.hasVideoId = false;
	      }
	
	      if ((0, _common.isGeoRestricted)(video.geoRestrictions, country)) {
	        player.video = {};
	        player.hasVideoId = false;
	      }
	    }
	  }
	}
	
	/**
	 * Filter out geo restricted videos on scorecard tab.
	 * Scorecard tab has players data for each innings created from rostersNode.
	 * Iterate over players and reset video object if necessary.
	 *
	 * @param  {Array}  scorecard scorecard page input data
	 * @param  {String} country   country of the user
	* @param   {Object} copyRightOptions user's domain, site etc information
	 * @return {undefined}           undefined
	 */
	function filterScorecardVideos() {
	  var scorecard = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var country = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var copyRightOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  // Do not filter out videos if country is not passed
	  if (country === '') {
	    return;
	  }
	  //console.info('scorecard', scorecard)
	
	  // extract all innings
	  var allInnings = scorecard.innings || {};
	  //console.info('allInnings', allInnings)
	
	  // Iterater over all innings
	  for (var i in allInnings) {
	    var current = allInnings[i] || {};
	    var sections = ['batsmen', 'bowlers'];
	    // iterater over batsmen and bowlers sections of current innings
	    for (var j = 0; j < sections.length; j++) {
	      var section = sections[j];
	      if (current.hasOwnProperty(section) === false) {
	        continue;
	      }
	      // extract players for current section
	      var players = current[section] || [];
	      //console.info('scorecard players', players)
	      // Iterate over all players from this section & call reset fn
	      for (var k = 0; k < players.length; k++) {
	        var player = players[k] || {};
	        var video = player.video || {};
	
	        //check for copyright video for a country and show/hide
	        if (!(0, _common.showCopyrightVideo)(video.ad, copyRightOptions)) {
	          player.video = {};
	          player.hasVideoId = false;
	        }
	
	        if ((0, _common.isGeoRestricted)(video.geoRestrictions, country)) {
	          player.video = {};
	          player.hasVideoId = false;
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Filter out geo restricted videos on commentary
	 *
	 * @param  {Object} commentary commentary object
	 * @param  {String} country   country of the user
	 * @param  {Object} copyRightOptions user's domain, site etc information
	 * @return {undefined}
	 */
	function filterCommentaryVideos() {
	  var commentary = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var country = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var copyRightOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  (commentary.overs || []).map(function (over) {
	    var comments = over.comments;
	    comments.map(function (comment) {
	      var video = comment.video || {};
	
	      //check for copyright video for a country and show/hide
	      if (!(0, _common.showCopyrightVideo)(video.ad, copyRightOptions)) {
	        comment.video = {};
	        comment.hasVideoId = false;
	      }
	
	      if ((0, _common.isGeoRestricted)(video.geoRestrictions, country)) {
	        comment.video = {};
	        comment.hasVideoId = false;
	      }
	    });
	  });
	}
	
	/**
	 * update new state of commentary
	 * @param  {Object} state previous state
	 * @param  {Object} data  action data
	 * @param  {Boolean} isPolling Determine if commentary is polling
	 * @param  {Object} copyRightOptions user's domain, site etc information
	 * @return {Object}       next state
	 */
	function updateCommentary() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var isPolling = arguments[2];
	  var copyRightOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var prevCommentary = (0, _selectn2.default)('fullCommentary', state) || {};
	  var _prevCommentary$overs = prevCommentary.oversByPage,
	      preOversByPage = _prevCommentary$overs === undefined ? {} : _prevCommentary$overs,
	      prevPage = prevCommentary.page;
	
	  var fullCommentary = (0, _selectn2.default)('fullCommentary', data) || {};
	  var _fullCommentary$overs = fullCommentary.oversByPage,
	      oversByPage = _fullCommentary$overs === undefined ? {} : _fullCommentary$overs,
	      page = fullCommentary.page,
	      pageCount = fullCommentary.pageCount,
	      _fullCommentary$overs2 = fullCommentary.overs,
	      overs = _fullCommentary$overs2 === undefined ? [] : _fullCommentary$overs2;
	
	  var allOvers = [];
	
	  // reverse order the comments
	  overs.map(function () {
	    var over = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var comments = over.comments;
	    over.comments = comments.length > 0 && comments.reverse();
	  });
	
	  // retain page from prev state if commentary is polling
	  if (isPolling) {
	    fullCommentary.page = page = prevPage;
	  }
	
	  // more commentary available is current page is b/w 1 and total page count
	  fullCommentary.hasMore = page > 1 && page <= pageCount ? true : false;
	
	  // if not initial load append the current page commentary
	  if (fullCommentary && fullCommentary.init != true) {
	    // merge oversbypage with the previous state
	    fullCommentary.oversByPage = (0, _assign2.default)({}, preOversByPage, oversByPage);
	
	    // compile all the overs from oversbypage
	    allOvers = getAllOvers(fullCommentary.oversByPage);
	
	    // update with all overs
	    fullCommentary.overs = allOvers.reverse();
	  }
	
	  //add lec clips into an array of objects in data
	  updateLecClips(state, data, copyRightOptions);
	
	  checkLastEndOfOver(fullCommentary, false);
	
	  return (0, _assign2.default)({}, state, (0, _extends3.default)({}, data));
	}
	
	/**
	 * filter overs by page and returns all overs
	 * 
	 * @param {any} oversByPage overs arranged by page
	 * @returns {Array} array of overs
	 */
	function getAllOvers(oversByPage) {
	  var allOvers = [];
	  var pages = void 0;
	  var pagesFiltered = void 0;
	
	  pages = (0, _keys2.default)(oversByPage).sort(function (a, b) {
	    return b - a;
	  });
	
	  pagesFiltered = pages.reduce(function (filteredPageNums, currentPage) {
	    var length = filteredPageNums.length;
	
	    // get the pages in sequence and leave the rest
	    if (length === 0 || filteredPageNums[length - 1] - currentPage === 1) {
	      filteredPageNums.push(currentPage);
	    }
	
	    return filteredPageNums;
	  }, []);
	
	  pagesFiltered.reverse().map(function (page) {
	    allOvers = allOvers.concat(oversByPage[page]);
	  });
	
	  return allOvers;
	}
	
	/**
	 * Add a flag if the over has the last end-of-over
	 * 
	 * @param {Object} commentary commentary object
	 * @param {Boolean} checkReverse decides in which direction to check
	 * @return {undefined}
	 */
	function checkLastEndOfOver() {
	  var commentary = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var checkReverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var overs = commentary.overs || [];
	  var oversLen = overs.length;
	  var checked = false;
	
	  if (oversLen === 0) {
	    return;
	  }
	
	  var setLastEndOfOver = function setLastEndOfOver(over) {
	    if (checked) {
	      over.hasLastEndOfOver = false;
	      return;
	    }
	
	    if (over.endOfOver) {
	      over.hasLastEndOfOver = true;
	      checked = true;
	    }
	  };
	
	  if (checkReverse) {
	    for (var index = oversLen - 1; index >= 0; index--) {
	      var over = overs[index] || {};
	      setLastEndOfOver(over);
	    }
	  } else {
	    for (var _index = 0; _index < oversLen; _index++) {
	      var _over = overs[_index] || {};
	      setLastEndOfOver(_over);
	    }
	  }
	}
	
	function updateVideos() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var copyRightOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  var prevVideos = (0, _selectn2.default)('allVideos', state) || {};
	  var _prevVideos$videos = prevVideos.videos,
	      preVideos = _prevVideos$videos === undefined ? [] : _prevVideos$videos,
	      _prevVideos$page = prevVideos.page,
	      prevPage = _prevVideos$page === undefined ? 1 : _prevVideos$page;
	
	
	  var allVideos = (0, _selectn2.default)('allVideos', data) || {};
	  var _allVideos$videos = allVideos.videos,
	      videos = _allVideos$videos === undefined ? [] : _allVideos$videos,
	      hasMore = allVideos.hasMore;
	
	
	  if (state.country && videos) {
	
	    //check for copyright video for a country and show/hide
	    videos = videos.filter(function (i) {
	      return (0, _common.showCopyrightVideo)(i.ad, copyRightOptions);
	    });
	
	    videos = videos.filter(function (v) {
	      return !(0, _common.isGeoRestricted)(v.geoRestrictions, state.country);
	    });
	  }
	
	  allVideos.videos = preVideos.concat(videos);
	
	  allVideos.page = hasMore ? prevPage + 1 : prevPage;
	
	  return (0, _assign2.default)({}, state, (0, _extends3.default)({}, data));
	}
	
	/**
	 * [updateLecClips update the LEC clips data]
	 * @param  {Object} state [current state]
	 * @param  {Object} data  [data]
	 * @param  {Object} copyRightOptions user's domain, site etc information
	 * @return {Object}       [returns updated data]
	 */
	function updateLecClips() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var copyRightOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  var fullCommentary = (0, _selectn2.default)('fullCommentary', data) || {};
	  var prevLecClips = (0, _selectn2.default)('lecclips', state) || [];
	  var lecclips = (0, _selectn2.default)('lecclips', data) || [];
	  var page = fullCommentary.page;
	
	
	  if (state.country && lecclips) {
	
	    //check for copyright video for a country and show/hide
	    lecclips = lecclips.filter(function (i) {
	      return (0, _common.showCopyrightVideo)(i.ad, copyRightOptions);
	    });
	
	    lecclips = lecclips.filter(function (v) {
	      return !(0, _common.isGeoRestricted)(v.geoRestrictions, state.country);
	    });
	  }
	
	  // page 1 means on load, otherwise concat content to prev state
	  if (page !== 1) {
	    lecclips = prevLecClips.concat(lecclips);
	  }
	
	  data.lecclips = lecclips;
	
	  return (0, _assign2.default)({}, state, (0, _extends3.default)({}, data));
	}
	var filterVideoContent = exports.filterVideoContent = function filterVideoContent() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var country = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var copyRightOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  var gridVideos = (0, _selectn2.default)('allVideos.videos', data) || [];
	  var sliderVideos = (0, _selectn2.default)('videoSlider.videos', data) || [];
	  var articleVideos = (0, _selectn2.default)('videoSlider.articleVideos', data) || [];
	  var highlightVideos = (0, _selectn2.default)('videoSlider.highlightVideos', data) || [];
	  var lecclips = (0, _selectn2.default)('lecclips', data) || [];
	  var rosterVideos = (0, _selectn2.default)('rosterVideos', data) || [];
	  var matchCoverageArticles = [].concat.apply([], (data.matchCoverage || []).map(function (a) {
	    return a.articles;
	  }));
	  var links = data.links || [];
	
	  //check for copyright video for a country and show/hide
	  gridVideos = gridVideos.filter(function (i) {
	    return (0, _common.showCopyrightVideo)(i.ad, copyRightOptions);
	  });
	
	  sliderVideos = sliderVideos.filter(function (i) {
	    return (0, _common.showCopyrightVideo)(i.ad, copyRightOptions);
	  });
	
	  articleVideos = articleVideos.filter(function (i) {
	    return (0, _common.showCopyrightVideo)(i.ad, copyRightOptions);
	  });
	
	  highlightVideos = highlightVideos.filter(function (i) {
	    return (0, _common.showCopyrightVideo)(i.ad, copyRightOptions);
	  });
	
	  lecclips = lecclips.filter(function (i) {
	    return (0, _common.showCopyrightVideo)(i.ad, copyRightOptions);
	  });
	
	  rosterVideos = rosterVideos.filter(function (i) {
	    return (0, _common.showCopyrightVideo)(i.ad, copyRightOptions);
	  });
	  // End
	
	  if (country) {
	    gridVideos = gridVideos.filter(function (v) {
	      return !(0, _common.isGeoRestricted)(v.geoRestrictions, country);
	    });
	    sliderVideos = sliderVideos.filter(function (v) {
	      return !(0, _common.isGeoRestricted)(v.geoRestrictions, country);
	    });
	    articleVideos = articleVideos.filter(function (v) {
	      return !(0, _common.isGeoRestricted)(v.geoRestrictions, country);
	    });
	    highlightVideos = highlightVideos.filter(function (v) {
	      return !(0, _common.isGeoRestricted)(v.geoRestrictions, country);
	    });
	    lecclips = lecclips.filter(function (v) {
	      return !(0, _common.isGeoRestricted)(v.geoRestrictions, country);
	    });
	    rosterVideos = rosterVideos.filter(function (v) {
	      return !(0, _common.isGeoRestricted)(v.geoRestrictions, country);
	    });
	    matchCoverageArticles.forEach(function (a) {
	      if (a.video && (0, _common.isGeoRestricted)(a.video.geoRestrictions, country)) {
	        a.video = undefined;
	      }
	    });
	    // If there are no videos to show, remove video from nav
	    if (!gridVideos.length) {
	      var videoLinkPos = -1;
	      var numLinks = links.length;
	      // Get the position at which video object resides in links array
	      for (var i = 0; i < numLinks; i++) {
	        if (links[i].pageType === 'video') {
	          videoLinkPos = i;
	          //console.info('videoLinkPos', videoLinkPos)
	        }
	      }
	      if (videoLinkPos !== -1) {
	        links.splice(videoLinkPos, 1);
	      }
	    }
	    if (data.allVideos) {
	      data.allVideos.videos = gridVideos;
	    }
	    if (data.videoSlider) {
	      data.videoSlider.videos = sliderVideos.slice(0, 5); // limit slider videos here
	      data.videoSlider.articleVideos = articleVideos.slice(0, 1);
	      data.videoSlider.highlightVideos = highlightVideos;
	    }
	    if (data.lecclips) {
	      data.lecclips = lecclips;
	    }
	    if (data.rosterVideos) {
	      data.rosterVideos = rosterVideos;
	    }
	    if (data.links && data.links.length !== links.length) {
	      data.links = links;
	    }
	
	    filterCommentaryVideos(data.partCommentary, country, copyRightOptions);
	  }
	};
	
	function setLocalTime(date) {
	  var tzOptions = {
	    timeZone: _momentTimezone2.default.tz.guess(),
	    timeFormat: 'hh:mm A'
	  };
	
	  return _dateformat2.default.convertDateTime(date, tzOptions);
	}
	
	function filterEvent() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var isSBUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  var favs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	
	  var favTeams = favs.length ? favs : state.favTeams || [];
	  var topEventBackup = [];
	  var leaguesBackup = [];
	  var topEventLeagues = [];
	  var favLeagues = [];
	  var leagues = [];
	  if (isSBUpdate) {
	    leaguesBackup = data.leagues || [];
	    topEventBackup = data.isToday ? state.topEventBackup : [];
	  } else {
	    leaguesBackup = state.leaguesBackup || [];
	    topEventBackup = data.topEventLeagues || [];
	  }
	
	  if (favTeams.length) {
	    var _extractFavEvents, _extractFavEvents$fav, _extractFavEvents2, _extractFavEvents2$fa;
	
	    var LeaguefavEvents = [];
	    var topFavEvents = [];
	    topEventBackup.length && (_extractFavEvents = extractFavEvents(topEventBackup, favTeams), topEventLeagues = _extractFavEvents.filteredLeagues, _extractFavEvents$fav = _extractFavEvents.favEvents, topFavEvents = _extractFavEvents$fav === undefined ? [] : _extractFavEvents$fav, _extractFavEvents);
	
	    leaguesBackup.length && (_extractFavEvents2 = extractFavEvents(leaguesBackup, favTeams), leagues = _extractFavEvents2.filteredLeagues, _extractFavEvents2$fa = _extractFavEvents2.favEvents, LeaguefavEvents = _extractFavEvents2$fa === undefined ? [] : _extractFavEvents2$fa, _extractFavEvents2);
	    if (LeaguefavEvents.length > 0 || topFavEvents.length > 0) {
	      favLeagues.push({
	        abbreviation: 'Favorites',
	        name: 'Favorites',
	        id: '',
	        seriesHome: '',
	        events: [].concat((0, _toConsumableArray3.default)(topFavEvents), (0, _toConsumableArray3.default)(LeaguefavEvents)),
	        order: 1,
	        isFavorites: true
	      });
	    }
	  } else {
	    topEventLeagues = topEventBackup;
	    leagues = leaguesBackup;
	  }
	  return (0, _assign2.default)({}, state, (0, _extends3.default)({}, data, {
	    favTeams: favTeams,
	    topEventLeagues: topEventLeagues,
	    favLeagues: favLeagues,
	    leagues: leagues,
	    topEventBackup: topEventBackup,
	    leaguesBackup: leaguesBackup,
	    loading: false
	  }));
	}
	
	function extractFavEvents(leagues, favTeams) {
	  var favEvents = [];
	  var filteredLeagues = [];
	  filteredLeagues = leagues.map(function (league) {
	    var _league$events = league.events,
	        events = _league$events === undefined ? [] : _league$events,
	        rest = (0, _objectWithoutProperties3.default)(league, ['events']);
	
	    events = events.filter(function (ev) {
	      var awayId = parseInt((0, _selectn2.default)('teams.away.id', ev) || 0);
	      var homeId = parseInt((0, _selectn2.default)('teams.home.id', ev) || 0);
	      if (favTeams.indexOf(awayId) !== -1 || favTeams.indexOf(homeId) !== -1) {
	        favEvents.push(ev);
	        return false;
	      } else {
	        return true;
	      }
	    });
	    return (0, _extends3.default)({
	      events: events
	    }, rest);
	  });
	  return {
	    filteredLeagues: filteredLeagues,
	    favEvents: favEvents
	  };
	}
	function updateMidColFeed() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var prevArticles = (0, _selectn2.default)('middleColumn', state) || {};
	  var _prevArticles$newsfee = prevArticles.newsfeed,
	      preArticles = _prevArticles$newsfee === undefined ? [] : _prevArticles$newsfee,
	      page = prevArticles.page,
	      resultsCount = prevArticles.resultsCount,
	      excludedCountPrev = prevArticles.excludedCount,
	      geoRestrictedPrev = prevArticles.geoRestricted,
	      prevTotalCount = prevArticles.totalCount;
	
	
	  var allArticles = (0, _selectn2.default)('middleColumn', data) || {};
	  var _allArticles$newsfeed = allArticles.newsfeed,
	      newsfeed = _allArticles$newsfeed === undefined ? [] : _allArticles$newsfeed,
	      excludedCount = allArticles.excludedCount,
	      geoRestricted = allArticles.geoRestricted,
	      totalCount = allArticles.totalCount;
	
	
	  allArticles.newsfeed = preArticles.concat(newsfeed); //merge prev items with new items
	
	  allArticles.hasMore = prevTotalCount + totalCount < resultsCount && totalCount != 0 ? true : false; //decides if there are data remaining to lazy load
	  //below datas are cosmetic
	  allArticles.page = page + 1;
	  allArticles.excludedCount = excludedCount + excludedCountPrev;
	  allArticles.totalCount = totalCount + prevTotalCount;
	  allArticles.geoRestricted = geoRestricted + geoRestrictedPrev;
	  allArticles.resultsCount = resultsCount;
	
	  return (0, _assign2.default)({}, state, (0, _extends3.default)({}, data));
	}
	
	function midColVidGeoFilter() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var country = arguments[1];
	  var prevState = arguments[2];
	
	  var prevStateNewsFeed = (0, _selectn2.default)('middleColumn.newsfeed', prevState);
	  var count = prevStateNewsFeed !== undefined ? prevStateNewsFeed.length : 0;
	  var feed = (0, _selectn2.default)('middleColumn.newsfeed', data) || [];
	  var sport = (0, _selectn2.default)('middleColumn.sport', data) || '';
	
	  var filteredFeed = feed.filter(function (v) {
	    var geoRestricted = (0, _common.isGeoRestricted)((0, _selectn2.default)('video.geoRestrictions', v), country);
	    if (geoRestricted === false) {
	      count = count + 1;
	      v.tracking = _common2.common.createTrackingName([sport, 'TeamClubhouse', count, 'News']);
	    }
	    return !(0, _common.isGeoRestricted)((0, _selectn2.default)('video.geoRestrictions', v), country);
	  });
	
	  data.middleColumn.newsfeed = filteredFeed;
	  data.middleColumn.geoRestricted = feed.length - filteredFeed.length;
	}
	
	function filterBet365() {
	  var bet365 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var country = arguments[1];
	
	  var blacklist = ['AU', 'US', 'PK', 'IN', 'EG', 'IR', 'SA', 'SY', 'AE', 'IL', 'JO', 'PS', 'LB', 'OM', 'KW', 'QA', 'BH', 'YE', 'LK', 'FR', 'FX', 'CL', 'CO', 'AF', 'AS', 'AO', 'AR', 'BH', 'BD', 'BE', 'BO', 'BR', 'BG', 'BI', 'KH', 'CA', 'TD', 'CR', 'CU', 'CD', 'DO', 'EC', 'SV', 'ER', 'FR', 'GF', 'GR', 'GP', 'GT', 'GW', 'HT', 'HN', 'HK', 'ID', 'IQ', 'IT', 'KW', 'LY', 'MY', 'MQ', 'MX', 'MC', 'NL', 'NI', 'OM', 'PK', 'PA', 'PY', 'PE', 'PH', 'PR', 'QA', 'RO', 'BL', 'MF', 'SA', 'SG', 'SO', 'ZA', 'TJ', 'TR', 'TM', 'UY', 'VI', 'UZ', 'VE', 'YE', 'ZW', 'NZ', 'WW', 'UNKNOWN'];
	
	  // apply geo filtering if bet365 set to show in edition
	  if (bet365.showInEdition === true) {
	    // compute future if valid country code is available else ignore since bet365 is blacklisted by default
	    if (typeof country === 'string' && country !== '') {
	      country = country.toUpperCase();
	
	      // show bet365 if country is not blacklisted
	      if (blacklist.indexOf(country) == -1) {
	        bet365.showInGeo = true;
	      }
	    }
	  }
	}
	
	function updateNavLinks(navNode, navLinks) {
	  var linkMap = {
	    'home': 'homeLink',
	    'fixtures': 'fixturesLink',
	    'results': 'resultsLink',
	    'players': 'playersLink',
	    'stats': 'statsLink',
	    'videos': 'videosLink',
	    'table': 'tableLink',
	    'squads': 'squadsLink',
	    'seasons': 'seasonsLink'
	  };
	
	  var navigation = (0, _selectn2.default)('subNavMenu.navigation', navNode);
	  var items = navigation.items || [];
	
	  var homeLink = navLinks['homeLink'];
	
	  if (homeLink) {
	    navigation.links[0].href = homeLink;
	    navigation.links[0].text = navLinks.name;
	  }
	
	  items.map(function () {
	    var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var itemLink = item.links[0] || {};
	    var attrText = (0, _selectn2.default)('attributes.text', itemLink) || '';
	
	    if (attrText && typeof attrText === 'string') {
	      attrText = attrText.trim().toLowerCase();
	
	      var linkKey = linkMap[attrText];
	
	      itemLink.href = navLinks[linkKey] || '#';
	      itemLink.text = itemLink.shortText || '';
	    }
	  });
	}
	
	/**
	 * Update the article
	 *
	 * @param {Object} article      existing article
	 * @param {Object} articleNew   new article
	 * @param {Object} pageType     pagetype
	 * @param {Boolean} isFastcast  flag to identify if fastcast update
	 * @returns {Object}            updated article
	 */
	function updateArticle() {
	  var article = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var articleNew = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var pageType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	  var isFastcast = arguments[3];
	  var _article = article,
	      id = _article.id,
	      _article$html = _article.html,
	      html = _article$html === undefined ? '' : _article$html;
	  var idNew = articleNew.id,
	      _articleNew$type = articleNew.type,
	      typeNew = _articleNew$type === undefined ? '' : _articleNew$type,
	      htmlNew = articleNew.html;
	
	
	  if (typeNew && typeof typeNew === 'string') {
	    typeNew = typeNew.toLowerCase();
	
	    typeNew = typeNew === 'recap' ? 'report' : typeNew;
	  }
	
	  // on initial load
	  if (!id) {
	    return articleNew;
	  } else if (!idNew) {
	    // retain article html if id is null or not changed instead of showing empty page
	    return article;
	  } else if (idNew == id) {
	    // check if state don't have valid content then take from action data 
	    if (typeof html === 'undefined' || html.trim().length === 0) {
	      article = (0, _assign2.default)({}, article, articleNew);
	    }
	
	    return article;
	  } else if (pageType === 'game' || typeNew === pageType) {
	    // if current tab is summary tab or if the article is different and matches current pageType (report tab of day1, day2, etc.)
	
	    // if no html content retain existing article (hack for empty article in fascast update)
	    if (typeof htmlNew === 'undefined' && isFastcast === true) {
	      return article;
	    }
	
	    return articleNew;
	  } else {
	    // if the article is different but different from current pageType retain the existing article (hack for empty article in fascast update)
	    return article;
	  }
	}
	/**
	 * update gamestrip time for prematch games based on user timezone
	 * @param {String} isoDate isodate from gamestrip
	 * @param {string} sport sport from action
	 * @param {Boolean} timeValid timeValid
	 * @returns {Object}           date and time
	 */
	function updateGameStrip(isoDate) {
	  var sport = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'cricket';
	  var timeValid = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  var timezone = _dateformat2.default.getLocalTimezone();
	  var date = _dateformat2.default.dateFormat(isoDate, 'DD/MM', timezone);
	  var time = _dateformat2.default.dateFormat(isoDate, 'h:mm A z', timezone);
	  var dateTimeFormat = 'DD/MM - hh:mm A z';
	  if (sport == 'cricket') {
	    date = timeValid ? _dateformat2.default.dateFormat(isoDate, dateTimeFormat, timezone) : '';
	    time = '';
	  }
	  return { date: date, time: time };
	}
	
	function getNoContentText(pageType, edition) {
	  return _common2.common.getNoContentText(pageType, edition);
	}
	
	exports.default = {
	  filterVideoContent: filterVideoContent,
	  updateCommentary: updateCommentary,
	  updateVideos: updateVideos,
	  setLocalTime: setLocalTime,
	  updateMidColFeed: updateMidColFeed,
	  midColVidGeoFilter: midColVidGeoFilter,
	  filterBet365: filterBet365,
	  updateNavLinks: updateNavLinks,
	  updateArticle: updateArticle,
	  updateGameStrip: updateGameStrip,
	  checkLastEndOfOver: checkLastEndOfOver,
	  getNoContentText: getNoContentText
	};

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(435);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _assign = __webpack_require__(365);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _promise = __webpack_require__(370);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	exports.getArticleTab = getArticleTab;
	exports.getCommentaryTab = getCommentaryTab;
	exports.getPlayByPlay = getPlayByPlay;
	exports.getPlayByPlayMore = getPlayByPlayMore;
	exports.dispatchPlayByPlay = dispatchPlayByPlay;
	exports.getStandings = getStandings;
	
	var _selectn = __webpack_require__(438);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	var _lib = __webpack_require__(392);
	
	var _actionTypes = __webpack_require__(417);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _transform = __webpack_require__(806);
	
	var transform = _interopRequireWildcard(_transform);
	
	var _index = __webpack_require__(369);
	
	var _utils = __webpack_require__(857);
	
	var _queryString = __webpack_require__(207);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * get the pre-rendered Preview/Report HTML for injectino into Preview / Report tab
	 * @param  {Object} edition     edition config
	 * @param  {Object} params      router params
	 * @param  {Object} location    router location
	 * @param  {Boolean} isPolling  isPolling
	 * @return {Function}           handled by thunk middleware
	 */
	function getArticleTab(_ref) {
	  var _ref$edition = _ref.edition,
	      edition = _ref$edition === undefined ? {} : _ref$edition,
	      _ref$params = _ref.params,
	      params = _ref$params === undefined ? {} : _ref$params,
	      _ref$location = _ref.location,
	      location = _ref$location === undefined ? {} : _ref$location,
	      isPolling = _ref.isPolling,
	      appProps = _ref.appProps;
	
	  return function (dispatch, getState) {
	    return new _promise2.default(function (resolve) {
	      var gamepackage = (0, _index.getGameSummary)({ edition: edition, params: params, location: location, isPolling: isPolling, appProps: appProps });
	      var promise = gamepackage.promise;
	
	
	      dispatch((0, _index.apiReqStart)(isPolling));
	
	      promise.then(function (res) {
	
	        dispatch({
	          params: params,
	          edition: edition,
	          location: location,
	          url: gamepackage.url,
	          type: gamepackage.type,
	          data: gamepackage.transform({ res: res, edition: edition, params: params, location: location, appProps: appProps })
	        });
	
	        var state = getState();
	        var sCoreHost = (0, _index.getHost)('score');
	        var article = (0, _selectn2.default)('gamePackage.article', state) || {};
	
	        var articleId = article.id;
	        var articleType = article.type || '';
	        var html = article.html || '';
	
	        var requiredPageTypes = {
	          Recap: 'report',
	          Preview: 'preview'
	        };
	
	        if (params.pageType !== requiredPageTypes[articleType]) {
	          articleId = undefined;
	        }
	
	        if (params.day || !articleId) {
	          var matchCoveragePreviewReport = [].concat.apply([], ((0, _selectn2.default)('gamePackage.matchCoverage', state) || []).map(function (a) {
	            return a.articles;
	          })).find(function (a) {
	            return requiredPageTypes[a.type] === params.pageType && (parseInt(params.day, 10) === parseInt(a.gameDay, 10) || !articleId);
	          });
	          if (matchCoveragePreviewReport) {
	            articleId = matchCoveragePreviewReport.id;
	            html = '';
	          }
	        }
	
	        // If there is no article id or if html is already present,
	        // resolve and return
	        if (!articleId || html.length) {
	          dispatch((0, _index.apiReqComplete)());
	          resolve(false);
	          return;
	        }
	
	        var qsObj = {
	          'edition-host': edition.host,
	          render: true,
	          partial: 'article',
	          tabtype: params.pageType,
	          xhr: 1,
	          country: edition.userGeo
	        };
	
	        if (edition.isEspnCricinfo) {
	          qsObj.site = edition.site;
	        }
	
	        if (params.platform) {
	          qsObj.platform = params.platform;
	        }
	        if (appProps.siteType === 'data-lite') {
	          qsObj.connectionspeed = appProps.siteType;
	        }
	
	        var url = (params.origin || sCoreHost) + '/story/_/id/' + articleId + (0, _index.getQueryString)(qsObj, edition, params);
	
	        var articlePromise = _lib.memoizr.get(url);
	
	        articlePromise.then(function (article) {
	          dispatch((0, _index.apiReqComplete)());
	          var htmlRaw = (0, _selectn2.default)('data.content.html', article);
	          var type = (0, _selectn2.default)('data.content.type', article);
	          dispatch({
	            url: url,
	            edition: edition,
	            location: location,
	            params: params,
	            data: {
	              article: {
	                id: articleId,
	                type: type,
	                html: htmlRaw.replace('</script>', '<\\/script>')
	              }
	            },
	            type: _actionTypes2.default.GET_RENDERED_ARTICLE
	          });
	          resolve(true);
	        });
	      }).catch(function (e) {
	        dispatch((0, _index.apiReqComplete)());
	        resolve(true);
	        console.error(e);
	      });
	    });
	  };
	}
	
	function getCommentaryTab(_ref2) {
	  var _ref2$edition = _ref2.edition,
	      edition = _ref2$edition === undefined ? {} : _ref2$edition,
	      _ref2$params = _ref2.params,
	      params = _ref2$params === undefined ? {} : _ref2$params,
	      _ref2$location = _ref2.location,
	      location = _ref2$location === undefined ? {} : _ref2$location,
	      isPolling = _ref2.isPolling,
	      appProps = _ref2.appProps;
	
	  return function (dispatch, getState) {
	    return new _promise2.default(function (resolve, reject) {
	      // parse 'query' object from location.search when not available on server side
	      if (typeof location.query === 'undefined') {
	        location = (0, _assign2.default)({}, location, {
	          query: _queryString2.default.parse(location.search)
	        });
	      }
	
	      dispatch((0, _index.apiReqStart)(isPolling));
	
	      var gamepackage = (0, _index.getGameSummary)({ edition: edition, params: params, location: location, isPolling: isPolling, appProps: appProps });
	
	      var promise = gamepackage.promise;
	
	
	      promise.then(function (res) {
	
	        dispatch({
	          params: params,
	          edition: edition,
	          location: location,
	          url: gamepackage.url,
	          type: gamepackage.type,
	          data: gamepackage.transform({ res: res, edition: edition, params: params, location: location, appProps: appProps })
	        });
	
	        var state = getState();
	        var filter = (0, _selectn2.default)('gamePackage.selCmtryFilter.playtype', state);
	        var innings = (0, _selectn2.default)('gamePackage.selInnings.period', state);
	        var commentaryArgs = { dispatch: dispatch, state: state, edition: edition, params: params, location: location, isPolling: isPolling, resolve: resolve, appProps: appProps };
	        var _location = location,
	            _location$query = _location.query,
	            query = _location$query === undefined ? {} : _location$query;
	
	        var queryModified = (0, _assign2.default)({}, query, {
	          innings: innings,
	          filter: filter
	        });
	
	        var locationModified = (0, _assign2.default)({}, location, { query: queryModified });
	
	        if (!isPolling) {
	          // make dummy request to get the page count of commentary
	          var commentary = getPlayByPlay({ edition: edition, params: params, location: locationModified });
	
	          commentary.promise.then(function (res) {
	            var pageCount = (0, _selectn2.default)('data.commentary.pageCount', res);
	            commentaryArgs.page = pageCount;
	            dispatchPlayByPlay(commentaryArgs);
	          });
	        } else {
	          dispatchPlayByPlay(commentaryArgs);
	        }
	      }).catch(function (e) {
	        reject(e);
	        console.error(e);
	      });
	    });
	  };
	}
	
	function getPlayByPlay(_ref3) {
	  var _ref3$edition = _ref3.edition,
	      edition = _ref3$edition === undefined ? {} : _ref3$edition,
	      _ref3$params = _ref3.params,
	      params = _ref3$params === undefined ? {} : _ref3$params,
	      _ref3$location = _ref3.location,
	      location = _ref3$location === undefined ? {} : _ref3$location,
	      page = _ref3.page,
	      isPolling = _ref3.isPolling,
	      appProps = _ref3.appProps;
	  var _location$query2 = location.query,
	      query = _location$query2 === undefined ? {} : _location$query2;
	
	  var host = (0, _index.getHost)('site', '', appProps);
	  var innings = query.innings,
	      filter = query.filter;
	
	  var qsObj = {
	    event: 951333,
	    contentorigin: 'espn'
	  };
	
	  if (params.gameId) {
	    qsObj.event = params.gameId;
	  }
	
	  if (/^superover$/ig.test(innings) === true) {
	    qsObj.sort = 'overs:asc';
	    qsObj.tiebreaker = true;
	  } else {
	    // Check if commentary needs to be fetched for a particular innings
	    if (innings) {
	      var period = parseInt(innings, 10) || 1;
	      if ([1, 2, 3, 4].indexOf(period) > -1) {
	        qsObj.period = period;
	      }
	    }
	
	    if (filter && filter.toUpperCase() !== 'FULL') {
	      qsObj.playtype = filter;
	    }
	
	    qsObj.page = page;
	  }
	
	  var url = (params.origin || host) + '/apis/site/v2/sports/' + params.sport + '/' + params.league + '/playbyplay' + (0, _index.getQueryString)(qsObj, edition, params, true);
	  return {
	    url: url,
	    edition: edition,
	    params: params,
	    location: location,
	    isPolling: isPolling,
	    type: _actionTypes2.default.GET_PLAY_BY_PLAY,
	    promise: _lib.memoizr.get(url),
	    transform: transform.onGetPlayByPlay
	  };
	}
	
	/**
	 * get the commentary in next page
	 * @param  {Object} edition     edition config
	 * @param  {Object} params      router params
	 * @param  {Object} location    router location
	 * @param  {Number} page        next page number to be loaded
	 * @return {Function}           handled by thunk middleware
	 */
	function getPlayByPlayMore(_ref4) {
	  var _ref4$edition = _ref4.edition,
	      edition = _ref4$edition === undefined ? {} : _ref4$edition,
	      _ref4$params = _ref4.params,
	      params = _ref4$params === undefined ? {} : _ref4$params,
	      _ref4$location = _ref4.location,
	      location = _ref4$location === undefined ? {} : _ref4$location,
	      page = _ref4.page,
	      isPolling = _ref4.isPolling,
	      appProps = _ref4.appProps;
	
	  /*
	   * Thunk middleware calls this function
	   * with dispatch and getState method pointers of Store
	   */
	  return function (dispatch, getState) {
	    return new _promise2.default(function (resolve) {
	      dispatchPlayByPlay({ dispatch: dispatch, state: getState(), edition: edition, params: params, location: location, page: page, resolve: resolve, isPolling: isPolling, appProps: appProps });
	    });
	  };
	}
	
	function dispatchPlayByPlay(_ref5) {
	  var dispatch = _ref5.dispatch,
	      _ref5$state = _ref5.state,
	      state = _ref5$state === undefined ? {} : _ref5$state,
	      _ref5$edition = _ref5.edition,
	      edition = _ref5$edition === undefined ? {} : _ref5$edition,
	      _ref5$params = _ref5.params,
	      params = _ref5$params === undefined ? {} : _ref5$params,
	      _ref5$location = _ref5.location,
	      location = _ref5$location === undefined ? {} : _ref5$location,
	      page = _ref5.page,
	      resolve = _ref5.resolve,
	      _ref5$isPolling = _ref5.isPolling,
	      isPolling = _ref5$isPolling === undefined ? false : _ref5$isPolling,
	      appProps = _ref5.appProps;
	  var _state$gamePackage = state.gamePackage,
	      gamePackage = _state$gamePackage === undefined ? {} : _state$gamePackage;
	  var _gamePackage$selInnin = gamePackage.selInnings,
	      selInnings = _gamePackage$selInnin === undefined ? {} : _gamePackage$selInnin,
	      _gamePackage$selCmtry = gamePackage.selCmtryFilter,
	      selCmtryFilter = _gamePackage$selCmtry === undefined ? {} : _gamePackage$selCmtry,
	      _gamePackage$fullComm = gamePackage.fullCommentary,
	      fullCommentary = _gamePackage$fullComm === undefined ? {} : _gamePackage$fullComm;
	  var _location$query3 = location.query,
	      query = _location$query3 === undefined ? {} : _location$query3;
	  var pageCount = fullCommentary.pageCount;
	
	  // no commentary polling if selected innings is not current innings
	
	  if (isPolling === true && selInnings.isCurrent === false) {
	    dispatch({ type: null });
	  }
	  var innings = query.innings || selInnings.period || '';
	  var filter = query.filter || selCmtryFilter.playtype || '';
	
	  var queryModified = (0, _assign2.default)({}, query, {
	    innings: innings,
	    filter: filter
	  });
	
	  var locationModified = (0, _assign2.default)({}, location, { query: queryModified });
	
	  // poll the latest page
	  if (isPolling === true) {
	    page = pageCount;
	
	    if (fullCommentary.commSwitch === true) {
	      page = 1;
	    }
	  }
	
	  // do nothing if no page number available
	  if (!page) {
	    dispatch({ type: null });
	  }
	
	  var commentary = getPlayByPlay({ edition: edition, params: params, location: locationModified, page: page, isPolling: isPolling, appProps: appProps });
	  commentary.promise.then(function (commentary_res) {
	
	    dispatch((0, _index.apiReqComplete)());
	
	    dispatch({
	      edition: edition,
	      params: params,
	      url: commentary.url,
	      location: locationModified,
	      isPolling: isPolling,
	      data: commentary.transform({ res: commentary_res, edition: edition, params: params, location: locationModified }),
	      type: commentary.type
	    });
	
	    resolve(true);
	  }).catch(function (e) {
	    dispatch((0, _index.apiReqComplete)());
	    // Since we dispatch apiReqComplete above, assuming we try to gracefully handle errors and let the page load?
	    // Hence resolve instead of reject.
	    // This prevents invalid URLs like /cricket/series/0/report/0 from holding up the request and going forver.
	    resolve(true);
	    console.error(e);
	  });
	}
	
	/**
	 * An Example of calling multiple APIs
	 * in series having dependencies
	 * @param  {Object} edition     edition config
	 * @param  {Object} params      Params
	 * @param  {Object} location    router location
	 * @return {Function}           Handled by thunk middleware
	 */
	function getStandings(_ref6) {
	  var _ref6$edition = _ref6.edition,
	      edition = _ref6$edition === undefined ? {} : _ref6$edition,
	      _ref6$params = _ref6.params,
	      params = _ref6$params === undefined ? {} : _ref6$params,
	      _ref6$location = _ref6.location,
	      location = _ref6$location === undefined ? {} : _ref6$location,
	      appProps = _ref6.appProps;
	
	  return function (dispatch, getState) {
	    return new _promise2.default(function (resolve) {
	
	      var leaguesAction = (0, _index.getLeagues)({ edition: edition, params: params, appProps: appProps });
	      var leaguesPromise = leaguesAction.promise,
	          leaguesUrl = leaguesAction.url;
	
	
	      leaguesPromise.then(function (res) {
	        var leagues = (0, _selectn2.default)('data.leagues', res) || [];
	        var defaultLeagueId = void 0;
	
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(leagues), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var league = _step.value;
	
	            if (league.hasStandings === true) {
	              defaultLeagueId = league.id;
	              break;
	            }
	          }
	
	          // TODO: error check
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        return {
	          data: res.data,
	          id: params.league || defaultLeagueId
	        };
	      }).then(function (res) {
	        var routeParams = (0, _assign2.default)({}, params, {
	          league: res.id
	        });
	
	        dispatch({
	          edition: edition,
	          location: location,
	          params: routeParams,
	          url: leaguesUrl,
	          data: transform.onGetLeagues(res, edition, routeParams, location),
	          type: _actionTypes2.default.GET_LEAGUES
	        });
	
	        routeParams.slug = (0, _selectn2.default)('leagues.currentLeague.slug', getState());
	
	        var standingsAction = (0, _index.getStandings)({ edition: edition, routeParams: routeParams });
	        var standingsPromise = standingsAction.promise,
	            standingsUrl = standingsAction.url;
	
	
	        standingsPromise.then(function (res) {
	
	          dispatch({
	            edition: edition,
	            location: location,
	            params: routeParams,
	            url: standingsUrl,
	            data: transform.onGetStandings({ res: res, edition: edition, routeParams: routeParams, location: location }),
	            type: _actionTypes2.default.GET_STANDINGS
	          });
	          // Resolve promise once the standings api has finished loading
	          resolve(true);
	        }).catch(function () {
	          dispatch((0, _utils.getErrorRedirect)(params));
	        });
	      });
	    });
	  };
	}
	
	exports.default = {
	  getPlayByPlay: getPlayByPlay,
	  getPlayByPlayMore: getPlayByPlayMore,
	  getCommentaryTab: getCommentaryTab,
	  getStandings: getStandings
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getErrorRedirect = getErrorRedirect;
	exports.setDeviceType = setDeviceType;
	exports.bindRouterPush = bindRouterPush;
	exports.updateCommentaryFbStatus = updateCommentaryFbStatus;
	exports.commentaryFbInprogress = commentaryFbInprogress;
	exports.commentaryFbSuccess = commentaryFbSuccess;
	exports.commentaryFbError = commentaryFbError;
	exports.postCommentryFeedback = postCommentryFeedback;
	exports.resetScoreboard = resetScoreboard;
	exports.resetGamePackage = resetGamePackage;
	
	var _actionTypes = __webpack_require__(417);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _reactRouterRedux = __webpack_require__(858);
	
	var _redux = __webpack_require__(256);
	
	var _rugby = __webpack_require__(840);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * generate a location replace action
	 * @param  {Object} params - router params
	 * @return {Object}        - location replace action
	 */
	/* global jQuery */
	function getErrorRedirect(params) {
	  var sport = params.sport,
	      pageType = params.pageType;
	  // default to home page
	
	  var redirectPath = '/';
	
	  // respective sport page
	  if (typeof sport === 'string') {
	    redirectPath = '/' + sport + '/';
	
	    // respective section page
	    if (typeof pageType === 'string') {
	      redirectPath += pageType + '/';
	    }
	  }
	
	  return (0, _reactRouterRedux.replace)(redirectPath);
	}
	
	/**
	 * set the device type
	 * @param {Number} currentWidth - current width of the device
	 * @return {Object} action
	 */
	function setDeviceType(currentWidth) {
	  return {
	    type: _actionTypes2.default.SET_DEVICE_TYPE,
	    currentWidth: currentWidth
	  };
	}
	
	function bindRouterPush(dispatch) {
	  return (0, _redux.bindActionCreators)(_reactRouterRedux.push, dispatch);
	}
	
	function updateCommentaryFbStatus(status) {
	  return {
	    type: _actionTypes2.default.COMM_FB_STATUS,
	    status: status
	  };
	}
	
	function commentaryFbInprogress() {
	  return updateCommentaryFbStatus('SUBMITTING');
	}
	
	function commentaryFbSuccess() {
	  return updateCommentaryFbStatus('SUCCESS');
	}
	
	function commentaryFbError() {
	  return updateCommentaryFbStatus('ERROR');
	}
	
	function postCommentryFeedback(data) {
	  return function (dispatch) {
	    try {
	      dispatch(commentaryFbInprogress());
	      jQuery.ajax({
	        url: '//submit.espncricinfo.com/ci/content/submit/forms/commentary_feedback_jsonp.json',
	        jsonp: 'callback',
	        dataType: 'jsonp',
	        data: data,
	        success: function success() {
	          dispatch(commentaryFbSuccess());
	        }
	      });
	    } catch (err) {
	      dispatch(commentaryFbError());
	    }
	  };
	}
	
	function resetScoreboard() {
	  return {
	    type: _actionTypes2.default.RESET_SCOREBOARD
	  };
	}
	
	function resetGamePackage() {
	  return {
	    type: _actionTypes2.default.RESET_GAMEPACKAGE
	  };
	}

/***/ }),
/* 858 */
/***/ (function(module, exports) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routeReducer = routeReducer;
	exports.syncHistory = syncHistory;
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// Constants
	
	var TRANSITION = exports.TRANSITION = '@@router/TRANSITION';
	var UPDATE_LOCATION = exports.UPDATE_LOCATION = '@@router/UPDATE_LOCATION';
	
	var SELECT_LOCATION = function SELECT_LOCATION(state) {
	  return state.routing.location;
	};
	
	function transition(method) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return {
	      type: TRANSITION,
	      payload: { method: method, args: args }
	    };
	  };
	}
	
	var push = exports.push = transition('push');
	var replace = exports.replace = transition('replace');
	var go = exports.go = transition('go');
	var goBack = exports.goBack = transition('goBack');
	var goForward = exports.goForward = transition('goForward');
	
	var routeActions = exports.routeActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };
	
	function updateLocation(location) {
	  return {
	    type: UPDATE_LOCATION,
	    payload: location
	  };
	}
	
	// Reducer
	
	var initialState = {
	  location: undefined
	};
	
	function routeReducer() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	  var _ref = arguments[1];
	  var type = _ref.type;
	  var location = _ref.payload;
	
	  if (type !== UPDATE_LOCATION) {
	    return state;
	  }
	
	  return _extends({}, state, { location: location });
	}
	
	// Syncing
	
	function syncHistory(history) {
	  var unsubscribeHistory = undefined,
	      currentKey = undefined,
	      unsubscribeStore = undefined;
	  var connected = false,
	      syncing = false;
	
	  history.listen(function (location) {
	    initialState.location = location;
	  })();
	
	  function middleware(store) {
	    unsubscribeHistory = history.listen(function (location) {
	      currentKey = location.key;
	      if (syncing) {
	        // Don't dispatch a new action if we're replaying location.
	        return;
	      }
	
	      store.dispatch(updateLocation(location));
	    });
	
	    connected = true;
	
	    return function (next) {
	      return function (action) {
	        if (action.type !== TRANSITION || !connected) {
	          return next(action);
	        }
	
	        var _action$payload = action.payload;
	        var method = _action$payload.method;
	        var args = _action$payload.args;
	
	        history[method].apply(history, _toConsumableArray(args));
	      };
	    };
	  }
	
	  middleware.listenForReplays = function (store) {
	    var selectLocationState = arguments.length <= 1 || arguments[1] === undefined ? SELECT_LOCATION : arguments[1];
	
	    var getLocationState = function getLocationState() {
	      return selectLocationState(store.getState());
	    };
	    var initialLocation = getLocationState();
	
	    unsubscribeStore = store.subscribe(function () {
	      var location = getLocationState();
	
	      // If we're resetting to the beginning, use the saved initial value. We
	      // need to dispatch a new action at this point to populate the store
	      // appropriately.
	      if (location.key === initialLocation.key) {
	        history.replace(initialLocation);
	        return;
	      }
	
	      // Otherwise, if we need to update the history location, do so without
	      // dispatching a new action, as we're just bringing history in sync
	      // with the store.
	      if (location.key !== currentKey) {
	        syncing = true;
	        history.transitionTo(location);
	        syncing = false;
	      }
	    });
	  };
	
	  middleware.unsubscribe = function () {
	    unsubscribeHistory();
	    if (unsubscribeStore) {
	      unsubscribeStore();
	    }
	
	    connected = false;
	  };
	
	  return middleware;
	}


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(370);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _assign = __webpack_require__(365);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getIterator2 = __webpack_require__(435);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.default = getStandingsPage;
	
	var _lib = __webpack_require__(392);
	
	var _transform = __webpack_require__(806);
	
	var transform = _interopRequireWildcard(_transform);
	
	var _actionTypes = __webpack_require__(417);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _index = __webpack_require__(369);
	
	var _config = __webpack_require__(853);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _selectn = __webpack_require__(438);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Gets the first league from the league api if no league supplied in URL
	 *
	 * @param  {Object}   params      Router params
	 * @param  {Object}   res     Complete API return value
	 * @return {Object}               Action
	 **/
	function getLeagueId() {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var res = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	  var leagueId = params.league || '';
	
	  if (!leagueId) {
	    var leagues = (0, _selectn2.default)('data.leagues', res) || [];
	
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = (0, _getIterator3.default)(leagues), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var league = _step.value;
	
	        if (league.hasStandings === true) {
	          if (params.sport === 'cricket') {
	            leagueId = league.id || '';
	          } else {
	            leagueId = league.midsizeName || '';
	          }
	          break;
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  }
	
	  return leagueId.toLowerCase() || '';
	}
	
	/**
	 * action to get standings
	 *
	 * @param  {Object}   edition     Edition config
	 * @param  {Object}   params      Router params
	 * @param  {Object}   location    Router location
	 * @param  {Object}   config    Config values
	 * @return {Object}               Action
	 **/
	function getStandings(_ref) {
	  var _ref$edition = _ref.edition,
	      edition = _ref$edition === undefined ? {} : _ref$edition,
	      _ref$params = _ref.params,
	      params = _ref$params === undefined ? {} : _ref$params,
	      _ref$location = _ref.location,
	      location = _ref$location === undefined ? {} : _ref$location,
	      _ref$config = _ref.config,
	      config = _ref$config === undefined ? { parameters: {} } : _ref$config,
	      appProps = _ref.appProps;
	
	
	  var queryObject = {
	    sort: config.parameters.sort && config.parameters.sort + ':' + (config.parameters.dir || 'asc') || false,
	    seasontype: config.parameters.seasontype || 1,
	    type: 0
	  };
	
	  if (params.season) {
	    queryObject.season = params.season;
	  }
	
	  var url = (params.origin || (0, _index.getHost)('site', '', appProps)) + '/apis/v2/sports/' + params.sport + '/' + params.league + '/standings' + (0, _index.getQueryString)(queryObject, edition, params);
	
	  return {
	    url: url,
	    edition: edition,
	    location: location,
	    params: params,
	    type: _actionTypes2.default.GET_STANDINGS,
	    promise: _lib.memoizr.get(url),
	    transform: transform.onGetStandings
	  };
	}
	
	/**
	 * An Example of calling multiple APIs
	 * in series having dependencies
	 *
	 * @param  {Object}   edition     Edition config
	 * @param  {Object}   params      Params
	 * @param  {Object}   location    Router location
	 * @return {Function}             Handled by thunk middleware
	 **/
	function getStandingsPage(_ref2) {
	  var _ref2$edition = _ref2.edition,
	      edition = _ref2$edition === undefined ? {} : _ref2$edition,
	      _ref2$params = _ref2.params,
	      params = _ref2$params === undefined ? {} : _ref2$params,
	      _ref2$location = _ref2.location,
	      location = _ref2$location === undefined ? {} : _ref2$location,
	      _ref2$appProps = _ref2.appProps,
	      appProps = _ref2$appProps === undefined ? {} : _ref2$appProps;
	
	
	  //console.log('fetching standings page')
	
	  /* load in the config for standings */
	  var config = _config2.default.get({
	    sport: params.sport,
	    root: params.sport,
	    page: params.pageType,
	    params: params
	  });
	
	  /* copy params so we can overwrite league id */
	  var routeParams = (0, _assign2.default)({}, params);
	  var leagueResults = {};
	  var standingsResults = {};
	  var leaguesAction = void 0;
	  var standingsAction = void 0;
	
	  return function (dispatch) {
	
	    var loadLeagueList = function loadLeagueList() {
	
	      //console.log('fetching league list')
	
	      leaguesAction = (0, _index.getLeagues)({ edition: edition, params: routeParams, location: location, appProps: appProps });
	
	      return leaguesAction.promise.then(function (res) {
	
	        //console.log('fetched league list')
	
	        routeParams.league = getLeagueId(routeParams, res);
	
	        leagueResults = res || {};
	
	        return res;
	      });
	    };
	
	    var loadStandings = function loadStandings() {
	
	      //console.log('fetching standings')
	
	      standingsAction = getStandings({ edition: edition, params: routeParams, location: location, config: config, appProps: appProps });
	
	      return standingsAction.promise.then(function (res) {
	
	        //console.log('fetched standings')
	
	        standingsResults = res || {};
	
	        return res;
	      });
	    };
	
	    var dispatchResult = function dispatchResult() {
	      var url = [leaguesAction.url, standingsAction.url];
	      dispatch({
	        data: transform.onGetStandings({ res: standingsResults, leagueRes: leagueResults, edition: edition, params: routeParams, location: location, appProps: appProps }),
	        type: _actionTypes2.default.GET_STANDINGS,
	        url: url
	      });
	    };
	
	    var standingsFailure = function standingsFailure(error) {
	      console.log(error);
	      //dispatch( getErrorRedirect( routeParams ) )
	    };
	
	    if (config.showLeagueDropdown) {
	      if (!routeParams.league) {
	        return loadLeagueList().then(loadStandings).then(dispatchResult).catch(standingsFailure);
	      } else {
	        return _promise2.default.all([loadStandings(), loadLeagueList()]).then(dispatchResult).catch(standingsFailure);
	      }
	    }
	
	    return loadStandings().then(dispatchResult).catch(standingsFailure);
	  };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(370);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _assign = __webpack_require__(365);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.default = getSchedule;
	
	var _transform = __webpack_require__(806);
	
	var transform = _interopRequireWildcard(_transform);
	
	var _actionTypes = __webpack_require__(417);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _index = __webpack_require__(369);
	
	var _selectn = __webpack_require__(438);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	var _dateformat = __webpack_require__(449);
	
	var _dateformat2 = _interopRequireDefault(_dateformat);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DAY_IN_MILLISECONDS = 86400000; // 1 day in milliseconds
	
	function getAltDates() {
	  var minRange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	  var scoreboardRes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	  var calendar = (0, _selectn2.default)('data.leagues[0].calendar', scoreboardRes) || [];
	  var calLen = calendar.length || 0;
	  var maxRange = minRange + DAY_IN_MILLISECONDS * 6;
	  var altDates = [];
	
	  for (var i = 0; i < calLen; i++) {
	    var dateObj = _dateformat2.default.dateToObject(calendar[i]) || new Date();
	    var epochTime = dateObj.setHours(0, 0, 0, 0);
	    if (epochTime >= minRange && epochTime < maxRange) {
	      altDates.push(_dateformat2.default.dateToKey(epochTime));
	    }
	  }
	  return altDates;
	}
	
	function getDisplayDate() {
	  var paramDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var scoreboardRes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	  var calendar = (0, _selectn2.default)('data.leagues[0].calendar', scoreboardRes) || [];
	  var calLen = calendar.length || 0;
	  var dataDate = getDate(paramDate, (0, _selectn2.default)('data', scoreboardRes));
	
	  /* now search calendar for first date >= this */
	  for (var i = 0; i < calLen; i++) {
	    var loopDateObj = _dateformat2.default.dateToObject(calendar[i]) || new Date();
	    var epochTime = loopDateObj.setHours(0, 0, 0, 0);
	    if (epochTime >= dataDate) {
	      dataDate = epochTime;
	      break;
	    }
	  }
	
	  return dataDate;
	}
	
	function getDate() {
	  var paramDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var scoreboardRes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (paramDate) {
	    return getParamDate(paramDate);
	  }
	  return getDataDate(scoreboardRes);
	}
	
	function getParamDate() {
	  var paramDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	  var dateObj = _dateformat2.default.paramToDate(paramDate) || new Date();
	  return dateObj.setHours(0, 0, 0, 0);
	}
	
	function getDataDate() {
	  var scoreboardRes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var dateStr = (0, _selectn2.default)('day.date', scoreboardRes) || (0, _selectn2.default)('events[0].date', scoreboardRes) || '';
	  if (!dateStr) {
	    var d = new Date();
	    dateStr = d.toISOString();
	  }
	  var dateObj = _dateformat2.default.dateToObject(dateStr) || new Date();
	  return dateObj.setHours(0, 0, 0, 0);
	}
	
	function getDefaultDate() {
	  var dateObj = new Date();
	  return dateObj.setHours(0, 0, 0, 0);
	}
	
	function epochToISO(epoch) {
	  var dateObj = new Date(epoch);
	  return dateObj.toISOString();
	}
	
	/**
	 * An Example of calling multiple APIs
	 * in series having dependencies
	 *
	 * @param  {Object}   edition     Edition config
	 * @param  {Object}   params      Params
	 * @param  {Object}   location    Router location
	 * @return {Function}             Handled by thunk middleware
	 **/
	function getSchedule(_ref) {
	  var _ref$edition = _ref.edition,
	      edition = _ref$edition === undefined ? {} : _ref$edition,
	      _ref$params = _ref.params,
	      params = _ref$params === undefined ? {} : _ref$params,
	      _ref$location = _ref.location,
	      location = _ref$location === undefined ? {} : _ref$location,
	      appProps = _ref.appProps;
	
	
	  //console.log('fetching schedule page')
	
	  var league = params.league || '';
	  var team = params.team || '';
	  var leagueResults = {};
	  var fixturesResults = {};
	  var displayDate = getDefaultDate();
	  var leaguesAction = void 0;
	  var fixturesAction = void 0;
	
	  if (league || team) {
	    fixturesResults = {
	      data: {
	        scores: []
	      }
	    };
	  }
	
	  return function (dispatch) {
	
	    var loadLeagueList = function loadLeagueList() {
	
	      //console.log('fetching league list')
	
	      leaguesAction = (0, _index.getLeagues)({ edition: edition, params: params, location: location });
	
	      if (!leaguesAction.promise) {
	        //console.log('fetched league list')
	        return {};
	      }
	
	      return leaguesAction.promise.then(function (res) {
	
	        //console.log('fetched league list')
	
	        leagueResults = res || {};
	
	        return res;
	      });
	    };
	
	    var loadSchedule = function loadSchedule() {
	
	      //console.log('fetching schedule')
	
	      if (league || team) {
	        return loadScoreboard();
	      } else {
	        return loadScorepanel();
	      }
	    };
	
	    var loadScorepanel = function loadScorepanel() {
	
	      //console.log('fetching scorepanel')
	
	      fixturesAction = (0, _index.getScoreboard)({ edition: edition, params: params, location: location });
	
	      return fixturesAction.promise.then(function (res) {
	
	        //console.log('fetched scorepanel')
	
	        displayDate = getDate(params.date, (0, _selectn2.default)('data.scores[0]', res) || {});
	        fixturesResults = res || {};
	
	        return res;
	      });
	    };
	
	    var loadScoreboard = function loadScoreboard() {
	      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	
	      //console.log('fetching scoreboard '+ date)
	
	      var linkParams = (0, _assign2.default)({}, params);
	      if (date) {
	        linkParams.date = date;
	      }
	
	      fixturesAction = (0, _index.getScoreboard)({ edition: edition, params: linkParams, location: location });
	
	      return fixturesAction.promise.then(function (res) {
	
	        //console.log('fetched scoreboard '+ date)
	
	        var scheduleData = (0, _selectn2.default)('data', res) || {};
	
	        if (scheduleData.events && scheduleData.events.length > 0) {
	          fixturesResults.data.scores.push(scheduleData);
	        } else if (scheduleData.scores && scheduleData.scores.length > 0) {
	          fixturesResults.data.scores = scheduleData.scores;
	        }
	
	        if (!date) {
	
	          displayDate = getDisplayDate(params.date, res);
	
	          var minDate = displayDate;
	          if (params.date) {
	            var paramsDate = getParamDate(params.date) || 0;
	            if (paramsDate === displayDate) {
	              minDate = paramsDate + DAY_IN_MILLISECONDS;
	            }
	          } else {
	            minDate = displayDate + DAY_IN_MILLISECONDS;
	          }
	
	          var altDates = getAltDates(minDate, res);
	          var altLen = altDates.length || 0;
	          if (altLen) {
	            var promises = [];
	            for (var i = 0; i < altLen; i++) {
	              promises.push(loadScoreboard(altDates[i]));
	            }
	            return _promise2.default.all(promises);
	          }
	        }
	
	        return res;
	      });
	    };
	
	    var dispatchResult = function dispatchResult() {
	
	      //console.log('fetched schedule')
	
	      var url = [fixturesAction.url, leaguesAction.url];
	
	      function compare(a, b) {
	        var aVal = (0, _selectn2.default)('events[0].date', a) || 0;
	        var bVal = (0, _selectn2.default)('events[0].date', b) || 0;
	        aVal = _dateformat2.default.dateToKey(aVal);
	        bVal = _dateformat2.default.dateToKey(bVal);
	        if (aVal < bVal) {
	          return -1;
	        }
	        if (aVal > bVal) {
	          return 1;
	        }
	        return 0;
	      }
	
	      fixturesResults.data.scores.sort(compare);
	
	      dispatch({
	        data: transform.onGetSchedule({ scheduleRes: fixturesResults, leagueRes: leagueResults, displayDate: epochToISO(displayDate), edition: edition, params: params, location: location, appProps: appProps }),
	        type: _actionTypes2.default.GET_FIXTURES,
	        url: url
	      });
	    };
	
	    var scheduleFailure = function scheduleFailure(error) {
	      console.log(error);
	      var url = [fixturesAction.url, leaguesAction.url];
	      //dispatch( getErrorRedirect( params ) )
	      dispatch({
	        data: transform.onGetSchedule({ scheduleRes: {}, leagueRes: [], displayDate: '', edition: edition, params: params, location: location, appProps: appProps }),
	        type: _actionTypes2.default.GET_FIXTURES,
	        url: url
	      });
	    };
	
	    return _promise2.default.all([loadSchedule(), loadLeagueList()]).then(dispatchResult).catch(scheduleFailure);
	  };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getClubhouse;
	
	var _lib = __webpack_require__(392);
	
	var _transform = __webpack_require__(806);
	
	var transform = _interopRequireWildcard(_transform);
	
	var _actionTypes = __webpack_require__(417);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _index = __webpack_require__(369);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * [getClubhouse Get clubhouse API]
	 * @param  {Object} edition  [edition details]
	 * @param  {Object} params   [page params]
	 * @param  {Object} location [location details]
	 * @return {[type]}          [redux action]
	 */
	function getClubhouse(_ref) {
	  var _ref$edition = _ref.edition,
	      edition = _ref$edition === undefined ? {} : _ref$edition,
	      _ref$params = _ref.params,
	      params = _ref$params === undefined ? {} : _ref$params,
	      _ref$location = _ref.location,
	      location = _ref$location === undefined ? {} : _ref$location,
	      appProps = _ref.appProps;
	
	  var additionalQuery = {
	    team: params.team,
	    sport: params.sport,
	    pubkey: params.sport + '-clubhouse'
	  };
	
	  if (params.sport === 'rugby') {
	    additionalQuery.pubkey = 'rugby-team-clubhouse';
	  }
	
	  var url = (0, _index.getFlexApiUrl)(edition, params, location, additionalQuery, appProps);
	
	  return {
	    url: url,
	    edition: edition,
	    params: params,
	    location: location,
	    promise: _lib.memoizr.get(url),
	    type: _actionTypes2.default.GET_CLUBHOUSE,
	    transform: transform.onGetClubhouse
	  };
	}

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.meta = undefined;
	
	var _common = __webpack_require__(430);
	
	var meta = exports.meta = {
	  update: function update() {
	    var meta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var metaDescriptors = [{
	      selector: 'title',
	      prop: 'title'
	    }, {
	      selector: 'meta[name="description"]',
	      prop: 'description'
	    }, {
	      selector: 'meta[name="keywords"]',
	      prop: 'keywords'
	    }, {
	      selector: 'link[rel="canonical"]',
	      prop: 'canonical',
	      attr: 'href'
	    }, {
	      selector: 'meta[name="twitter:site"]',
	      prop: 'site'
	    }, {
	      selector: 'meta[name="twitter:url"]',
	      prop: 'canonical'
	    }, {
	      selector: 'meta[name="twitter:title"]',
	      prop: 'title'
	    }, {
	      selector: 'meta[name="twitter:description"]',
	      prop: 'description'
	    }, {
	      selector: 'meta[name="twitter:image"]',
	      prop: 'image'
	    }, {
	      selector: 'meta[property="og:site_name"]',
	      prop: 'site_name'
	    }, {
	      selector: 'meta[property="og:url"]',
	      prop: 'canonical'
	    }, {
	      selector: 'meta[property="og:title"]',
	      prop: 'title'
	    }, {
	      selector: 'meta[property="og:description"]',
	      prop: 'description'
	    }, {
	      selector: 'meta[property="og:image"]',
	      prop: 'image'
	    }, {
	      selector: 'meta[name="title"]',
	      prop: 'title'
	    }, {
	      selector: 'meta[name="medium"]',
	      prop: 'website'
	    }, {
	      selector: 'meta[name="news_keywords"]',
	      prop: 'keywords'
	    }];
	
	    try {
	      var domain = espn.i18n && espn.i18n.domain || window.location.hostname;
	      var origin = 'http://' + domain;
	      metaDescriptors.map(function (descriptor) {
	        var prop = descriptor.prop;
	        var selector = descriptor.selector;
	        var value = meta[prop];
	        var attr = descriptor.attr || 'content';
	
	        if (prop == 'title') {
	          if (selector === 'title') {
	            jQuery(document).attr('title', value);
	          } else {
	            jQuery(descriptor.selector).attr(attr, value);
	          }
	        } else {
	          var pathname = window.location.pathname;
	          if (prop === 'canonical' && pathname) {
	            var search = window.location.search;
	            if (meta.sport === 'cricket') {
	              origin = 'https://www.espncricinfo.com';
	              pathname = (0, _common.getCricketCanonical)(pathname);
	            }
	            value = '' + origin + pathname + search;
	          }
	          if (prop == 'site') {
	            value = 'ESPN';
	          }
	          jQuery(descriptor.selector).attr(attr, value);
	        }
	      });
	    } catch (e) {
	      console.log(e);
	    }
	  }
	}; /* global jQuery espn */
	exports.default = meta;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.webviews = undefined;
	
	var _assign = __webpack_require__(365);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _stringify = __webpack_require__(864);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _typeof2 = __webpack_require__(312);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _selectn = __webpack_require__(438);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	var _config = __webpack_require__(423);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _queryString = __webpack_require__(207);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var webviews = exports.webviews = {
	  // cache frequently used elements
	  elems: {
	    // Attach on App only if body has class webview
	    wrapper: 'body.webview #' + _config2.default.uid,
	    videoPlayButton: '.video-play-button',
	    contentContainer: '.main-content.react-content',
	    //bloom: '.highlight.gamepackage_bloom',
	    // List of elements on which webviews interceptor should not be attached
	    ignore: ['.back-to-top', '.react-router-link', '.accordion-header a', '.commentary a.icon-font-before ', '.more-link', 'a.button-filter-alt'].join(',')
	  },
	  interceptorAttached: false,
	  allVideos: [],
	  sliderVideos: [],
	  pageInfo: {},
	  TAKE_ACTION: 'takeAction',
	  X_CALLBACK_CLUBHOUSE: 'sportscenter://x-callback-url/showClubhouse',
	  useFollow: false,
	  MIN_VERSION: { major: 6, minor: 6 },
	  /**
	   * Get page information, used for app
	   * @param  {String} platform valid platform as per isPlatformSupported
	   * @param  {Object} meta     title, canonical, description props
	   * @return {Object}          commandParameters
	   */
	  getPageInfo: function getPageInfo() {
	    var platform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    // default return value
	    var commandParameters = {};
	    // Get canonical and return if it's empty string
	    var canonical = meta.canonical || '';
	    if (canonical === '' || webviews.isPlatformSupported(platform) === false) {
	      return commandParameters;
	    }
	    // Construct the full url if missing
	    if (canonical.indexOf('http://') === -1) {
	      canonical = 'http://' + window.location.hostname + canonical;
	    }
	    // webview part which needs to be stripped off
	    var webviewPart = '/' + platform + '/webview';
	    // default value of sharable URL
	    var sharableUrl = '';
	    // Remove webview part only if it's found
	    if (canonical.indexOf(webviewPart) > -1) {
	      sharableUrl = canonical.replace(webviewPart, '');
	    }
	    if (typeof encodeURIComponent === 'function') {
	      sharableUrl = encodeURIComponent(sharableUrl);
	    }
	
	    //console.info('sharableUrl', sharableUrl)
	
	    // prep return data
	    /*
	    commandParameters = {
	      headline : meta.title || '',
	      description : meta.description || '',
	      shareurl : sharableUrl,
	      platform :  platform,
	      matchId: meta.matchId || '',
	      matchDescription: meta.matchDescription || '',
	      leagueId: meta.leagueId || '',
	      leagueUID: meta.leagueUID || '',
	      leagueName: meta.leagueName || '',
	      sport: meta.sport || '',
	      gameState: meta.gameState || '',
	      shortTitle: meta.shortTitle || '',
	      competitionUID: meta.competitionUID || ''
	    }
	    */
	    // Updated command parameters as per request from webview channel
	    commandParameters = {
	      headline: meta.title || '',
	      gameId: meta.gameId || '',
	      description: meta.matchDescription || '',
	      leagueId: meta.leagueId || '',
	      leagueUID: meta.leagueUID || '',
	      leagueName: meta.leagueName || '',
	      sport: meta.sport || '',
	      gameState: meta.gameState || '',
	      shortTitle: meta.shortTitle || '',
	      competitionUID: meta.competitionUID || '',
	      shareurl: sharableUrl,
	      platform: platform
	    };
	    return commandParameters;
	  },
	
	  /**
	   * Get video's URL
	   * @param  {Object} videoObj video node as received from feed
	   * @return {String}          video URL if found else empty string
	   */
	  getVideoUrl: function getVideoUrl() {
	    var videoObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var videoUrl = (0, _selectn2.default)('links.mobile.streaming.href', videoObj) || '';
	    return videoUrl;
	  },
	
	  /**
	   * Get video object by looking up in multiple sources
	   *
	   * @param  {Number}  id           video id
	   * @param  {Boolean} isLecVideo   is function called via a LEC clip
	   * @return {Object}               clicked video details
	   */
	  getVideoNodeFromArray: function getVideoNodeFromArray(id, isLecVideo) {
	    var videoNode = {};
	    /**
	     * If it's a LEC video, we also need to lookup in
	     * lecclips array - on commentary tab
	     * rosterVideos array - on scorecard and current innings section
	     */
	    // keep the global array unchanged and create a new array for all the videos
	    var allGamepackageVideos = webviews.allVideos || [];
	    if (isLecVideo) {
	      if (webviews.lecclips.length > 0) {
	        allGamepackageVideos = allGamepackageVideos.concat(webviews.lecclips);
	      }
	      if (webviews.rosterVideos.length > 0) {
	        //console.info('rosterVideos', rosterVideos)
	        allGamepackageVideos = allGamepackageVideos.concat(webviews.rosterVideos);
	      }
	    }
	    if (webviews.allVideos.length === 0 && webviews.sliderVideos.length > 0) {
	      allGamepackageVideos = allGamepackageVideos.concat(webviews.sliderVideos);
	    }
	    // Iterate over all videos and extract clicked video's details
	    for (var i = 0; i < allGamepackageVideos.length; i++) {
	      var currentVideo = allGamepackageVideos[i] || {};
	      if (currentVideo.id === id) {
	        videoNode = currentVideo;
	        break;
	      }
	    }
	    //console.log('======== videoNode',videoNode)
	    return videoNode;
	  },
	  /**
	   * Get data for a video from list of video objects. Modify it as required by
	   * App.
	   * @param  {String} id        video id
	   * @param  {Boolean} isCarousel is this video clicked on carousel section?
	   * @param  {Boolean} isVideosTab is this video clicked on videos tab
	   * @param  {Boolean} isLecVideo  is this a LEC video clicked?
	   * @param  {Boolean} isContent  is this a preview/report tab
	   * @param  {Boolean} isVideoEmbed is this video embedded in commentary
	   * @param  {Object}  dataVideoInfo    videoInfo extracted from data attrs of embed
	   * @return {Object}           data for a particular video (with videoUrlList data)
	   */
	  getVideoDetails: function getVideoDetails() {
	    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var isCarousel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    var isVideosTab = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	    var isLecVideo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	    var isContent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	    var isVideoEmbed = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
	    var dataVideoInfo = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
	
	
	    //console.info('id:', id,'\nisCarousel:',isCarousel,'\nisVideosTab:',isVideosTab,'\nisLecVideo:',isLecVideo,'\nisContent',isContent)
	
	
	    // default video details of the passed id
	    var videoNode = {};
	    // Video details which are required for App
	    var appVideo = {};
	
	    // Return if id is missing or if there are no videos
	    if (id === '' || isVideoEmbed === false && (0, _selectn2.default)('allVideos.length', webviews) === 0 && (0, _selectn2.default)('sliderVideos.length', webviews) === 0) {
	      return appVideo;
	    }
	    if (isVideoEmbed) {
	      videoNode = dataVideoInfo;
	    } else {
	      //get video node by search in all videos and lec clips
	      videoNode = webviews.getVideoNodeFromArray(id, isLecVideo);
	    }
	    //console.log('videoNode', videoNode)
	
	    // By default videoUrlList should be an empty array
	    videoNode.videoUrlList = [];
	
	    /**
	     * If a video from carousel was clicked, get it's index from the carousel.
	     * Create an array of urls from clicked index to length of list.
	     */
	    if (isCarousel === true) {
	      // default clicked index
	      var clickedVideoIdx = void 0;
	      // number of slider videos
	      var numSliderVideos = webviews.sliderVideos.length;
	
	      // Iterate over all slider videos and match current video id with id
	      for (var k = 0; k < numSliderVideos; k++) {
	        var currentSliderVideo = webviews.sliderVideos[k] || {};
	        var currentVideoId = currentSliderVideo.id || '';
	        // extract streaming url
	        var mobileUrl = webviews.getVideoUrl(currentSliderVideo);
	        // if id matches with current id, set index of clicked video
	        if (currentVideoId === id) {
	          clickedVideoIdx = k;
	        }
	        //console.info('k %d clicked %d', k, clickedVideoIdx)
	
	        /**
	         * Push all videos from index of clicked video to end of list
	         * e.g. if 2nd video was clicked, video url list should have
	         * urls of 2,3,4 to nth
	         */
	        if (k >= clickedVideoIdx) {
	          // Push to array only if url is not empty string
	          if (mobileUrl !== '') {
	            videoNode.videoUrlList.push(mobileUrl);
	          }
	        }
	      }
	    }
	
	    // For video tab, populate videoUrlList with clicked video's streaming URL
	    if (isVideosTab || isLecVideo || isContent || isVideoEmbed) {
	      var clickedVideoUrl = webviews.getVideoUrl(videoNode);
	      if (clickedVideoUrl !== '') {
	        videoNode.videoUrlList.push(clickedVideoUrl);
	      }
	    }
	
	    console.info('videoUrlList', videoNode.videoUrlList);
	
	    // Start setting props required for App
	    appVideo = {
	      geoRestrictions: undefined,
	      androidSource: videoNode.source,
	      iosSource: videoNode.source
	
	      // Properties which need to be picked from videoNode and added tp appVideo
	    };var allRequiredProps = ['id', 'headline', 'source', 'tracking', 'deviceRestrictions', 'links', 'videoUrlList'];
	
	    // Iterate over all props and set them in appVideo if they have truthy value
	    for (var j = 0; j < allRequiredProps.length; j++) {
	      var key = allRequiredProps[j];
	      if (videoNode.hasOwnProperty(key) && videoNode[key]) {
	        appVideo[key] = videoNode[key];
	        // Android app needs video id in videoId key so set another property
	        if (key === 'id') {
	          appVideo.videoId = videoNode[key];
	        }
	      }
	    }
	    //console.log('appVideo', appVideo)
	    return appVideo;
	  },
	
	  /**
	   * Check if this is a mobile platform supported by webview implementation
	   * @param  {String}  platform ios/android/windows
	   * @return {Boolean}          true if supported else false
	   */
	  isPlatformSupported: function isPlatformSupported() {
	    var platform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	    // Platforms currently supported for webviews
	    var validPlatforms = ['ios', 'android', 'windows'];
	    if (validPlatforms.indexOf(platform) > -1) {
	      return true;
	    }
	    //console.info('%s platform is not supported, webviews will not init' , platform)
	    return false;
	  },
	  /**
	   * Function to check version number from FITT webviews
	   * @param {String} currentVersion current version number from the app like 6.6.0 , 6.6.0-DEBUG etc
	   * @param {String} minVersion minimum version number
	   * @returns {Boolean} true / false
	   */
	  meetsMinimumVersion: function meetsMinimumVersion(currentVersion, minVersion) {
	    // parse the current version
	    var versionElements = currentVersion && currentVersion.split('.') || [],
	        minMajor = minVersion && minVersion.major || 0,
	        minMinor = minVersion && minVersion.minor || 0,
	        currentMajor = 0,
	        currentMinor = 0;
	
	    if (versionElements && versionElements.length) {
	      currentMajor = parseFloat(versionElements[0]);
	      if (versionElements.length >= 2) {
	        currentMinor = parseFloat(versionElements[1]);
	      }
	    }
	
	    if (currentMajor > minMajor) {
	      return true;
	    } else if (currentMajor === minMajor) {
	      // when the major versions match, we need to check the minor version
	      return currentMinor >= minMinor;
	    }
	    return false;
	  },
	
	  /**
	   *  Function to get the apps version and check whether to use follow option
	   * @param {String} platform ios / android
	   * @returns {void}
	   */
	  getAppVersion: function getAppVersion(platform) {
	    try {
	      //Maybe use callback and nativeBridge
	      var scAppVersion = 0;
	      if (platform === 'ios') {
	        window.espn.nativeBridge.getData('version', function (data) {
	          webviews.useFollow = webviews.meetsMinimumVersion(data, webviews.MIN_VERSION);
	        });
	      } else if (platform === 'android') {
	        scAppVersion = window.linklanguage && window.linklanguage.getAppVersion() || '';
	        webviews.useFollow = webviews.meetsMinimumVersion(scAppVersion, webviews.MIN_VERSION);
	      }
	    } catch (e) {
	      if (console && console.log) {
	        console.log('callLinkLang error:', e, typeof e === 'undefined' ? 'undefined' : (0, _typeof3.default)(e));
	      }
	    }
	  },
	
	  /**
	   * Wrapper to Link Language library or the bridge which connects JavaScript
	   * with Native App code. Here it wraps window.espn.nativeBridge.sendMessage
	   * method in a try-catch block.
	   *
	   * @param  {String}   command  commandName
	   * @param  {Object}   params   params which need to be passed
	   * @param  {Function} callback callback function name
	   * @return {undefined}            undefined
	   */
	  callLinkLang: function callLinkLang(command, params, callback) {
	    try {
	      window.espn.nativeBridge.sendMessage(command, params, callback);
	    } catch (e) {
	      if (console && console.log) {
	        console.log('callLinkLang error:', e, typeof e === 'undefined' ? 'undefined' : (0, _typeof3.default)(e));
	      }
	    }
	  },
	  /**
	   * [loadInBrowser Wrapper to window.espn.nativeBridge.loadMinibrowser function]
	   * @param  {string} url [path of the url that needs to be opened in minibrowser]
	   * @return {undefined}     [description]
	   */
	  loadInBrowser: function loadInBrowser(url) {
	    try {
	      window.espn.nativeBridge.loadMinibrowser(url);
	    } catch (e) {
	      if (console && console.log) {
	        console.log('loadInBrowser error:', e, typeof e === 'undefined' ? 'undefined' : (0, _typeof3.default)(e));
	      }
	    }
	  },
	
	  /**
	   * [sharePageInfo function to send the data for sharing in app]
	   * @param {String} platform name of platform
	   * @param {Object} meta meta
	   * @return {[type]} [object with page meta information]
	   */
	  sharePageInfo: function sharePageInfo() {
	    var platform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    webviews.pageInfo = webviews.getPageInfo(platform, meta) || {};
	    // Setup a public method so that App can access it.
	    if (typeof window !== 'undefined') {
	      // This function is used by android app
	      window._getPageInfo = function () {
	        try {
	          /**
	           * We need this for lower androids which can't read directly
	           * returned json objects. This is added for testing share page info
	           * on QA site. After verifiying on QA, keep only one method of
	           * sharing page info with android.
	           *
	           * This function call is as provided by Tushar Garg.
	           */
	          linklanguage.receiveValueFromJs((0, _stringify2.default)(webviews.pageInfo));
	        } catch (e) {
	          //console.log('e, typeof e', e, typeof e)
	          // This is used by latest androids. Commented as asked by Tushar.
	          return webviews.pageInfo;
	        }
	      };
	      // Also adding as an object for ios app
	      window._pageInfo = (0, _assign2.default)({}, webviews.pageInfo);
	      //console.info('window._pageInfo', window._pageInfo)
	      // New Link language call for ios app, noredirect param used for webview testing in browser
	      if (platform === 'ios') {
	        var querystr = _queryString2.default.parse(window.location.search);
	        var noredirect = querystr.noredirect === 'true' ? true : false;
	        if (!noredirect) {
	          webviews.callLinkLang('onLoadComplete', { pageInfo: (0, _assign2.default)({}, webviews.pageInfo) }, null);
	        }
	      }
	      // end
	    }
	  },
	
	  /**
	   * Load clubhouse inside Native App
	   * @param  {Object} $this jQuery selected object
	   * @return {undefined}       undefined
	   */
	  loadClubhouse: function loadClubhouse($this) {
	    var commandParameters = {};
	    commandParameters.uid = $this.data('uid') || '';
	    if (commandParameters.uid) {
	      webviews.callLinkLang('loadClubhouseWithUID', commandParameters, null);
	    }
	  },
	
	  /**
	   * Load a points table URL in minibrowser
	   * @param  {Object}  $this                jQuery selected object
	   * @param  {Boolean} isMiniBrowserPresent is mini browser available
	   * @return {undefined}                    undefined
	   */
	  loadPointsTable: function loadPointsTable($this, isMiniBrowserPresent) {
	    var leagueUid = jQuery('#gamepackage-header-wrap').data('leagueUid');
	    if (typeof leagueUid !== 'undefined' && isMiniBrowserPresent) {
	      var pageURL = 'http://www.espn.com/allsports/scorecenter/apps/webviews/standings/build?uid=' + leagueUid + '&appName=sportscenter';
	      if (typeof encodeURIComponent === 'function') {
	        /**
	         * Commenting out encodeURIComponent for now since loadMinibrowserWithURL does not decode URL
	         */
	        //pageURL = encodeURIComponent(pageURL)
	      }
	      webviews.loadInBrowser(pageURL);
	    }
	  },
	
	  /**
	   * Load video inside Native App
	   * @param  {Object} e Event handler object
	   * @return {undefined}        undefined
	   */
	  loadVideo: function loadVideo(e) {
	    e.preventDefault();
	    e.stopImmediatePropagation();
	    var $this = jQuery(this);
	    // Init videoId
	    var videoId = void 0;
	    // Check type of page
	    var isVideosTab = $this.parents('#gamepackage-videos').length > 0 ? true : false;
	    var isCarousel = $this.parents('#carousel').length > 0 ? true : false;
	    //check if element is a video embedded in commentary
	    var parentElm = $this.parents('.video-embed');
	    var isVideoEmbed = parentElm.length > 0 ? true : false;
	    var isContent = $this.parents(webviews.elems.contentContainer).length > 0 ? true : false;
	    var videoInfo = {};
	    // Get videoId from the data attrs
	    if (isVideosTab || isContent) {
	      videoId = $this.data('id');
	      console.info('Videos Tab or Content Tab or commentary-vod-embed', videoId);
	    }
	    if (isCarousel) {
	      videoId = $this.parents('.video-carousel').data('id');
	      console.info('Carousel', videoId);
	    }
	    if (isVideoEmbed) {
	      videoInfo = parentElm.data('video-info');
	      videoId = videoInfo.id;
	    }
	    if (typeof videoId !== 'undefined') {
	      var commandParameters = {};
	      commandParameters = webviews.getVideoDetails(videoId, isCarousel, isVideosTab, false, isContent, isVideoEmbed, videoInfo);
	      console.info('Video play button clicked');
	      webviews.callLinkLang('loadVideo', commandParameters, 'loggingCallback');
	    }
	  },
	
	  /**
	   * Load video inside Native App
	   * @param  {Object} e     Event handler object
	   * @param  {Object} $this Reference to jQuery selection
	   * @return {undefined}       undefined
	   */
	  loadLecVideo: function loadLecVideo(e, $this) {
	    e.preventDefault();
	    e.stopImmediatePropagation();
	    // Init videoId
	    var videoId = void 0;
	    // Set type of page
	    var isVideosTab = false;
	    var isCarousel = false;
	    var isLecVideo = true;
	
	    // Get videoId from the data attrs
	    videoId = $this.data('id');
	    console.info('loadLecVideo', videoId);
	    if (typeof videoId !== 'undefined') {
	      var commandParameters = {};
	      commandParameters = webviews.getVideoDetails(videoId, isCarousel, isVideosTab, isLecVideo, false);
	      console.info('Video play button clicked');
	      webviews.callLinkLang('loadVideo', commandParameters, 'loggingCallback');
	    }
	  },
	
	  /**
	   * Load player in Native App
	   * @param  {Object} $this jQuery selected object
	   * @return {undefined}       undefined
	   */
	  loadPlayer: function loadPlayer($this) {
	    var commandParameters = {};
	    commandParameters.uid = $this.data('player-uid') || '';
	    commandParameters.href = $this.attr('href') || '';
	
	    if (commandParameters.uid) {
	      if (webviews.useFollow) {
	        webviews.callLinkLang('loadClubhouseWithUID', commandParameters, null);
	      } else {
	        webviews.loadInBrowser(commandParameters.href);
	      }
	    }
	  },
	
	  /**
	   * Click handler to intercept all link clicks inside body.webview #reduxion
	   * @param  {Object} e Event handler object
	   * @return {undefined}   undefined
	   */
	  interceptor: function interceptor(e) {
	    console.info('body.webview #' + _config2.default.uid + ' Link clicked');
	    var $this = jQuery(this);
	    // All links with app_partial class should be opened in App
	    var isNativeAppLink = $this.hasClass('app_partial');
	    // Extract href
	    var pageURL = $this.attr('href') || '#';
	    // gather what type of link this is
	    var linkType = $this.data('linktype');
	
	    var isMiniBrowserPresent = false;
	    if ((0, _selectn2.default)('espn.nativeBridge', window)) {
	      isMiniBrowserPresent = typeof window.espn.nativeBridge.loadMinibrowser === 'function' ? true : false;
	    }
	
	    // If it's a native app link, call repective function as per linkType
	    if (isNativeAppLink) {
	      e.preventDefault();
	      e.stopImmediatePropagation();
	      console.info('Native App link of type %s', linkType);
	      if (linkType === 'clubhouse') {
	        webviews.loadClubhouse($this);
	      } else if (linkType === 'video') {
	        webviews.loadVideo($this);
	      } else if (linkType === 'lecvideo') {
	        webviews.loadLecVideo(e, $this);
	      }
	    }
	    // If it's not a native app link
	    else if (isMiniBrowserPresent) {
	        e.stopImmediatePropagation();
	        e.preventDefault();
	
	        // if linkType table, Init functionality for the same
	        var sport = webviews.pageInfo && webviews.pageInfo.sport;
	        var isRugbySport = sport === 'rugby' || sport === 'rugby-league' ? true : false;
	        if (linkType === 'table' && !isRugbySport) {
	          console.info('Points table link click');
	          webviews.loadPointsTable($this, isMiniBrowserPresent);
	        } else {
	          console.info('Regular href. Opening in minibrowser', pageURL);
	          webviews.loadInBrowser(pageURL);
	        }
	      }
	  },
	
	  /**
	   * Init webviews functionality
	   * @param  {String} platform      ios/android/windows
	   * @param  {Object} meta          meta data for page
	   * @param  {Array} allVideos      All videos for this match
	   * @param  {Array} sliderVideos   slider/carousel videos
	   * @param  {Array} lecclips       All lecclips for this match
	   * @param  {Array} rosterVideos   videos in player rosters
	   * @param  {Array} action         page onload or onstatechange
	   * @return {undefined}            undefined
	   */
	  init: function init() {
	    var platform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var meta = arguments[1];
	    var allVideos = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	    var sliderVideos = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	    var lecclips = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	    var rosterVideos = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
	    var action = arguments[6];
	
	    // Do not proceed if this platform is not supported
	    if (webviews.isPlatformSupported(platform) === false) {
	      return;
	    }
	    //console.info('%s platform is supported',platform)
	
	    //calling sharePageInfo so that app gets latest info for sharing on load
	    if (action === 'init') {
	      webviews.sharePageInfo(platform, meta);
	    }
	
	    //check if device detection is available
	    // console.info('window.espn_ui.device', selectn('espn_ui.device', window))
	
	
	    //console.info('lecclips', lecclips)
	    //console.info('rosterVideos', rosterVideos)
	    //console.info('action', action)
	    //console.info('sliderVideos', sliderVideos)
	
	    // Push latest videos to allVideos & sliderVideos property
	    webviews.allVideos = allVideos;
	    webviews.sliderVideos = sliderVideos;
	    webviews.lecclips = lecclips;
	    webviews.rosterVideos = rosterVideos;
	
	    // Attach click handler only once based on the flag
	    if (webviews.interceptorAttached === false) {
	      // Attach click handler for all anchor links except those with class react-router-link
	      var $parentElem = jQuery(webviews.elems.wrapper);
	      //console.info('webviews.elems.ignore', webviews.elems.ignore)
	      $parentElem.on('click', 'a:not(' + webviews.elems.ignore + ')', webviews.interceptor);
	      // Attach click handler on video elements
	      $parentElem.on('click', webviews.elems.videoPlayButton, webviews.loadVideo);
	      console.info('Attached interceptor on body.webview #' + _config2.default.uid);
	      webviews.interceptorAttached = true;
	    }
	  },
	
	  disableInterceptor: function disableInterceptor() {
	    console.info('disableInterceptor');
	    // Disable click handler for all anchor links except those with class react-router-link
	    var $parentElem = jQuery(webviews.elems.wrapper);
	    $parentElem.off('click', 'a:not(' + webviews.elems.ignore + ')', webviews.interceptor);
	    // Disable click handler on video elements
	    $parentElem.off('click', webviews.elems.videoPlayButton, webviews.loadVideo);
	  }
	
	}; /* global jQuery linklanguage */
	
	exports.default = webviews;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(865), __esModule: true };

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(288);
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};


/***/ }),
/* 866 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = debounce;
	/* Returns a function, that, as long as it continues to be invoked, will not
	* be triggered. The function will be called after it stops being called for
	* N milliseconds. If `immediate` is passed, trigger the function on the
	* leading edge, instead of the trailing.
	* https://davidwalsh.name/javascript-debounce-function
	*/
	
	function debounce(callback) {
	  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
	  var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var timeout = void 0;
	  return function () {
	
	    var context = this;
	    var args = arguments;
	    var later = function later() {
	      timeout = null;
	      if (!immediate) {
	        callback.apply(context, args);
	      }
	    };
	    var callNow = immediate && !timeout;
	    clearTimeout(timeout);
	    timeout = setTimeout(later, wait);
	    if (callNow) {
	      callback.apply(context, args);
	    }
	  };
	}
	
	/*
	var myEfficientFn = debounce(function() {
	  // All the taxing stuff you do
	}, 250);

	window.addEventListener('resize', myEfficientFn);
	*/

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(279);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(306);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(307);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(311);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(356);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Home = function (_React$Component) {
	  (0, _inherits3.default)(Home, _React$Component);
	
	  function Home() {
	    (0, _classCallCheck3.default)(this, Home);
	    return (0, _possibleConstructorReturn3.default)(this, (Home.__proto__ || (0, _getPrototypeOf2.default)(Home)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Home, [{
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        'Hello Reduxion!'
	      );
	    }
	  }]);
	  return Home;
	}(_react2.default.Component);
	
	exports.default = Home;

/***/ }),
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1114);
	} else {
	  module.exports = require('./configureStore.dev');
	}

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = configureStore;
	
	var _redux = __webpack_require__(256);
	
	var _reactRouterRedux = __webpack_require__(858);
	
	var _promiseMiddleware = __webpack_require__(1115);
	
	var _promiseMiddleware2 = _interopRequireDefault(_promiseMiddleware);
	
	var _reduxThunk = __webpack_require__(1116);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reducers = __webpack_require__(1117);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function configureStore(initialState, history) {
	
	  var finalCreateStore = (0, _redux.compose)((0, _redux.applyMiddleware)(_reduxThunk2.default, _promiseMiddleware2.default, (0, _reactRouterRedux.syncHistory)(history)))(_redux.createStore);
	
	  return finalCreateStore(_reducers2.default, initialState);
	}

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(364);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(416);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	exports.default = promiseMiddleware;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var API_ERROR = 'Invalid response from API.';
	
	function promiseMiddleware() {
	  return function (next) {
	    return function (action) {
	      var edition = action.edition,
	          location = action.location,
	          promise = action.promise,
	          type = action.type,
	          transform = action.transform,
	          params = action.params,
	          appProps = action.appProps,
	          rest = (0, _objectWithoutProperties3.default)(action, ['edition', 'location', 'promise', 'type', 'transform', 'params', 'appProps']);
	
	
	      if (!promise) return next(action);
	
	      var SUCCESS = type;
	      var REQUEST = type + '_REQUEST';
	      var FAILURE = type + '_FAILURE';
	
	      next((0, _extends3.default)({}, rest, { type: REQUEST }));
	
	      return promise.then(function (res) {
	        var data = {};
	        var error = void 0;
	
	        if (!res) {
	          error = Error(API_ERROR);
	          next((0, _extends3.default)({}, rest, { error: error, type: FAILURE }));
	          throw error;
	        }
	        if (typeof transform === 'function') {
	          data = transform({ res: res, edition: edition, params: params, location: location, appProps: appProps });
	        }
	        next((0, _extends3.default)({}, rest, { edition: edition, params: params, location: location, data: data, res: res, type: SUCCESS }));
	        return true;
	      });
	    };
	  };
	}

/***/ }),
/* 1116 */
/***/ (function(module, exports) {

	'use strict';
	
	function thunkMiddleware(_ref) {
	  var dispatch = _ref.dispatch;
	  var getState = _ref.getState;
	
	  return function (next) {
	    return function (action) {
	      return typeof action === 'function' ? action(dispatch, getState) : next(action);
	    };
	  };
	}
	
	module.exports = thunkMiddleware;

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.rootReducer = undefined;
	
	var _redux = __webpack_require__(256);
	
	var _reactRouterRedux = __webpack_require__(858);
	
	var _leagues = __webpack_require__(1118);
	
	var _leagues2 = _interopRequireDefault(_leagues);
	
	var _news = __webpack_require__(1119);
	
	var _news2 = _interopRequireDefault(_news);
	
	var _editorial = __webpack_require__(1120);
	
	var _editorial2 = _interopRequireDefault(_editorial);
	
	var _scoreboard = __webpack_require__(1121);
	
	var _scoreboard2 = _interopRequireDefault(_scoreboard);
	
	var _standings = __webpack_require__(1122);
	
	var _standings2 = _interopRequireDefault(_standings);
	
	var _schedule = __webpack_require__(1123);
	
	var _schedule2 = _interopRequireDefault(_schedule);
	
	var _gamePackage = __webpack_require__(1124);
	
	var _gamePackage2 = _interopRequireDefault(_gamePackage);
	
	var _utils = __webpack_require__(1125);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _page = __webpack_require__(1126);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _clubhouse = __webpack_require__(1127);
	
	var _clubhouse2 = _interopRequireDefault(_clubhouse);
	
	var _apiUrls = __webpack_require__(1128);
	
	var _apiUrls2 = _interopRequireDefault(_apiUrls);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rootReducer = exports.rootReducer = (0, _redux.combineReducers)({
	  news: _news2.default,
	  editorial: _editorial2.default,
	  leagues: _leagues2.default,
	  scoreboard: _scoreboard2.default,
	  standings: _standings2.default,
	  gamePackage: _gamePackage2.default,
	  clubhouse: _clubhouse2.default,
	  routing: _reactRouterRedux.routeReducer,
	  utils: _utils2.default,
	  schedule: _schedule2.default,
	  page: _page2.default,
	  apiUrls: _apiUrls2.default
	});
	
	exports.default = rootReducer;

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(364);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(365);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.default = leaguesReducer;
	
	var _actionTypes = __webpack_require__(417);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function leaguesReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	
	  switch (action.type) {
	    case _actionTypes2.default.GET_LEAGUES:
	      return (0, _assign2.default)({}, state, (0, _extends3.default)({}, action.data, {
	        pageType: action.pageType
	      }));
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(365);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.default = newsReducer;
	
	var _actionTypes = __webpack_require__(417);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function newsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _actionTypes2.default.GET_HEADLINES:
	      var edition = action.edition || {};
	      return (0, _assign2.default)({}, state, {
	        items: action.data.newsItems,
	        heading: edition.isEspnCricinfo ? 'ESPNcricinfo headlines' : 'ESPN.in Headlines'
	      });
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(365);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.default = editorialReducer;
	
	var _actionTypes = __webpack_require__(417);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function editorialReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _actionTypes2.default.GET_EDITORIAL:
	      return (0, _assign2.default)({}, state, {
	        editorialItems: action.data.editorialItems,
	        heading: 'Editorial'
	      });
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(364);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(365);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.default = scoreboardReducer;
	
	var _actionTypes = __webpack_require__(417);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _cricket = __webpack_require__(808);
	
	var _helpers = __webpack_require__(855);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function scoreboardReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _actionTypes2.default.UPDATE_TIMEZONE:
	      var _action$params = action.params,
	          params = _action$params === undefined ? {} : _action$params,
	          _action$query = action.query,
	          query = _action$query === undefined ? {} : _action$query;
	
	      _cricket.scoreboard.setLocalTime(state.leagues || [], state.scoreboardType || '', params.sport || '');
	      var activeDates = _cricket.scoreboard.getActiveDates(state.leagues || []);
	      var date = _cricket.scoreboard.getDate(state.apiDate, params, query);
	      return (0, _assign2.default)({}, state, {
	        activeDates: activeDates,
	        zone: action.zone,
	        date: date
	      });
	
	    case _actionTypes2.default.GET_GEO_LOCATION:
	      var country = action.data.country;
	
	
	      return (0, _assign2.default)({}, state, (0, _extends3.default)({}, action.data, {
	        country: country
	      }));
	    case _actionTypes2.default.UPDATE_FAVORITES:
	      return (0, _helpers.filterEvent)(state, state, false, action.data);
	    case _actionTypes2.default.GET_SCOREBOARD:
	      var actionData = action.data;
	      var _action$params2 = action.params,
	          _action$params2$sport = _action$params2.sport,
	          sport = _action$params2$sport === undefined ? '' : _action$params2$sport,
	          league = _action$params2.league,
	          team = _action$params2.team;
	
	      if (league || team || sport !== 'cricket') {
	        return (0, _assign2.default)({}, state, (0, _extends3.default)({}, actionData, {
	          loading: false
	        }));
	      } else {
	        return (0, _helpers.filterEvent)(state, actionData, true);
	      }
	
	    case _actionTypes2.default.GET_TOPEVENTS:
	      return (0, _helpers.filterEvent)(state, action.data, false);
	
	    case _actionTypes2.default.GET_SCOREBOARD_REQUEST:
	      return (0, _assign2.default)({}, state, {
	        loading: action.isPolling ? false : true
	      });
	
	    case _actionTypes2.default.HISTORY_CHANGE:
	    case _actionTypes2.default.GET_SCOREBOARD_FAILURE:
	      return (0, _assign2.default)({}, state, {
	        loading: false
	      });
	
	    case _actionTypes2.default.RESET_SCOREBOARD:
	      return {};
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(364);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(365);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.default = standingsReducer;
	
	var _actionTypes = __webpack_require__(417);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function standingsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	
	  switch (action.type) {
	    case _actionTypes2.default.GET_STANDINGS:
	      return (0, _assign2.default)({}, state, (0, _extends3.default)({}, action.data));
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(364);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(365);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.default = fixturesReducer;
	
	var _actionTypes = __webpack_require__(417);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fixturesReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	
	    case _actionTypes2.default.GET_FIXTURES:
	
	      return (0, _assign2.default)({}, state, (0, _extends3.default)({}, action.data));
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(685);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(364);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(365);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _objectWithoutProperties2 = __webpack_require__(416);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	exports.default = gamePackageReducer;
	
	var _actionTypes = __webpack_require__(417);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _helpers = __webpack_require__(855);
	
	var _selectn = __webpack_require__(438);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function gamePackageReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  var copyRightCheckObj = {};
	  copyRightCheckObj.site = (0, _selectn2.default)('edition.site', action) || '';
	  copyRightCheckObj.domain = (0, _selectn2.default)('edition.domain', action) || '';
	  copyRightCheckObj.userGeo = (0, _selectn2.default)('edition.userGeo', action) || '';
	  copyRightCheckObj.isWebView = (0, _selectn2.default)('params.webview', action) || '';
	
	  switch (action.type) {
	    case _actionTypes2.default.GET_RENDERED_ARTICLE:
	    case _actionTypes2.default.GET_GAMEPACKAGE:
	      var _action$data = action.data,
	          _action$data$article = _action$data.article,
	          article = _action$data$article === undefined ? {} : _action$data$article,
	          allVideos = _action$data.allVideos,
	          partCommentary = _action$data.partCommentary,
	          scorecard = _action$data.scorecard,
	          _action$data$innings = _action$data.innings,
	          innings = _action$data$innings === undefined ? {} : _action$data$innings,
	          bet365 = _action$data.bet365,
	          rest = (0, _objectWithoutProperties3.default)(_action$data, ['article', 'allVideos', 'partCommentary', 'scorecard', 'innings', 'bet365']);
	
	
	      var prevVideos = (0, _selectn2.default)('allVideos.videos', state) || [];
	      var video = [];
	      var pageType = (0, _selectn2.default)('params.pageType', action);
	      var country = ((0, _selectn2.default)('edition.userGeo', action) || '').toUpperCase();
	      var isFastcast = action.isFastcast || false;
	      var commFilterPrev = (0, _selectn2.default)('selCmtryFilter.playtype', state);
	      var commInningsPrev = (0, _selectn2.default)('selInnings.period', state) || 1;
	      var commFilter = (0, _selectn2.default)('data.selCmtryFilter.playtype', action);
	      var commInnings = (0, _selectn2.default)('data.selInnings.period', action) || 1;
	
	      // reinit fullcommentary state if innings/commentary-filter is changed
	      if (action.type === _actionTypes2.default.GET_GAMEPACKAGE) {
	        if (!commInningsPrev || !commFilterPrev) {
	          rest.fullCommentary = { init: true };
	        } else if (commInningsPrev !== commInnings || commFilterPrev !== commFilter) {
	          rest.fullCommentary = { init: true, commSwitch: true };
	        }
	      }
	      if (prevVideos.length <= 20) {
	        rest.allVideos = allVideos;
	      } else {
	        rest.allVideos = state.allVideos;
	      }
	
	      article = (0, _helpers.updateArticle)(state.article, article, pageType, isFastcast);
	
	      video = (0, _selectn2.default)('article.video', state) || [];
	      (0, _helpers.filterVideoContent)(rest, country, copyRightCheckObj);
	      (0, _helpers.filterScorecardVideos)(scorecard, country, copyRightCheckObj);
	      (0, _helpers.filterActivePlayerVideos)(innings, country, copyRightCheckObj);
	      (0, _helpers.filterVideoContent)(video, country, copyRightCheckObj);
	      (0, _helpers.filterCommentaryVideos)(partCommentary, country, copyRightCheckObj);
	      if (typeof bet365 === 'undefined') {
	        bet365 = (0, _selectn2.default)('bet365', state) || {};
	      }
	      if ('cricket' === (0, _selectn2.default)('params.sport', action)) {
	        (0, _helpers.filterBet365)(bet365, country);
	      }
	
	      article.video = video;
	      (0, _helpers.checkLastEndOfOver)(partCommentary, false);
	
	      return (0, _assign2.default)({}, state, (0, _extends3.default)({
	        article: article,
	        commentaryFeedback: {},
	        country: country,
	        partCommentary: partCommentary,
	        scorecard: scorecard,
	        innings: innings,
	        bet365: bet365
	      }, rest, {
	        clientApiUrl: action.clientApiUrl || state.clientApiUrl
	      }));
	
	    case _actionTypes2.default.GET_PLAY_BY_PLAY:
	      (0, _helpers.filterCommentaryVideos)(action.data.fullCommentary, state.country, copyRightCheckObj);
	      return (0, _helpers.updateCommentary)(state, action.data, action.isPolling, copyRightCheckObj);
	
	    case _actionTypes2.default.GET_VIDEOS_MORE:
	      return (0, _helpers.updateVideos)(state, action.data, copyRightCheckObj);
	
	    case _actionTypes2.default.API_REQUEST_START:
	      return (0, _assign2.default)({}, state, {
	        loading: action.isPolling ? false : true
	      });
	
	    case _actionTypes2.default.HISTORY_CHANGE:
	    case _actionTypes2.default.API_REQUEST_COMPLETE:
	      return (0, _assign2.default)({}, state, {
	        loading: false
	      });
	
	    case _actionTypes2.default.COMM_FB_STATUS:
	      var status = action.status;
	      var _state$commentaryFeed = state.commentaryFeedback,
	          commentaryFeedback = _state$commentaryFeed === undefined ? {} : _state$commentaryFeed;
	
	
	      commentaryFeedback = (0, _assign2.default)({}, commentaryFeedback, {
	        status: (0, _defineProperty3.default)({}, status, true)
	      });
	
	      return (0, _assign2.default)({}, state, { commentaryFeedback: commentaryFeedback });
	    case _actionTypes2.default.UPDATE_GAMESTRIP_TIME:
	      if (state.gameState && state.gameState === 'pregame') {
	        var isoDate = (0, _selectn2.default)('gameStrip.isoDate', state);
	        var timeValid = (0, _selectn2.default)('gameStrip.timeValid', state);
	        var dateObj = (0, _helpers.updateGameStrip)(isoDate, action.sport, timeValid);
	        state.gameStrip.date = dateObj.date;
	        state.gameStrip.time = dateObj.time;
	      }
	      return (0, _assign2.default)({}, state);
	
	    case _actionTypes2.default.RESET_GAMEPACKAGE:
	      return {};
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(365);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.default = utils;
	
	var _actionTypes = __webpack_require__(417);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function utils() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	
	  var mobileBreakPoint = void 0,
	      tabletBreakPoint = void 0,
	      smallDesktopBreakPoint = void 0,
	      isSmallDevice = void 0,
	      isTabletDevice = void 0,
	      isSmallDesktopDevice = void 0,
	      currentWidth = void 0;
	
	  switch (action.type) {
	    case _actionTypes2.default.SET_DEVICE_TYPE:
	
	      currentWidth = action.currentWidth;
	      mobileBreakPoint = 768;
	      tabletBreakPoint = [mobileBreakPoint, 1024];
	      smallDesktopBreakPoint = [1024, 1260];
	      isSmallDevice = false;
	      isTabletDevice = false;
	      isSmallDesktopDevice = false;
	
	      if (currentWidth < mobileBreakPoint) {
	        isSmallDevice = true;
	      }
	
	      if (currentWidth > tabletBreakPoint[0] && currentWidth < tabletBreakPoint[1]) {
	        isTabletDevice = true;
	      }
	
	      if (currentWidth > smallDesktopBreakPoint[0] && currentWidth < smallDesktopBreakPoint[1]) {
	        isSmallDesktopDevice = true;
	      }
	
	      return (0, _assign2.default)({}, state, {
	        isSmallDevice: isSmallDevice,
	        isTabletDevice: isTabletDevice,
	        isSmallDesktopDevice: isSmallDesktopDevice
	      });
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(364);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(685);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _keys = __webpack_require__(419);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(365);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.default = pageReducer;
	
	var _actionTypes = __webpack_require__(417);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _selectn = __webpack_require__(438);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	var _mapPageToTemplate = __webpack_require__(765);
	
	var _mapPageToTemplate2 = _interopRequireDefault(_mapPageToTemplate);
	
	var _helpers = __webpack_require__(855);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function pageReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	
	  var config = void 0;
	  var analytics = void 0;
	  var ads = void 0;
	  var params = void 0;
	  var edition = void 0;
	  var tier3Nav = void 0;
	  var tier2Nav = void 0;
	  var tier2NavLinks = void 0;
	
	  switch (action.type) {
	    case _actionTypes2.default.UPDATE_TIMEZONE:
	
	      config = {};
	      config.edition = state.edition || {};
	      config.edition.timeZoneBucket = action.zone;
	
	      return (0, _assign2.default)({}, state, config);
	
	    case _actionTypes2.default.PAGE_CONFIG:
	      config = {};
	      ads = action.ads || (0, _selectn2.default)('res.data.ads', action);
	      analytics = action.analytics || (0, _selectn2.default)('res.data.analytics', action);
	      tier3Nav = action.tier3Nav || (0, _selectn2.default)('res.data.tier3Nav', action);
	      tier2Nav = action.tier2Nav || (0, _selectn2.default)('res.data.tier2Nav', action);
	      tier2NavLinks = action.league || (0, _selectn2.default)('res.data.league', action);
	      params = action.params || {};
	      edition = action.edition;
	
	      if (ads) {
	        config.ads = ads;
	
	        // If a previous value is available, preserve it unless we have new data
	        var prevCMSEnabledSponsoredContentProviders = (0, _selectn2.default)('ads.cmsEnbldSpnsrdCntntPrvdrs', state);
	        if (prevCMSEnabledSponsoredContentProviders) {
	          config.ads.cmsEnbldSpnsrdCntntPrvdrs = config.ads.cmsEnbldSpnsrdCntntPrvdrs || prevCMSEnabledSponsoredContentProviders;
	        }
	      }
	
	      if (analytics) {
	        config.analytics = analytics;
	      }
	
	      if (process.browser && tier2Nav && tier2NavLinks) {
	        (0, _helpers.updateNavLinks)(tier2Nav, tier2NavLinks);
	      }
	
	      config.tier3Nav = tier3Nav;
	      config.tier2Nav = tier2Nav;
	
	      if ((0, _keys2.default)(params).length > 0) {
	        config.params = params;
	        config.template = (0, _mapPageToTemplate2.default)({ pageType: params.pageType, sport: params.sport });
	      }
	
	      config.edition = edition || state.edition;
	
	      return (0, _assign2.default)({}, state, config);
	
	    case _actionTypes2.default.APP_PROPS:
	      var appProps = action.appProps || {};
	      var deviceStr = appProps.device || '';
	
	      appProps.device = deviceStr !== '' ? (0, _defineProperty3.default)({}, deviceStr, true) : {};
	
	      config = {};
	      config.appProps = (0, _assign2.default)({}, state.appProps, (0, _extends3.default)({}, appProps));
	
	      return (0, _assign2.default)({}, state, config);
	
	    case _actionTypes2.default.ALLOW_DENY_FASTCAST:
	      var shouldAllow = action.payload || false;
	      return (0, _assign2.default)({}, state, {
	        isFastcastAllowed: shouldAllow
	      });
	
	    default:
	      return state;
	
	  }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(364);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(365);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.default = clubhouseReducer;
	
	var _actionTypes = __webpack_require__(417);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _helpers = __webpack_require__(855);
	
	var _flex = __webpack_require__(850);
	
	var _selectn = __webpack_require__(438);
	
	var _selectn2 = _interopRequireDefault(_selectn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function clubhouseReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _actionTypes2.default.UPDATE_TIMEZONE:
	      {
	        var edition = action.edition || {};
	        var leftcolumn = state.leftColumn || {};
	        var tzOptions = { zone: action.zone, zoneAbbr: action.zoneAbbr };
	        leftcolumn = _flex.flex.updateLeftColumnTimezones(leftcolumn, tzOptions, edition);
	
	        return (0, _assign2.default)({}, state, (0, _extends3.default)({}, action.data, {
	          leftColumn: leftcolumn,
	          zone: action.zone,
	          zoneAbbr: action.zoneAbbr
	        }));
	      }
	    case _actionTypes2.default.GET_CLUBHOUSE:
	      return (0, _assign2.default)({}, state, (0, _extends3.default)({}, action.data, {
	        pageType: (0, _selectn2.default)('params.pageType', action)
	      }));
	
	    case _actionTypes2.default.GET_MORE_MID_COL_FEED:
	      (0, _helpers.midColVidGeoFilter)(action.data, state.country, state);
	      return (0, _helpers.updateMidColFeed)(state, action.data);
	
	    case _actionTypes2.default.GET_GEO_LOCATION:
	      var country = action.data.country;
	
	      if (state.pageType === 'team') {
	        (0, _helpers.midColVidGeoFilter)(state, country);
	      }
	      return (0, _assign2.default)({}, state, { country: country });
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(365);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.default = apiURLs;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function apiURLs() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var url = action.url || (action.data || {}).url;
	  var urls = state.urls || [];
	
	  if (url && urls.indexOf(url) == -1) {
	    urls = urls.concat(url);
	  }
	
	  return (0, _assign2.default)({}, state, { urls: urls });
	}

/***/ }),
/* 1129 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * source: https://github.com/jfriend00/docReady
	 * @param  {String} funcName function name
	 * @param  {Object} baseObj  scope
	 * @return {Function}        document ready
	 */
	var docReady = exports.docReady = function (funcName, baseObj) {
	  funcName = funcName || 'docReady';
	  baseObj = baseObj || window;
	  var readyList = [];
	  var readyFired = false;
	  var readyEventHandlersInstalled = false;
	
	  function ready() {
	    if (!readyFired) {
	      readyFired = true;
	      for (var i = 0; i < readyList.length; i++) {
	        readyList[i].fn.call(window, readyList[i].ctx);
	      }
	      readyList = [];
	    }
	  }
	
	  function readyStateChange() {
	    if (document.readyState === 'complete') {
	      ready();
	    }
	  }
	
	  return function (callback, context) {
	    if (readyFired) {
	      setTimeout(function () {
	        callback(context);
	      }, 1);
	      return;
	    } else {
	      readyList.push({ fn: callback, ctx: context });
	    }
	    if (document.readyState === 'complete' || !document.attachEvent && document.readyState === 'interactive') {
	      setTimeout(ready, 1);
	    } else if (!readyEventHandlersInstalled) {
	      if (document.addEventListener) {
	        document.addEventListener('DOMContentLoaded', ready, false);
	        window.addEventListener('load', ready, false);
	      } else {
	        document.attachEvent('onreadystatechange', readyStateChange);
	        window.attachEvent('onload', ready);
	      }
	      readyEventHandlersInstalled = true;
	    }
	  };
	}('docReady', window);

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(365);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.default = getRequestParams;
	
	var _getSportFromRoot = __webpack_require__(831);
	
	var _getSportFromRoot2 = _interopRequireDefault(_getSportFromRoot);
	
	var _queryString = __webpack_require__(207);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _translateURI = __webpack_require__(832);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getRequestParams() {
	  var edition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var routerParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var location = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	
	  var query = location.query || _queryString2.default.parse(location.search) || {};
	
	  //translate query
	  query = (0, _translateURI.translateQueryKey)(edition, query, true);
	
	  var params = routerParams.params || {};
	  var currRoot = params.sport || edition.defaultSport; /* the variable is called sport but it could be a league */
	  var actualSport = (0, _getSportFromRoot2.default)(currRoot) || currRoot;
	  var pageType = params.pageType || '';
	  var slug = params.slug || query.slug || '';
	  var actualLeague = params.league || query.league || query.leagueId || '';
	  var actualGameId = params.gameId || query.gameId || '';
	  var actualSeason = params.season || query.season || '';
	  var actualTeam = '';
	  var actualPlatform = params.platform || '';
	
	  if (pageType !== 'team') {
	    actualTeam = params.team || query.team || '';
	  } else {
	    actualTeam = params.teamId || query.id || '';
	  }
	
	  var newParams = {
	    sport: actualSport,
	    root: currRoot,
	    slug: slug
	  };
	
	  if (actualGameId) {
	    newParams.gameId = actualGameId;
	  }
	
	  if (actualTeam) {
	    newParams.team = actualTeam;
	  }
	
	  if (actualLeague) {
	    newParams.league = actualLeague;
	  }
	
	  if (actualSeason) {
	    newParams.season = actualSeason;
	  }
	
	  if (actualPlatform) {
	    if (['ios', 'android', 'windows'].indexOf(actualPlatform) > -1) {
	      newParams.platform = actualPlatform;
	    } else {
	      newParams.platform = '';
	    }
	  }
	
	  /* get default league if we need to hardcode one */
	
	  /* pagetype can be modified here on a lang/location basis i.e. for es/ar we can take `resultados` and convert to `results`  */
	
	  (0, _assign2.default)(params, newParams);
	
	  return params;
	} //import selectn          from 'selectn'

/***/ }),
/* 1131 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getLocale;
	/* http://momentjs.com/docs/#/i18n/ */
	function getLocale_en() {
	  return {
	    months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat: {
	      LT: 'HH:mm',
	      LTS: 'HH:mm:ss',
	      L: 'DD/MM/YYYY',
	      LL: 'MMMM Do, YYYY',
	      LLL: 'D MMMM YYYY HH:mm',
	      LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	      sameDay: '[Today at] LT',
	      nextDay: '[Tomorrow at] LT',
	      nextWeek: 'dddd [at] LT',
	      lastDay: '[Yesterday at] LT',
	      lastWeek: '[Last] dddd [at] LT',
	      sameElse: 'L'
	    },
	    relativeTime: {
	      future: 'in %s',
	      past: '%s ago',
	      s: 'a few seconds',
	      ss: '%d seconds',
	      m: 'a minute',
	      mm: '%d minutes',
	      h: 'an hour',
	      hh: '%d hours',
	      d: 'a day',
	      dd: '%d days',
	      M: 'a month',
	      MM: '%d months',
	      y: 'a year',
	      yy: '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal: function ordinal(number) {
	      var b = number % 10,
	          output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
	      return number + output;
	    },
	    week: {
	      dow: 1, // Monday is the first day of the week.
	      doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	  };
	}
	function getLocale_pt() {
	  return {
	    months: 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays: 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	      LT: 'HH:mm',
	      LTS: 'HH:mm:ss',
	      L: 'DD/MM/YYYY',
	      LL: 'D [de] MMMM, YYYY',
	      LLL: 'D [de] MMMM [de] YYYY HH:mm',
	      LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm'
	    },
	    calendar: {
	      sameDay: '[Hoje às] LT',
	      nextDay: '[Amanhã às] LT',
	      nextWeek: 'dddd [às] LT',
	      lastDay: '[Ontem às] LT',
	      lastWeek: function lastWeek() {
	        return this.day() === 0 || this.day() === 6 ? '[Último] dddd [às] LT' : // Saturday + Sunday
	        '[Última] dddd [às] LT'; // Monday - Friday
	      },
	      sameElse: 'L'
	    },
	    relativeTime: {
	      future: 'em %s',
	      past: 'há %s',
	      s: 'segundos',
	      ss: '%d segundos',
	      m: 'um minuto',
	      mm: '%d minutos',
	      h: 'uma hora',
	      hh: '%d horas',
	      d: 'um dia',
	      dd: '%d dias',
	      M: 'um mês',
	      MM: '%d meses',
	      y: 'um ano',
	      yy: '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº'
	  };
	}
	function getLocale_es() {
	  return {
	    months: 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split('_'),
	    monthsShort: 'Ene_Feb_Mar_Abr_May_Jun_Jul_Ago_Sep_Oct_Nov_Dic'.split('_'),
	    weekdays: 'Domingo_Lunes_Martes_Miércoles_Jueves_Viernes_Sábado'.split('_'),
	    weekdaysShort: 'Dom_Lun_Mar_Mié_Jue_Vie_Sáb'.split('_'),
	    weekdaysMin: 'Do_Lu_Ma_Mi_Ju_Vi_Sá'.split('_'),
	    longDateFormat: {
	      LT: 'H:mm',
	      LTS: 'H:mm:ss',
	      L: 'DD/MM/YYYY',
	      LL: 'D [de] MMMM, YYYY',
	      LLL: 'D [de] MMMM [de] YYYY H:mm',
	      LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar: {
	      sameDay: function sameDay() {
	        return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	      },
	      nextDay: function nextDay() {
	        return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	      },
	      nextWeek: function nextWeek() {
	        return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	      },
	      lastDay: function lastDay() {
	        return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	      },
	      lastWeek: function lastWeek() {
	        return '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	      },
	      sameElse: 'L'
	    },
	    relativeTime: {
	      future: 'en %s',
	      past: 'hace %s',
	      s: 'unos segundos',
	      ss: '%d segundos',
	      m: 'un minuto',
	      mm: '%d minutos',
	      h: 'una hora',
	      hh: '%d horas',
	      d: 'un día',
	      dd: '%d días',
	      M: 'un mes',
	      MM: '%d meses',
	      y: 'un año',
	      yy: '%d años'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº'
	  };
	}
	
	function getLocale() {
	  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';
	
	  switch (locale) {
	    case 'en':
	      return getLocale_en();
	    case 'es':
	      return getLocale_es();
	    case 'pt':
	      return getLocale_pt();
	  }
	}

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(process, global) {/*!
	 * @overview es6-promise - a tiny implementation of Promises/A+.
	 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
	 * @license   Licensed under MIT license
	 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
	 * @version   3.3.1
	 */
	
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ES6Promise = factory());
	}(this, (function () { 'use strict';
	
	function objectOrFunction(x) {
	  return typeof x === 'function' || typeof x === 'object' && x !== null;
	}
	
	function isFunction(x) {
	  return typeof x === 'function';
	}
	
	var _isArray = undefined;
	if (!Array.isArray) {
	  _isArray = function (x) {
	    return Object.prototype.toString.call(x) === '[object Array]';
	  };
	} else {
	  _isArray = Array.isArray;
	}
	
	var isArray = _isArray;
	
	var len = 0;
	var vertxNext = undefined;
	var customSchedulerFn = undefined;
	
	var asap = function asap(callback, arg) {
	  queue[len] = callback;
	  queue[len + 1] = arg;
	  len += 2;
	  if (len === 2) {
	    // If len is 2, that means that we need to schedule an async flush.
	    // If additional callbacks are queued before the queue is flushed, they
	    // will be processed by this flush that we are scheduling.
	    if (customSchedulerFn) {
	      customSchedulerFn(flush);
	    } else {
	      scheduleFlush();
	    }
	  }
	};
	
	function setScheduler(scheduleFn) {
	  customSchedulerFn = scheduleFn;
	}
	
	function setAsap(asapFn) {
	  asap = asapFn;
	}
	
	var browserWindow = typeof window !== 'undefined' ? window : undefined;
	var browserGlobal = browserWindow || {};
	var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
	var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && ({}).toString.call(process) === '[object process]';
	
	// test for web worker but not in IE10
	var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';
	
	// node
	function useNextTick() {
	  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
	  // see https://github.com/cujojs/when/issues/410 for details
	  return function () {
	    return process.nextTick(flush);
	  };
	}
	
	// vertx
	function useVertxTimer() {
	  return function () {
	    vertxNext(flush);
	  };
	}
	
	function useMutationObserver() {
	  var iterations = 0;
	  var observer = new BrowserMutationObserver(flush);
	  var node = document.createTextNode('');
	  observer.observe(node, { characterData: true });
	
	  return function () {
	    node.data = iterations = ++iterations % 2;
	  };
	}
	
	// web worker
	function useMessageChannel() {
	  var channel = new MessageChannel();
	  channel.port1.onmessage = flush;
	  return function () {
	    return channel.port2.postMessage(0);
	  };
	}
	
	function useSetTimeout() {
	  // Store setTimeout reference so es6-promise will be unaffected by
	  // other code modifying setTimeout (like sinon.useFakeTimers())
	  var globalSetTimeout = setTimeout;
	  return function () {
	    return globalSetTimeout(flush, 1);
	  };
	}
	
	var queue = new Array(1000);
	function flush() {
	  for (var i = 0; i < len; i += 2) {
	    var callback = queue[i];
	    var arg = queue[i + 1];
	
	    callback(arg);
	
	    queue[i] = undefined;
	    queue[i + 1] = undefined;
	  }
	
	  len = 0;
	}
	
	function attemptVertx() {
	  try {
	    var r = require;
	    var vertx = __webpack_require__(1133);
	    vertxNext = vertx.runOnLoop || vertx.runOnContext;
	    return useVertxTimer();
	  } catch (e) {
	    return useSetTimeout();
	  }
	}
	
	var scheduleFlush = undefined;
	// Decide what async method to use to triggering processing of queued callbacks:
	if (isNode) {
	  scheduleFlush = useNextTick();
	} else if (BrowserMutationObserver) {
	  scheduleFlush = useMutationObserver();
	} else if (isWorker) {
	  scheduleFlush = useMessageChannel();
	} else if (browserWindow === undefined && "function" === 'function') {
	  scheduleFlush = attemptVertx();
	} else {
	  scheduleFlush = useSetTimeout();
	}
	
	function then(onFulfillment, onRejection) {
	  var _arguments = arguments;
	
	  var parent = this;
	
	  var child = new this.constructor(noop);
	
	  if (child[PROMISE_ID] === undefined) {
	    makePromise(child);
	  }
	
	  var _state = parent._state;
	
	  if (_state) {
	    (function () {
	      var callback = _arguments[_state - 1];
	      asap(function () {
	        return invokeCallback(_state, child, callback, parent._result);
	      });
	    })();
	  } else {
	    subscribe(parent, child, onFulfillment, onRejection);
	  }
	
	  return child;
	}
	
	/**
	  `Promise.resolve` returns a promise that will become resolved with the
	  passed `value`. It is shorthand for the following:
	
	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    resolve(1);
	  });
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = Promise.resolve(1);
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  @method resolve
	  @static
	  @param {Any} value value that the returned promise will be resolved with
	  Useful for tooling.
	  @return {Promise} a promise that will become fulfilled with the given
	  `value`
	*/
	function resolve(object) {
	  /*jshint validthis:true */
	  var Constructor = this;
	
	  if (object && typeof object === 'object' && object.constructor === Constructor) {
	    return object;
	  }
	
	  var promise = new Constructor(noop);
	  _resolve(promise, object);
	  return promise;
	}
	
	var PROMISE_ID = Math.random().toString(36).substring(16);
	
	function noop() {}
	
	var PENDING = void 0;
	var FULFILLED = 1;
	var REJECTED = 2;
	
	var GET_THEN_ERROR = new ErrorObject();
	
	function selfFulfillment() {
	  return new TypeError("You cannot resolve a promise with itself");
	}
	
	function cannotReturnOwn() {
	  return new TypeError('A promises callback cannot return that same promise.');
	}
	
	function getThen(promise) {
	  try {
	    return promise.then;
	  } catch (error) {
	    GET_THEN_ERROR.error = error;
	    return GET_THEN_ERROR;
	  }
	}
	
	function tryThen(then, value, fulfillmentHandler, rejectionHandler) {
	  try {
	    then.call(value, fulfillmentHandler, rejectionHandler);
	  } catch (e) {
	    return e;
	  }
	}
	
	function handleForeignThenable(promise, thenable, then) {
	  asap(function (promise) {
	    var sealed = false;
	    var error = tryThen(then, thenable, function (value) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	      if (thenable !== value) {
	        _resolve(promise, value);
	      } else {
	        fulfill(promise, value);
	      }
	    }, function (reason) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	
	      _reject(promise, reason);
	    }, 'Settle: ' + (promise._label || ' unknown promise'));
	
	    if (!sealed && error) {
	      sealed = true;
	      _reject(promise, error);
	    }
	  }, promise);
	}
	
	function handleOwnThenable(promise, thenable) {
	  if (thenable._state === FULFILLED) {
	    fulfill(promise, thenable._result);
	  } else if (thenable._state === REJECTED) {
	    _reject(promise, thenable._result);
	  } else {
	    subscribe(thenable, undefined, function (value) {
	      return _resolve(promise, value);
	    }, function (reason) {
	      return _reject(promise, reason);
	    });
	  }
	}
	
	function handleMaybeThenable(promise, maybeThenable, then$$) {
	  if (maybeThenable.constructor === promise.constructor && then$$ === then && maybeThenable.constructor.resolve === resolve) {
	    handleOwnThenable(promise, maybeThenable);
	  } else {
	    if (then$$ === GET_THEN_ERROR) {
	      _reject(promise, GET_THEN_ERROR.error);
	    } else if (then$$ === undefined) {
	      fulfill(promise, maybeThenable);
	    } else if (isFunction(then$$)) {
	      handleForeignThenable(promise, maybeThenable, then$$);
	    } else {
	      fulfill(promise, maybeThenable);
	    }
	  }
	}
	
	function _resolve(promise, value) {
	  if (promise === value) {
	    _reject(promise, selfFulfillment());
	  } else if (objectOrFunction(value)) {
	    handleMaybeThenable(promise, value, getThen(value));
	  } else {
	    fulfill(promise, value);
	  }
	}
	
	function publishRejection(promise) {
	  if (promise._onerror) {
	    promise._onerror(promise._result);
	  }
	
	  publish(promise);
	}
	
	function fulfill(promise, value) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	
	  promise._result = value;
	  promise._state = FULFILLED;
	
	  if (promise._subscribers.length !== 0) {
	    asap(publish, promise);
	  }
	}
	
	function _reject(promise, reason) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	  promise._state = REJECTED;
	  promise._result = reason;
	
	  asap(publishRejection, promise);
	}
	
	function subscribe(parent, child, onFulfillment, onRejection) {
	  var _subscribers = parent._subscribers;
	  var length = _subscribers.length;
	
	  parent._onerror = null;
	
	  _subscribers[length] = child;
	  _subscribers[length + FULFILLED] = onFulfillment;
	  _subscribers[length + REJECTED] = onRejection;
	
	  if (length === 0 && parent._state) {
	    asap(publish, parent);
	  }
	}
	
	function publish(promise) {
	  var subscribers = promise._subscribers;
	  var settled = promise._state;
	
	  if (subscribers.length === 0) {
	    return;
	  }
	
	  var child = undefined,
	      callback = undefined,
	      detail = promise._result;
	
	  for (var i = 0; i < subscribers.length; i += 3) {
	    child = subscribers[i];
	    callback = subscribers[i + settled];
	
	    if (child) {
	      invokeCallback(settled, child, callback, detail);
	    } else {
	      callback(detail);
	    }
	  }
	
	  promise._subscribers.length = 0;
	}
	
	function ErrorObject() {
	  this.error = null;
	}
	
	var TRY_CATCH_ERROR = new ErrorObject();
	
	function tryCatch(callback, detail) {
	  try {
	    return callback(detail);
	  } catch (e) {
	    TRY_CATCH_ERROR.error = e;
	    return TRY_CATCH_ERROR;
	  }
	}
	
	function invokeCallback(settled, promise, callback, detail) {
	  var hasCallback = isFunction(callback),
	      value = undefined,
	      error = undefined,
	      succeeded = undefined,
	      failed = undefined;
	
	  if (hasCallback) {
	    value = tryCatch(callback, detail);
	
	    if (value === TRY_CATCH_ERROR) {
	      failed = true;
	      error = value.error;
	      value = null;
	    } else {
	      succeeded = true;
	    }
	
	    if (promise === value) {
	      _reject(promise, cannotReturnOwn());
	      return;
	    }
	  } else {
	    value = detail;
	    succeeded = true;
	  }
	
	  if (promise._state !== PENDING) {
	    // noop
	  } else if (hasCallback && succeeded) {
	      _resolve(promise, value);
	    } else if (failed) {
	      _reject(promise, error);
	    } else if (settled === FULFILLED) {
	      fulfill(promise, value);
	    } else if (settled === REJECTED) {
	      _reject(promise, value);
	    }
	}
	
	function initializePromise(promise, resolver) {
	  try {
	    resolver(function resolvePromise(value) {
	      _resolve(promise, value);
	    }, function rejectPromise(reason) {
	      _reject(promise, reason);
	    });
	  } catch (e) {
	    _reject(promise, e);
	  }
	}
	
	var id = 0;
	function nextId() {
	  return id++;
	}
	
	function makePromise(promise) {
	  promise[PROMISE_ID] = id++;
	  promise._state = undefined;
	  promise._result = undefined;
	  promise._subscribers = [];
	}
	
	function Enumerator(Constructor, input) {
	  this._instanceConstructor = Constructor;
	  this.promise = new Constructor(noop);
	
	  if (!this.promise[PROMISE_ID]) {
	    makePromise(this.promise);
	  }
	
	  if (isArray(input)) {
	    this._input = input;
	    this.length = input.length;
	    this._remaining = input.length;
	
	    this._result = new Array(this.length);
	
	    if (this.length === 0) {
	      fulfill(this.promise, this._result);
	    } else {
	      this.length = this.length || 0;
	      this._enumerate();
	      if (this._remaining === 0) {
	        fulfill(this.promise, this._result);
	      }
	    }
	  } else {
	    _reject(this.promise, validationError());
	  }
	}
	
	function validationError() {
	  return new Error('Array Methods must be provided an Array');
	};
	
	Enumerator.prototype._enumerate = function () {
	  var length = this.length;
	  var _input = this._input;
	
	  for (var i = 0; this._state === PENDING && i < length; i++) {
	    this._eachEntry(_input[i], i);
	  }
	};
	
	Enumerator.prototype._eachEntry = function (entry, i) {
	  var c = this._instanceConstructor;
	  var resolve$$ = c.resolve;
	
	  if (resolve$$ === resolve) {
	    var _then = getThen(entry);
	
	    if (_then === then && entry._state !== PENDING) {
	      this._settledAt(entry._state, i, entry._result);
	    } else if (typeof _then !== 'function') {
	      this._remaining--;
	      this._result[i] = entry;
	    } else if (c === Promise) {
	      var promise = new c(noop);
	      handleMaybeThenable(promise, entry, _then);
	      this._willSettleAt(promise, i);
	    } else {
	      this._willSettleAt(new c(function (resolve$$) {
	        return resolve$$(entry);
	      }), i);
	    }
	  } else {
	    this._willSettleAt(resolve$$(entry), i);
	  }
	};
	
	Enumerator.prototype._settledAt = function (state, i, value) {
	  var promise = this.promise;
	
	  if (promise._state === PENDING) {
	    this._remaining--;
	
	    if (state === REJECTED) {
	      _reject(promise, value);
	    } else {
	      this._result[i] = value;
	    }
	  }
	
	  if (this._remaining === 0) {
	    fulfill(promise, this._result);
	  }
	};
	
	Enumerator.prototype._willSettleAt = function (promise, i) {
	  var enumerator = this;
	
	  subscribe(promise, undefined, function (value) {
	    return enumerator._settledAt(FULFILLED, i, value);
	  }, function (reason) {
	    return enumerator._settledAt(REJECTED, i, reason);
	  });
	};
	
	/**
	  `Promise.all` accepts an array of promises, and returns a new promise which
	  is fulfilled with an array of fulfillment values for the passed promises, or
	  rejected with the reason of the first passed promise to be rejected. It casts all
	  elements of the passed iterable to promises as it runs this algorithm.
	
	  Example:
	
	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = resolve(2);
	  let promise3 = resolve(3);
	  let promises = [ promise1, promise2, promise3 ];
	
	  Promise.all(promises).then(function(array){
	    // The array here would be [ 1, 2, 3 ];
	  });
	  ```
	
	  If any of the `promises` given to `all` are rejected, the first promise
	  that is rejected will be given as an argument to the returned promises's
	  rejection handler. For example:
	
	  Example:
	
	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = reject(new Error("2"));
	  let promise3 = reject(new Error("3"));
	  let promises = [ promise1, promise2, promise3 ];
	
	  Promise.all(promises).then(function(array){
	    // Code here never runs because there are rejected promises!
	  }, function(error) {
	    // error.message === "2"
	  });
	  ```
	
	  @method all
	  @static
	  @param {Array} entries array of promises
	  @param {String} label optional string for labeling the promise.
	  Useful for tooling.
	  @return {Promise} promise that is fulfilled when all `promises` have been
	  fulfilled, or rejected if any of them become rejected.
	  @static
	*/
	function all(entries) {
	  return new Enumerator(this, entries).promise;
	}
	
	/**
	  `Promise.race` returns a new promise which is settled in the same way as the
	  first passed promise to settle.
	
	  Example:
	
	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 2');
	    }, 100);
	  });
	
	  Promise.race([promise1, promise2]).then(function(result){
	    // result === 'promise 2' because it was resolved before promise1
	    // was resolved.
	  });
	  ```
	
	  `Promise.race` is deterministic in that only the state of the first
	  settled promise matters. For example, even if other promises given to the
	  `promises` array argument are resolved, but the first settled promise has
	  become rejected before the other promises became fulfilled, the returned
	  promise will become rejected:
	
	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      reject(new Error('promise 2'));
	    }, 100);
	  });
	
	  Promise.race([promise1, promise2]).then(function(result){
	    // Code here never runs
	  }, function(reason){
	    // reason.message === 'promise 2' because promise 2 became rejected before
	    // promise 1 became fulfilled
	  });
	  ```
	
	  An example real-world use case is implementing timeouts:
	
	  ```javascript
	  Promise.race([ajax('foo.json'), timeout(5000)])
	  ```
	
	  @method race
	  @static
	  @param {Array} promises array of promises to observe
	  Useful for tooling.
	  @return {Promise} a promise which settles in the same way as the first passed
	  promise to settle.
	*/
	function race(entries) {
	  /*jshint validthis:true */
	  var Constructor = this;
	
	  if (!isArray(entries)) {
	    return new Constructor(function (_, reject) {
	      return reject(new TypeError('You must pass an array to race.'));
	    });
	  } else {
	    return new Constructor(function (resolve, reject) {
	      var length = entries.length;
	      for (var i = 0; i < length; i++) {
	        Constructor.resolve(entries[i]).then(resolve, reject);
	      }
	    });
	  }
	}
	
	/**
	  `Promise.reject` returns a promise rejected with the passed `reason`.
	  It is shorthand for the following:
	
	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    reject(new Error('WHOOPS'));
	  });
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = Promise.reject(new Error('WHOOPS'));
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  @method reject
	  @static
	  @param {Any} reason value that the returned promise will be rejected with.
	  Useful for tooling.
	  @return {Promise} a promise rejected with the given `reason`.
	*/
	function reject(reason) {
	  /*jshint validthis:true */
	  var Constructor = this;
	  var promise = new Constructor(noop);
	  _reject(promise, reason);
	  return promise;
	}
	
	function needsResolver() {
	  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
	}
	
	function needsNew() {
	  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
	}
	
	/**
	  Promise objects represent the eventual result of an asynchronous operation. The
	  primary way of interacting with a promise is through its `then` method, which
	  registers callbacks to receive either a promise's eventual value or the reason
	  why the promise cannot be fulfilled.
	
	  Terminology
	  -----------
	
	  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
	  - `thenable` is an object or function that defines a `then` method.
	  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
	  - `exception` is a value that is thrown using the throw statement.
	  - `reason` is a value that indicates why a promise was rejected.
	  - `settled` the final resting state of a promise, fulfilled or rejected.
	
	  A promise can be in one of three states: pending, fulfilled, or rejected.
	
	  Promises that are fulfilled have a fulfillment value and are in the fulfilled
	  state.  Promises that are rejected have a rejection reason and are in the
	  rejected state.  A fulfillment value is never a thenable.
	
	  Promises can also be said to *resolve* a value.  If this value is also a
	  promise, then the original promise's settled state will match the value's
	  settled state.  So a promise that *resolves* a promise that rejects will
	  itself reject, and a promise that *resolves* a promise that fulfills will
	  itself fulfill.
	
	
	  Basic Usage:
	  ------------
	
	  ```js
	  let promise = new Promise(function(resolve, reject) {
	    // on success
	    resolve(value);
	
	    // on failure
	    reject(reason);
	  });
	
	  promise.then(function(value) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Advanced Usage:
	  ---------------
	
	  Promises shine when abstracting away asynchronous interactions such as
	  `XMLHttpRequest`s.
	
	  ```js
	  function getJSON(url) {
	    return new Promise(function(resolve, reject){
	      let xhr = new XMLHttpRequest();
	
	      xhr.open('GET', url);
	      xhr.onreadystatechange = handler;
	      xhr.responseType = 'json';
	      xhr.setRequestHeader('Accept', 'application/json');
	      xhr.send();
	
	      function handler() {
	        if (this.readyState === this.DONE) {
	          if (this.status === 200) {
	            resolve(this.response);
	          } else {
	            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
	          }
	        }
	      };
	    });
	  }
	
	  getJSON('/posts.json').then(function(json) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Unlike callbacks, promises are great composable primitives.
	
	  ```js
	  Promise.all([
	    getJSON('/posts'),
	    getJSON('/comments')
	  ]).then(function(values){
	    values[0] // => postsJSON
	    values[1] // => commentsJSON
	
	    return values;
	  });
	  ```
	
	  @class Promise
	  @param {function} resolver
	  Useful for tooling.
	  @constructor
	*/
	function Promise(resolver) {
	  this[PROMISE_ID] = nextId();
	  this._result = this._state = undefined;
	  this._subscribers = [];
	
	  if (noop !== resolver) {
	    typeof resolver !== 'function' && needsResolver();
	    this instanceof Promise ? initializePromise(this, resolver) : needsNew();
	  }
	}
	
	Promise.all = all;
	Promise.race = race;
	Promise.resolve = resolve;
	Promise.reject = reject;
	Promise._setScheduler = setScheduler;
	Promise._setAsap = setAsap;
	Promise._asap = asap;
	
	Promise.prototype = {
	  constructor: Promise,
	
	  /**
	    The primary way of interacting with a promise is through its `then` method,
	    which registers callbacks to receive either a promise's eventual value or the
	    reason why the promise cannot be fulfilled.
	  
	    ```js
	    findUser().then(function(user){
	      // user is available
	    }, function(reason){
	      // user is unavailable, and you are given the reason why
	    });
	    ```
	  
	    Chaining
	    --------
	  
	    The return value of `then` is itself a promise.  This second, 'downstream'
	    promise is resolved with the return value of the first promise's fulfillment
	    or rejection handler, or rejected if the handler throws an exception.
	  
	    ```js
	    findUser().then(function (user) {
	      return user.name;
	    }, function (reason) {
	      return 'default name';
	    }).then(function (userName) {
	      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
	      // will be `'default name'`
	    });
	  
	    findUser().then(function (user) {
	      throw new Error('Found user, but still unhappy');
	    }, function (reason) {
	      throw new Error('`findUser` rejected and we're unhappy');
	    }).then(function (value) {
	      // never reached
	    }, function (reason) {
	      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
	      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
	    });
	    ```
	    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
	  
	    ```js
	    findUser().then(function (user) {
	      throw new PedagogicalException('Upstream error');
	    }).then(function (value) {
	      // never reached
	    }).then(function (value) {
	      // never reached
	    }, function (reason) {
	      // The `PedgagocialException` is propagated all the way down to here
	    });
	    ```
	  
	    Assimilation
	    ------------
	  
	    Sometimes the value you want to propagate to a downstream promise can only be
	    retrieved asynchronously. This can be achieved by returning a promise in the
	    fulfillment or rejection handler. The downstream promise will then be pending
	    until the returned promise is settled. This is called *assimilation*.
	  
	    ```js
	    findUser().then(function (user) {
	      return findCommentsByAuthor(user);
	    }).then(function (comments) {
	      // The user's comments are now available
	    });
	    ```
	  
	    If the assimliated promise rejects, then the downstream promise will also reject.
	  
	    ```js
	    findUser().then(function (user) {
	      return findCommentsByAuthor(user);
	    }).then(function (comments) {
	      // If `findCommentsByAuthor` fulfills, we'll have the value here
	    }, function (reason) {
	      // If `findCommentsByAuthor` rejects, we'll have the reason here
	    });
	    ```
	  
	    Simple Example
	    --------------
	  
	    Synchronous Example
	  
	    ```javascript
	    let result;
	  
	    try {
	      result = findResult();
	      // success
	    } catch(reason) {
	      // failure
	    }
	    ```
	  
	    Errback Example
	  
	    ```js
	    findResult(function(result, err){
	      if (err) {
	        // failure
	      } else {
	        // success
	      }
	    });
	    ```
	  
	    Promise Example;
	  
	    ```javascript
	    findResult().then(function(result){
	      // success
	    }, function(reason){
	      // failure
	    });
	    ```
	  
	    Advanced Example
	    --------------
	  
	    Synchronous Example
	  
	    ```javascript
	    let author, books;
	  
	    try {
	      author = findAuthor();
	      books  = findBooksByAuthor(author);
	      // success
	    } catch(reason) {
	      // failure
	    }
	    ```
	  
	    Errback Example
	  
	    ```js
	  
	    function foundBooks(books) {
	  
	    }
	  
	    function failure(reason) {
	  
	    }
	  
	    findAuthor(function(author, err){
	      if (err) {
	        failure(err);
	        // failure
	      } else {
	        try {
	          findBoooksByAuthor(author, function(books, err) {
	            if (err) {
	              failure(err);
	            } else {
	              try {
	                foundBooks(books);
	              } catch(reason) {
	                failure(reason);
	              }
	            }
	          });
	        } catch(error) {
	          failure(err);
	        }
	        // success
	      }
	    });
	    ```
	  
	    Promise Example;
	  
	    ```javascript
	    findAuthor().
	      then(findBooksByAuthor).
	      then(function(books){
	        // found books
	    }).catch(function(reason){
	      // something went wrong
	    });
	    ```
	  
	    @method then
	    @param {Function} onFulfilled
	    @param {Function} onRejected
	    Useful for tooling.
	    @return {Promise}
	  */
	  then: then,
	
	  /**
	    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
	    as the catch block of a try/catch statement.
	  
	    ```js
	    function findAuthor(){
	      throw new Error('couldn't find that author');
	    }
	  
	    // synchronous
	    try {
	      findAuthor();
	    } catch(reason) {
	      // something went wrong
	    }
	  
	    // async with promises
	    findAuthor().catch(function(reason){
	      // something went wrong
	    });
	    ```
	  
	    @method catch
	    @param {Function} onRejection
	    Useful for tooling.
	    @return {Promise}
	  */
	  'catch': function _catch(onRejection) {
	    return this.then(null, onRejection);
	  }
	};
	
	function polyfill() {
	    var local = undefined;
	
	    if (typeof global !== 'undefined') {
	        local = global;
	    } else if (typeof self !== 'undefined') {
	        local = self;
	    } else {
	        try {
	            local = Function('return this')();
	        } catch (e) {
	            throw new Error('polyfill failed because global object is unavailable in this environment');
	        }
	    }
	
	    var P = local.Promise;
	
	    if (P) {
	        var promiseToString = null;
	        try {
	            promiseToString = Object.prototype.toString.call(P.resolve());
	        } catch (e) {
	            // silently ignored
	        }
	
	        if (promiseToString === '[object Promise]' && !P.cast) {
	            return;
	        }
	    }
	
	    local.Promise = Promise;
	}
	
	polyfill();
	// Strange compat..
	Promise.polyfill = polyfill;
	Promise.Promise = Promise;
	
	return Promise;
	
	})));
	//# sourceMappingURL=es6-promise.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), (function() { return this; }())))

/***/ }),
/* 1133 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// reduxion.bundle.js